var isV1GT = true;
/*
DONT MODIFY OR UPDATE/REPLACE THIS FILE

- new option appendToBody
- line 132: prevent focus on input element after selecting an item automatically
- line 210: auto open dropdown suggestion when focusing on input element
*/
/**
 * 
/*
    JavaScript autoComplete v1.0.4
    Copyright (c) 2014 Simon Steinberger / Pixabay
    GitHub: https://github.com/Pixabay/JavaScript-autoComplete
    License: http://www.opensource.org/licenses/mit-license.php
*/

var autoComplete = (function(){
    // "use strict";
    function autoComplete(options){
        if (!document.querySelector) return;

        // helpers
        function hasClass(el, className){ return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className); }

        function addEvent(el, type, handler){
            if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
        }
        function removeEvent(el, type, handler){
            // if (el.removeEventListener) not working in IE11
            if (el.detachEvent) el.detachEvent('on'+type, handler); else el.removeEventListener(type, handler);
        }
        function live(elClass, event, cb, context){
            addEvent(context || document, event, function(e){
                var found, el = e.target || e.srcElement;
                while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
                if (found) cb.call(el, e);
            });
        }

        var o = {
            selector: 0,
            source: 0,
            minChars: 3,
            delay: 150,
            offsetLeft: 0,
            offsetTop: 1,
            cache: 1,
            appendToBody: 0,
            menuClass: '',
            renderItem: function (item, search){
                // escape special characters
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
            },
            onSelect: function(e, term, item){}
        };
        for (var k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }

        // init
        var elems = typeof o.selector == 'object' ? [o.selector] : document.querySelectorAll(o.selector);
        for (var i=0; i<elems.length; i++) {
            var that = elems[i];

            // create suggestions container "sc"
            that.sc = document.createElement('div');
            that.sc.className = 'autocomplete-suggestions '+o.menuClass;

            that.autocompleteAttr = that.getAttribute('autocomplete');
            that.setAttribute('autocomplete', 'off');
            that.cache = {};
            that.last_val = '';

            that.updateSC = function(resize, next){
                var rect = that.getBoundingClientRect();
                if(o.appendToBody) {
                    that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + 'px';
                    that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + 'px';
                }

                if (o.width)
                    that.sc.style.width = o.width + 'px';
                else
                    that.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
                if (!resize) {
                    if (!that.sc.maxHeight) { that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight); }
                    if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
                    if (that.sc.suggestionHeight)
                        if (!next) that.sc.scrollTop = 0;
                        else {
                            var scrTop = that.sc.scrollTop, selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
                            if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0)
                                that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
                            else if (selTop < 0)
                                that.sc.scrollTop = selTop + scrTop;
                        }
                    that.sc.style.display = 'block';
                }
            }
            addEvent(window, 'resize', that.updateSC);

            if(o.appendToBody)
                document.body.appendChild(that.sc);
            else
                that.insertAdjacentElement("afterend", that.sc);

            live('autocomplete-suggestion', 'mouseleave', function(e){
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) setTimeout(function(){ sel.className = sel.className.replace('selected', ''); }, 20);
            }, that.sc);

            live('autocomplete-suggestion', 'mouseover', function(e){
                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                if (sel) sel.className = sel.className.replace('selected', '');
                this.className += ' selected';
            }, that.sc);

            live('autocomplete-suggestion', 'mousedown', function(e){
                if (hasClass(this, 'autocomplete-suggestion')) { // else outside click
                    var v = this.getAttribute('data-val');
                    that.value = v;
                    o.onSelect(e, v, this);
                    that.sc.style.display = 'none';
                }
            }, that.sc);

            that.blurHandler = function(){
                try { var over_sb = document.querySelector('.autocomplete-suggestions:hover'); } catch(e){ var over_sb = 0; }
                if (!over_sb) {
                    that.last_val = that.value;
                    that.sc.style.display = 'none';
                    setTimeout(function(){ that.sc.style.display = 'none'; }, 350); // hide suggestions on fast input
                }
                // } else if (that !== document.activeElement) setTimeout(function(){ that.focus(); }, 20);
            };
            addEvent(that, 'blur', that.blurHandler);

            var suggest = function(data){
                var val = that.value;
                that.cache[val] = data;
                if (data.length && val.length >= o.minChars) {
                    var s = '';
                    for (var i=0;i<data.length;i++) s += o.renderItem(data[i], val);
                    that.sc.innerHTML = "<div class='autocomplete-suggestions-wrapper'>"+s+"</div>";
                    that.updateSC(0);
                }
                else
                    that.sc.style.display = 'none';
            }

            that.keydownHandler = function(e){
                var key = window.event ? e.keyCode : e.which;
                // down (40), up (38)
                if ((key == 40 || key == 38) && that.sc.innerHTML) {
                    var next, sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                    if (!sel) {
                        next = (key == 40) ? that.sc.querySelector('.autocomplete-suggestion') : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
                        next.className += ' selected';
                        that.value = next.getAttribute('data-val');
                    } else {
                        next = (key == 40) ? sel.nextSibling : sel.previousSibling;
                        if (next) {
                            sel.className = sel.className.replace('selected', '');
                            next.className += ' selected';
                            that.value = next.getAttribute('data-val');
                        }
                        else { sel.className = sel.className.replace('selected', ''); that.value = that.last_val; next = 0; }
                    }
                    that.updateSC(0, next);
                    return false;
                }
                // esc
                else if (key == 27) { that.value = that.last_val; that.sc.style.display = 'none'; }
                // enter
                else if (key == 13 || key == 9) {
                    var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
                    if (sel && that.sc.style.display != 'none') { o.onSelect(e, sel.getAttribute('data-val'), sel); setTimeout(function(){ that.sc.style.display = 'none'; }, 20); }
                }
            };
            addEvent(that, 'keydown', that.keydownHandler);

            that.keyupHandler = function(e){
                var key = window.event ? e.keyCode : e.which;
                if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
                    var val = that.value;
                    if (val.length >= o.minChars) {
                        if (val != that.last_val) {
                            that.last_val = val;
                            clearTimeout(that.timer);
                            if (o.cache) {
                                if (val in that.cache) { suggest(that.cache[val]); return; }
                                // no requests if previous suggestions were empty
                                for (var i=1; i<val.length-o.minChars; i++) {
                                    var part = val.slice(0, val.length-i);
                                    if (part in that.cache && !that.cache[part].length) { suggest([]); return; }
                                }
                            }
                            that.timer = setTimeout(function(){ o.source(val, suggest) }, o.delay);
                        }
                    } else {
                        that.last_val = val;
                        that.sc.style.display = 'none';
                    }
                }
            };
            addEvent(that, 'keyup', that.keyupHandler);

            that.focusHandler = function(e){
                if(that.value.length)
                    that.sc.style.display = 'block';
                else if(!o.minChars) {
                    that.last_val = "\n";
                    that.keyupHandler(e);
                }

            };
            addEvent(that, 'focus', that.focusHandler);
        }

        // public destroy method
        this.destroy = function(){
            for (var i=0; i<elems.length; i++) {
                var that = elems[i];
                removeEvent(window, 'resize', that.updateSC);
                removeEvent(that, 'blur', that.blurHandler);
                removeEvent(that, 'focus', that.focusHandler);
                removeEvent(that, 'keydown', that.keydownHandler);
                removeEvent(that, 'keyup', that.keyupHandler);
                if (that.autocompleteAttr)
                    that.setAttribute('autocomplete', that.autocompleteAttr);
                else
                    that.removeAttribute('autocomplete');
                
                that.sc.remove();
                that = null;
            }
        };
    }
    return autoComplete;
})();

(function(){
    if (typeof define === 'function' && define.amd)
        define('autoComplete', function () { return autoComplete; });
    else if (typeof module !== 'undefined' && module.exports)
        module.exports = autoComplete;
    else
        window.autoComplete = autoComplete;
})();

// COOKIE FUNCTIONS
// ================
// cookie functions from http://www.quirksmode.org/js/cookies.html

function createCookie(name, value, days) {
    var date = new Date(),
        expires;
    if(days) {
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=",
        ca = document.cookie.split(';'),
        c, i;
    for(i = 0; i < ca.length; i++) {
        c = ca[i];
        while(c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if(c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

// end of quirksmode.org cookie functions


// Read and write form input values as JS objects
$.fn.valueAsObject = function valueAsObject( input ){
    var $element = this;
    var value    = $element.val();

    // Write
    if( /array|object/.test( typeof input ) ){
        return $element.val( JSON.stringify( input ) );
    }
    // Read
    else {
        try {
            try {
                value = JSON.parse( value );
            }
            catch( rawParseError ){
                try {
                    value = JSON.parse( value.replace( /&quot;/g, '"' ) );
                }
                catch( quoteParseError ){
                    value = $( '<x>' ).html( value ).text();
                }
            }
        }
        catch( totalParseError ){
            // This wasn't JSON after all!
        }
        finally {
            return value;
        }
    }
};
/*!
 * THIS FILE HAS BEEN CUSTOMIZED, DONT NOT UPGRADE TO A NEW VERSION!!!

1. return current instance after run event fire

    //OLD
    Events.emit('run.after', _this.move);
    Events.emit('run.before', this);
    Events.emit('run', this.move);
    Events.emit('swipe.start');
    Events.emit('swipe.move');
    Events.emit('swipe.end');

    //NEW
    Events.emit('run.after', {
        "move": _this.move, 
        "instance": Glide
    });

    Events.emit('run', {
        "move": _this.move, 
        "instance": Glide
    });

    Events.emit('run.before', {
        "move": _this.move, 
        "instance": Glide
    });

    Events.emit('swipe.start', {
        "move": -1, 
        "instance": Glide
    });

    Events.emit('swipe.move', {
        "move": -1, 
        "instance": Glide
    });

    Events.emit('swipe.end', {
        "move": steps, 
        "instance": Glide
    });

2. Update calculate function, improve carousel animated effect

3. Modify collect function, should clone all items to improve carousel animated effect

 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Glide = factory());
}(this, (function () { 'use strict';

  var defaults = {
    /**
     * Type of the movement.
     *
     * Available types:
     * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
     * `carousel` - Changes slides without starting over when it reaches the first or last slide.
     *
     * @type {String}
     */
    type: 'slider',

    /**
     * Start at specific slide number defined with zero-based index.
     *
     * @type {Number}
     */
    startAt: 0,

    /**
     * A number of slides visible on the single viewport.
     *
     * @type {Number}
     */
    perView: 1,

    /**
     * Focus currently active slide at a specified position in the track.
     *
     * Available inputs:
     * `center` - Current slide will be always focused at the center of a track.
     * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
     *
     * @type {String|Number}
     */
    focusAt: 0,

    /**
     * A size of the gap added between slides.
     *
     * @type {Number}
     */
    gap: 10,

    /**
     * Change slides after a specified interval. Use `false` for turning off autoplay.
     *
     * @type {Number|Boolean}
     */
    autoplay: false,

    /**
     * Stop autoplay on mouseover event.
     *
     * @type {Boolean}
     */
    hoverpause: true,

    /**
     * Allow for changing slides with left and right keyboard arrows.
     *
     * @type {Boolean}
     */
    keyboard: true,

    /**
     * Stop running `perView` number of slides from the end. Use this
     * option if you don't want to have an empty space after
     * a slider. Works only with `slider` type and a
     * non-centered `focusAt` setting.
     *
     * @type {Boolean}
     */
    bound: false,

    /**
     * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
     *
     * @type {Number|Boolean}
     */
    swipeThreshold: 80,

    /**
     * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
     *
     * @type {Number|Boolean}
     */
    dragThreshold: 120,

    /**
     * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
     *
     * @type {Number|Boolean}
     */
    perTouch: false,

    /**
     * Moving distance ratio of the slides on a swiping and dragging.
     *
     * @type {Number}
     */
    touchRatio: 0.5,

    /**
     * Angle required to activate slides moving on swiping or dragging.
     *
     * @type {Number}
     */
    touchAngle: 45,

    /**
     * Duration of the animation in milliseconds.
     *
     * @type {Number}
     */
    animationDuration: 400,

    /**
     * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
     *
     * @type {Boolean}
     */
    rewind: true,

    /**
     * Duration of the rewinding animation of the `slider` type in milliseconds.
     *
     * @type {Number}
     */
    rewindDuration: 800,

    /**
     * Easing function for the animation.
     *
     * @type {String}
     */
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

    /**
     * Throttle costly events at most once per every wait milliseconds.
     *
     * @type {Number}
     */
    throttle: 10,

    /**
     * Moving direction mode.
     *
     * Available inputs:
     * - 'ltr' - left to right movement,
     * - 'rtl' - right to left movement.
     *
     * @type {String}
     */
    direction: 'ltr',

    /**
     * The distance value of the next and previous viewports which
     * have to peek in the current view. Accepts number and
     * pixels as a string. Left and right peeking can be
     * set up separately with a directions object.
     *
     * For example:
     * `100` - Peek 100px on the both sides.
     * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
     *
     * @type {Number|String|Object}
     */
    peek: 0,

    /**
     * Collection of options applied at specified media breakpoints.
     * For example: display two slides per view under 800px.
     * `{
     *   '800px': {
     *     perView: 2
     *   }
     * }`
     */
    breakpoints: {},

    /**
     * Collection of internally used HTML classes.
     *
     * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
     * @type {Object}
     */
    classes: {
      direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
      },
      slider: 'glide--slider',
      carousel: 'glide--carousel',
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      cloneSlide: 'glide__slide--clone',
      activeNav: 'glide__bullet--active',
      activeSlide: 'glide__slide--active',
      disabledArrow: 'glide__arrow--disabled'
    }
  };

  /**
   * Outputs warning message to the bowser console.
   *
   * @param  {String} msg
   * @return {Void}
   */
  function warn(msg) {
    console.error("[Glide warn]: " + msg);
  }

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  /**
   * Converts value entered as number
   * or string to integer value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toInt(value) {
    return parseInt(value);
  }

  /**
   * Converts value entered as number
   * or string to flat value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toFloat(value) {
    return parseFloat(value);
  }

  /**
   * Indicates whether the specified value is a string.
   *
   * @param  {*}   value
   * @return {Boolean}
   */
  function isString(value) {
    return typeof value === 'string';
  }

  /**
   * Indicates whether the specified value is an object.
   *
   * @param  {*} value
   * @return {Boolean}
   *
   * @see https://github.com/jashkenas/underscore
   */
  function isObject(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
  }

  /**
   * Indicates whether the specified value is a number.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isNumber(value) {
    return typeof value === 'number';
  }

  /**
   * Indicates whether the specified value is a function.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isFunction(value) {
    return typeof value === 'function';
  }

  /**
   * Indicates whether the specified value is undefined.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * Indicates whether the specified value is an array.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isArray(value) {
    return value.constructor === Array;
  }

  /**
   * Creates and initializes specified collection of extensions.
   * Each extension receives access to instance of glide and rest of components.
   *
   * @param {Object} glide
   * @param {Object} extensions
   *
   * @returns {Object}
   */
  function mount(glide, extensions, events) {
    var components = {};

    for (var name in extensions) {
      if (isFunction(extensions[name])) {
        components[name] = extensions[name](glide, components, events);
      } else {
        warn('Extension must be a function');
      }
    }

    for (var _name in components) {
      if (isFunction(components[_name].mount)) {
        components[_name].mount();
      }
    }

    return components;
  }

  /**
   * Defines getter and setter property on the specified object.
   *
   * @param  {Object} obj         Object where property has to be defined.
   * @param  {String} prop        Name of the defined property.
   * @param  {Object} definition  Get and set definitions for the property.
   * @return {Void}
   */
  function define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
  }

  /**
   * Sorts aphabetically object keys.
   *
   * @param  {Object} obj
   * @return {Object}
   */
  function sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function (r, k) {
      r[k] = obj[k];

      return r[k], r;
    }, {});
  }

  /**
   * Merges passed settings object with default options.
   *
   * @param  {Object} defaults
   * @param  {Object} settings
   * @return {Object}
   */
  function mergeOptions(defaults, settings) {
    var options = _extends({}, defaults, settings);

    // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty('classes')) {
      options.classes = _extends({}, defaults.classes, settings.classes);

      if (settings.classes.hasOwnProperty('direction')) {
        options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
      }
    }

    if (settings.hasOwnProperty('breakpoints')) {
      options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
    }

    return options;
  }

  var EventsBus = function () {
    /**
     * Construct a EventBus instance.
     *
     * @param {Object} events
     */
    function EventsBus() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, EventsBus);

      this.events = events;
      this.hop = events.hasOwnProperty;
    }

    /**
     * Adds listener to the specifed event.
     *
     * @param {String|Array} event
     * @param {Function} handler
     */


    createClass(EventsBus, [{
      key: 'on',
      value: function on(event, handler) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.on(event[i], handler);
          }
        }

        // Create the event's object if not yet created
        if (!this.hop.call(this.events, event)) {
          this.events[event] = [];
        }

        // Add the handler to queue
        var index = this.events[event].push(handler) - 1;

        // Provide handle back for removal of event
        return {
          remove: function remove() {
            delete this.events[event][index];
          }
        };
      }

      /**
       * Runs registered handlers for specified event.
       *
       * @param {String|Array} event
       * @param {Object=} context
       */

    }, {
      key: 'emit',
      value: function emit(event, context) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.emit(event[i], context);
          }
        }

        // If the event doesn't exist, or there's no handlers in queue, just leave
        if (!this.hop.call(this.events, event)) {
          return;
        }

        // Cycle through events queue, fire!
        this.events[event].forEach(function (item) {
          item(context || {});
        });
      }
    }]);
    return EventsBus;
  }();

  var Glide = function () {
    /**
     * Construct glide.
     *
     * @param  {String} selector
     * @param  {Object} options
     */
    function Glide(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      classCallCheck(this, Glide);

      this._c = {};
      this._t = [];
      this._e = new EventsBus();

      this.disabled = false;
      this.selector = selector;
      this.settings = mergeOptions(defaults, options);
      this.index = this.settings.startAt;
    }

    /**
     * Initializes glide.
     *
     * @param {Object} extensions Collection of extensions to initialize.
     * @return {Glide}
     */


    createClass(Glide, [{
      key: 'mount',
      value: function mount$$1() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._e.emit('mount.before');

        if (isObject(extensions)) {
          this._c = mount(this, extensions, this._e);
        } else {
          warn('You need to provide a object on `mount()`');
        }

        this._e.emit('mount.after', {
          instance: this
        });

        return this;
      }

      /**
       * Collects an instance `translate` transformers.
       *
       * @param  {Array} transformers Collection of transformers.
       * @return {Void}
       */

    }, {
      key: 'mutate',
      value: function mutate() {
        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (isArray(transformers)) {
          this._t = transformers;
        } else {
          warn('You need to provide a array on `mutate()`');
        }

        return this;
      }

      /**
       * Updates glide with specified settings.
       *
       * @param {Object} settings
       * @return {Glide}
       */

    }, {
      key: 'update',
      value: function update() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.settings = mergeOptions(this.settings, settings);

        if (settings.hasOwnProperty('startAt')) {
          this.index = settings.startAt;
        }

        this._e.emit('update');

        return this;
      }

      /**
       * Change slide with specified pattern. A pattern must be in the special format:
       * `>` - Move one forward
       * `<` - Move one backward
       * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
       * `>>` - Rewinds to end (last slide)
       * `<<` - Rewinds to start (first slide)
       *
       * @param {String} pattern
       * @return {Glide}
       */

    }, {
      key: 'go',
      value: function go(pattern) {
        this._c.Run.make(pattern);

        return this;
      }

      /**
       * Move track by specified distance.
       *
       * @param {String} distance
       * @return {Glide}
       */

    }, {
      key: 'move',
      value: function move(distance) {
        this._c.Transition.disable();
        this._c.Move.make(distance);

        return this;
      }

      /**
       * Destroy instance and revert all changes done by this._c.
       *
       * @return {Glide}
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this._e.emit('destroy');

        return this;
      }

      /**
       * Start instance autoplaying.
       *
       * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Glide}
       */

    }, {
      key: 'play',
      value: function play() {
        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (interval) {
          this.settings.autoplay = interval;
        }

        this._e.emit('play');

        return this;
      }

      /**
       * Stop instance autoplaying.
       *
       * @return {Glide}
       */

    }, {
      key: 'pause',
      value: function pause() {
        this._e.emit('pause');

        return this;
      }

      /**
       * Sets glide into a idle status.
       *
       * @return {Glide}
       */

    }, {
      key: 'disable',
      value: function disable() {
        this.disabled = true;

        return this;
      }

      /**
       * Sets glide into a active status.
       *
       * @return {Glide}
       */

    }, {
      key: 'enable',
      value: function enable() {
        this.disabled = false;

        return this;
      }

      /**
       * Adds cuutom event listener with handler.
       *
       * @param  {String|Array} event
       * @param  {Function} handler
       * @return {Glide}
       */

    }, {
      key: 'on',
      value: function on(event, handler) {
        this._e.on(event, handler);

        return this;
      }

      /**
       * Checks if glide is a precised type.
       *
       * @param  {String} name
       * @return {Boolean}
       */

    }, {
      key: 'isType',
      value: function isType(name) {
        return this.settings.type === name;
      }

      /**
       * Gets value of the core options.
       *
       * @return {Object}
       */

    }, {
      key: 'settings',
      get: function get$$1() {
        return this._o;
      }

      /**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */
      ,
      set: function set$$1(o) {
        if (isObject(o)) {
          this._o = o;
        } else {
          warn('Options must be an `object` instance.');
        }
      }

      /**
       * Gets current index of the slider.
       *
       * @return {Object}
       */

    }, {
      key: 'index',
      get: function get$$1() {
        return this._i;
      }

      /**
       * Sets current index a slider.
       *
       * @return {Object}
       */
      ,
      set: function set$$1(i) {
        this._i = toInt(i);
      }

      /**
       * Gets type name of the slider.
       *
       * @return {String}
       */

    }, {
      key: 'type',
      get: function get$$1() {
        return this.settings.type;
      }

      /**
       * Gets value of the idle status.
       *
       * @return {Boolean}
       */

    }, {
      key: 'disabled',
      get: function get$$1() {
        return this._d;
      }

      /**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */
      ,
      set: function set$$1(status) {
        this._d = !!status;
      }
    }]);
    return Glide;
  }();

  function Run (Glide, Components, Events) {
    var Run = {
      /**
       * Initializes autorunning of the glide.
       *
       * @return {Void}
       */
      mount: function mount() {
        this._o = false;
      },


      /**
       * Makes glides running based on the passed moving schema.
       *
       * @param {String} move
       */
      make: function make(move) {
        var _this = this;

        if (!Glide.disabled) {
          Glide.disable();

          this.move = move;

          Events.emit('run.before', {
            "move": _this.move, 
            "instance": Glide
          });

          this.calculate();

          Events.emit('run', {
            "move": _this.move, 
            "instance": Glide
          });

          Components.Transition.after(function () {
            if (_this.isStart()) {
              Events.emit('run.start', {
                  "move": _this.move, 
                  "instance": Glide
                });
            }

            if (_this.isEnd()) {
              Events.emit('run.end', {
                  "move": _this.move, 
                  "instance": Glide
                });
            }

            if (_this.isOffset('<') || _this.isOffset('>')) {
              _this._o = false;

              Events.emit('run.offset', {
                  "move": _this.move, 
                  "instance": Glide
              });
            }

            Events.emit('run.after', {
                "move": _this.move, 
                "instance": Glide
              });

            Glide.enable();
          });
        }
      },


      /**
       * Calculates current index based on defined move.
       *
       * @return {Void}
       */
      calculate: function calculate() {
        var move = this.move,
            length = this.length;
        var steps = Glide.settings.steps || move.steps,
            direction = move.direction;

        if(move.direction == "=") steps = move.steps;

        var countableSteps = isNumber(toInt(steps)) && toInt(steps) !== 0;
        let oldDuartion = Glide.settings.animationDuration;

        switch (direction) {
          case '>':
            if (steps === '>') {
              Glide.index = length;
            } else if (this.isEnd()) {
              if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
                this._o = true;

                Glide.index = 0;
              }
            } else if (countableSteps) {
                  Glide.index += Math.abs(steps);
                
                  if(Glide.index > length)
                      setTimeout(function(){
                          Components.Transition.disable();
                          Glide.index = Glide.index - length - 1;
                          Components.Translate.set(Components.Sizes.slideWidth * steps);
                          Components.Move.make();
                      }, oldDuartion)
            } else {
              Glide.index++;
            }
            break;

          case '<':
            if (steps === '<' || (Glide.isType('slider') && isNumber(toInt(steps)) && this.isStart())) {
              Glide.index = 0;
            } else if (this.isStart() && (!countableSteps || Math.abs(steps) == 1)) {
              if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
                this._o = true;

                Glide.index = length;
              }
            } else if (countableSteps) {
                  Glide.index -= Math.abs(steps);
                
                  if(Glide.index < 0)
                      setTimeout(function(){
                          Components.Transition.disable();
                          Glide.index = length - Math.abs(Glide.index) + 1;
                          Components.Translate.set(Components.Sizes.slideWidth * steps);
                          Components.Move.make();
                      }, oldDuartion)
            } else {
              Glide.index--;
            }
            break;

          case '=':
            if(Glide.settings.type == "slider" && Components.Sizes.length - steps - 1 < Glide.settings.perView) {
                  Glide.index = Components.Sizes.length - Glide.settings.perView;
            } else
              Glide.index = steps;
            break;

          default:
            warn('Invalid direction pattern [' + direction + steps + '] has been used');
            break;
        }
      },


      /**
       * Checks if we are on the first slide.
       *
       * @return {Boolean}
       */
      isStart: function isStart() {
        return Glide.index === 0;
      },


      /**
       * Checks if we are on the last slide.
       *
       * @return {Boolean}
       */
      isEnd: function isEnd() {
        return Glide.index === this.length;
      },


      /**
       * Checks if we are making a offset run.
       *
       * @param {String} direction
       * @return {Boolean}
       */
      isOffset: function isOffset(direction) {
        return this._o && this.move.direction === direction;
      }
    };

    define(Run, 'move', {
      /**
       * Gets value of the move schema.
       *
       * @returns {Object}
       */
      get: function get() {
        return this._m;
      },


      /**
       * Sets value of the move schema.
       *
       * @returns {Object}
       */
      set: function set(value) {
        var step = value.substr(1);

        this._m = {
          direction: value.substr(0, 1),
          steps: step ? toInt(step) ? toInt(step) : step : 0
        };
      }
    });

    define(Run, 'length', {
      /**
       * Gets value of the running distance based
       * on zero-indexing number of slides.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;
        var length = Components.Html.slides.length;

        // If the `bound` option is acitve, a maximum running distance should be
        // reduced by `perView` and `focusAt` settings. Running distance
        // should end before creating an empty space after instance.

        if (Glide.isType('slider') && settings.focusAt !== 'center' && settings.bound) {
          return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
        }

        return length - 1;
      }
    });

    define(Run, 'offset', {
      /**
       * Gets status of the offsetting flag.
       *
       * @return {Boolean}
       */
      get: function get() {
        return this._o;
      }
    });

    return Run;
  }

  /**
   * Returns a current time.
   *
   * @return {Number}
   */
  function now() {
    return new Date().getTime();
  }

  /**
   * Returns a function, that, when invoked, will only be triggered
   * at most once during a given window of time.
   *
   * @param {Function} func
   * @param {Number} wait
   * @param {Object=} options
   * @return {Function}
   *
   * @see https://github.com/jashkenas/underscore
   */
  function throttle(func, wait, options) {
    var timeout = void 0,
        context = void 0,
        args = void 0,
        result = void 0;
    var previous = 0;
    if (!options) options = {};

    var later = function later() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function throttled() {
      var at = now();
      if (!previous && options.leading === false) previous = at;
      var remaining = wait - (at - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = at;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function () {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  var MARGIN_TYPE = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft']
  };

  function Gaps (Glide, Components, Events) {
    var Gaps = {
      /**
       * Applies gaps between slides. First and last
       * slides do not receive it's edge margins.
       *
       * @param {HTMLCollection} slides
       * @return {Void}
       */
      apply: function apply(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          var direction = Components.Direction.value;

          if (i !== 0) {
            style[MARGIN_TYPE[direction][0]] = this.value / 2 + 'px';
          } else {
            style[MARGIN_TYPE[direction][0]] = '';
          }

          if (i !== slides.length - 1) {
            style[MARGIN_TYPE[direction][1]] = this.value / 2 + 'px';
          } else {
            style[MARGIN_TYPE[direction][1]] = '';
          }
        }
      },


      /**
       * Removes gaps from the slides.
       *
       * @param {HTMLCollection} slides
       * @returns {Void}
      */
      remove: function remove(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;

          style.marginLeft = '';
          style.marginRight = '';
        }
      }
    };

    define(Gaps, 'value', {
      /**
       * Gets value of the gap.
       *
       * @returns {Number}
       */
      get: function get() {
        return toInt(Glide.settings.gap);
      }
    });

    define(Gaps, 'grow', {
      /**
       * Gets additional dimentions value caused by gaps.
       * Used to increase width of the slides wrapper.
       *
       * @returns {Number}
       */
      get: function get() {
        return Gaps.value * (Components.Sizes.length - 1);
      }
    });

    define(Gaps, 'reductor', {
      /**
       * Gets reduction value caused by gaps.
       * Used to subtract width of the slides.
       *
       * @returns {Number}
       */
      get: function get() {
        var perView = Glide.settings.perView;

        return Gaps.value * (perView - 1) / perView;
      }
    });

    /**
     * Apply calculated gaps:
     * - after building, so slides (including clones) will receive proper margins
     * - on updating via API, to recalculate gaps with new options
     */
    Events.on(['build.after', 'update'], throttle(function () {
      Gaps.apply(Components.Html.wrapper.children);
    }, 30));

    /**
     * Remove gaps:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Gaps.remove(Components.Html.wrapper.children);
    });

    return Gaps;
  }

  /**
   * Finds siblings nodes of the passed node.
   *
   * @param  {Element} node
   * @return {Array}
   */
  function siblings(node) {
    if (node && node.parentNode) {
      var n = node.parentNode.firstChild;
      var matched = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== node) {
          matched.push(n);
        }
      }

      return matched;
    }

    return [];
  }

  /**
   * Checks if passed node exist and is a valid element.
   *
   * @param  {Element} node
   * @return {Boolean}
   */
  function exist(node) {
    if (node && node instanceof window.HTMLElement) {
      return true;
    }

    return false;
  }

  var TRACK_SELECTOR = '[data-glide-el="track"]';

  function Html (Glide, Components) {
    var Html = {
      /**
       * Setup slider HTML nodes.
       *
       * @param {Glide} glide
       */
      mount: function mount() {
        this.root = Glide.selector;
        this.track = this.root.querySelector(TRACK_SELECTOR);
        this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (slide) {
          return !slide.classList.contains(Glide.settings.classes.cloneSlide);
        });
      }
    };

    define(Html, 'root', {
      /**
       * Gets node of the glide main element.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._r;
      },


      /**
       * Sets node of the glide main element.
       *
       * @return {Object}
       */
      set: function set(r) {
        if (isString(r)) {
          r = document.querySelector(r);
        }

        if (exist(r)) {
          Html._r = r;
        } else {
          warn('Root element must be a existing Html node');
        }
      }
    });

    define(Html, 'track', {
      /**
       * Gets node of the glide track with slides.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._t;
      },


      /**
       * Sets node of the glide track with slides.
       *
       * @return {Object}
       */
      set: function set(t) {
        if (exist(t)) {
          Html._t = t;
        } else {
          warn('Could not find track element. Please use ' + TRACK_SELECTOR + ' attribute.');
        }
      }
    });

    define(Html, 'wrapper', {
      /**
       * Gets node of the slides wrapper.
       *
       * @return {Object}
       */
      get: function get() {
        return Html.track.children[0];
      }
    });

    return Html;
  }

  function Peek (Glide, Components, Events) {
    var Peek = {
      /**
       * Setups how much to peek based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.peek;
      }
    };

    define(Peek, 'value', {
      /**
       * Gets value of the peek.
       *
       * @returns {Number|Object}
       */
      get: function get() {
        return Peek._v;
      },


      /**
       * Sets value of the peek.
       *
       * @param {Number|Object} value
       * @return {Void}
       */
      set: function set(value) {
        if (isObject(value)) {
          value.before = toInt(value.before);
          value.after = toInt(value.after);
        } else {
          value = toInt(value);
        }

        Peek._v = value;
      }
    });

    define(Peek, 'reductor', {
      /**
       * Gets reduction value caused by peek.
       *
       * @returns {Number}
       */
      get: function get() {
        var value = Peek.value;
        var perView = Glide.settings.perView;

        if (isObject(value)) {
          return value.before / perView + value.after / perView;
        }

        return value * 2 / perView;
      }
    });

    /**
     * Recalculate peeking sizes on:
     * - when resizing window to update to proper percents
     */
    Events.on(['resize', 'update'], function () {
      Peek.mount();
    });

    return Peek;
  }

  function Move (Glide, Components, Events) {
    var Move = {
      /**
       * Constructs move component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        this._o = 0;
      },


      /**
       * Calculates a movement value based on passed offset and currently active index.
       *
       * @param  {Number} offset
       * @return {Void}
       */
      make: function make() {
        var _this = this;

        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this.offset = offset;

        Events.emit('move', {
          movement: this.value
        });

        Components.Transition.after(function () {
          Events.emit('move.after', {
            movement: _this.value
          });
        });
      }
    };

    define(Move, 'offset', {
      /**
       * Gets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      get: function get() {
        return Move._o;
      },


      /**
       * Sets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      set: function set(value) {
        Move._o = !isUndefined(value) ? toInt(value) : 0;
      }
    });

    define(Move, 'translate', {
      /**
       * Gets a raw movement value.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Sizes.slideWidth * Glide.index;
      }
    });

    define(Move, 'value', {
      /**
       * Gets an actual movement value corrected by offset.
       *
       * @return {Number}
       */
      get: function get() {
        var offset = this.offset;
        var translate = this.translate;

        if (Components.Direction.is('rtl')) {
          return translate + offset;
        }

        return translate - offset;
      }
    });

    /**
     * Make movement to proper slide on:
     * - before build, so glide will start at `startAt` index
     * - on each standard run to move to newly calculated index
     */
    Events.on(['build.before', 'run'], function () {
      Move.make();
    });

    return Move;
  }

  function Sizes (Glide, Components, Events) {
    var Sizes = {
      /**
       * Setups dimentions of slides.
       *
       * @return {Void}
       */
      setupSlides: function setupSlides() {
        var width = this.slideWidth + 'px';
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = width;
        }
      },


      /**
       * Setups dimentions of slides wrapper.
       *
       * @return {Void}
       */
      setupWrapper: function setupWrapper(dimention) {
        Components.Html.wrapper.style.width = this.wrapperSize + 'px';
      },


      /**
       * Removes applied styles from HTML elements.
       *
       * @returns {Void}
       */
      remove: function remove() {
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
        }

        Components.Html.wrapper.style.width = '';
      }
    };

    define(Sizes, 'length', {
      /**
       * Gets count number of the slides.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.slides.length;
      }
    });

    define(Sizes, 'width', {
      /**
       * Gets width value of the glide.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.root.offsetWidth;
      }
    });

    define(Sizes, 'wrapperSize', {
      /**
       * Gets size of the slides wrapper.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
      }
    });

    define(Sizes, 'slideWidth', {
      /**
       * Gets width value of the single slide.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
      }
    });

    /**
     * Apply calculated glide's dimensions:
     * - before building, so other dimentions (e.g. translate) will be calculated propertly
     * - when resizing window to recalculate sildes dimensions
     * - on updating via API, to calculate dimensions based on new options
     */
    Events.on(['build.before', 'resize', 'update'], function () {
      Sizes.setupSlides();
      Sizes.setupWrapper();
    });

    /**
     * Remove calculated glide's dimensions:
     * - on destoting to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Sizes.remove();
    });

    return Sizes;
  }

  function Build (Glide, Components, Events) {
    var Build = {
      /**
       * Init glide building. Adds classes, sets
       * dimensions and setups initial state.
       *
       * @return {Void}
       */
      mount: function mount() {
        Events.emit('build.before');

        this.typeClass();
        this.activeClass();

        Events.emit('build.after');
      },


      /**
       * Adds `type` class to the glide element.
       *
       * @return {Void}
       */
      typeClass: function typeClass() {
        Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
      },


      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      activeClass: function activeClass() {
        var classes = Glide.settings.classes;
        var slide = Components.Html.slides[Glide.index];

        if (slide) {
          slide.classList.add(classes.activeSlide);

          siblings(slide).forEach(function (sibling) {
            sibling.classList.remove(classes.activeSlide);
          });
        }
      },


      /**
       * Removes HTML classes applied at building.
       *
       * @return {Void}
       */
      removeClasses: function removeClasses() {
        var classes = Glide.settings.classes;

        Components.Html.root.classList.remove(classes[Glide.settings.type]);

        Components.Html.slides.forEach(function (sibling) {
          sibling.classList.remove(classes.activeSlide);
        });
      }
    };

    /**
     * Clear building classes:
     * - on destroying to bring HTML to its initial state
     * - on updating to remove classes before remounting component
     */
    Events.on(['destroy', 'update'], function () {
      Build.removeClasses();
    });

    /**
     * Remount component:
     * - on resizing of the window to calculate new dimentions
     * - on updating settings via API
     */
    Events.on(['resize', 'update'], function () {
      Build.mount();
    });

    /**
     * Swap active class of current slide:
     * - after each move to the new index
     */
    Events.on('move.after', function () {
      Build.activeClass();
    });

    return Build;
  }

  function Clones (Glide, Components, Events) {
    var Clones = {
      /**
       * Create pattern map and collect slides to be cloned.
       */
      mount: function mount() {
        this.items = [];

        if (Glide.isType('carousel')) {
          this.items = this.collect();
        }
      },


      /**
       * Collect clones with pattern.
       *
       * @return {Void}
       */
      collect: function collect() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var slides = Components.Html.slides;
        var _Glide$settings = Glide.settings,
            perView = _Glide$settings.perView,
            classes = _Glide$settings.classes;


        // var peekIncrementer = +!!Glide.settings.peek;
        // var part = perView + peekIncrementer;
        var part = slides.length - 1;
        var start = slides.slice(0, part);
        var end = slides.slice(-part);

        for (var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++) {
          for (var i = 0; i < start.length; i++) {
            var clone = start[i].cloneNode(true);

            clone.classList.add(classes.cloneSlide);

            items.push(clone);
          }

          for (var _i = 0; _i < end.length; _i++) {
            var _clone = end[_i].cloneNode(true);

            _clone.classList.add(classes.cloneSlide);

            items.unshift(_clone);
          }
        }

        return items;
      },


      /**
       * Append cloned slides with generated pattern.
       *
       * @return {Void}
       */
      append: function append() {
        var items = this.items;
        var _Components$Html = Components.Html,
            wrapper = _Components$Html.wrapper,
            slides = _Components$Html.slides;


        var half = Math.floor(items.length / 2);
        var prepend = items.slice(0, half).reverse();
        var append = items.slice(half, items.length);
        var width = Components.Sizes.slideWidth + 'px';

        for (var i = 0; i < append.length; i++) {
          wrapper.appendChild(append[i]);
        }

        for (var _i2 = 0; _i2 < prepend.length; _i2++) {
          wrapper.insertBefore(prepend[_i2], slides[0]);
        }

        for (var _i3 = 0; _i3 < items.length; _i3++) {
          items[_i3].style.width = width;
        }
      },


      /**
       * Remove all cloned slides.
       *
       * @return {Void}
       */
      remove: function remove() {
        var items = this.items;


        for (var i = 0; i < items.length; i++) {
          Components.Html.wrapper.removeChild(items[i]);
        }
      }
    };

    define(Clones, 'grow', {
      /**
       * Gets additional dimentions value caused by clones.
       *
       * @return {Number}
       */
      get: function get() {
        return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
      }
    });

    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */
    Events.on('update', function () {
      Clones.remove();
      Clones.mount();
      Clones.append();
    });

    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */
    Events.on('build.before', function () {
      if (Glide.isType('carousel')) {
        Clones.append();
      }
    });

    /**
     * Remove clones HTMLElements:
     * - on destroying, to bring HTML to its initial state
     */
    Events.on('destroy', function () {
      Clones.remove();
    });

    return Clones;
  }

  var EventsBinder = function () {
    /**
     * Construct a EventsBinder instance.
     */
    function EventsBinder() {
      var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, EventsBinder);

      this.listeners = listeners;
    }

    /**
     * Adds events listeners to arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Function} closure
     * @param  {Boolean|Object} capture
     * @return {Void}
     */


    createClass(EventsBinder, [{
      key: 'on',
      value: function on(events, el, closure) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          this.listeners[events[i]] = closure;

          el.addEventListener(events[i], this.listeners[events[i]], capture);
        }
      }

      /**
       * Removes event listeners from arrows HTML elements.
       *
       * @param  {String|Array} events
       * @param  {Element|Window|Document} el
       * @param  {Boolean|Object} capture
       * @return {Void}
       */

    }, {
      key: 'off',
      value: function off(events, el) {
        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          el.removeEventListener(events[i], this.listeners[events[i]], capture);
        }
      }

      /**
       * Destroy collected listeners.
       *
       * @returns {Void}
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        delete this.listeners;
      }
    }]);
    return EventsBinder;
  }();

  function Resize (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Resize = {
      /**
       * Initializes window bindings.
       */
      mount: function mount() {
        this.bind();
      },


      /**
       * Binds `rezsize` listener to the window.
       * It's a costly event, so we are debouncing it.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('resize', window, throttle(function () {
          Events.emit('resize');
        }, Glide.settings.throttle));
      },


      /**
       * Unbinds listeners from the window.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('resize', window);
      }
    };

    /**
     * Remove bindings from window:
     * - on destroying, to remove added EventListener
     */
    Events.on('destroy', function () {
      Resize.unbind();
      Binder.destroy();
    });

    return Resize;
  }

  var VALID_DIRECTIONS = ['ltr', 'rtl'];
  var FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
  };

  function Direction (Glide, Components, Events) {
    var Direction = {
      /**
       * Setups gap value based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.direction;
      },


      /**
       * Resolves pattern based on direction value
       *
       * @param {String} pattern
       * @returns {String}
       */
      resolve: function resolve(pattern) {
        var token = pattern.slice(0, 1);

        if (this.is('rtl')) {
          return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
        }

        return pattern;
      },


      /**
       * Checks value of direction mode.
       *
       * @param {String} direction
       * @returns {Boolean}
       */
      is: function is(direction) {
        return this.value === direction;
      },


      /**
       * Applies direction class to the root HTML element.
       *
       * @return {Void}
       */
      addClass: function addClass() {
        Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
      },


      /**
       * Removes direction class from the root HTML element.
       *
       * @return {Void}
       */
      removeClass: function removeClass() {
        Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
      }
    };

    define(Direction, 'value', {
      /**
       * Gets value of the direction.
       *
       * @returns {Number}
       */
      get: function get() {
        return Direction._v;
      },


      /**
       * Sets value of the direction.
       *
       * @param {String} value
       * @return {Void}
       */
      set: function set(value) {
        if (VALID_DIRECTIONS.indexOf(value) > -1) {
          Direction._v = value;
        } else {
          warn('Direction value must be `ltr` or `rtl`');
        }
      }
    });

    /**
     * Clear direction class:
     * - on destroy to bring HTML to its initial state
     * - on update to remove class before reappling bellow
     */
    Events.on(['destroy', 'update'], function () {
      Direction.removeClass();
    });

    /**
     * Remount component:
     * - on update to reflect changes in direction value
     */
    Events.on('update', function () {
      Direction.mount();
    });

    /**
     * Apply direction class:
     * - before building to apply class for the first time
     * - on updating to reapply direction class that may changed
     */
    Events.on(['build.before', 'update'], function () {
      Direction.addClass();
    });

    return Direction;
  }

  /**
   * Reflects value of glide movement.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Rtl (Glide, Components) {
    return {
      /**
       * Negates the passed translate if glide is in RTL option.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Components.Direction.is('rtl')) {
          return -translate;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `gap` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Gap (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with number in the `gap` settings.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Gaps.value * Glide.index;
      }
    };
  }

  /**
   * Updates glide movement with width of additional clones width.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Grow (Glide, Components) {
    return {
      /**
       * Adds to the passed translate width of the half of clones.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Clones.grow / 2;
      }
    };
  }

  /**
   * Updates glide movement with a `peek` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Peeking (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with a `peek` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Glide.settings.focusAt >= 0) {
          var peek = Components.Peek.value;

          if (isObject(peek)) {
            return translate - peek.before;
          }

          return translate - peek;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `focusAt` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Focusing (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with index in the `focusAt` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var gap = Components.Gaps.value;
        var width = Components.Sizes.width;
        var focusAt = Glide.settings.focusAt;
        var slideWidth = Components.Sizes.slideWidth;

        if (focusAt === 'center') {
          return translate - (width / 2 - slideWidth / 2);
        }

        return translate - slideWidth * focusAt - gap * focusAt;
      }
    };
  }

  /**
   * Applies diffrent transformers on translate value.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function mutator (Glide, Components, Events) {
    /**
     * Merge instance transformers with collection of default transformers.
     * It's important that the Rtl component be last on the list,
     * so it reflects all previous transformations.
     *
     * @type {Array}
     */
    var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);

    return {
      /**
       * Piplines translate value with registered transformers.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      mutate: function mutate(translate) {
        for (var i = 0; i < TRANSFORMERS.length; i++) {
          var transformer = TRANSFORMERS[i];

          if (isFunction(transformer) && isFunction(transformer().modify)) {
            translate = transformer(Glide, Components, Events).modify(translate);
          } else {
            warn('Transformer should be a function that returns an object with `modify()` method');
          }
        }

        return translate;
      }
    };
  }

  function Translate (Glide, Components, Events) {
    var Translate = {
      /**
       * Sets value of translate on HTML element.
       *
       * @param {Number} value
       * @return {Void}
       */
      set: function set(value) {
        var transform = mutator(Glide, Components).mutate(value);

        Components.Html.wrapper.style.transform = 'translate3d(' + -1 * transform + 'px, 0px, 0px)';
      },


      /**
       * Removes value of translate from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transform = '';
      }
    };

    /**
     * Set new translate value:
     * - on move to reflect index change
     * - on updating via API to reflect possible changes in options
     */
    Events.on('move', function (context) {
      var gap = Components.Gaps.value;
      var length = Components.Sizes.length;
      var width = Components.Sizes.slideWidth;

      if (Glide.isType('carousel') && Components.Run.isOffset('<')) {
        Components.Transition.after(function () {
          Events.emit('translate.jump');

          Translate.set(width * (length - 1));
        });

        return Translate.set(-width - gap * length);
      }

      if (Glide.isType('carousel') && Components.Run.isOffset('>')) {
        Components.Transition.after(function () {
          Events.emit('translate.jump');

          Translate.set(0);
        });

        return Translate.set(width * length + gap * length);
      }

      return Translate.set(context.movement);
    });

    /**
     * Remove translate:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Translate.remove();
    });

    return Translate;
  }

  function Transition (Glide, Components, Events) {
    /**
     * Holds inactivity status of transition.
     * When true transition is not applied.
     *
     * @type {Boolean}
     */
    var disabled = false;

    var Transition = {
      /**
       * Composes string of the CSS transition.
       *
       * @param {String} property
       * @return {String}
       */
      compose: function compose(property) {
        var settings = Glide.settings;

        if (!disabled) {
          return property + ' ' + this.duration + 'ms ' + settings.animationTimingFunc;
        }

        return property + ' 0ms ' + settings.animationTimingFunc;
      },


      /**
       * Sets value of transition on HTML element.
       *
       * @param {String=} property
       * @return {Void}
       */
      set: function set() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

        Components.Html.wrapper.style.transition = this.compose(property);
      },


      /**
       * Removes value of transition from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transition = '';
      },


      /**
       * Runs callback after animation.
       *
       * @param  {Function} callback
       * @return {Void}
       */
      after: function after(callback) {
        setTimeout(function () {
          callback();
        }, this.duration);
      },


      /**
       * Enable transition.
       *
       * @return {Void}
       */
      enable: function enable() {
        disabled = false;

        this.set();
      },


      /**
       * Disable transition.
       *
       * @return {Void}
       */
      disable: function disable() {
        disabled = true;

        this.set();
      }
    };

    define(Transition, 'duration', {
      /**
       * Gets duration of the transition based
       * on currently running animation type.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;

        if (Glide.isType('slider') && Components.Run.offset) {
          return settings.rewindDuration;
        }

        return settings.animationDuration;
      }
    });

    /**
     * Set transition `style` value:
     * - on each moving, because it may be cleared by offset move
     */
    Events.on('move', function () {
      Transition.set();
    });

    /**
     * Disable transition:
     * - before initial build to avoid transitioning from `0` to `startAt` index
     * - while resizing window and recalculating dimentions
     * - on jumping from offset transition at start and end edges in `carousel` type
     */
    Events.on(['build.before', 'resize', 'translate.jump'], function () {
      Transition.disable();
    });

    /**
     * Enable transition:
     * - on each running, because it may be disabled by offset move
     */
    Events.on('run', function () {
      Transition.enable();
    });

    /**
     * Remove transition:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Transition.remove();
    });

    return Transition;
  }

  /**
   * Test via a getter in the options object to see
   * if the passive property is accessed.
   *
   * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
   */

  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });

    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  var supportsPassive$1 = supportsPassive;

  var START_EVENTS = ['touchstart', 'mousedown'];
  var MOVE_EVENTS = ['touchmove', 'mousemove'];
  var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
  var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

  function Swipe (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = supportsPassive$1 ? { passive: true } : false;

    var Swipe = {
      /**
       * Initializes swipe bindings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bindSwipeStart();
      },


      /**
       * Handler for `swipestart` event. Calculates entry points of the user's tap.
       *
       * @param {Object} event
       * @return {Void}
       */
      start: function start(event) {
        if (!disabled && !Glide.disabled) {
          this.disable();

          var swipe = this.touches(event);

          swipeSin = null;
          swipeStartX = toInt(swipe.pageX);
          swipeStartY = toInt(swipe.pageY);

          this.bindSwipeMove();
          this.bindSwipeEnd();

          Events.emit('swipe.start', {
            "move": -1, 
            "instance": Glide
          });
        }
      },


      /**
       * Handler for `swipemove` event. Calculates user's tap angle and distance.
       *
       * @param {Object} event
       */
      move: function move(event) {
        if (!Glide.disabled) {
          var _Glide$settings = Glide.settings,
              touchAngle = _Glide$settings.touchAngle,
              touchRatio = _Glide$settings.touchRatio,
              classes = _Glide$settings.classes;


          var swipe = this.touches(event);

          var subExSx = toInt(swipe.pageX) - swipeStartX;
          var subEySy = toInt(swipe.pageY) - swipeStartY;
          var powEX = Math.abs(subExSx << 2);
          var powEY = Math.abs(subEySy << 2);
          var swipeHypotenuse = Math.sqrt(powEX + powEY);
          var swipeCathetus = Math.sqrt(powEY);

          swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

          if (swipeSin * 180 / Math.PI < touchAngle) {
            event.stopPropagation();

            Components.Move.make(subExSx * toFloat(touchRatio));

            Components.Html.root.classList.add(classes.dragging);

            Events.emit('swipe.move', {
              "move": -1, 
              "instance": Glide
            });
          } else {
            return false;
          }
        }
      },


      /**
       * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
       *
       * @param {Object} event
       * @return {Void}
       */
      end: function end(event) {
        if (!Glide.disabled) {
          var settings = Glide.settings;

          var swipe = this.touches(event);
          var threshold = this.threshold(event);

          var swipeDistance = swipe.pageX - swipeStartX;
          var swipeDeg = swipeSin * 180 / Math.PI;
          var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);

          this.enable();

          if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
            // While swipe is positive and greater than threshold move backward.
            if (settings.perTouch) {
              steps = Math.min(steps, toInt(settings.perTouch));
            }

            if (Components.Direction.is('rtl')) {
              steps = -steps;
            }

            if(settings.type == "slider" && Glide.index - steps < 0)
              Components.Run.make(Components.Direction.resolve('<<'));
            else
              Components.Run.make(Components.Direction.resolve('<' + steps));
          } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
            // While swipe is negative and lower than negative threshold move forward.
            if (settings.perTouch) {
              steps = Math.max(steps, -toInt(settings.perTouch));
            }

            if (Components.Direction.is('rtl')) {
              steps = -steps;
            }
            
            if(settings.type == "slider" && toInt(settings.perView) + Math.abs(steps) >= parseInt(Glide.selector.dataset.totalItems) - 1)
              Components.Run.make(Components.Direction.resolve('>>'));
            else
              Components.Run.make(Components.Direction.resolve('>' + steps));
          } else {
            // While swipe don't reach distance apply previous transform.
            Components.Move.make();
          }

          Components.Html.root.classList.remove(settings.classes.dragging);

          this.unbindSwipeMove();
          this.unbindSwipeEnd();

          Events.emit('swipe.end', {
            "move": steps, 
            "instance": Glide
          });
        }
      },


      /**
       * Binds swipe's starting event.
       *
       * @return {Void}
       */
      bindSwipeStart: function bindSwipeStart() {
        var _this = this;

        var settings = Glide.settings;

        if (settings.swipeThreshold) {
          Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }

        if (settings.dragThreshold) {
          Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }
      },


      /**
       * Unbinds swipe's starting event.
       *
       * @return {Void}
       */
      unbindSwipeStart: function unbindSwipeStart() {
        Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
        Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
      },


      /**
       * Binds swipe's moving event.
       *
       * @return {Void}
       */
      bindSwipeMove: function bindSwipeMove() {
        var _this2 = this;

        Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
          _this2.move(event);
        }, Glide.settings.throttle), capture);
      },


      /**
       * Unbinds swipe's moving event.
       *
       * @return {Void}
       */
      unbindSwipeMove: function unbindSwipeMove() {
        Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
      },


      /**
       * Binds swipe's ending event.
       *
       * @return {Void}
       */
      bindSwipeEnd: function bindSwipeEnd() {
        var _this3 = this;

        Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
          _this3.end(event);
        });
      },


      /**
       * Unbinds swipe's ending event.
       *
       * @return {Void}
       */
      unbindSwipeEnd: function unbindSwipeEnd() {
        Binder.off(END_EVENTS, Components.Html.wrapper);
      },


      /**
       * Normalizes event touches points accorting to different types.
       *
       * @param {Object} event
       */
      touches: function touches(event) {
        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return event;
        }

        return event.touches[0] || event.changedTouches[0];
      },


      /**
       * Gets value of minimum swipe distance settings based on event type.
       *
       * @return {Number}
       */
      threshold: function threshold(event) {
        var settings = Glide.settings;

        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return settings.dragThreshold;
        }

        return settings.swipeThreshold;
      },


      /**
       * Enables swipe event.
       *
       * @return {self}
       */
      enable: function enable() {
        disabled = false;

        Components.Transition.enable();

        return this;
      },


      /**
       * Disables swipe event.
       *
       * @return {self}
       */
      disable: function disable() {
        disabled = true;

        Components.Transition.disable();

        return this;
      }
    };

    /**
     * Add component class:
     * - after initial building
     */
    Events.on('build.after', function () {
      Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });

    /**
     * Remove swiping bindings:
     * - on destroying, to remove added EventListeners
     */
    Events.on('destroy', function () {
      Swipe.unbindSwipeStart();
      Swipe.unbindSwipeMove();
      Swipe.unbindSwipeEnd();
      Binder.destroy();
    });

    return Swipe;
  }

  function Images (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Images = {
      /**
       * Binds listener to glide wrapper.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bind();
      },


      /**
       * Binds `dragstart` event on wrapper to prevent dragging images.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
      },


      /**
       * Unbinds `dragstart` event on wrapper.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('dragstart', Components.Html.wrapper);
      },


      /**
       * Event handler. Prevents dragging.
       *
       * @return {Void}
       */
      dragstart: function dragstart(event) {
        event.preventDefault();
      }
    };

    /**
     * Remove bindings from images:
     * - on destroying, to remove added EventListeners
     */
    Events.on('destroy', function () {
      Images.unbind();
      Binder.destroy();
    });

    return Images;
  }

  function Anchors (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    /**
     * Holds detaching status of anchors.
     * Prevents detaching of already detached anchors.
     *
     * @private
     * @type {Boolean}
     */
    var detached = false;

    /**
     * Holds preventing status of anchors.
     * If `true` redirection after click will be disabled.
     *
     * @private
     * @type {Boolean}
     */
    var prevented = false;

    var Anchors = {
      /**
       * Setups a initial state of anchors component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        /**
         * Holds collection of anchors elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._a = Components.Html.wrapper.querySelectorAll('a');

        this.bind();
      },


      /**
       * Binds events to anchors inside a track.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('click', Components.Html.wrapper, this.click);
      },


      /**
       * Unbinds events attached to anchors inside a track.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('click', Components.Html.wrapper);
      },


      /**
       * Handler for click event. Prevents clicks when glide is in `prevent` status.
       *
       * @param  {Object} event
       * @return {Void}
       */
      click: function click(event) {
        if (prevented) {
          event.stopPropagation();
          event.preventDefault();
        }
      },


      /**
       * Detaches anchors click event inside glide.
       *
       * @return {self}
       */
      detach: function detach() {
        prevented = true;

        if (!detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = false;
            //THIS ONE CAUSES THE BLINK ISSUE
            // this.items[i].setAttribute('data-href', this.items[i].getAttribute('href'));

            // this.items[i].removeAttribute('href');
          }

          detached = true;
        }

        return this;
      },


      /**
       * Attaches anchors click events inside glide.
       *
       * @return {self}
       */
      attach: function attach() {
        prevented = false;

        if (detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = true;
            //THIS ONE CAUSES THE BLINK ISSUE
            // this.items[i].setAttribute('href', this.items[i].getAttribute('data-href'));
          }

          detached = false;
        }

        return this;
      }
    };

    define(Anchors, 'items', {
      /**
       * Gets collection of the arrows HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Anchors._a;
      }
    });

    /**
     * Detach anchors inside slides:
     * - on swiping, so they won't redirect to its `href` attributes
     */
    Events.on('swipe.move', function () {
      Anchors.detach();
    });

    /**
     * Attach anchors inside slides:
     * - after swiping and transitions ends, so they can redirect after click again
     */
    Events.on('swipe.end', function () {
      Components.Transition.after(function () {
        Anchors.attach();
      });
    });

    /**
     * Unbind anchors inside slides:
     * - on destroying, to bring anchors to its initial state
     */
    Events.on('destroy', function () {
      Anchors.attach();
      Anchors.unbind();
      Binder.destroy();
    });

    return Anchors;
  }

  var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';

  function Controls (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var capture = supportsPassive$1 ? { passive: true } : false;

    var Controls = {
      /**
       * Inits arrows. Binds events listeners
       * to the arrows HTML elements.
       *
       * @return {Void}
       */
      mount: function mount() {
        /**
         * Collection of navigation HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);

        /**
         * Collection of controls HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);

        this.addBindings();
      },


      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      setActive: function setActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.addClass(this._n[i].children);
        }
      },


      /**
       * Removes active class to current slide.
       *
       * @return {Void}
       */
      removeActive: function removeActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.removeClass(this._n[i].children);
        }
      },


      /**
       * Toggles active class on items inside navigation.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      addClass: function addClass(controls) {
        var settings = Glide.settings;
        var item = controls[Glide.index];

        if (item) {
          item.classList.add(settings.classes.activeNav);

          siblings(item).forEach(function (sibling) {
            sibling.classList.remove(settings.classes.activeNav);
          });
        }
      },


      /**
       * Removes active class from active control.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      removeClass: function removeClass(controls) {
        var item = controls[Glide.index];

        if (item) {
          item.classList.remove(Glide.settings.classes.activeNav);
        }
      },


      /**
       * Adds handles to the each group of controls.
       *
       * @return {Void}
       */
      addBindings: function addBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.bind(this._c[i].children);
        }
      },


      /**
       * Removes handles from the each group of controls.
       *
       * @return {Void}
       */
      removeBindings: function removeBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.unbind(this._c[i].children);
        }
      },


      /**
       * Binds events to arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      bind: function bind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.on('click', elements[i], this.click);
          Binder.on('touchstart', elements[i], this.click, capture);
        }
      },


      /**
       * Unbinds events binded to the arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      unbind: function unbind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.off(['click', 'touchstart'], elements[i]);
        }
      },


      /**
       * Handles `click` event on the arrows HTML elements.
       * Moves slider in driection precised in
       * `data-glide-dir` attribute.
       *
       * @param {Object} event
       * @return {Void}
       */
      click: function click(event) {
        event.preventDefault();

        Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute('data-glide-dir')));
      }
    };

    define(Controls, 'items', {
      /**
       * Gets collection of the controls HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Controls._c;
      }
    });

    /**
     * Swap active class of current navigation item:
     * - after mounting to set it to initial index
     * - after each move to the new index
     */
    Events.on(['mount.after', 'move.after'], function () {
      Controls.setActive();
    });

    /**
     * Remove bindings and HTML Classes:
     * - on destroying, to bring markup to its initial state
     */
    Events.on('destroy', function () {
      Controls.removeBindings();
      Controls.removeActive();
      Binder.destroy();
    });

    return Controls;
  }

  function Keyboard (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Keyboard = {
      /**
       * Binds keyboard events on component mount.
       *
       * @return {Void}
       */
      mount: function mount() {
        if (Glide.settings.keyboard) {
          this.bind();
        }
      },


      /**
       * Adds keyboard press events.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('keyup', document, this.press);
      },


      /**
       * Removes keyboard press events.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('keyup', document);
      },


      /**
       * Handles keyboard's arrows press and moving glide foward and backward.
       *
       * @param  {Object} event
       * @return {Void}
       */
      press: function press(event) {
        if (event.keyCode === 39) {
          Components.Run.make(Components.Direction.resolve('>'));
        }

        if (event.keyCode === 37) {
          Components.Run.make(Components.Direction.resolve('<'));
        }
      }
    };

    /**
     * Remove bindings from keyboard:
     * - on destroying to remove added events
     * - on updating to remove events before remounting
     */
    Events.on(['destroy', 'update'], function () {
      Keyboard.unbind();
    });

    /**
     * Remount component
     * - on updating to reflect potential changes in settings
     */
    Events.on('update', function () {
      Keyboard.mount();
    });

    /**
     * Destroy binder:
     * - on destroying to remove listeners
     */
    Events.on('destroy', function () {
      Binder.destroy();
    });

    return Keyboard;
  }

  function Autoplay (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Autoplay = {
      /**
       * Initializes autoplaying and events.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.start();

        if (Glide.settings.hoverpause) {
          this.bind();
        }
      },


      /**
       * Starts autoplaying in configured interval.
       *
       * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Void}
       */
      start: function start() {
        var _this = this;

        if (Glide.settings.autoplay) {
          if (isUndefined(this._i)) {
            this._i = setInterval(function () {
              _this.stop();

              Components.Run.make('>');

              _this.start();
            }, this.time);
          }
        }
      },


      /**
       * Stops autorunning of the glide.
       *
       * @return {Void}
       */
      stop: function stop() {
        this._i = clearInterval(this._i);
      },


      /**
       * Stops autoplaying while mouse is over glide's area.
       *
       * @return {Void}
       */
      bind: function bind() {
        var _this2 = this;

        Binder.on('mouseover', Components.Html.root, function () {
          _this2.stop();
        });

        Binder.on('mouseout', Components.Html.root, function () {
          _this2.start();
        });
      },


      /**
       * Unbind mouseover events.
       *
       * @returns {Void}
       */
      unbind: function unbind() {
        Binder.off(['mouseover', 'mouseout'], Components.Html.root);
      }
    };

    define(Autoplay, 'time', {
      /**
       * Gets time period value for the autoplay interval. Prioritizes
       * times in `data-glide-autoplay` attrubutes over options.
       *
       * @return {Number}
       */
      get: function get() {
        var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

        if (autoplay) {
          return toInt(autoplay);
        }

        return toInt(Glide.settings.autoplay);
      }
    });

    /**
     * Stop autoplaying and unbind events:
     * - on destroying, to clear defined interval
     * - on updating via API to reset interval that may changed
     */
    Events.on(['destroy', 'update'], function () {
      Autoplay.unbind();
    });

    /**
     * Stop autoplaying:
     * - before each run, to restart autoplaying
     * - on pausing via API
     * - on destroying, to clear defined interval
     * - while starting a swipe
     * - on updating via API to reset interval that may changed
     */
    Events.on(['run.before', 'pause', 'destroy', 'swipe.start', 'update'], function () {
      Autoplay.stop();
    });

    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */
    Events.on(['run.after', 'play', 'swipe.end'], function () {
      Autoplay.start();
    });

    /**
     * Remount autoplaying:
     * - on updating via API to reset interval that may changed
     */
    Events.on('update', function () {
      Autoplay.mount();
    });

    /**
     * Destroy a binder:
     * - on destroying glide instance to clearup listeners
     */
    Events.on('destroy', function () {
      Binder.destroy();
    });

    return Autoplay;
  }

  /**
   * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
   *
   * @param {Object} points
   * @returns {Object}
   */
  function sortBreakpoints(points) {
    if (isObject(points)) {
      return sortKeys(points);
    } else {
      warn('Breakpoints option must be an object');
    }

    return {};
  }

  function Breakpoints (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    /**
     * Holds reference to settings.
     *
     * @type {Object}
     */
    var settings = Glide.settings;

    /**
     * Holds reference to breakpoints object in settings. Sorts breakpoints
     * from smaller to larger. It is required in order to proper
     * matching currently active breakpoint settings.
     *
     * @type {Object}
     */
    var points = sortBreakpoints(settings.breakpoints);

    /**
     * Cache initial settings before overwritting.
     *
     * @type {Object}
     */
    var defaults = _extends({}, settings);

    var Breakpoints = {
      /**
       * Matches settings for currectly matching media breakpoint.
       *
       * @param {Object} points
       * @returns {Object}
       */
      match: function match(points) {
        if (typeof window.matchMedia !== 'undefined') {
          for (var point in points) {
            if (points.hasOwnProperty(point)) {
              if (window.matchMedia('(max-width: ' + point + 'px)').matches) {
                return points[point];
              }
            }
          }
        }

        return defaults;
      }
    };

    /**
     * Overwrite instance settings with currently matching breakpoint settings.
     * This happens right after component initialization.
     */
    _extends(settings, Breakpoints.match(points));

    /**
     * Update glide with settings of matched brekpoint:
     * - window resize to update slider
     */
    Binder.on('resize', window, throttle(function () {
      Glide.settings = mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));

    /**
     * Resort and update default settings:
     * - on reinit via API, so breakpoint matching will be performed with options
     */
    Events.on('update', function () {
      points = sortBreakpoints(points);

      defaults = _extends({}, settings);
    });

    /**
     * Unbind resize listener:
     * - on destroying, to bring markup to its initial state
     */
    Events.on('destroy', function () {
      Binder.off('resize', window);
    });

    return Breakpoints;
  }

  var COMPONENTS = {
    // Required
    Html: Html,
    Translate: Translate,
    Transition: Transition,
    Direction: Direction,
    Peek: Peek,
    Sizes: Sizes,
    Gaps: Gaps,
    Move: Move,
    Clones: Clones,
    Resize: Resize,
    Build: Build,
    Run: Run,

    // Optional
    Swipe: Swipe,
    Images: Images,
    Anchors: Anchors,
    Controls: Controls,
    Keyboard: Keyboard,
    Autoplay: Autoplay,
    Breakpoints: Breakpoints
  };

  var Glide$1 = function (_Core) {
    inherits(Glide$$1, _Core);

    function Glide$$1() {
      classCallCheck(this, Glide$$1);
      return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
    }

    createClass(Glide$$1, [{
      key: 'mount',
      value: function mount() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), 'mount', this).call(this, _extends({}, COMPONENTS, extensions));
      }
    }]);
    return Glide$$1;
  }(Glide);

  return Glide$1;

})));
class GTHelper {
    constructor() {}

    validateEmail(email){
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    };

    
    detectDOMChange(parentElement, callback){
      let observer = new MutationObserver(function(mutations) {
        let hasChangeNode = false;
        mutations.forEach(mutation => {
          if(mutation.addedNodes.length)
            hasChangeNode = true;
        })

        if(hasChangeNode) {
          callback && callback(mutations);
        }
      });

      observer.observe(parentElement, {childList: true, subtree: true});
    }

    dispatchEvt(name, elm, data) {
      const evt = new CustomEvent(name, {
        bubbles: true,
        detail: data,
      });
      elm.dispatchEvent(evt);
    }
}
class HttpService {
    METHODS = {
        DELETE: "delete",
        GET: "get",
        PUT: "put",
        POST: "post",
        UPLOAD: "uploadFile",
        PATCH: "patch"
    }

    constructor() { }

    sendRequest(method, url, data = null, requestHeaders = {}, isAsync = true, xhr = null) {
        return new Promise(function (resolve, reject) {
            xhr = xhr || new XMLHttpRequest();
            if (method == "POST_FILE") {
                xhr.open("POST", url, isAsync);
                /*xhr.setRequestHeader('Content-type', 'multipart/form-data');*/
            } else {
                xhr.open(method, url, isAsync);
                xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
            }
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            //
            let body = document.getElementsByTagName('body');
            let fromPage = 0;
            if (body != undefined && body.length > 0) {
                fromPage = body[0].getAttribute('p');
            }
            xhr.setRequestHeader('bro-p', fromPage);

            if (requestHeaders) {
                Object.keys(requestHeaders).forEach(headerKey => {
                    xhr.setRequestHeader(headerKey, requestHeaders[headerKey]);
                });
            }

            //Add default forgery token to header of post method
            if (!requestHeaders || !requestHeaders.hasOwnProperty('RequestVerificationToken')) {
                let tokens = document.getElementsByName('__RequestVerificationToken');
                if (tokens != null && tokens != undefined && tokens.length > 0) {
                    xhr.setRequestHeader('RequestVerificationToken', tokens[0]?.value);
                }
            }
            
            xhr.onload = function () {
                try {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(xhr.responseText ? JSON.parse(xhr.responseText) : {});
                    } else {
                        let resError = {};
                        resError = JSON.parse(xhr.responseText);
                        resolve(Object.assign({
                            status: xhr.status,
                            statusText: xhr.statusText,
                            error: true
                        }, resError));
                    }
                } catch (error) {
                    resolve({
                        status: xhr.status,
                        statusText: xhr.statusText,
                        error: true
                    });
                    console.error("Content is malformed ", error);
                }
            };
            xhr.onerror = function (e) {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            
            if (method == "POST_FILE") {
                xhr.send(data);
            } else {
                xhr.send(data ? JSON.stringify(data) : null);
            }
        });
    }

    getHtmlContent(url, data = null, requestHeaders = {}, isAsync = true) {
        return new Promise(function (resolve, reject) {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url, isAsync);
            xhr.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9');
            if (requestHeaders) {
                Object.keys(requestHeaders).forEach(headerKey => {
                    xhr.setRequestHeader(headerKey, requestHeaders['headerKey']);
                });
            }
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                } else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send(JSON.stringify(data));
        });
    }
    
    get(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('GET', url, data, requestHeaders, isAsync, xhr);
    }

    post(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('POST', url, data, requestHeaders, isAsync, xhr);
    }

    patch(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('PATCH', url, data, requestHeaders, isAsync, xhr);
    }

    uploadFile(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('POST_FILE', url, data, requestHeaders, isAsync, xhr);
    }
    
    put(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('PUT', url, data, requestHeaders, isAsync, xhr);
    }

    update(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('PUT', url, data, requestHeaders, isAsync, xhr);
    }

    delete(url, data, requestHeaders, isAsync = true, xhr = null) {
        return this.sendRequest('DELETE', url, data, requestHeaders, isAsync, xhr);
    }

    getPromise(method, endPoint, data, isAsync, doNotShowErrorMSG){
        let self = this;
        return new Promise((resolve, reject) => {
                self[method](endPoint, data, null, isAsync)
                .then(res => {
                    if(!doNotShowErrorMSG && res.error && res.message) {
                        // BN.toastService.displayToast(res.message, "error");
                    }
                    resolve(res);
                }
            )
            .catch(e => {
                // BN.toastService.displayToast("Something wrong!", "error");
                console.log(e);
                reject(e);
            });
        });
    }

    getPromiseWithoutMSG(method, endPoint, data, isAsync){
        return this.getPromise(method, endPoint, data, isAsync, true);
    }
}
/*!
 * jQuery Validation Plugin v1.17.0
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2017 Jörn Zaefferer
 * Released under the MIT license
 * 
 * Edited: 2018 by Szymon Grzybek, POSSIBLE
 */

(function( factory ) {
	if ( typeof define === "function" && define.amd ) {
		define( ["jquery"], factory );
	} else if (typeof module === "object" && module.exports) {
		module.exports = factory( require( "jquery" ) );
	} else {
		factory( jQuery );
	}
}(function( $ ) {

$.extend( $.fn, {

	// https://jqueryvalidation.org/validate/
	validate: function( options ) {

		// If nothing is selected, return nothing; can't chain anyway
		if ( !this.length ) {
			if ( options && options.debug && window.console ) {
				console.warn( "Nothing selected, can't validate, returning nothing." );
			}
			return;
		}

		// Check if a validator for this form was already created
		var validator = $.data( this[ 0 ], "validator" );
		if ( validator ) {
			return validator;
		}

		// Add novalidate tag if HTML5.
		this.attr( "novalidate", "novalidate" );

		validator = new $.validator( options, this[ 0 ] );
		$.data( this[ 0 ], "validator", validator );

		if ( validator.settings.onsubmit ) {

			this.on( "click.validate", ":submit", function( event ) {

				// Track the used submit button to properly handle scripted
				// submits later.
				validator.submitButton = event.currentTarget;

				// Allow suppressing validation by adding a cancel class to the submit button
				if ( $( this ).hasClass( "cancel" ) ) {
					validator.cancelSubmit = true;
				}

				// Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
				if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
					validator.cancelSubmit = true;
				}
			} );

			// Validate the form on submit
			this.on( "submit.validate", function( event ) {
				if ( validator.settings.debug ) {

					// Prevent form submit to be able to see console output
					event.preventDefault();
				}
				function handle() {
					var hidden, result;

					// Insert a hidden input as a replacement for the missing submit button
					// The hidden input is inserted in two cases:
					//   - A user defined a `submitHandler`
					//   - There was a pending request due to `remote` method and `stopRequest()`
					//     was called to submit the form in case it's valid
					if ( validator.submitButton && ( validator.settings.submitHandler || validator.formSubmitted ) ) {
						hidden = $( "<input type='hidden'/>" )
							.attr( "name", validator.submitButton.name )
							.val( $( validator.submitButton ).val() )
							.appendTo( validator.currentForm );
					}

					if ( validator.settings.submitHandler ) {
						result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
						if ( hidden ) {

							// And clean up afterwards; thanks to no-block-scope, hidden can be referenced
							hidden.remove();
						}
						if ( result !== undefined ) {
							return result;
						}
						return false;
					}
					return true;
				}

				// Prevent submit for invalid forms or custom submit handlers
				if ( validator.cancelSubmit ) {
					validator.cancelSubmit = false;
					return handle();
				}
				if ( validator.form() ) {
					if ( validator.pendingRequest ) {
						validator.formSubmitted = true;
						return false;
					}
					return handle();
				} else {
					validator.focusInvalid();
					return false;
				}
			} );
		}

		return validator;
	},

	// https://jqueryvalidation.org/valid/
	valid: function() {
		var valid, validator, errorList;

		if ( $( this[ 0 ] ).is( "form" ) ) {
			valid = this.validate().form();
		} else {
			errorList = [];
			valid = true;
			validator = $( this[ 0 ].form ).validate();
			this.each( function() {
				valid = validator.element( this ) && valid;
				if ( !valid ) {
					errorList = errorList.concat( validator.errorList );
				}
			} );
			validator.errorList = errorList;
		}
		return valid;
	},

	// https://jqueryvalidation.org/rules/
	rules: function( command, argument ) {
		var element = this[ 0 ],
			settings, staticRules, existingRules, data, param, filtered;

		// If nothing is selected, return empty object; can't chain anyway
		if ( element == null ) {
			return;
		}

		if ( !element.form && element.hasAttribute( "contenteditable" ) ) {
			element.form = this.closest( "form" )[ 0 ];
			element.name = this.attr( "name" );
		}

		if ( element.form == null ) {
			return;
		}

		if ( command ) {
			settings = $.data( element.form, "validator" ).settings;
			staticRules = settings.rules;
			existingRules = $.validator.staticRules( element );
			switch ( command ) {
			case "add":
				$.extend( existingRules, $.validator.normalizeRule( argument ) );

				// Remove messages from rules, but allow them to be set separately
				delete existingRules.messages;
				staticRules[ element.name ] = existingRules;
				if ( argument.messages ) {
					settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
				}
				break;
			case "remove":
				if ( !argument ) {
					delete staticRules[ element.name ];
					return existingRules;
				}
				filtered = {};
				$.each( argument.split( /\s/ ), function( index, method ) {
					filtered[ method ] = existingRules[ method ];
					delete existingRules[ method ];
				} );
				return filtered;
			}
		}

		data = $.validator.normalizeRules(
		$.extend(
			{},
			$.validator.classRules( element ),
			$.validator.attributeRules( element ),
			$.validator.dataRules( element ),
			$.validator.staticRules( element )
		), element );

		// Make sure required is at front
		if ( data.required ) {
			param = data.required;
			delete data.required;
			data = $.extend( { required: param }, data );
		}

		// Make sure remote is at back
		if ( data.remote ) {
			param = data.remote;
			delete data.remote;
			data = $.extend( data, { remote: param } );
		}

		return data;
	}
} );

// Custom selectors
$.extend( $.expr.pseudos || $.expr[ ":" ], {		// '|| $.expr[ ":" ]' here enables backwards compatibility to jQuery 1.7. Can be removed when dropping jQ 1.7.x support

	// https://jqueryvalidation.org/blank-selector/
	blank: function( a ) {
		return !$.trim( "" + $( a ).val() );
	},

	// https://jqueryvalidation.org/filled-selector/
	filled: function( a ) {
		var val = $( a ).val();
		return val !== null && !!$.trim( "" + val );
	},

	// https://jqueryvalidation.org/unchecked-selector/
	unchecked: function( a ) {
		return !$( a ).prop( "checked" );
	}
} );

// Constructor for validator
$.validator = function( options, form ) {
	this.settings = $.extend( true, {}, $.validator.defaults, options );
	this.currentForm = form;
	this.init();
};

// https://jqueryvalidation.org/jQuery.validator.format/
$.validator.format = function( source, params ) {
	if ( arguments.length === 1 ) {
		return function() {
			var args = $.makeArray( arguments );
			args.unshift( source );
			return $.validator.format.apply( this, args );
		};
	}
	if ( params === undefined ) {
		return source;
	}
	if ( arguments.length > 2 && params.constructor !== Array  ) {
		params = $.makeArray( arguments ).slice( 1 );
	}
	if ( params.constructor !== Array ) {
		params = [ params ];
	}
	$.each( params, function( i, n ) {
		source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
			return n;
		} );
	} );
	return source;
};

$.extend( $.validator, {

	defaults: {
		messages: {},
		groups: {},
		rules: {},
		errorClass: "error",
		pendingClass: "pending",
		validClass: "valid",
		errorElement: "label",
		focusCleanup: false,
		focusInvalid: true,
		errorContainer: $( [] ),
		errorLabelContainer: $( [] ),
		onsubmit: true,
		ignore: ":hidden",
		ignoreTitle: false,
		onfocusin: function( element ) {
			this.lastActive = element;

			// Hide error label and remove error class on focus if enabled
			if ( this.settings.focusCleanup ) {
				if ( this.settings.unhighlight ) {
					this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
				}
				this.hideThese( this.errorsFor( element ) );
			}
		},
		onfocusout: function( element ) {
			if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
				this.element( element );
			}
		},
		onkeyup: function( element, event ) {

			// Avoid revalidate the field when pressing one of the following keys
			// Shift       => 16
			// Ctrl        => 17
			// Alt         => 18
			// Caps lock   => 20
			// End         => 35
			// Home        => 36
			// Left arrow  => 37
			// Up arrow    => 38
			// Right arrow => 39
			// Down arrow  => 40
			// Insert      => 45
			// Num lock    => 144
			// AltGr key   => 225
			var excludedKeys = [
				16, 17, 18, 20, 35, 36, 37,
				38, 39, 40, 45, 144, 225
			];

			if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
				return;
			} else if ( element.name in this.submitted || element.name in this.invalid ) {
				this.element( element );
			}
		},
		onclick: function( element ) {

			// Click on selects, radiobuttons and checkboxes
			if ( element.name in this.submitted ) {
				this.element( element );

			// Or option elements, check parent select in that case
			} else if ( element.parentNode.name in this.submitted ) {
				this.element( element.parentNode );
			}
		},
		highlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
			} else {
				$( element ).addClass( errorClass ).removeClass( validClass );
			}
		},
		unhighlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
			} else {
				$( element ).removeClass( errorClass ).addClass( validClass );
			}
		}
	},

	// https://jqueryvalidation.org/jQuery.validator.setDefaults/
	setDefaults: function( settings ) {
		$.extend( $.validator.defaults, settings );
	},

	messages: {
		required: "This field is required.",
		remote: "Please fix this field.",
		email: "Please enter a valid email address.",
		url: "Please enter a valid URL.",
		date: "Please enter a valid date.",
		dateISO: "Please enter a valid date (ISO).",
		number: "Please enter a valid number.",
		digits: "Please enter only digits.",
		equalTo: "Please enter the same value again.",
		maxlength: $.validator.format( "Please enter no more than {0} characters." ),
		minlength: $.validator.format( "Please enter at least {0} characters." ),
		rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
		range: $.validator.format( "Please enter a value between {0} and {1}." ),
		max: $.validator.format( "Please enter a value less than or equal to {0}." ),
		min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
		step: $.validator.format( "Please enter a multiple of {0}." )
	},

	autoCreateRanges: false,

	prototype: {

		init: function() {
			this.labelContainer = $( this.settings.errorLabelContainer );
			this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
			this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
			this.submitted = {};
			this.valueCache = {};
			this.pendingRequest = 0;
			this.pending = {};
			this.invalid = {};
			this.reset();

			var groups = ( this.groups = {} ),
				rules;
			$.each( this.settings.groups, function( key, value ) {
				if ( typeof value === "string" ) {
					value = value.split( /\s/ );
				}
				$.each( value, function( index, name ) {
					groups[ name ] = key;
				} );
			} );
			rules = this.settings.rules;
			$.each( rules, function( key, value ) {
				rules[ key ] = $.validator.normalizeRule( value );
			} );

			function delegate( event ) {

				// Set form expando on contenteditable
				if ( !this.form && this.hasAttribute( "contenteditable" ) ) {
					this.form = $( this ).closest( "form" )[ 0 ];
					this.name = $( this ).attr( "name" );
				}

				var validator = $.data( this.form, "validator" ),
					eventType = "on" + event.type.replace( /^validate/, "" ),
					settings = validator.settings;
				if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
					settings[ eventType ].call( validator, this, event );
				}
			}

			$( this.currentForm )
				.on( "focusin.validate focusout.validate keyup.validate",
					":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
					"[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
					"[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
					"[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate )

				// Support: Chrome, oldIE
				// "select" is provided as event.target when clicking a option
				.on( "click.validate", "select, option, [type='radio'], [type='checkbox']", delegate );

			if ( this.settings.invalidHandler ) {
				$( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
			}
		},

		// https://jqueryvalidation.org/Validator.form/
		form: function() {
			this.checkForm();
			$.extend( this.submitted, this.errorMap );
			this.invalid = $.extend( {}, this.errorMap );
			if ( !this.valid() ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
			}
			this.showErrors();
			return this.valid();
		},

		checkForm: function() {
			this.prepareForm();
			for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
				this.check( elements[ i ] );
			}
			return this.valid();
		},

		// https://jqueryvalidation.org/Validator.element/
		element: function( element ) {
			var cleanElement = this.clean( element ),
				checkElement = this.validationTargetFor( cleanElement ),
				v = this,
				result = true,
				rs, group;

			if ( checkElement === undefined ) {
				delete this.invalid[ cleanElement.name ];
			} else {
				this.prepareElement( checkElement );
				this.currentElements = $( checkElement );

				// If this element is grouped, then validate all group elements already
				// containing a value
				group = this.groups[ checkElement.name ];
				if ( group ) {
					$.each( this.groups, function( name, testgroup ) {
						if ( testgroup === group && name !== checkElement.name ) {
							cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
							if ( cleanElement && cleanElement.name in v.invalid ) {
								v.currentElements.push( cleanElement );
								result = v.check( cleanElement ) && result;
							}
						}
					} );
				}

				rs = this.check( checkElement ) !== false;
				result = result && rs;
				if ( rs ) {
					this.invalid[ checkElement.name ] = false;
				} else {
					this.invalid[ checkElement.name ] = true;
				}

				if ( !this.numberOfInvalids() ) {

					// Hide error containers on last error
					this.toHide = this.toHide.add( this.containers );
				}
				this.showErrors();

				// Add aria-invalid status for screen readers
				$( element ).attr( "aria-invalid", !rs );
			}

			return result;
		},

		// https://jqueryvalidation.org/Validator.showErrors/
		showErrors: function( errors ) {
			if ( errors ) {
				var validator = this;

				// Add items to error list and map
				$.extend( this.errorMap, errors );
				this.errorList = $.map( this.errorMap, function( message, name ) {
					return {
						message: message,
						element: validator.findByName( name )[ 0 ]
					};
				} );

				// Remove items from success list
				this.successList = $.grep( this.successList, function( element ) {
					return !( element.name in errors );
				} );
			}
			if ( this.settings.showErrors ) {
				this.settings.showErrors.call( this, this.errorMap, this.errorList );
			} else {
				this.defaultShowErrors();
			}
		},

		// https://jqueryvalidation.org/Validator.resetForm/
		resetForm: function() {
			if ( $.fn.resetForm ) {
				$( this.currentForm ).resetForm();
			}
			this.invalid = {};
			this.submitted = {};
			this.prepareForm();
			this.hideErrors();
			var elements = this.elements()
				.removeData( "previousValue" )
				.removeAttr( "aria-invalid" );

			this.resetElements( elements );
		},

		resetElements: function( elements ) {
			var i;

			if ( this.settings.unhighlight ) {
				for ( i = 0; elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ],
						this.settings.errorClass, "" );
					this.findByName( elements[ i ].name ).removeClass( this.settings.validClass );
				}
			} else {
				elements
					.removeClass( this.settings.errorClass )
					.removeClass( this.settings.validClass );
			}
		},

		numberOfInvalids: function() {
			return this.objectLength( this.invalid );
		},

		objectLength: function( obj ) {
			/* jshint unused: false */
			var count = 0,
				i;
			for ( i in obj ) {

				// This check allows counting elements with empty error
				// message as invalid elements
				if ( obj[ i ] !== undefined && obj[ i ] !== null && obj[ i ] !== false ) {
					count++;
				}
			}
			return count;
		},

		hideErrors: function() {
			this.hideThese( this.toHide );
		},

		hideThese: function( errors ) {
			errors.not( this.containers ).text( "" );
			this.addWrapper( errors ).hide();
		},

		valid: function() {
			return this.size() === 0;
		},

		size: function() {
			return this.errorList.length;
		},

		focusInvalid: function() {
			if ( this.settings.focusInvalid ) {
				try {
					$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
					.filter( ":visible" )
					.focus()

					// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
					.trigger( "focusin" );
				} catch ( e ) {

					// Ignore IE throwing errors when focusing hidden elements
				}
			}
		},

		findLastActive: function() {
			var lastActive = this.lastActive;
			return lastActive && $.grep( this.errorList, function( n ) {
				return n.element.name === lastActive.name;
			} ).length === 1 && lastActive;
		},

		elements: function() {
			var validator = this,
				rulesCache = {};

			// Select all valid inputs inside the form (no submit or reset buttons)
			return $( this.currentForm )
			.find( "input, select, textarea, [contenteditable]" )
			.not( ":submit, :reset, :image, :disabled" )
			.not( this.settings.ignore )
			.filter( function() {
				var name = this.name || $( this ).attr( "name" ); // For contenteditable
				if ( !name && validator.settings.debug && window.console ) {
					console.error( "%o has no name assigned", this );
				}

				// Set form expando on contenteditable
				if ( this.hasAttribute( "contenteditable" ) ) {
					this.form = $( this ).closest( "form" )[ 0 ];
					this.name = name;
				}

				// Select only the first element for each name, and only those with rules specified
				if ( name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
					return false;
				}

				rulesCache[ name ] = true;
				return true;
			} );
		},

		clean: function( selector ) {
			return $( selector )[ 0 ];
		},

		errors: function() {
			var errorClass = this.settings.errorClass.split( " " ).join( "." );
			return $( this.settings.errorElement + "." + errorClass, this.errorContext );
		},

		resetInternals: function() {
			this.successList = [];
			this.errorList = [];
			this.errorMap = {};
			this.toShow = $( [] );
			this.toHide = $( [] );
		},

		reset: function() {
			this.resetInternals();
			this.currentElements = $( [] );
		},

		prepareForm: function() {
			this.reset();
			this.toHide = this.errors().add( this.containers );
		},

		prepareElement: function( element ) {
			this.reset();
			this.toHide = this.errorsFor( element );
		},

		elementValue: function( element ) {
			var $element = $( element ),
				type = element.type,
				val, idx;

			if ( type === "radio" || type === "checkbox" ) {
				return this.findByName( element.name ).filter( ":checked" ).val();
			} else if ( type === "number" && typeof element.validity !== "undefined" ) {
				return element.validity.badInput ? "NaN" : $element.val();
			}

			if ( element.hasAttribute( "contenteditable" ) ) {
				val = $element.text();
			} else {
				val = $element.val();
			}

			if ( type === "file" ) {

				// Modern browser (chrome & safari)
				if ( val.substr( 0, 12 ) === "C:\\fakepath\\" ) {
					return val.substr( 12 );
				}

				// Legacy browsers
				// Unix-based path
				idx = val.lastIndexOf( "/" );
				if ( idx >= 0 ) {
					return val.substr( idx + 1 );
				}

				// Windows-based path
				idx = val.lastIndexOf( "\\" );
				if ( idx >= 0 ) {
					return val.substr( idx + 1 );
				}

				// Just the file name
				return val;
			}

			if ( typeof val === "string" ) {
				return val.replace( /\r/g, "" );
			}
			return val;
		},

		check: function( element ) {
			element = this.validationTargetFor( this.clean( element ) );

			var rules = $( element ).rules(),
				rulesCount = $.map( rules, function( n, i ) {
					return i;
				} ).length,
				dependencyMismatch = false,
				val = this.elementValue( element ),
				result, method, rule, normalizer;

			// Prioritize the local normalizer defined for this element over the global one
			// if the former exists, otherwise user the global one in case it exists.
			if ( typeof rules.normalizer === "function" ) {
				normalizer = rules.normalizer;
			} else if (	typeof this.settings.normalizer === "function" ) {
				normalizer = this.settings.normalizer;
			}

			// If normalizer is defined, then call it to retreive the changed value instead
			// of using the real one.
			// Note that `this` in the normalizer is `element`.
			if ( normalizer ) {
				val = normalizer.call( element, val );

				if ( typeof val !== "string" ) {
					throw new TypeError( "The normalizer should return a string value." );
				}

				// Delete the normalizer from rules to avoid treating it as a pre-defined method.
				delete rules.normalizer;
			}

			for ( method in rules ) {
				rule = { method: method, parameters: rules[ method ] };
				try {
					result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

					// If a method indicates that the field is optional and therefore valid,
					// don't mark it as valid when there are no other rules
					if ( result === "dependency-mismatch" && rulesCount === 1 ) {
						dependencyMismatch = true;
						continue;
					}
					dependencyMismatch = false;

					if ( result === "pending" ) {
						this.toHide = this.toHide.not( this.errorsFor( element ) );
						return;
					}

					if ( !result ) {
						this.formatAndAdd( element, rule );
						return false;
					}
				} catch ( e ) {
					if ( this.settings.debug && window.console ) {
						console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
					}
					if ( e instanceof TypeError ) {
						e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
					}

					throw e;
				}
			}
			if ( dependencyMismatch ) {
				return;
			}
			if ( this.objectLength( rules ) ) {
				this.successList.push( element );
			}
			return true;
		},

		// Return the custom message for the given element and validation method
		// specified in the element's HTML5 data attribute
		// return the generic message if present and no method specific message is present
		customDataMessage: function( element, method ) {
			return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
				method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
		},

		// Return the custom message for the given element name and validation method
		customMessage: function( name, method ) {
			var m = this.settings.messages[ name ];
			return m && ( m.constructor === String ? m : m[ method ] );
		},

		// Return the first defined argument, allowing empty strings
		findDefined: function() {
			for ( var i = 0; i < arguments.length; i++ ) {
				if ( arguments[ i ] !== undefined ) {
					return arguments[ i ];
				}
			}
			return undefined;
		},

		// The second parameter 'rule' used to be a string, and extended to an object literal
		// of the following form:
		// rule = {
		//     method: "method name",
		//     parameters: "the given method parameters"
		// }
		//
		// The old behavior still supported, kept to maintain backward compatibility with
		// old code, and will be removed in the next major release.
		defaultMessage: function( element, rule ) {
			if ( typeof rule === "string" ) {
				rule = { method: rule };
			}

			var message = this.findDefined(
					this.customMessage( element.name, rule.method ),
					this.customDataMessage( element, rule.method ),

					// 'title' is never undefined, so handle empty string as undefined
					!this.settings.ignoreTitle && element.title || undefined,
					$.validator.messages[ rule.method ],
					"<strong>Warning: No message defined for " + element.name + "</strong>"
				),
				theregex = /\$?\{(\d+)\}/g;
			if ( typeof message === "function" ) {
				message = message.call( this, rule.parameters, element );
			} else if ( theregex.test( message ) ) {
				message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
			}

			return message;
		},

		formatAndAdd: function( element, rule ) {
			var message = this.defaultMessage( element, rule );

			this.errorList.push( {
				message: message,
				element: element,
				method: rule.method
			} );

			this.errorMap[ element.name ] = message;
			this.submitted[ element.name ] = message;
		},

		addWrapper: function( toToggle ) {
			if ( this.settings.wrapper ) {
				toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
			}
			return toToggle;
		},

		defaultShowErrors: function() {
			var i, elements, error;
			for ( i = 0; this.errorList[ i ]; i++ ) {
				error = this.errorList[ i ];
				if ( this.settings.highlight ) {
					this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
				}
				this.showLabel( error.element, error.message );
			}
			if ( this.errorList.length ) {
				this.toShow = this.toShow.add( this.containers );
			}
			if ( this.settings.success ) {
				for ( i = 0; this.successList[ i ]; i++ ) {
					this.showLabel( this.successList[ i ] );
				}
			}
			if ( this.settings.unhighlight ) {
				for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
				}
			}
			this.toHide = this.toHide.not( this.toShow );
			this.hideErrors();
			this.addWrapper( this.toShow ).show();
		},

		validElements: function() {
			return this.currentElements.not( this.invalidElements() );
		},

		invalidElements: function() {
			return $( this.errorList ).map( function() {
				return this.element;
			} );
		},

		showLabel: function( element, message ) {
			var place, group, errorID, v,
				error = this.errorsFor( element ),
				elementID = this.idOrName( element ),
				describedBy = $( element ).attr( "aria-describedby" );

			if ( error.length ) {

				// Refresh error/success class
				error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );

				// Replace message on existing label
				error.html( message );
			} else {

				// Create error element
				error = $( "<" + this.settings.errorElement + ">" )
					.attr( "id", elementID + "-error" )
					.addClass( this.settings.errorClass )
					.html( message || "" );

				// Maintain reference to the element to be placed into the DOM
				place = error;
				if ( this.settings.wrapper ) {

					// Make sure the element is visible, even in IE
					// actually showing the wrapped element is handled elsewhere
					place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
				}
				if ( this.labelContainer.length ) {
					this.labelContainer.append( place );
				} else if ( this.settings.errorPlacement ) {
					this.settings.errorPlacement.call( this, place, $( element ) );
				} else {
					place.insertAfter( element );
				}

				// Link error back to the element
				if ( error.is( "label" ) ) {

					// If the error is a label, then associate using 'for'
					error.attr( "for", elementID );

					// If the element is not a child of an associated label, then it's necessary
					// to explicitly apply aria-describedby
				} else if ( error.parents( "label[for='" + this.escapeCssMeta( elementID ) + "']" ).length === 0 ) {
					errorID = error.attr( "id" );

					// Respect existing non-error aria-describedby
					if ( !describedBy ) {
						describedBy = errorID;
					} else if ( !describedBy.match( new RegExp( "\\b" + this.escapeCssMeta( errorID ) + "\\b" ) ) ) {

						// Add to end of list if not already present
						describedBy += " " + errorID;
					}
					$( element ).attr( "aria-describedby", describedBy );

					// If this element is grouped, then assign to all elements in the same group
					group = this.groups[ element.name ];
					if ( group ) {
						v = this;
						$.each( v.groups, function( name, testgroup ) {
							if ( testgroup === group ) {
								$( "[name='" + v.escapeCssMeta( name ) + "']", v.currentForm )
									.attr( "aria-describedby", error.attr( "id" ) );
							}
						} );
					}
				}
			}
			if ( !message && this.settings.success ) {
				error.text( "" );
				if ( typeof this.settings.success === "string" ) {
					error.addClass( this.settings.success );
				} else {
					this.settings.success( error, element );
				}
			}
			this.toShow = this.toShow.add( error );
		},

		errorsFor: function( element ) {
			var name = this.escapeCssMeta( this.idOrName( element ) ),
				describer = $( element ).attr( "aria-describedby" ),
				selector = "label[for='" + name + "'], label[for='" + name + "'] *";

			// 'aria-describedby' should directly reference the error element
			if ( describer ) {
				selector = selector + ", #" + this.escapeCssMeta( describer )
					.replace( /\s+/g, ", #" );
			}

			return this
				.errors()
				.filter( selector );
		},

		// See https://api.jquery.com/category/selectors/, for CSS
		// meta-characters that should be escaped in order to be used with JQuery
		// as a literal part of a name/id or any selector.
		escapeCssMeta: function( string ) {
			return string.replace( /([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1" );
		},

		idOrName: function( element ) {
			return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
		},

		validationTargetFor: function( element ) {

			// If radio/checkbox, validate first element in group instead
			if ( this.checkable( element ) ) {
				element = this.findByName( element.name );
			}

			// Always apply ignore filter
			return $( element ).not( this.settings.ignore )[ 0 ];
		},

		checkable: function( element ) {
			return ( /radio|checkbox/i ).test( element.type );
		},

		findByName: function( name ) {
			return $( this.currentForm ).find( "[name='" + this.escapeCssMeta( name ) + "']" );
		},

		getLength: function( value, element ) {
			switch ( element.nodeName.toLowerCase() ) {
			case "select":
				return $( "option:selected", element ).length;
			case "input":
				if ( this.checkable( element ) ) {
					return this.findByName( element.name ).filter( ":checked" ).length;
				}
			}
			return value.length;
		},

		depend: function( param, element ) {
			return this.dependTypes[ typeof param ] ? this.dependTypes[ typeof param ]( param, element ) : true;
		},

		dependTypes: {
			"boolean": function( param ) {
				return param;
			},
			"string": function( param, element ) {
				return !!$( param, element.form ).length;
			},
			"function": function( param, element ) {
				return param( element );
			}
		},

		optional: function( element ) {
			var val = this.elementValue( element );
			return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
		},

		startRequest: function( element ) {
			if ( !this.pending[ element.name ] ) {
				this.pendingRequest++;
				$( element ).addClass( this.settings.pendingClass );
				this.pending[ element.name ] = true;
			}
		},

		stopRequest: function( element, valid ) {
			this.pendingRequest--;

			// Sometimes synchronization fails, make sure pendingRequest is never < 0
			if ( this.pendingRequest < 0 ) {
				this.pendingRequest = 0;
			}
			delete this.pending[ element.name ];
			$( element ).removeClass( this.settings.pendingClass );
			if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
				$( this.currentForm ).submit();

				// Remove the hidden input that was used as a replacement for the
				// missing submit button. The hidden input is added by `handle()`
				// to ensure that the value of the used submit button is passed on
				// for scripted submits triggered by this method
				if ( this.submitButton ) {
					$( "input:hidden[name='" + this.submitButton.name + "']", this.currentForm ).remove();
				}

				this.formSubmitted = false;
			} else if ( !valid && this.pendingRequest === 0 && this.formSubmitted ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
				this.formSubmitted = false;
			}
		},

		previousValue: function( element, method ) {
			method = typeof method === "string" && method || "remote";

			return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
				old: null,
				valid: true,
				message: this.defaultMessage( element, { method: method } )
			} );
		},

		// Cleans up all forms and elements, removes validator-specific events
		destroy: function() {
			this.resetForm();

			$( this.currentForm )
				.off( ".validate" )
				.removeData( "validator" )
				.find( ".validate-equalTo-blur" )
					.off( ".validate-equalTo" )
					.removeClass( "validate-equalTo-blur" );
		}

	},

	classRuleSettings: {
		required: { required: true },
		email: { email: true },
		url: { url: true },
		date: { date: true },
		dateISO: { dateISO: true },
		number: { number: true },
		digits: { digits: true },
		creditcard: { creditcard: true }
	},

	addClassRules: function( className, rules ) {
		if ( className.constructor === String ) {
			this.classRuleSettings[ className ] = rules;
		} else {
			$.extend( this.classRuleSettings, className );
		}
	},

	classRules: function( element ) {
		var rules = {},
			classes = $( element ).attr( "class" );

		if ( classes ) {
			$.each( classes.split( " " ), function() {
				if ( this in $.validator.classRuleSettings ) {
					$.extend( rules, $.validator.classRuleSettings[ this ] );
				}
			} );
		}
		return rules;
	},

	normalizeAttributeRule: function( rules, type, method, value ) {

		// Convert the value to a number for number inputs, and for text for backwards compability
		// allows type="date" and others to be compared as strings
		if ( /min|max|step/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
			value = Number( value );

			// Support Opera Mini, which returns NaN for undefined minlength
			if ( isNaN( value ) ) {
				value = undefined;
			}
		}

		if ( value || value === 0 ) {
			rules[ method ] = value;
		} else if ( type === method && type !== "range" ) {

			// Exception: the jquery validate 'range' method
			// does not test for the html5 'range' type
			rules[ method ] = true;
		}
	},

	attributeRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {

			// Support for <input required> in both html5 and older browsers
			if ( method === "required" ) {
				value = element.getAttribute( method );

				// Some browsers return an empty string for the required attribute
				// and non-HTML5 browsers might have required="" markup
				if ( value === "" ) {
					value = true;
				}

				// Force non-HTML5 browsers to return bool
				value = !!value;
			} else {
				value = $element.attr( method );
			}

			this.normalizeAttributeRule( rules, type, method, value );
		}

		// 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
		if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
			delete rules.maxlength;
		}

		return rules;
	},

	dataRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {
			value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
			this.normalizeAttributeRule( rules, type, method, value );
		}
		return rules;
	},

	staticRules: function( element ) {
		var rules = {},
			validator = $.data( element.form, "validator" );

		if ( validator.settings.rules ) {
			rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
		}
		return rules;
	},

	normalizeRules: function( rules, element ) {

		// Handle dependency check
		$.each( rules, function( prop, val ) {

			// Ignore rule when param is explicitly false, eg. required:false
			if ( val === false ) {
				delete rules[ prop ];
				return;
			}
			if ( val.param || val.depends ) {
				var keepRule = true;
				switch ( typeof val.depends ) {
				case "string":
					keepRule = !!$( val.depends, element.form ).length;
					break;
				case "function":
					keepRule = val.depends.call( element, element );
					break;
				}
				if ( keepRule ) {
					rules[ prop ] = val.param !== undefined ? val.param : true;
				} else {
					$.data( element.form, "validator" ).resetElements( $( element ) );
					delete rules[ prop ];
				}
			}
		} );

		// Evaluate parameters
		$.each( rules, function( rule, parameter ) {
			rules[ rule ] = $.isFunction( parameter ) && rule !== "normalizer" ? parameter( element ) : parameter;
		} );

		// Clean number parameters
		$.each( [ "minlength", "maxlength" ], function() {
			if ( rules[ this ] ) {
				rules[ this ] = Number( rules[ this ] );
			}
		} );
		$.each( [ "rangelength", "range" ], function() {
			var parts;
			if ( rules[ this ] ) {
				if ( $.isArray( rules[ this ] ) ) {
					rules[ this ] = [ Number( rules[ this ][ 0 ] ), Number( rules[ this ][ 1 ] ) ];
				} else if ( typeof rules[ this ] === "string" ) {
					parts = rules[ this ].replace( /[\[\]]/g, "" ).split( /[\s,]+/ );
					rules[ this ] = [ Number( parts[ 0 ] ), Number( parts[ 1 ] ) ];
				}
			}
		} );

		if ( $.validator.autoCreateRanges ) {

			// Auto-create ranges
			if ( rules.min != null && rules.max != null ) {
				rules.range = [ rules.min, rules.max ];
				delete rules.min;
				delete rules.max;
			}
			if ( rules.minlength != null && rules.maxlength != null ) {
				rules.rangelength = [ rules.minlength, rules.maxlength ];
				delete rules.minlength;
				delete rules.maxlength;
			}
		}

		return rules;
	},

	// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
	normalizeRule: function( data ) {
		if ( typeof data === "string" ) {
			var transformed = {};
			$.each( data.split( /\s/ ), function() {
				transformed[ this ] = true;
			} );
			data = transformed;
		}
		return data;
	},

	// https://jqueryvalidation.org/jQuery.validator.addMethod/
	addMethod: function( name, method, message ) {
		$.validator.methods[ name ] = method;
		$.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
		if ( method.length < 3 ) {
			$.validator.addClassRules( name, $.validator.normalizeRule( name ) );
		}
	},

	// https://jqueryvalidation.org/jQuery.validator.methods/
	methods: {

		// https://jqueryvalidation.org/required-method/
		required: function( value, element, param ) {

			// Check if dependency is met
			if ( !this.depend( param, element ) ) {
				return "dependency-mismatch";
			}
			if ( element.nodeName.toLowerCase() === "select" ) {

				// Could be an array for select-multiple or a string, both are fine this way
				var val = $( element ).val();
				return val && val.length > 0;
			}
			if ( this.checkable( element ) ) {
				return this.getLength( value, element ) > 0;
			}
			return value.length > 0;
		},

		// https://jqueryvalidation.org/email-method/
		email: function( value, element ) {

			// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
			// Retrieved 2014-01-14
			// If you have a problem with this implementation, report a bug against the above spec
			// Or use custom methods to implement your own email validation
			return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
		},

		// https://jqueryvalidation.org/url-method/
		url: function( value, element ) {

			// Copyright (c) 2010-2013 Diego Perini, MIT licensed
			// https://gist.github.com/dperini/729294
			// see also https://mathiasbynens.be/demo/url-regex
			// modified to allow protocol-relative URLs
			return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
		},

		// https://jqueryvalidation.org/date-method/
		date: function( value, element ) {
			return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
		},

		// https://jqueryvalidation.org/dateISO-method/
		dateISO: function( value, element ) {
			return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
		},

		// https://jqueryvalidation.org/number-method/
		number: function( value, element ) {
			return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
		},

		// https://jqueryvalidation.org/digits-method/
		digits: function( value, element ) {
			return this.optional( element ) || /^\d+$/.test( value );
		},

		// https://jqueryvalidation.org/minlength-method/
		minlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length >= param;
		},

		// https://jqueryvalidation.org/maxlength-method/
		maxlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length <= param;
		},

		// https://jqueryvalidation.org/rangelength-method/
		rangelength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
		},

		// https://jqueryvalidation.org/min-method/
		min: function( value, element, param ) {
			return this.optional( element ) || value >= param;
		},

		// https://jqueryvalidation.org/max-method/
		max: function( value, element, param ) {
			return this.optional( element ) || value <= param;
		},

		// https://jqueryvalidation.org/range-method/
		range: function( value, element, param ) {
			return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
		},

		// https://jqueryvalidation.org/step-method/
		step: function( value, element, param ) {
			var type = $( element ).attr( "type" ),
				errorMessage = "Step attribute on input type " + type + " is not supported.",
				supportedTypes = [ "text", "number", "range" ],
				re = new RegExp( "\\b" + type + "\\b" ),
				notSupported = type && !re.test( supportedTypes.join() ),
				decimalPlaces = function( num ) {
					var match = ( "" + num ).match( /(?:\.(\d+))?$/ );
					if ( !match ) {
						return 0;
					}

					// Number of digits right of decimal point.
					return match[ 1 ] ? match[ 1 ].length : 0;
				},
				toInt = function( num ) {
					return Math.round( num * Math.pow( 10, decimals ) );
				},
				valid = true,
				decimals;

			// Works only for text, number and range input types
			// TODO find a way to support input types date, datetime, datetime-local, month, time and week
			if ( notSupported ) {
				throw new Error( errorMessage );
			}

			decimals = decimalPlaces( param );

			// Value can't have too many decimals
			if ( decimalPlaces( value ) > decimals || toInt( value ) % toInt( param ) !== 0 ) {
				valid = false;
			}

			return this.optional( element ) || valid;
		},

		// https://jqueryvalidation.org/equalTo-method/
		equalTo: function( value, element, param ) {

			// Bind to the blur event of the target in order to revalidate whenever the target field is updated
			var target = $( param );
			if ( this.settings.onfocusout && target.not( ".validate-equalTo-blur" ).length ) {
				target.addClass( "validate-equalTo-blur" ).on( "blur.validate-equalTo", function() {
					$( element ).valid();
				} );
			}
			return value === target.val();
		},

		// https://jqueryvalidation.org/remote-method/
		remote: function( value, element, param, method ) {
			if ( this.optional( element ) ) {
				return "dependency-mismatch";
			}

			method = typeof method === "string" && method || "remote";

			var previous = this.previousValue( element, method ),
				validator, data, optionDataString;

			if ( !this.settings.messages[ element.name ] ) {
				this.settings.messages[ element.name ] = {};
			}
			previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
			this.settings.messages[ element.name ][ method ] = previous.message;

			param = typeof param === "string" && { url: param } || param;
			optionDataString = $.param( $.extend( { data: value }, param.data ) );
			if ( previous.old === optionDataString ) {
				return previous.valid;
			}

			previous.old = optionDataString;
			validator = this;
			this.startRequest( element );
			data = {};
			data[ element.name ] = value;
			$.ajax( $.extend( true, {
				mode: "abort",
				port: "validate" + element.name,
				dataType: "json",
				data: data,
				context: validator.currentForm,
				success: function( response ) {
					var valid = response === true || response === "true",
						errors, message, submitted;

					validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
					if ( valid ) {
						submitted = validator.formSubmitted;
						validator.resetInternals();
						validator.toHide = validator.errorsFor( element );
						validator.formSubmitted = submitted;
						validator.successList.push( element );
						validator.invalid[ element.name ] = false;
						validator.showErrors();
					} else {
						errors = {};
						message = response || validator.defaultMessage( element, { method: method, parameters: value } );
						errors[ element.name ] = previous.message = message;
						validator.invalid[ element.name ] = true;
						validator.showErrors( errors );
					}
					previous.valid = valid;
					validator.stopRequest( element, valid );
				}
			}, param ) );
			return "pending";
		}
	}

} );

// Ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

var pendingRequests = {},
	ajax;

// Use a prefilter if available (1.5+)
if ( $.ajaxPrefilter ) {
	$.ajaxPrefilter( function( settings, _, xhr ) {
		var port = settings.port;
		if ( settings.mode === "abort" ) {
			if ( pendingRequests[ port ] ) {
				pendingRequests[ port ].abort();
			}
			pendingRequests[ port ] = xhr;
		}
	} );
} else {

	// Proxy ajax
	ajax = $.ajax;
	$.ajax = function( settings ) {
		var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
			port = ( "port" in settings ? settings : $.ajaxSettings ).port;
		if ( mode === "abort" ) {
			if ( pendingRequests[ port ] ) {
				pendingRequests[ port ].abort();
			}
			pendingRequests[ port ] = ajax.apply( this, arguments );
			return pendingRequests[ port ];
		}
		return ajax.apply( this, arguments );
	};
}
return $;
}));

// Unobtrusive validation support library for jQuery and jQuery Validate
// Copyright (C) Microsoft Corporation. All rights reserved.
// @version v3.2.7

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global document: false, jQuery: false */

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("jquery.validate.unobtrusive", ['jquery.validate'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS-like environments that support module.exports     
        module.exports = factory(require('jquery-validation'));
    } else {
        // Browser global
        jQuery.validator.unobtrusive = factory(jQuery);
    }
}(function ($) {
    var $jQval = $.validator,
        adapters,
        data_validation = "unobtrusiveValidation";

    function setValidationValues(options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    }

    function splitAndTrim(value) {
        return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
    }

    function escapeAttributeValue(value) {
        // As mentioned on http://api.jquery.com/category/selectors/
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
    }

    function getModelPrefix(fieldName) {
        return fieldName.substr(0, fieldName.lastIndexOf(".") + 1);
    }

    function appendModelPrefix(value, prefix) {
        if (value.indexOf("*.") === 0) {
            value = value.replace("*.", prefix);
        }
        return value;
    }

    function onError(error, inputElement) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
            replaceAttrValue = container.attr("data-valmsg-replace"),
            replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) !== false : null;

        container.removeClass("field-validation-valid").addClass("field-validation-error");
        error.data("unobtrusiveContainer", container);

        if (replace) {
            container.empty();
            error.removeClass("input-validation-error").appendTo(container);
        }
        else {
            error.hide();
        }
    }

    function onErrors(event, validator) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-summary=true]"),
            list = container.find("ul");

        if (list && list.length && validator.errorList.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");

            $.each(validator.errorList, function () {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }

    function onSuccess(error) {  // 'this' is the form element
        var container = error.data("unobtrusiveContainer");

        if (container) {
            var replaceAttrValue = container.attr("data-valmsg-replace"),
                replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) : null;

            container.addClass("field-validation-valid").removeClass("field-validation-error");
            error.removeData("unobtrusiveContainer");

            if (replace) {
                container.empty();
            }
        }
    }

    function onReset(event) {  // 'this' is the form element
        var $form = $(this),
            key = '__jquery_unobtrusive_validation_form_reset';
        if ($form.data(key)) {
            return;
        }
        // Set a flag that indicates we're currently resetting the form.
        $form.data(key, true);
        try {
            $form.data("validator").resetForm();
        } finally {
            $form.removeData(key);
        }

        $form.find(".validation-summary-errors")
            .addClass("validation-summary-valid")
            .removeClass("validation-summary-errors");
        $form.find(".field-validation-error")
            .addClass("field-validation-valid")
            .removeClass("field-validation-error")
            .removeData("unobtrusiveContainer")
            .find(">*")  // If we were using valmsg-replace, get the underlying error
                .removeData("unobtrusiveContainer");
    }

    function validationInfo(form) {
        var $form = $(form),
            result = $form.data(data_validation),
            onResetProxy = $.proxy(onReset, form),
            defaultOptions = $jQval.unobtrusive.options || {},
            execInContext = function (name, args) {
                var func = defaultOptions[name];
                func && $.isFunction(func) && func.apply(form, args);
            }

        if (!result) {
            result = {
                options: {  // options structure passed to jQuery Validate's validate() method
                    errorClass: defaultOptions.errorClass || "input-validation-error",
                    errorElement: defaultOptions.errorElement || "span",
                    errorPlacement: function () {
                        onError.apply(form, arguments);
                        execInContext("errorPlacement", arguments);
                    },
                    invalidHandler: function () {
                        onErrors.apply(form, arguments);
                        execInContext("invalidHandler", arguments);
                    },
                    messages: {},
                    rules: {},
                    success: function () {
                        onSuccess.apply(form, arguments);
                        execInContext("success", arguments);
                    }
                },
                attachValidation: function () {
                    $form
                        .off("reset." + data_validation, onResetProxy)
                        .on("reset." + data_validation, onResetProxy)
                        .validate(this.options);
                },
                validate: function () {  // a validation function that is called by unobtrusive Ajax
                    $form.validate();
                    return $form.valid();
                }
            };
            $form.data(data_validation, result);
        }

        return result;
    }

    $jQval.unobtrusive = {
        adapters: [],

        parseElement: function (element, skipAttach) {
            /// <summary>
            /// Parses a single HTML element for unobtrusive validation attributes.
            /// </summary>
            /// <param name="element" domElement="true">The HTML element to be parsed.</param>
            /// <param name="skipAttach" type="Boolean">[Optional] true to skip attaching the
            /// validation to the form. If parsing just this single element, you should specify true.
            /// If parsing several elements, you should specify false, and manually attach the validation
            /// to the form when you are finished. The default is false.</param>
            var $element = $(element),
                form = $element.parents("form")[0],
                valInfo, rules, messages;

            if (!form) {  // Cannot do client-side validation without a form
                return;
            }

            valInfo = validationInfo(form);
            valInfo.options.rules[element.name] = rules = {};
            valInfo.options.messages[element.name] = messages = {};

            $.each(this.adapters, function () {
                var prefix = "data-val-" + this.name,
                    message = $element.attr(prefix),
                    paramValues = {};

                if (message !== undefined) {  // Compare against undefined, because an empty message is legal (and falsy)
                    prefix += "-";

                    $.each(this.params, function () {
                        paramValues[this] = $element.attr(prefix + this);
                    });

                    this.adapt({
                        element: element,
                        form: form,
                        message: message,
                        params: paramValues,
                        rules: rules,
                        messages: messages
                    });
                }
            });

            $.extend(rules, { "__dummy__": true });

            if (!skipAttach) {
                valInfo.attachValidation();
            }
        },

        parse: function (selector) {
            /// <summary>
            /// Parses all the HTML elements in the specified selector. It looks for input elements decorated
            /// with the [data-val=true] attribute value and enables validation according to the data-val-*
            /// attribute values.
            /// </summary>
            /// <param name="selector" type="String">Any valid jQuery selector.</param>

            // $forms includes all forms in selector's DOM hierarchy (parent, children and self) that have at least one
            // element with data-val=true
            var $selector = $(selector),
                $forms = $selector.parents()
                                  .addBack()
                                  .filter("form")
                                  .add($selector.find("form"))
                                  .has("[data-val=true]");

            $selector.find("[data-val=true]").each(function () {
                $jQval.unobtrusive.parseElement(this, true);
            });

            $forms.each(function () {
                var info = validationInfo(this);
                if (info) {
                    info.attachValidation();
                }
            });
        }
    };

    adapters = $jQval.unobtrusive.adapters;

    adapters.add = function (adapterName, params, fn) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="params" type="Array" optional="true">[Optional] An array of parameter names (strings) that will
        /// be extracted from the data-val-nnnn-mmmm HTML attributes (where nnnn is the adapter name, and
        /// mmmm is the parameter name).</param>
        /// <param name="fn" type="Function">The function to call, which adapts the values from the HTML
        /// attributes into jQuery Validate rules and/or messages.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        if (!fn) {  // Called with no params, just a function
            fn = params;
            params = [];
        }
        this.push({ name: adapterName, params: params, adapt: fn });
        return this;
    };

    adapters.addBool = function (adapterName, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has no parameter values.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, function (options) {
            setValidationValues(options, ruleName || adapterName, true);
        });
    };

    adapters.addMinMax = function (adapterName, minRuleName, maxRuleName, minMaxRuleName, minAttribute, maxAttribute) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation has three potential rules (one for min-only, one for max-only, and
        /// one for min-and-max). The HTML parameters are expected to be named -min and -max.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="minRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a minimum value.</param>
        /// <param name="maxRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a maximum value.</param>
        /// <param name="minMaxRuleName" type="String">The name of the jQuery Validate rule to be used when you
        /// have both a minimum and maximum value.</param>
        /// <param name="minAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the minimum value. The default is "min".</param>
        /// <param name="maxAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the maximum value. The default is "max".</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [minAttribute || "min", maxAttribute || "max"], function (options) {
            var min = options.params.min,
                max = options.params.max;

            if (min && max) {
                setValidationValues(options, minMaxRuleName, [min, max]);
            }
            else if (min) {
                setValidationValues(options, minRuleName, min);
            }
            else if (max) {
                setValidationValues(options, maxRuleName, max);
            }
        });
    };

    adapters.addSingleVal = function (adapterName, attribute, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has a single value.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute(where nnnn is the adapter name).</param>
        /// <param name="attribute" type="String">[Optional] The name of the HTML attribute that contains the value.
        /// The default is "val".</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [attribute || "val"], function (options) {
            setValidationValues(options, ruleName || adapterName, options.params[attribute]);
        });
    };

    $jQval.addMethod("__dummy__", function (value, element, params) {
        return true;
    });

    $jQval.addMethod("regex", function (value, element, params) {
        var match;
        if (this.optional(element)) {
            return true;
        }

        match = new RegExp(params).exec(value);
        return (match && (match.index === 0) && (match[0].length === value.length));
    });

    $jQval.addMethod("nonalphamin", function (value, element, nonalphamin) {
        var match;
        if (nonalphamin) {
            match = value.match(/\W/g);
            match = match && match.length >= nonalphamin;
        }
        return match;
    });

    if ($jQval.methods.extension) {
        adapters.addSingleVal("accept", "mimtype");
        adapters.addSingleVal("extension", "extension");
    } else {
        // for backward compatibility, when the 'extension' validation method does not exist, such as with versions
        // of JQuery Validation plugin prior to 1.10, we should use the 'accept' method for
        // validating the extension, and ignore mime-type validations as they are not supported.
        adapters.addSingleVal("extension", "extension", "accept");
    }

    adapters.addSingleVal("regex", "pattern");
    adapters.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");
    adapters.addMinMax("length", "minlength", "maxlength", "rangelength").addMinMax("range", "min", "max", "range");
    adapters.addMinMax("minlength", "minlength").addMinMax("maxlength", "minlength", "maxlength");
    adapters.add("equalto", ["other"], function (options) {
        var prefix = getModelPrefix(options.element.name),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(fullOtherName) + "']")[0];

        setValidationValues(options, "equalTo", element);
    });
    adapters.add("required", function (options) {
				// jQuery Validate equates "required" with "mandatory" for checkbox elements
	
        if (options.element.tagName.toUpperCase() !== "INPUT" || options.element.type.toUpperCase() !== "CHECKBOX") {
						setValidationValues(options, "required", true);
				}
			// added if statement for Policy Accept checkbox in Content Hub
				if (options.element.id == "ContentHubFormPolicyAccept") {
					setValidationValues(options, "required", true);
			}
				

    });
    adapters.add("remote", ["url", "type", "additionalfields"], function (options) {
        var value = {
            url: options.params.url,
            type: options.params.type || "GET",
            data: {}
        },
            prefix = getModelPrefix(options.element.name);

        $.each(splitAndTrim(options.params.additionalfields || options.element.name), function (i, fieldName) {
            var paramName = appendModelPrefix(fieldName, prefix);
            value.data[paramName] = function () {
                var field = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(paramName) + "']");
                // For checkboxes and radio buttons, only pick up values from checked fields.
                if (field.is(":checkbox")) {
                    return field.filter(":checked").val() || field.filter(":hidden").val() || '';
                }
                else if (field.is(":radio")) {
                    return field.filter(":checked").val() || '';
                }
                return field.val();
            };
        });

        setValidationValues(options, "remote", value);
    });
    adapters.add("password", ["min", "nonalphamin", "regex"], function (options) {
        if (options.params.min) {
            setValidationValues(options, "minlength", options.params.min);
        }
        if (options.params.nonalphamin) {
            setValidationValues(options, "nonalphamin", options.params.nonalphamin);
        }
        if (options.params.regex) {
            setValidationValues(options, "regex", options.params.regex);
        }
    });
    adapters.add("fileextensions", ["extensions"], function (options) {
        setValidationValues(options, "extension", options.params.extensions);
    });

    $(function () {
        $jQval.unobtrusive.parse(document);
    });

    return $jQval.unobtrusive;
}));
/**
 * Copyright (C) 2017 Kyle Florence
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * @website https://github.com/kflorence/jquery-deserialize/
 * @version 1.3.7
 *
 * Dual licensed under the MIT and GPLv2 licenses.
 */
!function(a){"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(window.jQuery)}(function(a){function g(b,c){return b.map(function(){return this.elements?a.makeArray(this.elements):this}).filter(c||":input:not(:disabled)").get()}function h(b){var c,d={};return a.each(b,function(a,b){c=d[b.name],void 0===c&&(d[b.name]=[]),d[b.name].push(b)}),d}var b=Array.prototype.push,c=/^(?:radio|checkbox)$/i,d=/\+/g,e=/^(?:option|select-one|select-multiple)$/i,f=/^(?:button|color|date|datetime|datetime-local|email|hidden|month|number|password|range|reset|search|submit|tel|text|textarea|time|url|week)$/i;a.fn.deserialize=function(i,j){var k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A=a.noop,B=a.noop,C={},D=[];if(j=j||{},a.isFunction(j)?B=j:(A=a.isFunction(j.change)?j.change:A,B=a.isFunction(j.complete)?j.complete:B),m=g(this,j.filter),!i||!m.length)return this;if(a.isArray(i))D=i;else if(a.isPlainObject(i))for(r in i)a.isArray(z=i[r])?b.apply(D,a.map(z,function(a){return{name:r,value:a}})):b.call(D,{name:r,value:z});else if("string"==typeof i){var E;for(i=i.split("&"),o=0,t=i.length;o<t;o++)E=i[o].split("="),b.call(D,{name:decodeURIComponent(E[0].replace(d,"%20")),value:decodeURIComponent(E[1].replace(d,"%20"))})}if(!(t=D.length))return this;for(m=h(m),o=0;o<t;o++)if(k=D[o],u=k.name,z=k.value,n=m[u],n&&0!==n.length)if(void 0===C[u]&&(C[u]=0),v=C[u]++,n[v]&&(l=n[v],y=(l.type||l.nodeName).toLowerCase(),f.test(y)))A.call(l,l.value=z);else for(p=0,s=n.length;p<s;p++)if(l=n[p],y=(l.type||l.nodeName).toLowerCase(),x=null,c.test(y)?x="checked":e.test(y)&&(x="selected"),x){if(w=[],l.options)for(q=0;q<l.options.length;q++)w.push(l.options[q]);else w.push(l);for(q=0;q<w.length;q++)k=w[q],k.value==z&&A.call(k,(k[x]=!0)&&z)}return B.call(this),this}});

function LazyEvent($element, event, safedistance, isForceReExec, event__KEY, old_event__KEY) {
    var safeDistance = safedistance || 150;
    let elmList = $element;
    if(!NodeList.prototype.isPrototypeOf($element) && !Array.isArray($element))
        elmList = $element.get();

    let lLength = elmList.length;
    
    function lazyLoad(forceExc){
        if (lLength === null) 
            triggerEvt(elmList);
        else
            for(let lCount = 0; lCount < lLength; lCount++){
                let item = elmList[lCount];
                triggerEvt(item);
            }

        function triggerEvt(item){
            let condition = (typeof forceExc == "boolean" && forceExc === true) || item.dataset.lazyeventTriggered != "true";
            if(condition) {
                requestAnimationFrame(() => {
                    var boundingRect = item.getBoundingClientRect();
                    if (
                        (boundingRect.top >= 0 && boundingRect.top <= GT.wHeight + safeDistance)
                        || (boundingRect.bottom <= 0 && boundingRect.bottom + safeDistance >= 0)
                        || (boundingRect.top >= 0 && boundingRect.bottom <= GT.wHeight)
                    ) {
                        item.dataset.lazyeventTriggered = true;
                        event(item);
                    }
                });
            }
        }
    }
// console.log(Object.keys(GT.listFunctionsTriggerInScrollEvent).length, event__KEY, old_event__KEY);
    if(old_event__KEY) {
        delete GT.listFunctionsTriggerInScrollEvent[old_event__KEY];
        delete GT.windowResizeFncList[old_event__KEY];
    }

    if(!event__KEY)
        event__KEY = 'lazy_RandomEvt_' + (Math.random() * (1000000 - 0) + 0);
    
    lazyLoad(isForceReExec);
    GT.listFunctionsTriggerInScrollEvent[event__KEY] = lazyLoad;
    GT.windowResizeFncList[event__KEY] = function(){
        lazyLoad(true);
    }
    // console.log(Object.keys(GT.listFunctionsTriggerInScrollEvent).length);

};

    // CODE FOR TESTING. DONT NOT REMOVE THIS BLOCK!
    // let countClamp = 0;
    // Object.keys(GT.listFunctionsTriggerInScrollEvent).forEach(function(key){
    //     if(key.indexOf("clampKey") > 1) {
    //         if(!document.querySelector('[data-clampkey="'+key+'"]'))
    //             console.log(key);
    // countClamp++;
    //     }
    // })
    // console.log(countClamp)
/*respimg polyfill plugin*/

(function(window, factory) {
	if(!window) {return;}
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if (typeof define == 'function' && define.amd) {
		define(['lazysizes'], factory);
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(typeof window != 'undefined' ?
	window : 0, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var polyfill;
	var lazySizesCfg = lazySizes.cfg;
	var img = document.createElement('img');
	var supportSrcset = ('sizes' in img) && ('srcset' in img);
	var regHDesc = /\s+\d+h/g;
	var fixEdgeHDescriptor = (function(){
		var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
		var forEach = Array.prototype.forEach;

		return function(){
			var img = document.createElement('img');
			var removeHDescriptors = function(source){
				var ratio, match;
				var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
				if(srcset){
					if((match = srcset.match(regDescriptors))){
						if(match[2] == 'w'){
							ratio = match[1] / match[3];
						} else {
							ratio = match[3] / match[1];
						}

						if(ratio){
							source.setAttribute('data-aspectratio', ratio);
						}
						source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ''));
					}
				}
			};
			var handler = function(e){
				if(e.detail.instance != lazySizes){return;}
				var picture = e.target.parentNode;

				if(picture && picture.nodeName == 'PICTURE'){
					forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
				}
				removeHDescriptors(e.target);
			};

			var test = function(){
				if(!!img.currentSrc){
					document.removeEventListener('lazybeforeunveil', handler);
				}
			};

			document.addEventListener('lazybeforeunveil', handler);

			img.onload = test;
			img.onerror = test;

			img.srcset = 'data:,a 1w 1h';

			if(img.complete){
				test();
			}
		};
	})();

	if(!lazySizesCfg.supportsType){
		lazySizesCfg.supportsType = function(type/*, elem*/){
			return !type;
		};
	}

	if (window.HTMLPictureElement && supportSrcset) {
		if(!lazySizes.hasHDescriptorFix && document.msElementsFromPoint){
			lazySizes.hasHDescriptorFix = true;
			fixEdgeHDescriptor();
		}
		return;
	}

	if(window.picturefill || lazySizesCfg.pf){return;}

	lazySizesCfg.pf = function(options){
		var i, len;
		if(window.picturefill){return;}
		for(i = 0, len = options.elements.length; i < len; i++){
			polyfill(options.elements[i]);
		}
	};

	// partial polyfill
	polyfill = (function(){
		var ascendingSort = function( a, b ) {
			return a.w - b.w;
		};
		var regPxLength = /^\s*\d+\.*\d*px\s*$/;
		var reduceCandidate = function (srces) {
			var lowerCandidate, bonusFactor;
			var len = srces.length;
			var candidate = srces[len -1];
			var i = 0;

			for(i; i < len;i++){
				candidate = srces[i];
				candidate.d = candidate.w / srces.w;

				if(candidate.d >= srces.d){
					if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
						lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

						bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

						if(lowerCandidate.cached) {
							lowerCandidate.d += 0.15 * bonusFactor;
						}

						if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
							candidate = lowerCandidate;
						}
					}
					break;
				}
			}
			return candidate;
		};

		var parseWsrcset = (function(){
			var candidates;
			var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
			var regMultiple = /\s/;
			var addCandidate = function(match, candidate, url, wDescriptor){
				candidates.push({
					c: candidate,
					u: url,
					w: wDescriptor * 1
				});
			};

			return function(input){
				candidates = [];
				input = input.trim();
				input
					.replace(regHDesc, '')
					.replace(regWCandidates, addCandidate)
				;

				if(!candidates.length && input && !regMultiple.test(input)){
					candidates.push({
						c: input,
						u: input,
						w: 99
					});
				}

				return candidates;
			};
		})();

		var runMatchMedia = function(){
			if(runMatchMedia.init){return;}

			runMatchMedia.init = true;
			addEventListener('resize', (function(){
				var timer;
				var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
				var run = function(){
					var i, len;
					for(i = 0, len = matchMediaElems.length; i < len; i++){
						polyfill(matchMediaElems[i]);
					}
				};

				return function(){
					clearTimeout(timer);
					timer = setTimeout(run, 66);
				};
			})());
		};

		var createSrcset = function(elem, isImage){
			var parsedSet;
			var srcSet = elem.getAttribute('srcset') || elem.getAttribute(lazySizesCfg.srcsetAttr);

			if(!srcSet && isImage){
				srcSet = !elem._lazypolyfill ?
					(elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute('src')) :
					elem._lazypolyfill._set
				;
			}

			if(!elem._lazypolyfill || elem._lazypolyfill._set != srcSet){

				parsedSet = parseWsrcset( srcSet || '' );
				if(isImage && elem.parentNode){
					parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';

					if(parsedSet.isPicture){
						if(window.matchMedia){
							lazySizes.aC(elem, 'lazymatchmedia');
							runMatchMedia();
						}
					}
				}

				parsedSet._set = srcSet;
				Object.defineProperty(elem, '_lazypolyfill', {
					value: parsedSet,
					writable: true
				});
			}
		};

		var getX = function(elem){
			var dpr = window.devicePixelRatio || 1;
			var optimum = lazySizes.getX && lazySizes.getX(elem);
			return Math.min(optimum || dpr, 2.5, dpr);
		};

		var matchesMedia = function(media){
			if(window.matchMedia){
				matchesMedia = function(media){
					return !media || (matchMedia(media) || {}).matches;
				};
			} else {
				return !media;
			}

			return matchesMedia(media);
		};

		var getCandidate = function(elem){
			var sources, i, len, media, source, srces, src, width;

			source = elem;
			createSrcset(source, true);
			srces = source._lazypolyfill;

			if(srces.isPicture){
				for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
					if( lazySizesCfg.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia( sources[i].getAttribute('media')) ){
						source = sources[i];
						createSrcset(source);
						srces = source._lazypolyfill;
						break;
					}
				}
			}

			if(srces.length > 1){
				width = source.getAttribute('sizes') || '';
				width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
				srces.d = getX(elem);
				if(!srces.src || !srces.w || srces.w < width){
					srces.w = width;
					src = reduceCandidate(srces.sort(ascendingSort));
					srces.src = src;
				} else {
					src = srces.src;
				}
			} else {
				src = srces[0];
			}

			return src;
		};

		var p = function(elem){
			if(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE'){return;}
			var candidate = getCandidate(elem);

			if(candidate && candidate.u && elem._lazypolyfill.cur != candidate.u){
				elem._lazypolyfill.cur = candidate.u;
				candidate.cached = true;
				elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
				elem.setAttribute('src', candidate.u);
			}
		};

		p.parse = parseWsrcset;

		return p;
	})();

	if(lazySizesCfg.loadedClass && lazySizesCfg.loadingClass){
		(function(){
			var sels = [];
			['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function(sel){
				sels.push(sel + lazySizesCfg.loadedClass);
				sels.push(sel + lazySizesCfg.loadingClass);
			});
			lazySizesCfg.pf({
				elements: document.querySelectorAll(sels.join(', '))
			});
		})();

	}
}));

/*! lazysizes - v5.3.0 - Core */
(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, function l(window, document, Date) { // Pass in the windoe Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes, lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			cfg: lazySizesCfg,
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));

/*! lazysizes - v5.3.0 - BGset*/
(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if (typeof define == 'function' && define.amd) {
		define(['lazysizes'], factory);
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	if(!window.addEventListener){return;}

	var lazySizesCfg = lazySizes.cfg;
	var regWhite = /\s+/g;
	var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
	var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
	var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
	var regBgUrlEscape = /\(|\)|'/;
	var allowedBackgroundSize = {contain: 1, cover: 1};
	var proxyWidth = function(elem){
		var width = lazySizes.gW(elem, elem.parentNode);

		if(!elem._lazysizesWidth || width > elem._lazysizesWidth){
			elem._lazysizesWidth = width;
		}
		return elem._lazysizesWidth;
	};
	var getBgSize = function(elem){
		var bgSize;

		bgSize = (getComputedStyle(elem) || {getPropertyValue: function(){}}).getPropertyValue('background-size');

		if(!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]){
			bgSize = elem.style.backgroundSize;
		}

		return bgSize;
	};
	var setTypeOrMedia = function(source, match){
		if(match){
			var typeMatch = match.match(regType);
			if(typeMatch && typeMatch[1]){
				source.setAttribute('type', typeMatch[1]);
			} else {
				source.setAttribute('media', lazySizesCfg.customMedia[match] || match);
			}
		}
	};
	var createPicture = function(sets, elem, img){
		var picture = document.createElement('picture');
		var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
		var ratio = elem.getAttribute('data-ratio');
		var optimumx = elem.getAttribute('data-optimumx');

		if(elem._lazybgset && elem._lazybgset.parentNode == elem){
			elem.removeChild(elem._lazybgset);
		}

		Object.defineProperty(img, '_lazybgset', {
			value: elem,
			writable: true
		});
		Object.defineProperty(elem, '_lazybgset', {
			value: picture,
			writable: true
		});

		sets = sets.replace(regWhite, ' ').split(regSplitSet);

		picture.style.display = 'none';
		img.className = lazySizesCfg.lazyClass;

		if(sets.length == 1 && !sizes){
			sizes = 'auto';
		}

		sets.forEach(function(set){
			var match;
			var source = document.createElement('source');

			if(sizes && sizes != 'auto'){
				source.setAttribute('sizes', sizes);
			}

			if((match = set.match(regSource))){
				source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);

				setTypeOrMedia(source, match[2]);
				setTypeOrMedia(source, match[3]);
			} else {
				source.setAttribute(lazySizesCfg.srcsetAttr, set);
			}

			picture.appendChild(source);
		});

		if(sizes){
			img.setAttribute(lazySizesCfg.sizesAttr, sizes);
			elem.removeAttribute(lazySizesCfg.sizesAttr);
			elem.removeAttribute('sizes');
		}
		if(optimumx){
			img.setAttribute('data-optimumx', optimumx);
		}
		if(ratio) {
			img.setAttribute('data-ratio', ratio);
		}

		picture.appendChild(img);

		elem.appendChild(picture);
	};

	var proxyLoad = function(e){
		if(!e.target._lazybgset){return;}

		var image = e.target;
		var elem = image._lazybgset;
		var bg = image.currentSrc || image.src;


		if(bg){
			var useSrc = regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg;
			var event = lazySizes.fire(elem, 'bgsetproxy', {
				src: bg,
				useSrc: useSrc,
				fullSrc: null,
			});

			if(!event.defaultPrevented){
				elem.style.backgroundImage = event.detail.fullSrc || 'url(' + event.detail.useSrc + ')';
			}
		}

		if(image._lazybgsetLoading){
			lazySizes.fire(elem, '_lazyloaded', {}, false, true);
			delete image._lazybgsetLoading;
		}
	};

	addEventListener('lazybeforeunveil', function(e){
		var set, image, elem;

		if(e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))){return;}

		elem = e.target;
		image = document.createElement('img');

		image.alt = '';

		image._lazybgsetLoading = true;
		e.detail.firesLoad = true;

		createPicture(set, elem, image);

		setTimeout(function(){
			lazySizes.loader.unveil(image);

			lazySizes.rAF(function(){
				lazySizes.fire(image, '_lazyloaded', {}, true, true);
				if(image.complete) {
					proxyLoad({target: image});
				}
			});
		});

	});

	document.addEventListener('load', proxyLoad, true);

	window.addEventListener('lazybeforesizes', function(e){
		if(e.detail.instance != lazySizes){return;}
		if(e.target._lazybgset && e.detail.dataAttr){
			var elem = e.target._lazybgset;
			var bgSize = getBgSize(elem);

			if(allowedBackgroundSize[bgSize]){
				e.target._lazysizesParentFit = bgSize;

				lazySizes.rAF(function(){
					e.target.setAttribute('data-parent-fit', bgSize);
					if(e.target._lazysizesParentFit){
						delete e.target._lazysizesParentFit;
					}
				});
			}
		}
	}, true);

	document.documentElement.addEventListener('lazybeforesizes', function(e){
		if(e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes){return;}
		e.detail.width = proxyWidth(e.target._lazybgset);
	});
}));
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-mq-setclasses-shiv-teststyles !*/
!function(e,t,n){function a(e,t){return typeof e===t}function r(){var e,t,n,r,o,i,s;for(var l in d)if(d.hasOwnProperty(l)){if(e=[],t=d[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(r=a(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)i=e[o],s=i.split("."),1===s.length?Modernizr[s[0]]=r:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=r),c.push((r?"":"no-")+s.join("-"))}}function o(e){var t=f.className,n=Modernizr._config.classPrefix||"";if(m&&(t=t.baseVal),Modernizr._config.enableJSClass){var a=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(a,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),m?f.className.baseVal=t:f.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):m?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function s(){var e=t.body;return e||(e=i(m?"svg":"body"),e.fake=!0),e}function l(e,n,a,r){var o,l,c,d,u="modernizr",m=i("div"),h=s();if(parseInt(a,10))for(;a--;)c=i("div"),c.id=r?r[a]:u+(a+1),m.appendChild(c);return o=i("style"),o.type="text/css",o.id="s"+u,(h.fake?h:m).appendChild(o),h.appendChild(m),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(t.createTextNode(e)),m.id=u,h.fake&&(h.style.background="",h.style.overflow="hidden",d=f.style.overflow,f.style.overflow="hidden",f.appendChild(h)),l=n(m,e),h.fake?(h.parentNode.removeChild(h),f.style.overflow=d,f.offsetHeight):m.parentNode.removeChild(m),!!l}var c=[],d=[],u={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){d.push({name:e,fn:t,options:n})},addAsyncTest:function(e){d.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=u,Modernizr=new Modernizr;var f=t.documentElement,m="svg"===f.nodeName.toLowerCase();m||!function(e,t){function n(e,t){var n=e.createElement("p"),a=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",a.insertBefore(n.lastChild,a.firstChild)}function a(){var e=E.elements;return"string"==typeof e?e.split(" "):e}function r(e,t){var n=E.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),E.elements=n+" "+e,c(t)}function o(e){var t=y[e[g]];return t||(t={},v++,e[g]=v,y[v]=t),t}function i(e,n,a){if(n||(n=t),u)return n.createElement(e);a||(a=o(n));var r;return r=a.cache[e]?a.cache[e].cloneNode():p.test(e)?(a.cache[e]=a.createElem(e)).cloneNode():a.createElem(e),!r.canHaveChildren||h.test(e)||r.tagUrn?r:a.frag.appendChild(r)}function s(e,n){if(e||(e=t),u)return e.createDocumentFragment();n=n||o(e);for(var r=n.frag.cloneNode(),i=0,s=a(),l=s.length;l>i;i++)r.createElement(s[i]);return r}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return E.shivMethods?i(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+a().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(E,t.frag)}function c(e){e||(e=t);var a=o(e);return!E.shivCSS||d||a.hasCSS||(a.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),u||l(e,a),e}var d,u,f="3.7.3",m=e.html5||{},h=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,p=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",d="hidden"in e,u=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){d=!0,u=!0}}();var E={elements:m.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:f,shivCSS:m.shivCSS!==!1,supportsUnknownElements:u,shivMethods:m.shivMethods!==!1,type:"default",shivDocument:c,createElement:i,createDocumentFragment:s,addElements:r};e.html5=E,c(t),"object"==typeof module&&module.exports&&(module.exports=E)}("undefined"!=typeof e?e:this,t);var h=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return l("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}();u.mq=h;u.testStyles=l;r(),o(c),delete u.addTest,delete u.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
/*!
 * perfect-scrollbar v1.5.1
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */(function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):(a=a||self,a.PerfectScrollbar=b())})(this,function(){'use strict';var u=Math.abs,v=Math.floor;function a(a){return getComputedStyle(a)}function b(a,b){for(var c in b){var d=b[c];"number"==typeof d&&(d+="px"),a.style[c]=d}return a}function c(a){var b=document.createElement("div");return b.className=a,b}function d(a,b){if(!w)throw new Error("No element matching method supported");return w.call(a,b)}function e(a){a.remove?a.remove():a.parentNode&&a.parentNode.removeChild(a)}function f(a,b){return Array.prototype.filter.call(a.children,function(a){return d(a,b)})}function g(a,b){var c=a.element.classList,d=z.state.scrolling(b);c.contains(d)?clearTimeout(A[b]):c.add(d)}function h(a,b){A[b]=setTimeout(function(){return a.isAlive&&a.element.classList.remove(z.state.scrolling(b))},a.settings.scrollingThreshold)}function j(a,b){g(a,b),h(a,b)}function k(a){if("function"==typeof window.CustomEvent)return new CustomEvent(a);var b=document.createEvent("CustomEvent");return b.initCustomEvent(a,!1,!1,void 0),b}function l(a,b,c,d,e){void 0===d&&(d=!0),void 0===e&&(e=!1);var f;if("top"===b)f=["contentHeight","containerHeight","scrollTop","y","up","down"];else if("left"===b)f=["contentWidth","containerWidth","scrollLeft","x","left","right"];else throw new Error("A proper axis should be provided");m(a,c,f,d,e)}function m(a,b,c,d,e){var f=c[0],g=c[1],h=c[2],i=c[3],l=c[4],m=c[5];void 0===d&&(d=!0),void 0===e&&(e=!1);var n=a.element;// reset reach
  a.reach[i]=null,1>n[h]&&(a.reach[i]="start"),n[h]>a[f]-a[g]-1&&(a.reach[i]="end"),b&&(n.dispatchEvent(k("ps-scroll-"+i)),0>b?n.dispatchEvent(k("ps-scroll-"+l)):0<b&&n.dispatchEvent(k("ps-scroll-"+m)),d&&j(a,i)),a.reach[i]&&(b||e)&&n.dispatchEvent(k("ps-"+i+"-reach-"+a.reach[i]))}function n(a){return parseInt(a,10)||0}function o(a){return d(a,"input,[contenteditable]")||d(a,"select,[contenteditable]")||d(a,"textarea,[contenteditable]")||d(a,"button,[contenteditable]")}function p(b){var c=a(b);return n(c.width)+n(c.paddingLeft)+n(c.paddingRight)+n(c.borderLeftWidth)+n(c.borderRightWidth)}function q(a){var b=Math.round,c=a.element,d=v(c.scrollTop),g=c.getBoundingClientRect();a.containerWidth=b(g.width),a.containerHeight=b(g.height),a.contentWidth=c.scrollWidth,a.contentHeight=c.scrollHeight,c.contains(a.scrollbarXRail)||(f(c,z.element.rail("x")).forEach(function(a){return e(a)}),c.appendChild(a.scrollbarXRail)),c.contains(a.scrollbarYRail)||(f(c,z.element.rail("y")).forEach(function(a){return e(a)}),c.appendChild(a.scrollbarYRail)),!a.settings.suppressScrollX&&a.containerWidth+a.settings.scrollXMarginOffset<a.contentWidth?(a.scrollbarXActive=!0,a.railXWidth=a.containerWidth-a.railXMarginWidth,a.railXRatio=a.containerWidth/a.railXWidth,a.scrollbarXWidth=r(a,n(a.railXWidth*a.containerWidth/a.contentWidth)),a.scrollbarXLeft=n((a.negativeScrollAdjustment+c.scrollLeft)*(a.railXWidth-a.scrollbarXWidth)/(a.contentWidth-a.containerWidth))):a.scrollbarXActive=!1,!a.settings.suppressScrollY&&a.containerHeight+a.settings.scrollYMarginOffset<a.contentHeight?(a.scrollbarYActive=!0,a.railYHeight=a.containerHeight-a.railYMarginHeight,a.railYRatio=a.containerHeight/a.railYHeight,a.scrollbarYHeight=r(a,n(a.railYHeight*a.containerHeight/a.contentHeight)),a.scrollbarYTop=n(d*(a.railYHeight-a.scrollbarYHeight)/(a.contentHeight-a.containerHeight))):a.scrollbarYActive=!1,a.scrollbarXLeft>=a.railXWidth-a.scrollbarXWidth&&(a.scrollbarXLeft=a.railXWidth-a.scrollbarXWidth),a.scrollbarYTop>=a.railYHeight-a.scrollbarYHeight&&(a.scrollbarYTop=a.railYHeight-a.scrollbarYHeight),s(c,a),a.scrollbarXActive?c.classList.add(z.state.active("x")):(c.classList.remove(z.state.active("x")),a.scrollbarXWidth=0,a.scrollbarXLeft=0,c.scrollLeft=!0===a.isRtl?a.contentWidth:0),a.scrollbarYActive?c.classList.add(z.state.active("y")):(c.classList.remove(z.state.active("y")),a.scrollbarYHeight=0,a.scrollbarYTop=0,c.scrollTop=0)}function r(a,b){var c=Math.min,d=Math.max;return a.settings.minScrollbarLength&&(b=d(b,a.settings.minScrollbarLength)),a.settings.maxScrollbarLength&&(b=c(b,a.settings.maxScrollbarLength)),b}function s(a,c){var d={width:c.railXWidth},e=v(a.scrollTop);d.left=c.isRtl?c.negativeScrollAdjustment+a.scrollLeft+c.containerWidth-c.contentWidth:a.scrollLeft,c.isScrollbarXUsingBottom?d.bottom=c.scrollbarXBottom-e:d.top=c.scrollbarXTop+e,b(c.scrollbarXRail,d);var f={top:e,height:c.railYHeight};c.isScrollbarYUsingRight?c.isRtl?f.right=c.contentWidth-(c.negativeScrollAdjustment+a.scrollLeft)-c.scrollbarYRight-c.scrollbarYOuterWidth-9:f.right=c.scrollbarYRight-a.scrollLeft:c.isRtl?f.left=c.negativeScrollAdjustment+a.scrollLeft+2*c.containerWidth-c.contentWidth-c.scrollbarYLeft-c.scrollbarYOuterWidth:f.left=c.scrollbarYLeft+a.scrollLeft,b(c.scrollbarYRail,f),b(c.scrollbarX,{left:c.scrollbarXLeft,width:c.scrollbarXWidth-c.railBorderXWidth}),b(c.scrollbarY,{top:c.scrollbarYTop,height:c.scrollbarYHeight-c.railBorderYWidth})}function t(a,b){function c(b){b.touches&&b.touches[0]&&(b[k]=b.touches[0].pageY),s[o]=t+v*(b[k]-u),g(a,p),q(a),b.stopPropagation(),b.preventDefault()}function d(){h(a,p),a[r].classList.remove(z.state.clicking),a.event.unbind(a.ownerDocument,"mousemove",c)}function f(b,e){t=s[o],e&&b.touches&&(b[k]=b.touches[0].pageY),u=b[k],v=(a[j]-a[i])/(a[l]-a[n]),e?a.event.bind(a.ownerDocument,"touchmove",c):(a.event.bind(a.ownerDocument,"mousemove",c),a.event.once(a.ownerDocument,"mouseup",d),b.preventDefault()),a[r].classList.add(z.state.clicking),b.stopPropagation()}var i=b[0],j=b[1],k=b[2],l=b[3],m=b[4],n=b[5],o=b[6],p=b[7],r=b[8],s=a.element,t=null,u=null,v=null;a.event.bind(a[m],"mousedown",function(a){f(a)}),a.event.bind(a[m],"touchstart",function(a){f(a,!0)})}var w="undefined"!=typeof Element&&(Element.prototype.matches||Element.prototype.webkitMatchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector),z={main:"ps",rtl:"ps__rtl",element:{thumb:function(a){return"ps__thumb-"+a},rail:function(a){return"ps__rail-"+a},consuming:"ps__child--consume"},state:{focus:"ps--focus",clicking:"ps--clicking",active:function(a){return"ps--active-"+a},scrolling:function(a){return"ps--scrolling-"+a}}},A={x:null,y:null},B=function(a){this.element=a,this.handlers={}},C={isEmpty:{configurable:!0}};B.prototype.bind=function(a,b){"undefined"==typeof this.handlers[a]&&(this.handlers[a]=[]),this.handlers[a].push(b),this.element.addEventListener(a,b,!1)},B.prototype.unbind=function(a,b){var c=this;this.handlers[a]=this.handlers[a].filter(function(d){return!!(b&&d!==b)||(c.element.removeEventListener(a,d,!1),!1)})},B.prototype.unbindAll=function(){for(var a in this.handlers)this.unbind(a)},C.isEmpty.get=function(){var a=this;return Object.keys(this.handlers).every(function(b){return 0===a.handlers[b].length})},Object.defineProperties(B.prototype,C);var D=function(){this.eventElements=[]};D.prototype.eventElement=function(a){var b=this.eventElements.filter(function(b){return b.element===a})[0];return b||(b=new B(a),this.eventElements.push(b)),b},D.prototype.bind=function(a,b,c){this.eventElement(a).bind(b,c)},D.prototype.unbind=function(a,b,c){var d=this.eventElement(a);d.unbind(b,c),d.isEmpty&&this.eventElements.splice(this.eventElements.indexOf(d),1)},D.prototype.unbindAll=function(){this.eventElements.forEach(function(a){return a.unbindAll()}),this.eventElements=[]},D.prototype.once=function(a,b,c){var d=this.eventElement(a),e=function(a){d.unbind(b,e),c(a)};d.bind(b,e)};var E={isWebKit:"undefined"!=typeof document&&"WebkitAppearance"in document.documentElement.style,supportsTouch:"undefined"!=typeof window&&("ontouchstart"in window||"maxTouchPoints"in window.navigator&&0<window.navigator.maxTouchPoints||window.DocumentTouch&&document instanceof window.DocumentTouch),supportsIePointer:"undefined"!=typeof navigator&&navigator.msMaxTouchPoints,isChrome:"undefined"!=typeof navigator&&/Chrome/i.test(navigator&&navigator.userAgent)},F=function(){return{handlers:["click-rail","drag-thumb","keyboard","wheel","touch"],maxScrollbarLength:null,minScrollbarLength:null,scrollingThreshold:1e3,scrollXMarginOffset:0,scrollYMarginOffset:0,suppressScrollX:!1,suppressScrollY:!1,swipeEasing:!0,useBothWheelAxes:!1,wheelPropagation:!0,wheelSpeed:1}},G={"click-rail":function(a){a.element;a.event.bind(a.scrollbarY,"mousedown",function(a){return a.stopPropagation()}),a.event.bind(a.scrollbarYRail,"mousedown",function(b){var c=b.pageY-window.pageYOffset-a.scrollbarYRail.getBoundingClientRect().top,d=c>a.scrollbarYTop?1:-1;a.element.scrollTop+=d*a.containerHeight,q(a),b.stopPropagation()}),a.event.bind(a.scrollbarX,"mousedown",function(a){return a.stopPropagation()}),a.event.bind(a.scrollbarXRail,"mousedown",function(b){var c=b.pageX-window.pageXOffset-a.scrollbarXRail.getBoundingClientRect().left,d=c>a.scrollbarXLeft?1:-1;a.element.scrollLeft+=d*a.containerWidth,q(a),b.stopPropagation()})},"drag-thumb":function(a){t(a,["containerWidth","contentWidth","pageX","railXWidth","scrollbarX","scrollbarXWidth","scrollLeft","x","scrollbarXRail"]),t(a,["containerHeight","contentHeight","pageY","railYHeight","scrollbarY","scrollbarYHeight","scrollTop","y","scrollbarYRail"])},keyboard:function(a){function b(b,d){var e=v(c.scrollTop);if(0===b){if(!a.scrollbarYActive)return!1;if(0===e&&0<d||e>=a.contentHeight-a.containerHeight&&0>d)return!a.settings.wheelPropagation}var f=c.scrollLeft;if(0===d){if(!a.scrollbarXActive)return!1;if(0===f&&0>b||f>=a.contentWidth-a.containerWidth&&0<b)return!a.settings.wheelPropagation}return!0}var c=a.element,f=function(){return d(c,":hover")},g=function(){return d(a.scrollbarX,":focus")||d(a.scrollbarY,":focus")};a.event.bind(a.ownerDocument,"keydown",function(d){if(!(d.isDefaultPrevented&&d.isDefaultPrevented()||d.defaultPrevented)&&(f()||g())){var e=document.activeElement?document.activeElement:a.ownerDocument.activeElement;if(e){if("IFRAME"===e.tagName)e=e.contentDocument.activeElement;else// go deeper if element is a webcomponent
  for(;e.shadowRoot;)e=e.shadowRoot.activeElement;if(o(e))return}var h=0,i=0;switch(d.which){case 37:h=d.metaKey?-a.contentWidth:d.altKey?-a.containerWidth:-30;break;case 38:i=d.metaKey?a.contentHeight:d.altKey?a.containerHeight:30;break;case 39:h=d.metaKey?a.contentWidth:d.altKey?a.containerWidth:30;break;case 40:i=d.metaKey?-a.contentHeight:d.altKey?-a.containerHeight:-30;break;case 32:i=d.shiftKey?a.containerHeight:-a.containerHeight;break;case 33:i=a.containerHeight;break;case 34:i=-a.containerHeight;break;case 36:i=a.contentHeight;break;case 35:i=-a.contentHeight;break;default:return;}a.settings.suppressScrollX&&0!==h||a.settings.suppressScrollY&&0!==i||(c.scrollTop-=i,c.scrollLeft+=h,q(a),b(h,i)&&d.preventDefault())}})},wheel:function(b){function c(a,c){var d,e=v(h.scrollTop),f=0===h.scrollTop,g=e+h.offsetHeight===h.scrollHeight,i=0===h.scrollLeft,j=h.scrollLeft+h.offsetWidth===h.scrollWidth;return d=u(c)>u(a)?f||g:i||j,!d||!b.settings.wheelPropagation}function d(a){var b=a.deltaX,c=-1*a.deltaY;return("undefined"==typeof b||"undefined"==typeof c)&&(b=-1*a.wheelDeltaX/6,c=a.wheelDeltaY/6),a.deltaMode&&1===a.deltaMode&&(b*=10,c*=10),b!==b&&c!==c/* NaN checks */&&(b=0,c=a.wheelDelta),a.shiftKey?[-c,-b]:[b,c]}function f(b,c,d){// FIXME: this is a workaround for <select> issue in FF and IE #571
  if(!E.isWebKit&&h.querySelector("select:focus"))return!0;if(!h.contains(b))return!1;for(var e=b;e&&e!==h;){if(e.classList.contains(z.element.consuming))return!0;var f=a(e);// if deltaY && vertical scrollable
  if(d&&f.overflowY.match(/(scroll|auto)/)){var g=e.scrollHeight-e.clientHeight;if(0<g&&(0<e.scrollTop&&0>d||e.scrollTop<g&&0<d))return!0}// if deltaX && horizontal scrollable
  if(c&&f.overflowX.match(/(scroll|auto)/)){var i=e.scrollWidth-e.clientWidth;if(0<i&&(0<e.scrollLeft&&0>c||e.scrollLeft<i&&0<c))return!0}e=e.parentNode}return!1}function g(a){var e=d(a),g=e[0],i=e[1];if(!f(a.target,g,i)){var j=!1;b.settings.useBothWheelAxes?b.scrollbarYActive&&!b.scrollbarXActive?(i?h.scrollTop-=i*b.settings.wheelSpeed:h.scrollTop+=g*b.settings.wheelSpeed,j=!0):b.scrollbarXActive&&!b.scrollbarYActive&&(g?h.scrollLeft+=g*b.settings.wheelSpeed:h.scrollLeft-=i*b.settings.wheelSpeed,j=!0):(h.scrollTop-=i*b.settings.wheelSpeed,h.scrollLeft+=g*b.settings.wheelSpeed),q(b),j=j||c(g,i),j&&!a.ctrlKey&&(a.stopPropagation(),a.preventDefault())}}var h=b.element;"undefined"==typeof window.onwheel?"undefined"!=typeof window.onmousewheel&&b.event.bind(h,"mousewheel",g):b.event.bind(h,"wheel",g)},touch:function(b){function c(a,c){var d=v(l.scrollTop),e=l.scrollLeft,f=u(a),g=u(c);if(g>f){// user is perhaps trying to swipe up/down the page
  if(0>c&&d===b.contentHeight-b.containerHeight||0<c&&0===d)// set prevent for mobile Chrome refresh
  return 0===window.scrollY&&0<c&&E.isChrome;}else if(f>g&&(0>a&&e===b.contentWidth-b.containerWidth||0<a&&0===e))// user is perhaps trying to swipe left/right across the page
  return!0;return!0}function d(a,c){l.scrollTop-=c,l.scrollLeft-=a,q(b)}function f(a){return a.targetTouches?a.targetTouches[0]:a}function g(a){return!(a.pointerType&&"pen"===a.pointerType&&0===a.buttons)&&(!!(a.targetTouches&&1===a.targetTouches.length)||!!(a.pointerType&&"mouse"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_MOUSE))}function h(a){if(g(a)){var b=f(a);m.pageX=b.pageX,m.pageY=b.pageY,n=new Date().getTime(),null!==p&&clearInterval(p)}}function i(b,c,d){if(!l.contains(b))return!1;for(var e=b;e&&e!==l;){if(e.classList.contains(z.element.consuming))return!0;var f=a(e);// if deltaY && vertical scrollable
  if(d&&f.overflowY.match(/(scroll|auto)/)){var g=e.scrollHeight-e.clientHeight;if(0<g&&(0<e.scrollTop&&0>d||e.scrollTop<g&&0<d))return!0}// if deltaX && horizontal scrollable
  if(c&&f.overflowX.match(/(scroll|auto)/)){var h=e.scrollWidth-e.clientWidth;if(0<h&&(0<e.scrollLeft&&0>c||e.scrollLeft<h&&0<c))return!0}e=e.parentNode}return!1}function j(a){if(g(a)){var b=f(a),e={pageX:b.pageX,pageY:b.pageY},h=e.pageX-m.pageX,j=e.pageY-m.pageY;if(i(a.target,h,j))return;d(h,j),m=e;var k=new Date().getTime(),l=k-n;0<l&&(o.x=h/l,o.y=j/l,n=k),c(h,j)&&a.preventDefault()}}function k(){b.settings.swipeEasing&&(clearInterval(p),p=setInterval(function(){return b.isInitialized?void clearInterval(p):o.x||o.y?.01>u(o.x)&&.01>u(o.y)?void clearInterval(p):b.element?void(d(30*o.x,30*o.y),o.x*=.8,o.y*=.8):void clearInterval(p):void clearInterval(p)},10))}if(E.supportsTouch||E.supportsIePointer){var l=b.element,m={},n=0,o={},p=null;E.supportsTouch?(b.event.bind(l,"touchstart",h),b.event.bind(l,"touchmove",j),b.event.bind(l,"touchend",k)):E.supportsIePointer&&(window.PointerEvent?(b.event.bind(l,"pointerdown",h),b.event.bind(l,"pointermove",j),b.event.bind(l,"pointerup",k)):window.MSPointerEvent&&(b.event.bind(l,"MSPointerDown",h),b.event.bind(l,"MSPointerMove",j),b.event.bind(l,"MSPointerUp",k)))}}},H=function(d,e){var f=this;if(void 0===e&&(e={}),"string"==typeof d&&(d=document.querySelector(d)),!d||!d.nodeName)throw new Error("no element is specified to initialize PerfectScrollbar");for(var g in this.element=d,d.classList.add(z.main),this.settings=F(),e)this.settings[g]=e[g];this.containerWidth=null,this.containerHeight=null,this.contentWidth=null,this.contentHeight=null;var h=function(){return d.classList.add(z.state.focus)},i=function(){return d.classList.remove(z.state.focus)};this.isRtl="rtl"===a(d).direction,!0===this.isRtl&&d.classList.add(z.rtl),this.isNegativeScroll=function(){var a=d.scrollLeft,b=null;return d.scrollLeft=-1,b=0>d.scrollLeft,d.scrollLeft=a,b}(),this.negativeScrollAdjustment=this.isNegativeScroll?d.scrollWidth-d.clientWidth:0,this.event=new D,this.ownerDocument=d.ownerDocument||document,this.scrollbarXRail=c(z.element.rail("x")),d.appendChild(this.scrollbarXRail),this.scrollbarX=c(z.element.thumb("x")),this.scrollbarXRail.appendChild(this.scrollbarX),this.scrollbarX.setAttribute("tabindex",0),this.event.bind(this.scrollbarX,"focus",h),this.event.bind(this.scrollbarX,"blur",i),this.scrollbarXActive=null,this.scrollbarXWidth=null,this.scrollbarXLeft=null;var j=a(this.scrollbarXRail);this.scrollbarXBottom=parseInt(j.bottom,10),isNaN(this.scrollbarXBottom)?(this.isScrollbarXUsingBottom=!1,this.scrollbarXTop=n(j.top)):this.isScrollbarXUsingBottom=!0,this.railBorderXWidth=n(j.borderLeftWidth)+n(j.borderRightWidth),b(this.scrollbarXRail,{display:"block"}),this.railXMarginWidth=n(j.marginLeft)+n(j.marginRight),b(this.scrollbarXRail,{display:""}),this.railXWidth=null,this.railXRatio=null,this.scrollbarYRail=c(z.element.rail("y")),d.appendChild(this.scrollbarYRail),this.scrollbarY=c(z.element.thumb("y")),this.scrollbarYRail.appendChild(this.scrollbarY),this.scrollbarY.setAttribute("tabindex",0),this.event.bind(this.scrollbarY,"focus",h),this.event.bind(this.scrollbarY,"blur",i),this.scrollbarYActive=null,this.scrollbarYHeight=null,this.scrollbarYTop=null;var k=a(this.scrollbarYRail);this.scrollbarYRight=parseInt(k.right,10),isNaN(this.scrollbarYRight)?(this.isScrollbarYUsingRight=!1,this.scrollbarYLeft=n(k.left)):this.isScrollbarYUsingRight=!0,this.scrollbarYOuterWidth=this.isRtl?p(this.scrollbarY):null,this.railBorderYWidth=n(k.borderTopWidth)+n(k.borderBottomWidth),b(this.scrollbarYRail,{display:"block"}),this.railYMarginHeight=n(k.marginTop)+n(k.marginBottom),b(this.scrollbarYRail,{display:""}),this.railYHeight=null,this.railYRatio=null,this.reach={x:0>=d.scrollLeft?"start":d.scrollLeft>=this.contentWidth-this.containerWidth?"end":null,y:0>=d.scrollTop?"start":d.scrollTop>=this.contentHeight-this.containerHeight?"end":null},this.isAlive=!0,this.settings.handlers.forEach(function(a){return G[a](f)}),this.lastScrollTop=v(d.scrollTop),this.lastScrollLeft=d.scrollLeft,this.event.bind(this.element,"scroll",function(a){return f.onScroll(a)}),q(this)};return H.prototype.update=function(){this.isAlive&&(// Recalcuate negative scrollLeft adjustment
  // Recalculate rail margins
  // Hide scrollbars not to affect scrollWidth and scrollHeight
  this.negativeScrollAdjustment=this.isNegativeScroll?this.element.scrollWidth-this.element.clientWidth:0,b(this.scrollbarXRail,{display:"block"}),b(this.scrollbarYRail,{display:"block"}),this.railXMarginWidth=n(a(this.scrollbarXRail).marginLeft)+n(a(this.scrollbarXRail).marginRight),this.railYMarginHeight=n(a(this.scrollbarYRail).marginTop)+n(a(this.scrollbarYRail).marginBottom),b(this.scrollbarXRail,{display:"none"}),b(this.scrollbarYRail,{display:"none"}),q(this),l(this,"top",0,!1,!0),l(this,"left",0,!1,!0),b(this.scrollbarXRail,{display:""}),b(this.scrollbarYRail,{display:""}))},H.prototype.onScroll=function(){this.isAlive&&(q(this),l(this,"top",this.element.scrollTop-this.lastScrollTop),l(this,"left",this.element.scrollLeft-this.lastScrollLeft),this.lastScrollTop=v(this.element.scrollTop),this.lastScrollLeft=this.element.scrollLeft)},H.prototype.destroy=function(){this.isAlive&&(// unset elements
  this.event.unbindAll(),e(this.scrollbarX),e(this.scrollbarY),e(this.scrollbarXRail),e(this.scrollbarYRail),this.removePsClasses(),this.element=null,this.scrollbarX=null,this.scrollbarY=null,this.scrollbarXRail=null,this.scrollbarYRail=null,this.isAlive=!1)},H.prototype.removePsClasses=function(){this.element.className=this.element.className.split(" ").filter(function(a){return!a.match(/^ps([-_].+|)$/)}).join(" ")},H});
  //# sourceMappingURL=perfect-scrollbar.min.js.map
  
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ReadingPositionIndicator=e():t.ReadingPositionIndicator=e()}(this,function(){return function(t){function e(s){if(r[s])return r[s].exports;var o=r[s]={i:s,l:!1,exports:{}};return t[s].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var r={};return e.m=t,e.c=r,e.i=function(t){return t},e.d=function(t,r,s){e.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:s})},e.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(r,"a",r),r},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=4)}([function(t,e,r){"use strict";t.exports=r(1).default},function(t,e,r){"use strict";function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var s in r)Object.prototype.hasOwnProperty.call(r,s)&&(t[s]=r[s])}return t},i=function(){function t(t,e){for(var r=0;r<e.length;r++){var s=e[r];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(t,s.key,s)}}return function(e,r,s){return r&&t(e.prototype,r),s&&t(e,s),e}}();r(3);var n=r(2),a=function(){function t(e){s(this,t);var r={progressBar:{show:!0,color:null,opacity:null},percentage:{show:!1,displayBeforeScroll:!1,color:null,opacity:null},rpiArea:null};this.props=o({},r,e),this.elems={},this.state={scroll:{maxHeight:1,last_known_scroll_position:0,ticking:!1},rpiArea:{},virtualDOM:{},DOM:{}}}return i(t,[{key:"init",value:function(){return this._transformName=(0,n.getTransformVendorPrefixAsString)(),n.applyElements.call(this),this._updateCalculationInformationAndSaveToState(),n.applyConfiguration.call(this),n.applyEventListeners.call(this),this}},{key:"destroy",value:function(){return window.removeEventListener("scroll",this._onScroll),window.removeEventListener("resize",this._onResize),this}},{key:"_updateRpiArea",value:function(){if(this.elems.rpiArea){var t=this.elems.rpiArea.getBoundingClientRect(),e=(0,n.getScrollPosition)();this.state.rpiArea={top:t.top+e,bottom:t.bottom+e,height:t.height}}else{var r=(0,n.getDocumentHeight)();this.state.rpiArea={top:0,bottom:r,height:r}}}},{key:"_updateCalculationInformationAndSaveToState",value:function(){this._updateRpiArea(),this.state.scroll.viewHeight=(0,n.getViewHeight)(),this.state.scroll.maxHeight=this.state.rpiArea.height-this.state.scroll.viewHeight}},{key:"_onScroll",value:function(){var t=this;this.state.scroll.last_known_scroll_position=(0,n.getScrollPosition)(),this.state.scroll.ticking||window.requestAnimationFrame(function(){t._updateProgressBar(t.state.scroll.last_known_scroll_position||0),t.state.scroll.ticking=!1}),this.state.scroll.ticking=!0}},{key:"_updateProgressBar",value:function(t){this._updateVirtualDOM(t),this._updateDOM()}},{key:"_updateVirtualDOM",value:function(t){var e=this.state.scroll,r=e.viewHeight,s=e.maxHeight;if(r>=this.state.rpiArea.height)return this.state.virtualDOM.progressBarPercentageTextContent="",void(this.state.virtualDOM.progressBarPercentage="100");if(t<this.state.rpiArea.top)this.state.virtualDOM.progressBarPercentageTextContent="",this.state.virtualDOM.progressBarPercentage="0",this.state.virtualDOM.progressBarPositionStyleTransform="scaleX(0)";else if(t>this.state.rpiArea.bottom-r)this.state.virtualDOM.progressBarPercentageTextContent="",this.state.virtualDOM.progressBarPercentage="100",this.state.virtualDOM.progressBarPositionStyleTransform="scaleX(1)";else{var o=t-this.state.rpiArea.top,i=Math.min(Math.round(100*o/Math.max(s,1)),100);this.props.progressBar.show&&(this.state.virtualDOM.progressBarPositionStyleTransform="scaleX("+i/100+")"),this.props.percentage.show&&(this.state.virtualDOM.progressBarPercentageTextContent=i+"%"),this.state.virtualDOM.progressBarPercentage=""+i}}},{key:"update",value:function(){return this._updateCalculationInformationAndSaveToState(),this._updateProgressBar((0,n.getScrollPosition)()),this}},{key:"_updateDOM",value:function(){var t=this.state.virtualDOM,e=t.progressBarPercentageTextContent,r=t.progressBarPositionStyleTransform,s=t.progressBarPercentage;e!==this.state.DOM.progressBarPercentageTextContent&&(this.state.DOM.progressBarPercentageTextContent=e,this.elems.progressBarPercentage.textContent=e),r!==this.state.DOM.progressBarPositionStyleTransform&&(this.state.DOM.progressBarPositionStyleTransform=r,this.elems.progressBarPosition.style[this._transformName]=r),s!==this.state.DOM.progressBarPercentage&&(this.state.DOM.progressBarPercentage=s,this.elems.progressBar.setAttribute("aria-valuenow",s))}}]),t}();e.default=a},function(t,e,r){"use strict";function s(t,e,r){var s;return function(){var o=this,i=arguments,n=function(){s=null,r||t.apply(o,i)},a=r&&!s;clearTimeout(s),s=setTimeout(n,e||200),a&&t.apply(o,i)}}function o(){return window.pageYOffset||document.documentElement.scrollTop||0}function i(){var t=document.querySelector(".rpi-progress-bar");this.elems.progressBar=t,this.elems.progressBarPosition=t.querySelector(".rpi-progress-bar__position"),this.elems.progressBarPercentage=t.querySelector(".rpi-progress-bar__percentage"),this.props.rpiArea&&(this.elems.rpiArea=document.querySelector(this.props.rpiArea))}function n(){var t=this.props,e=t.percentage,r=t.progressBar;r&&(r.color&&(this.elems.progressBarPosition.style.background=r.color),r.opacity&&(this.elems.progressBarPosition.style.opacity=r.opacity)),e&&(e.color&&(this.elems.progressBarPercentage.style.color=e.color),e.opacity&&(this.elems.progressBarPercentage.style.opacity=e.opacity),e.displayBeforeScroll&&this._updateProgressBar(o()))}function a(){var t=this;this._onResize=s(function(){t.update()},200),this._onScroll=this._onScroll.bind(this),this._onResize=this._onResize.bind(this),window.addEventListener("scroll",this._onScroll),window.addEventListener("resize",this._onResize)}function l(){for(var t=document.createElement("div"),e={transform:"transform",WebkitTransition:"webkitTransform",MsTransform:"msTransform"},r=0;r<e.length;r+=1){var s=e[r];if(void 0!==t.style[s])return e[s]}return"transform"}function c(){return Math.max(document.documentElement.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight)}function u(){return Math.max(window.innerHeight,0)}Object.defineProperty(e,"__esModule",{value:!0}),e.debounce=s,e.getScrollPosition=o,e.applyElements=i,e.applyConfiguration=n,e.applyEventListeners=a,e.getTransformVendorPrefixAsString=l,e.getDocumentHeight=c,e.getViewHeight=u},function(t,e){},function(t,e,r){t.exports=r(0)}])});
/*! Selectric ϟ v1.11.1 (2017-01-11) - git.io/tjl9sQ - Copyright (c) 2017 Leonardo Santos - MIT License */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof module&&module.exports?module.exports=function(t,s){return void 0===s&&(s="undefined"!=typeof window?require("jquery"):require("jquery")(t)),e(s),s}:e(jQuery)}(function(e){"use strict";var t=e(document),s=e(window),i="selectric",l="Input Items Open Disabled TempShow HideSelect Wrapper Focus Hover Responsive Above Scroll Group GroupLabel",n=".sl",a=["a","e","i","o","u","n","c","y"],o=[/[\xE0-\xE5]/g,/[\xE8-\xEB]/g,/[\xEC-\xEF]/g,/[\xF2-\xF6]/g,/[\xF9-\xFC]/g,/[\xF1]/g,/[\xE7]/g,/[\xFD-\xFF]/g],r=function(t,s){var i=this;i.element=t,i.$element=e(t),i.state={multiple:!!i.$element.attr("multiple"),enabled:!1,opened:!1,currValue:-1,selectedIdx:-1,highlightedIdx:-1},i.eventTriggers={open:i.open,close:i.close,destroy:i.destroy,refresh:i.refresh,init:i.init},i.init(s)};r.prototype={utils:{isMobile:function(){return/android|ip(hone|od|ad)/i.test(navigator.userAgent)},escapeRegExp:function(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")},replaceDiacritics:function(e){for(var t=o.length;t--;)e=e.toLowerCase().replace(o[t],a[t]);return e},format:function(e){var t=arguments;return(""+e).replace(/\{(?:(\d+)|(\w+))\}/g,function(e,s,i){return i&&t[1]?t[1][i]:t[s]})},nextEnabledItem:function(e,t){for(;e[t=(t+1)%e.length].disabled;);return t},previousEnabledItem:function(e,t){for(;e[t=(t>0?t:e.length)-1].disabled;);return t},toDash:function(e){return e.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()},triggerCallback:function(t,s){var l=s.element,n=s.options["on"+t],a=[l].concat([].slice.call(arguments).slice(1));e.isFunction(n)&&n.apply(l,a),e(l).trigger(i+"-"+this.toDash(t),a)},arrayToClassname:function(t){var s=e.grep(t,function(e){return!!e});return e.trim(s.join(" "))}},init:function(t){var s=this;if(s.options=e.extend(!0,{},e.fn[i].defaults,s.options,t),s.utils.triggerCallback("BeforeInit",s),s.destroy(!0),s.options.disableOnMobile&&s.utils.isMobile())return void(s.disableOnMobile=!0);s.classes=s.getClassNames();var l=e("<input/>",{class:s.classes.input,readonly:s.utils.isMobile()}),n=e("<div/>",{class:s.classes.items,tabindex:0}),a=e("<div/>",{class:s.classes.scroll}),o=e("<div/>",{class:s.classes.prefix,html:s.options.arrowButtonMarkup}),r=e("<span/>",{class:"label"}),u=s.$element.wrap("<div/>").parent().append(o.prepend(r),n,l),p=e("<div/>",{class:s.classes.hideselect});s.elements={input:l,items:n,itemsScroll:a,wrapper:o,label:r,outerWrapper:u},s.options.nativeOnMobile&&s.utils.isMobile()&&(s.elements.input=void 0,p.addClass(s.classes.prefix+"-is-native"),s.$element.on("change",function(){s.refresh()})),s.$element.on(s.eventTriggers).wrap(p),s.originalTabindex=s.$element.prop("tabindex"),s.$element.prop("tabindex",0),s.populate(),s.activate(),s.utils.triggerCallback("Init",s)},activate:function(){var e=this,t=e.elements.items.closest(":visible").children(":hidden").addClass(e.classes.tempshow),s=e.$element.width();t.removeClass(e.classes.tempshow),e.utils.triggerCallback("BeforeActivate",e),e.elements.outerWrapper.prop("class",e.utils.arrayToClassname([e.classes.wrapper,e.$element.prop("class").replace(/\S+/g,e.classes.prefix+"-$&"),e.options.responsive?e.classes.responsive:""])),e.options.inheritOriginalWidth&&s>0&&e.elements.outerWrapper.width(s),e.unbindEvents(),e.$element.prop("disabled")?(e.elements.outerWrapper.addClass(e.classes.disabled),e.elements.input&&e.elements.input.prop("disabled",!0)):(e.state.enabled=!0,e.elements.outerWrapper.removeClass(e.classes.disabled),e.$li=e.elements.items.removeAttr("style").find("li"),e.bindEvents()),e.utils.triggerCallback("Activate",e)},getClassNames:function(){var t=this,s=t.options.customClass,i={};return e.each(l.split(" "),function(e,l){var n=s.prefix+l;i[l.toLowerCase()]=s.camelCase?n:t.utils.toDash(n)}),i.prefix=s.prefix,i},setLabel:function(){var t=this,s=t.options.labelBuilder;if(t.state.multiple){var i=e.isArray(t.state.currValue)?t.state.currValue:[t.state.currValue];i=0===i.length?[0]:i;var l=e.map(i,function(s){return e.grep(t.lookupItems,function(e){return e.index===s})[0]});l=e.grep(l,function(t){return l.length>1||0===l.length?""!==e.trim(t.value):t}),l=e.map(l,function(i){return e.isFunction(s)?s(i):t.utils.format(s,i)}),t.options.multiple.maxLabelEntries&&(l.length>=t.options.multiple.maxLabelEntries+1?(l=l.slice(0,t.options.multiple.maxLabelEntries),l.push(e.isFunction(s)?s({text:"..."}):t.utils.format(s,{text:"..."}))):l.slice(l.length-1)),t.elements.label.html(l.join(t.options.multiple.separator))}else{var n=t.lookupItems[t.state.currValue];t.elements.label.html(e.isFunction(s)?s(n):t.utils.format(s,n))}},populate:function(){var t=this,s=t.$element.children(),i=t.$element.find("option"),l=i.filter(":selected"),n=i.index(l),a=0,o=t.state.multiple?[]:0;l.length>1&&t.state.multiple&&(n=[],l.each(function(){n.push(e(this).index())})),t.state.currValue=~n?n:o,t.state.selectedIdx=t.state.currValue,t.state.highlightedIdx=t.state.currValue,t.items=[],t.lookupItems=[],s.length&&(s.each(function(s){var i=e(this);if(i.is("optgroup")){var l={element:i,label:i.prop("label"),groupDisabled:i.prop("disabled"),items:[]};i.children().each(function(s){var i=e(this);l.items[s]=t.getItemData(a,i,l.groupDisabled||i.prop("disabled")),t.lookupItems[a]=l.items[s],a++}),t.items[s]=l}else t.items[s]=t.getItemData(a,i,i.prop("disabled")),t.lookupItems[a]=t.items[s],a++}),t.setLabel(),t.elements.items.append(t.elements.itemsScroll.html(t.getItemsMarkup(t.items))))},getItemData:function(t,s,i){var l=this;return{index:t,element:s,value:s.val(),className:s.prop("class"),text:s.html(),slug:e.trim(l.utils.replaceDiacritics(s.html())),selected:s.prop("selected"),disabled:i}},getItemsMarkup:function(t){var s=this,i="<ul>";return e.isFunction(s.options.listBuilder)&&s.options.listBuilder&&(t=s.options.listBuilder(t)),e.each(t,function(t,l){void 0!==l.label?(i+=s.utils.format('<ul class="{1}"><li class="{2}">{3}</li>',s.utils.arrayToClassname([s.classes.group,l.groupDisabled?"disabled":"",l.element.prop("class")]),s.classes.grouplabel,l.element.prop("label")),e.each(l.items,function(e,t){i+=s.getItemMarkup(t.index,t)}),i+="</ul>"):i+=s.getItemMarkup(l.index,l)}),i+"</ul>"},getItemMarkup:function(t,s){var i=this,l=i.options.optionsItemBuilder,n={value:s.value,text:s.text,slug:s.slug,index:s.index};return i.utils.format('<li data-index="{1}" class="{2}">{3}</li>',t,i.utils.arrayToClassname([s.className,t===i.items.length-1?"last":"",s.disabled?"disabled":"",s.selected?"selected":""]),e.isFunction(l)?i.utils.format(l(s),s):i.utils.format(l,n))},unbindEvents:function(){var e=this;e.elements.wrapper.add(e.$element).add(e.elements.outerWrapper).add(e.elements.input).off(n)},bindEvents:function(){var t=this;t.elements.outerWrapper.on("mouseenter"+n+" mouseleave"+n,function(s){e(this).toggleClass(t.classes.hover,"mouseenter"===s.type),t.options.openOnHover&&(clearTimeout(t.closeTimer),"mouseleave"===s.type?t.closeTimer=setTimeout(e.proxy(t.close,t),t.options.hoverIntentTimeout):t.open())}),t.elements.wrapper.on("click"+n,function(e){t.state.opened?t.close():t.open(e)}),t.options.nativeOnMobile&&t.utils.isMobile()||(t.$element.on("focus"+n,function(){t.elements.input.focus()}),t.elements.input.prop({tabindex:t.originalTabindex,disabled:!1}).on("keydown"+n,e.proxy(t.handleKeys,t)).on("focusin"+n,function(e){t.elements.outerWrapper.addClass(t.classes.focus),t.elements.input.one("blur",function(){t.elements.input.blur()}),t.options.openOnFocus&&!t.state.opened&&t.open(e)}).on("focusout"+n,function(){t.elements.outerWrapper.removeClass(t.classes.focus)}).on("input propertychange",function(){var s=t.elements.input.val(),i=new RegExp("^"+t.utils.escapeRegExp(s),"i");clearTimeout(t.resetStr),t.resetStr=setTimeout(function(){t.elements.input.val("")},t.options.keySearchTimeout),s.length&&e.each(t.items,function(e,s){if(!s.disabled&&i.test(s.text)||i.test(s.slug))return void t.highlight(e)})})),t.$li.on({mousedown:function(e){e.preventDefault(),e.stopPropagation()},click:function(){return t.select(e(this).data("index")),!1}})},handleKeys:function(t){var s=this,i=t.which,l=s.options.keys,n=e.inArray(i,l.previous)>-1,a=e.inArray(i,l.next)>-1,o=e.inArray(i,l.select)>-1,r=e.inArray(i,l.open)>-1,u=s.state.highlightedIdx,p=n&&0===u||a&&u+1===s.items.length,c=0;if(13!==i&&32!==i||t.preventDefault(),n||a){if(!s.options.allowWrap&&p)return;n&&(c=s.utils.previousEnabledItem(s.lookupItems,u)),a&&(c=s.utils.nextEnabledItem(s.lookupItems,u)),s.highlight(c)}return o&&s.state.opened?(s.select(u),void(s.state.multiple&&s.options.multiple.keepMenuOpen||s.close())):void(r&&!s.state.opened&&s.open())},refresh:function(){var e=this;e.populate(),e.activate(),e.utils.triggerCallback("Refresh",e)},setOptionsDimensions:function(){var e=this,t=e.elements.items.closest(":visible").children(":hidden").addClass(e.classes.tempshow),s=e.options.maxHeight,i=e.elements.items.outerWidth(),l=e.elements.wrapper.outerWidth()-(i-e.elements.items.width());!e.options.expandToItemText||l>i?e.finalWidth=l:(e.elements.items.css("overflow","scroll"),e.elements.outerWrapper.width(9e4),e.finalWidth=e.elements.items.width(),e.elements.items.css("overflow",""),e.elements.outerWrapper.width("")),e.elements.items.width(e.finalWidth).height()>s&&e.elements.items.height(s),t.removeClass(e.classes.tempshow)},isInViewport:function(){var e=this,t=s.scrollTop(),i=s.height(),l=e.elements.outerWrapper.offset().top,n=e.elements.outerWrapper.outerHeight(),a=l+n+e.itemsHeight<=t+i,o=l-e.itemsHeight>t,r=!a&&o;e.elements.outerWrapper.toggleClass(e.classes.above,r)},detectItemVisibility:function(t){var s=this,i=s.$li.filter("[data-index]");s.state.multiple&&(t=e.isArray(t)&&0===t.length?0:t,t=e.isArray(t)?Math.min.apply(Math,t):t);var l=i.eq(t).outerHeight(),n=i[t].offsetTop,a=s.elements.itemsScroll.scrollTop(),o=n+2*l;s.elements.itemsScroll.scrollTop(o>a+s.itemsHeight?o-s.itemsHeight:n-l<a?n-l:a)},open:function(s){var l=this;return(!l.options.nativeOnMobile||!l.utils.isMobile())&&(l.utils.triggerCallback("BeforeOpen",l),s&&(s.preventDefault(),l.options.stopPropagation&&s.stopPropagation()),void(l.state.enabled&&(l.setOptionsDimensions(),e("."+l.classes.hideselect,"."+l.classes.open).children()[i]("close"),l.state.opened=!0,l.itemsHeight=l.elements.items.outerHeight(),l.itemsInnerHeight=l.elements.items.height(),l.elements.outerWrapper.addClass(l.classes.open),l.elements.input.val(""),s&&"focusin"!==s.type&&l.elements.input.focus(),setTimeout(function(){t.on("click"+n,e.proxy(l.close,l)).on("scroll"+n,e.proxy(l.isInViewport,l))},1),l.isInViewport(),l.options.preventWindowScroll&&t.on("mousewheel"+n+" DOMMouseScroll"+n,"."+l.classes.scroll,function(t){var s=t.originalEvent,i=e(this).scrollTop(),n=0;"detail"in s&&(n=s.detail*-1),"wheelDelta"in s&&(n=s.wheelDelta),"wheelDeltaY"in s&&(n=s.wheelDeltaY),"deltaY"in s&&(n=s.deltaY*-1),(i===this.scrollHeight-l.itemsInnerHeight&&n<0||0===i&&n>0)&&t.preventDefault()}),l.detectItemVisibility(l.state.selectedIdx),l.highlight(l.state.multiple?-1:l.state.selectedIdx),l.utils.triggerCallback("Open",l))))},close:function(){var e=this;e.utils.triggerCallback("BeforeClose",e),t.off(n),e.elements.outerWrapper.removeClass(e.classes.open),e.state.opened=!1,e.utils.triggerCallback("Close",e)},change:function(){var t=this;t.utils.triggerCallback("BeforeChange",t),t.state.multiple?(e.each(t.lookupItems,function(e){t.lookupItems[e].selected=!1,t.$element.find("option").prop("selected",!1)}),e.each(t.state.selectedIdx,function(e,s){t.lookupItems[s].selected=!0,t.$element.find("option").eq(s).prop("selected",!0)}),t.state.currValue=t.state.selectedIdx,t.setLabel(),t.utils.triggerCallback("Change",t)):t.state.currValue!==t.state.selectedIdx&&(t.$element.prop("selectedIndex",t.state.currValue=t.state.selectedIdx).data("value",t.lookupItems[t.state.selectedIdx].text),t.setLabel(),t.utils.triggerCallback("Change",t))},highlight:function(e){var t=this,s=t.$li.filter("[data-index]").removeClass("highlighted");t.utils.triggerCallback("BeforeHighlight",t),void 0===e||e===-1||t.lookupItems[e].disabled||(s.eq(t.state.highlightedIdx=e).addClass("highlighted"),t.detectItemVisibility(e),t.utils.triggerCallback("Highlight",t))},select:function(t){var s=this,i=s.$li.filter("[data-index]");if(s.utils.triggerCallback("BeforeSelect",s,t),void 0!==t&&t!==-1&&!s.lookupItems[t].disabled){if(s.state.multiple){s.state.selectedIdx=e.isArray(s.state.selectedIdx)?s.state.selectedIdx:[s.state.selectedIdx];var l=e.inArray(t,s.state.selectedIdx);l!==-1?s.state.selectedIdx.splice(l,1):s.state.selectedIdx.push(t),i.removeClass("selected").filter(function(t){return e.inArray(t,s.state.selectedIdx)!==-1}).addClass("selected")}else i.removeClass("selected").eq(s.state.selectedIdx=t).addClass("selected");s.state.multiple&&s.options.multiple.keepMenuOpen||s.close(),s.change(),s.utils.triggerCallback("Select",s,t)}},destroy:function(e){var t=this;t.state&&t.state.enabled&&(t.elements.items.add(t.elements.wrapper).add(t.elements.input).remove(),e||t.$element.removeData(i).removeData("value"),t.$element.prop("tabindex",t.originalTabindex).off(n).off(t.eventTriggers).unwrap().unwrap(),t.state.enabled=!1)}},e.fn[i]=function(t){return this.each(function(){var s=e.data(this,i);s&&!s.disableOnMobile?"string"==typeof t&&s[t]?s[t]():s.init(t):e.data(this,i,new r(this,t))})},e.fn[i].defaults={onChange:function(t){e(t).change()},maxHeight:300,keySearchTimeout:500,arrowButtonMarkup:'<b class="button">&#x25be;</b>',disableOnMobile:!1,nativeOnMobile:!0,openOnFocus:!0,openOnHover:!1,hoverIntentTimeout:500,expandToItemText:!1,responsive:!1,preventWindowScroll:!0,inheritOriginalWidth:!1,allowWrap:!0,stopPropagation:!0,optionsItemBuilder:"{text}",labelBuilder:"{text}",listBuilder:!1,keys:{previous:[37,38],next:[39,40],select:[9,13,27],open:[13,32,37,38,39,40],close:[9,27]},customClass:{prefix:i,camelCase:!1},multiple:{separator:", ",keepMenuOpen:!0,maxLabelEntries:!1}}});
/*
DONT MODIFY OR UPDATE/REPLACE THIS FILE

These lines below were commented out to disable Shave elements automatically generating.
- line 163 - 168: removed diff string element
- line 196 - 111: removed span tag that wraps ... characters
*/
/**
  shave - Shave is a javascript plugin that truncates multi-line text within a html element based on set max height
  @version v5.0.2
  @link https://github.com/yowainwright/shave#readme
  @author Jeff Wainwright <yowainwright@gmail.com> (jeffry.in)
  @license MIT
**/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.shave = factory());
})(this, (function () { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    function generateArrayOfNodes(target) {
        if (typeof target === 'string') {
            return __spreadArray([], __read(document.querySelectorAll(target)), false);
        }
        else if ('length' in target) {
            return __spreadArray([], __read(target), false);
        }
        else {
            return [target];
        }
    }
    function shave(target, maxHeight, opts) {
        if (opts === void 0) { opts = {}; }
        if (typeof maxHeight === 'undefined' || isNaN(maxHeight)) {
            throw Error('maxHeight is required');
        }
        var els = generateArrayOfNodes(target);
        if (!els.length) {
            return;
        }
        var _a = opts.character, character = _a === void 0 ? '…' : _a, _b = opts.classname, classname = _b === void 0 ? 'js-shave' : _b, _c = opts.spaces, initialSpaces = _c === void 0 ? true : _c, _d = opts.charclassname, charclassname = _d === void 0 ? 'js-shave-char' : _d, _e = opts.link, link = _e === void 0 ? {} : _e;
        /**
         * @notes
         * the initialSpaces + spaces variable definition below fixes
         * a previous bug where spaces being a boolean type wasn't clear
         * meaning people were using (a string, in example—which is truthy)
         * hence, doing it this way is a non-breaking change
         */
        var spaces = typeof initialSpaces === 'boolean' ? initialSpaces : true;
        /**
         * @notes
         * - create a span or anchor element and assign properties to it
         * - JSON.stringify is used to support IE8+
         * - if link.href is not provided, link object properties are ignored
         */
        var isLink = link && JSON.stringify(link) !== '{}' && link.href;
        var shavedTextElType = isLink ? 'a' : 'span';
        for (var i = 0; i < els.length; i += 1) {
            var el = els[i];
            var styles = el.style;
            // var span = el.querySelector('.' + classname);
            var textProp = el.textContent === undefined ? 'innerText' : 'textContent';
            // If element text has already been shaved
            // if (span) {
            //     // Remove the ellipsis to recapture the original text
            //     // el.removeChild(el.querySelector('.' + charclassname));
            //     // el[textProp] = el[textProp]; // eslint-disable-line
            //     // nuke span, recombine text
            // }
            var fullText = el[textProp];
            var words = spaces ? fullText.split(' ') : fullText;
            // If 0 or 1 words, we're done
            if (words.length < 2) {
                continue;
            }
            // Temporarily remove any CSS height for text height calculation
            var heightStyle = styles.height;
            styles.height = 'auto';
            var maxHeightStyle = styles.maxHeight;
            styles.maxHeight = 'none';
            // If already short enough, we're done
            if (el.offsetHeight <= maxHeight) {
                styles.height = heightStyle;
                styles.maxHeight = maxHeightStyle;
                continue;
            }
            var textContent = isLink && link.textContent ? link.textContent : character;
            var shavedTextEl = document.createElement(shavedTextElType);
            var shavedTextElAttributes = {
                className: charclassname,
                textContent: textContent,
            };
            for (var property in shavedTextElAttributes) {
                shavedTextEl[property] = shavedTextElAttributes[property];
                shavedTextEl.textContent = character;
            }
            if (isLink) {
                for (var linkProperty in link) {
                    shavedTextEl[linkProperty] = link[linkProperty];
                }
            }
            // Binary search for number of words which can fit in allotted height
            var max = words.length - 1;
            var min = 0;
            var pivot = void 0;
            while (min < max) {
                pivot = (min + max + 1) >> 1; // eslint-disable-line no-bitwise
                el[textProp] = spaces
                    ? words.slice(0, pivot).join(' ')
                    : words.slice(0, pivot);
                el.insertAdjacentHTML('beforeend', shavedTextEl.textContent);
                if (el.offsetHeight > maxHeight) {
                    max = pivot - 1;
                }
                else {
                    min = pivot;
                }
            }
            el[textProp] = spaces ? words.slice(0, max).join(' ') : words.slice(0, max);
            el.insertAdjacentHTML('beforeend', shavedTextEl.textContent);
            // var diff = spaces
            //     ? " ".concat(words.slice(max).join(' '))
            //     : words.slice(max);
            // var shavedText = document.createTextNode(diff);
            // var elWithShavedText = document.createElement('span');
            // elWithShavedText.classList.add(classname);
            // elWithShavedText.style.display = 'none';
            // elWithShavedText.appendChild(shavedText);
            // el.insertAdjacentElement('beforeend', elWithShavedText);
            styles.height = heightStyle;
            styles.maxHeight = maxHeightStyle;
        }
    }

    return shave;

}));

/**
 * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
 * https://github.com/iconic/SVGInjector
 *
 * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
 * @license MIT
 */
!function(t,e){"use strict";function r(t){t=t.split(" ");for(var e={},r=t.length,n=[];r--;)e.hasOwnProperty(t[r])||(e[t[r]]=1,n.unshift(t[r]));return n.join(" ")}var n="file:"===t.location.protocol,i=e.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1"),o=Array.prototype.forEach||function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;var r,n=this.length>>>0;for(r=0;n>r;++r)r in this&&t.call(e,this[r],r,this)},a={},l=0,s=[],u=[],c={},f=function(t){return t.cloneNode(!0)},p=function(t,e){u[t]=u[t]||[],u[t].push(e)},d=function(t){for(var e=0,r=u[t].length;r>e;e++)!function(e){setTimeout(function(){u[t][e](f(a[t]))},0)}(e)},v=function(e,r){if(void 0!==a[e])a[e]instanceof SVGSVGElement?r(f(a[e])):p(e,r);else{if(!t.XMLHttpRequest)return r("Browser does not support XMLHttpRequest"),!1;a[e]={},p(e,r);var i=new XMLHttpRequest;i.onreadystatechange=function(){if(4===i.readyState){if(404===i.status||null===i.responseXML)return r("Unable to load SVG file: "+e),n&&r("Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver."),r(),!1;if(!(200===i.status||n&&0===i.status))return r("There was a problem injecting the SVG: "+i.status+" "+i.statusText),!1;if(i.responseXML instanceof Document)a[e]=i.responseXML.documentElement;else if(DOMParser&&DOMParser instanceof Function){var t;try{var o=new DOMParser;t=o.parseFromString(i.responseText,"text/xml")}catch(l){t=void 0}if(!t||t.getElementsByTagName("parsererror").length)return r("Unable to parse SVG file: "+e),!1;a[e]=t.documentElement}d(e)}},i.open("GET",e),i.overrideMimeType&&i.overrideMimeType("text/xml"),i.send()}},h=function(e,n,a,u){var f=e.getAttribute("data-src")||e.getAttribute("src");if(!/\.svg/i.test(f))return void u("Attempted to inject a file with a non-svg extension: "+f);if(!i){var p=e.getAttribute("data-fallback")||e.getAttribute("data-png");return void(p?(e.setAttribute("src",p),u(null)):a?(e.setAttribute("src",a+"/"+f.split("/").pop().replace(".svg",".png")),u(null)):u("This browser does not support SVG and no PNG fallback was defined."))}-1===s.indexOf(e)&&(s.push(e),e.setAttribute("src",""),v(f,function(i){if("undefined"==typeof i||"string"==typeof i)return u(i),!1;var a=e.getAttribute("id");a&&i.setAttribute("id",a);var p=e.getAttribute("title");p&&i.setAttribute("title",p);var d=[].concat(i.getAttribute("class")||[],"injected-svg",e.getAttribute("class")||[]).join(" ");i.setAttribute("class",r(d));var v=e.getAttribute("style");v&&i.setAttribute("style",v);var h=[].filter.call(e.attributes,function(t){return/^data-\w[\w\-]*$/.test(t.name)});o.call(h,function(t){t.name&&t.value&&i.setAttribute(t.name,t.value)});var g,m,b,y,A,w={clipPath:["clip-path"],"color-profile":["color-profile"],cursor:["cursor"],filter:["filter"],linearGradient:["fill","stroke"],marker:["marker","marker-start","marker-mid","marker-end"],mask:["mask"],pattern:["fill","stroke"],radialGradient:["fill","stroke"]};Object.keys(w).forEach(function(t){g=t,b=w[t],m=i.querySelectorAll("defs "+g+"[id]");for(var e=0,r=m.length;r>e;e++){y=m[e].id,A=y+"-"+l;var n;o.call(b,function(t){n=i.querySelectorAll("["+t+'*="'+y+'"]');for(var e=0,r=n.length;r>e;e++)n[e].setAttribute(t,"url(#"+A+")")}),m[e].id=A}}),i.removeAttribute("xmlns:a");for(var x,S,k=i.querySelectorAll("script"),j=[],G=0,T=k.length;T>G;G++)S=k[G].getAttribute("type"),S&&"application/ecmascript"!==S&&"application/javascript"!==S||(x=k[G].innerText||k[G].textContent,j.push(x),i.removeChild(k[G]));if(j.length>0&&("always"===n||"once"===n&&!c[f])){for(var M=0,V=j.length;V>M;M++)new Function(j[M])(t);c[f]=!0}var E=i.querySelectorAll("style");o.call(E,function(t){t.textContent+=""}),e.parentNode.replaceChild(i,e),delete s[s.indexOf(e)],e=null,l++,u(i)}))},g=function(t,e,r){e=e||{};var n=e.evalScripts||"always",i=e.pngFallback||!1,a=e.each;if(void 0!==t.length){var l=0;o.call(t,function(e){h(e,n,i,function(e){a&&"function"==typeof a&&a(e),r&&t.length===++l&&r(l)})})}else t?h(t,n,i,function(e){a&&"function"==typeof a&&a(e),r&&r(1),t=null}):r&&r(0)};"object"==typeof module&&"object"==typeof module.exports?module.exports=exports=g:"function"==typeof define&&define.amd?define(function(){return g}):"object"==typeof t&&(t.SVGInjector=g)}(window,document);
/**
 * Swiper 3.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: December 13, 2016
 */
(function () {
    'use strict';
    var $;
    /*===========================
    Swiper
    ===========================*/
    var Swiper = function (container, params) {
        if (!(this instanceof Swiper)) return new Swiper(container, params);

        var defaults = {
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            // autoplay
            autoplay: false,
            autoplayDisableOnInteraction: true,
            autoplayStopOnLast: false,
            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
            iOSEdgeSwipeDetection: false,
            iOSEdgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Autoheight
            autoHeight: false,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true
            },
            flip: {
                slideShadows : true,
                limitRotation: true
            },
            cube: {
                slideShadows: true,
                shadow: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            fade: {
                crossFade: false
            },
            // Parallax
            parallax: false,
            // Zoom
            zoom: false,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: true,
            // Scrollbar
            scrollbar: null,
            scrollbarHide: true,
            scrollbarDraggable: false,
            scrollbarSnapOnRelease: false,
            // Keyboard Mousewheel
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelReleaseOnEdges: false,
            mousewheelInvert: false,
            mousewheelForceToAxis: false,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: 'container',
            // Hash Navigation
            hashnav: false,
            hashnavWatchState: false,
            // History
            history: false,
            // Commong Nav State
            replaceState: false,
            // Breakpoints
            breakpoints: undefined,
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: false,
            slidesOffsetBefore: 0, // in px
            slidesOffsetAfter: 0, // in px
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            onlyExternal: false,
            threshold: 0,
            touchMoveStopPropagation: true,
            touchReleaseOnEdges: false,
            // Unique Navigation Elements
            uniqueNavElements: true,
            // Pagination
            pagination: null,
            paginationElement: 'span',
            paginationClickable: false,
            paginationHide: false,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Next/prev buttons
            nextButton: null,
            prevButton: null,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Lazy Loading
            lazyLoading: false,
            lazyLoadingInPrevNext: false,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            // Control
            control: undefined,
            controlInverse: false,
            controlBy: 'slide', //or 'container'
            normalizeSlideIndex: true,
            // Swiping/no swiping
            allowSwipeToPrev: true,
            allowSwipeToNext: true,
            swipeHandler: null, //'.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            // Passive Listeners
            passiveListeners: true,
            // NS
            containerModifierClass: 'swiper-container-', // NEW
            slideClass: 'swiper-slide',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            buttonDisabledClass: 'swiper-button-disabled',
            paginationCurrentClass: 'swiper-pagination-current',
            paginationTotalClass: 'swiper-pagination-total',
            paginationHiddenClass: 'swiper-pagination-hidden',
            paginationProgressbarClass: 'swiper-pagination-progressbar',
            paginationClickableClass: 'swiper-pagination-clickable', // NEW
            paginationModifierClass: 'swiper-pagination-', // NEW
            lazyLoadingClass: 'swiper-lazy',
            lazyStatusLoadingClass: 'swiper-lazy-loading',
            lazyStatusLoadedClass: 'swiper-lazy-loaded',
            lazyPreloaderClass: 'swiper-lazy-preloader',
            notificationClass: 'swiper-notification',
            preloaderClass: 'preloader',
            zoomContainerClass: 'swiper-zoom-container',
        
            // Observer
            observer: false,
            observeParents: false,
            // Accessibility
            a11y: false,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            // Callbacks
            runCallbacksOnInit: true
            /*
            Callbacks:
            onInit: function (swiper)
            onDestroy: function (swiper)
            onClick: function (swiper, e)
            onTap: function (swiper, e)
            onDoubleTap: function (swiper, e)
            onSliderMove: function (swiper, e)
            onSlideChangeStart: function (swiper)
            onSlideChangeEnd: function (swiper)
            onTransitionStart: function (swiper)
            onTransitionEnd: function (swiper)
            onImagesReady: function (swiper)
            onProgress: function (swiper, progress)
            onTouchStart: function (swiper, e)
            onTouchMove: function (swiper, e)
            onTouchMoveOpposite: function (swiper, e)
            onTouchEnd: function (swiper, e)
            onReachBeginning: function (swiper)
            onReachEnd: function (swiper)
            onSetTransition: function (swiper, duration)
            onSetTranslate: function (swiper, translate)
            onAutoplayStart: function (swiper)
            onAutoplayStop: function (swiper),
            onLazyImageLoad: function (swiper, slide, image)
            onLazyImageReady: function (swiper, slide, image)
            */
        
        };
        var initialVirtualTranslate = params && params.virtualTranslate;
        
        params = params || {};
        var originalParams = {};
        for (var param in params) {
            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
                originalParams[param] = {};
                for (var deepParam in params[param]) {
                    originalParams[param][deepParam] = params[param][deepParam];
                }
            }
            else {
                originalParams[param] = params[param];
            }
        }
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
            else if (typeof params[def] === 'object') {
                for (var deepDef in defaults[def]) {
                    if (typeof params[def][deepDef] === 'undefined') {
                        params[def][deepDef] = defaults[def][deepDef];
                    }
                }
            }
        }
        
        // Swiper
        var s = this;
        
        // Params
        s.params = params;
        s.originalParams = originalParams;
        
        // Classname
        s.classNames = [];
        /*=========================
          Dom Library and plugins
          ===========================*/
        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
            $ = Dom7;
        }
        if (typeof $ === 'undefined') {
            if (typeof Dom7 === 'undefined') {
                $ = window.Dom7 || window.Zepto || window.jQuery;
            }
            else {
                $ = Dom7;
            }
            if (!$) return;
        }
        // Export it to Swiper instance
        s.$ = $;
        
        /*=========================
          Breakpoints
          ===========================*/
        s.currentBreakpoint = undefined;
        s.getActiveBreakpoint = function () {
            //Get breakpoint for window width
            if (!s.params.breakpoints) return false;
            var breakpoint = false;
            var points = [], point;
            for ( point in s.params.breakpoints ) {
                if (s.params.breakpoints.hasOwnProperty(point)) {
                    points.push(point);
                }
            }
            points.sort(function (a, b) {
                return parseInt(a, 10) > parseInt(b, 10);
            });
            for (var i = 0; i < points.length; i++) {
                point = points[i];
                if (point >= window.innerWidth && !breakpoint) {
                    breakpoint = point;
                }
            }
            return breakpoint || 'max';
        };
        s.setBreakpoint = function () {
            //Set breakpoint for window width and update parameters
            var breakpoint = s.getActiveBreakpoint();
            if (breakpoint && s.currentBreakpoint !== breakpoint) {
                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
                for ( var param in breakPointsParams ) {
                    s.params[param] = breakPointsParams[param];
                }
                s.currentBreakpoint = breakpoint;
                if(needsReLoop && s.destroyLoop) {
                    s.reLoop(true);
                }
            }
        };
        // Set breakpoint on load
        if (s.params.breakpoints) {
            s.setBreakpoint();
        }
        
        /*=========================
          Preparation - Define Container, Wrapper and Pagination
          ===========================*/
        s.container = $(container);
        if (s.container.length === 0) return;
        if (s.container.length > 1) {
            var swipers = [];
            s.container.each(function () {
                var container = this;
                swipers.push(new Swiper(this, params));
            });
            return swipers;
        }
        
        // Save instance in container HTML Element and in data
        s.container[0].swiper = s;
        s.container.data('swiper', s);
        
        s.classNames.push(s.params.containerModifierClass + s.params.direction);
        
        if (s.params.freeMode) {
            s.classNames.push(s.params.containerModifierClass + 'free-mode');
        }
        if (!s.support.flexbox) {
            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
            s.params.slidesPerColumn = 1;
        }
        if (s.params.autoHeight) {
            s.classNames.push(s.params.containerModifierClass + 'autoheight');
        }
        // Enable slides progress when required
        if (s.params.parallax || s.params.watchSlidesVisibility) {
            s.params.watchSlidesProgress = true;
        }
        // Max resistance when touchReleaseOnEdges
        if (s.params.touchReleaseOnEdges) {
            s.params.resistanceRatio = 0;
        }
        // Coverflow / 3D
        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
            if (s.support.transforms3d) {
                s.params.watchSlidesProgress = true;
                s.classNames.push(s.params.containerModifierClass + '3d');
            }
            else {
                s.params.effect = 'slide';
            }
        }
        if (s.params.effect !== 'slide') {
            s.classNames.push(s.params.containerModifierClass + s.params.effect);
        }
        if (s.params.effect === 'cube') {
            s.params.resistanceRatio = 0;
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.centeredSlides = false;
            s.params.spaceBetween = 0;
            s.params.virtualTranslate = true;
            s.params.setWrapperSize = false;
        }
        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.watchSlidesProgress = true;
            s.params.spaceBetween = 0;
            s.params.setWrapperSize = false;
            if (typeof initialVirtualTranslate === 'undefined') {
                s.params.virtualTranslate = true;
            }
        }
        
        // Grab Cursor
        if (s.params.grabCursor && s.support.touch) {
            s.params.grabCursor = false;
        }
        
        // Wrapper
        s.wrapper = s.container.children('.' + s.params.wrapperClass);
        
        // Pagination
        if (s.params.pagination) {
            s.paginationContainer = $(s.params.pagination);
            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
                s.paginationContainer = s.container.find(s.params.pagination);
            }
        
            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
            }
            else {
                s.params.paginationClickable = false;
            }
            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
        }
        // Next/Prev Buttons
        if (s.params.nextButton || s.params.prevButton) {
            if (s.params.nextButton) {
                s.nextButton = $(s.params.nextButton);
                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
                    s.nextButton = s.container.find(s.params.nextButton);
                }
            }
            if (s.params.prevButton) {
                s.prevButton = $(s.params.prevButton);
                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
                    s.prevButton = s.container.find(s.params.prevButton);
                }
            }
        }
        
        // Is Horizontal
        s.isHorizontal = function () {
            return s.params.direction === 'horizontal';
        };
        // s.isH = isH;
        
        // RTL
        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
        if (s.rtl) {
            s.classNames.push(s.params.containerModifierClass + 'rtl');
        }
        
        // Wrong RTL support
        if (s.rtl) {
            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
        }
        
        // Columns
        if (s.params.slidesPerColumn > 1) {
            s.classNames.push(s.params.containerModifierClass + 'multirow');
        }
        
        // Check for Android
        if (s.device.android) {
            s.classNames.push(s.params.containerModifierClass + 'android');
        }
        
        // Add classes
        s.container.addClass(s.classNames.join(' '));
        
        // Translate
        s.translate = 0;
        
        // Progress
        s.progress = 0;
        
        // Velocity
        s.velocity = 0;
        
        /*=========================
          Locks, unlocks
          ===========================*/
        s.lockSwipeToNext = function () {
            s.params.allowSwipeToNext = false;
            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = false;
            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
            if (s.params.grabCursor) s.unsetGrabCursor();
        };
        s.unlockSwipeToNext = function () {
            s.params.allowSwipeToNext = true;
            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = true;
            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
            if (s.params.grabCursor) s.setGrabCursor();
        };
        
        /*=========================
          Round helper
          ===========================*/
        function round(a) {
            return Math.floor(a);
        }
        /*=========================
          Set grab cursor
          ===========================*/
        s.setGrabCursor = function(moving) {
            s.container[0].style.cursor = 'move';
            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
        };
        s.unsetGrabCursor = function () {
            s.container[0].style.cursor = '';
        };
        if (s.params.grabCursor) {
            s.setGrabCursor();
        }
        /*=========================
          Update on Images Ready
          ===========================*/
        s.imagesToLoad = [];
        s.imagesLoaded = 0;
        
        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
            var image;
            function onReady () {
                if (callback) callback();
            }
            if (!imgElement.complete || !checkForComplete) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;
                    if (sizes) {
                        image.sizes = sizes;
                    }
                    if (srcset) {
                        image.srcset = srcset;
                    }
                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
        
            } else {//image already loaded...
                onReady();
            }
        };
        s.preloadImages = function () {
            s.imagesToLoad = s.container.find('img');
            function _onReady() {
                if (typeof s === 'undefined' || s === null || !s) return;
                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
                if (s.imagesLoaded === s.imagesToLoad.length) {
                    if (s.params.updateOnImagesReady) s.update();
                    s.emit('onImagesReady', s);
                }
            }
            for (var i = 0; i < s.imagesToLoad.length; i++) {
                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
            }
        };
        
        /*=========================
          Autoplay
          ===========================*/
        s.autoplayTimeoutId = undefined;
        s.autoplaying = false;
        s.autoplayPaused = false;
        function autoplay() {
            var autoplayDelay = s.params.autoplay;
            var activeSlide = s.slides.eq(s.activeIndex);
            if (activeSlide.attr('data-swiper-autoplay')) {
                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
            }
            s.autoplayTimeoutId = setTimeout(function () {
                if (s.params.loop) {
                    s.fixLoop();
                    s._slideNext();
                    s.emit('onAutoplay', s);
                }
                else {
                    if (!s.isEnd) {
                        s._slideNext();
                        s.emit('onAutoplay', s);
                    }
                    else {
                        if (!params.autoplayStopOnLast) {
                            s._slideTo(0);
                            s.emit('onAutoplay', s);
                        }
                        else {
                            s.stopAutoplay();
                        }
                    }
                }
            }, autoplayDelay);
        }
        s.startAutoplay = function () {
            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
            if (!s.params.autoplay) return false;
            if (s.autoplaying) return false;
            s.autoplaying = true;
            s.emit('onAutoplayStart', s);
            autoplay();
        };
        s.stopAutoplay = function (internal) {
            if (!s.autoplayTimeoutId) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplaying = false;
            s.autoplayTimeoutId = undefined;
            s.emit('onAutoplayStop', s);
        };
        s.pauseAutoplay = function (speed) {
            if (s.autoplayPaused) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplayPaused = true;
            if (speed === 0) {
                s.autoplayPaused = false;
                autoplay();
            }
            else {
                s.wrapper.transitionEnd(function () {
                    if (!s) return;
                    s.autoplayPaused = false;
                    if (!s.autoplaying) {
                        s.stopAutoplay();
                    }
                    else {
                        autoplay();
                    }
                });
            }
        };
        /*=========================
          Min/Max Translate
          ===========================*/
        s.minTranslate = function () {
            return (-s.snapGrid[0]);
        };
        s.maxTranslate = function () {
            return (-s.snapGrid[s.snapGrid.length - 1]);
        };
        /*=========================
          Slider/slides sizes
          ===========================*/
        s.updateAutoHeight = function () {
            var activeSlides = [];
            var newHeight = 0;
            var i;
        
            // Find slides currently in view
            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
                    var index = s.activeIndex + i;
                    if(index > s.slides.length) break;
                    activeSlides.push(s.slides.eq(index)[0]);
                }
            } else {
                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
            }
        
            // Find new height from heighest slide in view
            for (i = 0; i < activeSlides.length; i++) {
                if (typeof activeSlides[i] !== 'undefined') {
                    var height = activeSlides[i].offsetHeight;
                    newHeight = height > newHeight ? height : newHeight;
                }
            }
        
            // Update Height
            if (newHeight) s.wrapper.css('height', newHeight + 'px');
        };
        s.updateContainerSize = function () {
            var width, height;
            if (typeof s.params.width !== 'undefined') {
                width = s.params.width;
            }
            else {
                width = s.container[0].clientWidth;
            }
            if (typeof s.params.height !== 'undefined') {
                height = s.params.height;
            }
            else {
                height = s.container[0].clientHeight;
            }
            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
                return;
            }
        
            //Subtract paddings
            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
        
            // Store values
            s.width = width;
            s.height = height;
            s.size = s.isHorizontal() ? s.width : s.height;
        };
        
        s.updateSlidesSize = function () {
            s.slides = s.wrapper.children('.' + s.params.slideClass);
            s.snapGrid = [];
            s.slidesGrid = [];
            s.slidesSizesGrid = [];
        
            var spaceBetween = s.params.spaceBetween,
                slidePosition = -s.params.slidesOffsetBefore,
                i,
                prevSlideSize = 0,
                index = 0;
            if (typeof s.size === 'undefined') return;
            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
            }
        
            s.virtualSize = -spaceBetween;
            // reset margins
            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
            else s.slides.css({marginRight: '', marginBottom: ''});
        
            var slidesNumberEvenToRows;
            if (s.params.slidesPerColumn > 1) {
                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
                    slidesNumberEvenToRows = s.slides.length;
                }
                else {
                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
                }
                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
                }
            }
        
            // Calc slides
            var slideSize;
            var slidesPerColumn = s.params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
            for (i = 0; i < s.slides.length; i++) {
                slideSize = 0;
                var slide = s.slides.eq(i);
                if (s.params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex;
                    var column, row;
                    if (s.params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;
                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
                            if (++row >= slidesPerColumn) {
                                row = 0;
                                column++;
                            }
                        }
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide
                            .css({
                                '-webkit-box-ordinal-group': newSlideOrderIndex,
                                '-moz-box-ordinal-group': newSlideOrderIndex,
                                '-ms-flex-order': newSlideOrderIndex,
                                '-webkit-order': newSlideOrderIndex,
                                'order': newSlideOrderIndex
                            });
                    }
                    else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }
                    slide
                        .css(
                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
                        )
                        .attr('data-swiper-column', column)
                        .attr('data-swiper-row', row);
        
                }
                if (slide.css('display') === 'none') continue;
                if (s.params.slidesPerView === 'auto') {
                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
                    if (s.params.roundLengths) slideSize = round(slideSize);
                }
                else {
                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
                    if (s.params.roundLengths) slideSize = round(slideSize);
        
                    if (s.isHorizontal()) {
                        s.slides[i].style.width = slideSize + 'px';
                    }
                    else {
                        s.slides[i].style.height = slideSize + 'px';
                    }
                }
                s.slides[i].swiperSlideSize = slideSize;
                s.slidesSizesGrid.push(slideSize);
        
        
                if (s.params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                }
                else {
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }
        
                s.virtualSize += slideSize + spaceBetween;
        
                prevSlideSize = slideSize;
        
                index ++;
            }
            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
            var newSlidesGrid;
        
            if (
                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
            }
            if (!s.support.flexbox || s.params.setWrapperSize) {
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
            }
        
            if (s.params.slidesPerColumn > 1) {
                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
                if (s.params.centeredSlides) {
                    newSlidesGrid = [];
                    for (i = 0; i < s.snapGrid.length; i++) {
                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
                    }
                    s.snapGrid = newSlidesGrid;
                }
            }
        
            // Remove last grid elements depending on width
            if (!s.params.centeredSlides) {
                newSlidesGrid = [];
                for (i = 0; i < s.snapGrid.length; i++) {
                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
                        newSlidesGrid.push(s.snapGrid[i]);
                    }
                }
                s.snapGrid = newSlidesGrid;
                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
                    s.snapGrid.push(s.virtualSize - s.size);
                }
            }
            if (s.snapGrid.length === 0) s.snapGrid = [0];
        
            if (s.params.spaceBetween !== 0) {
                if (s.isHorizontal()) {
                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
                    else s.slides.css({marginRight: spaceBetween + 'px'});
                }
                else s.slides.css({marginBottom: spaceBetween + 'px'});
            }
            if (s.params.watchSlidesProgress) {
                s.updateSlidesOffset();
            }
        };
        s.updateSlidesOffset = function () {
            for (var i = 0; i < s.slides.length; i++) {
                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
            }
        };
        
        /*=========================
          Dynamic Slides Per View
          ===========================*/
        s.currentSlidesPerView = function () {
            var spv = 1, i, j;
            if (s.params.centeredSlides) {
                var size = s.slides[s.activeIndex].swiperSlideSize;
                var breakLoop;
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slides[i] && !breakLoop) {
                        size += s.slides[i].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
                for (j = s.activeIndex - 1; j >= 0; j--) {
                    if (s.slides[j] && !breakLoop) {
                        size += s.slides[j].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
            }
            else {
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
                        spv++;
                    }
                }
            }
            return spv;
        };
        /*=========================
          Slider/slides progress
          ===========================*/
        s.updateSlidesProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            if (s.slides.length === 0) return;
            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
        
            var offsetCenter = -translate;
            if (s.rtl) offsetCenter = translate;
        
            // Visible Slides
            s.slides.removeClass(s.params.slideVisibleClass);
            for (var i = 0; i < s.slides.length; i++) {
                var slide = s.slides[i];
                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
                if (s.params.watchSlidesVisibility) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
                    var isVisible =
                        (slideBefore >= 0 && slideBefore < s.size) ||
                        (slideAfter > 0 && slideAfter <= s.size) ||
                        (slideBefore <= 0 && slideAfter >= s.size);
                    if (isVisible) {
                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
                    }
                }
                slide.progress = s.rtl ? -slideProgress : slideProgress;
            }
        };
        s.updateProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            var wasBeginning = s.isBeginning;
            var wasEnd = s.isEnd;
            if (translatesDiff === 0) {
                s.progress = 0;
                s.isBeginning = s.isEnd = true;
            }
            else {
                s.progress = (translate - s.minTranslate()) / (translatesDiff);
                s.isBeginning = s.progress <= 0;
                s.isEnd = s.progress >= 1;
            }
            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
        
            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
            s.emit('onProgress', s, s.progress);
        };
        s.updateActiveIndex = function () {
            var translate = s.rtl ? s.translate : -s.translate;
            var newActiveIndex, i, snapIndex;
            for (i = 0; i < s.slidesGrid.length; i ++) {
                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
                        newActiveIndex = i;
                    }
                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
                        newActiveIndex = i + 1;
                    }
                }
                else {
                    if (translate >= s.slidesGrid[i]) {
                        newActiveIndex = i;
                    }
                }
            }
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
            }
            // for (i = 0; i < s.slidesGrid.length; i++) {
                // if (- translate >= s.slidesGrid[i]) {
                    // newActiveIndex = i;
                // }
            // }
            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
        
            if (newActiveIndex === s.activeIndex) {
                return;
            }
            s.snapIndex = snapIndex;
            s.previousIndex = s.activeIndex;
            s.activeIndex = newActiveIndex;
            s.updateClasses();
            s.updateRealIndex();
        };
        s.updateRealIndex = function(){
            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
        };
        
        /*=========================
          Classes
          ===========================*/
        s.updateClasses = function () {
            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
            var activeSlide = s.slides.eq(s.activeIndex);
            // Active classes
            activeSlide.addClass(s.params.slideActiveClass);
            if (params.loop) {
                // Duplicate to all looped slides
                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
            }
            // Next Slide
            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
            if (s.params.loop && nextSlide.length === 0) {
                nextSlide = s.slides.eq(0);
                nextSlide.addClass(s.params.slideNextClass);
            }
            // Prev Slide
            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
            if (s.params.loop && prevSlide.length === 0) {
                prevSlide = s.slides.eq(-1);
                prevSlide.addClass(s.params.slidePrevClass);
            }
            if (params.loop) {
                // Duplicate to all looped slides
                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
            }
        
            // Pagination
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                // Current/Total
                var current,
                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                if (s.params.loop) {
                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
                        current = current - (s.slides.length - s.loopedSlides * 2);
                    }
                    if (current > total - 1) current = current - total;
                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
                }
                else {
                    if (typeof s.snapIndex !== 'undefined') {
                        current = s.snapIndex;
                    }
                    else {
                        current = s.activeIndex || 0;
                    }
                }
                // Types
                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
                    s.bullets.removeClass(s.params.bulletActiveClass);
                    if (s.paginationContainer.length > 1) {
                        s.bullets.each(function () {
                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
                        });
                    }
                    else {
                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
                }
                if (s.params.paginationType === 'progress') {
                    var scale = (current + 1) / total,
                        scaleX = scale,
                        scaleY = 1;
                    if (!s.isHorizontal()) {
                        scaleY = scale;
                        scaleX = 1;
                    }
                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
                }
                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        
            // Next/active buttons
            if (!s.params.loop) {
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    if (s.isBeginning) {
                        s.prevButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
                    }
                    else {
                        s.prevButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
                    }
                }
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    if (s.isEnd) {
                        s.nextButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
                    }
                    else {
                        s.nextButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
                    }
                }
            }
        };
        
        /*=========================
          Pagination
          ===========================*/
        s.updatePagination = function () {
            if (!s.params.pagination) return;
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                var paginationHTML = '';
                if (s.params.paginationType === 'bullets') {
                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                    for (var i = 0; i < numberOfBullets; i++) {
                        if (s.params.paginationBulletRender) {
                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
                        }
                        else {
                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
                        }
                    }
                    s.paginationContainer.html(paginationHTML);
                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
                        s.a11y.initPagination();
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    if (s.params.paginationFractionRender) {
                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
                    }
                    else {
                        paginationHTML =
                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + s.params.paginationTotalClass+'"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType === 'progress') {
                    if (s.params.paginationProgressRender) {
                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
                    }
                    else {
                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType !== 'custom') {
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        };
        /*=========================
          Common update method
          ===========================*/
        s.update = function (updateTranslate) {
            if (!s) return;
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updateProgress();
            s.updatePagination();
            s.updateClasses();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            function forceSetTranslate() {
                var translate = s.rtl ? -s.translate : s.translate;
                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            if (updateTranslate) {
                var translated, newTranslate;
                if (s.controller && s.controller.spline) {
                    s.controller.spline = undefined;
                }
                if (s.params.freeMode) {
                    forceSetTranslate();
                    if (s.params.autoHeight) {
                        s.updateAutoHeight();
                    }
                }
                else {
                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
                    }
                    else {
                        translated = s.slideTo(s.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        forceSetTranslate();
                    }
                }
            }
            else if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
        };
        
        /*=========================
          Resize Handler
          ===========================*/
        s.onResize = function (forceUpdatePagination) {
            //Breakpoints
            if (s.params.breakpoints) {
                s.setBreakpoint();
            }
        
            // Disable locks on resize
            var allowSwipeToPrev = s.params.allowSwipeToPrev;
            var allowSwipeToNext = s.params.allowSwipeToNext;
            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
        
            s.updateContainerSize();
            s.updateSlidesSize();
            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            if (s.controller && s.controller.spline) {
                s.controller.spline = undefined;
            }
            var slideChangedBySlideTo = false;
            if (s.params.freeMode) {
                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
        
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
            }
            else {
                s.updateClasses();
                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
                }
                else {
                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
                }
            }
            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
                s.lazy.load();
            }
            // Return locks after resize
            s.params.allowSwipeToPrev = allowSwipeToPrev;
            s.params.allowSwipeToNext = allowSwipeToNext;
        };
        
        /*=========================
          Events
          ===========================*/
        
        //Define Touch Events
        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
        s.touchEvents = {
            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
        };
        
        
        // WP8 Touch Events Fix
        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
        }
        
        // Attach/detach events
        s.initEvents = function (detach) {
            var actionDom = detach ? 'off' : 'on';
            var action = detach ? 'removeEventListener' : 'addEventListener';
            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
            var target = s.support.touch ? touchEventsTarget : document;
        
            var capture = s.params.nested ? true : false;
        
            //Touch Events
            if (s.browser.ie) {
                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                target[action](s.touchEvents.move, s.onTouchMove, capture);
                target[action](s.touchEvents.end, s.onTouchEnd, false);
            }
            else {
                if (s.support.touch) {
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);                    
                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, s.support.passiveListener ? { passive: false, capture: capture } : capture);
                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
                }
                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
                    document[action]('mousemove', s.onTouchMove, capture);
                    document[action]('mouseup', s.onTouchEnd, false);
                }
            }
            window[action]('resize', s.onResize);
        
            // Next, Prev, Index
            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                s.nextButton[actionDom]('click', s.onClickNext);
                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                s.prevButton[actionDom]('click', s.onClickPrev);
                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.pagination && s.params.paginationClickable) {
                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
            }
        
            // Prevent Links Clicks
            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
        };
        s.attachEvents = function () {
            s.initEvents();
        };
        s.detachEvents = function () {
            s.initEvents(true);
        };
        
        /*=========================
          Handle Clicks
          ===========================*/
        // Prevent Clicks
        s.allowClick = true;
        s.preventClicks = function (e) {
            if (!s.allowClick) {
                if (s.params.preventClicks) e.preventDefault();
                if (s.params.preventClicksPropagation && s.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        };
        // Clicks
        s.onClickNext = function (e) {
            e.preventDefault();
            if (s.isEnd && !s.params.loop) return;
            s.slideNext();
        };
        s.onClickPrev = function (e) {
            e.preventDefault();
            if (s.isBeginning && !s.params.loop) return;
            s.slidePrev();
        };
        s.onClickIndex = function (e) {
            e.preventDefault();
            var index = $(this).index() * s.params.slidesPerGroup;
            if (s.params.loop) index = index + s.loopedSlides;
            s.slideTo(index);
        };
        
        /*=========================
          Handle Touches
          ===========================*/
        function findElementInEvent(e, selector) {
            var el = $(e.target);
            if (!el.is(selector)) {
                if (typeof selector === 'string') {
                    el = el.parents(selector);
                }
                else if (selector.nodeType) {
                    var found;
                    el.parents().each(function (index, _el) {
                        if (_el === selector) found = selector;
                    });
                    if (!found) return undefined;
                    else return selector;
                }
            }
            if (el.length === 0) {
                return undefined;
            }
            return el[0];
        }
        s.updateClickedSlide = function (e) {
            var slide = findElementInEvent(e, '.' + s.params.slideClass);
            var slideFound = false;
            if (slide) {
                for (var i = 0; i < s.slides.length; i++) {
                    if (s.slides[i] === slide) slideFound = true;
                }
            }
        
            if (slide && slideFound) {
                s.clickedSlide = slide;
                s.clickedIndex = $(slide).index();
            }
            else {
                s.clickedSlide = undefined;
                s.clickedIndex = undefined;
                return;
            }
            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
                var slideToIndex = s.clickedIndex,
                    realIndex,
                    duplicatedSlides,
                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
                if (s.params.loop) {
                    if (s.animating) return;
                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
                    if (s.params.centeredSlides) {
                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                    else {
                        if (slideToIndex > s.slides.length - slidesPerView) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                }
                else {
                    s.slideTo(slideToIndex);
                }
            }
        };
        
        var isTouched,
            isMoved,
            allowTouchCallbacks,
            touchStartTime,
            isScrolling,
            currentTranslate,
            startTranslate,
            allowThresholdMove,
            // Form elements to match
            formElements = 'input, select, textarea, button, video',
            // Last click time
            lastClickTime = Date.now(), clickTimeout,
            //Velocities
            velocities = [],
            allowMomentumBounce;
        
        // Animating Flag
        s.animating = false;
        
        // Touches information
        s.touches = {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
        };
        
        // Touch handlers
        var isTouchEvent, startMoving;
        s.onTouchStart = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            isTouchEvent = e.type === 'touchstart';
            if (!isTouchEvent && 'which' in e && e.which === 3) return;
            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
                s.allowClick = true;
                return;
            }
            if (s.params.swipeHandler) {
                if (!findElementInEvent(e, s.params.swipeHandler)) return;
            }
        
            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        
            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
                return;
            }
        
            isTouched = true;
            isMoved = false;
            allowTouchCallbacks = true;
            isScrolling = undefined;
            startMoving = undefined;
            s.touches.startX = startX;
            s.touches.startY = startY;
            touchStartTime = Date.now();
            s.allowClick = true;
            s.updateContainerSize();
            s.swipeDirection = undefined;
            if (s.params.threshold > 0) allowThresholdMove = false;
            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($(e.target).is(formElements)) preventDefault = false;
                if (document.activeElement && $(document.activeElement).is(formElements)) {
                    document.activeElement.blur();
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            }
            s.emit('onTouchStart', s, e);
        };
        
        s.onTouchMove = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (isTouchEvent && e.type === 'mousemove') return;
            if (e.preventedByNestedSwiper) {
                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                return;
            }
            if (s.params.onlyExternal) {
                // isMoved = true;
                s.allowClick = false;
                if (isTouched) {
                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                    touchStartTime = Date.now();
                }
                return;
            }
            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
                if (!s.isHorizontal()) {
                    // Vertical
                    if (
                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
                else {
                    if (
                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
            }
            if (isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && $(e.target).is(formElements)) {
                    isMoved = true;
                    s.allowClick = false;
                    return;
                }
            }
            if (allowTouchCallbacks) {
                s.emit('onTouchMove', s, e);
            }
            if (e.targetTouches && e.targetTouches.length > 1) return;
        
            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
            if (typeof isScrolling === 'undefined') {
                var touchAngle;
                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
                    isScrolling = false;
                }
                else {
                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
                }
            }
            if (isScrolling) {
                s.emit('onTouchMoveOpposite', s, e);
            }
            if (typeof startMoving === 'undefined' && s.browser.ieTouch) {
                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
                    startMoving = true;
                }
            }
            if (!isTouched) return;
            if (isScrolling)  {
                isTouched = false;
                return;
            }
            if (!startMoving && s.browser.ieTouch) {
                return;
            }
            s.allowClick = false;
            s.emit('onSliderMove', s, e);
            e.preventDefault();
            if (s.params.touchMoveStopPropagation && !s.params.nested) {
                e.stopPropagation();
            }
        
            if (!isMoved) {
                if (params.loop) {
                    s.fixLoop();
                }
                startTranslate = s.getWrapperTranslate();
                s.setWrapperTransition(0);
                if (s.animating) {
                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
                }
                if (s.params.autoplay && s.autoplaying) {
                    if (s.params.autoplayDisableOnInteraction) {
                        s.stopAutoplay();
                    }
                    else {
                        s.pauseAutoplay();
                    }
                }
                allowMomentumBounce = false;
                //Grab Cursor
                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                    s.setGrabCursor(true);
                }
            }
            isMoved = true;
        
            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
        
            diff = diff * s.params.touchRatio;
            if (s.rtl) diff = -diff;
        
            s.swipeDirection = diff > 0 ? 'prev' : 'next';
            currentTranslate = diff + startTranslate;
        
            var disableParentSwiper = true;
            if ((diff > 0 && currentTranslate > s.minTranslate())) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
            }
            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
            }
        
            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
                currentTranslate = startTranslate;
            }
            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
                currentTranslate = startTranslate;
            }
        
        
            // Threshold
            if (s.params.threshold > 0) {
                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
                    if (!allowThresholdMove) {
                        allowThresholdMove = true;
                        s.touches.startX = s.touches.currentX;
                        s.touches.startY = s.touches.currentY;
                        currentTranslate = startTranslate;
                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                        return;
                    }
                }
                else {
                    currentTranslate = startTranslate;
                    return;
                }
            }
        
            if (!s.params.followFinger) return;
        
            // Update active index in free mode
            if (s.params.freeMode || s.params.watchSlidesProgress) {
                s.updateActiveIndex();
            }
            if (s.params.freeMode) {
                //Velocity
                if (velocities.length === 0) {
                    velocities.push({
                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
                        time: touchStartTime
                    });
                }
                velocities.push({
                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
                    time: (new window.Date()).getTime()
                });
            }
            // Update progress
            s.updateProgress(currentTranslate);
            // Update translate
            s.setWrapperTranslate(currentTranslate);
        };
        s.onTouchEnd = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (allowTouchCallbacks) {
                s.emit('onTouchEnd', s, e);
            }
            allowTouchCallbacks = false;
            if (!isTouched) return;
            //Return Grab Cursor
            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                s.setGrabCursor(false);
            }
        
            // Time diff
            var touchEndTime = Date.now();
            var timeDiff = touchEndTime - touchStartTime;
        
            // Tap, doubleTap, Click
            if (s.allowClick) {
                s.updateClickedSlide(e);
                s.emit('onTap', s, e);
                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    clickTimeout = setTimeout(function () {
                        if (!s) return;
                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
                        }
                        s.emit('onClick', s, e);
                    }, 300);
        
                }
                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    s.emit('onDoubleTap', s, e);
                }
            }
        
            lastClickTime = Date.now();
            setTimeout(function () {
                if (s) s.allowClick = true;
            }, 0);
        
            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
                isTouched = isMoved = false;
                return;
            }
            isTouched = isMoved = false;
        
            var currentPos;
            if (s.params.followFinger) {
                currentPos = s.rtl ? s.translate : -s.translate;
            }
            else {
                currentPos = -currentTranslate;
            }
            if (s.params.freeMode) {
                if (currentPos < -s.minTranslate()) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                else if (currentPos > -s.maxTranslate()) {
                    if (s.slides.length < s.snapGrid.length) {
                        s.slideTo(s.snapGrid.length - 1);
                    }
                    else {
                        s.slideTo(s.slides.length - 1);
                    }
                    return;
                }
        
                if (s.params.freeModeMomentum) {
                    if (velocities.length > 1) {
                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
        
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        s.velocity = distance / time;
                        s.velocity = s.velocity / 2;
                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
                            s.velocity = 0;
                        }
                        // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.
                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
                            s.velocity = 0;
                        }
                    } else {
                        s.velocity = 0;
                    }
                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
        
                    velocities.length = 0;
                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
                    var momentumDistance = s.velocity * momentumDuration;
        
                    var newPosition = s.translate + momentumDistance;
                    if (s.rtl) newPosition = - newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
                    if (newPosition < s.maxTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition + s.maxTranslate() < -bounceAmount) {
                                newPosition = s.maxTranslate() - bounceAmount;
                            }
                            afterBouncePosition = s.maxTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.maxTranslate();
                        }
                    }
                    else if (newPosition > s.minTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition - s.minTranslate() > bounceAmount) {
                                newPosition = s.minTranslate() + bounceAmount;
                            }
                            afterBouncePosition = s.minTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.minTranslate();
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        var j = 0,
                            nextSlide;
                        for (j = 0; j < s.snapGrid.length; j += 1) {
                            if (s.snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
        
                        }
                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                            newPosition = s.snapGrid[nextSlide];
                        } else {
                            newPosition = s.snapGrid[nextSlide - 1];
                        }
                        if (!s.rtl) newPosition = - newPosition;
                    }
                    //Fix duration
                    if (s.velocity !== 0) {
                        if (s.rtl) {
                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
                        }
                        else {
                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        s.slideReset();
                        return;
                    }
        
                    if (s.params.freeModeMomentumBounce && doBounce) {
                        s.updateProgress(afterBouncePosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        s.animating = true;
                        s.wrapper.transitionEnd(function () {
                            if (!s || !allowMomentumBounce) return;
                            s.emit('onMomentumBounce', s);
        
                            s.setWrapperTransition(s.params.speed);
                            s.setWrapperTranslate(afterBouncePosition);
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        });
                    } else if (s.velocity) {
                        s.updateProgress(newPosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        if (!s.animating) {
                            s.animating = true;
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        }
        
                    } else {
                        s.updateProgress(newPosition);
                    }
        
                    s.updateActiveIndex();
                }
                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
                    s.updateProgress();
                    s.updateActiveIndex();
                }
                return;
            }
        
            // Find current slide
            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
                    }
                }
                else {
                    if (currentPos >= s.slidesGrid[i]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
                    }
                }
            }
        
            // Find current slide size
            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
        
            if (timeDiff > s.params.longSwipesMs) {
                // Long touches
                if (!s.params.longSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
        
                }
                if (s.swipeDirection === 'prev') {
                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
                }
            }
            else {
                // Short swipes
                if (!s.params.shortSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    s.slideTo(stopIndex + s.params.slidesPerGroup);
        
                }
                if (s.swipeDirection === 'prev') {
                    s.slideTo(stopIndex);
                }
            }
        };
        /*=========================
          Transitions
          ===========================*/
        s._slideTo = function (slideIndex, speed) {
            return s.slideTo(slideIndex, speed, true, true);
        };
        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (typeof slideIndex === 'undefined') slideIndex = 0;
            if (slideIndex < 0) slideIndex = 0;
            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
        
            var translate = - s.snapGrid[s.snapIndex];
            // Stop autoplay
            if (s.params.autoplay && s.autoplaying) {
                if (internal || !s.params.autoplayDisableOnInteraction) {
                    s.pauseAutoplay(speed);
                }
                else {
                    s.stopAutoplay();
                }
            }
            // Update progress
            s.updateProgress(translate);
        
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                for (var i = 0; i < s.slidesGrid.length; i++) {
                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
                        slideIndex = i;
                    }
                }
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
                if ((s.activeIndex || 0) !== slideIndex ) return false;
            }
        
            // Update Index
            if (typeof speed === 'undefined') speed = s.params.speed;
            s.previousIndex = s.activeIndex || 0;
            s.activeIndex = slideIndex;
            s.updateRealIndex();
            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
                // Update Height
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
                s.updateClasses();
                if (s.params.effect !== 'slide') {
                    s.setWrapperTranslate(translate);
                }
                return false;
            }
            s.updateClasses();
            s.onTransitionStart(runCallbacks);
        
            if (speed === 0 || s.browser.lteIE9) {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(0);
                s.onTransitionEnd(runCallbacks);
            }
            else {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(speed);
                if (!s.animating) {
                    s.animating = true;
                    s.wrapper.transitionEnd(function () {
                        if (!s) return;
                        s.onTransitionEnd(runCallbacks);
                    });
                }
        
            }
        
            return true;
        };
        
        s.onTransitionStart = function (runCallbacks) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
            if (s.lazy) s.lazy.onTransitionStart();
            if (runCallbacks) {
                s.emit('onTransitionStart', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeStart', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextStart', s);
                    }
                    else {
                        s.emit('onSlidePrevStart', s);
                    }
                }
        
            }
        };
        s.onTransitionEnd = function (runCallbacks) {
            s.animating = false;
            s.setWrapperTransition(0);
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionEnd();
            if (runCallbacks) {
                s.emit('onTransitionEnd', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeEnd', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextEnd', s);
                    }
                    else {
                        s.emit('onSlidePrevEnd', s);
                    }
                }
            }
            if (s.params.history && s.history) {
                s.history.setHistory(s.params.history, s.activeIndex);
            }
            if (s.params.hashnav && s.hashnav) {
                s.hashnav.setHash();
            }
        
        };
        s.slideNext = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
        };
        s._slideNext = function (speed) {
            return s.slideNext(true, speed, true);
        };
        s.slidePrev = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
        };
        s._slidePrev = function (speed) {
            return s.slidePrev(true, speed, true);
        };
        s.slideReset = function (runCallbacks, speed, internal) {
            return s.slideTo(s.activeIndex, speed, runCallbacks);
        };
        
        s.disableTouchControl = function () {
            s.params.onlyExternal = true;
            return true;
        };
        s.enableTouchControl = function () {
            s.params.onlyExternal = false;
            return true;
        };
        
        /*=========================
          Translate/transition helpers
          ===========================*/
        s.setWrapperTransition = function (duration, byController) {
            s.wrapper.transition(duration);
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTransition(duration);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTransition(duration);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTransition(duration);
            }
            if (s.params.control && s.controller) {
                s.controller.setTransition(duration, byController);
            }
            s.emit('onSetTransition', s, duration);
        };
        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
            var x = 0, y = 0, z = 0;
            if (s.isHorizontal()) {
                x = s.rtl ? -translate : translate;
            }
            else {
                y = translate;
            }
        
            if (s.params.roundLengths) {
                x = round(x);
                y = round(y);
            }
        
            if (!s.params.virtualTranslate) {
                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
            }
        
            s.translate = s.isHorizontal() ? x : y;
        
            // Check if we need to update progress
            var progress;
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            if (translatesDiff === 0) {
                progress = 0;
            }
            else {
                progress = (translate - s.minTranslate()) / (translatesDiff);
            }
            if (progress !== s.progress) {
                s.updateProgress(translate);
            }
        
            if (updateActiveIndex) s.updateActiveIndex();
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTranslate(s.translate);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTranslate(s.translate);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTranslate(s.translate);
            }
            if (s.params.control && s.controller) {
                s.controller.setTranslate(s.translate, byController);
            }
            s.emit('onSetTranslate', s, s.translate);
        };
        
        s.getTranslate = function (el, axis) {
            var matrix, curTransform, curStyle, transformMatrix;
        
            // automatic axis detection
            if (typeof axis === 'undefined') {
                axis = 'x';
            }
        
            if (s.params.virtualTranslate) {
                return s.rtl ? -s.translate : s.translate;
            }
        
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;
                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function(a){
                        return a.replace(',','.');
                    }).join(', ');
                }
                // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case
                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            }
            else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }
        
            if (axis === 'x') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m41;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[12]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[4]);
            }
            if (axis === 'y') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m42;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[13]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[5]);
            }
            if (s.rtl && curTransform) curTransform = -curTransform;
            return curTransform || 0;
        };
        s.getWrapperTranslate = function (axis) {
            if (typeof axis === 'undefined') {
                axis = s.isHorizontal() ? 'x' : 'y';
            }
            return s.getTranslate(s.wrapper[0], axis);
        };
        
        /*=========================
          Observer
          ===========================*/
        s.observers = [];
        function initObserver(target, options) {
            options = options || {};
            // create an observer instance
            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
            var observer = new ObserverFunc(function (mutations) {
                mutations.forEach(function (mutation) {
                    s.onResize(true);
                    s.emit('onObserverUpdate', s, mutation);
                });
            });
        
            observer.observe(target, {
                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                childList: typeof options.childList === 'undefined' ? true : options.childList,
                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
            });
        
            s.observers.push(observer);
        }
        s.initObservers = function () {
            if (s.params.observeParents) {
                var containerParents = s.container.parents();
                for (var i = 0; i < containerParents.length; i++) {
                    initObserver(containerParents[i]);
                }
            }
        
            // Observe container
            initObserver(s.container[0], {childList: false});
        
            // Observe wrapper
            initObserver(s.wrapper[0], {attributes: false});
        };
        s.disconnectObservers = function () {
            for (var i = 0; i < s.observers.length; i++) {
                s.observers[i].disconnect();
            }
            s.observers = [];
        };
        /*=========================
          Loop
          ===========================*/
        // Create looped slides
        s.createLoop = function () {
            // Remove duplicated slides
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
        
            var slides = s.wrapper.children('.' + s.params.slideClass);
        
            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
        
            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
            if (s.loopedSlides > slides.length) {
                s.loopedSlides = slides.length;
            }
        
            var prependSlides = [], appendSlides = [], i;
            slides.each(function (index, el) {
                var slide = $(this);
                if (index < s.loopedSlides) appendSlides.push(el);
                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
                slide.attr('data-swiper-slide-index', index);
            });
            for (i = 0; i < appendSlides.length; i++) {
                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
            for (i = prependSlides.length - 1; i >= 0; i--) {
                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
        };
        s.destroyLoop = function () {
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
            s.slides.removeAttr('data-swiper-slide-index');
        };
        s.reLoop = function (updatePosition) {
            var oldIndex = s.activeIndex - s.loopedSlides;
            s.destroyLoop();
            s.createLoop();
            s.updateSlidesSize();
            if (updatePosition) {
                s.slideTo(oldIndex + s.loopedSlides, 0, false);
            }
        
        };
        s.fixLoop = function () {
            var newIndex;
            //Fix For Negative Oversliding
            if (s.activeIndex < s.loopedSlides) {
                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
            //Fix For Positive Oversliding
            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
        };
        /*=========================
          Append/Prepend/Remove Slides
          ===========================*/
        s.appendSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.append(slides[i]);
                }
            }
            else {
                s.wrapper.append(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
        };
        s.prependSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            var newActiveIndex = s.activeIndex + 1;
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.prepend(slides[i]);
                }
                newActiveIndex = s.activeIndex + slides.length;
            }
            else {
                s.wrapper.prepend(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            s.slideTo(newActiveIndex, 0, false);
        };
        s.removeSlide = function (slidesIndexes) {
            if (s.params.loop) {
                s.destroyLoop();
                s.slides = s.wrapper.children('.' + s.params.slideClass);
            }
            var newActiveIndex = s.activeIndex,
                indexToRemove;
            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
                for (var i = 0; i < slidesIndexes.length; i++) {
                    indexToRemove = slidesIndexes[i];
                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex--;
                }
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
            else {
                indexToRemove = slidesIndexes;
                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex--;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
        
            if (s.params.loop) {
                s.createLoop();
            }
        
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            if (s.params.loop) {
                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
            }
            else {
                s.slideTo(newActiveIndex, 0, false);
            }
        
        };
        s.removeAllSlides = function () {
            var slidesIndexes = [];
            for (var i = 0; i < s.slides.length; i++) {
                slidesIndexes.push(i);
            }
            s.removeSlide(slidesIndexes);
        };
        

        /*=========================
          Effects
          ===========================*/
        s.effects = {
            fade: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var offset = slide[0].swiperSlideOffset;
                        var tx = -offset;
                        if (!s.params.virtualTranslate) tx = tx - s.translate;
                        var ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
                        var slideOpacity = s.params.fade.crossFade ?
                                Math.max(1 - Math.abs(slide[0].progress), 0) :
                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
                        slide
                            .css({
                                opacity: slideOpacity
                            })
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
        
                    }
        
                },
                setTransition: function (duration) {
                    s.slides.transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            flip: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var progress = slide[0].progress;
                        if (s.params.flip.limitRotation) {
                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        }
                        var offset = slide[0].swiperSlideOffset;
                        var rotate = -180 * progress,
                            rotateY = rotate,
                            rotateX = 0,
                            tx = -offset,
                            ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                            rotateX = -rotateY;
                            rotateY = 0;
                        }
                        else if (s.rtl) {
                            rotateY = -rotateY;
                        }
        
                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
        
                        if (s.params.flip.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
        
                        slide
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.eq(s.activeIndex).transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            cube: {
                setTranslate: function () {
                    var wrapperRotate = 0, cubeShadow;
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.wrapper.append(cubeShadow);
                            }
                            cubeShadow.css({height: s.width + 'px'});
                        }
                        else {
                            cubeShadow = s.container.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.container.append(cubeShadow);
                            }
                        }
                    }
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var slideAngle = i * 90;
                        var round = Math.floor(slideAngle / 360);
                        if (s.rtl) {
                            slideAngle = -slideAngle;
                            round = Math.floor(-slideAngle / 360);
                        }
                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        var tx = 0, ty = 0, tz = 0;
                        if (i % 4 === 0) {
                            tx = - round * 4 * s.size;
                            tz = 0;
                        }
                        else if ((i - 1) % 4 === 0) {
                            tx = 0;
                            tz = - round * 4 * s.size;
                        }
                        else if ((i - 2) % 4 === 0) {
                            tx = s.size + round * 4 * s.size;
                            tz = s.size;
                        }
                        else if ((i - 3) % 4 === 0) {
                            tx = - s.size;
                            tz = 3 * s.size + s.size * 4 * round;
                        }
                        if (s.rtl) {
                            tx = -tx;
                        }
        
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
        
                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                        if (progress <= 1 && progress > -1) {
                            wrapperRotate = i * 90 + progress * 90;
                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
                        }
                        slide.transform(transform);
                        if (s.params.cube.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
                    }
                    s.wrapper.css({
                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
                    });
        
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
                        }
                        else {
                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                            var scale1 = s.params.cube.shadowScale,
                                scale2 = s.params.cube.shadowScale / multiplier,
                                offset = s.params.cube.shadowOffset;
                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
                        }
                    }
                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.cube.shadow && !s.isHorizontal()) {
                        s.container.find('.swiper-cube-shadow').transition(duration);
                    }
                }
            },
            coverflow: {
                setTranslate: function () {
                    var transform = s.translate;
                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
                    var translate = s.params.coverflow.depth;
                    //Each slide offset from center
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideSize = s.slidesSizesGrid[i];
                        var slideOffset = slide[0].swiperSlideOffset;
                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
        
                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
                        // var rotateZ = 0
                        var translateZ = -translate * Math.abs(offsetMultiplier);
        
                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
        
                        //Fix for ultra small values
                        if (Math.abs(translateX) < 0.001) translateX = 0;
                        if (Math.abs(translateY) < 0.001) translateY = 0;
                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        
                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        
                        slide.transform(slideTransform);
                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                        if (s.params.coverflow.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
                        }
                    }
        
                    //Set correct perspective for IE10
                    if (s.browser.ie) {
                        var ws = s.wrapper[0].style;
                        ws.perspectiveOrigin = center + 'px 50%';
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                }
            }
        };

        /*=========================
          Images Lazy Loading
          ===========================*/
        s.lazy = {
            initialImageLoaded: false,
            loadImageInSlide: function (index, loadInDuplicate) {
                if (typeof index === 'undefined') return;
                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
                if (s.slides.length === 0) return;
        
                var slide = s.slides.eq(index);
                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
                    img = img.add(slide[0]);
                }
                if (img.length === 0) return;
        
                img.each(function () {
                    var _img = $(this);
                    _img.addClass(s.params.lazyStatusLoadingClass);
                    var background = _img.attr('data-background');
                    var src = _img.attr('data-src'),
                        srcset = _img.attr('data-srcset'),
                        sizes = _img.attr('data-sizes');
                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
                        if (background) {
                            _img.css('background-image', 'url("' + background + '")');
                            _img.removeAttr('data-background');
                        }
                        else {
                            if (srcset) {
                                _img.attr('srcset', srcset);
                                _img.removeAttr('data-srcset');
                            }
                            if (sizes) {
                                _img.attr('sizes', sizes);
                                _img.removeAttr('data-sizes');
                            }
                            if (src) {
                                _img.attr('src', src);
                                _img.removeAttr('data-src');
                            }
        
                        }
        
                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
                        if (s.params.loop && loadInDuplicate) {
                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
                            if (slide.hasClass(s.params.slideDuplicateClass)) {
                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                                s.lazy.loadImageInSlide(originalSlide.index(), false);
                            }
                            else {
                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
                            }
                        }
                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
                    });
        
                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
                });
        
            },
            load: function () {
                var i;
                var slidesPerView = s.params.slidesPerView;
                if (slidesPerView === 'auto') {
                    slidesPerView = 0;
                }
                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
                if (s.params.watchSlidesVisibility) {
                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
                        s.lazy.loadImageInSlide($(this).index());
                    });
                }
                else {
                    if (slidesPerView > 1) {
                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        s.lazy.loadImageInSlide(s.activeIndex);
                    }
                }
                if (s.params.lazyLoadingInPrevNext) {
                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
                        var amount = s.params.lazyLoadingInPrevNextAmount;
                        var spv = slidesPerView;
                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
                        // Next Slides
                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                        // Prev Slides
                        for (i = minIndex; i < s.activeIndex ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
        
                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
                    }
                }
            },
            onTransitionStart: function () {
                if (s.params.lazyLoading) {
                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
                        s.lazy.load();
                    }
                }
            },
            onTransitionEnd: function () {
                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
                    s.lazy.load();
                }
            }
        };
        

        /*=========================
          Scrollbar
          ===========================*/
        s.scrollbar = {
            isTouched: false,
            setDragPosition: function (e) {
                var sb = s.scrollbar;
                var x = 0, y = 0;
                var translate;
                var pointerPosition = s.isHorizontal() ?
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
                var positionMin = -s.minTranslate() * sb.moveDivider;
                var positionMax = -s.maxTranslate() * sb.moveDivider;
                if (position < positionMin) {
                    position = positionMin;
                }
                else if (position > positionMax) {
                    position = positionMax;
                }
                position = -position / sb.moveDivider;
                s.updateProgress(position);
                s.setWrapperTranslate(position, true);
            },
            dragStart: function (e) {
                var sb = s.scrollbar;
                sb.isTouched = true;
                e.preventDefault();
                e.stopPropagation();
        
                sb.setDragPosition(e);
                clearTimeout(sb.dragTimeout);
        
                sb.track.transition(0);
                if (s.params.scrollbarHide) {
                    sb.track.css('opacity', 1);
                }
                s.wrapper.transition(100);
                sb.drag.transition(100);
                s.emit('onScrollbarDragStart', s);
            },
            dragMove: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                sb.setDragPosition(e);
                s.wrapper.transition(0);
                sb.track.transition(0);
                sb.drag.transition(0);
                s.emit('onScrollbarDragMove', s);
            },
            dragEnd: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                sb.isTouched = false;
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.dragTimeout);
                    sb.dragTimeout = setTimeout(function () {
                        sb.track.css('opacity', 0);
                        sb.track.transition(400);
                    }, 1000);
        
                }
                s.emit('onScrollbarDragEnd', s);
                if (s.params.scrollbarSnapOnRelease) {
                    s.slideReset();
                }
            },
            draggableEvents: (function () {
                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
                else return s.touchEvents;
            })(),
            enableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
                $(target).on(sb.draggableEvents.move, sb.dragMove);
                $(target).on(sb.draggableEvents.end, sb.dragEnd);
            },
            disableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
                $(target).off(sb.draggableEvents.move, sb.dragMove);
                $(target).off(sb.draggableEvents.end, sb.dragEnd);
            },
            set: function () {
                if (!s.params.scrollbar) return;
                var sb = s.scrollbar;
                sb.track = $(s.params.scrollbar);
                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
                    sb.track = s.container.find(s.params.scrollbar);
                }
                sb.drag = sb.track.find('.swiper-scrollbar-drag');
                if (sb.drag.length === 0) {
                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
                    sb.track.append(sb.drag);
                }
                sb.drag[0].style.width = '';
                sb.drag[0].style.height = '';
                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        
                sb.divider = s.size / s.virtualSize;
                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
                sb.dragSize = sb.trackSize * sb.divider;
        
                if (s.isHorizontal()) {
                    sb.drag[0].style.width = sb.dragSize + 'px';
                }
                else {
                    sb.drag[0].style.height = sb.dragSize + 'px';
                }
        
                if (sb.divider >= 1) {
                    sb.track[0].style.display = 'none';
                }
                else {
                    sb.track[0].style.display = '';
                }
                if (s.params.scrollbarHide) {
                    sb.track[0].style.opacity = 0;
                }
            },
            setTranslate: function () {
                if (!s.params.scrollbar) return;
                var diff;
                var sb = s.scrollbar;
                var translate = s.translate || 0;
                var newPos;
        
                var newSize = sb.dragSize;
                newPos = (sb.trackSize - sb.dragSize) * s.progress;
                if (s.rtl && s.isHorizontal()) {
                    newPos = -newPos;
                    if (newPos > 0) {
                        newSize = sb.dragSize - newPos;
                        newPos = 0;
                    }
                    else if (-newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize + newPos;
                    }
                }
                else {
                    if (newPos < 0) {
                        newSize = sb.dragSize + newPos;
                        newPos = 0;
                    }
                    else if (newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize - newPos;
                    }
                }
                if (s.isHorizontal()) {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
                    }
                    else {
                        sb.drag.transform('translateX(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.width = newSize + 'px';
                }
                else {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
                    }
                    else {
                        sb.drag.transform('translateY(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.height = newSize + 'px';
                }
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.timeout);
                    sb.track[0].style.opacity = 1;
                    sb.timeout = setTimeout(function () {
                        sb.track[0].style.opacity = 0;
                        sb.track.transition(400);
                    }, 1000);
                }
            },
            setTransition: function (duration) {
                if (!s.params.scrollbar) return;
                s.scrollbar.drag.transition(duration);
            }
        };

        /*=========================
          Controller
          ===========================*/
        s.controller = {
            LinearSpline: function (x, y) {
                this.x = x;
                this.y = y;
                this.lastIndex = x.length - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                var i1, i3;
                var l = this.x.length;
        
                this.interpolate = function (x2) {
                    if (!x2) return 0;
        
                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
                    i3 = binarySearch(this.x, x2);
                    i1 = i3 - 1;
        
                    // We have our indexes i1 & i3, so we can calculate already:
                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
                };
        
                var binarySearch = (function() {
                    var maxIndex, minIndex, guess;
                    return function(array, val) {
                        minIndex = -1;
                        maxIndex = array.length;
                        while (maxIndex - minIndex > 1)
                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
                                minIndex = guess;
                            } else {
                                maxIndex = guess;
                            }
                        return maxIndex;
                    };
                })();
            },
            //xxx: for now i will just save one spline function to to
            getInterpolateFunction: function(c){
                if(!s.controller.spline) s.controller.spline = s.params.loop ?
                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
            },
            setTranslate: function (translate, byController) {
               var controlled = s.params.control;
               var multiplier, controlledTranslate;
               function setControlledTranslate(c) {
                    // this will create an Interpolate function based on the snapGrids
                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
                    // it makes sense to create this only once and recall it for the interpolation
                    // the function does a lot of value caching for performance
                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
                    if (s.params.controlBy === 'slide') {
                        s.controller.getInterpolateFunction(c);
                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                        // but it did not work out
                        controlledTranslate = -s.controller.spline.interpolate(-translate);
                    }
        
                    if(!controlledTranslate || s.params.controlBy === 'container'){
                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
                    }
        
                    if (s.params.controlInverse) {
                        controlledTranslate = c.maxTranslate() - controlledTranslate;
                    }
                    c.updateProgress(controlledTranslate);
                    c.setWrapperTranslate(controlledTranslate, false, s);
                    c.updateActiveIndex();
               }
               if (s.isArray(controlled)) {
                   for (var i = 0; i < controlled.length; i++) {
                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                           setControlledTranslate(controlled[i]);
                       }
                   }
               }
               else if (controlled instanceof Swiper && byController !== controlled) {
        
                   setControlledTranslate(controlled);
               }
            },
            setTransition: function (duration, byController) {
                var controlled = s.params.control;
                var i;
                function setControlledTransition(c) {
                    c.setWrapperTransition(duration, s);
                    if (duration !== 0) {
                        c.onTransitionStart();
                        c.wrapper.transitionEnd(function(){
                            if (!controlled) return;
                            if (c.params.loop && s.params.controlBy === 'slide') {
                                c.fixLoop();
                            }
                            c.onTransitionEnd();
        
                        });
                    }
                }
                if (s.isArray(controlled)) {
                    for (i = 0; i < controlled.length; i++) {
                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                            setControlledTransition(controlled[i]);
                        }
                    }
                }
                else if (controlled instanceof Swiper && byController !== controlled) {
                    setControlledTransition(controlled);
                }
            }
        };

        /*=========================
          Hash Navigation
          ===========================*/
        s.hashnav = {
            onHashCange: function (e, a) {
                var newHash = document.location.hash.replace('#', '');
                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
                if (newHash !== activeSlideHash) {
                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
                }
            },
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
                $(window)[action]('hashchange', s.hashnav.onHashCange);
            },
            setHash: function () {
                if (!s.hashnav.initialized || !s.params.hashnav) return;
                if (s.params.replaceState && window.history && window.history.replaceState) {
                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
                } else {
                    var slide = s.slides.eq(s.activeIndex);
                    var hash = slide.attr('data-hash') || slide.attr('data-history');
                    document.location.hash = hash || '';
                }
            },
            init: function () {
                if (!s.params.hashnav || s.params.history) return;
                s.hashnav.initialized = true;
                var hash = document.location.hash.replace('#', '');
                if (hash) {
                    var speed = 0;
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
                        }
                    }
                }
                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
            },
            destroy: function () {
                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
            }
        };

        /*=========================
          History Api with fallback to Hashnav
          ===========================*/
        s.history = {
            init: function () {
                if (!s.params.history) return;
                if (!window.history || !window.history.pushState) {
                    s.params.history = false;
                    s.params.hashnav = true;
                    return;
                }
                s.history.initialized = true;
                this.paths = this.getPathValues();
                if (!this.paths.key && !this.paths.value) return;
                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
                if (!s.params.replaceState) {
                    window.addEventListener('popstate', this.setHistoryPopState);
                }
            },
            setHistoryPopState: function() {
                s.history.paths = s.history.getPathValues();
                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
            },
            getPathValues: function() {
                var pathArray = window.location.pathname.slice(1).split('/');
                var total = pathArray.length;
                var key = pathArray[total - 2];
                var value = pathArray[total - 1];
                return { key: key, value: value };
            },
            setHistory: function (key, index) {
                if (!s.history.initialized || !s.params.history) return;
                var slide = s.slides.eq(index);
                var value = this.slugify(slide.attr('data-history'));
                if (!window.location.pathname.includes(key)) {
                    value = key + '/' + value;
                }
                if (s.params.replaceState) {
                    window.history.replaceState(null, null, value);
                } else {
                    window.history.pushState(null, null, value);
                }
            },
            slugify: function(text) {
                return text.toString().toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\w\-]+/g, '')
                    .replace(/\-\-+/g, '-')
                    .replace(/^-+/, '')
                    .replace(/-+$/, '');
            },
            scrollToSlide: function(speed, value, runCallbacks) {
                if (value) {
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHistory = this.slugify(slide.attr('data-history'));
                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, runCallbacks);
                        }
                    }
                } else {
                    s.slideTo(0, speed, runCallbacks);
                }
            }
        };

        /*=========================
          Keyboard Control
          ===========================*/
        function handleKeyboard(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var kc = e.keyCode || e.charCode;
            // Directions locks
            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
                return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
                return;
            }
            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
                var inView = false;
                //Check that swiper should be inside of visible area of window
                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
                    return;
                }
                var windowScroll = {
                    left: window.pageXOffset,
                    top: window.pageYOffset
                };
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var swiperOffset = s.container.offset();
                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + s.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + s.height],
                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (
                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
                    ) {
                        inView = true;
                    }
        
                }
                if (!inView) return;
            }
            if (s.isHorizontal()) {
                if (kc === 37 || kc === 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
            }
            else {
                if (kc === 38 || kc === 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc === 40) s.slideNext();
                if (kc === 38) s.slidePrev();
            }
        }
        s.disableKeyboardControl = function () {
            s.params.keyboardControl = false;
            $(document).off('keydown', handleKeyboard);
        };
        s.enableKeyboardControl = function () {
            s.params.keyboardControl = true;
            $(document).on('keydown', handleKeyboard);
        };
        

        /*=========================
          Mousewheel Control
          ===========================*/
        s.mousewheel = {
            event: false,
            lastScrollTime: (new window.Date()).getTime()
        };
        if (s.params.mousewheelControl) {
            /**
             * The best combination if you prefer spinX + spinY normalization.  It favors
             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
             * 'wheel' event, making spin speed determination impossible.
             */
            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
                'DOMMouseScroll' :
                isEventSupported() ?
                    'wheel' : 'mousewheel';
        }
        
        function isEventSupported() {
            var eventName = 'onwheel';
            var isSupported = eventName in document;
        
            if (!isSupported) {
                var element = document.createElement('div');
                element.setAttribute(eventName, 'return;');
                isSupported = typeof element[eventName] === 'function';
            }
        
            if (!isSupported &&
                document.implementation &&
                document.implementation.hasFeature &&
                    // always returns true in newer browsers as per the standard.
                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                document.implementation.hasFeature('', '') !== true ) {
                // This is the only way to test support for the `wheel` event in IE9+.
                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
            }
        
            return isSupported;
        }
        
        function handleMousewheel(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var delta = 0;
            var rtlFactor = s.rtl ? -1 : 1;
        
            var data = normalizeWheel( e );
        
            if (s.params.mousewheelForceToAxis) {
                if (s.isHorizontal()) {
                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
                    else return;
                }
                else {
                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
                    else return;
                }
            }
            else {
                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
            }
        
            if (delta === 0) return;
        
            if (s.params.mousewheelInvert) delta = -delta;
        
            if (!s.params.freeMode) {
                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
                    if (delta < 0) {
                        if ((!s.isEnd || s.params.loop) && !s.animating) {
                            s.slideNext();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                    else {
                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
                            s.slidePrev();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                }
                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
        
            }
            else {
                //Freemode or scrollContainer:
                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
                var wasBeginning = s.isBeginning,
                    wasEnd = s.isEnd;
        
                if (position >= s.minTranslate()) position = s.minTranslate();
                if (position <= s.maxTranslate()) position = s.maxTranslate();
        
                s.setWrapperTransition(0);
                s.setWrapperTranslate(position);
                s.updateProgress();
                s.updateActiveIndex();
        
                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
                    s.updateClasses();
                }
        
                if (s.params.freeModeSticky) {
                    clearTimeout(s.mousewheel.timeout);
                    s.mousewheel.timeout = setTimeout(function () {
                        s.slideReset();
                    }, 300);
                }
                else {
                    if (s.params.lazyLoading && s.lazy) {
                        s.lazy.load();
                    }
                }
                // Emit event
                s.emit('onScroll', s, e);
        
                // Stop autoplay
                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
        
                // Return page scroll on edge positions
                if (position === 0 || position === s.maxTranslate()) return;
            }
        
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        s.disableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.off(s.mousewheel.event, handleMousewheel);
            return true;
        };
        
        s.enableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.on(s.mousewheel.event, handleMousewheel);
            return true;
        };
        
        /**
         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
         * complicated, thus this doc is long and (hopefully) detailed enough to answer
         * your questions.
         *
         * If you need to react to the mouse wheel in a predictable way, this code is
         * like your bestest friend. * hugs *
         *
         * As of today, there are 4 DOM event types you can listen to:
         *
         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
         *
         * So what to do?  The is the best:
         *
         *   normalizeWheel.getEventType();
         *
         * In your event callback, use this code to get sane interpretation of the
         * deltas.  This code will return an object with properties:
         *
         *   spinX   -- normalized spin speed (use for zoom) - x plane
         *   spinY   -- " - y plane
         *   pixelX  -- normalized distance (to pixels) - x plane
         *   pixelY  -- " - y plane
         *
         * Wheel values are provided by the browser assuming you are using the wheel to
         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
         * significantly on different platforms and browsers, forgetting that you can
         * scroll at different speeds.  Some devices (like trackpads) emit more events
         * at smaller increments with fine granularity, and some emit massive jumps with
         * linear speed or acceleration.
         *
         * This code does its best to normalize the deltas for you:
         *
         *   - spin is trying to normalize how far the wheel was spun (or trackpad
         *     dragged).  This is super useful for zoom support where you want to
         *     throw away the chunky scroll steps on the PC and make those equal to
         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
         *     resolve a single slow step on a wheel to 1.
         *
         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
         *     get the crazy differences between browsers, but at least it'll be in
         *     pixels!
         *
         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
         *     should translate to positive value zooming IN, negative zooming OUT.
         *     This matches the newer 'wheel' event.
         *
         * Why are there spinX, spinY (or pixels)?
         *
         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
         *     with a mouse.  It results in side-scrolling in the browser by default.
         *
         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
         *
         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
         *     probably is by browsers in conjunction with fancy 3D controllers .. but
         *     you know.
         *
         * Implementation info:
         *
         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
         * average mouse:
         *
         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
         *
         * On the trackpad:
         *
         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
         *
         * On other/older browsers.. it's more complicated as there can be multiple and
         * also missing delta values.
         *
         * The 'wheel' event is more standard:
         *
         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
         *
         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
         * backward compatibility with older events.  Those other values help us
         * better normalize spin speed.  Example of what the browsers provide:
         *
         *                          | event.wheelDelta | event.detail
         *        ------------------+------------------+--------------
         *          Safari v5/OS X  |       -120       |       0
         *          Safari v5/Win7  |       -120       |       0
         *         Chrome v17/OS X  |       -120       |       0
         *         Chrome v17/Win7  |       -120       |       0
         *                IE9/Win7  |       -120       |   undefined
         *         Firefox v4/OS X  |     undefined    |       1
         *         Firefox v4/Win7  |     undefined    |       3
         *
         */
        function normalizeWheel( /*object*/ event ) /*object*/ {
            // Reasonable defaults
            var PIXEL_STEP = 10;
            var LINE_HEIGHT = 40;
            var PAGE_HEIGHT = 800;
        
            var sX = 0, sY = 0,       // spinX, spinY
                pX = 0, pY = 0;       // pixelX, pixelY
        
            // Legacy
            if( 'detail' in event ) {
                sY = event.detail;
            }
            if( 'wheelDelta' in event ) {
                sY = -event.wheelDelta / 120;
            }
            if( 'wheelDeltaY' in event ) {
                sY = -event.wheelDeltaY / 120;
            }
            if( 'wheelDeltaX' in event ) {
                sX = -event.wheelDeltaX / 120;
            }
        
            // side scrolling on FF with DOMMouseScroll
            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
                sX = sY;
                sY = 0;
            }
        
            pX = sX * PIXEL_STEP;
            pY = sY * PIXEL_STEP;
        
            if( 'deltaY' in event ) {
                pY = event.deltaY;
            }
            if( 'deltaX' in event ) {
                pX = event.deltaX;
            }
        
            if( (pX || pY) && event.deltaMode ) {
                if( event.deltaMode === 1 ) {          // delta in LINE units
                    pX *= LINE_HEIGHT;
                    pY *= LINE_HEIGHT;
                } else {                             // delta in PAGE units
                    pX *= PAGE_HEIGHT;
                    pY *= PAGE_HEIGHT;
                }
            }
        
            // Fall-back if spin cannot be determined
            if( pX && !sX ) {
                sX = (pX < 1) ? -1 : 1;
            }
            if( pY && !sY ) {
                sY = (pY < 1) ? -1 : 1;
            }
        
            return {
                spinX: sX,
                spinY: sY,
                pixelX: pX,
                pixelY: pY
            };
        }

        /*=========================
          Parallax
          ===========================*/
        function setParallaxTransform(el, progress) {
            el = $(el);
            var p, pX, pY;
            var rtlFactor = s.rtl ? -1 : 1;
        
            p = el.attr('data-swiper-parallax') || '0';
            pX = el.attr('data-swiper-parallax-x');
            pY = el.attr('data-swiper-parallax-y');
            if (pX || pY) {
                pX = pX || '0';
                pY = pY || '0';
            }
            else {
                if (s.isHorizontal()) {
                    pX = p;
                    pY = '0';
                }
                else {
                    pY = p;
                    pX = '0';
                }
            }
        
            if ((pX).indexOf('%') >= 0) {
                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
            }
            else {
                pX = pX * progress * rtlFactor + 'px' ;
            }
            if ((pY).indexOf('%') >= 0) {
                pY = parseInt(pY, 10) * progress + '%';
            }
            else {
                pY = pY * progress + 'px' ;
            }
        
            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
        }
        s.parallax = {
            setTranslate: function () {
                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    setParallaxTransform(this, s.progress);
        
                });
                s.slides.each(function () {
                    var slide = $(this);
                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
                        setParallaxTransform(this, progress);
                    });
                });
            },
            setTransition: function (duration) {
                if (typeof duration === 'undefined') duration = s.params.speed;
                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    var el = $(this);
                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
                    if (duration === 0) parallaxDuration = 0;
                    el.transition(parallaxDuration);
                });
            }
        };
        

        /*=========================
          Zoom
          ===========================*/
        s.zoom = {
            // "Global" Props
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                slide: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                image: undefined,
                imageWrap: undefined,
                zoomMax: s.params.zoomMax
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            },
            // Calc Scale From Multi-touches
            getDistanceBetweenTouches: function (e) {
                if (e.targetTouches.length < 2) return 1;
                var x1 = e.targetTouches[0].pageX,
                    y1 = e.targetTouches[0].pageY,
                    x2 = e.targetTouches[1].pageX,
                    y2 = e.targetTouches[1].pageY;
                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                return distance;
            },
            // Events
            onGestureStart: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.slide || !z.gesture.slide.length) {
                    z.gesture.slide = $(this);
                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
                    if (z.gesture.imageWrap.length === 0) {
                        z.gesture.image = undefined;
                        return;
                    }
                }
                z.gesture.image.transition(0);
                z.isScaling = true;
            },
            onGestureChange: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (s.support.gestures) {
                    z.scale = e.scale * z.currentScale;
                }
                else {
                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
                }
                if (z.scale > z.gesture.zoomMax) {
                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
                }
                if (z.scale < s.params.zoomMin) {
                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
                }
                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
            },
            onGestureEnd: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
                        return;
                    }
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                z.currentScale = z.scale;
                z.isScaling = false;
                if (z.scale === 1) z.gesture.slide = undefined;
            },
            onTouchStart: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (z.image.isTouched) return;
                if (s.device.os === 'android') e.preventDefault();
                z.image.isTouched = true;
                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            },
            onTouchMove: function (e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                s.allowClick = false;
                if (!z.image.isTouched || !z.gesture.slide) return;
        
                if (!z.image.isMoved) {
                    z.image.width = z.gesture.image[0].offsetWidth;
                    z.image.height = z.gesture.image[0].offsetHeight;
                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
                    z.gesture.imageWrap.transition(0);
                    if (s.rtl) z.image.startX = -z.image.startX;
                    if (s.rtl) z.image.startY = -z.image.startY;
                }
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
        
                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
        
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
        
                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
                if (!z.image.isMoved && !z.isScaling) {
                    if (s.isHorizontal() &&
                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                    else if (!s.isHorizontal() &&
                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                }
                e.preventDefault();
                e.stopPropagation();
        
                z.image.isMoved = true;
                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
        
                if (z.image.currentX < z.image.minX) {
                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
                }
                if (z.image.currentX > z.image.maxX) {
                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
                }
        
                if (z.image.currentY < z.image.minY) {
                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
                }
                if (z.image.currentY > z.image.maxY) {
                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
                }
        
                //Velocity
                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
                z.velocity.prevPositionX = z.image.touchesCurrent.x;
                z.velocity.prevPositionY = z.image.touchesCurrent.y;
                z.velocity.prevTime = Date.now();
        
                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTouchEnd: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (!z.image.isTouched || !z.image.isMoved) {
                    z.image.isTouched = false;
                    z.image.isMoved = false;
                    return;
                }
                z.image.isTouched = false;
                z.image.isMoved = false;
                var momentumDurationX = 300;
                var momentumDurationY = 300;
                var momentumDistanceX = z.velocity.x * momentumDurationX;
                var newPositionX = z.image.currentX + momentumDistanceX;
                var momentumDistanceY = z.velocity.y * momentumDurationY;
                var newPositionY = z.image.currentY + momentumDistanceY;
        
                //Fix duration
                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        
                z.image.currentX = newPositionX;
                z.image.currentY = newPositionY;
        
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
        
                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTransitionEnd: function (s) {
                var z = s.zoom;
                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
                    z.scale = z.currentScale = 1;
                }
            },
            // Toggle Zoom
            toggleZoom: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.slide) {
                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
        
                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
        
                if (typeof z.image.touchesStart.x === 'undefined' && e) {
                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
                }
                else {
                    touchX = z.image.touchesStart.x;
                    touchY = z.image.touchesStart.y;
                }
        
                if (z.scale && z.scale !== 1) {
                    // Zoom Out
                    z.scale = z.currentScale = 1;
                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
                    z.gesture.slide = undefined;
                }
                else {
                    // Zoom In
                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
                    if (e) {
                        slideWidth = z.gesture.slide[0].offsetWidth;
                        slideHeight = z.gesture.slide[0].offsetHeight;
                        offsetX = z.gesture.slide.offset().left;
                        offsetY = z.gesture.slide.offset().top;
                        diffX = offsetX + slideWidth/2 - touchX;
                        diffY = offsetY + slideHeight/2 - touchY;
        
                        imageWidth = z.gesture.image[0].offsetWidth;
                        imageHeight = z.gesture.image[0].offsetHeight;
                        scaledWidth = imageWidth * z.scale;
                        scaledHeight = imageHeight * z.scale;
        
                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
                        translateMaxX = -translateMinX;
                        translateMaxY = -translateMinY;
        
                        translateX = diffX * z.scale;
                        translateY = diffY * z.scale;
        
                        if (translateX < translateMinX) {
                            translateX =  translateMinX;
                        }
                        if (translateX > translateMaxX) {
                            translateX = translateMaxX;
                        }
        
                        if (translateY < translateMinY) {
                            translateY =  translateMinY;
                        }
                        if (translateY > translateMaxY) {
                            translateY = translateMaxY;
                        }
                    }
                    else {
                        translateX = 0;
                        translateY = 0;
                    }
                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                }
            },
            // Attach/Detach Events
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
        
                if (s.params.zoom) {
                    var target = s.slides;
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    // Scale image
                    if (s.support.gestures) {
                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
                    }
                    else if (s.touchEvents.start === 'touchstart') {
                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
                    }
        
                    // Move image
                    s[action]('touchStart', s.zoom.onTouchStart);
                    s.slides.each(function (index, slide){
                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
                        }
                    });
                    s[action]('touchEnd', s.zoom.onTouchEnd);
        
                    // Scale Out
                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
                    if (s.params.zoomToggle) {
                        s.on('doubleTap', s.zoom.toggleZoom);
                    }
                }
            },
            init: function () {
                s.zoom.attachEvents();
            },
            destroy: function () {
                s.zoom.attachEvents(true);
            }
        };

        /*=========================
          Plugins API. Collect all and init all plugins
          ===========================*/
        s._plugins = [];
        for (var plugin in s.plugins) {
            var p = s.plugins[plugin](s, s.params[plugin]);
            if (p) s._plugins.push(p);
        }
        // Method to call all plugins event/method
        s.callPlugins = function (eventName) {
            for (var i = 0; i < s._plugins.length; i++) {
                if (eventName in s._plugins[i]) {
                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
        };

        /*=========================
          Events/Callbacks/Plugins Emitter
          ===========================*/
        function normalizeEventName (eventName) {
            if (eventName.indexOf('on') !== 0) {
                if (eventName[0] !== eventName[0].toUpperCase()) {
                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
                }
                else {
                    eventName = 'on' + eventName;
                }
            }
            return eventName;
        }
        s.emitterEventListeners = {
        
        };
        s.emit = function (eventName) {
            // Trigger callbacks
            if (s.params[eventName]) {
                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
            var i;
            // Trigger events
            if (s.emitterEventListeners[eventName]) {
                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
            // Trigger plugins
            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        };
        s.on = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
            s.emitterEventListeners[eventName].push(handler);
            return s;
        };
        s.off = function (eventName, handler) {
            var i;
            eventName = normalizeEventName(eventName);
            if (typeof handler === 'undefined') {
                // Remove all handlers for such event
                s.emitterEventListeners[eventName] = [];
                return s;
            }
            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
            }
            return s;
        };
        s.once = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            var _handler = function () {
                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                s.off(eventName, _handler);
            };
            s.on(eventName, _handler);
            return s;
        };

        // Accessibility tools
        s.a11y = {
            makeFocusable: function ($el) {
                $el.attr('tabIndex', '0');
                return $el;
            },
            addRole: function ($el, role) {
                $el.attr('role', role);
                return $el;
            },
        
            addLabel: function ($el, label) {
                $el.attr('aria-label', label);
                return $el;
            },
        
            disable: function ($el) {
                $el.attr('aria-disabled', true);
                return $el;
            },
        
            enable: function ($el) {
                $el.attr('aria-disabled', false);
                return $el;
            },
        
            onEnterKey: function (event) {
                if (event.keyCode !== 13) return;
                if ($(event.target).is(s.params.nextButton)) {
                    s.onClickNext(event);
                    if (s.isEnd) {
                        s.a11y.notify(s.params.lastSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.nextSlideMessage);
                    }
                }
                else if ($(event.target).is(s.params.prevButton)) {
                    s.onClickPrev(event);
                    if (s.isBeginning) {
                        s.a11y.notify(s.params.firstSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.prevSlideMessage);
                    }
                }
                if ($(event.target).is('.' + s.params.bulletClass)) {
                    $(event.target)[0].click();
                }
            },
        
            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
        
            notify: function (message) {
                var notification = s.a11y.liveRegion;
                if (notification.length === 0) return;
                notification.html('');
                notification.html(message);
            },
            init: function () {
                // Setup accessibility
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    s.a11y.makeFocusable(s.nextButton);
                    s.a11y.addRole(s.nextButton, 'button');
                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
                }
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    s.a11y.makeFocusable(s.prevButton);
                    s.a11y.addRole(s.prevButton, 'button');
                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
                }
        
                $(s.container).append(s.a11y.liveRegion);
            },
            initPagination: function () {
                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
                    s.bullets.each(function () {
                        var bullet = $(this);
                        s.a11y.makeFocusable(bullet);
                        s.a11y.addRole(bullet, 'button');
                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
                    });
                }
            },
            destroy: function () {
                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
            }
        };
        

        /*=========================
          Init/Destroy
          ===========================*/
        s.init = function () {
            if (s.params.loop) s.createLoop();
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.enableDraggable();
                }
            }
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                if (!s.params.loop) s.updateProgress();
                s.effects[s.params.effect].setTranslate();
            }
            if (s.params.loop) {
                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
            }
            else {
                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
                if (s.params.initialSlide === 0) {
                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
                    if (s.lazy && s.params.lazyLoading) {
                        s.lazy.load();
                        s.lazy.initialImageLoaded = true;
                    }
                }
            }
            s.attachEvents();
            if (s.params.observer && s.support.observer) {
                s.initObservers();
            }
            if (s.params.preloadImages && !s.params.lazyLoading) {
                s.preloadImages();
            }
            if (s.params.zoom && s.zoom) {
                s.zoom.init();
            }
            if (s.params.autoplay) {
                s.startAutoplay();
            }
            if (s.params.keyboardControl) {
                if (s.enableKeyboardControl) s.enableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.enableMousewheelControl) s.enableMousewheelControl();
            }
            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
            if (s.params.hashnavReplaceState) {
                s.params.replaceState = s.params.hashnavReplaceState;
            }
            if (s.params.history) {
                if (s.history) s.history.init();
            }
            if (s.params.hashnav) {
                if (s.hashnav) s.hashnav.init();
            }
            if (s.params.a11y && s.a11y) s.a11y.init();
            s.emit('onInit', s);
        };
        
        // Cleanup dynamic styles
        s.cleanupStyles = function () {
            // Container
            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
        
            // Wrapper
            s.wrapper.removeAttr('style');
        
            // Slides
            if (s.slides && s.slides.length) {
                s.slides
                    .removeClass([
                      s.params.slideVisibleClass,
                      s.params.slideActiveClass,
                      s.params.slideNextClass,
                      s.params.slidePrevClass
                    ].join(' '))
                    .removeAttr('style')
                    .removeAttr('data-swiper-column')
                    .removeAttr('data-swiper-row');
            }
        
            // Pagination/Bullets
            if (s.paginationContainer && s.paginationContainer.length) {
                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
            }
            if (s.bullets && s.bullets.length) {
                s.bullets.removeClass(s.params.bulletActiveClass);
            }
        
            // Buttons
            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
        
            // Scrollbar
            if (s.params.scrollbar && s.scrollbar) {
                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
            }
        };
        
        // Destroy
        s.destroy = function (deleteInstance, cleanupStyles) {
            // Detach evebts
            s.detachEvents();
            // Stop autoplay
            s.stopAutoplay();
            // Disable draggable
            if (s.params.scrollbar && s.scrollbar) {
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.disableDraggable();
                }
            }
            // Destroy loop
            if (s.params.loop) {
                s.destroyLoop();
            }
            // Cleanup styles
            if (cleanupStyles) {
                s.cleanupStyles();
            }
            // Disconnect observer
            s.disconnectObservers();
        
            // Destroy zoom
            if (s.params.zoom && s.zoom) {
                s.zoom.destroy();
            }
            // Disable keyboard/mousewheel
            if (s.params.keyboardControl) {
                if (s.disableKeyboardControl) s.disableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.disableMousewheelControl) s.disableMousewheelControl();
            }
            // Disable a11y
            if (s.params.a11y && s.a11y) s.a11y.destroy();
            // Delete history popstate
            if (s.params.history && !s.params.replaceState) {
                window.removeEventListener('popstate', s.history.setHistoryPopState);
            }
            if (s.params.hashnav && s.hashnav)  {
                s.hashnav.destroy();
            }
            // Destroy callback
            s.emit('onDestroy');
            // Delete instance
            if (deleteInstance !== false) s = null;
        };
        
        s.init();
        

    
        // Return swiper instance
        return s;
    };
    

    /*==================================================
        Prototype
    ====================================================*/
    Swiper.prototype = {
        isSafari: (function () {
            var ua = window.navigator.userAgent.toLowerCase();
            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function (arr) {
            return Object.prototype.toString.apply(arr) === '[object Array]';
        },
        /*==================================================
        Browser
        ====================================================*/
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
            lteIE9: (function() {
                // create temporary DIV
                var div = document.createElement('div');
                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
                // return true / false value based on what will browser render
                return div.getElementsByTagName('i').length === 1;
            })()
        },
        /*==================================================
        Devices
        ====================================================*/
        device: (function () {
            var ua = window.navigator.userAgent;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {
                ios: ipad || iphone || ipod,
                android: android
            };
        })(),
        /*==================================================
        Feature Detection
        ====================================================*/
        support: {
            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
            })(),
    
            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
                var div = document.createElement('div').style;
                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
            })(),
    
            flexbox: (function () {
                var div = document.createElement('div').style;
                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i] in div) return true;
                }
            })(),
    
            observer: (function () {
                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
            })(),
    
            passiveListener: (function () {
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('testPassiveListener', null, opts);
                } catch (e) {}
                return supportsPassive;
            })(),
    
            gestures: (function () {
                return 'ongesturestart' in window;
            })()
        },
        /*==================================================
        Plugins
        ====================================================*/
        plugins: {}
    };
    

    /*===========================
    Dom7 Library
    ===========================*/
    var Dom7 = (function () {
        var Dom7 = function (arr) {
            var _this = this, i = 0;
            // Create array-like object
            for (i = 0; i < arr.length; i++) {
                _this[i] = arr[i];
            }
            _this.length = arr.length;
            // Return collection with methods
            return this;
        };
        var $ = function (selector, context) {
            var arr = [], i = 0;
            if (selector && !context) {
                if (selector instanceof Dom7) {
                    return selector;
                }
            }
            if (selector) {
                // String
                if (typeof selector === 'string') {
                    var els, tempParent, html = selector.trim();
                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                        var toCreate = 'div';
                        if (html.indexOf('<li') === 0) toCreate = 'ul';
                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
                        if (html.indexOf('<option') === 0) toCreate = 'select';
                        tempParent = document.createElement(toCreate);
                        tempParent.innerHTML = selector;
                        for (i = 0; i < tempParent.childNodes.length; i++) {
                            arr.push(tempParent.childNodes[i]);
                        }
                    }
                    else {
                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
                            // Pure ID selector
                            els = [document.getElementById(selector.split('#')[1])];
                        }
                        else {
                            // Other selectors
                            els = (context || document).querySelectorAll(selector);
                        }
                        for (i = 0; i < els.length; i++) {
                            if (els[i]) arr.push(els[i]);
                        }
                    }
                }
                // Node/element
                else if (selector.nodeType || selector === window || selector === document) {
                    arr.push(selector);
                }
                //Array of elements or instance of Dom
                else if (selector.length > 0 && selector[0].nodeType) {
                    for (i = 0; i < selector.length; i++) {
                        arr.push(selector[i]);
                    }
                }
            }
            return new Dom7(arr);
        };
        Dom7.prototype = {
            // Classes and attriutes
            addClass: function (className) {
                if (typeof className === 'undefined') {
                    return this;
                }
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.add(classes[i]);
                    }
                }
                return this;
            },
            removeClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.remove(classes[i]);
                    }
                }
                return this;
            },
            hasClass: function (className) {
                if (!this[0]) return false;
                else return this[0].classList.contains(className);
            },
            toggleClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.toggle(classes[i]);
                    }
                }
                return this;
            },
            attr: function (attrs, value) {
                if (arguments.length === 1 && typeof attrs === 'string') {
                    // Get attr
                    if (this[0]) return this[0].getAttribute(attrs);
                    else return undefined;
                }
                else {
                    // Set attrs
                    for (var i = 0; i < this.length; i++) {
                        if (arguments.length === 2) {
                            // String
                            this[i].setAttribute(attrs, value);
                        }
                        else {
                            // Object
                            for (var attrName in attrs) {
                                this[i][attrName] = attrs[attrName];
                                this[i].setAttribute(attrName, attrs[attrName]);
                            }
                        }
                    }
                    return this;
                }
            },
            removeAttr: function (attr) {
                for (var i = 0; i < this.length; i++) {
                    this[i].removeAttribute(attr);
                }
                return this;
            },
            data: function (key, value) {
                if (typeof value === 'undefined') {
                    // Get value
                    if (this[0]) {
                        var dataKey = this[0].getAttribute('data-' + key);
                        if (dataKey) return dataKey;
                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
                        else return undefined;
                    }
                    else return undefined;
                }
                else {
                    // Set value
                    for (var i = 0; i < this.length; i++) {
                        var el = this[i];
                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                        el.dom7ElementDataStorage[key] = value;
                    }
                    return this;
                }
            },
            // Transforms
            transform : function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            },
            transition: function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            },
            //Events
            on: function (eventName, targetSelector, listener, capture) {
                function handleLiveEvent(e) {
                    var target = e.target;
                    if ($(target).is(targetSelector)) listener.call(target, e);
                    else {
                        var parents = $(target).parents();
                        for (var k = 0; k < parents.length; k++) {
                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
                        }
                    }
                }
                var events = eventName.split(' ');
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof targetSelector === 'function' || targetSelector === false) {
                        // Usual events
                        if (typeof targetSelector === 'function') {
                            listener = arguments[1];
                            capture = arguments[2] || false;
                        }
                        for (j = 0; j < events.length; j++) {
                            this[i].addEventListener(events[j], listener, capture);
                        }
                    }
                    else {
                        //Live events
                        for (j = 0; j < events.length; j++) {
                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
                            this[i].addEventListener(events[j], handleLiveEvent, capture);
                        }
                    }
                }
    
                return this;
            },
            off: function (eventName, targetSelector, listener, capture) {
                var events = eventName.split(' ');
                for (var i = 0; i < events.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        if (typeof targetSelector === 'function' || targetSelector === false) {
                            // Usual events
                            if (typeof targetSelector === 'function') {
                                listener = arguments[1];
                                capture = arguments[2] || false;
                            }
                            this[j].removeEventListener(events[i], listener, capture);
                        }
                        else {
                            // Live event
                            if (this[j].dom7LiveListeners) {
                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
                                    if (this[j].dom7LiveListeners[k].listener === listener) {
                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
                                    }
                                }
                            }
                        }
                    }
                }
                return this;
            },
            once: function (eventName, targetSelector, listener, capture) {
                var dom = this;
                if (typeof targetSelector === 'function') {
                    targetSelector = false;
                    listener = arguments[1];
                    capture = arguments[2];
                }
                function proxy(e) {
                    listener(e);
                    dom.off(eventName, targetSelector, proxy, capture);
                }
                dom.on(eventName, targetSelector, proxy, capture);
            },
            trigger: function (eventName, eventData) {
                for (var i = 0; i < this.length; i++) {
                    var evt;
                    try {
                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
                    }
                    catch (e) {
                        evt = document.createEvent('Event');
                        evt.initEvent(eventName, true, true);
                        evt.detail = eventData;
                    }
                    this[i].dispatchEvent(evt);
                }
                return this;
            },
            transitionEnd: function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            },
            // Sizing/Styles
            width: function () {
                if (this[0] === window) {
                    return window.innerWidth;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('width'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerWidth: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            },
            height: function () {
                if (this[0] === window) {
                    return window.innerHeight;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('height'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerHeight: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
                    else
                        return this[0].offsetHeight;
                }
                else return null;
            },
            offset: function () {
                if (this.length > 0) {
                    var el = this[0];
                    var box = el.getBoundingClientRect();
                    var body = document.body;
                    var clientTop  = el.clientTop  || body.clientTop  || 0;
                    var clientLeft = el.clientLeft || body.clientLeft || 0;
                    var scrollTop  = window.pageYOffset || el.scrollTop;
                    var scrollLeft = window.pageXOffset || el.scrollLeft;
                    return {
                        top: box.top  + scrollTop  - clientTop,
                        left: box.left + scrollLeft - clientLeft
                    };
                }
                else {
                    return null;
                }
            },
            css: function (props, value) {
                var i;
                if (arguments.length === 1) {
                    if (typeof props === 'string') {
                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                    }
                    else {
                        for (i = 0; i < this.length; i++) {
                            for (var prop in props) {
                                this[i].style[prop] = props[prop];
                            }
                        }
                        return this;
                    }
                }
                if (arguments.length === 2 && typeof props === 'string') {
                    for (i = 0; i < this.length; i++) {
                        this[i].style[props] = value;
                    }
                    return this;
                }
                return this;
            },
    
            //Dom manipulation
            each: function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.call(this[i], i, this[i]);
                }
                return this;
            },
            html: function (html) {
                if (typeof html === 'undefined') {
                    return this[0] ? this[0].innerHTML : undefined;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].innerHTML = html;
                    }
                    return this;
                }
            },
            text: function (text) {
                if (typeof text === 'undefined') {
                    if (this[0]) {
                        return this[0].textContent.trim();
                    }
                    else return null;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].textContent = text;
                    }
                    return this;
                }
            },
            is: function (selector) {
                if (!this[0]) return false;
                var compareWith, i;
                if (typeof selector === 'string') {
                    var el = this[0];
                    if (el === document) return selector === document;
                    if (el === window) return selector === window;
    
                    if (el.matches) return el.matches(selector);
                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                    else {
                        compareWith = $(selector);
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                }
                else if (selector === document) return this[0] === document;
                else if (selector === window) return this[0] === window;
                else {
                    if (selector.nodeType || selector instanceof Dom7) {
                        compareWith = selector.nodeType ? [selector] : selector;
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                    return false;
                }
    
            },
            index: function () {
                if (this[0]) {
                    var child = this[0];
                    var i = 0;
                    while ((child = child.previousSibling) !== null) {
                        if (child.nodeType === 1) i++;
                    }
                    return i;
                }
                else return undefined;
            },
            eq: function (index) {
                if (typeof index === 'undefined') return this;
                var length = this.length;
                var returnIndex;
                if (index > length - 1) {
                    return new Dom7([]);
                }
                if (index < 0) {
                    returnIndex = length + index;
                    if (returnIndex < 0) return new Dom7([]);
                    else return new Dom7([this[returnIndex]]);
                }
                return new Dom7([this[index]]);
            },
            append: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].appendChild(newChild[j]);
                        }
                    }
                    else {
                        this[i].appendChild(newChild);
                    }
                }
                return this;
            },
            prepend: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                        }
                        // this[i].insertAdjacentHTML('afterbegin', newChild);
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                        }
                    }
                    else {
                        this[i].insertBefore(newChild, this[i].childNodes[0]);
                    }
                }
                return this;
            },
            insertBefore: function (selector) {
                var before = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (before.length === 1) {
                        before[0].parentNode.insertBefore(this[i], before[0]);
                    }
                    else if (before.length > 1) {
                        for (var j = 0; j < before.length; j++) {
                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                        }
                    }
                }
            },
            insertAfter: function (selector) {
                var after = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (after.length === 1) {
                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                    }
                    else if (after.length > 1) {
                        for (var j = 0; j < after.length; j++) {
                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                        }
                    }
                }
            },
            next: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            nextAll: function (selector) {
                var nextEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.nextElementSibling) {
                    var next = el.nextElementSibling;
                    if (selector) {
                        if($(next).is(selector)) nextEls.push(next);
                    }
                    else nextEls.push(next);
                    el = next;
                }
                return new Dom7(nextEls);
            },
            prev: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            prevAll: function (selector) {
                var prevEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.previousElementSibling) {
                    var prev = el.previousElementSibling;
                    if (selector) {
                        if($(prev).is(selector)) prevEls.push(prev);
                    }
                    else prevEls.push(prev);
                    el = prev;
                }
                return new Dom7(prevEls);
            },
            parent: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    }
                    else {
                        parents.push(this[i].parentNode);
                    }
                }
                return $($.unique(parents));
            },
            parents: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    var parent = this[i].parentNode;
                    while (parent) {
                        if (selector) {
                            if ($(parent).is(selector)) parents.push(parent);
                        }
                        else {
                            parents.push(parent);
                        }
                        parent = parent.parentNode;
                    }
                }
                return $($.unique(parents));
            },
            find : function (selector) {
                var foundElements = [];
                for (var i = 0; i < this.length; i++) {
                    var found = this[i].querySelectorAll(selector);
                    for (var j = 0; j < found.length; j++) {
                        foundElements.push(found[j]);
                    }
                }
                return new Dom7(foundElements);
            },
            children: function (selector) {
                var children = [];
                for (var i = 0; i < this.length; i++) {
                    var childNodes = this[i].childNodes;
    
                    for (var j = 0; j < childNodes.length; j++) {
                        if (!selector) {
                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
                        }
                        else {
                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
                        }
                    }
                }
                return new Dom7($.unique(children));
            },
            remove: function () {
                for (var i = 0; i < this.length; i++) {
                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
                }
                return this;
            },
            add: function () {
                var dom = this;
                var i, j;
                for (i = 0; i < arguments.length; i++) {
                    var toAdd = $(arguments[i]);
                    for (j = 0; j < toAdd.length; j++) {
                        dom[dom.length] = toAdd[j];
                        dom.length++;
                    }
                }
                return dom;
            }
        };
        $.fn = Dom7.prototype;
        $.unique = function (arr) {
            var unique = [];
            for (var i = 0; i < arr.length; i++) {
                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
            }
            return unique;
        };
    
        return $;
    })();
    

    /*===========================
     Get Dom libraries
     ===========================*/
    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
    for (var i = 0; i < swiperDomPlugins.length; i++) {
    	if (window[swiperDomPlugins[i]]) {
    		addLibraryPlugin(window[swiperDomPlugins[i]]);
    	}
    }
    // Required DOM Plugins
    var domLib;
    if (typeof Dom7 === 'undefined') {
    	domLib = window.Dom7 || window.Zepto || window.jQuery;
    }
    else {
    	domLib = Dom7;
    }

    /*===========================
    Add .swiper plugin from Dom libraries
    ===========================*/
    function addLibraryPlugin(lib) {
        lib.fn.swiper = function (params) {
            var firstInstance;
            lib(this).each(function () {
                var s = new Swiper(this, params);
                if (!firstInstance) firstInstance = s;
            });
            return firstInstance;
        };
    }
    
    if (domLib) {
        if (!('transitionEnd' in domLib.fn)) {
            domLib.fn.transitionEnd = function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            };
        }
        if (!('transform' in domLib.fn)) {
            domLib.fn.transform = function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            };
        }
        if (!('transition' in domLib.fn)) {
            domLib.fn.transition = function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            };
        }
        if (!('outerWidth' in domLib.fn)) {
            domLib.fn.outerWidth = function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            };
        }
    }

    window.Swiper = Swiper;
})();
/*===========================
Swiper AMD Export
===========================*/
if (typeof(module) !== 'undefined')
{
    module.exports = window.Swiper;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.Swiper;
    });
}
//# sourceMappingURL=maps/swiper.js.map

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
function TabPanelActionHandler(tablist) {
  var tabs;
  var panels;

  generateArrays();

  function generateArrays () {
    tabs = tablist.querySelectorAll('[role="tab"]');
    panels = tablist.querySelectorAll('[role="tabpanel"]');
  };

  // For easy reference
  var keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46,
    enter: 13,
    space: 32
  };

  // Add or subtract depending on key pressed
  var direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1
  };

  // Bind listeners
  for (i = 0; i < tabs.length; ++i) {
    addListeners(i);
  };

  function addListeners (index) {
    tabs[index].addEventListener('click', clickEventListener);
    tabs[index].addEventListener('keydown', keydownEventListener);
    tabs[index].addEventListener('keyup', keyupEventListener);

    // Build an array with all tabs (<button>s) in it
    tabs[index].index = index;
  };

  // When a tab is clicked, activateTab is fired to activate it
  function clickEventListener (event) {
    var tab = event.target;
    activateTab(tab, false);
  };

  // Handle keydown on tabs
  function keydownEventListener (event) {
    var key = event.keyCode;

    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        focusLastTab();
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
    console.log(tabs);
        focusFirstTab();
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
    };
  };

  // Handle keyup on tabs
  function keyupEventListener (event) {
    var key = event.keyCode;

    switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.delete:
        determineDeletable(event);
        break;
      case keys.enter:
      case keys.space:
        activateTab(event.target);
        break;
    };
  };

  // When a tablistâ€™s aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  function determineOrientation (event) {
    var key = event.keyCode;
    var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
    var proceed = false;

    if (vertical) {
      if (key === keys.up || key === keys.down) {
        event.preventDefault();
        proceed = true;
      };
    }
    else {
      if (key === keys.left || key === keys.right) {
        proceed = true;
      };
    };

    if (proceed) {
      switchTabOnArrowPress(event);
    };
  };

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  function switchTabOnArrowPress (event) {
    var pressed = event.keyCode;

    if (direction[pressed]) {
      var target = event.target;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        }
        else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        }
        else if (pressed === keys.right || pressed == keys.down) {
          focusFirstTab();
        };
      };
    };
  };

  // Activates any given tab panel
  function activateTab (tab, setFocus) {
    if(tab.classList.contains("active") || tab.getAttribute("role") != "tab")
        return;

    setFocus = setFocus || true;
    // Deactivate all other tabs
    deactivateTabs();

    tab.setAttribute('tabindex', '0');

    // Set the tab as selected
    tab.setAttribute('aria-selected', 'true');

    // Get the value of aria-controls (which is an ID)
    var controls = tab.getAttribute('aria-controls'),
        targetPanel = tablist.querySelector("#"+controls);

    if(tablist && targetPanel) {
        // console.log(controls, tablist);
        // Remove hidden attribute from tab panel to make it visible
        targetPanel.removeAttribute('hidden');
    }

    // Set focus when required
    if (setFocus) {
      tab.focus();
    };
  };

  // Deactivate all tabs and tab panels
  function deactivateTabs () {
    for (t = 0; t < tabs.length; t++) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
      tabs[t].classList.remove('active');
    };

    for (p = 0; p < panels.length; p++) {
      panels[p].setAttribute('hidden', 'hidden');
    };
  };

  // Make a guess
  function focusFirstTab () {
    tabs[0].focus();
  };

  // Make a guess
  function focusLastTab () {
    tabs[tabs.length - 1].focus();
  };

  // Detect if a tab is deletable
  function determineDeletable (event) {
    target = event.target;

    if (target.getAttribute('data-deletable') !== null) {
      // Delete target tab
      deleteTab(event, target);

      // Update arrays related to tabs widget
      generateArrays();

      // Activate the closest tab to the one that was just deleted
      if (target.index - 1 < 0) {
        activateTab(tabs[0]);
      }
      else {
        activateTab(tabs[target.index - 1]);
      };
    };
  };

  // Deletes a tab and its panel
  function deleteTab (event) {
    var target = event.target;
    var panel = tablist.getElementById(target.getAttribute('aria-controls'));

    target.parentElement.removeChild(target);
    panel.parentElement.removeChild(panel);
  };

  // Determine whether there should be a delay
  // when user navigates with the arrow keys
  function determineDelay () {
    var hasDelay = tablist.hasAttribute('data-delay');
    var delay = 0;

    if (hasDelay) {
      var delayValue = tablist.getAttribute('data-delay');
      if (delayValue) {
        delay = delayValue;
      }
      else {
        // If no value is specified, default to 300ms
        delay = 300;
      };
    };

    return delay;
  };
}

function initTabPanelActionHandler(){
    Array.prototype.slice.call(document.querySelectorAll('[role="tablist"]')).forEach(function(tablist){
        TabPanelActionHandler(tablist);
    });
}
/**
 * Skipped minification because the original files appears to be already minified.
 * Original file: /npm/chart.js@4.4.8/dist/chart.umd.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Chart=e()}(this,(function(){"use strict";var t=Object.freeze({__proto__:null,get Colors(){return Go},get Decimation(){return Qo},get Filler(){return ma},get Legend(){return ya},get SubTitle(){return ka},get Title(){return Ma},get Tooltip(){return Ba}});function e(){}const i=(()=>{let t=0;return()=>t++})();function s(t){return null==t}function n(t){if(Array.isArray&&Array.isArray(t))return!0;const e=Object.prototype.toString.call(t);return"[object"===e.slice(0,7)&&"Array]"===e.slice(-6)}function o(t){return null!==t&&"[object Object]"===Object.prototype.toString.call(t)}function a(t){return("number"==typeof t||t instanceof Number)&&isFinite(+t)}function r(t,e){return a(t)?t:e}function l(t,e){return void 0===t?e:t}const h=(t,e)=>"string"==typeof t&&t.endsWith("%")?parseFloat(t)/100:+t/e,c=(t,e)=>"string"==typeof t&&t.endsWith("%")?parseFloat(t)/100*e:+t;function d(t,e,i){if(t&&"function"==typeof t.call)return t.apply(i,e)}function u(t,e,i,s){let a,r,l;if(n(t))if(r=t.length,s)for(a=r-1;a>=0;a--)e.call(i,t[a],a);else for(a=0;a<r;a++)e.call(i,t[a],a);else if(o(t))for(l=Object.keys(t),r=l.length,a=0;a<r;a++)e.call(i,t[l[a]],l[a])}function f(t,e){let i,s,n,o;if(!t||!e||t.length!==e.length)return!1;for(i=0,s=t.length;i<s;++i)if(n=t[i],o=e[i],n.datasetIndex!==o.datasetIndex||n.index!==o.index)return!1;return!0}function g(t){if(n(t))return t.map(g);if(o(t)){const e=Object.create(null),i=Object.keys(t),s=i.length;let n=0;for(;n<s;++n)e[i[n]]=g(t[i[n]]);return e}return t}function p(t){return-1===["__proto__","prototype","constructor"].indexOf(t)}function m(t,e,i,s){if(!p(t))return;const n=e[t],a=i[t];o(n)&&o(a)?x(n,a,s):e[t]=g(a)}function x(t,e,i){const s=n(e)?e:[e],a=s.length;if(!o(t))return t;const r=(i=i||{}).merger||m;let l;for(let e=0;e<a;++e){if(l=s[e],!o(l))continue;const n=Object.keys(l);for(let e=0,s=n.length;e<s;++e)r(n[e],t,l,i)}return t}function b(t,e){return x(t,e,{merger:_})}function _(t,e,i){if(!p(t))return;const s=e[t],n=i[t];o(s)&&o(n)?b(s,n):Object.prototype.hasOwnProperty.call(e,t)||(e[t]=g(n))}const y={"":t=>t,x:t=>t.x,y:t=>t.y};function v(t){const e=t.split("."),i=[];let s="";for(const t of e)s+=t,s.endsWith("\\")?s=s.slice(0,-1)+".":(i.push(s),s="");return i}function M(t,e){const i=y[e]||(y[e]=function(t){const e=v(t);return t=>{for(const i of e){if(""===i)break;t=t&&t[i]}return t}}(e));return i(t)}function w(t){return t.charAt(0).toUpperCase()+t.slice(1)}const k=t=>void 0!==t,S=t=>"function"==typeof t,P=(t,e)=>{if(t.size!==e.size)return!1;for(const i of t)if(!e.has(i))return!1;return!0};function D(t){return"mouseup"===t.type||"click"===t.type||"contextmenu"===t.type}const C=Math.PI,O=2*C,A=O+C,T=Number.POSITIVE_INFINITY,L=C/180,E=C/2,R=C/4,I=2*C/3,z=Math.log10,F=Math.sign;function V(t,e,i){return Math.abs(t-e)<i}function B(t){const e=Math.round(t);t=V(t,e,t/1e3)?e:t;const i=Math.pow(10,Math.floor(z(t))),s=t/i;return(s<=1?1:s<=2?2:s<=5?5:10)*i}function W(t){const e=[],i=Math.sqrt(t);let s;for(s=1;s<i;s++)t%s==0&&(e.push(s),e.push(t/s));return i===(0|i)&&e.push(i),e.sort(((t,e)=>t-e)).pop(),e}function N(t){return!function(t){return"symbol"==typeof t||"object"==typeof t&&null!==t&&!(Symbol.toPrimitive in t||"toString"in t||"valueOf"in t)}(t)&&!isNaN(parseFloat(t))&&isFinite(t)}function H(t,e){const i=Math.round(t);return i-e<=t&&i+e>=t}function j(t,e,i){let s,n,o;for(s=0,n=t.length;s<n;s++)o=t[s][i],isNaN(o)||(e.min=Math.min(e.min,o),e.max=Math.max(e.max,o))}function $(t){return t*(C/180)}function Y(t){return t*(180/C)}function U(t){if(!a(t))return;let e=1,i=0;for(;Math.round(t*e)/e!==t;)e*=10,i++;return i}function X(t,e){const i=e.x-t.x,s=e.y-t.y,n=Math.sqrt(i*i+s*s);let o=Math.atan2(s,i);return o<-.5*C&&(o+=O),{angle:o,distance:n}}function q(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function K(t,e){return(t-e+A)%O-C}function G(t){return(t%O+O)%O}function Z(t,e,i,s){const n=G(t),o=G(e),a=G(i),r=G(o-n),l=G(a-n),h=G(n-o),c=G(n-a);return n===o||n===a||s&&o===a||r>l&&h<c}function J(t,e,i){return Math.max(e,Math.min(i,t))}function Q(t){return J(t,-32768,32767)}function tt(t,e,i,s=1e-6){return t>=Math.min(e,i)-s&&t<=Math.max(e,i)+s}function et(t,e,i){i=i||(i=>t[i]<e);let s,n=t.length-1,o=0;for(;n-o>1;)s=o+n>>1,i(s)?o=s:n=s;return{lo:o,hi:n}}const it=(t,e,i,s)=>et(t,i,s?s=>{const n=t[s][e];return n<i||n===i&&t[s+1][e]===i}:s=>t[s][e]<i),st=(t,e,i)=>et(t,i,(s=>t[s][e]>=i));function nt(t,e,i){let s=0,n=t.length;for(;s<n&&t[s]<e;)s++;for(;n>s&&t[n-1]>i;)n--;return s>0||n<t.length?t.slice(s,n):t}const ot=["push","pop","shift","splice","unshift"];function at(t,e){t._chartjs?t._chartjs.listeners.push(e):(Object.defineProperty(t,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[e]}}),ot.forEach((e=>{const i="_onData"+w(e),s=t[e];Object.defineProperty(t,e,{configurable:!0,enumerable:!1,value(...e){const n=s.apply(this,e);return t._chartjs.listeners.forEach((t=>{"function"==typeof t[i]&&t[i](...e)})),n}})})))}function rt(t,e){const i=t._chartjs;if(!i)return;const s=i.listeners,n=s.indexOf(e);-1!==n&&s.splice(n,1),s.length>0||(ot.forEach((e=>{delete t[e]})),delete t._chartjs)}function lt(t){const e=new Set(t);return e.size===t.length?t:Array.from(e)}const ht="undefined"==typeof window?function(t){return t()}:window.requestAnimationFrame;function ct(t,e){let i=[],s=!1;return function(...n){i=n,s||(s=!0,ht.call(window,(()=>{s=!1,t.apply(e,i)})))}}function dt(t,e){let i;return function(...s){return e?(clearTimeout(i),i=setTimeout(t,e,s)):t.apply(this,s),e}}const ut=t=>"start"===t?"left":"end"===t?"right":"center",ft=(t,e,i)=>"start"===t?e:"end"===t?i:(e+i)/2,gt=(t,e,i,s)=>t===(s?"left":"right")?i:"center"===t?(e+i)/2:e;function pt(t,e,i){const n=e.length;let o=0,a=n;if(t._sorted){const{iScale:r,vScale:l,_parsed:h}=t,c=t.dataset&&t.dataset.options?t.dataset.options.spanGaps:null,d=r.axis,{min:u,max:f,minDefined:g,maxDefined:p}=r.getUserBounds();if(g){if(o=Math.min(it(h,d,u).lo,i?n:it(e,d,r.getPixelForValue(u)).lo),c){const t=h.slice(0,o+1).reverse().findIndex((t=>!s(t[l.axis])));o-=Math.max(0,t)}o=J(o,0,n-1)}if(p){let t=Math.max(it(h,r.axis,f,!0).hi+1,i?0:it(e,d,r.getPixelForValue(f),!0).hi+1);if(c){const e=h.slice(t-1).findIndex((t=>!s(t[l.axis])));t+=Math.max(0,e)}a=J(t,o,n)-o}else a=n-o}return{start:o,count:a}}function mt(t){const{xScale:e,yScale:i,_scaleRanges:s}=t,n={xmin:e.min,xmax:e.max,ymin:i.min,ymax:i.max};if(!s)return t._scaleRanges=n,!0;const o=s.xmin!==e.min||s.xmax!==e.max||s.ymin!==i.min||s.ymax!==i.max;return Object.assign(s,n),o}class xt{constructor(){this._request=null,this._charts=new Map,this._running=!1,this._lastDate=void 0}_notify(t,e,i,s){const n=e.listeners[s],o=e.duration;n.forEach((s=>s({chart:t,initial:e.initial,numSteps:o,currentStep:Math.min(i-e.start,o)})))}_refresh(){this._request||(this._running=!0,this._request=ht.call(window,(()=>{this._update(),this._request=null,this._running&&this._refresh()})))}_update(t=Date.now()){let e=0;this._charts.forEach(((i,s)=>{if(!i.running||!i.items.length)return;const n=i.items;let o,a=n.length-1,r=!1;for(;a>=0;--a)o=n[a],o._active?(o._total>i.duration&&(i.duration=o._total),o.tick(t),r=!0):(n[a]=n[n.length-1],n.pop());r&&(s.draw(),this._notify(s,i,t,"progress")),n.length||(i.running=!1,this._notify(s,i,t,"complete"),i.initial=!1),e+=n.length})),this._lastDate=t,0===e&&(this._running=!1)}_getAnims(t){const e=this._charts;let i=e.get(t);return i||(i={running:!1,initial:!0,items:[],listeners:{complete:[],progress:[]}},e.set(t,i)),i}listen(t,e,i){this._getAnims(t).listeners[e].push(i)}add(t,e){e&&e.length&&this._getAnims(t).items.push(...e)}has(t){return this._getAnims(t).items.length>0}start(t){const e=this._charts.get(t);e&&(e.running=!0,e.start=Date.now(),e.duration=e.items.reduce(((t,e)=>Math.max(t,e._duration)),0),this._refresh())}running(t){if(!this._running)return!1;const e=this._charts.get(t);return!!(e&&e.running&&e.items.length)}stop(t){const e=this._charts.get(t);if(!e||!e.items.length)return;const i=e.items;let s=i.length-1;for(;s>=0;--s)i[s].cancel();e.items=[],this._notify(t,e,Date.now(),"complete")}remove(t){return this._charts.delete(t)}}var bt=new xt;
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */function _t(t){return t+.5|0}const yt=(t,e,i)=>Math.max(Math.min(t,i),e);function vt(t){return yt(_t(2.55*t),0,255)}function Mt(t){return yt(_t(255*t),0,255)}function wt(t){return yt(_t(t/2.55)/100,0,1)}function kt(t){return yt(_t(100*t),0,100)}const St={0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:10,B:11,C:12,D:13,E:14,F:15,a:10,b:11,c:12,d:13,e:14,f:15},Pt=[..."0123456789ABCDEF"],Dt=t=>Pt[15&t],Ct=t=>Pt[(240&t)>>4]+Pt[15&t],Ot=t=>(240&t)>>4==(15&t);function At(t){var e=(t=>Ot(t.r)&&Ot(t.g)&&Ot(t.b)&&Ot(t.a))(t)?Dt:Ct;return t?"#"+e(t.r)+e(t.g)+e(t.b)+((t,e)=>t<255?e(t):"")(t.a,e):void 0}const Tt=/^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;function Lt(t,e,i){const s=e*Math.min(i,1-i),n=(e,n=(e+t/30)%12)=>i-s*Math.max(Math.min(n-3,9-n,1),-1);return[n(0),n(8),n(4)]}function Et(t,e,i){const s=(s,n=(s+t/60)%6)=>i-i*e*Math.max(Math.min(n,4-n,1),0);return[s(5),s(3),s(1)]}function Rt(t,e,i){const s=Lt(t,1,.5);let n;for(e+i>1&&(n=1/(e+i),e*=n,i*=n),n=0;n<3;n++)s[n]*=1-e-i,s[n]+=e;return s}function It(t){const e=t.r/255,i=t.g/255,s=t.b/255,n=Math.max(e,i,s),o=Math.min(e,i,s),a=(n+o)/2;let r,l,h;return n!==o&&(h=n-o,l=a>.5?h/(2-n-o):h/(n+o),r=function(t,e,i,s,n){return t===n?(e-i)/s+(e<i?6:0):e===n?(i-t)/s+2:(t-e)/s+4}(e,i,s,h,n),r=60*r+.5),[0|r,l||0,a]}function zt(t,e,i,s){return(Array.isArray(e)?t(e[0],e[1],e[2]):t(e,i,s)).map(Mt)}function Ft(t,e,i){return zt(Lt,t,e,i)}function Vt(t){return(t%360+360)%360}function Bt(t){const e=Tt.exec(t);let i,s=255;if(!e)return;e[5]!==i&&(s=e[6]?vt(+e[5]):Mt(+e[5]));const n=Vt(+e[2]),o=+e[3]/100,a=+e[4]/100;return i="hwb"===e[1]?function(t,e,i){return zt(Rt,t,e,i)}(n,o,a):"hsv"===e[1]?function(t,e,i){return zt(Et,t,e,i)}(n,o,a):Ft(n,o,a),{r:i[0],g:i[1],b:i[2],a:s}}const Wt={x:"dark",Z:"light",Y:"re",X:"blu",W:"gr",V:"medium",U:"slate",A:"ee",T:"ol",S:"or",B:"ra",C:"lateg",D:"ights",R:"in",Q:"turquois",E:"hi",P:"ro",O:"al",N:"le",M:"de",L:"yello",F:"en",K:"ch",G:"arks",H:"ea",I:"ightg",J:"wh"},Nt={OiceXe:"f0f8ff",antiquewEte:"faebd7",aqua:"ffff",aquamarRe:"7fffd4",azuY:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"0",blanKedOmond:"ffebcd",Xe:"ff",XeviTet:"8a2be2",bPwn:"a52a2a",burlywood:"deb887",caMtXe:"5f9ea0",KartYuse:"7fff00",KocTate:"d2691e",cSO:"ff7f50",cSnflowerXe:"6495ed",cSnsilk:"fff8dc",crimson:"dc143c",cyan:"ffff",xXe:"8b",xcyan:"8b8b",xgTMnPd:"b8860b",xWay:"a9a9a9",xgYF:"6400",xgYy:"a9a9a9",xkhaki:"bdb76b",xmagFta:"8b008b",xTivegYF:"556b2f",xSange:"ff8c00",xScEd:"9932cc",xYd:"8b0000",xsOmon:"e9967a",xsHgYF:"8fbc8f",xUXe:"483d8b",xUWay:"2f4f4f",xUgYy:"2f4f4f",xQe:"ced1",xviTet:"9400d3",dAppRk:"ff1493",dApskyXe:"bfff",dimWay:"696969",dimgYy:"696969",dodgerXe:"1e90ff",fiYbrick:"b22222",flSOwEte:"fffaf0",foYstWAn:"228b22",fuKsia:"ff00ff",gaRsbSo:"dcdcdc",ghostwEte:"f8f8ff",gTd:"ffd700",gTMnPd:"daa520",Way:"808080",gYF:"8000",gYFLw:"adff2f",gYy:"808080",honeyMw:"f0fff0",hotpRk:"ff69b4",RdianYd:"cd5c5c",Rdigo:"4b0082",ivSy:"fffff0",khaki:"f0e68c",lavFMr:"e6e6fa",lavFMrXsh:"fff0f5",lawngYF:"7cfc00",NmoncEffon:"fffacd",ZXe:"add8e6",ZcSO:"f08080",Zcyan:"e0ffff",ZgTMnPdLw:"fafad2",ZWay:"d3d3d3",ZgYF:"90ee90",ZgYy:"d3d3d3",ZpRk:"ffb6c1",ZsOmon:"ffa07a",ZsHgYF:"20b2aa",ZskyXe:"87cefa",ZUWay:"778899",ZUgYy:"778899",ZstAlXe:"b0c4de",ZLw:"ffffe0",lime:"ff00",limegYF:"32cd32",lRF:"faf0e6",magFta:"ff00ff",maPon:"800000",VaquamarRe:"66cdaa",VXe:"cd",VScEd:"ba55d3",VpurpN:"9370db",VsHgYF:"3cb371",VUXe:"7b68ee",VsprRggYF:"fa9a",VQe:"48d1cc",VviTetYd:"c71585",midnightXe:"191970",mRtcYam:"f5fffa",mistyPse:"ffe4e1",moccasR:"ffe4b5",navajowEte:"ffdead",navy:"80",Tdlace:"fdf5e6",Tive:"808000",TivedBb:"6b8e23",Sange:"ffa500",SangeYd:"ff4500",ScEd:"da70d6",pOegTMnPd:"eee8aa",pOegYF:"98fb98",pOeQe:"afeeee",pOeviTetYd:"db7093",papayawEp:"ffefd5",pHKpuff:"ffdab9",peru:"cd853f",pRk:"ffc0cb",plum:"dda0dd",powMrXe:"b0e0e6",purpN:"800080",YbeccapurpN:"663399",Yd:"ff0000",Psybrown:"bc8f8f",PyOXe:"4169e1",saddNbPwn:"8b4513",sOmon:"fa8072",sandybPwn:"f4a460",sHgYF:"2e8b57",sHshell:"fff5ee",siFna:"a0522d",silver:"c0c0c0",skyXe:"87ceeb",UXe:"6a5acd",UWay:"708090",UgYy:"708090",snow:"fffafa",sprRggYF:"ff7f",stAlXe:"4682b4",tan:"d2b48c",teO:"8080",tEstN:"d8bfd8",tomato:"ff6347",Qe:"40e0d0",viTet:"ee82ee",JHt:"f5deb3",wEte:"ffffff",wEtesmoke:"f5f5f5",Lw:"ffff00",LwgYF:"9acd32"};let Ht;function jt(t){Ht||(Ht=function(){const t={},e=Object.keys(Nt),i=Object.keys(Wt);let s,n,o,a,r;for(s=0;s<e.length;s++){for(a=r=e[s],n=0;n<i.length;n++)o=i[n],r=r.replace(o,Wt[o]);o=parseInt(Nt[a],16),t[r]=[o>>16&255,o>>8&255,255&o]}return t}(),Ht.transparent=[0,0,0,0]);const e=Ht[t.toLowerCase()];return e&&{r:e[0],g:e[1],b:e[2],a:4===e.length?e[3]:255}}const $t=/^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;const Yt=t=>t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055,Ut=t=>t<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4);function Xt(t,e,i){if(t){let s=It(t);s[e]=Math.max(0,Math.min(s[e]+s[e]*i,0===e?360:1)),s=Ft(s),t.r=s[0],t.g=s[1],t.b=s[2]}}function qt(t,e){return t?Object.assign(e||{},t):t}function Kt(t){var e={r:0,g:0,b:0,a:255};return Array.isArray(t)?t.length>=3&&(e={r:t[0],g:t[1],b:t[2],a:255},t.length>3&&(e.a=Mt(t[3]))):(e=qt(t,{r:0,g:0,b:0,a:1})).a=Mt(e.a),e}function Gt(t){return"r"===t.charAt(0)?function(t){const e=$t.exec(t);let i,s,n,o=255;if(e){if(e[7]!==i){const t=+e[7];o=e[8]?vt(t):yt(255*t,0,255)}return i=+e[1],s=+e[3],n=+e[5],i=255&(e[2]?vt(i):yt(i,0,255)),s=255&(e[4]?vt(s):yt(s,0,255)),n=255&(e[6]?vt(n):yt(n,0,255)),{r:i,g:s,b:n,a:o}}}(t):Bt(t)}class Zt{constructor(t){if(t instanceof Zt)return t;const e=typeof t;let i;var s,n,o;"object"===e?i=Kt(t):"string"===e&&(o=(s=t).length,"#"===s[0]&&(4===o||5===o?n={r:255&17*St[s[1]],g:255&17*St[s[2]],b:255&17*St[s[3]],a:5===o?17*St[s[4]]:255}:7!==o&&9!==o||(n={r:St[s[1]]<<4|St[s[2]],g:St[s[3]]<<4|St[s[4]],b:St[s[5]]<<4|St[s[6]],a:9===o?St[s[7]]<<4|St[s[8]]:255})),i=n||jt(t)||Gt(t)),this._rgb=i,this._valid=!!i}get valid(){return this._valid}get rgb(){var t=qt(this._rgb);return t&&(t.a=wt(t.a)),t}set rgb(t){this._rgb=Kt(t)}rgbString(){return this._valid?(t=this._rgb)&&(t.a<255?`rgba(${t.r}, ${t.g}, ${t.b}, ${wt(t.a)})`:`rgb(${t.r}, ${t.g}, ${t.b})`):void 0;var t}hexString(){return this._valid?At(this._rgb):void 0}hslString(){return this._valid?function(t){if(!t)return;const e=It(t),i=e[0],s=kt(e[1]),n=kt(e[2]);return t.a<255?`hsla(${i}, ${s}%, ${n}%, ${wt(t.a)})`:`hsl(${i}, ${s}%, ${n}%)`}(this._rgb):void 0}mix(t,e){if(t){const i=this.rgb,s=t.rgb;let n;const o=e===n?.5:e,a=2*o-1,r=i.a-s.a,l=((a*r==-1?a:(a+r)/(1+a*r))+1)/2;n=1-l,i.r=255&l*i.r+n*s.r+.5,i.g=255&l*i.g+n*s.g+.5,i.b=255&l*i.b+n*s.b+.5,i.a=o*i.a+(1-o)*s.a,this.rgb=i}return this}interpolate(t,e){return t&&(this._rgb=function(t,e,i){const s=Ut(wt(t.r)),n=Ut(wt(t.g)),o=Ut(wt(t.b));return{r:Mt(Yt(s+i*(Ut(wt(e.r))-s))),g:Mt(Yt(n+i*(Ut(wt(e.g))-n))),b:Mt(Yt(o+i*(Ut(wt(e.b))-o))),a:t.a+i*(e.a-t.a)}}(this._rgb,t._rgb,e)),this}clone(){return new Zt(this.rgb)}alpha(t){return this._rgb.a=Mt(t),this}clearer(t){return this._rgb.a*=1-t,this}greyscale(){const t=this._rgb,e=_t(.3*t.r+.59*t.g+.11*t.b);return t.r=t.g=t.b=e,this}opaquer(t){return this._rgb.a*=1+t,this}negate(){const t=this._rgb;return t.r=255-t.r,t.g=255-t.g,t.b=255-t.b,this}lighten(t){return Xt(this._rgb,2,t),this}darken(t){return Xt(this._rgb,2,-t),this}saturate(t){return Xt(this._rgb,1,t),this}desaturate(t){return Xt(this._rgb,1,-t),this}rotate(t){return function(t,e){var i=It(t);i[0]=Vt(i[0]+e),i=Ft(i),t.r=i[0],t.g=i[1],t.b=i[2]}(this._rgb,t),this}}function Jt(t){if(t&&"object"==typeof t){const e=t.toString();return"[object CanvasPattern]"===e||"[object CanvasGradient]"===e}return!1}function Qt(t){return Jt(t)?t:new Zt(t)}function te(t){return Jt(t)?t:new Zt(t).saturate(.5).darken(.1).hexString()}const ee=["x","y","borderWidth","radius","tension"],ie=["color","borderColor","backgroundColor"];const se=new Map;function ne(t,e,i){return function(t,e){e=e||{};const i=t+JSON.stringify(e);let s=se.get(i);return s||(s=new Intl.NumberFormat(t,e),se.set(i,s)),s}(e,i).format(t)}const oe={values:t=>n(t)?t:""+t,numeric(t,e,i){if(0===t)return"0";const s=this.chart.options.locale;let n,o=t;if(i.length>1){const e=Math.max(Math.abs(i[0].value),Math.abs(i[i.length-1].value));(e<1e-4||e>1e15)&&(n="scientific"),o=function(t,e){let i=e.length>3?e[2].value-e[1].value:e[1].value-e[0].value;Math.abs(i)>=1&&t!==Math.floor(t)&&(i=t-Math.floor(t));return i}(t,i)}const a=z(Math.abs(o)),r=isNaN(a)?1:Math.max(Math.min(-1*Math.floor(a),20),0),l={notation:n,minimumFractionDigits:r,maximumFractionDigits:r};return Object.assign(l,this.options.ticks.format),ne(t,s,l)},logarithmic(t,e,i){if(0===t)return"0";const s=i[e].significand||t/Math.pow(10,Math.floor(z(t)));return[1,2,3,5,10,15].includes(s)||e>.8*i.length?oe.numeric.call(this,t,e,i):""}};var ae={formatters:oe};const re=Object.create(null),le=Object.create(null);function he(t,e){if(!e)return t;const i=e.split(".");for(let e=0,s=i.length;e<s;++e){const s=i[e];t=t[s]||(t[s]=Object.create(null))}return t}function ce(t,e,i){return"string"==typeof e?x(he(t,e),i):x(he(t,""),e)}class de{constructor(t,e){this.animation=void 0,this.backgroundColor="rgba(0,0,0,0.1)",this.borderColor="rgba(0,0,0,0.1)",this.color="#666",this.datasets={},this.devicePixelRatio=t=>t.chart.platform.getDevicePixelRatio(),this.elements={},this.events=["mousemove","mouseout","click","touchstart","touchmove"],this.font={family:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",size:12,style:"normal",lineHeight:1.2,weight:null},this.hover={},this.hoverBackgroundColor=(t,e)=>te(e.backgroundColor),this.hoverBorderColor=(t,e)=>te(e.borderColor),this.hoverColor=(t,e)=>te(e.color),this.indexAxis="x",this.interaction={mode:"nearest",intersect:!0,includeInvisible:!1},this.maintainAspectRatio=!0,this.onHover=null,this.onClick=null,this.parsing=!0,this.plugins={},this.responsive=!0,this.scale=void 0,this.scales={},this.showLine=!0,this.drawActiveElementsOnTop=!0,this.describe(t),this.apply(e)}set(t,e){return ce(this,t,e)}get(t){return he(this,t)}describe(t,e){return ce(le,t,e)}override(t,e){return ce(re,t,e)}route(t,e,i,s){const n=he(this,t),a=he(this,i),r="_"+e;Object.defineProperties(n,{[r]:{value:n[e],writable:!0},[e]:{enumerable:!0,get(){const t=this[r],e=a[s];return o(t)?Object.assign({},e,t):l(t,e)},set(t){this[r]=t}}})}apply(t){t.forEach((t=>t(this)))}}var ue=new de({_scriptable:t=>!t.startsWith("on"),_indexable:t=>"events"!==t,hover:{_fallback:"interaction"},interaction:{_scriptable:!1,_indexable:!1}},[function(t){t.set("animation",{delay:void 0,duration:1e3,easing:"easeOutQuart",fn:void 0,from:void 0,loop:void 0,to:void 0,type:void 0}),t.describe("animation",{_fallback:!1,_indexable:!1,_scriptable:t=>"onProgress"!==t&&"onComplete"!==t&&"fn"!==t}),t.set("animations",{colors:{type:"color",properties:ie},numbers:{type:"number",properties:ee}}),t.describe("animations",{_fallback:"animation"}),t.set("transitions",{active:{animation:{duration:400}},resize:{animation:{duration:0}},show:{animations:{colors:{from:"transparent"},visible:{type:"boolean",duration:0}}},hide:{animations:{colors:{to:"transparent"},visible:{type:"boolean",easing:"linear",fn:t=>0|t}}}})},function(t){t.set("layout",{autoPadding:!0,padding:{top:0,right:0,bottom:0,left:0}})},function(t){t.set("scale",{display:!0,offset:!1,reverse:!1,beginAtZero:!1,bounds:"ticks",clip:!0,grace:0,grid:{display:!0,lineWidth:1,drawOnChartArea:!0,drawTicks:!0,tickLength:8,tickWidth:(t,e)=>e.lineWidth,tickColor:(t,e)=>e.color,offset:!1},border:{display:!0,dash:[],dashOffset:0,width:1},title:{display:!1,text:"",padding:{top:4,bottom:4}},ticks:{minRotation:0,maxRotation:50,mirror:!1,textStrokeWidth:0,textStrokeColor:"",padding:3,display:!0,autoSkip:!0,autoSkipPadding:3,labelOffset:0,callback:ae.formatters.values,minor:{},major:{},align:"center",crossAlign:"near",showLabelBackdrop:!1,backdropColor:"rgba(255, 255, 255, 0.75)",backdropPadding:2}}),t.route("scale.ticks","color","","color"),t.route("scale.grid","color","","borderColor"),t.route("scale.border","color","","borderColor"),t.route("scale.title","color","","color"),t.describe("scale",{_fallback:!1,_scriptable:t=>!t.startsWith("before")&&!t.startsWith("after")&&"callback"!==t&&"parser"!==t,_indexable:t=>"borderDash"!==t&&"tickBorderDash"!==t&&"dash"!==t}),t.describe("scales",{_fallback:"scale"}),t.describe("scale.ticks",{_scriptable:t=>"backdropPadding"!==t&&"callback"!==t,_indexable:t=>"backdropPadding"!==t})}]);function fe(){return"undefined"!=typeof window&&"undefined"!=typeof document}function ge(t){let e=t.parentNode;return e&&"[object ShadowRoot]"===e.toString()&&(e=e.host),e}function pe(t,e,i){let s;return"string"==typeof t?(s=parseInt(t,10),-1!==t.indexOf("%")&&(s=s/100*e.parentNode[i])):s=t,s}const me=t=>t.ownerDocument.defaultView.getComputedStyle(t,null);function xe(t,e){return me(t).getPropertyValue(e)}const be=["top","right","bottom","left"];function _e(t,e,i){const s={};i=i?"-"+i:"";for(let n=0;n<4;n++){const o=be[n];s[o]=parseFloat(t[e+"-"+o+i])||0}return s.width=s.left+s.right,s.height=s.top+s.bottom,s}const ye=(t,e,i)=>(t>0||e>0)&&(!i||!i.shadowRoot);function ve(t,e){if("native"in t)return t;const{canvas:i,currentDevicePixelRatio:s}=e,n=me(i),o="border-box"===n.boxSizing,a=_e(n,"padding"),r=_e(n,"border","width"),{x:l,y:h,box:c}=function(t,e){const i=t.touches,s=i&&i.length?i[0]:t,{offsetX:n,offsetY:o}=s;let a,r,l=!1;if(ye(n,o,t.target))a=n,r=o;else{const t=e.getBoundingClientRect();a=s.clientX-t.left,r=s.clientY-t.top,l=!0}return{x:a,y:r,box:l}}(t,i),d=a.left+(c&&r.left),u=a.top+(c&&r.top);let{width:f,height:g}=e;return o&&(f-=a.width+r.width,g-=a.height+r.height),{x:Math.round((l-d)/f*i.width/s),y:Math.round((h-u)/g*i.height/s)}}const Me=t=>Math.round(10*t)/10;function we(t,e,i,s){const n=me(t),o=_e(n,"margin"),a=pe(n.maxWidth,t,"clientWidth")||T,r=pe(n.maxHeight,t,"clientHeight")||T,l=function(t,e,i){let s,n;if(void 0===e||void 0===i){const o=t&&ge(t);if(o){const t=o.getBoundingClientRect(),a=me(o),r=_e(a,"border","width"),l=_e(a,"padding");e=t.width-l.width-r.width,i=t.height-l.height-r.height,s=pe(a.maxWidth,o,"clientWidth"),n=pe(a.maxHeight,o,"clientHeight")}else e=t.clientWidth,i=t.clientHeight}return{width:e,height:i,maxWidth:s||T,maxHeight:n||T}}(t,e,i);let{width:h,height:c}=l;if("content-box"===n.boxSizing){const t=_e(n,"border","width"),e=_e(n,"padding");h-=e.width+t.width,c-=e.height+t.height}h=Math.max(0,h-o.width),c=Math.max(0,s?h/s:c-o.height),h=Me(Math.min(h,a,l.maxWidth)),c=Me(Math.min(c,r,l.maxHeight)),h&&!c&&(c=Me(h/2));return(void 0!==e||void 0!==i)&&s&&l.height&&c>l.height&&(c=l.height,h=Me(Math.floor(c*s))),{width:h,height:c}}function ke(t,e,i){const s=e||1,n=Math.floor(t.height*s),o=Math.floor(t.width*s);t.height=Math.floor(t.height),t.width=Math.floor(t.width);const a=t.canvas;return a.style&&(i||!a.style.height&&!a.style.width)&&(a.style.height=`${t.height}px`,a.style.width=`${t.width}px`),(t.currentDevicePixelRatio!==s||a.height!==n||a.width!==o)&&(t.currentDevicePixelRatio=s,a.height=n,a.width=o,t.ctx.setTransform(s,0,0,s,0,0),!0)}const Se=function(){let t=!1;try{const e={get passive(){return t=!0,!1}};fe()&&(window.addEventListener("test",null,e),window.removeEventListener("test",null,e))}catch(t){}return t}();function Pe(t,e){const i=xe(t,e),s=i&&i.match(/^(\d+)(\.\d+)?px$/);return s?+s[1]:void 0}function De(t){return!t||s(t.size)||s(t.family)?null:(t.style?t.style+" ":"")+(t.weight?t.weight+" ":"")+t.size+"px "+t.family}function Ce(t,e,i,s,n){let o=e[n];return o||(o=e[n]=t.measureText(n).width,i.push(n)),o>s&&(s=o),s}function Oe(t,e,i,s){let o=(s=s||{}).data=s.data||{},a=s.garbageCollect=s.garbageCollect||[];s.font!==e&&(o=s.data={},a=s.garbageCollect=[],s.font=e),t.save(),t.font=e;let r=0;const l=i.length;let h,c,d,u,f;for(h=0;h<l;h++)if(u=i[h],null==u||n(u)){if(n(u))for(c=0,d=u.length;c<d;c++)f=u[c],null==f||n(f)||(r=Ce(t,o,a,r,f))}else r=Ce(t,o,a,r,u);t.restore();const g=a.length/2;if(g>i.length){for(h=0;h<g;h++)delete o[a[h]];a.splice(0,g)}return r}function Ae(t,e,i){const s=t.currentDevicePixelRatio,n=0!==i?Math.max(i/2,.5):0;return Math.round((e-n)*s)/s+n}function Te(t,e){(e||t)&&((e=e||t.getContext("2d")).save(),e.resetTransform(),e.clearRect(0,0,t.width,t.height),e.restore())}function Le(t,e,i,s){Ee(t,e,i,s,null)}function Ee(t,e,i,s,n){let o,a,r,l,h,c,d,u;const f=e.pointStyle,g=e.rotation,p=e.radius;let m=(g||0)*L;if(f&&"object"==typeof f&&(o=f.toString(),"[object HTMLImageElement]"===o||"[object HTMLCanvasElement]"===o))return t.save(),t.translate(i,s),t.rotate(m),t.drawImage(f,-f.width/2,-f.height/2,f.width,f.height),void t.restore();if(!(isNaN(p)||p<=0)){switch(t.beginPath(),f){default:n?t.ellipse(i,s,n/2,p,0,0,O):t.arc(i,s,p,0,O),t.closePath();break;case"triangle":c=n?n/2:p,t.moveTo(i+Math.sin(m)*c,s-Math.cos(m)*p),m+=I,t.lineTo(i+Math.sin(m)*c,s-Math.cos(m)*p),m+=I,t.lineTo(i+Math.sin(m)*c,s-Math.cos(m)*p),t.closePath();break;case"rectRounded":h=.516*p,l=p-h,a=Math.cos(m+R)*l,d=Math.cos(m+R)*(n?n/2-h:l),r=Math.sin(m+R)*l,u=Math.sin(m+R)*(n?n/2-h:l),t.arc(i-d,s-r,h,m-C,m-E),t.arc(i+u,s-a,h,m-E,m),t.arc(i+d,s+r,h,m,m+E),t.arc(i-u,s+a,h,m+E,m+C),t.closePath();break;case"rect":if(!g){l=Math.SQRT1_2*p,c=n?n/2:l,t.rect(i-c,s-l,2*c,2*l);break}m+=R;case"rectRot":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+u,s-a),t.lineTo(i+d,s+r),t.lineTo(i-u,s+a),t.closePath();break;case"crossRot":m+=R;case"cross":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a);break;case"star":d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a),m+=R,d=Math.cos(m)*(n?n/2:p),a=Math.cos(m)*p,r=Math.sin(m)*p,u=Math.sin(m)*(n?n/2:p),t.moveTo(i-d,s-r),t.lineTo(i+d,s+r),t.moveTo(i+u,s-a),t.lineTo(i-u,s+a);break;case"line":a=n?n/2:Math.cos(m)*p,r=Math.sin(m)*p,t.moveTo(i-a,s-r),t.lineTo(i+a,s+r);break;case"dash":t.moveTo(i,s),t.lineTo(i+Math.cos(m)*(n?n/2:p),s+Math.sin(m)*p);break;case!1:t.closePath()}t.fill(),e.borderWidth>0&&t.stroke()}}function Re(t,e,i){return i=i||.5,!e||t&&t.x>e.left-i&&t.x<e.right+i&&t.y>e.top-i&&t.y<e.bottom+i}function Ie(t,e){t.save(),t.beginPath(),t.rect(e.left,e.top,e.right-e.left,e.bottom-e.top),t.clip()}function ze(t){t.restore()}function Fe(t,e,i,s,n){if(!e)return t.lineTo(i.x,i.y);if("middle"===n){const s=(e.x+i.x)/2;t.lineTo(s,e.y),t.lineTo(s,i.y)}else"after"===n!=!!s?t.lineTo(e.x,i.y):t.lineTo(i.x,e.y);t.lineTo(i.x,i.y)}function Ve(t,e,i,s){if(!e)return t.lineTo(i.x,i.y);t.bezierCurveTo(s?e.cp1x:e.cp2x,s?e.cp1y:e.cp2y,s?i.cp2x:i.cp1x,s?i.cp2y:i.cp1y,i.x,i.y)}function Be(t,e,i,s,n){if(n.strikethrough||n.underline){const o=t.measureText(s),a=e-o.actualBoundingBoxLeft,r=e+o.actualBoundingBoxRight,l=i-o.actualBoundingBoxAscent,h=i+o.actualBoundingBoxDescent,c=n.strikethrough?(l+h)/2:h;t.strokeStyle=t.fillStyle,t.beginPath(),t.lineWidth=n.decorationWidth||2,t.moveTo(a,c),t.lineTo(r,c),t.stroke()}}function We(t,e){const i=t.fillStyle;t.fillStyle=e.color,t.fillRect(e.left,e.top,e.width,e.height),t.fillStyle=i}function Ne(t,e,i,o,a,r={}){const l=n(e)?e:[e],h=r.strokeWidth>0&&""!==r.strokeColor;let c,d;for(t.save(),t.font=a.string,function(t,e){e.translation&&t.translate(e.translation[0],e.translation[1]),s(e.rotation)||t.rotate(e.rotation),e.color&&(t.fillStyle=e.color),e.textAlign&&(t.textAlign=e.textAlign),e.textBaseline&&(t.textBaseline=e.textBaseline)}(t,r),c=0;c<l.length;++c)d=l[c],r.backdrop&&We(t,r.backdrop),h&&(r.strokeColor&&(t.strokeStyle=r.strokeColor),s(r.strokeWidth)||(t.lineWidth=r.strokeWidth),t.strokeText(d,i,o,r.maxWidth)),t.fillText(d,i,o,r.maxWidth),Be(t,i,o,d,r),o+=Number(a.lineHeight);t.restore()}function He(t,e){const{x:i,y:s,w:n,h:o,radius:a}=e;t.arc(i+a.topLeft,s+a.topLeft,a.topLeft,1.5*C,C,!0),t.lineTo(i,s+o-a.bottomLeft),t.arc(i+a.bottomLeft,s+o-a.bottomLeft,a.bottomLeft,C,E,!0),t.lineTo(i+n-a.bottomRight,s+o),t.arc(i+n-a.bottomRight,s+o-a.bottomRight,a.bottomRight,E,0,!0),t.lineTo(i+n,s+a.topRight),t.arc(i+n-a.topRight,s+a.topRight,a.topRight,0,-E,!0),t.lineTo(i+a.topLeft,s)}function je(t,e=[""],i,s,n=(()=>t[0])){const o=i||t;void 0===s&&(s=ti("_fallback",t));const a={[Symbol.toStringTag]:"Object",_cacheable:!0,_scopes:t,_rootScopes:o,_fallback:s,_getTarget:n,override:i=>je([i,...t],e,o,s)};return new Proxy(a,{deleteProperty:(e,i)=>(delete e[i],delete e._keys,delete t[0][i],!0),get:(i,s)=>qe(i,s,(()=>function(t,e,i,s){let n;for(const o of e)if(n=ti(Ue(o,t),i),void 0!==n)return Xe(t,n)?Je(i,s,t,n):n}(s,e,t,i))),getOwnPropertyDescriptor:(t,e)=>Reflect.getOwnPropertyDescriptor(t._scopes[0],e),getPrototypeOf:()=>Reflect.getPrototypeOf(t[0]),has:(t,e)=>ei(t).includes(e),ownKeys:t=>ei(t),set(t,e,i){const s=t._storage||(t._storage=n());return t[e]=s[e]=i,delete t._keys,!0}})}function $e(t,e,i,s){const a={_cacheable:!1,_proxy:t,_context:e,_subProxy:i,_stack:new Set,_descriptors:Ye(t,s),setContext:e=>$e(t,e,i,s),override:n=>$e(t.override(n),e,i,s)};return new Proxy(a,{deleteProperty:(e,i)=>(delete e[i],delete t[i],!0),get:(t,e,i)=>qe(t,e,(()=>function(t,e,i){const{_proxy:s,_context:a,_subProxy:r,_descriptors:l}=t;let h=s[e];S(h)&&l.isScriptable(e)&&(h=function(t,e,i,s){const{_proxy:n,_context:o,_subProxy:a,_stack:r}=i;if(r.has(t))throw new Error("Recursion detected: "+Array.from(r).join("->")+"->"+t);r.add(t);let l=e(o,a||s);r.delete(t),Xe(t,l)&&(l=Je(n._scopes,n,t,l));return l}(e,h,t,i));n(h)&&h.length&&(h=function(t,e,i,s){const{_proxy:n,_context:a,_subProxy:r,_descriptors:l}=i;if(void 0!==a.index&&s(t))return e[a.index%e.length];if(o(e[0])){const i=e,s=n._scopes.filter((t=>t!==i));e=[];for(const o of i){const i=Je(s,n,t,o);e.push($e(i,a,r&&r[t],l))}}return e}(e,h,t,l.isIndexable));Xe(e,h)&&(h=$e(h,a,r&&r[e],l));return h}(t,e,i))),getOwnPropertyDescriptor:(e,i)=>e._descriptors.allKeys?Reflect.has(t,i)?{enumerable:!0,configurable:!0}:void 0:Reflect.getOwnPropertyDescriptor(t,i),getPrototypeOf:()=>Reflect.getPrototypeOf(t),has:(e,i)=>Reflect.has(t,i),ownKeys:()=>Reflect.ownKeys(t),set:(e,i,s)=>(t[i]=s,delete e[i],!0)})}function Ye(t,e={scriptable:!0,indexable:!0}){const{_scriptable:i=e.scriptable,_indexable:s=e.indexable,_allKeys:n=e.allKeys}=t;return{allKeys:n,scriptable:i,indexable:s,isScriptable:S(i)?i:()=>i,isIndexable:S(s)?s:()=>s}}const Ue=(t,e)=>t?t+w(e):e,Xe=(t,e)=>o(e)&&"adapters"!==t&&(null===Object.getPrototypeOf(e)||e.constructor===Object);function qe(t,e,i){if(Object.prototype.hasOwnProperty.call(t,e)||"constructor"===e)return t[e];const s=i();return t[e]=s,s}function Ke(t,e,i){return S(t)?t(e,i):t}const Ge=(t,e)=>!0===t?e:"string"==typeof t?M(e,t):void 0;function Ze(t,e,i,s,n){for(const o of e){const e=Ge(i,o);if(e){t.add(e);const o=Ke(e._fallback,i,n);if(void 0!==o&&o!==i&&o!==s)return o}else if(!1===e&&void 0!==s&&i!==s)return null}return!1}function Je(t,e,i,s){const a=e._rootScopes,r=Ke(e._fallback,i,s),l=[...t,...a],h=new Set;h.add(s);let c=Qe(h,l,i,r||i,s);return null!==c&&((void 0===r||r===i||(c=Qe(h,l,r,c,s),null!==c))&&je(Array.from(h),[""],a,r,(()=>function(t,e,i){const s=t._getTarget();e in s||(s[e]={});const a=s[e];if(n(a)&&o(i))return i;return a||{}}(e,i,s))))}function Qe(t,e,i,s,n){for(;i;)i=Ze(t,e,i,s,n);return i}function ti(t,e){for(const i of e){if(!i)continue;const e=i[t];if(void 0!==e)return e}}function ei(t){let e=t._keys;return e||(e=t._keys=function(t){const e=new Set;for(const i of t)for(const t of Object.keys(i).filter((t=>!t.startsWith("_"))))e.add(t);return Array.from(e)}(t._scopes)),e}function ii(t,e,i,s){const{iScale:n}=t,{key:o="r"}=this._parsing,a=new Array(s);let r,l,h,c;for(r=0,l=s;r<l;++r)h=r+i,c=e[h],a[r]={r:n.parse(M(c,o),h)};return a}const si=Number.EPSILON||1e-14,ni=(t,e)=>e<t.length&&!t[e].skip&&t[e],oi=t=>"x"===t?"y":"x";function ai(t,e,i,s){const n=t.skip?e:t,o=e,a=i.skip?e:i,r=q(o,n),l=q(a,o);let h=r/(r+l),c=l/(r+l);h=isNaN(h)?0:h,c=isNaN(c)?0:c;const d=s*h,u=s*c;return{previous:{x:o.x-d*(a.x-n.x),y:o.y-d*(a.y-n.y)},next:{x:o.x+u*(a.x-n.x),y:o.y+u*(a.y-n.y)}}}function ri(t,e="x"){const i=oi(e),s=t.length,n=Array(s).fill(0),o=Array(s);let a,r,l,h=ni(t,0);for(a=0;a<s;++a)if(r=l,l=h,h=ni(t,a+1),l){if(h){const t=h[e]-l[e];n[a]=0!==t?(h[i]-l[i])/t:0}o[a]=r?h?F(n[a-1])!==F(n[a])?0:(n[a-1]+n[a])/2:n[a-1]:n[a]}!function(t,e,i){const s=t.length;let n,o,a,r,l,h=ni(t,0);for(let c=0;c<s-1;++c)l=h,h=ni(t,c+1),l&&h&&(V(e[c],0,si)?i[c]=i[c+1]=0:(n=i[c]/e[c],o=i[c+1]/e[c],r=Math.pow(n,2)+Math.pow(o,2),r<=9||(a=3/Math.sqrt(r),i[c]=n*a*e[c],i[c+1]=o*a*e[c])))}(t,n,o),function(t,e,i="x"){const s=oi(i),n=t.length;let o,a,r,l=ni(t,0);for(let h=0;h<n;++h){if(a=r,r=l,l=ni(t,h+1),!r)continue;const n=r[i],c=r[s];a&&(o=(n-a[i])/3,r[`cp1${i}`]=n-o,r[`cp1${s}`]=c-o*e[h]),l&&(o=(l[i]-n)/3,r[`cp2${i}`]=n+o,r[`cp2${s}`]=c+o*e[h])}}(t,o,e)}function li(t,e,i){return Math.max(Math.min(t,i),e)}function hi(t,e,i,s,n){let o,a,r,l;if(e.spanGaps&&(t=t.filter((t=>!t.skip))),"monotone"===e.cubicInterpolationMode)ri(t,n);else{let i=s?t[t.length-1]:t[0];for(o=0,a=t.length;o<a;++o)r=t[o],l=ai(i,r,t[Math.min(o+1,a-(s?0:1))%a],e.tension),r.cp1x=l.previous.x,r.cp1y=l.previous.y,r.cp2x=l.next.x,r.cp2y=l.next.y,i=r}e.capBezierPoints&&function(t,e){let i,s,n,o,a,r=Re(t[0],e);for(i=0,s=t.length;i<s;++i)a=o,o=r,r=i<s-1&&Re(t[i+1],e),o&&(n=t[i],a&&(n.cp1x=li(n.cp1x,e.left,e.right),n.cp1y=li(n.cp1y,e.top,e.bottom)),r&&(n.cp2x=li(n.cp2x,e.left,e.right),n.cp2y=li(n.cp2y,e.top,e.bottom)))}(t,i)}const ci=t=>0===t||1===t,di=(t,e,i)=>-Math.pow(2,10*(t-=1))*Math.sin((t-e)*O/i),ui=(t,e,i)=>Math.pow(2,-10*t)*Math.sin((t-e)*O/i)+1,fi={linear:t=>t,easeInQuad:t=>t*t,easeOutQuad:t=>-t*(t-2),easeInOutQuad:t=>(t/=.5)<1?.5*t*t:-.5*(--t*(t-2)-1),easeInCubic:t=>t*t*t,easeOutCubic:t=>(t-=1)*t*t+1,easeInOutCubic:t=>(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2),easeInQuart:t=>t*t*t*t,easeOutQuart:t=>-((t-=1)*t*t*t-1),easeInOutQuart:t=>(t/=.5)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2),easeInQuint:t=>t*t*t*t*t,easeOutQuint:t=>(t-=1)*t*t*t*t+1,easeInOutQuint:t=>(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2),easeInSine:t=>1-Math.cos(t*E),easeOutSine:t=>Math.sin(t*E),easeInOutSine:t=>-.5*(Math.cos(C*t)-1),easeInExpo:t=>0===t?0:Math.pow(2,10*(t-1)),easeOutExpo:t=>1===t?1:1-Math.pow(2,-10*t),easeInOutExpo:t=>ci(t)?t:t<.5?.5*Math.pow(2,10*(2*t-1)):.5*(2-Math.pow(2,-10*(2*t-1))),easeInCirc:t=>t>=1?t:-(Math.sqrt(1-t*t)-1),easeOutCirc:t=>Math.sqrt(1-(t-=1)*t),easeInOutCirc:t=>(t/=.5)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1),easeInElastic:t=>ci(t)?t:di(t,.075,.3),easeOutElastic:t=>ci(t)?t:ui(t,.075,.3),easeInOutElastic(t){const e=.1125;return ci(t)?t:t<.5?.5*di(2*t,e,.45):.5+.5*ui(2*t-1,e,.45)},easeInBack(t){const e=1.70158;return t*t*((e+1)*t-e)},easeOutBack(t){const e=1.70158;return(t-=1)*t*((e+1)*t+e)+1},easeInOutBack(t){let e=1.70158;return(t/=.5)<1?t*t*((1+(e*=1.525))*t-e)*.5:.5*((t-=2)*t*((1+(e*=1.525))*t+e)+2)},easeInBounce:t=>1-fi.easeOutBounce(1-t),easeOutBounce(t){const e=7.5625,i=2.75;return t<1/i?e*t*t:t<2/i?e*(t-=1.5/i)*t+.75:t<2.5/i?e*(t-=2.25/i)*t+.9375:e*(t-=2.625/i)*t+.984375},easeInOutBounce:t=>t<.5?.5*fi.easeInBounce(2*t):.5*fi.easeOutBounce(2*t-1)+.5};function gi(t,e,i,s){return{x:t.x+i*(e.x-t.x),y:t.y+i*(e.y-t.y)}}function pi(t,e,i,s){return{x:t.x+i*(e.x-t.x),y:"middle"===s?i<.5?t.y:e.y:"after"===s?i<1?t.y:e.y:i>0?e.y:t.y}}function mi(t,e,i,s){const n={x:t.cp2x,y:t.cp2y},o={x:e.cp1x,y:e.cp1y},a=gi(t,n,i),r=gi(n,o,i),l=gi(o,e,i),h=gi(a,r,i),c=gi(r,l,i);return gi(h,c,i)}const xi=/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/,bi=/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;function _i(t,e){const i=(""+t).match(xi);if(!i||"normal"===i[1])return 1.2*e;switch(t=+i[2],i[3]){case"px":return t;case"%":t/=100}return e*t}const yi=t=>+t||0;function vi(t,e){const i={},s=o(e),n=s?Object.keys(e):e,a=o(t)?s?i=>l(t[i],t[e[i]]):e=>t[e]:()=>t;for(const t of n)i[t]=yi(a(t));return i}function Mi(t){return vi(t,{top:"y",right:"x",bottom:"y",left:"x"})}function wi(t){return vi(t,["topLeft","topRight","bottomLeft","bottomRight"])}function ki(t){const e=Mi(t);return e.width=e.left+e.right,e.height=e.top+e.bottom,e}function Si(t,e){t=t||{},e=e||ue.font;let i=l(t.size,e.size);"string"==typeof i&&(i=parseInt(i,10));let s=l(t.style,e.style);s&&!(""+s).match(bi)&&(console.warn('Invalid font style specified: "'+s+'"'),s=void 0);const n={family:l(t.family,e.family),lineHeight:_i(l(t.lineHeight,e.lineHeight),i),size:i,style:s,weight:l(t.weight,e.weight),string:""};return n.string=De(n),n}function Pi(t,e,i,s){let o,a,r,l=!0;for(o=0,a=t.length;o<a;++o)if(r=t[o],void 0!==r&&(void 0!==e&&"function"==typeof r&&(r=r(e),l=!1),void 0!==i&&n(r)&&(r=r[i%r.length],l=!1),void 0!==r))return s&&!l&&(s.cacheable=!1),r}function Di(t,e,i){const{min:s,max:n}=t,o=c(e,(n-s)/2),a=(t,e)=>i&&0===t?0:t+e;return{min:a(s,-Math.abs(o)),max:a(n,o)}}function Ci(t,e){return Object.assign(Object.create(t),e)}function Oi(t,e,i){return t?function(t,e){return{x:i=>t+t+e-i,setWidth(t){e=t},textAlign:t=>"center"===t?t:"right"===t?"left":"right",xPlus:(t,e)=>t-e,leftForLtr:(t,e)=>t-e}}(e,i):{x:t=>t,setWidth(t){},textAlign:t=>t,xPlus:(t,e)=>t+e,leftForLtr:(t,e)=>t}}function Ai(t,e){let i,s;"ltr"!==e&&"rtl"!==e||(i=t.canvas.style,s=[i.getPropertyValue("direction"),i.getPropertyPriority("direction")],i.setProperty("direction",e,"important"),t.prevTextDirection=s)}function Ti(t,e){void 0!==e&&(delete t.prevTextDirection,t.canvas.style.setProperty("direction",e[0],e[1]))}function Li(t){return"angle"===t?{between:Z,compare:K,normalize:G}:{between:tt,compare:(t,e)=>t-e,normalize:t=>t}}function Ei({start:t,end:e,count:i,loop:s,style:n}){return{start:t%i,end:e%i,loop:s&&(e-t+1)%i==0,style:n}}function Ri(t,e,i){if(!i)return[t];const{property:s,start:n,end:o}=i,a=e.length,{compare:r,between:l,normalize:h}=Li(s),{start:c,end:d,loop:u,style:f}=function(t,e,i){const{property:s,start:n,end:o}=i,{between:a,normalize:r}=Li(s),l=e.length;let h,c,{start:d,end:u,loop:f}=t;if(f){for(d+=l,u+=l,h=0,c=l;h<c&&a(r(e[d%l][s]),n,o);++h)d--,u--;d%=l,u%=l}return u<d&&(u+=l),{start:d,end:u,loop:f,style:t.style}}(t,e,i),g=[];let p,m,x,b=!1,_=null;const y=()=>b||l(n,x,p)&&0!==r(n,x),v=()=>!b||0===r(o,p)||l(o,x,p);for(let t=c,i=c;t<=d;++t)m=e[t%a],m.skip||(p=h(m[s]),p!==x&&(b=l(p,n,o),null===_&&y()&&(_=0===r(p,n)?t:i),null!==_&&v()&&(g.push(Ei({start:_,end:t,loop:u,count:a,style:f})),_=null),i=t,x=p));return null!==_&&g.push(Ei({start:_,end:d,loop:u,count:a,style:f})),g}function Ii(t,e){const i=[],s=t.segments;for(let n=0;n<s.length;n++){const o=Ri(s[n],t.points,e);o.length&&i.push(...o)}return i}function zi(t,e){const i=t.points,s=t.options.spanGaps,n=i.length;if(!n)return[];const o=!!t._loop,{start:a,end:r}=function(t,e,i,s){let n=0,o=e-1;if(i&&!s)for(;n<e&&!t[n].skip;)n++;for(;n<e&&t[n].skip;)n++;for(n%=e,i&&(o+=n);o>n&&t[o%e].skip;)o--;return o%=e,{start:n,end:o}}(i,n,o,s);if(!0===s)return Fi(t,[{start:a,end:r,loop:o}],i,e);return Fi(t,function(t,e,i,s){const n=t.length,o=[];let a,r=e,l=t[e];for(a=e+1;a<=i;++a){const i=t[a%n];i.skip||i.stop?l.skip||(s=!1,o.push({start:e%n,end:(a-1)%n,loop:s}),e=r=i.stop?a:null):(r=a,l.skip&&(e=a)),l=i}return null!==r&&o.push({start:e%n,end:r%n,loop:s}),o}(i,a,r<a?r+n:r,!!t._fullLoop&&0===a&&r===n-1),i,e)}function Fi(t,e,i,s){return s&&s.setContext&&i?function(t,e,i,s){const n=t._chart.getContext(),o=Vi(t.options),{_datasetIndex:a,options:{spanGaps:r}}=t,l=i.length,h=[];let c=o,d=e[0].start,u=d;function f(t,e,s,n){const o=r?-1:1;if(t!==e){for(t+=l;i[t%l].skip;)t-=o;for(;i[e%l].skip;)e+=o;t%l!=e%l&&(h.push({start:t%l,end:e%l,loop:s,style:n}),c=n,d=e%l)}}for(const t of e){d=r?d:t.start;let e,o=i[d%l];for(u=d+1;u<=t.end;u++){const r=i[u%l];e=Vi(s.setContext(Ci(n,{type:"segment",p0:o,p1:r,p0DataIndex:(u-1)%l,p1DataIndex:u%l,datasetIndex:a}))),Bi(e,c)&&f(d,u-1,t.loop,c),o=r,c=e}d<u-1&&f(d,u-1,t.loop,c)}return h}(t,e,i,s):e}function Vi(t){return{backgroundColor:t.backgroundColor,borderCapStyle:t.borderCapStyle,borderDash:t.borderDash,borderDashOffset:t.borderDashOffset,borderJoinStyle:t.borderJoinStyle,borderWidth:t.borderWidth,borderColor:t.borderColor}}function Bi(t,e){if(!e)return!1;const i=[],s=function(t,e){return Jt(e)?(i.includes(e)||i.push(e),i.indexOf(e)):e};return JSON.stringify(t,s)!==JSON.stringify(e,s)}var Wi=Object.freeze({__proto__:null,HALF_PI:E,INFINITY:T,PI:C,PITAU:A,QUARTER_PI:R,RAD_PER_DEG:L,TAU:O,TWO_THIRDS_PI:I,_addGrace:Di,_alignPixel:Ae,_alignStartEnd:ft,_angleBetween:Z,_angleDiff:K,_arrayUnique:lt,_attachContext:$e,_bezierCurveTo:Ve,_bezierInterpolation:mi,_boundSegment:Ri,_boundSegments:Ii,_capitalize:w,_computeSegments:zi,_createResolver:je,_decimalPlaces:U,_deprecated:function(t,e,i,s){void 0!==e&&console.warn(t+': "'+i+'" is deprecated. Please use "'+s+'" instead')},_descriptors:Ye,_elementsEqual:f,_factorize:W,_filterBetween:nt,_getParentNode:ge,_getStartAndCountOfVisiblePoints:pt,_int16Range:Q,_isBetween:tt,_isClickEvent:D,_isDomSupported:fe,_isPointInArea:Re,_limitValue:J,_longestText:Oe,_lookup:et,_lookupByKey:it,_measureText:Ce,_merger:m,_mergerIf:_,_normalizeAngle:G,_parseObjectDataRadialScale:ii,_pointInLine:gi,_readValueToProps:vi,_rlookupByKey:st,_scaleRangesChanged:mt,_setMinAndMaxByKey:j,_splitKey:v,_steppedInterpolation:pi,_steppedLineTo:Fe,_textX:gt,_toLeftRightCenter:ut,_updateBezierControlPoints:hi,addRoundedRectPath:He,almostEquals:V,almostWhole:H,callback:d,clearCanvas:Te,clipArea:Ie,clone:g,color:Qt,createContext:Ci,debounce:dt,defined:k,distanceBetweenPoints:q,drawPoint:Le,drawPointLegend:Ee,each:u,easingEffects:fi,finiteOrDefault:r,fontString:function(t,e,i){return e+" "+t+"px "+i},formatNumber:ne,getAngleFromPoint:X,getHoverColor:te,getMaximumSize:we,getRelativePosition:ve,getRtlAdapter:Oi,getStyle:xe,isArray:n,isFinite:a,isFunction:S,isNullOrUndef:s,isNumber:N,isObject:o,isPatternOrGradient:Jt,listenArrayEvents:at,log10:z,merge:x,mergeIf:b,niceNum:B,noop:e,overrideTextDirection:Ai,readUsedSize:Pe,renderText:Ne,requestAnimFrame:ht,resolve:Pi,resolveObjectKey:M,restoreTextDirection:Ti,retinaScale:ke,setsEqual:P,sign:F,splineCurve:ai,splineCurveMonotone:ri,supportsEventListenerOptions:Se,throttled:ct,toDegrees:Y,toDimension:c,toFont:Si,toFontString:De,toLineHeight:_i,toPadding:ki,toPercentage:h,toRadians:$,toTRBL:Mi,toTRBLCorners:wi,uid:i,unclipArea:ze,unlistenArrayEvents:rt,valueOrDefault:l});function Ni(t,e,i,n){const{controller:o,data:a,_sorted:r}=t,l=o._cachedMeta.iScale,h=t.dataset&&t.dataset.options?t.dataset.options.spanGaps:null;if(l&&e===l.axis&&"r"!==e&&r&&a.length){const r=l._reversePixels?st:it;if(!n){const n=r(a,e,i);if(h){const{vScale:e}=o._cachedMeta,{_parsed:i}=t,a=i.slice(0,n.lo+1).reverse().findIndex((t=>!s(t[e.axis])));n.lo-=Math.max(0,a);const r=i.slice(n.hi).findIndex((t=>!s(t[e.axis])));n.hi+=Math.max(0,r)}return n}if(o._sharedOptions){const t=a[0],s="function"==typeof t.getRange&&t.getRange(e);if(s){const t=r(a,e,i-s),n=r(a,e,i+s);return{lo:t.lo,hi:n.hi}}}}return{lo:0,hi:a.length-1}}function Hi(t,e,i,s,n){const o=t.getSortedVisibleDatasetMetas(),a=i[e];for(let t=0,i=o.length;t<i;++t){const{index:i,data:r}=o[t],{lo:l,hi:h}=Ni(o[t],e,a,n);for(let t=l;t<=h;++t){const e=r[t];e.skip||s(e,i,t)}}}function ji(t,e,i,s,n){const o=[];if(!n&&!t.isPointInArea(e))return o;return Hi(t,i,e,(function(i,a,r){(n||Re(i,t.chartArea,0))&&i.inRange(e.x,e.y,s)&&o.push({element:i,datasetIndex:a,index:r})}),!0),o}function $i(t,e,i,s,n,o){let a=[];const r=function(t){const e=-1!==t.indexOf("x"),i=-1!==t.indexOf("y");return function(t,s){const n=e?Math.abs(t.x-s.x):0,o=i?Math.abs(t.y-s.y):0;return Math.sqrt(Math.pow(n,2)+Math.pow(o,2))}}(i);let l=Number.POSITIVE_INFINITY;return Hi(t,i,e,(function(i,h,c){const d=i.inRange(e.x,e.y,n);if(s&&!d)return;const u=i.getCenterPoint(n);if(!(!!o||t.isPointInArea(u))&&!d)return;const f=r(e,u);f<l?(a=[{element:i,datasetIndex:h,index:c}],l=f):f===l&&a.push({element:i,datasetIndex:h,index:c})})),a}function Yi(t,e,i,s,n,o){return o||t.isPointInArea(e)?"r"!==i||s?$i(t,e,i,s,n,o):function(t,e,i,s){let n=[];return Hi(t,i,e,(function(t,i,o){const{startAngle:a,endAngle:r}=t.getProps(["startAngle","endAngle"],s),{angle:l}=X(t,{x:e.x,y:e.y});Z(l,a,r)&&n.push({element:t,datasetIndex:i,index:o})})),n}(t,e,i,n):[]}function Ui(t,e,i,s,n){const o=[],a="x"===i?"inXRange":"inYRange";let r=!1;return Hi(t,i,e,((t,s,l)=>{t[a]&&t[a](e[i],n)&&(o.push({element:t,datasetIndex:s,index:l}),r=r||t.inRange(e.x,e.y,n))})),s&&!r?[]:o}var Xi={evaluateInteractionItems:Hi,modes:{index(t,e,i,s){const n=ve(e,t),o=i.axis||"x",a=i.includeInvisible||!1,r=i.intersect?ji(t,n,o,s,a):Yi(t,n,o,!1,s,a),l=[];return r.length?(t.getSortedVisibleDatasetMetas().forEach((t=>{const e=r[0].index,i=t.data[e];i&&!i.skip&&l.push({element:i,datasetIndex:t.index,index:e})})),l):[]},dataset(t,e,i,s){const n=ve(e,t),o=i.axis||"xy",a=i.includeInvisible||!1;let r=i.intersect?ji(t,n,o,s,a):Yi(t,n,o,!1,s,a);if(r.length>0){const e=r[0].datasetIndex,i=t.getDatasetMeta(e).data;r=[];for(let t=0;t<i.length;++t)r.push({element:i[t],datasetIndex:e,index:t})}return r},point:(t,e,i,s)=>ji(t,ve(e,t),i.axis||"xy",s,i.includeInvisible||!1),nearest(t,e,i,s){const n=ve(e,t),o=i.axis||"xy",a=i.includeInvisible||!1;return Yi(t,n,o,i.intersect,s,a)},x:(t,e,i,s)=>Ui(t,ve(e,t),"x",i.intersect,s),y:(t,e,i,s)=>Ui(t,ve(e,t),"y",i.intersect,s)}};const qi=["left","top","right","bottom"];function Ki(t,e){return t.filter((t=>t.pos===e))}function Gi(t,e){return t.filter((t=>-1===qi.indexOf(t.pos)&&t.box.axis===e))}function Zi(t,e){return t.sort(((t,i)=>{const s=e?i:t,n=e?t:i;return s.weight===n.weight?s.index-n.index:s.weight-n.weight}))}function Ji(t,e){const i=function(t){const e={};for(const i of t){const{stack:t,pos:s,stackWeight:n}=i;if(!t||!qi.includes(s))continue;const o=e[t]||(e[t]={count:0,placed:0,weight:0,size:0});o.count++,o.weight+=n}return e}(t),{vBoxMaxWidth:s,hBoxMaxHeight:n}=e;let o,a,r;for(o=0,a=t.length;o<a;++o){r=t[o];const{fullSize:a}=r.box,l=i[r.stack],h=l&&r.stackWeight/l.weight;r.horizontal?(r.width=h?h*s:a&&e.availableWidth,r.height=n):(r.width=s,r.height=h?h*n:a&&e.availableHeight)}return i}function Qi(t,e,i,s){return Math.max(t[i],e[i])+Math.max(t[s],e[s])}function ts(t,e){t.top=Math.max(t.top,e.top),t.left=Math.max(t.left,e.left),t.bottom=Math.max(t.bottom,e.bottom),t.right=Math.max(t.right,e.right)}function es(t,e,i,s){const{pos:n,box:a}=i,r=t.maxPadding;if(!o(n)){i.size&&(t[n]-=i.size);const e=s[i.stack]||{size:0,count:1};e.size=Math.max(e.size,i.horizontal?a.height:a.width),i.size=e.size/e.count,t[n]+=i.size}a.getPadding&&ts(r,a.getPadding());const l=Math.max(0,e.outerWidth-Qi(r,t,"left","right")),h=Math.max(0,e.outerHeight-Qi(r,t,"top","bottom")),c=l!==t.w,d=h!==t.h;return t.w=l,t.h=h,i.horizontal?{same:c,other:d}:{same:d,other:c}}function is(t,e){const i=e.maxPadding;function s(t){const s={left:0,top:0,right:0,bottom:0};return t.forEach((t=>{s[t]=Math.max(e[t],i[t])})),s}return s(t?["left","right"]:["top","bottom"])}function ss(t,e,i,s){const n=[];let o,a,r,l,h,c;for(o=0,a=t.length,h=0;o<a;++o){r=t[o],l=r.box,l.update(r.width||e.w,r.height||e.h,is(r.horizontal,e));const{same:a,other:d}=es(e,i,r,s);h|=a&&n.length,c=c||d,l.fullSize||n.push(r)}return h&&ss(n,e,i,s)||c}function ns(t,e,i,s,n){t.top=i,t.left=e,t.right=e+s,t.bottom=i+n,t.width=s,t.height=n}function os(t,e,i,s){const n=i.padding;let{x:o,y:a}=e;for(const r of t){const t=r.box,l=s[r.stack]||{count:1,placed:0,weight:1},h=r.stackWeight/l.weight||1;if(r.horizontal){const s=e.w*h,o=l.size||t.height;k(l.start)&&(a=l.start),t.fullSize?ns(t,n.left,a,i.outerWidth-n.right-n.left,o):ns(t,e.left+l.placed,a,s,o),l.start=a,l.placed+=s,a=t.bottom}else{const s=e.h*h,a=l.size||t.width;k(l.start)&&(o=l.start),t.fullSize?ns(t,o,n.top,a,i.outerHeight-n.bottom-n.top):ns(t,o,e.top+l.placed,a,s),l.start=o,l.placed+=s,o=t.right}}e.x=o,e.y=a}var as={addBox(t,e){t.boxes||(t.boxes=[]),e.fullSize=e.fullSize||!1,e.position=e.position||"top",e.weight=e.weight||0,e._layers=e._layers||function(){return[{z:0,draw(t){e.draw(t)}}]},t.boxes.push(e)},removeBox(t,e){const i=t.boxes?t.boxes.indexOf(e):-1;-1!==i&&t.boxes.splice(i,1)},configure(t,e,i){e.fullSize=i.fullSize,e.position=i.position,e.weight=i.weight},update(t,e,i,s){if(!t)return;const n=ki(t.options.layout.padding),o=Math.max(e-n.width,0),a=Math.max(i-n.height,0),r=function(t){const e=function(t){const e=[];let i,s,n,o,a,r;for(i=0,s=(t||[]).length;i<s;++i)n=t[i],({position:o,options:{stack:a,stackWeight:r=1}}=n),e.push({index:i,box:n,pos:o,horizontal:n.isHorizontal(),weight:n.weight,stack:a&&o+a,stackWeight:r});return e}(t),i=Zi(e.filter((t=>t.box.fullSize)),!0),s=Zi(Ki(e,"left"),!0),n=Zi(Ki(e,"right")),o=Zi(Ki(e,"top"),!0),a=Zi(Ki(e,"bottom")),r=Gi(e,"x"),l=Gi(e,"y");return{fullSize:i,leftAndTop:s.concat(o),rightAndBottom:n.concat(l).concat(a).concat(r),chartArea:Ki(e,"chartArea"),vertical:s.concat(n).concat(l),horizontal:o.concat(a).concat(r)}}(t.boxes),l=r.vertical,h=r.horizontal;u(t.boxes,(t=>{"function"==typeof t.beforeLayout&&t.beforeLayout()}));const c=l.reduce(((t,e)=>e.box.options&&!1===e.box.options.display?t:t+1),0)||1,d=Object.freeze({outerWidth:e,outerHeight:i,padding:n,availableWidth:o,availableHeight:a,vBoxMaxWidth:o/2/c,hBoxMaxHeight:a/2}),f=Object.assign({},n);ts(f,ki(s));const g=Object.assign({maxPadding:f,w:o,h:a,x:n.left,y:n.top},n),p=Ji(l.concat(h),d);ss(r.fullSize,g,d,p),ss(l,g,d,p),ss(h,g,d,p)&&ss(l,g,d,p),function(t){const e=t.maxPadding;function i(i){const s=Math.max(e[i]-t[i],0);return t[i]+=s,s}t.y+=i("top"),t.x+=i("left"),i("right"),i("bottom")}(g),os(r.leftAndTop,g,d,p),g.x+=g.w,g.y+=g.h,os(r.rightAndBottom,g,d,p),t.chartArea={left:g.left,top:g.top,right:g.left+g.w,bottom:g.top+g.h,height:g.h,width:g.w},u(r.chartArea,(e=>{const i=e.box;Object.assign(i,t.chartArea),i.update(g.w,g.h,{left:0,top:0,right:0,bottom:0})}))}};class rs{acquireContext(t,e){}releaseContext(t){return!1}addEventListener(t,e,i){}removeEventListener(t,e,i){}getDevicePixelRatio(){return 1}getMaximumSize(t,e,i,s){return e=Math.max(0,e||t.width),i=i||t.height,{width:e,height:Math.max(0,s?Math.floor(e/s):i)}}isAttached(t){return!0}updateConfig(t){}}class ls extends rs{acquireContext(t){return t&&t.getContext&&t.getContext("2d")||null}updateConfig(t){t.options.animation=!1}}const hs="$chartjs",cs={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"},ds=t=>null===t||""===t;const us=!!Se&&{passive:!0};function fs(t,e,i){t&&t.canvas&&t.canvas.removeEventListener(e,i,us)}function gs(t,e){for(const i of t)if(i===e||i.contains(e))return!0}function ps(t,e,i){const s=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||gs(i.addedNodes,s),e=e&&!gs(i.removedNodes,s);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}function ms(t,e,i){const s=t.canvas,n=new MutationObserver((t=>{let e=!1;for(const i of t)e=e||gs(i.removedNodes,s),e=e&&!gs(i.addedNodes,s);e&&i()}));return n.observe(document,{childList:!0,subtree:!0}),n}const xs=new Map;let bs=0;function _s(){const t=window.devicePixelRatio;t!==bs&&(bs=t,xs.forEach(((e,i)=>{i.currentDevicePixelRatio!==t&&e()})))}function ys(t,e,i){const s=t.canvas,n=s&&ge(s);if(!n)return;const o=ct(((t,e)=>{const s=n.clientWidth;i(t,e),s<n.clientWidth&&i()}),window),a=new ResizeObserver((t=>{const e=t[0],i=e.contentRect.width,s=e.contentRect.height;0===i&&0===s||o(i,s)}));return a.observe(n),function(t,e){xs.size||window.addEventListener("resize",_s),xs.set(t,e)}(t,o),a}function vs(t,e,i){i&&i.disconnect(),"resize"===e&&function(t){xs.delete(t),xs.size||window.removeEventListener("resize",_s)}(t)}function Ms(t,e,i){const s=t.canvas,n=ct((e=>{null!==t.ctx&&i(function(t,e){const i=cs[t.type]||t.type,{x:s,y:n}=ve(t,e);return{type:i,chart:e,native:t,x:void 0!==s?s:null,y:void 0!==n?n:null}}(e,t))}),t);return function(t,e,i){t&&t.addEventListener(e,i,us)}(s,e,n),n}class ws extends rs{acquireContext(t,e){const i=t&&t.getContext&&t.getContext("2d");return i&&i.canvas===t?(function(t,e){const i=t.style,s=t.getAttribute("height"),n=t.getAttribute("width");if(t[hs]={initial:{height:s,width:n,style:{display:i.display,height:i.height,width:i.width}}},i.display=i.display||"block",i.boxSizing=i.boxSizing||"border-box",ds(n)){const e=Pe(t,"width");void 0!==e&&(t.width=e)}if(ds(s))if(""===t.style.height)t.height=t.width/(e||2);else{const e=Pe(t,"height");void 0!==e&&(t.height=e)}}(t,e),i):null}releaseContext(t){const e=t.canvas;if(!e[hs])return!1;const i=e[hs].initial;["height","width"].forEach((t=>{const n=i[t];s(n)?e.removeAttribute(t):e.setAttribute(t,n)}));const n=i.style||{};return Object.keys(n).forEach((t=>{e.style[t]=n[t]})),e.width=e.width,delete e[hs],!0}addEventListener(t,e,i){this.removeEventListener(t,e);const s=t.$proxies||(t.$proxies={}),n={attach:ps,detach:ms,resize:ys}[e]||Ms;s[e]=n(t,e,i)}removeEventListener(t,e){const i=t.$proxies||(t.$proxies={}),s=i[e];if(!s)return;({attach:vs,detach:vs,resize:vs}[e]||fs)(t,e,s),i[e]=void 0}getDevicePixelRatio(){return window.devicePixelRatio}getMaximumSize(t,e,i,s){return we(t,e,i,s)}isAttached(t){const e=t&&ge(t);return!(!e||!e.isConnected)}}function ks(t){return!fe()||"undefined"!=typeof OffscreenCanvas&&t instanceof OffscreenCanvas?ls:ws}var Ss=Object.freeze({__proto__:null,BasePlatform:rs,BasicPlatform:ls,DomPlatform:ws,_detectPlatform:ks});const Ps="transparent",Ds={boolean:(t,e,i)=>i>.5?e:t,color(t,e,i){const s=Qt(t||Ps),n=s.valid&&Qt(e||Ps);return n&&n.valid?n.mix(s,i).hexString():e},number:(t,e,i)=>t+(e-t)*i};class Cs{constructor(t,e,i,s){const n=e[i];s=Pi([t.to,s,n,t.from]);const o=Pi([t.from,n,s]);this._active=!0,this._fn=t.fn||Ds[t.type||typeof o],this._easing=fi[t.easing]||fi.linear,this._start=Math.floor(Date.now()+(t.delay||0)),this._duration=this._total=Math.floor(t.duration),this._loop=!!t.loop,this._target=e,this._prop=i,this._from=o,this._to=s,this._promises=void 0}active(){return this._active}update(t,e,i){if(this._active){this._notify(!1);const s=this._target[this._prop],n=i-this._start,o=this._duration-n;this._start=i,this._duration=Math.floor(Math.max(o,t.duration)),this._total+=n,this._loop=!!t.loop,this._to=Pi([t.to,e,s,t.from]),this._from=Pi([t.from,s,e])}}cancel(){this._active&&(this.tick(Date.now()),this._active=!1,this._notify(!1))}tick(t){const e=t-this._start,i=this._duration,s=this._prop,n=this._from,o=this._loop,a=this._to;let r;if(this._active=n!==a&&(o||e<i),!this._active)return this._target[s]=a,void this._notify(!0);e<0?this._target[s]=n:(r=e/i%2,r=o&&r>1?2-r:r,r=this._easing(Math.min(1,Math.max(0,r))),this._target[s]=this._fn(n,a,r))}wait(){const t=this._promises||(this._promises=[]);return new Promise(((e,i)=>{t.push({res:e,rej:i})}))}_notify(t){const e=t?"res":"rej",i=this._promises||[];for(let t=0;t<i.length;t++)i[t][e]()}}class Os{constructor(t,e){this._chart=t,this._properties=new Map,this.configure(e)}configure(t){if(!o(t))return;const e=Object.keys(ue.animation),i=this._properties;Object.getOwnPropertyNames(t).forEach((s=>{const a=t[s];if(!o(a))return;const r={};for(const t of e)r[t]=a[t];(n(a.properties)&&a.properties||[s]).forEach((t=>{t!==s&&i.has(t)||i.set(t,r)}))}))}_animateOptions(t,e){const i=e.options,s=function(t,e){if(!e)return;let i=t.options;if(!i)return void(t.options=e);i.$shared&&(t.options=i=Object.assign({},i,{$shared:!1,$animations:{}}));return i}(t,i);if(!s)return[];const n=this._createAnimations(s,i);return i.$shared&&function(t,e){const i=[],s=Object.keys(e);for(let e=0;e<s.length;e++){const n=t[s[e]];n&&n.active()&&i.push(n.wait())}return Promise.all(i)}(t.options.$animations,i).then((()=>{t.options=i}),(()=>{})),n}_createAnimations(t,e){const i=this._properties,s=[],n=t.$animations||(t.$animations={}),o=Object.keys(e),a=Date.now();let r;for(r=o.length-1;r>=0;--r){const l=o[r];if("$"===l.charAt(0))continue;if("options"===l){s.push(...this._animateOptions(t,e));continue}const h=e[l];let c=n[l];const d=i.get(l);if(c){if(d&&c.active()){c.update(d,h,a);continue}c.cancel()}d&&d.duration?(n[l]=c=new Cs(d,t,l,h),s.push(c)):t[l]=h}return s}update(t,e){if(0===this._properties.size)return void Object.assign(t,e);const i=this._createAnimations(t,e);return i.length?(bt.add(this._chart,i),!0):void 0}}function As(t,e){const i=t&&t.options||{},s=i.reverse,n=void 0===i.min?e:0,o=void 0===i.max?e:0;return{start:s?o:n,end:s?n:o}}function Ts(t,e){const i=[],s=t._getSortedDatasetMetas(e);let n,o;for(n=0,o=s.length;n<o;++n)i.push(s[n].index);return i}function Ls(t,e,i,s={}){const n=t.keys,o="single"===s.mode;let r,l,h,c;if(null===e)return;let d=!1;for(r=0,l=n.length;r<l;++r){if(h=+n[r],h===i){if(d=!0,s.all)continue;break}c=t.values[h],a(c)&&(o||0===e||F(e)===F(c))&&(e+=c)}return d||s.all?e:0}function Es(t,e){const i=t&&t.options.stacked;return i||void 0===i&&void 0!==e.stack}function Rs(t,e,i){const s=t[e]||(t[e]={});return s[i]||(s[i]={})}function Is(t,e,i,s){for(const n of e.getMatchingVisibleMetas(s).reverse()){const e=t[n.index];if(i&&e>0||!i&&e<0)return n.index}return null}function zs(t,e){const{chart:i,_cachedMeta:s}=t,n=i._stacks||(i._stacks={}),{iScale:o,vScale:a,index:r}=s,l=o.axis,h=a.axis,c=function(t,e,i){return`${t.id}.${e.id}.${i.stack||i.type}`}(o,a,s),d=e.length;let u;for(let t=0;t<d;++t){const i=e[t],{[l]:o,[h]:d}=i;u=(i._stacks||(i._stacks={}))[h]=Rs(n,c,o),u[r]=d,u._top=Is(u,a,!0,s.type),u._bottom=Is(u,a,!1,s.type);(u._visualValues||(u._visualValues={}))[r]=d}}function Fs(t,e){const i=t.scales;return Object.keys(i).filter((t=>i[t].axis===e)).shift()}function Vs(t,e){const i=t.controller.index,s=t.vScale&&t.vScale.axis;if(s){e=e||t._parsed;for(const t of e){const e=t._stacks;if(!e||void 0===e[s]||void 0===e[s][i])return;delete e[s][i],void 0!==e[s]._visualValues&&void 0!==e[s]._visualValues[i]&&delete e[s]._visualValues[i]}}}const Bs=t=>"reset"===t||"none"===t,Ws=(t,e)=>e?t:Object.assign({},t);class Ns{static defaults={};static datasetElementType=null;static dataElementType=null;constructor(t,e){this.chart=t,this._ctx=t.ctx,this.index=e,this._cachedDataOpts={},this._cachedMeta=this.getMeta(),this._type=this._cachedMeta.type,this.options=void 0,this._parsing=!1,this._data=void 0,this._objectData=void 0,this._sharedOptions=void 0,this._drawStart=void 0,this._drawCount=void 0,this.enableOptionSharing=!1,this.supportsDecimation=!1,this.$context=void 0,this._syncList=[],this.datasetElementType=new.target.datasetElementType,this.dataElementType=new.target.dataElementType,this.initialize()}initialize(){const t=this._cachedMeta;this.configure(),this.linkScales(),t._stacked=Es(t.vScale,t),this.addElements(),this.options.fill&&!this.chart.isPluginEnabled("filler")&&console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options")}updateIndex(t){this.index!==t&&Vs(this._cachedMeta),this.index=t}linkScales(){const t=this.chart,e=this._cachedMeta,i=this.getDataset(),s=(t,e,i,s)=>"x"===t?e:"r"===t?s:i,n=e.xAxisID=l(i.xAxisID,Fs(t,"x")),o=e.yAxisID=l(i.yAxisID,Fs(t,"y")),a=e.rAxisID=l(i.rAxisID,Fs(t,"r")),r=e.indexAxis,h=e.iAxisID=s(r,n,o,a),c=e.vAxisID=s(r,o,n,a);e.xScale=this.getScaleForId(n),e.yScale=this.getScaleForId(o),e.rScale=this.getScaleForId(a),e.iScale=this.getScaleForId(h),e.vScale=this.getScaleForId(c)}getDataset(){return this.chart.data.datasets[this.index]}getMeta(){return this.chart.getDatasetMeta(this.index)}getScaleForId(t){return this.chart.scales[t]}_getOtherScale(t){const e=this._cachedMeta;return t===e.iScale?e.vScale:e.iScale}reset(){this._update("reset")}_destroy(){const t=this._cachedMeta;this._data&&rt(this._data,this),t._stacked&&Vs(t)}_dataCheck(){const t=this.getDataset(),e=t.data||(t.data=[]),i=this._data;if(o(e)){const t=this._cachedMeta;this._data=function(t,e){const{iScale:i,vScale:s}=e,n="x"===i.axis?"x":"y",o="x"===s.axis?"x":"y",a=Object.keys(t),r=new Array(a.length);let l,h,c;for(l=0,h=a.length;l<h;++l)c=a[l],r[l]={[n]:c,[o]:t[c]};return r}(e,t)}else if(i!==e){if(i){rt(i,this);const t=this._cachedMeta;Vs(t),t._parsed=[]}e&&Object.isExtensible(e)&&at(e,this),this._syncList=[],this._data=e}}addElements(){const t=this._cachedMeta;this._dataCheck(),this.datasetElementType&&(t.dataset=new this.datasetElementType)}buildOrUpdateElements(t){const e=this._cachedMeta,i=this.getDataset();let s=!1;this._dataCheck();const n=e._stacked;e._stacked=Es(e.vScale,e),e.stack!==i.stack&&(s=!0,Vs(e),e.stack=i.stack),this._resyncElements(t),(s||n!==e._stacked)&&(zs(this,e._parsed),e._stacked=Es(e.vScale,e))}configure(){const t=this.chart.config,e=t.datasetScopeKeys(this._type),i=t.getOptionScopes(this.getDataset(),e,!0);this.options=t.createResolver(i,this.getContext()),this._parsing=this.options.parsing,this._cachedDataOpts={}}parse(t,e){const{_cachedMeta:i,_data:s}=this,{iScale:a,_stacked:r}=i,l=a.axis;let h,c,d,u=0===t&&e===s.length||i._sorted,f=t>0&&i._parsed[t-1];if(!1===this._parsing)i._parsed=s,i._sorted=!0,d=s;else{d=n(s[t])?this.parseArrayData(i,s,t,e):o(s[t])?this.parseObjectData(i,s,t,e):this.parsePrimitiveData(i,s,t,e);const a=()=>null===c[l]||f&&c[l]<f[l];for(h=0;h<e;++h)i._parsed[h+t]=c=d[h],u&&(a()&&(u=!1),f=c);i._sorted=u}r&&zs(this,d)}parsePrimitiveData(t,e,i,s){const{iScale:n,vScale:o}=t,a=n.axis,r=o.axis,l=n.getLabels(),h=n===o,c=new Array(s);let d,u,f;for(d=0,u=s;d<u;++d)f=d+i,c[d]={[a]:h||n.parse(l[f],f),[r]:o.parse(e[f],f)};return c}parseArrayData(t,e,i,s){const{xScale:n,yScale:o}=t,a=new Array(s);let r,l,h,c;for(r=0,l=s;r<l;++r)h=r+i,c=e[h],a[r]={x:n.parse(c[0],h),y:o.parse(c[1],h)};return a}parseObjectData(t,e,i,s){const{xScale:n,yScale:o}=t,{xAxisKey:a="x",yAxisKey:r="y"}=this._parsing,l=new Array(s);let h,c,d,u;for(h=0,c=s;h<c;++h)d=h+i,u=e[d],l[h]={x:n.parse(M(u,a),d),y:o.parse(M(u,r),d)};return l}getParsed(t){return this._cachedMeta._parsed[t]}getDataElement(t){return this._cachedMeta.data[t]}applyStack(t,e,i){const s=this.chart,n=this._cachedMeta,o=e[t.axis];return Ls({keys:Ts(s,!0),values:e._stacks[t.axis]._visualValues},o,n.index,{mode:i})}updateRangeFromParsed(t,e,i,s){const n=i[e.axis];let o=null===n?NaN:n;const a=s&&i._stacks[e.axis];s&&a&&(s.values=a,o=Ls(s,n,this._cachedMeta.index)),t.min=Math.min(t.min,o),t.max=Math.max(t.max,o)}getMinMax(t,e){const i=this._cachedMeta,s=i._parsed,n=i._sorted&&t===i.iScale,o=s.length,r=this._getOtherScale(t),l=((t,e,i)=>t&&!e.hidden&&e._stacked&&{keys:Ts(i,!0),values:null})(e,i,this.chart),h={min:Number.POSITIVE_INFINITY,max:Number.NEGATIVE_INFINITY},{min:c,max:d}=function(t){const{min:e,max:i,minDefined:s,maxDefined:n}=t.getUserBounds();return{min:s?e:Number.NEGATIVE_INFINITY,max:n?i:Number.POSITIVE_INFINITY}}(r);let u,f;function g(){f=s[u];const e=f[r.axis];return!a(f[t.axis])||c>e||d<e}for(u=0;u<o&&(g()||(this.updateRangeFromParsed(h,t,f,l),!n));++u);if(n)for(u=o-1;u>=0;--u)if(!g()){this.updateRangeFromParsed(h,t,f,l);break}return h}getAllParsedValues(t){const e=this._cachedMeta._parsed,i=[];let s,n,o;for(s=0,n=e.length;s<n;++s)o=e[s][t.axis],a(o)&&i.push(o);return i}getMaxOverflow(){return!1}getLabelAndValue(t){const e=this._cachedMeta,i=e.iScale,s=e.vScale,n=this.getParsed(t);return{label:i?""+i.getLabelForValue(n[i.axis]):"",value:s?""+s.getLabelForValue(n[s.axis]):""}}_update(t){const e=this._cachedMeta;this.update(t||"default"),e._clip=function(t){let e,i,s,n;return o(t)?(e=t.top,i=t.right,s=t.bottom,n=t.left):e=i=s=n=t,{top:e,right:i,bottom:s,left:n,disabled:!1===t}}(l(this.options.clip,function(t,e,i){if(!1===i)return!1;const s=As(t,i),n=As(e,i);return{top:n.end,right:s.end,bottom:n.start,left:s.start}}(e.xScale,e.yScale,this.getMaxOverflow())))}update(t){}draw(){const t=this._ctx,e=this.chart,i=this._cachedMeta,s=i.data||[],n=e.chartArea,o=[],a=this._drawStart||0,r=this._drawCount||s.length-a,l=this.options.drawActiveElementsOnTop;let h;for(i.dataset&&i.dataset.draw(t,n,a,r),h=a;h<a+r;++h){const e=s[h];e.hidden||(e.active&&l?o.push(e):e.draw(t,n))}for(h=0;h<o.length;++h)o[h].draw(t,n)}getStyle(t,e){const i=e?"active":"default";return void 0===t&&this._cachedMeta.dataset?this.resolveDatasetElementOptions(i):this.resolveDataElementOptions(t||0,i)}getContext(t,e,i){const s=this.getDataset();let n;if(t>=0&&t<this._cachedMeta.data.length){const e=this._cachedMeta.data[t];n=e.$context||(e.$context=function(t,e,i){return Ci(t,{active:!1,dataIndex:e,parsed:void 0,raw:void 0,element:i,index:e,mode:"default",type:"data"})}(this.getContext(),t,e)),n.parsed=this.getParsed(t),n.raw=s.data[t],n.index=n.dataIndex=t}else n=this.$context||(this.$context=function(t,e){return Ci(t,{active:!1,dataset:void 0,datasetIndex:e,index:e,mode:"default",type:"dataset"})}(this.chart.getContext(),this.index)),n.dataset=s,n.index=n.datasetIndex=this.index;return n.active=!!e,n.mode=i,n}resolveDatasetElementOptions(t){return this._resolveElementOptions(this.datasetElementType.id,t)}resolveDataElementOptions(t,e){return this._resolveElementOptions(this.dataElementType.id,e,t)}_resolveElementOptions(t,e="default",i){const s="active"===e,n=this._cachedDataOpts,o=t+"-"+e,a=n[o],r=this.enableOptionSharing&&k(i);if(a)return Ws(a,r);const l=this.chart.config,h=l.datasetElementScopeKeys(this._type,t),c=s?[`${t}Hover`,"hover",t,""]:[t,""],d=l.getOptionScopes(this.getDataset(),h),u=Object.keys(ue.elements[t]),f=l.resolveNamedOptions(d,u,(()=>this.getContext(i,s,e)),c);return f.$shared&&(f.$shared=r,n[o]=Object.freeze(Ws(f,r))),f}_resolveAnimations(t,e,i){const s=this.chart,n=this._cachedDataOpts,o=`animation-${e}`,a=n[o];if(a)return a;let r;if(!1!==s.options.animation){const s=this.chart.config,n=s.datasetAnimationScopeKeys(this._type,e),o=s.getOptionScopes(this.getDataset(),n);r=s.createResolver(o,this.getContext(t,i,e))}const l=new Os(s,r&&r.animations);return r&&r._cacheable&&(n[o]=Object.freeze(l)),l}getSharedOptions(t){if(t.$shared)return this._sharedOptions||(this._sharedOptions=Object.assign({},t))}includeOptions(t,e){return!e||Bs(t)||this.chart._animationsDisabled}_getSharedOptions(t,e){const i=this.resolveDataElementOptions(t,e),s=this._sharedOptions,n=this.getSharedOptions(i),o=this.includeOptions(e,n)||n!==s;return this.updateSharedOptions(n,e,i),{sharedOptions:n,includeOptions:o}}updateElement(t,e,i,s){Bs(s)?Object.assign(t,i):this._resolveAnimations(e,s).update(t,i)}updateSharedOptions(t,e,i){t&&!Bs(e)&&this._resolveAnimations(void 0,e).update(t,i)}_setStyle(t,e,i,s){t.active=s;const n=this.getStyle(e,s);this._resolveAnimations(e,i,s).update(t,{options:!s&&this.getSharedOptions(n)||n})}removeHoverStyle(t,e,i){this._setStyle(t,i,"active",!1)}setHoverStyle(t,e,i){this._setStyle(t,i,"active",!0)}_removeDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!1)}_setDatasetHoverStyle(){const t=this._cachedMeta.dataset;t&&this._setStyle(t,void 0,"active",!0)}_resyncElements(t){const e=this._data,i=this._cachedMeta.data;for(const[t,e,i]of this._syncList)this[t](e,i);this._syncList=[];const s=i.length,n=e.length,o=Math.min(n,s);o&&this.parse(0,o),n>s?this._insertElements(s,n-s,t):n<s&&this._removeElements(n,s-n)}_insertElements(t,e,i=!0){const s=this._cachedMeta,n=s.data,o=t+e;let a;const r=t=>{for(t.length+=e,a=t.length-1;a>=o;a--)t[a]=t[a-e]};for(r(n),a=t;a<o;++a)n[a]=new this.dataElementType;this._parsing&&r(s._parsed),this.parse(t,e),i&&this.updateElements(n,t,e,"reset")}updateElements(t,e,i,s){}_removeElements(t,e){const i=this._cachedMeta;if(this._parsing){const s=i._parsed.splice(t,e);i._stacked&&Vs(i,s)}i.data.splice(t,e)}_sync(t){if(this._parsing)this._syncList.push(t);else{const[e,i,s]=t;this[e](i,s)}this.chart._dataChanges.push([this.index,...t])}_onDataPush(){const t=arguments.length;this._sync(["_insertElements",this.getDataset().data.length-t,t])}_onDataPop(){this._sync(["_removeElements",this._cachedMeta.data.length-1,1])}_onDataShift(){this._sync(["_removeElements",0,1])}_onDataSplice(t,e){e&&this._sync(["_removeElements",t,e]);const i=arguments.length-2;i&&this._sync(["_insertElements",t,i])}_onDataUnshift(){this._sync(["_insertElements",0,arguments.length])}}class Hs{static defaults={};static defaultRoutes=void 0;x;y;active=!1;options;$animations;tooltipPosition(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}hasValue(){return N(this.x)&&N(this.y)}getProps(t,e){const i=this.$animations;if(!e||!i)return this;const s={};return t.forEach((t=>{s[t]=i[t]&&i[t].active()?i[t]._to:this[t]})),s}}function js(t,e){const i=t.options.ticks,n=function(t){const e=t.options.offset,i=t._tickSize(),s=t._length/i+(e?0:1),n=t._maxLength/i;return Math.floor(Math.min(s,n))}(t),o=Math.min(i.maxTicksLimit||n,n),a=i.major.enabled?function(t){const e=[];let i,s;for(i=0,s=t.length;i<s;i++)t[i].major&&e.push(i);return e}(e):[],r=a.length,l=a[0],h=a[r-1],c=[];if(r>o)return function(t,e,i,s){let n,o=0,a=i[0];for(s=Math.ceil(s),n=0;n<t.length;n++)n===a&&(e.push(t[n]),o++,a=i[o*s])}(e,c,a,r/o),c;const d=function(t,e,i){const s=function(t){const e=t.length;let i,s;if(e<2)return!1;for(s=t[0],i=1;i<e;++i)if(t[i]-t[i-1]!==s)return!1;return s}(t),n=e.length/i;if(!s)return Math.max(n,1);const o=W(s);for(let t=0,e=o.length-1;t<e;t++){const e=o[t];if(e>n)return e}return Math.max(n,1)}(a,e,o);if(r>0){let t,i;const n=r>1?Math.round((h-l)/(r-1)):null;for($s(e,c,d,s(n)?0:l-n,l),t=0,i=r-1;t<i;t++)$s(e,c,d,a[t],a[t+1]);return $s(e,c,d,h,s(n)?e.length:h+n),c}return $s(e,c,d),c}function $s(t,e,i,s,n){const o=l(s,0),a=Math.min(l(n,t.length),t.length);let r,h,c,d=0;for(i=Math.ceil(i),n&&(r=n-s,i=r/Math.floor(r/i)),c=o;c<0;)d++,c=Math.round(o+d*i);for(h=Math.max(o,0);h<a;h++)h===c&&(e.push(t[h]),d++,c=Math.round(o+d*i))}const Ys=(t,e,i)=>"top"===e||"left"===e?t[e]+i:t[e]-i,Us=(t,e)=>Math.min(e||t,t);function Xs(t,e){const i=[],s=t.length/e,n=t.length;let o=0;for(;o<n;o+=s)i.push(t[Math.floor(o)]);return i}function qs(t,e,i){const s=t.ticks.length,n=Math.min(e,s-1),o=t._startPixel,a=t._endPixel,r=1e-6;let l,h=t.getPixelForTick(n);if(!(i&&(l=1===s?Math.max(h-o,a-h):0===e?(t.getPixelForTick(1)-h)/2:(h-t.getPixelForTick(n-1))/2,h+=n<e?l:-l,h<o-r||h>a+r)))return h}function Ks(t){return t.drawTicks?t.tickLength:0}function Gs(t,e){if(!t.display)return 0;const i=Si(t.font,e),s=ki(t.padding);return(n(t.text)?t.text.length:1)*i.lineHeight+s.height}function Zs(t,e,i){let s=ut(t);return(i&&"right"!==e||!i&&"right"===e)&&(s=(t=>"left"===t?"right":"right"===t?"left":t)(s)),s}class Js extends Hs{constructor(t){super(),this.id=t.id,this.type=t.type,this.options=void 0,this.ctx=t.ctx,this.chart=t.chart,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this._margins={left:0,right:0,top:0,bottom:0},this.maxWidth=void 0,this.maxHeight=void 0,this.paddingTop=void 0,this.paddingBottom=void 0,this.paddingLeft=void 0,this.paddingRight=void 0,this.axis=void 0,this.labelRotation=void 0,this.min=void 0,this.max=void 0,this._range=void 0,this.ticks=[],this._gridLineItems=null,this._labelItems=null,this._labelSizes=null,this._length=0,this._maxLength=0,this._longestTextCache={},this._startPixel=void 0,this._endPixel=void 0,this._reversePixels=!1,this._userMax=void 0,this._userMin=void 0,this._suggestedMax=void 0,this._suggestedMin=void 0,this._ticksLength=0,this._borderValue=0,this._cache={},this._dataLimitsCached=!1,this.$context=void 0}init(t){this.options=t.setContext(this.getContext()),this.axis=t.axis,this._userMin=this.parse(t.min),this._userMax=this.parse(t.max),this._suggestedMin=this.parse(t.suggestedMin),this._suggestedMax=this.parse(t.suggestedMax)}parse(t,e){return t}getUserBounds(){let{_userMin:t,_userMax:e,_suggestedMin:i,_suggestedMax:s}=this;return t=r(t,Number.POSITIVE_INFINITY),e=r(e,Number.NEGATIVE_INFINITY),i=r(i,Number.POSITIVE_INFINITY),s=r(s,Number.NEGATIVE_INFINITY),{min:r(t,i),max:r(e,s),minDefined:a(t),maxDefined:a(e)}}getMinMax(t){let e,{min:i,max:s,minDefined:n,maxDefined:o}=this.getUserBounds();if(n&&o)return{min:i,max:s};const a=this.getMatchingVisibleMetas();for(let r=0,l=a.length;r<l;++r)e=a[r].controller.getMinMax(this,t),n||(i=Math.min(i,e.min)),o||(s=Math.max(s,e.max));return i=o&&i>s?s:i,s=n&&i>s?i:s,{min:r(i,r(s,i)),max:r(s,r(i,s))}}getPadding(){return{left:this.paddingLeft||0,top:this.paddingTop||0,right:this.paddingRight||0,bottom:this.paddingBottom||0}}getTicks(){return this.ticks}getLabels(){const t=this.chart.data;return this.options.labels||(this.isHorizontal()?t.xLabels:t.yLabels)||t.labels||[]}getLabelItems(t=this.chart.chartArea){return this._labelItems||(this._labelItems=this._computeLabelItems(t))}beforeLayout(){this._cache={},this._dataLimitsCached=!1}beforeUpdate(){d(this.options.beforeUpdate,[this])}update(t,e,i){const{beginAtZero:s,grace:n,ticks:o}=this.options,a=o.sampleSize;this.beforeUpdate(),this.maxWidth=t,this.maxHeight=e,this._margins=i=Object.assign({left:0,right:0,top:0,bottom:0},i),this.ticks=null,this._labelSizes=null,this._gridLineItems=null,this._labelItems=null,this.beforeSetDimensions(),this.setDimensions(),this.afterSetDimensions(),this._maxLength=this.isHorizontal()?this.width+i.left+i.right:this.height+i.top+i.bottom,this._dataLimitsCached||(this.beforeDataLimits(),this.determineDataLimits(),this.afterDataLimits(),this._range=Di(this,n,s),this._dataLimitsCached=!0),this.beforeBuildTicks(),this.ticks=this.buildTicks()||[],this.afterBuildTicks();const r=a<this.ticks.length;this._convertTicksToLabels(r?Xs(this.ticks,a):this.ticks),this.configure(),this.beforeCalculateLabelRotation(),this.calculateLabelRotation(),this.afterCalculateLabelRotation(),o.display&&(o.autoSkip||"auto"===o.source)&&(this.ticks=js(this,this.ticks),this._labelSizes=null,this.afterAutoSkip()),r&&this._convertTicksToLabels(this.ticks),this.beforeFit(),this.fit(),this.afterFit(),this.afterUpdate()}configure(){let t,e,i=this.options.reverse;this.isHorizontal()?(t=this.left,e=this.right):(t=this.top,e=this.bottom,i=!i),this._startPixel=t,this._endPixel=e,this._reversePixels=i,this._length=e-t,this._alignToPixels=this.options.alignToPixels}afterUpdate(){d(this.options.afterUpdate,[this])}beforeSetDimensions(){d(this.options.beforeSetDimensions,[this])}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=0,this.right=this.width):(this.height=this.maxHeight,this.top=0,this.bottom=this.height),this.paddingLeft=0,this.paddingTop=0,this.paddingRight=0,this.paddingBottom=0}afterSetDimensions(){d(this.options.afterSetDimensions,[this])}_callHooks(t){this.chart.notifyPlugins(t,this.getContext()),d(this.options[t],[this])}beforeDataLimits(){this._callHooks("beforeDataLimits")}determineDataLimits(){}afterDataLimits(){this._callHooks("afterDataLimits")}beforeBuildTicks(){this._callHooks("beforeBuildTicks")}buildTicks(){return[]}afterBuildTicks(){this._callHooks("afterBuildTicks")}beforeTickToLabelConversion(){d(this.options.beforeTickToLabelConversion,[this])}generateTickLabels(t){const e=this.options.ticks;let i,s,n;for(i=0,s=t.length;i<s;i++)n=t[i],n.label=d(e.callback,[n.value,i,t],this)}afterTickToLabelConversion(){d(this.options.afterTickToLabelConversion,[this])}beforeCalculateLabelRotation(){d(this.options.beforeCalculateLabelRotation,[this])}calculateLabelRotation(){const t=this.options,e=t.ticks,i=Us(this.ticks.length,t.ticks.maxTicksLimit),s=e.minRotation||0,n=e.maxRotation;let o,a,r,l=s;if(!this._isVisible()||!e.display||s>=n||i<=1||!this.isHorizontal())return void(this.labelRotation=s);const h=this._getLabelSizes(),c=h.widest.width,d=h.highest.height,u=J(this.chart.width-c,0,this.maxWidth);o=t.offset?this.maxWidth/i:u/(i-1),c+6>o&&(o=u/(i-(t.offset?.5:1)),a=this.maxHeight-Ks(t.grid)-e.padding-Gs(t.title,this.chart.options.font),r=Math.sqrt(c*c+d*d),l=Y(Math.min(Math.asin(J((h.highest.height+6)/o,-1,1)),Math.asin(J(a/r,-1,1))-Math.asin(J(d/r,-1,1)))),l=Math.max(s,Math.min(n,l))),this.labelRotation=l}afterCalculateLabelRotation(){d(this.options.afterCalculateLabelRotation,[this])}afterAutoSkip(){}beforeFit(){d(this.options.beforeFit,[this])}fit(){const t={width:0,height:0},{chart:e,options:{ticks:i,title:s,grid:n}}=this,o=this._isVisible(),a=this.isHorizontal();if(o){const o=Gs(s,e.options.font);if(a?(t.width=this.maxWidth,t.height=Ks(n)+o):(t.height=this.maxHeight,t.width=Ks(n)+o),i.display&&this.ticks.length){const{first:e,last:s,widest:n,highest:o}=this._getLabelSizes(),r=2*i.padding,l=$(this.labelRotation),h=Math.cos(l),c=Math.sin(l);if(a){const e=i.mirror?0:c*n.width+h*o.height;t.height=Math.min(this.maxHeight,t.height+e+r)}else{const e=i.mirror?0:h*n.width+c*o.height;t.width=Math.min(this.maxWidth,t.width+e+r)}this._calculatePadding(e,s,c,h)}}this._handleMargins(),a?(this.width=this._length=e.width-this._margins.left-this._margins.right,this.height=t.height):(this.width=t.width,this.height=this._length=e.height-this._margins.top-this._margins.bottom)}_calculatePadding(t,e,i,s){const{ticks:{align:n,padding:o},position:a}=this.options,r=0!==this.labelRotation,l="top"!==a&&"x"===this.axis;if(this.isHorizontal()){const a=this.getPixelForTick(0)-this.left,h=this.right-this.getPixelForTick(this.ticks.length-1);let c=0,d=0;r?l?(c=s*t.width,d=i*e.height):(c=i*t.height,d=s*e.width):"start"===n?d=e.width:"end"===n?c=t.width:"inner"!==n&&(c=t.width/2,d=e.width/2),this.paddingLeft=Math.max((c-a+o)*this.width/(this.width-a),0),this.paddingRight=Math.max((d-h+o)*this.width/(this.width-h),0)}else{let i=e.height/2,s=t.height/2;"start"===n?(i=0,s=t.height):"end"===n&&(i=e.height,s=0),this.paddingTop=i+o,this.paddingBottom=s+o}}_handleMargins(){this._margins&&(this._margins.left=Math.max(this.paddingLeft,this._margins.left),this._margins.top=Math.max(this.paddingTop,this._margins.top),this._margins.right=Math.max(this.paddingRight,this._margins.right),this._margins.bottom=Math.max(this.paddingBottom,this._margins.bottom))}afterFit(){d(this.options.afterFit,[this])}isHorizontal(){const{axis:t,position:e}=this.options;return"top"===e||"bottom"===e||"x"===t}isFullSize(){return this.options.fullSize}_convertTicksToLabels(t){let e,i;for(this.beforeTickToLabelConversion(),this.generateTickLabels(t),e=0,i=t.length;e<i;e++)s(t[e].label)&&(t.splice(e,1),i--,e--);this.afterTickToLabelConversion()}_getLabelSizes(){let t=this._labelSizes;if(!t){const e=this.options.ticks.sampleSize;let i=this.ticks;e<i.length&&(i=Xs(i,e)),this._labelSizes=t=this._computeLabelSizes(i,i.length,this.options.ticks.maxTicksLimit)}return t}_computeLabelSizes(t,e,i){const{ctx:o,_longestTextCache:a}=this,r=[],l=[],h=Math.floor(e/Us(e,i));let c,d,f,g,p,m,x,b,_,y,v,M=0,w=0;for(c=0;c<e;c+=h){if(g=t[c].label,p=this._resolveTickFontOptions(c),o.font=m=p.string,x=a[m]=a[m]||{data:{},gc:[]},b=p.lineHeight,_=y=0,s(g)||n(g)){if(n(g))for(d=0,f=g.length;d<f;++d)v=g[d],s(v)||n(v)||(_=Ce(o,x.data,x.gc,_,v),y+=b)}else _=Ce(o,x.data,x.gc,_,g),y=b;r.push(_),l.push(y),M=Math.max(_,M),w=Math.max(y,w)}!function(t,e){u(t,(t=>{const i=t.gc,s=i.length/2;let n;if(s>e){for(n=0;n<s;++n)delete t.data[i[n]];i.splice(0,s)}}))}(a,e);const k=r.indexOf(M),S=l.indexOf(w),P=t=>({width:r[t]||0,height:l[t]||0});return{first:P(0),last:P(e-1),widest:P(k),highest:P(S),widths:r,heights:l}}getLabelForValue(t){return t}getPixelForValue(t,e){return NaN}getValueForPixel(t){}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getPixelForDecimal(t){this._reversePixels&&(t=1-t);const e=this._startPixel+t*this._length;return Q(this._alignToPixels?Ae(this.chart,e,0):e)}getDecimalForPixel(t){const e=(t-this._startPixel)/this._length;return this._reversePixels?1-e:e}getBasePixel(){return this.getPixelForValue(this.getBaseValue())}getBaseValue(){const{min:t,max:e}=this;return t<0&&e<0?e:t>0&&e>0?t:0}getContext(t){const e=this.ticks||[];if(t>=0&&t<e.length){const i=e[t];return i.$context||(i.$context=function(t,e,i){return Ci(t,{tick:i,index:e,type:"tick"})}(this.getContext(),t,i))}return this.$context||(this.$context=Ci(this.chart.getContext(),{scale:this,type:"scale"}))}_tickSize(){const t=this.options.ticks,e=$(this.labelRotation),i=Math.abs(Math.cos(e)),s=Math.abs(Math.sin(e)),n=this._getLabelSizes(),o=t.autoSkipPadding||0,a=n?n.widest.width+o:0,r=n?n.highest.height+o:0;return this.isHorizontal()?r*i>a*s?a/i:r/s:r*s<a*i?r/i:a/s}_isVisible(){const t=this.options.display;return"auto"!==t?!!t:this.getMatchingVisibleMetas().length>0}_computeGridLineItems(t){const e=this.axis,i=this.chart,s=this.options,{grid:n,position:a,border:r}=s,h=n.offset,c=this.isHorizontal(),d=this.ticks.length+(h?1:0),u=Ks(n),f=[],g=r.setContext(this.getContext()),p=g.display?g.width:0,m=p/2,x=function(t){return Ae(i,t,p)};let b,_,y,v,M,w,k,S,P,D,C,O;if("top"===a)b=x(this.bottom),w=this.bottom-u,S=b-m,D=x(t.top)+m,O=t.bottom;else if("bottom"===a)b=x(this.top),D=t.top,O=x(t.bottom)-m,w=b+m,S=this.top+u;else if("left"===a)b=x(this.right),M=this.right-u,k=b-m,P=x(t.left)+m,C=t.right;else if("right"===a)b=x(this.left),P=t.left,C=x(t.right)-m,M=b+m,k=this.left+u;else if("x"===e){if("center"===a)b=x((t.top+t.bottom)/2+.5);else if(o(a)){const t=Object.keys(a)[0],e=a[t];b=x(this.chart.scales[t].getPixelForValue(e))}D=t.top,O=t.bottom,w=b+m,S=w+u}else if("y"===e){if("center"===a)b=x((t.left+t.right)/2);else if(o(a)){const t=Object.keys(a)[0],e=a[t];b=x(this.chart.scales[t].getPixelForValue(e))}M=b-m,k=M-u,P=t.left,C=t.right}const A=l(s.ticks.maxTicksLimit,d),T=Math.max(1,Math.ceil(d/A));for(_=0;_<d;_+=T){const t=this.getContext(_),e=n.setContext(t),s=r.setContext(t),o=e.lineWidth,a=e.color,l=s.dash||[],d=s.dashOffset,u=e.tickWidth,g=e.tickColor,p=e.tickBorderDash||[],m=e.tickBorderDashOffset;y=qs(this,_,h),void 0!==y&&(v=Ae(i,y,o),c?M=k=P=C=v:w=S=D=O=v,f.push({tx1:M,ty1:w,tx2:k,ty2:S,x1:P,y1:D,x2:C,y2:O,width:o,color:a,borderDash:l,borderDashOffset:d,tickWidth:u,tickColor:g,tickBorderDash:p,tickBorderDashOffset:m}))}return this._ticksLength=d,this._borderValue=b,f}_computeLabelItems(t){const e=this.axis,i=this.options,{position:s,ticks:a}=i,r=this.isHorizontal(),l=this.ticks,{align:h,crossAlign:c,padding:d,mirror:u}=a,f=Ks(i.grid),g=f+d,p=u?-d:g,m=-$(this.labelRotation),x=[];let b,_,y,v,M,w,k,S,P,D,C,O,A="middle";if("top"===s)w=this.bottom-p,k=this._getXAxisLabelAlignment();else if("bottom"===s)w=this.top+p,k=this._getXAxisLabelAlignment();else if("left"===s){const t=this._getYAxisLabelAlignment(f);k=t.textAlign,M=t.x}else if("right"===s){const t=this._getYAxisLabelAlignment(f);k=t.textAlign,M=t.x}else if("x"===e){if("center"===s)w=(t.top+t.bottom)/2+g;else if(o(s)){const t=Object.keys(s)[0],e=s[t];w=this.chart.scales[t].getPixelForValue(e)+g}k=this._getXAxisLabelAlignment()}else if("y"===e){if("center"===s)M=(t.left+t.right)/2-g;else if(o(s)){const t=Object.keys(s)[0],e=s[t];M=this.chart.scales[t].getPixelForValue(e)}k=this._getYAxisLabelAlignment(f).textAlign}"y"===e&&("start"===h?A="top":"end"===h&&(A="bottom"));const T=this._getLabelSizes();for(b=0,_=l.length;b<_;++b){y=l[b],v=y.label;const t=a.setContext(this.getContext(b));S=this.getPixelForTick(b)+a.labelOffset,P=this._resolveTickFontOptions(b),D=P.lineHeight,C=n(v)?v.length:1;const e=C/2,i=t.color,o=t.textStrokeColor,h=t.textStrokeWidth;let d,f=k;if(r?(M=S,"inner"===k&&(f=b===_-1?this.options.reverse?"left":"right":0===b?this.options.reverse?"right":"left":"center"),O="top"===s?"near"===c||0!==m?-C*D+D/2:"center"===c?-T.highest.height/2-e*D+D:-T.highest.height+D/2:"near"===c||0!==m?D/2:"center"===c?T.highest.height/2-e*D:T.highest.height-C*D,u&&(O*=-1),0===m||t.showLabelBackdrop||(M+=D/2*Math.sin(m))):(w=S,O=(1-C)*D/2),t.showLabelBackdrop){const e=ki(t.backdropPadding),i=T.heights[b],s=T.widths[b];let n=O-e.top,o=0-e.left;switch(A){case"middle":n-=i/2;break;case"bottom":n-=i}switch(k){case"center":o-=s/2;break;case"right":o-=s;break;case"inner":b===_-1?o-=s:b>0&&(o-=s/2)}d={left:o,top:n,width:s+e.width,height:i+e.height,color:t.backdropColor}}x.push({label:v,font:P,textOffset:O,options:{rotation:m,color:i,strokeColor:o,strokeWidth:h,textAlign:f,textBaseline:A,translation:[M,w],backdrop:d}})}return x}_getXAxisLabelAlignment(){const{position:t,ticks:e}=this.options;if(-$(this.labelRotation))return"top"===t?"left":"right";let i="center";return"start"===e.align?i="left":"end"===e.align?i="right":"inner"===e.align&&(i="inner"),i}_getYAxisLabelAlignment(t){const{position:e,ticks:{crossAlign:i,mirror:s,padding:n}}=this.options,o=t+n,a=this._getLabelSizes().widest.width;let r,l;return"left"===e?s?(l=this.right+n,"near"===i?r="left":"center"===i?(r="center",l+=a/2):(r="right",l+=a)):(l=this.right-o,"near"===i?r="right":"center"===i?(r="center",l-=a/2):(r="left",l=this.left)):"right"===e?s?(l=this.left+n,"near"===i?r="right":"center"===i?(r="center",l-=a/2):(r="left",l-=a)):(l=this.left+o,"near"===i?r="left":"center"===i?(r="center",l+=a/2):(r="right",l=this.right)):r="right",{textAlign:r,x:l}}_computeLabelArea(){if(this.options.ticks.mirror)return;const t=this.chart,e=this.options.position;return"left"===e||"right"===e?{top:0,left:this.left,bottom:t.height,right:this.right}:"top"===e||"bottom"===e?{top:this.top,left:0,bottom:this.bottom,right:t.width}:void 0}drawBackground(){const{ctx:t,options:{backgroundColor:e},left:i,top:s,width:n,height:o}=this;e&&(t.save(),t.fillStyle=e,t.fillRect(i,s,n,o),t.restore())}getLineWidthForValue(t){const e=this.options.grid;if(!this._isVisible()||!e.display)return 0;const i=this.ticks.findIndex((e=>e.value===t));if(i>=0){return e.setContext(this.getContext(i)).lineWidth}return 0}drawGrid(t){const e=this.options.grid,i=this.ctx,s=this._gridLineItems||(this._gridLineItems=this._computeGridLineItems(t));let n,o;const a=(t,e,s)=>{s.width&&s.color&&(i.save(),i.lineWidth=s.width,i.strokeStyle=s.color,i.setLineDash(s.borderDash||[]),i.lineDashOffset=s.borderDashOffset,i.beginPath(),i.moveTo(t.x,t.y),i.lineTo(e.x,e.y),i.stroke(),i.restore())};if(e.display)for(n=0,o=s.length;n<o;++n){const t=s[n];e.drawOnChartArea&&a({x:t.x1,y:t.y1},{x:t.x2,y:t.y2},t),e.drawTicks&&a({x:t.tx1,y:t.ty1},{x:t.tx2,y:t.ty2},{color:t.tickColor,width:t.tickWidth,borderDash:t.tickBorderDash,borderDashOffset:t.tickBorderDashOffset})}}drawBorder(){const{chart:t,ctx:e,options:{border:i,grid:s}}=this,n=i.setContext(this.getContext()),o=i.display?n.width:0;if(!o)return;const a=s.setContext(this.getContext(0)).lineWidth,r=this._borderValue;let l,h,c,d;this.isHorizontal()?(l=Ae(t,this.left,o)-o/2,h=Ae(t,this.right,a)+a/2,c=d=r):(c=Ae(t,this.top,o)-o/2,d=Ae(t,this.bottom,a)+a/2,l=h=r),e.save(),e.lineWidth=n.width,e.strokeStyle=n.color,e.beginPath(),e.moveTo(l,c),e.lineTo(h,d),e.stroke(),e.restore()}drawLabels(t){if(!this.options.ticks.display)return;const e=this.ctx,i=this._computeLabelArea();i&&Ie(e,i);const s=this.getLabelItems(t);for(const t of s){const i=t.options,s=t.font;Ne(e,t.label,0,t.textOffset,s,i)}i&&ze(e)}drawTitle(){const{ctx:t,options:{position:e,title:i,reverse:s}}=this;if(!i.display)return;const a=Si(i.font),r=ki(i.padding),l=i.align;let h=a.lineHeight/2;"bottom"===e||"center"===e||o(e)?(h+=r.bottom,n(i.text)&&(h+=a.lineHeight*(i.text.length-1))):h+=r.top;const{titleX:c,titleY:d,maxWidth:u,rotation:f}=function(t,e,i,s){const{top:n,left:a,bottom:r,right:l,chart:h}=t,{chartArea:c,scales:d}=h;let u,f,g,p=0;const m=r-n,x=l-a;if(t.isHorizontal()){if(f=ft(s,a,l),o(i)){const t=Object.keys(i)[0],s=i[t];g=d[t].getPixelForValue(s)+m-e}else g="center"===i?(c.bottom+c.top)/2+m-e:Ys(t,i,e);u=l-a}else{if(o(i)){const t=Object.keys(i)[0],s=i[t];f=d[t].getPixelForValue(s)-x+e}else f="center"===i?(c.left+c.right)/2-x+e:Ys(t,i,e);g=ft(s,r,n),p="left"===i?-E:E}return{titleX:f,titleY:g,maxWidth:u,rotation:p}}(this,h,e,l);Ne(t,i.text,0,0,a,{color:i.color,maxWidth:u,rotation:f,textAlign:Zs(l,e,s),textBaseline:"middle",translation:[c,d]})}draw(t){this._isVisible()&&(this.drawBackground(),this.drawGrid(t),this.drawBorder(),this.drawTitle(),this.drawLabels(t))}_layers(){const t=this.options,e=t.ticks&&t.ticks.z||0,i=l(t.grid&&t.grid.z,-1),s=l(t.border&&t.border.z,0);return this._isVisible()&&this.draw===Js.prototype.draw?[{z:i,draw:t=>{this.drawBackground(),this.drawGrid(t),this.drawTitle()}},{z:s,draw:()=>{this.drawBorder()}},{z:e,draw:t=>{this.drawLabels(t)}}]:[{z:e,draw:t=>{this.draw(t)}}]}getMatchingVisibleMetas(t){const e=this.chart.getSortedVisibleDatasetMetas(),i=this.axis+"AxisID",s=[];let n,o;for(n=0,o=e.length;n<o;++n){const o=e[n];o[i]!==this.id||t&&o.type!==t||s.push(o)}return s}_resolveTickFontOptions(t){return Si(this.options.ticks.setContext(this.getContext(t)).font)}_maxDigits(){const t=this._resolveTickFontOptions(0).lineHeight;return(this.isHorizontal()?this.width:this.height)/t}}class Qs{constructor(t,e,i){this.type=t,this.scope=e,this.override=i,this.items=Object.create(null)}isForType(t){return Object.prototype.isPrototypeOf.call(this.type.prototype,t.prototype)}register(t){const e=Object.getPrototypeOf(t);let i;(function(t){return"id"in t&&"defaults"in t})(e)&&(i=this.register(e));const s=this.items,n=t.id,o=this.scope+"."+n;if(!n)throw new Error("class does not have id: "+t);return n in s||(s[n]=t,function(t,e,i){const s=x(Object.create(null),[i?ue.get(i):{},ue.get(e),t.defaults]);ue.set(e,s),t.defaultRoutes&&function(t,e){Object.keys(e).forEach((i=>{const s=i.split("."),n=s.pop(),o=[t].concat(s).join("."),a=e[i].split("."),r=a.pop(),l=a.join(".");ue.route(o,n,l,r)}))}(e,t.defaultRoutes);t.descriptors&&ue.describe(e,t.descriptors)}(t,o,i),this.override&&ue.override(t.id,t.overrides)),o}get(t){return this.items[t]}unregister(t){const e=this.items,i=t.id,s=this.scope;i in e&&delete e[i],s&&i in ue[s]&&(delete ue[s][i],this.override&&delete re[i])}}class tn{constructor(){this.controllers=new Qs(Ns,"datasets",!0),this.elements=new Qs(Hs,"elements"),this.plugins=new Qs(Object,"plugins"),this.scales=new Qs(Js,"scales"),this._typedRegistries=[this.controllers,this.scales,this.elements]}add(...t){this._each("register",t)}remove(...t){this._each("unregister",t)}addControllers(...t){this._each("register",t,this.controllers)}addElements(...t){this._each("register",t,this.elements)}addPlugins(...t){this._each("register",t,this.plugins)}addScales(...t){this._each("register",t,this.scales)}getController(t){return this._get(t,this.controllers,"controller")}getElement(t){return this._get(t,this.elements,"element")}getPlugin(t){return this._get(t,this.plugins,"plugin")}getScale(t){return this._get(t,this.scales,"scale")}removeControllers(...t){this._each("unregister",t,this.controllers)}removeElements(...t){this._each("unregister",t,this.elements)}removePlugins(...t){this._each("unregister",t,this.plugins)}removeScales(...t){this._each("unregister",t,this.scales)}_each(t,e,i){[...e].forEach((e=>{const s=i||this._getRegistryForType(e);i||s.isForType(e)||s===this.plugins&&e.id?this._exec(t,s,e):u(e,(e=>{const s=i||this._getRegistryForType(e);this._exec(t,s,e)}))}))}_exec(t,e,i){const s=w(t);d(i["before"+s],[],i),e[t](i),d(i["after"+s],[],i)}_getRegistryForType(t){for(let e=0;e<this._typedRegistries.length;e++){const i=this._typedRegistries[e];if(i.isForType(t))return i}return this.plugins}_get(t,e,i){const s=e.get(t);if(void 0===s)throw new Error('"'+t+'" is not a registered '+i+".");return s}}var en=new tn;class sn{constructor(){this._init=[]}notify(t,e,i,s){"beforeInit"===e&&(this._init=this._createDescriptors(t,!0),this._notify(this._init,t,"install"));const n=s?this._descriptors(t).filter(s):this._descriptors(t),o=this._notify(n,t,e,i);return"afterDestroy"===e&&(this._notify(n,t,"stop"),this._notify(this._init,t,"uninstall")),o}_notify(t,e,i,s){s=s||{};for(const n of t){const t=n.plugin;if(!1===d(t[i],[e,s,n.options],t)&&s.cancelable)return!1}return!0}invalidate(){s(this._cache)||(this._oldCache=this._cache,this._cache=void 0)}_descriptors(t){if(this._cache)return this._cache;const e=this._cache=this._createDescriptors(t);return this._notifyStateChanges(t),e}_createDescriptors(t,e){const i=t&&t.config,s=l(i.options&&i.options.plugins,{}),n=function(t){const e={},i=[],s=Object.keys(en.plugins.items);for(let t=0;t<s.length;t++)i.push(en.getPlugin(s[t]));const n=t.plugins||[];for(let t=0;t<n.length;t++){const s=n[t];-1===i.indexOf(s)&&(i.push(s),e[s.id]=!0)}return{plugins:i,localIds:e}}(i);return!1!==s||e?function(t,{plugins:e,localIds:i},s,n){const o=[],a=t.getContext();for(const r of e){const e=r.id,l=nn(s[e],n);null!==l&&o.push({plugin:r,options:on(t.config,{plugin:r,local:i[e]},l,a)})}return o}(t,n,s,e):[]}_notifyStateChanges(t){const e=this._oldCache||[],i=this._cache,s=(t,e)=>t.filter((t=>!e.some((e=>t.plugin.id===e.plugin.id))));this._notify(s(e,i),t,"stop"),this._notify(s(i,e),t,"start")}}function nn(t,e){return e||!1!==t?!0===t?{}:t:null}function on(t,{plugin:e,local:i},s,n){const o=t.pluginScopeKeys(e),a=t.getOptionScopes(s,o);return i&&e.defaults&&a.push(e.defaults),t.createResolver(a,n,[""],{scriptable:!1,indexable:!1,allKeys:!0})}function an(t,e){const i=ue.datasets[t]||{};return((e.datasets||{})[t]||{}).indexAxis||e.indexAxis||i.indexAxis||"x"}function rn(t){if("x"===t||"y"===t||"r"===t)return t}function ln(t,...e){if(rn(t))return t;for(const s of e){const e=s.axis||("top"===(i=s.position)||"bottom"===i?"x":"left"===i||"right"===i?"y":void 0)||t.length>1&&rn(t[0].toLowerCase());if(e)return e}var i;throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`)}function hn(t,e,i){if(i[e+"AxisID"]===t)return{axis:e}}function cn(t,e){const i=re[t.type]||{scales:{}},s=e.scales||{},n=an(t.type,e),a=Object.create(null);return Object.keys(s).forEach((e=>{const r=s[e];if(!o(r))return console.error(`Invalid scale configuration for scale: ${e}`);if(r._proxy)return console.warn(`Ignoring resolver passed as options for scale: ${e}`);const l=ln(e,r,function(t,e){if(e.data&&e.data.datasets){const i=e.data.datasets.filter((e=>e.xAxisID===t||e.yAxisID===t));if(i.length)return hn(t,"x",i[0])||hn(t,"y",i[0])}return{}}(e,t),ue.scales[r.type]),h=function(t,e){return t===e?"_index_":"_value_"}(l,n),c=i.scales||{};a[e]=b(Object.create(null),[{axis:l},r,c[l],c[h]])})),t.data.datasets.forEach((i=>{const n=i.type||t.type,o=i.indexAxis||an(n,e),r=(re[n]||{}).scales||{};Object.keys(r).forEach((t=>{const e=function(t,e){let i=t;return"_index_"===t?i=e:"_value_"===t&&(i="x"===e?"y":"x"),i}(t,o),n=i[e+"AxisID"]||e;a[n]=a[n]||Object.create(null),b(a[n],[{axis:e},s[n],r[t]])}))})),Object.keys(a).forEach((t=>{const e=a[t];b(e,[ue.scales[e.type],ue.scale])})),a}function dn(t){const e=t.options||(t.options={});e.plugins=l(e.plugins,{}),e.scales=cn(t,e)}function un(t){return(t=t||{}).datasets=t.datasets||[],t.labels=t.labels||[],t}const fn=new Map,gn=new Set;function pn(t,e){let i=fn.get(t);return i||(i=e(),fn.set(t,i),gn.add(i)),i}const mn=(t,e,i)=>{const s=M(e,i);void 0!==s&&t.add(s)};class xn{constructor(t){this._config=function(t){return(t=t||{}).data=un(t.data),dn(t),t}(t),this._scopeCache=new Map,this._resolverCache=new Map}get platform(){return this._config.platform}get type(){return this._config.type}set type(t){this._config.type=t}get data(){return this._config.data}set data(t){this._config.data=un(t)}get options(){return this._config.options}set options(t){this._config.options=t}get plugins(){return this._config.plugins}update(){const t=this._config;this.clearCache(),dn(t)}clearCache(){this._scopeCache.clear(),this._resolverCache.clear()}datasetScopeKeys(t){return pn(t,(()=>[[`datasets.${t}`,""]]))}datasetAnimationScopeKeys(t,e){return pn(`${t}.transition.${e}`,(()=>[[`datasets.${t}.transitions.${e}`,`transitions.${e}`],[`datasets.${t}`,""]]))}datasetElementScopeKeys(t,e){return pn(`${t}-${e}`,(()=>[[`datasets.${t}.elements.${e}`,`datasets.${t}`,`elements.${e}`,""]]))}pluginScopeKeys(t){const e=t.id;return pn(`${this.type}-plugin-${e}`,(()=>[[`plugins.${e}`,...t.additionalOptionScopes||[]]]))}_cachedScopes(t,e){const i=this._scopeCache;let s=i.get(t);return s&&!e||(s=new Map,i.set(t,s)),s}getOptionScopes(t,e,i){const{options:s,type:n}=this,o=this._cachedScopes(t,i),a=o.get(e);if(a)return a;const r=new Set;e.forEach((e=>{t&&(r.add(t),e.forEach((e=>mn(r,t,e)))),e.forEach((t=>mn(r,s,t))),e.forEach((t=>mn(r,re[n]||{},t))),e.forEach((t=>mn(r,ue,t))),e.forEach((t=>mn(r,le,t)))}));const l=Array.from(r);return 0===l.length&&l.push(Object.create(null)),gn.has(e)&&o.set(e,l),l}chartOptionScopes(){const{options:t,type:e}=this;return[t,re[e]||{},ue.datasets[e]||{},{type:e},ue,le]}resolveNamedOptions(t,e,i,s=[""]){const o={$shared:!0},{resolver:a,subPrefixes:r}=bn(this._resolverCache,t,s);let l=a;if(function(t,e){const{isScriptable:i,isIndexable:s}=Ye(t);for(const o of e){const e=i(o),a=s(o),r=(a||e)&&t[o];if(e&&(S(r)||_n(r))||a&&n(r))return!0}return!1}(a,e)){o.$shared=!1;l=$e(a,i=S(i)?i():i,this.createResolver(t,i,r))}for(const t of e)o[t]=l[t];return o}createResolver(t,e,i=[""],s){const{resolver:n}=bn(this._resolverCache,t,i);return o(e)?$e(n,e,void 0,s):n}}function bn(t,e,i){let s=t.get(e);s||(s=new Map,t.set(e,s));const n=i.join();let o=s.get(n);if(!o){o={resolver:je(e,i),subPrefixes:i.filter((t=>!t.toLowerCase().includes("hover")))},s.set(n,o)}return o}const _n=t=>o(t)&&Object.getOwnPropertyNames(t).some((e=>S(t[e])));const yn=["top","bottom","left","right","chartArea"];function vn(t,e){return"top"===t||"bottom"===t||-1===yn.indexOf(t)&&"x"===e}function Mn(t,e){return function(i,s){return i[t]===s[t]?i[e]-s[e]:i[t]-s[t]}}function wn(t){const e=t.chart,i=e.options.animation;e.notifyPlugins("afterRender"),d(i&&i.onComplete,[t],e)}function kn(t){const e=t.chart,i=e.options.animation;d(i&&i.onProgress,[t],e)}function Sn(t){return fe()&&"string"==typeof t?t=document.getElementById(t):t&&t.length&&(t=t[0]),t&&t.canvas&&(t=t.canvas),t}const Pn={},Dn=t=>{const e=Sn(t);return Object.values(Pn).filter((t=>t.canvas===e)).pop()};function Cn(t,e,i){const s=Object.keys(t);for(const n of s){const s=+n;if(s>=e){const o=t[n];delete t[n],(i>0||s>e)&&(t[s+i]=o)}}}function On(t,e,i){return t.options.clip?t[i]:e[i]}class An{static defaults=ue;static instances=Pn;static overrides=re;static registry=en;static version="4.4.8";static getChart=Dn;static register(...t){en.add(...t),Tn()}static unregister(...t){en.remove(...t),Tn()}constructor(t,e){const s=this.config=new xn(e),n=Sn(t),o=Dn(n);if(o)throw new Error("Canvas is already in use. Chart with ID '"+o.id+"' must be destroyed before the canvas with ID '"+o.canvas.id+"' can be reused.");const a=s.createResolver(s.chartOptionScopes(),this.getContext());this.platform=new(s.platform||ks(n)),this.platform.updateConfig(s);const r=this.platform.acquireContext(n,a.aspectRatio),l=r&&r.canvas,h=l&&l.height,c=l&&l.width;this.id=i(),this.ctx=r,this.canvas=l,this.width=c,this.height=h,this._options=a,this._aspectRatio=this.aspectRatio,this._layers=[],this._metasets=[],this._stacks=void 0,this.boxes=[],this.currentDevicePixelRatio=void 0,this.chartArea=void 0,this._active=[],this._lastEvent=void 0,this._listeners={},this._responsiveListeners=void 0,this._sortedMetasets=[],this.scales={},this._plugins=new sn,this.$proxies={},this._hiddenIndices={},this.attached=!1,this._animationsDisabled=void 0,this.$context=void 0,this._doResize=dt((t=>this.update(t)),a.resizeDelay||0),this._dataChanges=[],Pn[this.id]=this,r&&l?(bt.listen(this,"complete",wn),bt.listen(this,"progress",kn),this._initialize(),this.attached&&this.update()):console.error("Failed to create chart: can't acquire context from the given item")}get aspectRatio(){const{options:{aspectRatio:t,maintainAspectRatio:e},width:i,height:n,_aspectRatio:o}=this;return s(t)?e&&o?o:n?i/n:null:t}get data(){return this.config.data}set data(t){this.config.data=t}get options(){return this._options}set options(t){this.config.options=t}get registry(){return en}_initialize(){return this.notifyPlugins("beforeInit"),this.options.responsive?this.resize():ke(this,this.options.devicePixelRatio),this.bindEvents(),this.notifyPlugins("afterInit"),this}clear(){return Te(this.canvas,this.ctx),this}stop(){return bt.stop(this),this}resize(t,e){bt.running(this)?this._resizeBeforeDraw={width:t,height:e}:this._resize(t,e)}_resize(t,e){const i=this.options,s=this.canvas,n=i.maintainAspectRatio&&this.aspectRatio,o=this.platform.getMaximumSize(s,t,e,n),a=i.devicePixelRatio||this.platform.getDevicePixelRatio(),r=this.width?"resize":"attach";this.width=o.width,this.height=o.height,this._aspectRatio=this.aspectRatio,ke(this,a,!0)&&(this.notifyPlugins("resize",{size:o}),d(i.onResize,[this,o],this),this.attached&&this._doResize(r)&&this.render())}ensureScalesHaveIDs(){u(this.options.scales||{},((t,e)=>{t.id=e}))}buildOrUpdateScales(){const t=this.options,e=t.scales,i=this.scales,s=Object.keys(i).reduce(((t,e)=>(t[e]=!1,t)),{});let n=[];e&&(n=n.concat(Object.keys(e).map((t=>{const i=e[t],s=ln(t,i),n="r"===s,o="x"===s;return{options:i,dposition:n?"chartArea":o?"bottom":"left",dtype:n?"radialLinear":o?"category":"linear"}})))),u(n,(e=>{const n=e.options,o=n.id,a=ln(o,n),r=l(n.type,e.dtype);void 0!==n.position&&vn(n.position,a)===vn(e.dposition)||(n.position=e.dposition),s[o]=!0;let h=null;if(o in i&&i[o].type===r)h=i[o];else{h=new(en.getScale(r))({id:o,type:r,ctx:this.ctx,chart:this}),i[h.id]=h}h.init(n,t)})),u(s,((t,e)=>{t||delete i[e]})),u(i,(t=>{as.configure(this,t,t.options),as.addBox(this,t)}))}_updateMetasets(){const t=this._metasets,e=this.data.datasets.length,i=t.length;if(t.sort(((t,e)=>t.index-e.index)),i>e){for(let t=e;t<i;++t)this._destroyDatasetMeta(t);t.splice(e,i-e)}this._sortedMetasets=t.slice(0).sort(Mn("order","index"))}_removeUnreferencedMetasets(){const{_metasets:t,data:{datasets:e}}=this;t.length>e.length&&delete this._stacks,t.forEach(((t,i)=>{0===e.filter((e=>e===t._dataset)).length&&this._destroyDatasetMeta(i)}))}buildOrUpdateControllers(){const t=[],e=this.data.datasets;let i,s;for(this._removeUnreferencedMetasets(),i=0,s=e.length;i<s;i++){const s=e[i];let n=this.getDatasetMeta(i);const o=s.type||this.config.type;if(n.type&&n.type!==o&&(this._destroyDatasetMeta(i),n=this.getDatasetMeta(i)),n.type=o,n.indexAxis=s.indexAxis||an(o,this.options),n.order=s.order||0,n.index=i,n.label=""+s.label,n.visible=this.isDatasetVisible(i),n.controller)n.controller.updateIndex(i),n.controller.linkScales();else{const e=en.getController(o),{datasetElementType:s,dataElementType:a}=ue.datasets[o];Object.assign(e,{dataElementType:en.getElement(a),datasetElementType:s&&en.getElement(s)}),n.controller=new e(this,i),t.push(n.controller)}}return this._updateMetasets(),t}_resetElements(){u(this.data.datasets,((t,e)=>{this.getDatasetMeta(e).controller.reset()}),this)}reset(){this._resetElements(),this.notifyPlugins("reset")}update(t){const e=this.config;e.update();const i=this._options=e.createResolver(e.chartOptionScopes(),this.getContext()),s=this._animationsDisabled=!i.animation;if(this._updateScales(),this._checkEventBindings(),this._updateHiddenIndices(),this._plugins.invalidate(),!1===this.notifyPlugins("beforeUpdate",{mode:t,cancelable:!0}))return;const n=this.buildOrUpdateControllers();this.notifyPlugins("beforeElementsUpdate");let o=0;for(let t=0,e=this.data.datasets.length;t<e;t++){const{controller:e}=this.getDatasetMeta(t),i=!s&&-1===n.indexOf(e);e.buildOrUpdateElements(i),o=Math.max(+e.getMaxOverflow(),o)}o=this._minPadding=i.layout.autoPadding?o:0,this._updateLayout(o),s||u(n,(t=>{t.reset()})),this._updateDatasets(t),this.notifyPlugins("afterUpdate",{mode:t}),this._layers.sort(Mn("z","_idx"));const{_active:a,_lastEvent:r}=this;r?this._eventHandler(r,!0):a.length&&this._updateHoverStyles(a,a,!0),this.render()}_updateScales(){u(this.scales,(t=>{as.removeBox(this,t)})),this.ensureScalesHaveIDs(),this.buildOrUpdateScales()}_checkEventBindings(){const t=this.options,e=new Set(Object.keys(this._listeners)),i=new Set(t.events);P(e,i)&&!!this._responsiveListeners===t.responsive||(this.unbindEvents(),this.bindEvents())}_updateHiddenIndices(){const{_hiddenIndices:t}=this,e=this._getUniformDataChanges()||[];for(const{method:i,start:s,count:n}of e){Cn(t,s,"_removeElements"===i?-n:n)}}_getUniformDataChanges(){const t=this._dataChanges;if(!t||!t.length)return;this._dataChanges=[];const e=this.data.datasets.length,i=e=>new Set(t.filter((t=>t[0]===e)).map(((t,e)=>e+","+t.splice(1).join(",")))),s=i(0);for(let t=1;t<e;t++)if(!P(s,i(t)))return;return Array.from(s).map((t=>t.split(","))).map((t=>({method:t[1],start:+t[2],count:+t[3]})))}_updateLayout(t){if(!1===this.notifyPlugins("beforeLayout",{cancelable:!0}))return;as.update(this,this.width,this.height,t);const e=this.chartArea,i=e.width<=0||e.height<=0;this._layers=[],u(this.boxes,(t=>{i&&"chartArea"===t.position||(t.configure&&t.configure(),this._layers.push(...t._layers()))}),this),this._layers.forEach(((t,e)=>{t._idx=e})),this.notifyPlugins("afterLayout")}_updateDatasets(t){if(!1!==this.notifyPlugins("beforeDatasetsUpdate",{mode:t,cancelable:!0})){for(let t=0,e=this.data.datasets.length;t<e;++t)this.getDatasetMeta(t).controller.configure();for(let e=0,i=this.data.datasets.length;e<i;++e)this._updateDataset(e,S(t)?t({datasetIndex:e}):t);this.notifyPlugins("afterDatasetsUpdate",{mode:t})}}_updateDataset(t,e){const i=this.getDatasetMeta(t),s={meta:i,index:t,mode:e,cancelable:!0};!1!==this.notifyPlugins("beforeDatasetUpdate",s)&&(i.controller._update(e),s.cancelable=!1,this.notifyPlugins("afterDatasetUpdate",s))}render(){!1!==this.notifyPlugins("beforeRender",{cancelable:!0})&&(bt.has(this)?this.attached&&!bt.running(this)&&bt.start(this):(this.draw(),wn({chart:this})))}draw(){let t;if(this._resizeBeforeDraw){const{width:t,height:e}=this._resizeBeforeDraw;this._resizeBeforeDraw=null,this._resize(t,e)}if(this.clear(),this.width<=0||this.height<=0)return;if(!1===this.notifyPlugins("beforeDraw",{cancelable:!0}))return;const e=this._layers;for(t=0;t<e.length&&e[t].z<=0;++t)e[t].draw(this.chartArea);for(this._drawDatasets();t<e.length;++t)e[t].draw(this.chartArea);this.notifyPlugins("afterDraw")}_getSortedDatasetMetas(t){const e=this._sortedMetasets,i=[];let s,n;for(s=0,n=e.length;s<n;++s){const n=e[s];t&&!n.visible||i.push(n)}return i}getSortedVisibleDatasetMetas(){return this._getSortedDatasetMetas(!0)}_drawDatasets(){if(!1===this.notifyPlugins("beforeDatasetsDraw",{cancelable:!0}))return;const t=this.getSortedVisibleDatasetMetas();for(let e=t.length-1;e>=0;--e)this._drawDataset(t[e]);this.notifyPlugins("afterDatasetsDraw")}_drawDataset(t){const e=this.ctx,i=t._clip,s=!i.disabled,n=function(t,e){const{xScale:i,yScale:s}=t;return i&&s?{left:On(i,e,"left"),right:On(i,e,"right"),top:On(s,e,"top"),bottom:On(s,e,"bottom")}:e}(t,this.chartArea),o={meta:t,index:t.index,cancelable:!0};!1!==this.notifyPlugins("beforeDatasetDraw",o)&&(s&&Ie(e,{left:!1===i.left?0:n.left-i.left,right:!1===i.right?this.width:n.right+i.right,top:!1===i.top?0:n.top-i.top,bottom:!1===i.bottom?this.height:n.bottom+i.bottom}),t.controller.draw(),s&&ze(e),o.cancelable=!1,this.notifyPlugins("afterDatasetDraw",o))}isPointInArea(t){return Re(t,this.chartArea,this._minPadding)}getElementsAtEventForMode(t,e,i,s){const n=Xi.modes[e];return"function"==typeof n?n(this,t,i,s):[]}getDatasetMeta(t){const e=this.data.datasets[t],i=this._metasets;let s=i.filter((t=>t&&t._dataset===e)).pop();return s||(s={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null,order:e&&e.order||0,index:t,_dataset:e,_parsed:[],_sorted:!1},i.push(s)),s}getContext(){return this.$context||(this.$context=Ci(null,{chart:this,type:"chart"}))}getVisibleDatasetCount(){return this.getSortedVisibleDatasetMetas().length}isDatasetVisible(t){const e=this.data.datasets[t];if(!e)return!1;const i=this.getDatasetMeta(t);return"boolean"==typeof i.hidden?!i.hidden:!e.hidden}setDatasetVisibility(t,e){this.getDatasetMeta(t).hidden=!e}toggleDataVisibility(t){this._hiddenIndices[t]=!this._hiddenIndices[t]}getDataVisibility(t){return!this._hiddenIndices[t]}_updateVisibility(t,e,i){const s=i?"show":"hide",n=this.getDatasetMeta(t),o=n.controller._resolveAnimations(void 0,s);k(e)?(n.data[e].hidden=!i,this.update()):(this.setDatasetVisibility(t,i),o.update(n,{visible:i}),this.update((e=>e.datasetIndex===t?s:void 0)))}hide(t,e){this._updateVisibility(t,e,!1)}show(t,e){this._updateVisibility(t,e,!0)}_destroyDatasetMeta(t){const e=this._metasets[t];e&&e.controller&&e.controller._destroy(),delete this._metasets[t]}_stop(){let t,e;for(this.stop(),bt.remove(this),t=0,e=this.data.datasets.length;t<e;++t)this._destroyDatasetMeta(t)}destroy(){this.notifyPlugins("beforeDestroy");const{canvas:t,ctx:e}=this;this._stop(),this.config.clearCache(),t&&(this.unbindEvents(),Te(t,e),this.platform.releaseContext(e),this.canvas=null,this.ctx=null),delete Pn[this.id],this.notifyPlugins("afterDestroy")}toBase64Image(...t){return this.canvas.toDataURL(...t)}bindEvents(){this.bindUserEvents(),this.options.responsive?this.bindResponsiveEvents():this.attached=!0}bindUserEvents(){const t=this._listeners,e=this.platform,i=(i,s)=>{e.addEventListener(this,i,s),t[i]=s},s=(t,e,i)=>{t.offsetX=e,t.offsetY=i,this._eventHandler(t)};u(this.options.events,(t=>i(t,s)))}bindResponsiveEvents(){this._responsiveListeners||(this._responsiveListeners={});const t=this._responsiveListeners,e=this.platform,i=(i,s)=>{e.addEventListener(this,i,s),t[i]=s},s=(i,s)=>{t[i]&&(e.removeEventListener(this,i,s),delete t[i])},n=(t,e)=>{this.canvas&&this.resize(t,e)};let o;const a=()=>{s("attach",a),this.attached=!0,this.resize(),i("resize",n),i("detach",o)};o=()=>{this.attached=!1,s("resize",n),this._stop(),this._resize(0,0),i("attach",a)},e.isAttached(this.canvas)?a():o()}unbindEvents(){u(this._listeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._listeners={},u(this._responsiveListeners,((t,e)=>{this.platform.removeEventListener(this,e,t)})),this._responsiveListeners=void 0}updateHoverStyle(t,e,i){const s=i?"set":"remove";let n,o,a,r;for("dataset"===e&&(n=this.getDatasetMeta(t[0].datasetIndex),n.controller["_"+s+"DatasetHoverStyle"]()),a=0,r=t.length;a<r;++a){o=t[a];const e=o&&this.getDatasetMeta(o.datasetIndex).controller;e&&e[s+"HoverStyle"](o.element,o.datasetIndex,o.index)}}getActiveElements(){return this._active||[]}setActiveElements(t){const e=this._active||[],i=t.map((({datasetIndex:t,index:e})=>{const i=this.getDatasetMeta(t);if(!i)throw new Error("No dataset found at index "+t);return{datasetIndex:t,element:i.data[e],index:e}}));!f(i,e)&&(this._active=i,this._lastEvent=null,this._updateHoverStyles(i,e))}notifyPlugins(t,e,i){return this._plugins.notify(this,t,e,i)}isPluginEnabled(t){return 1===this._plugins._cache.filter((e=>e.plugin.id===t)).length}_updateHoverStyles(t,e,i){const s=this.options.hover,n=(t,e)=>t.filter((t=>!e.some((e=>t.datasetIndex===e.datasetIndex&&t.index===e.index)))),o=n(e,t),a=i?t:n(t,e);o.length&&this.updateHoverStyle(o,s.mode,!1),a.length&&s.mode&&this.updateHoverStyle(a,s.mode,!0)}_eventHandler(t,e){const i={event:t,replay:e,cancelable:!0,inChartArea:this.isPointInArea(t)},s=e=>(e.options.events||this.options.events).includes(t.native.type);if(!1===this.notifyPlugins("beforeEvent",i,s))return;const n=this._handleEvent(t,e,i.inChartArea);return i.cancelable=!1,this.notifyPlugins("afterEvent",i,s),(n||i.changed)&&this.render(),this}_handleEvent(t,e,i){const{_active:s=[],options:n}=this,o=e,a=this._getActiveElements(t,s,i,o),r=D(t),l=function(t,e,i,s){return i&&"mouseout"!==t.type?s?e:t:null}(t,this._lastEvent,i,r);i&&(this._lastEvent=null,d(n.onHover,[t,a,this],this),r&&d(n.onClick,[t,a,this],this));const h=!f(a,s);return(h||e)&&(this._active=a,this._updateHoverStyles(a,s,e)),this._lastEvent=l,h}_getActiveElements(t,e,i,s){if("mouseout"===t.type)return[];if(!i)return e;const n=this.options.hover;return this.getElementsAtEventForMode(t,n.mode,n,s)}}function Tn(){return u(An.instances,(t=>t._plugins.invalidate()))}function Ln(){throw new Error("This method is not implemented: Check that a complete date adapter is provided.")}class En{static override(t){Object.assign(En.prototype,t)}options;constructor(t){this.options=t||{}}init(){}formats(){return Ln()}parse(){return Ln()}format(){return Ln()}add(){return Ln()}diff(){return Ln()}startOf(){return Ln()}endOf(){return Ln()}}var Rn={_date:En};function In(t){const e=t.iScale,i=function(t,e){if(!t._cache.$bar){const i=t.getMatchingVisibleMetas(e);let s=[];for(let e=0,n=i.length;e<n;e++)s=s.concat(i[e].controller.getAllParsedValues(t));t._cache.$bar=lt(s.sort(((t,e)=>t-e)))}return t._cache.$bar}(e,t.type);let s,n,o,a,r=e._length;const l=()=>{32767!==o&&-32768!==o&&(k(a)&&(r=Math.min(r,Math.abs(o-a)||r)),a=o)};for(s=0,n=i.length;s<n;++s)o=e.getPixelForValue(i[s]),l();for(a=void 0,s=0,n=e.ticks.length;s<n;++s)o=e.getPixelForTick(s),l();return r}function zn(t,e,i,s){return n(t)?function(t,e,i,s){const n=i.parse(t[0],s),o=i.parse(t[1],s),a=Math.min(n,o),r=Math.max(n,o);let l=a,h=r;Math.abs(a)>Math.abs(r)&&(l=r,h=a),e[i.axis]=h,e._custom={barStart:l,barEnd:h,start:n,end:o,min:a,max:r}}(t,e,i,s):e[i.axis]=i.parse(t,s),e}function Fn(t,e,i,s){const n=t.iScale,o=t.vScale,a=n.getLabels(),r=n===o,l=[];let h,c,d,u;for(h=i,c=i+s;h<c;++h)u=e[h],d={},d[n.axis]=r||n.parse(a[h],h),l.push(zn(u,d,o,h));return l}function Vn(t){return t&&void 0!==t.barStart&&void 0!==t.barEnd}function Bn(t,e,i,s){let n=e.borderSkipped;const o={};if(!n)return void(t.borderSkipped=o);if(!0===n)return void(t.borderSkipped={top:!0,right:!0,bottom:!0,left:!0});const{start:a,end:r,reverse:l,top:h,bottom:c}=function(t){let e,i,s,n,o;return t.horizontal?(e=t.base>t.x,i="left",s="right"):(e=t.base<t.y,i="bottom",s="top"),e?(n="end",o="start"):(n="start",o="end"),{start:i,end:s,reverse:e,top:n,bottom:o}}(t);"middle"===n&&i&&(t.enableBorderRadius=!0,(i._top||0)===s?n=h:(i._bottom||0)===s?n=c:(o[Wn(c,a,r,l)]=!0,n=h)),o[Wn(n,a,r,l)]=!0,t.borderSkipped=o}function Wn(t,e,i,s){var n,o,a;return s?(a=i,t=Nn(t=(n=t)===(o=e)?a:n===a?o:n,i,e)):t=Nn(t,e,i),t}function Nn(t,e,i){return"start"===t?e:"end"===t?i:t}function Hn(t,{inflateAmount:e},i){t.inflateAmount="auto"===e?1===i?.33:0:e}class jn extends Ns{static id="doughnut";static defaults={datasetElementType:!1,dataElementType:"arc",animation:{animateRotate:!0,animateScale:!1},animations:{numbers:{type:"number",properties:["circumference","endAngle","innerRadius","outerRadius","startAngle","x","y","offset","borderWidth","spacing"]}},cutout:"50%",rotation:0,circumference:360,radius:"100%",spacing:0,indexAxis:"r"};static descriptors={_scriptable:t=>"spacing"!==t,_indexable:t=>"spacing"!==t&&!t.startsWith("borderDash")&&!t.startsWith("hoverBorderDash")};static overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data;if(e.labels.length&&e.datasets.length){const{labels:{pointStyle:i,color:s}}=t.legend.options;return e.labels.map(((e,n)=>{const o=t.getDatasetMeta(0).controller.getStyle(n);return{text:e,fillStyle:o.backgroundColor,strokeStyle:o.borderColor,fontColor:s,lineWidth:o.borderWidth,pointStyle:i,hidden:!t.getDataVisibility(n),index:n}}))}return[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}}}};constructor(t,e){super(t,e),this.enableOptionSharing=!0,this.innerRadius=void 0,this.outerRadius=void 0,this.offsetX=void 0,this.offsetY=void 0}linkScales(){}parse(t,e){const i=this.getDataset().data,s=this._cachedMeta;if(!1===this._parsing)s._parsed=i;else{let n,a,r=t=>+i[t];if(o(i[t])){const{key:t="value"}=this._parsing;r=e=>+M(i[e],t)}for(n=t,a=t+e;n<a;++n)s._parsed[n]=r(n)}}_getRotation(){return $(this.options.rotation-90)}_getCircumference(){return $(this.options.circumference)}_getRotationExtents(){let t=O,e=-O;for(let i=0;i<this.chart.data.datasets.length;++i)if(this.chart.isDatasetVisible(i)&&this.chart.getDatasetMeta(i).type===this._type){const s=this.chart.getDatasetMeta(i).controller,n=s._getRotation(),o=s._getCircumference();t=Math.min(t,n),e=Math.max(e,n+o)}return{rotation:t,circumference:e-t}}update(t){const e=this.chart,{chartArea:i}=e,s=this._cachedMeta,n=s.data,o=this.getMaxBorderWidth()+this.getMaxOffset(n)+this.options.spacing,a=Math.max((Math.min(i.width,i.height)-o)/2,0),r=Math.min(h(this.options.cutout,a),1),l=this._getRingWeight(this.index),{circumference:d,rotation:u}=this._getRotationExtents(),{ratioX:f,ratioY:g,offsetX:p,offsetY:m}=function(t,e,i){let s=1,n=1,o=0,a=0;if(e<O){const r=t,l=r+e,h=Math.cos(r),c=Math.sin(r),d=Math.cos(l),u=Math.sin(l),f=(t,e,s)=>Z(t,r,l,!0)?1:Math.max(e,e*i,s,s*i),g=(t,e,s)=>Z(t,r,l,!0)?-1:Math.min(e,e*i,s,s*i),p=f(0,h,d),m=f(E,c,u),x=g(C,h,d),b=g(C+E,c,u);s=(p-x)/2,n=(m-b)/2,o=-(p+x)/2,a=-(m+b)/2}return{ratioX:s,ratioY:n,offsetX:o,offsetY:a}}(u,d,r),x=(i.width-o)/f,b=(i.height-o)/g,_=Math.max(Math.min(x,b)/2,0),y=c(this.options.radius,_),v=(y-Math.max(y*r,0))/this._getVisibleDatasetWeightTotal();this.offsetX=p*y,this.offsetY=m*y,s.total=this.calculateTotal(),this.outerRadius=y-v*this._getRingWeightOffset(this.index),this.innerRadius=Math.max(this.outerRadius-v*l,0),this.updateElements(n,0,n.length,t)}_circumference(t,e){const i=this.options,s=this._cachedMeta,n=this._getCircumference();return e&&i.animation.animateRotate||!this.chart.getDataVisibility(t)||null===s._parsed[t]||s.data[t].hidden?0:this.calculateCircumference(s._parsed[t]*n/O)}updateElements(t,e,i,s){const n="reset"===s,o=this.chart,a=o.chartArea,r=o.options.animation,l=(a.left+a.right)/2,h=(a.top+a.bottom)/2,c=n&&r.animateScale,d=c?0:this.innerRadius,u=c?0:this.outerRadius,{sharedOptions:f,includeOptions:g}=this._getSharedOptions(e,s);let p,m=this._getRotation();for(p=0;p<e;++p)m+=this._circumference(p,n);for(p=e;p<e+i;++p){const e=this._circumference(p,n),i=t[p],o={x:l+this.offsetX,y:h+this.offsetY,startAngle:m,endAngle:m+e,circumference:e,outerRadius:u,innerRadius:d};g&&(o.options=f||this.resolveDataElementOptions(p,i.active?"active":s)),m+=e,this.updateElement(i,p,o,s)}}calculateTotal(){const t=this._cachedMeta,e=t.data;let i,s=0;for(i=0;i<e.length;i++){const n=t._parsed[i];null===n||isNaN(n)||!this.chart.getDataVisibility(i)||e[i].hidden||(s+=Math.abs(n))}return s}calculateCircumference(t){const e=this._cachedMeta.total;return e>0&&!isNaN(t)?O*(Math.abs(t)/e):0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,s=i.data.labels||[],n=ne(e._parsed[t],i.options.locale);return{label:s[t]||"",value:n}}getMaxBorderWidth(t){let e=0;const i=this.chart;let s,n,o,a,r;if(!t)for(s=0,n=i.data.datasets.length;s<n;++s)if(i.isDatasetVisible(s)){o=i.getDatasetMeta(s),t=o.data,a=o.controller;break}if(!t)return 0;for(s=0,n=t.length;s<n;++s)r=a.resolveDataElementOptions(s),"inner"!==r.borderAlign&&(e=Math.max(e,r.borderWidth||0,r.hoverBorderWidth||0));return e}getMaxOffset(t){let e=0;for(let i=0,s=t.length;i<s;++i){const t=this.resolveDataElementOptions(i);e=Math.max(e,t.offset||0,t.hoverOffset||0)}return e}_getRingWeightOffset(t){let e=0;for(let i=0;i<t;++i)this.chart.isDatasetVisible(i)&&(e+=this._getRingWeight(i));return e}_getRingWeight(t){return Math.max(l(this.chart.data.datasets[t].weight,1),0)}_getVisibleDatasetWeightTotal(){return this._getRingWeightOffset(this.chart.data.datasets.length)||1}}class $n extends Ns{static id="polarArea";static defaults={dataElementType:"arc",animation:{animateRotate:!0,animateScale:!0},animations:{numbers:{type:"number",properties:["x","y","startAngle","endAngle","innerRadius","outerRadius"]}},indexAxis:"r",startAngle:0};static overrides={aspectRatio:1,plugins:{legend:{labels:{generateLabels(t){const e=t.data;if(e.labels.length&&e.datasets.length){const{labels:{pointStyle:i,color:s}}=t.legend.options;return e.labels.map(((e,n)=>{const o=t.getDatasetMeta(0).controller.getStyle(n);return{text:e,fillStyle:o.backgroundColor,strokeStyle:o.borderColor,fontColor:s,lineWidth:o.borderWidth,pointStyle:i,hidden:!t.getDataVisibility(n),index:n}}))}return[]}},onClick(t,e,i){i.chart.toggleDataVisibility(e.index),i.chart.update()}}},scales:{r:{type:"radialLinear",angleLines:{display:!1},beginAtZero:!0,grid:{circular:!0},pointLabels:{display:!1},startAngle:0}}};constructor(t,e){super(t,e),this.innerRadius=void 0,this.outerRadius=void 0}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart,s=i.data.labels||[],n=ne(e._parsed[t].r,i.options.locale);return{label:s[t]||"",value:n}}parseObjectData(t,e,i,s){return ii.bind(this)(t,e,i,s)}update(t){const e=this._cachedMeta.data;this._updateRadius(),this.updateElements(e,0,e.length,t)}getMinMax(){const t=this._cachedMeta,e={min:Number.POSITIVE_INFINITY,max:Number.NEGATIVE_INFINITY};return t.data.forEach(((t,i)=>{const s=this.getParsed(i).r;!isNaN(s)&&this.chart.getDataVisibility(i)&&(s<e.min&&(e.min=s),s>e.max&&(e.max=s))})),e}_updateRadius(){const t=this.chart,e=t.chartArea,i=t.options,s=Math.min(e.right-e.left,e.bottom-e.top),n=Math.max(s/2,0),o=(n-Math.max(i.cutoutPercentage?n/100*i.cutoutPercentage:1,0))/t.getVisibleDatasetCount();this.outerRadius=n-o*this.index,this.innerRadius=this.outerRadius-o}updateElements(t,e,i,s){const n="reset"===s,o=this.chart,a=o.options.animation,r=this._cachedMeta.rScale,l=r.xCenter,h=r.yCenter,c=r.getIndexAngle(0)-.5*C;let d,u=c;const f=360/this.countVisibleElements();for(d=0;d<e;++d)u+=this._computeAngle(d,s,f);for(d=e;d<e+i;d++){const e=t[d];let i=u,g=u+this._computeAngle(d,s,f),p=o.getDataVisibility(d)?r.getDistanceFromCenterForValue(this.getParsed(d).r):0;u=g,n&&(a.animateScale&&(p=0),a.animateRotate&&(i=g=c));const m={x:l,y:h,innerRadius:0,outerRadius:p,startAngle:i,endAngle:g,options:this.resolveDataElementOptions(d,e.active?"active":s)};this.updateElement(e,d,m,s)}}countVisibleElements(){const t=this._cachedMeta;let e=0;return t.data.forEach(((t,i)=>{!isNaN(this.getParsed(i).r)&&this.chart.getDataVisibility(i)&&e++})),e}_computeAngle(t,e,i){return this.chart.getDataVisibility(t)?$(this.resolveDataElementOptions(t,e).angle||i):0}}var Yn=Object.freeze({__proto__:null,BarController:class extends Ns{static id="bar";static defaults={datasetElementType:!1,dataElementType:"bar",categoryPercentage:.8,barPercentage:.9,grouped:!0,animations:{numbers:{type:"number",properties:["x","y","base","width","height"]}}};static overrides={scales:{_index_:{type:"category",offset:!0,grid:{offset:!0}},_value_:{type:"linear",beginAtZero:!0}}};parsePrimitiveData(t,e,i,s){return Fn(t,e,i,s)}parseArrayData(t,e,i,s){return Fn(t,e,i,s)}parseObjectData(t,e,i,s){const{iScale:n,vScale:o}=t,{xAxisKey:a="x",yAxisKey:r="y"}=this._parsing,l="x"===n.axis?a:r,h="x"===o.axis?a:r,c=[];let d,u,f,g;for(d=i,u=i+s;d<u;++d)g=e[d],f={},f[n.axis]=n.parse(M(g,l),d),c.push(zn(M(g,h),f,o,d));return c}updateRangeFromParsed(t,e,i,s){super.updateRangeFromParsed(t,e,i,s);const n=i._custom;n&&e===this._cachedMeta.vScale&&(t.min=Math.min(t.min,n.min),t.max=Math.max(t.max,n.max))}getMaxOverflow(){return 0}getLabelAndValue(t){const e=this._cachedMeta,{iScale:i,vScale:s}=e,n=this.getParsed(t),o=n._custom,a=Vn(o)?"["+o.start+", "+o.end+"]":""+s.getLabelForValue(n[s.axis]);return{label:""+i.getLabelForValue(n[i.axis]),value:a}}initialize(){this.enableOptionSharing=!0,super.initialize();this._cachedMeta.stack=this.getDataset().stack}update(t){const e=this._cachedMeta;this.updateElements(e.data,0,e.data.length,t)}updateElements(t,e,i,n){const o="reset"===n,{index:a,_cachedMeta:{vScale:r}}=this,l=r.getBasePixel(),h=r.isHorizontal(),c=this._getRuler(),{sharedOptions:d,includeOptions:u}=this._getSharedOptions(e,n);for(let f=e;f<e+i;f++){const e=this.getParsed(f),i=o||s(e[r.axis])?{base:l,head:l}:this._calculateBarValuePixels(f),g=this._calculateBarIndexPixels(f,c),p=(e._stacks||{})[r.axis],m={horizontal:h,base:i.base,enableBorderRadius:!p||Vn(e._custom)||a===p._top||a===p._bottom,x:h?i.head:g.center,y:h?g.center:i.head,height:h?g.size:Math.abs(i.size),width:h?Math.abs(i.size):g.size};u&&(m.options=d||this.resolveDataElementOptions(f,t[f].active?"active":n));const x=m.options||t[f].options;Bn(m,x,p,a),Hn(m,x,c.ratio),this.updateElement(t[f],f,m,n)}}_getStacks(t,e){const{iScale:i}=this._cachedMeta,n=i.getMatchingVisibleMetas(this._type).filter((t=>t.controller.options.grouped)),o=i.options.stacked,a=[],r=this._cachedMeta.controller.getParsed(e),l=r&&r[i.axis],h=t=>{const e=t._parsed.find((t=>t[i.axis]===l)),n=e&&e[t.vScale.axis];if(s(n)||isNaN(n))return!0};for(const i of n)if((void 0===e||!h(i))&&((!1===o||-1===a.indexOf(i.stack)||void 0===o&&void 0===i.stack)&&a.push(i.stack),i.index===t))break;return a.length||a.push(void 0),a}_getStackCount(t){return this._getStacks(void 0,t).length}_getStackIndex(t,e,i){const s=this._getStacks(t,i),n=void 0!==e?s.indexOf(e):-1;return-1===n?s.length-1:n}_getRuler(){const t=this.options,e=this._cachedMeta,i=e.iScale,s=[];let n,o;for(n=0,o=e.data.length;n<o;++n)s.push(i.getPixelForValue(this.getParsed(n)[i.axis],n));const a=t.barThickness;return{min:a||In(e),pixels:s,start:i._startPixel,end:i._endPixel,stackCount:this._getStackCount(),scale:i,grouped:t.grouped,ratio:a?1:t.categoryPercentage*t.barPercentage}}_calculateBarValuePixels(t){const{_cachedMeta:{vScale:e,_stacked:i,index:n},options:{base:o,minBarLength:a}}=this,r=o||0,l=this.getParsed(t),h=l._custom,c=Vn(h);let d,u,f=l[e.axis],g=0,p=i?this.applyStack(e,l,i):f;p!==f&&(g=p-f,p=f),c&&(f=h.barStart,p=h.barEnd-h.barStart,0!==f&&F(f)!==F(h.barEnd)&&(g=0),g+=f);const m=s(o)||c?g:o;let x=e.getPixelForValue(m);if(d=this.chart.getDataVisibility(t)?e.getPixelForValue(g+p):x,u=d-x,Math.abs(u)<a){u=function(t,e,i){return 0!==t?F(t):(e.isHorizontal()?1:-1)*(e.min>=i?1:-1)}(u,e,r)*a,f===r&&(x-=u/2);const t=e.getPixelForDecimal(0),s=e.getPixelForDecimal(1),o=Math.min(t,s),h=Math.max(t,s);x=Math.max(Math.min(x,h),o),d=x+u,i&&!c&&(l._stacks[e.axis]._visualValues[n]=e.getValueForPixel(d)-e.getValueForPixel(x))}if(x===e.getPixelForValue(r)){const t=F(u)*e.getLineWidthForValue(r)/2;x+=t,u-=t}return{size:u,base:x,head:d,center:d+u/2}}_calculateBarIndexPixels(t,e){const i=e.scale,n=this.options,o=n.skipNull,a=l(n.maxBarThickness,1/0);let r,h;if(e.grouped){const i=o?this._getStackCount(t):e.stackCount,l="flex"===n.barThickness?function(t,e,i,s){const n=e.pixels,o=n[t];let a=t>0?n[t-1]:null,r=t<n.length-1?n[t+1]:null;const l=i.categoryPercentage;null===a&&(a=o-(null===r?e.end-e.start:r-o)),null===r&&(r=o+o-a);const h=o-(o-Math.min(a,r))/2*l;return{chunk:Math.abs(r-a)/2*l/s,ratio:i.barPercentage,start:h}}(t,e,n,i):function(t,e,i,n){const o=i.barThickness;let a,r;return s(o)?(a=e.min*i.categoryPercentage,r=i.barPercentage):(a=o*n,r=1),{chunk:a/n,ratio:r,start:e.pixels[t]-a/2}}(t,e,n,i),c=this._getStackIndex(this.index,this._cachedMeta.stack,o?t:void 0);r=l.start+l.chunk*c+l.chunk/2,h=Math.min(a,l.chunk*l.ratio)}else r=i.getPixelForValue(this.getParsed(t)[i.axis],t),h=Math.min(a,e.min*e.ratio);return{base:r-h/2,head:r+h/2,center:r,size:h}}draw(){const t=this._cachedMeta,e=t.vScale,i=t.data,s=i.length;let n=0;for(;n<s;++n)null===this.getParsed(n)[e.axis]||i[n].hidden||i[n].draw(this._ctx)}},BubbleController:class extends Ns{static id="bubble";static defaults={datasetElementType:!1,dataElementType:"point",animations:{numbers:{type:"number",properties:["x","y","borderWidth","radius"]}}};static overrides={scales:{x:{type:"linear"},y:{type:"linear"}}};initialize(){this.enableOptionSharing=!0,super.initialize()}parsePrimitiveData(t,e,i,s){const n=super.parsePrimitiveData(t,e,i,s);for(let t=0;t<n.length;t++)n[t]._custom=this.resolveDataElementOptions(t+i).radius;return n}parseArrayData(t,e,i,s){const n=super.parseArrayData(t,e,i,s);for(let t=0;t<n.length;t++){const s=e[i+t];n[t]._custom=l(s[2],this.resolveDataElementOptions(t+i).radius)}return n}parseObjectData(t,e,i,s){const n=super.parseObjectData(t,e,i,s);for(let t=0;t<n.length;t++){const s=e[i+t];n[t]._custom=l(s&&s.r&&+s.r,this.resolveDataElementOptions(t+i).radius)}return n}getMaxOverflow(){const t=this._cachedMeta.data;let e=0;for(let i=t.length-1;i>=0;--i)e=Math.max(e,t[i].size(this.resolveDataElementOptions(i))/2);return e>0&&e}getLabelAndValue(t){const e=this._cachedMeta,i=this.chart.data.labels||[],{xScale:s,yScale:n}=e,o=this.getParsed(t),a=s.getLabelForValue(o.x),r=n.getLabelForValue(o.y),l=o._custom;return{label:i[t]||"",value:"("+a+", "+r+(l?", "+l:"")+")"}}update(t){const e=this._cachedMeta.data;this.updateElements(e,0,e.length,t)}updateElements(t,e,i,s){const n="reset"===s,{iScale:o,vScale:a}=this._cachedMeta,{sharedOptions:r,includeOptions:l}=this._getSharedOptions(e,s),h=o.axis,c=a.axis;for(let d=e;d<e+i;d++){const e=t[d],i=!n&&this.getParsed(d),u={},f=u[h]=n?o.getPixelForDecimal(.5):o.getPixelForValue(i[h]),g=u[c]=n?a.getBasePixel():a.getPixelForValue(i[c]);u.skip=isNaN(f)||isNaN(g),l&&(u.options=r||this.resolveDataElementOptions(d,e.active?"active":s),n&&(u.options.radius=0)),this.updateElement(e,d,u,s)}}resolveDataElementOptions(t,e){const i=this.getParsed(t);let s=super.resolveDataElementOptions(t,e);s.$shared&&(s=Object.assign({},s,{$shared:!1}));const n=s.radius;return"active"!==e&&(s.radius=0),s.radius+=l(i&&i._custom,n),s}},DoughnutController:jn,LineController:class extends Ns{static id="line";static defaults={datasetElementType:"line",dataElementType:"point",showLine:!0,spanGaps:!1};static overrides={scales:{_index_:{type:"category"},_value_:{type:"linear"}}};initialize(){this.enableOptionSharing=!0,this.supportsDecimation=!0,super.initialize()}update(t){const e=this._cachedMeta,{dataset:i,data:s=[],_dataset:n}=e,o=this.chart._animationsDisabled;let{start:a,count:r}=pt(e,s,o);this._drawStart=a,this._drawCount=r,mt(e)&&(a=0,r=s.length),i._chart=this.chart,i._datasetIndex=this.index,i._decimated=!!n._decimated,i.points=s;const l=this.resolveDatasetElementOptions(t);this.options.showLine||(l.borderWidth=0),l.segment=this.options.segment,this.updateElement(i,void 0,{animated:!o,options:l},t),this.updateElements(s,a,r,t)}updateElements(t,e,i,n){const o="reset"===n,{iScale:a,vScale:r,_stacked:l,_dataset:h}=this._cachedMeta,{sharedOptions:c,includeOptions:d}=this._getSharedOptions(e,n),u=a.axis,f=r.axis,{spanGaps:g,segment:p}=this.options,m=N(g)?g:Number.POSITIVE_INFINITY,x=this.chart._animationsDisabled||o||"none"===n,b=e+i,_=t.length;let y=e>0&&this.getParsed(e-1);for(let i=0;i<_;++i){const g=t[i],_=x?g:{};if(i<e||i>=b){_.skip=!0;continue}const v=this.getParsed(i),M=s(v[f]),w=_[u]=a.getPixelForValue(v[u],i),k=_[f]=o||M?r.getBasePixel():r.getPixelForValue(l?this.applyStack(r,v,l):v[f],i);_.skip=isNaN(w)||isNaN(k)||M,_.stop=i>0&&Math.abs(v[u]-y[u])>m,p&&(_.parsed=v,_.raw=h.data[i]),d&&(_.options=c||this.resolveDataElementOptions(i,g.active?"active":n)),x||this.updateElement(g,i,_,n),y=v}}getMaxOverflow(){const t=this._cachedMeta,e=t.dataset,i=e.options&&e.options.borderWidth||0,s=t.data||[];if(!s.length)return i;const n=s[0].size(this.resolveDataElementOptions(0)),o=s[s.length-1].size(this.resolveDataElementOptions(s.length-1));return Math.max(i,n,o)/2}draw(){const t=this._cachedMeta;t.dataset.updateControlPoints(this.chart.chartArea,t.iScale.axis),super.draw()}},PieController:class extends jn{static id="pie";static defaults={cutout:0,rotation:0,circumference:360,radius:"100%"}},PolarAreaController:$n,RadarController:class extends Ns{static id="radar";static defaults={datasetElementType:"line",dataElementType:"point",indexAxis:"r",showLine:!0,elements:{line:{fill:"start"}}};static overrides={aspectRatio:1,scales:{r:{type:"radialLinear"}}};getLabelAndValue(t){const e=this._cachedMeta.vScale,i=this.getParsed(t);return{label:e.getLabels()[t],value:""+e.getLabelForValue(i[e.axis])}}parseObjectData(t,e,i,s){return ii.bind(this)(t,e,i,s)}update(t){const e=this._cachedMeta,i=e.dataset,s=e.data||[],n=e.iScale.getLabels();if(i.points=s,"resize"!==t){const e=this.resolveDatasetElementOptions(t);this.options.showLine||(e.borderWidth=0);const o={_loop:!0,_fullLoop:n.length===s.length,options:e};this.updateElement(i,void 0,o,t)}this.updateElements(s,0,s.length,t)}updateElements(t,e,i,s){const n=this._cachedMeta.rScale,o="reset"===s;for(let a=e;a<e+i;a++){const e=t[a],i=this.resolveDataElementOptions(a,e.active?"active":s),r=n.getPointPositionForValue(a,this.getParsed(a).r),l=o?n.xCenter:r.x,h=o?n.yCenter:r.y,c={x:l,y:h,angle:r.angle,skip:isNaN(l)||isNaN(h),options:i};this.updateElement(e,a,c,s)}}},ScatterController:class extends Ns{static id="scatter";static defaults={datasetElementType:!1,dataElementType:"point",showLine:!1,fill:!1};static overrides={interaction:{mode:"point"},scales:{x:{type:"linear"},y:{type:"linear"}}};getLabelAndValue(t){const e=this._cachedMeta,i=this.chart.data.labels||[],{xScale:s,yScale:n}=e,o=this.getParsed(t),a=s.getLabelForValue(o.x),r=n.getLabelForValue(o.y);return{label:i[t]||"",value:"("+a+", "+r+")"}}update(t){const e=this._cachedMeta,{data:i=[]}=e,s=this.chart._animationsDisabled;let{start:n,count:o}=pt(e,i,s);if(this._drawStart=n,this._drawCount=o,mt(e)&&(n=0,o=i.length),this.options.showLine){this.datasetElementType||this.addElements();const{dataset:n,_dataset:o}=e;n._chart=this.chart,n._datasetIndex=this.index,n._decimated=!!o._decimated,n.points=i;const a=this.resolveDatasetElementOptions(t);a.segment=this.options.segment,this.updateElement(n,void 0,{animated:!s,options:a},t)}else this.datasetElementType&&(delete e.dataset,this.datasetElementType=!1);this.updateElements(i,n,o,t)}addElements(){const{showLine:t}=this.options;!this.datasetElementType&&t&&(this.datasetElementType=this.chart.registry.getElement("line")),super.addElements()}updateElements(t,e,i,n){const o="reset"===n,{iScale:a,vScale:r,_stacked:l,_dataset:h}=this._cachedMeta,c=this.resolveDataElementOptions(e,n),d=this.getSharedOptions(c),u=this.includeOptions(n,d),f=a.axis,g=r.axis,{spanGaps:p,segment:m}=this.options,x=N(p)?p:Number.POSITIVE_INFINITY,b=this.chart._animationsDisabled||o||"none"===n;let _=e>0&&this.getParsed(e-1);for(let c=e;c<e+i;++c){const e=t[c],i=this.getParsed(c),p=b?e:{},y=s(i[g]),v=p[f]=a.getPixelForValue(i[f],c),M=p[g]=o||y?r.getBasePixel():r.getPixelForValue(l?this.applyStack(r,i,l):i[g],c);p.skip=isNaN(v)||isNaN(M)||y,p.stop=c>0&&Math.abs(i[f]-_[f])>x,m&&(p.parsed=i,p.raw=h.data[c]),u&&(p.options=d||this.resolveDataElementOptions(c,e.active?"active":n)),b||this.updateElement(e,c,p,n),_=i}this.updateSharedOptions(d,n,c)}getMaxOverflow(){const t=this._cachedMeta,e=t.data||[];if(!this.options.showLine){let t=0;for(let i=e.length-1;i>=0;--i)t=Math.max(t,e[i].size(this.resolveDataElementOptions(i))/2);return t>0&&t}const i=t.dataset,s=i.options&&i.options.borderWidth||0;if(!e.length)return s;const n=e[0].size(this.resolveDataElementOptions(0)),o=e[e.length-1].size(this.resolveDataElementOptions(e.length-1));return Math.max(s,n,o)/2}}});function Un(t,e,i,s){const n=vi(t.options.borderRadius,["outerStart","outerEnd","innerStart","innerEnd"]);const o=(i-e)/2,a=Math.min(o,s*e/2),r=t=>{const e=(i-Math.min(o,t))*s/2;return J(t,0,Math.min(o,e))};return{outerStart:r(n.outerStart),outerEnd:r(n.outerEnd),innerStart:J(n.innerStart,0,a),innerEnd:J(n.innerEnd,0,a)}}function Xn(t,e,i,s){return{x:i+t*Math.cos(e),y:s+t*Math.sin(e)}}function qn(t,e,i,s,n,o){const{x:a,y:r,startAngle:l,pixelMargin:h,innerRadius:c}=e,d=Math.max(e.outerRadius+s+i-h,0),u=c>0?c+s+i+h:0;let f=0;const g=n-l;if(s){const t=((c>0?c-s:0)+(d>0?d-s:0))/2;f=(g-(0!==t?g*t/(t+s):g))/2}const p=(g-Math.max(.001,g*d-i/C)/d)/2,m=l+p+f,x=n-p-f,{outerStart:b,outerEnd:_,innerStart:y,innerEnd:v}=Un(e,u,d,x-m),M=d-b,w=d-_,k=m+b/M,S=x-_/w,P=u+y,D=u+v,O=m+y/P,A=x-v/D;if(t.beginPath(),o){const e=(k+S)/2;if(t.arc(a,r,d,k,e),t.arc(a,r,d,e,S),_>0){const e=Xn(w,S,a,r);t.arc(e.x,e.y,_,S,x+E)}const i=Xn(D,x,a,r);if(t.lineTo(i.x,i.y),v>0){const e=Xn(D,A,a,r);t.arc(e.x,e.y,v,x+E,A+Math.PI)}const s=(x-v/u+(m+y/u))/2;if(t.arc(a,r,u,x-v/u,s,!0),t.arc(a,r,u,s,m+y/u,!0),y>0){const e=Xn(P,O,a,r);t.arc(e.x,e.y,y,O+Math.PI,m-E)}const n=Xn(M,m,a,r);if(t.lineTo(n.x,n.y),b>0){const e=Xn(M,k,a,r);t.arc(e.x,e.y,b,m-E,k)}}else{t.moveTo(a,r);const e=Math.cos(k)*d+a,i=Math.sin(k)*d+r;t.lineTo(e,i);const s=Math.cos(S)*d+a,n=Math.sin(S)*d+r;t.lineTo(s,n)}t.closePath()}function Kn(t,e,i,s,n){const{fullCircles:o,startAngle:a,circumference:r,options:l}=e,{borderWidth:h,borderJoinStyle:c,borderDash:d,borderDashOffset:u}=l,f="inner"===l.borderAlign;if(!h)return;t.setLineDash(d||[]),t.lineDashOffset=u,f?(t.lineWidth=2*h,t.lineJoin=c||"round"):(t.lineWidth=h,t.lineJoin=c||"bevel");let g=e.endAngle;if(o){qn(t,e,i,s,g,n);for(let e=0;e<o;++e)t.stroke();isNaN(r)||(g=a+(r%O||O))}f&&function(t,e,i){const{startAngle:s,pixelMargin:n,x:o,y:a,outerRadius:r,innerRadius:l}=e;let h=n/r;t.beginPath(),t.arc(o,a,r,s-h,i+h),l>n?(h=n/l,t.arc(o,a,l,i+h,s-h,!0)):t.arc(o,a,n,i+E,s-E),t.closePath(),t.clip()}(t,e,g),o||(qn(t,e,i,s,g,n),t.stroke())}function Gn(t,e,i=e){t.lineCap=l(i.borderCapStyle,e.borderCapStyle),t.setLineDash(l(i.borderDash,e.borderDash)),t.lineDashOffset=l(i.borderDashOffset,e.borderDashOffset),t.lineJoin=l(i.borderJoinStyle,e.borderJoinStyle),t.lineWidth=l(i.borderWidth,e.borderWidth),t.strokeStyle=l(i.borderColor,e.borderColor)}function Zn(t,e,i){t.lineTo(i.x,i.y)}function Jn(t,e,i={}){const s=t.length,{start:n=0,end:o=s-1}=i,{start:a,end:r}=e,l=Math.max(n,a),h=Math.min(o,r),c=n<a&&o<a||n>r&&o>r;return{count:s,start:l,loop:e.loop,ilen:h<l&&!c?s+h-l:h-l}}function Qn(t,e,i,s){const{points:n,options:o}=e,{count:a,start:r,loop:l,ilen:h}=Jn(n,i,s),c=function(t){return t.stepped?Fe:t.tension||"monotone"===t.cubicInterpolationMode?Ve:Zn}(o);let d,u,f,{move:g=!0,reverse:p}=s||{};for(d=0;d<=h;++d)u=n[(r+(p?h-d:d))%a],u.skip||(g?(t.moveTo(u.x,u.y),g=!1):c(t,f,u,p,o.stepped),f=u);return l&&(u=n[(r+(p?h:0))%a],c(t,f,u,p,o.stepped)),!!l}function to(t,e,i,s){const n=e.points,{count:o,start:a,ilen:r}=Jn(n,i,s),{move:l=!0,reverse:h}=s||{};let c,d,u,f,g,p,m=0,x=0;const b=t=>(a+(h?r-t:t))%o,_=()=>{f!==g&&(t.lineTo(m,g),t.lineTo(m,f),t.lineTo(m,p))};for(l&&(d=n[b(0)],t.moveTo(d.x,d.y)),c=0;c<=r;++c){if(d=n[b(c)],d.skip)continue;const e=d.x,i=d.y,s=0|e;s===u?(i<f?f=i:i>g&&(g=i),m=(x*m+e)/++x):(_(),t.lineTo(e,i),u=s,x=0,f=g=i),p=i}_()}function eo(t){const e=t.options,i=e.borderDash&&e.borderDash.length;return!(t._decimated||t._loop||e.tension||"monotone"===e.cubicInterpolationMode||e.stepped||i)?to:Qn}const io="function"==typeof Path2D;function so(t,e,i,s){io&&!e.options.segment?function(t,e,i,s){let n=e._path;n||(n=e._path=new Path2D,e.path(n,i,s)&&n.closePath()),Gn(t,e.options),t.stroke(n)}(t,e,i,s):function(t,e,i,s){const{segments:n,options:o}=e,a=eo(e);for(const r of n)Gn(t,o,r.style),t.beginPath(),a(t,e,r,{start:i,end:i+s-1})&&t.closePath(),t.stroke()}(t,e,i,s)}class no extends Hs{static id="line";static defaults={borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",borderWidth:3,capBezierPoints:!0,cubicInterpolationMode:"default",fill:!1,spanGaps:!1,stepped:!1,tension:0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};static descriptors={_scriptable:!0,_indexable:t=>"borderDash"!==t&&"fill"!==t};constructor(t){super(),this.animated=!0,this.options=void 0,this._chart=void 0,this._loop=void 0,this._fullLoop=void 0,this._path=void 0,this._points=void 0,this._segments=void 0,this._decimated=!1,this._pointsUpdated=!1,this._datasetIndex=void 0,t&&Object.assign(this,t)}updateControlPoints(t,e){const i=this.options;if((i.tension||"monotone"===i.cubicInterpolationMode)&&!i.stepped&&!this._pointsUpdated){const s=i.spanGaps?this._loop:this._fullLoop;hi(this._points,i,t,s,e),this._pointsUpdated=!0}}set points(t){this._points=t,delete this._segments,delete this._path,this._pointsUpdated=!1}get points(){return this._points}get segments(){return this._segments||(this._segments=zi(this,this.options.segment))}first(){const t=this.segments,e=this.points;return t.length&&e[t[0].start]}last(){const t=this.segments,e=this.points,i=t.length;return i&&e[t[i-1].end]}interpolate(t,e){const i=this.options,s=t[e],n=this.points,o=Ii(this,{property:e,start:s,end:s});if(!o.length)return;const a=[],r=function(t){return t.stepped?pi:t.tension||"monotone"===t.cubicInterpolationMode?mi:gi}(i);let l,h;for(l=0,h=o.length;l<h;++l){const{start:h,end:c}=o[l],d=n[h],u=n[c];if(d===u){a.push(d);continue}const f=r(d,u,Math.abs((s-d[e])/(u[e]-d[e])),i.stepped);f[e]=t[e],a.push(f)}return 1===a.length?a[0]:a}pathSegment(t,e,i){return eo(this)(t,this,e,i)}path(t,e,i){const s=this.segments,n=eo(this);let o=this._loop;e=e||0,i=i||this.points.length-e;for(const a of s)o&=n(t,this,a,{start:e,end:e+i-1});return!!o}draw(t,e,i,s){const n=this.options||{};(this.points||[]).length&&n.borderWidth&&(t.save(),so(t,this,i,s),t.restore()),this.animated&&(this._pointsUpdated=!1,this._path=void 0)}}function oo(t,e,i,s){const n=t.options,{[i]:o}=t.getProps([i],s);return Math.abs(e-o)<n.radius+n.hitRadius}function ao(t,e){const{x:i,y:s,base:n,width:o,height:a}=t.getProps(["x","y","base","width","height"],e);let r,l,h,c,d;return t.horizontal?(d=a/2,r=Math.min(i,n),l=Math.max(i,n),h=s-d,c=s+d):(d=o/2,r=i-d,l=i+d,h=Math.min(s,n),c=Math.max(s,n)),{left:r,top:h,right:l,bottom:c}}function ro(t,e,i,s){return t?0:J(e,i,s)}function lo(t){const e=ao(t),i=e.right-e.left,s=e.bottom-e.top,n=function(t,e,i){const s=t.options.borderWidth,n=t.borderSkipped,o=Mi(s);return{t:ro(n.top,o.top,0,i),r:ro(n.right,o.right,0,e),b:ro(n.bottom,o.bottom,0,i),l:ro(n.left,o.left,0,e)}}(t,i/2,s/2),a=function(t,e,i){const{enableBorderRadius:s}=t.getProps(["enableBorderRadius"]),n=t.options.borderRadius,a=wi(n),r=Math.min(e,i),l=t.borderSkipped,h=s||o(n);return{topLeft:ro(!h||l.top||l.left,a.topLeft,0,r),topRight:ro(!h||l.top||l.right,a.topRight,0,r),bottomLeft:ro(!h||l.bottom||l.left,a.bottomLeft,0,r),bottomRight:ro(!h||l.bottom||l.right,a.bottomRight,0,r)}}(t,i/2,s/2);return{outer:{x:e.left,y:e.top,w:i,h:s,radius:a},inner:{x:e.left+n.l,y:e.top+n.t,w:i-n.l-n.r,h:s-n.t-n.b,radius:{topLeft:Math.max(0,a.topLeft-Math.max(n.t,n.l)),topRight:Math.max(0,a.topRight-Math.max(n.t,n.r)),bottomLeft:Math.max(0,a.bottomLeft-Math.max(n.b,n.l)),bottomRight:Math.max(0,a.bottomRight-Math.max(n.b,n.r))}}}}function ho(t,e,i,s){const n=null===e,o=null===i,a=t&&!(n&&o)&&ao(t,s);return a&&(n||tt(e,a.left,a.right))&&(o||tt(i,a.top,a.bottom))}function co(t,e){t.rect(e.x,e.y,e.w,e.h)}function uo(t,e,i={}){const s=t.x!==i.x?-e:0,n=t.y!==i.y?-e:0,o=(t.x+t.w!==i.x+i.w?e:0)-s,a=(t.y+t.h!==i.y+i.h?e:0)-n;return{x:t.x+s,y:t.y+n,w:t.w+o,h:t.h+a,radius:t.radius}}var fo=Object.freeze({__proto__:null,ArcElement:class extends Hs{static id="arc";static defaults={borderAlign:"center",borderColor:"#fff",borderDash:[],borderDashOffset:0,borderJoinStyle:void 0,borderRadius:0,borderWidth:2,offset:0,spacing:0,angle:void 0,circular:!0};static defaultRoutes={backgroundColor:"backgroundColor"};static descriptors={_scriptable:!0,_indexable:t=>"borderDash"!==t};circumference;endAngle;fullCircles;innerRadius;outerRadius;pixelMargin;startAngle;constructor(t){super(),this.options=void 0,this.circumference=void 0,this.startAngle=void 0,this.endAngle=void 0,this.innerRadius=void 0,this.outerRadius=void 0,this.pixelMargin=0,this.fullCircles=0,t&&Object.assign(this,t)}inRange(t,e,i){const s=this.getProps(["x","y"],i),{angle:n,distance:o}=X(s,{x:t,y:e}),{startAngle:a,endAngle:r,innerRadius:h,outerRadius:c,circumference:d}=this.getProps(["startAngle","endAngle","innerRadius","outerRadius","circumference"],i),u=(this.options.spacing+this.options.borderWidth)/2,f=l(d,r-a),g=Z(n,a,r)&&a!==r,p=f>=O||g,m=tt(o,h+u,c+u);return p&&m}getCenterPoint(t){const{x:e,y:i,startAngle:s,endAngle:n,innerRadius:o,outerRadius:a}=this.getProps(["x","y","startAngle","endAngle","innerRadius","outerRadius"],t),{offset:r,spacing:l}=this.options,h=(s+n)/2,c=(o+a+l+r)/2;return{x:e+Math.cos(h)*c,y:i+Math.sin(h)*c}}tooltipPosition(t){return this.getCenterPoint(t)}draw(t){const{options:e,circumference:i}=this,s=(e.offset||0)/4,n=(e.spacing||0)/2,o=e.circular;if(this.pixelMargin="inner"===e.borderAlign?.33:0,this.fullCircles=i>O?Math.floor(i/O):0,0===i||this.innerRadius<0||this.outerRadius<0)return;t.save();const a=(this.startAngle+this.endAngle)/2;t.translate(Math.cos(a)*s,Math.sin(a)*s);const r=s*(1-Math.sin(Math.min(C,i||0)));t.fillStyle=e.backgroundColor,t.strokeStyle=e.borderColor,function(t,e,i,s,n){const{fullCircles:o,startAngle:a,circumference:r}=e;let l=e.endAngle;if(o){qn(t,e,i,s,l,n);for(let e=0;e<o;++e)t.fill();isNaN(r)||(l=a+(r%O||O))}qn(t,e,i,s,l,n),t.fill()}(t,this,r,n,o),Kn(t,this,r,n,o),t.restore()}},BarElement:class extends Hs{static id="bar";static defaults={borderSkipped:"start",borderWidth:0,borderRadius:0,inflateAmount:"auto",pointStyle:void 0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};constructor(t){super(),this.options=void 0,this.horizontal=void 0,this.base=void 0,this.width=void 0,this.height=void 0,this.inflateAmount=void 0,t&&Object.assign(this,t)}draw(t){const{inflateAmount:e,options:{borderColor:i,backgroundColor:s}}=this,{inner:n,outer:o}=lo(this),a=(r=o.radius).topLeft||r.topRight||r.bottomLeft||r.bottomRight?He:co;var r;t.save(),o.w===n.w&&o.h===n.h||(t.beginPath(),a(t,uo(o,e,n)),t.clip(),a(t,uo(n,-e,o)),t.fillStyle=i,t.fill("evenodd")),t.beginPath(),a(t,uo(n,e)),t.fillStyle=s,t.fill(),t.restore()}inRange(t,e,i){return ho(this,t,e,i)}inXRange(t,e){return ho(this,t,null,e)}inYRange(t,e){return ho(this,null,t,e)}getCenterPoint(t){const{x:e,y:i,base:s,horizontal:n}=this.getProps(["x","y","base","horizontal"],t);return{x:n?(e+s)/2:e,y:n?i:(i+s)/2}}getRange(t){return"x"===t?this.width/2:this.height/2}},LineElement:no,PointElement:class extends Hs{static id="point";parsed;skip;stop;static defaults={borderWidth:1,hitRadius:1,hoverBorderWidth:1,hoverRadius:4,pointStyle:"circle",radius:3,rotation:0};static defaultRoutes={backgroundColor:"backgroundColor",borderColor:"borderColor"};constructor(t){super(),this.options=void 0,this.parsed=void 0,this.skip=void 0,this.stop=void 0,t&&Object.assign(this,t)}inRange(t,e,i){const s=this.options,{x:n,y:o}=this.getProps(["x","y"],i);return Math.pow(t-n,2)+Math.pow(e-o,2)<Math.pow(s.hitRadius+s.radius,2)}inXRange(t,e){return oo(this,t,"x",e)}inYRange(t,e){return oo(this,t,"y",e)}getCenterPoint(t){const{x:e,y:i}=this.getProps(["x","y"],t);return{x:e,y:i}}size(t){let e=(t=t||this.options||{}).radius||0;e=Math.max(e,e&&t.hoverRadius||0);return 2*(e+(e&&t.borderWidth||0))}draw(t,e){const i=this.options;this.skip||i.radius<.1||!Re(this,e,this.size(i)/2)||(t.strokeStyle=i.borderColor,t.lineWidth=i.borderWidth,t.fillStyle=i.backgroundColor,Le(t,i,this.x,this.y))}getRange(){const t=this.options||{};return t.radius+t.hitRadius}}});function go(t,e,i,s){const n=t.indexOf(e);if(-1===n)return((t,e,i,s)=>("string"==typeof e?(i=t.push(e)-1,s.unshift({index:i,label:e})):isNaN(e)&&(i=null),i))(t,e,i,s);return n!==t.lastIndexOf(e)?i:n}function po(t){const e=this.getLabels();return t>=0&&t<e.length?e[t]:t}function mo(t,e,{horizontal:i,minRotation:s}){const n=$(s),o=(i?Math.sin(n):Math.cos(n))||.001,a=.75*e*(""+t).length;return Math.min(e/o,a)}class xo extends Js{constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._endValue=void 0,this._valueRange=0}parse(t,e){return s(t)||("number"==typeof t||t instanceof Number)&&!isFinite(+t)?null:+t}handleTickRangeOptions(){const{beginAtZero:t}=this.options,{minDefined:e,maxDefined:i}=this.getUserBounds();let{min:s,max:n}=this;const o=t=>s=e?s:t,a=t=>n=i?n:t;if(t){const t=F(s),e=F(n);t<0&&e<0?a(0):t>0&&e>0&&o(0)}if(s===n){let e=0===n?1:Math.abs(.05*n);a(n+e),t||o(s-e)}this.min=s,this.max=n}getTickLimit(){const t=this.options.ticks;let e,{maxTicksLimit:i,stepSize:s}=t;return s?(e=Math.ceil(this.max/s)-Math.floor(this.min/s)+1,e>1e3&&(console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${e} ticks. Limiting to 1000.`),e=1e3)):(e=this.computeTickLimit(),i=i||11),i&&(e=Math.min(i,e)),e}computeTickLimit(){return Number.POSITIVE_INFINITY}buildTicks(){const t=this.options,e=t.ticks;let i=this.getTickLimit();i=Math.max(2,i);const n=function(t,e){const i=[],{bounds:n,step:o,min:a,max:r,precision:l,count:h,maxTicks:c,maxDigits:d,includeBounds:u}=t,f=o||1,g=c-1,{min:p,max:m}=e,x=!s(a),b=!s(r),_=!s(h),y=(m-p)/(d+1);let v,M,w,k,S=B((m-p)/g/f)*f;if(S<1e-14&&!x&&!b)return[{value:p},{value:m}];k=Math.ceil(m/S)-Math.floor(p/S),k>g&&(S=B(k*S/g/f)*f),s(l)||(v=Math.pow(10,l),S=Math.ceil(S*v)/v),"ticks"===n?(M=Math.floor(p/S)*S,w=Math.ceil(m/S)*S):(M=p,w=m),x&&b&&o&&H((r-a)/o,S/1e3)?(k=Math.round(Math.min((r-a)/S,c)),S=(r-a)/k,M=a,w=r):_?(M=x?a:M,w=b?r:w,k=h-1,S=(w-M)/k):(k=(w-M)/S,k=V(k,Math.round(k),S/1e3)?Math.round(k):Math.ceil(k));const P=Math.max(U(S),U(M));v=Math.pow(10,s(l)?P:l),M=Math.round(M*v)/v,w=Math.round(w*v)/v;let D=0;for(x&&(u&&M!==a?(i.push({value:a}),M<a&&D++,V(Math.round((M+D*S)*v)/v,a,mo(a,y,t))&&D++):M<a&&D++);D<k;++D){const t=Math.round((M+D*S)*v)/v;if(b&&t>r)break;i.push({value:t})}return b&&u&&w!==r?i.length&&V(i[i.length-1].value,r,mo(r,y,t))?i[i.length-1].value=r:i.push({value:r}):b&&w!==r||i.push({value:w}),i}({maxTicks:i,bounds:t.bounds,min:t.min,max:t.max,precision:e.precision,step:e.stepSize,count:e.count,maxDigits:this._maxDigits(),horizontal:this.isHorizontal(),minRotation:e.minRotation||0,includeBounds:!1!==e.includeBounds},this._range||this);return"ticks"===t.bounds&&j(n,this,"value"),t.reverse?(n.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),n}configure(){const t=this.ticks;let e=this.min,i=this.max;if(super.configure(),this.options.offset&&t.length){const s=(i-e)/Math.max(t.length-1,1)/2;e-=s,i+=s}this._startValue=e,this._endValue=i,this._valueRange=i-e}getLabelForValue(t){return ne(t,this.chart.options.locale,this.options.ticks.format)}}class bo extends xo{static id="linear";static defaults={ticks:{callback:ae.formatters.numeric}};determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=a(t)?t:0,this.max=a(e)?e:1,this.handleTickRangeOptions()}computeTickLimit(){const t=this.isHorizontal(),e=t?this.width:this.height,i=$(this.options.ticks.minRotation),s=(t?Math.sin(i):Math.cos(i))||.001,n=this._resolveTickFontOptions(0);return Math.ceil(e/Math.min(40,n.lineHeight/s))}getPixelForValue(t){return null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getValueForPixel(t){return this._startValue+this.getDecimalForPixel(t)*this._valueRange}}const _o=t=>Math.floor(z(t)),yo=(t,e)=>Math.pow(10,_o(t)+e);function vo(t){return 1===t/Math.pow(10,_o(t))}function Mo(t,e,i){const s=Math.pow(10,i),n=Math.floor(t/s);return Math.ceil(e/s)-n}function wo(t,{min:e,max:i}){e=r(t.min,e);const s=[],n=_o(e);let o=function(t,e){let i=_o(e-t);for(;Mo(t,e,i)>10;)i++;for(;Mo(t,e,i)<10;)i--;return Math.min(i,_o(t))}(e,i),a=o<0?Math.pow(10,Math.abs(o)):1;const l=Math.pow(10,o),h=n>o?Math.pow(10,n):0,c=Math.round((e-h)*a)/a,d=Math.floor((e-h)/l/10)*l*10;let u=Math.floor((c-d)/Math.pow(10,o)),f=r(t.min,Math.round((h+d+u*Math.pow(10,o))*a)/a);for(;f<i;)s.push({value:f,major:vo(f),significand:u}),u>=10?u=u<15?15:20:u++,u>=20&&(o++,u=2,a=o>=0?1:a),f=Math.round((h+d+u*Math.pow(10,o))*a)/a;const g=r(t.max,f);return s.push({value:g,major:vo(g),significand:u}),s}class ko extends Js{static id="logarithmic";static defaults={ticks:{callback:ae.formatters.logarithmic,major:{enabled:!0}}};constructor(t){super(t),this.start=void 0,this.end=void 0,this._startValue=void 0,this._valueRange=0}parse(t,e){const i=xo.prototype.parse.apply(this,[t,e]);if(0!==i)return a(i)&&i>0?i:null;this._zero=!0}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!0);this.min=a(t)?Math.max(0,t):null,this.max=a(e)?Math.max(0,e):null,this.options.beginAtZero&&(this._zero=!0),this._zero&&this.min!==this._suggestedMin&&!a(this._userMin)&&(this.min=t===yo(this.min,0)?yo(this.min,-1):yo(this.min,0)),this.handleTickRangeOptions()}handleTickRangeOptions(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let i=this.min,s=this.max;const n=e=>i=t?i:e,o=t=>s=e?s:t;i===s&&(i<=0?(n(1),o(10)):(n(yo(i,-1)),o(yo(s,1)))),i<=0&&n(yo(s,-1)),s<=0&&o(yo(i,1)),this.min=i,this.max=s}buildTicks(){const t=this.options,e=wo({min:this._userMin,max:this._userMax},this);return"ticks"===t.bounds&&j(e,this,"value"),t.reverse?(e.reverse(),this.start=this.max,this.end=this.min):(this.start=this.min,this.end=this.max),e}getLabelForValue(t){return void 0===t?"0":ne(t,this.chart.options.locale,this.options.ticks.format)}configure(){const t=this.min;super.configure(),this._startValue=z(t),this._valueRange=z(this.max)-z(t)}getPixelForValue(t){return void 0!==t&&0!==t||(t=this.min),null===t||isNaN(t)?NaN:this.getPixelForDecimal(t===this.min?0:(z(t)-this._startValue)/this._valueRange)}getValueForPixel(t){const e=this.getDecimalForPixel(t);return Math.pow(10,this._startValue+e*this._valueRange)}}function So(t){const e=t.ticks;if(e.display&&t.display){const t=ki(e.backdropPadding);return l(e.font&&e.font.size,ue.font.size)+t.height}return 0}function Po(t,e,i,s,n){return t===s||t===n?{start:e-i/2,end:e+i/2}:t<s||t>n?{start:e-i,end:e}:{start:e,end:e+i}}function Do(t){const e={l:t.left+t._padding.left,r:t.right-t._padding.right,t:t.top+t._padding.top,b:t.bottom-t._padding.bottom},i=Object.assign({},e),s=[],o=[],a=t._pointLabels.length,r=t.options.pointLabels,l=r.centerPointLabels?C/a:0;for(let u=0;u<a;u++){const a=r.setContext(t.getPointLabelContext(u));o[u]=a.padding;const f=t.getPointPosition(u,t.drawingArea+o[u],l),g=Si(a.font),p=(h=t.ctx,c=g,d=n(d=t._pointLabels[u])?d:[d],{w:Oe(h,c.string,d),h:d.length*c.lineHeight});s[u]=p;const m=G(t.getIndexAngle(u)+l),x=Math.round(Y(m));Co(i,e,m,Po(x,f.x,p.w,0,180),Po(x,f.y,p.h,90,270))}var h,c,d;t.setCenterPoint(e.l-i.l,i.r-e.r,e.t-i.t,i.b-e.b),t._pointLabelItems=function(t,e,i){const s=[],n=t._pointLabels.length,o=t.options,{centerPointLabels:a,display:r}=o.pointLabels,l={extra:So(o)/2,additionalAngle:a?C/n:0};let h;for(let o=0;o<n;o++){l.padding=i[o],l.size=e[o];const n=Oo(t,o,l);s.push(n),"auto"===r&&(n.visible=Ao(n,h),n.visible&&(h=n))}return s}(t,s,o)}function Co(t,e,i,s,n){const o=Math.abs(Math.sin(i)),a=Math.abs(Math.cos(i));let r=0,l=0;s.start<e.l?(r=(e.l-s.start)/o,t.l=Math.min(t.l,e.l-r)):s.end>e.r&&(r=(s.end-e.r)/o,t.r=Math.max(t.r,e.r+r)),n.start<e.t?(l=(e.t-n.start)/a,t.t=Math.min(t.t,e.t-l)):n.end>e.b&&(l=(n.end-e.b)/a,t.b=Math.max(t.b,e.b+l))}function Oo(t,e,i){const s=t.drawingArea,{extra:n,additionalAngle:o,padding:a,size:r}=i,l=t.getPointPosition(e,s+n+a,o),h=Math.round(Y(G(l.angle+E))),c=function(t,e,i){90===i||270===i?t-=e/2:(i>270||i<90)&&(t-=e);return t}(l.y,r.h,h),d=function(t){if(0===t||180===t)return"center";if(t<180)return"left";return"right"}(h),u=function(t,e,i){"right"===i?t-=e:"center"===i&&(t-=e/2);return t}(l.x,r.w,d);return{visible:!0,x:l.x,y:c,textAlign:d,left:u,top:c,right:u+r.w,bottom:c+r.h}}function Ao(t,e){if(!e)return!0;const{left:i,top:s,right:n,bottom:o}=t;return!(Re({x:i,y:s},e)||Re({x:i,y:o},e)||Re({x:n,y:s},e)||Re({x:n,y:o},e))}function To(t,e,i){const{left:n,top:o,right:a,bottom:r}=i,{backdropColor:l}=e;if(!s(l)){const i=wi(e.borderRadius),s=ki(e.backdropPadding);t.fillStyle=l;const h=n-s.left,c=o-s.top,d=a-n+s.width,u=r-o+s.height;Object.values(i).some((t=>0!==t))?(t.beginPath(),He(t,{x:h,y:c,w:d,h:u,radius:i}),t.fill()):t.fillRect(h,c,d,u)}}function Lo(t,e,i,s){const{ctx:n}=t;if(i)n.arc(t.xCenter,t.yCenter,e,0,O);else{let i=t.getPointPosition(0,e);n.moveTo(i.x,i.y);for(let o=1;o<s;o++)i=t.getPointPosition(o,e),n.lineTo(i.x,i.y)}}class Eo extends xo{static id="radialLinear";static defaults={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,lineWidth:1,borderDash:[],borderDashOffset:0},grid:{circular:!1},startAngle:0,ticks:{showLabelBackdrop:!0,callback:ae.formatters.numeric},pointLabels:{backdropColor:void 0,backdropPadding:2,display:!0,font:{size:10},callback:t=>t,padding:5,centerPointLabels:!1}};static defaultRoutes={"angleLines.color":"borderColor","pointLabels.color":"color","ticks.color":"color"};static descriptors={angleLines:{_fallback:"grid"}};constructor(t){super(t),this.xCenter=void 0,this.yCenter=void 0,this.drawingArea=void 0,this._pointLabels=[],this._pointLabelItems=[]}setDimensions(){const t=this._padding=ki(So(this.options)/2),e=this.width=this.maxWidth-t.width,i=this.height=this.maxHeight-t.height;this.xCenter=Math.floor(this.left+e/2+t.left),this.yCenter=Math.floor(this.top+i/2+t.top),this.drawingArea=Math.floor(Math.min(e,i)/2)}determineDataLimits(){const{min:t,max:e}=this.getMinMax(!1);this.min=a(t)&&!isNaN(t)?t:0,this.max=a(e)&&!isNaN(e)?e:0,this.handleTickRangeOptions()}computeTickLimit(){return Math.ceil(this.drawingArea/So(this.options))}generateTickLabels(t){xo.prototype.generateTickLabels.call(this,t),this._pointLabels=this.getLabels().map(((t,e)=>{const i=d(this.options.pointLabels.callback,[t,e],this);return i||0===i?i:""})).filter(((t,e)=>this.chart.getDataVisibility(e)))}fit(){const t=this.options;t.display&&t.pointLabels.display?Do(this):this.setCenterPoint(0,0,0,0)}setCenterPoint(t,e,i,s){this.xCenter+=Math.floor((t-e)/2),this.yCenter+=Math.floor((i-s)/2),this.drawingArea-=Math.min(this.drawingArea/2,Math.max(t,e,i,s))}getIndexAngle(t){return G(t*(O/(this._pointLabels.length||1))+$(this.options.startAngle||0))}getDistanceFromCenterForValue(t){if(s(t))return NaN;const e=this.drawingArea/(this.max-this.min);return this.options.reverse?(this.max-t)*e:(t-this.min)*e}getValueForDistanceFromCenter(t){if(s(t))return NaN;const e=t/(this.drawingArea/(this.max-this.min));return this.options.reverse?this.max-e:this.min+e}getPointLabelContext(t){const e=this._pointLabels||[];if(t>=0&&t<e.length){const i=e[t];return function(t,e,i){return Ci(t,{label:i,index:e,type:"pointLabel"})}(this.getContext(),t,i)}}getPointPosition(t,e,i=0){const s=this.getIndexAngle(t)-E+i;return{x:Math.cos(s)*e+this.xCenter,y:Math.sin(s)*e+this.yCenter,angle:s}}getPointPositionForValue(t,e){return this.getPointPosition(t,this.getDistanceFromCenterForValue(e))}getBasePosition(t){return this.getPointPositionForValue(t||0,this.getBaseValue())}getPointLabelPosition(t){const{left:e,top:i,right:s,bottom:n}=this._pointLabelItems[t];return{left:e,top:i,right:s,bottom:n}}drawBackground(){const{backgroundColor:t,grid:{circular:e}}=this.options;if(t){const i=this.ctx;i.save(),i.beginPath(),Lo(this,this.getDistanceFromCenterForValue(this._endValue),e,this._pointLabels.length),i.closePath(),i.fillStyle=t,i.fill(),i.restore()}}drawGrid(){const t=this.ctx,e=this.options,{angleLines:i,grid:s,border:n}=e,o=this._pointLabels.length;let a,r,l;if(e.pointLabels.display&&function(t,e){const{ctx:i,options:{pointLabels:s}}=t;for(let n=e-1;n>=0;n--){const e=t._pointLabelItems[n];if(!e.visible)continue;const o=s.setContext(t.getPointLabelContext(n));To(i,o,e);const a=Si(o.font),{x:r,y:l,textAlign:h}=e;Ne(i,t._pointLabels[n],r,l+a.lineHeight/2,a,{color:o.color,textAlign:h,textBaseline:"middle"})}}(this,o),s.display&&this.ticks.forEach(((t,e)=>{if(0!==e||0===e&&this.min<0){r=this.getDistanceFromCenterForValue(t.value);const i=this.getContext(e),a=s.setContext(i),l=n.setContext(i);!function(t,e,i,s,n){const o=t.ctx,a=e.circular,{color:r,lineWidth:l}=e;!a&&!s||!r||!l||i<0||(o.save(),o.strokeStyle=r,o.lineWidth=l,o.setLineDash(n.dash||[]),o.lineDashOffset=n.dashOffset,o.beginPath(),Lo(t,i,a,s),o.closePath(),o.stroke(),o.restore())}(this,a,r,o,l)}})),i.display){for(t.save(),a=o-1;a>=0;a--){const s=i.setContext(this.getPointLabelContext(a)),{color:n,lineWidth:o}=s;o&&n&&(t.lineWidth=o,t.strokeStyle=n,t.setLineDash(s.borderDash),t.lineDashOffset=s.borderDashOffset,r=this.getDistanceFromCenterForValue(e.reverse?this.min:this.max),l=this.getPointPosition(a,r),t.beginPath(),t.moveTo(this.xCenter,this.yCenter),t.lineTo(l.x,l.y),t.stroke())}t.restore()}}drawBorder(){}drawLabels(){const t=this.ctx,e=this.options,i=e.ticks;if(!i.display)return;const s=this.getIndexAngle(0);let n,o;t.save(),t.translate(this.xCenter,this.yCenter),t.rotate(s),t.textAlign="center",t.textBaseline="middle",this.ticks.forEach(((s,a)=>{if(0===a&&this.min>=0&&!e.reverse)return;const r=i.setContext(this.getContext(a)),l=Si(r.font);if(n=this.getDistanceFromCenterForValue(this.ticks[a].value),r.showLabelBackdrop){t.font=l.string,o=t.measureText(s.label).width,t.fillStyle=r.backdropColor;const e=ki(r.backdropPadding);t.fillRect(-o/2-e.left,-n-l.size/2-e.top,o+e.width,l.size+e.height)}Ne(t,s.label,0,-n,l,{color:r.color,strokeColor:r.textStrokeColor,strokeWidth:r.textStrokeWidth})})),t.restore()}drawTitle(){}}const Ro={millisecond:{common:!0,size:1,steps:1e3},second:{common:!0,size:1e3,steps:60},minute:{common:!0,size:6e4,steps:60},hour:{common:!0,size:36e5,steps:24},day:{common:!0,size:864e5,steps:30},week:{common:!1,size:6048e5,steps:4},month:{common:!0,size:2628e6,steps:12},quarter:{common:!1,size:7884e6,steps:4},year:{common:!0,size:3154e7}},Io=Object.keys(Ro);function zo(t,e){return t-e}function Fo(t,e){if(s(e))return null;const i=t._adapter,{parser:n,round:o,isoWeekday:r}=t._parseOpts;let l=e;return"function"==typeof n&&(l=n(l)),a(l)||(l="string"==typeof n?i.parse(l,n):i.parse(l)),null===l?null:(o&&(l="week"!==o||!N(r)&&!0!==r?i.startOf(l,o):i.startOf(l,"isoWeek",r)),+l)}function Vo(t,e,i,s){const n=Io.length;for(let o=Io.indexOf(t);o<n-1;++o){const t=Ro[Io[o]],n=t.steps?t.steps:Number.MAX_SAFE_INTEGER;if(t.common&&Math.ceil((i-e)/(n*t.size))<=s)return Io[o]}return Io[n-1]}function Bo(t,e,i){if(i){if(i.length){const{lo:s,hi:n}=et(i,e);t[i[s]>=e?i[s]:i[n]]=!0}}else t[e]=!0}function Wo(t,e,i){const s=[],n={},o=e.length;let a,r;for(a=0;a<o;++a)r=e[a],n[r]=a,s.push({value:r,major:!1});return 0!==o&&i?function(t,e,i,s){const n=t._adapter,o=+n.startOf(e[0].value,s),a=e[e.length-1].value;let r,l;for(r=o;r<=a;r=+n.add(r,1,s))l=i[r],l>=0&&(e[l].major=!0);return e}(t,s,n,i):s}class No extends Js{static id="time";static defaults={bounds:"data",adapters:{},time:{parser:!1,unit:!1,round:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{}},ticks:{source:"auto",callback:!1,major:{enabled:!1}}};constructor(t){super(t),this._cache={data:[],labels:[],all:[]},this._unit="day",this._majorUnit=void 0,this._offsets={},this._normalized=!1,this._parseOpts=void 0}init(t,e={}){const i=t.time||(t.time={}),s=this._adapter=new Rn._date(t.adapters.date);s.init(e),b(i.displayFormats,s.formats()),this._parseOpts={parser:i.parser,round:i.round,isoWeekday:i.isoWeekday},super.init(t),this._normalized=e.normalized}parse(t,e){return void 0===t?null:Fo(this,t)}beforeLayout(){super.beforeLayout(),this._cache={data:[],labels:[],all:[]}}determineDataLimits(){const t=this.options,e=this._adapter,i=t.time.unit||"day";let{min:s,max:n,minDefined:o,maxDefined:r}=this.getUserBounds();function l(t){o||isNaN(t.min)||(s=Math.min(s,t.min)),r||isNaN(t.max)||(n=Math.max(n,t.max))}o&&r||(l(this._getLabelBounds()),"ticks"===t.bounds&&"labels"===t.ticks.source||l(this.getMinMax(!1))),s=a(s)&&!isNaN(s)?s:+e.startOf(Date.now(),i),n=a(n)&&!isNaN(n)?n:+e.endOf(Date.now(),i)+1,this.min=Math.min(s,n-1),this.max=Math.max(s+1,n)}_getLabelBounds(){const t=this.getLabelTimestamps();let e=Number.POSITIVE_INFINITY,i=Number.NEGATIVE_INFINITY;return t.length&&(e=t[0],i=t[t.length-1]),{min:e,max:i}}buildTicks(){const t=this.options,e=t.time,i=t.ticks,s="labels"===i.source?this.getLabelTimestamps():this._generate();"ticks"===t.bounds&&s.length&&(this.min=this._userMin||s[0],this.max=this._userMax||s[s.length-1]);const n=this.min,o=nt(s,n,this.max);return this._unit=e.unit||(i.autoSkip?Vo(e.minUnit,this.min,this.max,this._getLabelCapacity(n)):function(t,e,i,s,n){for(let o=Io.length-1;o>=Io.indexOf(i);o--){const i=Io[o];if(Ro[i].common&&t._adapter.diff(n,s,i)>=e-1)return i}return Io[i?Io.indexOf(i):0]}(this,o.length,e.minUnit,this.min,this.max)),this._majorUnit=i.major.enabled&&"year"!==this._unit?function(t){for(let e=Io.indexOf(t)+1,i=Io.length;e<i;++e)if(Ro[Io[e]].common)return Io[e]}(this._unit):void 0,this.initOffsets(s),t.reverse&&o.reverse(),Wo(this,o,this._majorUnit)}afterAutoSkip(){this.options.offsetAfterAutoskip&&this.initOffsets(this.ticks.map((t=>+t.value)))}initOffsets(t=[]){let e,i,s=0,n=0;this.options.offset&&t.length&&(e=this.getDecimalForValue(t[0]),s=1===t.length?1-e:(this.getDecimalForValue(t[1])-e)/2,i=this.getDecimalForValue(t[t.length-1]),n=1===t.length?i:(i-this.getDecimalForValue(t[t.length-2]))/2);const o=t.length<3?.5:.25;s=J(s,0,o),n=J(n,0,o),this._offsets={start:s,end:n,factor:1/(s+1+n)}}_generate(){const t=this._adapter,e=this.min,i=this.max,s=this.options,n=s.time,o=n.unit||Vo(n.minUnit,e,i,this._getLabelCapacity(e)),a=l(s.ticks.stepSize,1),r="week"===o&&n.isoWeekday,h=N(r)||!0===r,c={};let d,u,f=e;if(h&&(f=+t.startOf(f,"isoWeek",r)),f=+t.startOf(f,h?"day":o),t.diff(i,e,o)>1e5*a)throw new Error(e+" and "+i+" are too far apart with stepSize of "+a+" "+o);const g="data"===s.ticks.source&&this.getDataTimestamps();for(d=f,u=0;d<i;d=+t.add(d,a,o),u++)Bo(c,d,g);return d!==i&&"ticks"!==s.bounds&&1!==u||Bo(c,d,g),Object.keys(c).sort(zo).map((t=>+t))}getLabelForValue(t){const e=this._adapter,i=this.options.time;return i.tooltipFormat?e.format(t,i.tooltipFormat):e.format(t,i.displayFormats.datetime)}format(t,e){const i=this.options.time.displayFormats,s=this._unit,n=e||i[s];return this._adapter.format(t,n)}_tickFormatFunction(t,e,i,s){const n=this.options,o=n.ticks.callback;if(o)return d(o,[t,e,i],this);const a=n.time.displayFormats,r=this._unit,l=this._majorUnit,h=r&&a[r],c=l&&a[l],u=i[e],f=l&&c&&u&&u.major;return this._adapter.format(t,s||(f?c:h))}generateTickLabels(t){let e,i,s;for(e=0,i=t.length;e<i;++e)s=t[e],s.label=this._tickFormatFunction(s.value,e,t)}getDecimalForValue(t){return null===t?NaN:(t-this.min)/(this.max-this.min)}getPixelForValue(t){const e=this._offsets,i=this.getDecimalForValue(t);return this.getPixelForDecimal((e.start+i)*e.factor)}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return this.min+i*(this.max-this.min)}_getLabelSize(t){const e=this.options.ticks,i=this.ctx.measureText(t).width,s=$(this.isHorizontal()?e.maxRotation:e.minRotation),n=Math.cos(s),o=Math.sin(s),a=this._resolveTickFontOptions(0).size;return{w:i*n+a*o,h:i*o+a*n}}_getLabelCapacity(t){const e=this.options.time,i=e.displayFormats,s=i[e.unit]||i.millisecond,n=this._tickFormatFunction(t,0,Wo(this,[t],this._majorUnit),s),o=this._getLabelSize(n),a=Math.floor(this.isHorizontal()?this.width/o.w:this.height/o.h)-1;return a>0?a:1}getDataTimestamps(){let t,e,i=this._cache.data||[];if(i.length)return i;const s=this.getMatchingVisibleMetas();if(this._normalized&&s.length)return this._cache.data=s[0].controller.getAllParsedValues(this);for(t=0,e=s.length;t<e;++t)i=i.concat(s[t].controller.getAllParsedValues(this));return this._cache.data=this.normalize(i)}getLabelTimestamps(){const t=this._cache.labels||[];let e,i;if(t.length)return t;const s=this.getLabels();for(e=0,i=s.length;e<i;++e)t.push(Fo(this,s[e]));return this._cache.labels=this._normalized?t:this.normalize(t)}normalize(t){return lt(t.sort(zo))}}function Ho(t,e,i){let s,n,o,a,r=0,l=t.length-1;i?(e>=t[r].pos&&e<=t[l].pos&&({lo:r,hi:l}=it(t,"pos",e)),({pos:s,time:o}=t[r]),({pos:n,time:a}=t[l])):(e>=t[r].time&&e<=t[l].time&&({lo:r,hi:l}=it(t,"time",e)),({time:s,pos:o}=t[r]),({time:n,pos:a}=t[l]));const h=n-s;return h?o+(a-o)*(e-s)/h:o}var jo=Object.freeze({__proto__:null,CategoryScale:class extends Js{static id="category";static defaults={ticks:{callback:po}};constructor(t){super(t),this._startValue=void 0,this._valueRange=0,this._addedLabels=[]}init(t){const e=this._addedLabels;if(e.length){const t=this.getLabels();for(const{index:i,label:s}of e)t[i]===s&&t.splice(i,1);this._addedLabels=[]}super.init(t)}parse(t,e){if(s(t))return null;const i=this.getLabels();return((t,e)=>null===t?null:J(Math.round(t),0,e))(e=isFinite(e)&&i[e]===t?e:go(i,t,l(e,t),this._addedLabels),i.length-1)}determineDataLimits(){const{minDefined:t,maxDefined:e}=this.getUserBounds();let{min:i,max:s}=this.getMinMax(!0);"ticks"===this.options.bounds&&(t||(i=0),e||(s=this.getLabels().length-1)),this.min=i,this.max=s}buildTicks(){const t=this.min,e=this.max,i=this.options.offset,s=[];let n=this.getLabels();n=0===t&&e===n.length-1?n:n.slice(t,e+1),this._valueRange=Math.max(n.length-(i?0:1),1),this._startValue=this.min-(i?.5:0);for(let i=t;i<=e;i++)s.push({value:i});return s}getLabelForValue(t){return po.call(this,t)}configure(){super.configure(),this.isHorizontal()||(this._reversePixels=!this._reversePixels)}getPixelForValue(t){return"number"!=typeof t&&(t=this.parse(t)),null===t?NaN:this.getPixelForDecimal((t-this._startValue)/this._valueRange)}getPixelForTick(t){const e=this.ticks;return t<0||t>e.length-1?null:this.getPixelForValue(e[t].value)}getValueForPixel(t){return Math.round(this._startValue+this.getDecimalForPixel(t)*this._valueRange)}getBasePixel(){return this.bottom}},LinearScale:bo,LogarithmicScale:ko,RadialLinearScale:Eo,TimeScale:No,TimeSeriesScale:class extends No{static id="timeseries";static defaults=No.defaults;constructor(t){super(t),this._table=[],this._minPos=void 0,this._tableRange=void 0}initOffsets(){const t=this._getTimestampsForTable(),e=this._table=this.buildLookupTable(t);this._minPos=Ho(e,this.min),this._tableRange=Ho(e,this.max)-this._minPos,super.initOffsets(t)}buildLookupTable(t){const{min:e,max:i}=this,s=[],n=[];let o,a,r,l,h;for(o=0,a=t.length;o<a;++o)l=t[o],l>=e&&l<=i&&s.push(l);if(s.length<2)return[{time:e,pos:0},{time:i,pos:1}];for(o=0,a=s.length;o<a;++o)h=s[o+1],r=s[o-1],l=s[o],Math.round((h+r)/2)!==l&&n.push({time:l,pos:o/(a-1)});return n}_generate(){const t=this.min,e=this.max;let i=super.getDataTimestamps();return i.includes(t)&&i.length||i.splice(0,0,t),i.includes(e)&&1!==i.length||i.push(e),i.sort(((t,e)=>t-e))}_getTimestampsForTable(){let t=this._cache.all||[];if(t.length)return t;const e=this.getDataTimestamps(),i=this.getLabelTimestamps();return t=e.length&&i.length?this.normalize(e.concat(i)):e.length?e:i,t=this._cache.all=t,t}getDecimalForValue(t){return(Ho(this._table,t)-this._minPos)/this._tableRange}getValueForPixel(t){const e=this._offsets,i=this.getDecimalForPixel(t)/e.factor-e.end;return Ho(this._table,i*this._tableRange+this._minPos,!0)}}});const $o=["rgb(54, 162, 235)","rgb(255, 99, 132)","rgb(255, 159, 64)","rgb(255, 205, 86)","rgb(75, 192, 192)","rgb(153, 102, 255)","rgb(201, 203, 207)"],Yo=$o.map((t=>t.replace("rgb(","rgba(").replace(")",", 0.5)")));function Uo(t){return $o[t%$o.length]}function Xo(t){return Yo[t%Yo.length]}function qo(t){let e=0;return(i,s)=>{const n=t.getDatasetMeta(s).controller;n instanceof jn?e=function(t,e){return t.backgroundColor=t.data.map((()=>Uo(e++))),e}(i,e):n instanceof $n?e=function(t,e){return t.backgroundColor=t.data.map((()=>Xo(e++))),e}(i,e):n&&(e=function(t,e){return t.borderColor=Uo(e),t.backgroundColor=Xo(e),++e}(i,e))}}function Ko(t){let e;for(e in t)if(t[e].borderColor||t[e].backgroundColor)return!0;return!1}var Go={id:"colors",defaults:{enabled:!0,forceOverride:!1},beforeLayout(t,e,i){if(!i.enabled)return;const{data:{datasets:s},options:n}=t.config,{elements:o}=n,a=Ko(s)||(r=n)&&(r.borderColor||r.backgroundColor)||o&&Ko(o)||"rgba(0,0,0,0.1)"!==ue.borderColor||"rgba(0,0,0,0.1)"!==ue.backgroundColor;var r;if(!i.forceOverride&&a)return;const l=qo(t);s.forEach(l)}};function Zo(t){if(t._decimated){const e=t._data;delete t._decimated,delete t._data,Object.defineProperty(t,"data",{configurable:!0,enumerable:!0,writable:!0,value:e})}}function Jo(t){t.data.datasets.forEach((t=>{Zo(t)}))}var Qo={id:"decimation",defaults:{algorithm:"min-max",enabled:!1},beforeElementsUpdate:(t,e,i)=>{if(!i.enabled)return void Jo(t);const n=t.width;t.data.datasets.forEach(((e,o)=>{const{_data:a,indexAxis:r}=e,l=t.getDatasetMeta(o),h=a||e.data;if("y"===Pi([r,t.options.indexAxis]))return;if(!l.controller.supportsDecimation)return;const c=t.scales[l.xAxisID];if("linear"!==c.type&&"time"!==c.type)return;if(t.options.parsing)return;let{start:d,count:u}=function(t,e){const i=e.length;let s,n=0;const{iScale:o}=t,{min:a,max:r,minDefined:l,maxDefined:h}=o.getUserBounds();return l&&(n=J(it(e,o.axis,a).lo,0,i-1)),s=h?J(it(e,o.axis,r).hi+1,n,i)-n:i-n,{start:n,count:s}}(l,h);if(u<=(i.threshold||4*n))return void Zo(e);let f;switch(s(a)&&(e._data=h,delete e.data,Object.defineProperty(e,"data",{configurable:!0,enumerable:!0,get:function(){return this._decimated},set:function(t){this._data=t}})),i.algorithm){case"lttb":f=function(t,e,i,s,n){const o=n.samples||s;if(o>=i)return t.slice(e,e+i);const a=[],r=(i-2)/(o-2);let l=0;const h=e+i-1;let c,d,u,f,g,p=e;for(a[l++]=t[p],c=0;c<o-2;c++){let s,n=0,o=0;const h=Math.floor((c+1)*r)+1+e,m=Math.min(Math.floor((c+2)*r)+1,i)+e,x=m-h;for(s=h;s<m;s++)n+=t[s].x,o+=t[s].y;n/=x,o/=x;const b=Math.floor(c*r)+1+e,_=Math.min(Math.floor((c+1)*r)+1,i)+e,{x:y,y:v}=t[p];for(u=f=-1,s=b;s<_;s++)f=.5*Math.abs((y-n)*(t[s].y-v)-(y-t[s].x)*(o-v)),f>u&&(u=f,d=t[s],g=s);a[l++]=d,p=g}return a[l++]=t[h],a}(h,d,u,n,i);break;case"min-max":f=function(t,e,i,n){let o,a,r,l,h,c,d,u,f,g,p=0,m=0;const x=[],b=e+i-1,_=t[e].x,y=t[b].x-_;for(o=e;o<e+i;++o){a=t[o],r=(a.x-_)/y*n,l=a.y;const e=0|r;if(e===h)l<f?(f=l,c=o):l>g&&(g=l,d=o),p=(m*p+a.x)/++m;else{const i=o-1;if(!s(c)&&!s(d)){const e=Math.min(c,d),s=Math.max(c,d);e!==u&&e!==i&&x.push({...t[e],x:p}),s!==u&&s!==i&&x.push({...t[s],x:p})}o>0&&i!==u&&x.push(t[i]),x.push(a),h=e,m=0,f=g=l,c=d=u=o}}return x}(h,d,u,n);break;default:throw new Error(`Unsupported decimation algorithm '${i.algorithm}'`)}e._decimated=f}))},destroy(t){Jo(t)}};function ta(t,e,i,s){if(s)return;let n=e[t],o=i[t];return"angle"===t&&(n=G(n),o=G(o)),{property:t,start:n,end:o}}function ea(t,e,i){for(;e>t;e--){const t=i[e];if(!isNaN(t.x)&&!isNaN(t.y))break}return e}function ia(t,e,i,s){return t&&e?s(t[i],e[i]):t?t[i]:e?e[i]:0}function sa(t,e){let i=[],s=!1;return n(t)?(s=!0,i=t):i=function(t,e){const{x:i=null,y:s=null}=t||{},n=e.points,o=[];return e.segments.forEach((({start:t,end:e})=>{e=ea(t,e,n);const a=n[t],r=n[e];null!==s?(o.push({x:a.x,y:s}),o.push({x:r.x,y:s})):null!==i&&(o.push({x:i,y:a.y}),o.push({x:i,y:r.y}))})),o}(t,e),i.length?new no({points:i,options:{tension:0},_loop:s,_fullLoop:s}):null}function na(t){return t&&!1!==t.fill}function oa(t,e,i){let s=t[e].fill;const n=[e];let o;if(!i)return s;for(;!1!==s&&-1===n.indexOf(s);){if(!a(s))return s;if(o=t[s],!o)return!1;if(o.visible)return s;n.push(s),s=o.fill}return!1}function aa(t,e,i){const s=function(t){const e=t.options,i=e.fill;let s=l(i&&i.target,i);void 0===s&&(s=!!e.backgroundColor);if(!1===s||null===s)return!1;if(!0===s)return"origin";return s}(t);if(o(s))return!isNaN(s.value)&&s;let n=parseFloat(s);return a(n)&&Math.floor(n)===n?function(t,e,i,s){"-"!==t&&"+"!==t||(i=e+i);if(i===e||i<0||i>=s)return!1;return i}(s[0],e,n,i):["origin","start","end","stack","shape"].indexOf(s)>=0&&s}function ra(t,e,i){const s=[];for(let n=0;n<i.length;n++){const o=i[n],{first:a,last:r,point:l}=la(o,e,"x");if(!(!l||a&&r))if(a)s.unshift(l);else if(t.push(l),!r)break}t.push(...s)}function la(t,e,i){const s=t.interpolate(e,i);if(!s)return{};const n=s[i],o=t.segments,a=t.points;let r=!1,l=!1;for(let t=0;t<o.length;t++){const e=o[t],s=a[e.start][i],h=a[e.end][i];if(tt(n,s,h)){r=n===s,l=n===h;break}}return{first:r,last:l,point:s}}class ha{constructor(t){this.x=t.x,this.y=t.y,this.radius=t.radius}pathSegment(t,e,i){const{x:s,y:n,radius:o}=this;return e=e||{start:0,end:O},t.arc(s,n,o,e.end,e.start,!0),!i.bounds}interpolate(t){const{x:e,y:i,radius:s}=this,n=t.angle;return{x:e+Math.cos(n)*s,y:i+Math.sin(n)*s,angle:n}}}function ca(t){const{chart:e,fill:i,line:s}=t;if(a(i))return function(t,e){const i=t.getDatasetMeta(e),s=i&&t.isDatasetVisible(e);return s?i.dataset:null}(e,i);if("stack"===i)return function(t){const{scale:e,index:i,line:s}=t,n=[],o=s.segments,a=s.points,r=function(t,e){const i=[],s=t.getMatchingVisibleMetas("line");for(let t=0;t<s.length;t++){const n=s[t];if(n.index===e)break;n.hidden||i.unshift(n.dataset)}return i}(e,i);r.push(sa({x:null,y:e.bottom},s));for(let t=0;t<o.length;t++){const e=o[t];for(let t=e.start;t<=e.end;t++)ra(n,a[t],r)}return new no({points:n,options:{}})}(t);if("shape"===i)return!0;const n=function(t){const e=t.scale||{};if(e.getPointPositionForValue)return function(t){const{scale:e,fill:i}=t,s=e.options,n=e.getLabels().length,a=s.reverse?e.max:e.min,r=function(t,e,i){let s;return s="start"===t?i:"end"===t?e.options.reverse?e.min:e.max:o(t)?t.value:e.getBaseValue(),s}(i,e,a),l=[];if(s.grid.circular){const t=e.getPointPositionForValue(0,a);return new ha({x:t.x,y:t.y,radius:e.getDistanceFromCenterForValue(r)})}for(let t=0;t<n;++t)l.push(e.getPointPositionForValue(t,r));return l}(t);return function(t){const{scale:e={},fill:i}=t,s=function(t,e){let i=null;return"start"===t?i=e.bottom:"end"===t?i=e.top:o(t)?i=e.getPixelForValue(t.value):e.getBasePixel&&(i=e.getBasePixel()),i}(i,e);if(a(s)){const t=e.isHorizontal();return{x:t?s:null,y:t?null:s}}return null}(t)}(t);return n instanceof ha?n:sa(n,s)}function da(t,e,i){const s=ca(e),{line:n,scale:o,axis:a}=e,r=n.options,l=r.fill,h=r.backgroundColor,{above:c=h,below:d=h}=l||{};s&&n.points.length&&(Ie(t,i),function(t,e){const{line:i,target:s,above:n,below:o,area:a,scale:r}=e,l=i._loop?"angle":e.axis;t.save(),"x"===l&&o!==n&&(ua(t,s,a.top),fa(t,{line:i,target:s,color:n,scale:r,property:l}),t.restore(),t.save(),ua(t,s,a.bottom));fa(t,{line:i,target:s,color:o,scale:r,property:l}),t.restore()}(t,{line:n,target:s,above:c,below:d,area:i,scale:o,axis:a}),ze(t))}function ua(t,e,i){const{segments:s,points:n}=e;let o=!0,a=!1;t.beginPath();for(const r of s){const{start:s,end:l}=r,h=n[s],c=n[ea(s,l,n)];o?(t.moveTo(h.x,h.y),o=!1):(t.lineTo(h.x,i),t.lineTo(h.x,h.y)),a=!!e.pathSegment(t,r,{move:a}),a?t.closePath():t.lineTo(c.x,i)}t.lineTo(e.first().x,i),t.closePath(),t.clip()}function fa(t,e){const{line:i,target:s,property:n,color:o,scale:a}=e,r=function(t,e,i){const s=t.segments,n=t.points,o=e.points,a=[];for(const t of s){let{start:s,end:r}=t;r=ea(s,r,n);const l=ta(i,n[s],n[r],t.loop);if(!e.segments){a.push({source:t,target:l,start:n[s],end:n[r]});continue}const h=Ii(e,l);for(const e of h){const s=ta(i,o[e.start],o[e.end],e.loop),r=Ri(t,n,s);for(const t of r)a.push({source:t,target:e,start:{[i]:ia(l,s,"start",Math.max)},end:{[i]:ia(l,s,"end",Math.min)}})}}return a}(i,s,n);for(const{source:e,target:l,start:h,end:c}of r){const{style:{backgroundColor:r=o}={}}=e,d=!0!==s;t.save(),t.fillStyle=r,ga(t,a,d&&ta(n,h,c)),t.beginPath();const u=!!i.pathSegment(t,e);let f;if(d){u?t.closePath():pa(t,s,c,n);const e=!!s.pathSegment(t,l,{move:u,reverse:!0});f=u&&e,f||pa(t,s,h,n)}t.closePath(),t.fill(f?"evenodd":"nonzero"),t.restore()}}function ga(t,e,i){const{top:s,bottom:n}=e.chart.chartArea,{property:o,start:a,end:r}=i||{};"x"===o&&(t.beginPath(),t.rect(a,s,r-a,n-s),t.clip())}function pa(t,e,i,s){const n=e.interpolate(i,s);n&&t.lineTo(n.x,n.y)}var ma={id:"filler",afterDatasetsUpdate(t,e,i){const s=(t.data.datasets||[]).length,n=[];let o,a,r,l;for(a=0;a<s;++a)o=t.getDatasetMeta(a),r=o.dataset,l=null,r&&r.options&&r instanceof no&&(l={visible:t.isDatasetVisible(a),index:a,fill:aa(r,a,s),chart:t,axis:o.controller.options.indexAxis,scale:o.vScale,line:r}),o.$filler=l,n.push(l);for(a=0;a<s;++a)l=n[a],l&&!1!==l.fill&&(l.fill=oa(n,a,i.propagate))},beforeDraw(t,e,i){const s="beforeDraw"===i.drawTime,n=t.getSortedVisibleDatasetMetas(),o=t.chartArea;for(let e=n.length-1;e>=0;--e){const i=n[e].$filler;i&&(i.line.updateControlPoints(o,i.axis),s&&i.fill&&da(t.ctx,i,o))}},beforeDatasetsDraw(t,e,i){if("beforeDatasetsDraw"!==i.drawTime)return;const s=t.getSortedVisibleDatasetMetas();for(let e=s.length-1;e>=0;--e){const i=s[e].$filler;na(i)&&da(t.ctx,i,t.chartArea)}},beforeDatasetDraw(t,e,i){const s=e.meta.$filler;na(s)&&"beforeDatasetDraw"===i.drawTime&&da(t.ctx,s,t.chartArea)},defaults:{propagate:!0,drawTime:"beforeDatasetDraw"}};const xa=(t,e)=>{let{boxHeight:i=e,boxWidth:s=e}=t;return t.usePointStyle&&(i=Math.min(i,e),s=t.pointStyleWidth||Math.min(s,e)),{boxWidth:s,boxHeight:i,itemHeight:Math.max(e,i)}};class ba extends Hs{constructor(t){super(),this._added=!1,this.legendHitBoxes=[],this._hoveredItem=null,this.doughnutMode=!1,this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this.legendItems=void 0,this.columnSizes=void 0,this.lineWidths=void 0,this.maxHeight=void 0,this.maxWidth=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.height=void 0,this.width=void 0,this._margins=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e,i){this.maxWidth=t,this.maxHeight=e,this._margins=i,this.setDimensions(),this.buildLabels(),this.fit()}setDimensions(){this.isHorizontal()?(this.width=this.maxWidth,this.left=this._margins.left,this.right=this.width):(this.height=this.maxHeight,this.top=this._margins.top,this.bottom=this.height)}buildLabels(){const t=this.options.labels||{};let e=d(t.generateLabels,[this.chart],this)||[];t.filter&&(e=e.filter((e=>t.filter(e,this.chart.data)))),t.sort&&(e=e.sort(((e,i)=>t.sort(e,i,this.chart.data)))),this.options.reverse&&e.reverse(),this.legendItems=e}fit(){const{options:t,ctx:e}=this;if(!t.display)return void(this.width=this.height=0);const i=t.labels,s=Si(i.font),n=s.size,o=this._computeTitleHeight(),{boxWidth:a,itemHeight:r}=xa(i,n);let l,h;e.font=s.string,this.isHorizontal()?(l=this.maxWidth,h=this._fitRows(o,n,a,r)+10):(h=this.maxHeight,l=this._fitCols(o,s,a,r)+10),this.width=Math.min(l,t.maxWidth||this.maxWidth),this.height=Math.min(h,t.maxHeight||this.maxHeight)}_fitRows(t,e,i,s){const{ctx:n,maxWidth:o,options:{labels:{padding:a}}}=this,r=this.legendHitBoxes=[],l=this.lineWidths=[0],h=s+a;let c=t;n.textAlign="left",n.textBaseline="middle";let d=-1,u=-h;return this.legendItems.forEach(((t,f)=>{const g=i+e/2+n.measureText(t.text).width;(0===f||l[l.length-1]+g+2*a>o)&&(c+=h,l[l.length-(f>0?0:1)]=0,u+=h,d++),r[f]={left:0,top:u,row:d,width:g,height:s},l[l.length-1]+=g+a})),c}_fitCols(t,e,i,s){const{ctx:n,maxHeight:o,options:{labels:{padding:a}}}=this,r=this.legendHitBoxes=[],l=this.columnSizes=[],h=o-t;let c=a,d=0,u=0,f=0,g=0;return this.legendItems.forEach(((t,o)=>{const{itemWidth:p,itemHeight:m}=function(t,e,i,s,n){const o=function(t,e,i,s){let n=t.text;n&&"string"!=typeof n&&(n=n.reduce(((t,e)=>t.length>e.length?t:e)));return e+i.size/2+s.measureText(n).width}(s,t,e,i),a=function(t,e,i){let s=t;"string"!=typeof e.text&&(s=_a(e,i));return s}(n,s,e.lineHeight);return{itemWidth:o,itemHeight:a}}(i,e,n,t,s);o>0&&u+m+2*a>h&&(c+=d+a,l.push({width:d,height:u}),f+=d+a,g++,d=u=0),r[o]={left:f,top:u,col:g,width:p,height:m},d=Math.max(d,p),u+=m+a})),c+=d,l.push({width:d,height:u}),c}adjustHitBoxes(){if(!this.options.display)return;const t=this._computeTitleHeight(),{legendHitBoxes:e,options:{align:i,labels:{padding:s},rtl:n}}=this,o=Oi(n,this.left,this.width);if(this.isHorizontal()){let n=0,a=ft(i,this.left+s,this.right-this.lineWidths[n]);for(const r of e)n!==r.row&&(n=r.row,a=ft(i,this.left+s,this.right-this.lineWidths[n])),r.top+=this.top+t+s,r.left=o.leftForLtr(o.x(a),r.width),a+=r.width+s}else{let n=0,a=ft(i,this.top+t+s,this.bottom-this.columnSizes[n].height);for(const r of e)r.col!==n&&(n=r.col,a=ft(i,this.top+t+s,this.bottom-this.columnSizes[n].height)),r.top=a,r.left+=this.left+s,r.left=o.leftForLtr(o.x(r.left),r.width),a+=r.height+s}}isHorizontal(){return"top"===this.options.position||"bottom"===this.options.position}draw(){if(this.options.display){const t=this.ctx;Ie(t,this),this._draw(),ze(t)}}_draw(){const{options:t,columnSizes:e,lineWidths:i,ctx:s}=this,{align:n,labels:o}=t,a=ue.color,r=Oi(t.rtl,this.left,this.width),h=Si(o.font),{padding:c}=o,d=h.size,u=d/2;let f;this.drawTitle(),s.textAlign=r.textAlign("left"),s.textBaseline="middle",s.lineWidth=.5,s.font=h.string;const{boxWidth:g,boxHeight:p,itemHeight:m}=xa(o,d),x=this.isHorizontal(),b=this._computeTitleHeight();f=x?{x:ft(n,this.left+c,this.right-i[0]),y:this.top+c+b,line:0}:{x:this.left+c,y:ft(n,this.top+b+c,this.bottom-e[0].height),line:0},Ai(this.ctx,t.textDirection);const _=m+c;this.legendItems.forEach(((y,v)=>{s.strokeStyle=y.fontColor,s.fillStyle=y.fontColor;const M=s.measureText(y.text).width,w=r.textAlign(y.textAlign||(y.textAlign=o.textAlign)),k=g+u+M;let S=f.x,P=f.y;r.setWidth(this.width),x?v>0&&S+k+c>this.right&&(P=f.y+=_,f.line++,S=f.x=ft(n,this.left+c,this.right-i[f.line])):v>0&&P+_>this.bottom&&(S=f.x=S+e[f.line].width+c,f.line++,P=f.y=ft(n,this.top+b+c,this.bottom-e[f.line].height));if(function(t,e,i){if(isNaN(g)||g<=0||isNaN(p)||p<0)return;s.save();const n=l(i.lineWidth,1);if(s.fillStyle=l(i.fillStyle,a),s.lineCap=l(i.lineCap,"butt"),s.lineDashOffset=l(i.lineDashOffset,0),s.lineJoin=l(i.lineJoin,"miter"),s.lineWidth=n,s.strokeStyle=l(i.strokeStyle,a),s.setLineDash(l(i.lineDash,[])),o.usePointStyle){const a={radius:p*Math.SQRT2/2,pointStyle:i.pointStyle,rotation:i.rotation,borderWidth:n},l=r.xPlus(t,g/2);Ee(s,a,l,e+u,o.pointStyleWidth&&g)}else{const o=e+Math.max((d-p)/2,0),a=r.leftForLtr(t,g),l=wi(i.borderRadius);s.beginPath(),Object.values(l).some((t=>0!==t))?He(s,{x:a,y:o,w:g,h:p,radius:l}):s.rect(a,o,g,p),s.fill(),0!==n&&s.stroke()}s.restore()}(r.x(S),P,y),S=gt(w,S+g+u,x?S+k:this.right,t.rtl),function(t,e,i){Ne(s,i.text,t,e+m/2,h,{strikethrough:i.hidden,textAlign:r.textAlign(i.textAlign)})}(r.x(S),P,y),x)f.x+=k+c;else if("string"!=typeof y.text){const t=h.lineHeight;f.y+=_a(y,t)+c}else f.y+=_})),Ti(this.ctx,t.textDirection)}drawTitle(){const t=this.options,e=t.title,i=Si(e.font),s=ki(e.padding);if(!e.display)return;const n=Oi(t.rtl,this.left,this.width),o=this.ctx,a=e.position,r=i.size/2,l=s.top+r;let h,c=this.left,d=this.width;if(this.isHorizontal())d=Math.max(...this.lineWidths),h=this.top+l,c=ft(t.align,c,this.right-d);else{const e=this.columnSizes.reduce(((t,e)=>Math.max(t,e.height)),0);h=l+ft(t.align,this.top,this.bottom-e-t.labels.padding-this._computeTitleHeight())}const u=ft(a,c,c+d);o.textAlign=n.textAlign(ut(a)),o.textBaseline="middle",o.strokeStyle=e.color,o.fillStyle=e.color,o.font=i.string,Ne(o,e.text,u,h,i)}_computeTitleHeight(){const t=this.options.title,e=Si(t.font),i=ki(t.padding);return t.display?e.lineHeight+i.height:0}_getLegendItemAt(t,e){let i,s,n;if(tt(t,this.left,this.right)&&tt(e,this.top,this.bottom))for(n=this.legendHitBoxes,i=0;i<n.length;++i)if(s=n[i],tt(t,s.left,s.left+s.width)&&tt(e,s.top,s.top+s.height))return this.legendItems[i];return null}handleEvent(t){const e=this.options;if(!function(t,e){if(("mousemove"===t||"mouseout"===t)&&(e.onHover||e.onLeave))return!0;if(e.onClick&&("click"===t||"mouseup"===t))return!0;return!1}(t.type,e))return;const i=this._getLegendItemAt(t.x,t.y);if("mousemove"===t.type||"mouseout"===t.type){const o=this._hoveredItem,a=(n=i,null!==(s=o)&&null!==n&&s.datasetIndex===n.datasetIndex&&s.index===n.index);o&&!a&&d(e.onLeave,[t,o,this],this),this._hoveredItem=i,i&&!a&&d(e.onHover,[t,i,this],this)}else i&&d(e.onClick,[t,i,this],this);var s,n}}function _a(t,e){return e*(t.text?t.text.length:0)}var ya={id:"legend",_element:ba,start(t,e,i){const s=t.legend=new ba({ctx:t.ctx,options:i,chart:t});as.configure(t,s,i),as.addBox(t,s)},stop(t){as.removeBox(t,t.legend),delete t.legend},beforeUpdate(t,e,i){const s=t.legend;as.configure(t,s,i),s.options=i},afterUpdate(t){const e=t.legend;e.buildLabels(),e.adjustHitBoxes()},afterEvent(t,e){e.replay||t.legend.handleEvent(e.event)},defaults:{display:!0,position:"top",align:"center",fullSize:!0,reverse:!1,weight:1e3,onClick(t,e,i){const s=e.datasetIndex,n=i.chart;n.isDatasetVisible(s)?(n.hide(s),e.hidden=!0):(n.show(s),e.hidden=!1)},onHover:null,onLeave:null,labels:{color:t=>t.chart.options.color,boxWidth:40,padding:10,generateLabels(t){const e=t.data.datasets,{labels:{usePointStyle:i,pointStyle:s,textAlign:n,color:o,useBorderRadius:a,borderRadius:r}}=t.legend.options;return t._getSortedDatasetMetas().map((t=>{const l=t.controller.getStyle(i?0:void 0),h=ki(l.borderWidth);return{text:e[t.index].label,fillStyle:l.backgroundColor,fontColor:o,hidden:!t.visible,lineCap:l.borderCapStyle,lineDash:l.borderDash,lineDashOffset:l.borderDashOffset,lineJoin:l.borderJoinStyle,lineWidth:(h.width+h.height)/4,strokeStyle:l.borderColor,pointStyle:s||l.pointStyle,rotation:l.rotation,textAlign:n||l.textAlign,borderRadius:a&&(r||l.borderRadius),datasetIndex:t.index}}),this)}},title:{color:t=>t.chart.options.color,display:!1,position:"center",text:""}},descriptors:{_scriptable:t=>!t.startsWith("on"),labels:{_scriptable:t=>!["generateLabels","filter","sort"].includes(t)}}};class va extends Hs{constructor(t){super(),this.chart=t.chart,this.options=t.options,this.ctx=t.ctx,this._padding=void 0,this.top=void 0,this.bottom=void 0,this.left=void 0,this.right=void 0,this.width=void 0,this.height=void 0,this.position=void 0,this.weight=void 0,this.fullSize=void 0}update(t,e){const i=this.options;if(this.left=0,this.top=0,!i.display)return void(this.width=this.height=this.right=this.bottom=0);this.width=this.right=t,this.height=this.bottom=e;const s=n(i.text)?i.text.length:1;this._padding=ki(i.padding);const o=s*Si(i.font).lineHeight+this._padding.height;this.isHorizontal()?this.height=o:this.width=o}isHorizontal(){const t=this.options.position;return"top"===t||"bottom"===t}_drawArgs(t){const{top:e,left:i,bottom:s,right:n,options:o}=this,a=o.align;let r,l,h,c=0;return this.isHorizontal()?(l=ft(a,i,n),h=e+t,r=n-i):("left"===o.position?(l=i+t,h=ft(a,s,e),c=-.5*C):(l=n-t,h=ft(a,e,s),c=.5*C),r=s-e),{titleX:l,titleY:h,maxWidth:r,rotation:c}}draw(){const t=this.ctx,e=this.options;if(!e.display)return;const i=Si(e.font),s=i.lineHeight/2+this._padding.top,{titleX:n,titleY:o,maxWidth:a,rotation:r}=this._drawArgs(s);Ne(t,e.text,0,0,i,{color:e.color,maxWidth:a,rotation:r,textAlign:ut(e.align),textBaseline:"middle",translation:[n,o]})}}var Ma={id:"title",_element:va,start(t,e,i){!function(t,e){const i=new va({ctx:t.ctx,options:e,chart:t});as.configure(t,i,e),as.addBox(t,i),t.titleBlock=i}(t,i)},stop(t){const e=t.titleBlock;as.removeBox(t,e),delete t.titleBlock},beforeUpdate(t,e,i){const s=t.titleBlock;as.configure(t,s,i),s.options=i},defaults:{align:"center",display:!1,font:{weight:"bold"},fullSize:!0,padding:10,position:"top",text:"",weight:2e3},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const wa=new WeakMap;var ka={id:"subtitle",start(t,e,i){const s=new va({ctx:t.ctx,options:i,chart:t});as.configure(t,s,i),as.addBox(t,s),wa.set(t,s)},stop(t){as.removeBox(t,wa.get(t)),wa.delete(t)},beforeUpdate(t,e,i){const s=wa.get(t);as.configure(t,s,i),s.options=i},defaults:{align:"center",display:!1,font:{weight:"normal"},fullSize:!0,padding:0,position:"top",text:"",weight:1500},defaultRoutes:{color:"color"},descriptors:{_scriptable:!0,_indexable:!1}};const Sa={average(t){if(!t.length)return!1;let e,i,s=new Set,n=0,o=0;for(e=0,i=t.length;e<i;++e){const i=t[e].element;if(i&&i.hasValue()){const t=i.tooltipPosition();s.add(t.x),n+=t.y,++o}}if(0===o||0===s.size)return!1;return{x:[...s].reduce(((t,e)=>t+e))/s.size,y:n/o}},nearest(t,e){if(!t.length)return!1;let i,s,n,o=e.x,a=e.y,r=Number.POSITIVE_INFINITY;for(i=0,s=t.length;i<s;++i){const s=t[i].element;if(s&&s.hasValue()){const t=q(e,s.getCenterPoint());t<r&&(r=t,n=s)}}if(n){const t=n.tooltipPosition();o=t.x,a=t.y}return{x:o,y:a}}};function Pa(t,e){return e&&(n(e)?Array.prototype.push.apply(t,e):t.push(e)),t}function Da(t){return("string"==typeof t||t instanceof String)&&t.indexOf("\n")>-1?t.split("\n"):t}function Ca(t,e){const{element:i,datasetIndex:s,index:n}=e,o=t.getDatasetMeta(s).controller,{label:a,value:r}=o.getLabelAndValue(n);return{chart:t,label:a,parsed:o.getParsed(n),raw:t.data.datasets[s].data[n],formattedValue:r,dataset:o.getDataset(),dataIndex:n,datasetIndex:s,element:i}}function Oa(t,e){const i=t.chart.ctx,{body:s,footer:n,title:o}=t,{boxWidth:a,boxHeight:r}=e,l=Si(e.bodyFont),h=Si(e.titleFont),c=Si(e.footerFont),d=o.length,f=n.length,g=s.length,p=ki(e.padding);let m=p.height,x=0,b=s.reduce(((t,e)=>t+e.before.length+e.lines.length+e.after.length),0);if(b+=t.beforeBody.length+t.afterBody.length,d&&(m+=d*h.lineHeight+(d-1)*e.titleSpacing+e.titleMarginBottom),b){m+=g*(e.displayColors?Math.max(r,l.lineHeight):l.lineHeight)+(b-g)*l.lineHeight+(b-1)*e.bodySpacing}f&&(m+=e.footerMarginTop+f*c.lineHeight+(f-1)*e.footerSpacing);let _=0;const y=function(t){x=Math.max(x,i.measureText(t).width+_)};return i.save(),i.font=h.string,u(t.title,y),i.font=l.string,u(t.beforeBody.concat(t.afterBody),y),_=e.displayColors?a+2+e.boxPadding:0,u(s,(t=>{u(t.before,y),u(t.lines,y),u(t.after,y)})),_=0,i.font=c.string,u(t.footer,y),i.restore(),x+=p.width,{width:x,height:m}}function Aa(t,e,i,s){const{x:n,width:o}=i,{width:a,chartArea:{left:r,right:l}}=t;let h="center";return"center"===s?h=n<=(r+l)/2?"left":"right":n<=o/2?h="left":n>=a-o/2&&(h="right"),function(t,e,i,s){const{x:n,width:o}=s,a=i.caretSize+i.caretPadding;return"left"===t&&n+o+a>e.width||"right"===t&&n-o-a<0||void 0}(h,t,e,i)&&(h="center"),h}function Ta(t,e,i){const s=i.yAlign||e.yAlign||function(t,e){const{y:i,height:s}=e;return i<s/2?"top":i>t.height-s/2?"bottom":"center"}(t,i);return{xAlign:i.xAlign||e.xAlign||Aa(t,e,i,s),yAlign:s}}function La(t,e,i,s){const{caretSize:n,caretPadding:o,cornerRadius:a}=t,{xAlign:r,yAlign:l}=i,h=n+o,{topLeft:c,topRight:d,bottomLeft:u,bottomRight:f}=wi(a);let g=function(t,e){let{x:i,width:s}=t;return"right"===e?i-=s:"center"===e&&(i-=s/2),i}(e,r);const p=function(t,e,i){let{y:s,height:n}=t;return"top"===e?s+=i:s-="bottom"===e?n+i:n/2,s}(e,l,h);return"center"===l?"left"===r?g+=h:"right"===r&&(g-=h):"left"===r?g-=Math.max(c,u)+n:"right"===r&&(g+=Math.max(d,f)+n),{x:J(g,0,s.width-e.width),y:J(p,0,s.height-e.height)}}function Ea(t,e,i){const s=ki(i.padding);return"center"===e?t.x+t.width/2:"right"===e?t.x+t.width-s.right:t.x+s.left}function Ra(t){return Pa([],Da(t))}function Ia(t,e){const i=e&&e.dataset&&e.dataset.tooltip&&e.dataset.tooltip.callbacks;return i?t.override(i):t}const za={beforeTitle:e,title(t){if(t.length>0){const e=t[0],i=e.chart.data.labels,s=i?i.length:0;if(this&&this.options&&"dataset"===this.options.mode)return e.dataset.label||"";if(e.label)return e.label;if(s>0&&e.dataIndex<s)return i[e.dataIndex]}return""},afterTitle:e,beforeBody:e,beforeLabel:e,label(t){if(this&&this.options&&"dataset"===this.options.mode)return t.label+": "+t.formattedValue||t.formattedValue;let e=t.dataset.label||"";e&&(e+=": ");const i=t.formattedValue;return s(i)||(e+=i),e},labelColor(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{borderColor:e.borderColor,backgroundColor:e.backgroundColor,borderWidth:e.borderWidth,borderDash:e.borderDash,borderDashOffset:e.borderDashOffset,borderRadius:0}},labelTextColor(){return this.options.bodyColor},labelPointStyle(t){const e=t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);return{pointStyle:e.pointStyle,rotation:e.rotation}},afterLabel:e,afterBody:e,beforeFooter:e,footer:e,afterFooter:e};function Fa(t,e,i,s){const n=t[e].call(i,s);return void 0===n?za[e].call(i,s):n}class Va extends Hs{static positioners=Sa;constructor(t){super(),this.opacity=0,this._active=[],this._eventPosition=void 0,this._size=void 0,this._cachedAnimations=void 0,this._tooltipItems=[],this.$animations=void 0,this.$context=void 0,this.chart=t.chart,this.options=t.options,this.dataPoints=void 0,this.title=void 0,this.beforeBody=void 0,this.body=void 0,this.afterBody=void 0,this.footer=void 0,this.xAlign=void 0,this.yAlign=void 0,this.x=void 0,this.y=void 0,this.height=void 0,this.width=void 0,this.caretX=void 0,this.caretY=void 0,this.labelColors=void 0,this.labelPointStyles=void 0,this.labelTextColors=void 0}initialize(t){this.options=t,this._cachedAnimations=void 0,this.$context=void 0}_resolveAnimations(){const t=this._cachedAnimations;if(t)return t;const e=this.chart,i=this.options.setContext(this.getContext()),s=i.enabled&&e.options.animation&&i.animations,n=new Os(this.chart,s);return s._cacheable&&(this._cachedAnimations=Object.freeze(n)),n}getContext(){return this.$context||(this.$context=(t=this.chart.getContext(),e=this,i=this._tooltipItems,Ci(t,{tooltip:e,tooltipItems:i,type:"tooltip"})));var t,e,i}getTitle(t,e){const{callbacks:i}=e,s=Fa(i,"beforeTitle",this,t),n=Fa(i,"title",this,t),o=Fa(i,"afterTitle",this,t);let a=[];return a=Pa(a,Da(s)),a=Pa(a,Da(n)),a=Pa(a,Da(o)),a}getBeforeBody(t,e){return Ra(Fa(e.callbacks,"beforeBody",this,t))}getBody(t,e){const{callbacks:i}=e,s=[];return u(t,(t=>{const e={before:[],lines:[],after:[]},n=Ia(i,t);Pa(e.before,Da(Fa(n,"beforeLabel",this,t))),Pa(e.lines,Fa(n,"label",this,t)),Pa(e.after,Da(Fa(n,"afterLabel",this,t))),s.push(e)})),s}getAfterBody(t,e){return Ra(Fa(e.callbacks,"afterBody",this,t))}getFooter(t,e){const{callbacks:i}=e,s=Fa(i,"beforeFooter",this,t),n=Fa(i,"footer",this,t),o=Fa(i,"afterFooter",this,t);let a=[];return a=Pa(a,Da(s)),a=Pa(a,Da(n)),a=Pa(a,Da(o)),a}_createItems(t){const e=this._active,i=this.chart.data,s=[],n=[],o=[];let a,r,l=[];for(a=0,r=e.length;a<r;++a)l.push(Ca(this.chart,e[a]));return t.filter&&(l=l.filter(((e,s,n)=>t.filter(e,s,n,i)))),t.itemSort&&(l=l.sort(((e,s)=>t.itemSort(e,s,i)))),u(l,(e=>{const i=Ia(t.callbacks,e);s.push(Fa(i,"labelColor",this,e)),n.push(Fa(i,"labelPointStyle",this,e)),o.push(Fa(i,"labelTextColor",this,e))})),this.labelColors=s,this.labelPointStyles=n,this.labelTextColors=o,this.dataPoints=l,l}update(t,e){const i=this.options.setContext(this.getContext()),s=this._active;let n,o=[];if(s.length){const t=Sa[i.position].call(this,s,this._eventPosition);o=this._createItems(i),this.title=this.getTitle(o,i),this.beforeBody=this.getBeforeBody(o,i),this.body=this.getBody(o,i),this.afterBody=this.getAfterBody(o,i),this.footer=this.getFooter(o,i);const e=this._size=Oa(this,i),a=Object.assign({},t,e),r=Ta(this.chart,i,a),l=La(i,a,r,this.chart);this.xAlign=r.xAlign,this.yAlign=r.yAlign,n={opacity:1,x:l.x,y:l.y,width:e.width,height:e.height,caretX:t.x,caretY:t.y}}else 0!==this.opacity&&(n={opacity:0});this._tooltipItems=o,this.$context=void 0,n&&this._resolveAnimations().update(this,n),t&&i.external&&i.external.call(this,{chart:this.chart,tooltip:this,replay:e})}drawCaret(t,e,i,s){const n=this.getCaretPosition(t,i,s);e.lineTo(n.x1,n.y1),e.lineTo(n.x2,n.y2),e.lineTo(n.x3,n.y3)}getCaretPosition(t,e,i){const{xAlign:s,yAlign:n}=this,{caretSize:o,cornerRadius:a}=i,{topLeft:r,topRight:l,bottomLeft:h,bottomRight:c}=wi(a),{x:d,y:u}=t,{width:f,height:g}=e;let p,m,x,b,_,y;return"center"===n?(_=u+g/2,"left"===s?(p=d,m=p-o,b=_+o,y=_-o):(p=d+f,m=p+o,b=_-o,y=_+o),x=p):(m="left"===s?d+Math.max(r,h)+o:"right"===s?d+f-Math.max(l,c)-o:this.caretX,"top"===n?(b=u,_=b-o,p=m-o,x=m+o):(b=u+g,_=b+o,p=m+o,x=m-o),y=b),{x1:p,x2:m,x3:x,y1:b,y2:_,y3:y}}drawTitle(t,e,i){const s=this.title,n=s.length;let o,a,r;if(n){const l=Oi(i.rtl,this.x,this.width);for(t.x=Ea(this,i.titleAlign,i),e.textAlign=l.textAlign(i.titleAlign),e.textBaseline="middle",o=Si(i.titleFont),a=i.titleSpacing,e.fillStyle=i.titleColor,e.font=o.string,r=0;r<n;++r)e.fillText(s[r],l.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+a,r+1===n&&(t.y+=i.titleMarginBottom-a)}}_drawColorBox(t,e,i,s,n){const a=this.labelColors[i],r=this.labelPointStyles[i],{boxHeight:l,boxWidth:h}=n,c=Si(n.bodyFont),d=Ea(this,"left",n),u=s.x(d),f=l<c.lineHeight?(c.lineHeight-l)/2:0,g=e.y+f;if(n.usePointStyle){const e={radius:Math.min(h,l)/2,pointStyle:r.pointStyle,rotation:r.rotation,borderWidth:1},i=s.leftForLtr(u,h)+h/2,o=g+l/2;t.strokeStyle=n.multiKeyBackground,t.fillStyle=n.multiKeyBackground,Le(t,e,i,o),t.strokeStyle=a.borderColor,t.fillStyle=a.backgroundColor,Le(t,e,i,o)}else{t.lineWidth=o(a.borderWidth)?Math.max(...Object.values(a.borderWidth)):a.borderWidth||1,t.strokeStyle=a.borderColor,t.setLineDash(a.borderDash||[]),t.lineDashOffset=a.borderDashOffset||0;const e=s.leftForLtr(u,h),i=s.leftForLtr(s.xPlus(u,1),h-2),r=wi(a.borderRadius);Object.values(r).some((t=>0!==t))?(t.beginPath(),t.fillStyle=n.multiKeyBackground,He(t,{x:e,y:g,w:h,h:l,radius:r}),t.fill(),t.stroke(),t.fillStyle=a.backgroundColor,t.beginPath(),He(t,{x:i,y:g+1,w:h-2,h:l-2,radius:r}),t.fill()):(t.fillStyle=n.multiKeyBackground,t.fillRect(e,g,h,l),t.strokeRect(e,g,h,l),t.fillStyle=a.backgroundColor,t.fillRect(i,g+1,h-2,l-2))}t.fillStyle=this.labelTextColors[i]}drawBody(t,e,i){const{body:s}=this,{bodySpacing:n,bodyAlign:o,displayColors:a,boxHeight:r,boxWidth:l,boxPadding:h}=i,c=Si(i.bodyFont);let d=c.lineHeight,f=0;const g=Oi(i.rtl,this.x,this.width),p=function(i){e.fillText(i,g.x(t.x+f),t.y+d/2),t.y+=d+n},m=g.textAlign(o);let x,b,_,y,v,M,w;for(e.textAlign=o,e.textBaseline="middle",e.font=c.string,t.x=Ea(this,m,i),e.fillStyle=i.bodyColor,u(this.beforeBody,p),f=a&&"right"!==m?"center"===o?l/2+h:l+2+h:0,y=0,M=s.length;y<M;++y){for(x=s[y],b=this.labelTextColors[y],e.fillStyle=b,u(x.before,p),_=x.lines,a&&_.length&&(this._drawColorBox(e,t,y,g,i),d=Math.max(c.lineHeight,r)),v=0,w=_.length;v<w;++v)p(_[v]),d=c.lineHeight;u(x.after,p)}f=0,d=c.lineHeight,u(this.afterBody,p),t.y-=n}drawFooter(t,e,i){const s=this.footer,n=s.length;let o,a;if(n){const r=Oi(i.rtl,this.x,this.width);for(t.x=Ea(this,i.footerAlign,i),t.y+=i.footerMarginTop,e.textAlign=r.textAlign(i.footerAlign),e.textBaseline="middle",o=Si(i.footerFont),e.fillStyle=i.footerColor,e.font=o.string,a=0;a<n;++a)e.fillText(s[a],r.x(t.x),t.y+o.lineHeight/2),t.y+=o.lineHeight+i.footerSpacing}}drawBackground(t,e,i,s){const{xAlign:n,yAlign:o}=this,{x:a,y:r}=t,{width:l,height:h}=i,{topLeft:c,topRight:d,bottomLeft:u,bottomRight:f}=wi(s.cornerRadius);e.fillStyle=s.backgroundColor,e.strokeStyle=s.borderColor,e.lineWidth=s.borderWidth,e.beginPath(),e.moveTo(a+c,r),"top"===o&&this.drawCaret(t,e,i,s),e.lineTo(a+l-d,r),e.quadraticCurveTo(a+l,r,a+l,r+d),"center"===o&&"right"===n&&this.drawCaret(t,e,i,s),e.lineTo(a+l,r+h-f),e.quadraticCurveTo(a+l,r+h,a+l-f,r+h),"bottom"===o&&this.drawCaret(t,e,i,s),e.lineTo(a+u,r+h),e.quadraticCurveTo(a,r+h,a,r+h-u),"center"===o&&"left"===n&&this.drawCaret(t,e,i,s),e.lineTo(a,r+c),e.quadraticCurveTo(a,r,a+c,r),e.closePath(),e.fill(),s.borderWidth>0&&e.stroke()}_updateAnimationTarget(t){const e=this.chart,i=this.$animations,s=i&&i.x,n=i&&i.y;if(s||n){const i=Sa[t.position].call(this,this._active,this._eventPosition);if(!i)return;const o=this._size=Oa(this,t),a=Object.assign({},i,this._size),r=Ta(e,t,a),l=La(t,a,r,e);s._to===l.x&&n._to===l.y||(this.xAlign=r.xAlign,this.yAlign=r.yAlign,this.width=o.width,this.height=o.height,this.caretX=i.x,this.caretY=i.y,this._resolveAnimations().update(this,l))}}_willRender(){return!!this.opacity}draw(t){const e=this.options.setContext(this.getContext());let i=this.opacity;if(!i)return;this._updateAnimationTarget(e);const s={width:this.width,height:this.height},n={x:this.x,y:this.y};i=Math.abs(i)<.001?0:i;const o=ki(e.padding),a=this.title.length||this.beforeBody.length||this.body.length||this.afterBody.length||this.footer.length;e.enabled&&a&&(t.save(),t.globalAlpha=i,this.drawBackground(n,t,s,e),Ai(t,e.textDirection),n.y+=o.top,this.drawTitle(n,t,e),this.drawBody(n,t,e),this.drawFooter(n,t,e),Ti(t,e.textDirection),t.restore())}getActiveElements(){return this._active||[]}setActiveElements(t,e){const i=this._active,s=t.map((({datasetIndex:t,index:e})=>{const i=this.chart.getDatasetMeta(t);if(!i)throw new Error("Cannot find a dataset at index "+t);return{datasetIndex:t,element:i.data[e],index:e}})),n=!f(i,s),o=this._positionChanged(s,e);(n||o)&&(this._active=s,this._eventPosition=e,this._ignoreReplayEvents=!0,this.update(!0))}handleEvent(t,e,i=!0){if(e&&this._ignoreReplayEvents)return!1;this._ignoreReplayEvents=!1;const s=this.options,n=this._active||[],o=this._getActiveElements(t,n,e,i),a=this._positionChanged(o,t),r=e||!f(o,n)||a;return r&&(this._active=o,(s.enabled||s.external)&&(this._eventPosition={x:t.x,y:t.y},this.update(!0,e))),r}_getActiveElements(t,e,i,s){const n=this.options;if("mouseout"===t.type)return[];if(!s)return e.filter((t=>this.chart.data.datasets[t.datasetIndex]&&void 0!==this.chart.getDatasetMeta(t.datasetIndex).controller.getParsed(t.index)));const o=this.chart.getElementsAtEventForMode(t,n.mode,n,i);return n.reverse&&o.reverse(),o}_positionChanged(t,e){const{caretX:i,caretY:s,options:n}=this,o=Sa[n.position].call(this,t,e);return!1!==o&&(i!==o.x||s!==o.y)}}var Ba={id:"tooltip",_element:Va,positioners:Sa,afterInit(t,e,i){i&&(t.tooltip=new Va({chart:t,options:i}))},beforeUpdate(t,e,i){t.tooltip&&t.tooltip.initialize(i)},reset(t,e,i){t.tooltip&&t.tooltip.initialize(i)},afterDraw(t){const e=t.tooltip;if(e&&e._willRender()){const i={tooltip:e};if(!1===t.notifyPlugins("beforeTooltipDraw",{...i,cancelable:!0}))return;e.draw(t.ctx),t.notifyPlugins("afterTooltipDraw",i)}},afterEvent(t,e){if(t.tooltip){const i=e.replay;t.tooltip.handleEvent(e.event,i,e.inChartArea)&&(e.changed=!0)}},defaults:{enabled:!0,external:null,position:"average",backgroundColor:"rgba(0,0,0,0.8)",titleColor:"#fff",titleFont:{weight:"bold"},titleSpacing:2,titleMarginBottom:6,titleAlign:"left",bodyColor:"#fff",bodySpacing:2,bodyFont:{},bodyAlign:"left",footerColor:"#fff",footerSpacing:2,footerMarginTop:6,footerFont:{weight:"bold"},footerAlign:"left",padding:6,caretPadding:2,caretSize:5,cornerRadius:6,boxHeight:(t,e)=>e.bodyFont.size,boxWidth:(t,e)=>e.bodyFont.size,multiKeyBackground:"#fff",displayColors:!0,boxPadding:0,borderColor:"rgba(0,0,0,0)",borderWidth:0,animation:{duration:400,easing:"easeOutQuart"},animations:{numbers:{type:"number",properties:["x","y","width","height","caretX","caretY"]},opacity:{easing:"linear",duration:200}},callbacks:za},defaultRoutes:{bodyFont:"font",footerFont:"font",titleFont:"font"},descriptors:{_scriptable:t=>"filter"!==t&&"itemSort"!==t&&"external"!==t,_indexable:!1,callbacks:{_scriptable:!1,_indexable:!1},animation:{_fallback:!1},animations:{_fallback:"animation"}},additionalOptionScopes:["interaction"]};return An.register(Yn,jo,fo,t),An.helpers={...Wi},An._adapters=Rn,An.Animation=Cs,An.Animations=Os,An.animator=bt,An.controllers=en.controllers.items,An.DatasetController=Ns,An.Element=Hs,An.elements=fo,An.Interaction=Xi,An.layouts=as,An.platforms=Ss,An.Scale=Js,An.Ticks=ae,Object.assign(An,Yn,jo,fo,t,Ss),An.Chart=An,"undefined"!=typeof window&&(window.Chart=An),An}));
//# sourceMappingURL=chart.umd.js.map

/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(require("chart.js")):"function"==typeof define&&define.amd?define(["chart.js"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).Chart)}(this,(function(t){"use strict";function e(t){if(null===t||!0===t||!1===t)return NaN;var e=Number(t);return isNaN(e)?e:e<0?Math.ceil(e):Math.floor(e)}function r(t,e){if(e.length<t)throw new TypeError(t+" argument"+(t>1?"s":"")+" required, but only "+e.length+" present")}function n(t){r(1,arguments);var e=Object.prototype.toString.call(t);return t instanceof Date||"object"==typeof t&&"[object Date]"===e?new Date(t.getTime()):"number"==typeof t||"[object Number]"===e?new Date(t):("string"!=typeof t&&"[object String]"!==e||"undefined"==typeof console||(console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"),console.warn((new Error).stack)),new Date(NaN))}function a(t,a){r(2,arguments);var i=n(t),o=e(a);return isNaN(o)?new Date(NaN):o?(i.setDate(i.getDate()+o),i):i}function i(t,a){r(2,arguments);var i=n(t),o=e(a);if(isNaN(o))return new Date(NaN);if(!o)return i;var u=i.getDate(),s=new Date(i.getTime());s.setMonth(i.getMonth()+o+1,0);var c=s.getDate();return u>=c?s:(i.setFullYear(s.getFullYear(),s.getMonth(),u),i)}function o(t,a){r(2,arguments);var i=n(t).getTime(),o=e(a);return new Date(i+o)}var u=36e5;function s(t,a){r(1,arguments);var i=a||{},o=i.locale,u=o&&o.options&&o.options.weekStartsOn,s=null==u?0:e(u),c=null==i.weekStartsOn?s:e(i.weekStartsOn);if(!(c>=0&&c<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var d=n(t),l=d.getDay(),f=(l<c?7:0)+l-c;return d.setDate(d.getDate()-f),d.setHours(0,0,0,0),d}function c(t){var e=new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds()));return e.setUTCFullYear(t.getFullYear()),t.getTime()-e.getTime()}function d(t){r(1,arguments);var e=n(t);return e.setHours(0,0,0,0),e}var l=864e5;function f(t,e){r(2,arguments);var n=d(t),a=d(e),i=n.getTime()-c(n),o=a.getTime()-c(a);return Math.round((i-o)/l)}function h(t,e){r(2,arguments);var a=n(t),i=n(e),o=a.getTime()-i.getTime();return o<0?-1:o>0?1:o}function m(t){r(1,arguments);var e=n(t);return!isNaN(e)}function w(t,e){r(2,arguments);var a=n(t),i=n(e),o=a.getFullYear()-i.getFullYear(),u=a.getMonth()-i.getMonth();return 12*o+u}function g(t,e){r(2,arguments);var a=n(t),i=n(e);return a.getFullYear()-i.getFullYear()}function v(t,e){var r=t.getFullYear()-e.getFullYear()||t.getMonth()-e.getMonth()||t.getDate()-e.getDate()||t.getHours()-e.getHours()||t.getMinutes()-e.getMinutes()||t.getSeconds()-e.getSeconds()||t.getMilliseconds()-e.getMilliseconds();return r<0?-1:r>0?1:r}function y(t,e){r(2,arguments);var a=n(t),i=n(e),o=v(a,i),u=Math.abs(f(a,i));a.setDate(a.getDate()-o*u);var s=v(a,i)===-o,c=o*(u-s);return 0===c?0:c}function b(t,e){r(2,arguments);var a=n(t),i=n(e);return a.getTime()-i.getTime()}var T=36e5;function p(t){r(1,arguments);var e=n(t);return e.setHours(23,59,59,999),e}function C(t){r(1,arguments);var e=n(t),a=e.getMonth();return e.setFullYear(e.getFullYear(),a+1,0),e.setHours(23,59,59,999),e}function M(t){r(1,arguments);var e=n(t);return p(e).getTime()===C(e).getTime()}function D(t,e){r(2,arguments);var a,i=n(t),o=n(e),u=h(i,o),s=Math.abs(w(i,o));if(s<1)a=0;else{1===i.getMonth()&&i.getDate()>27&&i.setDate(30),i.setMonth(i.getMonth()-u*s);var c=h(i,o)===-u;M(n(t))&&1===s&&1===h(t,o)&&(c=!1),a=u*(s-c)}return 0===a?0:a}var x={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXWeeks:{one:"about 1 week",other:"about {{count}} weeks"},xWeeks:{one:"1 week",other:"{{count}} weeks"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}};function k(t){return function(e){var r=e||{},n=r.width?String(r.width):t.defaultWidth;return t.formats[n]||t.formats[t.defaultWidth]}}var U={date:k({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:k({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:k({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},Y={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"};function N(t){return function(e,r){var n,a=r||{};if("formatting"===(a.context?String(a.context):"standalone")&&t.formattingValues){var i=t.defaultFormattingWidth||t.defaultWidth,o=a.width?String(a.width):i;n=t.formattingValues[o]||t.formattingValues[i]}else{var u=t.defaultWidth,s=a.width?String(a.width):t.defaultWidth;n=t.values[s]||t.values[u]}return n[t.argumentCallback?t.argumentCallback(e):e]}}function S(t){return function(e,r){var n=String(e),a=r||{},i=a.width,o=i&&t.matchPatterns[i]||t.matchPatterns[t.defaultMatchWidth],u=n.match(o);if(!u)return null;var s,c=u[0],d=i&&t.parsePatterns[i]||t.parsePatterns[t.defaultParseWidth];return s="[object Array]"===Object.prototype.toString.call(d)?function(t,e){for(var r=0;r<t.length;r++)if(e(t[r]))return r}(d,(function(t){return t.test(c)})):function(t,e){for(var r in t)if(t.hasOwnProperty(r)&&e(t[r]))return r}(d,(function(t){return t.test(c)})),s=t.valueCallback?t.valueCallback(s):s,{value:s=a.valueCallback?a.valueCallback(s):s,rest:n.slice(c.length)}}}var P,q={code:"en-US",formatDistance:function(t,e,r){var n;return r=r||{},n="string"==typeof x[t]?x[t]:1===e?x[t].one:x[t].other.replace("{{count}}",e),r.addSuffix?r.comparison>0?"in "+n:n+" ago":n},formatLong:U,formatRelative:function(t,e,r,n){return Y[t]},localize:{ordinalNumber:function(t,e){var r=Number(t),n=r%100;if(n>20||n<10)switch(n%10){case 1:return r+"st";case 2:return r+"nd";case 3:return r+"rd"}return r+"th"},era:N({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:N({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:function(t){return Number(t)-1}}),month:N({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:N({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:N({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaultFormattingWidth:"wide"})},match:{ordinalNumber:(P={matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:function(t){return parseInt(t,10)}},function(t,e){var r=String(t),n=e||{},a=r.match(P.matchPattern);if(!a)return null;var i=a[0],o=r.match(P.parsePattern);if(!o)return null;var u=P.valueCallback?P.valueCallback(o[0]):o[0];return{value:u=n.valueCallback?n.valueCallback(u):u,rest:r.slice(i.length)}}),era:S({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:S({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:function(t){return t+1}}),month:S({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:S({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:S({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})},options:{weekStartsOn:0,firstWeekContainsDate:1}};function H(t,n){r(2,arguments);var a=e(n);return o(t,-a)}function E(t,e){for(var r=t<0?"-":"",n=Math.abs(t).toString();n.length<e;)n="0"+n;return r+n}var O={y:function(t,e){var r=t.getUTCFullYear(),n=r>0?r:1-r;return E("yy"===e?n%100:n,e.length)},M:function(t,e){var r=t.getUTCMonth();return"M"===e?String(r+1):E(r+1,2)},d:function(t,e){return E(t.getUTCDate(),e.length)},a:function(t,e){var r=t.getUTCHours()/12>=1?"pm":"am";switch(e){case"a":case"aa":return r.toUpperCase();case"aaa":return r;case"aaaaa":return r[0];default:return"am"===r?"a.m.":"p.m."}},h:function(t,e){return E(t.getUTCHours()%12||12,e.length)},H:function(t,e){return E(t.getUTCHours(),e.length)},m:function(t,e){return E(t.getUTCMinutes(),e.length)},s:function(t,e){return E(t.getUTCSeconds(),e.length)},S:function(t,e){var r=e.length,n=t.getUTCMilliseconds();return E(Math.floor(n*Math.pow(10,r-3)),e.length)}},F=864e5;function W(t){r(1,arguments);var e=1,a=n(t),i=a.getUTCDay(),o=(i<e?7:0)+i-e;return a.setUTCDate(a.getUTCDate()-o),a.setUTCHours(0,0,0,0),a}function L(t){r(1,arguments);var e=n(t),a=e.getUTCFullYear(),i=new Date(0);i.setUTCFullYear(a+1,0,4),i.setUTCHours(0,0,0,0);var o=W(i),u=new Date(0);u.setUTCFullYear(a,0,4),u.setUTCHours(0,0,0,0);var s=W(u);return e.getTime()>=o.getTime()?a+1:e.getTime()>=s.getTime()?a:a-1}function Q(t){r(1,arguments);var e=L(t),n=new Date(0);n.setUTCFullYear(e,0,4),n.setUTCHours(0,0,0,0);var a=W(n);return a}var R=6048e5;function I(t){r(1,arguments);var e=n(t),a=W(e).getTime()-Q(e).getTime();return Math.round(a/R)+1}function G(t,a){r(1,arguments);var i=a||{},o=i.locale,u=o&&o.options&&o.options.weekStartsOn,s=null==u?0:e(u),c=null==i.weekStartsOn?s:e(i.weekStartsOn);if(!(c>=0&&c<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var d=n(t),l=d.getUTCDay(),f=(l<c?7:0)+l-c;return d.setUTCDate(d.getUTCDate()-f),d.setUTCHours(0,0,0,0),d}function X(t,a){r(1,arguments);var i=n(t,a),o=i.getUTCFullYear(),u=a||{},s=u.locale,c=s&&s.options&&s.options.firstWeekContainsDate,d=null==c?1:e(c),l=null==u.firstWeekContainsDate?d:e(u.firstWeekContainsDate);if(!(l>=1&&l<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var f=new Date(0);f.setUTCFullYear(o+1,0,l),f.setUTCHours(0,0,0,0);var h=G(f,a),m=new Date(0);m.setUTCFullYear(o,0,l),m.setUTCHours(0,0,0,0);var w=G(m,a);return i.getTime()>=h.getTime()?o+1:i.getTime()>=w.getTime()?o:o-1}function j(t,n){r(1,arguments);var a=n||{},i=a.locale,o=i&&i.options&&i.options.firstWeekContainsDate,u=null==o?1:e(o),s=null==a.firstWeekContainsDate?u:e(a.firstWeekContainsDate),c=X(t,n),d=new Date(0);d.setUTCFullYear(c,0,s),d.setUTCHours(0,0,0,0);var l=G(d,n);return l}var B=6048e5;function z(t,e){r(1,arguments);var a=n(t),i=G(a,e).getTime()-j(a,e).getTime();return Math.round(i/B)+1}var A="midnight",Z="noon",K="morning",$="afternoon",_="evening",J="night",V={G:function(t,e,r){var n=t.getUTCFullYear()>0?1:0;switch(e){case"G":case"GG":case"GGG":return r.era(n,{width:"abbreviated"});case"GGGGG":return r.era(n,{width:"narrow"});default:return r.era(n,{width:"wide"})}},y:function(t,e,r){if("yo"===e){var n=t.getUTCFullYear(),a=n>0?n:1-n;return r.ordinalNumber(a,{unit:"year"})}return O.y(t,e)},Y:function(t,e,r,n){var a=X(t,n),i=a>0?a:1-a;return"YY"===e?E(i%100,2):"Yo"===e?r.ordinalNumber(i,{unit:"year"}):E(i,e.length)},R:function(t,e){return E(L(t),e.length)},u:function(t,e){return E(t.getUTCFullYear(),e.length)},Q:function(t,e,r){var n=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"Q":return String(n);case"QQ":return E(n,2);case"Qo":return r.ordinalNumber(n,{unit:"quarter"});case"QQQ":return r.quarter(n,{width:"abbreviated",context:"formatting"});case"QQQQQ":return r.quarter(n,{width:"narrow",context:"formatting"});default:return r.quarter(n,{width:"wide",context:"formatting"})}},q:function(t,e,r){var n=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"q":return String(n);case"qq":return E(n,2);case"qo":return r.ordinalNumber(n,{unit:"quarter"});case"qqq":return r.quarter(n,{width:"abbreviated",context:"standalone"});case"qqqqq":return r.quarter(n,{width:"narrow",context:"standalone"});default:return r.quarter(n,{width:"wide",context:"standalone"})}},M:function(t,e,r){var n=t.getUTCMonth();switch(e){case"M":case"MM":return O.M(t,e);case"Mo":return r.ordinalNumber(n+1,{unit:"month"});case"MMM":return r.month(n,{width:"abbreviated",context:"formatting"});case"MMMMM":return r.month(n,{width:"narrow",context:"formatting"});default:return r.month(n,{width:"wide",context:"formatting"})}},L:function(t,e,r){var n=t.getUTCMonth();switch(e){case"L":return String(n+1);case"LL":return E(n+1,2);case"Lo":return r.ordinalNumber(n+1,{unit:"month"});case"LLL":return r.month(n,{width:"abbreviated",context:"standalone"});case"LLLLL":return r.month(n,{width:"narrow",context:"standalone"});default:return r.month(n,{width:"wide",context:"standalone"})}},w:function(t,e,r,n){var a=z(t,n);return"wo"===e?r.ordinalNumber(a,{unit:"week"}):E(a,e.length)},I:function(t,e,r){var n=I(t);return"Io"===e?r.ordinalNumber(n,{unit:"week"}):E(n,e.length)},d:function(t,e,r){return"do"===e?r.ordinalNumber(t.getUTCDate(),{unit:"date"}):O.d(t,e)},D:function(t,e,a){var i=function(t){r(1,arguments);var e=n(t),a=e.getTime();e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0);var i=e.getTime(),o=a-i;return Math.floor(o/F)+1}(t);return"Do"===e?a.ordinalNumber(i,{unit:"dayOfYear"}):E(i,e.length)},E:function(t,e,r){var n=t.getUTCDay();switch(e){case"E":case"EE":case"EEE":return r.day(n,{width:"abbreviated",context:"formatting"});case"EEEEE":return r.day(n,{width:"narrow",context:"formatting"});case"EEEEEE":return r.day(n,{width:"short",context:"formatting"});default:return r.day(n,{width:"wide",context:"formatting"})}},e:function(t,e,r,n){var a=t.getUTCDay(),i=(a-n.weekStartsOn+8)%7||7;switch(e){case"e":return String(i);case"ee":return E(i,2);case"eo":return r.ordinalNumber(i,{unit:"day"});case"eee":return r.day(a,{width:"abbreviated",context:"formatting"});case"eeeee":return r.day(a,{width:"narrow",context:"formatting"});case"eeeeee":return r.day(a,{width:"short",context:"formatting"});default:return r.day(a,{width:"wide",context:"formatting"})}},c:function(t,e,r,n){var a=t.getUTCDay(),i=(a-n.weekStartsOn+8)%7||7;switch(e){case"c":return String(i);case"cc":return E(i,e.length);case"co":return r.ordinalNumber(i,{unit:"day"});case"ccc":return r.day(a,{width:"abbreviated",context:"standalone"});case"ccccc":return r.day(a,{width:"narrow",context:"standalone"});case"cccccc":return r.day(a,{width:"short",context:"standalone"});default:return r.day(a,{width:"wide",context:"standalone"})}},i:function(t,e,r){var n=t.getUTCDay(),a=0===n?7:n;switch(e){case"i":return String(a);case"ii":return E(a,e.length);case"io":return r.ordinalNumber(a,{unit:"day"});case"iii":return r.day(n,{width:"abbreviated",context:"formatting"});case"iiiii":return r.day(n,{width:"narrow",context:"formatting"});case"iiiiii":return r.day(n,{width:"short",context:"formatting"});default:return r.day(n,{width:"wide",context:"formatting"})}},a:function(t,e,r){var n=t.getUTCHours()/12>=1?"pm":"am";switch(e){case"a":case"aa":return r.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"aaa":return r.dayPeriod(n,{width:"abbreviated",context:"formatting"}).toLowerCase();case"aaaaa":return r.dayPeriod(n,{width:"narrow",context:"formatting"});default:return r.dayPeriod(n,{width:"wide",context:"formatting"})}},b:function(t,e,r){var n,a=t.getUTCHours();switch(n=12===a?Z:0===a?A:a/12>=1?"pm":"am",e){case"b":case"bb":return r.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"bbb":return r.dayPeriod(n,{width:"abbreviated",context:"formatting"}).toLowerCase();case"bbbbb":return r.dayPeriod(n,{width:"narrow",context:"formatting"});default:return r.dayPeriod(n,{width:"wide",context:"formatting"})}},B:function(t,e,r){var n,a=t.getUTCHours();switch(n=a>=17?_:a>=12?$:a>=4?K:J,e){case"B":case"BB":case"BBB":return r.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"BBBBB":return r.dayPeriod(n,{width:"narrow",context:"formatting"});default:return r.dayPeriod(n,{width:"wide",context:"formatting"})}},h:function(t,e,r){if("ho"===e){var n=t.getUTCHours()%12;return 0===n&&(n=12),r.ordinalNumber(n,{unit:"hour"})}return O.h(t,e)},H:function(t,e,r){return"Ho"===e?r.ordinalNumber(t.getUTCHours(),{unit:"hour"}):O.H(t,e)},K:function(t,e,r){var n=t.getUTCHours()%12;return"Ko"===e?r.ordinalNumber(n,{unit:"hour"}):E(n,e.length)},k:function(t,e,r){var n=t.getUTCHours();return 0===n&&(n=24),"ko"===e?r.ordinalNumber(n,{unit:"hour"}):E(n,e.length)},m:function(t,e,r){return"mo"===e?r.ordinalNumber(t.getUTCMinutes(),{unit:"minute"}):O.m(t,e)},s:function(t,e,r){return"so"===e?r.ordinalNumber(t.getUTCSeconds(),{unit:"second"}):O.s(t,e)},S:function(t,e){return O.S(t,e)},X:function(t,e,r,n){var a=(n._originalDate||t).getTimezoneOffset();if(0===a)return"Z";switch(e){case"X":return et(a);case"XXXX":case"XX":return rt(a);default:return rt(a,":")}},x:function(t,e,r,n){var a=(n._originalDate||t).getTimezoneOffset();switch(e){case"x":return et(a);case"xxxx":case"xx":return rt(a);default:return rt(a,":")}},O:function(t,e,r,n){var a=(n._originalDate||t).getTimezoneOffset();switch(e){case"O":case"OO":case"OOO":return"GMT"+tt(a,":");default:return"GMT"+rt(a,":")}},z:function(t,e,r,n){var a=(n._originalDate||t).getTimezoneOffset();switch(e){case"z":case"zz":case"zzz":return"GMT"+tt(a,":");default:return"GMT"+rt(a,":")}},t:function(t,e,r,n){var a=n._originalDate||t;return E(Math.floor(a.getTime()/1e3),e.length)},T:function(t,e,r,n){return E((n._originalDate||t).getTime(),e.length)}};function tt(t,e){var r=t>0?"-":"+",n=Math.abs(t),a=Math.floor(n/60),i=n%60;if(0===i)return r+String(a);var o=e||"";return r+String(a)+o+E(i,2)}function et(t,e){return t%60==0?(t>0?"-":"+")+E(Math.abs(t)/60,2):rt(t,e)}function rt(t,e){var r=e||"",n=t>0?"-":"+",a=Math.abs(t);return n+E(Math.floor(a/60),2)+r+E(a%60,2)}var nt=V;function at(t,e){switch(t){case"P":return e.date({width:"short"});case"PP":return e.date({width:"medium"});case"PPP":return e.date({width:"long"});default:return e.date({width:"full"})}}function it(t,e){switch(t){case"p":return e.time({width:"short"});case"pp":return e.time({width:"medium"});case"ppp":return e.time({width:"long"});default:return e.time({width:"full"})}}var ot={p:it,P:function(t,e){var r,n=t.match(/(P+)(p+)?/),a=n[1],i=n[2];if(!i)return at(t,e);switch(a){case"P":r=e.dateTime({width:"short"});break;case"PP":r=e.dateTime({width:"medium"});break;case"PPP":r=e.dateTime({width:"long"});break;default:r=e.dateTime({width:"full"})}return r.replace("{{date}}",at(a,e)).replace("{{time}}",it(i,e))}},ut=ot,st=["D","DD"],ct=["YY","YYYY"];function dt(t){return-1!==st.indexOf(t)}function lt(t){return-1!==ct.indexOf(t)}function ft(t,e,r){if("YYYY"===t)throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e,"`) for formatting years to the input `").concat(r,"`; see: https://git.io/fxCyr"));if("YY"===t)throw new RangeError("Use `yy` instead of `YY` (in `".concat(e,"`) for formatting years to the input `").concat(r,"`; see: https://git.io/fxCyr"));if("D"===t)throw new RangeError("Use `d` instead of `D` (in `".concat(e,"`) for formatting days of the month to the input `").concat(r,"`; see: https://git.io/fxCyr"));if("DD"===t)throw new RangeError("Use `dd` instead of `DD` (in `".concat(e,"`) for formatting days of the month to the input `").concat(r,"`; see: https://git.io/fxCyr"))}var ht=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,mt=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,wt=/^'([^]*?)'?$/,gt=/''/g,vt=/[a-zA-Z]/;function yt(t){return t.match(wt)[1].replace(gt,"'")}function bt(t,e){if(null==t)throw new TypeError("assign requires that input parameter not be null or undefined");for(var r in e=e||{})e.hasOwnProperty(r)&&(t[r]=e[r]);return t}function Tt(t,a,i){r(2,arguments);var o=i||{},u=o.locale,s=u&&u.options&&u.options.weekStartsOn,c=null==s?0:e(s),d=null==o.weekStartsOn?c:e(o.weekStartsOn);if(!(d>=0&&d<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var l=n(t),f=e(a),h=l.getUTCDay(),m=f%7,w=(m+7)%7,g=(w<d?7:0)+f-h;return l.setUTCDate(l.getUTCDate()+g),l}var pt=/^(1[0-2]|0?\d)/,Ct=/^(3[0-1]|[0-2]?\d)/,Mt=/^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,Dt=/^(5[0-3]|[0-4]?\d)/,xt=/^(2[0-3]|[0-1]?\d)/,kt=/^(2[0-4]|[0-1]?\d)/,Ut=/^(1[0-1]|0?\d)/,Yt=/^(1[0-2]|0?\d)/,Nt=/^[0-5]?\d/,St=/^[0-5]?\d/,Pt=/^\d/,qt=/^\d{1,2}/,Ht=/^\d{1,3}/,Et=/^\d{1,4}/,Ot=/^-?\d+/,Ft=/^-?\d/,Wt=/^-?\d{1,2}/,Lt=/^-?\d{1,3}/,Qt=/^-?\d{1,4}/,Rt=/^([+-])(\d{2})(\d{2})?|Z/,It=/^([+-])(\d{2})(\d{2})|Z/,Gt=/^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,Xt=/^([+-])(\d{2}):(\d{2})|Z/,jt=/^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;function Bt(t,e,r){var n=e.match(t);if(!n)return null;var a=parseInt(n[0],10);return{value:r?r(a):a,rest:e.slice(n[0].length)}}function zt(t,e){var r=e.match(t);return r?"Z"===r[0]?{value:0,rest:e.slice(1)}:{value:("+"===r[1]?1:-1)*(36e5*(r[2]?parseInt(r[2],10):0)+6e4*(r[3]?parseInt(r[3],10):0)+1e3*(r[5]?parseInt(r[5],10):0)),rest:e.slice(r[0].length)}:null}function At(t,e){return Bt(Ot,t,e)}function Zt(t,e,r){switch(t){case 1:return Bt(Pt,e,r);case 2:return Bt(qt,e,r);case 3:return Bt(Ht,e,r);case 4:return Bt(Et,e,r);default:return Bt(new RegExp("^\\d{1,"+t+"}"),e,r)}}function Kt(t,e,r){switch(t){case 1:return Bt(Ft,e,r);case 2:return Bt(Wt,e,r);case 3:return Bt(Lt,e,r);case 4:return Bt(Qt,e,r);default:return Bt(new RegExp("^-?\\d{1,"+t+"}"),e,r)}}function $t(t){switch(t){case"morning":return 4;case"evening":return 17;case"pm":case"noon":case"afternoon":return 12;default:return 0}}function _t(t,e){var r,n=e>0,a=n?e:1-e;if(a<=50)r=t||100;else{var i=a+50;r=t+100*Math.floor(i/100)-(t>=i%100?100:0)}return n?r:1-r}var Jt=[31,28,31,30,31,30,31,31,30,31,30,31],Vt=[31,29,31,30,31,30,31,31,30,31,30,31];function te(t){return t%400==0||t%4==0&&t%100!=0}var ee={G:{priority:140,parse:function(t,e,r,n){switch(e){case"G":case"GG":case"GGG":return r.era(t,{width:"abbreviated"})||r.era(t,{width:"narrow"});case"GGGGG":return r.era(t,{width:"narrow"});default:return r.era(t,{width:"wide"})||r.era(t,{width:"abbreviated"})||r.era(t,{width:"narrow"})}},set:function(t,e,r,n){return e.era=r,t.setUTCFullYear(r,0,1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["R","u","t","T"]},y:{priority:130,parse:function(t,e,r,n){var a=function(t){return{year:t,isTwoDigitYear:"yy"===e}};switch(e){case"y":return Zt(4,t,a);case"yo":return r.ordinalNumber(t,{unit:"year",valueCallback:a});default:return Zt(e.length,t,a)}},validate:function(t,e,r){return e.isTwoDigitYear||e.year>0},set:function(t,e,r,n){var a=t.getUTCFullYear();if(r.isTwoDigitYear){var i=_t(r.year,a);return t.setUTCFullYear(i,0,1),t.setUTCHours(0,0,0,0),t}var o="era"in e&&1!==e.era?1-r.year:r.year;return t.setUTCFullYear(o,0,1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","u","w","I","i","e","c","t","T"]},Y:{priority:130,parse:function(t,e,r,n){var a=function(t){return{year:t,isTwoDigitYear:"YY"===e}};switch(e){case"Y":return Zt(4,t,a);case"Yo":return r.ordinalNumber(t,{unit:"year",valueCallback:a});default:return Zt(e.length,t,a)}},validate:function(t,e,r){return e.isTwoDigitYear||e.year>0},set:function(t,e,r,n){var a=X(t,n);if(r.isTwoDigitYear){var i=_t(r.year,a);return t.setUTCFullYear(i,0,n.firstWeekContainsDate),t.setUTCHours(0,0,0,0),G(t,n)}var o="era"in e&&1!==e.era?1-r.year:r.year;return t.setUTCFullYear(o,0,n.firstWeekContainsDate),t.setUTCHours(0,0,0,0),G(t,n)},incompatibleTokens:["y","R","u","Q","q","M","L","I","d","D","i","t","T"]},R:{priority:130,parse:function(t,e,r,n){return Kt("R"===e?4:e.length,t)},set:function(t,e,r,n){var a=new Date(0);return a.setUTCFullYear(r,0,4),a.setUTCHours(0,0,0,0),W(a)},incompatibleTokens:["G","y","Y","u","Q","q","M","L","w","d","D","e","c","t","T"]},u:{priority:130,parse:function(t,e,r,n){return Kt("u"===e?4:e.length,t)},set:function(t,e,r,n){return t.setUTCFullYear(r,0,1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["G","y","Y","R","w","I","i","e","c","t","T"]},Q:{priority:120,parse:function(t,e,r,n){switch(e){case"Q":case"QQ":return Zt(e.length,t);case"Qo":return r.ordinalNumber(t,{unit:"quarter"});case"QQQ":return r.quarter(t,{width:"abbreviated",context:"formatting"})||r.quarter(t,{width:"narrow",context:"formatting"});case"QQQQQ":return r.quarter(t,{width:"narrow",context:"formatting"});default:return r.quarter(t,{width:"wide",context:"formatting"})||r.quarter(t,{width:"abbreviated",context:"formatting"})||r.quarter(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,r){return e>=1&&e<=4},set:function(t,e,r,n){return t.setUTCMonth(3*(r-1),1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","q","M","L","w","I","d","D","i","e","c","t","T"]},q:{priority:120,parse:function(t,e,r,n){switch(e){case"q":case"qq":return Zt(e.length,t);case"qo":return r.ordinalNumber(t,{unit:"quarter"});case"qqq":return r.quarter(t,{width:"abbreviated",context:"standalone"})||r.quarter(t,{width:"narrow",context:"standalone"});case"qqqqq":return r.quarter(t,{width:"narrow",context:"standalone"});default:return r.quarter(t,{width:"wide",context:"standalone"})||r.quarter(t,{width:"abbreviated",context:"standalone"})||r.quarter(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,r){return e>=1&&e<=4},set:function(t,e,r,n){return t.setUTCMonth(3*(r-1),1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","Q","M","L","w","I","d","D","i","e","c","t","T"]},M:{priority:110,parse:function(t,e,r,n){var a=function(t){return t-1};switch(e){case"M":return Bt(pt,t,a);case"MM":return Zt(2,t,a);case"Mo":return r.ordinalNumber(t,{unit:"month",valueCallback:a});case"MMM":return r.month(t,{width:"abbreviated",context:"formatting"})||r.month(t,{width:"narrow",context:"formatting"});case"MMMMM":return r.month(t,{width:"narrow",context:"formatting"});default:return r.month(t,{width:"wide",context:"formatting"})||r.month(t,{width:"abbreviated",context:"formatting"})||r.month(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,r){return e>=0&&e<=11},set:function(t,e,r,n){return t.setUTCMonth(r,1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","q","Q","L","w","I","D","i","e","c","t","T"]},L:{priority:110,parse:function(t,e,r,n){var a=function(t){return t-1};switch(e){case"L":return Bt(pt,t,a);case"LL":return Zt(2,t,a);case"Lo":return r.ordinalNumber(t,{unit:"month",valueCallback:a});case"LLL":return r.month(t,{width:"abbreviated",context:"standalone"})||r.month(t,{width:"narrow",context:"standalone"});case"LLLLL":return r.month(t,{width:"narrow",context:"standalone"});default:return r.month(t,{width:"wide",context:"standalone"})||r.month(t,{width:"abbreviated",context:"standalone"})||r.month(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,r){return e>=0&&e<=11},set:function(t,e,r,n){return t.setUTCMonth(r,1),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","q","Q","M","w","I","D","i","e","c","t","T"]},w:{priority:100,parse:function(t,e,r,n){switch(e){case"w":return Bt(Dt,t);case"wo":return r.ordinalNumber(t,{unit:"week"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=1&&e<=53},set:function(t,a,i,o){return G(function(t,a,i){r(2,arguments);var o=n(t),u=e(a),s=z(o,i)-u;return o.setUTCDate(o.getUTCDate()-7*s),o}(t,i,o),o)},incompatibleTokens:["y","R","u","q","Q","M","L","I","d","D","i","t","T"]},I:{priority:100,parse:function(t,e,r,n){switch(e){case"I":return Bt(Dt,t);case"Io":return r.ordinalNumber(t,{unit:"week"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=1&&e<=53},set:function(t,a,i,o){return W(function(t,a){r(2,arguments);var i=n(t),o=e(a),u=I(i)-o;return i.setUTCDate(i.getUTCDate()-7*u),i}(t,i,o),o)},incompatibleTokens:["y","Y","u","q","Q","M","L","w","d","D","e","c","t","T"]},d:{priority:90,subPriority:1,parse:function(t,e,r,n){switch(e){case"d":return Bt(Ct,t);case"do":return r.ordinalNumber(t,{unit:"date"});default:return Zt(e.length,t)}},validate:function(t,e,r){var n=te(t.getUTCFullYear()),a=t.getUTCMonth();return n?e>=1&&e<=Vt[a]:e>=1&&e<=Jt[a]},set:function(t,e,r,n){return t.setUTCDate(r),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","q","Q","w","I","D","i","e","c","t","T"]},D:{priority:90,subPriority:1,parse:function(t,e,r,n){switch(e){case"D":case"DD":return Bt(Mt,t);case"Do":return r.ordinalNumber(t,{unit:"date"});default:return Zt(e.length,t)}},validate:function(t,e,r){return te(t.getUTCFullYear())?e>=1&&e<=366:e>=1&&e<=365},set:function(t,e,r,n){return t.setUTCMonth(0,r),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["Y","R","q","Q","M","L","w","I","d","E","i","e","c","t","T"]},E:{priority:90,parse:function(t,e,r,n){switch(e){case"E":case"EE":case"EEE":return r.day(t,{width:"abbreviated",context:"formatting"})||r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"});case"EEEEE":return r.day(t,{width:"narrow",context:"formatting"});case"EEEEEE":return r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"});default:return r.day(t,{width:"wide",context:"formatting"})||r.day(t,{width:"abbreviated",context:"formatting"})||r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,r){return e>=0&&e<=6},set:function(t,e,r,n){return(t=Tt(t,r,n)).setUTCHours(0,0,0,0),t},incompatibleTokens:["D","i","e","c","t","T"]},e:{priority:90,parse:function(t,e,r,n){var a=function(t){var e=7*Math.floor((t-1)/7);return(t+n.weekStartsOn+6)%7+e};switch(e){case"e":case"ee":return Zt(e.length,t,a);case"eo":return r.ordinalNumber(t,{unit:"day",valueCallback:a});case"eee":return r.day(t,{width:"abbreviated",context:"formatting"})||r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"});case"eeeee":return r.day(t,{width:"narrow",context:"formatting"});case"eeeeee":return r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"});default:return r.day(t,{width:"wide",context:"formatting"})||r.day(t,{width:"abbreviated",context:"formatting"})||r.day(t,{width:"short",context:"formatting"})||r.day(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,r){return e>=0&&e<=6},set:function(t,e,r,n){return(t=Tt(t,r,n)).setUTCHours(0,0,0,0),t},incompatibleTokens:["y","R","u","q","Q","M","L","I","d","D","E","i","c","t","T"]},c:{priority:90,parse:function(t,e,r,n){var a=function(t){var e=7*Math.floor((t-1)/7);return(t+n.weekStartsOn+6)%7+e};switch(e){case"c":case"cc":return Zt(e.length,t,a);case"co":return r.ordinalNumber(t,{unit:"day",valueCallback:a});case"ccc":return r.day(t,{width:"abbreviated",context:"standalone"})||r.day(t,{width:"short",context:"standalone"})||r.day(t,{width:"narrow",context:"standalone"});case"ccccc":return r.day(t,{width:"narrow",context:"standalone"});case"cccccc":return r.day(t,{width:"short",context:"standalone"})||r.day(t,{width:"narrow",context:"standalone"});default:return r.day(t,{width:"wide",context:"standalone"})||r.day(t,{width:"abbreviated",context:"standalone"})||r.day(t,{width:"short",context:"standalone"})||r.day(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,r){return e>=0&&e<=6},set:function(t,e,r,n){return(t=Tt(t,r,n)).setUTCHours(0,0,0,0),t},incompatibleTokens:["y","R","u","q","Q","M","L","I","d","D","E","i","e","t","T"]},i:{priority:90,parse:function(t,e,r,n){var a=function(t){return 0===t?7:t};switch(e){case"i":case"ii":return Zt(e.length,t);case"io":return r.ordinalNumber(t,{unit:"day"});case"iii":return r.day(t,{width:"abbreviated",context:"formatting",valueCallback:a})||r.day(t,{width:"short",context:"formatting",valueCallback:a})||r.day(t,{width:"narrow",context:"formatting",valueCallback:a});case"iiiii":return r.day(t,{width:"narrow",context:"formatting",valueCallback:a});case"iiiiii":return r.day(t,{width:"short",context:"formatting",valueCallback:a})||r.day(t,{width:"narrow",context:"formatting",valueCallback:a});default:return r.day(t,{width:"wide",context:"formatting",valueCallback:a})||r.day(t,{width:"abbreviated",context:"formatting",valueCallback:a})||r.day(t,{width:"short",context:"formatting",valueCallback:a})||r.day(t,{width:"narrow",context:"formatting",valueCallback:a})}},validate:function(t,e,r){return e>=1&&e<=7},set:function(t,a,i,o){return t=function(t,a){r(2,arguments);var i=e(a);i%7==0&&(i-=7);var o=1,u=n(t),s=u.getUTCDay(),c=((i%7+7)%7<o?7:0)+i-s;return u.setUTCDate(u.getUTCDate()+c),u}(t,i,o),t.setUTCHours(0,0,0,0),t},incompatibleTokens:["y","Y","u","q","Q","M","L","w","d","D","E","e","c","t","T"]},a:{priority:80,parse:function(t,e,r,n){switch(e){case"a":case"aa":case"aaa":return r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"});case"aaaaa":return r.dayPeriod(t,{width:"narrow",context:"formatting"});default:return r.dayPeriod(t,{width:"wide",context:"formatting"})||r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,r,n){return t.setUTCHours($t(r),0,0,0),t},incompatibleTokens:["b","B","H","K","k","t","T"]},b:{priority:80,parse:function(t,e,r,n){switch(e){case"b":case"bb":case"bbb":return r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"});case"bbbbb":return r.dayPeriod(t,{width:"narrow",context:"formatting"});default:return r.dayPeriod(t,{width:"wide",context:"formatting"})||r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,r,n){return t.setUTCHours($t(r),0,0,0),t},incompatibleTokens:["a","B","H","K","k","t","T"]},B:{priority:80,parse:function(t,e,r,n){switch(e){case"B":case"BB":case"BBB":return r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"});case"BBBBB":return r.dayPeriod(t,{width:"narrow",context:"formatting"});default:return r.dayPeriod(t,{width:"wide",context:"formatting"})||r.dayPeriod(t,{width:"abbreviated",context:"formatting"})||r.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,r,n){return t.setUTCHours($t(r),0,0,0),t},incompatibleTokens:["a","b","t","T"]},h:{priority:70,parse:function(t,e,r,n){switch(e){case"h":return Bt(Yt,t);case"ho":return r.ordinalNumber(t,{unit:"hour"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=1&&e<=12},set:function(t,e,r,n){var a=t.getUTCHours()>=12;return a&&r<12?t.setUTCHours(r+12,0,0,0):a||12!==r?t.setUTCHours(r,0,0,0):t.setUTCHours(0,0,0,0),t},incompatibleTokens:["H","K","k","t","T"]},H:{priority:70,parse:function(t,e,r,n){switch(e){case"H":return Bt(xt,t);case"Ho":return r.ordinalNumber(t,{unit:"hour"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=0&&e<=23},set:function(t,e,r,n){return t.setUTCHours(r,0,0,0),t},incompatibleTokens:["a","b","h","K","k","t","T"]},K:{priority:70,parse:function(t,e,r,n){switch(e){case"K":return Bt(Ut,t);case"Ko":return r.ordinalNumber(t,{unit:"hour"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=0&&e<=11},set:function(t,e,r,n){return t.getUTCHours()>=12&&r<12?t.setUTCHours(r+12,0,0,0):t.setUTCHours(r,0,0,0),t},incompatibleTokens:["a","b","h","H","k","t","T"]},k:{priority:70,parse:function(t,e,r,n){switch(e){case"k":return Bt(kt,t);case"ko":return r.ordinalNumber(t,{unit:"hour"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=1&&e<=24},set:function(t,e,r,n){var a=r<=24?r%24:r;return t.setUTCHours(a,0,0,0),t},incompatibleTokens:["a","b","h","H","K","t","T"]},m:{priority:60,parse:function(t,e,r,n){switch(e){case"m":return Bt(Nt,t);case"mo":return r.ordinalNumber(t,{unit:"minute"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=0&&e<=59},set:function(t,e,r,n){return t.setUTCMinutes(r,0,0),t},incompatibleTokens:["t","T"]},s:{priority:50,parse:function(t,e,r,n){switch(e){case"s":return Bt(St,t);case"so":return r.ordinalNumber(t,{unit:"second"});default:return Zt(e.length,t)}},validate:function(t,e,r){return e>=0&&e<=59},set:function(t,e,r,n){return t.setUTCSeconds(r,0),t},incompatibleTokens:["t","T"]},S:{priority:30,parse:function(t,e,r,n){return Zt(e.length,t,(function(t){return Math.floor(t*Math.pow(10,3-e.length))}))},set:function(t,e,r,n){return t.setUTCMilliseconds(r),t},incompatibleTokens:["t","T"]},X:{priority:10,parse:function(t,e,r,n){switch(e){case"X":return zt(Rt,t);case"XX":return zt(It,t);case"XXXX":return zt(Gt,t);case"XXXXX":return zt(jt,t);default:return zt(Xt,t)}},set:function(t,e,r,n){return e.timestampIsSet?t:new Date(t.getTime()-r)},incompatibleTokens:["t","T","x"]},x:{priority:10,parse:function(t,e,r,n){switch(e){case"x":return zt(Rt,t);case"xx":return zt(It,t);case"xxxx":return zt(Gt,t);case"xxxxx":return zt(jt,t);default:return zt(Xt,t)}},set:function(t,e,r,n){return e.timestampIsSet?t:new Date(t.getTime()-r)},incompatibleTokens:["t","T","X"]},t:{priority:40,parse:function(t,e,r,n){return At(t)},set:function(t,e,r,n){return[new Date(1e3*r),{timestampIsSet:!0}]},incompatibleTokens:"*"},T:{priority:20,parse:function(t,e,r,n){return At(t)},set:function(t,e,r,n){return[new Date(r),{timestampIsSet:!0}]},incompatibleTokens:"*"}},re=ee,ne=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,ae=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,ie=/^'([^]*?)'?$/,oe=/''/g,ue=/\S/,se=/[a-zA-Z]/;function ce(t,e){if(e.timestampIsSet)return t;var r=new Date(0);return r.setFullYear(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()),r.setHours(t.getUTCHours(),t.getUTCMinutes(),t.getUTCSeconds(),t.getUTCMilliseconds()),r}function de(t){return t.match(ie)[1].replace(oe,"'")}var le=36e5,fe={dateTimeDelimiter:/[T ]/,timeZoneDelimiter:/[Z ]/i,timezone:/([Z+-].*)$/},he=/^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,me=/^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,we=/^([+-])(\d{2})(?::?(\d{2}))?$/;function ge(t){var e,r={},n=t.split(fe.dateTimeDelimiter);if(n.length>2)return r;if(/:/.test(n[0])?(r.date=null,e=n[0]):(r.date=n[0],e=n[1],fe.timeZoneDelimiter.test(r.date)&&(r.date=t.split(fe.timeZoneDelimiter)[0],e=t.substr(r.date.length,t.length))),e){var a=fe.timezone.exec(e);a?(r.time=e.replace(a[1],""),r.timezone=a[1]):r.time=e}return r}function ve(t,e){var r=new RegExp("^(?:(\\d{4}|[+-]\\d{"+(4+e)+"})|(\\d{2}|[+-]\\d{"+(2+e)+"})$)"),n=t.match(r);if(!n)return{year:null};var a=n[1]&&parseInt(n[1]),i=n[2]&&parseInt(n[2]);return{year:null==i?a:100*i,restDateString:t.slice((n[1]||n[2]).length)}}function ye(t,e){if(null===e)return null;var r=t.match(he);if(!r)return null;var n=!!r[4],a=be(r[1]),i=be(r[2])-1,o=be(r[3]),u=be(r[4]),s=be(r[5])-1;if(n)return function(t,e,r){return e>=1&&e<=53&&r>=0&&r<=6}(0,u,s)?function(t,e,r){var n=new Date(0);n.setUTCFullYear(t,0,4);var a=n.getUTCDay()||7,i=7*(e-1)+r+1-a;return n.setUTCDate(n.getUTCDate()+i),n}(e,u,s):new Date(NaN);var c=new Date(0);return function(t,e,r){return e>=0&&e<=11&&r>=1&&r<=(Me[e]||(De(t)?29:28))}(e,i,o)&&function(t,e){return e>=1&&e<=(De(t)?366:365)}(e,a)?(c.setUTCFullYear(e,i,Math.max(a,o)),c):new Date(NaN)}function be(t){return t?parseInt(t):1}function Te(t){var e=t.match(me);if(!e)return null;var r=pe(e[1]),n=pe(e[2]),a=pe(e[3]);return function(t,e,r){if(24===t)return 0===e&&0===r;return r>=0&&r<60&&e>=0&&e<60&&t>=0&&t<25}(r,n,a)?r*le+6e4*n+1e3*a:NaN}function pe(t){return t&&parseFloat(t.replace(",","."))||0}function Ce(t){if("Z"===t)return 0;var e=t.match(we);if(!e)return 0;var r="+"===e[1]?-1:1,n=parseInt(e[2]),a=e[3]&&parseInt(e[3])||0;return function(t,e){return e>=0&&e<=59}(0,a)?r*(n*le+6e4*a):NaN}var Me=[31,null,31,30,31,30,31,31,30,31,30,31];function De(t){return t%400==0||t%4==0&&t%100}const xe={datetime:"MMM d, yyyy, h:mm:ss aaaa",millisecond:"h:mm:ss.SSS aaaa",second:"h:mm:ss aaaa",minute:"h:mm aaaa",hour:"ha",day:"MMM d",week:"PP",month:"MMM yyyy",quarter:"qqq - yyyy",year:"yyyy"};t._adapters._date.override({_id:"date-fns",formats:function(){return xe},parse:function(t,a){if(null==t)return null;const i=typeof t;return"number"===i||t instanceof Date?t=n(t):"string"===i&&(t="string"==typeof a?function(t,a,i,o){r(3,arguments);var u=String(t),s=String(a),d=o||{},l=d.locale||q;if(!l.match)throw new RangeError("locale must contain match property");var f=l.options&&l.options.firstWeekContainsDate,h=null==f?1:e(f),m=null==d.firstWeekContainsDate?h:e(d.firstWeekContainsDate);if(!(m>=1&&m<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var w=l.options&&l.options.weekStartsOn,g=null==w?0:e(w),v=null==d.weekStartsOn?g:e(d.weekStartsOn);if(!(v>=0&&v<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(""===s)return""===u?n(i):new Date(NaN);var y,b={firstWeekContainsDate:m,weekStartsOn:v,locale:l},T=[{priority:10,subPriority:-1,set:ce,index:0}],p=s.match(ae).map((function(t){var e=t[0];return"p"===e||"P"===e?(0,ut[e])(t,l.formatLong,b):t})).join("").match(ne),C=[];for(y=0;y<p.length;y++){var M=p[y];!d.useAdditionalWeekYearTokens&&lt(M)&&ft(M,s,t),!d.useAdditionalDayOfYearTokens&&dt(M)&&ft(M,s,t);var D=M[0],x=re[D];if(x){var k=x.incompatibleTokens;if(Array.isArray(k)){for(var U=void 0,Y=0;Y<C.length;Y++){var N=C[Y].token;if(-1!==k.indexOf(N)||N===D){U=C[Y];break}}if(U)throw new RangeError("The format string mustn't contain `".concat(U.fullToken,"` and `").concat(M,"` at the same time"))}else if("*"===x.incompatibleTokens&&C.length)throw new RangeError("The format string mustn't contain `".concat(M,"` and any other token at the same time"));C.push({token:D,fullToken:M});var S=x.parse(u,M,l.match,b);if(!S)return new Date(NaN);T.push({priority:x.priority,subPriority:x.subPriority||0,set:x.set,validate:x.validate,value:S.value,index:T.length}),u=S.rest}else{if(D.match(se))throw new RangeError("Format string contains an unescaped latin alphabet character `"+D+"`");if("''"===M?M="'":"'"===D&&(M=de(M)),0!==u.indexOf(M))return new Date(NaN);u=u.slice(M.length)}}if(u.length>0&&ue.test(u))return new Date(NaN);var P=T.map((function(t){return t.priority})).sort((function(t,e){return e-t})).filter((function(t,e,r){return r.indexOf(t)===e})).map((function(t){return T.filter((function(e){return e.priority===t})).sort((function(t,e){return e.subPriority-t.subPriority}))})).map((function(t){return t[0]})),E=n(i);if(isNaN(E))return new Date(NaN);var O=H(E,c(E)),F={};for(y=0;y<P.length;y++){var W=P[y];if(W.validate&&!W.validate(O,W.value,b))return new Date(NaN);var L=W.set(O,F,W.value,b);L[0]?(O=L[0],bt(F,L[1])):O=L}return O}(t,a,new Date,this.options):function(t,n){r(1,arguments);var a=n||{},i=null==a.additionalDigits?2:e(a.additionalDigits);if(2!==i&&1!==i&&0!==i)throw new RangeError("additionalDigits must be 0, 1 or 2");if("string"!=typeof t&&"[object String]"!==Object.prototype.toString.call(t))return new Date(NaN);var o,u=ge(t);if(u.date){var s=ve(u.date,i);o=ye(s.restDateString,s.year)}if(isNaN(o)||!o)return new Date(NaN);var c,d=o.getTime(),l=0;if(u.time&&(l=Te(u.time),isNaN(l)||null===l))return new Date(NaN);if(!u.timezone){var f=new Date(d+l),h=new Date(0);return h.setFullYear(f.getUTCFullYear(),f.getUTCMonth(),f.getUTCDate()),h.setHours(f.getUTCHours(),f.getUTCMinutes(),f.getUTCSeconds(),f.getUTCMilliseconds()),h}return c=Ce(u.timezone),isNaN(c)?new Date(NaN):new Date(d+l+c)}(t,this.options)),m(t)?t.getTime():null},format:function(t,a){return function(t,a,i){r(2,arguments);var o=String(a),u=i||{},s=u.locale||q,d=s.options&&s.options.firstWeekContainsDate,l=null==d?1:e(d),f=null==u.firstWeekContainsDate?l:e(u.firstWeekContainsDate);if(!(f>=1&&f<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var h=s.options&&s.options.weekStartsOn,w=null==h?0:e(h),g=null==u.weekStartsOn?w:e(u.weekStartsOn);if(!(g>=0&&g<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(!s.localize)throw new RangeError("locale must contain localize property");if(!s.formatLong)throw new RangeError("locale must contain formatLong property");var v=n(t);if(!m(v))throw new RangeError("Invalid time value");var y=c(v),b=H(v,y),T={firstWeekContainsDate:f,weekStartsOn:g,locale:s,_originalDate:v},p=o.match(mt).map((function(t){var e=t[0];return"p"===e||"P"===e?(0,ut[e])(t,s.formatLong,T):t})).join("").match(ht).map((function(e){if("''"===e)return"'";var r=e[0];if("'"===r)return yt(e);var n=nt[r];if(n)return!u.useAdditionalWeekYearTokens&&lt(e)&&ft(e,a,t),!u.useAdditionalDayOfYearTokens&&dt(e)&&ft(e,a,t),n(b,e,s.localize,T);if(r.match(vt))throw new RangeError("Format string contains an unescaped latin alphabet character `"+r+"`");return e})).join("");return p}(t,a,this.options)},add:function(t,n,s){switch(s){case"millisecond":return o(t,n);case"second":return function(t,n){r(2,arguments);var a=e(n);return o(t,1e3*a)}(t,n);case"minute":return function(t,n){r(2,arguments);var a=e(n);return o(t,6e4*a)}(t,n);case"hour":return function(t,n){r(2,arguments);var a=e(n);return o(t,a*u)}(t,n);case"day":return a(t,n);case"week":return function(t,n){r(2,arguments);var i=e(n),o=7*i;return a(t,o)}(t,n);case"month":return i(t,n);case"quarter":return function(t,n){r(2,arguments);var a=e(n),o=3*a;return i(t,o)}(t,n);case"year":return function(t,n){r(2,arguments);var a=e(n);return i(t,12*a)}(t,n);default:return t}},diff:function(t,e,a){switch(a){case"millisecond":return b(t,e);case"second":return function(t,e){r(2,arguments);var n=b(t,e)/1e3;return n>0?Math.floor(n):Math.ceil(n)}(t,e);case"minute":return function(t,e){r(2,arguments);var n=b(t,e)/6e4;return n>0?Math.floor(n):Math.ceil(n)}(t,e);case"hour":return function(t,e){r(2,arguments);var n=b(t,e)/T;return n>0?Math.floor(n):Math.ceil(n)}(t,e);case"day":return y(t,e);case"week":return function(t,e){r(2,arguments);var n=y(t,e)/7;return n>0?Math.floor(n):Math.ceil(n)}(t,e);case"month":return D(t,e);case"quarter":return function(t,e){r(2,arguments);var n=D(t,e)/3;return n>0?Math.floor(n):Math.ceil(n)}(t,e);case"year":return function(t,e){r(2,arguments);var a=n(t),i=n(e),o=h(a,i),u=Math.abs(g(a,i));a.setFullYear("1584"),i.setFullYear("1584");var s=h(a,i)===-o,c=o*(u-s);return 0===c?0:c}(t,e);default:return 0}},startOf:function(t,e,a){switch(e){case"second":return function(t){r(1,arguments);var e=n(t);return e.setMilliseconds(0),e}(t);case"minute":return function(t){r(1,arguments);var e=n(t);return e.setSeconds(0,0),e}(t);case"hour":return function(t){r(1,arguments);var e=n(t);return e.setMinutes(0,0,0),e}(t);case"day":return d(t);case"week":return s(t);case"isoWeek":return s(t,{weekStartsOn:+a});case"month":return function(t){r(1,arguments);var e=n(t);return e.setDate(1),e.setHours(0,0,0,0),e}(t);case"quarter":return function(t){r(1,arguments);var e=n(t),a=e.getMonth(),i=a-a%3;return e.setMonth(i,1),e.setHours(0,0,0,0),e}(t);case"year":return function(t){r(1,arguments);var e=n(t),a=new Date(0);return a.setFullYear(e.getFullYear(),0,1),a.setHours(0,0,0,0),a}(t);default:return t}},endOf:function(t,a){switch(a){case"second":return function(t){r(1,arguments);var e=n(t);return e.setMilliseconds(999),e}(t);case"minute":return function(t){r(1,arguments);var e=n(t);return e.setSeconds(59,999),e}(t);case"hour":return function(t){r(1,arguments);var e=n(t);return e.setMinutes(59,59,999),e}(t);case"day":return p(t);case"week":return function(t,a){r(1,arguments);var i=a||{},o=i.locale,u=o&&o.options&&o.options.weekStartsOn,s=null==u?0:e(u),c=null==i.weekStartsOn?s:e(i.weekStartsOn);if(!(c>=0&&c<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var d=n(t),l=d.getDay(),f=6+(l<c?-7:0)-(l-c);return d.setDate(d.getDate()+f),d.setHours(23,59,59,999),d}(t);case"month":return C(t);case"quarter":return function(t){r(1,arguments);var e=n(t),a=e.getMonth(),i=a-a%3+3;return e.setMonth(i,0),e.setHours(23,59,59,999),e}(t);case"year":return function(t){r(1,arguments);var e=n(t),a=e.getFullYear();return e.setFullYear(a+1,0,0),e.setHours(23,59,59,999),e}(t);default:return t}}})}));

/*!
 * chartjs-plugin-datalabels v2.0.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2021 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e(require("chart.js/helpers"),require("chart.js")):"function"==typeof define&&define.amd?define(["chart.js/helpers","chart.js"],e):(t="undefined"!=typeof globalThis?globalThis:t||self).ChartDataLabels=e(t.Chart.helpers,t.Chart)}(this,(function(t,e){"use strict";var r=function(){if("undefined"!=typeof window){if(window.devicePixelRatio)return window.devicePixelRatio;var t=window.screen;if(t)return(t.deviceXDPI||1)/(t.logicalXDPI||1)}return 1}(),a=function(e){var r,a=[];for(e=[].concat(e);e.length;)"string"==typeof(r=e.pop())?a.unshift.apply(a,r.split("\n")):Array.isArray(r)?e.push.apply(e,r):t.isNullOrUndef(e)||a.unshift(""+r);return a},o=function(t,e,r){var a,o=[].concat(e),n=o.length,i=t.font,l=0;for(t.font=r.string,a=0;a<n;++a)l=Math.max(t.measureText(o[a]).width,l);return t.font=i,{height:n*r.lineHeight,width:l}},n=function(t,e,r){return Math.max(t,Math.min(e,r))},i=function(t,e){var r,a,o,n,i=t.slice(),l=[];for(r=0,o=e.length;r<o;++r)n=e[r],-1===(a=i.indexOf(n))?l.push([n,1]):i.splice(a,1);for(r=0,o=i.length;r<o;++r)l.push([i[r],-1]);return l};function l(t,e){var r=e.x,a=e.y;if(null===r)return{x:0,y:-1};if(null===a)return{x:1,y:0};var o=t.x-r,n=t.y-a,i=Math.sqrt(o*o+n*n);return{x:i?o/i:0,y:i?n/i:-1}}function s(t,e,r){var a=0;return t<r.left?a|=1:t>r.right&&(a|=2),e<r.top?a|=8:e>r.bottom&&(a|=4),a}function u(t,e){var r,a,o=e.anchor,n=t;return e.clamp&&(n=function(t,e){for(var r,a,o,n=t.x0,i=t.y0,l=t.x1,u=t.y1,d=s(n,i,e),c=s(l,u,e);d|c&&!(d&c);)8&(r=d||c)?(a=n+(l-n)*(e.top-i)/(u-i),o=e.top):4&r?(a=n+(l-n)*(e.bottom-i)/(u-i),o=e.bottom):2&r?(o=i+(u-i)*(e.right-n)/(l-n),a=e.right):1&r&&(o=i+(u-i)*(e.left-n)/(l-n),a=e.left),r===d?d=s(n=a,i=o,e):c=s(l=a,u=o,e);return{x0:n,x1:l,y0:i,y1:u}}(n,e.area)),"start"===o?(r=n.x0,a=n.y0):"end"===o?(r=n.x1,a=n.y1):(r=(n.x0+n.x1)/2,a=(n.y0+n.y1)/2),function(t,e,r,a,o){switch(o){case"center":r=a=0;break;case"bottom":r=0,a=1;break;case"right":r=1,a=0;break;case"left":r=-1,a=0;break;case"top":r=0,a=-1;break;case"start":r=-r,a=-a;break;case"end":break;default:o*=Math.PI/180,r=Math.cos(o),a=Math.sin(o)}return{x:t,y:e,vx:r,vy:a}}(r,a,t.vx,t.vy,e.align)}var d=function(t,e){var r=(t.startAngle+t.endAngle)/2,a=Math.cos(r),o=Math.sin(r),n=t.innerRadius,i=t.outerRadius;return u({x0:t.x+a*n,y0:t.y+o*n,x1:t.x+a*i,y1:t.y+o*i,vx:a,vy:o},e)},c=function(t,e){var r=l(t,e.origin),a=r.x*t.options.radius,o=r.y*t.options.radius;return u({x0:t.x-a,y0:t.y-o,x1:t.x+a,y1:t.y+o,vx:r.x,vy:r.y},e)},h=function(t,e){var r=l(t,e.origin),a=t.x,o=t.y,n=0,i=0;return t.horizontal?(a=Math.min(t.x,t.base),n=Math.abs(t.base-t.x)):(o=Math.min(t.y,t.base),i=Math.abs(t.base-t.y)),u({x0:a,y0:o+i,x1:a+n,y1:o,vx:r.x,vy:r.y},e)},f=function(t,e){var r=l(t,e.origin);return u({x0:t.x,y0:t.y,x1:t.x,y1:t.y,vx:r.x,vy:r.y},e)},x=function(t){return Math.round(t*r)/r};function y(t,e){var r=e.chart.getDatasetMeta(e.datasetIndex).vScale;if(!r)return null;if(void 0!==r.xCenter&&void 0!==r.yCenter)return{x:r.xCenter,y:r.yCenter};var a=r.getBasePixel();return t.horizontal?{x:a,y:null}:{x:null,y:a}}function v(t,e,r){var a=r.backgroundColor,o=r.borderColor,n=r.borderWidth;(a||o&&n)&&(t.beginPath(),function(t,e,r,a,o,n){var i=Math.PI/2;if(n){var l=Math.min(n,o/2,a/2),s=e+l,u=r+l,d=e+a-l,c=r+o-l;t.moveTo(e,u),s<d&&u<c?(t.arc(s,u,l,-Math.PI,-i),t.arc(d,u,l,-i,0),t.arc(d,c,l,0,i),t.arc(s,c,l,i,Math.PI)):s<d?(t.moveTo(s,r),t.arc(d,u,l,-i,i),t.arc(s,u,l,i,Math.PI+i)):u<c?(t.arc(s,u,l,-Math.PI,0),t.arc(s,c,l,0,Math.PI)):t.arc(s,u,l,-Math.PI,Math.PI),t.closePath(),t.moveTo(e,r)}else t.rect(e,r,a,o)}(t,x(e.x)+n/2,x(e.y)+n/2,x(e.w)-n,x(e.h)-n,r.borderRadius),t.closePath(),a&&(t.fillStyle=a,t.fill()),o&&n&&(t.strokeStyle=o,t.lineWidth=n,t.lineJoin="miter",t.stroke()))}function b(t,e,r){var a=t.shadowBlur,o=r.stroked,n=x(r.x),i=x(r.y),l=x(r.w);o&&t.strokeText(e,n,i,l),r.filled&&(a&&o&&(t.shadowBlur=0),t.fillText(e,n,i,l),a&&o&&(t.shadowBlur=a))}var _=function(t,e,r,a){var o=this;o._config=t,o._index=a,o._model=null,o._rects=null,o._ctx=e,o._el=r};t.merge(_.prototype,{_modelize:function(r,a,n,i){var l,s=this,u=s._index,x=t.toFont(t.resolve([n.font,{}],i,u)),v=t.resolve([n.color,e.defaults.color],i,u);return{align:t.resolve([n.align,"center"],i,u),anchor:t.resolve([n.anchor,"center"],i,u),area:i.chart.chartArea,backgroundColor:t.resolve([n.backgroundColor,null],i,u),borderColor:t.resolve([n.borderColor,null],i,u),borderRadius:t.resolve([n.borderRadius,0],i,u),borderWidth:t.resolve([n.borderWidth,0],i,u),clamp:t.resolve([n.clamp,!1],i,u),clip:t.resolve([n.clip,!1],i,u),color:v,display:r,font:x,lines:a,offset:t.resolve([n.offset,0],i,u),opacity:t.resolve([n.opacity,1],i,u),origin:y(s._el,i),padding:t.toPadding(t.resolve([n.padding,0],i,u)),positioner:(l=s._el,l instanceof e.ArcElement?d:l instanceof e.PointElement?c:l instanceof e.BarElement?h:f),rotation:t.resolve([n.rotation,0],i,u)*(Math.PI/180),size:o(s._ctx,a,x),textAlign:t.resolve([n.textAlign,"start"],i,u),textShadowBlur:t.resolve([n.textShadowBlur,0],i,u),textShadowColor:t.resolve([n.textShadowColor,v],i,u),textStrokeColor:t.resolve([n.textStrokeColor,v],i,u),textStrokeWidth:t.resolve([n.textStrokeWidth,0],i,u)}},update:function(e){var r,o,n,i=this,l=null,s=null,u=i._index,d=i._config,c=t.resolve([d.display,!0],e,u);c&&(r=e.dataset.data[u],o=t.valueOrDefault(t.callback(d.formatter,[r,e]),r),(n=t.isNullOrUndef(o)?[]:a(o)).length&&(s=function(t){var e=t.borderWidth||0,r=t.padding,a=t.size.height,o=t.size.width,n=-o/2,i=-a/2;return{frame:{x:n-r.left-e,y:i-r.top-e,w:o+r.width+2*e,h:a+r.height+2*e},text:{x:n,y:i,w:o,h:a}}}(l=i._modelize(c,n,d,e)))),i._model=l,i._rects=s},geometry:function(){return this._rects?this._rects.frame:{}},rotation:function(){return this._model?this._model.rotation:0},visible:function(){return this._model&&this._model.opacity},model:function(){return this._model},draw:function(t,e){var r,a=t.ctx,o=this._model,i=this._rects;this.visible()&&(a.save(),o.clip&&(r=o.area,a.beginPath(),a.rect(r.left,r.top,r.right-r.left,r.bottom-r.top),a.clip()),a.globalAlpha=n(0,o.opacity,1),a.translate(x(e.x),x(e.y)),a.rotate(o.rotation),v(a,i.frame,o),function(t,e,r,a){var o,n=a.textAlign,i=a.color,l=!!i,s=a.font,u=e.length,d=a.textStrokeColor,c=a.textStrokeWidth,h=d&&c;if(u&&(l||h))for(r=function(t,e,r){var a=r.lineHeight,o=t.w,n=t.x;return"center"===e?n+=o/2:"end"!==e&&"right"!==e||(n+=o),{h:a,w:o,x:n,y:t.y+a/2}}(r,n,s),t.font=s.string,t.textAlign=n,t.textBaseline="middle",t.shadowBlur=a.textShadowBlur,t.shadowColor=a.textShadowColor,l&&(t.fillStyle=i),h&&(t.lineJoin="round",t.lineWidth=c,t.strokeStyle=d),o=0,u=e.length;o<u;++o)b(t,e[o],{stroked:h,filled:l,w:r.w,x:r.x,y:r.y+r.h*o})}(a,o.lines,i.text,o),a.restore())}});var p=Number.MIN_SAFE_INTEGER||-9007199254740991,g=Number.MAX_SAFE_INTEGER||9007199254740991;function m(t,e,r){var a=Math.cos(r),o=Math.sin(r),n=e.x,i=e.y;return{x:n+a*(t.x-n)-o*(t.y-i),y:i+o*(t.x-n)+a*(t.y-i)}}function w(t,e){var r,a,o,n,i,l=g,s=p,u=e.origin;for(r=0;r<t.length;++r)o=(a=t[r]).x-u.x,n=a.y-u.y,i=e.vx*o+e.vy*n,l=Math.min(l,i),s=Math.max(s,i);return{min:l,max:s}}function M(t,e){var r=e.x-t.x,a=e.y-t.y,o=Math.sqrt(r*r+a*a);return{vx:(e.x-t.x)/o,vy:(e.y-t.y)/o,origin:t,ln:o}}var k=function(){this._rotation=0,this._rect={x:0,y:0,w:0,h:0}};function $(t,e,r){var a=e.positioner(t,e),o=a.vx,n=a.vy;if(!o&&!n)return{x:a.x,y:a.y};var i=r.w,l=r.h,s=e.rotation,u=Math.abs(i/2*Math.cos(s))+Math.abs(l/2*Math.sin(s)),d=Math.abs(i/2*Math.sin(s))+Math.abs(l/2*Math.cos(s)),c=1/Math.max(Math.abs(o),Math.abs(n));return u*=o*c,d*=n*c,u+=e.offset*o,d+=e.offset*n,{x:a.x+u,y:a.y+d}}t.merge(k.prototype,{center:function(){var t=this._rect;return{x:t.x+t.w/2,y:t.y+t.h/2}},update:function(t,e,r){this._rotation=r,this._rect={x:e.x+t.x,y:e.y+t.y,w:e.w,h:e.h}},contains:function(t){var e=this,r=e._rect;return!((t=m(t,e.center(),-e._rotation)).x<r.x-1||t.y<r.y-1||t.x>r.x+r.w+2||t.y>r.y+r.h+2)},intersects:function(t){var e,r,a,o=this._points(),n=t._points(),i=[M(o[0],o[1]),M(o[0],o[3])];for(this._rotation!==t._rotation&&i.push(M(n[0],n[1]),M(n[0],n[3])),e=0;e<i.length;++e)if(r=w(o,i[e]),a=w(n,i[e]),r.max<a.min||a.max<r.min)return!1;return!0},_points:function(){var t=this,e=t._rect,r=t._rotation,a=t.center();return[m({x:e.x,y:e.y},a,r),m({x:e.x+e.w,y:e.y},a,r),m({x:e.x+e.w,y:e.y+e.h},a,r),m({x:e.x,y:e.y+e.h},a,r)]}});var C={prepare:function(t){var e,r,a,o,n,i=[];for(e=0,a=t.length;e<a;++e)for(r=0,o=t[e].length;r<o;++r)n=t[e][r],i.push(n),n.$layout={_box:new k,_hidable:!1,_visible:!0,_set:e,_idx:r};return i.sort((function(t,e){var r=t.$layout,a=e.$layout;return r._idx===a._idx?a._set-r._set:a._idx-r._idx})),this.update(i),i},update:function(t){var e,r,a,o,n,i=!1;for(e=0,r=t.length;e<r;++e)o=(a=t[e]).model(),(n=a.$layout)._hidable=o&&"auto"===o.display,n._visible=a.visible(),i|=n._hidable;i&&function(t){var e,r,a,o,n,i,l;for(e=0,r=t.length;e<r;++e)(o=(a=t[e]).$layout)._visible&&(l=new Proxy(a._el,{get:(t,e)=>t.getProps([e],!0)[e]}),n=a.geometry(),i=$(l,a.model(),n),o._box.update(i,n,a.rotation()));(function(t,e){var r,a,o,n;for(r=t.length-1;r>=0;--r)for(o=t[r].$layout,a=r-1;a>=0&&o._visible;--a)(n=t[a].$layout)._visible&&o._box.intersects(n._box)&&e(o,n)})(t,(function(t,e){var r=t._hidable,a=e._hidable;r&&a||a?e._visible=!1:r&&(t._visible=!1)}))}(t)},lookup:function(t,e){var r,a;for(r=t.length-1;r>=0;--r)if((a=t[r].$layout)&&a._visible&&a._box.contains(e))return t[r];return null},draw:function(t,e){var r,a,o,n,i,l;for(r=0,a=e.length;r<a;++r)(n=(o=e[r]).$layout)._visible&&(i=o.geometry(),l=$(o._el,o.model(),i),n._box.update(l,i,o.rotation()),o.draw(t,l))}},P="$default";function S(e,r,a){if(r){var o,n=a.$context,i=a.$groups;r[i._set]&&(o=r[i._set][i._key])&&!0===t.callback(o,[n])&&(e.$datalabels._dirty=!0,a.update(n))}}function I(t,e){var r,a,o=t.$datalabels,n=o._listeners;if(n.enter||n.leave){if("mousemove"===e.type)a=C.lookup(o._labels,e);else if("mouseout"!==e.type)return;r=o._hovered,o._hovered=a,function(t,e,r,a){var o,n;(r||a)&&(r?a?r!==a&&(n=o=!0):n=!0:o=!0,n&&S(t,e.leave,r),o&&S(t,e.enter,a))}(t,n,r,a)}}return{id:"datalabels",defaults:{align:"center",anchor:"center",backgroundColor:null,borderColor:null,borderRadius:0,borderWidth:0,clamp:!1,clip:!1,color:void 0,display:!0,font:{family:void 0,lineHeight:1.2,size:void 0,style:void 0,weight:null},formatter:function(e){if(t.isNullOrUndef(e))return null;var r,a,o,n=e;if(t.isObject(e))if(t.isNullOrUndef(e.label))if(t.isNullOrUndef(e.r))for(n="",o=0,a=(r=Object.keys(e)).length;o<a;++o)n+=(0!==o?", ":"")+r[o]+": "+e[r[o]];else n=e.r;else n=e.label;return""+n},labels:void 0,listeners:{},offset:4,opacity:1,padding:{top:4,right:4,bottom:4,left:4},rotation:0,textAlign:"start",textStrokeColor:void 0,textStrokeWidth:0,textShadowBlur:0,textShadowColor:void 0},beforeInit:function(t){t.$datalabels={_actives:[]}},beforeUpdate:function(t){var e=t.$datalabels;e._listened=!1,e._listeners={},e._datasets=[],e._labels=[]},afterDatasetUpdate:function(e,r,a){var o,n,i,l,s,u,d,c,h=r.index,f=e.$datalabels,x=f._datasets[h]=[],y=e.isDatasetVisible(h),v=e.data.datasets[h],b=function(e,r){var a,o,n,i=e.datalabels,l=[];return!1===i?null:(!0===i&&(i={}),r=t.merge({},[r,i]),o=r.labels||{},n=Object.keys(o),delete r.labels,n.length?n.forEach((function(e){o[e]&&l.push(t.merge({},[r,o[e],{_key:e}]))})):l.push(r),a=l.reduce((function(e,r){return t.each(r.listeners||{},(function(t,a){e[a]=e[a]||{},e[a][r._key||P]=t})),delete r.listeners,e}),{}),{labels:l,listeners:a})}(v,a),p=r.meta.data||[],g=e.ctx;for(g.save(),o=0,i=p.length;o<i;++o)if((d=p[o]).$datalabels=[],y&&d&&e.getDataVisibility(o)&&!d.skip)for(n=0,l=b.labels.length;n<l;++n)u=(s=b.labels[n])._key,(c=new _(s,g,d,o)).$groups={_set:h,_key:u||P},c.$context={active:!1,chart:e,dataIndex:o,dataset:v,datasetIndex:h},c.update(c.$context),d.$datalabels.push(c),x.push(c);g.restore(),t.merge(f._listeners,b.listeners,{merger:function(t,e,a){e[t]=e[t]||{},e[t][r.index]=a[t],f._listened=!0}})},afterUpdate:function(t,e){t.$datalabels._labels=C.prepare(t.$datalabels._datasets,e)},afterDatasetsDraw:function(t){C.draw(t,t.$datalabels._labels)},beforeEvent:function(t,e){if(t.$datalabels._listened){var r=e.event;switch(r.type){case"mousemove":case"mouseout":I(t,r);break;case"click":!function(t,e){var r=t.$datalabels,a=r._listeners.click,o=a&&C.lookup(r._labels,e);o&&S(t,a,o)}(t,r)}}},afterEvent:function(t){var e,r,a,o,n,l,s,u=t.$datalabels,d=u._actives,c=u._actives=t.getActiveElements(),h=i(d,c);for(e=0,r=h.length;e<r;++e)if((n=h[e])[1])for(a=0,o=(s=n[0].element.$datalabels||[]).length;a<o;++a)(l=s[a]).$context.active=1===n[1],l.update(l.$context);(u._dirty||h.length)&&(C.update(u._labels),t.render()),delete u._dirty}}}));

/**
 * Skipped minification because the original files appears to be already minified.
 * Original file: /npm/chartjs-plugin-stacked100@1.0.0/build/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(t,a){"object"==typeof exports&&"object"==typeof module?module.exports=a():"function"==typeof define&&define.amd?define([],a):"object"==typeof exports?exports.ChartjsPluginStacked100=a():t.ChartjsPluginStacked100=a()}(self,(function(){return(()=>{"use strict";var t={d:(a,e)=>{for(var n in e)t.o(e,n)&&!t.o(a,n)&&Object.defineProperty(a,n,{enumerable:!0,get:e[n]})},o:(t,a)=>Object.prototype.hasOwnProperty.call(t,a),r:t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})}},a={};t.r(a),t.d(a,{default:()=>f});var e=function(t,a){for(var e=0,n=a.length,r=t.length;e<n;e++,r++)t[r]=a[e];return t},n=function(t,a){return"object"==typeof(e=t)&&e?a?t.x:t.y:t;var e},r=function(t){t.originalData=t.datasets.map((function(t){return a=t.data,e([],a);var a}))},o=function(){return(o=Object.assign||function(t){for(var a,e=1,n=arguments.length;e<n;e++)for(var r in a=arguments[e])Object.prototype.hasOwnProperty.call(a,r)&&(t[r]=a[r]);return t}).apply(this,arguments)},i=function(t,a){for(var e=0,n=a.length,r=t.length;e<n;e++,r++)t[r]=a[e];return t},u=function(t,a,e){var r,o,u,c=t.datasets.map((function(t){return t.hidden?0:1})),d=(null===(u=null===(o=null===(r=null==t?void 0:t.datasets)||void 0===r?void 0:r[0])||void 0===o?void 0:o.data)||void 0===u?void 0:u.length)||0,f=i([],new Array(d)).map((function(e,r){return t.datasets.reduce((function(t,e,o){var i=e.stack;return t[i]||(t[i]=0),t[i]+=Math.abs(n(e.data[r],a))*c[o],t}),{})}));return t.datasets.map((function(t){return t.data.map((function(r,o){var i=f[o][t.stack],u=n(r,a);return u&&i?function(t,a){var e=Math.pow(10,a);return Math.round(100*t*e)/e}(u/i,e):0}))}))},c=function(t,a){t&&t.forEach((function(t,e){a[e].data=t}))},d=function(t){return"y"===t.options.indexAxis};const f={id:"stacked100",beforeInit:function(t,a,e){if(e.enable){var r=e.replaceTooltipLabel,i=void 0===r||r,u=d(t),c=u?"x":"y",f=t.data.datasets.some((function(t){return t.data.some((function(t){return t<0}))}));["x","y"].forEach((function(a){var e=o(o({stacked:!0},a===c?{min:f?-100:0,max:100}:{}),t.options.scales[a]);t.options.scales[a]=e})),i&&(t.options.plugins.tooltip.callbacks.label=function(t){return function(a){var e=a.chart.data,r=a.datasetIndex,o=a.dataIndex,i=e.datasets[r].label||"",u=e.originalData[r][o];return i+": "+e.calculatedData[r][o]+"% ("+n(u,t)+")"}}(u))}},beforeUpdate:function(t,a,e){if(e.enable){var n=t.data;r(n);var o=function(t){if(!("precision"in t))return 1;if(!t.precision)return 1;var a=Math.floor(t.precision);return isNaN(a)||a<0||a>16?1:a}(e);n.calculatedData=u(n,d(t),o),c(n.calculatedData,n.datasets)}},afterUpdate:function(t,a,e){if(e.enable){var n=t.data;c(n.originalData,n.datasets)}}};return a})()}));

// GT namespace
var GT = GT || {};

GT.wHeight = 0,
GT.wWidth = 0;
GT.domContentLoadedFncList = [];
GT.windowResizeFncList = {};
GT.touchMoveFncList = {};
GT.bodyWidth = 0;
GT.disableDetectScrollUpOrDown = false;
GT.stickyHeaderOffsetTop = 0;
GT.triggerFnListAfterMainLogoLoaded = {};
GT.RecaptchaCallbackFnList = {};
GT.isScreenReader = false;
GT.announceArea = null;
GT.pathScript = "/dist/v2/js-v2/";

GT.breakPoints = {
	tablet_lg: 960,
	desktop: 1024,
	desktop_md: 1200,
	desktop_lg: 1300
}

GT.isEventFromScreenReader = function(e) {
	GT.isScreenReader = e.buttons || !e.pointerType;
	return GT.isScreenReader;
}

GT.isMobileView = function(){
	return GT.wWidth < GT.breakPoints.tablet_lg;
}
GT.isTabletView = function(){
	return GT.wWidth >= GT.breakPoints.tablet_lg;
}
GT.isDesktopView = function(){
	return GT.wWidth >= GT.breakPoints.desktop;
}
GT.isMediumDesktopView = function(){
	return GT.wWidth >= GT.breakPoints.desktop_md;
}
GT.isLargeDesktopView = function(){
	return GT.wWidth >= GT.breakPoints.desktop_lg;
}

GT.queryStringFocusableElm = 'a[href]:not([hide-on-desktop]):not([tabindex="-1"]), button:not([disabled]):not([hide-on-desktop]):not([tabindex="-1"]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), textarea:not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), details:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), iframe';

GT.isMobile = function(){return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)};
// GT.isMobile = function(){return typeof window.orientation !== 'undefined'};
GT.isIOS = function(){return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream};
GT.iOSversion = function() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return parseInt(v[1], 10);
    }
};
GT.isMac = function(){return /Mac/.test(navigator.userAgent) && !window.MSStream};
GT.isIE = function(){return /MSIE|Trident/.test(navigator.userAgent)};
GT.isEdge = function(){return /Edge/.test(navigator.userAgent)};
GT.isChrome = function(){return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)};
GT.isSafari = function(){return /safari/i.test(navigator.userAgent) && /Chrome/.test(navigator.userAgent) == false};
GT.isTouchDevice = function(){
    return window.ontouchstart !== undefined;
}

GT.isMobileCached = GT.isMobile();

// Common function to execute a function only once within a 'wait' amount of time
// The purpose of this is to improve performance during frequently triggered events such as scrolling or window resizing
GT.debounce = function (func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


GT.throttleTimerList = [];
GT.throttle = (func, delay = 150) => {
    return function(...args) {

        GT.throttleTimerList.forEach((timerItem) => {
            clearTimeout(timerItem);
        })

        let context = this;        // store the context of the object that owns this function
        let timer = setTimeout(function() {
            func.apply(context,args) // execute the function with the context of the object that owns it
        }, delay);
        GT.throttleTimerList.push(timer)
    }
}

GT.isFunction = function (functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'; 
};
GT.isInteger = function (num) {
    // an alternative to Number.isInteger due to lack of support in IE10, 11
    // num must be a Number, not a string-number
    return (num ^ 0) === num;
};
// For scrollTop, $('body') works for IE and Firefox whereas $('html,body') works for Chrome and Safari
GT.scrollTop = function(top) {
	if (!top) {
		return $('body').scrollTop() || $('html,body').scrollTop();
	}

	var currentScrollTop = window.pageYOffset;
	if (currentScrollTop === top) return;
	$('body').scrollTop(top);
	if (currentScrollTop === window.pageYOffset);
	$('html,body').scrollTop(top);
};

GT.processSearchKeywordBeforeSubmit = function(_searchKeyword, _userPreviousSearches, _MAX_PREVIOUS_SEARCH_ITEMS) {
	
	if(!_searchKeyword) return;
	_searchKeyword = _searchKeyword.replace(/(<([^>]+)>)/gi, "");
	if(_userPreviousSearches == null) _userPreviousSearches = [];
	
	for(let i = 0; i < _userPreviousSearches.length; i++) {
		let _previousSearch = _userPreviousSearches[i];
		if(_searchKeyword.trim().toLowerCase() == _previousSearch.trim().toLowerCase()) {
			_userPreviousSearches.splice(i, 1);
			break;
		}
	}

	if(_userPreviousSearches.length >= _MAX_PREVIOUS_SEARCH_ITEMS) _userPreviousSearches.pop();

	_userPreviousSearches.unshift(_searchKeyword.trim().toLowerCase());

	localStorage.setItem('user_previous_searches', JSON.stringify(_userPreviousSearches));
}

//Prevent horizontal scroll in IOS

// //Prevent horizontal scroll in IOS
// if(GT.isIOS()) {
// 	function keepScrollX(){
// 		if(window.scrollX != 0)
// 			window.scrollTo(0, window.scrollY);
// 	}
// 	// window.addEventListener('scroll', keepScrollX, {passive: true});
// 	// window.addEventListener('touchstart', keepScrollX, {passive: true});
// 	// window.addEventListener('touchmove', keepScrollX, {passive: true});
// 	window.addEventListener('touchend', keepScrollX, {passive: true});
// }

// if(GT.isIOS()) {
// 	let startTouchX,
// 		startTouchY;
// 	document.addEventListener('touchstart', function(e){
// 		startTouchX = e.touches[0].clientX;
// 		startTouchY = e.touches[0].clientY;
// 	}, {passive: true});

// 	document.addEventListener('touchmove', function(e){
// 		let endTouchX = e.changedTouches[0].clientX;
// 		let endTouchY = e.changedTouches[0].clientY;
// 		if(Math.abs(startTouchX - endTouchX) / Math.abs(startTouchY - endTouchY) >= 0.4)
// 			e.preventDefault();

// 	// console.log(Math.abs(startTouchX - endTouchX) / Math.abs(startTouchY - endTouchY));
// 	}, {passive: false});
// }

// if(GT.isIE()) {
// 	let imgListIE = Array.prototype.slice.call(document.querySelectorAll(".banner-block--photograph .fixed-width__banner picture"));
// 	imgListIE = imgListIE.concat(Array.prototype.slice.call(document.querySelectorAll(".event-detail__banner--v2 picture")));
// 	imgListIE.forEach(function(elm) {
// 		let imgElm = elm.querySelector("img");
// 		if(!elm.parentElement.dataset.bgset) {
// 			elm.parentElement.style.background = "url("+ imgElm.src +") no-repeat center center";
// 			elm.parentElement.style.backgroundSize = "cover";
// 			elm.remove();
// 		}
// 	});
// }

// if(GT.isIOS()) {
// 	let startTouchX;
// 	document.addEventListener('touchstart', function(e){
// 		startTouchX = e.touches[0].clientX;
// 	}, {passive: true});

// 	document.addEventListener('touchmove', function(e){
// 		let endTouchX = e.changedTouches[0].clientX;
// 		if (startTouchX !== endTouchX) {
// 			window.scrollTo(0, window.scrollY);
// 		}
// 	}, {passive: false});
// }

//Fix issue in Jquery: Consider marking your touch and wheel event listeners as `passive` to improve your page's scroll performance.
jQuery.event.special.touchstart = {
	setup: function( _, ns, handle ){
	  this.addEventListener("touchstart", handle, { passive: true });
	}
};

(function ($) {
    $.fn.isBeforeElement = function (elem) {
        if (typeof(elem) == "string") elem = $(elem); //just in case of bad input
        return this.add(elem).index(elem) > 0;
    }
})(jQuery);


GT.listboxKeyboardHandle = function(listbox) {
    let list = document.querySelector(listbox); // targets the <ul>
    let first = list.firstChild, // targets the first <li>
        last = list.lastChild; // targets the first <li>
        
    if(!list.dataset.initedKeyboardHandler) {
        document.addEventListener("keydown", function(e){
            switch (e.keyCode) {
				case 38: // if the UP key is pressed
					if (document.activeElement == first){ break; } // stop the script if the focus is on the input or first element
					else { document.activeElement.previousSibling.focus(); } // select the element before the current, and focus it
					break;
				case 40: // if the DOWN key is pressed
					if (document.activeElement == last) { break; } // if the currently focused element is the main input --> focus the first <li>
					else { document.activeElement.nextSibling.focus(); } // target the currently focused element -> <a>, go up a node -> <li>, select the next node, go down a node and focus it
				break;
            }
        })

        list.dataset.initedKeyboardHandler = true;
    }
}

GT.waitForElmRendering = function(selector, timeout) {
	return new Promise(function(resolve) {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		if(!timeout) {
			timeout = 15000;
		}

		if(timeout) {
			setTimeout(function(){
				if(observer)
					observer.disconnect();
			}, timeout)
		}

		let observer = new MutationObserver(function() {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
}


GT.detectElementChange = function(selector, attributesLst = [], callback) {
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes' && attributesLst.indexOf(mutation.attributeName) >= 0) {
				callback();
			}
		}
	});
	
	observer.observe(selector, {
		attributes: true,        // Observe attribute changes
		attributeFilter: attributesLst // Only watch the attributes inside attributesLst, array
	});
}

// GT.checkElmVisible = function (selector, callback, recheck, threshold, leaveCallback) {
GT.checkElmVisible = function (selector, options) {
	let _rootMargin = "0px";
	if(options.rootMargin) _rootMargin = options.rootMargin;
	if(options.rootMarginWithoutHeader) _rootMargin = (((GT.isScrollingUp ? GT.headerElmHeight : GT.mainHeaderElmHeight) || 0) * -1 - 100) + "px 0px 0px 0px";

	const observer = new IntersectionObserver((entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				options.callback && options.callback(entry);
				if(!options.recheck)
					observer.unobserve(entry.target);
			} else {
				options.leaveCallback && options.recheck && options.leaveCallback(entry);
			}
		}
	}, {
		root: null,
		rootMargin: _rootMargin,
		threshold: options.threshold || 0.5, // set offset 0.1 means trigger if atleast 10% of element in viewport
	});

	if(typeof selector == "object")
		observer.observe(selector);
	else
		document.querySelectorAll(selector).forEach(function (item) {
			observer.observe(item);
		})
}

GT.lockScrollBehindOverlay = function(queryStr){
	let _overlay = document.querySelector(queryStr),
		_clientY = null;

	if(_overlay.dataset.lockedScroll)
		return;

	_overlay.style.webkitOverflowScrolling = "touch";
	_overlay.dataset.lockedScroll = true;
	
	_overlay.addEventListener('touchstart', function (event) {
		if (event.targetTouches.length === 1) {
			// detect single touch
			_clientY = event.targetTouches[0].clientY;
		}
	}, false);
	
	_overlay.addEventListener('touchmove', function (event) {
		if (event.targetTouches.length === 1) {
			// detect single touch
			disableRubberBand(event);
		}
	}, false);
	
	function disableRubberBand(event) {
		let clientY = event.targetTouches[0].clientY - _clientY;
	
		if (_overlay.scrollTop === 0 && clientY > 0) {
			// element is at the top of its scroll
			event.preventDefault();
		}
	
		if (isOverlayTotallyScrolled() && clientY < 0) {
			//element is at the top of its scroll
			event.preventDefault();
		}
	}
	
	function isOverlayTotallyScrolled() {
		// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
		return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
	}
}

//===========Trigger window.onscroll Evt
GT.listFunctionsTriggerInScrollEvent = {};
GT.lastScrollTop = 0;
GT.isScrollingUp = false;

//waiting for animation is complete
GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging = function(time){
	GT.disableDetectScrollUpOrDown = true;
	setTimeout(function(){
		GT.disableDetectScrollUpOrDown = false;
	}, time ? time : 500)
}

GT.preventOpeningMenu = (timeout) => {
	document.firstElementChild.classList.add("animating");
	setTimeout(() => {
		document.firstElementChild.classList.remove("animating");
	}, timeout ? timeout : 600);
}

window.addEventListener('scroll', function(e) {
	if(GT.isNav2 && !GT.disableDetectScrollUpOrDown) {
		if(document.firstElementChild.classList.contains("global-reach--opening"))
			return;

		if(GT.headerElm && !GT.stickyHeaderOffsetTop)
			GT.stickyHeaderOffsetTop = GT.headerElm.firstElementChild.offsetHeight - (GT.isMobileView() ? 64 : 88);
	}

    const st = window.pageYOffset || document.documentElement.scrollTop;
	let isScrollDown = false;

	if(!GT.disableDetectScrollUpOrDown) {
		if(st + GT.wHeight < document.body.scrollHeight - 50) {
			if (st > GT.lastScrollTop){
			// downscroll code
				isScrollDown = true;
				document.body.classList.remove("scroll-up");
				document.body.classList.add("scroll-down");
				GT.isScrollingUp = false;
				// if(GT.isNav2 && st >= 0) {
				// 	if(st < GT.stickyHeaderOffsetTop) {
				// 		// window.scrollTo(0, GT.stickyHeaderOffsetTop + 100);
				// 	}
				// }
				
			} else {
			// upscroll code
				document.body.classList.remove("scroll-down");
				document.body.classList.add("scroll-up");
				GT.isScrollingUp = true;
			}
		}

		if(st > 10) {
			document.body.classList.add("scrolling");
		} else {
			document.body.classList.remove("scrolling");
		}

		if(st > GT.headerElmHeight) {
			document.body.classList.add("sticky-header");
		} else {
			document.body.classList.remove("sticky-header");
		}
    
    
		GT.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}

	Object.keys(GT.listFunctionsTriggerInScrollEvent).forEach(function(k) {
		GT.listFunctionsTriggerInScrollEvent[k] && GT.listFunctionsTriggerInScrollEvent[k](e, isScrollDown);
	})
}, {passive: true})


CallbackGReCaptchaInited = function(){
	Object.keys(GT.RecaptchaCallbackFnList).forEach(function(key){
		let recaptchaItem = GT.RecaptchaCallbackFnList[key];
		if(recaptchaItem && !recaptchaItem.isExecuted) {
			recaptchaItem.fnc();
			recaptchaItem.isExecuted = true;
		}
	})
}

GT.observeElement = function(element, property, callback, delay = 0) {
    let elementPrototype = Object.getPrototypeOf(element);
    if (elementPrototype.hasOwnProperty(property)) {
        let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
        Object.defineProperty(element, property, {
            get: function() {
                return descriptor.get.apply(this, arguments);
            },
            set: function () {
                let oldValue = this[property];
                descriptor.set.apply(this, arguments);
                let newValue = this[property];
                if (typeof callback == "function") {
                    setTimeout(callback.bind(this, oldValue, newValue), delay);
                }
                return newValue;
            }
        });
    }
}

GT.canFocus = function (element) {
	return element.closest(GT.queryStringFocusableElm);
}

GT.getListFocusableElms = function (element) {
	let arrElms = element.querySelectorAll(GT.queryStringFocusableElm),
		outputLst = [];

	for (const element of arrElms) {
		if (GT.isNotHidden(element)) {
			outputLst.push(element);
		}
	}
	return outputLst;
}


GT.getElementOffset = function(element){
	let offsetLeft = 0;
	let offsetTop  = 0;
	
	while (element)
	{
		offsetLeft += element.offsetLeft;
		offsetTop  += element.offsetTop;
	
		element = element.offsetParent;
	}
	
	return {
		top: offsetTop,
		left: offsetLeft
	};
}

// Avoid Reflow / Performance issue. Instead of using the innerWidth/offsetWidth, use this one
// return {x, y, top, left, bottom, height, width}
GT.getElementBounds = (elm) => {
    return new Promise((resolveInner) => {
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                resolveInner(entry.boundingClientRect);
            }
            // Disconnect the observer to stop from running in the background
            observer.disconnect();
        });
        observer.observe(elm);
    })
}

GT.firstFocusableElmKeyHandler = function(e) {
	if(e.key == "Tab" && !e.shiftKey) {
		e.preventDefault();
		GT.firstFocusableElm.focus();
	}
}

GT.lastFocusableElmKeyHandler = function(e) {
	if(e.key == "Tab" && e.shiftKey) {
		e.preventDefault();
		GT.lastFocusableElm.focus();
	}
}

GT.unloopFocus = function(listFocusableElms) {
	listFocusableElms.forEach((item, indx) => {
		item.removeEventListener("keydown", GT.firstFocusableElmKeyHandler);
		item.removeEventListener("keydown", GT.lastFocusableElmKeyHandler);
	})
}

GT.loopFocus = function(targetPanel, listFocusableElms, onlyLoopFocus) {
	let tmpListFocusableElms = listFocusableElms ? listFocusableElms : GT.getListFocusableElms(targetPanel),
		tmpListFocusableElmsLength = tmpListFocusableElms.length;

	if(tmpListFocusableElmsLength) {
		tmpListFocusableElms.forEach((item, indx) => {
			tmpListFocusableElms[indx]?.removeEventListener("keydown", GT.firstFocusableElmKeyHandler);
			tmpListFocusableElms[indx]?.removeEventListener("keydown", GT.lastFocusableElmKeyHandler);
		})

		GT.firstFocusableElm = tmpListFocusableElms[0],
		GT.lastFocusableElm = tmpListFocusableElmsLength > 1 ? tmpListFocusableElms[tmpListFocusableElmsLength - 1] : GT.firstFocusableElm;
		
		if(!onlyLoopFocus)
			GT.firstFocusableElm.focus();

		if(GT.firstFocusableElm) {
			GT.lastFocusableElm.addEventListener("keydown", GT.firstFocusableElmKeyHandler);
			GT.firstFocusableElm.addEventListener("keydown", GT.lastFocusableElmKeyHandler);
		}

		return {
			firstFocusableElm: GT.firstFocusableElm,
			lastFocusableElm: GT.lastFocusableElm
		}
	}
}

GT.pageAccessedByReload = () => {
	return (
	(window.performance.navigation && window.performance.navigation.type === 1) ||
	  window.performance
		.getEntriesByType('navigation')
		.map((nav) => nav.type)
		.includes('reload')
)};

GT.domContentLoadedFncList.push(() => {
	window.addEventListener("keydown", e => {
		if(e.key == "Tab") {
			GT.isScreenReader = true;
		}
	})

	if(GT.isMobileView())
		GT.isScreenReader = true;

	//This solution cannot resolve the case: cursor in the middle page after loading page completely
	// document.querySelector(".desktop-logo")?.addEventListener("focus", () => {
	// 	GT.isScreenReader = true;
	// 	alert("OK");
	// })

	//isReload
	if(GT.pageAccessedByReload()) {
		const lastScrollTop = window.scrollY;
		GT.lastScrollTop = lastScrollTop;
		if(lastScrollTop >= 10) document.body.classList.add("scrolling");
		if(lastScrollTop > 150) document.body.classList.add("sticky-header");
		console.log("Access by reload function");
	}

	document.querySelectorAll('a[href*="#"]').forEach(anchorLinkItem => {
		anchorLinkItem.addEventListener("click", function(e) {
			GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging(1000);
		})
	})
})

GT.clickEvt = (elm, callback) => {
	["click", "keydown"].forEach(evt => {
		elm.addEventListener(evt, (e) => {
			if(e.type == "click" || e.key == "Enter") {
				callback.call(e.target || e.currentTarget, e);
			}
		})
	})
}

GT.isNotHidden = (element, forceInMainPage) => {
	//Element.checkVisibility() => still not support Safari
	//https://caniuse.com/mdn-api_element_checkvisibility
	let isVisible;
	if(element.checkVisibility) 
		isVisible = element.checkVisibility({checkOpacity: true, checkVisibilityCSS: true}) && element.offsetWidth > 0 && element.offsetHeight > 0;
	else {
		const style = window.getComputedStyle(element);
		isVisible = style.visibility !== 'hidden' && style.display !== 'none' && style.opacity != 0 && element.offsetWidth > 0 && element.offsetHeight > 0;
	}

	let isInMainPage = true;
	if(forceInMainPage) {
		const computed = element.getBoundingClientRect();
		if(computed.left < 0 || computed.right < 0)
			isInMainPage = false;
	}

	return isVisible && isInMainPage;
}

GT.getFirstFocusableVisible = (container) => {
	function getFirstFocusableVisibleElement() {
		const focusableElements = (container || document.querySelector(".gt-wrapper")).querySelectorAll(GT.queryStringFocusableElm);
		for (const element of focusableElements) {
			if (GT.isNotHidden(element, true)) {
				return element;
			}
		}
		return null;
	}
	
	return getFirstFocusableVisibleElement();
}

GT.setInertWhileOpeningDialog = function(isLock) {
	let wrapperElm = document.querySelector(".gt-wrapper");
	let shortcutElm = document.querySelector(".shortcuts");
	if(isLock) {
		GT.headerElm?.setAttribute("inert", true);
		wrapperElm?.setAttribute("inert", true);
		shortcutElm?.setAttribute("inert", true);
	} else {
		GT.headerElm?.removeAttribute("inert");
		wrapperElm?.removeAttribute("inert");
		shortcutElm?.removeAttribute("inert");
	}
}

GT.loadScript = async function(url) {
	const script = document.createElement('script');
	script.src = url;
	script.defer = true;
	document.head.appendChild(script);
	return new Promise((resolve, reject) => {
		script.onload = () => {
			resolve();
		};
		script.onerror = () => {
			reject();
		};
	});
}

GT.getVersion = () => {
	return document.body.dataset.version;
}

GT.generateHexCode = (str) => {
	return Array.from(str)
	.map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
	.join('');
}
var GTAboutUsReportPage = function (isResize) {
    // Cache DOM elements
    const elements = {
        header: document.querySelector(".about-us-report-header"),
        headerV3: document.querySelector(".header.nav3"),
        applyBtn: document.querySelector(".sticky-pdf-header__cta"),
        introSection: document.querySelector(".introduction-section"),
        contentArea: document.querySelector("#gtPageContentArea")
    };

    if (!elements.header) return;

    let headerHeight = 0;

    if(GT.pageAccessedByReload()) {
        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
    }

    function handleScroll(e, isScrollDown) {
        const scrollTarget = elements.introSection;
        if (!scrollTarget) return;

        // Calculate heights once
        if (!headerHeight) {
            headerHeight = elements.header.clientHeight;
        }

        const shouldShowHeader = scrollTarget.getBoundingClientRect().top <
            scrollTarget.clientHeight && (isScrollDown || isScrollDown == null) && GT.isTabletView();

        if (shouldShowHeader) {
            makeHeaderSticky();
            showAboutUsReportHeader();
        } else {
            if (!GT.disableDetectScrollUpOrDown) {
                hideAboutUsReportHeader();
            }
            if (elements.header.dataset.isFakeStickyData === "true") {
                unstickHeader();
            }
        }
    }

    function makeHeaderSticky() {
        if (elements.header.dataset.sticky === "false") {
            elements.contentArea.style.paddingTop = headerHeight + "px";
            elements.header.classList.add("animate", "force-show-anchor", "sticky");
            elements.header.dataset.sticky = true;
            elements.header.dataset.isFakeStickyData = true;
        }
    }

    function unstickHeader() {
        elements.contentArea.style.paddingTop = "0";
        elements.header.classList.remove("animate", "force-show-anchor", "sticky");
        elements.header.dataset.sticky = false;
    }

    function showAboutUsReportHeader() {
        if(elements.headerV3?.querySelector(".bleed.open")) return;

        elements.header.classList.add("show-about-us-report-header");
        elements.headerV3?.classList.add("show-about-us-report-title-on-nav");

        // Close MegaMenu when Article title is showing on header
        const megaMenuLV2 = document.querySelector(".mega__level--2 .bleed.open");
        if (megaMenuLV2) {
            megaMenuLV2.classList.remove("open");
        }
    }

    function hideAboutUsReportHeader() {
        if (elements.headerV3) {
            GT.hideHyperLinkAnimation();
            elements.headerV3.classList.remove("show-about-us-report-title-on-nav");
        }
        elements.header.classList.remove("show-about-us-report-header");
    }

    // Initialize
    if (isResize || GT.lastScrollTop) {
        setTimeout(handleScroll, 200);
    }

    // Register scroll handler
    GT.listFunctionsTriggerInScrollEvent.aboutUsReportPageScrollHandler = handleScroll;
}

// window.addEventListener("DOMContentLoaded", function(){
GT.domContentLoadedFncList.push(function () {
    GTAboutUsReportPage();
    
    GT.windowResizeFncList.GTAboutUsReportPage = function(){
        GTAboutUsReportPage(true);
    };
});
GT.Accordion = function ($elem, object) {
    var opts = object.settings;
    var ths = this;
    $($elem).on('click', opts.triggerSelector, function (event) {
        ths.itemSwitchHandler(event, opts);
    });

    $($elem).on('keypress', opts.triggerSelector, function (event) {
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            ths.itemSwitchHandler(event, opts);
        }
    });
};
GT.Accordion.prototype.itemSwitchHandler = function (event, opts) {
    event.preventDefault();
    var animationDuration = 225;
    var trigger = $(event.target);
    var scrollTop = $(event.target).attr('scrollTop');
    var itemsContainer = trigger.parent().parent().parent();
    trigger.toggleClass('active');
    itemsContainer.find(opts.triggerSelector).not(trigger).removeClass('active');
    itemsContainer.find(opts.containerSelector).not(trigger.next(opts.containerSelector)).stop(true, true).slideUp(animationDuration);
    trigger.next(opts.containerSelector).stop(true, true).slideToggle(animationDuration, function () {
        if (trigger.hasClass('active') && scrollTop === true) {
            var scrollTopSpacing = $(window).width() <= 768 ? 70 : 8;
            var $scrollContainer = null;
            var newPosition = null;

            $scrollContainer = $('html, body');
            newPosition = trigger.offset().top - scrollTopSpacing;

            $scrollContainer.animate({
                scrollTop: newPosition
            }, animationDuration);
        }

        if(trigger.hasClass("active"))
            trigger.attr("aria-expanded", true);
        else
            trigger.attr("aria-expanded", false);

            
        trigger[0]?.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
};
var listDetailLocation = [];
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        [
            { elm: '.accordion', settings: { containerSelector: '.accordion-item__content', triggerSelector: '.accordion-item__trigger' } },
        ].map(function (item) {
            if (item.elm.length) {
                new GT.Accordion(item.elm, item);
            }
        })
    });

GT.AccordionV2 = function () {
    let allAccordionElms = document.querySelectorAll(".accordion-v2-item-wrapper");
    allAccordionElms.forEach((item, idx) => {
        item.dataset.index = idx;
        item.querySelector(".accordion-v2-item__trigger")?.addEventListener("click", e => {
            let currentElm = e.currentTarget || e.target,
                parentElm = currentElm.closest(".accordion-v2-item-wrapper");

            parentElm.querySelector(".accordion-v2-item__content").style.setProperty("--accordion-v2--max-height", parentElm.querySelector(".accordion-v2-item__content-text").offsetHeight + "px");

            parentElm.classList.toggle("active");

            setTimeout(e => {
                if(parentElm.classList.contains("active")) {
                    window.history.pushState(null, null, location.href.split("#")[0] + "#" + currentElm.id);
                    let onPageNav = document.querySelector(".onpage-navigation");
                    let onPageNavHeight = onPageNav ? onPageNav.clientHeight : 0;
                    let offSetVal = GT.getElementOffset(currentElm).top - GT.headerElm.clientHeight - (GT.stickyHeaderOffsetTop > 0 ? GT.stickyHeaderOffsetTop : 0) - 32 - onPageNavHeight;
                    window.scrollTo(0, offSetVal);
                    currentElm.setAttribute("aria-expanded", true);
                } else {
                    window.history.pushState(null, null, location.href.split("#")[0]);
                    currentElm.setAttribute("aria-expanded", false);
                }
            }, 350)
        })
    })

    if(location.hash) {
        const hash = location.hash.substring(1);
        let button = document.getElementById(hash);
        if (button?.classList.contains("accordion-v2-item__trigger")) {
            setTimeout(() => button.click(), 200);
        }
    }
};


GT.domContentLoadedFncList.push(function(){
    new GT.AccordionV2();
});

var GTAnchor = function(){
    let anchorContainerElm = document.querySelector(".anchor-container");

    let otherAElms = document.querySelectorAll('.gt-wrapper a[href^="#"]'),
        isScrollingByClickAction = false,
        AElms = [];

    if (anchorContainerElm) {
        AElms = anchorContainerElm.querySelectorAll("a");
        Array.prototype.slice.call(AElms).forEach(function (AElm) {
            AElm.onclick = function (e) {
                e.preventDefault();

                Array.prototype.slice.call(AElms).forEach(function (AElm2) {
                    AElm2.classList.remove("active");
                })

                scroll2Div(e);
                isScrollingByClickAction = true;
                e.target.classList.add("active");
            }
        })
    }

    
    Array.prototype.slice.call(otherAElms).forEach(function(AElm){
        AElm.onclick = function(e){
            e.preventDefault();
            if(e.target.href)
                scroll2Div(e);
        }
    })

    function scroll2Div(e){
        let headerElm = document.querySelector("header .header-top-wrapper"),
            headerElmHeight = 80;
        if(headerElm)
            headerElmHeight = headerElm.clientHeight;
        
        let targetElm = document.querySelector("#" + e.target.href.split("#")[1]);
        if(!targetElm) return;
        document.documentElement.scrollTop = (targetElm.getBoundingClientRect().top - headerElmHeight + document.documentElement.scrollTop);
    }

    let scrollTimers = [];
    function anchorScrollHandler(){
        scrollTimers.forEach(function(scrollTimer, scrollTimerIndex){
            clearTimeout(scrollTimer);
            scrollTimers.slice(scrollTimerIndex, 1);
        })
        let tmpScrollTimer = setTimeout(function(){
            isScrollingByClickAction = false;
        }, 100);
        scrollTimers.push(tmpScrollTimer);
        if(isScrollingByClickAction)
            return;
            
        let halfWH = GT.wHeight / 2 - 150,
            elmWillHighLight,
            highlightingElm;
        

        if(AElms && AElms.length > 0) {
            Array.prototype.slice.call(AElms).forEach(function(AElm){
                let targetElm = document.querySelector("#" + AElm.href.split("#")[1]);
                if(targetElm) {
                    let elmPosition = targetElm.getBoundingClientRect().top,
                        elmHeight = targetElm.clientHeight;
                        
                    if(elmPosition < halfWH && elmPosition * -1 < elmHeight - 150)
                        elmWillHighLight = AElm;
                    else
                        AElm.classList.remove("active");
                }
            })
        }
        
        if(elmWillHighLight && !elmWillHighLight.classList.contains("active")) {
            //make sure only 1 element is activated
            Array.prototype.slice.call(AElms).forEach(function(AElm){
                if(AElm.classList.contains("active") && elmWillHighLight != AElm)
                    AElm.classList.remove("active");
            })
            elmWillHighLight.classList.add("active");
        }
    }
    if (AElms.length)
        GT.listFunctionsTriggerInScrollEvent.anchorScrollHandler = anchorScrollHandler;
}

// window.addEventListener("DOMContentLoaded", function(){
GT.domContentLoadedFncList.push(function(){
    GTAnchor();
});
GT.Animation = function () {
    if (GT.isMobileView()) return;

    GT.checkElmVisible(".scroll-animation__container", {
        threshold: 0.1,
        callback: function (intersectObj) {
            let target = intersectObj.target;
            target.querySelectorAll(".animation-item").forEach(function (item) {
                if (item.dataset.animationDelay) {
                    item.style.setProperty('--element-animation-delay', item.dataset.animationDelay);
                    item.style.animationDelay = item.dataset.animationDelay;
                }
                if (item.dataset.transitionDelay) {
                    item.style.setProperty('--element-transition-delay', item.dataset.transitionDelay);
                    item.style.transitionDelay = item.dataset.transitionDelay;
                }
                if (item.dataset.y)
                    item.style.setProperty('--element-fade-in-y', item.dataset.y);
                (typeof item.dataset.transition != "undefined") && item.classList.add(item.dataset.transition);
            })
        }
    });
}

GT.domContentLoadedFncList.push(GT.Animation);
GT.windowResizeFncList.GTAnimation = GT.Animation;
GT.ArticleSummaries = function(elements, obj) {
    const richTextSelector = [
        '.richtext-block.richtext',
        '.b-richtext--mage',
        '.wide-rich-text-block',
        '.b-richtext--pdf-download',
        '.b-richtext--embeded-video',
        '.b-richtext--left-video',
        '.richtext-with-promos',
        'left-image-rich-text-block',
        '.pull-accordion-h2',
        '.text-area__contents .tinymce-page__text',
        '.campaign-content-page',
        '.tinymce-wrapper-v2',
        '.people-grid__content'
    ];
    
    let query = '';
    for (let i = 0; i < richTextSelector.length; i++) {
        query += richTextSelector[i] + ' h2';
        if (i !== richTextSelector.length - 1) query += ', ';
    }
    
    const h2List = Array.from(document.querySelectorAll(query));
    if (h2List.length === 0) {
        elements.forEach(el => el.remove());
        return;
    }

    elements.forEach((el, index) => {
        new GT.ArticleSummary(el, h2List);
    });

    document.addEventListener('click', function(e) {
        const target = e.target.closest('a[data-kp]');
        if (!target) return;
        
        e.preventDefault();
        const id = target.dataset.kp;
        const h2 = document.querySelector(`h2[data-kp="${id}"]`);
        if (h2) {
            const buffer = 250;
            const targetPosition = h2.getBoundingClientRect().top + window.pageYOffset - buffer;
            target.closest(".article-summary")?.querySelector(".highlight")?.classList.remove("highlight");
            target.classList.add("highlight", "force-highlight");
            setTimeout(() => {
                target.classList.remove("force-highlight");
            }, 1000);
			GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging(1000);
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
};

GT.ArticleSummary = function(element, h2List) {
    const isIE = /MSIE|Trident/.test(navigator.userAgent);
    const isEdge = /Edge/.test(navigator.userAgent);
    this.element = element;
    let elementCount = 0;
    let listHtmlStr = '<ul class="keypoints">';
    const maxItem = 20;
    
    h2List.forEach((h2, index) => {
        const text = getText(h2);
        if (text && isBeforeElement(element, h2) && elementCount < maxItem) {
            elementCount++;
            let dataKp = new Date().getTime() + index;
            if (!h2.getAttribute('data-kp')) {
                h2.setAttribute('data-kp', dataKp);
            } else {
                dataKp = h2.getAttribute('data-kp');
            }
            listHtmlStr += `<li><a class="keypoint-link" href="#" data-kp="${dataKp}">${text}</a></li>`;

            

            if(element.dataset.showHighLight) {
                GT.checkElmVisible(h2, {
                    callback: (observeResult) => {
                        //Prevent auto highlight on a wrong anchor link, if having 2-3 anchor links on the screen
                        if(element.closest(".article-summary")?.querySelector(".force-highlight")) return;

                        element.querySelector(`.highlight`)?.classList.remove('highlight');
                        const id = observeResult.target.getAttribute('data-kp');
                        const anchorLink = element.querySelector(`a[data-kp="${id}"]`);
                        if(anchorLink) {
                            anchorLink.classList.add('highlight');
                        }
                    },
                    recheck: true,
                    rootMarginWithoutHeader: true
                });
            }
        }
    });
    
    if(element.dataset.showHighLight) {
        GT.checkElmVisible(element, {
            leaveCallback: (observeResult) => {
                observeResult.target?.querySelectorAll('.highlight')?.forEach(el => el.classList.remove('highlight'));
            },
            recheck: true,
            rootMarginWithoutHeader: true
        });
    }
    
    if (elementCount === 0) {
        element.remove();
        return;
    }
    
    listHtmlStr += '</ul>';
    const editModeEl = element.querySelector('.edit-mode');
    if (editModeEl) {
        editModeEl.outerHTML = listHtmlStr;
    }
    
    const rightImageTextBlock = closestRightImageTextBlock(element);
    if (rightImageTextBlock) {
        setTimeout(function() {
            handleRightImageTextBlock(rightImageTextBlock, element);
            window.addEventListener('resize', function() {
                handleRightImageTextBlock(rightImageTextBlock, element);
            });
        }, 300);
        return;
    }
    element.classList.add('show');

    function getText(h2Dom) {
        const excludedTitles = [
            '.subscribe-services-container h2.Form__Title', 
            '.accordion h2.accordion__title', 
            '.gt-dataTable-wrapper h2.datatable-title', 
            '.newsletter-container h2.Form__Title',
            '.key-question-box h2.sidebar',
            '.top-trending-article h2.trending-sub__title',
            '.insights-page__subscription h2.subscription-title',
            '.addto-reading__content--text h2.heading',
            '.inline-article__contents h2.inline-article__title',
            '.reader-view__heading h2.reader-view__title',
            '.podcast-block h2.podcast-heading',
            '.datatableblock h2.datatable-title',
            '.gt-horizontal-table h2',
            'h2.Form__Title',
            '.marketo-embed-form h2',
            '.dynamic-pdf-content h2',
            // Exclude summary title in T40
            '.article-summary .summary-title',
            '.awards-carousel-block .award-carousel-title',
            '.related-content-container h2.category',
            '.related-experts-block h2.category',
            '.b-richtext--pdf-download .additional-resources-block h2.title',
            '.share-this-page-block h2.category',
            '.shared-block-container-full h2.subscribe-block-text',
            '.icontextlistblock h2',
            '.campaign-content-page .promo-listing-block h2',
            '.t13-page .wide-rich-text-block h2',
            '.t13-page .pagepromoblock h2',
            '.sml-promo.rich-text-block-with-promos h2.title',
            '.med-promo.rich-text-block-with-promos h2.title'
        ];
        
        // Check if h2 should be excluded
        const isExcluded = excludedTitles.some(selector => {
            try {
                return h2Dom.matches(selector) || h2Dom.closest(selector.split(' h2')[0]);
            } catch (error) {
                return false;
            }
        });
        
        if (isExcluded) return undefined;

        const text = h2Dom.textContent;
        if (!text || text.trim().length === 0) return undefined;
        return text.trim();
    }

    function isBeforeElement(element, h2Element) {
        if(element.dataset.forceClone) return true;
        const elementRect = element.getBoundingClientRect();
        const h2Rect = h2Element.getBoundingClientRect();
        return elementRect.top < h2Rect.top;
    }

    function closestRightImageTextBlock(element) {
        return element.closest('.b-richtext--mage');
    }

    function handleRightImageTextBlock(closestRightImgTextBlock, element) {
        const imgElement = closestRightImgTextBlock.querySelector('.right-image');
        if (!imgElement) return;
        
        const elementRect = element.getBoundingClientRect();
        const imgRect = imgElement.getBoundingClientRect();
        const elementStart = isIE || isEdge ? elementRect.top : elementRect.y;
        const imageStart = isIE || isEdge ? imgRect.top : imgRect.y;
        
        if (elementStart === 0 || imageStart === 0 || imgRect.width === 0) {
            setTimeout(function() {
                handleRightImageTextBlock(closestRightImgTextBlock, element);
            }, 100);
            return;
        }
        
        const imageEnd = imageStart + imgRect.height;
        const imageWidth = imgRect.width + 64;
        
        if (elementStart >= imageStart && elementStart <= imageEnd) {
            element.style.width = `calc(100% - ${imageWidth}px)`;
        }
        element.classList.add('show');
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        const summaryElements = Array.from(document.querySelectorAll(".b-richtext .article-summary, .campaign-content-page .article-summary, .t13-page .article-summary, .t45-insights-page .article-summary, .outline-block .article-summary, .people-grid-block .article-summary"));
        GT.ArticleSummaries(summaryElements);
    });
GT.BalanceHeight = function(containerElm, beforeCalculate, afterCalculate){
    if(!containerElm)
        return;
        
    let columnsList = containerElm.querySelectorAll("[balance-height-column]"),
        childItemsColumnList = [],
        maxLength = 0,
        totalColumns = columnsList.length;

    columnsList.forEach(function(columnElm, idx) {
        childItemsColumnList[idx] = [];
        childItemsColumnList[idx] = columnElm.querySelectorAll("[balance-height-item]");
        const _maxLength = childItemsColumnList[idx].length;
        if(_maxLength > maxLength)
            maxLength = _maxLength;
    })

    for(let i = 0; i < maxLength; i++) {
        //find MaxHeight of each rows
        let maxHeight = 0;
        for(let j = 0; j < totalColumns; j++) {
            let currentItem = childItemsColumnList[j][i];
            if(currentItem) {
                currentItem.style.minHeight = "auto";
                let _maxHeight = currentItem.clientHeight,
                    excludeHeight = 0;
                currentItem.querySelectorAll("[balance-height-exclude]").forEach(function(item){
                    const currentStyle = window.getComputedStyle(item);
                    excludeHeight += item.clientHeight + (+currentStyle.marginTop.replace("px", "")) + (+currentStyle.marginBottom.replace("px", ""));
                })

                if(excludeHeight)
                    _maxHeight -= excludeHeight;

                if(maxHeight < _maxHeight)
                    maxHeight = _maxHeight;
            }
        }

        //execute function before calculating
        beforeCalculate && beforeCalculate();

        //balance height between each columns
        for(let j = 0; j < totalColumns; j++) {
            if(childItemsColumnList[j][i]) {
                childItemsColumnList[j][i].style.minHeight = maxHeight + "px";
            }
        }

        //execute function after calculating
        afterCalculate && afterCalculate();
    }
}
GT.GTBookmarkArticle = function ($element) {    
    articleTilBookmark();
    function articleTilBookmark() {
        let _bookmarkButtons = document.querySelectorAll('.bookmark-article__button');
        if(!_bookmarkButtons) return;
        
        [].forEach.call(_bookmarkButtons, function(_bookmarkButton){
            bindBookmarkEvent(_bookmarkButton);
        });

        function bindBookmarkEvent(_bookmarkButton) {
            _bookmarkButton.addEventListener('click', function(e) {
                e.stopPropagation();
                let _this = this;
                let isauthenticated = _this.getAttribute('data-isauthenticated');

                if (isauthenticated === "False") {
                    let _isBookmarkRequiredLogin = document.getElementById('IsBookmarkLoginRequested');
                    if(_isBookmarkRequiredLogin) _isBookmarkRequiredLogin.value = 'True';

                    var articleId = _this.getAttribute('data-articleid');
                    let _bookmarkPageId = document.getElementById('bookmarkPageId');
                    _bookmarkPageId.value = articleId;

                    let containerWidth = 640;
                    let containerHeight = 475;

                    let _externalLoginButton = document.getElementById('externalLoginButton');
                    if(!_externalLoginButton) return;

                    var loginFormReferenceId = _externalLoginButton.getAttribute('data-external-login-overlay');
                    
                    var winWidth = window.innerWidth;
                    
                    let _loginPopup = document.getElementById(loginFormReferenceId);
                    if(_loginPopup) _loginPopup.style.display = 'block';

                    if (containerWidth > winWidth) {
                        containerWidth = winWidth;
                    }
                    GT.Overlays.runOverlay(document.getElementById(loginFormReferenceId), '#' + loginFormReferenceId, containerWidth, containerHeight, false, false);
                } else {
                    var isBookmarked = _this.getAttribute('data-isbookmarked');
                    var articleId = _this.getAttribute('data-articleid');
                    var language = _this.getAttribute('data-languagename');
                    var dataObject = { "articleId": articleId, "language": language };

                    let _doBookmarkEndpointInput = document.getElementById('bookmarkEndpoint');
                    let _unBookmarkEndpointInput = document.getElementById('unbookmarkEndpoint');

                    if(!_unBookmarkEndpointInput || !_doBookmarkEndpointInput) return;

                    var url = _doBookmarkEndpointInput.getAttribute('data-endpoint');
                    if (isBookmarked === "True"){
                        url = _unBookmarkEndpointInput.getAttribute('data-endpoint');
                    }

                    $.ajax({
                        type: "POST",
                        url: url,
                        contentType: "application/json",
                        dataType: "json",
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            let _addToReadingListElement = document.querySelector('.add-to-reading-list');
                            let _eventName = "";
                            let _articleTitle = _this.getAttribute('data-article-title');
                            if (isBookmarked === "True") {
                                _this.setAttribute('data-isbookmarked', 'False');
                                if(_addToReadingListElement) _addToReadingListElement.style.display = "block";

                                _eventName = "Unbookmark Article";
                            } else {
                                _this.setAttribute('data-isbookmarked', 'True');
                                if(_addToReadingListElement) _addToReadingListElement.style.display = "none";

                                _eventName = "Bookmark Article";
                            }

                            dataLayer.push({ 'event': _eventName, 'eventAction': 'Click', "eventLabel": _articleTitle });
                        },
                        error: function (xhr) {
                            console.error(xhr);
                        }
                    })
                }
                setTimeout(function() {
                    _this.blur();
                }, 500);
            });
        }
    }
};


if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTBookmarkArticle();
    });
GT.CampaignBanners = function ($element, obj) {
    $element.each(function (index, element) {
        var banner = new GT.CampaignBanner(element, obj);
        banner.init();
    });
};

GT.CampaignBanner = function (element, obj) {
    var _this = this;
    var $element = $(element);
    _this.$container = $element;
    _this.isBannerForm = $element.find('.EPiServerForms').length > 0;
};


GT.CampaignBanner.prototype.recalculateHeight = function () {
    var _this = this;
    if (_this.isBannerForm) {
        var $form = _this.$container.find('.EPiServerForms');
        if ($form.length == 0) return;
        var formHeight = $form.outerHeight();
        if (formHeight + 150 > 600) {
            var newHeight = formHeight + 150;
            _this.$container.css('min-height', newHeight);
        }
    }
};

GT.CampaignBanner.prototype.init = function () {
    var _this = this;
    if (_this.isBannerForm) {
        _this.recalculateHeight();
    }
};

GT.Capitalize = function ($elem) {
    
    $($elem).each(function() {
        var $elementText = $(this).text();
        $elementText = $elementText.replace(/\s/g, '');
        var $elemCapitalizedText = $elementText.charAt(0).toUpperCase() + $elementText.slice(1).toLowerCase();
        $(this).text(' ' + $elemCapitalizedText);
    });

};
var GTCareerDetailPage = function(isResize){
    // Cache DOM elements
    const elements = {
        header: document.querySelector(".career-detail-page-header"),
        headerV3: document.querySelector(".header.nav3"),
        applyBtn: document.querySelector(".career-detail__apply-btn"),
        fieldWrap: document.querySelector(".career-detail__field-wrap"),
        contentArea: document.querySelector("#gtPageContentArea")
    };
    
    if (!elements.header) return;
    
    let headerHeight = 0;
    
    if(GT.pageAccessedByReload()) {
        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
    }
    
    function handleScroll(e, isScrollDown) {
        const scrollTarget = elements.applyBtn || elements.fieldWrap;
        if (!scrollTarget) return;
        
        // Calculate heights once
        if (!headerHeight) {
            headerHeight = elements.header.clientHeight;
        }
        
        const shouldShowHeader = scrollTarget.getBoundingClientRect().top < 
            (elements.applyBtn ? scrollTarget.clientHeight * -1 + 80 : scrollTarget.clientHeight)  && (isScrollDown || isScrollDown == null) && GT.isTabletView();
            
        if (shouldShowHeader) {
            makeHeaderSticky();
            showCareerHeader();
        } else {
            if (!GT.disableDetectScrollUpOrDown) {
                hideCareerHeader();
            }
            if (elements.header.dataset.isFakeStickyData === "true") {
                unstickHeader();
            }
        }
    }
    
    function makeHeaderSticky() {
        if (elements.header.dataset.sticky === "false") {
            elements.contentArea.style.paddingTop = headerHeight + "px";
            elements.header.classList.add("animate", "force-show-anchor", "sticky");
            elements.header.dataset.sticky = true;
            elements.header.dataset.isFakeStickyData = true;
        }
    }
    
    function unstickHeader() {
        elements.contentArea.style.paddingTop = "0";
        elements.header.classList.remove("animate", "force-show-anchor", "sticky");
        elements.header.dataset.sticky = false;
    }
    
    function showCareerHeader() {
        if(elements.headerV3?.querySelector(".bleed.open")) return;
        
        elements.header.classList.add("show-career-detail-header");
        elements.headerV3?.classList.add("show-career-title-on-nav");
        
        // Close MegaMenu when Article title is showing on header
        const megaMenuLV2 = document.querySelector(".mega__level--2 .bleed.open");
        if (megaMenuLV2) {
            megaMenuLV2.classList.remove("open");
        }
    }
    
    function hideCareerHeader() {
        if (elements.headerV3) {
            GT.hideHyperLinkAnimation();
            elements.headerV3.classList.remove("show-career-title-on-nav");
        }
        elements.header.classList.remove("show-career-detail-header");
    }
    
    // Initialize
    if (isResize || GT.lastScrollTop) {
        setTimeout(handleScroll, 200);
    }
    
    // Register scroll handler
    GT.listFunctionsTriggerInScrollEvent.careerDetailPageScrollHandler = handleScroll;
}

// window.addEventListener("DOMContentLoaded", function(){
GT.domContentLoadedFncList.push(function(){
    GTCareerDetailPage();

    GT.windowResizeFncList.GTCareerDetailPage = function(){
        GTCareerDetailPage(true);
    };
});
// GT.CaseStudyVideoBanner = function ($element, obj) {
//     var _this = this;
//     var _iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//     var _isMobile = /Mobi/.test(navigator.userAgent) && !window.MSStream;

//     _this.hideTimeout = obj.settings.hideTimeout || 0;
//     _this.forceLoadOnMobile = obj.settings.forceLoadOnMobile || false;
//     _this.videoArray = [];

//     $element.each(function (index, element) {
//         if (element.nodeName.toLowerCase() != 'video') {
//             new GT.CaseStudyVideoBanner(element.querySelectorAll('video'), obj);
//             return false;
//         }
//         _this.videoArray.push(element);
//     });
//     if ((!_iOS) && (!_isMobile || _this.forceLoadOnMobile)) {
//         _this.loadVideo();
//     }
// };

// GT.CaseStudyVideoBanner.prototype.hideVideoAfterTimeout = function (video) {
//     var _this = this;
//     var _hideTimeout = video.data("hide-timeout") || _this.hideTimeout;
//     if (_hideTimeout > 0) {
//         setTimeout(function () {
//             video.removeClass("visible");
//             video[0].pause();
//         }, _hideTimeout * 1000);
//     }
// };

// GT.CaseStudyVideoBanner.prototype.playWhenLoaded = function (video) {
//     var _this = this;
//     video[0].oncanplaythrough = function () {
//         if (this.done) return;
//         this.done = true;

//         video.addClass("visible");
//         video[0].play();
//         _this.hideVideoAfterTimeout(video);
//     };
// };

// GT.CaseStudyVideoBanner.prototype.loadVideo = function () {
//     var _this = this;
//     _this.videoArray.map(function (video) {
//         var _video = $(video);
//         video.load();
//         _this.playWhenLoaded(_video);
//     });
// };


GT.listCharts = [];
GT.chartPlugins = {};
GT.chartConfigs = {};
GT.Chart = async () => {
    const chartType = {
        CIRCLE_DONUT: "circle-donut",
        CIRCLE_DONUT_MULTIPLE: "circle-donut-multiple",
        CIRCLE_PIE: "circle-pie",
        LINE: "line",
        PARETO: "pareto",
        BAR: "bar",
        BAR_STACKED: "bar-stacked",
        BAR_STACKED_100: "bar-stacked-100"
    };

    let lang = document.firstElementChild.lang;
    let isRTL = document.querySelector(".RTL");
    isRTL = false;

    function formatText(chartContainer, value) {
        if(!value) return "";
        if(typeof value === "number") {
            value = new Intl.NumberFormat(lang).format(value);
        }
        return chartContainer.dataset ? chartContainer.dataset.prefixText + value + chartContainer.dataset.suffixText : value;
    }

    const pluginVersion = GT.getVersion();

    GT.chartConfigs = {
        CANVAS_SYSTEM_FONT_FAMILY: "sans-serif",
        CANVAS_TEXT_CHART_COLOR: "#1A1A1A",
        CANVAS_TEXT_CHART_LIGHT_COLOR: "#4D4D4D",
        CIRCLE_DONUT_MULTIPLE_PADDING: 120,
        CANVAS_GRID_CHART_COLOR__X: "#E0DCD7",
        CANVAS_GRID_CHART_COLOR__Y: "#E0DCD7",
        formatText: formatText,
        plugins: {
            chartjs: {
                url: `${GT.pathScript}plugins/chartjs/chart.min.js`,
                isLoaded: false
            },
            datalabels: {
                url: `${GT.pathScript}plugins/chartjs/chartjs-plugin-datalabels.js`,
                isLoaded: false
            },
            stacked100: {
                url: `${GT.pathScript}plugins/chartjs/chartjs-plugin-stacked100.js`,
                isLoaded: false
            },
            adapterDateFns: {
                url: `${GT.pathScript}plugins/chartjs/chartjs-adapter-date-fns.js`,
                isLoaded: false
            },
            GTHtmlLegendPlugin: {
                url: `${GT.pathScript}modules/chartjs/GTHtmlLegendPlugin.js`,
                isLoaded: false
            },
            GTDrawLinesPlugin: {
                url: `${GT.pathScript}modules/chartjs/GTDrawLinesPlugin.js`,
                isLoaded: false
            },
            GTCenterTextPlugin: {
                url: `${GT.pathScript}modules/chartjs/GTCenterTextPlugin.js`,
                isLoaded: false
            },
            GTCutByDatePlugin: {
                url: `${GT.pathScript}modules/chartjs/GTCutByDatePlugin.js`,
                isLoaded: false
            },
            GTChartTooltip: {
                url: `${GT.pathScript}modules/chartjs/GTChartTooltip.js`,
                isLoaded: false
            },
            GTRebuildChartData: {
                url: `${GT.pathScript}modules/chartjs/GTRebuildChartData.js`,
                isLoaded: false
            }
        }
    }


    function accessibleReverse(hex) {
        // normalize
        let h = hex.replace('#','');
        if (h.length === 3) h = h.split('').map(c => c + c).join('');
        const r = parseInt(h.slice(0,2), 16);
        const g = parseInt(h.slice(2,4), 16);
        const b = parseInt(h.slice(4,6), 16);
      
        // sRGB -> linear
        const toLin = c => {
          const v = c / 255;
          return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        };
      
        const L = 0.2126 * toLin(r) + 0.7152 * toLin(g) + 0.0722 * toLin(b);
      
        // Contrast with white and black
        const contrastWhite = (1.0 + 0.05) / (L + 0.05);
        const contrastBlack = (L + 0.05) / (0.0 + 0.05);
      
        // Pick the one with higher contrast (meets 4.5:1 for body text)
        return contrastWhite >= contrastBlack ? '#ffffff' : '#000000';
    }

    async function loadPlugin(plugin, register) {
        return new Promise(async (resolve, reject) => {
            if(!plugin.isLoaded) {
                await GT.loadScript(plugin.url + "?v=" + pluginVersion).then(() => {
                    plugin.isLoaded = true;
                    if(register) {
                        Chart.register(typeof register === "string" ? GT.chartPlugins[register] : (typeof register === "function" ? register() : register));
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    // Memoized function to avoid recalculating on every call
    let isMobileView = GT.isMobileView();

    // Initialize charts with requestAnimationFrame for better performance
    requestAnimationFrame(() => {
        document.querySelectorAll(".chart-container").forEach(chartContainer => {
            chartContainer.insertAdjacentHTML("afterbegin", "<div class='chart-area fetching'><div class='loader absolute-center'><div class='spinner'></div></div><canvas></canvas></div>");
            // Lazy rendering
            GT.checkElmVisible(chartContainer, {
                callback: (intersectionObserverItem) => {
                    const targetElm = intersectionObserverItem.target;
                    const baseData = targetElm.dataset.source ? JSON.parse(targetElm.dataset.source) : null;
                    initChart(targetElm, baseData);
                }
            })
        });
    });

    function setLabelOffset(currentChart) {
        currentChart.options.scales.y.ticks.labelOffset = -((() => {
            const yScale = currentChart.scales.y;
            const first = yScale.getPixelForTick(0);
            const second = yScale.getPixelForTick(1);
            return (second - first) / 2 - 1; // half category height
        })());
    }

    function getChartFontSize(currentChart) {
        return !GT.isLargeDesktopView() || currentChart.isSmallContainer ? 12 : 14;
    };

    async function initChart(chartContainer, baseData) {
        if(!baseData) return;
        let datasetType = chartContainer.dataset.type;
        let datasetOrientation = chartContainer.dataset.orientation;
        let currentChartType = "";

        await loadPlugin(GT.chartConfigs.plugins.chartjs);
        await loadPlugin(GT.chartConfigs.plugins.datalabels);
        await loadPlugin(GT.chartConfigs.plugins.GTHtmlLegendPlugin, "htmlLegend");
        await loadPlugin(GT.chartConfigs.plugins.GTChartTooltip);
        await loadPlugin(GT.chartConfigs.plugins.GTRebuildChartData);
        
        let chartData = GTRebuildChartData(chartContainer, baseData, chartType);

        //tradeoff between performance and layout benefit
        //This only causes reflow issue when the chart is in the above the fold
        //Already have a check by Observer, only fire this one when the chart is in the viewport
        chartContainer.isSmallContainer = chartContainer.offsetWidth < GT.breakPoints.tablet_lg ? true : false;

        let chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '0%',
            plugins: {
                htmlLegend: {
                    container: chartContainer,
                    chartColors: baseData.colorSets
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                    external: function(context) {
                        GTChartTooltip(context, formatText);
                    }
                }
            }
        }

        if(![chartType.CIRCLE_PIE, chartType.CIRCLE_DONUT, chartType.CIRCLE_DONUT_MULTIPLE].includes(datasetType)) {
            // Custom grid for line + bar chart
            Object.assign(chartOptions, {
                scales: {
                    x: {
                        reverse: isRTL ? true : false,
                        offset: datasetOrientation == "horizontal" ? false : true,
                        border: {
                            dash: [0, 1],
                            color: GT.chartConfigs.CANVAS_GRID_CHART_COLOR__X
                        },
                        ticks: {
                            font: {
                                size: getChartFontSize(chartContainer)
                            },
                            z: 2000
                        }
                    },
                    y: {
                        beginAtZero: chartContainer.dataset.beginAtZero == "true" ? true : false,
                        position: isRTL ? "right" : "left",
                        border: {
                            dash: [4, 4],
                            display: false
                        },
                        grid: {
                            color: GT.chartConfigs.CANVAS_GRID_CHART_COLOR__Y
                        },
                        ticks: {
                            font: {
                                size: getChartFontSize(chartContainer)
                            },
                            z: 2000,
                            textStrokeColor: "#ffffff",
                            textStrokeWidth: (datasetOrientation == "horizontal" && baseData.trendLineDatasets.length > 0) ? 3 : 0
                        }
                    }
            }})

            chartOptions.scales[datasetOrientation == "horizontal" ? "x" : "y"].ticks.callback = function(value) {
                return formatText(chartContainer, value);
            };

            chartOptions.scales[datasetOrientation == "horizontal" ? "y" : "x"].ticks.callback = function(value) {
                let label = this.getLabelForValue(value);
                const words = label.split(" ");
                const tmp = [];
                let length = 0;
                let reachMaxLength = false;
                
                for (let i = 0; i < words.length; i ++) {
                    const currentWord = words[i];
                    length += currentWord.length + 1; // 1 == space character
                    let maxLength = (datasetOrientation == "horizontal" && chartContainer.dataset.showLabelOnTop == "true") ? (isMobileView ? 40 : 80) : (isMobileView ? 20 : 30);

                    if(length <= maxLength) {
                        tmp.push(currentWord);
                    } else {
                        if(!reachMaxLength) {
                            tmp[tmp.length - 1] += "...";
                            reachMaxLength = true;
                        }
                    }
                }

                return tmp.join(" ");
            };

            if(chartContainer.dataset.showDataLabel == "true") {
                chartOptions.plugins.datalabels = {
                    display: true,
                    clamp: true,
                    anchor: "end",
                    align: "end",
                    color: function(context) {
                        if([chartType.BAR, chartType.LINE, chartType.PARETO].includes(datasetType)) {
                            return "black";
                        }
                        return accessibleReverse(context.dataset.backgroundColor);
                    },
                    offset: datasetOrientation == "horizontal" ? 8 : 4,
                    formatter: function(value, ctx) {
                        const calculatedData = ctx.chart.chartData?.data.calculatedData;
                        return formatText(chartContainer, calculatedData ? calculatedData[ctx.datasetIndex][ctx.dataIndex] : value);
                    }
                }

                if([chartType.BAR_STACKED, chartType.BAR_STACKED_100].includes(datasetType)) {
                    chartOptions.plugins.datalabels.offset = 8;
                    chartOptions.plugins.datalabels.align = "start";
                    chartOptions.plugins.datalabels.display = function(context, x) {
                        const bar = context.chart.getDatasetMeta(context.datasetIndex).data[context.dataIndex];
                        const value = context.dataset.data[context.dataIndex];
                        const formattedValue = formatText(chartContainer, value);
                        const textLength = formattedValue.length * (getChartFontSize(chartContainer) * 0.6); // Approximate width of text
                        
                        const {
                            width,
                            height
                        } = bar.getProps(['width', 'height'], true);

                        if(datasetOrientation == "horizontal") {
                            return width >= textLength + 24 && height >= 30;
                        } else {
                            return height >= 30 && width >= textLength + 16;
                        }
                    }
                }

                
                if([chartType.PARETO, chartType.LINE, chartType.BAR].includes(datasetType)) {
                    chartOptions.plugins.datalabels.display = "auto";
                    if(chartContainer.dataset.showDataLabelBackdrop == "true") {
                        chartOptions.plugins.datalabels.backgroundColor = function(ctx) {
                            return ctx.dataset.data[ctx.dataIndex] ? "rgba(255, 255, 255, 0.85)" : "";
                        };
                    }
                    chartOptions.plugins.datalabels.borderRadius = 4;
                    chartOptions.plugins.datalabels.padding = {
                        top: 10,
                        bottom: 8,
                        left: 4,
                        right: 4
                    };
                    chartOptions.plugins.datalabels.font = {
                        lineHeight: 0
                    };
                }
            } else {
                chartOptions.plugins.datalabels = {
                    display: false,
                }
            }
        } else {
            chartOptions.plugins.datalabels = {
                display: true,
                color: 'white',
                font: function(context) {
                    const chartArea = context.chart.chartArea;
                    return {
                        weight: 'bold',
                        size: (Math.min(chartArea.width, chartArea.height) / 16) + "px"
                    };
                },
                formatter: function(value, ctx) {
                    let totalValue = 0;

                    ctx.chart.legend.legendItems.forEach((legendItem, legendItemIdx) => {
                        if(!legendItem.hidden) {
                            const currentData = ctx.dataset.data[legendItemIdx];
                            totalValue += (currentData < 0 ? currentData * -1 : currentData);
                        }
                    })

                    const percentageValue = (value < 0 ? value * -1 : value) / totalValue * 100;
                    return percentageValue < 10 ? "" : formatText(chartContainer, value);
                }
            }

            if(chartType.CIRCLE_PIE == datasetType) {
                currentChartType = "pie";
            } else {
                currentChartType = "doughnut";
                chartOptions.cutout = datasetType == chartType.CIRCLE_DONUT ? "80%" : "50%";
                chartOptions.plugins.centerText = true;
                await loadPlugin(GT.chartConfigs.plugins.GTCenterTextPlugin, "centerText");
                if(datasetType == chartType.CIRCLE_DONUT) {
                    chartOptions.plugins.datalabels.display = false;
                }

                if(datasetType == chartType.CIRCLE_DONUT_MULTIPLE) {
                    chartOptions.plugins.datalabels.display = isMobileView ? true : false;
                    await loadPlugin(GT.chartConfigs.plugins.GTDrawLinesPlugin, "drawLines");

                    chartOptions.plugins.drawLines = isMobileView ? false : true;
                    chartOptions.layout = {
                        padding: {
                            left: isMobileView ? 0 : GT.chartConfigs.CIRCLE_DONUT_MULTIPLE_PADDING,
                            right: isMobileView ? 0 : GT.chartConfigs.CIRCLE_DONUT_MULTIPLE_PADDING
                        }
                    }
                }
            }
        }

        if([chartType.LINE, chartType.PARETO].includes(datasetType)) {
            currentChartType = "line";

            //Make a gap between top and bottom for line chart
            if(chartType.LINE == datasetType) {
                Object.assign(chartOptions.scales.y, {
                    afterDataLimits: (scale) => {
                        if(chartContainer.dataset.roundMinMaxValues) {
                            try {
                                scale.min = scale.min - parseInt(chartContainer.dataset.roundMinMaxValues);
                                scale.max = scale.max + parseInt(chartContainer.dataset.roundMinMaxValues);
                            } catch(e) {
                                console.log(e);
                            }
                        } else {
                            if(chartContainer.dataset.beginAtZero != "true") {
                                scale.min = scale.min - 2;
                                scale.max = scale.max + 2;
                            }
                        }
                    },
                });

                if(chartContainer.dataset.isLineChartWithDates == "true") {
                    await loadPlugin(GT.chartConfigs.plugins.adapterDateFns);
                    await loadPlugin(GT.chartConfigs.plugins.GTCutByDatePlugin, "cutByDate");

                    chartOptions.scales.x.ticks.maxTicksLimit = 10;
                    chartOptions.scales.x.type = 'time';
                    chartOptions.scales.x.time = {
                        tooltipFormat: 'dd MMMM yyyy'
                    }

                    const diffMonth = Math.abs(new Date(chartData.data.labels[chartData.data.labels.length - 1]).getTime() - new Date(chartData.data.labels[0]).getTime()) / (1000 * 60 * 60 * 24 * 30);

                    chartOptions.scales.x.ticks.callback = function(value) {
                        if (diffMonth < 7) {
                            return new Date(value).toLocaleDateString(lang, {day: "numeric", month: "short", year: "numeric" });
                        } else {
                            return new Date(value).toLocaleDateString(lang, {month: "short", year: "numeric" });
                        }
                    }

                    chartOptions.interaction = {
                        intersect: false,
                        mode: 'index',
                    };
                }
            }
        }
        
        if([chartType.BAR, chartType.BAR_STACKED, chartType.BAR_STACKED_100].includes(datasetType)) {
            currentChartType = "bar";

            if(chartType.BAR_STACKED == datasetType) {
                chartOptions.scales.y.stacked = true;
                chartOptions.scales.x.stacked = true;
            }

            if(datasetType === chartType.BAR_STACKED_100) {
                await loadPlugin(GT.chartConfigs.plugins.stacked100, () => {return ChartjsPluginStacked100.default; });
                chartOptions.plugins.stacked100 = { enable: true };
            }
        }

        if(datasetOrientation ==  "horizontal") {
            chartOptions.indexAxis = "y";
            if(chartContainer.dataset.showLabelOnTop == "true") {
                chartOptions.scales.y.ticks.mirror = true;
                chartOptions.scales.y.ticks.padding = 0;
                chartOptions.scales.y.border.dash = [0, 4];
                chartOptions.scales.y.grid.drawTicks = false;
            }
        }

        const chartPlugins = [];
        chartPlugins.push(ChartDataLabels);

        let currentChart = new Chart(chartContainer.querySelector("canvas").getContext('2d'), {
            type: currentChartType,
            data: chartData.data,
            options: chartOptions,
            plugins: chartPlugins
        });

        if(datasetOrientation ==  "horizontal" && chartContainer.dataset.showLabelOnTop == "true") {
            // Set labelOffset to center labels
            setLabelOffset(currentChart);
            currentChart.update();
        }

        currentChart.datasetType = datasetType;
        currentChart.datasetOrientation = datasetOrientation;
        currentChart.total = chartData.total;
        currentChart.containerElm = chartContainer;
        currentChart.chartData = chartData;
        chartContainer.querySelector(".fetching").classList.remove("fetching");

        GT.listCharts.push(currentChart);
    }

    // Add resize event listener
    GT.windowResizeFncList.chart = () => {
        isMobileView = GT.isMobileView();

        GT.listCharts.forEach(currentChart => {
            let hasChange = false;
            if([chartType.CIRCLE_DONUT_MULTIPLE, chartType.CIRCLE_DONUT].includes(currentChart.datasetType)) {

                if(chartType.CIRCLE_DONUT_MULTIPLE == currentChart.datasetType) {
                    currentChart.options.plugins.datalabels.display = isMobileView ? true : false;
                    if(isMobileView) {
                        currentChart.options.plugins.drawLines = false;
                        currentChart.options.layout.padding.left = 0;
                        currentChart.options.layout.padding.right = 0;
                    } else {
                        currentChart.options.plugins.drawLines = true;
                        currentChart.options.layout.padding.left = GT.chartConfigs.CIRCLE_DONUT_MULTIPLE_PADDING;
                        currentChart.options.layout.padding.right = GT.chartConfigs.CIRCLE_DONUT_MULTIPLE_PADDING;
                    }
                }

                hasChange = true;
            }

            if(![chartType.CIRCLE_PIE, chartType.CIRCLE_DONUT, chartType.CIRCLE_DONUT_MULTIPLE].includes(currentChart.datasetType)) {
                hasChange = true;
                currentChart.options.scales.x.ticks.font.size = currentChart.options.scales.y.ticks.font.size = getChartFontSize(currentChart.containerElm);
            }

            if(currentChart.datasetOrientation ==  "horizontal" && currentChart.containerElm.dataset.showLabelOnTop == "true") {
                // Set labelOffset to center labels
                setLabelOffset(currentChart);
            }

            if(hasChange)
                currentChart.update();
        })
    };
};

GT.domContentLoadedFncList.push(function(){
    GT.Chart();
});
GT.clampData = {
    "aboutblock": [
        {selector: '.gt-small-title > a'},
        {selector: '.gt-body-text', lines: 5}
    ],
    "ibcblock": [
        {selector: '.ibc-suggested__descriptions', lines: 4}
    ],
    "newsblock": [
        {selector: '.gt-small-title > a'},
        {selector: '.news-title-text'},
        {selector: '.gt-body-text', lines: 5}
        // {selector: '.news-text', lines: 5, isHidden: false}
    ],
    "relatedcontentwithimage": [
        {selector: '.event-item__title--gridview a'},
        {selector: '.rcwib_item-content-category', lines: 1},
        {selector: '.rcwib_item-content-title', lines: 2}
    ],
    "relatedcontentnoimage": [
        {selector: '.event-item__title--gridview a'},
        {selector: '.rcwib_item-content-category', lines: 1},
        {selector: '.rcwib_item-content-title', lines: 2}, 
        {selector: '.has-description .title', lines: 2},
        {selector: '.no-description .title', lines: 4},
        {selector: '.article-tile .text', lines: 5},
        {selector: '.four-items-per-view .article-tile .text', lines: 3}
    ],
    "event-block": [
        {selector: '.event-item__title--gridview a'},
        {selector: '.event-item__title--listview a', lines: 2},
        {selector: '.grid-view .js-single-event-name'},
        {selector: '.list-view .js-single-event-name', lines: 2},
        {selector: '.single-event-block .js-single-event-name', lines: 2}
    ],
    "semminar-block": [
        {selector: '.list-view .js-single-semminar-name', lines: 2},
        {selector: '.single-event-block .js-single-semminar-name', lines: 2}
    ],
    "insight-hub-block": [
        { selector: '.article-content__clamp .content .title', lines: 3 },
        { selector: '.article-content__clamp .content-bottom .text', lines: 3 }
    ],
    "global-article-clamp": [
        { selector: '.global-article__list--items .article-content__clamp .content .category', lines: 1 },
        { selector: '.global-article__list--items .article-content__clamp .content .title', lines: 3 },
        { selector: '.global-article__list--items .article-content__clamp .content .text', lines: 3 }
    ],
    "upcoming-events__results": [
        {selector: '.event-item__title--gridview a'},
        {selector: '.event-item__title--listview a', lines: 2}
    ],
    "tombstone": [
        {selector: '.tombstone-block-container .item-transaction'},
        {selector: '.tombstone-block-container .item-business', lines: 4}
    ],
    "tombstone-transaction": [
        { selector: '.transaction-action__container .transaction-action', lines: 2 }
    ],
    "eventdetailpagev2": [
        {selector: '.title', lines: 1}
    ],
    "mega-menu-v2": [
        {selector: '.mega-content__item .mega-link', lines: 2, renderAtPageLoad: true},
        {selector: '.mega-content__item .mega-content__item--descriptions', lines: 3, renderAtPageLoad: true}
    ],
    "t11-result-v2": [
        {selector: '.result-card__desc'},        
        {selector: '.result-card__people-desc'}
    ]
}

GT.getLineHeight = function ($elem) {
    if($elem) {
        let computedStyle = window.getComputedStyle($elem);
        let fontSize = parseFloat(computedStyle.fontSize.replace("px",""));
        let lineHeight = computedStyle.lineHeight.replace("px","");
        if(lineHeight == "normal")
            lineHeight = 1.2 * fontSize;
        return parseFloat(lineHeight);
    }
};

GT.getNumberLineContent = function ($elem) {
    if(!$elem) return 0;
    try {
        // Cache measurements to avoid layout thrashing
        const measurements = {
            height: $elem.offsetHeight,
            lineHeight: GT.getLineHeight($elem)
        };
        
        // Use a more precise calculation and avoid parseInt which can be slower
        const parsedLineHeight = parseFloat(measurements.lineHeight) || 0;
        if (parsedLineHeight <= 0) return 0;
        
        // Use Math.floor instead of Math.round for better performance
        // Add a small epsilon to handle floating point precision issues
        return Math.floor((measurements.height + 0.001) / parsedLineHeight);
    } catch (e) {
        console.warn('Error calculating line content:', e);
        return 0;
    }
};

GT.clampArticleBlock = function ($elem, isForceReRender){
    let articleText = $elem.querySelector('.text'),
        articleTitle = $elem.querySelector('.title'),
        authorElm = $elem.querySelector('.page-promote__info'),
        isNoImage = $elem.classList.contains("no-image"),
        isNoDescription = $elem.classList.contains("no-description"),
        isTrending = $elem.classList.contains("trending"),
        isReverse = $elem.classList.contains("reverse"),
        isMediumDesktopView = GT.isMediumDesktopView(),
        clampText = 3,
        elClamp = 3;

    if(!articleTitle) return;
    
    if(articleText && !articleText.dataset.clamptext) {
        articleText.dataset.clamptext = articleText.textContent;
    }

    if(!articleTitle.dataset.clamptext) {
        articleTitle.dataset.clamptext = articleTitle.textContent;
    }

    let numberLine = 0,
        authorLine = 0;
    
    numberLine = GT.getNumberLineContent(articleTitle);
    authorLine = GT.getNumberLineContent(authorElm);

    if(authorElm) {
        authorLine = GT.getNumberLineContent(authorElm) + 1;
    }

    if (numberLine > 3) isNoImage && !isNoDescription && isMediumDesktopView ? elClamp = 4 : elClamp = 3;
    else elClamp = numberLine;

    
    let customLineClamp = getCustomClampLines(articleTitle);
    if(customLineClamp != -2)
        elClamp = customLineClamp;
        
    if(authorLine > 1 && elClamp > 2) {
        elClamp = elClamp - authorLine + 2 - (isTrending || isReverse ? 1 : 0);
    }

    var objTitle = {
        settings: { clamp: elClamp, isHidden: true}
    }

    if(elClamp > -1 && articleTitle) {
        if(isForceReRender) {
            articleTitle.removeAttribute("data-lazyevent-triggered");
            articleTitle.textContent = articleTitle.dataset.clamptext;
        }
        GT.Clamp(articleTitle, objTitle, isForceReRender);
        $elem.setAttribute('clamp', true);
    }
    
    // Apply only for featured article block in T1, T9 and T39
    clampText = 6 - elClamp;
    if(isNoImage) {
        if(elClamp == 4) clampText = 3;
        if(elClamp == 3) clampText = 4;

        if(isMediumDesktopView) {
            if(elClamp == 2) clampText = 6;
            if(elClamp == 1) clampText = 8;
        } else {
            if(elClamp == 2) clampText = 5;
            if(elClamp == 1) clampText = 7;
        }
    }


    if(articleTitle?.closest(".mega-featured__contents")) {
        if (numberLine > 3) elClamp = 3;
        clampText = 5 - elClamp;
    } else if(authorLine > 1)
        clampText = clampText - authorLine + 1;

    if(articleText) {
        customLineClamp = getCustomClampLines(articleText);
        if(customLineClamp != -2)
            clampText = customLineClamp;

        var objText = {
            settings: { clamp: clampText, isHidden: true}
        }

        if(clampText > -1) {
            if(isForceReRender) {
                articleText.removeAttribute("data-lazyevent-triggered");
                articleText.textContent = articleText.dataset.clamptext;
            }
            GT.Clamp(articleText, objText, isForceReRender);
            $elem.setAttribute('clamp', true);
        }
    }
}

function getCustomClampLines(clampElm){
    let _lines = -2;
    if(clampElm && clampElm.dataset.clamplines) {
        let _tmpLines = JSON.parse(clampElm.dataset.clamplines);

        if(GT.wWidth < GT.breakPoints.tablet_lg)
            _lines = _tmpLines.mobile;
        else
            _lines = _tmpLines.desktop;
    }
    return _lines;
}

GT.Clamp = function (elem, obj, isForceReRender) {
    if(!elem.dataset) return;

    let spaces = true;
    const lang = document.documentElement.lang;
    if(["zh", "ja"].indexOf(lang) >= 0) spaces = false;

    var lines = obj.settings.clamp || 3; // a default
    var isHidden = obj.settings.isHidden || false;
    var doClamp = function execute(current) {
        var lineHeight = GT.getLineHeight(current);
        var containerHeight = lineHeight * lines;

        requestAnimationFrame(() => {
            if (current.offsetHeight > containerHeight || isHidden) {
                var height = containerHeight + parseInt(lineHeight / 2.5);
                if (height)
                    shave(current, height, {spaces: spaces});
            }
        });
    };

    let clampKey = elem.dataset.clampkey,
        oldClampKey = null;

    if(!clampKey || isForceReRender) {
        if(isForceReRender) {
            oldClampKey = clampKey;
                
            // delete GT.listFunctionsTriggerInScrollEvent[oldClampKey];
            // delete GT.windowResizeFncList[oldClampKey];
        }
        clampKey = 'lazy_clampKey_' + (Math.random() * (1000000 - 0) + 0);
        elem.dataset.clampkey = clampKey;
    }

    if(obj.settings.renderAtPageLoad)
        doClamp(elem);
    else
        LazyEvent([elem], doClamp, null, isForceReRender, clampKey, oldClampKey);
};

GT.initClampText = function(elmSelector, clampName){
    let elms = document.querySelectorAll(elmSelector);
    Array.prototype.slice.call(elms).forEach(function(elm){
        elm.dataset.clampname = clampName;
        elm.classList.add("clamp-text");
    })
}

GT.clampText = function(clampName, isForceReRender){
    function doClamp(elm){
        //let ClampText function auto collect selectors. Just call GT.clampText() or GT.clampText(null, true) to force rerender
        elm.classList.add("clamp-text");
        let clampData = GT.clampData[elm.dataset.clampname];
        if(clampData){
            const clampDataLength = clampData.length;
            for(let i = 0; i < clampDataLength; i++) {
                const clampItem = clampData[i],
                    clampSelectors = elm.querySelectorAll(clampItem.selector),
                    clampSelectorsLength = clampSelectors.length;
                
                for(let clampElmIndex = 0; clampElmIndex < clampSelectorsLength; clampElmIndex++) {
                    const clampElm = clampSelectors[clampElmIndex];
                    if(!clampElm.dataset.clamptext)
                        clampElm.dataset.clamptext = clampElm.innerText || clampElm.text || clampElm.textContent;
                    if(isForceReRender || clampItem.isHidden) {
                        delete clampElm.dataset.lazyeventTriggered;
                        clampItem.isHidden = true;
                    }

                    let customLineClamp = getCustomClampLines(clampElm);
                    if(customLineClamp != -2)
                        clampItem.lines = customLineClamp;

                    if(clampItem.lines > -1 || clampItem.lines == null) {
                        GT.Clamp(clampElm, {settings: {isHidden: clampItem.isHidden, renderAtPageLoad: clampItem.renderAtPageLoad, clamp: clampItem.lines || 3}}, isForceReRender);
                    }
                }
            }
        }
    }

    let clampElms = [];

    if(clampName) {
        clampElms = document.querySelectorAll("[data-clampname=" + clampName + "]");
    } else {
        clampElms = document.querySelectorAll("[data-clampname]");
    }

    const clampElmsLength = clampElms.length;
    for(let i = 0; i < clampElmsLength; i++) {
        const item = clampElms[i];
        try{
            if(isForceReRender)
                GT.clampRevertToOriginalText(item.dataset.clampname);
            setTimeout(e => {
                doClamp(item);
            })
        }catch(e){
            console.log(e);
        }
    }
}

GT.clampRevertToOriginalText = function(clampElmName){
    Array.prototype.slice.call(document.querySelectorAll("[data-clampname=" + clampElmName + "]")).forEach(function(item){
        try{
            let clampData = GT.clampData[item.dataset.clampname];
            if(clampData){
                Array.prototype.slice.call(clampData).forEach(function(clampItem){
                    let clampElms = item.querySelectorAll(clampItem.selector);
                    Array.prototype.slice.call(clampElms).forEach(function(clampElm){
                        if(clampElm.dataset.clamptext) {
                            clampElm.innerText = clampElm.dataset.clamptext;
                        }
                    })
                })
            }
        }catch(e){
            console.log(e);
        }
    })
}


GT.clampArticle = function(isForceReRender){
    //only apply for mega menu if it opens
    let $article = document.querySelectorAll(document.querySelector(".mega__level--2.open") ? '.mega__level--2.open .article-tile' : '.gt-wrapper .article-tile');

    $article.forEach(function(item){
        item.removeAttribute("clamp");
        GT.clampArticleBlock(item, isForceReRender);
    })
}

GT.retriggerClampList = {};

GT.domContentLoadedFncList.push(function(){
    GT.clampArticle();
    GT.clampText();
});

GT.windowResizeFncList.clampTextOnResize = function() {
    GT.clampArticle(true);
    GT.clampText(null, true);
    Object.keys(GT.retriggerClampList).forEach(clampItemKey => {
        GT.retriggerClampList[clampItemKey]();
    })
};
GT.GTColumnSlider = function() {
    let _columnsCarousel = document.querySelector('.columns-carousel');
    if(!_columnsCarousel) return;

    let _columnsCarouselItems = _columnsCarousel.querySelectorAll('.column-slider-item');
    let heroSlider = _columnsCarousel.querySelectorAll(".hero-item");
    [].forEach.call(_columnsCarouselItems, function(item) {
        if(item) {
            let _slideItem = item.closest('.glide__slide');
            let _index = parseInt(_slideItem.getAttribute('data-index'));
            item.addEventListener("mouseover", function() {
                heroSlider[_index].classList.add("image-effect");
            });

            item.addEventListener("mouseout", function() {
                heroSlider[_index].classList.remove("image-effect");
            });
        }
    });

};

(function ($) {
    $.fn.isBeforeElement = function (elem) {
        if (typeof(elem) == "string") elem = $(elem);
        return this.add(elem).index(elem) > 0;
    }
})(jQuery);
////////////////////////////////////////
// GT CONTACT PAGE SPECIFIC FUNCTIONS //
////////////////////////////////////////

const GTContact = function () {

    const me = this;

    this.addMsg = function (container, message, type) {
        const msgContainer = container || document.querySelectorAll(".error-msg ul");
        const msg = message || "";
        const msgType = type || "";

    }

    // File upload event handlers
    const fileUploadInput = document.querySelector("#fileUpload .FormFileUpload__Input");
    if (fileUploadInput) {
        fileUploadInput.addEventListener('change', (e) => {
            e.preventDefault();
            me.fileChangeAndDrop(this.files);
        });
        
        fileUploadInput.addEventListener('dragover', (e) => {
            e.preventDefault();
        });
        
        fileUploadInput.addEventListener('dragenter', (e) => {
            e.preventDefault();
        });
        
        fileUploadInput.addEventListener('drop', (e) => {
            e.preventDefault();
            e.stopPropagation();

            me.fileChangeAndDrop(e.dataTransfer.files);
            this.files = e.dataTransfer.files;
        });
    }

    this.fileChangeAndDrop = function (files) {
        const ths = this;
        const __fileArray = [];
        const listEL = document.querySelector("#fileUpload .FormFileUpload__List");
        if (listEL) {
            listEL.innerHTML = "";
        }
        //ths.filePicker.parent().parent().removeClass('ValidationFail');

        //if (files.length > ths.maxFile) {
        //    GT.resetFileInput(ths.filePicker[0]);
        //    setTimeout(function () {
        //        ths.filePicker.parent().parent().addClass('ValidationFail');
        //        ths.filePicker.parent().parent().find(".Form__Element__ValidationError").html(ths.allowUploadMaxItemLabel).show();
        //    }, 10);
        //    return false;
        //}

        for (const file of files) {
            if (typeof file != "undefined") me.pushFileToArray(file);
        }
    };

    this.pushFileToArray = function (file) {
        const ths = this;
        const maxFileNameLength = 25;
        const removeEL = '<div class="file-item" title="{1}">{0}</div>';
        const attachment = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAABc0lEQVQ4jc3TT0sVURgH4EcKd9YiSwsiSYJAECLcuBMiRAiiVLQiIyX6Bq76CEkRLtRWQguLcudecHUhUTQR3VTQDdQW0h9Ly1qcVxiCO3p14wvDDIdznjm/M+9w2OvIAdbW4TI28K3cxcfRFs+VGMHfuH6grxzsBKbxG7UYD2gUN1HAL9TvBavGDP7gId4E9jgzpyXGbu2GncRsYA/wOhYO/DfvUYw352GnMCfF7M1gT3Adq2hCO7YwiYpSWA3eBXYPrwJ7Kp3ZJpbjRZtYwpk8bD6DvQhsCJ0Z4L7ULh+k9ikZczEi3MZYYM/QHeOL6AnsPc6VwmBC+gAdGA5sEHdixwvownd8xPk8rCEDHMO21G89gc3jBr7iEy7kYXA3wKvS71iMWNtS61zDOj7jYh50NO5bca+K2K3ox4p0FC/xE1ekc9y1TseCghR5p1rwBWto3AuUrX4pdlHqvSkp8houlYvtVDfexm6LeI6z+8UOZ/0DwZRpt1eyc7oAAAAASUVORK5CYII=">';
        const pdf = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAABBUlEQVQ4ja3Tuy6EQRgG4GfXoVIrVILeBRBR+BONRBQS4hDXodneDaiRSMQl6Bz67YSgp9hGIkKyCvMzZv2HFW/yZeabb+ad95z5Z/QSPIpLGOgYP4VzusQ36JbEi9YrEPURaug1gr1VyylxWYd9gTDOE3J/kKUk53EA7HZ43jAIQ4qiLawqfeyzONNudG/xRfyo81hEBl2fBqaYQVnaIc8K5LYTNonPOIa79jHLjoYw14VUY4OVjEd8lEMhf59UFaLaALbod/GjO8HuBDVCrGhf6N/mN2I2nUc4RIXFRvPBrU915+j7IvEaKWKUlR92jhu4oWptEmsYaRC0TOOcVdDfX/4ANRPU9USB4cEAAAAAElFTkSuQmCC">';
        const doc = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAAnElEQVQ4jWNgoBJgROOrMDAwBDAwMDBjUfuEgYFhKbEG32ZgYPiPBzcQaxAuxQ5IhnVg08hErA1IoBybYeQYhNUwFiI1vmdgYNiDxFeCGlaBSwOxAdoAVQsH5HoNA+Dz2n8c4uhpj6BBnUQ7h4BBOAOSVIOGuNfQAaFMi4xvIWtE968yAwNDJAMDAw8BC78wMDAsZ2BguEuJq7ECAAklKSMnXojkAAAAAElFTkSuQmCC">';
        const img = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAA/0lEQVQ4jd3TTyvEURTG8c9oSPzWZmtlPbYUQsLGeAf+lFI2SnkBsrOQjaVXIDtSGnkDZpayEztNNrNTWMyZ+qk7YrLh2dzOuff5dp57u/xbFWItY7NLxjHqxSiGUcHJDyGruEC93aig9g3jEh5wGHUtvHo6GDKMJvrreMIWevMbKVAW495gPHr9WMMRBrGH17yp6LMynOMd+wFcxg7mI1I5FSEPGggILKKJN1zhFmM4jf3tr0AjeMZCQPowofUic2hgCtcpWB70GOM3te7kDEOYxkucuccMqhG/kAI1EpDZHKStu4BXUUqBStiNGJM4wIbOusRKu/i1L9Kl9y/oAw0OMeRN588pAAAAAElFTkSuQmCC">';
        let __fileName = file.name;
        const __fullName = __fileName;
        let icon = attachment;

        if (__fileName.length) {
            const __extension = __fileName.match(/\..{1,5}$/ig);
            const __ext = __extension ? __extension : '';

            if (__fileName.replace(__extension, '').length >= maxFileNameLength) {
                __fileName = __fileName.substring(0, maxFileNameLength) + '..' + __ext;
            }

            const ext_icon = __ext[0].toLowerCase();
            if (ext_icon.indexOf(".pdf") >= 0) {
                icon = pdf;
            } else if (ext_icon.indexOf(".doc") >= 0 || ext_icon.indexOf(".xls") >= 0) {
                icon = doc;
            } else if (ext_icon.indexOf(".jp") >= 0 || ext_icon.indexOf(".png") >= 0 || ext_icon.indexOf(".gif") >= 0) {
                icon = img;
            }

            //ths.__fileArray.push(file);
            __fileName = removeEL.replace('{0}', icon + " " + __fileName).replace('{1}', __fullName);
            const listEL = document.querySelector("#fileUpload .FormFileUpload__List");
            if (listEL) {
                listEL.innerHTML += __fileName;
            }
        }
    }

    this.contactForm = function () {

        const enquiryTypeSelect = document.querySelector("#EnquiryType");
        if (enquiryTypeSelect) {
            enquiryTypeSelect.addEventListener('change', function () {
                const dropdown = this;
                me.updateFileUploadVisibility(dropdown);
            });
        }

        const emailContactBtn = document.querySelector("#EmailContact");
        if (emailContactBtn) {
            emailContactBtn.addEventListener('click', () => { 
                updateContactDetails(false); 
            });
        }
        
        const phoneContactBtn = document.querySelector("#PhoneContact");
        if (phoneContactBtn) {
            phoneContactBtn.addEventListener('click', () => { 
                updateContactDetails(true); 
            });
        }

        const contactFormMessage = document.querySelector('.contact-form .message');
        if (contactFormMessage && contactFormMessage.classList.contains('success-msg')) {
            triggerGACall();
        }
    };

    this.updateFileUploadVisibility = function (dropdown) {
        const selected = dropdown.options[dropdown.selectedIndex];
        const showUpload = parseInt(selected.getAttribute("data-showupload"), 10);
        const fileUpload = document.querySelector("#fileUpload");
        const uploadTitle = document.querySelector("#uploadTitle");
        const isFileRequired = document.querySelector("#IsFileRequired");
        const enquiryEmail = document.querySelector("#EnquiryEmail");
        
        if (showUpload === 1) {
            if (fileUpload) fileUpload.style.display = 'block';
            if (uploadTitle) {
                uploadTitle.textContent = selected.getAttribute("data-uploadtitle");
                const alertSpan = document.createElement('span');
                alertSpan.className = 'alert';
                alertSpan.textContent = '*';
                uploadTitle.appendChild(alertSpan);
            }
            if (isFileRequired) isFileRequired.value = true;
        } else {
            if (fileUpload) fileUpload.style.display = 'none';
            if (isFileRequired) isFileRequired.value = false;
        }
        if (enquiryEmail) enquiryEmail.value = selected.getAttribute("data-email");
    };

    this.methodOfContact = function (elem) {
        const preferredContactType = elem.querySelector('input[name="PreferredContactType"]');

        if (preferredContactType) {
            preferredContactType.addEventListener('click', function () {
                const thisInput = this;
                const placeholderText = thisInput.getAttribute('data-placeholder');
                // set proper placeholder
                const form = thisInput.closest('form');
                if (form) {
                    const contactDetails = form.querySelector('#ContactDetails');
                    if (contactDetails) contactDetails.setAttribute('placeholder', placeholderText);
                }
            });
        }
    };

    this.privacyPolicyAccepted = function (elem) {
        const policy = elem.querySelector('#IsPrivacyPolicyAcceptedOn');
        const submit = elem.querySelector('[type="submit"]');
        const form = elem.closest('form');
        
        if (policy) {
            policy.addEventListener('click', function () {
                const thisPolicy = this;
                if (thisPolicy.checked) {
                    if (submit) submit.removeAttribute("disabled");
                } else {
                    if (submit && submit.getAttribute("disabled") === null) {
                        submit.setAttribute("disabled", "disabled");
                    }
                }
            });
        }
    };

    this.contactSelector = function (elem) {
        let scrollTopSpacing = window.innerWidth <= 768 ? 70 : 10;
        const header = document.querySelector('header');
        if (header && header.dataset.sticky) scrollTopSpacing = 300;
        
        const select = elem.querySelector('.form-select select');
        if (select) {
            select.addEventListener("change", (e) => {
                const form = e.currentTarget.closest('form');
                if (form) form.submit();
            });
        }
        
        const contactForm = elem.querySelector('.EPiServerForms');
        if (contactForm) {
            const currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
            const contactFormRect = contactForm.getBoundingClientRect();
            const newPosition = contactFormRect.top + window.pageYOffset - scrollTopSpacing;
            const vector = Math.abs(currentPosition - newPosition);
            const PXperMS = 2.5; // PX per MS

            // Smooth scroll animation
            let startTime = null;
            const animateScroll = (currentTime) => {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const progress = Math.min(timeElapsed / (vector / PXperMS), 1);
                
                const easeInOutQuad = (t) => {
                    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                };
                
                const currentScrollTop = currentPosition + (newPosition - currentPosition) * easeInOutQuad(progress);
                window.scrollTo(0, currentScrollTop);
                
                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                }
            };
            
            requestAnimationFrame(animateScroll);
        }
    }
};


GT.domContentLoadedFncList.push(() => {
    GT.Contact = new GTContact();
    if (typeof isV1GT == "undefined") {
        GT.Contact.contactForm();
        const enquiryType = document.querySelector('#EnquiryType');
        if (enquiryType) GT.Contact.updateFileUploadVisibility(enquiryType);
        
        const eventRegisterForm = document.querySelector('.event-register-form');
        if (eventRegisterForm) {
            GT.Contact.methodOfContact(eventRegisterForm);
            GT.Contact.privacyPolicyAccepted(eventRegisterForm);
        }
        
        const contactSelector = document.querySelector('.contact-selector');
        if (contactSelector) GT.Contact.contactSelector(contactSelector);
    }
});
GT.ContactFormOverlay = function (elem, GTConstruct) {
    var settings = GTConstruct.settings || {};
    var containerWidth = settings.containerWidth || 640;
    var containerHeight = settings.containerHeight || 475;
    var ID_PREFIX = 'contact-form-popup-';
    var PARENT_ID_DATA_KEY = 'contact-form-popup-parent-id';
    var DATA_SELECTOR = '[data-' + PARENT_ID_DATA_KEY + ']';
    var HASH = '#';

    var resetHash = function () {
        var scrollmem = document.documentElement.scrollTop || document.body.scrollTop;
        history.replaceState({}, document.title, window.location.href.split('#')[0]);
        GT.scrollTop(scrollmem);
    };

    var getCurrentFragment = function () {
        var currentFragment = window.location.hash;
        var locationHashIndex = currentFragment.indexOf(HASH);
        if (locationHashIndex === 0) {
            currentFragment = currentFragment.substr(1);
        }
        return currentFragment;
    };

    $(elem).each(function (_id, launcher) {
        var contactFormParentId = $(launcher).closest(DATA_SELECTOR).data(PARENT_ID_DATA_KEY);
        var contactFormId = ID_PREFIX + contactFormParentId;
        var isOpenedByClicking = false;

        var openPopup = function (_currentBtn) {
            GT.Overlays.runOverlay(
                document.getElementById(contactFormId),
                '#' + contactFormId, containerWidth, containerHeight,
                false,
                false,
                false,
                function () {
                    resetHash();
                    isOpenedByClicking = false;
                    if(_currentBtn) {
                        let _parentSourceElm = _currentBtn.closest('[data-contact-form-popup-parent-id="'+ contactFormParentId +'"]');
                        let sourceBtnElm = _parentSourceElm.querySelector('.contact-form-launcher');
                        if(sourceBtnElm)
                            sourceBtnElm.focus();
                    }

                    return false;
                }
            );
            window.location.hash = contactFormId;
        };
    
        $(launcher).click(function (e) {
            e.preventDefault();
            let _currentBtn = e.currentTarget;
            isOpenedByClicking = true;
            openPopup(_currentBtn);
        });
        $(launcher).keydown(function (e) {
            let _currentBtn = e.currentTarget;
            if(e.keyCode == 13) {
                openPopup(_currentBtn);
                isOpenedByClicking = true;
            }
        });

        if (contactFormId === getCurrentFragment()) {
            openPopup();
        }

        $(window).on('hashchange', function () {
            if (isOpenedByClicking) {
                return;
            }
            if (contactFormId === getCurrentFragment()) {
                openPopup();
            }
        });
    });
};

GT.domContentLoadedFncList.push(function(){
    if (typeof isV1GT == "undefined") {
        new GT.ContactFormOverlay($('.contact-form-launcher'), {});
    }
});
var GTContactWidgetOverlay;
GT.GTContactWidgetOverlay = function(element) {
    var $element = $(element);
    this.$element = $element;
    this.cwPercent = $element.data('percent');
    this.fadeout = $element.data('fadeout');
    this.intervalId = null;
    this.focus = true;
    var contactWidgetKey = $element.data('cwkey');
    this.cwStorageKey = 'c-widget_overlay-' + contactWidgetKey;
    this.cwFormsubmitKey = 'c-widget_overlay_submit' + '_' + contactWidgetKey;
    this.maxSubmitFormAllowed = element.data('max-submit-allowed');
    this.cwGlobalFormsubmittedKey = 'c-widget_overlay_submitted';

    this.isFooterOverlay = this.cwStorageKey.indexOf("footer-overlay") >= 0;
    if(this.isFooterOverlay) {
        if (!this.cwPercent || this.cwPercent <= 0) this.cwPercent = 0;
    } else {
        if (!this.cwPercent || this.cwPercent <= 0) this.cwPercent = 50;
    }
    this.cwMaxApperance = $element.data('numberofpage') >= 0 ? $element.data('numberofpage') : 3;
    var sessionDuration = $element.data('session');
    if (!sessionDuration || sessionDuration <= 0) sessionDuration = 24;
    this.cwSessionDuration = sessionDuration * 60 * 60 * 1000;
    var ignoreDuration = $element.data('ignored');
    if (!ignoreDuration || ignoreDuration <= 0) ignoreDuration = 365;
    this.cwIgnoreDuration = ignoreDuration * 86400000;
    this.ignoreCase = this.isFooterOverlay && document.querySelector(".t5-page__contents, .t43-page, .t44-page, .event-details-page-v2");
    this.init();
};
GT.GTContactWidgetOverlay.prototype.cwGetScrollPercent = function() {
    var s = $(window).scrollTop(),
        d = $(document).height(),
        c = $(window).height();
    var footerHeight = $('footer').outerHeight();
    var scrollPercent = (s / (d - c - footerHeight)) * 100;
    return scrollPercent;
};
GT.GTContactWidgetOverlay.prototype.onScrollHandler = function(e) {
    var $this = GTContactWidgetOverlay;
    var scrollPercent = $this.cwGetScrollPercent();
    if (scrollPercent < 0 || scrollPercent >= $this.cwPercent) {
        delete GT.listFunctionsTriggerInScrollEvent.GTContactWidgetOverlay;
        $this.appear();
        
    }
};
GT.GTContactWidgetOverlay.prototype.init = function() {

    var formSubmitState = this.getState(this.cwFormsubmitKey);
    
    if ((formSubmitState && formSubmitState.ignored) || this.ignoreCase) return;

    var currentBlockState = this.getState(this.cwStorageKey);
    if (!currentBlockState) {
        currentBlockState = this.defaultState();
        this.saveState(currentBlockState, this.cwStorageKey);
    }
    
    // Only show popup when number of submit less than number of time allowed to show popup in config
    let _cwGlobalFormsubmittedKey = this.getState(this.cwGlobalFormsubmittedKey);

    if(!this.maxSubmitFormAllowed) this.maxSubmitFormAllowed = 3;

    let _maxNumberOfSubmitForm = parseInt(this.maxSubmitFormAllowed);

    if(_cwGlobalFormsubmittedKey && parseInt(_cwGlobalFormsubmittedKey) >= _maxNumberOfSubmitForm ) return;

    if (currentBlockState.ignored) return;

    var $this = this;
    GTContactWidgetOverlay = this;

    if ($(window).scrollTop() === 0 && this.cwPercent === 0) {
        $this.appear();
    } else {
        GT.listFunctionsTriggerInScrollEvent.GTContactWidgetOverlay = GTContactWidgetOverlay.onScrollHandler;
        // window.addEventListener('scroll', onScrollHandler);
    }

    this.bindEvent();
};

GT.GTContactWidgetOverlay.prototype.bindEvent = function() {
    var $this = this;
    var $closeBtn = $this.$element.find('.c-widget__close');
    function closeBtnHandler(e){
        
        let targetElm = $(e.target.closest(".c-widget__overlay"));
        targetElm.removeClass("go");
        targetElm.hide();

        if($this.isFooterOverlay) {
            var currentBlockState = $this.getState($this.cwStorageKey);
            currentBlockState.ignored = true;
            $this.saveState(currentBlockState, $this.cwStorageKey);
        }
    
    }
    $closeBtn.on('click', function(e) { 
        closeBtnHandler(e);
     });
     $closeBtn.on('keydown', function(e) { 
         if(e.keyCode == 13)
            closeBtnHandler(e);
      });

    // get number of time submitted form local stograde
    let _cwGlobalFormsubmittedKey = $this.getState($this.cwGlobalFormsubmittedKey);
    if(!_cwGlobalFormsubmittedKey) _cwGlobalFormsubmittedKey = 0;
    let _count = 0;

    // epiform
    if (typeof $$epiforms !== 'undefined') {
        // listen to event when form is successfully submitted
        $$epiforms(".EPiServerForms").on("formsSubmitted", function (data) {
            if (this.closest(".c-widget__body")) {
                var formSubmitState = $this.getState($this.cwFormsubmitKey);
                if (!formSubmitState) formSubmitState = $this.defaultState();

                $this.setExpireState(formSubmitState);
                $this.saveState(formSubmitState, $this.cwFormsubmitKey);

                _count = parseInt(_cwGlobalFormsubmittedKey) + 1;
                // Save number of time to submit form into local stograde
                $this.saveState(_count, $this.cwGlobalFormsubmittedKey);
            }
        });

        if(document.querySelectorAll('.contactwidgetoverlayblock .c-widget__body .EPiServerForms input[placeholder=""]', ".contactwidgetoverlayblock .c-widget__body .EPiServerForms textarea[placeholder='']").length)
            document.querySelectorAll('.contactwidgetoverlayblock .c-widget__body .EPiServerForms input', ".contactwidgetoverlayblock .c-widget__body .EPiServerForms textarea").forEach(function (item) {
                let parentElm = item.closest(".Form__Element");
                if(parentElm) {
                    let label = parentElm.querySelector("label");
                    if(label)
                        label.style.display = "block";
                }
            })
    }

    // marketo form
    if (window.MktoForms2) {
        window.MktoForms2.whenReady(function (form) {
            form.onSuccess(function () {
                var element = $this.$element;
                if (element && element.hasClass("c-widget__overlay")) {
                    var formSubmitState = $this.getState($this.cwFormsubmitKey);
                    if (!formSubmitState) formSubmitState = $this.defaultState();
                    $this.setExpireState(formSubmitState);
                    $this.saveState(formSubmitState, $this.cwFormsubmitKey);
                    
                    _count = parseInt(_cwGlobalFormsubmittedKey) + 1;
                    // Save number of time to submit form into local stograde
                    $this.saveState(_count, $this.cwGlobalFormsubmittedKey);
                }
            });
        });
    }
};

GT.GTContactWidgetOverlay.prototype.defaultState = function(state) {
    return {
        'expiredOn': new Date().getTime() + this.cwSessionDuration,
        'appearance': 0
    };
};

GT.GTContactWidgetOverlay.prototype.setExpireState = function(state) {
    state.expiredOn = new Date().getTime() + this.cwIgnoreDuration;
    state.ignored = true;
};

GT.GTContactWidgetOverlay.prototype.appear = function() {
    var $this = this;
    var currentState = $this.getState($this.cwStorageKey);
    if (!currentState) currentState = $this.defaultState();
    currentState.appearance = currentState.appearance + 1;
    if (currentState.appearance >= $this.cwMaxApperance) {
        $this.setExpireState(currentState);
    }
    // $this.$element.fadeIn();
    $this.$element.addClass("animated fadeInUpShort delay-250");
    $this.$element.show();
    $this.$element.addClass("go");

    $this.saveState(currentState, $this.cwStorageKey);
    $this.counterFadeout();
    $this.focusFadeout();

    //use for whatsapp button
    if(GT.wWidth < 960) {
        let footerOverlayElmHeight = document.querySelector(".footer-overlay");
        if(footerOverlayElmHeight) {
            var cssStr = '.footer-overlay {transform: translate(0,0)} #whatsapp_chat_widget #wa-widget-send-button { margin-bottom: '+(footerOverlayElmHeight.clientHeight + 32)+'px; }',
                styleElm = document.createElement('style');

            document.body.appendChild(styleElm);
            styleElm.appendChild(document.createTextNode(cssStr));
        }
    }
};

GT.GTContactWidgetOverlay.prototype.saveState = function(state, storageKey) {
    if (!state) return;
    var data = JSON.stringify(state);
    localStorage.setItem(storageKey, data);
};

GT.GTContactWidgetOverlay.prototype.getState = function(storageKey) {
    var storedData = localStorage.getItem(storageKey);
    if (storedData) {
        var objStoredData = JSON.parse(storedData);
        if (objStoredData.expiredOn && objStoredData.expiredOn < new Date().getTime()) {
            localStorage.removeItem(storageKey);
            return null;
        }
        return objStoredData;
    }
    return null;
};

GT.GTContactWidgetOverlay.prototype.focusFadeout = function() {
    var $this = this;
    var element = $this.$element;
    if (element.attr("data-fadeout") > 0){
        $('body').on('focus', '.c-widget__overlay input, .c-widget__overlay textarea, .c-widget__overlay select, .c-widget__overlay button', function () {
            clearInterval($this.intervalId);
            element.attr("data-fadeout", $this.fadeout);
        }).on('focusout', '.c-widget__overlay input, .c-widget__overlay textarea, .c-widget__overlay select, .c-widget__overlay button', function() {
            $this.counterFadeout();
        });
    }
}


GT.GTContactWidgetOverlay.prototype.counterFadeout = function() {
    var $this = this;
    var element = $this.$element;
    if (element.attr("data-fadeout") > 0 && !this.isFooterOverlay){
        var counter = 0;
        $this.intervalId = setInterval(function() {
            counter++;
            // Display 'counter' wherever you want to display it.
            var timeplay = parseInt($this.fadeout - counter);
            element.attr("data-fadeout", timeplay);

            if (counter == $this.fadeout) {
                clearInterval($this.intervalId);
                element.removeClass("go");
                element.hide();
            }
        }, 1000);
    }
}

GT.domContentLoadedFncList.push(function(){
    if (typeof isV1GT == "undefined") {
        GT.GTContactWidgetOverlay = new GT.GTContactWidgetOverlay($('.js-contact-widget-overlay'));
    }
});
//////////////////////////
// GT COOKIES FUNCTIONS //
//////////////////////////

var GTCookies = function () {
    this.cookieName = "cookiePolicy";

    this.setCookie = function (name, value, expires, path, domain) {
        var today = new Date();
        today.setTime(today.getTime());

        /*
        if the expires variable is set, make the correct expires time, the current script below will set
        it for x number of days, to make it for hours, delete * 24, for minutes, delete * 60 * 24
        */
        if (expires) {
            expires = expires * 1000 * 60 * 60 * 24;
        }
        var expires_date = new Date(today.getTime() + expires);

        document.cookie = name + "=" + encodeURIComponent(value) +
            (expires ? ";expires=" + expires_date.toGMTString() : "") +
            (path ? ";path=" + path : "") +
            (domain ? ";domain=" + domain : "") +
            ";secure";
        var checkCookies = "/Cookies/CheckCookies";
        $.ajax({
            cache: false,
            url: checkCookies,
            type: "post",
            dataType: "json",
            success: function (data) {
                console.log("check cookies successfully");
            },
            error: function (xhr) {
                console.error(xhr);
            }
        });
	};

	this.setCookieWithoutServerCheck = function (name, value, expires, path, domain) {
		var today = new Date();
		today.setTime(today.getTime());

		/*
		if the expires variable is set, make the correct expires time, the current script below will set
		it for x number of days, to make it for hours, delete * 24, for minutes, delete * 60 * 24
		*/
		if (expires) {
			expires = expires * 1000 * 60 * 60 * 24;
		}
		var expires_date = new Date(today.getTime() + expires);

        document.cookie = name + "=" + encodeURIComponent(value) +
			(expires ? ";expires=" + expires_date.toGMTString() : "") +
			(path ? ";path=" + path : "") +
			(domain ? ";domain=" + domain : "") +
			";secure";
	};

    /** @id getCookie */
    this.getCookie = function (name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(name + "=");
            if (c_start !== -1) {
                c_start = c_start + name.length + 1;
                var c_end = document.cookie.indexOf(";", c_start);
                if (c_end === -1) {
                    c_end = document.cookie.length;
                }
                return decodeURIComponent(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    };
    
    this.deleteCookie = function (name) {
        var me = this;
        if (me.getCookie(name)) {
            // Try deleting cookie with common combinations
            const domainParts = location.hostname.split(".");
            let domain = location.hostname;

            // Attempt to remove cookie at different domain levels
            while (domainParts.length > 1) {
                domain = domainParts.join(".");
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}; Secure`;
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
                domainParts.shift();
            }

            // // Also try current domain without specifying domain attribute
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
        }
    };

    this.cookieNotify = function () {
        var me = this;

        if (this.getCookie(this.cookieName)) {
            document.querySelector("#skipcookie")?.remove();
            return;
        }

        var cprompt = $('div.cookie-block');
        var cookieCTA = cprompt.find(".cookie-cta");

        $(cprompt).show();

        // set the cookie and close the box
        cookieCTA.on("click keydown  touchend", function (e) {
            if (!e.keyCode || e.keyCode === 13) {
                $(cprompt).slideUp('slow');
                me.setCookie(me.cookieName, $(e.currentTarget).val(), 365, '/');
                e.preventDefault();
                document.querySelector("#skipcookie")?.remove();
                return false;
            }
        });
    };
};
GT.CopyText = function(){
    let elms = Array.prototype.slice.call(document.querySelectorAll("[copytext]"));
    function copyStr(textInput) {
        if(window.ClipboardItem) {

            let data = {
                "text/plain": new Blob([textInput.textContent], {type: "text/plain"})
            }

            if(typeof textInput != "string")
                data["text/html"] = new Blob([textInput.innerHTML], {type: "text/html"});

            navigator.clipboard.write([new ClipboardItem(data)]).then(
                function () {
                    /* success */
                },
                function (e) {
                    /* failure */
                    console.log(e);
                }
            );
        } else {
            if(typeof textInput != "string")
                textInput = textInput.textContent;

            var input = document.createElement('textarea');
            input.innerHTML = textInput;
            document.body.appendChild(input);
            input.select();
            var result = document.execCommand('copy');
            document.body.removeChild(input);
            return result;
        }
    }
    elms.forEach(function(elm){
        elm.addEventListener("click", function(e){
            const targetElmDT = e.target.dataset;
            if(targetElmDT) {
                if(targetElmDT.target) {
                    const contentStr = document.getElementById(targetElmDT.target);
                    if(contentStr) {
                        copyStr(contentStr);
                        if(targetElmDT.copied)
                            e.target.innerHTML = targetElmDT.copied;
                    }
                    dataLayer.push({
                        "event": "gtm.click",
                        "gtm.elementID": "press-text-copied-CTA"
                    });
                } else {
                    copyStr(targetElmDT.text);
                }
            }
        })
    })
}

GT.domContentLoadedFncList.push(function(){
    GT.CopyText();
});

GT.CountryPreselection = function () {
    if(GT.dropdown) {
        if(!GT.dropdown.callback) GT.dropdown.callback = {};
        GT.dropdown.callback.countryPreselection = function(dropdownElm) {
            const selectedItem = dropdownElm.querySelector("input:checked");
            let gotoElm = dropdownElm.closest(".country-preselection-action")?.querySelector("a");
            if(gotoElm && selectedItem) {
                gotoElm.href = selectedItem.value;
                dropdownElm.querySelector(".extended-search-v3__dropdown-selected-item").innerText = (new URL(selectedItem.value).host).replace("www.", "");
                gotoElm.setAttribute("aria-label", gotoElm.dataset.text + " " + selectedItem.dataset.label);
            }
        }
    }

    document.querySelector(".country-preselection-dismiss")?.addEventListener("click", function(e) {
        const containerElm = e.target.closest(".country-preselection");
        new HttpService().post(containerElm.dataset.endpoint);
        containerElm.remove();
        GT.recalculateHeaderHeight && GT.recalculateHeaderHeight(0);
    });
};

GT.domContentLoadedFncList.push(() => {
    GT.CountryPreselection();
});
GT.Datatables = function ($elem, obj) {
    $.each($elem, function (index, item) {
        new GT.Datatable($(item));
    });
};

GT.Datatable = function ($elem, settings) {
    let translateObj = {
        lengthMenu: dataTableTranslation?.lengthMenu || "Show _MENU_ entries",
        searchPlaceholder: dataTableTranslation?.searchPlaceholder || "Search",
    }

    var extraSetting = {
        scrollX: true,
        pagingType: 'simple',
        layout: {
            bottomEnd: {
                paging: {
                    numbers: false
                }
            }
        },
        language: {
            search: '',
            lengthMenu: translateObj.lengthMenu,
            searchPlaceholder: translateObj.searchPlaceholder,
            paginate: {
                next: '<span class="arrow1 arrow"><svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right-arrow-icon"></use></svg></span><span class="arrow2 arrow"><svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right-arrow-icon"></use></svg></span>',
                previous: '<span class="arrow1 arrow"><svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right-arrow-icon"></use></svg></span><span class="arrow2 arrow"><svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right-arrow-icon"></use></svg></span>',
            }
        }
    };
    var $wrapper = $elem.closest('.gt-dataTable-wrapper');
    var $overlay = $wrapper.find('.table-overlay');
    var useLazyLoad = $elem.data('lazyload');
    var tableId = $elem.data('id');
    var automaticNumber = $elem.data('autonumber');
    var indexColumnTitle = $elem.data('indextitle');
    if (useLazyLoad) {
        extraSetting.processing = true;
        extraSetting.serverSide = true;
        extraSetting.ajax = {
            url: '/DataTableService/Search/',
            method: 'POST',
            data: function (data) {
                data.tableId = tableId;
                data.AutomaticNumbering = automaticNumber;
                data.UseLazyLoad = true;
            }
        };
    }
    if (automaticNumber) {
        extraSetting.columnDefs = [{
            searchable: false,
            orderable: false,
            targets: 0
        }];
    }
    var setting = $.extend($.extend({}, settings), extraSetting);
    var instance = $elem.DataTable(setting);
    if (automaticNumber) {
        instance.on('preDraw.dt', function (event, dataTable) {
            instance.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                if (useLazyLoad) {
                    cell.innerHTML = dataTable._iDisplayStart + i + 1;
                } else {
                    cell.innerHTML = i + 1;
                }
            });
        }).draw();
        $(instance.column(0).header()).text(indexColumnTitle);
    }
    if (useLazyLoad) {
        instance.on('preXhr.dt', function () {
            $overlay.css('display', 'block');
        });
        instance.on('xhr.dt', function () {
            $overlay.css('display', 'none');
        });
    }
    var _this = this;
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.Datatables($('.gt-dataTable'));
    });
GT.isAdvancedUpload = function () {
    //return false; //remove for enable DnD
    var __div = document.createElement('div');
    return (('draggable' in __div) || ('ondragstart' in __div && 'ondrop' in __div)) && 'FormData' in window && 'FileReader' in window;
}();
GT.DragNDrop = function (dndContainer) {
    if (GT.isAdvancedUpload) {
        dndContainer.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('dragover dragenter', function () {
            //dndContainer.addClass('is-dragover');
        }).on('dragleave dragend drop', function () {
            //dndContainer.removeClass('is-dragover');
        });
    }
};
GT.DynamicPDF = function(){
    let scrollAnimationAreas = document.querySelectorAll(".scroll-animation .dynamic-pdf-cover.enable-parallax");

    if (!scrollAnimationAreas.length) return;    

    window.addEventListener("scroll", () => {
        scrollAnimationAreas.forEach(scrollAnimationArea => {
            let clientRect = scrollAnimationArea.getBoundingClientRect();
            let percentInViewport = 50 - (GT.wHeight - clientRect.y + 40 - clientRect.height / 2) / GT.wHeight * 100; // 40 = 1/2 of Menu's height
            if(percentInViewport > -300 && percentInViewport < 600) {
                scrollAnimationArea.style.setProperty("--scroll", percentInViewport + "%");
            }
        })
    },  false);
}

GT.domContentLoadedFncList.push(function(){
    GT.DynamicPDF();
});
GT.EPiServerForms = function (elem) {
    var ths = this;
    ths.files = {};
    var __errorClass = 'ValidationFail';
    var _campaignBtnGaClass = "t33-campaign-page-form-submit";

    function addCustomGAClass(epiForm) {
        var isCampaignPage = $(document).find('.campaign-page').length > 0;
        if (isCampaignPage) {
            var submitBtn = $(epiForm).find('button[type="submit"]');
            if (submitBtn.length > 0) {
                submitBtn.addClass(_campaignBtnGaClass);
            }
        }
    }
    function fromChoiceSelectableElem(formChoice) {
        formChoice.find('label').append('<i class="FormChoice__Icon"></i>');
    }

    function removeError(e) {
        var __element = $(e.currentTarget);
        __element.removeClass(__errorClass);
        __element.parent().removeClass(__errorClass);
        
        let checkboxElm = __element.find('input[type="checkbox"][required]');
        if(checkboxElm) {
            checkboxElm.attr("aria-invalid", false)
        }
        return;
    }

    function addBindings(formElement) {
        formElement.on('change', removeError);
    }

    function getFirstMultipleStepForm() {
        var form = $("input[name='__FormGuid']");
            if (!form.length) {
                return null;
            }
        var filteredForm = form.filter(function () {
            var that = this;
            var formId = that.value;
            var workingFormInfo = null;
            if (epi && epi.EPiServer && epi.EPiServer.Forms && epi.EPiServer.Forms[formId]) {
                workingFormInfo = epi.EPiServer.Forms[formId];
            }
            if (!workingFormInfo) {
                return false;
            }
            if (workingFormInfo && workingFormInfo.StepsInfo && workingFormInfo.StepsInfo.Steps && workingFormInfo.StepsInfo.Steps.length > 0) {
                return true;
            }
            return false;
        });
        if (filteredForm.length) {
            return filteredForm[0];
        }
        return null;            
    }

    elem.each(function () {
        var $ths = $(this);

        var formElement = $ths.find('.Form__Element');
        addBindings(formElement);
        
        let formElm = formElement.find("input,select,textarea");
        if(formElm)
            formElm.find("input,select,textarea").on('change', removeError);

        var __formChoice = $ths.find('.FormChoice');
        fromChoiceSelectableElem(__formChoice);

        var multiselect = $ths.find('.FormSelection select[multiple]');
        multiselect.parent().find('label').addClass('no-before');

        var formHeading = $ths.find('.FormStep__Title, .Form__Title, .FormStep__Description, .Form__Description');
        ths.emptyBlockChecker(formHeading);

        var filePicker = $ths.find('input[type=file]');
        filePicker.each(function () {
            ths.files[this.name] = new GT.FileUpload(this);
        });
        addCustomGAClass($ths);
    });

    if (typeof $$epiforms !== 'undefined') {
        $$epiforms(".EPiServerForms").on("formsNavigationNextStep formsNavigationPrevStep formsReset formsStartSubmitting formsSubmitted formsSubmittedError formsStepValidating FormsStructureChange FormsStepSubmitted FormsSubmissionFinalized FormsSubmitting", function (event, param1, param2) {
            ths[event.type](event);
        });

        // show/hide loading icon
        var $body = $("body");
        var $loadingDiv = $('<div class="form-loading-submit"><div class="lds-ripple"><div></div><div></div></div></div>');
        epi.EPiServer.Forms.AsyncSubmit = true;
        // listen to event when form is about submitting
        $$epiforms(".EPiServerForms").on("formsStartSubmitting", function (data) {
            $body.append($loadingDiv);
        });

        // listen to event when form is successfully submitted
        $$epiforms(".EPiServerForms").on("formsSubmitted", function (data) {
            $(".form-loading-submit").remove();
        });

        
        let epiForms = Array.prototype.slice.call(document.querySelectorAll(".EPiServerForms [type='submit']"));
        if(epiForms.length) {
            epiForms.forEach(function(epiForm){
                epiForm.addEventListener("click", function(ev){
                    let currentForm = ev.target.closest(".EPiServerForms");
                    let checkboxElms = Array.prototype.slice.call(currentForm.querySelectorAll('.Form__Element input[type="checkbox"][required]'));
                    checkboxElms.forEach(function(checkboxElm){
                        if(!checkboxElm.checked)
                            checkboxElm.setAttribute("aria-invalid", true);
                    })
                });
            })
        }

        // formsSubmittedError
        $$epiforms(".EPiServerForms").on("formsSubmittedError", function (data) {
            $(".form-loading-submit").remove();
        });        
        
        $(document).ready(function () {
            // focus multiple steps form
            var multiStepForm = getFirstMultipleStepForm();
            if (!multiStepForm) {
              return;
            }
            var formId = multiStepForm.value;
            var formData = epi.EPiServer.Forms.Data.loadFormDataFromStorage(formId);
      
            if (Object.keys(formData).length !== 0) {
              var formElement = $('#' + formId);
              if (formElement.length) {
                  ths.formScroll(formElement[0]);
              }
            }
        });


        epi.EPiServer.Forms.Validators['EPiServer.Forms.Implementation.Validation.RegularExpressionValidator'] = function (fieldID, inputData, validator) {
            let regexValue = new RegExp(validator.model.jsPattern).test(inputData);
            let fieldElm = document.querySelector('input[name="'+ fieldID +'"]');
            
            let condition = inputData && !regexValue,
                message = validator.model.message;
            
            if(fieldElm && inputData) {
                if(fieldElm.maxLength > 0 && inputData.length > fieldElm.maxLength) {
                    condition = true;
                    message = "This field's max-length is " + fieldElm.maxLength + ".";
                }

                if(fieldElm.minLength > 0 && inputData.length < fieldElm.minLength) {
                    condition = true;
                    message = "This field's min-length is " + fieldElm.maxLength + ".";
                }

                if(fieldElm.minLength > 0 && fieldElm.maxLength > 0 && inputData.length != fieldElm.maxLength) {
                    condition = true;
                    message = "This field's length is " + fieldElm.maxLength;
                    if(fieldElm.getAttribute("india-phone")) {
                        message = document.querySelector(".india-phone-wrong-length")?.value || "";
                    }
                }
            }

            if(condition && !message) {
                message = "This field is not correct.";
            }

            return condition ? {
                isValid: false,
                message: message
            } : {
                    isValid: true,
                }
        };
    }

    if (GT.isAdvancedUpload) {
        epi.EPiServer.Forms.Validators['EPiServer.Forms.Implementation.Validation.RequiredValidator'] = function (fieldID, inputData, validator) {
            var condition = false;
            if (!ths.files[fieldID]) {
                condition = inputData == "" || inputData && !inputData.length;
            } else {
                var __file = ths.files[fieldID];
                condition = !(inputData && inputData.length || __file.droppedFiles && __file.droppedFiles.length);
            }

            return condition ? {
                isValid: false,
                message: validator.model.message
            } : {
                    isValid: true,
                }
        };

        epi.EPiServer.Forms.Validators['EPiServer.Forms.Implementation.Validation.AllowedExtensionsValidator'] = function (fieldID, inputData, validator) {
            function checkExtensions(name, blackList, whiteList) {
                var extension = getExtension(name);
                console.log(extension);
                return extension.length < 1 ? !1 : (extension = extension.toLowerCase(),
                    blackList.indexOf(extension) >= 0) ? !1 : whiteList.length < 1 ? !0 : whiteList.indexOf(extension) > -1
            }

            function getExtension(name) {
                return name.substr((~-name.lastIndexOf(".") >>> 0) + 2)
            }

            if (!inputData || inputData instanceof Array && inputData.length == 0) {
                return {
                    isValid: true
                };
            }

            var __input = inputData;

            if (ths.files[fieldID] && ths.files[fieldID].droppedFiles && ths.files[fieldID].droppedFiles.length) {
                __input = ths.files[fieldID].droppedFiles;
            }

            var __ext = validator.model.accept,
                extBlackListArray = epi.EPiServer.Forms.UploadExtensionBlackList.split(","),
                extArray = __ext == undefined || __ext.length < 1 ? [] : __ext.split(","),
                extArrayLength = extArray.length,
                filesLength = __input.length;

            if (extArrayLength > 0) for (var f = 0; f < extArrayLength; f++) {
                extArray[f] = extArray[f].substr(1);
            }

            for (var e = 0; e < filesLength; e++) if (!checkExtensions(__input[e].name, extBlackListArray, extArray)) {
                return {
                    isValid: false,
                    message: epi.EPiServer.Forms.Utils.stringFormat(validator.model.message, [__ext])
                };
            }

            return {
                isValid: true
            }
        };

        epi.EPiServer.Forms.Validators['EPiServer.Forms.Implementation.Validation.MaxFileSizeValidator'] = function (fieldID, inputData, validator) {
            var __input = inputData;
            if (ths.files[fieldID] && ths.files[fieldID].droppedFiles && ths.files[fieldID].droppedFiles.length) {
                __input = ths.files[fieldID].droppedFiles;
            }

            for (var r = 0, e = __input.length, __sizeInBytes = validator.model.sizeInBytes; r < e; r++) {
                if (__input[r].size > __sizeInBytes) {
                    return {
                        isValid: false,
                        message: epi.EPiServer.Forms.Utils.stringFormat(validator.model.message, [__sizeInBytes / 1048576])
                    };
                }
            }
            return {
                isValid: true
            }
        };
    }

};

GT.EPiServerForms.prototype.emptyBlockChecker = function (el) {
    el.each(function () {
        var currentEl = this;
        if (!currentEl.innerHTML.length && currentEl.parentNode) {
            currentEl.parentNode.removeChild(currentEl);
        }
    });
};

GT.EPiServerForms.prototype.emptyTextChecker = function (el) {
    $(el).each(function () {
        if (!$(this).text().trim().length) {
            $(this).css('padding', '0');
        }
    });
};

GT.EPiServerForms.prototype.formsNavigationNextStep = function (event) {
    $(event.currentTarget).find('.ValidationFail').removeClass('ValidationFail');
};

GT.EPiServerForms.prototype.formScroll = function (target, callback) {
    if (!$('.epi-editmode').length && !$('.c-widget__overlay').length) {
        var __scrollTopSpacing = $(window).width() <= 768 ? 70 : 8;
        if($("header[data-sticky='true']").length) __scrollTopSpacing += 150;
        setTimeout(function () {
            // __overlay represents the list of special form popup container that requires special treatment
            var __overlay = $(target).parents([
                '.newsletter-container',
                '.contact-form-popup'
            ].join(','));
            var __epiForms = $(target).parents('.EPiServerForms');
            var __scrollContainer = $('html, body'),
                currentPosition = $('html, body').scrollTop(),
                newPosition = $(target).offset().top - __scrollTopSpacing,
                vector = Math.abs(currentPosition - newPosition),
                PXperMS = 2.5; // PX per MS

            if (__overlay.length) {
                __scrollContainer = __overlay;
                currentPosition = __overlay.scrollTop();
                newPosition = Math.abs((__epiForms.offset() || { top: 0 }).top - $(target).offset().top) - 20;
                vector = Math.abs(currentPosition - newPosition);
            }

            __scrollContainer.animate({
                scrollTop: newPosition
            }, Math.floor(vector / PXperMS), callback || function () { });
        }, 10);
    }
};

GT.EPiServerForms.prototype.formsSubmitted = function (event) {
    $('.ValidationFail').each(function () {
        var __el = $(this);
        var __validationMSG = __el.find('.Form__Element__ValidationError');
        if (__validationMSG.length && !__validationMSG.text().length) {
            __el.removeClass('ValidationFail');
        }
    });

    this.formScroll(event.currentTarget);
};

GT.EPiServerForms.prototype.formsStepValidating = function (event) {
    var __failElem = '.Form__Element.ValidationFail';

    var __allFailedFormElems = $(event.currentTarget)
        .find(__failElem + ' input, ' + __failElem + ' textarea, ' + __failElem + ' select');
    if (__allFailedFormElems.length) {
        var __firstFailedFormElem = __allFailedFormElems.eq(0);
        this.formScroll(__firstFailedFormElem.parents(__failElem), function () {
            if ($(window).width() > 768) {
                __firstFailedFormElem.focus();
            }
        });
    }
};
GT.EPiServerForms.prototype.formsStartSubmitting = function (event) {
    var ths = this;
    var __formData = event.formData;

    for (var i in ths.files) {
        var __singleFileInput = ths.files[i];
        var __inputName = __singleFileInput.filePicker[0].name;
        var __fileArray = __singleFileInput.droppedFiles;
        if (__fileArray && Object.getPrototypeOf(__fileArray[0]) === File.prototype) {
            for (var fileName = "", j = 0; j < __fileArray.length; j++) {
                __formData.append(__inputName + "_file_" + j, __fileArray[j]);
                fileName += __fileArray[j].name + "|";
            }

            __formData.append(__inputName, fileName)
        }
    }
};

GT.EPiServerForms.prototype.formsNavigationPrevStep = function () { };
GT.EPiServerForms.prototype.formsReset = function () { };
GT.EPiServerForms.prototype.formsSubmittedError = function () { };
GT.EPiServerForms.prototype.FormsStructureChange = function () { };
GT.EPiServerForms.prototype.FormsStepSubmitted = function () { };
GT.EPiServerForms.prototype.FormsSubmissionFinalized = function () { };
GT.EPiServerForms.prototype.FormsSubmitting = function () { };
GT.EPiServerForms.prototype.emptyTextChecker('.Form__Element__Caption');


if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.EPiServerForms($('.EPiServerForms'));
    });

GT.EPiServerFormsOverlay = function(elem) {
    let containerWidth = 640;
    let containerHeight = 475;
    let inited = false;
    const formReferenceID = elem.getAttribute('data-epiforms-overlay');

    const handleClick = e => {
        e.preventDefault();
        const formTemplate = document.querySelector("#forms-overlay-template");
        
        if (!document.querySelector(`#${formReferenceID}`) && formTemplate) {
            document.body.insertAdjacentHTML("beforeend", formTemplate.innerHTML);
            GT.setInertWhileOpeningDialog(true);
        }

        const formContainer = document.getElementById(formReferenceID);
        if (!formContainer) return;

        const winWidth = window.innerWidth;
        const formBody = formContainer.querySelector(".Form__MainBody");
        const formStatus = formContainer.querySelector(".Form__Status");

        if (formBody) formBody.style.display = 'block';
        if (formStatus) formStatus.innerHTML = '<span class="Form__Status__Message hide"></span>';

        if (containerWidth > winWidth) {
            containerWidth = winWidth;
        }

        formContainer.setAttribute("aria-modal", "true");
        inited = GT.Overlays.runOverlay(
            formContainer,
            `#${formReferenceID}`,
            containerWidth,
            containerHeight,
            true,
            true,
            inited,
            () => {
                elem.focus();
                formContainer.setAttribute("aria-modal", "false");
            }
        );
    };

    elem.addEventListener('click', handleClick);

    // Return cleanup method
    return {
        destroy: () => elem.removeEventListener('click', handleClick)
    };
};

GT.domContentLoadedFncList.push(() => {
    const selectors = [
        '#launchServiceIndustryContactFormSubscribe.subscribe-now',
        '#launchContactFormSubscribe[data-epiforms-overlay]',
        '#launchServiceIndustryContactFormSubscribe[data-epiforms-overlay]'
    ];

    selectors.forEach(selector => {
        const elem = document.querySelector(selector);
        if (elem) GT.EPiServerFormsOverlay(elem);
    });
});
GT.EmailObfuscate = function (elem) {
	$(document).on('mouseover touchstart focus',
		'[data-obfuscate-specific="true"]',
		function (e) {
			var $m = $(this);
			var href = $m.attr('href');
			if (!href) {
				$m.attr('target', '_blank');
				var user = $m.data('user');
				var domain = $m.data('domain');
				var subject = $m.data('subject');
				var bccUser = $m.data('bccuser');
				var bccDomain = $m.data('bccdomain');
				if (user != '' && domain != '') {
					var email = user + '@' + domain;
					var emailOnly = email;
					if (subject != '' && subject != undefined && subject != null) {
						email = email + '?subject=' + subject;
						if (bccUser != '' && bccUser != undefined && bccUser != null) {
							var bcc = bccUser + '@' + bccDomain;
							email = email + '&bcc=' + bcc;
						}
					} else {
						if (bccUser != '' && bccUser != undefined && bccUser != null) {
							var bcc = bccUser + '@' + bccDomain;
							email = email + '?bcc=' + bcc;
						}
					}
					$m.closest("a").attr('href', 'mailto:' + email);
					var isMobile = GT.isMobile();
					if (!isMobile && $($m, ".email-obfuscate").length) {
						var $emailObfucate = $m.find(".email-obfuscate");
						var $buttonText = $emailObfucate.parents('.button-vi-text');
						$emailObfucate.remove();
						if($buttonText.length <= 0) {
							$m.append('<span>' + emailOnly + '</span>');
						} else {
							$buttonText.text(emailOnly);
						}
					}
					if (GT.isIE()) {
						$m[0].blur();
					}
				}
			}
		});

	if (typeof(isEnableMailtoDialog) == "undefined" || !isEnableMailtoDialog) {
		$(document).on('mouseover touchstart focus',
			'[data-obfuscate="true"]',
			function (e) {
				var $m = $(this);
				var href = $m.attr('href');
				if (!href) {
					$m.attr('target', '_blank');
					var user = $m.data('user');
					var domain = $m.data('domain');
					var subject = $m.data('subject');
					var bccUser = $m.data('bccuser');
					var bccDomain = $m.data('bccdomain');
					if (user != '' && domain != '') {
						var email = user + '@' + domain;
						if (subject != '' && subject != undefined && subject != null) {
							email = email + '?subject=' + subject;
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								email = email + '&bcc=' + bcc;
							}
						} else {
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								email = email + '?bcc=' + bcc;
							}
						}
						$m.closest("a").attr('href', 'mailto:' + email);
						if (GT.isIE()) {
							$m[0].blur();
						}
					}
				}
			});
	} else {
		$(document).on('click',
			'[data-obfuscate="true"]',
			function (e) {
				e.preventDefault();
				var $m = $(this);
				if($m.attr("data-obfuscate-specific"))
					return;
				$m.attr('href', "#");
				if ($m && mailtoDialogTemplate) {
					var user = $m.data('user');
					var domain = $m.data('domain');
					var subject = $m.data('subject');
					var bccUser = $m.data('bccuser');
					var bccDomain = $m.data('bccdomain');
					if (user != '' && domain != '') {
						var email = user + '@' + domain,
							mailto = email;
						if (subject != '' && subject != undefined && subject != null) {
							email = email + '&subject=' + subject;
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								mailto = email + '&bcc=' + bcc;
							}
						} else {
							if (bccUser != '' && bccUser != undefined && bccUser != null) {
								var bcc = bccUser + '@' + bccDomain;
								mailto = email + '?bcc=' + bcc;
							}
						}
						var newMailtoDialogTemplate = mailtoDialogTemplate
													.replaceAll("gmailto", mailto.replace("?", "&"))
													.replaceAll("mailto", mailto)
													.replaceAll("mailoption", "mailto:" + mailto)
													.replaceAll("copyemail", email)
													.replaceAll("copybcc", bcc);
						if(!bcc) {
							newMailtoDialogTemplate = newMailtoDialogTemplate.replace("hidebccblock", "hide");
						}

						var $mailtoTemplate = $("#emailDialogTemplate");
						if ($mailtoTemplate)
							$mailtoTemplate.remove();
						GT.Overlays.runOverlay(newMailtoDialogTemplate, '#emailDialogTemplate', 640, 457, true, true, false, function(){
							$m.focus();
						});

						var clientSelect = document.querySelector('.js-client-select'),
							clientOpen = document.querySelector('.js-client-open');

						document.querySelector('.js-copy').addEventListener('click', function () {
								var copyText = document.getElementById("emailMailtoInput");

								/* Select the text field */
								copyText.select();
								copyText.setSelectionRange(0, 99999); /*For mobile devices*/

								/* Copy the text inside the text field */
								document.execCommand("copy");
								$("#emailDialogTemplate").find('.copied-confirmation.bcc').removeClass('show-confirmation');
								$("#emailDialogTemplate").find('.copied-confirmation.email').addClass('show-confirmation');
						});

						document.querySelector('.js-copy-bcc').addEventListener('click', function () {
								var copyText = document.getElementById("emailBCCtoInput");

								/* Select the text field */
								copyText.select();
								copyText.setSelectionRange(0, 99999); /*For mobile devices*/

								/* Copy the text inside the text field */
								document.execCommand("copy");
								$("#emailDialogTemplate").find('.copied-confirmation.email').removeClass('show-confirmation');
								$("#emailDialogTemplate").find('.copied-confirmation.bcc').addClass('show-confirmation');
						});

						clientSelect.addEventListener('change',
							function () {
								var clientSelection = clientSelect.value;
								clientOpen.setAttribute('href', clientSelection);
							});
					}
				}
			});
	}

	$(document).ready(function () {

		var beforePrint = function (e) {
			$('.email-obfuscate').each(function () {
				$(this).html($(this).attr("data-user") + "@" + $(this).attr("data-domain"));
			});
			$('.email-obfuscate').addClass('printing');

			$('.icon-social-email').each(function () {
				var user, domain;
				if ($(this).find('.ir').length > 0) {
					$(this).find(".ir").html('');
					user = $(this).attr("data-user");
					domain = $(this).attr("data-domain");
					$(this).find(".ir").html(user + "@" + domain);
				}
			});
		};
		var afterPrint = function (e) {
			$('.email-obfuscate').removeClass('printing').html('');
			$('.icon-social-email .ir').html('Email address');
			$('[data-obfuscate="true"]').blur();
		};

		if (window.matchMedia) {
			window.matchMedia('print').addListener(function (mql) {
				if (mql.matches) {
					beforePrint();
				} else {
					afterPrint();
				}
			});
		}

		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;
	}());
};

if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		GT.EmailObfuscate();
	});
var GTEpiFormV2Label = function() {
    var me = this,
        formInput = document.querySelectorAll('.EPiServerForms .FormTextbox__Input, .EPiServerForms .FormDateTime__Input'),
        formSelect = document.querySelectorAll('.EPiServerForms select'),
        formDateInput = document.querySelectorAll('.EPiServerForms .FormDateTime__Input');

    me.init = function() {
        function toggleFilledClass(item) {
            var parent = item.parentNode;
            if (item.multiple) {
                // For multiple select, check if any options are selected
                var selectedOptions = Array.from(item.selectedOptions);
                if (selectedOptions.length > 0) {
                    parent.classList.add('filled');
                } else {
                    parent.classList.remove('filled');
                }
            } else {
                // For regular inputs and single selects
                if (item.value.length > 0) {
                    parent.classList.add('filled');
                } else {
                    parent.classList.remove('filled');
                }
            }
        }

        // Fill empty title attribute with label content for input and select elements
        function fillEmptyTitle(item, label) {
            if (!item.getAttribute('title') && label && label.textContent) {
                const labelContent = label.textContent.trim();
                if(labelContent.length > 0) {
                    item.setAttribute('title', labelContent);
                    label.setAttribute('title', labelContent);
                }
            }
        }

        formInput.forEach(function (item) {
            var parentDiv = item.parentNode,
                label = parentDiv.querySelector('.Form__Element__Caption');

            fillEmptyTitle(item, label);

            setTimeout(function() {
                toggleFilledClass(item);
            }, 1000);
            
            if (!label.innerHTML) {
                label.classList.add('empty');
            }
    
            item.addEventListener("focusin", function() {
                parentDiv.classList.add('focus');
            })
    
            item.addEventListener("focusout", function(event) {
                parentDiv.classList.remove('focus');
                toggleFilledClass(event.target);
            })
            item.addEventListener("change", function(event) {
                toggleFilledClass(event.target);
            })
        });
        [].forEach.call(formSelect, function(item) {
            var parentDiv = item.parentNode,
                label = parentDiv.querySelector('.Form__Element__Caption');

            fillEmptyTitle(item, label);

            setTimeout(function() {
                toggleFilledClass(item);
            }, 1000);

            if (item.multiple) {
                parentDiv.classList.add('multiple');
            }
            
            if (!label.innerHTML) {
                label.classList.add('empty');
            }
    
            item.addEventListener("focusin", function() {
                parentDiv.classList.add('focus');
                label.classList.add('focus');
            })
    
            item.addEventListener("focusout", function() {
                parentDiv.classList.remove('focus');
                label.classList.remove('focus');
            })
    
            item.addEventListener("change", function(event) {
                toggleFilledClass(event.target);
            })
        });

        [].forEach.call(formDateInput, function(item) {
            let parentDiv = item.closest('.Form__Element');
            GT.observeElement(item, "value", function (oldValue, newValue) {
                parentDiv.classList.remove('focus');
                toggleFilledClass(item);
            });
        });

    }
    me.init();
}

GT.domContentLoadedFncList.push(function(){
    GTEpiFormV2Label();
});
GT.Equalise = function (elem) {
    var me = this;
    function equalise(elem) {

        var i = 0;
        var items = document.querySelectorAll(elem);
        var windowWWidth = window.innerWidth;

        function getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
        }

        for (i = 0; i < items.length; i++) {
            var item = items[i];
            var parent = item.parentnode;
            var eqHeight = item.querySelectorAll('.eq');
            var itemsHeight = [];
            for (j = 0; j < eqHeight.length; j++) {
                var eqItem = eqHeight[j];
                itemsHeight.push(eqItem.offsetHeight);
            }
            var maxHeight = getMaxOfArray(itemsHeight);
            for (t = 0; t < eqHeight.length; t++) {
                var targetH = eqHeight[t];
                if (windowWWidth <= 768 || (parent && parent.classList.contain('grid-view'))) {
                    targetH.style.removeProperty("height");
                }
                else {
                    targetH.style.height = maxHeight + "px";
                }
            }
        }
    }

    me.init = function () {
        equalise(elem);
        $(window).on('resize', function () {
            equalise(elem);
        });
    }
    me.init();
};
//if (typeof isV1GT == "undefined")
//   document.addEventListener('DOMContentLoaded', function () {
//        //new GT.Equalise('.single-event-block');
//        // new GT.Equalise('.events-container .switchable-single-event-block');
//        // new GT.Equalise('.seminars-container .switchable-single-event-block');
//    });

GT.EventCopyLink = function (inputid, copyButton) {
	document.getElementById(copyButton).addEventListener("click", function () {
		var copyText = document.getElementById(inputid);
		copyText.select();
		copyText.setSelectionRange(0, 99999);
		document.execCommand("copy");
		copyText.parentNode.parentNode.querySelector(".copied-message").classList.add("copied-message--show");
	}); 
};

if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		new GT.EventCopyLink('event-copy-link', 'event-copy-link-button');
    });

GT.EventCountdown = function (elem) {
    function getTimeRemaining(eventIsoStartDateTime) {
        var now = new Date();
        var total = eventIsoStartDateTime - now;
        if (total < 0) {
            total = 0;
        }
        var seconds = Math.floor((total / 1000) % 60);
        var minutes = Math.floor((total / 1000 / 60) % 60);
        var hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        var days = Math.floor(total / (1000 * 60 * 60 * 24));
        var timer = {
            remainingTotal: total,
            remainingDays: days,
            remainingHours: hours,
            remainingMinutes: minutes,
            remainingSeconds: seconds
        }

        return timer;
    }

    function initializeClock(id, endTime) {
        var clock = document.getElementById(id);
        var daysSpan = clock.querySelector('.days');
        var hoursSpan = clock.querySelector('.hours');
        var minutesSpan = clock.querySelector('.minutes');
        var secondsSpan = clock.querySelector('.seconds');

        function updateClock() {
            var t = getTimeRemaining(endTime);
            var daysLength = parseInt(String(t.remainingDays).length);
            daysSpan.innerHTML = ('0' + t.remainingDays).slice(-daysLength);
            hoursSpan.innerHTML = ('0' + t.remainingHours).slice(-2);
            minutesSpan.innerHTML = ('0' + t.remainingMinutes).slice(-2);
            secondsSpan.innerHTML = ('0' + t.remainingSeconds).slice(-2);

            if (t.remainingTotal <= 0) {
                clearInterval(timeInterval);
            }
        }

        updateClock();
        var timeInterval = setInterval(updateClock, 1000);
    }
    var eventIsoStartDateUtcElement = document.getElementById(elem);
	if(eventIsoStartDateUtcElement)
	{
		var eventIsoStartDateValue = new Date(eventIsoStartDateUtcElement.getAttribute('data-iso-start-date'));
		initializeClock(elem, eventIsoStartDateValue);	
	}    
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.EventCountdown('event-countdown__clock');
    });

var GTEventDetailPageV2 = function(isResize){
    let eventDetailPageV2HeaderElm = document.querySelector(".event-detail-page-v2-header"),
        eventDetailPageV2HeaderV3 = document.querySelector(".header.nav3"),
        eventDetailPageV2HeaderElmHeight = 0,
        eventCountDownBlock = document.querySelector(".event-countdown__block") || document.querySelector(".begin-article"),
        eventCountDownBlockHeight = 0,
        isLargeScreen = GT.wWidth >= 960,
        isInitClamp = false,
        gtPageContentAreaElm = document.querySelector("#gtPageContentArea");
    
    if(!eventCountDownBlock || !eventDetailPageV2HeaderElm)
        return;

    let anchorContainerElm = eventDetailPageV2HeaderElm.querySelector(".anchor-container");

    function eventDetailPageV2ScrollHandler(e, isScrollDown){
        if(!eventDetailPageV2HeaderElmHeight) {
            eventCountDownBlockHeight = eventCountDownBlock.clientHeight * -1 + 80;
            eventDetailPageV2HeaderElmHeight = eventDetailPageV2HeaderElm.clientHeight;
        }

        if(eventCountDownBlock.getBoundingClientRect().top < eventCountDownBlockHeight && isLargeScreen && (isScrollDown || isScrollDown == null)) {
            if(eventDetailPageV2HeaderElm.dataset.sticky == "false") {
                gtPageContentAreaElm.style.paddingTop = eventDetailPageV2HeaderElmHeight + "px";
                eventDetailPageV2HeaderElm.classList.add("animate");
                eventDetailPageV2HeaderElm.classList.add("force-show-anchor");
                eventDetailPageV2HeaderElm.classList.add("sticky");
                eventDetailPageV2HeaderElm.dataset.sticky = true;
                eventDetailPageV2HeaderElm.dataset.isFakeStickyData = true;
            }

            isScrollDown && eventDetailPageV2HeaderElm.classList.add("show-event-detail-header");

            // With Nav V3, display the Event title only when when no Bleed menu is open.
            if (eventDetailPageV2HeaderV3 && !eventDetailPageV2HeaderV3?.querySelector(".bleed.open"))
                eventDetailPageV2HeaderV3.classList.add("show-event-title-on-nav");

            //close MegaMenu when Article title is showing on header
            let megaMenuLV2 = document.querySelector(".mega__level--2 .bleed.open");
            if(megaMenuLV2)
                megaMenuLV2.classList.remove("open");

            if(anchorContainerElm) {
                eventDetailPageV2HeaderElm.classList.add("show-anchor");

                // In Nav V3, ensure that the Mega menu does not inadvertently open immediately after scrolling upward.
                if (eventDetailPageV2HeaderV3) {
                    anchorContainerElm.querySelectorAll("a").forEach(item => {
                        item.addEventListener("click", (e) => {
                            e.preventDefault();
                            let href = e.target.href.split("#");
                            let scrollTarget = document.getElementById(href[1]);
                            if (!scrollTarget) return;
                            let scrollOffset = GT.getElementOffset(scrollTarget).top - GT.headerElm.clientHeight - 64;
                            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging(2000);
                            window.scrollTo(0, scrollOffset);
                        })
                    })
                }
            }
            if(!isInitClamp) {
                let registerBtn = eventDetailPageV2HeaderElm.querySelector(".register-event__btn");
                document.querySelector(".event-detail__heading-container").style.width = (eventDetailPageV2HeaderElm.querySelector(".header-top")?.clientWidth - (GT.isNav2 ? 0 : 200) - (registerBtn ? registerBtn.clientWidth : 0)) + "px";
                GT.initClampText(".event-detail__heading-container", "eventdetailpagev2");
                GT.clampText("eventdetailpagev2");
                isInitClamp = true;
            }
        } else {
            if(!GT.disableDetectScrollUpOrDown) {
                if (eventDetailPageV2HeaderV3) {
                    GT.hideHyperLinkAnimation();
                    eventDetailPageV2HeaderV3.classList.remove("show-event-title-on-nav");
                }
                eventDetailPageV2HeaderElm.classList.remove("show-event-detail-header");
                if(anchorContainerElm)
                    eventDetailPageV2HeaderElm.classList.remove("show-anchor");
            }
            if(eventDetailPageV2HeaderElm.dataset.isFakeStickyData == "true") {
                gtPageContentAreaElm.style.paddingTop = "0";
                eventDetailPageV2HeaderElm.classList.remove("animate");
                eventDetailPageV2HeaderElm.classList.remove("force-show-anchor");
                eventDetailPageV2HeaderElm.classList.remove("sticky");
                eventDetailPageV2HeaderElm.dataset.sticky = false;
            }
        }
    }
    
    if(isResize || GT.lastScrollTop) {
        setTimeout(function(){
            eventDetailPageV2ScrollHandler();
        }, 200)
    }

    delete GT.listFunctionsTriggerInScrollEvent.eventDetailPageV2ScrollHandler;
    if(isLargeScreen)
        GT.listFunctionsTriggerInScrollEvent.eventDetailPageV2ScrollHandler = eventDetailPageV2ScrollHandler;
    
}

// window.addEventListener("DOMContentLoaded", function(){
GT.domContentLoadedFncList.push(function(){
    GTEventDetailPageV2();
});
window.addEventListener("resize", GT.debounce(function(){
    GTEventDetailPageV2(true);
}, 500));
if(typeof timeStart != "function") {
    function timeStart(name) {
        window['TS'] = window['TS'] || [];
        window['TS' + name] = Date.now();
        window['TStotal'] = window['TStotal'] ? window['TStotal'] + 1 : 1;
    }

    function timeEnd(name) {
        if (window['TS' + name]) {
            window['TS' + name] = Date.now() - window['TS' + name];
            window['TS'].push(name + ' took ' + window['TS' + name] + 'ms');
            delete (window['TS' + name]);
            window['TStotal']--;
            if (window['TStotal'] < 1) {
                if (~window.location.search.indexOf('debug=true')) {
                    alert(window['TS'].join('\r\n'));
                }
                window['TS'] = [];
            }
        }
    }
}

GT.EventListingSearch = function ($element, obj) {
    var __ths = this;
    // extend default settings
    __ths.opts = $.extend({}, {
        'form': 'form#events-listing-search-form',
        'submitBtn': '.extended-search-bar__search-btn',
        'applyFilters': '.filters__apply-close-btn',
        'filterTags': '.filters__item',
        'clearFiltersBtn': '.event-grid__clear-btn',
        'sResults': '.insight-search__results--grid',
        'sEventResult': '.event-search__results',
        'sResultsLastItem': '.extended-search__results .article-tile:last',
        'toggleFilters': '.extended-search-bar__filter-btn',
        'searchInput': '.extended-search-bar__search-input',
        'filters': '.extended-search-bar__filters',
        'closeFiltersButton': '.filters__close-button a',
        'filterHeading': '.filters__heading',
        'isFilterField': '.isFilter',
        'pageSize': '.pageSize',
        'joinChar': '+',
        'classes': {
            'filtersClosed': 'filters--closed',
            'overflowHidden': 'overflowHidden--mobile'
        },
        'eventTotalDisplayingItems': '#eventTotalDisplayingItems',
        'totalEventResultsQty': '.totalEventResultsQty',
        'eventLoadBtn': '.event-extended-search__load-btn',
        'eventLoadMoreEndpoint': '#eventLoadMoreEndpoint',
        'filterForm': '#events-listing-search-form'
    }, obj.settings);

    __ths.CLOSED = 0; __ths.OPENED = 1;
    __ths.UNACTIVE = 0; __ths.ACTIVE = 1;
    __ths.MOBILE_BREAKPOINT = 767;
    __ths.TABLET_BREAKPOINT = 1023;

    __prevWindowWidth = $(window).outerWidth();

    __ths.filtersState = __ths.CLOSED;
    __ths.activeState = __ths.ACTIVE;
    __ths.searchState = __ths.ACTIVE;
    __ths.searchState = __ths.ACTIVE;
    __ths.searchState = __ths.ACTIVE;

    __ths.el = $element;

    __ths.queryString = '';

    var _isFilter = false;
    var _isFilterHidden = __ths.el.find(__ths.opts.isFilterField);
    if (_isFilterHidden.length) {
        var filterValue = _isFilterHidden.val();
        if(filterValue.toLowerCase() == "true"){
            _isFilter = true;
        } else {
            _isFilter = false;
        }
    }

    __ths.configEvent = {};

    __ths.sParams = {
        CurrentPageIndex: 1,
        isFilter: _isFilter,
    };

    __ths.sEventParams = {
        CurrentPageIndex: 1,
        isFilter: _isFilter,
    };


    __ths.observerElm = (elm) => {
        if(!elm.dataset.observed) {
            elm.dataset.observed = true;
            GT.checkElmVisible(elm, {
                callback: (e) => {
                    __ths.updatePageIndex(elm.dataset.page);
                },
                recheck: true,
                threshold: 1
            })
        }
    }

    __ths.updatePageIndex = (pageIndex) => {
        if(pageIndex > 1) {
            __ths.setParameterInQueryString("page", pageIndex);
        } else {
            __ths.setParameterInQueryString("page", pageIndex, true);
        }

        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm) {
            let queryStr = "";
            if(__ths.sEventParams.CurrentPageIndex > 0) {
                queryStr = "?page=" + __ths.sEventParams.CurrentPageIndex;
            }

            canonicalElm.href = location.origin + location.pathname + queryStr;
        }
    }

    __ths.fireAutocomplete = function (input) {
        function orphanCharAsWord(word) {
            return word.length > 1 ? word : ' ' + word + ' ';
        }

        try {
            if(window.currentAutoComplete)
                window.currentAutoComplete.destroy();
            const inputId = input[0]?.id;
            if (inputId)
                window.currentAutoComplete = new autoComplete({
                    selector: `#${inputId}`,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&');
                        $.ajax({
                            url: __ths.escapeQueryChars(input.data('endpoint')),
                            type: "get",
                            data: {
                                query: term
                            },
                            success: function (data) {
                                suggest(data);
                                if(!data || data.length <= 0) {
                                    let _autoCompleteItems = document.querySelectorAll('.autocomplete-suggestion');
                                    
                                    [].forEach.call(_autoCompleteItems, function(_autoCompleteItem){
                                        if(_autoCompleteItem) _autoCompleteItem.remove();
                                    });
                                }
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.Text.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-link="' + item.Value + '" data-val="' + decodedText + '" >' + decodedText.replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        window.location.href = $(item).data('link');
                    }
                });
        } catch (ex) {
            console.warn(ex);
        };
    };

    __ths.initFiltersList = function (eqactive) {
        var index = 0;
        if (typeof eqactive !== 'undefined' && eqactive > -1) {
            index = eqactive;
        }
        var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

        $filterHeading.removeClass('active');
        if ($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
            $filterHeading.eq(index).addClass('active');
            $filterHeading.eq(index).attr("tabindex", 0);
            $filterHeading.eq(index).attr("aria-selected", true);
            
            let toggleFilterBtn = document.querySelector(__ths.opts.toggleFilters + ".active");
            if(toggleFilterBtn) {
                let submitBtn = document.querySelector(__ths.opts.submitBtn),
                    searchInput = document.querySelector(__ths.opts.searchInput);

                submitBtn?.setAttribute("tabindex", -1);
                searchInput?.setAttribute("tabindex", -1);
                toggleFilterBtn.setAttribute("aria-expanded", true);
            }
        }


        let clearAllTagsBtn = document.querySelector(".filter-result__clear");
        if(clearAllTagsBtn) {
            let selectedTags = Array.prototype.slice.call(document.querySelectorAll(".filter-result__tag-item"));
            if(selectedTags.length)
                selectedTags.forEach(function(tagElm){
                    tagElm.onclick = function(e){
                        let eTarget = e.currentTarget;
                        if(eTarget.dataset.id == "gt-keywords") {
                            document.querySelector(__ths.opts.searchInput).value = "";
                            document.querySelector(__ths.opts.submitBtn).click();
                        }
                        else
                            document.querySelector("#"+eTarget.dataset.id).click();

                        if(selectedTags.length == 1)
                            clearAllTagsBtn.remove();
                        eTarget.remove();
                        if(GT.wWidth < 768) {
                            document.querySelector(__ths.opts.submitBtn).click();
                        }
                    }
                })
            clearAllTagsBtn.onclick = function(){
                if(selectedTags.length)
                    selectedTags.forEach(function(tagElm){
                        if(tagElm.dataset.id != "gt-keywords")
                            document.querySelector("#"+tagElm.dataset.id).checked = false;
                        tagElm.remove();
                    })
                __ths.lastClickedCheckbox = "empty_id";
                document.querySelector(__ths.opts.searchInput).value = "";
                document.querySelector(__ths.opts.submitBtn).click();
                clearAllTagsBtn.remove();
            }
        }
    };
    
    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(__ths.opts.toggleFilters + ".active");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }

    __ths.toggleFiltersDropdown = function (currentStatus) {
        var addClassMethod = 'addClass';
        var removeClassMethod = 'removeClass';
        var __action = currentStatus == __ths.OPENED

        var filtersMethod = __action ? addClassMethod : removeClassMethod;
        var overflowMethod = __action ? removeClassMethod : addClassMethod;
        var toggleButtonMethod = __action ? removeClassMethod : addClassMethod;
        __ths.filtersState = __action ? __ths.CLOSED : __ths.OPENED;

        var $button = __ths.el.find(__ths.opts.toggleFilters);
        var $filters = __ths.el.find(__ths.opts.filters);
        var __cls = __ths.opts.classes;
        $button[toggleButtonMethod]('active');
        $filters[filtersMethod](__cls.filtersClosed);
        $('html')[overflowMethod](__cls.overflowHidden);

        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
        let _searchBarContainer = document.querySelector(".event-listing-search");
        let filterBody = document.querySelector(".filters__body"),
            submitBtn = document.querySelector(__ths.opts.submitBtn),
            searchInput = document.querySelector(__ths.opts.searchInput);
            
        if (!__action) {
            $button[0].setAttribute('aria-expanded', 'true');
            __ths.searchBar && __ths.searchBar.classList.add("opening-filter");
            _searchBarContainer?.classList.add('filters-active');
            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                filterBody.setAttribute("role", "list");
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    elm.removeAttribute("tabindex");
                    elm.setAttribute("role", "button");
                    elm.setAttribute("aria-expanded", "false");
                })
                setTimeout(e => {
                    document.documentElement.classList.add("opening-mobile-filter");
                    document.querySelector(__ths.opts.closeFiltersButton).focus();
                }, 1000);
            } else {
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    if(!elm.classList.contains("active")) {
                        elm.setAttribute("tabindex", -1);
                    }
                    filterBody.setAttribute("role", "tablist");
                    elm.setAttribute("role", "tab");
                    elm.removeAttribute("aria-expanded");
                })
            }
            submitBtn?.setAttribute("tabindex", -1);
            searchInput?.setAttribute("tabindex", -1);
            window.addEventListener("keydown", pressESCToClose);
        } else {
            window.removeEventListener("keydown", pressESCToClose);
            document.documentElement.classList.remove("opening-mobile-filter");
            submitBtn?.removeAttribute("tabindex");
            searchInput?.removeAttribute("tabindex");

            setTimeout(function() {
                _searchBarContainer?.classList.remove('filters-active');
                __ths.searchBar && __ths.searchBar.classList.remove("opening-filter");
                if ($button.length > 0) {
                    $button[0].setAttribute('aria-expanded', 'false');
                    $button[0].focus();
                }
            }, 200);
        }
    };

    __ths.eventHandler = function () {
        function preventEvent(e) {
            e.preventDefault();
        }
        // lazy load
        __ths.el.on('click keydown', __ths.opts.eventLoadBtn, function (e) {
            if ((!e.keyCode || ~[13, 32].indexOf(e.keyCode)) && __ths.searchState !== __ths.UNACTIVE) {
                preventEvent(e);
                __ths.eventListinglazyLoad(true);
                __ths.searchState = __ths.UNACTIVE;
            }
        });

        // clear filters
        __ths.el.on('click', __ths.opts.clearFiltersBtn, function (e) {
            preventEvent(e);
            var clearEndPoint = $(this).attr('data-endpoint');
            __ths.clearFilters(clearEndPoint);
        });

        // search submit after selecting filters (UX feature)
        __ths.el.on('click', __ths.opts.applyFilters, function (e) {
            preventEvent(e);
            __ths.searchResults();
        });

        // search submit
        __ths.el.on('submit', __ths.opts.form, function (e) {
            preventEvent(e);
            if (__ths.searchState !== __ths.UNACTIVE) {
                __ths.searchResults();
                __ths.blockFilterFields();
                __ths.searchState = __ths.UNACTIVE;
            }
        });

        // Toggle filters
        __ths.el.on('click', __ths.opts.toggleFilters, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.filtersState);
        });

        __ths.el.on('click', __ths.opts.filterHeading, function (e) {
            preventEvent(e);
            var $this = $(this);
            var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();

            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-expanded", false);
                }

                this.classList.toggle('active');
                if(this.classList.contains("active")) {
                    this.setAttribute("aria-expanded", true);
                } else {
                    this.setAttribute("aria-expanded", false);
                }
            } else if (!$this.hasClass('active')) {
                $filterHeading.removeClass('active');
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-selected", false);
                    $filterHeading[i].setAttribute("tabindex", -1);
                }
                $this.addClass('active');
                $this[0].setAttribute("aria-selected", true);
                $this[0].setAttribute("tabindex", 0);
            }
        });

        __ths.el.on('click', __ths.opts.closeFiltersButton, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.OPENED);
        });

        __ths.el.on('change', __ths.opts.filterTags, function (e) {
            preventEvent(e);
            if ($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
                e.currentTarget.setAttribute("checked", "checked");
                __ths.lastClickedCheckbox = e.currentTarget.id;
                setTimeout(function(){
                    __ths.searchResults();
                    __ths.blockFilterFields();
                    __ths.blockSearchBtn();
                }, 50)
            }
        });
        var windowWidth = $(window).width();
        $(window).on('resize', function (e) {
            if(this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                $(this).trigger('windowResize');
            }, 100); 
            
        });
        $(window).on('windowResize', function() {
            var __windowWidth = $(window).outerWidth(),
                __MOBILE = __ths.MOBILE_BREAKPOINT;
            if ((__windowWidth <= __MOBILE && __prevWindowWidth > __MOBILE) ||
                (__windowWidth > __MOBILE && __prevWindowWidth <= __MOBILE)) {
                __ths.toggleFiltersDropdown(__ths.OPENED);
                __ths.initFiltersList();
            }
            if ($(window).width() != windowWidth){
                $('.article-block__item').removeAttr("clamp");
                windowWidth = $(window).width();
            }
            __prevWindowWidth = __windowWidth;
        });
    };

    __ths.escapeQueryChars = function (url) {
        return url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            });
    };

    __ths.tryAddSort = function (url, callParams) {
        var parentUrl = new URL(window.location);
        var currentUrl = new URL(window.location.origin + url);

        var parentQuery = parentUrl.search;
        var query = currentUrl.search;
        var parentParams = new URLSearchParams(parentQuery);
        var currentParams = new URLSearchParams(query);

        var sort = "desc";
        if (currentParams.get("query"))
            sort = 'rel';

        if (parentParams.get("sort"))
            sort = parentParams.get("sort");

        if (!__ths.sParams.isFilter) // clear filter
            sort = "desc";

        currentParams.set('sort', sort);

        // change the search property of the main url
        currentUrl.search = currentParams.toString();
        // the new url string with sort
        return currentUrl.toString();
    };

    __ths.ajaxCall = function (url, callParams, successCallback, test) {
        if(__ths.searchState == __ths.UNACTIVE) return;
        var contextRef = this;
        var __url = __ths.escapeQueryChars(url);
        __url = __ths.tryAddSort(__url, callParams);
        __ths.searchState = __ths.UNACTIVE;
        document.querySelector(".event-listing-search")?.classList.add("fetching");
        if (!test) {
            timeStart('ajax');
            $.ajax({
                url: __url,
                type: "get",
                data: callParams,
                success: function (data) {
                    timeEnd('ajax');
                    let selectedTagsElm = document.querySelector(".filter-result__tags");
                    if(selectedTagsElm && data.Value) {
                        selectedTagsElm.closest(".col-md-8").innerHTML = data.Value.searchFilterSelected;
                    }
                    successCallback(contextRef, data);
                    setTimeout(e => {
                        __ths.searchState = __ths.ACTIVE;
                        document.querySelector(".event-listing-search")?.classList.remove("fetching");
                    }, 100)
                    
                    let tablist = document.querySelector(".extended-search-bar__filters [role=tablist]");
                    if(tablist)
                        TabPanelActionHandler(tablist);

                    if(callParams.CurrentPageIndex == 1)
                        setTimeout(e => {
                            __ths.scrollIntoViewSearchResults();
                        }, 1000)
                },
                error: function (xhr) {
                    console.error(xhr);
                    __ths.searchState = __ths.ACTIVE;
                    __ths.unblockSearchFields();
                }
            });
        } else {
            var data = test;
            successCallback(contextRef, data);
        }
    };

    __ths.blockFilterFields = function () {
        __ths.el.find(__ths.opts.filterTags).attr('disabled', true);
    };

    __ths.blockSearchBtn = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', true);
    };

    __ths.unblockSearchFields = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', false);
        __ths.el.find(__ths.opts.filterTags).attr('disabled', false);
    };

    __ths.eventListinglazyLoad = function (isUpcomingLazyLoad, isLoadPrevious) {
        let configKey = "configEvent",
            paramKey = "sEventParams";

        let __ths = this,
            __queryStringChar = '?',
            __endpointUrl = __ths[configKey].loadEndPoint,
            __searchResults = __ths.resultContainerElms.sEventResult,
            callParams = __ths[paramKey];

        if(__ths.searchState == __ths.UNACTIVE) return;
        
        if (__ths.queryString) {
            if (__endpointUrl.match(/\?/ig) !== null) {
                __queryStringChar = '&';
            }
            __endpointUrl = __endpointUrl + __queryStringChar + __ths.queryString;
        }

        function successCallback(contextRef, data) {
            if(__searchResults) {
                let currentContainer = __searchResults.querySelector('.events-search__results--container'),
                old_DOM_height = document.querySelector(".gt-wrapper").offsetHeight,
                old_scroll = GT.lastScrollTop;
                
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                currentContainer?.insertAdjacentHTML(isLoadPrevious ? "afterbegin" : "beforeend", data);
                if (window.bindSorting) window.bindSorting();

                
                if(!isLoadPrevious) {
                    let configKey = "configEvent";
                    __ths[configKey].totalDisplayingItems += __ths[configKey].pageSize;
                    if(__ths[configKey].totalDisplayingItems > __ths[configKey].totalItemsCount)
                        __ths[configKey].totalDisplayingItems = __ths[configKey].totalItemsCount;
                }

                
                let focusableItem;
                currentContainer?.querySelectorAll(".event-item:not([data-page])").forEach(eventItem => {
                    eventItem.dataset.page = callParams.CurrentPageIndex;
                    __ths.observerElm(eventItem);
                    if(!focusableItem) focusableItem = eventItem;
                })

                if(!isLoadPrevious) {
                    let lstFocusableElms = GT.getListFocusableElms(focusableItem);
                    if(lstFocusableElms.length)
                        lstFocusableElms[0].focus();
                } else {
                    window.scrollTo({ top: (old_scroll + document.querySelector(".gt-wrapper").offsetHeight - old_DOM_height), left:0, behavior: "instant"});
                }

                __ths.rebuildClamp();
            }
        }

        if(isLoadPrevious) {
            __ths[configKey].CurrentPreviousPageIndex--;
            callParams.CurrentPageIndex = __ths[paramKey].CurrentPageIndex = __ths[configKey].CurrentPreviousPageIndex;
        } else {
            __ths[configKey].CurrentNextPageIndex++;
            callParams.CurrentPageIndex = __ths[paramKey].CurrentPageIndex = __ths[configKey].CurrentNextPageIndex;
        }

        __ths.ajaxCall(__endpointUrl, callParams, successCallback, false);
    };

    __ths.clearFilters = function (endpoint) {
        __ths.sUpcomingEventParams.CurrentPageIndex = 1;
        __ths.sPastEventParams.CurrentPageIndex = 1;
        __ths.sParams.CurrentPageIndex = 1;
        __ths.sParams.isFilter = false;
        __ths.ajaxCall(endpoint, __ths.sParams, __ths.replaceResults, false);
        __ths.setQueryString('');
    };

    __ths.searchResults = function () {
        timeStart('search action');
        var __ths = this,
            $form = __ths.el.find(__ths.opts.form),
            __searchParams = __ths.getSearchParams($form),
            __queryStringChar = '?',
            __searchEndPoint = $form.attr('action') || '',
            __endpointUrl = '';

        __ths.sUpcomingEventParams.CurrentPageIndex = 1;
        __ths.sPastEventParams.CurrentPageIndex = 1;
        __ths.sParams.CurrentPageIndex = 1;

        if (__searchEndPoint.match(/\?/ig) !== null) {
            __queryStringChar = '&';
        }
        __endpointUrl = __searchEndPoint + __queryStringChar + __searchParams;

        __ths.ajaxCall(__endpointUrl, __ths.sParams, __ths.replaceResults, false);
    };

    __ths.scrollIntoViewSearchResults = function(){
        if(GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
            __ths.toggleFiltersDropdown(__ths.OPENED);
            document.getElementById('filter_accordion')?.scrollIntoView();
        }
    }

    __ths.replaceResults = function (contextRef, data) {
        var __tmpFilterStatus = __ths.filtersState,
            __tmpData = data.Value.searchFilterData;

        if (__tmpFilterStatus == __ths.OPENED && $(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {

            var __allfilters = __ths.el.find(__ths.opts.filterHeading),
                __activefilter = __ths.el.find(__ths.opts.filterHeading + '.active'),
                toggleFiltersClass = __ths.opts.toggleFilters.replace('.', ''),
                index = __allfilters.index(__activefilter);

            __tmpData = data.Value.searchFilterData.replace(new RegExp(__ths.opts.classes.filtersClosed), '')
                .replace(toggleFiltersClass, toggleFiltersClass + ' active');
        }
        var __searchFilterResults = contextRef.el.find(contextRef.opts.filterForm);
        __searchFilterResults.html(__tmpData);

        var __upcomingResults = contextRef.el.find(contextRef.opts.sUpcomingEventResult);
        __upcomingResults.html(data.Value.upcomingEventData);

        var __pastEventsResults = contextRef.el.find(contextRef.opts.sPastEventResult);
        __pastEventsResults.html(data.Value.partEventData);

        __ths.displayClearFiltersBtn();
        __ths.init();
        __ths.initFiltersList(index);
        __ths.rebuildClamp();
        __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
        let lastClickedCheckboxElm = document.querySelector("#" + __ths.lastClickedCheckbox);

        setTimeout(e => {
            if(lastClickedCheckboxElm)
                lastClickedCheckboxElm.focus();
            else
                document.querySelector(__ths.opts.toggleFilters)?.focus();
        }, 1000)
            

        if (window.bindSorting) window.bindSorting();
        timeEnd('search action');
    };

    __ths.qsToObj = function (queryString) {
        var qsObj = {};
        queryString.split('&').forEach(function (item) {
            var tmp = item.split('='),
                key = tmp[0],
                value = tmp[1];
            if (value) {
                qsObj[key] = qsObj[key] || [];
                qsObj[key].push(value);
            }
        });
        return /*json*/ qsObj;
    };

    __ths.qsURIbuilder = function (qsObj) {
        var qsArray = [];
        for (var key in qsObj) {
            var __tmpkey = key;
            if (__tmpkey === 'query') {
                __tmpkey = 'q';
            }
            qsArray.push(__tmpkey + '=' + qsObj[key].join(this.opts.joinChar));
        }

        return /*string*/ qsArray.join('&');
    };

    __ths.setParameterInQueryString = function(key, value, isDelete){
        var queryParams = new URLSearchParams(window.location.search);
        if(isDelete)
            queryParams.delete(key);
        else
            queryParams.set(key, value);

        let queryStr = queryParams.toString();
        history.replaceState(null, null, (queryStr.length ? "?" + queryStr : location.href.split("?")[0].split("#")[0])  + location.hash);
    }

    __ths.setQueryString = function (queryString) {
        var __qsString = this.qsURIbuilder(this.qsToObj(queryString)) || '',
            filters = '#filters';

        __ths.queryString = queryString;
        if (__qsString.length) {
            __qsString = '?' + __ths.escapeQueryChars(__qsString);
            __ths.sParams.isFilter = true;
            window.history.pushState(null, null, __qsString + filters);
        } else {
            __ths.sParams.isFilter = false;
            window.history.pushState(null, null, location.href.split("?")[0].split("#")[0] + filters);
        }
    };

    __ths.getQueryString = function () {
        __ths.queryString = __ths.el.find(__ths.opts.form).serialize();
    };

    __ths.getSearchParams = function ($form) {
        var serializedForm = $form.serialize();
        __ths.setQueryString(serializedForm);
        return serializedForm;
    };

    __ths.init = function () {
        let queryParams = new URLSearchParams(window.location.search),
            page = parseInt(queryParams.get('page')) || 1;

        __ths.sEventParams.CurrentPageIndex = page;
        __ths.configEvent = {
                CurrentPreviousPageIndex: page, 
                CurrentNextPageIndex: page, 
                pageSize: parseInt(document.querySelector(__ths.opts.pageSize)?.value) || 0, 
                totalDisplayingItems: parseInt(document.querySelector(__ths.opts.eventTotalDisplayingItems)?.value) || 0, 
                totalItemsCount: parseInt(document.querySelector(__ths.opts.totalEventResultsQty)?.value) || 0, 
                loadEndPoint: document.querySelector(__ths.opts.eventLoadMoreEndpoint)?.value || "",
                resultContainerOffsetTop: 0
            };
            __ths.resultContainerElms.sEventResult.querySelectorAll(".event-item").forEach(eventItem => {
                eventItem.dataset.page = page;
                __ths.observerElm(eventItem, true);
            })
    }

    __ths.shouldLoadMore = function (isUpcoming) {
        let configKey = "configEvent";
        let __ths = this,
            __loadBtn = document.querySelector(isUpcoming ? __ths.opts.upcomingEventLoadBtn : __ths.opts.pastEventLoadBtn),
            totalItems = __ths[configKey].totalItemsCount,
            containerElm = __ths.resultContainerElms.sEventResult,
            loadMoreContainer = containerElm.querySelector(".load-more-container");

        __ths.maxPage = Math.ceil(totalItems / __ths[configKey].pageSize);

        if (__ths.maxPage < (__ths[configKey].CurrentNextPageIndex + 1)) {
            if(loadMoreContainer)
                loadMoreContainer.classList.add("hidden");
            else if(__loadBtn) {
                __loadBtn.classList.add("hidden");
            }
        } else {
            if(loadMoreContainer)
                loadMoreContainer.classList.remove("hidden");
            else if(__loadBtn) {
                __loadBtn.classList.remove("hidden");
            }
        }

        if(loadMoreContainer) {
            let currentTotalDisplayingItems = __ths[configKey].totalDisplayingItems;
            loadMoreContainer.querySelector(".load-more-stats__showing-items").innerText = currentTotalDisplayingItems;
            loadMoreContainer.querySelector(".load-more-stats__progressbar-loaded").style.width = (currentTotalDisplayingItems / totalItems * 100) + "%";

            if(__loadBtn && __loadBtn.href) {
                //wait for setParameterInQueryString runs completely
                setTimeout(function() {
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("page", __ths[configKey].CurrentNextPageIndex + 1);
                    __loadBtn.href = "?" + queryParams.toString() + location.hash;
                })
            }
        }
    };

    
    __ths.resultContainerElms = {
        sEventResult: document.querySelector(__ths.opts.sEventResult),
    };

    __ths.currentTotalDisplayingItems = function(currentElm) {
        return currentElm.querySelectorAll(".event-item.grid-view").length;
    }

    __ths.loadPreviousHandler = () => {
        ["Event"].forEach(function(key, index){
            let configKey = "config" + key;
            let currentElm = __ths.resultContainerElms["s" + key + "Result"];
            let currentTotalDisplayingItems = __ths.currentTotalDisplayingItems(currentElm);
            if(currentTotalDisplayingItems && currentTotalDisplayingItems <= __ths[configKey].totalItemsCount) {
                __ths[configKey].resultContainerOffsetTop = 0;
                GT.listFunctionsTriggerInScrollEvent['checkScrollPosEventSearch_' + configKey] = () => {
                    let CurrentPreviousPageIndex = parseInt(__ths[configKey].CurrentPreviousPageIndex),
                        resultContainerElm = currentElm;

                    __ths[configKey].resultContainerOffsetTop = GT.getElementOffset(resultContainerElm).top;
                    if(CurrentPreviousPageIndex > 1 && GT.isScrollingUp && GT.lastScrollTop - __ths[configKey].resultContainerOffsetTop < 300 && __ths[configKey].resultContainerOffsetTop - GT.lastScrollTop < GT.wHeight / 2 && __ths.searchState == __ths.ACTIVE) {
                        __ths.eventListinglazyLoad(true);
                    }
                }
            }
        })
    }

    __ths.displayClearFiltersBtn = function () {
        var __ths = this,
            __clearFiltersBtn = __ths.el.find(__ths.opts.clearFiltersBtn);

        if (__ths.sParams.isFilter === false) {
            __clearFiltersBtn.removeClass('hidden');
            __clearFiltersBtn.addClass('hidden');
        } else {
            __clearFiltersBtn.removeClass('hidden');
        }
    };

    __ths.rebuildClamp = function () {
        __ths.shouldLoadMore();
        GT.clampArticle();
        GT.FakeHyperlink();
    };

    if (_isFilter && _isFilter != false) {
        __ths.getQueryString();
    }

    __ths.init();
    __ths.initFiltersList();
    __ths.displayClearFiltersBtn();
    
    __ths.shouldLoadMore();

    __ths.eventHandler();
    __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
    __ths.loadPreviousHandler();
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        [
            {
                elm: $('.event-listing-search'),
                settings:
                {
                    'form': 'form#events-listing-search-form',
                    'submitBtn': '.extended-search-bar__search-btn',
                    'applyFilters': '.filters__apply-close-btn',
                    'filterTags': '.filters__item',
                    'clearFiltersBtn': '.event-grid__clear-btn',
                    'sResults': '.extended-search__results',
                    'sEventResult': '.event-search__results',
                    'toggleFilters': '.extended-search-bar__filter-btn',
                    'searchInput': '.extended-search-bar__search-input',
                    'filters': '.extended-search-bar__filters',
                    'closeFiltersButton': '.filters__close-button a',
                    'filterHeading': '.filters__heading',
                    'isFilterField': '.isFilter',
                    'pageSize': '.pageSize',
                    'joinChar': '+',
                    'classes': {
                        'filtersClosed': 'filters--closed',
                        'overflowHidden': 'overflowHidden--mobile'
                    },
                    'eventTotalDisplayingItems': '#eventTotalDisplayingItems',
                    'totalEventResultsQty': '.totalEventResultsQty',
                    'eventLoadBtn': '.event-extended-search__load-btn',
                    'eventLoadMoreEndpoint': '#eventLoadMoreEndpoint',
                    'filterForm': '#events-listing-search-form'
                }
            }
        ].map(function (item) {
            if (item.elm.length) {
                new GT.EventListingSearch(item.elm, item);
            }
        })
    });
GT.ExpandContent = function() {
    document.querySelectorAll('.expand-content').forEach(content => {
        const targetContent = content.querySelector(".expand-content__area");
        const hintButton = content.querySelector('.expand-content__hint-button');
        if(!targetContent || !hintButton) return;
        hintButton.addEventListener('click', () => {
            const maxHeight = targetContent.querySelector('.expand-content__container')?.offsetHeight || 0;
            if(maxHeight > 80) {
                //200 for the delayed contents: recaptcha, etc.
                targetContent.style.setProperty('--expand-content-max-height', (maxHeight + 200) + 'px');
            }
            targetContent.classList.remove('hidden-content');
            hintButton.classList.add('hidden-content');
            //make sure the delayed contents will show up: error message, recaptcha, etc.
            setTimeout(() => {
                targetContent.classList.add('remove-overflow-hidden');
            }, 700);
        });
    });
};

GT.domContentLoadedFncList.push(function() {
    new GT.ExpandContent();
});
GT.Expert = function ($element, obj) {

    if(!$element.length)
        return;

    let formElm = $element[0].querySelector("form");

    formElm.onsubmit = function(e){
        e.preventDefault();

        let tags = [],
			link = $element[0].querySelector("form").action;

		$element[0].querySelectorAll("select").forEach(function(item){
            if(item.value)
                tags.push(item.value)
        });
        let _hasTags = false;
        if(tags.length > 0){
            _hasTags = true;
            link += "?tags=" + tags.join("+");
        }
        

		let keywordInputElm = $element[0].querySelector("input[type=text]");
        if(keywordInputElm && keywordInputElm.value.trim().length > 0) {
            if(_hasTags) {
                link += "&q=" + keywordInputElm.value.trim();
            } else {
                link += "?q=" + keywordInputElm.value.trim();
            }
        }

        location.href = link;
    }
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.Expert($('.experts-search-block'));
    });
GT.GTExpertQuickview = function (elem, GTConstruct) {
    var settings = GTConstruct && GTConstruct.settings ? GTConstruct.settings : {};
    var containerWidth = settings.containerWidth || 1170;
    var containerHeight = settings.containerHeight || 825;
    let lastFocusElement;

    openQuickviewByUrl();
    function openQuickviewByUrl() {
        var currentFragment = window.location.hash;
        var locationHashIndex = currentFragment.indexOf("#");
        if (locationHashIndex === 0) {
            currentFragment = currentFragment.substr(1);
        }
        if (currentFragment && $('[data-expert-quickview-overlay="' + currentFragment + '"]').length > 0) {
            openPopup(currentFragment);
        }
    }

    function openPopup(expertQuickviewReferenceId) {
        let expertModal = document.querySelector(".expert-modal");
        if(!expertModal) {
            document.body.insertAdjacentHTML("beforeend", '<div class="expert-modal"></div>');
            expertModal = document.querySelector(".expert-modal");
        } else {
            expertModal.innerHTML = "";
        }

        function closeDialogCallback(){
            expertModal.remove();
            resetHash();
            setTimeout(function() {
                if(lastFocusElement?.dataset.expertQuickviewOverlay == expertQuickviewReferenceId)
                    lastFocusElement?.focus();
            }, 500);
        }

        expertModal.innerHTML = document.querySelector("#template_t4_dialog_" + expertQuickviewReferenceId).innerHTML;
        expertModal.addEventListener("click", function(e) {
            if (!document.querySelector('.quickview-modal')?.contains(e.target)) {
                GT.Overlays.hideOverlay();
                closeDialogCallback();
            }
        });
        GT.setInertWhileOpeningDialog(true);

        var winWidth = $(window).innerWidth();

        if (containerWidth > winWidth) {
            containerWidth = winWidth;
        }
        var _quickviewModalContainer = $('#' + expertQuickviewReferenceId).find('.quickview-modal__contents');
        if (_quickviewModalContainer.find('.quickview-contents').length > 0) {
            GT.Overlays.runOverlay(document.getElementById(expertQuickviewReferenceId), '#' + expertQuickviewReferenceId, containerWidth, containerHeight, false, false, false,
                function () {
                    closeDialogCallback();
                });
            window.location.hash = expertQuickviewReferenceId;
        } else {
            var _url = $('[data-expert-quickview-overlay="' + expertQuickviewReferenceId + '"]').data('endpoint');
            $.ajax({
                url: _url,
                type: "get",
                success: function (data) {
                    _quickviewModalContainer.html(data);
                    if ($('[data-expert-quickview-overlay="' + expertQuickviewReferenceId + '"]').length > 0) {
                        GT.Overlays.runOverlay(document.getElementById(expertQuickviewReferenceId), '#' + expertQuickviewReferenceId, containerWidth, containerHeight, false, false, false,
                            function () {
                                closeDialogCallback();
                            });
                        window.location.hash = expertQuickviewReferenceId;
                    }
                },
                error: function (xhr) {
                    console.error(xhr);
                }
            });
        }
    }
    
    $(document).on('click', '[data-expert-quickview-overlay]', function (e) {
        e.preventDefault();
        var _this = $(this);
        var expertQuickviewReferenceId = _this.data('expert-quickview-overlay');
        lastFocusElement = this;
        openPopup(expertQuickviewReferenceId);
    });

    var resetHash = function () {
        history.replaceState({}, document.title, window.location.href.split('#')[0]);
    };
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTExpertQuickview($('[data-expert-quickview-overlay]'));
    });

if(typeof timeStart != "function") {
    function timeStart(name) {
        window['TS'] = window['TS'] || [];
        window['TS' + name] = Date.now();
        window['TStotal'] = window['TStotal'] ? window['TStotal'] + 1 : 1;
    }

    function timeEnd(name) {
        if (window['TS' + name]) {
            window['TS' + name] = Date.now() - window['TS' + name];
            window['TS'].push(name + ' took ' + window['TS' + name] + 'ms');
            delete (window['TS' + name]);
            window['TStotal']--;
            if (window['TStotal'] < 1) {
                if (~window.location.search.indexOf('debug=true')) {
                    alert(window['TS'].join('\r\n'));
                }
                window['TS'] = [];
            }
        }
    }
}

GT.ExtendedSearch = function ($element, obj) {
    let selectElm;
    var __ths = this;
    
    // extend default settings
    __ths.opts = $.extend({}, {
        'form': 'form',
        'loadBtn': '.extended-search__load-btn',
        'submitBtn': '.extended-search-bar__search-btn',
        'applyFilters': '.filters__apply-close-btn',
        'filterTags': '.filters__item',
        'clearFiltersBtn': '.article-grid__clear-btn',
        'sResults': '.insight-search__results--grid',
        'sResultsLastItem': '.extended-search__results .article-tile:last',
        'toggleFilters': '.extended-search-bar__filter-btn',
        'searchInput': '.extended-search-bar__search-input',
        'filters': '.extended-search-bar__filters',
        'closeFiltersButton': '.filters__close-button a',
        'filterHeading': '.filters__heading',
        'filterSubHeading': '.filters__subheading',
        'isFilterField': '.isFilter',
        'totalResultsQty': '.totalResultsQty',
        'pageSize': '.pageSize',
        'joinChar': '+',
        'classes': {
            'filtersClosed': 'filters--closed',
            'overflowHidden': 'overflowHidden--mobile'
        }
    }, obj.settings);

    __ths.CLOSED = 0; __ths.OPENED = 1;
    __ths.UNACTIVE = 0; __ths.ACTIVE = 1;
    __ths.MOBILE_BREAKPOINT = 767;
    __ths.TABLET_BREAKPOINT = 1023;

    __prevWindowWidth = $(window).outerWidth();

    __ths.filtersState = __ths.CLOSED;
    __ths.activeState = __ths.ACTIVE;
    __ths.loadMoreState = __ths.ACTIVE;
    __ths.searchState = __ths.ACTIVE;

    __ths.el = $element;

    __ths.loadEndPoint = '';

    __ths.queryString = '';

    var _isFilter = false;
    var _isFilterHidden = __ths.el.find(__ths.opts.isFilterField);
    if (_isFilterHidden.length) {
        _isFilter = _isFilterHidden.val();
    }
    
    __ths.tombstoneContainerElm = document.querySelector(".tombstone-listing-page");
    __ths.t53NewPressContainerElm = document.querySelector(".press-landing-page-v2");
    __ths.sParams = [];

    Array.prototype.slice.call(document.querySelectorAll("input[name=CurrentPageIndex]")).forEach(function(currentPageIndex, index){
        __ths.sParams.push({CurrentPageIndex: currentPageIndex.value, isFilter: _isFilter, blockindex: index});
        __ths.el[index].dataset.blockindex = index;
    })
    
    if(!__ths.sParams.length) {
        __ths.sParams.push({CurrentPageIndex: 0, isFilter:_isFilter, blockindex: 0});
        if(__ths.el.length)
            __ths.el[0].dataset.blockindex = 0;
    }

    __ths.fireAutocomplete = function (input) {
        function orphanCharAsWord(word) {
            return word.length > 1 ? word : ' ' + word + ' ';
        }
        
        if(!input.length)
            return;

        // var __ths = this,
        //     $form = __ths.el.find(__ths.opts.form),
        //     allowUseSerialize = document.querySelector(".profile-listing-page");

        try {
            if(window.currentAutoComplete)
                window.currentAutoComplete.destroy();
            const inputId = input[0]?.id;
            if (inputId)
                window.currentAutoComplete = new autoComplete({
                    selector: `#${inputId}`,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&')
                        
                        $.ajax({
                            url: __ths.escapeQueryChars(input.data('endpoint')),
                            type: "get",
                            // data:  allowUseSerialize ? $form.serialize() : { query: term },
                            data:  { query: term },
                            success: function (data) {
                                suggest(data);
                                if(!data || data.length <= 0) {
                                    let _autoCompleteItems = document.querySelectorAll('.autocomplete-suggestion');
                                    
                                    [].forEach.call(_autoCompleteItems, function(_autoCompleteItem){
                                        if(_autoCompleteItem) _autoCompleteItem.remove();
                                    });
                                }
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.Text.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-link="' + item.Value + '" data-val="' + decodedText + '" >' + decodedText.replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        window.location.href = $(item).data('link');
                    }
                });
        } catch (ex) {
            console.warn(ex);
        };
    };

    __ths.initFiltersList = function (eqactive) {
        __ths.searchBar = document.querySelector(".extended-search-bar");
        var index = 0;
        if (typeof eqactive !== 'undefined' && eqactive > -1) {
            index = eqactive;
        }
        var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

        selectElm = document.querySelector("#select_sorting");
        $filterHeading.removeClass('active');

        if (GT.wWidth > __ths.MOBILE_BREAKPOINT) {
            $filterHeading.eq(index).attr("aria-selected", true);
            $filterHeading.eq(index).addClass('active');
            $filterHeading.eq(index).attr("tabindex", 0);

            if(document.querySelector(__ths.opts.toggleFilters + ".active")) {
                let submitBtn = document.querySelector(__ths.opts.submitBtn),
                    searchInput = document.querySelector(__ths.opts.searchInput);

                submitBtn?.setAttribute("tabindex", -1);
                searchInput?.setAttribute("tabindex", -1);
            }
        }
        if(document.querySelector(".extended-search-with-sticky")) {
            __ths.searchBar.querySelector(".extended-search-bar__title").addEventListener("click", function(){
                
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                
                if(__ths.searchBar.classList.contains("active")) {
                    __ths.searchBar.classList.remove("active");
                    this.setAttribute("aria-expanded", "false");
                } else {
                    __ths.searchBar.classList.add("active");
                    this.setAttribute("aria-expanded", "true");
                }

                if (GT.wWidth > __ths.MOBILE_BREAKPOINT) {
                    if(__ths.searchBar.classList.contains("active")) {
                        __ths.toggleFiltersDropdown(__ths.CLOSED);
                        setTimeout(function(){
                            if(__ths.searchBar.getBoundingClientRect().y < 80) {
                                window.scrollTo(0, window.scrollY + __ths.searchBar.getBoundingClientRect().y - 80);
                            }
                        }, 300)
                    } else 
                        __ths.toggleFiltersDropdown(__ths.OPENED);
                }
            })

            let searchBarPos = 0,
                cacheSearchBarPos = false;
            GT.listFunctionsTriggerInScrollEvent.extendedSearchSticky = function(e){
                setTimeout(function() {
                    if(!cacheSearchBarPos)
                        searchBarPos = __ths.searchBar.firstElementChild.offsetTop + __ths.searchBar.firstElementChild.offsetHeight;
                    if(window.scrollY >= searchBarPos) {
                        cacheSearchBarPos = true;
                        __ths.searchBar.classList.add("sticky");
                        setTimeout(function(){
                            __ths.searchBar.classList.add("animate");
                        })
                    } else {
                        __ths.searchBar.classList.remove("animate");
                        __ths.searchBar.classList.remove("sticky");
                        cacheSearchBarPos = false;
                    }
                }, 0);
            }
        }

        let clearAllTagsBtn = document.querySelector(".filter-result__clear");
        if(clearAllTagsBtn) {
            let selectedTags = Array.prototype.slice.call(document.querySelectorAll(".filter-result__tag-item"));
            if(selectedTags.length)
                selectedTags.forEach(function(tagElm){
                    tagElm.onclick = function(e){
                        let eTarget = e.currentTarget;
                        if(eTarget.dataset.id == "gt-keywords") {
                            document.querySelector(__ths.opts.searchInput).value = "";
                            document.querySelector(__ths.opts.submitBtn).click();
                        } else if(tagElm.dataset.id.indexOf("_people") >= 0) {
                            document.querySelector("#"+tagElm.dataset.id).remove();
                            document.querySelector(__ths.opts.submitBtn).click();
                        } else if(eTarget.dataset.isParent == "true") {
                            document.querySelector("#tab"+eTarget.dataset.id).click();
                            // document.querySelector(__ths.opts.filterSubHeading + ".active").click();
                        }
                        else
                            document.querySelector("#"+eTarget.dataset.id).click();

                        if(selectedTags.length == 1)
                            clearAllTagsBtn.remove();
                        eTarget.remove();
                        if(GT.wWidth < 768) {
                            document.querySelector(__ths.opts.submitBtn).click();
                        }
                    }
                })
            clearAllTagsBtn.onclick = function(){
                if(selectedTags.length)
                    selectedTags.forEach(function(tagElm){
                        let targetElm = document.querySelector("#"+tagElm.dataset.id);
                        if(targetElm) {
                            if(tagElm.dataset.id.indexOf("_people") >= 0)
                                targetElm.remove();
                            else if(tagElm.dataset.id != "gt-keywords")
                                targetElm.checked = false;
                        }
                        tagElm.remove();
                    })
                __ths.el.find('input[name="parenttag"]').val("");
                document.querySelector(__ths.opts.searchInput).value = "";
                document.querySelector(__ths.opts.submitBtn).click();
                clearAllTagsBtn.remove();
            }
        }
    };
    
    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(__ths.opts.toggleFilters + ".active");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }

    __ths.toggleFiltersDropdown = function (currentStatus) {
        var addClassMethod = 'addClass';
        var removeClassMethod = 'removeClass';
        var __action = currentStatus == __ths.OPENED

        var filtersMethod = __action ? addClassMethod : removeClassMethod;
        var overflowMethod = __action ? removeClassMethod : addClassMethod;
        var toggleButtonMethod = __action ? removeClassMethod : addClassMethod;
        __ths.filtersState = __action ? __ths.CLOSED : __ths.OPENED;

        var $button = __ths.el.find(__ths.opts.toggleFilters);
        var $filters = __ths.el.find(__ths.opts.filters);
        var __cls = __ths.opts.classes;
        $button[toggleButtonMethod]('active');
        $filters[filtersMethod](__cls.filtersClosed);
        $('html')[overflowMethod](__cls.overflowHidden);

        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
        let _searchBarContainer = document.querySelector(".extended-search");
        let filterBody = document.querySelector(".filters__body"),
            submitBtn = document.querySelector(__ths.opts.submitBtn),
            searchInput = document.querySelector(__ths.opts.searchInput);
            
        if (!__action) {
            $button[0].setAttribute('aria-expanded', 'true');
            __ths.searchBar && __ths.searchBar.classList.add("opening-filter");
            _searchBarContainer?.classList.add('filters-active');
            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                filterBody.setAttribute("role", "list");
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    elm.removeAttribute("tabindex");
                    elm.setAttribute("role", "button");
                    elm.setAttribute("aria-expanded", "false");
                })
                setTimeout(e => {
                    document.documentElement.classList.add("opening-mobile-filter");
                    document.querySelector(__ths.opts.closeFiltersButton).focus();
                }, 1000);
            } else {
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    if(!elm.classList.contains("active")) {
                        elm.setAttribute("tabindex", -1);
                    }
                    filterBody.setAttribute("role", "tablist");
                    elm.setAttribute("role", "tab");
                    elm.removeAttribute("aria-expanded");
                })
            }
            submitBtn?.setAttribute("tabindex", -1);
            searchInput?.setAttribute("tabindex", -1);
            window.addEventListener("keydown", pressESCToClose);
        } else {
            window.removeEventListener("keydown", pressESCToClose);
            document.documentElement.classList.remove("opening-mobile-filter");
            submitBtn?.removeAttribute("tabindex");
            searchInput?.removeAttribute("tabindex");
            // document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
            //     elm.classList.remove("active");
            // })

            setTimeout(function() {
                _searchBarContainer?.classList.remove('filters-active');
                __ths.searchBar && __ths.searchBar.classList.remove("opening-filter");
                if ($button.length > 0) {
                    $button[0].setAttribute('aria-expanded', 'false');
                    $button[0].focus();
                }
            }, 200);
        }
    };

    function articleTileBlur(e) {
        $(this).removeClass('no-focus');
        $(this).off();
    }

    __ths.eventHandler = function () {
        function preventEvent(e) {
            e.preventDefault();
        }
        // lazy load
        __ths.el.on('click keydown', __ths.opts.loadBtn, function (e) {
            let index = e.currentTarget.closest(".extended-search").dataset.blockindex;
            if ((!e.keyCode || ~[13, 32].indexOf(e.keyCode)) && __ths.sParams[index].loadMoreState !== __ths.UNACTIVE) {
                preventEvent(e);
                __ths.loadEndPoint = $(this).attr('data-endpoint') || '';
                if (e.keyCode) {
                    __ths.el.find(__ths.opts.sResultsLastItem)
                        .focus().addClass('no-focus')
                        .on('blur', articleTileBlur);
                } else {
                    this.blur();
                }
                __ths.lazyLoad(index);
                __ths.sParams[index].loadMoreState = __ths.UNACTIVE;
            }
        });

        // clear filters
        // __ths.el.on('click', __ths.opts.clearFiltersBtn, function (e) {
        //     preventEvent(e);
        //     var clearEndPoint = $(this).attr('data-endpoint');
        //     __ths.clearFilters(clearEndPoint);
        // });

        // search submit after selecting filters (UX feature)
        __ths.el.on('click', __ths.opts.applyFilters, function (e) {
            preventEvent(e);
            __ths.searchResults(e);
        });

        // search submit
        __ths.el.on('submit', __ths.opts.form, function (e) {
            preventEvent(e);
            if (__ths.searchState !== __ths.UNACTIVE) {
                __ths.searchResults(e);
                __ths.blockFilterFields();
                __ths.searchState = __ths.UNACTIVE;
            }
        });

        // Toggle filters
        __ths.el.on('click', __ths.opts.toggleFilters, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.filtersState);
        });

        __ths.el.on('click', __ths.opts.filterHeading, function (e) {
            preventEvent(e);
            var $this = $(this);
            var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();

            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-expanded", false);
                }

                this.classList.toggle('active');
                if(this.classList.contains("active")) {
                    this.setAttribute("aria-expanded", true);
                } else {
                    this.setAttribute("aria-expanded", false);
                }
            } else if (!$this.hasClass('active')) {
                $filterHeading.removeClass('active');
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-selected", false);
                    $filterHeading[i].setAttribute("tabindex", -1);
                }
                $this.addClass('active');
                $this[0].setAttribute("aria-selected", true);
                $this[0].setAttribute("tabindex", 0);
            }
        });
        

        __ths.el.on('click', __ths.opts.filterSubHeading, function (e) {
            preventEvent(e);
            var $this = $(this);
            var $filterSubHeading = __ths.el.find(__ths.opts.filterSubHeading),
                parentTagInputElm = document.querySelector('input[name="parenttag"]');


            const newValue = $this.data("value");
            let currentStateIsActive = $this.hasClass('active'),
                tombstoneCheckboxElms = document.querySelectorAll(".filters__heading.active + .has-child-panel input");

            tombstoneCheckboxElms.forEach(function(elm){
                elm.checked = false;
            })
            
            $filterSubHeading.removeClass('active');
            for (var i = 0; i < $filterSubHeading.length; i++) {
                $filterSubHeading[i].setAttribute("aria-pressed", false);
                // $filterSubHeading[i].setAttribute("tabindex", -1);
            }
            
            if(!currentStateIsActive) {
                $this.addClass('active');
                $this[0].setAttribute("aria-pressed", true);
                // $this[0].setAttribute("tabindex", 0);
            }

            if(__ths.t53NewPressContainerElm) {
                let currentParentTagVal = parentTagInputElm.value,
                    currentParentTagVals = currentParentTagVal.split(" "),
                    newValueElm = $this[0];
                    parentTabOfNewVal = newValueElm.closest(".second-level").previousElementSibling;

                if(!currentStateIsActive) {
                    if(currentParentTagVal && currentParentTagVals.length)
                        currentParentTagVals.forEach(function(item, idx){
                            let currentItemElm = document.querySelector('[data-value="'+ item +'"]');
                            if(currentItemElm) {
                                if(currentItemElm.closest(".second-level").previousElementSibling != parentTabOfNewVal)
                                    currentParentTagVals.push(newValue);
                                else if(currentItemElm.closest(".second-level").previousElementSibling == parentTabOfNewVal) {
                                    currentParentTagVals[idx] = newValue;
                                }
                            }
                        })
                    else
                        currentParentTagVals.push(newValue);
                } else {
                    let tmpArr = [];
                    currentParentTagVals.forEach(function(item){
                        if(item != newValue)
                            tmpArr.push(item);
                    })
                    currentParentTagVals = tmpArr;
                }

                let tmpArrPreventDuplicate = [];
                currentParentTagVals.forEach(function(item){
                    if(tmpArrPreventDuplicate.indexOf(item) == -1 && item)
                        tmpArrPreventDuplicate.push(item);
                })
                currentParentTagVals = tmpArrPreventDuplicate;

                parentTagInputElm.value = currentParentTagVals.join(" ");
            } else {
                if(!currentStateIsActive) {
                    parentTagInputElm.value = newValue;
                } else
                    parentTagInputElm.value = "";
            }
            
            if($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
                __ths.searchResults(e, "#" + e.currentTarget.id);
                __ths.blockFilterFields();
                __ths.blockSearchBtn();
            }
        });

        __ths.el.on('click', __ths.opts.closeFiltersButton, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.OPENED);
        });

        __ths.el.on('change', __ths.opts.filterTags, function (e) {
            preventEvent(e);
            if ($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
                // e.currentTarget.setAttribute("checked", "checked");
                // setTimeout(function(){
                    __ths.searchResults(e, "#" + e.currentTarget.id);
                    __ths.blockFilterFields();
                    __ths.blockSearchBtn();
                // }, 50)
            }
        });
        var windowWidth = $(window).width();
        $(window).on('resize', function (e) {
            if(this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                $(this).trigger('windowResize');
            }, 100); 
            
        });
        $(window).on('windowResize', function() {
            var __windowWidth = $(window).outerWidth(),
                __MOBILE = __ths.MOBILE_BREAKPOINT;
            if ((__windowWidth <= __MOBILE && __prevWindowWidth > __MOBILE) ||
                (__windowWidth > __MOBILE && __prevWindowWidth <= __MOBILE)) {
                __ths.toggleFiltersDropdown(__ths.OPENED);
                __ths.initFiltersList();
            }
            if ($(window).width() != windowWidth){
                $('.article-block__item').removeAttr("clamp");
                windowWidth = $(window).width();
            }
            __prevWindowWidth = __windowWidth;
        });
    };

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };

    __ths.tryAddSort = function (url, callParams) {
        var parentUrl = new URL(window.location);
        var currentUrl = new URL(window.location.origin + url);

        var parentQuery = parentUrl.search;
        var query = currentUrl.search;
        var parentParams = new URLSearchParams(parentQuery);
        var currentParams = new URLSearchParams(query);

        var sort = "desc";
        if (currentParams.get("query"))
            sort = 'rel';

        if (parentParams.get("sort"))
            sort = parentParams.get("sort");

        if (!__ths.sParams[callParams.blockindex].isFilter) // clear filter
            sort = "desc";

        if(!currentParams.get("sort"))
            currentParams.set('sort', sort);

        // change the search property of the main url
        currentUrl.search = currentParams.toString();
        // the new url string with sort
        return currentUrl.toString();
    };

    __ths.ajaxCall = function (url, callParams, successCallback, test) {
        var contextRef = this;
        var __url = __ths.escapeQueryChars(url);
        __url = __ths.tryAddSort(__url, callParams);
        //var _isInsightLandingPage = contextRef.el.hasClass('insight-landing__extended--search');
        //var spinner = document.getElementById('clear-filter__overlay');
        if (!test) {
            timeStart('ajax');
            let selectedTagsElm = document.querySelector(".filter-result__tags");
            if(selectedTagsElm) {
                selectedTagsElm.classList.add("fetching");
            }
            __ths.searchBar && __ths.searchBar.classList.add("fetching");
            $.ajax({
                url: __url,
                type: "get",
                data: callParams,
                success: function (data) {                    
                    timeEnd('ajax');
                    successCallback(contextRef, data, callParams);
                    __ths.searchState = __ths.ACTIVE;
                    if ($('.topic-block').length) {
                        var topicBlock = document.querySelector(".topic-block");
                        var topicGlide = topicBlock.querySelector(".glide");
                        GT.Glide(topicGlide);
                        setTimeout(function () {
                            topicGlide.classList.remove("loading");
                            topicGlide.querySelector(".glide__track").style.height = "initial";
                        }, 1000);
                    }
                        
                    let tablist = document.querySelector(".extended-search-bar__filters [role=tablist]");
                    if(tablist)
                        TabPanelActionHandler(tablist);
                    if(selectedTagsElm) {
                        selectedTagsElm.classList.remove("fetching");
                    }
                    
                    if(selectElm) {
                        __ths.setParameterInQueryString("sort", selectElm.value);
                    }
                    __ths.searchBar && __ths.searchBar.classList.remove("fetching");
                    
                    if(callParams.CurrentPageIndex == 0)
                        setTimeout(e => {
                            __ths.scrollIntoViewSearchResults();
                        }, 1000)
                },
                error: function (xhr) {
                    console.error(xhr);
                    __ths.searchState = __ths.ACTIVE;
                    __ths.unblockSearchFields();
                }
            });
        } else {
            var data = test;
            successCallback(contextRef, data, callParams);
        }
    };

    __ths.blockFilterFields = function () {
        __ths.el.find(__ths.opts.filterTags).attr('disabled', true);
    };

    __ths.blockSearchBtn = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', true);
    };

    __ths.unblockSearchFields = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', false);
        __ths.el.find(__ths.opts.filterTags).attr('disabled', false);
    };

    __ths.lazyLoad = function (index) {
        var __ths = this,
            __queryStringChar = '?',
            __endpointUrl = __ths.loadEndPoint;

        __ths.sParams[index].CurrentPageIndex++;
        if (__ths.queryString) {
            if (__ths.loadEndPoint.match(/\?/ig) !== null) {
                __queryStringChar = '&';
            }
            __endpointUrl = __ths.loadEndPoint + __queryStringChar + __ths.queryString;
        }

        __ths.ajaxCall(__endpointUrl, __ths.sParams[index], __ths.appendResults, false);
    };

    __ths.searchResults = function (e, targetElm) {
        timeStart('search action');
        var __ths = this,
            $form = __ths.el.find(__ths.opts.form),
            __searchParams = __ths.getSearchParams($form),
            __queryStringChar = '?',
            __searchEndPoint = $form.attr('action') || '',
            __endpointUrl = '';

        let currentIndex = e.delegateTarget.dataset.blockindex;

        __ths.sParams[currentIndex].CurrentPageIndex = 0;
        __ths.sParams[currentIndex].isFilter = true;

        function successCallback(contextRef, data){
            __ths.replaceResults(contextRef, data);
            setTimeout(e => {
                if(targetElm) {
                    document.querySelector(targetElm).focus();
                } else
                    __ths.el.find(__ths.opts.toggleFilters).focus();
            }, 1000)
        }

        if (__searchEndPoint.match(/\?/ig) !== null) {
            __queryStringChar = '&';
        }
        __endpointUrl = __searchEndPoint + __queryStringChar + __searchParams;

        __ths.ajaxCall(__endpointUrl, __ths.sParams[currentIndex], successCallback, false);

    };

    __ths.scrollIntoViewSearchResults = function(){
        if(GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
            __ths.toggleFiltersDropdown(__ths.OPENED);
            document.getElementById('filter_accordion')?.scrollIntoView();
        }
    }


    __ths.appendResults = function (contextRef, data, callParams) {
        if(!contextRef.el.length)
            return;

        let __contextElm = contextRef.el[callParams.blockindex ? callParams.blockindex : 0],
            __searchResults = __contextElm.querySelector(contextRef.opts.sResults),
            __searchResultsGrid = __searchResults.querySelector('.insight-search__results--grid');

        if (__searchResultsGrid) {
            __searchResults = __searchResultsGrid;
        }

        let glideItemHasLoadMoreFnc = __contextElm.querySelector(".glide.loading");
        if(glideItemHasLoadMoreFnc) {
            GT.destroyGlide(glideItemHasLoadMoreFnc);
            __searchResults = glideItemHasLoadMoreFnc.querySelector(contextRef.opts.sResults);
        }

        let lastItem = __searchResults.lastElementChild;
        // Using timeout for tombstone listing page when load more(broken layout if not)
        if(__ths.tombstoneContainerElm) {
            setTimeout(function() {
                __searchResults.insertAdjacentHTML("beforeend", data);        
            });
        } else {
            __searchResults.insertAdjacentHTML("beforeend", data);
        }

        contextRef.shouldLoadMore();
        contextRef.rebuildClamp();
        if (window.bindSorting) window.bindSorting();
        

        if(glideItemHasLoadMoreFnc) {
            GT.Glide(glideItemHasLoadMoreFnc);
            glideItemHasLoadMoreFnc.classList.remove("loading");
            glideItemHasLoadMoreFnc.querySelector(".glide__track").style.height = "initial";
        }

        if(__ths.tombstoneContainerElm || document.querySelector(".related-tombstone__sliders")) {
            setTimeout(function() {
                GT.TombstoneTransaction(true);
                GT.clampText("tombstone-transaction");
            });
        }
        GT.FakeHyperlink();

        if(lastItem && !glideItemHasLoadMoreFnc) {
            let nextToLastItem = lastItem.nextElementSibling;
            if(nextToLastItem) {
                let lstFocusableElms = GT.getListFocusableElms(nextToLastItem);
                if(lstFocusableElms.length)
                    lstFocusableElms[0].focus();
            }
        }
    };


    __ths.replaceResults = function (contextRef, data) {
        var __tmpFilterStatus = __ths.filtersState,
            __tmpData = data;

        if (__tmpFilterStatus == __ths.OPENED && $(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {

            var __allfilters = __ths.el.find(__ths.opts.filterHeading),
                __activefilter = __ths.el.find(__ths.opts.filterHeading + '.active'),
                toggleFiltersClass = __ths.opts.toggleFilters.replace('.', ''),
                index = __allfilters.index(__activefilter);

            __tmpData = data.replace(new RegExp(__ths.opts.classes.filtersClosed), '')
                .replace(toggleFiltersClass, toggleFiltersClass + ' active');
        }
        __ths.el.html(__tmpData);
        __ths.shouldLoadMore();
        __ths.rebuildClamp();
        __ths.initFiltersList(index);
        __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
        GT.FakeHyperlink();
        let filterByBtn = __ths.el.find(__ths.opts.toggleFilters);
        if(filterByBtn.hasClass("active"))
            filterByBtn.attr("aria-expanded", true);

        if (typeof GT !== "undefined" && GT.FormSelect) {
            GT.FormSelect($('.insight-search-sorting .form-select'));
        }

        if(document.querySelector(".change-view"))
            new GT.View($('.change-view'));

        if (window.bindSorting) window.bindSorting();
        if(__ths.tombstoneContainerElm) {
            GT.TombstoneTransaction();
            GT.clampText("tombstone-transaction");
        }
        attackEvtforSort();
        if(GT.wWidth <= __ths.MOBILE_BREAKPOINT)
            window.scrollTo(0,0);
        timeEnd('search action');
    };

    __ths.qsToObj = function (queryString) {
        var qsObj = {};
        queryString.split('&').forEach(function (item) {
            var tmp = item.split('='),
                key = tmp[0],
                value = tmp[1];
            if (value) {
                qsObj[key] = qsObj[key] || [];
                qsObj[key].push(value);
            }
        });

        return /*json*/ qsObj;
    };

    __ths.qsURIbuilder = function (qsObj) {
        var qsArray = [];
        for (var key in qsObj) {
            var __tmpkey = key;
            if (__tmpkey === 'query') {
                __tmpkey = 'q';
            }
            qsArray.push(__tmpkey + '=' + qsObj[key].join(this.opts.joinChar));
        }
        return /*string*/ qsArray.join('&');
    };

    __ths.setQueryString = function (queryString) {
        var __qsString = this.qsURIbuilder(this.qsToObj(queryString)) || '',
            filters = '#filters';

        __ths.queryString = queryString;
        if (__qsString.length) {
            __qsString = '?' + __ths.escapeQueryChars(__qsString);
            window.history.pushState(null, null, __qsString + filters);
        } else {
            window.history.pushState(null, null, location.href.split("?")[0].split("#")[0] + filters);
        }
    };

    __ths.setParameterInQueryString = function(key, value){
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set(key, value);
        history.replaceState(null, null, "?" + queryParams.toString() + location.hash);
    }

    __ths.getQueryString = function () {
        __ths.queryString = __ths.el.find(__ths.opts.form).serialize();
    };

    __ths.getSearchParams = function ($form) {
        var serializedForm = $form.serialize();
        __ths.setQueryString(serializedForm);
        return serializedForm;
    };

    __ths.shouldLoadMore = function () {
        var __ths = this;

        Array.prototype.slice.call(document.querySelectorAll("input[name=CurrentPageIndex]")).forEach(function(currentPageIndexElm, index){
            let currentElm = __ths.el[index],
                __loadBtn = currentElm.querySelector(__ths.opts.loadBtn);

            if(!__loadBtn) 
                return;

            let totalItems = currentElm.querySelector(__ths.opts.totalResultsQty).value,
                maxPage = Math.ceil(totalItems / currentElm.querySelector(__ths.opts.pageSize).value),
                loadMoreContainer = currentElm.querySelector(".load-more-container"),
                currentPageIndex = parseInt(__ths.sParams[index].CurrentPageIndex);

            if (maxPage <= (currentPageIndex + 1)) {
                if(loadMoreContainer)
                    loadMoreContainer.classList.add("hidden");
                else
                    __loadBtn.classList.add('hidden');

                __ths.sParams[index].loadMoreState = __ths.UNACTIVE;
            } else {
                if(loadMoreContainer)
                    loadMoreContainer.classList.remove("hidden");
                else
                    __loadBtn.classList.remove('hidden');

                __ths.sParams[index].loadMoreState = __ths.ACTIVE;
            }

            if(loadMoreContainer) {
                let currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " > div:not(.expert-facts__container)").length;
                if(document.querySelector(".insight-landing__extended--search"))
                    currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " .insight-search__results--grid > div:not(.expert-facts__container)").length;
                if(__ths.tombstoneContainerElm)
                    currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " .transaction-list__item").length;
                
                let _loadmoreShowItems = currentElm.querySelector(".load-more-stats__showing-items");
                let _loadMoreProgressbar = currentElm.querySelector(".load-more-stats__progressbar-loaded");
                if(_loadmoreShowItems) _loadmoreShowItems.innerText = currentTotalDisplayingItems;
                if(_loadMoreProgressbar) _loadMoreProgressbar.style.width = (currentTotalDisplayingItems / totalItems * 100) + "%";
            }
            
            if(!isNaN(currentPageIndex) && document.querySelector(".profile-listing-page, .t37-page, .insight-landing__extended--search, .insight-search-page, .tombstone-listing-page, .press-landing-page-v2, .icb-listing-page")) {
                if(currentPageIndex > 0) {
                    __ths.setParameterInQueryString("page", currentPageIndex);
                }
                
                let canonicalElm = document.querySelector('link[rel="canonical"]');
                if(canonicalElm)
                    canonicalElm.href = location.origin + location.pathname  + (currentPageIndex > 0 ? "?page=" + currentPageIndex : ""); 
                    
                if(__loadBtn.href) {
                    //wait for setParameterInQueryString runs completely
                    setTimeout(function() {
                        var queryParams = new URLSearchParams(window.location.search);
                        queryParams.set("page", currentPageIndex + 1);
                        __loadBtn.href = "?" + queryParams.toString() + location.hash;
                    })
                }
            }
            
        })
    };

    __ths.rebuildClamp = function () {
        GT.clampArticle();
    };

    if (_isFilter && _isFilter.toLowerCase() != 'false') {
        __ths.getQueryString();
    }

    function changeSort() {
        let slSort = document.getElementById("select_sorting"),
            url = new URL(window.location),
            query_string = url.search,
            search_params = new URLSearchParams(query_string);

        search_params.set('sort', slSort.options[slSort.selectedIndex].value);
        // change the search property of the main url
        url.search = search_params.toString();
        // the new url string
        window.location = url.toString();
    }

    function attackEvtforSort() {
        let select = document.querySelector('#select_sorting');
        if(select && !select.dataset.attackedEvt) {
            select.dataset.attackedEvt = true;
            select.addEventListener('change', changeSort);
        }
    }

    __ths.shouldLoadMore();
    __ths.eventHandler();
    __ths.initFiltersList();
    __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
    attackEvtforSort();
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.ExtendedSearch($('.extended-search'), {settings: {
                'form': 'form',
                'submitBtn': '.extended-search-bar__search-btn',
                'loadBtn': '.extended-search__load-btn',
                'applyFilters': '.filters__apply-close-btn',
                'filterTags': '.filters__item',
                'clearFiltersBtn': '.article-grid__clear-btn',
                'sResults': '.extended-search__results',
                'toggleFilters': '.extended-search-bar__filter-btn',
                'searchInput': '.extended-search-bar__search-input',
                'filters': '.extended-search-bar__filters',
                'filterSubHeading': '.filters__subheading',
                'closeFiltersButton': '.filters__close-button a',
                'filterHeading': '.filters__heading',
                'isFilterField': '.isFilter',
                'totalResultsQty': '.totalResultsQty',
                'pageSize': '.pageSize',
                'joinChar': '+',
                'classes': {
                    'filtersClosed': 'filters--closed',
                    'overflowHidden': 'overflowHidden--mobile'
                }
        }});
        
        if(document.querySelector(".extended-search-with-sticky")) {
            document.querySelector(".gt-wrapper").style.overflow = "initial";
        }
    });
if(typeof timeStart != "function") {
    function timeStart(name) {
        window['TS'] = window['TS'] || [];
        window['TS' + name] = Date.now();
        window['TStotal'] = window['TStotal'] ? window['TStotal'] + 1 : 1;
    }

    function timeEnd(name) {
        if (window['TS' + name]) {
            window['TS' + name] = Date.now() - window['TS' + name];
            window['TS'].push(name + ' took ' + window['TS' + name] + 'ms');
            delete (window['TS' + name]);
            window['TStotal']--;
            if (window['TStotal'] < 1) {
                if (~window.location.search.indexOf('debug=true')) {
                    alert(window['TS'].join('\r\n'));
                }
                window['TS'] = [];
            }
        }
    }
}

GT.ExtendedSearchV2 = function ($element, obj) {
    let selectElm;
    let __ths = {};//should not use __ths = this; because of global scope, impact to the other blocks
    
    // extend default settings
    __ths.opts = $.extend({}, {
        'form': 'form',
        'loadBtn': '.extended-search__load-btn',
        'submitBtn': '.extended-search-bar__search-btn',
        'applyFilters': '.filters__apply-close-btn',
        'filterTags': '.filters__item',
        'clearFiltersBtn': '.article-grid__clear-btn',
        'sResults': '.insight-search__results--grid',
        'sResultsLastItem': '.extended-search__results .article-tile:last',
        'toggleFilters': '.extended-search-bar__filter-btn',
        'searchInput': '.extended-search-bar__search-input',
        'filters': '.extended-search-bar__filters',
        'closeFiltersButton': '.filters__close-button a',
        'filterHeading': '.filters__heading',
        'filterSubHeading': '.filters__subheading',
        'isFilterField': '.isFilter',
        'pageSize': '.pageSize',
        'joinChar': '+',
        'classes': {
            'filtersClosed': 'filters--closed',
            'overflowHidden': 'overflowHidden--mobile'
        }
    }, obj.settings);

    __ths.CLOSED = 0; __ths.OPENED = 1;
    __ths.UNACTIVE = 0; __ths.ACTIVE = 1;
    __ths.MOBILE_BREAKPOINT = 767;
    __ths.TABLET_BREAKPOINT = 1023;

    __prevWindowWidth = $(window).outerWidth();

    __ths.filtersState = __ths.CLOSED;
    __ths.activeState = __ths.ACTIVE;
    __ths.loadMoreState = __ths.ACTIVE;
    __ths.searchState = __ths.ACTIVE;

    __ths.el = $element;

    let _isFilter = false;
    let _isFilterHidden = __ths.el.find(__ths.opts.isFilterField);
    if (_isFilterHidden.length) {
        _isFilter = _isFilterHidden.val();
    }
    
    __ths.resultContainerElms = document.querySelectorAll(__ths.opts.sResults);
    __ths.tombstoneContainerElm = document.querySelector(".tombstone-listing-page");
    __ths.t53NewPressContainerElm = document.querySelector(".press-landing-page-v2");
    __ths.listingAreas = document.querySelectorAll(".loadmore-config");
    __ths.sParams = [];
    __ths.config = [];


    __ths.observerElm = (elm) => {
        if(!elm.dataset.observed) {
            elm.dataset.observed = true;
            GT.checkElmVisible(elm, {
                callback: (e) => {
                    // console.log(elm.dataset.page, e)
                    __ths.updatePageIndex(elm.dataset.page);
                },
                recheck: true,
                threshold: 1
            })
        }
    }

    function loadConfig(loadmoreConfig, index) {
        __ths.sParams[index] = {
            CurrentPageIndex: loadmoreConfig.currentPageIndex, 
            isFilter: _isFilter, 
            blockindex: index
        };

        __ths.config[index] = {
            CurrentPreviousPageIndex: loadmoreConfig.currentPageIndex, 
            CurrentNextPageIndex: loadmoreConfig.currentPageIndex, 
            totalDisplayingItems: loadmoreConfig.totalDisplayingItems, 
            pageSize: loadmoreConfig.pageSize, 
            totalItemsCount: loadmoreConfig.totalItemsCount, 
            loadEndPoint: loadmoreConfig.loadMoreEndPoint,
            resultContainerOffsetTop: 0
        };
    }

    __ths.listingAreas.forEach(function(loadmoreConfig, index){
        loadmoreConfig = JSON.parse(loadmoreConfig.textContent);

        __ths.config.push({});
        __ths.sParams.push({});
        loadConfig(loadmoreConfig, index);

        __ths.el[index].dataset.blockindex = index;
        
        [].forEach.call(__ths.el[index].querySelector(__ths.opts.sResults).children, (contentItem) => {
            contentItem.dataset.page = loadmoreConfig.currentPageIndex;
            __ths.observerElm(contentItem);
        });
    })
    
    // if(!__ths.sParams.length) {
    //     __ths.sParams.push({CurrentPageIndex: 1, isFilter:_isFilter, blockindex: 0});
        
    //     __ths.config.push({
    //         CurrentPreviousPageIndex: 1, 
    //         CurrentNextPageIndex: 1, 
    //         totalDisplayingItems: 0, 
    //         pageSize: 1, 
    //         totalItemsCount: 0, 
    //         loadEndPoint: __ths.el[index].querySelector("#dataEndpoint")?.value || "",
    //         resultContainerOffsetTop: 0
    //     });

    //     if(__ths.el.length)
    //         __ths.el[0].dataset.blockindex = 0;
    // }

    __ths.fireAutocomplete = function (input) {
        function orphanCharAsWord(word) {
            return word.length > 1 ? word : ' ' + word + ' ';
        }
        
        if(!input.length)
            return;

        // var __ths = this,
        //     $form = __ths.el.find(__ths.opts.form),
        //     allowUseSerialize = document.querySelector(".profile-listing-page");

        try {
            if(window.currentAutoComplete)
                window.currentAutoComplete.destroy();
            const inputId = input[0]?.id;
            if (inputId)
                window.currentAutoComplete = new autoComplete({
                    selector: `#${inputId}`,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&')
                        
                        $.ajax({
                            url: __ths.escapeQueryChars(input.data('endpoint')),
                            type: "get",
                            // data:  allowUseSerialize ? $form.serialize() : { query: term },
                            data:  { query: term },
                            success: function (data) {
                                suggest(data);
                                if(!data || data.length <= 0) {
                                    let _autoCompleteItems = document.querySelectorAll('.autocomplete-suggestion');
                                    
                                    [].forEach.call(_autoCompleteItems, function(_autoCompleteItem){
                                        if(_autoCompleteItem) _autoCompleteItem.remove();
                                    });
                                }
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.Text.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-link="' + item.Value + '" data-val="' + decodedText + '" >' + decodedText.replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        window.location.href = $(item).data('link');
                    }
                });
        } catch (ex) {
            console.warn(ex);
        };
    };

    
    let searchBarPos = 0,
        cacheSearchBarPos = false;

    __ths.checkStickyState = function(){
        setTimeout(function() {
            if(!cacheSearchBarPos)
                searchBarPos = __ths.searchBar.firstElementChild.offsetTop + __ths.searchBar.firstElementChild.offsetHeight;
            if(window.scrollY >= searchBarPos) {
                cacheSearchBarPos = true;
                __ths.searchBar.classList.add("sticky");
                setTimeout(function(){
                    __ths.searchBar.classList.add("animate");
                })
            } else {
                __ths.searchBar.classList.remove("animate");
                __ths.searchBar.classList.remove("sticky");
                cacheSearchBarPos = false;
            }
        }, 0);
    }

    __ths.initFiltersList = function (eqactive) {
        __ths.searchBar = document.querySelector(".extended-search-bar");
        var index = 0;
        if (typeof eqactive !== 'undefined' && eqactive > -1) {
            index = eqactive;
        }
        var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

        selectElm = document.querySelector("#select_sorting");
        $filterHeading.removeClass('active');

        if (GT.wWidth > __ths.MOBILE_BREAKPOINT) {
            $filterHeading.eq(index).attr("aria-selected", true);
            $filterHeading.eq(index).addClass('active');
            $filterHeading.eq(index).attr("tabindex", 0);

            if(document.querySelector(__ths.opts.toggleFilters + ".active")) {
                let submitBtn = document.querySelector(__ths.opts.submitBtn),
                    searchInput = document.querySelector(__ths.opts.searchInput);

                submitBtn?.setAttribute("tabindex", -1);
                searchInput?.setAttribute("tabindex", -1);
            }
        }
        if(document.querySelector(".extended-search-with-sticky")) {
            __ths.searchBar.querySelector(".extended-search-bar__title").addEventListener("click", function(){
                
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                
                if(__ths.searchBar.classList.contains("active")) {
                    __ths.searchBar.classList.remove("active");
                    this.setAttribute("aria-expanded", "false");
                } else {
                    __ths.searchBar.classList.add("active");
                    this.setAttribute("aria-expanded", "true");
                }

                if (GT.wWidth > __ths.MOBILE_BREAKPOINT) {
                    if(__ths.searchBar.classList.contains("active")) {
                        __ths.toggleFiltersDropdown(__ths.CLOSED);
                        setTimeout(function(){
                            if(__ths.searchBar.getBoundingClientRect().y < 80) {
                                window.scrollTo(0, window.scrollY + __ths.searchBar.getBoundingClientRect().y - 80);
                            }
                        }, 300)
                    } else 
                        __ths.toggleFiltersDropdown(__ths.OPENED);
                }
            })
            
            
            if(GT.pageAccessedByReload())
                __ths.checkStickyState();
            GT.listFunctionsTriggerInScrollEvent.extendedSearchSticky = __ths.checkStickyState;
        }

        let clearAllTagsBtn = document.querySelector(".filter-result__clear");
        if(clearAllTagsBtn) {
            let selectedTags = Array.prototype.slice.call(document.querySelectorAll(".filter-result__tag-item"));
            if(selectedTags.length)
                selectedTags.forEach(function(tagElm){
                    tagElm.onclick = function(e){
                        let eTarget = e.currentTarget;
                        if(eTarget.dataset.id == "gt-keywords") {
                            document.querySelector(__ths.opts.searchInput).value = "";
                            document.querySelector(__ths.opts.submitBtn).click();
                        } else if(tagElm.dataset.id.indexOf("_people") >= 0) {
                            document.querySelector("#"+tagElm.dataset.id).remove();
                            document.querySelector(__ths.opts.submitBtn).click();
                        } else if(eTarget.dataset.isParent == "true") {
                            document.querySelector("#tab"+eTarget.dataset.id).click();
                            // document.querySelector(__ths.opts.filterSubHeading + ".active").click();
                        }
                        else
                            document.querySelector("#"+eTarget.dataset.id).click();

                        if(selectedTags.length == 1)
                            clearAllTagsBtn.remove();
                        eTarget.remove();
                        if(GT.wWidth < 768) {
                            document.querySelector(__ths.opts.submitBtn).click();
                        }
                    }
                })
            clearAllTagsBtn.onclick = function(){
                if(selectedTags.length)
                    selectedTags.forEach(function(tagElm){
                        let targetElm = document.querySelector("#"+tagElm.dataset.id);
                        if(targetElm) {
                            if(tagElm.dataset.id.indexOf("_people") >= 0)
                                targetElm.remove();
                            else if(tagElm.dataset.id != "gt-keywords")
                                targetElm.checked = false;
                        }
                        tagElm.remove();
                    })
                __ths.el.find('input[name="parenttag"]').val("");
                document.querySelector(__ths.opts.searchInput).value = "";
                document.querySelector(__ths.opts.submitBtn).click();
                clearAllTagsBtn.remove();
            }
        }
    };
    
    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(__ths.opts.toggleFilters + ".active");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }

    __ths.toggleFiltersDropdown = function (currentStatus) {
        var addClassMethod = 'addClass';
        var removeClassMethod = 'removeClass';
        var __action = currentStatus == __ths.OPENED

        var filtersMethod = __action ? addClassMethod : removeClassMethod;
        var overflowMethod = __action ? removeClassMethod : addClassMethod;
        var toggleButtonMethod = __action ? removeClassMethod : addClassMethod;
        __ths.filtersState = __action ? __ths.CLOSED : __ths.OPENED;

        var $button = __ths.el.find(__ths.opts.toggleFilters);
        var $filters = __ths.el.find(__ths.opts.filters);
        var __cls = __ths.opts.classes;
        $button[toggleButtonMethod]('active');
        $filters[filtersMethod](__cls.filtersClosed);
        $('html')[overflowMethod](__cls.overflowHidden);

        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
        let _searchBarContainer = document.querySelector(".extended-search");
        let filterBody = document.querySelector(".filters__body"),
            submitBtn = document.querySelector(__ths.opts.submitBtn),
            searchInput = document.querySelector(__ths.opts.searchInput);
            
        if (!__action) {
            $button[0].setAttribute('aria-expanded', 'true');
            __ths.searchBar && __ths.searchBar.classList.add("opening-filter");
            _searchBarContainer?.classList.add('filters-active');
            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                filterBody.setAttribute("role", "list");
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    elm.removeAttribute("tabindex");
                    elm.setAttribute("role", "button");
                    elm.setAttribute("aria-expanded", "false");
                })
                setTimeout(e => {
                    document.documentElement.classList.add("opening-mobile-filter");
                    document.querySelector(__ths.opts.closeFiltersButton).focus();
                }, 1000);
            } else {
                document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
                    if(!elm.classList.contains("active")) {
                        elm.setAttribute("tabindex", -1);
                    }
                    filterBody.setAttribute("role", "tablist");
                    elm.setAttribute("role", "tab");
                    elm.removeAttribute("aria-expanded");
                })
            }
            submitBtn?.setAttribute("tabindex", -1);
            searchInput?.setAttribute("tabindex", -1);
            window.addEventListener("keydown", pressESCToClose);
        } else {
            window.removeEventListener("keydown", pressESCToClose);
            document.documentElement.classList.remove("opening-mobile-filter");
            submitBtn?.removeAttribute("tabindex");
            searchInput?.removeAttribute("tabindex");
            // document.querySelectorAll(__ths.opts.filterHeading).forEach(elm => {
            //     elm.classList.remove("active");
            // })

            setTimeout(function() {
                _searchBarContainer?.classList.remove('filters-active');
                __ths.searchBar && __ths.searchBar.classList.remove("opening-filter");
                if ($button.length > 0) {
                    $button[0].setAttribute('aria-expanded', 'false');
                    $button[0].focus();
                }
            }, 200);
        }
    };

    function articleTileBlur(e) {
        $(this).removeClass('no-focus');
        $(this).off();
    }

    __ths.eventHandler = function () {
        function preventEvent(e) {
            e.preventDefault();
        }
        // lazy load
        __ths.el.on('click keydown', __ths.opts.loadBtn, function (e) {
            let index = e.currentTarget.closest(".extended-search").dataset.blockindex;
            if ((!e.keyCode || ~[13, 32].indexOf(e.keyCode)) && __ths.sParams[index].loadMoreState !== __ths.UNACTIVE) {
                preventEvent(e);
                if (e.keyCode) {
                    __ths.el.find(__ths.opts.sResultsLastItem)
                        .focus().addClass('no-focus')
                        .on('blur', articleTileBlur);
                } else {
                    this.blur();
                }
                if(!__ths.config[index].loadEndPoint) __ths.config[index].loadEndPoint = $(this).attr('data-endpoint') || "";
                __ths.loadMore(index);
                __ths.sParams[index].loadMoreState = __ths.UNACTIVE;
            }
        });

        // clear filters
        // __ths.el.on('click', __ths.opts.clearFiltersBtn, function (e) {
        //     preventEvent(e);
        //     var clearEndPoint = $(this).attr('data-endpoint');
        //     __ths.clearFilters(clearEndPoint);
        // });

        // search submit after selecting filters (UX feature)
        __ths.el.on('click', __ths.opts.applyFilters, function (e) {
            preventEvent(e);
            __ths.searchResults(e);
        });

        // search submit
        __ths.el.on('submit', __ths.opts.form, function (e) {
            preventEvent(e);
            if (__ths.searchState !== __ths.UNACTIVE) {
                __ths.searchResults(e);
                __ths.blockFilterFields();
                __ths.searchState = __ths.UNACTIVE;
            }
        });

        // Toggle filters
        __ths.el.on('click', __ths.opts.toggleFilters, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.filtersState);
        });

        __ths.el.on('click', __ths.opts.filterHeading, function (e) {
            preventEvent(e);
            var $this = $(this);
            var $filterHeading = __ths.el.find(__ths.opts.filterHeading);

            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();

            if (GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-expanded", false);
                }

                this.classList.toggle('active');
                if(this.classList.contains("active")) {
                    this.setAttribute("aria-expanded", true);
                } else {
                    this.setAttribute("aria-expanded", false);
                }
            } else if (!$this.hasClass('active')) {
                $filterHeading.removeClass('active');
                for (var i = 0; i < $filterHeading.length; i++) {
                    $filterHeading[i].setAttribute("aria-selected", false);
                    $filterHeading[i].setAttribute("tabindex", -1);
                }
                $this.addClass('active');
                $this[0].setAttribute("aria-selected", true);
                $this[0].setAttribute("tabindex", 0);
            }
        });
        

        __ths.el.on('click', __ths.opts.filterSubHeading, function (e) {
            preventEvent(e);
            var $this = $(this);
            var $filterSubHeading = __ths.el.find(__ths.opts.filterSubHeading),
                parentTagInputElm = document.querySelector('input[name="parenttag"]');


            const newValue = $this.data("value");
            let currentStateIsActive = $this.hasClass('active'),
                tombstoneCheckboxElms = document.querySelectorAll(".filters__heading.active + .has-child-panel input");

            tombstoneCheckboxElms.forEach(function(elm){
                elm.checked = false;
            })
            
            $filterSubHeading.removeClass('active');
            for (var i = 0; i < $filterSubHeading.length; i++) {
                $filterSubHeading[i].setAttribute("aria-pressed", false);
                // $filterSubHeading[i].setAttribute("tabindex", -1);
            }
            
            if(!currentStateIsActive) {
                $this.addClass('active');
                $this[0].setAttribute("aria-pressed", true);
                // $this[0].setAttribute("tabindex", 0);
            }

            if(__ths.t53NewPressContainerElm) {
                let currentParentTagVal = parentTagInputElm.value,
                    currentParentTagVals = currentParentTagVal.split(" "),
                    newValueElm = $this[0];
                    parentTabOfNewVal = newValueElm.closest(".second-level").previousElementSibling;

                if(!currentStateIsActive) {
                    if(currentParentTagVal && currentParentTagVals.length)
                        currentParentTagVals.forEach(function(item, idx){
                            let currentItemElm = document.querySelector('[data-value="'+ item +'"]');
                            if(currentItemElm) {
                                if(currentItemElm.closest(".second-level").previousElementSibling != parentTabOfNewVal)
                                    currentParentTagVals.push(newValue);
                                else if(currentItemElm.closest(".second-level").previousElementSibling == parentTabOfNewVal) {
                                    currentParentTagVals[idx] = newValue;
                                }
                            }
                        })
                    else
                        currentParentTagVals.push(newValue);
                } else {
                    let tmpArr = [];
                    currentParentTagVals.forEach(function(item){
                        if(item != newValue)
                            tmpArr.push(item);
                    })
                    currentParentTagVals = tmpArr;
                }

                let tmpArrPreventDuplicate = [];
                currentParentTagVals.forEach(function(item){
                    if(tmpArrPreventDuplicate.indexOf(item) == -1 && item)
                        tmpArrPreventDuplicate.push(item);
                })
                currentParentTagVals = tmpArrPreventDuplicate;

                parentTagInputElm.value = currentParentTagVals.join(" ");
            } else {
                if(!currentStateIsActive) {
                    parentTagInputElm.value = newValue;
                } else
                    parentTagInputElm.value = "";
            }
            
            if($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
                __ths.searchResults(e, "#" + e.currentTarget.id);
                __ths.blockFilterFields();
                __ths.blockSearchBtn();
            }
        });

        __ths.el.on('click', __ths.opts.closeFiltersButton, function (e) {
            preventEvent(e);
            __ths.toggleFiltersDropdown(__ths.OPENED);
        });

        __ths.el.on('change', __ths.opts.filterTags, function (e) {
            preventEvent(e);
            if ($(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {
                // e.currentTarget.setAttribute("checked", "checked");
                // setTimeout(function(){
                    __ths.searchResults(e, "#" + e.currentTarget.id);
                    __ths.blockFilterFields();
                    __ths.blockSearchBtn();
                // }, 50)
            }
        });
        var windowWidth = $(window).width();
        $(window).on('resize', function (e) {
            if(this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                $(this).trigger('windowResize');
            }, 100); 
            
        });
        $(window).on('windowResize', function() {
            var __windowWidth = $(window).outerWidth(),
                __MOBILE = __ths.MOBILE_BREAKPOINT;
            if ((__windowWidth <= __MOBILE && __prevWindowWidth > __MOBILE) ||
                (__windowWidth > __MOBILE && __prevWindowWidth <= __MOBILE)) {
                __ths.toggleFiltersDropdown(__ths.OPENED);
                __ths.initFiltersList();
            }
            if ($(window).width() != windowWidth){
                $('.article-block__item').removeAttr("clamp");
                windowWidth = $(window).width();
            }
            __prevWindowWidth = __windowWidth;
        });
    };

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };

    __ths.tryAddSort = function (url, callParams) {
        var parentUrl = new URL(window.location);
        var currentUrl = new URL(window.location.origin + url);

        var parentQuery = parentUrl.search;
        var query = currentUrl.search;
        var parentParams = new URLSearchParams(parentQuery);
        var currentParams = new URLSearchParams(query);

        var sort = "desc";
        if (currentParams.get("query"))
            sort = 'rel';

        if (parentParams.get("sort"))
            sort = parentParams.get("sort");

        if (!__ths.sParams[callParams.blockindex].isFilter) // clear filter
            sort = "desc";

        if(!currentParams.get("sort"))
            currentParams.set('sort', sort);

        // change the search property of the main url
        currentUrl.search = currentParams.toString();
        // the new url string with sort
        return currentUrl.toString();
    };

    __ths.ajaxCall = function (url, callParams, successCallback, test) {
        if(__ths.searchState == __ths.UNACTIVE) return;

        let contextRef = this,
        __url = __ths.escapeQueryChars(url);
        __url = __ths.tryAddSort(__url, callParams);
        //var _isInsightLandingPage = contextRef.el.hasClass('insight-landing__extended--search');
        //var spinner = document.getElementById('clear-filter__overlay');
        document.querySelector(".extended-search")?.classList.add("fetching");
        if (!test) {
            timeStart('ajax');
            __ths.searchState = __ths.UNACTIVE;
            $.ajax({
                url: __url,
                type: "get",
                data: callParams,
                success: function (data) {                    
                    timeEnd('ajax');
                    successCallback(contextRef, data, callParams);
                    if ($('.topic-block').length) {
                        var topicBlock = document.querySelector(".topic-block");
                        var topicGlide = topicBlock.querySelector(".glide");
                        GT.GlideV2(topicGlide);
                        setTimeout(function () {
                            topicGlide.classList.remove("loading");
                            topicGlide.querySelector(".glide__track").style.height = "initial";
                        }, 1000);
                    }
                        
                    let tablist = document.querySelector(".extended-search-bar__filters [role=tablist]");
                    if(tablist)
                        TabPanelActionHandler(tablist);
                    
                    if(selectElm) {
                        __ths.setParameterInQueryString("sort", selectElm.value);
                    }
                    
                    if(callParams.CurrentPageIndex == 1)
                        setTimeout(e => {
                            __ths.scrollIntoViewSearchResults();
                        }, 1000)

                    setTimeout(e => {
                        __ths.searchState = __ths.ACTIVE;
                        document.querySelector(".extended-search")?.classList.remove("fetching");
                    }, 400)
                },
                error: function (xhr) {
                    console.error(xhr);
                    __ths.searchState = __ths.ACTIVE;
                    __ths.unblockSearchFields();
                }
            });
        } else {
            var data = test;
            successCallback(contextRef, data, callParams);
        }
    };

    __ths.blockFilterFields = function () {
        __ths.el.find(__ths.opts.filterTags).attr('disabled', true);
    };

    __ths.blockSearchBtn = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', true);
    };

    __ths.unblockSearchFields = function () {
        __ths.el.find(__ths.opts.submitBtn).attr('disabled', false);
        __ths.el.find(__ths.opts.filterTags).attr('disabled', false);
    };

    __ths.loadMore = function (index, isLoadPrevious) {
        let __ths = this,
            __queryStringChar = '?';
        
        let __endpointUrl = __ths.config[index].loadEndPoint;  //store document height  

        if(isLoadPrevious) {
            __ths.config[index].CurrentPreviousPageIndex--;
            __ths.sParams[index].CurrentPageIndex = __ths.config[index].CurrentPreviousPageIndex;
        } else {
            __ths.config[index].CurrentNextPageIndex++;
            __ths.sParams[index].CurrentPageIndex = __ths.config[index].CurrentNextPageIndex;
        }

        let currentForm = __ths.el.find(__ths.opts.form);

        if(currentForm.length) {
            let queryString = __ths.getSearchParams(currentForm, true);
            if (queryString) {
                if (__endpointUrl.match(/\?/ig) !== null) {
                    __queryStringChar = '&';
                }
                __endpointUrl = __endpointUrl + __queryStringChar + queryString;
            }
        }

        function successCallback(contextRef, data, callParams) {
            __ths.appendResults(contextRef, data, callParams, isLoadPrevious);
            // if(isLoadPrevious)
            //     __ths.updatePageIndex(__ths.sParams[index].CurrentPageIndex);
        }

        __ths.ajaxCall(__endpointUrl, __ths.sParams[index], successCallback, false);
    };

    __ths.searchResults = function (e, targetElm) {
        timeStart('search action');
        var __ths = this,
            $form = __ths.el.find(__ths.opts.form),
            __searchParams = __ths.getSearchParams($form),
            __queryStringChar = '?',
            __searchEndPoint = $form.attr('action') || '',
            __endpointUrl = '';

        let currentIndex = e.delegateTarget.dataset.blockindex;

        __ths.sParams[currentIndex].CurrentPageIndex = 1;
        __ths.sParams[currentIndex].isFilter = true;
        __ths.config[currentIndex].CurrentPreviousPageIndex = 1;
        __ths.config[currentIndex].CurrentNextPageIndex = 1;

        function successCallback(contextRef, data, callParams){
            __ths.replaceResults(contextRef, data, callParams);
            setTimeout(e => {
                if(targetElm) {
                    document.querySelector(targetElm).focus();
                } else
                    __ths.el.find(__ths.opts.toggleFilters).focus();
            }, 1000)
        }

        if (__searchEndPoint.match(/\?/ig) !== null) {
            __queryStringChar = '&';
        }
        __endpointUrl = __searchEndPoint + __queryStringChar + __searchParams;

        __ths.ajaxCall(__endpointUrl, __ths.sParams[currentIndex], successCallback, false);

    };

    __ths.scrollIntoViewSearchResults = function(){
        if(GT.wWidth <= __ths.MOBILE_BREAKPOINT) {
            __ths.toggleFiltersDropdown(__ths.OPENED);
            setTimeout(() => {
                document.getElementById('filter_accordion')?.scrollIntoView();
            }, 300);
        }
    }


    __ths.appendResults = function (contextRef, data, callParams, isLoadPrevious) {
        if(!contextRef.el.length)
            return;

        let __contextElm = contextRef.el[callParams.blockindex ? callParams.blockindex : 0],
            __searchResults = __contextElm.querySelector(contextRef.opts.sResults),
            __searchResultsGrid = __searchResults.querySelector('.insight-search__results--grid');

        if (__searchResultsGrid) {
            __searchResults = __searchResultsGrid;
        }

        let glideItemHasLoadMoreFnc = __contextElm.querySelector(".glide-v2");
        if(!isLoadPrevious && glideItemHasLoadMoreFnc && __contextElm.classList.contains("fetching")) {
            GT.destroyGlideV2(glideItemHasLoadMoreFnc);
            __searchResults = glideItemHasLoadMoreFnc.querySelector(contextRef.opts.sResults);
        }

        let lastItem = __searchResults.lastElementChild,
            old_DOM_height = document.querySelector(".gt-wrapper").offsetHeight,
            old_scroll = GT.lastScrollTop;

        GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
        // Using timeout for tombstone listing page when load more(broken layout if not)
        if(__ths.tombstoneContainerElm) {
            // setTimeout(function() {
            __searchResults.insertAdjacentHTML(isLoadPrevious ? "afterbegin" : "beforeend", data);        
            // });
        } else {
            __searchResults.insertAdjacentHTML(isLoadPrevious ? "afterbegin" : "beforeend", data);
        }

        if(!isLoadPrevious) {
            __ths.config[callParams.blockindex].totalDisplayingItems += __ths.config[callParams.blockindex].pageSize;
            if(__ths.config[callParams.blockindex].totalDisplayingItems > __ths.config[callParams.blockindex].totalItemsCount)
                __ths.config[callParams.blockindex].totalDisplayingItems = __ths.config[callParams.blockindex].totalItemsCount;
            contextRef.shouldLoadMore();
        }

        contextRef.rebuildClamp();
        if (window.bindSorting) window.bindSorting();
        

        if(!isLoadPrevious && glideItemHasLoadMoreFnc) {
            GT.GlideV2(glideItemHasLoadMoreFnc);
            glideItemHasLoadMoreFnc.classList.remove("loading");
            glideItemHasLoadMoreFnc.closest(".extended-search")?.classList.remove("fetching");
            glideItemHasLoadMoreFnc.querySelector(".glide__track").style.height = "initial";
        }

        if(__ths.tombstoneContainerElm || document.querySelector(".related-tombstone__sliders")) {
            setTimeout(function() {
                GT.TombstoneTransaction(true);
                GT.clampText("tombstone-transaction");
            });
        }
        GT.FakeHyperlink();

        if(!glideItemHasLoadMoreFnc) {
            
            [].forEach.call(__searchResults.children, (contentItem) => {
                if(!contentItem.dataset.observed) {
                    contentItem.dataset.page = callParams.CurrentPageIndex;
                    __ths.observerElm(contentItem);
                }
            });
            
            if(!isLoadPrevious) {
                let focusableItem = lastItem?.nextElementSibling;
                if(focusableItem) {
                    let elmIsFocusable = GT.canFocus(focusableItem);
                    if(elmIsFocusable) elmIsFocusable.focus();
                    else {
                        let lstFocusableElms = GT.getListFocusableElms(focusableItem);
                        if(lstFocusableElms.length)
                            lstFocusableElms[0].focus();
                    }
                }
            } else {
                window.scrollTo({ top: (old_scroll + document.querySelector(".gt-wrapper").offsetHeight - old_DOM_height), left:0, behavior: "instant"});
            }
        }
    };


    __ths.replaceResults = function (contextRef, data, callParams) {
        var __tmpFilterStatus = __ths.filtersState,
            __tmpData = data;

        if (__tmpFilterStatus == __ths.OPENED && $(window).outerWidth() > __ths.MOBILE_BREAKPOINT) {

            var __allfilters = __ths.el.find(__ths.opts.filterHeading),
                __activefilter = __ths.el.find(__ths.opts.filterHeading + '.active'),
                toggleFiltersClass = __ths.opts.toggleFilters.replace('.', ''),
                index = __allfilters.index(__activefilter);

            __tmpData = data.replace(new RegExp(__ths.opts.classes.filtersClosed), '')
                .replace(toggleFiltersClass, toggleFiltersClass + ' active');
        }
        __ths.el.html(__tmpData);

        loadConfig(JSON.parse(document.querySelectorAll(".loadmore-config")[callParams.blockindex].textContent), callParams.blockindex);

        // __ths.config[callParams.blockindex].totalDisplayingItems = __ths.currentTotalDisplayingItems(__ths.el[callParams.blockindex]);
        
        [].forEach.call(__ths.el[callParams.blockindex].querySelector(__ths.opts.sResults).children, (contentItem) => {
            contentItem.dataset.page = callParams.CurrentPageIndex;
            __ths.observerElm(contentItem);
        });

        __ths.shouldLoadMore();
        __ths.rebuildClamp();
        __ths.initFiltersList(index);
        __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
        GT.FakeHyperlink();
        let filterByBtn = __ths.el.find(__ths.opts.toggleFilters);
        if(filterByBtn.hasClass("active"))
            filterByBtn.attr("aria-expanded", true);

        if (typeof GT !== "undefined" && GT.FormSelect) {
            GT.FormSelect($('.insight-search-sorting .form-select'));
        }

        if(document.querySelector(".change-view"))
            new GT.View($('.change-view'));

        if (window.bindSorting) window.bindSorting();
        if(__ths.tombstoneContainerElm) {
            GT.TombstoneTransaction();
            GT.clampText("tombstone-transaction");
        }
        attackEvtforSort();
        if(GT.wWidth <= __ths.MOBILE_BREAKPOINT)
            window.scrollTo(0,0);
        timeEnd('search action');
    };

    __ths.qsToObj = function (queryString) {
        var qsObj = {};
        queryString.split('&').forEach(function (item) {
            var tmp = item.split('='),
                key = tmp[0],
                value = tmp[1];
            if (value) {
                qsObj[key] = qsObj[key] || [];
                qsObj[key].push(value);
            }
        });

        return /*json*/ qsObj;
    };

    __ths.qsURIbuilder = function (qsObj) {
        var qsArray = [];
        for (var key in qsObj) {
            var __tmpkey = key;
            if (__tmpkey === 'query') {
                __tmpkey = 'q';
            }
            qsArray.push(__tmpkey + '=' + qsObj[key].join(this.opts.joinChar));
        }
        return /*string*/ qsArray.join('&');
    };

    __ths.setParameterInQueryString = function(key, value, isRemove){
        var queryParams = new URLSearchParams(window.location.search);
        if(!isRemove)
            queryParams.set(key, value);
        else
            queryParams.delete(key);

        let queryStr = queryParams.toString();
        history.replaceState(null, null, (queryStr.length ? "?" + queryStr : location.href.split("?")[0].split("#")[0])  + location.hash);
    }

    __ths.getSearchParams = function ($form, isLoadMore) {
        let currentForm = $form[0];
        let __qsString = '',
            filters = '#filters',
            serializedForm = "";

        let urlSParams = new URLSearchParams(location.search);
        const oldKeywords = urlSParams.get("q");
        urlSParams.delete("q");
        urlSParams.delete("query");
        urlSParams.delete("tags");
        urlSParams.delete("parenttag");
        let currentURLParams = urlSParams.toString();

        if(currentForm.classList.contains("multiple-tags")) {
            // Multiple Tags
            let selectedTags = {};
            currentForm.querySelectorAll(".extended-search-bar__filters .filters__item:checked")?.forEach(selectedItem => {
                const parentID = selectedItem.closest(".second-level").id;
                if(!selectedTags[parentID])
                    selectedTags[parentID] = [];
                selectedTags[parentID].push(selectedItem.value);
            })

            let filterSelectedTags = [];
            Object.keys(selectedTags).forEach(selectedTagIdx => {
                filterSelectedTags.push("tags="+selectedTags[selectedTagIdx].join(__ths.opts.joinChar));
            })

            filterSelectedTags.push(currentURLParams);

            let tmpFilterSelectedTags = JSON.parse(JSON.stringify(filterSelectedTags)); // structuredClone
            let searchInput = currentForm.querySelector("#search-bar-input");
            if(searchInput && !isLoadMore) {
                filterSelectedTags.push("query=" + encodeURIComponent(searchInput.value));
                tmpFilterSelectedTags.push("q=" + encodeURIComponent(searchInput.value));
            }

            serializedForm = filterSelectedTags.join("&");
            __qsString = tmpFilterSelectedTags.join("&");
        } else {
            // Single Tags
            formData = $form.serialize();
            serializedForm = formData + (formData ? "&" : "") + currentURLParams;
            __qsString = this.qsURIbuilder(this.qsToObj(serializedForm)) || "";
        }

        if(isLoadMore) {
            serializedFormParams = new URLSearchParams(serializedForm);
            serializedFormParams.delete("page");
            if(oldKeywords) serializedFormParams.set("query", oldKeywords);
            else serializedFormParams.delete("query");
            serializedForm = serializedFormParams.toString();
        } else {
            if (__qsString.length) {
                __qsString = '?' + __ths.escapeQueryChars(__qsString);
                window.history.pushState(null, null, __qsString + filters);
            } else {
                window.history.pushState(null, null, location.href.split("?")[0].split("#")[0] + filters);
            }
        }

        return serializedForm;
    };

    __ths.currentTotalDisplayingItems = function(currentElm) {
        let currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " > div:not(.expert-facts__container)").length;
        if(document.querySelector(".insight-landing__extended--search"))
            currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " .insight-search__results--grid > div:not(.expert-facts__container)").length;
        if(__ths.tombstoneContainerElm)
            currentTotalDisplayingItems = currentElm.querySelectorAll(__ths.opts.sResults + " .transaction-list__item").length;

        return currentTotalDisplayingItems;
    }

    __ths.updatePageIndex = (pageIndex) => {
        if(pageIndex > 1) {
            __ths.setParameterInQueryString("page", pageIndex);
        } else {
            __ths.setParameterInQueryString("page", pageIndex, true);
        }
        
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (pageIndex > 1 ? "?page=" + pageIndex : ""); 
    }

    __ths.shouldLoadMore = function () {
        var __ths = this;

        __ths.config.forEach(function(currentConfig, index){
            let currentElm = __ths.el[index],
                __loadBtn = currentElm.querySelector(__ths.opts.loadBtn);

            if(!__loadBtn) 
                return;

            let totalItems = currentConfig.totalItemsCount,
                maxPage = Math.ceil(totalItems / currentConfig.pageSize),
                loadMoreContainer = currentElm.querySelector(".load-more-container"),
                currentNextPageIndex = parseInt(currentConfig.CurrentNextPageIndex);

            if (maxPage <= currentNextPageIndex) {
                if(loadMoreContainer)
                    loadMoreContainer.classList.add("hidden");
                else
                    __loadBtn.classList.add('hidden');

                __ths.sParams[index].loadMoreState = __ths.UNACTIVE;
            } else {
                if(loadMoreContainer)
                    loadMoreContainer.classList.remove("hidden");
                else
                    __loadBtn.classList.remove('hidden');

                __ths.sParams[index].loadMoreState = __ths.ACTIVE;
            }

            if(loadMoreContainer) {
                let currentTotalDisplayingItems = currentConfig.totalDisplayingItems;
                let _loadmoreShowItems = currentElm.querySelector(".load-more-stats__showing-items");
                let _loadMoreProgressbar = currentElm.querySelector(".load-more-stats__progressbar-loaded");
                if(_loadmoreShowItems) _loadmoreShowItems.innerText = currentTotalDisplayingItems;
                if(_loadMoreProgressbar) _loadMoreProgressbar.style.width = (currentTotalDisplayingItems / totalItems * 100) + "%";
            }

            if(!isNaN(currentNextPageIndex) && document.querySelector(".profile-listing-page, .t37-page, .insight-landing__extended--search, .insight-search-page, .tombstone-listing-page, .press-landing-page-v2, .icb-listing-page")) {
                __ths.updatePageIndex(currentNextPageIndex);
                if(__loadBtn.href) {
                    //wait for setParameterInQueryString runs completely
                    setTimeout(function() {
                        var queryParams = new URLSearchParams(window.location.search);
                        queryParams.set("page", currentNextPageIndex + 1);
                        __loadBtn.href = "?" + queryParams.toString() + location.hash;
                    })
                }
            }
            
        })
    };

    __ths.rebuildClamp = function () {
        GT.clampArticle();
        GT.ShowMore && GT.ShowMore();
    };

    function changeSort() {
        let slSort = document.getElementById("select_sorting"),
            url = new URL(window.location),
            query_string = url.search,
            search_params = new URLSearchParams(query_string);

        search_params.set('sort', slSort.options[slSort.selectedIndex].value);
        // change the search property of the main url
        url.search = search_params.toString();
        // the new url string
        window.location = url.toString();
    }

    function attackEvtforSort() {
        let select = document.querySelector('#select_sorting');
        if(select && !select.dataset.attackedEvt) {
            select.dataset.attackedEvt = true;
            select.addEventListener('change', changeSort);
        }
    }


    __ths.loadPreviousHandler = () => {
        __ths.config.forEach(function(currentConfig, index){
            let currentElm = __ths.el[index];
            let currentTotalDisplayingItems = __ths.currentTotalDisplayingItems(currentElm);
            if(currentTotalDisplayingItems <= currentConfig.totalItemsCount) {
                __ths.config[index].resultContainerOffsetTop = 0;
                GT.listFunctionsTriggerInScrollEvent['checkScrollPosExtendedSearch_' + index] = () => {
                    let CurrentPreviousPageIndex = parseInt(currentConfig.CurrentPreviousPageIndex),
                        resultContainerElm = __ths.resultContainerElms[index];

                    if(!currentConfig.resultContainerOffsetTop)
                        __ths.config[index].resultContainerOffsetTop = GT.getElementOffset(resultContainerElm).top;

                    if(CurrentPreviousPageIndex > 1 && GT.isScrollingUp && GT.lastScrollTop - currentConfig.resultContainerOffsetTop < 300 && __ths.searchState == __ths.ACTIVE) {
                        __ths.loadMore(index, true);
                    }
                }
            }
        })
    }

    __ths.shouldLoadMore();
    __ths.eventHandler();
    __ths.initFiltersList();
    __ths.loadPreviousHandler();
    __ths.fireAutocomplete(__ths.el.find(__ths.opts.searchInput));
    attackEvtforSort();
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.ExtendedSearchV2($('.extended-search'), {settings: {
                'form': 'form',
                'submitBtn': '.extended-search-bar__search-btn',
                'loadBtn': '.extended-search__load-btn',
                'applyFilters': '.filters__apply-close-btn',
                'filterTags': '.filters__item',
                'clearFiltersBtn': '.article-grid__clear-btn',
                'sResults': '.extended-search__results',
                'toggleFilters': '.extended-search-bar__filter-btn',
                'searchInput': '.extended-search-bar__search-input',
                'filters': '.extended-search-bar__filters',
                'filterSubHeading': '.filters__subheading',
                'closeFiltersButton': '.filters__close-button a',
                'filterHeading': '.filters__heading',
                'isFilterField': '.isFilter',
                'pageSize': '.pageSize',
                'joinChar': '+',
                'classes': {
                    'filtersClosed': 'filters--closed',
                    'overflowHidden': 'overflowHidden--mobile'
                }
        }});
        
        if(document.querySelector(".extended-search-with-sticky") && GT.isSafari()) {
            document.querySelector(".gt-wrapper").style.overflow = "initial";
        }
    });
//This file is using for MS365 form and MVC form
GT.ExternalFormV2Label = function () {
    let me = this;
    const formSelect = document.querySelectorAll('.ms365-form select');
    const formElementWrapper = [
        '.lp-form-field',
        '.textFormFieldBlock',
        '.lookupFormFieldBlock',
        '.dateTimeFormFieldBlock',
        '.phoneFormFieldBlock'
    ];

    const set = new Set();

    formElementWrapper.forEach(sel => {
        // get all input/textarea under this selector
        const nodeList = document.querySelectorAll(`${sel} input, ${sel} textarea`);
        nodeList.forEach(el => {
            // find the closest ancestor that matches the wrapper selector
            const wrapper = el.closest(sel);
            // include element only if wrapper exists and does NOT have data-hide="hide"
            if (wrapper && wrapper.dataset.hide !== 'hide') {
                set.add(el);
            }
        });
    });

    // result as an array
    const inputElements = Array.from(set);

    me.init = function () {
        function toggleFilledClass(item) {
            var parent = item.parentNode;
            if (item.closest('.phoneFormFieldBlock')) {
                parent = item.closest('.phoneFormFieldBlock');
            }
            if (item.value.length > 0) {
                parent.classList.add('filled');
            } else {
                parent.classList.remove('filled');
            }
        }
        inputElements.forEach(function (item) {
            var parentDiv = item.closest(".lp-form-field, .textFormFieldBlock, .lookupFormFieldBlock, .dateTimeFormFieldBlock, .phoneFormFieldBlock"),
                label = parentDiv?.querySelector('label');
            setTimeout(function () {
                toggleFilledClass(item);
            }, 1000)

            if (label && !label.innerHTML) {
                label.classList.add('empty');
            }

            item.addEventListener("focus", function () {
                parentDiv.classList.add('focus');
            })


            item.addEventListener("blur", function (event) {
                parentDiv.classList.remove('focus');
                toggleFilledClass(event.target);
            })

            item.addEventListener("change", function (event) {
                toggleFilledClass(event.target);
            })
        });

        [].forEach.call(formSelect, function (item) {
            var parentDiv = item.closest(".lp-form-field, .optionSetFormFieldBlock"),
                label = parentDiv.querySelector('label');

            if (!label.innerHTML) {
                label.classList.add('empty');
            }

            setTimeout(function () {
                toggleFilledClass(item);
            }, 1000)

            item.addEventListener("focus", function () {
                parentDiv.classList.add('focus');
                label.classList.add('focus');
            })

            item.addEventListener("blur", function () {
                parentDiv.classList.remove('focus');
                label.classList.remove('focus');
            })

            item.addEventListener("change", function (event) {
                toggleFilledClass(event.target);
            })
        });

        // [].forEach.call(formDateInput, function(item) {
        //     let parentDiv = item.closest('.Form__Element');
        //     GT.observeElement(item, "value", function (oldValue, newValue) {
        //         parentDiv.classList.remove('focus');
        //         toggleFilledClass(item);
        //     });
        // });

    }
    me.init();
}



GT.domContentLoadedFncList.push(function () {
    const formContainer = document.querySelector(".externalformblock");
    if (formContainer) {
        GT.ExternalFormV2Label();
    }
});
GT.GTExternalLogin = function (elem, GTConstruct) {
    var settings = GTConstruct && GTConstruct.settings ? GTConstruct.settings : {};
    var containerWidth = settings.containerWidth || 640;
    var containerHeight = settings.containerHeight || 475;
    var loginFormReferenceId = elem.data('external-login-overlay');
    $(elem).click(function (e) {
        e.preventDefault();
        $('#IsBookmarkLoginRequested').val('False');
        var winWidth = $(window).innerWidth();
        $('#' + loginFormReferenceId).show();
        if (containerWidth > winWidth) {
            containerWidth = winWidth;
        }
        GT.Overlays.runOverlay(document.getElementById(loginFormReferenceId), '#' + loginFormReferenceId, containerWidth, containerHeight, false, false);
    });
    openRegisterPopup();
    function openRegisterPopup() {
        $('.register-popup__button').click(function () {

            var containerWidth = settings.containerWidth || 640;
            var containerHeight = settings.containerHeight || 475;
            var registerFormReferenceId = $('.register-popup__button').data('external-register-overlay');
            let registerFormReferenceElm = document.getElementById(registerFormReferenceId);
            var winWidth = $(window).innerWidth();

            if (containerWidth > winWidth) {
                containerWidth = winWidth;
            }
            GT.Overlays.runOverlay(registerFormReferenceElm, '#' + registerFormReferenceId, containerWidth, containerHeight, false, false);
            registerFormReferenceElm.style.display = "block";
        });

        $('.register-popup__button').trigger('click');
    }
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTExternalLogin($('.externalLoginButton'));
    });

GT.FakeArrowTransitions = function (el, settings) {
    var $el = el;
    var expandWidth = settings.settings.width || 5;
    $el.each(function () {
        var $this = $(this);
        $this.on('mouseenter', function () {
            var $dom = $(this);
            var $arrow = $dom.find('.arrow');
            if ($arrow.length > 0) {
                var endOfArrow = $arrow.offset().left + $arrow.width();
                var endOfDiv = $dom.offset().left + $dom.width();
                if (endOfDiv <= endOfArrow + expandWidth) {
                    $dom.data('moved', true);
                    $dom.animate({
                        width: '+=' + expandWidth + 'px'
                    }, 150);
                }
                $dom.data('arrow-moved', true);
                $arrow.animate({
                    marginLeft: '+=' + expandWidth + 'px'
                }, 150);
            }

        });

        $this.on('mouseleave', function () {
            var $dom = $(this);
            if ($dom.data('moved')) {
                $dom.data('moved', false);
                $dom.animate({
                    width: '-=' + expandWidth + 'px'
                }, 150);
            }
            if ($dom.data('arrow-moved')) {
                $dom.data('arrow-moved', false);
                var $arrow = $dom.find('.arrow');
                if ($arrow.length > 0) {
                    $arrow.animate({
                        marginLeft: '-=' + expandWidth + 'px'
                    }, 150);
                }
            }
        });
    });
};
GT.fakeHyperLinkClickEvtList = [];
GT.fakeHyperLinkKeypressEvtList = [];
GT.FakeHyperlink = function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-anchor]')).forEach(function (el, index) {
        GT.fakeHyperLinkClickEvtList.forEach(function (func, funIdx) {
            el.removeEventListener("click", func);
        })
        GT.fakeHyperLinkKeypressEvtList.forEach(function (func, funIdx) {
            el.removeEventListener("keypress", func);
        })
    })
    GT.fakeHyperLinkClickEvtList = [];
    GT.fakeHyperLinkKeypressEvtList = [];


    function redirectLink(linkElm){
        window.open(linkElm.dataset.anchor, linkElm.getAttribute("target") ? linkElm.getAttribute("target") : '_self');
    }

    Array.prototype.slice.call(document.querySelectorAll('[data-anchor]')).forEach(function (el) {
        if(!el.querySelector('a, [role="link"]')) {
            el.setAttribute("tabindex", 0);
            el.setAttribute("role", "link");
        }

        function handleClickEvt(e) {
            redirectLink(e.currentTarget);
        }
        function handleKeypressEvt(e) {
            if (e.keyCode == 13)
                redirectLink(e.currentTarget);
        }

        GT.fakeHyperLinkClickEvtList.push(handleClickEvt);
        GT.fakeHyperLinkKeypressEvtList.push(handleKeypressEvt);
        el.addEventListener("click", handleClickEvt);
        el.addEventListener("keypress", handleKeypressEvt);
    })

    Array.prototype.slice.call(document.querySelectorAll('[data-anchor] a')).forEach(function (el) {
        el.addEventListener("click", function(e){
            e.stopPropagation();
        });
    })
};
GT.FileUpload = function (filePicker) {
    this.i18n = languageResources || {};
    this.filePicker = $(filePicker);
    this.acceptedExtArray = (this.filePicker.attr('accept') || "")
        .split(',').filter(function (filter) {
            // return false if string is empty i.e.: "";
            return filter;
        });
    this.acceptMultiple = this.filePicker.attr('multiple') ? true : false;
    this.initI18n();
    this.initDOMElements();
    this.initBindings();
    this.maxFileNameLength = 25;
    this.maxFile = 5;
    this.numbFile = 1;
    this.droppedFiles = null;
};

GT.resetFileInput = function (input) {
    input.value = '';

    if (!/safari/i.test(navigator.userAgent)) {
        input.type = '';
        input.type = 'file';
    }
};

GT.FileUpload.prototype.initI18n = function () {
    var __ths = this;
    var __i18n = __ths.i18n.Forms || {};
    __ths.filePickerLabel = __i18n.ButtonLabel;
    __ths.noFileLabel = __i18n.SelectFileLabel;
    __ths.multipleFilesLabel = __i18n.MultipleFiles;
    __ths.dropFilesLabel = __i18n.DropAreaLabel;
    __ths.dropOrLabel = __i18n.DropOrLabel;
    __ths.allowUploadMaxItemLabel = __i18n.AllowUploadMaxItemLabel;
    __ths.invalidMineTypes = __i18n.invalidMineTypes;
    __ths.invalidFileSize = __i18n.invalidFileSize;
};

GT.FileUpload.prototype.initDOMElements = function () {
    var ths = this;
    ths.filePicker.wrap('<div class="FormFileUpload__wrapper" for="' + ths.filePicker.attr("id") + '"></div>')
        .after('<span class="file-picker__choose FormFileUpload__CTA">' + ths.filePickerLabel + '</span>')
        .after('<span class="FormFileUpload__OR">&nbsp;' + ths.dropOrLabel + '</span>')
        .after('<div class="file-picker__drop-files">' + ths.dropFilesLabel + '</div>');

    ths.label = ths.filePicker.parent();
    ths.listEL = ths.label.after('<div class="FormFileUpload__List"></div>').next();

    ths.removeEL = '<div class="file-item" title="{1}">{0}</div>';

    ths.label.find('.file-picker__choose').click(function (e) {
        e.preventDefault();
        ths.filePicker.click();
    });

    // define icon
    ths.attachment = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAABc0lEQVQ4jc3TT0sVURgH4EcKd9YiSwsiSYJAECLcuBMiRAiiVLQiIyX6Bq76CEkRLtRWQguLcudecHUhUTQR3VTQDdQW0h9Ly1qcVxiCO3p14wvDDIdznjm/M+9w2OvIAdbW4TI28K3cxcfRFs+VGMHfuH6grxzsBKbxG7UYD2gUN1HAL9TvBavGDP7gId4E9jgzpyXGbu2GncRsYA/wOhYO/DfvUYw352GnMCfF7M1gT3Adq2hCO7YwiYpSWA3eBXYPrwJ7Kp3ZJpbjRZtYwpk8bD6DvQhsCJ0Z4L7ULh+k9ikZczEi3MZYYM/QHeOL6AnsPc6VwmBC+gAdGA5sEHdixwvownd8xPk8rCEDHMO21G89gc3jBr7iEy7kYXA3wKvS71iMWNtS61zDOj7jYh50NO5bca+K2K3ox4p0FC/xE1ekc9y1TseCghR5p1rwBWto3AuUrX4pdlHqvSkp8houlYvtVDfexm6LeI6z+8UOZ/0DwZRpt1eyc7oAAAAASUVORK5CYII=">';
    ths.pdf = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAABBUlEQVQ4ja3Tuy6EQRgG4GfXoVIrVILeBRBR+BONRBQS4hDXodneDaiRSMQl6Bz67YSgp9hGIkKyCvMzZv2HFW/yZeabb+add96Z4Z/QSPIpLGOgYP4VzusQ36JbEi9YrEPURaug1gr1VyylxWYd9gTDOE3J/kKUk53EA7HZ43jAIQ4qiLawqfeyzONNudG/xRfyo81hEBl2fBqaYQVnaIc8K5LYTNonPOIa79jHLjoYw14VUY4OVjEd8lEMhf59UFaLaALbod/GjO8HuBDVCrGhf6N/mN2I2nUc4RIXFRvPBrU915+j7IvEaKWKUlR92jhu4oWptEmsYaRC0TOOcVdDfX/4ANRPU9USB4cEAAAAAElFTkSuQmCC">';
    ths.doc = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAAnElEQVQ4jWNgoBJgROOrMDAwBDAwMDBjUfuEgYFhKbEG32ZgYPiPBzcQaxAuxQ5IhnVg08hErA1IoBybYeQYhNUwFiI1vmdgYNiDxFeCGlaBSwOxAdoAVQsH5HoNA+Dz2n8c4uhpj6BBnUQ7h4BBOAOSVIOGuNfQAaFMi4xvIWtE968yAwNDJAMDAw8BC78wMDAsZ2BguEuJq7ECAAklKSMnXojkAAAAAElFTkSuQmCC">';
    ths.img = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAA/0lEQVQ4jd3TTyvEURTG8c9oSPzWZmtlPbYUQsLGeAf+lFI2SnkBsrOQjaVXIDtSGnkDZpayEztNNrNTWMyZ+qk7YrLh2dzOuff5dp57u/xbFWItY7NLxjHqxSiGUcHJDyGruEC93aig9g3jEh5wGHUtvHo6GDKMJvrreMIWevMbKVAW495gPHr9WMMRBrGH17yp6LMynOMd+wFcxg7mI1I5FSEPGggILKKJN1zhFmM4jf3tr0AjeMZCQPowofUic2hgCtcpWB70GOM3te7kDEOYxkucuccMqhG/kAI1EpDZHKStu4BXUUqBStiNGJM4wIbOusRKu/i1L9Kl9y/oAw0OMeRN588pAAAAAElFTkSuQmCC">';
};

GT.FileUpload.prototype.initBindings = function () {
    var ths = this;
    var __droppedFileList = null;
    var __changeTrigeredByCode = false;

    ths.filePicker.on('change', function (e) {
        if (!__changeTrigeredByCode) {
            e.preventDefault();
            ths.changeAndDropFiles(this.files);
            //ths.droppedFiles = null;
        }
        __changeTrigeredByCode = false;
        
    });

    if(typeof isV1GT != "undefined") {
        ths.filePicker.on("dragover dragenter drop", false);
        ths.filePicker.on('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            __droppedFileList = e.originalEvent.dataTransfer.files;
    
            if (__droppedFileList.length) {
                ths.droppedFiles = ths.acceptMultiple ? __droppedFileList : [__droppedFileList[0]];
                GT.resetFileInput(ths.filePicker[0]);
                ths.changeAndDropFiles(ths.droppedFiles);
                __changeTrigeredByCode = true; 
                ths.filePicker.trigger('change');
            }
        });
    }
};

GT.FileUpload.prototype.pushFileToList = function (file) {
    var ths = this;
    var __fileName = file.name;
    var __fullName = __fileName;
    var icon = ths.attachment;

    if (__fileName.length){
        var __extension = __fileName.match(/\..{1,5}$/ig);
        var __ext = __extension ? __extension : '';

        if (__fileName.replace(__extension, '').length >= ths.maxFileNameLength) {
            __fileName = __fileName.substring(0, ths.maxFileNameLength) + '..' + __ext;
        }

        var ext_icon = __ext[0].toLowerCase();
        if(ext_icon.indexOf(".pdf") >= 0){
            icon = ths.pdf;
        }else if (ext_icon.indexOf(".doc") >= 0 || ext_icon.indexOf(".xls") >= 0){
            icon = ths.doc;
        }else if (ext_icon.indexOf(".jp") >= 0 || ext_icon.indexOf(".png") >= 0 || ext_icon.indexOf(".gif") >= 0){
            icon = ths.img;
        }

        __fileName = ths.removeEL.replace('{0}', icon + " " + __fileName).replace('{1}', __fullName);
        ths.listEL.append(__fileName);
    }
}

GT.FileUpload.prototype.changeAndDropFiles = function (files) {
    var ths = this;
    ths.listEL.html("");
    ths.filePicker.parent().parent().removeClass('ValidationFail');

    let invalidMessageElm = ths.filePicker.parent().parent().find(".Form__Element__ValidationError");

    invalidMessageElm.html("");

    if (files.length > ths.maxFile){
        GT.resetFileInput(ths.filePicker[0]);
        setTimeout(function(){
            ths.filePicker.parent().parent().addClass('ValidationFail');
            invalidMessageElm.html(ths.allowUploadMaxItemLabel + " " + ths.maxFile).show();
        }, 10);
        return false;
    } else if(ths.filePicker.data("allowedMineTypesList") || ths.filePicker.data("maxFileSize")) {
        const allowedMineTypesList = ths.filePicker.data("allowedMineTypesList").split(","),
            maxFileSize = ths.filePicker.data("maxFileSize"),
            dataTransfer = new DataTransfer();

        let wrongFiles = [],
            wrongFileSizeItems = [];

        $.each(files, function (index, file) {
            if (typeof file != "undefined") {
                let flagFail = false;

                if(allowedMineTypesList.indexOf(file.type) == -1) {
                    wrongFiles.push(" - " + file.name + " ("+ (file.type ? file.type : "unknown") +")");
                    flagFail = true;
                }  
                
                if(maxFileSize && file.size > maxFileSize * 1024) {
                    wrongFileSizeItems.push(" - " + file.name + " (" + (file.size / 1024 / 1024).toFixed(2) + "MB > " + (maxFileSize / 1024).toFixed(2) + "MB)");
                    flagFail = true;
                } 

                if(!flagFail){
                    dataTransfer.items.add(file);
                }
            }
        });

        if(wrongFiles.length || wrongFileSizeItems.length) {
            ths.filePicker.parent().parent().addClass('ValidationFail');
            let errString = [];

            if(wrongFiles.length)
                errString.push(ths.invalidMineTypes);
            
            if(wrongFileSizeItems.length)
                errString.push(ths.invalidFileSize);

            invalidMessageElm.html( errString.join("\n")).show();
        }

        ths.filePicker[0].files = dataTransfer.files;
        files = dataTransfer.files;
    }

    if(typeof ths.onChange != "undefined") {
        ths.onChange(files);
    }

    $.each(files, function (index, file) {
        if (typeof file != "undefined") ths.pushFileToList(file);
    });
};
var GTFilters = function() {
    GT.domContentLoadedFncList.push(function(){
        if(location.hash){
            var elId = location.hash.replace('#','');
            var scrollToEl = document.getElementById(elId);
            if(scrollToEl) {
                scrollToEl.scrollIntoView(true);
            }
        }
    });

    this.tabs = function () {

        
        // Convert selectors to variables
        var __container = $('.filters-container');
        var __panel = $('.tab-panel');
        var __heading = 'h3';

        // Add a class of 'active'
        // Create a container for our tabs
        $(__container).each(function (num, $container) {
            $(this).addClass('tabs-active').prepend('<ul id="tabs-' + num + '" class="second-level-filters clear"></ul>');

            // Loop through our panels...
            $(this).find(__panel).each(function (i) {

            // Two indexes to make our starting count '1'
                var __tIndex = i;
                var __pIndex = i;
                
                var __title = $(this).children('a');
                var __titleClass = __title.attr('class');
                var __titleTxt = __title[0].outerHTML;
                
                var __moreLink = '<a class="js-show-selection" href="#tab-' + num + '-' + __tIndex + '">more</a>';

                // Don't show "+" button when there's no third-level links
                if ($(this).find('> ul').length === 0) {
                    $(this).addClass('no-children');
                    __moreLink = '';
                }

                // Add our tabs, including a link with an anchor to be used for click feedback
                $('#tabs-' + num).append('<li class="' + (__moreLink.length ? '' : 'no-children') + '">' + __titleTxt + __moreLink + '</li>');

                // Add an ID to match our anchors
                $(this).attr('id', 'tab-' + num + '-' + __pIndex++).not('.active').hide();

                $(__title).hide();
            });
        });

        // Setup click event on the anchor:
        $('.second-level-filters li a.js-show-selection').click(function (e) {
            // Grab the parent of the clicked anchor
            var __clicked = $(this).parent();

            var sectionName = $(this).attr('href'),
                section = $('div' + sectionName);

            // If it isn't already selected, make it so and hide the others
            if (!__clicked.hasClass('open')) {
                __clicked
                    .addClass('open')
                    .siblings().removeClass('open');

                section.siblings('div').css({'display' : 'none'}).removeClass('active');
                section.fadeIn().addClass('active');
            }
            else {
                 __clicked.removeClass('open');
                 section.css({'display' : 'none'}).removeClass('active');
            }                      

            // Prevent the default link behaviour
            e.preventDefault();
        });

        $('li.no-children').each(function () {
            $(this).find('a:contains("(0)")').hide();
        });
    };

    this.moreFilters = function ($elem) {
        $($elem).click(function (e) {
            var thisID = "." + $(this).attr('id');
            // make the transition better
            $(thisID).slideDown("slow", function () {
                $(thisID).removeClass('less');
            });

            $(this).hide();

            return false;
        });
    };

    // define search function
    this.defineSearch = function ($elem) {
        //  hide bar
        
        $('.filters-container:not(.open)').hide();

        $elem.click(function () {
            var $this = $(this);
            if ($this.parent('li').hasClass('ctatag')) {
                return true;
            }
            var layerName = $this.attr('href'),
                layer = $('div' + layerName);

            if ($this.hasClass('active')) {
                $this.removeClass('active');
                layer.slideUp(200);
            } else {
                /* close open layers*/
                $('.filters-container').slideUp(200);
                $('.js-define-search li a').removeClass('active');

                $this.addClass('active');
                layer.slideDown(200);
            }

            return false;
        });
    };

};

GT.Filters = new GTFilters();
if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.Filters.defineSearch($('.js-define-search li a'));
        GT.Filters.moreFilters($('.more-btn'));
        GT.Filters.tabs($('.filters-container'));
    });
GT.GTFindOfficesNearYou = function () {
    let findOfficesElm = document.querySelector('.find-your__offices'),
        nearestOfficesContainerElm = document.querySelector('.nearest-offices__container'),
        nearestOfficesInputElm = document.querySelector('#nearest_offices_searchbox'),
        selectOffices = document.querySelector('.select-offices'),
        autoCompleteObj;

    if(!findOfficesElm || !nearestOfficesContainerElm || !nearestOfficesInputElm) return;

    initDropdown();
    function initDropdown() {
        let language = selectOffices.getAttribute("language");
        let offices = [];
      
        let _url = '/LocationService/GetListOffices';
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                let officesList = this.response;
                if (officesList && this.status == 200) {
                    let officesListObj = JSON.parse(officesList);
                    [].forEach.call(officesListObj, function(obj){
                        let _officesByLocationArr = obj.subData;
                        let _officeByLocationItem = _officesByLocationArr.map(function (office) { 
                            return { 
                                value: office.office, 
                                linkLocation: office.linkLocation 
                            }; 
                        });
                        
                        offices = offices.concat(_officeByLocationItem);
                    });
                }
            }
        };
        xhttp
        xhttp.open("GET", _url, true);
        xhttp.setRequestHeader("language", language);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.send();

        selectOffices.addEventListener('click', function() {
            nearestOfficesInputElm.value = "";
            if (offices.length > 0) {
                if(findOfficesElm.classList.contains('dropdown-expanded')) {
                    findOfficesElm.classList.remove('dropdown-expanded')
                } else {
                    findOfficesElm.classList.add('dropdown-expanded')
                }

                findOfficesNearYou(offices);
                nearestOfficesInputElm.focus();
            }
        });

        document.addEventListener('click', function(event) {
            let _autoCompleteSelect = event.target;
            if (!_autoCompleteSelect.closest('.nearest-offices__container') && !_autoCompleteSelect.closest('.select-offices')
                && !_autoCompleteSelect.closest('.nearest-offices_searchbox')) {
                    findOfficesElm.classList.remove('dropdown-expanded');
            }
        });
    }

    function officesLookup(query, offices) {
        let result = [];
        
        if(offices && offices.length > 0) {
            result = offices.filter(function(obj) {
                return obj.value.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
            return result;
        }
    }

    function findOfficesNearYou(offices) {
        let selectOffices = document.querySelector('.select-offices');
        let isOpenNewTab = false;
        if(selectOffices) 
            isOpenNewTab = selectOffices.getAttribute('data-openinnewtab');

        autoCompleteObj = new autoComplete({
            selector: '#nearest_offices_searchbox',
            minChars: 0,
            offsetTop: 10,
            offsetLeft: -12,
            width: 256,
            cache: 0,
            menuClass: 'nearest-offices__autocomplete-suggestions',
            source: function(term, suggest){
                term = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                let tmpArr = officesLookup(term, offices);
                suggest(tmpArr);
            },
            renderItem: function (item, search){
                // escape special characters
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                let re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item.value + '" data-link="' + item.linkLocation + '">' + item.value.replace(re, "<strong>$1</strong>") + '</div>';
            },
            onSelect: function (e, term, item) {
                findOfficesElm.classList.remove('dropdown-expanded');
                nearestOfficesInputElm.value = "";
                let link = item.getAttribute('data-link');
                if (link)
                    if (isOpenNewTab === "True") {
                        window.open(link, '_blank');
                    } else {
                        window.location = link;
                    }
            }
        })
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){	
		new GT.GTFindOfficesNearYou();
    });

GT.FlexibleBanner = function() {
    let _flexibleBannerBlocks = document.querySelectorAll('.flexible-banner__block');
    [].forEach.call(_flexibleBannerBlocks, function(_flexibleBannerBlock) {
        if(!_flexibleBannerBlock) return;
        let _ctaButton = _flexibleBannerBlock.querySelector('.flexible-cta__button');
        _ctaButton?.addEventListener("click", function(e) {
            let currentTarget = e.currentTarget || e.target,
            _ctaLink = currentTarget.href || currentTarget.dataset.anchor;
            let _currentPageHasBannerUrl = window.location.href;
            let _ctaText = this.innerText;
            dataLayer.push({
                'bannerName': "Flexible banner",
                'bannerLink': _currentPageHasBannerUrl,// link of the page that contain the banner
                'bannerCTAText': _ctaText,
                'CTAURL': _ctaLink,
                'event': 'bannerCTA'
            });
        })
    });
}

GT.domContentLoadedFncList.push(function(){
    GT.FlexibleBanner();
});
GT.FlexibleVideoBannerBlocks = function($element, obj) {
    $element.each(function(index, element) {
        new GT.FlexibleVideoBannerBlock(element, obj);
        return false;
    });
};

GT.FlexibleVideoBannerBlock = function(element, obj) {
    var _this = this;
    var _iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var _iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    var _isMobile = /Mobi/.test(navigator.userAgent) && !window.MSStream;

    _this.intervalId = null;
    _this.hideTimeout = obj.settings.hideTimeout || video.data("hide-timeout");
    _this.forceLoadOnMobile = obj.settings.forceLoadOnMobile || false;
    _this.videoArray = [];
    _this.isIOS = _iOS;
    _this.isMobile = _isMobile;
    _this.videoArray.push(element);

    if (_iOS && _iPhone && iOSversion() === 10) {
        $(element).addClass('ios10-video-fullscreen');
    }
    _this.loadVideo();

    function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return parseInt(v[1], 10);
        }
    }
    
};

GT.FlexibleVideoBannerBlock.prototype.hideVideoAfterTimeout = function(video) {
    var _this = this;
    var currentVideo = video[0];
    currentVideo.pause();
    video.parent().removeClass("video-playing").removeClass("showing-video");
    if (_this.isIOS || _this.isMobile) {
        if (typeof(currentVideo.webkitExitFullscreen) !== "undefined") {
            currentVideo.webkitExitFullscreen();
        } else if (typeof(currentVideo.mozCancelFullscreen) !== "undefined") {
            currentVideo.mozCancelFullscreen();
        } else if (typeof(currentVideo.exitFullscreen) !== "undefined") {
            currentVideo.exitFullscreen();
        }
    }
};

GT.FlexibleVideoBannerBlock.prototype.playWhenLoaded = function(video) {
    var _this = this;
    var currentVideo = video[0];
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');

    _this.checkAutoPlay(video);

    //only on IOS
    currentVideo.addEventListener('webkitendfullscreen', function(e) {
        video.parent().removeClass("video-playing");
        $playBtn.show();
    });

    //container
    $container[0].addEventListener('click', function(e) {
        if (e.target.classList.contains('js-play-video-button')){
            _this.playVideo(video);
        }
        else if ($container[0].classList.contains("flexible-video__banner") && (video.parent()[0].classList.contains('video-pause') || video.parent()[0].classList.contains('video-playing'))){
            if (!e.target.classList.contains('link') && !e.target.classList.contains('video-controls')){
                if (video.parent().hasClass("video-pause")){
                    _this.playVideo(video);
                }else{
                    _this.pauseVideo(video);
                }
            }
        }
    });
};

GT.FlexibleVideoBannerBlock.prototype.playVideo = function(video) {
    var _this = this;
    var currentVideo = video[0];
    currentVideo.play();
    video.parent().addClass("video-playing").removeClass("video-pause");
    _this.counterTimer(video);
}

GT.FlexibleVideoBannerBlock.prototype.pauseVideo = function(video) {
    var _this = this;
    var currentVideo = video[0];
    currentVideo.pause();
    video.parent().addClass("video-pause").removeClass("video-playing");
    
    _this.hideTimeout = parseInt(video.attr("data-hide-timeout"));
    if (_this.intervalId)
        clearInterval(_this.intervalId);
}

GT.FlexibleVideoBannerBlock.prototype.loadVideo = function() {
    var _this = this;
    _this.videoArray.map(function(video) {
        var _video = $(video);
        video.load();
        _this.playWhenLoaded(_video);
    });
};

GT.FlexibleVideoBannerBlock.prototype.showPlayButton = function(video) {
    var _this = this;
    var currentVideo = video[0];
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');

    $playBtn.addClass('is-show');
    $playBtn[0].addEventListener('click', function() {
        if (_this.videoTimeOut) {
            clearTimeout(_this.videoTimeOut);
        }
        //_this.hideVideoAfterTimeout(video);
        video.parent().addClass("video-playing").addClass("showing-video");
        _this.counterTimer(video);
        $playBtn.hide();
        if (_this.isIOS || _this.isMobile) {
            //for android only
            if (!_this.isIOS) {
                var isPlaying = true;
                var showBtn = function() {
                    if (!isPlaying) {
                        screen.orientation.unlock();
                        isPlaying = true;
                        video.parent().removeClass("video-playing");
                        $playBtn.show();
                    } else if (isPlaying) {
                        isPlaying = false;
                    }
                };
                screen.orientation.lock("portrait-primary");
                currentVideo.removeEventListener('webkitfullscreenchange', showBtn);
                currentVideo.addEventListener('webkitfullscreenchange', showBtn);
            }
            currentVideo.play();
            if (typeof(currentVideo.webkitEnterFullscreen) !== "undefined") {
                currentVideo.webkitEnterFullscreen();
            } else if (typeof(currentVideo.webkitRequestFullscreen) !== "undefined") {
                currentVideo.webkitRequestFullscreen();
            } else if (typeof(currentVideo.mozRequestFullScreen) !== "undefined") {
                currentVideo.mozRequestFullScreen();
            }
            return;
        }
        currentVideo.play();
    });
};

GT.FlexibleVideoBannerBlock.prototype.checkAutoPlay = function(video) {
    var _this = this;
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');
    var s = window['Promise'] ? window['Promise'].toString() : '';
    if (s.indexOf('function Promise()') !== -1 || s.indexOf('function ZoneAwarePromise()') !== -1) {
        //Add a surrounding try catch for browser that could not evaluate promise
        try {
            video[0].play().then(function() {
                    if(!$container.hasClass("mobius") && !$container.hasClass("bg-gradient-animate"))
                        $container.find('.background-underlay').hide();
                    $playBtn.hide();
                    video.parent().addClass("video-playing").addClass("showing-video");
                    _this.counterTimer(video);
                    //_this.hideVideoAfterTimeout(video);
                })
                .catch(function(error) {
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (error.name === "NotAllowedError" || (error.name === "AbortError" && isSafari)) {
                        _this.showPlayButton(video);
                    }
                });
        } catch (error) {
            _this.showPlayButton(video);
        }
    } else {
        _this.showPlayButton(video);
    }
};

GT.FlexibleVideoBannerBlock.prototype.counterTimer = function(video) {
    var _this = this;
    if (video.attr("data-hide-timeout") >= 0){
        var counter = 0;
        _this.intervalId = setInterval(function() {
            counter++;
            // Display 'counter' wherever you want to display it.
            var timeplay = parseInt(_this.hideTimeout - counter);
            video.attr("data-hide-timeout", timeplay);

            if (counter == _this.hideTimeout) {
                // Display a login box
                clearInterval(_this.intervalId);
                _this.hideVideoAfterTimeout(video);
            }
        }, 1000);
    }
}

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        [
            { elm: $('.flexible-video__banner .video-background'), settings: { hideTimeout: 60 } }
        ].map(function (item) {
            if (item.elm.length) {
                new GT.FlexibleVideoBannerBlocks(item.elm, item);
            }
        })
    });

GT.Footer = function ($element) {
    let COLLAPSE_EXPAND_BUTTON_SELLECTOR = '.footer-nav__title';
    let FOOTER_NAV_MENU = '.footer-nav__menu';
    let FOOTER_NAV_MENU_EXPANDED_CLASS = 'footer-nav__menu--expanded';

    footerNavCollapse();

    function footerNavCollapse() {
        if (GT.isMobile()) {
            let _footerLinkList = document.querySelector('.footer-link-list');
            if(!_footerLinkList) return;

            let _footerNavLinkItems = _footerLinkList.querySelectorAll(COLLAPSE_EXPAND_BUTTON_SELLECTOR);
            
            [].forEach.call(_footerNavLinkItems, function(linkItem) {
                linkItem.addEventListener("click", function() {
                    if (window.screen.width <= 767) {
                        let _this = this;
                        let _footerNavParent = _this.closest(FOOTER_NAV_MENU);
                        _footerNavParent.classList.toggle(FOOTER_NAV_MENU_EXPANDED_CLASS);
                        let _collapseButton = _this.querySelector('.collapse-expand__btn');
                        if(_footerNavParent.classList.contains(FOOTER_NAV_MENU_EXPANDED_CLASS)) {
                            _collapseButton.setAttribute('aria-expanded', 'true');
                        } else {
                            _collapseButton.setAttribute('aria-expanded', 'false');
                        }
                    }
                });
            });
        }
    }
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.Footer($('footer'));
    });

GT.FormSelect = function (elms, obj) {
    let open = false;

    function checkOrientation(elm) {
        if(!elm.initialized) {  
            elm.initialized = true;
            window.addEventListener("orientationchange", function () {
                elm.blur();
            }, false);
        }
    }


    Array.from(elms).forEach(function (elm) {
        const select = elm.querySelector('select');

        // Create select-text div
        const selectTextDiv = document.createElement('div');
        selectTextDiv.className = 'select-text';
        selectTextDiv.setAttribute('aria-hidden', 'true');
        selectTextDiv.textContent = select.options[select.selectedIndex].textContent;
        elm.insertBefore(selectTextDiv, elm.firstChild);

        // Add error class if select has errors class
        if (select.classList.contains("errors")) {
            selectTextDiv.classList.add("errors");
        }

        // Handle change event
        select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            selectTextDiv.textContent = selectedOption.text;
        });

        // Handle click event
        select.addEventListener('click', function () {
            open = !open;
            checkOrientation(this);
        });

        
        select.addEventListener('keydown', function (e) {
            if(e.key.includes('Arrow')) {
                e.preventDefault();
                // Open the select dropdown by triggering the native dropdown
                this.focus();
                // Use the showPicker method if available (modern browsers)
                if (typeof this.showPicker === 'function') {
                    this.showPicker();
                } else {
                    // Fallback: simulate a click to open the dropdown
                    setTimeout(() => {
                        this.click();
                    }, 0);
                }
            }
        });

        // Handle blur event
        select.addEventListener('blur', function () {
            if (open) {
                open = !open;
            }
        });
    });
};

if (typeof isV1GT == "undefined") {
    GT.domContentLoadedFncList.push(function(){
        GT.FormSelect(document.querySelectorAll('.form-select'));
    });
}
GT.GTMGlobal = (function(){
    let fncList = {
        clickBlock: clickEvtBlock,
        megaMenuV3: megaMenuV3ClickEvt,
        megaMenu: megaMenuClickEvt,
        megaMenuV1Mobile: megaMenuClickEvtV1Mobile,
        globalSearch: globalSearch
    };

    function clickEvtBlock() {
        document.querySelectorAll("[data-tracking-block]").forEach(elm => {
            elm.querySelectorAll("a, [data-anchor]").forEach(anchorElm => {
                anchorElm.addEventListener("click", (e) => {
                    let link = e.target.href || e.currentTarget.href || (e.target.dataset && e.target.dataset.anchor) || (e.currentTarget.dataset && e.currentTarget.dataset.anchor),
                        allowTracking = false;

                    if(document.querySelector(".home-page-container"))
                        allowTracking = true;

                    if(link && allowTracking)
                        dataLayer.push({ 
                            'event': 'block_view',
                            'blockName': elm.dataset.trackingBlock, 
                            'blockLink': link
                        });
                })
            })
        })
    }

    function megaMenuV3ClickEvt() {
        setTimeout(() => {
            document.querySelectorAll(".nav3 a, .nav3 [data-anchor]").forEach(elm => {
                if (!elm.dataset.initializedTracking) {
                    elm.dataset.initializedTracking = true;
                    elm.addEventListener("click", (e) => {
                        let currentTarget = e.currentTarget || e.target,
                            link = currentTarget.href || currentTarget.dataset.anchor,
                            containerClick = "level 1",
                            menuLevel_1 = "",
                            menuLevel_2 = "",
                            menuLevel_3 = "";

                        if (currentTarget.closest(".level-1")) {
                            menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                        }

                        if (currentTarget.closest(".bleed")) {
                            if (currentTarget.closest(".mega__level--2")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.closest(".mega__level--2").querySelector(".mega-link--level-2")?.innerText;
                            }
                            if (!menuLevel_1)
                                menuLevel_1 = currentTarget.closest(".bleed")?.dataset.content;
                        }

                        if (currentTarget.closest(".mega-link--level-3")) {
                            if (currentTarget.closest(".mega-link--level-2-placeholder")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.dataset.linktext ? currentTarget.dataset.linktext : currentTarget.innerText;
                            } else {
                                containerClick = "level 3";
                                menuLevel_3 = currentTarget.innerText;
                            }
                        }

                        if (currentTarget.closest(".header-logo")) {
                            containerClick = "logo";
                        }

                        if (currentTarget.closest(".message-top-banner__message")) {
                            containerClick = "top banner";
                        }

                        if (currentTarget.closest(".additional-link") || currentTarget.closest(".externalLoginButton") || (currentTarget.closest(".mobile__footer") && !currentTarget.closest(".list__global") && !currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = currentTarget.textContent?.trim();
                        }

                        if (currentTarget.closest(".site-language") || (currentTarget.closest(".lang__elem") && currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = "language";
                        }

                        if (currentTarget.closest(".local-site-link")) {
                            containerClick = "header";
                            menuLevel_1 = "member firm";
                        }

                        if (link) {
                            dataLayer.push({
                                'event': 'menu_click',
                                'containerClick': containerClick,
                                'menuLevel_1': menuLevel_1 || "",
                                'menuLevel_2': menuLevel_2 || "",
                                'menuLevel_3': menuLevel_3 || "",
                                'containerLink': link
                            });
                        }
                    })
                }
            })
        }, 1000)
    }

    function megaMenuClickEvt(){
        setTimeout(() => {
            document.querySelectorAll("header a, header [data-anchor]").forEach(elm => {
                if(!elm.dataset.initializedTracking) {
                    elm.dataset.initializedTracking = true;
                    elm.addEventListener("click", (e) => {
                        let currentTarget = e.currentTarget || e.target,
                            link = currentTarget.href || currentTarget.dataset.anchor,
                            containerClick = "level 1",
                            menuLevel_1 = "",
                            menuLevel_2 = "",
                            menuLevel_3 = "";

                        if(currentTarget.closest(".mobile__wrap") && !currentTarget.closest(".mobile__footer")) return;//NAV V1 Mobile

                        if(currentTarget.closest(".level-1")) {
                            menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                        }

                        if(currentTarget.closest(".bleed")) {
                            if(
                                (currentTarget.closest(".bleed__col--left") && !currentTarget.closest(".mega-header") && !currentTarget.matches(".mega-link--has-submenu, .group-name-text"))
                                || 
                                (currentTarget.closest(".mega__level--3") && !currentTarget.closest(".bleed").querySelector(".group-name-text.selected"))
                            ) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.closest(".mega-link--level-2")?.innerText || currentTarget.closest(".bleed").querySelector(".bleed__col--left .selected .mega-link--level-2")?.innerText || currentTarget.closest(".bleed").querySelector(".bleed__col--left .mega-link--level-2.active")?.innerText;
                            }
                            if(!menuLevel_1)
                                menuLevel_1 = currentTarget.closest(".bleed")?.dataset.content;
                        }

                        if(currentTarget.closest(".mega__level--3") && !currentTarget.closest(".mega-header") && !currentTarget.closest("span.h3")) {
                            containerClick = "level 3";
                            menuLevel_3 = currentTarget.innerText;
                        }

                        if(currentTarget.closest(".article-tile")) {
                            containerClick = "Related-Insight";
                            menuLevel_3 = "";
                        }

                        if(currentTarget.closest(".header-logo")) {
                            containerClick = "logo";
                        }

                        if(currentTarget.closest(".message-top-banner__message")) {
                            containerClick = "top banner";
                        }

                        if(currentTarget.closest(".additional-link") || currentTarget.closest(".externalLoginButton") || (currentTarget.closest(".mobile__footer") && !currentTarget.closest(".list__global") && !currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = currentTarget.textContent?.trim();
                        }

                        if(currentTarget.closest(".site-language") || (currentTarget.closest(".lang__elem") && currentTarget.hreflang)) {
                            containerClick = "header";
                            menuLevel_1 = "language";
                        }

                        if(currentTarget.closest(".local-site-link")) {
                            containerClick = "header";
                            menuLevel_1 = "member firm";
                        }

                        if(link) {
                            dataLayer.push({ 
                                'event': 'menu_click',
                                'containerClick': containerClick,
                                'menuLevel_1': menuLevel_1 || "",
                                'menuLevel_2': menuLevel_2 || "",
                                'menuLevel_3': menuLevel_3 || "",
                                'containerLink': link
                            });
                        }
                    })
                }
            })
        }, 1000)
    }

    function megaMenuClickEvtV1Mobile() {
        function triggerTracking() {
            setTimeout(() => {
                document.querySelectorAll(".mobile__wrap a, .mobile__wrap [data-anchor]").forEach(elm => {
                    if(!elm.dataset.initialized) {
                        elm.dataset.initialized = true;
                        elm.addEventListener("click", (e) => {
                            triggerTracking();
                            let currentTarget = e.currentTarget || e.target,
                                link = currentTarget.href || currentTarget.dataset.anchor,
                                containerClick = "level 1",
                                menuLevel_1 = "",
                                menuLevel_2 = "",
                                menuLevel_3 = "";

                            if(!currentTarget.closest(".mobile__wrap") || currentTarget.closest("[aria-haspopup]")) return;//NAV V1 Mobile

                            if(currentTarget.closest(".level-1")) {
                                menuLevel_1 = currentTarget.closest(".nav-link")?.innerText;
                            }

                            if(currentTarget.closest(".mobile__level--2") && !currentTarget.closest(".mobile__level--2").querySelector(".group-name-text.mega-link")) {
                                containerClick = "level 2";
                                menuLevel_2 = currentTarget.innerText;
                                menuLevel_1 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--1 [aria-expanded=true]")?.innerText;
                            }

                            if(currentTarget.closest(".mobile__level--3")) {
                                containerClick = "level 3";
                                menuLevel_3 = currentTarget.innerText;
                                menuLevel_1 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--1 [aria-expanded=true]")?.innerText;
                                menuLevel_2 = currentTarget.closest(".mobile__wrap")?.querySelector(".mobile__level--2 [aria-expanded=true]")?.innerText;
                            }
            
                            if(currentTarget.closest(".article-tile")) {
                                containerClick = "Related-Insight";
                                menuLevel_3 = "";
                            }

                            if(link) {
                                dataLayer.push({ 
                                    'event': 'menu_click',
                                    'containerClick': containerClick,
                                    'menuLevel_1': menuLevel_1 || "",
                                    'menuLevel_2': menuLevel_2 || "",
                                    'menuLevel_3': menuLevel_3 || "",
                                    'containerLink': link
                                });
                            }
                        })
                    }
                })
            }, 1000)
        }
        document.querySelector("header:not(.nav2) .menu-toggle")?.addEventListener("click", (e) => {
            triggerTracking();
        })
    }

    function globalSearch(){

        const __TYPE_POPULAR = "Popular searches",
            __TYPE_PREVIOUS = "Previous searches",
            __TYPE_RECENT = "Recently visited",
            __TYPE_SUGGESTION = "Search suggestions",
            __TYPE_YOUR_RESULTS = "Your Results",
            __TYPE_ALL_RESULTS = "See all results",
            __TYPE_SITE_SEARCH = "Site Search";

        function pushData(search_term, search_type, search_link, search_text){
            if(search_link && search_type)
                dataLayer.push({
                    'search_term': search_term,
                    'search_type': search_type,
                    'search_link': search_link,
                    'search_text': search_text,
                    'event': 'search_used'
                });
        }

        document.querySelectorAll("#previous-search__container a, .popular-search__container a, .recently-visited__container a, .suggestions-search__container a").forEach(item => {
            if(!item.dataset.initialized) {
                item.addEventListener("click", e => {
                    let currentElm = e.currentTarget || e.target;
                    let searchType = "",
                        searchText = currentElm.innerText,
                        searchTerm = document.querySelector("#searchField")?.value || "";

                    if(currentElm.closest(".search-contents__container.popular-search__container")) searchType = __TYPE_POPULAR;
                    if(currentElm.closest("#previous-search__container")) searchType = __TYPE_PREVIOUS;
                    if(currentElm.closest(".recently-visited__container")) searchType = __TYPE_RECENT;
                    if(currentElm.closest(".suggestions-search__container")) searchType = __TYPE_SUGGESTION;
                    if(currentElm.closest(".has-search__results")) searchType = __TYPE_YOUR_RESULTS;
                    if(currentElm.closest(".viewall-results")) searchText = __TYPE_ALL_RESULTS;
                    if([__TYPE_POPULAR, __TYPE_PREVIOUS, __TYPE_RECENT].indexOf(searchType) >= 0) searchTerm = "";
                    if(searchType) pushData(searchTerm, searchType, currentElm.href, searchText);
                })
                item.dataset.initialized = true;
            }
        })

        let currentFormx = document.querySelector(".header-search__form");
        if(currentFormx && !currentFormx.dataset.initialized) {
            currentFormx.dataset.initialized = true;
            currentFormx.addEventListener("submit", function(e) {
                let currentElm = e.currentTarget || e.target;
                let searchText = currentElm.querySelector("#searchField")?.value;
                const queryString = new URLSearchParams(new FormData(currentElm)).toString()
                pushData(searchText, __TYPE_SITE_SEARCH, currentElm.action + "?" + queryString, searchText);
            })
        }
    }

    return fncList;
});

GT.domContentLoadedFncList.push(function(){
    GT.GTMGlobal = GT.GTMGlobal();
    Object.keys(GT.GTMGlobal).forEach(function(key){
        GT.GTMGlobal[key]();
    })
})
GT.GTMTracking = (function(){
    let fncList = {
        ".t6-page": t6MemberFirm,
        ".articleinlineblock": articleInlineBlock
    };

    function t6MemberFirm(){
        document.querySelectorAll('.t6-page a[href^="tel:"]').forEach(function(item){
            item.addEventListener("click", function(e){
                dataLayer.push({ 'event': 'member firm - click to call', 'eventAction': "phone click", "eventLabel": (firmName ? firmName + " - " : "" ) + e.target.innerText });
            })
        })
        document.querySelectorAll('.t6-page .email-icon, .t6-page .email-link').forEach(function(item){
            item.addEventListener("click", function(e){
                dataLayer.push({ 'event': 'member firm - profile click', 'eventAction': "profile click", "eventLabel": (firmName ? firmName + " - " : "" ) + e.target.href.replace("mailto:", "") });
            })
        })
        document.querySelectorAll('.t6-page .linklistitemblock a').forEach(function(item){
            item.addEventListener("click", function(e){
                dataLayer.push({ 'event': 'member firm - deep link click', 'eventAction': "member deep link click", "eventLabel": (firmName ? firmName + " - " : "" ) + e.target.href });
            })
        })

        let t6PageTitle = document.querySelector(".t6-page .main-title").innerText || "Unknown Firm";
        document.querySelectorAll(".t6-page .ibc-contact a").forEach(function(item) {
            item.addEventListener("click", function(ev){
                let item = ev.target;
                let peopleName = item.closest(".contact-details").querySelector(".ibc-suggested__title");
                    peopleName = peopleName ? peopleName.innerText : "Unknown People";

                dataLayer.push({ 'event': 'ibcd', 'eventAction': 'selected_member_firm', 'eventLabel': t6PageTitle + " / " + peopleName});
            })
        })
    }

    function articleInlineBlock(){
        document.querySelectorAll('.inline-article__item .inline-article__readmore').forEach(function(item){
            item.addEventListener("click", function(e){
                const articleInlineBlockTitle = e.target.closest(".inline-article__contents").querySelector(".inline-article__title").innerText;
                dataLayer.push({ 'event': 'Inline CTA - Webinar', 'eventAction': "click", "eventLabel": articleInlineBlockTitle });
            })
        })
    }

    return fncList;
});

GT.domContentLoadedFncList.push(function(){
    GT.GTMTracking = GT.GTMTracking();
    Object.keys(GT.GTMTracking).forEach(function(key){
        if(document.querySelector(key)) {
            GT.GTMTracking[key]();
        }
    })
})
GT.GatedArticleForm = function ($element) {
	$element.each(function (index, element) {
		var epiForm = $(element).find("form")[0];
		if (!epiForm)
			return;
		var formId = $(element).find("#gatedArticleBlockId").val();
		if (!formId)
			return;
		var currentPageId = $(element).find("input[name=__FormHostedPage]").val();
		if (!currentPageId)
			return;

		var localStorageId = "GatedArticleForm" + formId;
		if (typeof $$epiforms !== 'undefined') {
			$$epiforms(document).ready(function myfunction() {
				checkElementHeight($(element));
				checkButtonPosition($(element));
				var objGatedForm = '';
				$$epiforms(epiForm).on("formsStartSubmitting",
					function (event) {
						objGatedForm = $(epiForm).find(":input:not(:hidden)").serialize();
						console.log(objGatedForm);
						delete objGatedForm["__RequestVerificationToken"];
					});
				$$epiforms(epiForm).on("formsSubmitted", function (data) {
					// run only if the form is finalized and submitted at the last step
					if (data.isFinalizedSubmission) {
						$(element).find(".Form__Description").css('display', 'none');
						localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));
						setCookie(formId, 'gatedarticleformids');
						setCookie(currentPageId, 'gatedarticleids');
						location.reload();
					}
				});
				if (isIE() && $(element).closest('.t13-page').length > 0 && $(element).closest('.t13-page--bottom').length === 0) {
					var screenWidth = $(window).width();
					var containerWidth = $('.t13-page > .container').width();
					var left = ((screenWidth - containerWidth) / 2) * -1;
					$(element).css('width', '100vw');
					if (isRTL()) {
						$(element).css('right', (left) + 'px');
					} else {
						$(element).css('left', (left) + 'px');
					}
					$(element).find('.container').first().css('width', containerWidth + 'px');
				}
			});
		}
		var storedGatedArticleForm = JSON.parse(localStorage.getItem(localStorageId));
		if (storedGatedArticleForm)
			$(epiForm).deserialize(storedGatedArticleForm);

	});

	function setCookie(cookieValue, cookieName) {
		var currentCookie = GT.Cookies.getCookie(cookieName);
		if (currentCookie) {
			if (!currentCookie.includes(cookieValue))
				GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
		} else {
			GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
		}
	}

	function isIE() {
		return /MSIE|Trident/.test(navigator.userAgent);
	}

	function isRTL() {
		return $('body').hasClass('RTL');
	}

	function checkElementHeight($el) {
		if (window.screen.width <= 768) return;
		var $blockContent = $el.find('.block--content');
		if (!$blockContent.hasClass('even')) return;
		var $formElements = $blockContent.find('div.Form__Element');
        if (!$formElements.length) return;
        if ($formElements.parents('.epi-form-row').length > 0) return;
		for (var i = 1; i < $formElements.length; i += 2) {
			var $element = $formElements.eq(i);
			var $prevElement = $formElements.eq(i - 1);
			var currentHeight = $element.height();
			var previousHeight = $prevElement.height();
			if (currentHeight > previousHeight) {
				$prevElement.css('min-height', currentHeight);
			} else if (currentHeight < previousHeight) {
				$element.css('min-height', previousHeight);
			}
		}
	}

	function checkButtonPosition($el) {
		var $blockContent = $el.find('.block--content');
		if ($blockContent.hasClass('even')) {
			var $formStep = $blockContent.find('.FormStep *');
			var lastItem = $formStep.last();
			if (lastItem.is('input[type="hidden"]')) {
				var closeTolast = $formStep.eq($blockContent.length - 2);
				if (closeTolast.is('button')) {
					if (isRTL()) closeTolast.css('margin-right', '0px');
					else closeTolast.css('margin-left', '0px');
				}
			}
		} else {
			var $checkBoxes = $blockContent.find('.FormChoice');
			$.each($checkBoxes, function (index, element) {
				var $button = $(element).prev('button');
				if ($button.length > 0) {
					var mgTop = $button.css('margin-top');
					if (mgTop) {
						$(element).css('margin-top', mgTop);
					}
				}
			});
		}
	}
};
if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
        new GT.GatedArticleForm($('.js-article-gated-form'));
    });

GT.GatedArticleMarketoForm = function ($element) {

    $element.each(function (index, element) {

        var epiForm = $(element).find("form")[0];
        if (!epiForm)
            return;
        var formId = $(element).find("#gatedArticleMarketoBlockId").val();
        if (!formId)
            return;

        var currentPageId = $(element).find("#gatedArticleMarketoPageId").val();
        if (!currentPageId)
            return;

        var localStorageId = "GatedArticleMarketoForm" + formId;

        MktoForms2.whenReady(function (form) {
            var maketoForm = form.getFormElem();
            if (maketoForm && maketoForm.length) {
                form.onSubmit(function (e) {
                    var maketoFormSubmit = e.getFormElem();
                    if(maketoFormSubmit && maketoFormSubmit.length) {
                        var objGatedForm = $(maketoFormSubmit).find(":input:not(:hidden)").serialize();
                        localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));
                        setGatedArticleMarketoFormCookie(formId, 'gatedarticlemarketoformids');
                        setGatedArticleMarketoFormCookie(currentPageId, 'gatedarticlemarketoids');

                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                });

                var storedGatedForm = JSON.parse(localStorage.getItem(localStorageId));
                if (storedGatedForm)
                    $(epiForm).deserialize(storedGatedForm);

                switchBgBasedOnHeight($(element));
            }
        });
    });

    function setGatedArticleMarketoFormCookie(cookieValue, cookieName) {
        var currentCookie = GT.Cookies.getCookie(cookieName);
        if (currentCookie) {
            if (!currentCookie.includes(cookieValue))
                GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
        } else {
            GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
        }
    }

    function prepareForm($el) {
        var $formRows = $el.find('.mktoFormRow');
        var $form = $el.find('.marketo-embed-form');
        $form.removeClass('banner-form bg-inverse__green bg-inverse__purple bg-inverse__grey bg-inverse__orange bg-inverse__teal bg-inverse__light');
        var elCount = 0;
        $.each($formRows, function (index, el) {
            elCount++;
            if ($(el).find('input[type="hidden"]').length > 0) {
                $(el).css('display', 'none');
                elCount--;
            }
            if ($(el).find('.mktoCheckboxList').length > 0) {
                $(el).addClass('gt-mktoCheckbox');
                if ($('body').hasClass('RTL')) {
                    var $fieldWrap = $(el).find('.mktoFieldWrap');
                    var $label = $fieldWrap.find('label.mktoLabel');
                    var $checkBoxList = $fieldWrap.find('.mktoCheckboxList');
                    var innerHtml = $label[0].outerHTML;
                    $label.remove();
                    $checkBoxList.after(innerHtml);
                }
            }
        });
        if (elCount % 2 === 0) $el.addClass('even');
        $el.css('opacity', '1');
    }

    function switchBgBasedOnHeight($el) {
        var $blockImage = $el.find('.block--image');
        if ($blockImage.length > 0) {
            var heightBreakpoint = 374;
            var formHeight = $el.height();
            var $smallImageInput = $el.find('.smallImageUrl');
            var $bigImageInput = $el.find('.bigImageUrl');
            if ($smallImageInput.length === 0 && $bigImageInput.length === 0) return;
            var smallImageUrl = $smallImageInput.length > 0 ? $smallImageInput.val() : undefined;
            var bigImageUrl = $bigImageInput.length > 0 ? $bigImageInput.val() : undefined;
            var imageUrl = bigImageUrl ? bigImageUrl : smallImageUrl;
            var finalUrl = formHeight > heightBreakpoint ? bigImageUrl : smallImageUrl;
            if (!finalUrl) finalUrl = imageUrl;
            $blockImage.css('background-image', 'url(' + finalUrl + ')');
        }
    }
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.GatedArticleMarketoForm($('.js-article-gated-marketo-form'));
    });
GT.GatedPdfForm = function ($element) {

	$element.each(function (index, element) {
		var downloadLink = $(element).find(".fileDownloadLink").val();
		if (downloadLink) {
			//download with favico
			var anchor = document.createElement('a');
			anchor.setAttribute('href', downloadLink);
			anchor.setAttribute('download', '');

			// Create event
			var ev = document.createEvent("MouseEvents");
			ev.initMouseEvent("click", true, false, self, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

			// Fire event
			anchor.dispatchEvent(ev);
			// window.location = downloadLink;
		}
		var epiForm = $(element).find("form")[0];
		if (!epiForm)
			return;
		var formId = $(element).find(".richTextWithGatedPdfBlockId").val();
		if (!formId)
			return;
		var localStorageId = "GatedPdfForm" + formId;
		if (typeof $$epiforms !== 'undefined') {
			$$epiforms(document).ready(function myfunction() {
				if(!$element.parents('.tinymce-page__text .tinymce-wrapper')) {
					checkElementHeight($(element));
				}
				checkButtonPosition($(element));
				$$epiforms(epiForm).on("formsStartSubmitting",
					function (event) {
						var objGatedForm = $(epiForm).find(":input:not(:hidden)").serialize();
						console.log(objGatedForm);
						delete objGatedForm["__RequestVerificationToken"];
						localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));
					});
				$$epiforms(epiForm).on("formsSubmitted", function (data) {
					$(element).find(".Form__Description").css('display','none');
				});
				if (isIE() && $(element).closest('.t13-page').length > 0 && $(element).closest('.t13-page--bottom').length === 0) {
					var screenWidth = $(window).width();
					var containerWidth = $('.t13-page > .container').width();
					var left = ((screenWidth - containerWidth) / 2) * -1;
					$(element).css('width', '100vw');
					if (isRTL()) {
						$(element).css('right', (left) + 'px');
					} else {
						$(element).css('left', (left) + 'px');
					}
					$(element).find('.container').first().css('width', containerWidth + 'px');
				}
			});
			var currentPageUrl = $(element).find(".currentPageUrl").val();
			if (currentPageUrl)
				$(epiForm).find("input[gated-content]").val(currentPageUrl);
		}
		var storedGatedPdfForm = JSON.parse(localStorage.getItem(localStorageId));
		if (storedGatedPdfForm)
			$(epiForm).deserialize(storedGatedPdfForm);

	});

	function isIE() {
		return /MSIE|Trident/.test(navigator.userAgent);
	}

	function isRTL() {
		return $('body').hasClass('RTL');
	}

	function checkElementHeight($el) {
		if (window.screen.width <= 768) return;
		var $blockContent = $el.find('.block--content');
		if (!$blockContent.hasClass('even')) return;
		var $formElements = $blockContent.find('div.Form__Element');
		if (!$formElements.length) return;
		for (var i = 1; i < $formElements.length; i += 2) {
			var $element = $formElements.eq(i);
			var $prevElement = $formElements.eq(i - 1);
			var currentHeight = $element.height();
			var previousHeight = $prevElement.height();
			if (currentHeight > previousHeight) {
				$prevElement.css('min-height', currentHeight);
			} else if (currentHeight < previousHeight) {
				$element.css('min-height', previousHeight);
			}
		}
	}

	function checkButtonPosition($el) {
		var $blockContent = $el.find('.block--content');
		if ($blockContent.hasClass('even')) {
			var $formStep = $blockContent.find('.FormStep *');
			var lastItem = $formStep.last();
			if (lastItem.is('input[type="hidden"]')) {
				var closeTolast = $formStep.eq($blockContent.length - 2);
				if (closeTolast.is('button')) {
					if (isRTL()) closeTolast.css('margin-right', '0px');
					else closeTolast.css('margin-left', '0px');
				}
			}
		} else {
			var $checkBoxes = $blockContent.find('.FormChoice');
			$.each($checkBoxes, function (index, element) {
				var $button = $(element).prev('button');
				if ($button.length > 0) {
					var mgTop = $button.css('margin-top');
					if (mgTop) {
						$(element).css('margin-top', mgTop);
					}
				}
			});
		}
	}
};
if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
        new GT.GatedPdfForm($('.js-gated-form'));
    });
GT.GatedPdfMarketoForm = function($element) {

    $element.each(function(index, element) {
        var downloadLink = $(element).find(".fileDownloadLink").val();
        if (downloadLink) {
            // window.location = downloadLink;
            //download with favico
			var anchor = document.createElement('a');
			anchor.setAttribute('href', downloadLink);
			anchor.setAttribute('download', '');

			// Create event
			var ev = document.createEvent("MouseEvents");
			ev.initMouseEvent("click", true, false, self, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

			// Fire event
			anchor.dispatchEvent(ev);
            $(element).css('display', 'block');
        }
        
        var formId = $(element).find(".richTextWithGatedPdfBlockId").val();
        if (!formId)
            return;
        var localStorageId = "GatedPdfForm" + formId;

        var currentPageUrl = $(element).find(".currentPageUrl").val();
        if (currentPageUrl && typeof MktoForms2 !== 'undefined') {
            setTimeout(function() {
                MktoForms2.whenReady(function(form) {
                    var maketoForm = form.getFormElem();
                    if (maketoForm && maketoForm.length) {
                        let gatedDownloadUrlElm = maketoForm.find('input[name=gatedDownloadUrl]');
                        if(gatedDownloadUrlElm && gatedDownloadUrlElm.length) gatedDownloadUrlElm.val(currentPageUrl);
                        
                        form.onSubmit(function(e) {
                            var maketoFormSubmit = e.getFormElem();
                            if(maketoFormSubmit && maketoFormSubmit.length) {
                                var objGatedForm = $(maketoFormSubmit).find(":input:not(:hidden)").serialize();
                                localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));
                            }
                        });

                        var storedGatedPdfForm = JSON.parse(localStorage.getItem(localStorageId));
                        if (storedGatedPdfForm)
                            $(maketoForm).deserialize(storedGatedPdfForm);

                        switchBgBasedOnHeight($(element));
                        prepareForm($(element));
                    }
                });
            }, 100);
        }
    });

    function prepareForm($el) {
        var $formRows = $el.find('.mktoFormRow');
        var $form = $el.find('.marketo-embed-form');
        $form.removeClass('banner-form bg-inverse__green bg-inverse__purple bg-inverse__grey bg-inverse__orange bg-inverse__teal bg-inverse__light');
        var elCount = 0;
        $.each($formRows, function(index, el) {
            elCount ++;
            if ($(el).find('input[type="hidden"]').length > 0) {
                $(el).css('display', 'none');
                elCount --;
            }
            if ($(el).find('.mktoCheckboxList').length > 0) {
                $(el).addClass('gt-mktoCheckbox');
                if($('body').hasClass('RTL')){
                    var $fieldWrap = $(el).find('.mktoFieldWrap');
                    var $label = $fieldWrap.find('label.mktoLabel');
                    var $checkBoxList = $fieldWrap.find('.mktoCheckboxList');
                    var innerHtml = $label[0].outerHTML;
                    $label.remove();
                    $checkBoxList.after(innerHtml);
                }
            }
        });
        if(elCount % 2 === 0)$el.addClass('even');
        $el.css('opacity', '1');
    }

    function switchBgBasedOnHeight($el) {
        var $blockImage = $el.find('.block--image');
        if ($blockImage.length > 0) {
            var heightBreakpoint = 374;
            var formHeight = $el.height();
            var $smallImageInput = $el.find('.smallImageUrl');
            var $bigImageInput = $el.find('.bigImageUrl');
            if ($smallImageInput.length === 0 && $bigImageInput.length === 0) return;
            var smallImageUrl = $smallImageInput.length > 0 ? $smallImageInput.val() : undefined;
            var bigImageUrl = $bigImageInput.length > 0 ? $bigImageInput.val() : undefined;
            var imageUrl = bigImageUrl ? bigImageUrl : smallImageUrl;
            var finalUrl = formHeight > heightBreakpoint ? bigImageUrl : smallImageUrl;
            if (!finalUrl) finalUrl = imageUrl;
            $blockImage.css('background-image', 'url(' + finalUrl + ')');
        }
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.GatedPdfMarketoForm($('.js-gated-marketo'));
    });

GT.glides = {};
GT.Glide = function(element){

    function setActiveBg(mainSlider, index){
        let listElms = mainSlider.querySelectorAll(".columns-carousel__hero .hero-item");
        Array.prototype.slice.call(listElms).forEach(function(bgItem, index2){
            if(index2 == index)
                bgItem.classList.add("active");
            else
                bgItem.classList.remove("active");
        })
    }

    function doInitGlide(elm) {
        if(elm.attributes["disable-on-desktop"] && GT.wWidth >= 960)
            return;
        if (elm.attributes["disable-on-tablet"] && GT.wWidth >= 768)
            return;
        let glideSlides = Array.prototype.slice.call(elm.querySelectorAll(":scope > .glide__track > .glide__slides > .glide__slide:not(.glide__slide--clone)")),
            totalItems = glideSlides.length;
            gap = elm.classList.contains("has-shadow") ? 0 : 32,
            currentPerView = 0,
            currentGlide = GT.glides[elm.dataset.glidename],
            breakpoints = {},
            count_breakpoint = 0,
            isHomepageColumnSlider = elm.dataset.ishomepagecolumnslider == "true",
            loadMoreBtn = document.querySelector("." + elm.dataset.loadmorebtn),
            containerW = elm.dataset.glidename.indexOf("fcb") == 0 ? GT.wWidth : elm.offsetWidth,
            hasPeek = elm.dataset.haspeek === "true" || (elm.dataset.haspeek === "mobile" && GT.bodyWidth < 960),
            tmp_breakpoints = {
                3200: {
                    perView: 7
                },
                2999: {
                    perView: 6
                },
                2100: {
                    perView: 5
                },
                1700: {
                    perView: 4
                },
                1500: {
                    perView: 3
                },
                960: {
                    perView: 2
                },
                600: {
                    perView: 1
                }
            },
            glide_controls = elm.querySelector(".glide-controls");
        
        if(elm.classList.contains("ibc-glide__container"))
            elm.dataset.isIBCD = true;

        if(isHomepageColumnSlider) {
            tmp_breakpoints = {
                3200: {
                    perView: 4
                }
            }
            glide_controls = elm.closest(".columns-carousel").querySelector(".columns-carousel__main .glide-custom-control");
        } else {
            glideSlides.forEach(function(glideItem, glideItemIndex){
                glideItem.dataset.index = glideItemIndex;
            })
        }
        // Ngoc Nguyen change for calculate item per view
        if(containerW < GT.bodyWidth) {
            if(elm.dataset.glidename.indexOf("fcb") != 0 && !elm.dataset.perview)
                tmp_breakpoints = {
                    3200: {
                        perView: 3
                    },
                    1500: {
                        perView: 3
                    },
                    960: {
                        perView: 2
                    },
                    600: {
                        perView: 1
                    }
                }
        }

        if(!elm.dataset.itemwidth)
            elm.dataset.itemwidth = 0;

        let itemW = parseInt(elm.dataset.itemwidth);
        if(elm.dataset.itemMobileWidth && GT.wWidth <= 960) itemW = parseInt(elm.dataset.itemMobileWidth);
        
        if(hasPeek && !itemW) {
            itemW = GT.wWidth <= 960 ? 327 : 382;
        }
        
        if(itemW) {
            breakpoints = {};
            currentPerView = Math.floor(containerW / itemW);
            if(elm.dataset.perview && elm.dataset.perview < currentPerView)
                currentPerView = elm.dataset.perview;
            if(GT.wWidth <= 450 && !currentPerView) {
                currentPerView = 1;
            }
            breakpoints[containerW] = {perView: currentPerView};
        } else {
            Object.keys(tmp_breakpoints).forEach(function(key) {
                let breakpoint = tmp_breakpoints[key];
                if(!currentPerView || breakpoint.perView < currentPerView) {
                    breakpoints[key] = breakpoint;
                    // Ngoc Nguyen change for calculate item per view
                    if(parseInt(key) >= containerW && !currentPerView)
                        currentPerView = breakpoint.perView;
                }
            })


            //Max perview from [View].cshtml
            // Ngoc Nguyen change for calculate item per view
            if(elm.dataset.perview && (!currentPerView || currentPerView > elm.dataset.perview)) {
                currentPerView = elm.dataset.perview;
                let tmp2_breakpoints = [];
                Object.keys(tmp_breakpoints).forEach(function(key) {
                    let breakpoint = tmp_breakpoints[key];
                    if(breakpoint.perView <= currentPerView && key < containerW) {
                        tmp2_breakpoints[key] = breakpoint;
                    } else {
                        tmp2_breakpoints[containerW] = {perView: currentPerView};
                    }
                })
                breakpoints = tmp2_breakpoints;
            }
        }

        let peek = 0;
        if(hasPeek) {
            let numberItemsCanShow = containerW / itemW;

            if(containerW < itemW * totalItems && (containerW < GT.bodyWidth || currentPerView == 1) && itemW < containerW) {
                let _perview = Math.floor(numberItemsCanShow);
                if(_perview <= 0)
                    _perview = 1;
                peek = containerW - _perview * itemW;
            }
        }

        elm.dataset.totalItems = totalItems;

        let bulletsElm = elm.querySelector(".glide__bullets.is-parrent") ||  elm.querySelector(".glide__bullets");

        if(bulletsElm) {
            if(!currentPerView || currentPerView >= totalItems)
                bulletsElm.classList.remove("show");
            else {
                bulletsElm.classList.add("show");

                let bulletHTML = "";
                let breakpoint_bullet = Math.ceil(totalItems / currentPerView);
                for(var bullet_i = 0; bullet_i < breakpoint_bullet; bullet_i++){
                    bulletHTML += '<li><button class="glide__bullet '+ (bullet_i == 0 ? 'glide__bullet--active' : '') +'" data-go="' + (bullet_i * currentPerView) + '"></button></li>';
                }
                bulletsElm.innerHTML = bulletHTML;
            }
        }

        if(glide_controls) 
            ((currentPerView && (currentPerView < totalItems || (currentPerView == totalItems && loadMoreBtn))) || isHomepageColumnSlider) ? glide_controls.classList.add("show") : glide_controls.classList.remove("show");

        // if(elm.dataset.glidename.indexOf("fcb") == 0 && totalItems > 3) {
        if(containerW >= GT.wWidth - 50 && containerW > 1024) {
            let containerElm = (elm.closest(".container") || elm.closest(".container-fluid"));
            if(containerElm)
                containerElm.classList.add(currentPerView && currentPerView <= totalItems ? "wideGlide" : "tinyWideGlide");
        }

        if(elm.dataset.perview == 1)
            gap = 0;
        else if(elm.dataset.gap)
            gap = elm.dataset.gap;
        
        if((currentPerView && (currentPerView < totalItems || (currentPerView == totalItems && loadMoreBtn))) || isHomepageColumnSlider) {

            if(isHomepageColumnSlider)
                currentPerView = 4;

            if(GT.wWidth <= 768) {
                // peek = 0;
                elm.dataset.focusat = 0;
            }

            if(!currentGlide) {
                currentGlide = new Glide(elm, {
                    startAt: elm.dataset.startAt ? elm.dataset.startAt : 0,
                    bound: true,
                    rewind: false,
                    perView: currentPerView,
                    direction: document.dir == 'rtl' ? 'rtl' : 'ltr',
                    gap: gap,
                    focusAt: elm.dataset.focusat ? elm.dataset.focusat : 0,
                    type: elm.dataset.type ? elm.dataset.type : 'carousel',
                    breakpoints: breakpoints,
                    peek: { before: 0, after: peek },
                    keyboard: false,
                    animationDuration: isHomepageColumnSlider ? 600 : 400,
                    autoplay: (isHomepageColumnSlider && elm.dataset.rotatetime && !GT.isMobileCached && !GT.isScreenReader) ? elm.dataset.rotatetime * 1000 : false,
                    perTouch: (loadMoreBtn || elm.dataset.sync) ? 1 : null
                });

                function setTabable(isMove){
                    Array.prototype.slice.call(document.querySelectorAll(".glide")).forEach(function(elm) {
                        let glideItem = GT.glides[elm.dataset.glidename];
                        if(glideItem && !elm.dataset.ishomepagecolumnslider) {
                            let countGlideItemElm = -1;

                            if(!isMove) {
                                elm.querySelector(".glide__slides").setAttribute("role", "none");
                            }

                            Array.prototype.slice.call(elm.querySelectorAll(".glide__slide")).forEach(function(item, index)
                            {
                                let aElms = Array.prototype.slice.call(item.querySelectorAll("a, button, [role='button'], [role='link']"));
                                if(item.classList.contains("glide__slide--active")) {
                                    countGlideItemElm = 0;
                                }

                                if(!isMove) {
                                    if(!item.classList.contains("glide__slide--clone")) {
                                        item.setAttribute("role", "group");
                                        // item.setAttribute("aria-roledescription", (parseInt(item.dataset.index) + 1));
                                        item.setAttribute("aria-label", "slide " +  (parseInt(item.dataset.index) + 1));
                                    }
                                }

                                if(countGlideItemElm >= 0 && !item.classList.contains("glide__slide--clone") && glideItem.settings.perView > countGlideItemElm) {
                                    aElms.forEach(function(aElm, aIdx){
                                        aElm.setAttribute("tabindex", 0);
                                    })
                                    
                                    item.setAttribute("tabindex", 0);
                                    if(isMove && countGlideItemElm == 0 && glideItem.isMoveByTabEvt) {
                                        glideItem.isMoveByTabEvt = false;
                                        item.focus();
                                    }
                                    countGlideItemElm++;
                                } else {
                                    item.setAttribute("tabindex", -1);
                                    aElms.forEach(function(aElm, aIdx){
                                        aElm.setAttribute("tabindex", -1);
                                    })
                                }
                            })

                            let currentBulletsCtrl = elm.querySelector(".glide__bullets.is-parrent") ||  elm.querySelector(".glide__bullets");
                            if(currentBulletsCtrl) {
                                let currentBulletPos = Math.floor(glideItem.index / glideItem.settings.perView),
                                    bulletElms = currentBulletsCtrl.querySelectorAll("button"),
                                    isEnd = glideItem.index + glideItem.settings.perView >= glideItem.selector.dataset.totalItems;
                                    bulletElmsLength = bulletElms.length,
                                    glideType = glideItem.settings.type;
                                
                                Array.prototype.slice.call(bulletElms).forEach(function(bulletElm, bulletElmIndex){    
                                    bulletElm.classList.remove("glide__bullet--active");
                                    let isActiveBullet = (isEnd && bulletElmIndex == bulletElmsLength - 1) || (!isEnd && currentBulletPos == bulletElmIndex);
                                    if(glideType == "carousel")
                                            isActiveBullet = currentBulletPos == bulletElmIndex
                                                
                                    if(isActiveBullet)
                                        bulletElm.classList.add("glide__bullet--active");

                                    if(isActiveBullet || (!isMove && bulletElmIndex == 0))
                                        bulletElm.setAttribute("aria-current", "true");
                                    else
                                        bulletElm.setAttribute("aria-current", "false");
                                    
                                    if(!isMove) {
                                        let bulletLabel = currentBulletsCtrl.dataset.label || "";
                                        bulletLabel = bulletLabel.replace("{0}", bulletElmIndex + 1);
                                        bulletLabel = bulletLabel.replace("{1}", bulletElmsLength);
                                        if(!bulletLabel) bulletLabel = "Slide";
                                        bulletElm.setAttribute("title", bulletLabel);
                                    }
                                })

                            }
                        }
                    })
                }
                
                currentGlide.on('swipe.start', function(ev){
                    ev.instance.isMoveByUser = true;
                })
                
                currentGlide.on("run.after", function(e){

                    let glideItem = e.instance,
                        currentSelector = glideItem.selector,
                        willTriggerLoadMore = false,
                        loadMoreContainer = currentSelector.parentElement.nextElementSibling,
                        currentLoadmoreBtn = loadMoreContainer ? loadMoreContainer.querySelector("." + currentSelector.dataset.loadmorebtn) : null;
                    
                    setTabable(true);

                    Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(item, index){
                        if(glideItem.index == item.dataset.index) {
                            
                            if(!item.classList.contains("glide__slide--clone")) {
                                if(currentSelector.dataset.totalItems - (GT.wWidth > 768 ? 2 : 1) == parseInt(item.dataset.index) + 1)
                                    willTriggerLoadMore = true;
                            }
                            
                        } 
                    })


                    if(willTriggerLoadMore && currentLoadmoreBtn && !currentLoadmoreBtn.classList.contains("hidden")) {
                        currentSelector.classList.add("loading");
                        currentSelector.dataset.startAt = glideItem.index;
                        let glideTrackElm = currentSelector.querySelector(".glide__track");
                        glideTrackElm.style.height = glideTrackElm.offsetHeight + "px";
                        glideItem.disable();
                        currentLoadmoreBtn.click();
                    }

                    if(currentSelector.dataset.disabled == "true")
                        setTimeout(function(){
                            glideItem.disable();
                        }, 50)

                    Object.keys(GT.glides).forEach(key => {
                        GT.glides[key].isMoveByUser = false;
                    })
                    glideItem.isMoving = false;
                });

                currentGlide.on('run', function(ev){
                    let glideItem = ev.instance;
                    if(glideItem) {
                        if(glideItem.isMoveByUser && !glideItem.isMoving)
                            sync2Slider(glideItem, ev.move.direction, ev.move.steps);
                        
                        glideItem.isMoving = true;
                        
                        let currentSelector = glideItem.selector,
                            parentBlock = currentSelector.dataset.ishomepagecolumnslider == "true" ? currentSelector.closest(".columns-carousel") : null;

                        Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(item, index){
                            if(glideItem.index == item.dataset.index) {
                                item.classList.add("glide__slide--custom-active");
                                
                                if(currentSelector.dataset.ishomepagecolumnslider == "true" && parentBlock) {
                                    Array.prototype.slice.call(parentBlock.querySelectorAll(".columns-carousel__hero .hero-item")).forEach(function(bgItem, bgItemIndex){
                                        if(bgItemIndex == item.dataset.index)
                                            bgItem.classList.add("active");
                                        else
                                            bgItem.classList.remove("active");
                                    })
                                }
                            } else
                                item.classList.remove("glide__slide--custom-active");
                        })
                    }
                });
                GT.glides[elm.dataset.glidename] = currentGlide;

                currentGlide.on(['mount.after'], function(e) {
                    let glideItem = e.instance;
                    if(glideItem) {
                        let currentSelector = glideItem.selector,
                            parentBlock = currentSelector.closest(".columns-carousel");
                        if(currentSelector.dataset.ishomepagecolumnslider == "true") {

                            Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(glideElmItem, glideElmIndex){
                                let aElm = glideElmItem.querySelector("a");
                                
                                if(!glideElmItem.classList.contains("glide__slide--clone")) {
                                    aElm.setAttribute("tabindex", 0);
                                    if(glideElmItem.classList.contains("glide__slide--active"))
                                        glideElmItem.classList.add("glide__slide--custom-active");
                                    aElm.onfocus = function(e){
                                        Array.prototype.slice.call(document.querySelectorAll(".columns-carousel__main .glide__slide--custom-active")).forEach(function(activatingElm){
                                            activatingElm.classList.remove("glide__slide--custom-active");
                                        })
                                        setActiveBg(e.currentTarget.closest(".columns-carousel"), e.currentTarget.parentElement.dataset.index);
                                    }
                                } else {
                                    aElm.setAttribute("tabindex", -1);
                                }
                                glideElmItem.addEventListener("mouseenter", function(e){
                                    setActiveBg(e.currentTarget.closest(".columns-carousel"), e.currentTarget.dataset.index);
                                    Array.prototype.slice.call(document.querySelectorAll(".columns-carousel__main .glide__slide--custom-active")).forEach(function(activatingElm){
                                        activatingElm.classList.remove("glide__slide--custom-active");
                                    })
                                    e.currentTarget.classList.add("glide__slide--custom-active");
                                })
                            })

                            parentBlock.addEventListener("keydown", function(e){
                                let keycode = e.keyCode || e.which;
                                if(!e.shiftKey && keycode == 9)
                                    Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(glideElmItem, glideElmIndex){                                        
                                        if(!glideElmItem.classList.contains("glide__slide--clone") && glideElmIndex == 0) {
                                            glideElmItem.querySelector("a").focus();
                                        }
                                    })                                    
                            })

                            parentBlock.onfocus = function(e){
                                let glideItemWillPause = GT.glides[e.currentTarget.closest(".columns-carousel__main").querySelector(".glide").dataset.glidename];
                                glideItemWillPause.go("<<");
                                setTimeout(function(){
                                    glideItemWillPause.pause();
                                }, glideItemWillPause.settings.animationDuration)
                            }

                            if(GT.GTColumnSlider)
                                GT.GTColumnSlider();
                        } else {
                            setTabable();
                            
                            let loadMoreContainer = currentSelector.parentElement.nextElementSibling,
                            currentLoadmoreBtn = loadMoreContainer ? loadMoreContainer.querySelector("." + currentSelector.dataset.loadmorebtn) : null;
                            
                            if(currentSelector.dataset.totalItems == glideItem.settings.perView && GT.wWidth > 768 && currentLoadmoreBtn && !currentLoadmoreBtn.classList.contains("hidden")) {
                                glideItem.disable();
                                currentSelector.classList.add("loading");
                                let glideTrackElm = currentSelector.querySelector(".glide__track");
                                glideTrackElm.style.height = glideTrackElm.offsetHeight + "px";
                                setTimeout(function(){
                                    currentLoadmoreBtn.click();
                                })
                            }


                            let parentGlideSelector = currentSelector.closest(".glide");
                            if(parentGlideSelector) {
                                let currentVisitedElm;

                                currentSelector.addEventListener("mousemove", function(e){
                                    let parentGlide = GT.glides[parentGlideSelector.dataset.glidename],
                                        currentGlideSelector = e.target.closest(".glide"),
                                        currentGlideName = currentGlideSelector.dataset.glidename,
                                        currentTotalItems = currentGlideSelector.dataset.totalItems;

                                    if(currentVisitedElm != currentGlideName && e.which == 0 && parentGlide) {
                                        if(currentGlideName != parentGlideSelector.dataset.glidename && currentTotalItems > 1) {
                                            currentVisitedElm = currentGlideName;
                                            parentGlide.disable();
                                            parentGlideSelector.dataset.disabled = true;
                                        } else {
                                            currentVisitedElm = parentGlideSelector.dataset.glidename;
                                            parentGlide.enable();
                                            parentGlideSelector.dataset.disabled = false;
                                        }
                                    }
                                        
                                })
                            }
                        }
                    }
                })

                let bulletItems = Array.prototype.slice.call(elm.querySelectorAll(".glide__bullet"));
                bulletItems.forEach(function(bulletItem){
                    bulletItem.addEventListener("click", function(e){
                        let glideItem = GT.glides[this.parentElement.closest(".glide").dataset.glidename];
                        if(!e.pointerType)
                            glideItem.isMoveByTabEvt = true;
                        glideItem.go("=" + this.dataset.go);
                        sync2Slider(glideItem, "=", this.dataset.go);
                    })
                })

                currentGlide.mount();
                //Fix issue: move 2 articels per click in safari
                let prevElm = elm.querySelector(".slider__prev"),
                    nextElm = elm.querySelector(".slider__next");
                
                    if(prevElm && nextElm) {
                        prevElm.dataset.glideCtrlName = elm.dataset.glidename;
                        nextElm.dataset.glideCtrlName = elm.dataset.glidename;
                        prevElm.onclick = function(e){
                            let glideItem = GT.glides[this.dataset.glideCtrlName],
                                glideItemSelector = glideItem.selector,
                                glideItemChildSelectors = glideItemSelector.querySelectorAll(".glide"),
                                glideItemChildSelector,
                                childGlide;
                            
                            if(glideItemChildSelectors.length)
                                glideItemChildSelector = glideItemChildSelectors[glideItem.index];

                            if(glideItemChildSelector)
                                childGlide = GT.glides[glideItemChildSelector.dataset.glidename];

                            if(e.buttons)
                                glideItem.isMoveByTabEvt = true;
                                
                            if(childGlide && childGlide.index > 0)
                                childGlide.go("<");
                            else
                                glideItem.go("<");
                            sync2Slider(glideItem, "<", 1);
                        }
                        nextElm.onclick = function(e){
                            let glideItem = GT.glides[this.dataset.glideCtrlName],
                                glideItemSelector = glideItem.selector,
                                glideItemChildSelectors = glideItemSelector.querySelectorAll(".glide"),
                                glideItemChildSelector,
                                childGlide;
                            
                            if(glideItemChildSelectors.length)
                                glideItemChildSelector = glideItemChildSelectors[glideItem.index];

                            if(glideItemChildSelector)
                                childGlide = GT.glides[glideItemChildSelector.dataset.glidename];

                            if(e.buttons)
                                glideItem.isMoveByTabEvt = true;
                                
                            if(childGlide && childGlide.index < glideItemChildSelector.dataset.totalItems - 1)
                                childGlide.go(">");
                            else
                                ((glideItem._i < glideItemSelector.dataset.totalItems - 1 && glideItemSelector.dataset.type == "slider") || glideItemSelector.dataset.type != "slider") && glideItem.go(">");

                            sync2Slider(glideItem, ">", 1);
                        }
                    }

                // GT.glides.push(currentGlide);
            } else {
                currentGlide.perView = totalItems;
                currentGlide.breakpoints = breakpoints;
                currentGlide.update();
                currentGlide.enable();
                GT.glides[elm.dataset.glidename] = currentGlide;
            }
        } else {
            glideSlides.forEach(function(glideItem, glideItemIndex){
                glideItem.setAttribute("tabindex", 0);
            })
        }

        // elm.dataset.renderedGlide = true;
        // if(!(isHomepageColumnSlider && GT.isMobileCached))
            elm.classList.add("glide--show-item");
        //wait for Glide initialization completed fully
        // setTimeout(function(){
        //     elm.dataset.renderedGlide = true;
        //     elm.classList.add("showitem");
        // }, 200)

        if(elm.dataset.clampname)
            setTimeout(function(){
                GT.clampText(elm.dataset.clampname, true);
            }, 750);
    }

    if(element)
        doInitGlide(element);
    else
        Array.prototype.slice.call(document.querySelectorAll(".glide")).forEach(function(elm) {
            doInitGlide(elm);
        })

    Array.prototype.slice.call(document.querySelectorAll(".glide-custom-control")).forEach(function(controlContainer){
        controlContainer.querySelector(".slider__prev").onclick = function(e){
            let glideItem = GT.glides[e.currentTarget.parentElement.dataset.glideCtrlName];
            if(e.buttons)
                glideItem.isMoveByTabEvt = true;
            glideItem.go("<");
            sync2Slider(glideItem, "<", 1);
        }
        controlContainer.querySelector(".slider__next").onclick = function(e){
            let glideItem = GT.glides[e.currentTarget.parentElement.dataset.glideCtrlName];
            if(e.buttons)
                glideItem.isMoveByTabEvt = true;
            glideItem.go(">");
            sync2Slider(glideItem, ">", 1);
        }
    })

    function sync2Slider(slider, direction, steps){
        let targetSlider = GT.glides[slider.selector.dataset.sync];
        if(!targetSlider)
            return;

        let nextIndex = slider.index;
        let nextSlide = slider.selector.querySelector('.glide__slide:not(.glide__slide--clone)[data-index="'+ nextIndex +'"]');
        let currentIdx = nextSlide ? nextSlide.dataset.parent : -100;
        if(currentIdx == -100) {
            currentIdx = nextIndex;
        }

        if(typeof currentIdx == "undefined") {
            targetGlide__slide = targetSlider.selector.querySelector('.glide__slide:not(.glide__slide--clone)[data-parent="'+ nextIndex +'"]');
            if(targetGlide__slide) {
                currentIdx = targetGlide__slide.dataset.index;
                if(direction == "=")
                    targetSlider.go("=" + currentIdx);
                else {
                    let steps = currentIdx - targetSlider.index;
                    targetSlider.go(direction + steps);
                }
            }
        } else if(targetSlider.index != currentIdx)
            targetSlider.go(direction + (direction == "=" ? currentIdx : ""));
    }
}

GT.reinitializeGlide = function(){
    Object.keys(GT.glides).forEach(function(key){
        GT.glides[key].destroy();
    })
    
    Array.prototype.slice.call(document.querySelectorAll(".glide")).forEach(function(elm) {
        // elm.dataset.renderedGlide = false;
        elm.classList.remove("glide--show-item");
        let containerElm = (elm.closest(".container") || elm.closest(".container-fluid"));
        if(containerElm) {
            let elmParentClasses = containerElm.classList;
            elmParentClasses.remove("wideGlide");
            elmParentClasses.remove("tinyWideGlide");
        }
    })
    GT.glides = {};
    GT.Glide();
}

GT.destroyGlide = function(elm){
    GT.glides[elm.dataset.glidename].destroy();
    
    // elm.dataset.renderedGlide = false;
    elm.classList.remove("glide--show-item");
    let containerElm = (elm.closest(".container") || elm.closest(".container-fluid"));
    if(containerElm) {
        let elmParentClasses = containerElm.classList;
        elmParentClasses.remove("wideGlide");
        elmParentClasses.remove("tinyWideGlide");
    }

    delete GT.glides[elm.dataset.glidename];
}

GT.domContentLoadedFncList.push(function(){
    LazyEvent(document.querySelectorAll(".glide"), GT.Glide, null, null, "lazy_DOMContentLoadedEvt__GTGlide");
});


GT.windowResizeFncList["resizeEvt__GTGlide"] = function(){
    //wait for GT.wWidth update new value
    setTimeout(function(){
        GT.reinitializeGlide();
    }, 50)
}
GT.glidesV2 = {};
GT.GlideV2 = function(specificElm){
    function doInitGlide(elm) {
        if(elm.attributes["disable-on-desktop"] && GT.wWidth >= 960)
            return;
        if (elm.attributes["disable-on-tablet"] && GT.wWidth >= 768)
            return;
        
        let glideSlides = Array.prototype.slice.call(elm.querySelectorAll(":scope > .glide__track > .glide__slides > .glide__slide:not(.glide__slide--clone)")),
            totalItems = glideSlides.length;
            gap = elm.classList.contains("has-shadow") ? 0 : 32,
            steps = 0,
            currentPerView = 0,
            currentGlide = GT.glidesV2[elm.dataset.glidename],
            breakpoints = {},
            count_breakpoint = 0,
            loadMoreBtn = document.querySelector("." + elm.dataset.loadmorebtn),
            containerW = elm.closest(".container-fluid") ? GT.bodyWidth : elm.offsetWidth,
            hasPeek = elm.dataset.haspeek === "true" || (elm.dataset.haspeek === "mobile" && (GT.bodyWidth < 1300 || containerW >= GT.bodyWidth)),
            bulletSize = GT.wWidth < GT.breakPoints.tablet_lg ? 24 : 28;
            tmp_breakpoints = {
                3200: {
                    perView: 7
                },
                2999: {
                    perView: 6
                },
                2100: {
                    perView: 5
                },
                1700: {
                    perView: 4
                },
                1200: {
                    perView: 3
                },
                960: {
                    perView: 2
                },
                600: {
                    perView: 1
                }
            },
            glide_controls = elm.querySelector(".glide-controls");
        
        if(elm.classList.contains("ibc-glide__container"))
            elm.dataset.isIBCD = true;

        glideSlides.forEach(function(glideItem, glideItemIndex){
            glideItem.dataset.index = glideItemIndex;
        })

        if(containerW < GT.bodyWidth) {
            if(elm.dataset.glidename.indexOf("fcb") != 0 && !elm.dataset.perview)
                tmp_breakpoints = {
                    3200: {
                        perView: 3
                    },
                    1200: {
                        perView: 3
                    },
                    960: {
                        perView: 2
                    },
                    600: {
                        perView: 1
                    }
                }
        }

        if(elm.dataset.steps && GT.isDesktopView())
            steps = elm.dataset.steps;

        if(!elm.dataset.itemwidth)
            elm.dataset.itemwidth = 0;

        let itemW = parseInt(elm.dataset.itemwidth);
        if(elm.dataset.itemMobileWidth && GT.wWidth < GT.breakPoints.tablet_lg) itemW = parseInt(elm.dataset.itemMobileWidth);
        if(elm.dataset.itemTabletWidth && GT.wWidth < GT.breakPoints.desktop_lg) itemW = parseInt(elm.dataset.itemTabletWidth);
        if(elm.dataset.itemDesktopWidth && GT.wWidth >= GT.breakPoints.desktop_lg) itemW = parseInt(elm.dataset.itemDesktopWidth);

        if(!itemW) {
            itemW = GT.wWidth < GT.breakPoints.tablet_lg ? 327 : (containerW >= GT.bodyWidth ? 380 : 390.5);
        }
        
        if(itemW) {
            breakpoints = {};
            currentPerView = Math.floor(containerW / itemW);
            if(elm.dataset.perview && elm.dataset.perview < currentPerView)
                currentPerView = elm.dataset.perview;
            if(GT.wWidth <= 450 && !currentPerView) {
                currentPerView = 1;
            }

            let mobilePerview = parseInt(elm.dataset.mobilePerview),
                tabletPerview = parseInt(elm.dataset.tabletPerview);
            
            if(GT.bodyWidth < 450 && mobilePerview > 0) {
                currentPerView = mobilePerview;
            } else if(!GT.isDesktopView() && tabletPerview > 0) {
                currentPerView = tabletPerview;
            }

            breakpoints[containerW] = {perView: currentPerView};
        } else {
            Object.keys(tmp_breakpoints).forEach(function(key) {
                let breakpoint = tmp_breakpoints[key];
                if(!currentPerView || breakpoint.perView < currentPerView) {
                    breakpoints[key] = breakpoint;
                    // Ngoc Nguyen change for calculate item per view
                    if(parseInt(key) >= containerW && !currentPerView)
                        currentPerView = breakpoint.perView;
                }
            })


            //Max perview from [View].cshtml
            // Ngoc Nguyen change for calculate item per view
            if(elm.dataset.perview && (!currentPerView || currentPerView > elm.dataset.perview)) {
                currentPerView = elm.dataset.perview;
                let tmp2_breakpoints = [];
                Object.keys(tmp_breakpoints).forEach(function(key) {
                    let breakpoint = tmp_breakpoints[key];
                    if(breakpoint.perView <= currentPerView && key < containerW) {
                        tmp2_breakpoints[key] = breakpoint;
                    } else {
                        tmp2_breakpoints[containerW] = {perView: currentPerView};
                    }
                })
                breakpoints = tmp2_breakpoints;
            }
        }

        let peek = 0;
        if(hasPeek) {
            let numberItemsCanShow = containerW / itemW;

            if(containerW < itemW * totalItems && (containerW <= GT.bodyWidth || currentPerView == 1) && itemW < containerW) {
                let _perview = Math.floor(numberItemsCanShow);
                if(_perview <= 0)
                    _perview = 1;
                peek = containerW - _perview * itemW;
            }
        }

        elm.dataset.totalItems = totalItems;

        let bulletsElm = elm.querySelector(".glide__bullets.is-parrent") ||  elm.querySelector(".glide__bullets");
        let glideNavButtons = elm.querySelector(".glide-nav__buttons");
        let elmDataset = elm.dataset;

        if(bulletsElm || glideNavButtons) {
            if(!currentPerView || currentPerView >= totalItems) {
                bulletsElm?.classList.remove("show");
                glideNavButtons?.classList.remove("show");
            } else {
                if (elmDataset.hideBullets !== 'true')
                    bulletsElm?.classList.add("show");
                glideNavButtons?.classList.add("show");

                if(bulletsElm) {
                    let bulletHTML = "";
                    let maxBullets = steps ? Math.ceil(totalItems / steps) : totalItems;
                    if(maxBullets > totalItems) maxBullets = totalItems;

                    if(elm.dataset.type == "slider" && !steps) {
                        maxBullets = totalItems - currentPerView + 1;
                    }
                    for(let bullet_i = 0; bullet_i < maxBullets; bullet_i++){
                        bulletHTML += '<li role="presentation"><button class="glide__bullet '+ (bullet_i == 0 ? 'glide__bullet--active' : '') + (bullet_i == 5 && maxBullets > 6 ? 'has-more' : '') +'" data-go="' + (steps ? bullet_i * steps : bullet_i) + '"' + ' type="button" role="tab"' + (bullet_i !== 0 ? ' tabindex="-1"' : '') + '></button></li>';
                    }
                    bulletsElm.setAttribute("role", "tablist");
                    bulletsElm.innerHTML = bulletHTML;
                    elm.dataset.totalBullets = maxBullets;
                    elm.style.removeProperty("--bullet-translate-x");
                    elm.dataset.lastindex = 0;
                }
            }
        }

        if(glide_controls) 
            ((currentPerView && (currentPerView < totalItems || (currentPerView == totalItems && loadMoreBtn)))) ? glide_controls.classList.add("show") : glide_controls.classList.remove("show");

        // If totalItems <= 3, Use container instead of container-fluid
        if(containerW >= GT.wWidth - 50 && containerW > 1024 || elm.closest(".container-fluid")) {
            let containerElm =  elm.closest(".container-fluid, .container");
            if(containerElm && totalItems > 3)
                containerElm.classList.add(currentPerView && currentPerView < totalItems ? "wideGlide" : "tinyWideGlide");
        }

        if(elm.dataset.perview == 1)
            gap = 0;
        else if(elm.dataset.gap)
            gap = elm.dataset.gap;


        function setSlideLabel(glideItem, totalItems) {
            let slideLabel = elm.querySelector("[data-slidetext]")?.dataset?.slidetext || "";
            slideLabel = slideLabel.replace("{0}", (parseInt(glideItem.dataset.index) + 1));
            slideLabel = slideLabel.replace("{1}", totalItems);
            if(!slideLabel) slideLabel = "slide ";
            glideItem.setAttribute("aria-label", slideLabel);
            glideItem.setAttribute("role", "group");
        }
        
        if((currentPerView && (currentPerView < totalItems || (currentPerView == totalItems && loadMoreBtn)))) {

            if(GT.wWidth <= 768) {
                // peek = 0;
                elm.dataset.focusat = 0;
            }

            if(!currentGlide) {
                let clickableElms = "a, button, [role='button'], [role='link'], [tabindex='0']";

                currentGlide = new Glide(elm, {
                    startAt: elm.dataset.startAt ? elm.dataset.startAt : 0,
                    rewind: false,
                    bound: true,
                    perView: currentPerView,
                    direction: document.dir == 'rtl' ? 'rtl' : 'ltr',
                    gap: gap,
                    focusAt: elm.dataset.focusat ? elm.dataset.focusat : 0,
                    type: elm.dataset.type ? elm.dataset.type : 'carousel',
                    breakpoints: breakpoints,
                    peek: { before: 0, after: peek },
                    keyboard: false,
                    animationDuration: 400,
                    autoplay: (elm.dataset.rotatetime && !GT.isMobileCached && !GT.isScreenReader) ? elm.dataset.rotatetime * 1000 : false,
                    perTouch: 1,
                    steps: steps
                    // perTouch: (loadMoreBtn || elm.dataset.sync) ? 1 : null
                });

                function setTabable(isMove){
                    Array.prototype.slice.call(document.querySelectorAll(".glide-v2")).forEach(function(elm) {
                        let glideItem = GT.glidesV2[elm.dataset.glidename];
                        if(glideItem) {
                            let countGlideItemElm = -1;

                            if(!isMove) {
                                const slidesContainerElm = elm.querySelector(".glide__slides");
                                if(slidesContainerElm) {
                                    slidesContainerElm.setAttribute("role", "application");
                                    slidesContainerElm.setAttribute("aria-label", "slider");
                                }
                            }
                            let currentSelector = glideItem.selector;
                            let prevElm = currentSelector.querySelector(".slider__prev"),   
                                nextElm = currentSelector.querySelector(".slider__next");
                            if(glideItem.settings.type == "slider") {
                                if(glideItem.index == 0) {
                                    prevElm.classList.add("disabled");
                                    prevElm.setAttribute("disabled", true);
                                    prevElm.setAttribute("aria-hidden", true);
                                    nextElm.classList.remove("disabled");
                                    nextElm.removeAttribute("disabled");
                                } else {
                                    prevElm.classList.remove("disabled");
                                    prevElm.removeAttribute("disabled");
                                    prevElm.removeAttribute("aria-hidden");
                                }

                                let isEnd = parseInt(glideItem.index) >= parseInt(currentSelector.dataset.totalItems) - glideItem.settings.perView;
                                if(isEnd) {
                                    nextElm.classList.add("disabled");
                                    nextElm.setAttribute("disabled", true);
                                    nextElm.setAttribute("aria-hidden", true);
                                    prevElm.classList.remove("disabled");
                                    prevElm.removeAttribute("disabled");
                                    prevElm.removeAttribute("aria-hidden");
                                } else {
                                    nextElm.classList.remove("disabled");
                                    nextElm.removeAttribute("disabled");
                                    nextElm.removeAttribute("aria-hidden");
                                }
                            }

                            Array.prototype.slice.call(elm.querySelectorAll(".glide__slide")).forEach(function(item, index)
                            {
                                let aElms = Array.prototype.slice.call(item.querySelectorAll(clickableElms));
                                if(item.classList.contains("glide__slide--active")) {
                                    countGlideItemElm = 0;
                                }

                                if(!isMove) {
                                    if(!item.classList.contains("glide__slide--clone")) {
                                        setSlideLabel(item, currentSelector.dataset.totalItems);
                                        // item.setAttribute("aria-roledescription", (parseInt(item.dataset.index) + 1));
                                        // item.setAttribute("aria-label", "slide " +  (parseInt(item.dataset.index) + 1) + " of " + currentSelector.dataset.totalItems);
                                    }
                                }

                                item.removeAttribute("tabindex");
                                item.removeAttribute("aria-hidden");

                                if(countGlideItemElm >= 0 && !item.classList.contains("glide__slide--clone") && glideItem.settings.perView > countGlideItemElm) {
                                    aElms.forEach(function(aElm, aIdx){
                                        aElm.setAttribute("tabindex", 0);
                                    })
                                    
                                    if(isMove && countGlideItemElm == 0 && glideItem.isMoveByTabEvt && !currentSelector.dataset.preventAutoFocus) {
                                        glideItem.isMoveByTabEvt = false;
                                        if(item.classList.contains("glide__slide--active")) {
                                            let firstChildCanClick = item.firstElementChild.closest(clickableElms) || item.querySelector(clickableElms);
                                            if(firstChildCanClick) firstChildCanClick.focus();
                                            else {
                                                item.setAttribute("tabindex", 0);
                                                item.focus();
                                            }
                                        }
                                    }
                                    countGlideItemElm++;
                                } else {
                                    item.setAttribute("aria-hidden", "true");
                                    item.setAttribute("tabindex", -1);
                                    aElms.forEach(function(aElm, aIdx){
                                        aElm.setAttribute("tabindex", -1);
                                    })
                                }
                            })

                            setTimeout(e => {
                                let currentBulletsCtrl = elm.querySelector(".glide__bullets.is-parrent") ||  elm.querySelector(".glide__bullets");
                                if(currentBulletsCtrl) {
                                    let bulletElms = currentBulletsCtrl.querySelectorAll("button");
                                    
                                    Array.prototype.slice.call(bulletElms).forEach(function(bulletElm, bulletElmIndex){    
                                        bulletElm.classList.remove("glide__bullet--active");
                                        bulletElm.setAttribute("tabindex", "-1");
                                        bulletElm.classList.remove("show");

                                        let currentSteps = (elm.dataset.steps && GT.isDesktopView()) ? elm.dataset.steps : 0;
                                        const realGlideIndex = currentSteps ? glideItem.index / currentSteps : glideItem.index;
                        
                                        if(realGlideIndex == bulletElmIndex) {
                                            //========= Animated Bullets
                                            elm.style.removeProperty("--bullet-active-translate-x");
                                            elm.style.removeProperty("--bullet-last-active-translate-x");
                                            bulletElm.classList.add("glide__bullet--active");
                                            elm.querySelector(".glide__bullet--target")?.classList.remove("glide__bullet--target");
                                            elm.querySelector(".glide__bullet--old-active")?.classList.remove("glide__bullet--old-active");
                                            elm.classList.remove("glide__bullet-animate");
                                            bulletElm.removeAttribute("tabindex");
                                            //END========= Animated Bullets
                                        } 

                                        if(!isMove) {
                                            let bulletLabel = currentBulletsCtrl.dataset.label || "";
                                            bulletLabel = bulletLabel.replace("{0}", bulletElmIndex + 1);
                                            bulletLabel = bulletLabel.replace("{1}", currentSelector.dataset.totalItems);
                                            if(!bulletLabel) bulletLabel = "Go to slide ";
                                            bulletElm.setAttribute("aria-label", bulletLabel);
                                        }
                                    })
                                }
                            }, 100)
                        }
                    })
                }
                
                currentGlide.on('swipe.start', function(ev){
                    ev.instance.isMoveByUser = true;
                })
                
                currentGlide.on("run.after", function(e){
                        let glideItem = e.instance,
                            currentSelector = glideItem.selector,
                            willTriggerLoadMore = false,
                            loadMoreContainer = currentSelector.closest(".extended-search"),
                            currentLoadmoreBtn = loadMoreContainer ? loadMoreContainer.querySelector("." + currentSelector.dataset.loadmorebtn) : null;

                        setTabable(true);

                        Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(item, index){
                            if(glideItem.index == item.dataset.index) {
                                
                                if(!item.classList.contains("glide__slide--clone")) {
                                    if(currentSelector.dataset.totalItems - (GT.wWidth > 768 ? 2 : 1) == parseInt(item.dataset.index) + 1)
                                        willTriggerLoadMore = true;
                                }
                                
                            } 
                        })
                        
                        if(willTriggerLoadMore && currentLoadmoreBtn && !currentLoadmoreBtn.classList.contains("hidden")) {
                            currentSelector.dataset.startAt = glideItem.index;
                            let glideTrackElm = currentSelector.querySelector(".glide__track");
                            glideTrackElm.style.height = glideTrackElm.offsetHeight + "px";
                            glideItem.disable();
                            if(!loadMoreContainer.classList.contains("fetching"))
                                currentLoadmoreBtn.click();
                            loadMoreContainer.classList.add("fetching");
                        }

                        if(currentSelector.dataset.disabled == "true")
                            setTimeout(function(){
                                glideItem.disable();
                            }, 50)

                        Object.keys(GT.glidesV2).forEach(key => {
                            GT.glidesV2[key].isMoveByUser = false;
                        })

                        //Prevent double click. wait for the bullet's animation finishes
                        setTimeout(e => {
                            glideItem.isMoving = false;
                        }, 350)
                });

                currentGlide.on('run', function(ev){
                    let glideItem = ev.instance;
                    if(glideItem) {
                        if(glideItem.isMoveByUser && !glideItem.isMoving)
                            sync2Slider(glideItem, ev.move.direction, ev.move.steps);
                        
                        glideItem.isMoving = true;
                        
                        let currentSelector = glideItem.selector;
                        Array.prototype.slice.call(currentSelector.querySelectorAll(".glide__slide")).forEach(function(item, index){
                            if(glideItem.index == item.dataset.index) {
                                item.classList.add("glide__slide--custom-active");
                            } else
                                item.classList.remove("glide__slide--custom-active");
                        })


                        //========= Animated Bullets
                        let currentSteps = (currentSelector.dataset.steps && GT.isDesktopView()) ? currentSelector.dataset.steps : 0,
                            lastIndex = parseInt(currentSelector.dataset.lastindex) || 0,
                            realGlideIndex = currentSteps ? glideItem.index / currentSteps : glideItem.index,
                            totalBullets = currentSelector.dataset.totalBullets || 0;
                    
                        realGlideIndex = realGlideIndex >= totalBullets ? 0 : realGlideIndex;
                        realGlideIndex = realGlideIndex < 0 ? totalBullets - 1 : realGlideIndex;
                        
                        let translateX = 0,
                            bullet_steps = lastIndex - realGlideIndex,
                            distance = bullet_steps * bulletSize;

                        if(Math.abs(distance) < 3) distance = 0;
                        if(realGlideIndex > 2) translateX = (bullet_steps < 0 ? bulletSize*3 : bulletSize*2) - realGlideIndex * bulletSize;
                        if(realGlideIndex >= totalBullets - 3) translateX = 0 - (totalBullets - 6) * bulletSize;
                        
                        if(totalBullets > 6) {
                            currentSelector.querySelector(".has-more")?.classList.remove("has-more");
                            currentSelector.style.setProperty("--bullet-translate-x",  translateX + "px");
                            let hiddenItems = translateX / bulletSize * -1 + 6;
                            currentSelector.querySelector(".glide__bullets li:nth-child("+ hiddenItems +") .glide__bullet")?.classList.add("has-more");
                        }

                        if(document.dir == "rtl") {
                            distance *= -1;
                        }

                        currentSelector.style.setProperty("--bullet-active-translate-x", distance + "px");
                        currentSelector.style.setProperty("--bullet-last-active-translate-x", (distance * -1) + "px");
                        currentSelector.querySelector(".glide__bullets .glide__bullet--active")?.classList.add("glide__bullet--old-active");
                        currentSelector.querySelector(".glide__bullets li:nth-child("+ (realGlideIndex + 1) +") .glide__bullet")?.classList.add("glide__bullet--target");
                        currentSelector.dataset.lastindex = realGlideIndex;
                        currentSelector.classList.add("glide__bullet-animate");
                        if(currentSelector.dataset.steps && glideItem.index % currentSelector.dataset.steps == 0)
                            currentSelector.classList.add("glide__slide--group-active");
                        else
                            currentSelector.classList.remove("glide__slide--group-active");
                        //END========= Animated Bullets

                    }
                });
                GT.glidesV2[elm.dataset.glidename] = currentGlide;

                currentGlide.on(['mount.after'], function(e) {
                    let glideItem = e.instance;
                    if(glideItem) {
                        let currentSelector = glideItem.selector;
                    
                        setTabable();
                        
                        let loadMoreContainer = currentSelector.closest(".extended-search"),
                        currentLoadmoreBtn = loadMoreContainer ? loadMoreContainer.querySelector("." + currentSelector.dataset.loadmorebtn) : null;
                        
                        if(currentSelector.dataset.totalItems == glideItem.settings.perView && GT.wWidth > 768 && currentLoadmoreBtn && !currentLoadmoreBtn.classList.contains("hidden")) {
                            glideItem.disable();
                            loadMoreContainer.classList.add("fetching");
                            let glideTrackElm = currentSelector.querySelector(".glide__track");
                            glideTrackElm.style.height = glideTrackElm.offsetHeight + "px";
                            setTimeout(function(){
                                currentLoadmoreBtn.click();
                            })
                        }


                        let parentGlideSelector = currentSelector.closest(".glide-v2");
                        if(parentGlideSelector) {
                            let currentVisitedElm;

                            currentSelector.addEventListener("mousemove", function(e){
                                let parentGlide = GT.glidesV2[parentGlideSelector.dataset.glidename],
                                    currentGlideSelector = e.target.closest(".glide-v2"),
                                    currentGlideName = currentGlideSelector.dataset.glidename,
                                    currentTotalItems = currentGlideSelector.dataset.totalItems;

                                if(currentVisitedElm != currentGlideName && e.which == 0 && parentGlide) {
                                    if(currentGlideName != parentGlideSelector.dataset.glidename && currentTotalItems > 1) {
                                        currentVisitedElm = currentGlideName;
                                        parentGlide.disable();
                                        parentGlideSelector.dataset.disabled = true;
                                    } else {
                                        currentVisitedElm = parentGlideSelector.dataset.glidename;
                                        parentGlide.enable();
                                        parentGlideSelector.dataset.disabled = false;
                                    }
                                }
                                    
                            })

                            currentSelector.addEventListener("keydown", function(e) {
                                const parentGlide = GT.glidesV2[parentGlideSelector.dataset.glidename];
                                if (!parentGlide || parentGlide.isMoving || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;

                                // e.preventDefault();
                                if (e.key === "ArrowLeft") {
                                    parentGlide.go("<");
                                } else if (e.key === "ArrowRight") {
                                    parentGlide.go(">");
                                }

                                if(!e.target.closest(".glide__bullet"))
                                    parentGlide.isMoveByTabEvt = true;

                                // Focus the active slide after movement
                                setTimeout(() => {
                                    const activeSlide = currentSelector.querySelector('.glide__bullet--active');
                                    activeSlide && activeSlide.focus();
                                }, 700); // Small delay to ensure slide transition is complete
                            });
                        }
                    }
                })

                let bulletItems = Array.prototype.slice.call(elm.querySelectorAll(".glide__bullet"));
                bulletItems.forEach(function(bulletItem){
                    let detectClickEvt = false;
                    bulletItem.addEventListener("mousedown", function(e){
                        detectClickEvt = true;
                    })
                    bulletItem.addEventListener("touchstart", function(e){
                        detectClickEvt = true;
                    })
                    bulletItem.addEventListener("mouseup", function(e){
                        detectClickEvt = false;
                    })
                    bulletItem.addEventListener("touchend", function(e){
                        detectClickEvt = false;
                    })

                    bulletItem.addEventListener("click", function(e){
                        let glideItem = GT.glidesV2[this.parentElement.closest(".glide-v2").dataset.glidename];
                        if(glideItem.isMoving) return;
                        glideItem.isMoving = true;
                        if(e.buttons)
                            glideItem.isMoveByTabEvt = true;
                        glideItem.go("=" + this.dataset.go);
                        sync2Slider(glideItem, "=", this.dataset.go);
                        glideItem.isMoveByTabEvt = true;
                    })

                    bulletItem.addEventListener("focus", e => {
                        if(detectClickEvt) return;
                        let bulletIndex = e.target.dataset.go;
                        let glideItem = GT.glidesV2[e.target.closest(".glide-v2").dataset.glidename];
                        let translateX = 0;
                        if(bulletIndex > 2) translateX = bulletSize*3 - bulletIndex * bulletSize;
                        if(bulletIndex >= glideItem.selector.dataset.totalItems - 3) translateX = bulletSize*3 - (glideItem.selector.dataset.totalItems - 3) * bulletSize;

                        glideItem.selector.style.setProperty("--bullet-translate-x",  translateX + "px");
                    })
                })

                currentGlide.mount();
                //Fix issue: move 2 articels per click in safari
                let prevElm = elm.querySelector(".slider__prev"),
                    nextElm = elm.querySelector(".slider__next");
                
                    if(prevElm && nextElm) {
                        prevElm.dataset.glideCtrlName = elm.dataset.glidename;
                        nextElm.dataset.glideCtrlName = elm.dataset.glidename;
                        prevElm.onclick = function(e){
                            let glideItem = GT.glidesV2[this.dataset.glideCtrlName],
                                glideItemSelector = glideItem.selector,
                                glideItemChildSelectors = glideItemSelector.querySelectorAll(".glide-v2"),
                                glideItemChildSelector,
                                childGlide;

                            if(glideItem.isMoving) return;
                            if(glideItem.settings.type != "slider" || (glideItem.settings.type == "slider" && glideItem.index > 0))
                                glideItem.isMoving = true;

                            if(glideItemChildSelectors.length)
                                glideItemChildSelector = glideItemChildSelectors[glideItem.index];

                            if(glideItemChildSelector)
                                childGlide = GT.glidesV2[glideItemChildSelector.dataset.glidename];

                            if(e.buttons || !e.pointerType)
                                glideItem.isMoveByTabEvt = true;
                                
                            if(childGlide && childGlide.index > 0)
                                childGlide.go("<");
                            else
                                glideItem.go("<");
                            sync2Slider(glideItem, "<", 1);
                        }
                        nextElm.onclick = function(e){
                            let glideItem = GT.glidesV2[this.dataset.glideCtrlName],
                                glideItemSelector = glideItem.selector,
                                glideItemChildSelectors = glideItemSelector.querySelectorAll(".glide-v2"),
                                glideItemChildSelector,
                                childGlide;
                            
                            if(glideItem.isMoving) return;
                            if(glideItem.settings.type != "slider" || (glideItem.settings.type == "slider" && glideItem.index < glideItemSelector.dataset.totalItems - 1))
                                glideItem.isMoving = true;

                            if(glideItemChildSelectors.length)
                                glideItemChildSelector = glideItemChildSelectors[glideItem.index];

                            if(glideItemChildSelector)
                                childGlide = GT.glidesV2[glideItemChildSelector.dataset.glidename];

                            if(e.buttons || !e.pointerType)
                                glideItem.isMoveByTabEvt = true;
                                
                            if(childGlide && childGlide.index < glideItemChildSelector.dataset.totalItems - 1)
                                childGlide.go(">");
                            else
                                ((glideItem._i < glideItemSelector.dataset.totalItems - 1 && glideItemSelector.dataset.type == "slider") || glideItemSelector.dataset.type != "slider") && glideItem.go(">");

                            sync2Slider(glideItem, ">", 1);
                        }
                    }
            } else {
                currentGlide.perView = totalItems;
                currentGlide.breakpoints = breakpoints;
                currentGlide.update();
                currentGlide.enable();
                GT.glidesV2[elm.dataset.glidename] = currentGlide;
            }
        } else {
            glideSlides.forEach(function(glideItem, glideItemIndex){
                setSlideLabel(glideItem, totalItems);
            })
        }

        if(elm.querySelector(".article-tile"))
            GT.clampArticle(true);

        // Object.keys(GT.retriggerClampList).forEach(clampItemKey => {
        //     GT.retriggerClampList[clampItemKey]();
        // })

        setTimeout(function(){
            elm.classList.add("glide--show-item");
            if(elm.dataset.clampname)
                GT.clampText(elm.dataset.clampname, true);
        }, 750);
    }

    if(specificElm)
        doInitGlide(specificElm);
    else
        Array.prototype.slice.call(document.querySelectorAll(".glide-v2")).forEach(function(elm) {
            doInitGlide(elm);
        })

    function sync2Slider(slider, direction, steps){
        let targetSlider = GT.glidesV2[slider.selector.dataset.sync];
        if(!targetSlider)
            return;

        let nextIndex = slider.index;
        let nextSlide = slider.selector.querySelector('.glide__slide:not(.glide__slide--clone)[data-index="'+ nextIndex +'"]');
        let currentIdx = nextSlide ? nextSlide.dataset.parent : -100;
        if(currentIdx == -100) {
            currentIdx = nextIndex;
        }

        if(typeof currentIdx == "undefined") {
            targetGlide__slide = targetSlider.selector.querySelector('.glide__slide:not(.glide__slide--clone)[data-parent="'+ nextIndex +'"]');
            if(targetGlide__slide) {
                currentIdx = targetGlide__slide.dataset.index;
                if(direction == "=")
                    targetSlider.go("=" + currentIdx);
                else {
                    let steps = currentIdx - targetSlider.index;
                    targetSlider.go(direction + steps);
                }
            }
        } else if(targetSlider.index != currentIdx)
            targetSlider.go(direction + (direction == "=" ? currentIdx : ""));
    }
}

GT.reinitializeGlideV2 = function(){
    Object.keys(GT.glidesV2).forEach(function(key){
        GT.glidesV2[key].destroy();
    })
    
    Array.prototype.slice.call(document.querySelectorAll(".glide-v2")).forEach(function(elm) {
        // elm.dataset.renderedGlide = false;
        elm.classList.remove("glide--show-item");
        let containerElm = (elm.closest(".container") || elm.closest(".container-fluid"));
        if(containerElm) {
            let elmParentClasses = containerElm.classList;
            elmParentClasses.remove("wideGlide");
            elmParentClasses.remove("tinyWideGlide");
        }
    })
    GT.glidesV2 = {};
    GT.GlideV2();
}

GT.destroyGlideV2 = function(elm, usingFadeAnimation){
    if(!GT.glidesV2[elm.dataset.glidename]) return;
    GT.glidesV2[elm.dataset.glidename].destroy();
    
    if(usingFadeAnimation)
        elm.classList.remove("glide--show-item");
    
    let containerElm = (elm.closest(".container") || elm.closest(".container-fluid"));
    if(containerElm) {
        let elmParentClasses = containerElm.classList;
        elmParentClasses.remove("wideGlide");
        elmParentClasses.remove("tinyWideGlide");
    }

    delete GT.glidesV2[elm.dataset.glidename];
}

GT.domContentLoadedFncList.push(function(){
    LazyEvent(document.querySelectorAll(".glide-v2"), GT.GlideV2, null, null, "lazy_DOMContentLoadedEvt__GTGlideV2");
});


GT.windowResizeFncList["resizeEvt__GTGlideV2"] = function(){
    //wait for GT.wWidth update new value
    setTimeout(function(){
        GT.reinitializeGlideV2();
    }, 50)
}
GT.GlobalPeopleFinder = function(){
    if(globalPeople && globalPeople.People) {

        let app = new Vue({
            el: '.globalPeopleFinderApp',
            data: {
                countries: [],
                peoples: [],
                filter: {
                    firm: "-1",
                    name: "",
                    contact: "",
                    job: ""
                },
                limitItems: 20,
                filteredPeoples: []
            },
            methods: {
                filterPeoples
            },
            mounted: function(){
                this.$nextTick(function () {
                    filterPeoples();
                })
            }
        })

        let tmpCountries = [],
            tmpPeoples = [];
        globalPeople.People.forEach(function(item){
            if(!item.Phone)
                item.Phone = "";
            if(!item.Email)
                item.Email = "";
            if(!item.JobTitle)
                item.JobTitle = "";

            if(tmpCountries.indexOf(item.Firm) == -1)
                tmpCountries.push(item.Firm);

            tmpPeoples.push(item);
        })

        app.countries = tmpCountries;
        app.peoples = tmpPeoples;

        function filterPeoples(){
            app.filteredPeoples = doFilterPeoples(app.peoples);
        }

        function doFilterPeoples(peoples){
            return peoples.filter(function(people) {
                let regex = new RegExp('(' + app.filter.name + ')', 'i'),
                    regexContact = new RegExp('(' + app.filter.contact + ')', 'i'),
                    regexJob = new RegExp('(' + app.filter.job + ')', 'i');
                return (people.Name.match(regex) && (people.Phone.match(regexContact) || people.Email.match(regexContact)) && people.JobTitle.match(regexJob))
                        && (app.filter.firm == -1 || (app.filter.firm != -1 && people.Firm == app.filter.firm));
            })
        }
    }
}


if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GlobalPeopleFinder();
    });
GT.HeadSearch = function ($element) {
    var me = this,
        $toggle = $element.find('.icon-link'),
        $content = $element.find('.header__search-form'),
        $search = $content.find('.searchBox'),
        $close = $element.find('.h-search__close'),

        $parent = $element.parent(),
        $globalreach = $parent.find('.header__global-reach-toggle'),
        $lang = $parent.find('.header__lang'),
        $login = $parent.find('.header__login');
    $header = $parent.parent();

    function is_iOS() {
        var iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    }


    function fixNav() {
        if (is_iOS()) {
            $('body').css('overflow-y', 'auto');
            $('body').css('position', 'absolute');
            $('body').css('top', 0);
            $('body').css('bottom', 0);
            $('body').css('-webkit-overflow-scrolling', 'touch');

            $(document).on('resize', function () {
                $('body').scrollTop(topShift);
            })
        }
    }
    function unfixNav() {
        if (is_iOS()) {
            $('html, body').removeClass('absolute');
        }
    }
    function closeSearch() {                
        $element.removeClass('open');
        $content.removeClass('open');
        $toggle.css({ 'display': '' });
        $lang.css({ 'display': '' });
        $login.css({ 'display': '' });
        $globalreach.css({ 'display': '' });
        $content.css({ 'position': 'absolute' });
        $('.mobile-logo').removeClass('hide');
        document.getElementById('searchField').blur();
        setTimeout(function(){
            $toggle.focus();
        }, 50)
    }

    me.init = function () {

        // fixNav();

        var $toggle = $element.find('.icon-link'),
            $content = $element.find('.header__search-form'),
            $close = $element.find('.h-search__close');
        $parent = $element.parent();
        $globalreach = $parent.find('.header__global-reach-toggle');
        $lang = $parent.find('.header__lang');
        $login = $parent.find('.header__login');

        topShift = $(window).scrollTop();

        $('body').on('touchmove', function () {
            topShift = $(window).scrollTop();
            document.activeElement.blur();
        })

        $toggle.on('click keydown', function (e) {            
            if (!e.keyCode || e.keyCode === '13') {
                $('.insight-menu__toggle').removeClass('open');
                $element.addClass('open');
                $content.addClass('open');
                $search.focus();
                $(this).css({ 'display': 'none' });
                $globalreach.css({ 'display': 'none' });
                $lang.css({ 'display': 'none' });
                $login.css({ 'display': 'none' });
                $content.css({ 'position': 'relative' });
                $('.mobile-logo').addClass('hide');
                document.getElementById('searchField').focus();
            }
        });

        $close.on('click keydown', function (e) {
            if (!e.keyCode || e.keyCode === 13) {
                closeSearch();
            }
        });

        // $content.find('.searchBox').blur(function () {
        //     closeSearch();
        // });


    }
    me.init();
};
GT.GTHomepageBannerCarousel = function (mainSlide) {
    if (mainSlide) {

        let controlSlide = mainSlide.querySelector(".hero-carousel-tabs"),
            mainSliderContainer = mainSlide.querySelector(".container"),
            mainSlideItems = mainSlide.querySelectorAll(".hero-carousel-slide"),
            backgroundItems = mainSlide.querySelectorAll(".hero-carousel__background"),
            controlSlideItems = controlSlide.querySelectorAll("li"),
            dotItems = mainSlide.querySelectorAll(".hero-carousel__dot"),
            nextBtn = mainSlide.querySelector(".hero-carousel__button-next"),
            preBtn = mainSlide.querySelector(".hero-carousel__button-prev"),
            itemNum = mainSlideItems.length,
            directionIsLTR = true,
            firstChildClonedElm,
            lastChildClonedElm,
            timeout,
            timeoutList = [],
            hasOutAnimation = false,
            _timer,
            transitionTime = mainSlide.dataset.slideTransitionTime ? parseInt(mainSlide.dataset.slideTransitionTime) * 1000 : 3000,
            isRTL = document.querySelector(".RTL");

        function triggerAnimation(currentSlide, currentBackground) {
            if (GT.wWidth > GT.breakPoints.tablet_lg && (!currentBackground || currentBackground.dataset.loaded)) {
                currentBackground?.querySelectorAll(".animation-item").forEach(function (animateItem) {
                    animateItem.classList.add(animateItem.dataset.transition);
                })
                currentSlide.querySelectorAll(".animation-item").forEach(function (animateItem) {
                    animateItem.classList.add(animateItem.dataset.transition);
                })
            }
        }

        function resetState(idx, isTriggerByPaginationItem) {
            timeoutList.forEach(function (timerItem) {
                clearTimeout(timerItem);
            })
            mainSlideItems = mainSlide.querySelectorAll(".hero-carousel-slide");
            backgroundItems = mainSlide.querySelectorAll(".hero-carousel__background");

            let isMobileView = GT.isMobileView();
            controlSlideItems.forEach(function (elm) {
                elm.classList.remove("active", "animate");
                elm.querySelector(".hero-carousel-tab").removeAttribute("aria-current");
                let buttonElm = elm.querySelector("[role=button]");
                if(buttonElm) {
                    buttonElm.setAttribute("tabindex", isMobileView ? -1 : 0);
                    if(isMobileView)
                        buttonElm.setAttribute("aria-hidden", true);
                    else
                        buttonElm.removeAttribute("aria-hidden", true);
                }
            })


            dotItems.forEach(function (elm) {
                elm.classList.remove("active");
                elm.removeAttribute("aria-current");
            })
            let currentDotItem = dotItems[idx];
            currentDotItem.classList.add("active");
            currentDotItem.setAttribute("aria-current", true);

            let currentControlSlideItem = controlSlideItems[idx];
            currentControlSlideItem.classList.add("active", "animate");
            currentControlSlideItem.querySelector(".hero-carousel-tab").setAttribute("aria-current", true);

            let currentSlide = mainSlideItems[idx],
                currentBackground = backgroundItems.length ? backgroundItems[idx] : null;

            if (GT.wWidth > GT.breakPoints.tablet_lg) {
                if(!hasOutAnimation)
                    currentSlide.querySelectorAll(".animation-item").forEach(function (animateItem) {
                        animateItem.classList.remove(animateItem.dataset.transition);
                    })
            }

            function triggerAnimationOnImageLoaded(elm, elmIndex) {
                if(!elm.dataset.loaded) {
                    elm.dataset.loaded = true;
                    if(idx == elmIndex) {
                        elm.classList.add("active");
                        currentBackground = elm;
                        triggerAnimation(currentSlide, currentBackground);
                    }
                }
            }

            backgroundItems.forEach(function (elm, elmIndex) {
                //show background item firstly, animation issue with display none
                elm.classList.add("show");
                //only trigger animation on unloaded image
                if(!elm.dataset.loaded) {
                    const imgElm = elm.querySelector("img");
                    //trigger animation on image: loaded or error
                    ["load", "error"].forEach(function (evt) {
                        imgElm?.addEventListener(evt, function() {
                            triggerAnimationOnImageLoaded(elm, elmIndex);
                        })
                    });
                    
                    //handle first item and no image cases
                    if(elmIndex == 0 || !imgElm) {
                        elm.dataset.loaded = true;
                    }
                }
                
                // trigger animation after 2 seconds if image is not loaded completely
                // force trigger animation
                setTimeout(() => {
                    triggerAnimationOnImageLoaded(elm, elmIndex);
                }, 2000)
            })

            let currentTimeout = setTimeout(function () {
                if (backgroundItems.length)
                    backgroundItems.forEach(function (elm) {
                        elm.classList.remove("active");
                        if (GT.wWidth > GT.breakPoints.tablet_lg)
                            elm.querySelectorAll(".animation-item").forEach(function (animateItem) {
                                animateItem.classList.remove(animateItem.dataset.transition);
                            })
                    })

                mainSlideItems.forEach(function (elm) {
                    elm.classList.add("show");
                    elm.classList.remove("active");
                    elm.setAttribute("aria-hidden", true);
                    elm.removeAttribute("tabindex");
                    elm.querySelector('a')?.setAttribute("tabindex", -1);
                })

                if (GT.wWidth > GT.breakPoints.tablet_lg) {
                    if(hasOutAnimation)
                        mainSlide.querySelectorAll(".animation-item").forEach(function (animateItem) {
                            animateItem.classList.remove("use-block-element-fade-out");
                        })
                }


                currentSlide.classList.add("active");
                currentSlide.removeAttribute("aria-hidden");
                currentSlide.querySelector('a')?.removeAttribute("tabindex");
                if(isTriggerByPaginationItem) {
                    currentSlide.setAttribute("tabindex", 0);
                    setTimeout(() => {
                        if(GT.isScreenReader)
                            currentSlide.focus();
                        setTimeout(() => {
                            currentSlide.removeAttribute("tabindex");
                        }, 1000)
                    }, 50)
                }
                
                if (currentBackground?.dataset.loaded)
                    currentBackground.classList.add("active");

                triggerAnimation(currentSlide, currentBackground);

            }, hasOutAnimation && GT.wWidth >= GT.breakPoints.tablet_lg ? 1600 : 200)

            if (GT.wWidth < GT.breakPoints.tablet_lg) {
                controlSlide.classList.add("animate");

                let tmpIdx = idx;

                if (!isTriggerByPaginationItem) {
                    if (directionIsLTR) {
                        if (idx == 0 && lastChildClonedElm) {
                            tmpIdx = itemNum;
                            lastChildClonedElm.classList.add("active");
                        }
                    } else {
                        if (idx == itemNum - 1 && firstChildClonedElm) {
                            tmpIdx = -1;
                            firstChildClonedElm.classList.add("active");
                        }
                    }
                }

                controlSlide.style.transform = "translateX(calc(100% * " + ((isRTL ? 1 : -1) * (tmpIdx + 2)) + "))";
                timeout = setTimeout(function () {
                    controlSlide.classList.remove("animate");
                    controlSlide.style.transform = "translateX(calc(100% * " + ((isRTL ? 1 : -1) * (idx + 2)) + "))";
                    firstChildClonedElm.classList.remove("active");
                    lastChildClonedElm.classList.remove("active");
                    timeout = null;
                }, 400);
            }
        
            timeoutList.push(currentTimeout);
        }

        mainSlide.querySelectorAll(".animation-item").forEach(function (animateItem) {
            animateItem.classList.remove(animateItem.dataset.transition);
        })

        let currentActivatedItem = mainSlide.querySelector(".gt-small-title.active")
        mainSlide.currentItemIdx = 0;

        mainSlide.querySelector(".first_time")?.classList.add("active");

        if (currentActivatedItem)
            currentActivatedItem.classList.add("animate");
                   


        function genClone() {
            cloneItems = controlSlide.querySelectorAll(".clone");
            if (GT.wWidth >= GT.breakPoints.tablet_lg) {
                cloneItems.forEach(function (item) {
                    item.remove();
                })
                controlSlide.style.transform = "translateX(0)";
                return;
            }

            if (cloneItems.length)
                return;

            let firstChild = controlSlideItems[0],
                lastChild = controlSlideItems[itemNum - 1],
                cloneLastChild = lastChild.cloneNode(true),
                cloneFirstChild = firstChild.cloneNode(true);
            cloneLastChild.classList.add("clone");
            cloneFirstChild.classList.add("clone");
            cloneFirstChild.classList.remove("active");
            cloneFirstChild.classList.remove("animate");
            controlSlide.insertBefore(cloneLastChild, firstChild);
            controlSlide.insertBefore(cloneFirstChild, lastChild.nextSibling);

            controlSlide.style.transform = "translateX(calc(100% * " + ((isRTL ? 1 : -1) * (mainSlide.currentItemIdx + 2)) + "))";
            firstChildClonedElm = cloneLastChild;
            lastChildClonedElm = cloneFirstChild;

            let preFirstChild = controlSlideItems[1],
                preLastChild = controlSlideItems[itemNum - 2],
                clonePreLastChild = preFirstChild.cloneNode(true),
                clonePreFirstChild = preLastChild.cloneNode(true);

            clonePreLastChild.classList.add("clone");
            clonePreFirstChild.classList.add("clone");
            clonePreFirstChild.classList.remove("active");
            clonePreFirstChild.classList.remove("animate");
            controlSlide.insertBefore(clonePreFirstChild, cloneLastChild);
            controlSlide.insertBefore(clonePreLastChild, cloneFirstChild.nextSibling);
        }

        if (controlSlideItems.length && controlSlideItems.length > 1) {
            let isMobile = GT.isMobileView();
            controlSlideItems.forEach(function (item) {
                ["click", "keydown"].forEach(evt => {
                    item.querySelector(".hero-carousel-tab").addEventListener(evt, function (e) {
                        if(!e.key || e.key == "Enter") {
                            const _currentItemIdx = parseInt(e.currentTarget.dataset.index);
                            resetState(_currentItemIdx, true);
                            clearInterval(_timer);
                            mainSlide.currentItemIdx = _currentItemIdx;
                            if (GT.isScreenReader)
                                setTimeout(function () {
                                    mainSlideItems[_currentItemIdx].focus();
                                }, 100)
                        }
                    })
                    
                })               

                if(!isMobile) {
                    let focusableElm = item.querySelector(".hero-carousel-tab");
                    if(focusableElm) {
                        focusableElm.setAttribute("tabindex", 0);
                        focusableElm.removeAttribute("aria-hidden");
                    }
                }
            })

            // mainSlideItems.forEach(function (elm) {
            //     elm.addEventListener("focus", function () {
            //         if (isScreenReader !== 0) {
            //             isScreenReader = true;
            //             clearInterval(_timer);
            //         }
            //     })
            //     elm.addEventListener("mouseenter", function () {
            //         isScreenReader = 0;
            //     })
            // })


            dotItems.forEach(function (elm) {
                elm.addEventListener('click', function (e) {
                    if (timeout)
                        return;

                    mainSlide.currentItemIdx = parseInt(e.target.dataset.index);

                    resetState(mainSlide.currentItemIdx, true);
                    clearInterval(_timer);                    
                })
            })

            nextBtn.addEventListener("click", function () {
                if (timeout)
                    return;

                if (mainSlide.currentItemIdx + 1 >= itemNum)
                    mainSlide.currentItemIdx = 0;
                else
                    mainSlide.currentItemIdx++;
                directionIsLTR = true;
                resetState(mainSlide.currentItemIdx);
                clearInterval(_timer);                
            })

            preBtn.addEventListener("click", function () {
                if (timeout)
                    return;

                if (mainSlide.currentItemIdx - 1 < 0)
                    mainSlide.currentItemIdx = itemNum - 1;
                else
                    mainSlide.currentItemIdx--;
                directionIsLTR = false;
                resetState(mainSlide.currentItemIdx);
                clearInterval(_timer);               
            })


            //=============================
            //=======DETECT SWIPE DIRECTION
            //=============================

            let touchstartX = 0
            let touchendX = 0

            function checkDirection() {
                if (touchstartX - touchendX > 50) {
                    //swiped left!
                    if (isRTL)
                        preBtn.click();
                    else
                        nextBtn.click();
                }

                if (touchendX - touchstartX > 50) {
                    //swiped right!
                    if (isRTL)
                        nextBtn.click();
                    else
                        preBtn.click();
                }
            }

            if (mainSliderContainer) {
                mainSliderContainer.addEventListener('touchstart', function (e) {
                    touchstartX = e.changedTouches[0].screenX;
                    clearInterval(_timer);
                }, { passive: true })

                mainSliderContainer.addEventListener('touchend', function (e) {
                    touchendX = e.changedTouches[0].screenX;
                    checkDirection();                    
                })
            }

            GT.windowResizeFncList["GTHomepageBannerCarousel" + Math.random(0, 100000)] = function () {
                resetState(mainSlide.currentItemIdx);
                genClone();
            }
            
            genClone();
        }
    }
}

GT.domContentLoadedFncList.push(function () {
    document.querySelectorAll(".hero-carousel").forEach(function (item) {
        GT.GTHomepageBannerCarousel(item);
    })
});
GT.HomeIndustryBlock = function () {
    document.querySelectorAll(".homepage-industry__block").forEach((block) => {
        block.querySelectorAll(".homepage-industry__links").forEach((link) => {
            link.addEventListener("mouseenter", (e) => {
                const target = e.currentTarget;
                const parent = target.closest(".homepage-industry__block");
                const images = parent.querySelectorAll(".homepage-industry__background.hide-to-desktop img");
                const targetIndex = target.dataset.index;
                const targetImage = Array.from(images).find(image => image.getAttribute('data-index') === targetIndex);

                if (!targetImage) return;
                images.forEach((img) => img.classList.remove("active"));
                targetImage.classList.add("active");
            });
        });
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.HomeIndustryBlock();
    });

GT.HomeInsightsNewsPromoBlock = function () {
    let __ths = {};//should not use __ths = this; because of global scope, impact to the other blocks
    init();
    function init() {

        let _tagFilterTabItems = document.querySelectorAll('.tag-filters-container .tag-filter__tab--item');
        
        [].forEach.call(_tagFilterTabItems, function(tabFilter) {
            tabFilter.addEventListener('click', function(e) {
                let _this = this;
                if(_this.classList.contains('selected')) return;

                let _tagFilterTabContainer = _this.parentNode;
                if(_tagFilterTabContainer) {
                    //Remove old active tab
                    let _activeTab = _tagFilterTabContainer.querySelector('.tag-filter__tab--item.selected');
                    if(_activeTab) _activeTab.classList.remove('selected');

                    _this.classList.add('selected');
                    _this.classList.add('focus');

                    let containerElm = _this.closest('.tag-filters-container');
                    if(!containerElm) return;
                    let _tabEndpointInput = containerElm.querySelector('.searchEndpoint');
                    if(!_tabEndpointInput) return;

                    let _endpointUri = _tabEndpointInput.getAttribute('data-endpoint'); 

                    let _ajaxUrl = _endpointUri;

                    let _filterTag = _this.getAttribute('data-tag');

                    if(_filterTag) _ajaxUrl += '&tags=' + _filterTag;

                    containerElm.classList.add("fetching");
                                
                    setTimeout(() => {
                        GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
                    }, 10);
                    
                    function successCallback(contextRef, data) {
                        let _insightsPromoContainerBlock = _this.closest('.tag-filters-container');
                        if(!_insightsPromoContainerBlock) return;
                        let _replaceResultContainer = _insightsPromoContainerBlock.querySelector('.tag-filters-result');
                        GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText;
                        if(_replaceResultContainer) {
                            __ths.replaceResults(data, _replaceResultContainer);
                            _this.blur();
                            const glideV2Elm = _insightsPromoContainerBlock.querySelector(".glide-v2");
                            if(_replaceResultContainer.querySelector(".glide__slide") && glideV2Elm) {
                                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging(1000);
                                GT.destroyGlideV2(glideV2Elm);
                                GT.GlideV2(glideV2Elm);
                            }

                            if(_replaceResultContainer.querySelector(".transaction-list__item")) {
                                GT.TombstoneTransaction && GT.TombstoneTransaction();
                            }

                            let selectedTab = _tagFilterTabContainer.querySelector('.tag-filter__tab--item.selected');
                            _replaceResultContainer.closest("[role='tabpanel']")?.setAttribute("aria-labelledby", selectedTab.id);

                            if(GT.isEventFromScreenReader(e)) {
                                const firstFocusableElm = GT.getFirstFocusableVisible(_replaceResultContainer);
                                if(firstFocusableElm) {
                                    setTimeout(() => {
                                        firstFocusableElm.focus();
                                    }, 0);
                                } else {
                                    selectedTab.focus();
                                }
                            }
                        }
                        containerElm.classList.remove("fetching");
                        setTimeout(() => {
                            GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText;
                        }, 10);
                    }
            
                    __ths.ajaxCall(__ths.escapeQueryChars(_ajaxUrl), successCallback); 
                }
            });

            tabFilter.addEventListener('focus', function(e) {
                if(GT.isScreenReader) {
                    GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging(200);
                    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });

            tabFilter.addEventListener("mouseout", mouseOut);
            function mouseOut() {
                this.classList.remove('focus');
                isClicked = false;
            }
        });
    }

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };


    __ths.ajaxCall = function (url, successCallback) {
        var contextRef = this;
        let __url = url;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.response && this.status == 200) {
                    successCallback(contextRef, this.response);
                } else {
                    // isInited = false;
                }
            }
        };
        xhttp.open("GET", __url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    __ths.replaceResults = function (data, _replaceContainer) {
        if(_replaceContainer) {
            //WILL_REMOVE gt-newtypo
            data = data.replaceAll('class="title "', 'class="title gt-newtypo"');
            data = data.replaceAll('class="category "', 'class="category gt-newtypo"');
            _replaceContainer.innerHTML = data;
            GT.FakeHyperlink();
        }

        // TODO, check if text is blink
        setTimeout(function() {
            GT.clampArticle();
            GT.GTBookmarkArticle && GT.GTBookmarkArticle();
        }, 100);
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.HomeInsightsNewsPromoBlock();
    });
GT.HorizontalTable = function ($elem) {
    $.each($elem, function (index, element) {
        var $table = $(element).find('table');
        $(window).on('resize', function () {
            changeRowBorder($table, index);
        });
        changeRowBorder($table, index);
    });

    function changeRowBorder($table, index) {
        var styleId = 'gt-hr-' + index;
        var tableId = 'gt-hr-tb-' + index;
        $table.attr('id', tableId);
        var styleDom = $('#' + styleId);
        var $tr = $table.find('tbody tr');
        if ($tr.length > 0 && $tr.width() > $table.width()) {
            var trWidth = $tr.width();
            var borderWidth = (trWidth - 32);
            if (styleDom.length > 0) styleDom.remove();
            var dom = $('<style id="' + styleId + '">.gt-horizontal-table #' + tableId +' tr:after { min-width: ' + borderWidth + 'px; } </style>');
            $('body').append(dom);
        } else {
            if (styleDom.length > 0) {
                styleDom.remove();
            }
        }
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
            GT.HorizontalTable($(".gt-horizontal-table"));
    });
GT.HubspotForms = function() {
    const formContainer = document.querySelector(".hbspt-form");
    if(formContainer) {
        // Initialize floating labels for HubSpot forms after form renders
        GT.initHubspotFormFloatingLabels(formContainer);
    }
}

GT.initHubspotFormFloatingLabels = function(formContainer) {
    // Wait for HubSpot form to be fully rendered
    const checkFormReady = () => {
        const form = formContainer.querySelector('form');
        const fields = formContainer.querySelectorAll('.hs-form-field');
        
        if (form && fields.length > 0) {
            // Form is ready, initialize floating labels
            new GT.HubspotForm(formContainer);
        } else {
            // Form not ready yet, check again in 100ms
            setTimeout(checkFormReady, 100);
        }
    };
    
    // Start checking for form readiness
    checkFormReady();
    
    // Also listen for HubSpot's form ready event if available
    if (window.hbspt && window.hbspt.forms) {
        window.hbspt.forms.create({
            region: "na1",
            portalId: "your-portal-id", // This will be overridden by actual form
            formId: "your-form-id",     // This will be overridden by actual form
            onFormReady: function($form) {
                // Form is ready, initialize floating labels
                new GT.HubspotForm(formContainer);
            }
        });
    }
}

GT.HubspotForm = function(formElement) {
    this.formElement = formElement;
    this.addFloatingClass();
    

    // Add submit event listener to form
    formElement.addEventListener('submit', (e) => {
        this.booleanCheckboxValidation(formElement);
    });

    // Also handle clicks on submit button in case form submission is prevented
    const submitButton = formElement.querySelector('input[type="submit"]');
    if (submitButton) {
        submitButton.addEventListener('click', (e) => {
            this.booleanCheckboxValidation(formElement);
        });
    }
    // Add change event listener to checkbox inputs
    const checkboxFields = formElement.querySelectorAll('.hs-fieldtype-booleancheckbox input[type="checkbox"]');
    if (checkboxFields) {
        checkboxFields.forEach(checkbox => {
            checkbox.addEventListener('change', (e) => {
                const field = e.target;
                const wrapper = field.closest('.hs-fieldtype-booleancheckbox');
                let isError = wrapper.querySelector('.hs-error-msgs');
                if(isError) {
                    field.classList.add('error');
                } else {
                    field.classList.remove('error');
                }
            });
        });
    }

    const handleFormSubmission = (event) => {
        const { type, eventName } = event.data;
        if (type === 'hsFormCallback' && eventName === 'onFormSubmitted') {
            formElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    window.addEventListener('message', handleFormSubmission);

};

GT.HubspotForm.prototype.addFloatingClass = function() {
    let _this = this;
    let form = _this.formElement;

    function errorClassHandle(field) {
        let wrapper = field.closest('.hs-form-field');
        if (field.classList.contains('hs-error-msgs') && wrapper.querySelector('.hs-error-msgs')) {
            wrapper.classList.add('error');
        } else {
            wrapper.classList.remove('error');
        }
    }

    function filledClassHandle(item) {
        let parent = item.closest('.hs-form-field');
        if (item.value && item.value.length) {
            parent.classList.add('filled');
        } else {
            parent.classList.remove('filled');
        }
    }

    function addLabelTitle(field) {
        let parent = field.closest('.hs-form-field');
        let label = parent.querySelector('.hs-label');
        const labelContent = label?.textContent.trim();
        if(labelContent && labelContent.length > 0) {
            label.setAttribute("title", labelContent);
            field.setAttribute("title", labelContent);
        }
    }
        
    let inputFields = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="date"], select, textarea');

    if (inputFields) {
        inputFields.forEach(function(element) {
            let fieldWrap = element.closest('.hs-form-field');

            if(fieldWrap) {
                fieldWrap.classList.add('floating-label');
                
                errorClassHandle(element);
                
                addLabelTitle(element);

                setTimeout(function() {
                    filledClassHandle(element);
                }, 1000)
                
                element.addEventListener('focusin', function(e) {
                    errorClassHandle(e.target);
                    fieldWrap.classList.add('focus');
                })
                element.addEventListener('focusout', function(e) {
                    errorClassHandle(e.target);
                    fieldWrap.classList.remove('focus');
                })
                element.addEventListener('change', function(e) {
                    filledClassHandle(e.target);
                
                    setTimeout(function() {
                        errorClassHandle(e.target);
                    }, 1000)
                })
            }
        });
    }
}

GT.HubspotForm.prototype.booleanCheckboxValidation = function(form) {
    // Find all boolean checkbox fields with error messages
    const booleanCheckboxFields = form.querySelectorAll('.hs-fieldtype-booleancheckbox');
    
    booleanCheckboxFields.forEach(errorElement => {
        let isError = errorElement.querySelector('.hs-error-msgs');
        const checkboxInput = errorElement.querySelector('input[type="checkbox"]'); 
        if (!checkboxInput) return;
        if (isError) {
            checkboxInput.classList.add('error');
        } else {
            checkboxInput.classList.remove('error');
        }
    });
}


GT.domContentLoadedFncList.push(function(){
    GT.HubspotForms();
});
GT.IBCDListingPage = function() {
    document.addEventListener("click", function(e){
        let trackingElm = e.target.closest("[data-gtm-tracking]");
        if(trackingElm) {
            dataLayer.push({ 'event': 'ibcd_listing', 'eventAction': trackingElm.dataset.gtmTracking, "eventLabel": trackingElm.closest(".t4-single__expert").dataset.trackingLabel });
        }
    })
}

GT.domContentLoadedFncList.push(function(){
    GT.IBCDListingPage();
});
GT.GTIBCFinder = function () {
    let _currentSelectedCountry = '',
        _suggestSection = document.querySelector('.ibc-suggested__section'),
        autoCompleteObj;

    let countriesListElm = document.getElementById('countriesList');
    
    let ibcFinderLatLongEndpoint = document.getElementById('ibcFinderLatLongEndpoint');
    let ibcSearchbox = document.getElementById('ibc_finder_searchbox');
    let ibcFinderSelectContainer = document.querySelector('.ibc-finder__select--container');
    
    if(!ibcSearchbox || !ibcFinderSelectContainer || !ibcFinderLatLongEndpoint || !_suggestSection)
        return;

    _currentSelectedCountry = ibcSearchbox.getAttribute('placeholder');

    initDropdown();
    useMyLocation();
    function initDropdown() {
        selectCountry();
        if(ibcSearchbox) {
            ibcSearchbox.addEventListener('click', initIbcSelectbox);
        }

        function initIbcSelectbox() {
            ibcSearchbox.value = "";
            ibcSearchbox.setAttribute('placeholder', _currentSelectedCountry);
            
            if(ibcFinderSelectContainer.classList.contains('dropdown-expanded')) {
                ibcFinderSelectContainer.classList.remove('dropdown-expanded');
            } else {
                ibcFinderSelectContainer.classList.add('dropdown-expanded');
            }
        }

        document.addEventListener('click', function(event) {
            let _autoCompleteSelect = event.target;
            ibcSearchbox.value = "";

            ibcSearchbox.setAttribute('placeholder', _currentSelectedCountry);
            
            if (!_autoCompleteSelect.closest('.bc-finder__select--container')
                && !_autoCompleteSelect.closest('.ibc-finder__select--searchbox')) {

                let autoCompleteElm = document.querySelector('.ibc-finder__autocomplete-suggestions');
                if(autoCompleteElm) autoCompleteElm.style.display = 'none';
                if(ibcFinderSelectContainer) ibcFinderSelectContainer.classList.remove('dropdown-expanded');

                if(!_currentSelectedCountry) {
                    let __countrySelected = document.getElementById('countrySelected');
                    _currentSelectedCountry = __countrySelected.getAttribute('data-value');
                }

                ibcSearchbox.setAttribute('placeholder', _currentSelectedCountry);
                ibcSearchbox.blur();
            }
            return true;
        });

        
        let __countrySelected = document.getElementById('countrySelected');
        if(__countrySelected) {
            dataLayer.push({ 'event': 'ibcd', 'eventAction': 'selected_country', 'eventLabel': __countrySelected.getAttribute('data-value')});
            dataLayer.push({ 'event': 'ibcd', 'eventAction': 'locationdeteced', 'eventLabel': 'by_maxmind'});
            peopleTracking();
        }
    }

    function countriesLookup(query) {
        let result = [],
        countriesList = countriesListElm.getAttribute('data-value');
        countriesList = JSON.parse(countriesList);
        
        if(!query) return countriesList;
        
        if(countriesList && countriesList.length > 0) {
            result = countriesList.filter(function(obj) {
                return (obj.value.toLowerCase().indexOf(query.toLowerCase()) > -1) || (obj.data.toLowerCase().indexOf(query.toLowerCase()) > -1);
            });
            return result;
        }
    }

    function selectCountry() {
        if(autoCompleteObj) autoCompleteObj.destroy();

        autoCompleteObj = new autoComplete({
            selector: '#ibc_finder_searchbox',
            minChars: 0,
            cache: 0,
            menuClass: 'ibc-finder__autocomplete-suggestions',
            source: function(term, suggest){
                term = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                let tmpArr = countriesLookup(term);
                suggest(tmpArr);
            },
            renderItem: function (item, search){
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item.value + '">' + item.value.replace(re, "<b>$1</b>") + '</div>';
            },
            onSelect: function (event, term, item) {
                ibcFinderSelectContainer.classList.remove('dropdown-expanded');
        
                let __countrySelected = document.getElementById('countrySelected');
                if(__countrySelected)
                    __countrySelected.setAttribute('data-value', term);

                getSelectedCountry(term);
                _currentSelectedCountry = term;

            },
        })
    }

    function peopleTracking(){
        document.querySelectorAll(".ibc-contact").forEach(function(item) {
            item.addEventListener("click", function(ev){
                let item = ev.target;
                let peopleName = item.closest(".contact-details").querySelector(".ibc-suggested__title");
                    peopleName = peopleName ? peopleName.innerText : "Unknown People";

                let currentFirm = item.closest(".ibc-glide__container").querySelector(".firm .glide__slide--active") || item.closest(".ibc-glide__container").querySelector(".firm .glide__slide");
                    currentFirm = currentFirm ? currentFirm.querySelector(".ibc-suggested__title").innerText : "Unknown Firm";

                dataLayer.push({ 'event': 'ibcd', 'eventAction': 'selected_member_firm', 'eventLabel': currentFirm + " / " + peopleName});
            })
        })
    }

    function getSelectedCountry(selectedCountry) {
        let _endPointUrl = document.getElementById('ibcFinderEndpoint').getAttribute('data-endpoint'),
            _lastSectionHeight = _suggestSection.offsetHeight;

        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                let data = this.response;
                if (data && this.status == 200) {
                    ibcFinderSelectContainer.classList.remove('dropdown-expanded');
                    _suggestSection.style.opacity = 0;
                    GT.disableDetectScrollUpOrDown = true;
                    if (!document.querySelector('.no-ibc__support')) {
                        _suggestSection.style.height = _lastSectionHeight + 'px';
                        _suggestSection.style.overflow = 'hidden';
                    }

                    setTimeout(function() {
                        _suggestSection.innerHTML = data;
                        let _ibcGlide = document.querySelector('.ibc-glide__container');

                        if(_ibcGlide) {
                            _ibcGlide.querySelectorAll(".glide").forEach(function(item) {
                                GT.Glide(item);
                            })
                        } else {
                            GT.clampText("ibcblock");
                        }

                        
                        dataLayer.push({ 'event': 'ibcd', 'eventAction': 'selected_country', 'eventLabel': selectedCountry});

                        
                        setTimeout(function() {
                            _suggestSection.style.removeProperty('height');
                            _suggestSection.style.removeProperty('overflow');
                            _suggestSection.style.opacity = 1;
                            GT.disableDetectScrollUpOrDown = false;
                            _lastSectionHeight = _suggestSection.offsetHeight;
                            setSearchboxValue();
                            peopleTracking();
                        }, _ibcGlide ? 800 : 100);
                    }, 100);
                }
            }
        };
        xhttp
        xhttp.open("GET", _endPointUrl + '/?country=' + encodeURIComponent(selectedCountry), true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    function getIBCByLatLong(latitude, longitude) {
        let _endPointUrl = ibcFinderLatLongEndpoint.getAttribute('data-endpoint');
        let _lastSectionHeight = _suggestSection.offsetHeight;
        
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                let data = this.response;
                if (data && this.status == 200) {
                    _suggestSection.style.opacity = 0;
                    GT.disableDetectScrollUpOrDown = true;
                    if (!document.querySelector('.no-ibc__support')) {
                        _suggestSection.style.height = _lastSectionHeight + 'px';
                        _suggestSection.style.overflow = 'hidden';
                    }
                    setTimeout(function() {
                        _suggestSection.innerHTML = data;
                        setSearchboxValue();
                        let _ibcGlide = document.querySelector('.ibc-glide__container');
                        
                        if(_ibcGlide) {
                            _ibcGlide.querySelectorAll(".glide").forEach(function(item) {
                                GT.Glide(item);
                            })
                        } else {
                            GT.clampText("ibcblock");
                        }

                        setTimeout(function() {
                            _suggestSection.style.removeProperty('height');
                            _suggestSection.style.removeProperty('overflow');
                            _suggestSection.style.opacity = 1;
                            GT.disableDetectScrollUpOrDown = false;
                            _lastSectionHeight = _suggestSection.offsetHeight;

                            let __currentCountry = document.getElementById('countrySelected');
                            if(__currentCountry) {
                                ibcSearchbox.setAttribute('placeholder', __currentCountry.getAttribute('data-value'));
                                _currentSelectedCountry = __currentCountry.getAttribute('data-value');
                                dataLayer.push({ 'event': 'ibcd', 'eventAction': 'selected_country', 'eventLabel': _currentSelectedCountry});
                                dataLayer.push({ 'event': 'ibcd', 'eventAction': 'locationdeteced', 'eventLabel': 'by_googlemap'});
                                ibcSearchbox.value = "";
                                ibcSearchbox.blur();
                                peopleTracking();
                            }
                        }, _ibcGlide ? 800 : 100);
                    }, 100);
                }
            }
        };
        xhttp.open("GET", _endPointUrl + '?latitude=' + latitude + '&longitude=' + longitude, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.send();
    }

    function setSearchboxValue() {
        let __countrySelected = document.getElementById('countrySelected');
        let _selectedCountry = __countrySelected.getAttribute('data-value');
        _currentSelectedCountry = _selectedCountry;

        ibcSearchbox.setAttribute('placeholder', _currentSelectedCountry);
        ibcSearchbox.blur();

        let autoCompleteElm = document.querySelector('.ibc-finder__autocomplete-suggestions');
        if(autoCompleteElm) autoCompleteElm.style.display = 'none';
    }

    function useMyLocation() {
        
        let ibcCurrentLocationElm = document.querySelector('.ibc-current__location');
        if(ibcCurrentLocationElm) {
            ibcCurrentLocationElm.addEventListener('click', function() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(successFunction, errorFunction);
                }
                this.blur();
            });
        }
    }

    function successFunction(position) {
        getIBCByLatLong(position.coords.latitude, position.coords.longitude);
    }
    
    function errorFunction() {
        var accessErrorMessage = document.getElementById('cannotAccessErrorMessage').getAttribute('data-value');
        if (!accessErrorMessage) {
            accessErrorMessage = 'Access device location is required to use this feature.';
        }
        _suggestSection.innerHTML = '<div class="no-ibc__support">' + accessErrorMessage + '</div>';
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){	
		new GT.GTIBCFinder();
    });

GT.ImagesGallery = function () {
    // Constants for better maintainability
    const modalDelay = 100;
    const slideTransitionDelay = 100;
    const sliderVisibleDelay = 250;
    const cssClasses = {
        openingModal: 'opening-modal',
        active: 'active',
        show: 'show',
        glideV2: 'glide-v2',
        glideSwipeable: 'glide--swipeable',
        gallerBlock: 'image-gallery-block',
        galleryModal: 'gallery-modal',
        galleryList: 'gallery-list',
        galleryItem: 'gallery-item',
        galleryItemIcon: 'gallery-item__icon',
        modalCloseButton: 'modal-close-button',
        glideSlide: 'glide__slide',
        glideSlides: 'glide__slides',
        lightbox: 'lightbox'
    };

    // Cache DOM elements to improve performance
    const domCache = {
        documentElement: document.firstElementChild,
        galleryItems: null,
        galleryIcons: null,
        closeButton: null
    };

    function openModal(target) {
        if (!target) return;
        // Optimize animation class removal with early returns and reduced DOM queries
        const animatedParentDiv = target.closest('.animatedParent');
        if (animatedParentDiv) {
            animatedParentDiv.classList.remove('animatedParent', 'animateOnce');
        }

        const animatedItemDiv = target.closest('.animated');
        if (animatedItemDiv) {
            animatedItemDiv.classList.remove('animated', 'fadeInUpShort', 'go');
        }
        setTimeout(() => {
            target.classList.add(cssClasses.active);
            setTimeout(() => {
                domCache.documentElement.classList.add(cssClasses.openingModal);
            }, modalDelay*5);
        });
    }

    function closeModal(target, activeSlideIndex) {
        if (!target) return;
        
        domCache.documentElement.classList.remove(cssClasses.openingModal);
        target.classList.remove(cssClasses.show);
        let mainSlider = target.closest(`.${cssClasses.gallerBlock}`)?.querySelector(`.${cssClasses.galleryList}`);
        
        setTimeout(() => {
            target.classList.remove(cssClasses.active);
            if  (mainSlider.classList.contains(cssClasses.glideV2)) {
                let activeSlide = mainSlider?.querySelector(`.${cssClasses.glideSlide}[data-index="${activeSlideIndex}"]`);
                activeSlide?.querySelector(`.${cssClasses.galleryItem}`)?.focus();
            } else {
                let activeItem = mainSlider?.querySelector(`.${cssClasses.galleryItem} img[data-order="${activeSlideIndex + 1}"]`);
                activeItem?.closest(`.${cssClasses.galleryItem}`)?.focus();
            }
        }, modalDelay);
    }

    function createSlideHtml(image) {
        const imageSrc = image?.src || image?.dataset?.src;

        if (!image || !image.alt || !image.dataset?.order || !imageSrc) {
            return '';
        }
        return `
            <div class="${cssClasses.glideSlide}">
                <div class="${cssClasses.galleryItem}">
                    <img alt="${image.alt}" 
                         data-order="${image.dataset.order}" 
                         loading="lazy" 
                         src="${imageSrc}">
                </div>
            </div>
        `;
    }

    function getGalleryImages(currentGalleryBlock) {
        const currentMainGallery = currentGalleryBlock.querySelector(`.${cssClasses.galleryList}`);
        if (!currentMainGallery) return [];

        const selector = currentMainGallery.classList.contains(cssClasses.glideV2)
            ? `.${cssClasses.glideSlide}:not(.glide__slide--clone) .${cssClasses.galleryItem} img`
            : `.${cssClasses.galleryItem} img`;

        return Array.from(currentMainGallery.querySelectorAll(selector));
    }

    function generateGallerySlidesHtml(images) {
        return images
            .map(image => createSlideHtml(image))
            .filter(html => html !== '')
            .join('');
    }

    function initializeGlideCarousel(currentModalGlide, currentModal, callback) {
        if (!currentModalGlide || !currentModal) {
            if (callback) callback();
            return;
        }

        setTimeout(() => {
            try {
                GT.GlideV2(currentModalGlide);
                currentModalGlide.classList.add(cssClasses.active);
                
                const closeButton = currentModal.querySelector(`.${cssClasses.modalCloseButton}`);
                if (closeButton) {
                    closeButton.classList.add(cssClasses.active);
                }
                
                if (callback && typeof callback === 'function') {
                    callback();
                }
            } catch (error) {
                console.error('Error initializing Glide carousel:', error);
                if (callback) callback();
            }
        }, modalDelay);
    }

    function initCarousel(currentGalleryBlock, callback) {
        if (!currentGalleryBlock) {
            if (callback) callback();
            return;
        }

        const currentModal = currentGalleryBlock.querySelector(`.${cssClasses.galleryModal}`);
        const currentModalGlide = currentModal?.querySelector(`.${cssClasses.glideV2}`);
        
        if (!currentModal || !currentModalGlide) {
            if (callback) callback();
            return;
        }

        const images = getGalleryImages(currentGalleryBlock);
        const gallerySlidesHtml = generateGallerySlidesHtml(images);

        const slidesContainer = currentModalGlide.querySelector(`.${cssClasses.glideSlides}`);
        if (slidesContainer) {
            slidesContainer.innerHTML = gallerySlidesHtml;
        }

        initializeGlideCarousel(currentModalGlide, currentModal, callback);
    }

    function navigateToSlide(activeModalGlideName, activeSlideIndex) {
        if (!activeModalGlideName || typeof activeSlideIndex !== 'number') return;

        setTimeout(() => {
            try {
                if (GT.glidesV2) {
                    let currentGlide = GT.glidesV2[activeModalGlideName];
                    currentGlide?.go('=' + activeSlideIndex);
                    
                    let slider = document.querySelector(`[data-glidename="${activeModalGlideName}"]`);
                    let currentModal = slider.closest(`.${cssClasses.galleryModal}`);
                    
                    if (currentModal) {
                        setTimeout(() => {
                            currentModal?.classList.add(cssClasses.show);

                            setTimeout(() => {
                                GT.loopFocus(currentModal, GT.getListFocusableElms(currentModal));

                                currentGlide?.on("run.after", () => {
                                    GT.loopFocus(currentModal, GT.getListFocusableElms(currentModal), true);
                                });
                            }, 500);

                        }, sliderVisibleDelay);
                    }
                }
            } catch (error) {
                console.error('Error navigating to slide:', error);
            }
        }, slideTransitionDelay);
    }

    function itemClickHandle(target) {
        if (!target) return;

        const currentGlide = GT.glidesV2[target.closest(`.${cssClasses.galleryList}`).dataset.glidename];
        if (currentGlide?.isMoving) return;

        const imageElement = target.querySelector('img');
        const dataOrder = imageElement?.getAttribute('data-order');
        
        if (!dataOrder) return;

        const currentGalleryBlock = target.closest('[data-gallery-block-id]');
        const blockId = currentGalleryBlock?.dataset?.galleryBlockId;
        if (!currentGalleryBlock || !blockId) return;

        const currentModal = currentGalleryBlock.querySelector(`.${cssClasses.galleryModal}`);
        const activeModalGlide = currentGalleryBlock.querySelector(`.${cssClasses.glideV2}[data-glidename="modalGlide_${blockId}"]`);
        
        if (!currentModal || !activeModalGlide) return;

        const activeModalGlideName = activeModalGlide.dataset.glidename;
        const isInitialized = activeModalGlide.classList.contains(cssClasses.glideSwipeable);
        const activeSlideIndex = parseInt(dataOrder, 10) - 1;

        openModal(currentModal);

        if (!isInitialized) {
            initCarousel(currentGalleryBlock, () => {
                navigateToSlide(activeModalGlideName, activeSlideIndex);
            });
        } else {
            navigateToSlide(activeModalGlideName, activeSlideIndex);
        }

        const handleClose = () => {
            closeModal(currentModal, activeSlideIndex);
        };

        const modalCloseButton = currentModal.querySelector(`.${cssClasses.modalCloseButton}`);
        modalCloseButton.addEventListener('click', (event) => {
            event.preventDefault();
            handleClose();
        });

        modalCloseButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault(); 
                handleClose();
            }
        });
    }

    function setupEventListeners() {
        // Setup gallery item hover effects
        domCache.galleryItems = document.querySelectorAll(`.${cssClasses.galleryItem}`);

        domCache.galleryItems.forEach((item) => {
            
            const handleItemInteraction = (event) => {
                event.preventDefault();
                itemClickHandle(item);
            };

            item.addEventListener('click', handleItemInteraction);
            item.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') handleItemInteraction(event);
            });
        });
    }

    function init() {
        try {
            setupEventListeners();
        } catch (error) {
            console.error('Error initializing GT.ImagesGallery:', error);
        }
    }

    // Initialize the gallery
    init();
};

if (typeof isV1GT === "undefined") {
    GT.domContentLoadedFncList.push(function () {
        GT.ImagesGallery();
    });
}

GT.InputLabel = function ($elem) {

    var input = $($elem).children('input');
    var label = $($elem).children('label');

    input.on('input', function (e) {
        if (input.val() != 0) {
            label.css('opacity', '0');
        } else {
            label.css('opacity', '1');
        }
    });

};

GT.GTInsightArticle = function () {
    contributorPopover();
    wrapWideImage();
    checkBookmark();
    addToReadingListEvent();

    //stickyEnabled
    var stickyEnabled = stickyHeaderState();    

    //topBannerExist
    var topBannerExist = isMessageTopBannerExist();

    if (!isMobileWidth() && !stickyEnabled && topBannerExist ) {
        $('.insight-page header').find('.header-top-wrapper').css({'position':'absolute','top':'30px'});
    }

    function contributorPopover() {
        $('.contributor-has_social').each(function () {
            var _this = $(this);
            var popoverTimer = (function () {
                var timer;
                return function () {
                    clearTimeout(timer);                 
                    timer = setTimeout(function(){
                        _this.find('.contributor-social__link').hide();                        
                    },2000); 
                };
            })();
            
            _this.on('mouseenter touchstart', function () {                
                _this.siblings().find('.contributor-social__link').hide();
                _this.find('.contributor-social__link').show();
                _this.find('.contributor-name').css("text-decoration", "underline");                
            }).on('mouseleave touchend', function () {
                _this.find('.contributor-name').css("text-decoration", "none");
                popoverTimer();
            });
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.contributor-has_social').length) {
                $('.contributor-social__link').hide();                
            }
            return true;
        });
    }

    function wrapWideImage() {
        $('.text-area__contents img.img-wide').wrap('<div class="wide-image__container"></div>');
    }

    function stickyHeaderState() {
        var stickyState = $('.insight-page header').data('sticky');
        return stickyState;
    }

    function isMessageTopBannerExist() {
        var topBannerstate = $('.header').find('.header-message-top-banner-wrapper').length;
        return topBannerstate;
    }

    function checkRPIavailable() {
        var _rpi = $('.header').find('.rpi-progress-bar').length;
        return _rpi;
    }

    function checkBookmark(){
        var isBookmarked = $('.bookmark-article__button').attr('data-isbookmarked');
        if (isBookmarked === "True"){
            $('.add-to-reading-list').hide();
        }
    }

    function addToReadingListEvent(){
        $('.add-to-reading-list__button').click(function () {
            $('.bookmark-article__button').trigger('click');
        });
    }

    function isMobileWidth() {
        return $(window).width() < 961;
    }
};


if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTInsightArticle();
    });


GT.InsightFilters = function ($element, obj) {
    let __ths = this;
    let _filterTagsTaxonomies = [];

    init();

    function taxonomyFilterTabs() {
        let _insightLandingFilters = document.querySelector('.insight-landing__filters');
        if(!_insightLandingFilters) return;
        let _taxonomyTabItems = _insightLandingFilters.querySelectorAll('.select-filter__item');
        [].forEach.call(_taxonomyTabItems, function(tabItem) {
            tabItem.addEventListener('click', function(e) {
                let _this = this;
                let _child = e.target.closest('.select-filter__condition');
                if(_child) return;
                
                if(_this.classList.contains('expanded')) {
                    _this.classList.remove('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", false);
                    window.removeEventListener("keydown", pressESCToClose);
                } else {
                    let _oldActiveTab = _insightLandingFilters.querySelector('.select-filter__item.expanded');
                    if(_oldActiveTab && _oldActiveTab.classList.contains('expanded')) _oldActiveTab.classList.remove('expanded');

                    window.addEventListener("keydown", pressESCToClose);
                    _this.classList.add('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", true);
                }
            });

            if(!GT.isMobileCached) {
                tabItem.querySelector(".select-filter__button").addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && e.shiftKey && this.closest(".expanded")) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".insight-apply__filters--btn").focus();
                    }
                })
            }
        });
    }
    
    function processFilterCheckbox(_filterCheckbox) {
        let _filterCheckboxValue = _filterCheckbox.value;
        if(_filterCheckbox.checked) {
            let _parentTaxonomy = _filterCheckbox.getAttribute('parent-taxonomy');
            let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
            if(_parentTaxonomyArr) {
                if(_parentTaxonomyArr.indexOf(_filterCheckboxValue) < 0) _parentTaxonomyArr.push(_filterCheckboxValue);
            } else {
                _parentTaxonomyArr = [];
                _parentTaxonomyArr.push(_filterCheckboxValue);
            }

            _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
        }
    }

    function processFilterTagLabel(_tagLabel) {
        if(_tagLabel) {
            let _tagLabelValue = _tagLabel.getAttribute('data-value');
            let _parentTaxonomy = _tagLabel.getAttribute('data-parenttagkey');
            if(_parentTaxonomy) {
                let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                if(_parentTaxonomyArr) {
                    if(_parentTaxonomyArr.indexOf(_tagLabelValue) < 0) _parentTaxonomyArr.push(_tagLabelValue);
                } else {
                    _parentTaxonomyArr = [];
                    _parentTaxonomyArr.push(_tagLabelValue);
                }

                _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
            }
        }
    }

    function initFilterByLabel() {
        let filterButtonsContainer = document.querySelector('.filter-result__tags--buttons');
        if(filterButtonsContainer) {
            // Get all current taxonomies are filterred and push into _filterTagsTaxonomies array.
            getAllFilterredTaxonomies();

            let _filterLables = filterButtonsContainer.querySelectorAll('button.filter-result__tag-item');
            [].forEach.call(_filterLables, function(filterBtn){
                filterBtn.addEventListener('click', function(e) {
                    let _this = this;
                    let _taxFilterValue = _this.getAttribute('data-value');
                    if(!_filterTagsTaxonomies)  _filterTagsTaxonomies = [];
                    let _parentTaxonomy = _this.getAttribute('data-parenttagkey');
                    let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                    if(_parentTaxonomyArr) {
                        for(let i = 0; i < _parentTaxonomyArr.length; i++) {
                            let _childTaxonomy = _parentTaxonomyArr[i];
                            if(_taxFilterValue == _childTaxonomy) {
                                _parentTaxonomyArr.splice(i, 1);
                                break;
                            }
                        }
                    }

                    if(_this.getAttribute('data-people')) {
                        let _urlSearchParams = new URLSearchParams(window.location.search);
                        let _filterByPeoples = _urlSearchParams.getAll('people');
                        let _people = _this.getAttribute('data-people');
                        if(_filterByPeoples && _filterByPeoples.length > 0) {
                            for(let i = 0; i < _filterByPeoples.length; i++) {
                                let _existedPeople = _filterByPeoples[i];
                                if(_people == _existedPeople) {
                                    _filterByPeoples.splice(i, 1);
                                    break;
                                }
                            }
                            __ths.setParameterInQueryString("people", _people, true);
                            if(_filterByPeoples && _filterByPeoples.length > 0) {
                                [].forEach.call(_filterByPeoples, function(people){
                                    _urlSearchParams.append('people', people);
                                });
                                history.replaceState(null, null, "?" + _urlSearchParams.toString() + location.hash);
                            }
                        }
                    }

                    _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;

                    __ths.searchResultsByTaxonomies([], false, '', '');                       
                });
            });
        }
    }

    function initClearFilterByLabel() {
        let _clearFilterLabelBtns = document.querySelectorAll('button.search-filters__reset-btn');
        [].forEach.call(_clearFilterLabelBtns, function(_clearFilterLabel){
            _clearFilterLabel.addEventListener('click', function(e) {                    
                // Clear all data get from filter checkboxes
                _filterTagsTaxonomies = [];

                // Delete all peoples in queries string
                __ths.setParameterInQueryString("people", '', true);
                __ths.setParameterInQueryString("hubtag", '', true);
                __ths.setParameterInQueryString("Sort", '', true);

                __ths.searchResultsByTaxonomies([], false, '', '');
            });
        });
    }

    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(".select-filter__item.expanded button");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }
    
    // Search Filter Select Handling On Desktop
    function insightsFilterHandle() {
        let _applyFilterBtns = document.querySelectorAll('.insight-apply__filters--btn');
        [].forEach.call(_applyFilterBtns, function(applyFilterBtn) {

            applyFilterBtn.addEventListener('click', function() {
                let _insightsFilterContainer = document.querySelector('.search-filters__tabs');
                if(_insightsFilterContainer) {
                    _filterTagsTaxonomies = [];
                    let _insightsFilterItems = _insightsFilterContainer.querySelectorAll('input[type="checkbox"].filters__item:checked');
                    [].forEach.call(_insightsFilterItems, function(checkedItem){
                        if(checkedItem) {
                            processFilterCheckbox(checkedItem);
                        }
                    });
                }

                let _queryParams = new URLSearchParams(window.location.search);
                let _params = [];
                let _currentPageIndex = parseInt(document.getElementById('CurrentPageIndex').value);

                // Clear all pagination when apply new filter
                if(_queryParams.get('CurrentPageIndex')){
                    _queryParams.delete('CurrentPageIndex');
                }

                // Clear all hub tag when apply new filter
                if(_queryParams.get('hubtag')){
                    _queryParams.delete('hubtag');
                }

                if(_currentPageIndex <= 0) {
                    if(_queryParams.get('page')){
                        _queryParams.delete('page');
                    }
                }
                __ths.searchResultsByTaxonomies(_params, false, '', '');
            });

            if(!GT.isMobileCached) {
                applyFilterBtn.addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && !e.shiftKey) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".select-filter__button").focus();
                    }
                })
            }
        });
    }

    function queryParams(_urlSearchParams, params) {
        for (var key in params) {
            if(key == 'peoples') {
                let _peoples = params[key];
                if(_peoples && _peoples.length > 0) {
                    [].forEach.call(_peoples, function(people){
                        _urlSearchParams.append('people', people);
                    });
                }
            } else if(key == 'hubtag') {
                let _hubtag = params[key];
                if(_hubtag && _hubtag.length > 0) {
                    _urlSearchParams.append('hubtag', _hubtag);
                }
            } else {
                _urlSearchParams.set(key, params[key]);
            }
        }

        if(_filterTagsTaxonomies) {
            for (var key in _filterTagsTaxonomies) {
                let _tagsArr = _filterTagsTaxonomies[key];
                if(!_tagsArr) return;
                let _tagsStr = '';
                let _counter = 0;
                [].forEach.call(_tagsArr, function(_tagValue){
                    if(_tagValue && _tagValue.length > 0) _tagsStr += _tagValue;
                    if(_counter < _tagsArr.length - 1 ) {
                        _tagsStr += '+';
                    }
                    _counter++;
                });
                if(_tagsStr && _tagsStr.length > 0) _urlSearchParams.append('tags', _tagsStr);
            }
        }

        return _urlSearchParams.toString();
    }

    __ths.setParameterInQueryString = function(key, value, isDelete) {
        var queryParams = new URLSearchParams(window.location.search);
        if(isDelete)
            queryParams.delete(key);
        else
            queryParams.set(key, value);
        history.replaceState(null, null, "?" + queryParams.toString() + location.hash);
    }

    __ths.getParameterInQueryString = function(key) {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(key);
    }

    function toggleFiltersForm() {
        let _filtersContainer = document.getElementById('insightLandingFilters'),
            _filtersContainerToggle = document.querySelectorAll('[data-toggle="insightLandingFilters"]'),
            _filterBtn = document.querySelector(".insight-filter__header-mobile button");

        if (_filtersContainerToggle)
            for (var i = 0; i < _filtersContainerToggle.length; i++) {
                _filtersContainerToggle[i].addEventListener('click', function () {
                    if(_filtersContainer.classList.contains("active")) {
                        _filtersContainer.classList.remove('active');
                        document.querySelector(".gt-wrapper").classList.remove("opening-mobile-filter");
                        if(_filterBtn) {
                            _filterBtn.focus();
                            _filterBtn.setAttribute("aria-expanded", false);
                        }
                    } else {
                        _filtersContainer.classList.add('active');
                        _filterBtn?.setAttribute("aria-expanded", true);
                        setTimeout(e => {
                            document.querySelector("#filtersFormCloseBtn")?.focus();
                            document.querySelector(".gt-wrapper").classList.add("opening-mobile-filter");
                        }, 1000)
                    }
                })
            }

        if (_filtersContainer)
            document.querySelector('.main-header .menu-toggle').addEventListener('click', function() {
                _filtersContainer.classList.remove('active');
            })
    }

    function showActiveFilters () {
        let _selectFilterItems = document.querySelectorAll('.select-filter__item');
        [].forEach.call(_selectFilterItems, function(checkedItem){
            let checkedCheckbox = checkedItem.querySelector('[type="checkbox"].filters__item:checked');
            if(checkedCheckbox) {
                checkedItem.classList.add('expanded');
            }
        });
    }

    function toggleOverhiddenHTML() {
        let _filtersShowBtn = document.querySelector('.search-results__filters-show'),
            _filtersHideBtn = document.querySelector('.search-filters__close-btn');

        if (_filtersShowBtn)
            _filtersShowBtn.addEventListener('click', function() {
                document.querySelector('html').classList.add('overflowHidden--mobile');
            })

        if (_filtersHideBtn)
            _filtersHideBtn.addEventListener('click', function() {
                document.querySelector('html').classList.remove('overflowHidden--mobile');
            })
    }

    function init() {

        if( /Android/i.test(navigator.userAgent) ) {
            let insightResultContainer = document.querySelector('.insight-results__container');
            if(insightResultContainer) {
                insightResultContainer.classList.add('android-devices');
            }
        }

        taxonomyFilterTabs();
        insightsFilterHandle();
        initClearFilterByLabel();
        initFilterByLabel();
        initLoadmoreButton();
        registerSortEvt();

        toggleFiltersForm();
        toggleOverhiddenHTML();
        if(GT.isMobileView()) {
            showActiveFilters();
        }

        clickOutsideFilterContainer();
    }

    function initLoadmoreButton() {
        let _loadmoreButton = document.getElementById('insightFilterLoadmore');
        if(_loadmoreButton) {
            _loadmoreButton.addEventListener('click', function(e) {
                e.preventDefault();
                let _this = this;
                let _loadmoreEndpoint = _this.getAttribute('data-endpoint') || '';
                __ths.loadMoreResultsByTag(_loadmoreEndpoint);
            });
        }
    }

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };

    function getAllFilterredTaxonomies() {
        let _currentTagsFilterred = document.querySelectorAll('button.filter-result__tag-item');
        if(_currentTagsFilterred && _currentTagsFilterred.length > 0) {
            [].forEach.call(_currentTagsFilterred, function(filterredByTaxonomy){
                if(filterredByTaxonomy) {
                    processFilterTagLabel(filterredByTaxonomy);
                }
            });
        }
    }

    __ths.loadMoreResultsByTag = function (_loadmoreEndpoint) {
        
        let _currentPageIndex = parseInt(document.getElementById('CurrentPageIndex').value);
        let _params = [];
        _params['CurrentPageIndex'] = _currentPageIndex + 1;

        getAllFilterredTaxonomies();

        __ths.searchResultsByTaxonomies(_params, true, _loadmoreEndpoint);
    };

    __ths.ajaxCall = function (url, successCallback) {
        var contextRef = this;
        let __url = url;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.response && this.status == 200) {
                    successCallback(contextRef, this.response);
                } else {
                    // isInited = false;
                }
            }
        };
        xhttp.open("GET", __url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    __ths.searchResultsByTaxonomies = function (_queryParams, _isAppendResults, _otherEndpoint, _replaceContainer) {
        let _ajaxUrl = '';
        if(_isAppendResults) {
            _ajaxUrl = queriesStringBuilder(_queryParams, _otherEndpoint, true);
            __ths.ajaxCall(_ajaxUrl, successCallback);
            return false;
        } else {
            _ajaxUrl = queriesStringBuilder(_queryParams);
        }

        function successCallback(contextRef, data) {
            __ths.appendResults(contextRef, data);
            setTimeout(function() {
                GT.clampArticle(true);
                GT.GTBookmarkArticle && GT.GTBookmarkArticle();
            }, 500);
        }
        //dataLayer.push({ 'event': 'global_search', 'eventAction': 'search', 'eventLabel': _ajaxUrl });
        window.location.href = _ajaxUrl;
    };

    function registerSortEvt(){
        let _sortSelectBoxesContainer = document.querySelectorAll('.search-results__sort-select');

        [].forEach.call(_sortSelectBoxesContainer, function(_sortSelectBoxContainer){
            if(_sortSelectBoxContainer) {
                let _sortingSelectBox = _sortSelectBoxContainer.querySelector('.styleSelBox');
                //update sort params when change sort select
                if(_sortingSelectBox) {
                    _sortingSelectBox.addEventListener('change', function (e) {
                        let _params = [];
                       
                        let _urlSearchParams = new URLSearchParams(window.location.search);
                        // Clear all pagination when sorting
                        if(_urlSearchParams.get('CurrentPageIndex')){
                            _urlSearchParams.delete('CurrentPageIndex');
                        }

                        let _filterByHubTag = _urlSearchParams.getAll('hubtag');
                        if(_filterByHubTag && _filterByHubTag.length > 0) {
                            _params['hubtag'] = _filterByHubTag;
                        }

                        __ths.searchResultsByTaxonomies(_params, false,'', '');
                    });
                }
            }
        });
    }
    
    function queriesStringBuilder(_params, _otherEndpoint, _isLoadmore) {

        if(!_params) _params = [];

        let _urlSearchParams = new URLSearchParams(window.location.search);
        
        let _filterByPeoples = _urlSearchParams.getAll('people');
        if(_filterByPeoples && _filterByPeoples.length > 0) {
            _params['peoples'] = _filterByPeoples;
        }

        _urlSearchParams = new URLSearchParams();
        let _searchSorting = '';
        let _sortingSelectBox = document.getElementById('select_sorting_desktop');

        if(_sortingSelectBox) {
            _searchSorting = _sortingSelectBox.value;
        }

        if(_searchSorting && _searchSorting.length > 0) {
            _params['Sort'] = _searchSorting;
        } else {
            _urlSearchParams.delete('Sort');
        }

        let _ajaxUrl = '';
        if(_isLoadmore) {
            if(_otherEndpoint && _otherEndpoint.length > 0) {
                _ajaxUrl = _otherEndpoint;
            }
        } else {
            _ajaxUrl = '?';
        }
        
        let _queryParams = queryParams(_urlSearchParams, _params);
        if(_queryParams && _queryParams.length > 0) {
            if(_isLoadmore ) _ajaxUrl += '&';
            _ajaxUrl += _queryParams;
        }

        return __ths.escapeQueryChars(_ajaxUrl);
    }

    __ths.appendResults = function (contextRef, data) {
        let _insightResultsContainer = document.getElementById('insightResultsContainer');
        _insightResultsContainer.insertAdjacentHTML("beforeend", data);
        let _currentPageIndex = parseInt(document.getElementById('CurrentPageIndex').value);
        document.getElementById('CurrentPageIndex').value = _currentPageIndex + 1;
        __ths.setParameterInQueryString("page", _currentPageIndex + 1);
        __ths.setShowingNumber();
            
        shouldLoadMore();
    }

    __ths.setShowingNumber = function () {
        let _showedInsightItems = document.querySelectorAll('.insight-article__item').length || 0;
        let _showingNumberElement = document.querySelector('#totalResultShowing');
        if(_showingNumberElement) _showingNumberElement.innerHTML = _showedInsightItems;
    }

    function clickOutsideFilterContainer() {
        document.addEventListener('mouseup', function(e) {
            let _filterItemContainers = document.querySelectorAll('.select-filter__item');
            
            [].forEach.call(_filterItemContainers, function(_filterItem){
                let _filterConditionContainer = _filterItem.querySelector('.select-filter__condition');
                if (!_filterConditionContainer.contains(e.target) && !_filterItem.contains(e.target)) {
                    _filterItem.classList.remove('expanded');
                }
            });
        });
    }

    function shouldLoadMore() {
        let _loadBtn = document.getElementById('insightFilterLoadmore');

        if(!_loadBtn) 
            return;

        let _pageIndexByTags = parseInt(document.getElementById('CurrentPageIndex').value);
        let totalItems = parseInt(document.getElementById('TotalItemsCount').value);
        
        let _pageSize = parseInt(document.getElementById('PageSize').value);
        let maxPage = Math.ceil(totalItems / _pageSize);
        let loadMoreContainer = document.querySelector(".load-more-container")

        if (maxPage <= (_pageIndexByTags + 1)) {
            if(loadMoreContainer)
                loadMoreContainer.classList.add("hidden");
            else
                _loadBtn.classList.add('hidden');

        } else {
            if(loadMoreContainer) {
                loadMoreContainer.classList.remove("hidden");
            }
            else {
                _loadBtn.classList.remove('hidden');
            }
            
            if(_loadBtn.href) {
                _loadBtn.href = location.href.replace("page=" + _pageIndexByTags, "page=" + (_pageIndexByTags + 1));
            }
        }
                
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (_pageIndexByTags > 0 ? "?page=" + _pageIndexByTags : ""); 
    };
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.InsightFilters();
    });
GT.InsightFiltersV2 = function ($element, obj) {
    let __ths = {},
        _loadBtn;
        _filterTagsTaxonomies = [],
        __ths.UNACTIVE = 0, 
        __ths.ACTIVE = 1,
        __ths.searchState = __ths.ACTIVE,
        __ths.currentFilterTabIndex = -1;


    __ths.currentTotalDisplayingItems = function(currentElm) {
        return currentElm.querySelectorAll(".insight-article__item").length;
    }

    function taxonomyFilterTabs() {
        let _insightLandingFilters = document.querySelector('.insight-landing__filters');
        if(!_insightLandingFilters) return;
        let _taxonomyTabItems = _insightLandingFilters.querySelectorAll('.select-filter__item');
        [].forEach.call(_taxonomyTabItems, function(tabItem, idx) {
            tabItem.dataset.index = idx;
            tabItem.addEventListener('click', function(e) {
                let _this = this;
                let _child = e.target.closest('.select-filter__condition');
                if(_child) return;
                
                
                if(_this.classList.contains('expanded')) {
                    _this.classList.remove('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", false);
                    window.removeEventListener("keydown", pressESCToClose);
                    __ths.currentFilterTabIndex = -1;
                } else {
                    let _oldActiveTab = _insightLandingFilters.querySelector('.select-filter__item.expanded');
                    if(_oldActiveTab && _oldActiveTab.classList.contains('expanded')) _oldActiveTab.classList.remove('expanded');

                    window.addEventListener("keydown", pressESCToClose);
                    _this.classList.add('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", true);
                    __ths.currentFilterTabIndex = parseInt(e.target.closest(".select-filter__item")?.dataset.index || -1);
                }
            });

            if(!GT.isMobileCached) {
                tabItem.querySelector(".select-filter__button").addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && e.shiftKey && this.closest(".expanded")) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".insight-apply__filters--btn").focus();
                    }
                })
            }
        });
    }
    
    function processFilterCheckbox(_filterCheckbox) {
        let _filterCheckboxValue = _filterCheckbox.value;
        if(_filterCheckbox.checked) {
            let _parentTaxonomy = _filterCheckbox.getAttribute('parent-taxonomy');
            let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
            if(_parentTaxonomyArr) {
                if(_parentTaxonomyArr.indexOf(_filterCheckboxValue) < 0) _parentTaxonomyArr.push(_filterCheckboxValue);
            } else {
                _parentTaxonomyArr = [];
                _parentTaxonomyArr.push(_filterCheckboxValue);
            }

            _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
        }
    }

    function processFilterTagLabel(_tagLabel) {
        if(_tagLabel) {
            let _tagLabelValue = _tagLabel.getAttribute('data-value');
            let _parentTaxonomy = _tagLabel.getAttribute('data-parenttagkey');
            if(_parentTaxonomy) {
                let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                if(_parentTaxonomyArr) {
                    if(_parentTaxonomyArr.indexOf(_tagLabelValue) < 0) _parentTaxonomyArr.push(_tagLabelValue);
                } else {
                    _parentTaxonomyArr = [];
                    _parentTaxonomyArr.push(_tagLabelValue);
                }

                _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
            }
        }
    }

    function initFilterByLabel() {
        let filterButtonsContainer = document.querySelector('.filter-result__tags--buttons');
        if(filterButtonsContainer) {
            // Get all current taxonomies are filterred and push into _filterTagsTaxonomies array.
            getAllFilterredTaxonomies();

            let _filterLables = filterButtonsContainer.querySelectorAll('button.filter-result__tag-item');
            [].forEach.call(_filterLables, function(filterBtn){
                filterBtn.addEventListener('click', function(e) {
                    let _this = this;
                    let _taxFilterValue = _this.getAttribute('data-value');
                    if(!_filterTagsTaxonomies)  _filterTagsTaxonomies = [];
                    let _parentTaxonomy = _this.getAttribute('data-parenttagkey');
                    let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                    if(_parentTaxonomyArr) {
                        for(let i = 0; i < _parentTaxonomyArr.length; i++) {
                            let _childTaxonomy = _parentTaxonomyArr[i];
                            if(_taxFilterValue == _childTaxonomy) {
                                _parentTaxonomyArr.splice(i, 1);
                                break;
                            }
                        }
                    }

                    if(_this.getAttribute('data-people')) {
                        let _urlSearchParams = new URLSearchParams(window.location.search);
                        let _filterByPeoples = _urlSearchParams.getAll('people');
                        let _people = _this.getAttribute('data-people');
                        if(_filterByPeoples && _filterByPeoples.length > 0) {
                            for(let i = 0; i < _filterByPeoples.length; i++) {
                                let _existedPeople = _filterByPeoples[i];
                                if(_people == _existedPeople) {
                                    _filterByPeoples.splice(i, 1);
                                    break;
                                }
                            }
                            __ths.setParameterInQueryString("people", _people, true);
                            if(_filterByPeoples && _filterByPeoples.length > 0) {
                                [].forEach.call(_filterByPeoples, function(people){
                                    _urlSearchParams.append('people', people);
                                });
                                history.replaceState(null, null, "?" + _urlSearchParams.toString() + location.hash);
                            }
                        }
                    }

                    _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;

                    __ths.searchResultsByTaxonomies([], false);                       
                });
            });
        }
    }

    function initClearFilterByLabel() {
        let _clearFilterLabelBtns = document.querySelectorAll('button.search-filters__reset-btn');
        [].forEach.call(_clearFilterLabelBtns, function(_clearFilterLabel){
            _clearFilterLabel.addEventListener('click', function(e) {                    
                // Clear all data get from filter checkboxes
                _filterTagsTaxonomies = [];

                // Delete all peoples in queries string
                __ths.setParameterInQueryString("people", '', true);
                __ths.setParameterInQueryString("hubtag", '', true);
                __ths.setParameterInQueryString("Sort", '', true);

                __ths.searchResultsByTaxonomies([], false);
            });
        });
    }

    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(".select-filter__item.expanded button");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }
    
    // Search Filter Select Handling On Desktop
    function insightsFilterHandle() {
        let _applyFilterBtns = document.querySelectorAll('.insight-apply__filters--btn');
        [].forEach.call(_applyFilterBtns, function(applyFilterBtn) {

            applyFilterBtn.addEventListener('click', function() {
                let _insightsFilterContainer = document.querySelector('.search-filters__tabs');
                if(_insightsFilterContainer) {
                    _filterTagsTaxonomies = [];
                    let _insightsFilterItems = _insightsFilterContainer.querySelectorAll('input[type="checkbox"].filters__item:checked');
                    [].forEach.call(_insightsFilterItems, function(checkedItem){
                        if(checkedItem) {
                            processFilterCheckbox(checkedItem);
                        }
                    });
                }

                let _queryParams = new URLSearchParams(window.location.search);
                let _params = [];

                // Clear all pagination when apply new filter
                if(_queryParams.get('page')){
                    _queryParams.delete('page');
                }

                // Clear all hub tag when apply new filter
                if(_queryParams.get('hubtag')){
                    _queryParams.delete('hubtag');
                }
                
                _params['CurrentPageIndex'] =  __ths.config.previousPageIndex = __ths.config.nextPageIndex = 1;
                __ths.searchResultsByTaxonomies(_params, false);
            });

            if(!GT.isMobileCached) {
                applyFilterBtn.addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && !e.shiftKey) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".select-filter__button").focus();
                    }
                })
            }
        });
    }

    function queryParams(_urlSearchParams, params) {
        let hasFilter = false;
        for (var key in params) {
            if(key == 'peoples') {
                let _peoples = params[key];
                if(_peoples && _peoples.length > 0) {
                    [].forEach.call(_peoples, function(people){
                        _urlSearchParams.append('people', people);
                        hasFilter = true;
                    });
                }
            } else if(key == 'hubtag') {
                let _hubtag = params[key];
                if(_hubtag && _hubtag.length > 0) {
                    _urlSearchParams.append('hubtag', _hubtag);
                    hasFilter = true;
                }
            } else {
                _urlSearchParams.set(key, params[key]);
            }
        }

        if(_filterTagsTaxonomies) {
            for (var key in _filterTagsTaxonomies) {
                let _tagsArr = _filterTagsTaxonomies[key];
                if(!_tagsArr) return;
                let _tagsStr = '';
                let _counter = 0;
                [].forEach.call(_tagsArr, function(_tagValue){
                    if(_tagValue && _tagValue.length > 0) _tagsStr += _tagValue;
                    if(_counter < _tagsArr.length - 1 ) {
                        _tagsStr += '+';
                    }
                    _counter++;
                });
                if(_tagsStr && _tagsStr.length > 0) {
                    _urlSearchParams.append('tags', _tagsStr);
                    hasFilter = true;
                }
            }
        }

        return _urlSearchParams.toString();
    }

    __ths.setParameterInQueryString = function(key, value, isDelete) {
        var queryParams = new URLSearchParams(window.location.search);
        if(isDelete)
            queryParams.delete(key);
        else
            queryParams.set(key, value);
        history.replaceState(null, null, "?" + queryParams.toString() + location.hash);
    }

    __ths.getParameterInQueryString = function(key) {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(key);
    }

    function toggleFiltersForm() {
        let _filtersContainer = document.getElementById('insightLandingFilters'),
            _filtersContainerToggle = document.querySelectorAll('[data-toggle="insightLandingFilters"]'),
            _filterBtn = document.querySelector(".insight-filter__header-mobile button");

        if (_filtersContainerToggle)
            for (var i = 0; i < _filtersContainerToggle.length; i++) {
                _filtersContainerToggle[i].addEventListener('click', function () {
                    if(_filtersContainer.classList.contains("active")) {
                        _filtersContainer.classList.remove('active');
                        document.querySelector(".gt-wrapper").classList.remove("opening-mobile-filter");
                        if(_filterBtn) {
                            _filterBtn.focus();
                            _filterBtn.setAttribute("aria-expanded", false);
                        }
                    } else {
                        _filtersContainer.classList.add('active');
                        _filterBtn?.setAttribute("aria-expanded", true);
                        setTimeout(e => {
                            document.querySelector("#filtersFormCloseBtn")?.focus();
                            document.querySelector(".gt-wrapper").classList.add("opening-mobile-filter");
                        }, 1000)
                    }
                })
            }

        if (_filtersContainer)
            document.querySelector('.main-header .menu-toggle').addEventListener('click', function() {
                _filtersContainer.classList.remove('active');
            })
    }

    function showActiveFilters () {
        let _selectFilterItems = document.querySelectorAll('.select-filter__item');
        [].forEach.call(_selectFilterItems, function(checkedItem){
            let checkedCheckbox = checkedItem.querySelector('[type="checkbox"].filters__item:checked');
            if(checkedCheckbox) {
                checkedItem.classList.add('expanded');
            }
        });
    }

    function toggleOverhiddenHTML() {
        let _filtersShowBtn = document.querySelector('.search-results__filters-show'),
            _filtersHideBtn = document.querySelector('.search-filters__close-btn');

        if (_filtersShowBtn)
            _filtersShowBtn.addEventListener('click', function() {
                document.querySelector('html').classList.add('overflowHidden--mobile');
            })

        if (_filtersHideBtn)
            _filtersHideBtn.addEventListener('click', function() {
                document.querySelector('html').classList.remove('overflowHidden--mobile');
            })
    }

    function init() {

        if( /Android/i.test(navigator.userAgent) ) {
            let insightResultContainer = document.querySelector('.insight-results__container');
            if(insightResultContainer) {
                insightResultContainer.classList.add('android-devices');
            }
        }


        let loadmoreConfig = document.querySelector(".loadmore-config");
        if(!loadmoreConfig) return;
        loadmoreConfig = JSON.parse(loadmoreConfig.textContent);

        _loadBtn = document.getElementById('insightFilterLoadmore');        
        _loadBtn?.addEventListener('click', function(e) {
            e.preventDefault();
            __ths.loadMoreResultsByTag();
        });
        
        let currentPage = loadmoreConfig.currentPageIndex;
        
        __ths.sParams = {
            CurrentPageIndex: currentPage
        };

        __ths.config = {
            previousPageIndex: currentPage, 
            nextPageIndex: currentPage, 
            totalDisplayingItems: loadmoreConfig.totalDisplayingItems, 
            pageSize: loadmoreConfig.pageSize, 
            totalItemsCount: loadmoreConfig.totalItemsCount, 
            loadEndPoint: loadmoreConfig.loadMoreEndPoint,
            insightResultsContainer: document.getElementById('insightResultsContainer'),
            insightListingContainer: document.getElementById('insightListingContainer'),
            resultContainerOffsetTop: 0
        };

        taxonomyFilterTabs();
        insightsFilterHandle();
        initClearFilterByLabel();
        initFilterByLabel();
        registerSortEvt();

        toggleFiltersForm();
        toggleOverhiddenHTML();
        if(GT.isMobileView()) {
            showActiveFilters();
        }
        clickOutsideFilterContainer();
        loadPreviousHandler();

        
        __ths.config.insightResultsContainer.querySelectorAll(".insight-article__item").forEach(articleItem => {
            articleItem.dataset.page = currentPage;
            __ths.observerElm(articleItem);
        })
    }

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };
    

    function getAllFilterredTaxonomies() {
        let _currentTagsFilterred = document.querySelectorAll('button.filter-result__tag-item');
        if(_currentTagsFilterred && _currentTagsFilterred.length > 0) {
            [].forEach.call(_currentTagsFilterred, function(filterredByTaxonomy){
                if(filterredByTaxonomy) {
                    processFilterTagLabel(filterredByTaxonomy);
                }
            });
        }
    }

    __ths.loadMoreResultsByTag = function (isLoadPrevious) {
        if(__ths.searchState == __ths.UNACTIVE) return;

        if(isLoadPrevious) {
            __ths.config.previousPageIndex -= 1;
        } else {
            __ths.config.nextPageIndex += 1;
        }
        __ths.sParams['CurrentPageIndex'] = isLoadPrevious ? __ths.config.previousPageIndex : __ths.config.nextPageIndex;
        getAllFilterredTaxonomies();
        __ths.searchResultsByTaxonomies(__ths.sParams, true, isLoadPrevious);
    };

    __ths.ajaxCall = function (url, successCallback) {
        var contextRef = this;
        let __url = url;
        var xhttp = new XMLHttpRequest();
        __ths.searchState = __ths.UNACTIVE;
        __ths.config.insightListingContainer.classList.add("fetching");
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.response && this.status == 200) {
                    successCallback(contextRef, this.response);
                } else {
                    // isInited = false;
                }
                setTimeout(e => {
                    __ths.config.insightListingContainer.classList.remove("fetching");
                    __ths.searchState = __ths.ACTIVE;
                }, 500);
            }
        };
        xhttp.open("GET", __url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    __ths.searchResultsByTaxonomies = function (_queryParams, _isAppendResults, _isLoadPrevious) {
        let _url = queriesStringBuilder(_queryParams);
        let _ajaxUrl = queriesStringBuilder(_queryParams, _isAppendResults ? __ths.config.loadEndPoint : filterEndpoint, true);
        __ths.ajaxCall(_ajaxUrl, function(contextRef, data){            

            if(_isAppendResults) {
                if(__ths.config.insightResultsContainer) {
                        old_DOM_height = document.querySelector(".gt-wrapper").offsetHeight,
                        old_scroll = GT.lastScrollTop;

                    GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                    __ths.config.insightResultsContainer.insertAdjacentHTML(_isLoadPrevious ? "afterbegin" : "beforeend", data);
                    
                    let focusableItem;
                    __ths.config.insightResultsContainer.querySelectorAll(".insight-article__item:not([data-page])").forEach(articleItem => {
                        articleItem.dataset.page = __ths.sParams.CurrentPageIndex;
                        __ths.observerElm(articleItem);
                        if(!focusableItem) focusableItem = articleItem;
                    })

                    if(!_isLoadPrevious) {
                        let lstFocusableElms = GT.getListFocusableElms(focusableItem);
                        if(lstFocusableElms.length)
                            lstFocusableElms[0].focus();
                        __ths.setParameterInQueryString("page", __ths.sParams.CurrentPageIndex);
                    } else {
                        window.scrollTo({ top: (old_scroll + document.querySelector(".gt-wrapper").offsetHeight - old_DOM_height), left:0, behavior: "instant"});
                    }
                }
            } else {
                if(__ths.config.insightListingContainer) {
                    if(GT.wWidth < 1024) {
                        document.querySelector('.gt-wrapper').classList.remove("opening-mobile-filter");
                        document.querySelector('html').classList.remove('overflowHidden--mobile');
                    }
                    __ths.config.insightListingContainer.innerHTML = data;
                    __ths.setParameterInQueryString("page", 1);
                    GT.FormSelect($('.form-select'));
                    init();
                    
                    document.querySelector('.select-filter__item:nth-child('+ (__ths.currentFilterTabIndex + 1) +')')?.focus();

                }
            }
            // Add the event listener again to redirect to the anchor when clicking on an article tile.
            GT.FakeHyperlink();

            __ths.setShowingNumber();
                
            shouldLoadMore();

            if(data.trim().length) {
                setTimeout(function() {
                    GT.clampArticle(true);
                    GT.GTBookmarkArticle && GT.GTBookmarkArticle();
                    if(document.querySelector(".insight-landing-promoted")) {
                        GT.clampText(null,true);
                        GT.InsightPageV2();
                    }
                }, 500);
            }
        });

        if(!_isAppendResults) {
            if(_url.length > 1)
                history.replaceState(null, null, _url.replace("CurrentPageIndex", "page"));
            else 
                history.replaceState(null, null, "");
        }
        //dataLayer.push({ 'event': 'global_search', 'eventAction': 'search', 'eventLabel': _ajaxUrl });
        // window.location.href = _ajaxUrl;
    };

    function loadPreviousHandler(){
        let currentTotalDisplayingItems = __ths.currentTotalDisplayingItems(__ths.config.insightResultsContainer);
        if(currentTotalDisplayingItems <= __ths.config.totalItemsCount) {
            __ths.config.resultContainerOffsetTop = 0;
            GT.listFunctionsTriggerInScrollEvent['checkScrollPosInsightListing'] = () => {

                if(!__ths.config.resultContainerOffsetTop)
                    __ths.config.resultContainerOffsetTop = GT.getElementOffset(__ths.config.insightResultsContainer).top;

                if(__ths.config.previousPageIndex > 1 && GT.isScrollingUp && GT.lastScrollTop - __ths.config.resultContainerOffsetTop < 300 && __ths.searchState == __ths.ACTIVE) {
                    __ths.loadMoreResultsByTag(true);
                }
            }
        }
    }

    function registerSortEvt(){
        let _sortSelectBoxesContainer = document.querySelectorAll('.search-results__sort-select');

        [].forEach.call(_sortSelectBoxesContainer, function(_sortSelectBoxContainer){
            if(_sortSelectBoxContainer) {
                let _sortingSelectBox = _sortSelectBoxContainer.querySelector('.styleSelBox');
                //update sort params when change sort select
                if(_sortingSelectBox) {
                    _sortingSelectBox.addEventListener('change', function (e) {
                        let _params = [];
                       
                        let _urlSearchParams = new URLSearchParams(window.location.search);
                        // Clear all pagination when sorting
                        if(_urlSearchParams.get('page')){
                            _urlSearchParams.delete('page');
                        }

                        let _filterByHubTag = _urlSearchParams.getAll('hubtag');
                        if(_filterByHubTag && _filterByHubTag.length > 0) {
                            _params['hubtag'] = _filterByHubTag;
                        }

                        __ths.searchResultsByTaxonomies(_params, false);
                    });
                }
            }
        });
    }
    
    function queriesStringBuilder(_params, _otherEndpoint, _isLoadmore) {

        if(!_params) _params = [];

        let _urlSearchParams = new URLSearchParams(window.location.search);
        
        let _filterByPeoples = _urlSearchParams.getAll('people');
        if(_filterByPeoples && _filterByPeoples.length > 0) {
            _params['peoples'] = _filterByPeoples;
        }

        _urlSearchParams = new URLSearchParams();
        let _searchSorting = '';
        let _sortingSelectBox = document.getElementById('select_sorting_desktop');

        if(_sortingSelectBox) {
            _searchSorting = _sortingSelectBox.value;
        }

        if(_searchSorting && _searchSorting.length > 0) {
            _params['Sort'] = _searchSorting;
        } else {
            _urlSearchParams.delete('Sort');
        }

        let _ajaxUrl = '';
        if(_isLoadmore) {
            if(_otherEndpoint && _otherEndpoint.length > 0) {
                _ajaxUrl = _otherEndpoint;
            }
        } else {
            _ajaxUrl = '?';
        }
        
        let _queryParams = queryParams(_urlSearchParams, _params);
        if(_queryParams && _queryParams.length > 0) {
            if(_isLoadmore ) _ajaxUrl += '&';
            _ajaxUrl += _queryParams;
        }

        return __ths.escapeQueryChars(_ajaxUrl);
    }

    __ths.observerElm = (elm) => {
        if(!elm.dataset.observed) {
            elm.dataset.observed = true;
            GT.checkElmVisible(elm, {
                callback: (e) => {
                    __ths.updatePageIndex(elm.dataset.page);
                },
                recheck: true,
                threshold: 1
            })
        }
    }

    
    __ths.updatePageIndex = (pageIndex) => {
        if(pageIndex > 1) {
            __ths.setParameterInQueryString("page", pageIndex);
        } else {
            __ths.setParameterInQueryString("page", pageIndex, true);
        }
        
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (pageIndex > 1 ? "?page=" + pageIndex : ""); 
    }

    __ths.setShowingNumber = function () {
        let _showedInsightItems = document.querySelectorAll('.insight-article__item').length || 0;
        let _showingNumberElement = document.querySelector('#totalResultShowing');
        if(_showingNumberElement) _showingNumberElement.innerHTML = _showedInsightItems;
    }

    function clickOutsideFilterContainer() {
        document.addEventListener('mouseup', function(e) {
            if(!e.target.closest(".select-filter__item")) {
                __ths.currentFilterTabIndex = -1;
                document.querySelectorAll('.select-filter__item').forEach(_filterItem => {
                    _filterItem.classList.remove('expanded');
                    _filterItem.querySelector(".select-filter__button").setAttribute("aria-expanded", false);
                })
            }
            // [].forEach.call(_filterItemContainers, function(_filterItem){
            //     let _filterConditionContainer = _filterItem.querySelector('.select-filter__condition');
            //     if (!_filterConditionContainer.contains(e.target) && !_filterItem.contains(e.target)) {
            //         _filterItem.classList.remove('expanded');
            //         _filterItem.querySelector(".select-filter__button").setAttribute("aria-expanded", false);
            //         __ths.currentFilterTabIndex = -1;
            //     }
            // });
        });
    }

    function shouldLoadMore() {
        if(!_loadBtn) 
            return;

        let _pageIndexByTags = __ths.config.nextPageIndex;
        let maxPage = Math.ceil(__ths.config.totalItemsCount / __ths.config.pageSize);
        let loadMoreContainer = document.querySelector(".load-more-container")

        if (maxPage < (_pageIndexByTags + 1)) {
            if(loadMoreContainer)
                loadMoreContainer.classList.add("hidden");
            else
                _loadBtn.classList.add('hidden');

        } else {
            if(loadMoreContainer) {
                loadMoreContainer.classList.remove("hidden");
            }
            else {
                _loadBtn.classList.remove('hidden');
            }
            
            if(_loadBtn.href) {
                _loadBtn.href = location.href.replace("page=" + _pageIndexByTags, "page=" + (_pageIndexByTags + 1));
            }
        }
                
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (_pageIndexByTags > 0 ? "?page=" + _pageIndexByTags : ""); 
    };

    init();
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.InsightFiltersV2();
    });
var GTInsightHubOverlays;

GT.GTInsightHubOverlays = function($elements, settings) {
    $.each($elements, function(index, element) {
        var component = GTInsightHubOverlays = new GT.GTInsightHubOverlay(element);
        component.init();
    });
};

GT.GTInsightHubOverlay = function(element) {
    var $element = $(element);
    this.element = element;
    this.$element = $element;
    this.hubid = $element.data('hub');
    this.percent = $element.data('percent');
    if (!this.percent || this.percent <= 0) this.percent = 60;
    this.fadeOutTime = $element.data('fadeout');
    this.showDialog = $element.data('dialog');
    this.storageKey = 'insight-hub-' + this.hubid;
    this.maxApperance = 3;
    var sessionDuration = $element.data('session');
    if (!sessionDuration || sessionDuration <= 0) sessionDuration = 24;
    this.sessionDuration = sessionDuration * 60 * 60 * 1000;
    var ignoreDuration = $element.data('ignored');
    if (!ignoreDuration || ignoreDuration <= 0) ignoreDuration = 365;
    this.ignoreDuration = ignoreDuration * 86400000;
};

GT.GTInsightHubOverlay.prototype.onScrollHandler = function(e) {
    var $this = GTInsightHubOverlays;
    var scrollPercent = $this.getScrollPercent();
    if (scrollPercent < 0 || scrollPercent >= $this.percent) {
        // window.removeEventListener('scroll', $this.onScrollHandler);
        delete GT.listFunctionsTriggerInScrollEvent.GTInsightHubOverlay;
        if(!$this.appear()) {
            $this.element.classList.add("animated", "fadeInUpShort", "delay-250");
            $this.element.style.display = "block";
            $this.element.classList.add("go");
        }
    }
};

GT.GTInsightHubOverlay.prototype.getScrollPercent = function() {
    var s = $(window).scrollTop(),
        d = $(document).height(),
        c = $(window).height();
    var footerHeight = $('footer').outerHeight();
    var scrollPercent = (s / (d - c - footerHeight)) * 100;
    return scrollPercent;
};


GT.GTInsightHubOverlay.prototype.init = function () {
    var currentState = this.getState();
    if (!currentState || currentState.hubid !== this.hubid) {
        currentState = this.defaultState();
        this.saveState(currentState);
    }
    if (currentState.ignored) return;

    var $this = this;

    var onClickIgnoreHandler = function(e) {
        if (e.target && $(e.target).closest('.js-hub-overlay').length === 0 && $(e.target).closest('header').length === 0) {
            $this.$element.fadeOut();
        }
    };

    var onResizeHandler = function onResize(e) {
        var isLandscape = window.innerHeight < window.innerWidth;
        if (isLandscape) {
            var overlayTop = $this.$element.position().top;
            if (overlayTop < 64) {
                $(document).on('click', onClickIgnoreHandler);
                return;
            }
        }
        $(document).off('click', onClickIgnoreHandler);
    };

    if (window.innerWidth < 959) {
        $(window).on('resize', onResizeHandler);
        onResizeHandler();
    }

    if ($(window).scrollTop() === 0 && this.percent === 0) {
        if(!$this.appear()) {
            $this.element.classList.add("animated", "fadeInUpShort", "delay-250");
            $this.element.style.display = "block";
            $this.element.classList.add("go");
        }
    } else {
        GT.listFunctionsTriggerInScrollEvent.GTInsightHubOverlay = GTInsightHubOverlays.onScrollHandler;
        // window.addEventListener('scroll', onScrollHandler);
    }

    this.bindEvent();
};

GT.GTInsightHubOverlay.prototype.bindEvent = function() {
    var $this = this;
    var $closeBtn = $this.$element.find('.h-widget__close');
    $closeBtn.on('click', function(e) { $this.$element.fadeOut(); });

    var $ctaBtn = $this.$element.find('.js-overlay-cta');
    $ctaBtn.on('click', function(e) {
        e.preventDefault();
        var currentState = $this.getState();
        if (!currentState) currentState = $this.defaultState();
        $this.setExpireState(currentState);
        $this.saveState(currentState);
        var href = $(this).attr('href');
        var targetFrame = $(this).attr('target');
        if (targetFrame && targetFrame === "_blank"){
            window.open(href, '_blank');
        } else {
            window.location.href = href;
        }
    });
};

GT.GTInsightHubOverlay.prototype.defaultState = function(state) {
    return {
        'hubid': this.hubid,
        'expiredOn': new Date().getTime() + this.sessionDuration,
        'appearance': 0
    };
};

GT.GTInsightHubOverlay.prototype.setExpireState = function(state) {
    state.expiredOn = new Date().getTime() + this.ignoreDuration;
    state.ignored = true;
};

GT.GTInsightHubOverlay.prototype.appear = function () {
    var $this = this;
    var currentState = $this.getState();
    if (!currentState) currentState = $this.defaultState();
    currentState.appearance = currentState.appearance + 1;
    if (currentState.appearance >= $this.maxApperance) {
        $this.setExpireState(currentState);
        if ($this.showDialog) {
            $this.saveState(currentState);
            $this.openDialog();
            return true;
        }
    }

    $this.saveState(currentState);
    if ($this.fadeOutTime) {
        var fadeOutTime = $this.fadeOutTime * 1000;
        setTimeout(function () {
            $this.$element.fadeOut();
        }, fadeOutTime);
    }
};

GT.GTInsightHubOverlay.prototype.openDialog = function() {
    var containerWidth = 640;
    var containerHeight = 475;
    var winWidth = $(window).innerWidth();
    if (containerWidth > winWidth) {
        containerWidth = winWidth;
    }
    var $form = this.$element.next('.newsletter-container');
    if ($form) {
        var formReferenceID = 'overlay-form-' + new Date().getTime();
        $form.attr('id', formReferenceID);
        var formBody = $('#' + formReferenceID).find(".Form__MainBody").show();
        var formStatus = $('#' + formReferenceID).find(".Form__Status");
        formStatus.html('<span class="Form__Status__Message hide"></span>');
        var formDialogDom = document.querySelector('#' + formReferenceID);
        GT.Overlays.runOverlay(formDialogDom, '#' + formReferenceID, containerWidth, containerHeight, true, true, false);
        setTimeout(function() {
            var $formEl = $form.find('.Form__Element');
            for (var i = 0; i < $formEl.length; i++) {
                var textInput = $formEl.eq(i).find('input[type="text"]');
                if (textInput.length > 0) {
                    textInput.focus();
                    break;
                }
                var checkboxes = $formEl.eq(i).find('input[type="checkbox"]');
                if (checkboxes.length > 0) {
                    checkboxes.focus();
                    break;
                }
                var selects = $formEl.eq(i).find('select');
                if (selects.length > 0) {
                    selects.focus();
                    break;
                }
            }
        }, 500);
    }

};

GT.GTInsightHubOverlay.prototype.saveState = function(state) {
    if (!state) return;
    var data = JSON.stringify(state);
    localStorage.setItem(this.storageKey, data);
};

GT.GTInsightHubOverlay.prototype.getState = function() {
    var storedData = localStorage.getItem(this.storageKey);
    if (storedData) {
        var objStoredData = JSON.parse(storedData);
        if (objStoredData.expiredOn && objStoredData.expiredOn < new Date().getTime()) {
            localStorage.removeItem(this.storageKey);
            return null;
        }
        return objStoredData;
    }
    return null;
};

GT.domContentLoadedFncList.push(function(){
    GT.GTInsightHubOverlays($(".js-hub-overlay"));
});

GT.InsightPageV2 = function () {
    function init() {
        var promotedBlock = document.querySelector('.insight-landing-promoted'), 
            popularBlock = document.querySelector('.insight-landing-popular'),
            promotedSidebar = document.querySelector('.insight-landing-promoted__sidebar');

        if(GT.isTabletView()) {
                if (promotedSidebar && popularBlock) {
                    promotedSidebar.prepend(popularBlock);
                }
                if (promotedBlock) promotedBlock.classList.add('visible');
        } else {
            if (promotedBlock && popularBlock) {
                promotedBlock.querySelector('.container').prepend(popularBlock);
            }
        }
    }
    init()
}

GT.domContentLoadedFncList.push(function(){
    GT.InsightPageV2();
});

GT.windowResizeFncList.GTInsightPageV2 = function() {
    GT.clampText(null,true);
    GT.InsightPageV2();
}

var GTIntenationalMemberFirms = function () {
    tabsHandle();
    continentsHandle();
    jumpToList();
    bookmarkEventHandle();
    bookmarkContinentUrlHandle();
    function tabsHandle() {
        let _memberFirmTabs = document.querySelector('.member-firm__tabs');
        if(!_memberFirmTabs) return;
        let _firmTabs = _memberFirmTabs.querySelectorAll('.firm-tab');

        [].forEach.call(_firmTabs, function(_firmTab){
            if(!_firmTab) return;
            _firmTab.addEventListener('click', function() {
                if(this.classList.contains('.active')) return;
                let _siblingChilds = this.parentNode.querySelectorAll('.firm-tab');
                removeSiblingsClass(_siblingChilds, 'active');
                this.classList.add('active');

                let __siblingFirmContents = document.querySelectorAll('.firm-tab__contents');
                removeSiblingsClass(__siblingFirmContents, 'active');

                let _firmTarget = this.getAttribute('data-target');
                if(_firmTarget) {
                    let _currentFirmContents = document.getElementById(_firmTarget);
                    if(_currentFirmContents) _currentFirmContents.classList.add('active');
                }
            });
        });
    }

    function continentsHandle() {
        let _continentsList = document.querySelectorAll('.member-firms__continents');
        if(!_continentsList) return;
        [].forEach.call(_continentsList, function(_continents) {
            let _continentsHeader = _continents.querySelector('.firms--continents__header');
            _continentsHeader.querySelector(".firms-continents__title").addEventListener("click", (e) => {
                e.preventDefault();
            })
            _continentsHeader.addEventListener('click', function (e) {
                collapseExpandContinent(_continents);
                let targetElm = e.target.closest(".firms--continents__header");
                if(targetElm) {
                    if(targetElm.closest(".member-firms__continents").classList.contains("active")) {
                        location.hash = targetElm.dataset.hash;
                        scroll2Elm(targetElm.offsetTop, 0);
                    } else
                        history.pushState('', document.title, window.location.pathname);
                }
            });

            _continents.addEventListener('beforematch', function() {
                GT.hideHyperLinkAnimation();
                _continents.classList.add('active');
            });
        });
    }

    function jumpToList() {
        let _jumpTolistElm = document.querySelector('.jump-to__list');
        if(!_jumpTolistElm) return;
        _jumpTolistElm.addEventListener('click', jumpToListHandle);
    }

    function jumpToListHandle(e) {
        e.preventDefault();
        let _targetID = this.getAttribute("href");

        let _targetElem = document.querySelector(_targetID);
        if(!_targetElem) return;

        // get padding of list continents container       
        let style = _targetElem.currentStyle || window.getComputedStyle(_targetElem);
        let _paddingElm = parseInt(style.paddingTop) + parseInt(style.paddingBottom);

        let offsetTop = _targetElem.offsetTop - _paddingElm;     
        scroll2Elm(offsetTop);
      }

    function removeSiblingsClass(elms, className) {
        [].forEach.call(elms, function(_otherChild) {
            _otherChild.classList.remove(className);
        });
    }

    function bookmarkContinentUrlHandle() {
        var currentFragment = window.location.hash;
        var locationHashIndex = currentFragment.indexOf("#");
        if (locationHashIndex === 0) {
            currentFragment = currentFragment.substr(1);
        }
        if (currentFragment) {
            let _targetElem = document.querySelector("#" + currentFragment.toLowerCase());
            if (!_targetElem) {
                expandContinentByGeo();
            } else {
                collapseExpandContinent(_targetElem.parentElement);
                scroll2Elm(_targetElem.offsetTop - 100, 1000);
            }
        } else {
            expandContinentByGeo();
        }
    }

    function expandContinentByGeo() {
        let _continentsList = document.querySelectorAll('.member-firms__continents');
        if (!_continentsList) return;
        [].forEach.call(_continentsList, function (_continents) {
            let isSelected = $(_continents).data('is-selected-continent');
            if (isSelected && isSelected.toLowerCase() == "true") {
                collapseExpandContinent(_continents);
            }
        });
    }

    function collapseExpandContinent(continent) {
        continent.classList.toggle('active');

        let _firmsList = continent.querySelector('.firms-continents__list');
        if(_firmsList) {
            if (continent.classList.contains('active')) {
                GT.hideHyperLinkAnimation();
                _firmsList.getAttribute("hidden");
                _firmsList.removeAttribute("hidden");
            } else {
                _firmsList.hidden = 'until-found';
            }
        }
    }

    function bookmarkEventHandle() {
        let _continentBookmarks = document.querySelectorAll('.continent-bookmark');
        if (!_continentBookmarks) return;
        [].forEach.call(_continentBookmarks, function (_continents) {
            _continents.addEventListener('click', function (e) {
                e.preventDefault();
            });
        });
    }

    function scroll2Elm(offset, timeout = 150){
        setTimeout(() => {
            scroll({ top: offset - 200 });
        }, timeout)
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.IntenationalMemberFirms = new GTIntenationalMemberFirms();
});
GT.triggerClampKeyContentBlock = (elm, isForceReRender) => {
    let textElm = elm.querySelector('.text'),
        titleElm = elm.querySelector('.title'),
        isMediumDesktopView = GT.isMediumDesktopView(),
        textElmNumLine = 3,
        titleElmNumLine = 3;


    if(textElm && !textElm.dataset.clamptext) {
        textElm.dataset.clamptext = textElm.textContent;
    }

    if(titleElm && !titleElm.dataset.clamptext) {
        titleElm.dataset.clamptext = titleElm.textContent;
    }

    titleElmNumLine = GT.getNumberLineContent(titleElm) || 0;
    textElmNumLine = GT.getNumberLineContent(titleElm) || 0;
    if(titleElmNumLine > 4) titleElmNumLine = 4;

    const objTitle = {
        settings: { clamp: titleElmNumLine, isHidden: true}
    }

    if(isForceReRender) {
        titleElm.removeAttribute("data-lazyevent-triggered");
        titleElm.textContent = titleElm.dataset.clamptext;
    }
    GT.Clamp(titleElm, objTitle, isForceReRender);
    elm.setAttribute('clamp', true);

    textElmNumLine = (isMediumDesktopView ? 7 : 6) - titleElmNumLine;


    if(textElm) {
        const objText = {
            settings: { clamp: textElmNumLine, isHidden: true}
        }

        if(isForceReRender) {
            textElm.removeAttribute("data-lazyevent-triggered");
            textElm.textContent = textElm.dataset.clamptext;
        }
        GT.Clamp(textElm, objText, isForceReRender);
        elm.setAttribute('clamp', true);
    }
}

GT.clampKeyContentBlock = function (isForceReRender){
    document.querySelectorAll('.career-story-items__container .career-story-item').forEach(elm => {
        GT.triggerClampKeyContentBlock(elm, isForceReRender);
    });
}


GT.domContentLoadedFncList.push(function(){
    GT.clampKeyContentBlock();

    GT.retriggerClampList.keyContent = () => {
        GT.clampKeyContentBlock(true);
    }
});

GT.KeyQuestion = function ($element, obj) {

    var keyIcon = $($element).find('.key-icon');
    var keyQuestion = 'key-question';
    var keyQuestionBox = '.key-question-box';
    var expanded = 'expanded';
    var contentQuestion = '.content-question';

    // GT.ProgressBarRPI object method
    function rpiUpdate() {
        if (GT.ProgressBarRPI) {
            GT.ProgressBarRPI.update();
        }
    }

    $(keyIcon).each(function () {
        var _this = $(this);
        _this.click(function (e) {
            var _this = $(this);
            _this.parents(keyQuestion).siblings().find('.key-question-model').removeClass(expanded).find(keyQuestionBox).removeClass('no-margin__right').hide();
            var keyQuestionModel = _this.parents('.key-question');
            $(keyQuestionModel).toggleClass(expanded);
            $(keyQuestionModel).find(contentQuestion).slideToggle(300, function () {
                $(this).parents(keyQuestionBox).toggleClass('no-margin__right');
            });

            // update progress bar indicator
            rpiUpdate();
        });
    });

    $('.key-question, .keyquestionblock, .podcast-block, .podcastblock, .gt-dataTable-wrapper, .datatableblock').each(function () {
        var _this = $(this);
        if (_this.next().hasClass('key-question')
            || _this.next().hasClass('keyquestionblock')
            || _this.next().hasClass('podcastblock')
            || _this.next().css('float') == 'left'
            || _this.next().css('float') == 'right') {
            _this.addClass('closed-float__group');
            _this.next().addClass('closed-float__group');
        }

        if (_this.prev().hasClass('key-question')
            || _this.prev().hasClass('keyquestionblock')
            || _this.prev().hasClass('podcastblock')
            || _this.prev().css('float') == 'left'
            || _this.prev().css('float') == 'right') {
            _this.addClass('closed-float__group');
            _this.prev().addClass('closed-float__group');
        }
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.KeyQuestion('.key-question');
    });
'use strict';
GT.LazyBackgrounds = function ($element, obj) {
    var doLazyLoad = function lazyLoad(element) {
        if (element.hasAttribute("data-src")) {
            var url = element.getAttribute("data-src");
            var backgroundImage = element.style.backgroundImage;
            if (url && url.length > 0 && backgroundImage.length === 0) {
                element.style.backgroundImage = 'url(' + url + ')';
            }
        }
    };
    var safeDistance = obj.settings && obj.settings.safeDistance ? obj.settings.safeDistance : 150;
    LazyEvent($element, doLazyLoad, safeDistance);
};

$.fn.valueAsObject = function valueAsObject(input) {
    var $element = this;
    var value = $element.val();

    // Write
    if (/array|object/.test(typeof input)) {
        return $element.val(JSON.stringify(input));
    }
    // Read
    try {
        try {
            value = JSON.parse(value);
        } catch (rawParseError) {
            try {
                value = JSON.parse(value.replace(/&quot;/g, '"'));
            } catch (quoteParseError) {
                value = $('<x>').html(value).text();
            }
        }
    } catch (ignore) {
        // This wasn't JSON after all!
    } finally {
        return value;
    }
};
GT.LazyLoad = function ($elem, obj) {
    this.settings = obj.settings || {};
    this.current = $elem;
    if (this.settings.run) {
        this[this.settings.run]($elem);
    };
};


GT.LazyLoad.prototype.loadArticles = function ($elem) {
    var me = this;
    var i = 0;
    var showItemOnClick = 8;
    var rovLenght = 4;
    var jsonUrl = $elem.attr("data-json");
    $($elem).click(function (e) {
        $.ajax({
            cache: false,
            url: jsonUrl,
            dataType: "json",
            success: function (json) {
                var len = 0;
                var relatedItems;
                var _format,
                    _len,
                    _heading,
                    _header,
                    _date,
                    _url,
                    lenLong;
                while (len < showItemOnClick) {
                    if (i < json.relatedContent.length) {
                        relatedItems = json.relatedContent[i];

                        _format = relatedItems.format;
                        _len = relatedItems.len;
                        _heading = relatedItems.heading;
                        _header = relatedItems.header;
                        _date = relatedItems.date;
                        _url = relatedItems.url;
                        if (len === 0 || len === rovLenght) {
                            _format += " firstOfItem ";
                        }
                        if (len === 2 || len === (rovLenght + 2)) {
                            _format += " firstOfItemTablet ";
                        }
                        lenLong = _len;
                        if (parseFloat(_len) === 6.5) {
                            lenLong = "6-5";
                        } else if (parseFloat(_len) === 12.5) {
                            lenLong = "12-5";
                        }
                        _format += " g" + lenLong;
                        //me.loadMoreArticles(_format, _heading, _header, _date, i, _url);
                        $("#art_id" + i).css('opacity', 0).slideDown('fast').animate({
                            opacity: 1
                        }, {
                            queue: true,
                            duration: 'fast'
                        });
                        len++;
                    }
                    if (++i >= json.relatedContent.length) {
                        $(".loadMore").css('opacity', 1).slideUp('fast').animate({
                            opacity: 0
                        }, {
                            queue: false,
                            duration: 'slow'
                        });
                        len = showItemOnClick;
                    }
                }

            }
        });
        e.preventDefault();
    });
};

/**
 * Lazy loading of articles tiles - Loading more items on "More" button click
 */
GT.LazyLoad.prototype.LazyLoadMoreLinkRemove = function ($moreLink) {
    $moreLink.remove();
};

/**
 * Takes fetched JSON and renders new items from it
 */
GT.LazyLoad.prototype.appendArticles = function (items, promoblocks, $relatedItemsContainer, readMoreText) {
    // Promo blocks templates to fill with data
    // large promo block
    var largePromoTemplate = '<div class="col-md-6 {{LargePromoClass}}">' +
        '<div class="lrg-promo" {{bgrImageStyle}}>' +
        '<div class="lrg-promo-gr-container">' +
        '<h2 class="sectionTag cf">{{LinkOpen}}{{Title}}{{LinkClose}}</h2>' +
        '<p class="big-text tc-b"><a href="{{Url}}">{{Summary}}</a></p>' +
        '</div></div></div>';
    // medium promo block
    var mediumPromoTemplate = '<div class="col-md-3 {{MedPromoClass}} block"><div class="med-promo pov" {{bgrImageStyle}}>' +
        '<div class="med-promo-gr-container">' +
        '<h2 class="sectionTag">{{LinkOpen}}{{Title}}{{LinkClose}}</h2>' +
        '<div class="padding">' +
        '<h3>{{Summary}}</h3>' +
        '<p><a href="{{Url}}" class="btn-secondary">' + readMoreText + '</a></p>' +
        '</div></div></div></div>';
    // small square promo block
    var smallPromoTemplate = '<div class="sml-promo"><h2 class="sectionTag">{{LinkOpen}}{{Title}}{{LinkClose}}</h2>' +
        '<h3>{{Summary}}</h3>' +
        '<a href="{{Url}}" class="btn-secondary">' + readMoreText + '</a>' +
        '</div>';
    // small square promo block in defined different color
    var smallPromoColorTemplate = '<div class="sml-promo {{PromoColour}}"><span class="sectionTag">{{PromoTitle}}</span>' +
        '{{PromoLinkBegin}}<p class="padding">{{PromoContent}}</p>{{PromoLinkEnd}}</div>';

    //var promocount = promoblocks.length;
    var promoOutput = [];

    //sometimes we need to add a promoblock in with onother block
    var comboBlock = '<div class="col-md-3 gmp1">{{block1}}{{block2}}</div>';

    //go through the promoblocks
    $.each(promoblocks, function (index, block) {
        var blockMarkup = smallPromoColorTemplate;
        //var $block;

        blockMarkup = blockMarkup.replace('{{PromoTitle}}', block.Title);
        blockMarkup = blockMarkup.replace('{{PromoContent}}', block.Summary);
        blockMarkup = blockMarkup.replace('{{PromoColour}}', 'solid-b');

        try {
            if (block.Url != null) {
                var linkContent = '<a href="' + block.Url + '">';
                blockMarkup = blockMarkup.replace('{{PromoLinkBegin}}', linkContent);
                blockMarkup = blockMarkup.replace('{{PromoLinkEnd}}', '</a>');
            } else {
                blockMarkup = blockMarkup.replace('{{PromoLinkBegin}}', '');
                blockMarkup = blockMarkup.replace('{{PromoLinkEnd}}', '');
            }
        } catch (e) {
            blockMarkup = blockMarkup.replace('{{PromoLinkBegin}}', '');
            blockMarkup = blockMarkup.replace('{{PromoLinkEnd}}', '');
        }
        promoOutput.push(blockMarkup);
    });

    //go through the regular blocks
    $.each(items, function (index, item) {
        var itemMarkup = largePromoTemplate;
        var $item;
        var medPromoClass = "gmp1";
        var largePromoClass = "";

        if (index === 3) {
            medPromoClass = "gmt1";
        }

        if (index === 5) {
            largePromoClass = "gmp1";
        }

        if (index !== 0 && index !== 5) {
            itemMarkup = mediumPromoTemplate;
        }

        if (((index === 1) && (promoOutput[0])) || ((index === 3) && (promoOutput[1]))) {
            itemMarkup = smallPromoTemplate;
        }

        // image
        var bgrImageTpl = 'style="background-image: url({{Image}});"';
        // if image is not null - add it. If not - don't
        if (item.Image !== null) {
            bgrImageTpl = bgrImageTpl.replace('{{Image}}', item.Image);
        } else {
            bgrImageTpl = '';
        }
        itemMarkup = itemMarkup.replace('{{bgrImageStyle}}', bgrImageTpl);
        //itemMarkup = itemMarkup.replace('{{Image}}', item.Image);
        itemMarkup = itemMarkup.replace('{{Title}}', item.Title);
        itemMarkup = itemMarkup.replace('{{Url}}', item.UrlPath);
        itemMarkup = itemMarkup.replace('{{Summary}}', item.Summary);
        itemMarkup = itemMarkup.replace('{{MedPromoClass}}', medPromoClass);
        itemMarkup = itemMarkup.replace('{{LargePromoClass}}', largePromoClass);

        try {
            if (item.TitleUrl) {
                itemMarkup = itemMarkup.replace('{{LinkOpen}}', ('<a href="' + item.TitleUrl + '">'));
                itemMarkup = itemMarkup.replace('{{LinkClose}}', '</a>');
            } else {
                itemMarkup = itemMarkup.replace('{{LinkOpen}}', '');
                itemMarkup = itemMarkup.replace('{{LinkClose}}', '');
            }
        } catch (e) {
            itemMarkup = itemMarkup.replace('{{LinkOpen}}', '');
            itemMarkup = itemMarkup.replace('{{LinkClose}}', '');
        }

        if (index === 1) {
            try {
                if (promoOutput[0]) {
                    itemMarkup = itemMarkup.replace('gmt1', '');
                    itemMarkup = comboBlock.replace('{{block1}}', itemMarkup);
                    itemMarkup = itemMarkup.replace('{{block2}}', promoOutput[0]);
                }
            } catch (ignore) {
                //do nothing
            }
        } else if (index === 3) {
            try {
                if (promoOutput[1]) {
                    itemMarkup = comboBlock.replace('{{block2}}', itemMarkup);
                    // GTE-783 Ensure that we don't indent the  wrong blocks
                    // index 3 is the left edge of a row so no indent required...
                    itemMarkup = itemMarkup.replace('gmp1', 'first-in-row');
                    promoOutput[1] = promoOutput[1].replace('gmt1', '');
                    itemMarkup = itemMarkup.replace('{{block1}}', promoOutput[1]);
                }
            } catch (ignore) {
                //do nothing
            }
        }
        $item = $(itemMarkup);
        // Append and fade in new item
        $item.css({
            opacity: 0
        });
        $relatedItemsContainer.append($item);
        $item.animate({
            opacity: 1
        }, 400);
    });
};

GT.LazyLoad.prototype.LazyLoadingArticles = function ($elem) {
    var me = this;
    // Hide "More" button and exit when there's not enough items to enable lazy loading
    var $moreLink = $('.js-more-articles');
    if (parseInt($('#enableLazyLoading').val(), 10) !== 1) {
        me.LazyLoadMoreLinkRemove($moreLink);
        return;
    }

    var startIndex = isNaN($('#initialStartIndex').val()) ? 100 : parseInt($('#initialStartIndex').val(), 10);
    var itemsPerPage = isNaN($('#itemsPerPage').val()) ? 200 : parseInt($('#itemsPerPage').val(), 10);

    var $relatedItemsContainer = $(".relatedContainer");
    // url to get json data from
    var url = $elem.attr("data-json");
    var queryParams = $('#searchQuery').valueAsObject();
    // Get translated "Read more" text
    var readMoreText = $elem.closest('div[data-readmore]').attr('data-readmore');

    // Bind "More" button
    $moreLink.click(function (e) {
        e.preventDefault();
        var _this = $(this);

        // Throttle fast button clicking
        if ($elem.hasClass('loading-more')) {
            return;
        }

        $elem.addClass('loading-more');

        $.ajax({
            cache: false,
            url: url,
            dataType: "json",
            data: $.param(queryParams, true),
            success: function (result) {
                $elem.removeClass('loading-more');
                _this.blur();
                if (!result || !result.Items || !result.Items.length) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                    return;
                }
                me.appendArticles(result.Items, result.PromoBlocks, $relatedItemsContainer, readMoreText);
                startIndex += itemsPerPage;
                ++queryParams.CurrentPageIndex;
                //lastIndex

                // Hide "More" button when reached the end
                if (startIndex >= result.TotalResultsNumber) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                }
            }
        });

    });

};

/**
 * Lazy loading articles on Media Center page
 */
GT.LazyLoad.prototype.appendMediaArticles = function (items, $resultsContainer) {
    var itemTemplate = '<div class="result clear"><h3><a href="{{Url}}" {{class}}>{{Title}}</a></h3><p>{{PublishDate}}</p></div><hr class="divider">';
    $.each(items, function (index, item) {
        // create media center article element
        var publishDate = item.PublishDateFormated;
        var itemClass = (item.CssClass !== null) ? 'class="' + item.CssClass + '"' : '';
        var elem = itemTemplate.replace("{{Url}}", item.Url).replace("{{Title}}", item.Summary).replace("{{PublishDate}}", publishDate).replace("{{class}}", itemClass);
        var $element = $(elem);
        $element.css({
            'opacity': 0
        });
        $resultsContainer.append($element);
        $element.animate({
            'opacity': 1
        });
    });
};

GT.LazyLoad.prototype.LazyLoadingMediaItemsArticles = function ($elem) {
    var me = this;

    var $moreLink = $('.js-mediacenter-more-articles');
    var $resultsContainer = $('.results-container');
    if (parseInt($('#enableLazyLoading').val(), 10) !== 1) {
        me.LazyLoadMoreLinkRemove($moreLink);
        return;
    }
    var initialStartIndex = $('#initialStartIndex').val();
    var itemsRequested = isNaN(parseInt(initialStartIndex, 10)) ? 100 : parseInt(initialStartIndex, 10);
    var itemsPerPage = $('#itemsPerPage').val();
    itemsPerPage = isNaN(parseInt(itemsPerPage, 10)) ? 200 : parseInt(itemsPerPage, 10);

    var url = $elem.attr("data-json");
    var queryParams = $('#searchQuery').valueAsObject();

    // Bind "More" button
    $moreLink.on("click", function (e) {
        e.preventDefault();

        var _this = $(this);

        // Throttle fast button clicking
        if ($elem.hasClass('loading-more')) {
            return;
        }
        $elem.addClass('loading-more');

        $.ajax({
            cache: false,
            url: url,
            dataType: "json",
            data: $.param(queryParams, true),
            success: function (result) {
                $elem.removeClass('loading-more');
                _this.blur();
                if (!result || !result.Items || !result.Items.length) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                    return;
                }
                me.appendMediaArticles(result.Items, $resultsContainer);
                itemsRequested += itemsPerPage;
                ++queryParams.CurrentPageIndex;

                // Hide "More" button when reached the end
                if (itemsRequested >= result.TotalResultsNumber) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                }
            }
        });

    });
};

/**
 * Lazy loading people on experts page
 */
GT.LazyLoad.prototype.appendExperts = function (items, $expertsContainer, hideLocation) {
    $.each(items, function (index, item) {
        var itemTemplate = '<div class="col-sm-6 col-md-3"><div class="single-expert lazyload" data-bgset="{{PhotoUrl}}">' +
            '<span class="sectionTag">{{Title}}</span>' +
            '<a class="name" href="{{ProfileUrl}}">{{Name}}</a>';

        if (hideLocation == 'False') {
            itemTemplate += '<p class="location">' + item.Location + '</p>';
        }
        itemTemplate += '<p class="phone">{{Phone}}</p><ul class="contact-details">';
        if (item.EmailAddress) {
            itemTemplate += '<li><a class="icon icon-social-email" href=""' + item.EmailAddressObfuscate + '><span class="ir">Email address</span></a></li>';
        }
        if (item.TwitterUrl) {
            itemTemplate += '<li><a class="icon-social-twitter" href="{{TwitterUrl}}"><span class="ir">{{TwitterUrl}}</span></a></li>';
        }
        if (item.LinkedInUrl) {
            itemTemplate += '<li><a class="icon-social-linkedin" href="{{LinkedInUrl}}"><span class="ir">{{LinkedInUrl}}</span></a></li>';
        }
        if (item.VCardDownloadDisabled != true) {
            itemTemplate += '<li class="sbVCard"><a class="vcard-download icon-v-card" data-vcard-name="{{Name}}" href="/PeopleService/GetVCard?contentGuid={{ProfileGuid}}&lang={{Language}}"><span class="ir">{{Name}} VCard</span></a></li>';
        } +
        '</ul>' +
        '</div></div>';
        var $item;

        if (item.Phone != null && item.Phone != "") {
            var tmpPhone = "<a href=\"tel:" + item.Phone + "\">" + item.Phone + "</a>";
            item.Phone = tmpPhone;
        }

        itemTemplate = itemTemplate.replace('{{Title}}', item.Title);
        itemTemplate = itemTemplate.replace(/\{{Name}}/g, item.Name);
        // itemTemplate = itemTemplate.replace('{{Location}}', item.Location);
        itemTemplate = itemTemplate.replace('{{Phone}}', item.Phone);
        itemTemplate = itemTemplate.replace('{{EmailAddress}}', item.EmailAddress);
        itemTemplate = itemTemplate.replace(/\{{TwitterUrl}}/g, item.TwitterUrl);
        itemTemplate = itemTemplate.replace(/\{{LinkedInUrl}}/g, item.LinkedInUrl);
        itemTemplate = itemTemplate.replace('{{PhotoUrl}}', item.PhotoUrl);
        itemTemplate = itemTemplate.replace('{{ProfileUrl}}', item.ProfileUrl);
        itemTemplate = itemTemplate.replace('{{ProfileGuid}}', item.Guid);
        itemTemplate = itemTemplate.replace('{{vCardTitle}}', item.VCardTitle);

        var language = (window.gtConfig.currentLanguageId || "");

        itemTemplate = itemTemplate.replace('{{Language}}', language);

        $item = $(itemTemplate);

        // Hide empty elements
        if (!item.EmailAddress) {
            $item.find('.sbEmail').remove();
        }
        if (!item.TwitterUrl) {
            $item.find('.sbTwitter').remove();
        }
        if (!item.LinkedInUrl) {
            $item.find('.sbLinkedIn').remove();
        }

        // Append and fade in new item
        $item.css({
            opacity: 0
        });
        $expertsContainer.append($item);
        $item.animate({
            opacity: 1
        }, 400);

    });
};

GT.LazyLoad.prototype.LazyLoadingPeople = function ($elem) {
    var me = this;

    // Hide "More" button and exit when there's not enough items to enable lazy loading
    var $moreLink = $('.js-more-experts');
    if ($('#enableLazyLoading').val() !== "1") {
        me.LazyLoadMoreLinkRemove($moreLink);
        return;
    }



    var initialStartIndex = isNaN(parseInt($('#initialStartIndex').val(), 10)) ? 100 : parseInt($('#initialStartIndex').val(), 10);
    var itemsPerPage = isNaN(parseInt($('#itemsPerPage').val(), 10)) ? 200 : parseInt($('#itemsPerPage').val(), 10);
    var lastIndex = isNaN(parseInt($('#totalItemsCount').val(), 10)) ? 0 : parseInt($('#totalItemsCount').val(), 10) - 1;
    var $expertsContainer = $(".expert-container");
    var nameSearch = ($("#name-search").val() || "");
    var serviceSearch = ($("#serv").val() || $("#lastUrlServicec").val() || "");
    var industrySearch = ($("#ind").val() || $("#lastUrlIndustries").val() || "");
    var locationSearch = ($("#exLoc").val() || $("#lastUrlLocations").val() || "");
    var langSearch = (window.gtConfig.currentLanguageId || "");

    if (nameSearch === "by name") {
        nameSearch = "";
    }



    // Unchangeable part of the url
    var url = $elem.attr("data-json") + '?' +
        "service=" + serviceSearch +
        "&industry=" + industrySearch +
        "&location=" + locationSearch +
        "&lang=" + langSearch +
        "&name=" + nameSearch +
        "&count=" + itemsPerPage.toString();

    var startIndex = initialStartIndex;
    // reset url when user press 'go to previous page' button in browser
    $(window).bind("pageshow", function () {
        if (($(location).attr('search'))){
        url = $elem.attr("data-json") + $(location).attr('search') + "&lang=" + langSearch + "&count=" + itemsPerPage.toString();
    }
    });

    // Bind "More" button
    $moreLink.click(function (e) {
        e.preventDefault();
        var _this = $(this);
        // Throttle fast button clicking
        if ($elem.hasClass('loading-more')) {
            return;
        }

        $elem.addClass('loading-more');
        var hideLocation = $elem.attr("data-hidelocation");
        $.ajax({
            cache: false,
            url: url + '&start=' + startIndex.toString(), // start is 0-based
            dataType: "json",
            success: function (data) {
                $elem.removeClass('loading-more');
                _this.blur();
                if (!data || !data.People || !data.People.length) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                    return;
                }
                // Take fetched JSON and render new items from it
                me.appendExperts(data.People, $expertsContainer, hideLocation);
                GT.GTPeopleLandingPage();

                startIndex += itemsPerPage;

                // Hide "More" button when reached the end
                if (startIndex > lastIndex) {
                    me.LazyLoadMoreLinkRemove($moreLink);
                }
            }
        });

    });

};

GT.LazyLoad.prototype.loadMoreVacancies = function (department, jobTitle, jobLocation, jobUrl, index) {
    // html mark up in here

    var html = '<div class="row vacancy-row"><div class="col-xs-4 vacancy-column"><a class="vacancy-cell" href="' + jobUrl + '">' + jobTitle + '</a>' + '</div><div class="col-xs-4 vacancy-column"><span class="vacancy-cell">' + department + '</span></div><div class="col-xs-4 vacancy-column"><span class="vacancy-cell">' + jobLocation +
        '</span></div></div>';

    $(".vacancy-list-view").append(html);
};

GT.LazyLoad.prototype.loadVacancies = function ($elem) {
    var me = this;

    var currentIndex = $elem.data("initialindex");
    var pagesize = $elem.data("loadmore");
    var totalCount = $elem.data("total");
    var languageSymbol = $elem.data("language");

    $elem.click(function (e) {
        var jsonUrl = "/CareerService/GetJobLists/?start=" + currentIndex + "&count=" + pagesize + "&languageSymbol=" + languageSymbol;

        $.ajax({
            cache: false,
            url: jsonUrl,
            dataType: "json",
            success: function (json) {
                var i;
                var moreVacancies,
                    _jobSect,
                    _jobName,
                    _jobLoc,
                    _jobUrl;
                var currentID;
                for (i = 0; i < json.length; i++) {
                    moreVacancies = json[i];
                    _jobSect = moreVacancies.Department;
                    _jobName = moreVacancies.JobTitle;
                    _jobLoc = moreVacancies.Location;
                    _jobUrl = moreVacancies.JobUrl;

                    me.loadMoreVacancies(_jobSect, _jobName, _jobLoc, _jobUrl, currentIndex + i);

                    currentID = currentIndex + i;
                    $("#job_id" + currentID).css('opacity', 0).slideDown('fast').animate({
                        opacity: 1
                    }, {
                        queue: true,
                        duration: 'fast'
                    });

                }

                currentIndex = currentIndex + pagesize; //increment the current index so the next ajax call gets the right content.

                if (currentIndex >= totalCount) {
                    $(".loadmore-container").fadeOut("fast", function () {
                        $(this).remove();
                    });
                }
            }
        });
        e.preventDefault();
    });
};

GT.LazyLoad.prototype.appendEvents = function (items, $resultsContainer) {
    var itemTemplate;
    var status;
    $.each(items, function (index, item) {
        status = item.Status;
        itemTemplate = '<div class="single-event-block" itemscope itemtype ="https://schema.org/Event"><div class="row">';
        itemTemplate += '<div class="col-sm-2 col-xs-12 event-date-container"><div class="eq event-date"><span itemprop="startDate" content="{{DateMarkupContent}}">{{Date}}</span></div></div>';
        if (status && (status !== "")) {
            itemTemplate += '<div class="col-sm-6 col-lg-7 col-xs-12 event-name-container"><div class="eq event-name-single"><span itemprop="name"><a href="{{Url}}">{{Title}}</a></span><span class="event-status">(' + status + ')</span></div></div>';
        } else {
            itemTemplate += '<div class="col-sm-6 col-lg-7 col-xs-12 event-name-container"><div class="eq event-name-single"><span itemprop="name"><a href="{{Url}}">{{Title}}</a></span></div></div>';
        }
        if (item.Location.length > 0) {
            itemTemplate += '<div class="event-time-float col-sm-4 col-lg-3 col-xs-12"><div class="eq event-time-single" itemprop="location" itemscope itemtype="https://schema.org/Place"><div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress"><span itemprop="addressLocality"><span class="icon-event-pin" aria-hidden="true"></span> {{Location}}</span></div></div></div>';
        }
        itemTemplate += '</div></div>';
        // create event item
        var elem = itemTemplate.replace("{{Url}}", item.Url).replace("{{Title}}", item.Title).replace("{{Date}}", item.Date).replace("{{Location}}", item.Location).replace("{{DateMarkupContent}}", item.DateMarkupContent);
        var $element = $(elem);
        $element.css({
            'opacity': 0
        });
        $resultsContainer.append($element);
        GT.Clamp($element.find('.event-name-single span a, .event-name span a'), {
            settings: {
                clamp: 2
            }
        });
        (function ($element) {
            setTimeout(function () {
                if (typeof GT.Equalise != "undefined") {
                    GT.Equalise('.single-event-block');
                }
                $element.animate({
                    'opacity': 1
                });
            }, 100);
        })($element);

    });
};

GT.LazyLoad.prototype.LoadMoreEvents = function (serviceUrl, queryParams, $moreLink, itemsPerPage, itemsRequested, $resultsContainer) {
    var me = this;
    $.ajax({
        cache: false,
        url: serviceUrl,
        dataType: "json",
        data: $.param(queryParams, true),
        success: function (result) {
            $moreLink.removeClass('loading-more');
            $moreLink.blur();
            if (!result || !result.Items || !result.Items.length) {
                me.LazyLoadMoreLinkRemove($moreLink);
                return;
            }
            //appendItems(result.Items);
            me.appendEvents(result.Items, $resultsContainer);
            itemsRequested += itemsPerPage;
            ++queryParams.CurrentPageIndex;
            me.lazyLoadingStatus = true;

            // Hide "More" button when reached the end
            if ($('.single-event-block').length === result.TotalResultsNumber) {

                me.LazyLoadMoreLinkRemove($moreLink);
            }
        }
    });
};

GT.LazyLoad.prototype.LazyLoadingEvents = function ($elem) {
    var me = this;
    // Hide "More" button and exit when there's not enough items to enable lazy loading
    var $moreLink = $('.js-more-events');
    if (parseInt($('#enableLazyLoading').val(), 10) !== 1) {
        me.LazyLoadMoreLinkRemove($moreLink);
        return;
    }
    var itemsRequested = $('#initialStartIndex').val();
    itemsRequested = isNaN(itemsRequested) ? 20 : parseInt(itemsRequested, 10);
    var itemsPerPage = $('#itemsPerPage').val();
    itemsPerPage = isNaN(itemsPerPage) ? 20 : parseInt(itemsPerPage, 10);

    var url = $elem.attr("data-json");

    var queryParams = $('#searchQuery').valueAsObject();

    var $resultsContainer = $('.listing-container');
    $($elem).on('click', function (e) {
        e.preventDefault();
        me.lazyLoadingStatus = false;

        // Throttle fast button clicking
        if ($elem.hasClass('loading-more')) {
            return;
        }
        $elem.addClass('loading-more');
        // check if filters has been set?
        var filter = $('#show-location').find('option:selected').val();
        queryParams.Location = filter;

        itemsRequested += itemsPerPage;
        me.LoadMoreEvents(url, queryParams, $elem, itemsPerPage, itemsRequested, $resultsContainer);
    });
};

GT.LazyLoad.prototype.FilterEvents = function ($elem) {
    $elem.on('change', function () {
        var $form = $elem.closest('form');
        $form.submit();
    });
};

GT.LazyLoad.prototype.getOfficeTemplate = function (_smallPrint, _additionalInfo, key, _employeesLink) {
    var addressTemplate = '';
    if (parseInt(key, 10) === 0) {
        addressTemplate += '<div class="row clear location-officeHeading"><div class="col-md-12"><span class="office-name">{{OfficeName}}, {{Location}}</span></div></div>';
    }
    addressTemplate += '<div class="gr clear location-cont"><div class="col-md-4 gmap-cont">';
    addressTemplate += '<img src="{{MapImg}}" class="gmap-img" alt=""><a href="{{MapUrl}}" class="btn-primary-alt link gmap-view-link" target="_blank">{{LocalLang}}</a></div>';
    addressTemplate += '<div class="gmp1 col-md-4 location-basic-info"><div class="location-basic-info-container"><h3>{{Office}}</h3><ul class="correspondent-list">';
    addressTemplate += '<li class="cor-phone">{{Phone}}</li><li class="cor-email"><a href="" {{Email}}><i class="icon-social-email" aria-hidden="true"></i> {{EmailUs}}</a></li>';
    addressTemplate += '<li class="cor-location"><ul class="location-info"><li><i class="icon-event-pin" aria-hidden="true"></i></li> <li>{{Address}}</li></ul></li>';
    if (_smallPrint !== undefined) {
        addressTemplate += '<li><span class="smallPrint">{{SmallPrint}}</span></li>';
    }
    addressTemplate += '</ul></li>';
    addressTemplate += '</ul>';
    if ((_employeesLink !== undefined) && (_employeesLink !== null) && (_employeesLink.length > 0)) {
        addressTemplate += '<a href="{{EmployeesLink}}" class="show-employees">{{ViewEmployees}}</a>';
    }
    addressTemplate += '</div>';
    addressTemplate += '</div>';
    if (_additionalInfo !== undefined) {
        addressTemplate += '<div class="gmp1 col-md-4 location-additional-info">{{AdditionalInfo}}</div>';
    }
    addressTemplate += '</div>';

    return addressTemplate;
};

GT.LazyLoad.prototype.loadOffices = function (key, _office, _location, _mapImg, _mapURL, _phone, _email, _addAry, _smallPrint, _additionalInfo, _emailUs, officeName, _employeesLink) {
    var me = this;
    var _addressAppend = _addAry ? _addAry.replace(/\n/g, '<br/>') : '';
    var $offices = $('.offices');
    var viewEmployees = $offices.closest('.container').attr('data-employees');

    if (!viewEmployees || (viewEmployees.length === 0)) {
        viewEmployees = "View employees";
    }
    var _defaultMapImgPath = $offices.closest('.container').attr('data-default-map-img');
    var $localLang = $offices.closest('.container').attr('data-location');
    var $localCountry = $offices.closest('.container').attr('data-country');

    var addressTemplate = me.getOfficeTemplate(_smallPrint, _additionalInfo, key, _employeesLink);
    if (_phone != null && _phone != "") {
        var tmpPhone = "<a href=\"tel:" + _phone + "\">" + _phone + "</a>";
        _phone = tmpPhone;
    }

    // fill template with data
    addressTemplate = addressTemplate.replace(/\{\{OfficeName\}\}/g, officeName);
    addressTemplate = addressTemplate.replace(/\{\{Office\}\}/g, _office);
    addressTemplate = addressTemplate.replace(/\{\{Location\}\}/g, $localCountry);
    if (_mapImg === '') {
        addressTemplate = addressTemplate.replace(/\{\{MapImg\}\}/g, _defaultMapImgPath);
    } else {
        addressTemplate = addressTemplate.replace(/\{\{MapImg\}\}/g, _mapImg);
    }
    addressTemplate = addressTemplate.replace(/\{\{MapUrl\}\}/g, _mapURL);
    addressTemplate = addressTemplate.replace(/\{\{LocalLang\}\}/g, $localLang);
    addressTemplate = addressTemplate.replace(/\{\{Phone\}\}/g, _phone);
    addressTemplate = addressTemplate.replace(/\{\{Email\}\}/g, _email);
    addressTemplate = addressTemplate.replace(/\{\{EmailUs\}\}/g, _emailUs);
    addressTemplate = addressTemplate.replace(/\{\{Address\}\}/g, _addressAppend);
    addressTemplate = addressTemplate.replace(/\{\{SmallPrint\}\}/g, _smallPrint);
    addressTemplate = addressTemplate.replace(/\{\{AdditionalInfo\}\}/g, _additionalInfo);
    addressTemplate = addressTemplate.replace(/\{\{EmployeesLink\}\}/g, _employeesLink);
    addressTemplate = addressTemplate.replace(/\{\{ViewEmployees\}\}/g, viewEmployees);

    $(".offices").append(addressTemplate);
};

GT.LazyLoad.prototype.getLocationData = function ($locElem, locationList) {
    var me = this;
    var locData = $locElem.attr('data-loc');
    var locDataArray = locData.split('||');
    var locationData = locDataArray[0];
    var locationNiceUrl = locDataArray[1];
    var officeName = $locElem.attr('data-name');
    // is not active so remove active class
    locationList.removeClass("active");
    // add class active to clicked item
    $locElem.addClass("active");

    // remove current offices
    $(".offices").children().fadeOut('fast', function () {
        $(this).remove();
    });

    var locationUrl = (locationNiceUrl || officeName || locationData);
    var locationParam = "?location=" + locationUrl;
    if (me.hasHistorySupport()) {
        history.pushState(null, document.title, locationParam);
    } else {
        // otherwise - reload page
        var currentUrl = window.location.href;
        currentUrl = currentUrl.replace(window.location.search, "");
        window.location.href = currentUrl + locationParam;
    }

    // test using AJAX instead:
    $.ajax({
        type: 'GET',
        ///LocationService/GetOfficeContactDetails parm: string city
        url: '/LocationService/GetOfficeContactDetails/',
        data: {
            city: locationData,
            locationString: '',
            lang: window.gtConfig.currentLanguageId
        },
        success: function (data, textStatus) {
            // Handle success
            //var _location = data.OfficeLocation;
            console.log(data);
            var key,
                _office,
                _location,
                _mapImg,
                _mapURL,
                _phone,
                _emailObfuscate,
                _addAry,
                _additionalInfo,
                _emailUsObfuscate,
                _smallPrint,
                _employeesLink;
            for (key in data.OfficeLists) {
                if (data.OfficeLists.hasOwnProperty(key)) {
                    _office = data.OfficeLists[key].Office;
                    _location = data.OfficeLists[key].locat;
                    _mapImg = data.OfficeLists[key].LocationImage;
                    _mapURL = data.OfficeLists[key].MapUrl;
                    _phone = data.OfficeLists[key].PhoneNumber;
                    _emailObfuscate = data.OfficeLists[key].EmailAddressObfuscate;
                    _addAry = data.OfficeLists[key].Address;
                    _additionalInfo = data.OfficeLists[key].AdditionalInfo;
                    _emailUsObfuscate = data.OfficeLists[key].EmailUsCaptionObfuscate;
                    _smallPrint = data.OfficeLists[key].smallprint;
                    _employeesLink = data.OfficeLists[key].EmployeesLink;
                    //  if smallprint exists
                    // if (data.OfficeLists[key].smallprint !== undefined) {
                    //     _smallPrint = data.OfficeLists[key].smallprint;
                    // } else {
                    //     _smallPrint = undefined;
                    // }

                    me.loadOffices(key, _office, _location, _mapImg, _mapURL, _phone, _emailObfuscate, _addAry, _smallPrint, _additionalInfo, _emailUsObfuscate, officeName, _employeesLink);
                }
            }
            if (data.OfficeLists[0]) {
                me.scrollDownToOffices();
            }
        },
        error: function (xhr, textStatus, errorThrown) {
            // Handle error
        }
    });
};

GT.LazyLoad.prototype.getLocation = function ($elem) {
    var me = this;
    // make this better...
    var locationList = $('.locations-list span.office a');

    locationList.click(function () {
        var $locElem = $(this);
        if (!$locElem.hasClass('active')) {
            me.getLocationData($locElem, locationList);
        }

        //  json function
        return false;
    });
};

GT.LazyLoad.prototype.scrollToLocation = function ($elem) {
    var me = this;

    var currentUrl = window.location.href;
    if (currentUrl.match(/\?location=/)) {
        setTimeout(function () {
            me.scrollDownToOffices();
        }, 750);
    }
};

GT.LazyLoad.prototype.scrollDownToOffices = function () {
    $('html, body').animate({
        scrollTop: $(".offices").offset().top
    }, 950);
};

GT.LazyLoad.prototype.hasHistorySupport = function () {
    return !!(window.history && history.pushState);
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        [
            { elm: $('.js-more-experts'), settings: { run: 'LazyLoadingPeople' } }
        ].map(function (item) {
            if (item.elm.length) {
                new GT.LazyLoad(item.elm, item);
            }
        })
    });

let linkTertiaryList = [];

GT.LinkTertiary = function () {
    linkTertiaryList.push(setTimeout(() => {
        let hiddenLinkAnimation = document.querySelector("body");
        if(hiddenLinkAnimation) {
            requestAnimationFrame(() => {
                hiddenLinkAnimation.classList.remove("hidden-link__animation");
            });
        }
    }, 350))
}

GT.hideHyperLinkAnimation = function() {
    linkTertiaryList.forEach(timer => {
        clearTimeout(timer);
    })
    
    let _body = document.querySelector("body");
    if(!_body.classList.contains('hidden-link__animation')) _body.classList.add('hidden-link__animation');
    GT.LinkTertiary();
}

GT.domContentLoadedFncList.push(function(){
    GT.LinkTertiary();
});

GT.expandBanner = function ($elem) {
    var copy = $($elem).find('.content-copy');
    var readMore = $($elem).find('.route-link.down.pull-right');
    var readLess = $($elem).find('.route-link.up.pull-right');
    readLess.hide();
    if (copy.height() <= 96) {
        readMore.hide();
    }
    else {
        copy.css('max-height','96px');
        readMore.show();
        readMore.on('click', function () {
            copy.css('max-height','none');
            readMore.hide();
            readLess.show();
            readLess.on('click', function () {
                copy.css('max-height','96px');
                readMore.show();
                readLess.hide();
            });
        });
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        new GT.expandBanner($('.content_hub.content_hub-container--wide'));
    });
GT.popupLocation = function (position) {
	var pickedPos = position;
	var mapBlock = $('.map-block .popup-content');
	mapBlock.find('.close').on('click', function (event) {
		mapBlock.css('display', 'none');
	});
	var getdirectiontextlocal;
	if (!getDirectionTextGoogleMap) {
		getdirectiontextlocal = "Get directions";
	} else {
		getdirectiontextlocal = getDirectionTextGoogleMap;
	}
	var currentLocation = JSON.parse(localStorage.getItem('location'));
	var latLngAddToMap = '';
	if (currentLocation.lat && currentLocation.lng && currentLocation.lat > 0 && currentLocation.lng > 0) {
		latLngAddToMap = currentLocation.lat + ',' + currentLocation.lng
	}
	for (var i = 0; i < listDetailLocation.length; i++) {
		if (listDetailLocation[i].officeId === pickedPos) {
			mapBlock.css('display', 'block');
			mapBlock.find('.map-title').empty().append(listDetailLocation[i].office);
			mapBlock.find('.map-address .address').empty().append(listDetailLocation[i].address);
			// var tollFreeNumberText = '';
			// if (listDetailLocation[i].isShowTollFree)
			// {
			// 	tollFreeNumberText = '<p class="map-links">' + listDetailLocation[i].tollFreeNumberTextNoClass+'<a href="tel: ' + listDetailLocation[i].tollFreeNumber + '">' + listDetailLocation[i].tollFreeNumber +'</a></p>';
			// }
			// var faxNumberText = '';
			// if (listDetailLocation[i].isShowFax) {
			// 	faxNumberText = '<p class="map-links"><i class="icon icon-printer_eps"></i><a href="tel: ' + listDetailLocation[i].faxNumber + '">' + listDetailLocation[i].faxNumber + '</a></p>\n';
			// }

			mapBlock.find('.map-links .map-link__location a').attr("href", listDetailLocation[i].mapUrl + latLngAddToMap);
			mapBlock.find('.map-links .map-link__location a').attr("title", listDetailLocation[i].mapUrlTitle);
			mapBlock.find('.map-links .map-link__phone a').text(listDetailLocation[i].phoneNo);
			mapBlock.find('.map-links .map-link__phone a').attr("href", "tel:" + listDetailLocation[i].phoneNo);
			// mapBlock.find('.map-links').empty().append('     <p class="map-link single-social__icon"><i class="icon icon-location"></i><a class="google-map-direction-litle-lot" target="_blank" title="'+ listDetailLocation[i].mapUrlTitle +'" href="' + listDetailLocation[i].mapUrl + latLngAddToMap +'">' + getdirectiontextlocal + '</a></p>\n' +
			// 	'            <p class="map-link single-social__icon"><i class="icon icon-phone-new"></i><a href="tel: ' + listDetailLocation[i].phoneNo + '">' + listDetailLocation[i].phoneNo + '</a></p>'+ faxNumberText + tollFreeNumberText
			// );
			mapBlock.find('.btn.btn-primary-teal').attr('href', listDetailLocation[i].linkLocation);
		}
	}
};
GT.checkMapDirection = function () {
	var currentLocation = JSON.parse(localStorage.getItem('location'));
	if (currentLocation) {
		if (currentLocation.lat && currentLocation.lng && currentLocation.lat > 0 && currentLocation.lng > 0) {
			$('.google-map-direction').each(function () {
					var newURL = $(this).attr('href') + currentLocation.lat + ',' + currentLocation.lng;
					$(this).attr('href', newURL);
			});
			}
	}
};
GT.checkMapDirectionLittleLotOffice = function () {
	var currentLocation = JSON.parse(localStorage.getItem('location'));
	if (currentLocation) {
		if (currentLocation.lat && currentLocation.lng && currentLocation.lat > 0 && currentLocation.lng > 0) {
			$('.google-map-direction-litle-lot').each(function () {
				var currentHref = $(this).attr('href');
				if(currentHref) {
					var locationArray = currentHref.split('&saddr=');
					if (locationArray && locationArray[1]==="") {
						var newURL = $(this).attr('href') + currentLocation.lat + ',' + currentLocation.lng;
						$(this).attr('href', newURL);
					}
				}
			});
		}
	}
};
GT.checkMapDirection();
GT.FilterOffice = function ($elem, opts) {
	if(typeof lotsofficeservicefilter == "undefined")
		return;

	var dataModel = JSON.parse(JSON.stringify(lotsofficeservicefilter));
	var $this = this;
	var showBtn = $($elem).find(".show-more-btn");
	var filterContainer = $($elem).find('.filter_list');
	var clearFilterContainer = $($elem).find(".filter-count");
	var clearFilter = $($elem).find(".clear-filter");
	var filterNumber = $($elem).find(".filter-number");
	var accordionList = $($elem).find(".accordion .accordion__items");
	var resultNumber = $($elem).find('.result-number');
	var backToTop = $($elem).find('.route-link.up');
	var is1stTime = true;
	var currentLocation = JSON.parse(localStorage.getItem('location'));
	var latLngAddToMap = '';
	if (currentLocation.lat && currentLocation.lng && currentLocation.lat > 0 && currentLocation.lng > 0) {
		latLngAddToMap = currentLocation.lat + ',' + currentLocation.lng
	}
	var defaultSelectedList = null;
	// DEFINE TEMPLATE
	var accordionItem = $('<div class="accordion-item">\n' +
		'    <div class="accordion-item__content">\n' +
		'        <div class="row d-flex">\n' +
		'            \n' +
		'        </div>\n' +
		'    </div>\n' +
		'</div>');
	var accordionHeading = $('<div class="accordion-item__title accordion-item__trigger" scrollTop="false" role="button" aria-expanded="false" tabindex="0"></div>');

	// FUNCTIONS
	function init() {

		initFilter();
		updateResults(defaultSelectedList);
		updateFilterNumber();
	}

	showBtn.on('click', function (event) {
		$(this).toggleClass('show-less');
		if ($(this).hasClass('show-less')) {
			if (showLessText) {
				$(this).text(showLessText);
			} else {
				$(this).text('Show less');
			}

			filterContainer.css('max-height', 'none');
		} else {
			if (showMoreText) {
				$(this).text(showMoreText);
			} else {
				$(this).text('Show more');
			}
			filterContainer.css('max-height', opts.height);
		}
	});
	backToTop.on('click', function (event) {
		var $container = $("html,body");
		$container.animate({
			scrollTop: ($($elem).offset().top)
		}, 500, function(){
			$($elem).find(".filter-pill:eq(0)").focus();
		});
	});
	$(opts.filterSelector).on('click', opts.triggerSelector, function (event) {
		is1stTime = false;
		$(this).toggleClass('selected');
		var selectedList = [];
		$(opts.triggerSelector + '.selected').each(function () {
			selectedList.push($(this).val());
		});
		if (selectedList.length === 0) {
			selectedList = defaultSelectedList;
			is1stTime = true;
			clearFilterContainer.hide();
		} else {
			clearFilterContainer.show();
		}
		if($(this).hasClass("selected"))
			$(this).attr("aria-selected", "true");
		$('.map-block .popup-content').css('display', 'none');
		updateResults(selectedList);
		updateFilterNumber();
	});
	clearFilter.on('click', function (event) {
		$(opts.triggerSelector).each(function () {
			$(this).removeClass('selected').attr("aria-selected", "false");
		});
		is1stTime = true;
		updateResults(defaultSelectedList);
		updateFilterNumber();
		$('.map-block .popup-content').css('display', 'none');
		clearFilterContainer.hide();
		$($elem).find(".filter-pill:eq(0)").focus();
	});

	var updateFilterNumber = function () {
		let filterNumberStr = $(opts.filterSelector).find(".selected").length + ' filters chosen';
		filterNumber.text(filterNumberStr);
		clearFilter.attr("aria-description", filterNumberStr);
		if (is1stTime === true) {
			resultNumber.hide();
		} else {
			resultNumber.show();
		}
	};
	var initFilter = function () {
		if (dataModel.isHideFilter === true || dataModel.listFilters.length <= 0) {
			$($elem).find(".filter-control").remove();
		} else {
			var filterPill = $(' <button class="filter-pill" role="option" aria-selected="false"></button>');
			filterContainer.empty();
			for (var i = 0; i < dataModel.listFilters.length; i++) {
				var filterPillInstance = filterPill.clone().text(dataModel.listFilters[i].text).val(dataModel.listFilters[i].value);
				filterPillInstance.appendTo(filterContainer);
			}
			if ($(window).width() < 1024) {
				opts.height = '236px';

				if (filterContainer.height() <= opts.height) {
					showBtn.hide();
				} else {
					filterContainer.css('max-height', opts.height);
					showBtn.show();
				}
			}
			else {
				if (filterContainer.height() <= 116) {
					showBtn.hide();
				} else {
					filterContainer.css('max-height', opts.height);
					showBtn.show();
				}
			}
			window.addEventListener('resize', function () {
				if ($(window).width() < 1024) {
					opts.height = '236px';
					filterContainer.css('max-height', 'none');
					if (filterContainer.height() <= 236) {
						showBtn.hide();
						filterContainer.css('max-height', opts.height);
					} else {
						filterContainer.css('max-height', opts.height);
						showBtn.show();
					}
				}
				else {
					opts.height = '116px';
					filterContainer.css('max-height', 'none');
					if (filterContainer.height() <= 116) {
						filterContainer.css('max-height', opts.height);
						showBtn.hide();
					} else {
						filterContainer.css('max-height', opts.height);
						showBtn.show();
					}
				}

			});

			clearFilterContainer.hide();
		}

	};


	var updateResults = function (selectedData) {
		accordionList.empty();
		resultNumber.empty();
		resultNumber.hide();
		$($elem).find('.filter-result .row').empty();
		var resultCount = 0;
		var dataClone = JSON.parse(JSON.stringify(dataModel));
		var defaultOffice;
		const defaultOfficeFromURL = new URLSearchParams(window.location.search).get("officeId");
		listLocation = [];
		var getdirectiontextlocal;
		if (!getDirectionText) {
			getdirectiontextlocal = "Get directions";
		} else {
			getdirectiontextlocal = getDirectionText;
		}
		
		if (dataClone.isLittleOffice === false) {
			var removeValFromIndex = [];
			for (var a = 0; a < dataClone.data.length; a++) {
				var temp1 = [];
				for (var b = 0; b < dataClone.data[a].subData.length; b++) {
					var flag = false;
					const currentOfficeId = dataClone.data[a].subData[b].officeId.toString();
					if (currentOfficeId === $('#defaultFocusOffice').val() && !defaultOfficeFromURL) {
						defaultOffice = a;
					}

					if (currentOfficeId === defaultOfficeFromURL || (defaultOfficeFromURL == -1 && a == 0)) {
						defaultOffice = a;
					}

					if (selectedData && selectedData.length > 0) {
						if (dataClone.data[a].subData[b].code) {
							for (var c = 0; c < dataClone.data[a].subData[b].code.length; c++) {

								if (selectedData.includes(dataClone.data[a].subData[b].code[c])) {
									flag = true;
									break;
								}
							}
						}
					} else {
						flag = true;
					}
					if (flag === true) {
						temp1.push(dataClone.data[a].subData[b]);
						listDetailLocation.push(dataClone.data[a].subData[b]);
						listLocation.push({
							officeId: dataClone.data[a].subData[b].officeId,
							office: dataClone.data[a].subData[b].office,
							coordinate: {
								'lat': dataClone.data[a].subData[b].lat,
								'lng': dataClone.data[a].subData[b].lng
							}
						}
						);
					}
				}
				if (temp1.length > 0) {
					dataClone.data[a].subData = temp1;
					resultCount += temp1.length;
					if (is1stTime === false) {
						dataClone.data[a].count = ' (' + temp1.length + ')';
					} else {
						dataClone.data[a].count = '';
					}
				} else {
					removeValFromIndex.push(a);
				}
			}
			for (var r = removeValFromIndex.length - 1; r >= 0; r--) {
				dataClone.data.splice(removeValFromIndex[r], 1);
			}
			resultNumber.append(resultCount + ' results');

			reloadMarkers();

			for (var i = 0; i < dataClone.data.length; i++) {
				var accClone = accordionItem.clone();
				accordionHeading.text(dataClone.data[i].heading + dataClone.data[i].count).clone().prependTo(accClone);

				for (var j = 0; j < dataClone.data[i].subData.length; j++) {
					var tollFreeNumberText = '';
					if (dataClone.data[i].subData[j].isShowTollFree) {
						tollFreeNumberText = '            <div class="link-icon">' + dataClone.data[i].subData[j].tollFreeNumberText+'<a href="tel: ' + dataClone.data[i].subData[j].tollFreeNumber + '">' + dataClone.data[i].subData[j].tollFreeNumber + '</a></div>';
					}
					var faxNumberText = '';
					if (dataClone.data[i].subData[j].isShowFax) {
						faxNumberText = '<div class="link-icon"><i class="icon icon-printer_eps"></i><a href="fax: ' + dataClone.data[i].subData[j].faxNumber + '">' + dataClone.data[i].subData[j].faxNumber + '</a></div>\n';
					}
					accClone.find('.accordion-item__content .row').append('<div class="col-xs-12 col-md-4 " code="' + dataClone.data[i].subData[j].code + '">\n' +
						'    <div class="office-hub bg-light" data-office-id="' + dataClone.data[i].subData[j].officeId + '">\n' +
						'        <div class="big-text center-text h3"> ' +
						'			<a class="navigation-link" href="' + dataClone.data[i].subData[j].linkLocation + '">' +
						'				<text class="button-vi-text">' + dataClone.data[i].subData[j].office + '</text>' + 
						'				<svg class="svg-animation-vi" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg_arrow-button-vi"></use></svg>' + 
						'			</a>' +
						'		 </div>\n' +
						'        <p>' + dataClone.data[i].subData[j].address + '</p>\n' +
						'        <div class="text-left info-links">\n' +
						'            <div class="link-icon"><i class="icon icon-location"></i><a class="google-map-direction-litle-lot" target="_blank" title="'+ dataClone.data[i].subData[j].mapUrlTitle +'" href="' + dataClone.data[i].subData[j].mapUrl + latLngAddToMap + '">' + getdirectiontextlocal + '</a></div>\n' +
						'            <div class="link-icon"><i class="icon icon-phone-new"></i><a href="tel: ' + dataClone.data[i].subData[j].phoneNo + '">' + dataClone.data[i].subData[j].phoneNo + '</a></div>\n' + faxNumberText +
						tollFreeNumberText+
						'        </div>\n' +
						'    </div>\n' +
						'</div>');
				}
				accClone.appendTo(accordionList);
			}
			
			if (is1stTime) {
				setTimeout(function () {
					$('.accordion-item').eq(defaultOffice).find('.accordion-item__trigger').click();
				}, 350);
			} else {
				$('.accordion-item__trigger').first().click();
			}
		} else {
			var temp2 = [];
			for (var a = 0; a < dataClone.datalittle.length; a++) {
				var flag = false;
				if (selectedData && selectedData.length > 0) {
					if (dataClone.datalittle[a].code) {
						for (var b = 0; b < dataClone.datalittle[a].code.length; b++) {
							if (selectedData.includes(dataClone.datalittle[a].code[b])) {
								flag = true;
								break;
							}
						}
					}
				} else {
					flag = true;
				}
				if (flag === true) {
					temp2.push(dataClone.datalittle[a]);
					listDetailLocation.push(dataClone.datalittle[a]);
					listLocation.push({
						officeId: dataClone.datalittle[a].officeId,
						office: dataClone.datalittle[a].office,
						coordinate: {
							'lat': dataClone.datalittle[a].lat,
							'lng': dataClone.datalittle[a].lng
						}
					}
					);
				}
			}
			if (temp2.length > 0) {
				dataClone.datalittle = temp2;
				resultCount += temp2.length;
			}
			reloadMarkers();
			resultNumber.append(resultCount + ' results');
			for (var i = 0; i < dataClone.datalittle.length; i++) {
				var tollFreeNumberText = '';
				if (dataClone.datalittle[i].isShowTollFree) {
					tollFreeNumberText = '            <div class="link-icon">' + dataClone.datalittle[i].tollFreeNumberText+'<a href="tel: ' + dataClone.datalittle[i].tollFreeNumber + '">' + dataClone.datalittle[i].tollFreeNumber + '</a></div>';
				}
				var faxNumberText = '';
				if (listDetailLocation[i].isShowFax) {
					faxNumberText = '<div class="link-icon"><i class="icon icon-printer_eps"></i><a href="fax: ' + dataClone.datalittle[i].faxNumber + '">' + dataClone.datalittle[i].faxNumber + '</a></div>\n';
				}
				$($elem).find('.filter-result .row').append('<div class="col-xs-12 col-md-4 margin-bottom-md" code="' + dataClone.datalittle[i].code + '">\n' +
					'    <div class="office-hub bg-light">\n' +
					'        <div class="big-text center-text h3">' + 
					'			<a class="navigation-link" href="' + dataClone.datalittle[i].linkLocation + '">' +
					'				<text class="button-vi-text">' + dataClone.datalittle[i].office + '</text>' + 
					'				<svg class="svg-animation-vi" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg_arrow-button-vi"></use></svg>' + 
					'			</a>' +
					'		 </div>\n' +
					'        <p>' + dataClone.datalittle[i].address + '</p>\n' +
					'        <div class="text-left info-links">\n' +
					'            <div class="link-icon"><i class="icon icon-location"></i><a class="google-map-direction-litle-lot" target="_blank" title="'+ dataClone.datalittle[i].mapUrlTitle +'" href="' + dataClone.datalittle[i].mapUrl + latLngAddToMap + '">' + getdirectiontextlocal + '</a></div>\n' +
					'            <div class="link-icon"><i class="icon icon-phone-new"></i><a href="tel: ' + dataClone.datalittle[i].phoneNo + '">' + dataClone.datalittle[i].phoneNo + '</a></div>\n' + faxNumberText +
					tollFreeNumberText +
					'        </div>\n' +
					'    </div>\n' +
					'</div>');
			}
		}
	};

	init();
};
GT.CheckClosestOffice = function ($elem) {
	navigator.geolocation.getCurrentPosition(function (position) {
		if (position) {
				var lat = position.coords.latitude;
				var lon = position.coords.longitude;
				var $blockValue = $elem.find('#officeCloseToServiceBlockValue');
				var $locationId = $elem.find('#officeCloseToServiceBlockLocationId');
				var $pageId = $elem.find('#officeCloseToCurrentPageId');
				if ($blockValue.length && $locationId.length && $pageId.length) {
					$.get(
						'/LocationService/GetOneOfficeCloseServiceTo',
						{
							locationPage: $locationId.val(),
							locationBannerOfficeCloseBlock: $blockValue.val(),
							language: $('#officeCloseToServiceBlockLanguageBranch').val(),
							currentPageId: $pageId.val(),
							latitude: lat,
							longitude: lon
						}
					).done(function (data) {
						if (data && data !== '') {
							$('#officeCloseToService').html(data);
							var elementToUpdateLatLng = $('#one-office-google-map-direction');
							var newURL = elementToUpdateLatLng.attr('href') + lat + ',' + lon;
							elementToUpdateLatLng.attr('href', newURL);
						}
					});
				}
			}
		},
		function (error) {
			console.log(error);
		},
		{ timeout: 60000 }
	);
};

function CallbackUKSitekeyGReCaptchaInited() {
    const recaptchaUKSitekey = window.gtUkMs365FormConfig?.recaptchaUKSitekey || '';
    if(!recaptchaUKSitekey) return;
    
    document.querySelectorAll(".ms365-form #g-recaptcha").forEach(async captchaContainerElm => {
        const formContainer = captchaContainerElm.closest(".ms365-form");
        captchaContainerElm.innerHTML = "";
        await grecaptcha.render(captchaContainerElm, {
            'sitekey' : recaptchaUKSitekey,
            'callback': function(){
                formContainer.querySelector(".g-recaptcha-response")?.setAttribute("required", "required");
            },
            'expired-callback': function(){
                //make sure the recaptcha is expired
                setTimeout(() => {
                    formContainer.querySelector(".g-recaptcha-response")?.removeAttribute("style");
                    formContainer.querySelector(".g-recaptcha-response")?.setAttribute("required", "required");
                }, 100);
            }
        });
        formContainer.querySelector(".g-recaptcha-response")?.setAttribute("required", "required");
        formContainer.querySelector(".g-recaptcha-response")?.removeAttribute("style");
    });
}

GT.domContentLoadedFncList.push(function () {
    const formContainer = document.querySelector(".ms365-form");
    const isUK = window.gtUkMs365FormConfig?.isUkFirm || false;
    const script_src = 'https://www.google.com/recaptcha/api.js?onload=CallbackUKSitekeyGReCaptchaInited&render=explicit';


    if (formContainer) {
        //after the submitted event, we need to wait for the new form again
        function watchFormSubmitted() {
            GT.waitForElmRendering(".onFormSubmittedFeedback", 86400 * 1000).then(e => {
                watchInitializedDOM(true);
                document.querySelectorAll(".onFormSubmittedFeedback[style]").forEach(containerElm => {
                    containerElm.removeAttribute("style");
                })
                
                document.querySelector(".onFormSubmittedFeedback")?.scrollIntoView({ behavior: "smooth", block: "center" });
            });
        }

        // wait for the new form to be initialized, then strip the inline style and watch the submitted event
        function watchInitializedDOM(isReInit) {
            GT.waitForElmRendering(".marketing-field", 86400 * 1000).then(e => {

                //Remove inline style for MS-365 form    
                document.querySelectorAll(".ms365-form form").forEach(containerElm => {
                    containerElm.querySelectorAll("[style]").forEach(formFieldElm => {
                        if (!formFieldElm.closest('[data-editorblocktype="Text"]'))
                            formFieldElm.removeAttribute("style");
                    })
                    containerElm.querySelectorAll("style").forEach(styleElm => {
                        styleElm.remove();
                    })


                    containerElm.querySelectorAll("input,textarea,select").forEach(item => {
                        item.addEventListener("focus", e => {
                            const currentElm = e.target
                            if (currentElm.getBoundingClientRect().top < GT.headerElmHeight) {
                                currentElm.scrollIntoView({ behavior: "smooth", block: "start" });
                                if(currentElm.closest('.error')) {
                                    // Chromium based browsers bug!
                                    // Lose error message when scrolling to the field
                                    setTimeout(() => {
                                        currentElm.reportValidity();
                                    }, 500);
                                }
                            }
                        })
                    })
                })

                GT.ExternalFormV2Label && GT.ExternalFormV2Label();
                watchFormSubmitted();
                if (isReInit && formContainer.querySelector("#g-recaptcha") && typeof onloadCallback != "undefined") {
                    onloadCallback();
                }
            });
        }

        watchInitializedDOM();
    }

    function validateInputs(form) {
        form.querySelectorAll('[required]').forEach(input => {
            if(input.isAddedEvent) return;
            input.isAddedEvent = true;
            input.addEventListener('change', (e) => {
                const parentBlock = input.closest('[data-required="required"]');
                if (!input.checkValidity()) {
                    parentBlock?.classList.add('error');
                } else {
                    parentBlock?.classList.remove('error');
                }
            });
        });
    }

    function mktFormStyleInit(form) {
        form.querySelectorAll("[style]").forEach(formFieldElm => {
            if (formFieldElm.closest('[data-editorblocktype="SubmitButton"]')) {
                formFieldElm.removeAttribute("style");
                formFieldElm.removeAttribute("align");
            }
        })

        form.querySelectorAll("style").forEach(styleElm => {
            styleElm.remove();
        })

        const selectors = [
            ':scope > div',
            '.wrap-section',
            '.columnContainer',
            '[data-editorblocktype="Text"]',
            '[data-editorblocktype="Text"] p',
            '[data-editorblocktype="Text"] span',
            '[data-editorblocktype="Text"] a',
            '.consentBlock',
            'label',
            'label span',
            'input[type="tel"]'
        ].join(', ');
        form.querySelectorAll(selectors).forEach(divElm => {
            divElm.removeAttribute("style");
        })
        form.closest(".ms365-form")?.querySelectorAll("style").forEach(styleElm => {
            styleElm.remove();
        })


        form.querySelectorAll("input,textarea,select").forEach(item => {
            item.addEventListener("focus", e => {
                const currentElm = e.target
                if (currentElm.getBoundingClientRect().top < GT.headerElmHeight) {
                    currentElm.scrollIntoView({ behavior: "smooth", block: "start" });
                    if(currentElm.closest('.error')) {
                        // Chromium based browsers bug!
                        // Lose error message when scrolling to the field
                        setTimeout(() => {
                            currentElm.reportValidity();
                        }, 500);
                    }
                }
            })
        })

        let radioContactChoice = form.querySelectorAll('.radiobuttons input[type="radio"]');
        if(isUK) {
            radioContactChoice = form.querySelectorAll('.radiobuttons input[type="radio"], select:has(option[value="call"], option[value="phone"])');
            form.closest(".ms365-form")?.classList.add('uk-form');
            if(!document.querySelector('script[src^="'+ script_src +'"]')) {
                let script = document.createElement('script');

                script.src = script_src;
                script.defer = "defer";
                document.head.append(script);
            }
        }

        function togglePhoneInput(inputElm) {
            const inputValue = inputElm.value;
            const currentForm = inputElm.closest("form");
            const telInput = currentForm.querySelector("input[type=tel]");
            const dateInput = currentForm.querySelector("input[type=datetime-local]");
            
            const show = inputValue?.toLowerCase().includes('call') || inputValue?.toLowerCase().includes('phone');
            show ? telInput?.setAttribute('required', 'required') : telInput?.removeAttribute('required');
            show ? dateInput?.setAttribute('required', 'required') : dateInput?.removeAttribute('required');
            validateInputs(currentForm);
        }

        radioContactChoice.forEach(radioInput => {
            togglePhoneInput(radioInput);
            radioInput.addEventListener('change', e => togglePhoneInput(e.target));
        });


        GT.ExternalFormV2Label && GT.ExternalFormV2Label();
        watchFormSubmitted();

        validateInputs(form);

        function validateCheckboxGroup(multiOptionBlock) {
            
            if (multiOptionBlock.querySelector('input[type="checkbox"]:checked')) {
                multiOptionBlock.classList.remove('error');
            } else {
                multiOptionBlock.classList.add('error');
            }
        }

        form.querySelectorAll('.multiOptionSetFormFieldBlock').forEach(multiOptionBlock => {
            const checkboxes = multiOptionBlock.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    validateCheckboxGroup(multiOptionBlock);
                });
            });
        });

        const submitButton = form.querySelector('button[type="submit"]');
        submitButton.addEventListener('click', (e) => {
            const requiredInputs = form.querySelectorAll('[required]');
            
            requiredInputs.forEach(input => {
                const parentBlock = input.closest('[data-required="required"]');
                if (!input.checkValidity()) {
                    parentBlock?.classList.add('error');
                } else {
                    parentBlock?.classList.remove('error');
                }
            });

            form.querySelectorAll('.multiOptionSetFormFieldBlock').forEach(multiOptionBlock => {
                validateCheckboxGroup(multiOptionBlock);
            });
        });

        if (formContainer.querySelector("#g-recaptcha") && typeof onloadCallback != "undefined") {
            onloadCallback();
        }
    }

    document.addEventListener("d365mkt-afterformload", (event) => {
        const form = event.target.querySelector("form");
        mktFormStyleInit(form);
    });
});
GT.Maps = function(){
    let currentLocations = [],
        mapElm = document.getElementById('location');
    
    function autoZoomFnc() {
        if(!mapElm || typeof mapConfig == "undefined")
            return;
        if(mapConfig.boundCoordinates) {
            let GLOBE_WIDTH = 256, // a constant in Google's map projection
                angle = mapConfig.boundCoordinates.startLat - mapConfig.boundCoordinates.endLat;
    
            if (angle < 0) {
                angle += 360;
            }

            let zoomByHeight = Math.log(mapElm.offsetHeight * 360 / angle / GLOBE_WIDTH) / Math.LN2;

            angle = mapConfig.boundCoordinates.startLng - mapConfig.boundCoordinates.endLng;
            if (angle < 0) {
                angle += 360;
            }

            let zoomByWidth = Math.log(mapElm.offsetWidth * 360 / angle / GLOBE_WIDTH) / Math.LN2;

            mapConfig.oldMapZoomLevel = mapConfig.mapZoomLevel;
            mapConfig.mapZoomLevel = zoomByHeight > zoomByWidth ? zoomByWidth : zoomByHeight;

            if(map) {
                map.setZoom(mapConfig.mapZoomLevel);
            }
        }
    }

    function initMap() {

        if(!mapElm || typeof mapConfig == "undefined")
            return;

        if (mapConfig.mapZoomLevelMobile && GT.wWidth < 768) {
            mapConfig.mapZoomLevel = mapConfig.mapZoomLevelMobile;
        }
        autoZoomFnc();

        if (isNaN(mapConfig.mapZoomLevel) || mapConfig.mapZoomLevel <= 0)
            mapConfig.mapZoomLevel = -1;

        if(parseFloat(mapConfig.defaultCenter.lat) == 0 && locations.length) {
            mapConfig.defaultCenter = locations[0];
        }

        mapConfig.defaultCenter.lat = parseFloat(mapConfig.defaultCenter.lat);
        mapConfig.defaultCenter.lng = parseFloat(mapConfig.defaultCenter.lng);
        map = new google.maps.Map(mapElm, {
                mapTypeControl: mapConfig.mapTypeControl || false,
                streetViewControl: mapConfig.streetViewControl || false,
                fullscreenControl: mapConfig.fullscreenControl || false,
                zoomControl: mapConfig.zoomControl || false,
                gestureHandling: mapConfig.gestureHandling || "none",
                zoom: mapConfig.mapZoomLevel,
                center: mapConfig.defaultCenter,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            });

   
        if(mapConfig.defaultCenterAsMaker)
            locations.unshift(mapConfig.defaultCenter);

        locations.forEach(function(element, idx) {
            locations[idx].lat = parseFloat(element.lat);
            locations[idx].lng = parseFloat(element.lng);
        });
        setMarkers(locations);
    }

    function setMarkers(locations) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < locations.length; i++) {
            let cur_location = locations[i],
                markerObj = {
                    position: cur_location,
                    icon: {
                        url: '/dist/icons/' + (mapConfig.markerIcon ? mapConfig.markerIcon : (i == 0 && mapConfig.makeDiff ? 'marker' : "marker-white")) +'.svg',
                        scaledSize: new google.maps.Size(50, 50),
                    },
                    map: map,
                    optimized: false
                };

            if(mapConfig.makeDiff && i == 0) {
                markerObj.zIndex = 999;
            }

            let marker = new google.maps.Marker(markerObj);

            if (mapConfig.mapZoomLevel === -1)
                bounds.extend(marker.position);
            
            if(mapConfig.callbackWhenClickingOnMarker)
                marker.addListener('click', function (e) {
                    mapConfig.callbackWhenClickingOnMarker(e, cur_location);
                });
            // Push marker to markers array
            currentLocations.push(marker);
        }
        if (mapConfig.mapZoomLevel === -1)
            map.fitBounds(bounds);
    }


    initMap();
    GT.windowResizeFncList.maps = autoZoomFnc;
}


GT.domContentLoadedFncList.push(function () {
    GT.Maps();
});
GT.MarketoEmbedForms = function () {
    let lang = document.querySelector("html").lang,
        script_src = 'https://www.google.com/recaptcha/api.js?onload=CallbackGReCaptchaInited&render=explicit' + (lang ? '&hl=' + lang : ""),
        gReCaptchaPubKey = document.querySelector(".g-recaptcha-key");

    if (typeof MktoForms2 !== 'undefined') {

        let mkForms = document.querySelectorAll(".marketo-embed-form form"),
            filteredIDList = [],
            filteredList = [],
            filteredConfigList = [];

        mkForms.forEach(function(elm, idx) {
            let existedID;
            filteredIDList.forEach(function(idArr, idxArr){
                if(idArr.indexOf(elm.id) >= 0) {
                    existedID = elm.id;
                    idArr.push(elm.id);
                    filteredList[idxArr].push(elm);
                    filteredConfigList[idxArr].push(marketoConfig[idx]);
                }
            })
            if(!existedID) {
                filteredIDList.push([elm.id]);
                filteredList.push([elm]);
                filteredConfigList.push([marketoConfig[idx]]);
            }
        })

        filteredIDList.forEach(function(idArr, idxArr){
            let currentList = filteredList[idxArr];
            renderMkForm(currentList, filteredConfigList[idxArr], currentList.length);
        })

        function renderMkForm(mkElmArr, mkConfigArr, listLength, countForm) {
            if(!countForm)
                countForm = 0;

            let mkForm = mkElmArr[countForm],
                renderMkFormFnc = mkConfigArr[countForm];
            mkForm.id = mkForm.id.replace("__", "_");

            renderMkFormFnc(function(form){
                mkForm.id = mkForm.id.replace("_", "__" + countForm);
                GT.marketoElm = new GT.MarketoEmbedForm(mkForm, form, script_src, gReCaptchaPubKey);
                countForm++;
                if(countForm < listLength){
                    renderMkForm(mkElmArr, mkConfigArr, listLength, countForm);
                }
            });
        }
    }
};

GT.MarketoEmbedForm = function (mkFormElm, form, script_src, gReCaptchaPubKey) {
    let _this = this;
    _this.formElement = mkFormElm;
    let container = _this.formElement.closest(".marketo-embed-form");
    let _iOS = GT.isIOS();
    let _isMobile = GT.isMobileCached;

    _this.isStripCss = container.dataset.stripCss;
    _this.container = container;
    _this.campaignGAClass = 't33-campaign-page-form-submit';
    _this.isHomepageBlock = document.querySelector('.homepagecontactblock');
    _this.enableFeatureFlag = container.dataset.enableFeatureFlag;

    if (_this.formElement) {
        form.submittable(false);
        form.onValidate(function(builtInValidation) {
            let recaptchaResponseElm = _this.formElement.querySelector(".g-recaptcha-response"),
                recaptchaContainerElm = _this.formElement.querySelector(".g-recaptcha-container"),
                isReCaptchaOK = true,
                lastRecaptchaUserInput = _this.formElement.querySelector("input[name=lastRecaptchaUserInput]");

            if (recaptchaResponseElm && lastRecaptchaUserInput) {
                lastRecaptchaUserInput.value = recaptchaResponseElm.value;

                let recaptchaMsgMkto = recaptchaContainerElm.querySelector(".captcha-error");
                if(recaptchaMsgMkto)
                    recaptchaMsgMkto.remove();

                if(lastRecaptchaUserInput.value.trim().length == 0) {
                    isReCaptchaOK = false;
                    recaptchaContainerElm.insertAdjacentHTML("beforeend", "<div class='captcha-error'>" + recaptchaRequireMessage + "</div>");
                }
            } 

            if (!builtInValidation || !isReCaptchaOK) {
                
                setTimeout(() => {
                    let errorMsgLabel = _this.formElement.querySelector(".mktoErrorMsg")?.closest(".mktoFormRow")?.querySelector(".mktoLabel")?.innerText;
                    if(errorMsgLabel) {
                        errorMsgLabel = errorMsgLabel.replace(/[\*|:|\n]/gm, "");
                    }

                    dataLayer.push({
                        "event": "marketoError",
                        "errorMessage": errorMsgLabel || (!isReCaptchaOK ? "ReCaptcha" : ""),
                        "marketoID": form.getId(),
                        "marketoMunchkinId": _this.formElement.querySelector('[name=munchkinId]')?.value || ""
                    });
                }, 500)

                return;
            }
            form.submittable(true);
        })

        form.onSuccess(function (values, followUpUrl) {
            if (container.dataset.displaySuccessMsg === "true") {
                let successMessage = container.querySelector('.success-msg');
                if (successMessage) {
                    _this.formElement.remove();
                    successMessage.style.display = "block";
                    window.scrollTo(0, GT.getElementOffset(successMessage).top - GT.wHeight/2);
                    dataLayer.push({
                        "event": "contactForm",
                        "eventAction": 'form submission',
                        "marketo.form_id": _this.formElement.id,
                        "marketo.form_values": values,
                        "marketo.follow_up_url": followUpUrl
                    });
                    return false;
                }
            }
        });


        let lastRecaptchaUserInput = _this.formElement.querySelector("input[name=lastRecaptchaUserInput]");
        if(lastRecaptchaUserInput && gReCaptchaPubKey) {

            if(!document.querySelector('script[src^="'+ script_src +'"]')) {
                let script = document.createElement('script');

                script.src = script_src;
                script.defer = "defer";
                document.head.append(script);
            }

            let captchaContainer = _this.formElement.querySelector(".g-recaptcha-container");
            if(!captchaContainer) {
                _this.formElement.querySelector("button[type=submit].mktoButton").insertAdjacentHTML("beforebegin", "<div class='g-recaptcha-container'></div>");
                captchaContainer = _this.formElement.querySelector(".g-recaptcha-container");
            }
            
            if(captchaContainer && !captchaContainer.innerHTML) {
                GT.RecaptchaCallbackFnList["marketoEmbedForm" + _this.formElement.id] = {fnc: null, isExecuted: false};
                GT.RecaptchaCallbackFnList["marketoEmbedForm" + _this.formElement.id].fnc = function(){
                    try{
                        setTimeout(function() {
                            grecaptcha.render(captchaContainer, {
                                'sitekey' : gReCaptchaPubKey.dataset.sitekey.trim(),
                                'callback': function(){
                                    let recaptchaMsgMkto = elm.querySelector(".captcha-error");
                                    if(recaptchaMsgMkto)
                                        recaptchaMsgMkto.remove();
                                }
                            });
                        }, 500)
                    } catch(ex){
                        console.log(ex);
                    }
                }

                if(typeof grecaptcha != "undefined") {
                    console.log("inited captcha", grecaptcha);
                    CallbackGReCaptchaInited();
                }
            }
            lastRecaptchaUserInput.closest(".mktoFieldDescriptor").classList.add("hide");
            lastRecaptchaUserInput.classList.remove("mktoRequired");
            lastRecaptchaUserInput.removeAttribute("aria-required");
            lastRecaptchaUserInput.type = "hidden";
        }

        if (_this.stripCss) {
            _this.stripCss();
            window.addEventListener("resize", function(){
                _this.stripCss();
            });
        }
        
        _this.addGaClass();

        function modifyStyle(doStripCss) {
            if (doStripCss && _this.stripCss)
                _this.stripCss();

            _this.addClassTocheckboxes();
            _this.addClassToRadio();
            _this.addClassToSelect();
            _this.addFloatingClass();
        }

        modifyStyle();


        //========= DETECT FORM's ELEMENTS CHANGE
        let gtHelper = new GTHelper();
        gtHelper.detectDOMChange(_this.formElement, function(mutations){
            modifyStyle(true);
        })
    }
};

GT.MarketoEmbedForm.prototype.addGaClass = function () {
    let _this = this;
    let submitBtn = document.querySelectorAll('#' + _this.formElement.id + ' .mktoButtonRow button[type="submit"]')[0];
    if (submitBtn && document.querySelector('.campaign-page')) {
        submitBtn.classList.add(_this.campaignGAClass);
    }
};

GT.MarketoEmbedForm.prototype.stripCss = function () {
    let _this = this,
        successMessage = document.querySelector('.marketo-embed-form .success-msg');
    if (_this.isStripCss || _this.isHomepageBlock) {
        let childElements = document.querySelectorAll('#' + _this.formElement.id + ' *');
        for (let i = 0; i < childElements.length; i++) {
            childElements[i].removeAttribute('style');
        }
        let dom = document.querySelectorAll('#' + _this.formElement.id);
        for (let i = 0; i < dom.length; i++) {
            dom[i].removeAttribute('style');
        }
        let styles = document.querySelectorAll('#' + _this.formElement.id + ' style');
        for (let i = 0; i < styles.length; i++) {
            styles[i].remove();
        }

        //remove the custom style for MKto form
        let mktoStyleLoadedID;
        document.querySelectorAll("style").forEach(item => {
            if(item.textContent.includes("#mktoStyleLoaded "))
                mktoStyleLoadedID = item;
        });

        const mktoCustomStyleElm = mktoStyleLoadedID.nextElementSibling;
        if(mktoCustomStyleElm && mktoCustomStyleElm.textContent.includes(".mktoForm")) {
            mktoCustomStyleElm.remove();
        }
        
        if (_this.isHomepageBlock && successMessage)  // //run only on homepage mkt form
            successMessage.style.removeProperty('padding');
    }
};

//remove extra checkbox label to meet WCAG
GT.MarketoEmbedForm.prototype.modifyCheckboxLabel = function () {
    let _this = this,
        checkboxes = _this.formElement.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach(function(element){
        if(!element.dataset.initializedCheckboxLabel) {
            element.dataset.initializedCheckboxLabel = true;
            _this.formElement.querySelectorAll('label[for="' + element.name + '"]').forEach(function(labelEl){
                if (labelEl.classList.contains('mktoLabel')) {
                    labelEl.setAttibute("for", labelEl.getAttribute("for") + "2");
                    labelEl.classList.add("mktoExtraLabel");
                    labelEl.style.display = "inline-block";
                } else {
                    labelEl.innerHTML = '<span class="hidden">' + element.name + '</span>';
                }
            });
        }
    })
};

//check if the field label is empty or only has an asterisk 

GT.MarketoEmbedForm.prototype.addEmptyLabelClass = function(fieldWrap) {
    const fieldLabel = fieldWrap.querySelector('.mktoLabel');
    
    if (fieldLabel.textContent.trim() === '' || fieldLabel.textContent.trim() === '*') {
        fieldLabel.classList.add('mktoLabel--empty-text');
        fieldWrap.classList.add('mktoFieldWrap--empty-label');
    }
    
}

GT.MarketoEmbedForm.prototype.addClassTocheckboxes = function () {
    let _this = this;
    let form = _this.formElement;
    let checkboxes = form.querySelectorAll('.mktoCheckboxList');
    
    checkboxes.forEach(function(element) {
        if(!element.dataset.initializedCheckbox) {
            element.dataset.initializedCheckbox = true;
            let wrapper = element.closest('.mktoFieldWrap');
            let isMulticheckboxes = element.querySelectorAll('input').length > 1;

            wrapper.classList.add('mktoCheckboxWrapper');
            _this.modifyFieldID(wrapper, _this.formElement);

            if (isMulticheckboxes) {
                wrapper.classList.add('mktMultiCheckboxes');
            } else {
                wrapper.classList.add('mktSingleCheckbox');
            }
            _this.addEmptyLabelClass(wrapper);
        }
    })
};
GT.MarketoEmbedForm.prototype.addIconToSelect = function () {
    this.formElement.querySelectorAll("select").forEach(function(element){
        if(!element.dataset.initializedSelectIcon) {
            element.dataset.initializedSelectIcon = true;
            let parentElement = element.parentElement;
            if(parentElement.querySelector('.custom-selection-icon')) {
                parentElement.insertAdjacentHTML("beforeend", '<div class="custom-selection-icon"></div>');
            }
        }
    })
};

GT.MarketoEmbedForm.prototype.addIconToRadio = function () {
    this.formElement.querySelectorAll(".mktoRadioList").forEach(function(element){
        if(!element.dataset.initializedRadioIcon) {
            element.dataset.initializedRadioIcon = true;
            if(element.querySelector('input')) {
                element.parentElement.classList.add("mktMultiRadios");
                element.querySelector('label').insertAdjacentHTML("afterbegin", '<span class="icon"></span>');
            }
        }
    })
};

GT.MarketoEmbedForm.prototype.addClassToRadio = function () {
    let _this = this;
    let form = _this.formElement;
    let checkboxes = form.querySelectorAll('.mktoRadioList');
    
    checkboxes.forEach(function(element) {
        if(!element.dataset.initializedRadio) {
            element.dataset.initializedRadio = true;
            let wrapper = element.closest('.mktoFieldWrap');
            wrapper.classList.add('mktoRadioWrapper');
            _this.modifyFieldID(wrapper, _this.formElement);
        }
    })
};

GT.MarketoEmbedForm.prototype.addClassToSelect = function () {
    let _this = this;
    let form = _this.formElement;
    let selects = form.querySelectorAll('select.mktoField');
    
    selects.forEach(function(element) {
        if(!element.dataset.initializedSelect) {
            element.dataset.initializedSelect = true;
            let wrapper = element.closest('.mktoFieldWrap');
            wrapper.classList.add('mktoSelectWrapper');
            if(element.multiple) {
                wrapper.classList.add('mktoSelectWrapper--multiple');
            }
        }
    })
};

GT.MarketoEmbedForm.prototype.modifyFieldID = function(fieldWrap, formElement) {
    fieldWrap.querySelectorAll("*").forEach(function(elm){
        if(elm.id && elm.id != "lastRecaptchaUserInput")
            elm.id += formElement.id;
        
        const forAttr = elm.getAttribute("for");
        if(forAttr)
            elm.setAttribute("for", forAttr + formElement.id);
    })
}

GT.MarketoEmbedForm.prototype.addFloatingClass = function() {
    let _this = this;
    let form = _this.formElement;

    function errorClassHandle(field) {
        let wrapper = field.closest('.mktoFieldWrap');
        if (field.classList.contains('mktoInvalid') && wrapper.querySelector('.mktoError')) {
            wrapper.classList.add('error');
        } else {
            wrapper.classList.remove('error');
        }
    }
    function filledClassHandle(item) {
        let parent = item.closest('.mktoFieldWrap');
        if (item.value.length) {
            parent.classList.add('filled');
        } else {
            parent.classList.remove('filled');
        }
    }
    function addLabelTitle(field) {
        let parent = field.closest('.mktoFieldWrap');
        let label = parent.querySelector('.mktoLabel');
        const labelContent = label?.textContent.trim();
        if(labelContent.length > 0) {
            label.setAttribute("title", labelContent);
            field.setAttribute("title", labelContent);
        }
        _this.addEmptyLabelClass(parent);
    }
        
    let inputFields = form.querySelectorAll('.mktoTextField, .mktoEmailField, .mktoTelField, .mktoDateField, select, textarea');

    if (inputFields) {
        inputFields.forEach(function(element) {
            let fieldWrap = element.closest('.mktoFieldWrap');

            if(fieldWrap) {
                // element.dataset.initializedFloatingStyle = true;
                fieldWrap.classList.add('floating-label');
                _this.modifyFieldID(fieldWrap, _this.formElement);
                
                errorClassHandle(element);
                
                addLabelTitle(element);

                setTimeout(function() {
                    filledClassHandle(element);
                }, 1000)
                
                element.addEventListener('focusin', function(e) {
                    errorClassHandle(e.target);
                    fieldWrap.classList.add('focus');
                })
                element.addEventListener('focusout', function(e) {
                    errorClassHandle(e.target);
                    fieldWrap.classList.remove('focus');
                })
                element.addEventListener('change', function(e) {
                    filledClassHandle(e.target);
                
                    setTimeout(function() {
                        errorClassHandle(e.target);
                    }, 1000)
                })
            }
        });
    }
}

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.MarketoEmbedForms();
    });
////////////////////////////
// GT CAROUSELS FUNCTIONS //
////////////////////////////

GT.MediaCarousel = function ($elem) {

    var me = this;

    me.tabNavigation = function ($tabContent, $tabItems) {
        var $tabHead = $elem.find('.tab-drawer-heading');

        // if in tab mode
        $tabItems.click(function (e) {
            var $tabItem = $(this);
            var _activeTab = $tabItem.attr('data-tab');

            if ($tabItem.parent().hasClass('active')) {
                return false;
            }
            $tabContent.hide();
            $('#' + _activeTab).fadeIn();

            $tabItems.parent().removeClass('active');
            $tabItem.parent().addClass('active');

            $tabHead.removeClass('d-active');
            $tabHead.each(function () {
                var $tHead = $(this);
                if ($tHead.attr('data-tab') === _activeTab) {
                    $tHead.addClass('d-active');
                }
            });

            return false;
        });

        // if in drawer mode
        $tabHead.click(function (e) {
            e.preventDefault();
            var $tabHeader = $(this),
                dActiveTab = $tabHeader.attr('data-tab'),
                offset = $tabHeader.offset();

            if ($tabHeader.hasClass('d-active')) {
                $tabHeader.removeClass('d-active');
                $('#' + dActiveTab).slideUp('slow');
            } else {
                $tabContent.slideUp('slow');
                $('#' + dActiveTab).slideDown('slow', function () {
                    $tabHead.removeClass('d-active');
                    $tabHeader.addClass('d-active');
                    //add scrolltop function here
                    offset = $tabHeader.offset();
                    offset.left -= 20;
                    offset.top -= 50;

                    $tabItems.parent().removeClass('active');
                    $tabItems.each(function () {
                        if ($(this).attr('data-tab') === dActiveTab) {
                            $(this).parent().addClass('active');
                        }
                    });
                });
            }
        });
    };

    me.adjustItems = function () {
        var $tabItems = $elem.find('ul.tabs li .tab-link'),
            $tabContent = $elem.find('.tab-content');

        var highest = 0;

        $tabContent.each(function (index) {
            if (highest < $(this).height()) {
                highest = $(this).height();
            }
        });

        itemCount = $tabItems.length,
            newHeight = highest / itemCount;

        $tabItems.css({ 'min-height': newHeight });

        var $tabs = $elem.find('ul.tabs');

        $('.page-promo-item').each(function () {
            if ($(this).height() < $tabs.height()) {
                $(this).css({ 'min-height': $tabs.height() });
            }

        })
    }

    me.init = function () {

        var $tabItems = $elem.find('ul.tabs li .tab-link'),
            $tabContent = $elem.find('.tab-content');

        $tabContent.hide();
        $tabContent.first().show();

        me.tabNavigation($tabContent, $tabItems);

        //equalize list-item heights with tabContent
        me.adjustItems();

        $(window).on('resize', function () {
            me.adjustItems();
        });
    };

    me.init();
};

GT.OfficeBanner = function ($element) {
    $(window).resize(function () {
        handleResize();
    });
    function handleResize() {
        var bannerBgColorClasses = ["purple","orange","green","teal","white","transparent"];
        var $bannerContainer = $element.find('.container .title');
        var $me = $element.find('.ww');
        var $extraClass = null;

        if ($bannerContainer.length > 0 && $me.length > 0) {
            for (var i = 0; i < bannerBgColorClasses.length; i++) {
                if ($bannerContainer.hasClass(bannerBgColorClasses[i]) || $me.hasClass(bannerBgColorClasses[i])){
                    $extraClass = bannerBgColorClasses[i];
                break;
              }
            }

            if (screen.width <= 767) {
                $bannerContainer.removeClass($extraClass);
                $me.addClass($extraClass);
            } else {
                $me.removeClass($extraClass);
                $bannerContainer.addClass($extraClass);
            }
        }
    }
    handleResize();
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        new GT.OfficeBanner($('.office-banner'));
    });
GT.OnPageNavigation = function () {
    const htmlElm = document.firstElementChild;
    const CLASSES = {
        ON_PAGE_NAV: ".onpage-navigation",
        ON_PAGE_NAV_CONT: ".onpage-navigation__container",
        EXPAND_BTN: ".onpage-navigation__expand",
        CLOSE_BTN: ".onpage-navigation__close",
        CURRENT_ITEM: ".onpage-navigation__current",
        LINK_ITEMS: ".onpage-navigation__link",
        OUT_VIEWPORT: "out-viewport",
        EXPANDED: "expanded",
        SHOW_OVERLAY: "showing-overlay",
        SHOW_ONPAGE_NAVIGATION: "showing-onpage-navigation"
    }
    const onPageNav = document.querySelector(CLASSES.ON_PAGE_NAV);
    if (!onPageNav) return;
    const expandedBtn = onPageNav.querySelector(CLASSES.EXPAND_BTN);
    const currentItem = onPageNav.querySelector(CLASSES.CURRENT_ITEM);
    const closeBtn = onPageNav.querySelector(CLASSES.CLOSE_BTN);
    const linkItems = onPageNav.querySelectorAll(CLASSES.LINK_ITEMS);

    let isExpandedBtnFocusable = true;

    init();

    function closeOnPageNav() {
        onPageNav.classList.remove(CLASSES.EXPANDED);
        htmlElm.classList.remove(CLASSES.SHOW_OVERLAY);
        GT.disableDetectScrollUpOrDown = false;
        if (!GT.isDesktopView()) {
            setLinkTabindex();
            setRole(false);
            if (isExpandedBtnFocusable) {
                expandedBtn?.focus();
            }
        }
    }

    function setActiveNavItem(id) {
        const activeLink = htmlElm.querySelector('.onpage-navigation__link[href^="#' + id + '"]');
        if (!activeLink) return;
        if(!htmlElm.classList.contains("animating")) {
            htmlElm.querySelectorAll('.onpage-navigation__link').forEach(link => link.classList.remove('active'));
            activeLink.classList.add("active");
            currentItem.innerHTML = activeLink.getAttribute("title");
            window.location.hash = activeLink.hash;
        }
        currentItem.classList.add("active");
    }

    function isElementInViewport(el) {
        const elmOffset = GT.getElementOffset(el).top;
        const scrollTop = GT.lastScrollTop;
        const viewportHeight = GT.wHeight;
        const upperBound = elmOffset < scrollTop + viewportHeight / 2;
        const lowerBound = elmOffset + el.clientHeight - (viewportHeight / 4) > scrollTop;
        
        return upperBound && lowerBound;
    }

    function needToScrollDirection(el) {
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (rect.top < 0) {
            return 'up';
        } else if (rect.bottom > windowHeight) {
            return 'down';
        } else {
            return 'in view';
        }
    }

    function menuActiveTracking() {
        handleNavPosition();
        let sections = htmlElm.querySelectorAll("[data-block-id], .text-area__contents a[id]");
        let isAnimating = htmlElm.classList.contains("animating");
        if(!isAnimating)
            currentItem.classList.remove("active");

        let set = false;
        sections.forEach((section, index) => {
            let blockIdDataSet = section.dataset.blockId;
            let id = blockIdDataSet || section.id;

            if ((isElementInViewport(section)) && !set) {
                setActiveNavItem(id);
                set = true;
            } else if(!isAnimating) {
                htmlElm.querySelector('.onpage-navigation__link[href^="#' + id + '"]')?.classList.remove("active");
            }
        });
    }

    function hasMenuV3() {
        return htmlElm.classList.contains("has-menu-v3");
    }

    function handleNavPosition() {
        const targetOffset = GT.getElementOffset(onPageNav).top - (GT.isScrollingUp ? GT.headerElmHeight : (hasMenuV3() ? 0 : GT.mainHeaderElmHeight));
        const isDesktopView = GT.isDesktopView();

        if (hasMenuV3()) {
            
            if (GT.lastScrollTop > targetOffset) {
                onPageNav.classList.add("visible");
                htmlElm.classList.add(CLASSES.SHOW_ONPAGE_NAVIGATION);
            } else {
                if (GT.lastScrollTop < onPageNav.offsetTop - onPageNav.clientHeight && isDesktopView) {
                    onPageNav.classList.remove("visible");
                    htmlElm.classList.remove(CLASSES.SHOW_ONPAGE_NAVIGATION);
                }
            }

        } else {
            if (GT.lastScrollTop > targetOffset) {
                onPageNav.classList.add("visible");
                htmlElm.classList.add(CLASSES.SHOW_ONPAGE_NAVIGATION);
            } else if(isDesktopView) {
                onPageNav.classList.remove("visible");
                htmlElm.classList.remove(CLASSES.SHOW_ONPAGE_NAVIGATION);
            }
        }
    }

    function getIdFromHash(hash) {
        const delimiter = "____";
        const hrefArr = hash.split("#");
        return hrefArr[1]?.split(delimiter)[0];
    }

    function scrollIntoView(href) {
        const id = getIdFromHash(href);
        const scrollTarget = document.querySelector(`[data-block-id="${id}"], .text-area__contents [id="${id}"]`);
        if (!scrollTarget) return;
        let scrollDirection = needToScrollDirection(scrollTarget);
        let targetOffsetTop = GT.getElementOffset(scrollTarget).top;
        let scrollOffset = targetOffsetTop - GT.headerElm.clientHeight - onPageNav.clientHeight - 16;
        

        if (hasMenuV3()) {
            scrollOffset = targetOffsetTop - onPageNav.clientHeight - 16;
            if (scrollDirection != "down") {
                scrollOffset -= GT.headerElm.clientHeight + 32;
            }

        }

        setActiveNavItem(id);
        GT.preventOpeningMenu(1000);
        window.scrollTo(0, scrollOffset);
    }

    function setLinkTabindex(set = true) {
        linkItems.forEach(item => {
            if (set) {
                item.setAttribute("tabindex", "-1");
                item.setAttribute("aria-hidden", "true");
            } else {
                item.removeAttribute("tabindex");
                item.removeAttribute("aria-hidden");
            }
        });
    }

    function setRole(set = true) {
        if(GT.isDesktopView()) {
            onPageNav.setAttribute("role", "navigation");
            onPageNav.removeAttribute("aria-modal");
            onPageNav.removeAttribute("aria-label");
            currentItem.removeAttribute("aria-hidden");
        } else {
            onPageNav.setAttribute("role", "dialog");
            onPageNav.setAttribute("aria-modal", set);
            onPageNav.setAttribute("aria-label", onPageNav.dataset.label);
            expandedBtn.setAttribute("aria-label", onPageNav.dataset.label);
            currentItem.setAttribute("aria-hidden", "true");
        }
    }

    function init() {
        if (!GT.isDesktopView()) {
            setLinkTabindex();
        }
        setRole(false);
        expandedBtn?.addEventListener("click", () => {
            onPageNav.classList.add(CLASSES.EXPANDED);
            GT.disableDetectScrollUpOrDown = true;
            GT.lockScrollBehindOverlay(CLASSES.ON_PAGE_NAV_CONT);
            htmlElm.classList.add(CLASSES.SHOW_OVERLAY);
            setLinkTabindex(false);
            setRole(true);
            closeBtn?.focus();
        })
        closeBtn?.addEventListener("click", () => {
            closeOnPageNav();
        })

        GT.listFunctionsTriggerInScrollEvent.onPageNav = () => {
            if(htmlElm.classList.contains("opening-megamenu")) return;
            menuActiveTracking();
        };

        htmlElm.querySelectorAll(CLASSES.LINK_ITEMS).forEach(item => {
            item.addEventListener("click", e => {
                const targetElm = e.target;
                e.preventDefault();
                if(!targetElm.classList.contains("active")) {
                    GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                    closeOnPageNav();
                    scrollIntoView(targetElm.href);
                    isExpandedBtnFocusable = true;
                }
            })
        })

        if(location.hash) {
            isExpandedBtnFocusable = false;
            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
            const activeItem = document.querySelector(".onpage-navigation__link[href='" + location.hash + "']");
            if(activeItem) {
                menuActiveTracking();
                setTimeout(() => {
                    activeItem.click();
                }, 300)
            }
        }
        
        if(!GT.isDesktopView()) {
            setTimeout(() => {
                htmlElm.classList.add(CLASSES.SHOW_ONPAGE_NAVIGATION);
                onPageNav.classList.add("visible");
            }, 300);
        }
    }

    return {
        closeOnPageNav
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.OnPageNavigation = GT.OnPageNavigation();
    });
///////////////////////////
// GT OVERLAYS FUNCTIONS //
///////////////////////////

function GTOverlays() {

    var me = this;
    var lastFocusElement;

    this.calculateOverlayH = function ($container, screenH, overlayH) {
        var offSetH = 0;
        $container.removeClass("full-height");
        if (overlayH > screenH) {
            $container.addClass("full-height");
        } else {
            offSetH = (screenH - overlayH) / 2;
        }

        return offSetH;
    };

    this.getWindowWidth = function ($window) {
        var winWidth;
        if ($('html').hasClass('lt-ie9')) {
            winWidth = document.body.clientWidth;
        } else {
            winWidth = $window.width();
        }

        return winWidth;
    };

    this.getWindowHeight = function ($window) {
        var winHeight;
        if ($('html').hasClass('lt-ie9')) {
            winHeight = document.body.clientHeight / 4;
        } else {
            winHeight = Math.max($window.height(), window.innerHeight);
        }

        return winHeight;
    };

    //reset Epi form
    this.resetEpiForm = function(){
        setTimeout(function(){
            if ($('.newsletter-container').length >= 1) 
                $('.newsletter-container .content > div').removeAttr('style');
        }, 600);
    }

    function autoFocusAtFirstElm(elm){
        var tabbable = elm.find('select, input, textarea, button, a, [role="button"]').filter(':visible');
        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        /*set focus on first input*/
        setTimeout(() => {
            firstTabbable.focus();
        }, 500)

        /*redirect last tab to first input*/
        lastTabbable.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstTabbable.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
    }

    // try this
    this.runOverlay = function (htmlOrRef, container, containerWidth, containerHeight, checkH, isNewsletter, doNotAddBindings, callbackOnClose) {
        var screenW, screenH;

        var $window = $(window);
        var screenW = me.getWindowWidth($window);
        var screenH = me.getWindowHeight($window);
        var removeOnClose = false;

        var $body = $('body');
        $body.addClass('overlay-no-scroll');
        $('html').addClass('overflowHidden');

        if (!$(".overlay").length) {
            $body.append('<div class="overlay"></div>');
        } else {
            $(".overlay").show();
        }
        if (typeof htmlOrRef === 'string' || htmlOrRef instanceof String) {
            $(".overlay").after(htmlOrRef);
            removeOnClose = true;
        } else if (htmlOrRef instanceof Element) {

        } else {
            return false;
        }

        // ok, so we have to check if our overlay isn't heigher than window
        var $container = $(container);
        if (checkH) {
            $container.width('100%');
        }
        var overlayH = $container.outerHeight(true);
        var offSetH = me.calculateOverlayH($container, screenH, overlayH);

        var scrollTop = $(window).scrollTop();
        var offSetL = (screenW - containerWidth) / 2;

        // Blur all inputs / textareas with placeholders to init on browsers LTE IE9
        if ($("html").hasClass('lte-ie9')) {
            $container.find("[placeholder]").blur();
        }

        // if offset is <0 make offset 10 else the overlay will appear off the screen on mobile.
        if (offSetL < 0) {
            offSetL = 0;
        }

        if (isNewsletter) {
            $container.css({ 'position': 'fixed' });
        } else {
            offSetH = offSetH + scrollTop;
        }

        $('.overlay').bind('touchmove', function (event) {
            event.preventDefault();
        })

        var closeOverlay = function(){
            //issue: cannot remove container in T32, so have to query selector again
            let _container = $(container);
            if ($('.overlay').is(':visible')) {
                me.hideOverlay();
                if (lastFocusElement) {
                    lastFocusElement.focus();
                }
                if (removeOnClose) {
                    _container.remove();
                } else {
                    _container.fadeOut();
                    me.resetEpiForm();
                }
                if (GT.isFunction(callbackOnClose)) {
                    callbackOnClose();
                }
            }
        }

        if (!doNotAddBindings) {
            $(document).on('resize', function () {
                setTimeout(function () {
                    $container.css({ 'overflow': 'auto' });
                    $container.css('-webkit-overflow-scrolling', 'touch');
                    $container.css('max-height', 'calc(100vh - 40px)');
                }, 1000)
            });

            $(document).on('keydown', function (e) {
                if (e.keyCode === 27) { // ESC
                    closeOverlay();
                }
            });

            $('.js-close-overlay').on('click', function () {
                //lastFocusElement = this;
                closeOverlay();
                return false;
            });
        }

        $('.overlay').on('click', function (e) {
            // lastFocusElement = this;
            closeOverlay();
            e.stopImmediatePropagation();
            return false;
        });

        $container.fadeIn();
        if (!$container.is(".contact-form-popup") && !$container.is(".popup-contact-me-form")  && !$container.is(".focusable-form")) {
            me.overlayTabNavHandlerOnOpen();
        } else {
            $container.css('display','flex');
            // if($container.is(".focusable-form")) {
            // }
            
            autoFocusAtFirstElm($container);
        }
        GT.hideHyperLinkAnimation();
        return true;
    };
    // / try this

    // hide overlay function
    this.hideOverlay = function () {

        $('.overlay').off('click');
        var $body = $('body');
        $body.removeClass('overlay-no-scroll');
        if(!document.firstElementChild.classList.contains("opening-mobile-menu"))
            $('html').removeClass('overflowHidden');

        var $window = $(window);
        var screenW = me.getWindowWidth($window);


        var top = Math.abs(parseInt($('body').css('top'), 10));

        GT.setInertWhileOpeningDialog(false);
        $('.overlay').fadeOut('slow');
        me.overlayTabNavHandlerOnClose();
    };

    // youtube overlay
    this.youTubeOverlay = function (url) {
        var winWidth = $(window).innerWidth();
        var winHeight = $(window).innerHeight();
        var playerWidth = winWidth * 0.8;//560,

        //if(playerWidth > 1000) playerWidth = 1000;

        var playerHeight = playerWidth / 1.6;//315,

        if (playerHeight > winHeight) {
            playerHeight = winHeight * 0.8;
            playerWidth = playerHeight * 1.6;
        }

        if (winWidth <= 480) {
            playerWidth = 320;
            playerHeight = 200;
        }

        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var videoID = url.match(regExp);

        if (videoID && videoID[2].length == 11) {
            videoID = videoID[2];
        } else {
            videoID = false;
        }

        if (videoID) {
            url = 'https://www.youtube.com/embed/' + videoID;
        }
        // var htmlMarkup = '<div class="youtube-container"><a href="#" class="js-close-overlay"><img src="../images/sprites/close-video-wh.png" alt="close video" /></a><iframe width="'+playerWidth+'" height="'+playerHeight+'" src="http:'+url+'?autoplay=1" frameborder="0" allowfullscreen></iframe></div>';
        var htmlMarkup = '<div class="youtube-container"><iframe id="' + videoID + '" width="' + playerWidth + '" height="' + playerHeight + '" src="' + url + '?rel=0&autoplay=1&enablejsapi=1&vq=large" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
        var container = '.youtube-container';

        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
        me.hideRelatedVideoInYoutube(container);
    };

    // vimeo overlay
    this.vimeoVideoOverlay = function (me, id, playerWidth, playerHeight) {
        var htmlMarkup = '<div class="youtube-container"><iframe src="https://player.vimeo.com/video/' + id + '?autoplay=1" width="' + playerWidth + '" height="' + playerHeight + '" allow="autoplay" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';

        var container = '.youtube-container';

        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
    };

    // vimeo thumbnail
    this.vimeoVideoThumbNail = function (me, currentElem, videoID) {
        currentElem.addClass("lazyload");
        currentElem.attr('data-bgset', 'https://vumbnail.com/' + videoID + '.jpg');
    };

    // youtube overlay
    this.youTubeVideoOverlay = function (me, id, playerWidth, playerHeight) {
        var htmlMarkup = '<div class="youtube-container"><iframe id="'+ id +'" src="https://www.youtube.com/embed/' + id + '?rel=0&autoplay=1&enablejsapi=1&vq=large"  width="' + playerWidth + '" height="' + playerHeight + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
        var container = '.youtube-container';
        me.runOverlay(htmlMarkup, container, playerWidth, playerHeight, false, false);
        me.hideRelatedVideoInYoutube(container);
    };

    var player;
    this.loadPlayer = function (playerFrame) {
        if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function () {
                me.onYouTubePlayer(playerFrame);
            };
        } else {
            me.onYouTubePlayer(playerFrame);
        }
    }

    this.onYouTubePlayer = function (playerFrame) {
        player = new YT.Player(playerFrame, {
            videoId: playerFrame,
            events: {
                'onReady': me.onPlayerReady,
                'onStateChange': me.onPlayerStateChange
            }
        });
    }
    
    this.onPlayerReady = function (event) {
        event.target.playVideo();
    }

    this.onPlayerStateChange = function (event) {
        if (event.data == YT.PlayerState.ENDED) {
            if (typeof player !== 'undefined' && typeof  player.seekTo != "function"){
                event.target.a.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            }else{
                player.seekTo(0, false);
                player.stopVideo();
            }
        }
    }
    this.hideRelatedVideoInYoutube = function (container) {
        var playerFrame = $(container).find("iframe");
        me.loadPlayer(playerFrame.attr("id"));
    }

    // generic overlay
    this.newsletterOverlay = function () {

        var containerWidth = 640,
            containerHeight = 457;
        var winWidth = $(window).innerWidth();
        if (containerWidth < winWidth) {
            containerWidth = winWidth;
        }

        // html content
        var heading = 'Subscribe to our newsletters',
            newsletter1 = 'Email newsletter option 1',
            newsletter1copy = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu ante lorem. Phasellus at lacinia nunc. Nullam iaculis quis nunc facilisis luctus.',
            newsletter2 = 'Email newsletter option 2',
            newsletter2copy = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu ante lorem. Phasellus at lacinia nunc. Nullam iaculis quis nunc facilisis luctus.',
            submitURL = '#';

        var htmlMarkup = '<div class="newsletter-container"><div class="header"><h2>' + heading + '</h2><a href="#" class="js-close-overlay"><i class="icon-close"></i><span class="ir">Close</span></a></div><div class="content"><div class="checkbox-inline"><input id="newsletter1" type="checkbox"><label for="newsletter1"><span></span>' + newsletter1 + '</label><p>' + newsletter1copy + '</p><input id="newsletter2" type="checkbox"><label for="newsletter2"><span></span>' + newsletter2 + '</label><p>' + newsletter2copy + '</p></div><div class="footer"><label for="subscribeEmail" class="reader">First name</label><input class="input-name errors" type="text" id="subscribeEmail" value="Your email address"><a href="' + submitURL + '" class="subscribe-btn">Subscribe here</a></div></div></div>';

        var container = '.newsletter-container';

        me.runOverlay(htmlMarkup, container, containerWidth, containerHeight, true, true);
    };

    this.openVideoInNewTab = function (currentElem) {

        currentElem.blur();
        var EXIT = true,
            CONTINUE = false;
        var win = false;

        if (currentElem.hasClass('video__open-in-new-tab')) {
            win = window.open(currentElem.attr("href"), '_blank');
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            }
            return EXIT;
        }
        return CONTINUE;
    }

    this.launchOverlay = function ($elem, obj) {
        function handleClick(e){
            if (!e.keyCode || e.keyCode === '13') {
                e.preventDefault();
                if (!me.openVideoInNewTab($(e.srcElement))) {
                    // on click - button name changes to "loading..." at the end
                    // open the modal
                    var youtubeLink = e.srcElement.href;
                    if (youtubeLink && youtubeLink.length > 0) {
                        me.youTubeOverlay(youtubeLink);
                    }
                }
            }
        }
        $elem.each(function(idx, item){
            item.onclick = handleClick;
            item.onkeydown = handleClick;
        })
    };

    this.launchVideoOverlay = function (elem, obj) {
        var
            vimeoRegExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|[\w]+\/review\/|)(\d+)(?:\/(\w+))?(?:$|\/|\?)/,
            youtubeRegExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/,
            playerWidth = 560,
            playerHeight = 315,
            winWidth = $(window).innerWidth();

        if (winWidth <= 480) {
            playerWidth = 320;
            playerHeight = 200;
        }

        function handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, videoFunction) {
            // on click - button name changes to "loading..." at the end
            // open the modal
            videoFunction(me, videoID, playerWidth, playerHeight);
        };

        elem.each(function () {
            var $current = $(this),
                videoLink = $current.attr("href"),
                videoID = 0;
            var vimeoMatch, youtubeMatch;
            if (videoLink && videoLink.length > 0) {
                vimeoMatch = videoLink.match(vimeoRegExp);
                youtubeMatch = videoLink.match(youtubeRegExp);
            }

            if (vimeoMatch) {
                videoID = vimeoMatch[3];
                if(!$current.parent(".press-video").length)
                    me.vimeoVideoThumbNail(me, $current, videoID);
            } else if (youtubeMatch) {
                videoID = youtubeMatch[1];
                if(!$current.parent(".press-video").length) {
                    $current.addClass("lazyload");
                    $current.attr('data-bgset', 'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg');
                }
                // $current.attr('style', 'background-image: url(" https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg");');
            }
        })

        
        function handleClick(e){
            if (!e.keyCode || e.keyCode === '13') {
                var currentElm = e.srcElement,
                    videoLink = currentElm.href,
                    videoID = 0;
                var vimeoMatch, youtubeMatch;
                if (videoLink && videoLink.length > 0) {
                    vimeoMatch = videoLink.match(vimeoRegExp);
                    youtubeMatch = videoLink.match(youtubeRegExp);
                }
                e.preventDefault();
                if (!me.openVideoInNewTab($(currentElm))) {
                    if (vimeoMatch) {
                        videoID = vimeoMatch[3];
                        handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, me.vimeoVideoOverlay);
                    } else if (youtubeMatch) {
                        videoID = youtubeMatch[1];
                        handleLaunchOfVideoOverlay(videoID, playerWidth, playerHeight, me.youTubeVideoOverlay);
                    }
                }
                
            }
        }

        elem.each(function (idx, item) {
            item.onclick = handleClick;
            item.onkeydown = handleClick;
        });
    };

    this.launchNewsletter = function ($elem) {

        //opening the overlay and the basket
        $($elem).on('click keydown', function (e) {
            if (!e.keyCode || e.keyCode === '13') {
                // on click - button name changes to "loading..." at the end
                // open the modal
                me.newsletterOverlay();
                return false;
            }
        });
    };

    this.overlayContactProcess = function(elem, container, postFormURL){
        var $optionErrors = $(container).find(".checkbox-inline .error");
        var $emailErrors = $(container).find(".footer .error");
        // FocusTrap
        var findInsiders = function (elem) {
            //reset
            var content = elem.find('.content');
            content.find('input, textarea, select').val('');
            content.find('input[type=checkbox], input[type=radio]').prop('checked', false); 
            $optionErrors.empty().addClass('hide');
            $emailErrors.empty().addClass('hide');
            
            autoFocusAtFirstElm(elem);

            /* allow escape key to close insiders div */
            elem.on('keyup', function (e) {
                if (e.keyCode === 27) {
                    lastFocusElement.focus();
                    me.resetEpiForm();
                    elem.hide();
                };
            });
        };

        findInsiders($(container));
        var recaptchaContainer = $(container).find(".g-recaptcha");
        var recaptcha = null;
        if (recaptchaContainer.length) {
            recaptcha = new GT.Captcha(recaptchaContainer, {
                settings: {
                    error_origin: "selector",
                    error_value: "",
                    error_selector: "data-captcha-error",
                    error_where: "after"
                }
            });
        }
        $(container).find("a.subscribe-btn").click(function (e) {
            e.preventDefault();

            var $btn = $(this);
            if ($btn.attr('disabled') === 'disabled') {
                return false;
            }

            var $selectedCbxs = $(container).find(".checkbox-inline input:checked");
            var email = $(container).find("input#subscribeEmail").val();
            var keys = [];
            var hpc = $(container).find('.hpc').val();
            var recaptchaVal = "";
            if (recaptcha) {
                recaptchaVal = $(container).find('.g-recaptcha-response').val();
            }

            if ((recaptcha && !recaptcha.captchaChecked)) {
                recaptcha.showRecaptchaErrorMsg();
                return false;
            }
            $btn.attr('disabled', 'disabled');

            $.each($selectedCbxs, function (i, val) {
                keys.push($(val).attr("id"));
            });
            var subscribeFormModel = {
                Email: email,
                Keys: keys,
                HoneyPotCaptcha: hpc,
                CurrentLanguage: window.gtConfig.currentLanguageId,
                ReCaptchaToken: recaptchaVal,
                ContactPageId: $("#ContactPageId").val()
            };
            var jsonData = JSON.stringify(subscribeFormModel);
            var postFormAjaxOptions = {
                url: postFormURL,
                type: "POST",
                data: jsonData,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data, results, info) {
                    $btn.removeAttr('disabled');
                    if (data.Success) {
                        $('.newsletter-container .content').children('div:not(.thanks)').hide();
                        $('.thanks').find('a.close').addClass('link-btn link-btn-page');
                        $('.newsletter-container .thanks').show();
                        findInsiders($(container));
                        $('.newsletter-container .thanks').find('.close').on('click', function (e) {
                            e.preventDefault();
                            $(container).find(".js-close-overlay").click();
                            me.resetEpiForm();
                            lastFocusElement.focus();
                        });
                    } else {
                        if (!data.IsEmailValid) {
                            $.each(data.EmailErrors, function (i, val) {
                                $emailErrors.empty();
                                $emailErrors.append($("<p />").text(val));
                                $emailErrors.removeClass("hide");
                            });
                        } else {
                            $emailErrors.addClass("hide");
                        }
                        
                        if (!data.AreKeysValid) {
                            $.each(data.KeysErrors, function (i, val) {
                                $optionErrors.empty();
                                $optionErrors.append($("<p />").text(val));
                                $optionErrors.removeClass("hide");
                            });
                        } else {
                            $optionErrors.addClass("hide");
                        }
                    }
                },
                // if error (302) - honeypot GTE-462
                error: function (data) {
                    //$('.newsletter-container .content').empty().append(data.responseText);
                    $optionErrors.empty().append(data.responseText).removeClass('hide');
                    $btn.removeAttr('disabled');
                }
            };
            $.ajax(postFormAjaxOptions);
        });
    }

    this.loadOverlayContact = function (elem) {

        $(elem).click(function (e) {
            e.preventDefault();
            lastFocusElement = this;
            var postFormURL = $(this).data('postajax');
            var url = $(this).data('href');
            var containerWidth = 640, containerHeight = 457;
            var container = '.newsletter-container';
            var winWidth = $(window).innerWidth();

            //FocusTrap
            if (containerWidth > winWidth) {
                containerWidth = winWidth;
            }

            if (url != "#") {
                container = '.newsletter-container[subscribe-overlay]';
                var options = {
                    url: url,
                    success: function (data, results, info) {
                        me.runOverlay(data, container, containerWidth, containerHeight, true, true);
                        me.overlayContactProcess(elem, container, postFormURL);
                    }
                };
                $.ajax(options);
            }else{
                me.runOverlay(document.getElementsByClassName('newsletter-container')[0], container, containerWidth, containerHeight, true, true);
                me.overlayContactProcess(elem, container, postFormURL);
            }
        });
    },
        this.loadOverlaySeminar = function (elem) {
            elem.click(function (e) {
                e.preventDefault();
                var postFormURL = $(this).data('postajax');
                var options = {
                    url: $(this).attr('href'),
                    success: function (data, results, info) {
                        var containerWidth = 640, containerHeight = 457;
                        var container = 'form.subscribe-semminars-container';
                        var winWidth = $(window).innerWidth();
                        if (containerWidth > winWidth) {
                            containerWidth = winWidth;
                        }
                        me.runOverlay(data, container, containerWidth, containerHeight, true, true);
                        var $container = $(container);
                        var recaptchaContainer = $container.find(".g-recaptcha");
                        var recaptcha = null;
                        if (recaptchaContainer.length) {
                            recaptcha = new GT.Captcha(recaptchaContainer, {
                                settings: {
                                    error_origin: "selector",
                                    error_value: "",
                                    error_selector: "data-captcha-error",
                                    error_where: "after"
                                }
                            });
                        }

                        $(document).on("submit", container, function (e) {
                            e.preventDefault();

                            var current = this;
                            var $nameError = $(current).find("#nameErrorMessage");
                            var $emailError = $(current).find("#emailErrorMessage");
                            var $optionsError = $(current).find("#optionsErrorMessage");
                            var $optinError = $(current).find("#optinErrorMessage");

                            $nameError.addClass("hide");
                            $nameError.prev().removeClass("errors");
                            $emailError.addClass("hide");
                            $emailError.prev().removeClass("errors");
                            $optinError.addClass("hide");
                            $optionsError.addClass("hide");

                            var $btn = $(this).find(".subscribe-btn");
                            if ($btn.attr('disabled') === 'disabled') {
                                return false;
                            }
                            var $selectedCbxs = $(current).find(".js-seminar-keys .checkbox-inline input:checked");
                            var $selectedOptin = $(current).find(".js-seminar-optin .checkbox-inline input:checked");
                            var name = $(current).find("input#subscribeName").val();
                            var email = $(current).find("input#subscribeEmail").val();
                            var hpc = $(current).find('.hpc').val();
                            var valid = {};
                            valid.Email = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]([a-z])+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(email);
                            valid.Name = name.length > 0 && /^\D+$/i.test(name);
                            valid.Optin = $selectedOptin.length;
                            valid.Keys = $selectedCbxs.length;

                            if (!valid.Name) {
                                $nameError.removeClass("hide");
                                $nameError.prev().addClass("errors");
                            }
                            if (!valid.Email) {
                                $emailError.removeClass("hide");
                                $emailError.prev().addClass("errors");
                            }
                            if (!valid.Optin) {
                                $optinError.removeClass("hide");
                            }
                            if (!valid.Keys) {
                                $optionsError.removeClass("hide");
                            }
                            if (valid.Email && valid.Keys && valid.Name && valid.Optin && hpc.length === 0) {
                                var postFormAjaxOptions = {
                                    url: postFormURL,
                                    type: "POST",
                                    dataType: "json",
                                    data: $(current).serialize(),
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "json",
                                    success: function (data) {
                                        $btn.removeAttr('disabled');
                                        $nameError.addClass("hide");
                                        $emailError.addClass("hide");
                                        $optinError.removeClass("hide");
                                        $optionsError.addClass("hide");

                                        $('.subscribe-semminars-container .content').children().hide();
                                        $('.thanks').show().parent().show();
                                        $('.field-group, .footer').hide();
                                        $('.thanks').find('a.close').addClass('link-btn link-btn-page');
                                        $('.subscribe-semminars-container .thanks').show().find('.close').on('click', function (e) {
                                            e.preventDefault();
                                            $(current).find(".js-close-overlay").click();
                                        });
                                    },
                                    // if error (302) - honeypot GTE-462
                                    error: function (data) {
                                        // $('.subscribe-semminars-container .content').empty().append(data.responseText);
                                        $btn.removeAttr('disabled');
                                    }
                                };
                                try {
                                    if ((recaptcha && recaptcha.captchaChecked) || !recaptcha) {
                                        $.ajax(postFormAjaxOptions);
                                    }
                                } catch (ex) {
                                    console.warn(ex);
                                }
                            }
                        });

                    }
                };
                $.ajax(options);
            });
        };

    this.calculateAndSetOverlayPos = function ($overlay, isNewsletter) {

        // get window width & height
        var $window = $(window);
        var winWidth = me.getWindowWidth($window);
        var winHeight = me.getWindowHeight($window);

        // get overlay width & height
        var overlayW = $overlay.outerWidth(true);
        $overlay.css({ 'height': '' });
        var overlayH = $overlay.outerHeight(true);
        // if overlay is heigher or wider than window - adjust it's size
        // center overlay in window (vertically & horizontally)
        if (overlayH > winHeight) {
            $overlay.css({ 'height': winHeight + 'px', 'overflow': 'auto' });
            // no need to center
        } else {
            // center vertically
            if (isNewsletter) {
                var topOffset = (winHeight - overlayH) / 2;
            } else {
                var topOffset = ((winHeight - overlayH) / 2) + $window.scrollTop();
            }
            $overlay.css({ 'top': topOffset + 'px' });
        }

        if (overlayW > winWidth) {
            $overlay.width(winWidth);
            // no need to center
        } else {
            // center horizontally
            var leftOffset = (winWidth - overlayW) / 2;
            $overlay.css({ 'left': leftOffset + 'px' });
        }

    };

    this.resizeOverlay = function ($elem) {

        // resize overlay if it's open
        $(window).resize(function () {
            var $overlay = $('.overlay');
            if ($overlay.length && $overlay.css('display') !== 'none') {
                //me.calculateAndSetOverlayPos($('.newsletter-container'), true);
            }
        });
    };

    this.overlayTabNavHandlerOnOpen = function () {

        $("*[tabindex != '-1']:visible").each(function () {
            var $this = $(this);
            if (!$this.closest('.newsletter-container').length && !$this.closest('.expert-modal').length) {
                $this.attr('tabindex', '-1').addClass('js-tabbable-blocked');
            }
        });
    };

    this.overlayTabNavHandlerOnClose = function () {

        $('.js-tabbable-blocked').each(function () {
            $(this).removeAttr('tabindex').removeClass('js-tabbable-blocked');
        });
    };

    let htmlElm = document.firstElementChild;   

    //Performance issue
    // this.initHeaderOverlay = function () {
    //     let headerOverlayHtml = '<div class="header-overlay"></div>',
    //         body = htmlElm.querySelector('body');
        
    //     // body.innerHTML += headerOverlayHtml;
    //     body.insertAdjacentHTML("beforeend", headerOverlayHtml);
    // }
    // this.initHeaderOverlay()
    
    
    this.toggleHeaderOverlay = function() {        
        htmlElm.classList.toggle('opening-header-overlay')
    }
    
    this.showHeaderOverlay = function() {        
        htmlElm.classList.add('opening-header-overlay')
    }
    
    this.hideHeaderOverlay = function() {        
        htmlElm.classList.remove('opening-header-overlay')
    }

};


GT.Overlays = new GTOverlays();
GT.domContentLoadedFncList.push(function(){
    if(typeof isV1GT == "undefined") {
        GT.Overlays.launchVideoOverlay($('.video__with-overlay'));
        GT.Overlays.launchOverlay($('.youtube-video'));
        GT.Overlays.loadOverlayContact($('#launchContactFormSubscribe:not([data-epiforms-overlay])'));
        GT.Overlays.loadOverlaySeminar($('#launchSemminarsFormSubscribe'));
    }
});

GT.PardotForm = function () {
    function handlePardotIframeMessage() {
        const iframes = document.querySelectorAll('iframe[src*="campaign.grantthornton.in"]');
        if (!iframes.length) return;

        const getFormTheme = (iframe) => {
            let formTheme = 'grey';
            const isWhitePage = document.querySelector('.page-bg-white, .t45-insights-page');
            if (isWhitePage) formTheme = 'white';
            if (iframe.closest('.bg-inverse__white')) formTheme = 'white';
            if (iframe.closest('.bg-inverse__grey') || iframe.closest('.t45-page--bottom')) formTheme = 'grey';
            if (iframe.closest('.bg-inverse__purple')) formTheme = 'purple';
            return formTheme;
        };

        iframes.forEach(iframe => {
            const formTheme = getFormTheme(iframe);
            
            iframe.addEventListener('load', () => {
                iframe.contentWindow.postMessage(
                    { formTheme },
                    'https://campaign.grantthornton.in'
                );
            });
        });
    }

    handlePardotIframeMessage();
};
GT.domContentLoadedFncList.push(function () {
    GT.PardotForm();
});
GT.PeopleFilters = function ($element, obj) {
    let __ths = this;
    let _filterTagsTaxonomies = [];

    function taxonomyFilterTabs() {
        let _insightLandingFilters = document.querySelector('.insight-landing__filters');
        if(!_insightLandingFilters) return;
        let _taxonomyTabItems = _insightLandingFilters.querySelectorAll('.select-filter__item');
        [].forEach.call(_taxonomyTabItems, function(tabItem) {
            tabItem.addEventListener('click', function(e) {
                let _this = this;
                let _child = e.target.closest('.select-filter__condition');
                if(_child) return;
                
                if(_this.classList.contains('expanded')) {
                    _this.classList.remove('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", false);
                    window.removeEventListener("keydown", pressESCToClose);
                } else {
                    let _oldActiveTab = _insightLandingFilters.querySelector('.select-filter__item.expanded');
                    if(_oldActiveTab && _oldActiveTab.classList.contains('expanded')) _oldActiveTab.classList.remove('expanded');

                    window.addEventListener("keydown", pressESCToClose);
                    _this.classList.add('expanded');
                    _this.querySelector(".select-filter__button").setAttribute("aria-expanded", true);
                }
            });

            if(!GT.isMobileCached) {
                tabItem.querySelector(".select-filter__button").addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && e.shiftKey && this.closest(".expanded")) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".insight-apply__filters--btn").focus();
                    }
                })
            }
        });
    }

    function pressESCToClose(e){
        if(e.key == "Escape") {
            let currentCursorActiveElm = document.querySelector(".select-filter__item.expanded button");
            if(currentCursorActiveElm) {
                currentCursorActiveElm.focus();
                currentCursorActiveElm.click();
            }
        }
    }
    
    function processFilterCheckbox(_filterCheckbox) {
        let _filterCheckboxValue = _filterCheckbox.value;
        if(_filterCheckbox.checked) {
            let _parentTaxonomy = _filterCheckbox.getAttribute('parent-taxonomy');
            let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
            if(_parentTaxonomyArr) {
                if(_parentTaxonomyArr.indexOf(_filterCheckboxValue) < 0) _parentTaxonomyArr.push(_filterCheckboxValue);
            } else {
                _parentTaxonomyArr = [];
                _parentTaxonomyArr.push(_filterCheckboxValue);
            }

            _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
        }
    }

    function processFilterTagLabel(_tagLabel) {
        if(_tagLabel) {
            let _tagLabelValue = _tagLabel.getAttribute('data-value');
            let _parentTaxonomy = _tagLabel.getAttribute('data-parenttagkey');
            let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
            if(_parentTaxonomyArr) {
                if(_parentTaxonomyArr.indexOf(_tagLabelValue) < 0) _parentTaxonomyArr.push(_tagLabelValue);
            } else {
                _parentTaxonomyArr = [];
                _parentTaxonomyArr.push(_tagLabelValue);
            }

            _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
        }
    }

    function initFilterByLabel() {
        let filterButtonsContainer = document.querySelector('.filter-result__tags--buttons');
        if(filterButtonsContainer) {
            // Get all current taxonomies are filterred and push into _filterTagsTaxonomies array.
            getAllFilterredTaxonomies();

            let _filterLables = filterButtonsContainer.querySelectorAll('button.filter-result__tag-item');
            [].forEach.call(_filterLables, function(filterBtn){
                filterBtn.addEventListener('click', function(e) {
                    let _this = this;
                    let _taxFilterValue = _this.getAttribute('data-value');
                    if(!_filterTagsTaxonomies)  _filterTagsTaxonomies = [];
                    let _parentTaxonomy = _this.getAttribute('data-parenttagkey');
                    let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                    if(_parentTaxonomyArr) {
                        for(let i = 0; i < _parentTaxonomyArr.length; i++) {
                            let _childTaxonomy = _parentTaxonomyArr[i];
                            if(_taxFilterValue == _childTaxonomy) {
                                _parentTaxonomyArr.splice(i, 1);
                                break;
                            }
                        }
                    }

                    _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;

                    __ths.searchResultsByTaxonomies([], false, '', '');                       
                });
            });
        }
    }

    function initClearFilterByLabel() {
        let _clearFilterLabelBtns = document.querySelectorAll('button.search-filters__reset-btn');
        [].forEach.call(_clearFilterLabelBtns, function(_clearFilterLabel){
            _clearFilterLabel.addEventListener('click', function(e) {                    
                // Clear all data get from filter checkboxes
                _filterTagsTaxonomies = [];

                __ths.searchResultsByTaxonomies([], false, '', '');
            });
        });
    }

    // Search Filter Select Handling On Desktop
    function insightsFilterHandle() {
        let _applyFilterBtns = document.querySelectorAll('.insight-apply__filters--btn');
        [].forEach.call(_applyFilterBtns, function(applyFilterBtn) {

            applyFilterBtn.addEventListener('click', function() {
                let _insightsFilterContainer = document.querySelector('.search-filters__tabs');
                if(_insightsFilterContainer) {
                    _filterTagsTaxonomies = [];
                    let _insightsFilterItems = _insightsFilterContainer.querySelectorAll('input[type="checkbox"].filters__item:checked');
                    [].forEach.call(_insightsFilterItems, function(checkedItem){
                        if(checkedItem) {
                            processFilterCheckbox(checkedItem);
                        }
                    });
                }

                let _queryParams = new URLSearchParams(window.location.search);
                let _params = [];

                // Clear all pagination when apply new filter
                if(_queryParams.get('CurrentPageIndex')){
                    _queryParams.delete('CurrentPageIndex');
                }

                if(__ths.config.currentPageIndex <= 0) {
                    if(_queryParams.get('page')){
                        _queryParams.delete('page');
                    }
                }
                __ths.searchResultsByTaxonomies(_params, false, '', '');
            });

            if(!GT.isMobileCached) {
                applyFilterBtn.addEventListener("keydown", function(e) {
                    if(e.key == "Tab" && !e.shiftKey) {
                        e.preventDefault();
                        this.closest(".expanded").querySelector(".select-filter__button").focus();
                    }
                })
            }
        });
    }

    function queryParams(_urlSearchParams, params) {
        for (var key in params) {
            _urlSearchParams.set(key, params[key]);
        }

        if(_filterTagsTaxonomies) {
            for (var key in _filterTagsTaxonomies) {
                let _tagsArr = _filterTagsTaxonomies[key];
                let _tagsStr = '';
                let _counter = 0;
                [].forEach.call(_tagsArr, function(_tagValue){
                    if(_tagValue && _tagValue.length > 0) _tagsStr += _tagValue;
                    if(_counter < _tagsArr.length - 1 ) {
                        _tagsStr += '+';
                    }
                    _counter++;
                });
                if(_tagsStr && _tagsStr.length > 0) _urlSearchParams.append('tags', _tagsStr);
            }
        }

        return _urlSearchParams.toString();
    }

    __ths.setParameterInQueryString = function(key, value, isDelete) {
        var queryParams = new URLSearchParams(window.location.search);
        if(isDelete)
            queryParams.delete(key);
        else
            queryParams.set(key, value);
        
        let queryStr = queryParams.toString();
        history.replaceState(null, null, (queryStr.length ? "?" + queryStr : location.href.split("?")[0].split("#")[0])  + location.hash);
    }

    __ths.getParameterInQueryString = function(key) {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(key);
    }

    function toggleFiltersForm() {
        let _filtersContainer = document.getElementById('insightLandingFilters'),
            _filtersContainerToggle = document.querySelectorAll('[data-toggle="insightLandingFilters"]'),
            _filterBtn = document.querySelector(".insight-filter__header-mobile button");

        if (_filtersContainerToggle)
            for (var i = 0; i < _filtersContainerToggle.length; i++) {
                _filtersContainerToggle[i].addEventListener('click', function () {
                    if(_filtersContainer.classList.contains("active")) {
                        _filtersContainer.classList.remove('active');
                        document.querySelector(".gt-wrapper").classList.remove("opening-mobile-filter");
                        if(_filterBtn) {
                            _filterBtn.focus();
                            _filterBtn.setAttribute("aria-expanded", false);
                        }
                    } else {
                        _filtersContainer.classList.add('active');
                        _filterBtn?.setAttribute("aria-expanded", true);
                        setTimeout(e => {
                            document.querySelector("#filtersFormCloseBtn")?.focus();
                            document.querySelector(".gt-wrapper").classList.add("opening-mobile-filter");
                        }, 1000)
                    }
                })
            }

        if (_filtersContainer)
            document.querySelector('.main-header .menu-toggle').addEventListener('click', function() {
                _filtersContainer.classList.remove('active');
            })
    }

    function showActiveFilters () {
        let _selectFilterItems = document.querySelectorAll('.select-filter__item');
        [].forEach.call(_selectFilterItems, function(checkedItem){
            let checkedCheckbox = checkedItem.querySelector('[type="checkbox"].filters__item:checked');
            if(checkedCheckbox) {
                checkedItem.classList.add('expanded');
            }
        });
    }

    function toggleOverhiddenHTML() {
        let _filtersShowBtn = document.querySelector('.search-results__filters-show'),
            _filtersHideBtn = document.querySelector('.search-filters__close-btn');

        if (_filtersShowBtn)
            _filtersShowBtn.addEventListener('click', function() {
                document.querySelector('html').classList.add('overflowHidden--mobile');
            })

        if (_filtersHideBtn)
            _filtersHideBtn.addEventListener('click', function() {
                document.querySelector('html').classList.remove('overflowHidden--mobile');
            })
    }

    function init() {

        if( /Android/i.test(navigator.userAgent) ) {
            let insightResultContainer = document.querySelector('.insight-results__container');
            if(insightResultContainer) {
                insightResultContainer.classList.add('android-devices');
            }
        }

    
        let currentPageIndex = parseInt(document.getElementById('CurrentPageIndex')?.value || 1);
        __ths.config = {
            totalItemsCount: parseInt(document.querySelector("#totalItemsCount")?.value || 0),
            totalDisplayingItems: parseInt(document.querySelector("#totalDisplayingItems")?.value || 0),
            loadmoreEndpoint: document.querySelector("#dataEndpoint")?.value || "",
            pageSize: parseInt(document.querySelector("#itemsPerPage")?.value || 0),
            currentPageIndex: currentPageIndex,
            currentNextPageIndex: currentPageIndex,
            currentPreviousPageIndex: currentPageIndex,
            resultContainerElm: document.querySelector(".expert-search__results"),
            fetchingAPI: false
        }

            
        if(__ths.config.resultContainerElm.firstElementChild != __ths.config.resultContainerElm.lastElementChild) {
            __ths.config.resultContainerElm.lastElementChild.dataset.page = currentPageIndex;
            __ths.observerElm(__ths.config.resultContainerElm.lastElementChild);
        }

        if(__ths.config.resultContainerElm.firstElementChild) {
            __ths.config.resultContainerElm.firstElementChild.dataset.page = currentPageIndex;
            __ths.observerElm(__ths.config.resultContainerElm.firstElementChild);
        }
        

        taxonomyFilterTabs();
        insightsFilterHandle();
        initClearFilterByLabel();
        initFilterByLabel();
        initLoadmoreButton();
        loadPreviousHandler();

        toggleFiltersForm();
        toggleOverhiddenHTML();
        if(GT.isMobileView()) {
            showActiveFilters();
        }

        clickOutsideFilterContainer();
    }

    function initLoadmoreButton() {
        let _loadmoreButton = document.getElementById('peopleFilterLoadmore');
        if(_loadmoreButton) {
            _loadmoreButton.addEventListener('click', function(e) {
                e.preventDefault();
                __ths.loadMoreResultsByTag();
            });
        }
    }

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };

    function getAllFilterredTaxonomies() {
        let _currentTagsFilterred = document.querySelectorAll('button.filter-result__tag-item');
        if(_currentTagsFilterred && _currentTagsFilterred.length > 0) {
            [].forEach.call(_currentTagsFilterred, function(filterredByTaxonomy){
                if(filterredByTaxonomy) {
                    processFilterTagLabel(filterredByTaxonomy);
                }
            });
        }
    }

    __ths.loadMoreResultsByTag = function (isLoadPrevious) {
        if(__ths.config.fetchingAPI) return;
        if(isLoadPrevious) {
            __ths.config.currentPreviousPageIndex--;
            __ths.config.currentPageIndex = __ths.config.currentPreviousPageIndex;
        } else {
            __ths.config.currentNextPageIndex++;
            __ths.config.currentPageIndex = __ths.config.currentNextPageIndex;
        }
        

        let _params = [];
        _params['CurrentPageIndex'] = __ths.config.currentPageIndex;

        getAllFilterredTaxonomies();
        __ths.searchResultsByTaxonomies(_params, true, __ths.config.loadmoreEndpoint, null, function(contextRef, data){
            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
            __ths.appendResults(contextRef, data, isLoadPrevious);
            setTimeout(e => {
                __ths.config.fetchingAPI = false;
            }, 500)
        });
    };

    __ths.ajaxCall = function (url, successCallback) {
        var contextRef = this;
        let __url = url;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.response && this.status == 200) {
                    successCallback(contextRef, this.response);
                }
            }
        };
        xhttp.open("GET", __url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    __ths.searchResultsByTaxonomies = function (_queryParams, _isAppendResults, _otherEndpoint, _replaceContainer, successCallback) {
        let _ajaxUrl = '';
        if(_isAppendResults) {
            __ths.config.fetchingAPI = true;
            _ajaxUrl = queriesStringBuilder(_queryParams, _otherEndpoint, true);
            __ths.ajaxCall(_ajaxUrl, successCallback);
            return false;
        } else {
            _ajaxUrl = queriesStringBuilder(_queryParams);
        }
        window.location.href = _ajaxUrl;
    };

    function queriesStringBuilder(_params, _otherEndpoint, _isLoadmore) {

        if(!_params) _params = [];

        let _urlSearchParams = new URLSearchParams();

        let _ajaxUrl = '';
        if(_isLoadmore) {
            if(_otherEndpoint && _otherEndpoint.length > 0) {
                _ajaxUrl = _otherEndpoint;
            }
        } else {
            _ajaxUrl = '?';
        }
        
        let _queryParams = queryParams(_urlSearchParams, _params);
        if(_queryParams && _queryParams.length > 0) {
            if(_isLoadmore ) _ajaxUrl += '&';
            _ajaxUrl += _queryParams;
        }

        return __ths.escapeQueryChars(_ajaxUrl);
    }
    
    function loadPreviousHandler(){
        if(__ths.currentTotalDisplayingItems() <= __ths.config.totalDisplayingItems) {
            let resultContainerElmOffset = 0;
            GT.listFunctionsTriggerInScrollEvent.checkScrollPosExtendedSearch = () => {
                if(!resultContainerElmOffset)
                    resultContainerElmOffset = GT.getElementOffset(__ths.config.resultContainerElm).top;
                if(__ths.config.currentPreviousPageIndex > 1 && GT.isScrollingUp && GT.lastScrollTop - resultContainerElmOffset < 300 && !__ths.config.fetchingAPI) {
                    __ths.loadMoreResultsByTag(true);
                }
            }
        }
    }

    __ths.currentTotalDisplayingItems = () => {
        let currentTotalDisplayingItems = document.getElementById('peopleResultsContainer')?.querySelectorAll(".t4-single__expert:not(.expert-facts__container)").length || 0;
        return parseInt(currentTotalDisplayingItems);
    }

    __ths.appendResults = function (contextRef, data, isLoadPrevious) {
        let _insightResultsContainer = document.getElementById('peopleResultsContainer'),
            firstItem = __ths.config.resultContainerElm.firstElementChild,
            lastItem = __ths.config.resultContainerElm.lastElementChild,
            old_DOM_height = document.querySelector(".gt-wrapper").offsetHeight,
            old_scroll = GT.lastScrollTop;

        _insightResultsContainer.insertAdjacentHTML(isLoadPrevious ? "afterbegin" : "beforeend", data);

        if(!isLoadPrevious) {
            __ths.setParameterInQueryString("page", __ths.config.currentPageIndex);
            shouldLoadMore();

            __ths.config.totalDisplayingItems += __ths.config.pageSize;
            if(__ths.config.totalDisplayingItems > __ths.config.totalItemsCount) __ths.config.totalDisplayingItems = __ths.config.totalItemsCount;

            document.querySelector(".load-more-stats__showing-items").innerText = __ths.config.totalDisplayingItems;
            document.querySelector(".load-more-stats__progressbar-loaded").style.width = Math.ceil(__ths.config.totalDisplayingItems / __ths.config.totalItemsCount * 100) + "%";

            
            let _showingNumberElement = document.querySelector('#totalResultShowing');
            if(_showingNumberElement) _showingNumberElement.innerHTML = __ths.config.totalDisplayingItems;

            if(firstItem) {
                __ths.config.resultContainerElm.lastElementChild.dataset.page = lastItem.nextElementSibling.dataset.page = __ths.config.currentPageIndex;
                __ths.observerElm(__ths.config.resultContainerElm.lastElementChild);
                __ths.observerElm(lastItem.nextElementSibling);
            }
        } else {
            if(firstItem) {
                __ths.config.resultContainerElm.firstElementChild.dataset.page = firstItem.previousElementSibling.dataset.page = __ths.config.currentPageIndex;
                __ths.observerElm(__ths.config.resultContainerElm.firstElementChild);
                __ths.observerElm(firstItem.previousElementSibling);
            }
            window.scrollTo({ top: (old_scroll + document.querySelector(".gt-wrapper").offsetHeight - old_DOM_height), left:0, behavior: "instant"});
        }
    }


    __ths.updatePageIndex = (pageIndex) => {
        if(pageIndex > 1) {
            __ths.setParameterInQueryString("page", pageIndex);
        } else {
            __ths.setParameterInQueryString("page", pageIndex, true);
        }
        
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (pageIndex > 1 ? "?page=" + pageIndex : ""); 
    }
    
    __ths.observerElm = (elm) => {
        if(!elm.dataset.observed) {
            elm.dataset.observed = true;
            GT.checkElmVisible(elm, {
                callback: (e) => {
                    __ths.updatePageIndex(elm.dataset.page);
                },
                recheck: true,
                threshold: 1
            })
        }
    }

    function clickOutsideFilterContainer() {
        document.addEventListener('mouseup', function(e) {
            let _filterItemContainers = document.querySelectorAll('.select-filter__item');
            
            [].forEach.call(_filterItemContainers, function(_filterItem){
                let _filterConditionContainer = _filterItem.querySelector('.select-filter__condition');
                if (!_filterConditionContainer.contains(e.target) && !_filterItem.contains(e.target)) {
                    _filterItem.classList.remove('expanded');
                }
            });
        });
    }

    function shouldLoadMore() {
        let _loadBtn = document.getElementById('peopleFilterLoadmore');

        if(!_loadBtn) 
            return;

        let _pageIndexByTags = __ths.config.currentPageIndex;
        let totalItems = __ths.config.totalItemsCount;
        
        let maxPage = Math.ceil(totalItems / __ths.config.pageSize);
        let loadMoreContainer = document.querySelector(".load-more-container")

        if (maxPage <= _pageIndexByTags) {
            if(loadMoreContainer)
                loadMoreContainer.classList.add("hidden");
            else
                _loadBtn.classList.add('hidden');

        } else {
            if(loadMoreContainer) {
                loadMoreContainer.classList.remove("hidden");
            }
            else {
                _loadBtn.classList.remove('hidden');
            }
            
            if(_loadBtn.href) {
                _loadBtn.href = location.href.replace("page=" + _pageIndexByTags, "page=" + (_pageIndexByTags + 1));
            }
        }
                
        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = location.origin + location.pathname  + (_pageIndexByTags > 0 ? "?page=" + _pageIndexByTags : ""); 
    };

    
    init();
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.PeopleFilters();
    });
GT.GTPeopleLandingPage = function($elem) {
    handleVCardEvent();
    function handleVCardEvent() {
        var vcards = document.querySelectorAll('a.vcard-download');
        for (var i = 0; i < vcards.length; i++) {
            var ctn = vcards[i];
            ctn.addEventListener('click', function () {
                var $this = this;
                var contactName = $this.getAttribute("data-vcard-name");
                dataLayer.push({ 'event': 'vcard', 'eventAction': "download", "eventLabel": contactName });
            });
        }
    }
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.GTPeopleLandingPage($('.people-landing-page'));
    });
// var div = document.querySelector('.richtext-block');
// var hasHorizontalScrollbar = div.scrollWidth > div.clientWidth;
var listPerfectScrollbar = [];
var GTPerfectScrollbar = function (elm) {
    let $table = elm ? $(elm) : $('table').not(".no-perfect-sb");
    if($table.hasClass("table-v2__area")) return;
    if ($table.length > 0) {
        
        //prevent duplicate events
        if(listPerfectScrollbar.length) {
            listPerfectScrollbar.forEach(function(ps){
                ps.destroy();
                ps = null; 
            })
            listPerfectScrollbar = [];
        }

        for (let i = 0; i < $table.length; i++) {
            let currentTB = $table[i];
            if(!currentTB.parentNode.classList.contains("gtscroll")) {
                let scrollElmStr = "<div class='gtscroll-wrapper'><div class='gtscroll-thumb'></div><div class='gtscroll-content'></div></div>";
                currentTB.insertAdjacentHTML("beforebegin", "<div class='gtscroll'>" + scrollElmStr + "</div>");
                let gtscrollWrapper = currentTB.previousElementSibling;
                gtscrollWrapper.appendChild(currentTB);
                gtscrollWrapper.insertAdjacentHTML("beforeend", scrollElmStr);
            }
        }

        let gtscrollbars = Array.prototype.slice.call(document.querySelectorAll('.gtscroll'));

        for (let i = 0; i < gtscrollbars.length; i++) {
            let currentScrollBar = gtscrollbars[i],
                currentTB = $table[i];
                
            if(!currentTB.querySelector("tbody")) return;

            let currentScrollWrapper = currentScrollBar.querySelector(".gtscroll-wrapper"),
                currentScrollThumbs = Array.prototype.slice.call(currentScrollBar.querySelectorAll(".gtscroll-thumb")),
                currentScrollContents = Array.prototype.slice.call(currentScrollBar.querySelectorAll(".gtscroll-content")),
                currentTBComputedStyle = window.getComputedStyle(currentTB),
                currentTBodyWidth = currentTB.querySelector("tbody").clientWidth + parseInt(currentTBComputedStyle.paddingLeft.replace("px", "")) + parseInt(currentTBComputedStyle.paddingRight.replace("px", "")) + parseInt(window.getComputedStyle(currentTB.querySelector("tbody")).marginLeft.replace("px", "")),
                currentTBWidth = currentTB.clientWidth,
                currentThumbWidth = currentTBWidth / currentTBodyWidth * currentTBWidth,
                isHoverOnGTScroll = false;
            
            if(currentTBodyWidth > currentTBWidth) {
                currentScrollBar.classList.remove("gtscroll-hide");
                currentScrollBar.style.margin = currentTBComputedStyle.margin;

                currentScrollContents.forEach(function(contentItem){
                    contentItem.style.width = currentTBodyWidth + "px";
                })
                
                currentScrollThumbs.forEach(function(thumb){
                    thumb.style.width = currentThumbWidth + "px";
                })

                currentScrollWrapper.onscroll = function(e){
                    if(isHoverOnGTScroll && !GT.isMobileCached)
                        currentTB.scrollLeft = e.target.scrollLeft;
                }
                        
                currentTB.onscroll = function(e){
                    if(!isHoverOnGTScroll) {
                        let currentThumbPosition = currentThumbWidth / currentTBWidth *  e.target.scrollLeft;
                        if(!GT.isMobileCached)
                            currentScrollWrapper.scrollLeft = e.target.scrollLeft;
                        currentScrollThumbs.forEach(function(thumb){
                            thumb.style.transform = "translateX(" + currentThumbPosition + "px)";
                        })
                    }
                }

                if(!GT.isMobileCached) {
                    currentScrollBar.classList.remove("gtscroll-mobile");
                    listPerfectScrollbar.push(new PerfectScrollbar(currentTB));
                    listPerfectScrollbar.push(new PerfectScrollbar(currentScrollWrapper));
                    
                    currentScrollWrapper.onmouseenter = function(){
                        isHoverOnGTScroll = true;
                    }

                    currentTB.querySelector(".ps__rail-x").onmouseenter = function(){
                        isHoverOnGTScroll = false;
                    }
                } else {
                    currentScrollBar.classList.add("gtscroll-mobile");
                }
            } else 
                currentScrollBar.classList.add("gtscroll-hide");
        }
    }
};

GT.destroyScrollbar = function () {
    if (listPerfectScrollbar.length) {
        listPerfectScrollbar.forEach(function (ps) {
            ps.destroy();
            ps = null;
        })
        listPerfectScrollbar = [];
    }
}

GT.reInitScrollbar = function () {
    GTPerfectScrollbar($('table').not(".no-perfect-sb"));
}

var removeScrollbarWhenPrint = function () {
    var beforePrint = function () {
        GT.destroyScrollbar();
    };

    var afterPrint = function () {
        GTPerfectScrollbar($('table').not(".no-perfect-sb"));
    };

    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(function (mql) {
            if (mql.matches) {
                beforePrint();
            } else {
                afterPrint();
            }
        });
    }

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
} 

removeScrollbarWhenPrint();

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
            GTPerfectScrollbar($('table').not(".no-perfect-sb"));
    });
else {
    GTPerfectScrollbar($('table').not(".no-perfect-sb"));
}

let debounceGTPerfectScrollbar = [];
window.addEventListener("resize", function(){
    if(debounceGTPerfectScrollbar.length) {
        let tmpdebounceGTPerfectScrollbarLength = debounceGTPerfectScrollbar.length;
        for(let i = 0; i < tmpdebounceGTPerfectScrollbarLength; i++) {
            clearTimeout(debounceGTPerfectScrollbar[i]);
        }
        debounceGTPerfectScrollbar = [];
    }
    let tmpTimer = setTimeout(function(){
        GTPerfectScrollbar($('table').not(".no-perfect-sb"));
    }, 500)
    debounceGTPerfectScrollbar.push(tmpTimer);
})
GT.PressCarouselBanner = function() {
    let controlItems = Array.prototype.slice.call(document.querySelectorAll(".press-details__carousel-banner .press-banner__item")),
        contentItems = Array.prototype.slice.call(document.querySelectorAll(".press-details__carousel-banner .press-banner__content")),
        backgroundItems = Array.prototype.slice.call(document.querySelectorAll(".press-details__carousel-banner .background")),
        totalItems = contentItems.length,
        isScreenReader = false;
        
    function resetState(idx){
        controlItems.forEach(function(elm){
            elm.classList.remove("active");
            elm.classList.remove("animate");
        })
        contentItems.forEach(function(elm){
            elm.classList.remove("active");
            elm.setAttribute("tabindex", -1);
        })
        backgroundItems.forEach(function(elm){
            elm.classList.remove("active");
        })

        controlItems[idx].classList.add("active");
        controlItems[idx].classList.add("animate");
        contentItems[idx].classList.add("active");
        backgroundItems[idx].classList.add("active");
    }

    let currentActivatedItem = document.querySelector(".press-banner__item.active")
        currentItemIdx = 0;
        
    if(currentActivatedItem)
        currentActivatedItem.classList.add("animate");

    let _timer;   

    function triggerAnimate(){
        currentItemIdx++;
        if(currentItemIdx > totalItems - 1)
            currentItemIdx = 0;
        resetState(currentItemIdx);
    }

    controlItems.forEach(function(item){
        item.addEventListener("click", function(e){
            const _currentItemIdx = e.currentTarget.dataset.index;
            clearInterval(_timer);
            currentItemIdx = _currentItemIdx - 1;
            triggerAnimate();           
            let currentContentItem = contentItems[_currentItemIdx];
            currentContentItem.setAttribute("tabindex", 0);
            setTimeout(function(){
                currentContentItem.focus();
                setTimeout(() => {
                    currentContentItem.removeAttribute("tabindex");
                }, 1000)
            }, 100)
        })
    })

    contentItems.forEach(function(elm){
        elm.addEventListener("focus", function(){
            if(isScreenReader !== 0) {
                isScreenReader = true;
                clearInterval(_timer);
            }
        })
        elm.addEventListener("mouseenter", function(){
            isScreenReader = 0;
        })
    })   
}

GT.domContentLoadedFncList.push(function(){
    GT.PressCarouselBanner();
});
GT.GTPressPage = function ($element) {    
    wrapWideImage();
    
    function wrapWideImage() {

        $('.image-container').each(function() {
            var _this = $(this);
            var imgViewmode = _this.find('img');

            _this.removeClass('img-wide img-full-width img-narrow');
            if(imgViewmode.hasClass('img-wide')) {
                imgViewmode.parent().addClass('img-wide');
            } else if(imgViewmode.hasClass('img-full-width')) {
                imgViewmode.parent().addClass('img-full-width');
            } else {
                imgViewmode.parent().addClass('img-narrow');
            }
        });        
    }


    function pressBalanceHeight() {
        let balanceHeightElms = document.querySelectorAll("[balance-height]");
        [].forEach.call(balanceHeightElms, function(balanceHeight) {
            GT.BalanceHeight(balanceHeight); 
        });
    }
    
    pressBalanceHeight();

    GT.windowResizeFncList.blanceHeightPressContacts = function() {
        if(GT.wWidth > 960)
        pressBalanceHeight();
    }

};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTPressPage();
    });
GT.PressVideo = function () {
    function copyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
      
        // Place in the top-left corner of screen regardless of scroll position.
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
      
        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        textArea.style.width = '2em';
        textArea.style.height = '2em';
      
        // We don't need padding, reducing the size if it does flash render.
        textArea.style.padding = 0;
      
        // Clean up any borders.
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
      
        // Avoid flash of the white box if rendered for any reason.
        textArea.style.background = 'transparent';
      
      
        textArea.value = text;
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
      
        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Copying text command was ' + msg);
        } catch (err) {
          console.log('Oops, unable to copy');
        }
      
        document.body.removeChild(textArea);
    }

    function pressEmbedBtnHandle(e) {
        let currentTarget = e.target;
        currentTarget.nextElementSibling.classList.add("show");
        
        let videoLink = "about:blank",
            link = currentTarget.parentElement.previousElementSibling.querySelector("a").href;

        if(link.indexOf("vimeo") < 0) {
            videoLink = "https://www.youtube.com/embed/" + getVideoID(link) + "?autoplay=1&rel=0";
        } else {
            videoLink = "https://player.vimeo.com/video/" + getVideoID(link) + "?title=1&byline=0&portrait=0&autoplay=true";
        }

        copyTextToClipboard('<iframe src="'+ videoLink +'" width="640px" height="360px" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen tabindex="0" aria-label="player"></iframe>');
        currentTarget.setAttribute("tabindex", -1);
        currentTarget.parentElement.previousElementSibling.querySelector("a").focus();
    }

    Array.prototype.slice.call(document.querySelectorAll(".press-video-embed")).forEach(function(pressEmbedBtn){
        pressEmbedBtn.addEventListener("click", pressEmbedBtnHandle);
        pressEmbedBtn.addEventListener("keydown", function(e){
            if(e.keyCode == 13) {
                pressEmbedBtnHandle(e);
            }
        });
    })

    Array.prototype.slice.call(document.querySelectorAll(".press-video")).forEach(function(pressVideoElm){
        backgroundElm = pressVideoElm.querySelector(".background");
        if(!backgroundElm.dataset.bgset) {
            let videoLink = pressVideoElm.querySelector("a").href,
                videoID = getVideoID(videoLink);

            if(videoLink.indexOf("vimeo") < 0) {
                backgroundElm.dataset.bgset = 'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg';
            } else {
                backgroundElm.dataset.bgset = 'https://vumbnail.com/' + videoID + '.jpg';
            }
            backgroundElm.classList.add("lazyload");
        }
    })

    function getVideoID(link){
        let videoID;
        if(link.indexOf("vimeo") < 0) {
            videoID = link.match(/^(https?:)?(\/\/)?((www\.|m\.)?youtube(-nocookie)?\.com\/((watch)?\?(feature=\w*&)?vi?=|embed\/|vi?\/|e\/)|youtu.be\/)([\w\-]{10,20})/i);
            videoID = videoID ? videoID[9] : "";
        } else {
            videoID = link.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|[\w]+\/review\/|)(\d+)(?:\/(\w+))?(?:$|\/|\?)/);
            videoID = videoID ? videoID[3] : "";
        }
        return videoID;
    }
}

GT.domContentLoadedFncList.push(function(){
    GT.PressVideo();
});
GT.domContentLoadedFncList.push(function(){
    if(document.querySelector('header[data-sticky="true"] .rpi-progress-bar')){
        GT.listFunctionsTriggerInScrollEvent.progressBarHandler = function(){
            if(!GT.ProgressBarRPI)
                GT.ProgressBarRPI = new ReadingPositionIndicator({
                    rpiArea: '[data-rpi-area]',
                    progressBar: {
                        show: true
                    }
                }).init();
            GT.ProgressBarRPI.update();
        }
    }
});
GT.RDStationForms = function(){
    const ids = Array.from(document.querySelectorAll('script'))
    .map(script => {
        const match = script.textContent.match(/new\s+RDStationForms\s*\(\s*['"]([^'"]+)['"]/);
        return match ? match[1] : null;
    })
    .filter(Boolean); // remove nulls

    ids.forEach(id => {
        GT.waitForElmRendering("#" + id + " form").then((elm) => initRDForm(elm, id));
    })
    
    function initRDForm(RDForm, formID){
        if(!RDForm) { 
            console.error("RDForm is not found");
            return;
        }

        let externalFormBlock = RDForm.closest(".rdembedformblock, .externalformblock");
        let RDStationFormConfig = externalFormBlock?.querySelector(".RDStationFormConfig")?.textContent.trim();
        RDStationFormConfig = JSON.parse(RDStationFormConfig);
        if(!RDStationFormConfig) {
            console.error("RDStationFormConfig is not found");
            return;
        }

        RDForm.action = RDStationFormConfig.endPoint;
        RDForm.enctype = "multipart/form-data";

   
        const handleFieldState = (field, fieldWrap) => {
            const hasValue = field.value.length > 0;
            fieldWrap.classList.toggle('filled', hasValue);
        };

        const handleFieldFocus = (field, fieldWrap, isFocus) => {
            fieldWrap.classList.toggle('focus', isFocus);
        };

        const initializeField = (selector, callback) => {
            const fields = RDForm.querySelectorAll(selector);
            if (!fields?.length) return;
            
            fields.forEach(callback);
        };

        const initializeFormFields = () => {
            initializeField(".bricks-form__input", field => {
                const fieldWrap = field.closest('.bricks-form__field');
                if (!fieldWrap) return;

                const label = fieldWrap.querySelector('.bricks-form__label');
                const labelContent = label?.textContent.trim();
                
                fieldWrap.classList.add('floating-label');
                handleFieldState(field, fieldWrap);

                field.addEventListener('focusin', () => handleFieldFocus(field, fieldWrap, true));
                field.addEventListener('focusout', () => handleFieldFocus(field, fieldWrap, false));
                field.addEventListener('change', () => handleFieldState(field, fieldWrap));

                if(labelContent && labelContent.length > 0) {
                    label.setAttribute("title", labelContent);
                    field.setAttribute("title", labelContent);
                }
            });
        };

        const initializeCheckboxFields = () => {
            initializeField(".bricks-form__field__option__input", checkbox => {
                const checkboxLabel = checkbox.closest('.bricks-form__label');
                const checkboxWrap = checkbox.closest('.bricks-form__field');

                checkboxWrap?.classList.add('bricks-form__field-option-wrap');
                if (!checkboxLabel) return;
                checkbox.insertAdjacentHTML('afterend', '<span class="bricks-form__field__option-icon"></span>');
            });
        };

        const initializeSelectFields = () => {
            initializeField("select.bricks-form__input", select => {
                const fieldWrap = select.closest('.bricks-form__field');
                if (!fieldWrap) return;
                fieldWrap.classList.add('bricks-form__field-select');
            });
        };

        // Initialize all form components
        initializeFormFields();
        initializeCheckboxFields();
        initializeSelectFields();

        const captchaKey = RDStationFormConfig.captchaKey;

        if (captchaKey) {
            let lang = document.querySelector("html").lang,
                script_src = 'https://www.google.com/recaptcha/api.js?onload=CallbackGReCaptchaInited&render=explicit';
    
            if(lang)
                script_src += '&hl=' + lang;
        
            if(!document.querySelector('script[src^="'+ script_src +'"]')) {
                let script = document.createElement('script');
    
                script.src = script_src;
                script.defer = "defer";
    
                document.head.append(script);
            }

            // Wait for captcha container to be rendered
            GT.waitForElmRendering(`#${formID} .g-recaptcha-container`, 15000).then(captchaContainer => {
                if (!captchaContainer.innerHTML) {
                    const callbackKey = `rdstationform${formID}`;
                    GT.RecaptchaCallbackFnList[callbackKey] = { fnc: null, isExecuted: false };
                    GT.RecaptchaCallbackFnList[callbackKey].fnc = () => {
                        try {
                            setTimeout(() => {
                                grecaptcha.render(captchaContainer, {
                                    sitekey: RDStationFormConfig.captchaKey,
                                    callback: () => {
                                        const recaptchaMsg = captchaContainer.querySelector(".captcha-error") || 
                                                           RDForm.querySelector("[for=validateCaptcha].error");
                                        recaptchaMsg?.remove();
                                        RDForm.querySelector("#validateCaptcha").checked = true;
                                    },
                                    'expired-callback': () => {
                                        RDForm.querySelector("#validateCaptcha").checked = false;
                                    }
                                });
                            }, 500);
                        } catch (error) {
                            console.error('Error rendering reCAPTCHA:', error);
                        }

                        const gCaptchaResponseElm = RDForm.querySelector(".g-recaptcha-response");
                        if (gCaptchaResponseElm) {
                            gCaptchaResponseElm.classList.add("required");
                            gCaptchaResponseElm.setAttribute("required", "required");
                            RDForm.querySelector("#validateCaptcha").checked = false;
                        }
                    }

                    if (typeof grecaptcha !== "undefined") {
                        CallbackGReCaptchaInited();
                    }
                }
            });
        }

        if(RDStationFormConfig.maxFile) {
            let privacyElm = RDForm.querySelector(".bricks-form__privacy") || RDForm.querySelector(".bricks-form__terms"),
                strAppend = `<div class="bricks-form__field bricks-form__field-upload floating-label">
                    <label for="uploadInputElm_${formID}" class="bricks-form__label">${RDStationFormConfig.uploadFieldLabel}</label>
                    <input name="fileupload[]" multiple id="uploadInputElm_${formID}" type="file" class="FormFileUpload__Input" aria-invalid="false" data-allowed-mine-types-list="${RDStationFormConfig.allowedMineTypesList}" data-max-file-size="${RDStationFormConfig.maxFileSize}">
                    <div id="tmpUploadArea_${formID}"></div>
                    <pre><label class="Form__Element__ValidationError error"></label></pre>
                </div>`;

            if(privacyElm)
                privacyElm.insertAdjacentHTML("beforebegin", strAppend);
            else
                RDForm.querySelector(".bricks-form__fieldset").insertAdjacentHTML("beforeend", strAppend);

            let _GTFileUpload = new GT.FileUpload("#uploadInputElm_"+ formID);
            _GTFileUpload.allowUploadMaxItemLabel = RDStationFormConfig.invalidFileQuantity.replace("{0}", RDStationFormConfig.maxFile);
            _GTFileUpload.invalidMineTypes = RDStationFormConfig.invalidMineTypes;
            _GTFileUpload.invalidFileSize = RDStationFormConfig.invalidFileSize;
            _GTFileUpload.maxFile = RDStationFormConfig.maxFile;

            _GTFileUpload.onChange = function(files){
                let tmpUploadArea = RDForm.querySelector("#tmpUploadArea_"+ formID);
                tmpUploadArea.innerHTML = "";
                Array.from(files).forEach(function(item, idx){
                    let reader = new FileReader();
                    // Closure to capture the file information.
                    reader.onload = (function() {
                        return function(evt) {
                            const htmlStr = '<input type="hidden" name="rdFiles[]" value="'+evt.target.result+'"/>' + '<input type="hidden" name="rdFileNames[]" value="'+item.name+'"/>';
                            tmpUploadArea.insertAdjacentHTML("afterbegin", htmlStr);
                        };
                    })(item);

                    // Read in the image file as a data URL.
                    reader.readAsDataURL(item);
                })
            }
        }

        // Cannot use the other ID: validateCaptcha, GRecaptcha will ignore the custom error label
        // Duplicated ID issue!
        RDForm.querySelector(".bricks-form__fieldset").insertAdjacentHTML("beforeend", `
            <div class='bricks-form__field custom-recaptcha'>
                <div class='g-recaptcha-container'></div>
                <input type='checkbox' tabindex='-1' required class='required' name='validateCaptcha' value=1 id='validateCaptcha'/>
                <label id='validateCaptcha-error' class='error' style='display:none' for='validateCaptcha'>${RDStationFormConfig.errorMsg}</label>
            </div>
        `);

        RDForm.querySelector(".bricks-form__fieldset").insertAdjacentHTML("beforeend", "<input type='hidden' name='cmsPageId' value='"+ RDStationFormConfig.cmsPageId +"'/>");
        
        setTimeout(checkBlockedEmailDomain, 500);

        function checkBlockedEmailDomain() {
            if(!RDStationFormConfig.emailDomainsBlocked) return;

            let _emailInput = RDForm.querySelector("[type=email]");
            let _blockEmailChkContainer = `
                <input type='hiden' tabindex='-1' required class='required blocked-email__domain' name='blockedemaildomain' id='blockedemaildomain_${formID}'/>
                <label id='blockedemaildomain-msg_${formID}' class='blockedemaildomain-msg error' style='display:none' for='blockedemaildomain_${formID}'>${RDStationFormConfig.errorBlockEmailMsg}</label>
            `;
            _emailInput.closest('.bricks-form__field').insertAdjacentHTML("beforeend", _blockEmailChkContainer);
            checkValidEmailDomain(_emailInput);
            _emailInput.addEventListener("blur", function(){
                checkValidEmailDomain(_emailInput);
            });
        }

        function checkValidEmailDomain(_emailInput) {

            let _emailAddress = _emailInput.value;
            if(!_emailAddress) return;
            // Email block domain function
            let _emailDomainStr = RDStationFormConfig.emailDomainsBlocked.replace(/\s/g, "");
            let _emailDomainArr = _emailDomainStr.split(',');
            if(_emailDomainArr.length <= 0) return;

            let _blockEmailChk = RDForm.querySelector('input[name="blockedemaildomain"]');
            let _blockedemaildomainMsg = RDForm.querySelector('label.blockedemaildomain-msg');
            let _currentEmailDomain = _emailAddress.split('@');
            if(_currentEmailDomain.length < 2) return;
            _currentEmailDomain = _currentEmailDomain[1].trim();
            let _submitBtn = RDForm.querySelector(".bricks-form__submit button");
            if(_currentEmailDomain.indexOf(".") == -1) {
                if(_submitBtn) _submitBtn.click();
                return;
            }
            if(_emailDomainArr.includes(_currentEmailDomain)) {
                if(_blockEmailChk) _blockEmailChk.value = '';
                _emailInput.classList.remove('valid');
                _emailInput.classList.add('error');
                _emailInput.focus();
                if(_blockedemaildomainMsg) _blockedemaildomainMsg.style.display = "block";
                return;
            } else {
                if(_blockEmailChk) _blockEmailChk.value = _emailDomainStr;
                _emailInput.classList.remove('error');
                _emailInput.classList.add('valid');
                if(_blockedemaildomainMsg) _blockedemaildomainMsg.style.display = "none";

                let divideNumber = typeof RDStationFormConfig.numberOfFieldsPerStep == "undefined" ? 0 : RDStationFormConfig.numberOfFieldsPerStep;
                if(divideNumber > 0) {
                    if(_submitBtn) _submitBtn.click();
                    return;
                }
            }
        }

        let divideNumber = typeof RDStationFormConfig.numberOfFieldsPerStep == "undefined" ? 0 : RDStationFormConfig.numberOfFieldsPerStep;
        if(divideNumber > 0) {
            let currentStep = 0,
                allFields = RDForm.querySelectorAll(".bricks-form__fieldset .bricks-form__field"),
                totalFields = allFields.length,
                totalSteps = Math.round(totalFields / divideNumber),
                nextLabel = RDStationFormConfig.nextStep ? RDStationFormConfig.nextStep : "Next",
                backLabel = RDStationFormConfig.backStep ? RDStationFormConfig.backStep : "Back";

            if(totalSteps > 1) {
                RDForm.classList.add("mutiple-steps");
                RDForm.querySelector(".bricks-form__submit").insertAdjacentHTML("afterbegin", "<div tabindex='0' class='bricks--component bricks--component-button rd-button nav-rd-btn back-btn' role='button'>"+backLabel+"</div><div class='bricks--component bricks--component-button nav-rd-btn rd-button next-btn' role='button' tabindex='0'>"+nextLabel+"</div>");
                RDForm.querySelector(".bricks-form__submit").classList.add("custom-submit");


                let nextBtn = RDForm.querySelector(".next-btn"),
                    backBtn = RDForm.querySelector(".back-btn"),
                    submitBtn = RDForm.querySelector(".bricks-form__submit button");
                   
                backBtn.classList.add("visually-hidden");
                submitBtn.classList.add("visually-hidden");

                function focusOnFirstElm(e){
                    if(e) {
                        let firstFocusableElm = RDForm.querySelector(".bricks-form__fieldset .bricks-form__field:not(.hide-rd-field) [name]");
                        if(firstFocusableElm)
                            firstFocusableElm.focus();
                    }
                }

                function nextBtnHandler(e){
                    setTimeout(function(){
                        if(isValid()) {
                            displayFields();
                            if(currentStep >= totalSteps) {
                                nextBtn.classList.add("visually-hidden");
                                submitBtn.classList.remove("visually-hidden");
                            } else {
                                submitBtn.classList.add("visually-hiddenx");
                            }
                            backBtn.classList.remove("visually-hidden");
                            focusOnFirstElm(e);
                        } else {
                            submitBtn.click();
                        }
                    }, 50);
                }

                function backBtnHandler(e){
                    displayFields(true);
                    if(currentStep <= 1) {
                        backBtn.classList.add("visually-hidden");
                    }
                    submitBtn.classList.add("visually-hidden");
                    nextBtn.classList.remove("visually-hidden");
                    focusOnFirstElm(e);
                }

                nextBtn.addEventListener("keypress", function(e){
                    if(e.key == "Enter")
                        nextBtnHandler(e);
                })
                nextBtn.addEventListener("click", function(){
                    nextBtnHandler();
                })
                   
                backBtn.addEventListener("keypress", function(e){
                    if(e.key == "Enter")
                        backBtnHandler(e);
                })
                   
                backBtn.addEventListener("click", function(){
                    backBtnHandler();
                })

                submitBtn.addEventListener("click", function(){
                    setTimeout(function(){
                        if(RDForm.querySelector('[name].error')) {
                            let errorElm = RDForm.querySelector('[name].error').closest(".bricks-form__field");
                            if(errorElm) {
                                const errorIdx = parseInt(errorElm.dataset.index) + 1;
                                const targetStep = Math.ceil(errorIdx / divideNumber);
                                if(targetStep < currentStep) {
                                    displayFields(null, targetStep);
                                    if(targetStep == 1)
                                        backBtn.classList.add("visually-hidden");
                                    submitBtn.classList.add("visually-hidden");
                                    nextBtn.classList.remove("visually-hidden");
                                }
                            }
                        }
                    }, 500);
                })

                displayFields();

                function displayFields(isBack, _currentStep){
                    if(!_currentStep) {
                        if(isBack)
                            currentStep--;
                        else
                            currentStep++;
                    } else {
                        currentStep = _currentStep;
                    }

                    let minPoint = (currentStep - 1) * divideNumber,
                        maxPoint = currentStep * divideNumber;
                    allFields.forEach(function(item, idx) {
                        if(((idx < maxPoint  && currentStep < totalSteps) || (currentStep >= totalSteps)) && idx >= minPoint) {
                            item.classList.remove("hide-rd-field");
                        } else {
                            item.classList.add("hide-rd-field");
                        }
                        item.dataset.index = idx;
                    })
                }

                function isValid() {
                    let minPoint = (currentStep - 1) * divideNumber,
                        maxPoint = currentStep * divideNumber,
                        _isValid = true;
                    allFields.forEach(function(item, idx) {
                        if(((idx < maxPoint  && currentStep < totalSteps) || (currentStep >= totalSteps)) && idx >= minPoint) {
                            let inputElm = item.querySelector('[name]');
                            if(inputElm && (!inputElm.validity.valid || inputElm.classList.contains('error'))) {
                                _isValid = false;
                                if(inputElm.type == "email") {
                                    validEmailElm(inputElm);
                                }
                            }

                            let _blockedEmailDomain = item.querySelector('input[name="blockedemaildomain"]');
                            if(_blockedEmailDomain && _blockedEmailDomain.classList.contains('error')) {
                                _isValid = false;
                            }

                            if(inputElm.type == "tel") {
                                let minTelLength = 18;//default for Brazil
                                if(inputElm.dataset.country != "BR") {
                                    minTelLength = inputElm.dataset.lastCountryCode.length + 10;// "+ ".length + [country code].length + 8
                                }
                                if(inputElm.value.length < minTelLength) {
                                    _isValid = false;
                                    setTimeout(function(){
                                        let realErrorLabel = inputElm.closest(".bricks-form__field").querySelector('label.error[for]');
                                        if(realErrorLabel) {
                                            realErrorLabel.style.display = "block";
                                        }
                                    }, 500)
                                }
                            }
                        } else {
                            if(item.querySelector('label.error:not(.blockedemaildomain-msg)')) {
                                item.querySelector('label.error:not(.blockedemaildomain-msg)').remove();
                            }
                            let _blockedEmailDomainChk =  RDForm.querySelector('input[name="blockedemaildomain"]');
                            if(_blockedEmailDomainChk && _blockedEmailDomainChk.value.length <= 0) {
                                let _inputEmail = _blockedEmailDomainChk.closest('.bricks-form__field').querySelector('input[type="email"]');
                                if(_inputEmail) {
                                    _inputEmail.classList.add('error');
                                    _inputEmail.classList.remove('valid');
                                    _inputEmail.focus();
                                }
                                return false;
                            } else {
                                if(item.querySelector('.error:not(.blockedemaildomain-msg)') && item.querySelector('.error:not(input[name="blockedemaildomain"])')) {
                                    item.querySelector('.error').classList.remove("error");
                                }
                            }
                        }
                    })
                    return _isValid;
                }

                //check UTF-8 characters
                function validEmailElm(emailElm){
                    if(!emailElm.validationMessage) {
                        let _emailErrorMsgElm = emailElm.closest(".bricks-form__field").querySelector('label.email-validate__failed');
                        if(_emailErrorMsgElm) _emailErrorMsgElm.remove();
                        let _emailBlockedErrorMsgElm = emailElm.closest(".bricks-form__field").querySelector('label.blockedemaildomain-msg');
                        setTimeout(function() {
                            if(_emailBlockedErrorMsgElm.style.display == "none") {
                                emailElm.classList.remove("error");
                                emailElm.classList.add('valid');
                            } else {
                                emailElm.classList.remove('valid');
                                emailElm.classList.add("error");
                            }
                        }, 50);

                        let domainEmail = emailElm.value.split('@');
                        if(domainEmail.length > 1 && domainEmail[1].indexOf(".") == -1) {
                            submitBtn.click();
                        }
                        return;
                    }

                    setTimeout(function(){
                        if(!emailElm.classList.contains('error'))
                            emailElm.classList.add('error');
                
                        let realErrorLabel = emailElm.closest(".bricks-form__field").querySelector('label.error[for]:not(.blockedemaildomain-msg)');
                        if(!realErrorLabel) {
                            if(!emailElm.nextElementSibling)
                                emailElm.insertAdjacentHTML("afterend", '<label generated="true" class="email-validate__failed error">'+ emailElm.validationMessage +'</label>');
                            else
                                emailElm.nextElementSibling.style.display = "block";
                        } else {
                            if(emailElm.nextElementSibling && !emailElm.nextElementSibling.getAttribute("for")) {
                                let _nextElm = emailElm.nextElementSibling;
                                if(_nextElm.name != 'blockedemaildomain') emailElm.nextElementSibling.remove();
                            }

                            if(!realErrorLabel.dataset.errStr) {
                                realErrorLabel.dataset.errStr = realErrorLabel.innerHTML;
                            }
                            realErrorLabel.innerHTML = realErrorLabel.dataset.errStr + " ("+ emailElm.validationMessage +")";
                            realErrorLabel.style.display = "block";
                        }
                    }, 500)
                }

                let emailElm = RDForm.querySelector("[type=email]");
                if(emailElm) {
                    emailElm.addEventListener("blur", function(){
                        validEmailElm(emailElm);
                    })
                }
            }
        }
    }
}


GT.domContentLoadedFncList.push(function(){
    GT.RDStationForms();
});
GT.RangeSlider = function () {
    document.querySelectorAll('input[type="range"]').forEach(function(item){
        let tooltipTitle = item.getAttribute("title");
        if(tooltipTitle) {
            item.insertAdjacentHTML('afterend', '<div class="rangeslider-tooltip"><span class="tooltip-value">'+ tooltipTitle +'</span><span class="down-arrow"></div>');
            item.setAttribute("title", "");
        }
        item.insertAdjacentHTML('afterend', '<span class="rangeslider__value"></span>');
    })
    document.querySelectorAll('input[type="range"]').forEach(function(item){
        let formRangeWrapper = item.closest(".FormRange__Wrapper");
        if(formRangeWrapper) {
            currentValueElm = formRangeWrapper.querySelector(".rangeslider__value");
            currentValueElm.innerText = item.value;
            item.addEventListener("input", function(e){
                e.target.nextElementSibling.innerText = e.target.value;
            })

            function moveTooltipPoint(e) {
                let toolTipElm  = e.target.nextElementSibling.nextElementSibling;
                if(toolTipElm.querySelector(".down-arrow")) {
                    let toolTipPointElm = toolTipElm.querySelector(".down-arrow");
                    let left = e.offsetX < 10 ? 10 : e.offsetX - 5;
                    left = left > toolTipElm.offsetWidth - 20 ? left - 20 : left;
                    toolTipPointElm.style.left = left + "px";
                }
            }

            item.addEventListener("mouseenter", function(e){
                moveTooltipPoint(e);
            })
            
            item.addEventListener("touchstart", function(e){
                moveTooltipPoint(e);
            })
        }
    })
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.RangeSlider();
    });

GT.Reach = function() {
    let htmlElm = document.firstElementChild;
    let globalReachElm = htmlElm.querySelector(".global-reach");
    if (!globalReachElm) return;
    let isInited = false;
    let globalReachToggleBtn = GT.headerElm.querySelector(".global-reach__toggle");
    let globalReachTabElms = globalReachElm.querySelectorAll('.reach-region-selector li');
    let isDesktop = GT.isDesktopView();
        
    if(typeof isNav3 == "undefined") {
        globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
    }

    function disableScroll(isDisable){
        if(GT.isTabletView()) {
            if(isDisable) {
                typeof isNav3 != "undefined" && GT.Overlays.showHeaderOverlay();
                htmlElm.classList.add("global-reach--opening");
                GT.headerElm.querySelector(".menu-link.open")?.classList.remove("open");
            } else {
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                GT.headerElm.style.setProperty("--globalreach-height", 0);
                GT.headerElm.classList.remove("trigger-animation");
                htmlElm.classList.remove("global-reach--opening");
                setTimeout(() => {
                    typeof isNav3 != "undefined" && GT.Overlays.hideHeaderOverlay();
                }, 350);
            }
        }

        if(!isDisable)
            setTimeout(e => {
                globalReachToggleBtn?.focus();
            }, 1000)
    }

    function calcActivatedTabHeight() {
        GT.headerElm.style.setProperty("--globalreach-height", globalReachElm.querySelector(".global-reach__list.active")?.offsetHeight + "px");
    }

    function initReachToggle() {
        if(globalReachToggleBtn.dataset.inited)
            return;

        globalReachToggleBtn.dataset.inited = true;

        function pressESCToClose(e){
            if(e.key == "Escape") {
                globalReachToggleBtn.click();
            }
        }
        
        const globalReachHeadTitle = globalReachElm.querySelector('.global-reach__head .title');

        globalReachHeadTitle?.addEventListener('keydown', tabify);

        globalReachToggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // if ($(e.target).hasClass('lang-dropdown-arrow')) {
            //     e.stopPropagation();
            //     return;
            // }
            
            let closeMegaNav2Btn = document.querySelector(".close-mega__menu");
            if(GT.isNav2 && closeMegaNav2Btn && GT.wWidth >= GT.breakPoints.tablet_lg) {
                closeMegaNav2Btn.click();
            }

            if (globalReachElm.classList.contains("open")) {
                globalReachElm.classList.remove("open");
                globalReachToggleBtn.setAttribute("aria-expanded", false);
                globalReachElm.setAttribute("aria-hidden", true);
                disableScroll();
                window.removeEventListener("keydown", pressESCToClose);
            } else {
                window.addEventListener("keydown", pressESCToClose);
                globalReachElm.classList.add("open");
                globalReachElm.removeAttribute("aria-hidden");
                globalReachToggleBtn.setAttribute("aria-expanded", true);
                
                globalReachTabElms.forEach(tabItem => {
                    if(!isInited) {
                        tabItem.addEventListener("click", tabify);
                        tabItem.addEventListener("keydown", tabify);
                    }
                    
                    if(GT.isMobileCached) {
                        tabItem.setAttribute("tabindex", 0);
                        tabItem.setAttribute("aria-expanded", false);
                    } else {
                        tabItem.setAttribute("role", "tab");
                        tabItem.setAttribute("aria-selected", false);
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);

                        if(tabItem.classList.contains("active")) {
                            tabItem.setAttribute("tabindex", 0);
                            tabItem.setAttribute("aria-selected", true);
                            tabItem.closest("ul").setAttribute("role", "tablist");
                            if(!isInited) {
                                setTimeout(() => {
                                    TabPanelActionHandler(tabItem.closest("ul"));
                                }, 500);
                            }
                        }
                    }
                })


                if(!isInited) {
                    GT.headerElm.classList.add("fetching");
                    isInited = true;
                    
                    globalReachElm.querySelector('.global-reach__close').addEventListener("click", () => {
                        globalReachElm.classList.remove("open");
                        globalReachElm.setAttribute("aria-hidden", true);
                        globalReachToggleBtn.setAttribute("aria-expanded", false);
                        disableScroll();
                    });


                    httpService = new HttpService();
                    httpService.getHtmlContent(globalReachLink, null, {"Content-type": "application/x-www-form-urlencoded"}, true).then(response => {

                        let globalReachRegionsMoileLV1Elm = document.querySelector(".mobile__global--level-1 .list");
                        if(globalReachRegionsMoileLV1Elm)
                            globalReachRegionsMoileLV1Elm.classList.remove("hide");

                        globalReachElm.querySelector("#global-reach-regions").insertAdjacentHTML("beforeend", `
                            <div class="translate-animation-item slow">
                                <div class="global-reach__content">
                                    ${response}
                                </div>
                            </div>
                        `);
                        GT.hideHyperLinkAnimation();
                        calcActivatedTabHeight();
                        setTimeout(function() {
                            GT.headerElm.classList.add("trigger-animation");
                        }, 100);
                        GT.GTMGlobal.megaMenu();
                    })
                    .catch((rej) => {
                        isInited = false;
                    })
                    .finally(() => {
                        GT.headerElm.classList.remove("fetching");
                    });

                } else {
                    GT.headerElm.classList.add("trigger-animation");
                    calcActivatedTabHeight();
                }

                disableScroll(true);
                setTimeout(function() {
                    globalReachElm.querySelector(".global-reach__head a")?.focus();
                    linkHandle();
                }, 1000);
            }
        });

    }


    function tabify(e) {
        if (e.key != "Tab") {
            e.preventDefault();
        }

        if (e.key == "Tab" && isDesktop) {
            const target = e.target;
            const activeLinks = globalReachElm.querySelectorAll('.global-reach__list.active .local-site-link');
            const lastActiveLink = activeLinks[activeLinks.length - 1];

            if (e.shiftKey && target.closest('.global-reach__head') && lastActiveLink) {
                e.preventDefault();
                lastActiveLink.focus();
            }
        }

        if (!e.keyCode || e.key == "Enter" || e.key == " ") {
            GT.hideHyperLinkAnimation();
            const currentTab = e.target,
                activeEl = currentTab.dataset.tab;

            if (!currentTab.classList.contains("active")) {
                globalReachTabElms.forEach(tabItem => {
                    tabItem.setAttribute("aria-selected", false);
                })

                if(!GT.isMobileCached) {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);
                    })
                    currentTab.setAttribute("tabindex", 0);
                    currentTab.setAttribute("aria-selected", true);
                } else {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.setAttribute("aria-expanded", false);
                    })
                    currentTab.setAttribute("aria-expanded", true);
                }

                setTimeout(() => {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.classList.remove("active");
                    })
                    currentTab.classList.add("active");

                    document.querySelectorAll(".global-reach .global-reach__list").forEach(listPanelItem => {
                        listPanelItem.classList.remove("active");
                        
                        if (listPanelItem.classList.contains(activeEl)) {
                            listPanelItem.classList.add("active");
                            calcActivatedTabHeight();
                            if(GT.isScreenReader && GT.isMobileCached)
                                setTimeout(e => {
                                    document.querySelector(".global-reach__list.active a")?.focus();
                                }, 500)
                        }
                    })
                }, GT.isMobileCached ? 500 : 0)
            }
        }
    }

    function linkHandle() {
        document.querySelectorAll('.global-reach__list a').forEach(item => {
            let parentElm = item.closest('li');
            item.addEventListener('keydown', function(e) {
                if (e.key == 'Tab' && !e.shiftKey && !parentElm.nextElementSibling) {
                    e.preventDefault();
                    document.querySelector('.global-reach__head .title').focus();
                }
            });
        });
    }

    initReachToggle();
    
    GT.windowResizeFncList.globalReach = function(){
        if(htmlElm.classList.contains("global-reach--opening"))
            globalReachToggleBtn.click();

        if(typeof isNav3 == "undefined") {
            globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
        }
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.Reach();
})
GT.ReadMore = function ($readMoreBlock) {
    var DATA_KEY = {
        READMORE_ENABLED: 'readmore-enabled',
        BLOCK_ID: 'block-id',
        MOBILE_HEIGHT: 'mobile-height',
        DESKTOP_HEIGHT: 'desktop-height'
    };
    var READMORE_STORAGE_KEY = 'readmore-states';
    var SELECTORS = {
        HINT: '.readmore_hint',
        CONTENT: '.readmore_content',
        COVER: '.readmore_cover',
        TEXTBLOCK: '.textblock',
        TINYMCE: '.tinymce-wrapper'
    };
    var COLLAPSING_CLASS = 'collapsing';
    var MAX_HEIGHT_PROP = 'max-height';
    var PIXEL = 'px';
    var ANIMATION_DURATION = 'slow';
    const noMaxHeight = 9999;

    function closingCover(readMoreBlock) {
        return function () {
            var $cover = $(readMoreBlock).find(SELECTORS.COVER)
            $cover.animate({ opacity: 0 }, {
                duration: ANIMATION_DURATION,
                done: function () {
                    $cover.remove();
                }
            });
        }
    }

    function getIsExpandingById(blockId) {
        var readmoreState = JSON.parse(localStorage.getItem(READMORE_STORAGE_KEY));
        readmoreState = readmoreState ? readmoreState : {};
        return readmoreState && readmoreState[blockId] || false;
    }

    function setIsExpandingById(blockId, isExpanding) {
        var readmoreState = JSON.parse(localStorage.getItem(READMORE_STORAGE_KEY));
        readmoreState = readmoreState ? readmoreState : {};
        var newState = {};
        newState[blockId] = isExpanding;
        readmoreState = $.extend({}, readmoreState, newState);
        localStorage.setItem(READMORE_STORAGE_KEY, JSON.stringify(readmoreState));
    }

    $readMoreBlock.each(function () {
        var _currentReadmoreBlock = this;
        var isReadMoreEnabled = $(_currentReadmoreBlock).data(DATA_KEY.READMORE_ENABLED);
        var $readmoreHint = $(_currentReadmoreBlock).find(SELECTORS.HINT);
        var $readmoreContent = $(_currentReadmoreBlock).find(SELECTORS.CONTENT);
        let focussableElements = [];
        let isByTabbing = false;

        if (!$readmoreContent.length) {
            return;
        }
        if (!isReadMoreEnabled) {
            $readmoreContent.removeClass(COLLAPSING_CLASS)
            return;
        }
        if (!$readmoreHint.length) {
            return;
        }
        var blockId = $readmoreHint.data(DATA_KEY.BLOCK_ID);
        if (!blockId) {
            return;
        }
        var isExpanding = _currentReadmoreBlock.dataset.reset == "true" ? false : getIsExpandingById(blockId);

        var isMobile = GT.isMobile();

        function expand(isExpandByUser) {
            isExpanding = true;
            $readmoreContent.parents('.readmore')?.removeClass('show-hint');
            setIsExpandingById(blockId, isExpanding);
            // $readmoreHint.attr("aria-expanded", "true");
            $readmoreHint.remove();
            $readmoreContent.animate({ maxHeight: "9999px" }, {
                duration: ANIMATION_DURATION,
                start: closingCover(_currentReadmoreBlock),
                done: function () {
                    $readmoreContent.removeClass(COLLAPSING_CLASS).css(MAX_HEIGHT_PROP, '');
                    $readmoreContent.attr("role", "article");
                    $readmoreContent.attr("tabindex", "0");
                    focussableElements.forEach(function(focussableElement, focussableElementIdx){
                        focussableElement.setAttribute("tabindex", "0");
                    })
                    if(isExpandByUser)
                        $readmoreContent.focus();
                }
            });
        }

        function isHeading(item) {
            return /^h[1-6]$/.test(item.tagName.toLowerCase());
        }

        function setHeightByLines() {
            const tinymceBlock = _currentReadmoreBlock.querySelector(SELECTORS.TINYMCE);

            if (!tinymceBlock) {
                return;
            }

            let totalHeight = 0;
            let maxLines = 3;
            const childElms = tinymceBlock.querySelectorAll("*");
            let listOfFullWidthElms = [];

            if(childElms.length == 1 && isHeading(childElms[0]))
                return 9999;

            childElms.forEach((item) => {
                const styles = window.getComputedStyle(item);
                if(styles.display.indexOf("inline") == -1 && styles.display.indexOf("none") == -1) {
                    listOfFullWidthElms.push({elm: item, styles: styles});
                }
            })

            listOfFullWidthElms.forEach((obj, idx) => {
                if(maxLines > 0) {
                    const item = obj.elm;
                    const styles = obj.styles;
                    let heightOfMT = parseInt(styles.marginTop);
                    let heightOfPT = parseInt(styles.paddingTop);
                    let spacing = 0;
                    spacing += heightOfMT;
                    spacing += heightOfPT;
                    spacing += parseInt(styles.paddingBottom);
                
                    if(heightOfPT && idx > 0) {
                        let prevStylesElm = listOfFullWidthElms[idx - 1].styles;
                        spacing += parseInt(prevStylesElm.marginBottom);
                    }
                    totalHeight += spacing;

                    
                    if(item.firstChild.textContent.trim() != "") {
                        const numberLines = GT.getNumberLineContent(item);
                        const isFirstHeading = isHeading(item) && idx == 0;
                        const heightOfElm = GT.getLineHeight(item) * (isFirstHeading ? numberLines : Math.min(maxLines, numberLines));
                        !isFirstHeading && (maxLines -= numberLines);
                        totalHeight += heightOfElm;
                    }
                }
            })

            if(maxLines > 0) totalHeight = noMaxHeight;

            return totalHeight;
        }

        function collapse() {
            let isIBCDListingPage = document.querySelector(".icb-listing-page");
            var restrictedHeight = isIBCDListingPage ? 156 : 200; // Fallback value 4 lines
            let textBlock = _currentReadmoreBlock.closest(SELECTORS.TEXTBLOCK);
            if(!isIBCDListingPage) {
                if (textBlock) {
                    restrictedHeight = setHeightByLines();
                }  else {
                    restrictedHeight = $readmoreHint.data(isMobile ? DATA_KEY.MOBILE_HEIGHT : DATA_KEY.DESKTOP_HEIGHT) || restrictedHeight;
                }
            }
            $readmoreContent.css(MAX_HEIGHT_PROP, restrictedHeight + PIXEL);
            focussableElements.forEach(function(focussableElement){
                focussableElement.setAttribute("tabindex", "-1");
            })
        }

        // Only show read more icon when height content larger than max-height in setting of block.
        isShowReadmoreIcon();
        // Adopting initial state
        if (isExpanding) {
            // Expanding (Not showing readmore)
            expand();
        } else {
            // Collapsing (Showing readmore)
            collapse();
        }

        focussableElements = $readmoreContent[0].querySelectorAll('a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])');
        Array.prototype.slice.call(focussableElements).forEach(function(focussableElement){
            focussableElement.setAttribute("tabindex", "-1");
        })
        
        // Reacting to click event
        $readmoreHint.on('click', function () {
            if (!isExpanding) {
                expand(true);
            }
        });
        
        $readmoreHint.on('keydown', function (e) {
            if (e.keyCode == 13 && !isExpanding) {
                expand(true);
            }
        });

        function isShowReadmoreIcon() {
            const heightKey = isMobile ? DATA_KEY.MOBILE_HEIGHT : DATA_KEY.DESKTOP_HEIGHT;
            restrictedHeight = $readmoreHint.data(heightKey) || restrictedHeight;

            let textBlock = _currentReadmoreBlock.closest(SELECTORS.TEXTBLOCK);

            if (textBlock && setHeightByLines())  {
                restrictedHeight = setHeightByLines() || restrictedHeight;
            }

            // Default max-height for collapsing class is 300px
            if(restrictedHeight != noMaxHeight && ($readmoreContent.outerHeight() >= restrictedHeight || $readmoreContent.outerHeight() >= 300)) {
                $readmoreContent.parents('.readmore').addClass('show-hint');
            } else {
                $readmoreContent.parents('.readmore').removeClass('show-hint');
            }
        }
        
        // Reacting to resize event
        $(window).on('resize', GT.debounce(function () {
            if (isExpanding) {
                return;
            }

            isShowReadmoreIcon();
            
            var newIsMobile = GT.isMobile();
            if (isMobile !== newIsMobile) {
                isMobile = newIsMobile;
                collapse();
            }
        }, 250 /* debounce time in milisecond */));
    });
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.ReadMore($('.readmore[data-readmore-enabled]'));
    });

GT.GTReaderView = function ($element) {

    function getURL(relativeFile) {
        return "/resources/readerview/" + relativeFile;
    }

    function getResourceVIURL(relativeFile) {
        return "/dist/" + relativeFile;
    }

    // Return preloader html
    function getPreloader() {
        var fetchingContentsText = $("#hdfFetchingContents").val();
        var preloader = "<div id='cr-pre-loader' style='width: 250px;height: 100px;text-align: center;font-family: Arial,Helvetica,sans-serif;font-weight: 200;color: #c1c1c1;letter-spacing: 0.5;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%); /* for IE 9 */-webkit-transform: translate(-50%, -50%); /* for Safari */'>"
            + "<style>@keyframes pulse {0% { transform: scale(0.95);box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3); } 70% { transform: scale(1);box-shadow: 0 0 0 10px rgba(0, 0, 0, 0); } 100% { transform: scale(0.95);box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); }}</style>"
            + "<div class='blobs-container text-center' style='margin: 0px auto;margin-bottom: 30px;width: 50px;'>"
            + "<div class='blob' style='background: #dddddd;border-radius: 50%;margin: 10px;height: 20px;width: 20px;box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);transform: scale(1);animation: pulse 2s infinite;'></div></div>"
            + "<p>" + fetchingContentsText + "</p></div>";

        return preloader;
    }

    // Added pre-loader
    function startPreloader(doc) {
        var preloader = getPreloader();
        $(doc).find("body").prepend(preloader);
    }

    // Create iframe
    function createIframe() {
        var iframe = document.createElement('iframe');
        iframe.id = "cr-iframe";
        iframe.style.height = "100%";
        iframe.style.width = "100%";
        iframe.style.position = "fixed";
        iframe.style.top = "0px";
        iframe.style.right = "0px";
        iframe.style.zIndex = "9000000000000000000";
        iframe.style.backgroundColor = "#fff";

        var preloader = getPreloader();
        $(iframe).contents().find('body').html(preloader);

        return iframe;
    }

    // Add styletag to iframe
    function addStyleTags(doc) {
        var isRightToLeft = $("#isRightToLeft").val();
        var styleUrls = [];
        if (isRightToLeft === "True") {
            styleUrls = [
                getResourceVIURL("css/screen-0-inline-rtl.css"),
                getResourceVIURL("css/screen-1st-rtl.css"),
                getResourceVIURL("css/screen-2nd-rtl.css")
            ];
        } else {
            styleUrls = [
                getResourceVIURL("css/screen-0-inline.css"),
                getResourceVIURL("css/screen-1st.css"),
                getResourceVIURL("css/screen-2nd.css")
            ];
        }
        var inlineStyles = $('style');
        var stylesTags = $('link[rel="stylesheet"]');
        inlineStyles.each(function() {
            $(doc).find('head').append("<style>" + $(this).html() + "</style>");
        });
        stylesTags.each(function() {
            if($(this).attr('href')) {
                $(doc).find('head').append("<link rel='stylesheet' type='text/css' href='" + $(this).attr('href') + "'>");
            }
        });
    }

    function addFonts(doc) {
        var fontUrl = "";
        fontUrl = getResourceVIURL("fonts/GT-Walsheim-Pro-Regular/GT-Walsheim-Pro-Regular.woff");
        $(doc).find('head').append("<link rel='preload' as='font' type='font/woff' crossorigin='anonymous' href='" + fontUrl + "'>");

        fontUrl = getResourceVIURL("fonts/GT-Walsheim-Pro-Medium/GT-Walsheim-Pro-Medium.woff");
        $(doc).find('head').append("<link rel='preload' as='font' type='font/woff' crossorigin='anonymous' href='" + fontUrl + "'>");

        fontUrl = getResourceVIURL("fonts/GT-Walsheim-Pro-Bold/GT-Walsheim-Pro-Bold.woff");
        $(doc).find('head').append("<link rel='preload' as='font' type='font/woff' crossorigin='anonymous' href='" + fontUrl + "'>");

        fontUrl = getResourceVIURL("fonts/GT-Walsheim-Pro-Bold-Oblique/GT-Walsheim-Pro-Bold-Oblique.woff");
        $(doc).find('head').append("<link rel='preload' as='font' type='font/woff' crossorigin='anonymous' href='" + fontUrl + "'>");

        fontUrl = getResourceVIURL("fonts/GT-IconSet/GT-IconSet.woff");
        $(doc).find('head').append("<link rel='preload' as='font' type='font/woff' crossorigin='anonymous' href='" + fontUrl + "'>");
    }

    function getParsedArticle() {
        var insightbanner = document.getElementsByClassName("insights-banner__block");
        var insightbannerHtml = '';
        if (insightbanner) {
            insightbannerHtml = insightbanner[0].outerHTML;
        }
        var insightmain = document.getElementsByClassName("t45-insights-page");
        var insightmainHtml = '';
        if (insightmain) {
            insightmainHtml = insightmain[0].innerHTML;
        }

        var excludeFromReaderView = document.querySelectorAll(".exclude-from-reader-view");
        if (excludeFromReaderView.length > 0) {
            for (var i = 0; i < excludeFromReaderView.length; i++) {
                insightmainHtml = insightmainHtml.replace(excludeFromReaderView[i].outerHTML, "");
            }
        }
        return insightbannerHtml + insightmainHtml;
    }

    function showAllAccordionContents() {
        // Show accordion item
        var accordion_items = $(".accordion-item__content");
        if (accordion_items.length > 0) {
            accordion_items.each(function () {
                var _this = $(this);
                if (_this.css("display") == "block") {
                    _this.addClass('showing');
                } else {
                    $(this).css('display', 'block');
                }
            });
        }
    }

    function resetAccordionContents() {
        var accordion_items = $(".accordion-item__content");
        if (accordion_items.length > 0) {
            accordion_items.each(function () {
                var _this = $(this);
                if (!_this.hasClass('showing')) {
                    _this.css('display', 'none');
                } else {
                    _this.css('display', 'block');
                    _this.removeClass('showing');
                }
            });
        }
    }

    function excludeParseArticleHtml() {
        var excludeSelector = [
            '.bookmark-sidebar',
            '.EPiServerForms',
            '.marketo-embed-form',
            '.add-to-reading-list',
            '.service-industry-subscription',
            '.t45-page--bottom',
            '.video-block',
            '.gt-dataTable-wrapper .dataTables_length',
            '.gt-dataTable-wrapper .dataTables_filter',
            '.gt-dataTable-wrapper .dataTables_paginate'
        ];
        for (var i = 0; i < excludeSelector.length; i++) {
            $(excludeSelector[i]).addClass('exclude-from-reader-view');
        }
    }

    function optionsMenu(iframe) {
        var doc = iframe.contentWindow.document;

        // Print
        $(doc).find("#options-print").click(function () {
            iframe.contentWindow.print();
        });

        // Close
        $(doc).find("#options-close").click(function () {
            $(iframe).hide();
            showElements();
        });
    }

    function init() {
        var closeReaderViewText = $("#hdfCloseReaderView").val();
        // Initialize iframe & doc
        var iframe = document.getElementById('cr-iframe');
        var doc = iframe.contentWindow.document;
        showAllAccordionContents();
        excludeParseArticleHtml();
        // Get parsed article
        var content = getParsedArticle();

        // Remove Media Playback from content
        content = content.replace("Media playback is unsupported on your device", "");
        $.ajax({
            url: getURL('insightpage-readerview.html'),
            type: 'GET',
            success: function (data) {
                var html = applyDir();
                // Add template to doc. Prevent injected links from refresh the iframe to original content
                doc.open();
                doc.write(html);
                doc.write(data);
                doc.close();

                // Add preloader the second time after template was fetched
                startPreloader(doc);
                $(doc).find("#cr-content").prepend(content);
                $(doc).find("#cr-content a").attr("target", "_blank");
                $(doc).find("#cr-content .article-summary a").removeAttr("href");
                $(doc).find("#cr-content #options-close").html(closeReaderViewText);

                // Add Font
                addFonts(doc);

                // Add style tag
                addStyleTags(doc);

                // Options
                optionsMenu(iframe);

                // key question
                expandKeyQuestions(iframe);

                // handle events
                handleEvents(iframe);

                // Display iframe
                $(iframe).show();
                setTimeout(function () {
                    $(doc).find("#cr-pre-loader").remove();
                    $(doc).find("#cr-body").fadeIn();
                }, 1000);
            }
        });
    }

    function handleEvents(iframe) {
        var doc = iframe.contentWindow.document;
        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) {
                $(iframe).hide();
                showElements();
            }
        });
        doc.addEventListener('keydown', function (e) {
            if (e.keyCode === 27) {
                $(iframe).hide();
                showElements();
            }
        });
        doc.addEventListener('click', function (e) {
            closeIframe(e, iframe);
        });
        doc.addEventListener('touchstart', function (e) {
            closeIframe(e, iframe);
        });
    }

    function closeIframe(e, iframe) {
        if (($(e.target).closest("#cr-content-container").attr("id") != "cr-content-container")) {
            $(iframe).hide();
            showElements();
        }
    }

    function expandKeyQuestions(iframe) {
        var doc = iframe.contentWindow.document;
        $(doc).find('.key-question').addClass("expanded");
        $(doc).find('.key-question .content-question').css("display", "block");
    }

    var latestUrl;
    function launch() {
        var iframe;
        // Detect past iframe - don't create another
        if (document.getElementById("cr-iframe") === null) {
            // Create iframe and append to body
            iframe = createIframe();

            document.body.appendChild(iframe);

            latestUrl = window.location.href;
            init();
            hideElements();
        } else {
            iframe = document.getElementById("cr-iframe");
            if ($(iframe).is(':visible')) {
                $(iframe).fadeOut();
                showElements();
            } else {
                // Only parse the article if the url was changed
                if (latestUrl === window.location) {
                    $(iframe).fadeIn();
                    hideElements();
                } else {
                    latestUrl = window.location.href;
                    init();
                    hideElements();
                }
            }
        }
    }

    function applyDir() {
        var html;
        var isRightToLeft = $("#isRightToLeft").val();
        if (isRightToLeft === "True") {
            html = "<!DOCTYPE html><html dir=" + "'rtl'>" +
                "<head></head>" +
                "<body></body></html>"
        } else {
            html = "<!DOCTYPE html><html>" +
                "<head></head>" +
                "<body></body></html>"
        }
        return html;
    }

    function hideElements() {
        document.getElementsByClassName("t45-insights-page")[0].style.display = "none";
        document.querySelector("footer").style.display = "none";
    }

    function showElements() {
        resetAccordionContents();
        document.getElementsByClassName("t45-insights-page")[0].style.display = "block";
        document.querySelector("footer").style.display = "block";
        GT.reInitScrollbar();
    }

    $(".reader-view-article__button").on('click', function (e) {
        e.preventDefault();
        GT.destroyScrollbar();
        launch();
    });

    $(".insight-page-print__button").on('click', function (e) {
        e.preventDefault();
        window.print();
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.GTReaderView();
    });
GT.Captcha = function (elem, obj) {
    var _ths = this;
    obj.settings = obj.settings || {};
    _ths.currentElem = elem;
    _ths.errorElem = null;
    _ths.widget = null;
    _ths.captchaChecked = false;
    _ths.tempPosition = 0;
    _ths.settings = {
        creator_container: obj.settings.creator_container || ".submit.submit-element", // true, false (added near form submit ) or selector string
        creator_where: obj.settings.creator_where || "before", // before, after, inside
        error_origin: obj.settings.error_origin || "selector", // from which origin get error message (variable, selector, etc...)
        error_variable: obj.settings.error_variable || null, // get error from variable if variable is set as origin (array of child nodes names or single string)
        error_selector: obj.settings.error_selector || null, // get error from selector
        error_value: obj.settings.error_value || "Captcha need to be checked", // default captcha error message
        error_containerSelector: obj.settings.error_containerSelector || ".g-recaptcha",
        error_where: obj.settings.error_where || "after", // before, after, inside
        key_origin: obj.settings.key_origin || "selector", // from which origin key should be get (variable, selector or false for default)
        key_value: obj.settings.key_value || null, // sitekey value or null
        key_variable: obj.settings.key_variable || null, // get key from variable if variable is set as origin (array of child nodes names or single string)
        key_selector: obj.settings.key_selector || "data-sitekey", // get key from selector
    }
    _ths.captcha = _ths.getReCaptchaElem();
    if (_ths.captcha !== null && _ths.captcha.length) {
        _ths.renderCaptcha(_ths.captcha[0]);
    }
};

GT.Captcha.prototype.isCaptchaChecked = function () {
    var _ths = this;
    if (_ths.recaptchaIsAvailable()) {
        return grecaptcha && grecaptcha.getResponse().length !== 0;
    }
    return true;
};

GT.Captcha.prototype.recaptchaIsAvailable = function () {
    var _ths = this;
    if (_ths.currentElem.hasClass('.g-recaptcha') || _ths.currentElem.find('.g-recaptcha').length) {
        return true;
    }
    return false;
};

GT.Captcha.prototype.getReCaptchaElem = function () {
    var _ths = this;
    if (_ths.currentElem.hasClass('g-recaptcha')) {
        return _ths.currentElem;
    } else if (_ths.currentElem.find('.g-recaptcha').length) {
        return _ths.currentElem.find('.g-recaptcha');
    } else {
        return _ths.createCaptcha(_ths.settings.creator_container, _ths.settings.creator_where);
    }
    return recaptchaElem;
};

GT.Captcha.prototype.getValueFromSelector = function (selectorObj) {
    var _ths = this;
    if (_ths.currentElem.attr(selectorObj)) {
        return _ths.currentElem.attr(selectorObj)
    } else {
        return _ths.currentElem.find("[" + selectorObj + "]").attr(selectorObj)
    }
};

GT.Captcha.prototype.getValueFromVariable = function (variableObj) {
    var _returnValue = "";
    var _tmp = window;
    if (typeof variableObj === "string" && window[variableObj]) {
        _returnValue = window[variableObj];
    } else if (Array.isArray(variableObj)) {
        for (var index in variableObj) {
            _tmp = _tmp[variableObj[index]];
        }
        if (_tmp) {
            _returnValue = _tmp;
        }
    }
    return _returnValue;
};

GT.Captcha.prototype.getValueFromOrigin = function (origin, selectorObj, variableObj, currentValue) {
    var _ths = this;
    var _tmp = null;
    switch (origin) {
        case "selector":
            return _ths.getValueFromSelector(selectorObj);
            break;
        case "variable":
            return _ths.getValueFromVariable(variableObj);
            break;
    }
    return currentValue;
};

GT.Captcha.prototype.createRecaptchaErrorMsg = function () {
    var _ths = this;
    var _error = _ths.settings.error_value;
    var _errorContainer = _ths.currentElem;
    var _errorElementInnerHTML = "";

    var errorElem = null;
    _error = _ths.getValueFromOrigin(_ths.settings.error_origin, _ths.settings.error_selector, _ths.settings.error_variable, _error)
    if (_ths.settings.error_containerSelector) {
        _errorContainer = _ths.currentElem.parent().find(_ths.settings.error_containerSelector);
    }

    _errorElementInnerHTML = '<div class="captcha-error error-msg hide">' + _error + '</div>';
    switch (_ths.settings.error_where) {
        case "before":
            errorElem = $(_errorElementInnerHTML).insertBefore(_errorContainer);
            break;
        case "after":
            errorElem = $(_errorElementInnerHTML).insertAfter(_errorContainer);
            break;
        default:
            errorElem = $(_errorContainer).append(_errorElementInnerHTML);
    }
    _ths.errorElem = errorElem;
    return errorElem;
};

GT.Captcha.prototype.showRecaptchaErrorMsg = function () {
    var _ths = this;
    if (!_ths.errorElem) {
        _ths.errorElem = _ths.createRecaptchaErrorMsg();
    }
    _ths.errorElem.removeClass("hide");
};

GT.Captcha.prototype.hideRecaptchaErrorMsg = function () {
    var _ths = this;
    if (_ths.errorElem) {
        _ths.errorElem.addClass("hide");
    }
};


GT.Captcha.prototype.getPositionInterval = function () {
    var _ths = this;
    setInterval(function () {
        _ths.tempPosition = $(document).scrollTop();
    }, 100);
};

GT.Captcha.prototype.createCaptcha = function (container, where) {
    var _ths = this;
    var _captchaInnerHTML = "";

    var $container = $(container);
    var captchaElem = null;
    if ($container.length) {
        _captchaInnerHTML = '<div class="g-recaptcha"></div>';
        switch (where) {
            case "before":
                $container.parent().prepend(_captchaInnerHTML);
                captchaElem = $container.parent().find('.g-recaptcha');
                break;
            case "after":
                $container.parent().append(_captchaInnerHTML);
                captchaElem = $container.parent().find('.g-recaptcha');
                break;
            default:
                $container.append(_captchaInnerHTML);
                captchaElem = $container.find('.g-recaptcha');
        }
    }
    return captchaElem;
};

GT.Captcha.prototype.verifyCallback = function () {
    var _ths = this;
    _ths.hideRecaptchaErrorMsg();
    _ths.captchaChecked = true;
    $('html, body').scrollTop(_ths.tempPosition);
};

GT.Captcha.prototype.renderCaptcha = function (element, retry) {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var _ths = this;
    var _retry = retry || 0;
    // wait for captcha till loaded, try up to 30 times;
    if ((typeof grecaptcha === "undefined" ||
        typeof grecaptcha.render === "undefined" ||
        typeof grecaptcha.getResponse === "undefined" ||
        typeof grecaptcha.reset === "undefined") &&
        _retry < 30) {
        setTimeout(function () {
            _ths.renderCaptcha(element, _retry);
        }, 100);
    } else {
        _ths.widget = grecaptcha.render(element, {
            'sitekey': _ths.getValueFromOrigin(
                _ths.settings.key_origin,
                _ths.settings.key_selector,
                _ths.settings.key_variable,
                _ths.settings.key_value),
            'callback': function () { _ths.verifyCallback() }
        });
        _ths.handleSubmit();
        _ths.createRecaptchaErrorMsg();
        _ths.getPositionInterval();
        _ths.orientationChange();
    }
};

GT.Captcha.prototype.orientationChange = function () {
    var _ths = this;
    $(window).on("orientationchange", function (event) {
        if (grecaptcha.getResponse(_ths.widget).length === 0) {
            grecaptcha.reset(_ths.widget);
        }
    });
};

GT.Captcha.prototype.handleSubmit = function () {
    var _ths = this;
    var _form = _ths.captcha.closest('form');
    _form.on('submit', function (e) {
        if (grecaptcha.getResponse(_ths.widget).length === 0) {
            e.preventDefault();
            _ths.showRecaptchaErrorMsg();
        }
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        [
            {
                elm: $('.g-recaptcha:not(.FormRecaptcha .g-recaptcha)'),
                settings: {
                    error_origin: "selector",
                    error_value: "",
                    error_selector: "data-captcha-error"
                }
            }
        ].map(function (item) {
            if (item.elm.length) {
                new GT.Captcha(item.elm, item);
            }
        })
    });

GT.Reveal = function ($elements, obj) {
    // var isMobile = GT.isMobile();
    // // $elements.forEach(elm => {
    // document.querySelectorAll(".reveal-item").forEach(function(childElm){
    //     if(isMobile)
    //         childElm.classList.add("use-banner-zoom");
    //     else
    //         childElm.classList.add("use-block-element-fade-in");
    // })
    // })
    // return;
    // var current = this;
    // if (typeof obj.settings === 'undefined') {
    //     obj.settings = {};
    // }

    // // SETTINGS
    // current.settings = $.extend({}, {
    //     animationType: 'fromBottom',
    //     dataDelay: 'reveal-delay',
    //     dataTransition: 'transition',
    //     customAnimation: null,
    //     rvlItemClass: null,
    // }, obj.settings);

    // // CREATE SCROLL REVEAL ANIMATION OBJECT
    // current.revealObj = ScrollReveal(current.settings.customAnimation || current.GetAnimation(current.settings.animationType));

    // // GET REVEAL ELEMENT AND REVEAL CONTAINER IF IT IS SET
    // current.rvlItemClass = current.settings.rvlItemClass;

    // // SEQUENCE ANIMATION IF CONTAINER IS SET
    // if (!GT.isMobile() && !sessionStorage['animationDone'] || $("." + current.rvlItemClass).attr("data-replay") == "true") {
    //     $element.each(function () {
    //         current.revealAnimation();
    //     });
    //     sessionStorage['animationDone'] = 'true';
    // } else {
    //     $('.' + current.rvlItemClass).addClass('still');
    //     $('.' + current.rvlItemClass).removeClass(current.rvlItemClass);
    // }
};

// Animations to obj prototype
GT.Reveal.prototype.GetAnimation = function (animationType) {
    var current = this;
    var defaultAnimation = {
        duration: 0,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        distance: '0rem',
        opacity: 1,
        scale: 1,
        viewFactor: 0.2,
        beforeReveal: function () {
            current.revealAnimation();
        }
    }
    switch (animationType) {
        case 'fromBottom':
            return $.extend({}, defaultAnimation, {
                origin: 'bottom'
            })
        default:
            return defaultAnimation
    }
};

GT.Reveal.prototype.revealAnimation = function () {
    var current = this;
    var targetElements = $('.' + current.rvlItemClass);
    for (var i = 0; i < targetElements.length; i++) {
        var elem = targetElements[i];
        var className = elem.getAttribute('data-transition');
        var delay = elem.getAttribute('data-reveal-delay');
        new revealElement(elem, className, delay);
    }
}

function revealElement(elem, className, delay) {
    $(elem).css({ 'animation-delay': delay + 'ms' })
    elem.classList.add(className);
}


'use strict';

function scrollTop() {
    $('.c-scrollToTop').fadeOut();
    $(window).scroll(function() {
        if ($(window).scrollTop() > $(window).height()) {
            $('.c-scrollToTop').fadeIn();
        }
        else {
            $('.c-scrollToTop').fadeOut();
        }

        $(this).scrollTop() > 30 ? $(".arrow").fadeOut() : $(".arrow").fadeIn();
    });

  //Click event to scroll to top
  $('.c-scrollToTop').click(function(){
    $('html, body').animate({scrollTop : 0},800);
  });
}

$(document).ready(function(){
    var $officePage = $('.office-page');
    var $locationPage = $('.location-page');
    var isOfficePage = $officePage.length;
    var isLocationPage = $locationPage.length;

    if(isLocationPage || isOfficePage) {
        $officePage.append('<div class="c-scrollToTop scrolltop-icon">' +
                                '<div class="scrolltop-icon__wrapper">' +
                                    '<div class="scrolltop-icon__wrapper__icon"></div>' +
                                '</div>' +
                            '</div>');
        $locationPage.append('<div class="c-scrollToTop scrolltop-icon">' +
                                '<div class="scrolltop-icon__wrapper">' +
                                    '<div class="scrolltop-icon__wrapper__icon"></div>' +
                                '</div>' +
                            '</div>');
        scrollTop();
    }
});

GT.SearchInput = function($element, obj) {

    function resizeForText(text) {
        var $this = $(this);
        if (text) {
            var $span = $('<span/>').html($element.attr('placeholder')).css({
                position: 'absolute',
                left: -99999,
                top: -9999,
                fontSize: $element.css('font-size'),
            }).appendTo('body');

            var emptyInput = false
            if (!text.trim() && $this.attr('placeholder')) {
                text = $this.attr('placeholder').trim();
                emptyInput = true;
            }

            $span.text(text);

            placeWidth = $span.width();

            if ($span.width() < (placeWidth)) {
                $inputSize = placeWidth
            } else {
                $inputSize = $span.width();
            }

            if (emptyInput) {
                $this.css('min-width', $inputSize);
                $this.css('width', $inputSize);
            } else {
                $this.css('width', $inputSize);
            }
            $span.remove();
        } else {
            var placeWidth = $('#searchInputPlaceholder').width();
            $this.css('min-width', placeWidth);
            $this.css('width', placeWidth);
        }
    }

    $element.on('keypress', function(e) {
        if (e.which && e.charCode) {
            var c = String.fromCharCode(e.keyCode | e.charCode);
            var $this = $(this);
            resizeForText.call($this, $this.val() + c);
        }
    });

    $element.on('paste change', function(e) {
        var $this = $(this);

        setTimeout(function() {
            resizeForText.call($this, $this.val());
        }, 100);
    });

    // Backspace
    $element.on('keyup', function(e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
            resizeForText.call($(this), $(this).val());
        }
    });

    resizeForText.call($element);

    $(window).on('resize', function() {
        resizeForText.call($element, $element.val());
    })

};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        function initGTSearchInput(elm) {
            GT.SearchInput($(elm));
        }
        LazyEvent(document.querySelectorAll('.name-search'), initGTSearchInput, 200, null, "lazy_DOMContentLoadedEvt__GTSearchInput");
    });

GT.SearchResults = function ($element, obj) {
    let __ths = this;
    let _searchKeyword = '';

    let _tabTagsIndex = [];
    let _filterTagsTaxonomies = [];
    let dropdowns = [];

    let lastFocusedElm = null;

    const SELECTORS = {
        activeTab: '.search-results-tab__item--current',
        resultsContainer: '.search-results__replace--contents',
        tabItem: '.search-results-tab__item',

        dropdown: '.select-filter',
        dropdownBtn: '.select-filter__heading',
        dropdownItem: '.select-filter__checkbox',
        dropdownList: '.select-filter__wrapper',

        resultCard: '.result-card',
        resultText: '.search-results-main__title',

        pageContainer: '.global-search-results',
        sortSelect: '.select-sorting',
        resetFiltersBtn: '.search-filters__reset-btn'
    }

    const config = {
        searchContentEndpoint: document.getElementById('searchContentEndpoint').getAttribute('data-endpoint'),
        seachEndpoint: document.getElementById('searchEndpoint').getAttribute('data-endpoint'),
    }

    init();

    function horizontalTabHandle() {
        let _searchResultsTab = document.querySelector('.search-results-tab');
        if(_searchResultsTab) {
            let _searchResultsTabItems = _searchResultsTab.querySelectorAll(SELECTORS.tabItem);
            function handleTabClick(_this) {
                _this = _this.closest(SELECTORS.tabItem);
                lastFocusedElm = "first_item";

                let activeTabClass = SELECTORS.activeTab.replace('.', '');

                if(_this.classList.contains(activeTabClass) || parseInt(_this.getAttribute('total-tag-results')) <= 0) return;

                _searchResultsTab.querySelector(SELECTORS.activeTab)?.classList.remove(activeTabClass);
                _this.classList.add(activeTabClass);

        
                let _currentTagIndex = 0;
                
                if (_tabTagsIndex[_this.getAttribute('tag-filter-name')]){
                    _currentTagIndex = parseInt(_tabTagsIndex[_this.getAttribute('tag-filter-name')]);
                } else {
                    _currentTagIndex = 0;
                }

                let _queryParams = new URLSearchParams(window.location.search);

                let _tagValue = _this.getAttribute('tag-filter-name');
                let _params = [];

                if(_tagValue) {
                    _params['tags'] = _tagValue;
                }


                if(_currentTagIndex > 0) {
                    _params['CurrentPageIndex'] = _currentTagIndex;
                } else {
                    
                    if(_queryParams.get('page')){
                        _queryParams.delete('page');
                    }
                }

                __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);
            }
            
            [].forEach.call(_searchResultsTabItems, function(tabItem) {
                if(!tabItem.isInitialized) {
                    tabItem.isInitialized = true;
                    
                    tabItem.addEventListener('click', e => handleTabClick(e.target));
                    tabItem.addEventListener('keydown', (e) => {
                        if(e.key === 'Enter') {
                            handleTabClick(e.target);
                        }
                    });
                }
            });
        }
    }

    function initFilterTags() {
        let _tagDictionaries = document.querySelectorAll('.tag-dictionary');
        if(_tagDictionaries) {
            [].forEach.call(_tagDictionaries, function(tagDictionary) {
                let _tagkey = tagDictionary.getAttribute('data-tagkey');
                let _tagValues = tagDictionary.getAttribute('data-tagvalue');              

                if(_tagValues) {
                    if(!_filterTagsTaxonomies) _filterTagsTaxonomies = [];
                    let _parentTaxonomyArr = _filterTagsTaxonomies[_tagkey];
                    let _tagValuesArr = _tagValues.split('|');
                    [].forEach.call(_tagValuesArr, function(_tagValue) {
                        if(_parentTaxonomyArr) {
                            if(_parentTaxonomyArr.indexOf(_tagValue) < 0) _parentTaxonomyArr.push(_tagValue);
                        } else {
                            _parentTaxonomyArr = [];
                            _parentTaxonomyArr.push(_tagValue);
                        }
                    });
                    
                    _filterTagsTaxonomies[_tagkey] = _parentTaxonomyArr;
                }
            });
        }
    }

    function initFilterByLabel() {
        document.querySelectorAll('.filter-result__tags--buttons button.filter-result__tag-item').forEach(function(filterBtn){
            if(!filterBtn.isInitialized) {
                filterBtn.isInitialized = true;
                filterBtn.addEventListener('click', function(e) {
                    //check if event is from screen reader
                    GT.isEventFromScreenReader(e);

                    if(_filterTagsTaxonomies) {
                        let _parentTaxonomy = this.getAttribute('data-parentTagKey');
                        let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
                        if(_parentTaxonomyArr) {
                            let _taxFilterValue = this.getAttribute('data-value');
                            lastFocusedElm = SELECTORS.dropdownItem + ":has(#_" + _taxFilterValue + ")";
                            for(let i = 0; i < _parentTaxonomyArr.length; i++) {
                                let _childTaxonomy = _parentTaxonomyArr[i];
                                if(_taxFilterValue == _childTaxonomy) {
                                    _parentTaxonomyArr.splice(i, 1);
                                    break;
                                }
                            }
                        }

                        _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
                    }

                    let _currentTabItem = getCurrentTabItem();
                    let _params = [];
                    
                    if(_currentTabItem) {
                        _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');
                    }

                    __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);                       
                });
            }
        });
    }


    function processFilterCheckbox(_filterCheckbox) {
        let _filterCheckboxValue = _filterCheckbox.value;
        if(_filterCheckbox.checked) {
            let _parentTaxonomy = _filterCheckbox.getAttribute('parent-taxonomy');
            let _parentTaxonomyArr = _filterTagsTaxonomies[_parentTaxonomy];
            if(_parentTaxonomyArr) {
                if(_parentTaxonomyArr.indexOf(_filterCheckboxValue) < 0) _parentTaxonomyArr.push(_filterCheckboxValue);
            } else {
                _parentTaxonomyArr = [];
                _parentTaxonomyArr.push(_filterCheckboxValue);
            }

            _filterTagsTaxonomies[_parentTaxonomy] = _parentTaxonomyArr;
        }
    }

    // Search Filter Select Handling On Desktop
    function searchFiltersHandle() {
        let _searchResultsFilterItems = document.querySelectorAll('input[type="checkbox"].filters__item');
        let _applyFiltersBtn = document.getElementById('applyFiltersBtn');
        [].forEach.call(_searchResultsFilterItems, function(filterItem) {
            filterItem.addEventListener('change', function(e) {
                let _this = this;
                let _parentTaxonomy = _this.getAttribute('parent-taxonomy');
                lastFocusedElm = SELECTORS.dropdownItem + ":has(#" + _this.id + ")";

                this.closest(SELECTORS.dropdownItem).setAttribute("aria-selected", _this.checked ? "true" : "false");
                // Delete all tags by parent
                _filterTagsTaxonomies[_parentTaxonomy] = [];

                // Get all checked items by parent
                let _groupTagsParent = _this.closest(SELECTORS.dropdownList);
                if(_groupTagsParent) {
                    let _checkedItemsByParent = _groupTagsParent.querySelectorAll('input[type="checkbox"]:checked');
                    [].forEach.call(_checkedItemsByParent, function(checkedItem){
                        if(checkedItem) {
                            processFilterCheckbox(checkedItem);
                        }
                    });
                }

                let _currentTabItem = getCurrentTabItem();

                let _params = [];
                
                if(_currentTabItem) {
                    _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');
                }

                if(GT.isTabletView()) {
                    setTimeout(() => {
                        __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);                       
                    }, 100);
                }
            });
        });

        if (_applyFiltersBtn) {
            _applyFiltersBtn.addEventListener('click', function() {
                lastFocusedElm = "first_item";

                [].forEach.call(_searchResultsFilterItems, function(filterItem) {
                    processFilterCheckbox(filterItem);
                });

                let _currentTabItem = getCurrentTabItem();

                let _params = [];
                
                if(_currentTabItem) {
                    _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');
                }

                document.querySelector('html').classList.remove('overflowHidden--mobile');
                __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);
             })
        }
    }

    function focusLastDropdownItem(e) {
        let lastDropdown = dropdowns[dropdowns.length - 1];
        if(lastDropdown.classList.contains("expanded")) {
            e.preventDefault();
            let lastDropdownItems = lastDropdown.querySelectorAll(SELECTORS.dropdownItem);
            lastDropdownItems[lastDropdownItems.length - 1]?.focus();
        }
    }

    function clearFilters() {
        function clearFilterHandler() {
            lastFocusedElm = "first_item";
            
            let _searchResultsFilterItems = document.querySelectorAll('input[type="checkbox"].filters__item');
            [].forEach.call(_searchResultsFilterItems, function(filterItem) {
                filterItem.checked = false;
            });
            
            _filterTagsTaxonomies = [];
            
            let _currentTagIndex = 0;
            let _currentTabItem = getCurrentTabItem();

            let _params = [];
            
            if(_currentTabItem) {
                _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');

                // Search keyword condition by tab tags
                if (_tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')]){
                    _currentTagIndex = parseInt(_tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')]);
                } else {
                    _currentTagIndex = 0;
                }
            }

            let _queryParams = new URLSearchParams(window.location.search);
            if(_currentTagIndex > 0) {
                _params['CurrentPageIndex'] = _currentTagIndex;
            } else {
                if(_queryParams.get('page')){
                    _queryParams.delete('page');
                }
            }

            //keep sort value after clear filters and call ajax
            _params['sort'] = ( _queryParams.get('sort') ) ? _queryParams.get('sort') : 'rel';
            
            __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);
        }

        document.querySelectorAll(SELECTORS.resetFiltersBtn).forEach(function(clearFilterLabelBtn){
            if(clearFilterLabelBtn.isInitialized) return;
            clearFilterLabelBtn.isInitialized = true;
            clearFilterLabelBtn.addEventListener('click', clearFilterHandler);
            if(clearFilterLabelBtn.id) {
                clearFilterLabelBtn.addEventListener('keydown', function(e) {
                    if(e.key === 'Tab' && e.shiftKey) {
                        focusLastDropdownItem(e);
                    }
                });
            }
        })

    }

    function scrollToTab (el) {
        if(!el) return;
        const elLeft = el.offsetLeft + el.offsetWidth;
        const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
        
        // check if element not in view
        setTimeout(function() {
            if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
                el.parentNode.scrollLeft = elLeft - elParentLeft;
            } else if (elLeft <= el.parentNode.offsetLeft + el.parentNode.scrollLeft) {
                el.parentNode.scrollLeft = el.offsetLeft - el.parentNode.offsetLeft;
            }
        }, 500);
    }

    function scrollToPosition(_container) {
        let _currentPos = document.documentElement.scrollTop || document.body.scrollTop;
        let _containerOffset = _container.offsetTop;
        if(_currentPos > (_containerOffset + _container.getBoundingClientRect().height)) {
            window.scrollTo({ top: _containerOffset - _container.getBoundingClientRect().height, behavior: 'smooth'});
        }
    }

    function getCurrentTabItem() {
        let _searchResultsTab = document.querySelector('.search-results-tab');
        if(_searchResultsTab) {
            let _searchResultsTabItem = _searchResultsTab.querySelector(SELECTORS.activeTab);
            if(_searchResultsTabItem) {
                return _searchResultsTabItem;
            }
        }
    }

    function queryParams(_urlSearchParams, params) {
        for (var key in params) {
            _urlSearchParams.set(key, params[key]);
        }

        if(_filterTagsTaxonomies) {
            for (var key in _filterTagsTaxonomies) {
                let _tagsArr = _filterTagsTaxonomies[key];
                let _tagsStr = '';
                let _counter = 0;
                [].forEach.call(_tagsArr, function(_tagValue){
                    _tagsStr += _tagValue;
                    if(_counter < _tagsArr.length - 1 ) {
                        _tagsStr += '+';
                    }
                    _counter++;
                });
                if(_tagsStr) _urlSearchParams.append('tags', _tagsStr);
            }
        }

        return _urlSearchParams.toString();
    }

    __ths.setParameterInQueryString = function(key, value, isDelete) {
        var queryParams = new URLSearchParams(window.location.search);
        if(isDelete)
            queryParams.delete(key);
        else
            queryParams.set(key, value);
        history.replaceState(null, null, "?" + queryParams.toString() + location.hash);
    }

    __ths.getParameterInQueryString = function(key) {
        var queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(key);
    }

    function toggleFiltersForm() {
        let _filtersContainer = document.querySelector('.search-filters'),
            _filtersContainerToggle = document.querySelectorAll('[data-toggle="search-filters"]');

        
        if(_filtersContainer && !_filtersContainer.isInitialized) {
            _filtersContainer.isInitialized = true;

            document.querySelector('.search-results__filters-show')?.addEventListener('click', function() {
                document.querySelector('html').classList.add('overflowHidden--mobile');
                _filtersContainer.setAttribute("role", "dialog");
                _filtersContainer.setAttribute("aria-modal", "true");
                setTimeout(() => {
                    document.querySelector("#filtersFormCloseBtn")?.focus();
                }, 100);
            });
            
            document.querySelector('.search-filters__close-btn')?.addEventListener('click', function() {
                document.querySelector('html').classList.remove('overflowHidden--mobile');
                _filtersContainer.removeAttribute("role");
                _filtersContainer.removeAttribute("aria-modal");
                document.querySelector(".search-results__filters-show")?.focus();
            });

            
            document.querySelector('.main-header .menu-toggle').addEventListener('click', function() {
                _filtersContainer.classList.remove('active');
            })

            
            for (var i = 0; i < _filtersContainerToggle.length; i++) {
                _filtersContainerToggle[i].addEventListener('click', function () {
                    _filtersContainer.classList.toggle('active');
                })
            }
        }
    }


    function dropdownHandler() {
        dropdowns = document.querySelectorAll(SELECTORS.dropdown);
        dropdowns.forEach(function(dropdown) {
            if(!dropdown.isInitialized) {
                dropdown.isInitialized = true;

                let dropdownItems = dropdown.querySelectorAll(SELECTORS.dropdownItem);
                
                function toggleDropdown(e) {
                    let currentDropdown = e.target.closest(SELECTORS.dropdown);
                    currentDropdown.classList.toggle('expanded');
                    const isExpanded = currentDropdown.classList.contains('expanded');
                    currentDropdown.querySelector(SELECTORS.dropdownBtn).setAttribute("aria-expanded", isExpanded ? "true" : "false");
                    // currentDropdown.setAttribute("aria-modal", isExpanded ? "true" : "false");
                    if(isExpanded) {
                        setTimeout(() => {
                            currentDropdown.querySelector(SELECTORS.dropdownItem)?.focus();
                        }, 700);
                    }
                }

                dropdown.querySelector(SELECTORS.dropdownBtn).addEventListener('click', toggleDropdown);
                dropdown.querySelector(SELECTORS.dropdownBtn).addEventListener('keydown', e => {
                    if(e.key === 'Enter') {
                        toggleDropdown(e);
                    }
                    if(e.key === 'Tab') {
                        if(!e.shiftKey) {
                            if(dropdown.classList.contains('expanded')) {
                                e.preventDefault();
                                dropdown.querySelector(SELECTORS.dropdownItem)?.focus();
                            }
                        } else {
                            let previousDropdown = dropdown.previousElementSibling;
                            if(previousDropdown && previousDropdown.classList.contains('expanded')) {
                                e.preventDefault();
                                let previousDropdownItems = previousDropdown.querySelectorAll(SELECTORS.dropdownItem);
                                previousDropdownItems[previousDropdownItems.length - 1]?.focus();
                            }
                        }
                    }
                });

                if(dropdown.querySelector('[type="checkbox"]:checked') || dropdown.querySelector(lastFocusedElm)) {
                    dropdown.classList.add('expanded');
                    dropdown.querySelector(SELECTORS.dropdownBtn).setAttribute("aria-expanded", "true");
                }

                dropdownItems.forEach(function(dropdownItem, idx) {
                    dropdownItem.idx = idx;
                    
                    dropdownItem.addEventListener('click', function(e) {
                        const currentItem = e.target.closest(SELECTORS.dropdownItem);
                        const checkboxElm = currentItem.querySelector('input');
                        if(!checkboxElm) return;

                        checkboxElm.checked ^= 1;
                        
                        const isChecked = checkboxElm.checked;
                        if(GT.isTouchDevice) {
                            currentItem.setAttribute("aria-checked", isChecked);
                        } else {
                            currentItem.setAttribute("aria-selected", isChecked);
                        }

                        const event = new Event("change");
                        checkboxElm.dispatchEvent(event);
                    });

                    dropdownItem.addEventListener('keydown', function(e) {
                        let currentItem = e.target;

                        if(e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.target.closest(SELECTORS.dropdownItem)?.click();
                        }

                        if(e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                            e.preventDefault();
                            
                            let nextIndex = parseInt(currentItem.idx) + (e.key == "ArrowDown" ? 1 : -1);
                            if(nextIndex < 0) nextIndex = dropdownItems.length - 1;
                            if(nextIndex >= dropdownItems.length) nextIndex = 0;

                            dropdownItems[nextIndex]?.focus();
                        }
                    });
                });
            }
        });
    }

    function initClearSearchInput() {
        let _searchFormResetBtn = document.getElementById('searchResetBtn');
        
        if (_searchFormResetBtn != null) {
            _searchFormResetBtn.addEventListener('click', function () {
                let _searchFormInput = document.getElementById('mainSearchInput');
                if(_searchFormInput) {
                    _searchFormInput.value = '';
                    _searchFormInput.focus();
                }
                this.classList.remove('active');
            })
        }
    }

    function init() {
        registerCommonEvents();

        initFilterTags();
        initDefaultSearchValue();

        let _currentTabItem = getCurrentTabItem();
        if(_currentTabItem){
            scrollToTab(_currentTabItem);
        }
    }

    function initDefaultSearchValue() {
        let  _queryParams = new URLSearchParams(window.location.search);

        let _currentPageIndex = _queryParams.get('page');
        let _currentTabItem = getCurrentTabItem();
        if(_currentPageIndex && _currentTabItem){
            _tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')] = parseInt(_currentPageIndex);
            scrollToTab(_currentTabItem);
        }
    }

    function registerSortEvt(){
        //update sort params when change sort select
        let sortSelect = document.querySelector(SELECTORS.sortSelect);
        if(!sortSelect) return;

        sortSelect.addEventListener('change', function (e) {
            let _currentTabItem = getCurrentTabItem();
            lastFocusedElm = SELECTORS.sortSelect;

            let _params = [];
            if(_currentTabItem) {
                _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');
            }

            _params['CurrentPageIndex'] = parseInt(document.getElementById('CurrentPageIndex').value);

            __ths.searchResultsByTaxonomies(_params, config.searchContentEndpoint, SELECTORS.resultsContainer);
        });

        sortSelect.addEventListener('keydown', function(e) {
            if(e.key === 'Tab' && e.shiftKey && !document.querySelector(SELECTORS.resetFiltersBtn)) {
                focusLastDropdownItem(e);
            }
        });
    }



    function initSearchboxInput() {
        // Search when press Enter key
        let _searchboxInput = document.getElementById('mainSearchInput');
        
        if(!_searchboxInput.isInitialized) {
            _searchboxInput.isInitialized = true;

            let _searchInputValue = _searchboxInput.value;
            let _searchFormResetBtn = document.getElementById('searchResetBtn');
            if (_searchInputValue) {
                _searchFormResetBtn.classList.add('active');
                _searchKeyword = _searchInputValue;
            } else {
                _searchFormResetBtn.classList.remove('active');
            }

            _searchboxInput.addEventListener('keydown', function(e) {
                if (e.key == 'Enter') {

                    let _headerSearchboxInput = document.querySelector('.header-search__form input[name="q"]');
                    let _currentSearchKeyword = this.value;
                    if(_headerSearchboxInput) {
                        let _isDisabledPreviousSearch = _headerSearchboxInput.getAttribute('disable-previoussearch');
                        if(_isDisabledPreviousSearch && _isDisabledPreviousSearch.toLowerCase() == 'false') {
                            let _userPreviousSearches = JSON.parse(localStorage.getItem('user_previous_searches'));
                            const _MAX_PREVIOUS_SEARCH_ITEMS = 6; 
                            
                            if(_currentSearchKeyword && _currentSearchKeyword.trim().length > 0) {
                                //Process to save search keyword into local stograde before submit search form
                                GT.processSearchKeywordBeforeSubmit(_currentSearchKeyword.trim(), _userPreviousSearches, _MAX_PREVIOUS_SEARCH_ITEMS);
                            }
                        }
                    }
                    
                    // Reset tab tags index when user input search keyword.
                    resetTabTagsIndex();

                    // Reset left filter bar
                    _filterTagsTaxonomies = [];

                    _searchKeyword = _currentSearchKeyword;
                    lastFocusedElm = "#mainSearchInput";

                    __ths.setParameterInQueryString('q', _currentSearchKeyword);
                    __ths.searchResultsByTaxonomies([], config.seachEndpoint, '.main-search-wrapper');
                    
                    setTimeout(e => {
                        dataLayer.push({
                            'search_term': _searchKeyword,
                            'search_type': "Site Search",
                            'search_link': location.href,
                            'search_text': _searchKeyword,
                            'event': 'search_used'
                        });
                    }, 50)
                }
            });

            _searchboxInput.addEventListener('input', GT.debounce(function(){
                let _this = this;
                let _inputValue = _this.value;
                let _searchFormResetBtn = document.getElementById('searchResetBtn');
                if(_inputValue.length > 0) {
                    _searchFormResetBtn.classList.add('active');
                } else {
                    _searchFormResetBtn.classList.remove('active');
                }
            }, 500));
        }
    }

    function initLoadmoreButton() {
        let _loadmoreButton = document.getElementById('searchResultsLoadmoreBtn');
        if(_loadmoreButton) {
            _loadmoreButton.addEventListener('click', function(e) {
                e.preventDefault();
                let _this = this;
                let _loadmoreEndpoint = _this.getAttribute('data-endpoint') || '';
                __ths.loadMoreResultsByTag(_loadmoreEndpoint);
            });
        }
    }
    
    function updateResultsCount() {
        let _allResultsCount = document.querySelectorAll('.results-count__by--tag');
        [].forEach.call(_allResultsCount, function(_resultKey) {
            let _tabKey = _resultKey.getAttribute('tag-filter-name');
            let _tabItem = document.querySelector('.search-results-tab__item[tag-filter-name="' + _tabKey + '"]');
            if(_tabItem) {
                _tabItem.setAttribute('total-tag-results', _resultKey.getAttribute('data-hitcount'));
                let _resultsHitCount = _tabItem.querySelector('.results-hit__count');
                if(_resultsHitCount) {
                    _resultsHitCount.innerHTML = '(' + _resultKey.getAttribute('data-hitcount') + ')';
                } else {
                    _resultsHitCount = '<span class="results-hit__count">(' + _resultKey.getAttribute('data-hitcount') + ')</span>';
                    _tabItem.insertAdjacentHTML("beforeend", _resultsHitCount);
                }
            }
        });
    }
    
    function resetTabTagsIndex() {
        _tabTagsIndex = [];
        __ths.setParameterInQueryString("page", "", true);
    }

    __ths.setShowingNumber = function () {
        let resultCardNumber = document.querySelectorAll(SELECTORS.resultCard).length || 0;
        document.querySelector('#totalResultShowing').innerHTML = resultCardNumber;
    }

    __ths.escapeQueryChars = function (url) {
        return url ? url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            }) : url;
    };

    __ths.loadMoreResultsByTag = function (_loadmoreEndpoint) {
        let _currentTabItem = getCurrentTabItem();
        let _pageIndexByTags = parseInt(document.getElementById('CurrentPageIndex').value);
        let _currentPageIndex = _pageIndexByTags + 1;
        let _params = [];
        if(_currentTabItem) {
            if (_tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')])
            {
                _tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')] = _tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')] + 1;
            }
            else
            {
                _tabTagsIndex[_currentTabItem.getAttribute('tag-filter-name')] = 1;
            }

            _params['tags'] = _currentTabItem.getAttribute('tag-filter-name');
        }

        _params['CurrentPageIndex'] = _currentPageIndex;
        document.getElementById('CurrentPageIndex').value = _currentPageIndex;
        __ths.searchResultsByTaxonomies(_params, _loadmoreEndpoint);

        __ths.setParameterInQueryString("page", _currentPageIndex);
    };

    __ths.ajaxCall = function (url, successCallback) {
        var contextRef = this;
        let __url = url;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.response && this.status == 200) {
                    successCallback(contextRef, this.response);
                } else {
                    // isInited = false;
                }
            }
        };
        xhttp.open("GET", __url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhttp.send();
    }

    __ths.searchResultsByTaxonomies = function (_queryParams, _otherEndpoint, _replaceContainer) {
        GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
        setTimeout(() => {
            document.querySelector(SELECTORS.pageContainer).classList.add("fetching");
            __ths.ajaxCall(queriesStringBuilder(_queryParams, _otherEndpoint, true), successCallback);
        }, 100);


        function successCallback(contextRef, data) {
            document.querySelector(SELECTORS.pageContainer).classList.remove("fetching");
            if(_replaceContainer) {
                __ths.replaceResults(data, _replaceContainer);
            } else {
                let totalItems = document.querySelectorAll(SELECTORS.resultCard).length;
                __ths.appendResults(contextRef, data);
                GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText + " " + (document.querySelector(SELECTORS.resultText)?.textContent || "");
                setTimeout(() => {
                    document.querySelectorAll(SELECTORS.resultCard)[totalItems]?.querySelector('a')?.focus();
                }, 100);
            }
        }

        if(_replaceContainer) {
            let newQueryStr = queriesStringBuilder(_queryParams).replace('CurrentPageIndex', 'page');
            dataLayer.push({ 'event': 'global_search', 'eventAction': 'search', 'eventLabel': newQueryStr });
            window.history.pushState(null, null, newQueryStr);
        }
        
    };

    function queriesStringBuilder(_params, _otherEndpoint, _isLoadmore) {

        if(!_params) _params = [];
        
        let _urlSearchParams = new URLSearchParams();

        let _searchSorting = document.querySelector(SELECTORS.sortSelect)?.value || '';

        if(_searchSorting) {
            _params['sort'] = _searchSorting;
        } else {
            _urlSearchParams.delete('sort');
        }

        let _ajaxUrl = '';
        if(_isLoadmore) {
            if(_otherEndpoint && _otherEndpoint.length > 0) {
                _ajaxUrl = _otherEndpoint;
                _ajaxUrl += '&Query=' + encodeURIComponent(_searchKeyword);
            }
        } else {
            _ajaxUrl += '?q=' + encodeURIComponent(_searchKeyword);
        }
        
        let _queryParams = queryParams(_urlSearchParams, _params);
        if(_queryParams && _queryParams.length > 0) {
            _ajaxUrl += '&' + _queryParams;
        }

        return __ths.escapeQueryChars(_ajaxUrl);
    }

    __ths.replaceResults = function (data, _replaceContainer) {
        let _mainSearchResultsContainer = document.querySelector(_replaceContainer);
        if(_mainSearchResultsContainer) {
            _mainSearchResultsContainer.innerHTML = data;
        }
        
        if (typeof GT !== "undefined" && GT.FormSelect) {
            GT.FormSelect($('.search-results__sort-select'));
        }

        fireEventsAfterRenderingResults();

        // Update results count in tab item.
        updateResultsCount();
        
        setTimeout(function() {
            // Register events after ajax call
            registerCommonEvents();

            let _container = document.querySelector('.search-results-container');
            if(_container) scrollToPosition(_container);

            GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText + " " + (document.querySelector(SELECTORS.resultText)?.textContent || "");
        }, 100);
    }

    __ths.appendResults = function (contextRef, data) {
        let _searchResultsContainer = document.getElementById('searchResultList');
        _searchResultsContainer.insertAdjacentHTML("beforeend", data);
        __ths.setShowingNumber();
        shouldLoadMore();
        fireEventsAfterRenderingResults();
    }

    function fireEventsAfterRenderingResults() {
        GT.clampText();

        if(typeof FindApi !== "undefined") {
            const api = new FindApi();
            api.setApplicationUrl('/');
            api.setServiceApiBaseUrl('/find_v2/');
            api.processEventFromCurrentUri();
            api.bindWindowEvents();
            api.bindAClickEvent();
            api.sendBufferedEvents();
        }
    }

    function registerCommonEvents(isFirstTime) {
        registerSortEvt();
        horizontalTabHandle();
        searchFiltersHandle();
        initLoadmoreButton();
        shouldLoadMore();
        dropdownHandler();
        toggleFiltersForm();
        initClearSearchInput();
        initSearchboxInput();
        clearFilters();
        
        initFilterByLabel();

        if(!isFirstTime) {
            if(GT.isScreenReader) {
                switch(lastFocusedElm) {
                    case "first_item":
                        document.querySelector(SELECTORS.resultCard + ' a')?.focus();
                        break;
                    default:
                        (document.querySelector(lastFocusedElm) || document.querySelector(SELECTORS.resultCard + ' a') || document.querySelector(SELECTORS.tabItem))?.focus();
                        break;
                }
            } else {
                document.querySelector(SELECTORS.sortSelect)?.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    function shouldLoadMore() {
        let _loadBtn = document.getElementById('searchResultsLoadmoreBtn');

        if(!_loadBtn) 
            return;

        let _pageIndexByTags = parseInt(document.getElementById('CurrentPageIndex').value);
        let totalItems = parseInt(document.getElementById('TotalItemsCount').value);
        
        
        let _pageSize = parseInt(document.getElementById('PageSize').value);
        let maxPage = Math.ceil(totalItems / _pageSize);
        let loadMoreContainer = document.querySelector(".load-more-container")

        if (maxPage <= _pageIndexByTags) {
            if(loadMoreContainer)
                loadMoreContainer.classList.add("hidden");
            else
                _loadBtn.classList.add('hidden');

        } else {
            if(loadMoreContainer) {
                loadMoreContainer.classList.remove("hidden");
            }
            else {
                _loadBtn.classList.remove('hidden');
            }
            
            if(_loadBtn.href)
                _loadBtn.href = location.href.replace("page=" + _pageIndexByTags, "page=" + (_pageIndexByTags + 1));
        }


        document.querySelectorAll(".search-results-main-wrapper a.result-card__heading").forEach(item => {
            if(!item.dataset.initialized) {
                item.dataset.initialized = true;
                item.addEventListener("click", e => {
                    let searchTerm = document.querySelector("#mainSearchInput")?.value || "",
                        currentElm = e.currentTarget || e.target;
                    dataLayer.push({
                        'search_term': searchTerm,
                        'search_type': "Your Results", //document.querySelector(".search-results-tab__item--current")?.innerText.replace(/ \(+[0-9]+\)/, "") || "",
                        'search_link': currentElm.href,
                        'search_text': currentElm.innerText,
                        'event': 'search_used'
                    });
                })
            }
        })
    };
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        GT.SearchResults();
    });
GT.SecondaryNavbar = function($navbarWrapper) {
    $.each($navbarWrapper, function(index, element) {
        function applyNavigation(element) {
            var $ul = $(element).find('ul');
            // $ul.parent().removeClass('centered');
            if (isIE()) {
                $(element).parent().addClass('ie');
                calculateListIEWidth($ul, $(element).width());
            }
            $(element).parent().addClass('gt-secondary-nav-parent');

            let wrapperWidth = document.querySelector('.gt-secondary-nav-wrapper ul')?.offsetWidth || 0;
            if (GT.wWidth < wrapperWidth) {
                appendArrow($(element));
            } else {
                // $ul.parent().addClass('centered');
                removeArrow($(element));
            }
        }
        applyNavigation(element);

        GT.windowResizeFncList.secondaryNavbar = function() {
            applyNavigation(element);
        }

        if (isOfficePage()) {
            moveNavigationAccordingToBanner($(element));
            $(window).on('resize', function() {
                moveNavigationAccordingToBanner($(element));
            });
        }
    });

	function isRTL() {
		return $('body').hasClass('RTL');
	}    

    function appendArrow($navbar) {
        var $parent = $navbar.parent();
        
        let $rightArrow = $parent.find('.gt-secondary-nav-arrow.right'),
            $lefttArrow = $parent.find('.gt-secondary-nav-arrow.left');
        var ticking = false;
        var lastScrollLeft = 0;
        var $wrapper = $navbar.find('.gt-secondary-nav-wrapper');
        var rightInterval = undefined;
        var leftInterval = undefined;

        var interval = 100;
        var distance = 100;
        var isClicking = false;

        function doScrollRight(e) {
            // if (e.cancelable) {
            //     e.preventDefault();
            // }
            if (!isClicking) {
                isClicking = true;
                if (!atRightEdge($wrapper)) {
                    rightInterval = setInterval(function() {
                        requestAnimationFrame(function(){
                            $wrapper.animate( {'scrollLeft' : '+=' + distance}, 100)
                        });
                    }, interval);
                }
            }
        }

        function stopScrollRight(e) {
            if (e.cancelable) {
                e.preventDefault();
            }
            setTimeout(function() {
                isClicking = false;
                clearInterval(rightInterval);
            }, 200);
        }

        function doScrollLeft(e) {
            // if (e.cancelable) {
            //     e.preventDefault();
            // }
            if (!isClicking) {
                isClicking = true;
                if (!atLeftEdge($wrapper)) {
                    leftInterval = setInterval(function() {
                         requestAnimationFrame(function(){
                            $wrapper.animate( {'scrollLeft' : '-=' + distance}, 100)
                        });
                    }, interval);
                }
            }
        }

        function stopScrollLeft(e) {
            if (e.cancelable) {
                e.preventDefault();
            }
            setTimeout(function() {
                isClicking = false;
                clearInterval(leftInterval);
            }, 200);
        }

        function scrollingHandler(){
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    var currentScrollLeft = $wrapper.scrollLeft();
                    if (lastScrollLeft < currentScrollLeft) {
                        lastScrollLeft = currentScrollLeft;
                        if (atRightEdge($wrapper)) {
                            $rightArrow.hide();
                            clearInterval(rightInterval);
                            $lefttArrow.show();
                        }
                    } else if (lastScrollLeft >= currentScrollLeft) {
                        lastScrollLeft = currentScrollLeft;
                        if (atLeftEdge($wrapper)) {
                            $lefttArrow.hide();
                            clearInterval(leftInterval);
                            $rightArrow.show();
                        }
                    }
                    ticking = false;
                });
                ticking = true;
            }
        }

        scrollingHandler();
        if(!$navbar.data("initialized")) {
            $navbar.data("initialized", true);

            $rightArrow.on('mousedown touchstart', function(e) {
                doScrollRight(e);
            });
            $rightArrow.on('mouseup touchend', function(e) {
                stopScrollRight(e)
            });
            $lefttArrow.on('mousedown touchstart', function(e) {
                doScrollLeft(e)
            });
            $lefttArrow.on('mouseup touchend', function(e) {
                stopScrollLeft(e);
            });

            $wrapper.on('scroll', function(event) {
                scrollingHandler();
            });
        }
    }

    function removeArrow($navbar) {
        var $parent = $navbar.parent();
        var $rightArrow = $parent.find('.gt-secondary-nav-arrow.right');
        var $lefttArrow = $parent.find('.gt-secondary-nav-arrow.left');
        $rightArrow.hide();
        $lefttArrow.hide();
    }

    function isIE() {
        return /MSIE|Trident/.test(navigator.userAgent);
    }

    function isEdge() {
        return /Edge/.test(navigator.userAgent);
    }

    function isOfficePage() {
        return $('.office-page').length > 0;
    }

    function moveNavigationAccordingToBanner($el) {
        var $parent = $el.closest('.gt-secondary-nav-parent');
        var $bannerParent = $parent.prev('div');
        var $officeBanner = $bannerParent.find('.office-banner');
        if ($officeBanner.length > 0) {
            var officeBannerRect = $officeBanner[0].getBoundingClientRect();
            var $contactBox = $officeBanner.find('.content.container');
            if ($contactBox.length > 0) {
                var officeBannerContactRect = $contactBox[0].getBoundingClientRect();
                var overlapse = false;
                if (isIE() || isEdge()) {
                    if (officeBannerContactRect.top + officeBannerContactRect.height > officeBannerRect.top + officeBannerRect.height) {
                        var extra = (officeBannerContactRect.top + officeBannerContactRect.height) - (officeBannerRect.top + officeBannerRect.height);
                        $parent.css('margin-top', (extra + 5) + 'px');
                        overlapse = true;
                    }
                } else {
                    if (officeBannerContactRect.y + officeBannerContactRect.height > officeBannerRect.y + officeBannerRect.height) {
                        var extra = (officeBannerContactRect.y + officeBannerContactRect.height) - (officeBannerRect.y + officeBannerRect.height);
                        $parent.css('margin-top', (extra + 5) + 'px');
                        overlapse = true;
                    }
                }
                if (overlapse && isEditMode()) {
                    var styleDom = $('<style>.epi-editmode .epi-editContainer [data-epi-block-id]:after { display : none }</style>');
                    $('body').append(styleDom);
                }
            }
        }
    }

    function isEditMode() {
        return $('body').hasClass('epi-editmode');
    }

    function calculateListIEWidth($ul, elementWidth) {
        var $li = $ul.find('li');
        var width = 0;
        $.each($li, function(index, el) {
            width += $(el).outerWidth();
        });
        if (width > elementWidth)
            $ul.css('min-width', width + 'px');
    }

    function atRightEdge($el) {
        //need to plus 2 for galaxy s5
        if ( isRTL() ) {
            return $el.scrollLeft() === 0;
        } else {
            return $el.scrollLeft() + $el.innerWidth() + 2 >= $el[0].scrollWidth;
        }
    }

    function atLeftEdge($el) {
        if ( isRTL() ) {
            return -$el.scrollLeft() + $el.innerWidth() + 2 >= $el[0].scrollWidth;
        } else {
            return $el.scrollLeft() === 0;
        }
    }
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.SecondaryNavbar($('.gt-secondary-nav'));
    });
GT.selectList = {};
GT.Select = function ($element, obj) {
    var doSelect = function (element) {
        var $target = $(element).find('select');
        $target.selectric({
            arrowButtonMarkup: '<i class="icon-arrow"></i>',
            expandToItemText: false,
            onInit: function () {
                setTimeout(function () {
                    var $customSelects = $('.custom-select');

                    $customSelects.map(function (index, el) {
                        var $currentCustomEl = $(el);
                        var $select = $currentCustomEl.find('select');
                        var ariaLabel = $select.attr("data-arialabel");
                        $select.attr('tabindex', -1);
                        var $selectricInput = $currentCustomEl.find('.selectric-input');
                        $selectricInput.attr('tabindex', -1);
                        $selectricInput.attr('readonly', true);
                        $selectricInput.attr('type', "hidden");

                        var $selectric = $currentCustomEl.find('.selectric');
                        $selectric.attr("aria-expanded", "false");
                        $selectric.attr('tabindex', 0);
                        $selectric.attr('aria-label', ariaLabel);
                        $selectric.attr('aria-haspopup', "listbox");
                        $selectric.attr('role', "button");

                        var $selectricItems = $currentCustomEl.find('.selectric-items');
                        $selectricItems.attr('tabindex', -1);
                        $selectricItems.find("li").keydown(function(e){
                            if(e.keyCode == 13 || e.keyCode == 32) {
                                e.preventDefault();
                                let currentOptionElm = e.target,
                                    selectricBtn = currentOptionElm.parentElement.parentElement.parentElement.previousSibling;
                                currentOptionElm.click();
                                selectricBtn.setAttribute("aria-label", currentOptionElm.innerText);
                                selectricBtn.focus();
                            }
                        });

                        $selectricItems.keydown(function(e){
                            if(e.keyCode == 27) {
                                GT.selectList[$selectric.attr('data-selectricname')].selectric("close");
                            }
                        })                   


                        if($selectric.length && !$selectric.attr('data-selectricname')) {
                            $selectric[0].addEventListener("keydown", function(e){
                                if(e.keyCode == 13 || e.keyCode == 40 || e.keyCode == 38 || e.keyCode == 32) {
                                    e.preventDefault();
                                    GT.selectList[e.target.dataset.selectricname].selectric("open");
                                    if(e.keyCode == 40 || e.keyCode == 38) {
                                        setTimeout(function(){
                                            document.dispatchEvent(new KeyboardEvent('keypress',{'keyCode': e.keyCode}));
                                        }, 100)
                                    }
                                } else if(e.keyCode == 27) {
                                    GT.selectList[e.target.dataset.selectricname].selectric("close");
                                }
                            })
                            $selectric.attr('data-selectricname', Math.random() * 10000);
                            GT.selectList[$selectric.attr('data-selectricname')] = $select;
                        }
                    }); 
                });
            },
            onOpen: function () {             
                var _this = $(this);
                var $selectric = _this.parents('.selectric-wrapper').find('.selectric');
                $selectric.attr("aria-expanded", "true");

                let dropdownElm = _this.parents('.selectric-wrapper').find('.selectric-scroll ul');
                dropdownElm.find("li").each(function(elmIdx, liElm){
                    liElm.setAttribute("id", "selectric_" + elmIdx);
                })
                
                let liElm = dropdownElm.find("li"),
                    liSelectedElm = dropdownElm.find("li.selected");

                dropdownElm.attr("role", "listbox");
                dropdownElm.attr("aria-activedescendant", liSelectedElm.attr("id"));

                liElm.attr("role", "option");
                liElm.attr("tabindex", "0");

                liSelectedElm.attr("selected", "selected");
                setTimeout(function() {
                    liSelectedElm.focus();
                    GT.listboxKeyboardHandle('.selectric-scroll ul');
                }, 50);
            },
            onClose: function () {
                var _this = $(this);
                var $selectric = _this.parents('.selectric-wrapper').find('.selectric');
                $selectric.attr("aria-expanded", "false");
                $selectric.focus();               
            },
            onHighlight: function () {
                var _this = $(this).parent().parent();
                _this.find("input").val(_this.find('.highlighted').html())
            },
            nativeOnMobile: false,
            disableOnMobile: false
        });
    };
    LazyEvent($element, doSelect, 200, null, "lazy_DOMContentLoadedEvt__GTSelect");
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.Select(document.querySelectorAll('.custom-select'));
    });
/**
 * This function is to update the color of a select dropdown to that of its **disabled & selected** option
 * Once the select dropdown's value has been changed, the binding will be removed
 *
 * @param {*} $container
 */
GT.SelectPlaceholder = function ($container) {
  var SELECTORS = {
    DROPDOWN: 'select',
    DISABLED_OPTION: ':disabled',
    SELECTED_OPTION: ':selected'
  };
  var COLOR = 'color';
  var CHANGE_EVENT = 'change';
  $container.find(SELECTORS.DROPDOWN).each(function (_index, dropdown) {
    var $dropdown = $(dropdown);
    var $selected = $dropdown.find(SELECTORS.SELECTED_OPTION);
    if ($selected.is(SELECTORS.DISABLED_OPTION)) {
      $dropdown.css(COLOR, $selected.css(COLOR));
    }

    var removeColorFunc = function () {
      $dropdown.css(COLOR, '');
      $dropdown.off(CHANGE_EVENT, removeColorFunc);
    };
    $dropdown.on(CHANGE_EVENT, removeColorFunc);
  });
};

GT.ServiceIndustrySubMenu = function () {
    var MENU_ITEM_SELECTOR = ".service-industry-sub-menu_item";
    var ACCORDION_TITLE_CLASS = 'sub-menu-accordion_title';
    var ACCORDION_TITLE_SELECTOR = '.' + ACCORDION_TITLE_CLASS;
    var ACCORDION_SELECTOR = '.sub-menu-accordion';
    var DATA_INDEX_KEY = 'menu-item-index';
    var COLLAPSING_ACCORDION_CLASS = 'collapsing';


    function balanceHeight() {
        let subMenus = document.querySelectorAll(".service-industry-sub-menu_desktop");
        [].forEach.call(subMenus, function(subMenu) {
            GT.BalanceHeight(subMenu); 
        });
    }
    
    balanceHeight();

    let accordionTitles = document.querySelectorAll(ACCORDION_TITLE_SELECTOR);
    [].forEach.call(accordionTitles, function(accordionTitle) {
        accordionTitle.addEventListener('click', function(e) {
            let _parent = e.target.closest(MENU_ITEM_SELECTOR);
            if(!_parent) return;

            let _subMenuAccordion = _parent.querySelector(ACCORDION_SELECTOR);
            if(_subMenuAccordion) {
                _subMenuAccordion.classList.toggle(COLLAPSING_ACCORDION_CLASS);
            }
        });
    });

    GT.windowResizeFncList.blanceHeightServiceIndustrySubMenu = function() {
        if(GT.wWidth > 960)
            balanceHeight();
    }
};


if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.ServiceIndustrySubMenu();
    });

GT.ShowMore = function() {
    document.querySelectorAll("[data-fulltext] .showmore").forEach(elm => {
        if(!elm.dataset.initialized) {
            elm.dataset.initialized = true;
            elm.addEventListener("click", e => {
                let parentElm = e.target.closest("[data-fulltext]");
                parentElm.innerHTML = parentElm.dataset.fulltext;
            })
        }
    })
}

GT.domContentLoadedFncList.push(function(){
    GT.ShowMore();
});
GT.SideNav = function () {
    secondaryNav();
    function secondaryNav($elem) {
        var navElements = $('.secondary-nav > li > .sectionLink');
        
        $('.highlight').parents('li').eq(1).children().addClass('highlight');

        navElements.click(function () {
            if ($(this).hasClass('open')) {
                $('.secondary-nav .sectionLink').removeClass('open').attr("aria-expanded", "false");
            } else {
                $('.secondary-nav .sectionLink').removeClass('open').attr("aria-expanded", "false");
                $(this).addClass('open').attr("aria-expanded", "true");
            }
            return false;
        });
    };
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.SideNav = new GT.SideNav();
    });
function GTSkipLink(){
    Array.prototype.slice.call(document.querySelectorAll(".shortcuts a")).forEach(function(shortcut){
        shortcut.addEventListener("click", function(e){
            e.preventDefault();
            let ahref = "#" + e.target.href.split("#")[1],
                target = document.querySelector(ahref);

            if(ahref == "#skip-nav"){
                let insightToggleBtn = document.querySelector(".insight-menu__toggle");
                const firstFocusableElement = target.querySelector("ul.level-1 li")?.querySelector("a, button");
                if(insightToggleBtn) {
                    insightToggleBtn.click();
                    setTimeout(function(){
                        firstFocusableElement?.focus();
                    }, 500)
                } else
                    firstFocusableElement?.focus();
            } else if(ahref == "#skip-cookie") {
                let lstElm = GT.getListFocusableElms(document.querySelector(".cookie-block"));
                if(lstElm.length) {
                    lstElm[0].focus();
                }
            } else {
                GT.getFirstFocusableVisible()?.focus();
            }
        })
    })
}

GT.domContentLoadedFncList.push(function(){
    GTSkipLink();
});

GT.SocialShareLine = function ($element, obj) {
    var scriptLoaded = false;
    function loadLineScript() {
        scriptLoaded = true;
        var script = document.createElement('script');
        script.src = "https://d.line-scdn.net/r/web/social-plugin/js/thirdparty/loader.min.js";
        document.head.appendChild(script);
    }
    $element.each(function (index, element) {
        $element = $(element);
        var url = $element.attr("data-url");
        var lang = $element.attr("data-lang");
        if (!url.length) {
            $element.attr("data-url", location.href);
        }
    });
    if (!scriptLoaded) {
        loadLineScript();
    }
};
/** Make the targeted element to appear having the same width and height.
 * 
 * Note:
 * The targeted element will not be made a square (or circle) immediately.
 * There will be a slight delay due to script loading.
 * There is no perfect CSS solution that will guarantee a square / circle for all situations.
 * This solution is glitchy but at least it will have a consistent result.
 * Also you can't test this by changing the content in the inspection mode.
 */ 
GT.Square = function ($elem) {
  $elem.each(function (_index, item) {
    var $item = $(item);
    var $word = $(item).children();

    // wrap each word with a span tag then calculate diameter
    $word.each(function(){
      var text = $(this).text().split(' ');

      for( var i = 0, len = text.length; i < len; i++ ) {
        text[i] = '<span class="word-' + i + '">' + text[i] + '</span>';
      }

      $.when($(this).html(text.join(' '))).then(function(item) {
        var max = Math.max($item.outerHeight(), $item.outerWidth());
        $item.css('width', max).css('height', max);
      });
    });

  });
};

var GTStickyButton = (function(container, button, onlyTriggerOnMobile){
    let containerElm = document.querySelector(container),
        buttonElm = containerElm.querySelector(button),
        isAnimated = false,
        buttonElmOffsetTop;
    
    if(!buttonElm)
        return;

    function doSticky(){
        if(onlyTriggerOnMobile && GT.wWidth >= 960) {
            return;
        }
    
        if(!buttonElmOffsetTop) {
            buttonElmOffsetTop = buttonElm.offsetTop;
        }
            
        if (window.pageYOffset > buttonElmOffsetTop) {
            if(!isAnimated) {
                isAnimated = true;
                containerElm.classList.add("stick-btn");
                buttonElm.classList.add("need-stick");
                setTimeout(function(){
                    buttonElm.classList.add("need-stick--animate");
                }, 50)
            }
        } else {
            isAnimated = false;
            containerElm.classList.remove("stick-btn");
            buttonElm.classList.remove("need-stick");
            buttonElm.classList.remove("need-stick--animate");
        }
    }

    window.addEventListener("resize", GT.debounce(function(){
        delete GT.listFunctionsTriggerInScrollEvent.GTStickyButton;
        GT.listFunctionsTriggerInScrollEvent.GTStickyButton = doSticky;
    }, 500))

    GT.listFunctionsTriggerInScrollEvent.GTStickyButton = doSticky;
})

if (typeof isV1GT == "undefined") {
    GT.domContentLoadedFncList.push(function(){
        new GTStickyButton(".event-countdown__block", ".register-event__btn", true);
    });
}

GT.StickyContact = function () {
    let __stickyContactBlock = document.querySelector('.sticky-contact-block');
    // Stop if there is no sticky contact block
    if (!__stickyContactBlock) {
        return;
    }

    // Function that handles showing & closing sticky contact block
    var handleSticky = function () {
        // Show first (enabled) sticky contact block if having scrolled past 50% viewport
        var prevPost = document.documentElement.scrollTop || document.body.scrollTop;
        
        var scrollHandler = function () {
            let currentPos = document.documentElement.scrollTop || document.body.scrollTop;
            if(prevPost > currentPos) {
                __stickyContactBlock.classList.add("show");
            } else {
                __stickyContactBlock.classList.remove("show");
            }
            prevPost = currentPos;
        };

        GT.listFunctionsTriggerInScrollEvent.handleStickyContact = scrollHandler;    
    }
  
    // Stop if it is not mobile (being mobile means at least one dimension < tablet min width)
    // Do not show on landscape mode in mobile
    var TABLET_MIN_WIDTH = 768;
    // var screenWidth = Math.min($(window).width(), $(window).height());
    // var isMobile = screenWidth < TABLET_MIN_WIDTH;
    if(GT.wWidth < TABLET_MIN_WIDTH && GT.wWidth < GT.wHeight)
        handleSticky();

    GT.windowResizeFncList["resizeEvt__GTStickyContact"] = function(){
        if(GT.wWidth < TABLET_MIN_WIDTH && GT.wWidth < GT.wHeight)
            handleSticky();
    }
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.StickyContact();
    });
'use strict';
GT.Swiper = function($element, obj) {
    var current = this;
    if (typeof obj.settings === 'undefined') {
        obj.settings = {};
    }
    // SETTINGS
    current.settings = $.extend({}, {
        colNumber: 'number-of-columns',
        spaceBetween: 32,
        swiperPagination: '.swiper-pagination',
        type: "default",
        a11y: true
    }, obj.settings);

    current.swiper = [];
    current.getSwiperObj = getSwiperObj;
    // SEQUENCE ANIMATION IF CONTAINER IS SET
    $element.each(function(index, element) {
        (function(current, index, element) {
            //Apply lazyloading if it is home page fcb slider
            if ($(element).hasClass('fcb__slider') && $('.home-page-container').length > 0 && $(window).width() < 960) {
                LazyEvent($(element), doSwiper, null, null, "lazy_DOMContentLoadedEvt__GTGlide_" + index);
                return;
            }
            doSwiper(element);
        })(current, index, element);
    });

    function doSwiper(element) {
        setTimeout(function() {
            var $me = $(element);
            var $slidesContainer = $me.find('.swiper-wrapper');
            var $slides = $me.find('.swiper-slide');
            if ($slides.length == 1) {
                $slidesContainer.addClass("disabled");
                $me.find('.swiper-pagination').remove();
            }
            $me.addClass('items-' + $slides.length);

            var numberOfColumns = $me.data(current.settings.colNumber);
            var originType = current.settings.type;
            if (current.settings.type === 'infinite_fcb' && $slides.length == 3) {
                current.settings.type = 'infinite_fcb_for3desktop';
            } 
            else if(current.settings.type === 'infinite_fcb' && $slides.length == 4){
                current.settings.type = 'infinite_fcb_for4';
            }
            else if(current.settings.type === 'infinite_fcb' && $slides.length < 9){
                if (check3ThItems()) $me.addClass('wide');
                for(; current.settings.type === 'infinite_fcb' && $slides.length < 9;){
                    $slides.clone().appendTo($slidesContainer);
                    $slides = $me.find('.swiper-slide');
                }
            }

            if (current.settings.type === 'infinite_reb' && $slides.length <= 3) {
                $me.addClass('related-experts-slider--centered');
            }

            var swiperObj = current.getSwiperObj(current.settings.type, numberOfColumns, $slides.length);
            swiperObj.pagination = $me.find(".swiper-pagination");
            var swiperInstance = null;
            if (current.settings.type == 'mobile-only-slider' || current.settings.type == 'small-mobile-only-slider') {
                hadleResize_ExpertBlock(current, $me, swiperInstance, numberOfColumns, current.settings.type);
            } else {
                swiperInstance = $me.swiper(swiperObj);
                if (swiperInstance.slides.length === 3 && current.settings.type != 'infinite_fcb_for3desktop' && current.settings.type != 'mobile-only-slider' && current.settings.type != 'small-mobile-only-slider') {
                    handleTouchControlEnableDisable(swiperInstance);
                }
                if (current.settings.type == 'infinite_fcb_for4') {
                    handleResize_FCB_for4(current, $me, swiperInstance, numberOfColumns, $slides.length);
                }
                if (current.settings.type == 'infinite_fcb_for3desktop') {
                    handleResize_FCB(current, $me, swiperInstance, numberOfColumns);
                }
                if (current.settings.type == 'infinite_reb') {
                    handleLoop_REB(current, $me, swiperInstance, numberOfColumns, $slides.length, $element.parent());
                }
            }
            if (current.settings.type === 'infinite_fcb_for3desktop' || current.settings.type === 'infinite_fcb' || current.settings.type === 'infinite_fcb_for4') {
                new GT.LazyBackgrounds($('.js-lazy-bg'), { settings: { safeDistance: 500 } });
            }
            current.swiper.push(swiperInstance);
            if (originType === 'infinite_fcb') {
                handleTabIndex($me, $slides.length, swiperInstance);
            }
            if (originType === 'large_promo_slider' || originType === 'dotted-pagination') {
                handleTabIndex($me, $slides.length, swiperInstance);
            }
            $slides.each(function(){
                GT.clampArticleBlock($(this));
            });
        }, 100);
    }
};

function setTabIndex(slider, slideLength) {
    function enableTabIndex(element) {
        var aTags = element.find('a');
        aTags.attr('tabindex', 0);
    }

    function disableTabIndex(element) {
        var aTags = element.find('a');
        aTags.attr('tabindex', -1);
    }

    var resolutionArray = [{ max: 10000, min: 1278, items: 5 }, { max: 1277, min: 1200, items: 4 }, { max: 1199, min: 769, items: 2 }];
    var currentWidth = $(window).width();
    var loop = true;
    for (var i = 0; i < resolutionArray.length; i++) {
        var reso = resolutionArray[i];
        if (currentWidth >= reso.min && currentWidth <= reso.max) {
            loop = false;
            if (slideLength >= reso.items) {
                loop = true;
                break;
            }
        }
    }

    var itemPerView = 5;
    var swiperSlides = slider.find('.swiper-slide');
    if (swiperSlides) {
        var indexCount = 0;
        if (!check3ThItems()){
            itemPerView = 3
        }else if (currentWidth >= 2100 && currentWidth <= 2999){
            itemPerView = 7
        }else if (currentWidth >= 3000){
            itemPerView = 9;
        }
        var numberOfColumns = parseInt(slider.attr("data-number-of-columns"));
        var count = 0;
        swiperSlides.each(function () {
            var _this = $(this);
            if ($(this).attr("clamp") == undefined){
                clampSwiper($(this));
            }
            
            if (currentWidth < 960 || (slideLength <= 4 && loop)) {
                if ($(this).hasClass("swiper-slide-visible")) {
                    enableTabIndex($(this));
                } else {
                    disableTabIndex($(this));
                }
            } else {
                if (slideLength > 4) {
                    if ($(this).hasClass("swiper-slide-visible")) {
                        if (itemPerView == 9 || itemPerView == 3) {
                            enableTabIndex($(this));
                        } else {
                            if (!$(this).hasClass("swiper-slide-active") && indexCount < itemPerView) {
                                if (itemPerView == 5 && !$(this).hasClass("swiper-slide-next")) {
                                    enableTabIndex($(this));
                                    indexCount = indexCount + 1;
                                } else if (itemPerView == 7) {
                                    enableTabIndex($(this));
                                    indexCount = indexCount + 1;
                                } else {
                                    disableTabIndex($(this));
                                }
                            } else {
                                disableTabIndex($(this));
                            }
                        }
                    } else {
                        disableTabIndex($(this));
                    }
                } else {
                    if ($(this).hasClass("swiper-slide-active")) {
                        enableTabIndex($(this));
                    } else {
                        disableTabIndex($(this));
                    }
                }
            }
            if (numberOfColumns > 0 && count < numberOfColumns) {
                enableTabIndex($(this));
            } else if (numberOfColumns == 0 || count >= numberOfColumns) {
                disableTabIndex($(this));
            }
            count++;
        })
    }
}

function check3ThItems(){
    var _iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var _iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    var _isMobile = /Mobi/.test(navigator.userAgent) && !window.MSStream;
    var min3th = 960;
    var max3th = 1299;
    var wWidth = GT.wWidth;

    if (!_iOS || !_iPhone || !_isMobile){
        min3th += 17;
        max3th += 17;
    }
    if (wWidth < min3th || wWidth > max3th)
        return true;
    else 
        return false;
}

function clampSwiper(element){
    var htmlTitle = element.find('.title').attr("data-clamp");
    element.find('.title').prop('innerHTML', htmlTitle);
    var htmlText = element.find('.text').attr("data-clamp");
    element.find('.text').prop('innerHTML', htmlText);

    GT.clampArticleBlock(element);
}

function handleTabIndex(slider, slideLength, swiperInstance){
    var windowWidth = $(window).width();
    $(window).resize(function () {
        if ($(window).width() != windowWidth) {
            var swiperSlides = slider.find('.swiper-slide');
            swiperSlides.removeAttr("clamp");
            swiperSlides.each(function () {
                clampSwiper($(this));
            });

            if (slideLength > 4) {
                if (check3ThItems()) 
                    slider.addClass('wide');
                else
                    slider.removeClass('wide');
                swiperInstance.on('progress', function () {
                    setTabIndex(slider, slideLength);
                });
            } else {
                setTabIndex(slider, slideLength);
            }
            windowWidth = $(window).width();
        }
    });

    slider.find(".slider__prev").on('click', function () {
        setTabIndex(slider, slideLength);
    });
    slider.find(".slider__next").on('click', function () {
        setTabIndex(slider, slideLength);
    });
    slider.find(".slider__prev").keyup(function (event) {
        if (event.keyCode === 13) {
            setTabIndex(slider, slideLength);
        }
    });
    slider.find(".slider__next").keyup(function (event) {
        if (event.keyCode === 13) {
            setTabIndex(slider, slideLength);
        }
    });
    setTabIndex(slider, slideLength);
}

function handleResize_FCB_for4(current, slider, swiperInstance, numberOfColumns, slideLength) {
    var windowWidth = $(window).width();
    $(window).resize(function() {
        if ($(window).width() != windowWidth) {
            windowWidth = $(window).width();
            handleResize();
        }
    });

    function handleResize() {
        var resolutionArray = [{ max: 10000, min: 1278, items: 5 }, { max: 1277, min: 1200, items: 4 }, { max: 1199, min: 769, items: 2 }];
        var desktopstarts = 959;
        var swiperObj = undefined;
        if (GT.wWidth <= desktopstarts) {
            swiperObj = current.getSwiperObj('infinite_fcb', numberOfColumns);
        } else {
            swiperObj = current.getSwiperObj('infinite_fcb_for3desktop', numberOfColumns);
        }
        swiperInstance.destroy(true, true);
        var currentWidth = GT.wWidth;
        var loop = true;
        for (var i = 0; i < resolutionArray.length; i++) {
            var reso = resolutionArray[i];
            if (currentWidth >= reso.min && currentWidth <= reso.max) {
                loop = false;
                if (slideLength >= reso.items) {
                    loop = true;
                    break;
                }
            }
        }
        swiperObj.loop = loop;
        if (!loop) {
            if (currentWidth >= 1500) {
                var currentSliderWidth = 0;
                var $slides = slider.find('.swiper-slide');
                $.each($slides, function (index, el) {
                    currentSliderWidth += $(el).outerWidth() + 32;
                });
                currentSliderWidth = currentSliderWidth - 32;
                var containerWidth = slider.closest('.container').outerWidth();
                var left = (currentSliderWidth - containerWidth) / 2;
                if ($('body').hasClass('RTL')) {
                    slider.css('right', '-' + left + 'px');
                } else {
                    slider.css('left', '-' + left + 'px');
                }
            }
            slider.find('.slider__prev, .slider__next').hide();
            swiperObj.slidesPerView = slideLength;
        } else {
            swiperObj.loopedSlides = slideLength;
            slider.find('.slider__prev, .slider__next').show();
        }
        swiperInstance = slider.swiper(swiperObj);
    }
    handleResize();
};

function handleResize_FCB(current, slider, swiperInstance, numberOfColumns) {
    var desktopstarts = 959;
    $(window).resize(function() {
        handleResize();
    });

    function handleResize() {
        swiperInstance.destroy(true, true);
        if (GT.wWidth <= desktopstarts) {
            swiperInstance = slider.swiper(current.getSwiperObj('infinite_fcb', numberOfColumns));
        } else {
            swiperInstance = slider.swiper(current.getSwiperObj('infinite_fcb_for3desktop', numberOfColumns));
        } 
    }
    handleResize();
};


function hadleResize_ExpertBlock(current, slider, swiperInstance, numberOfColumns, type) {
    var breakpoint = window.matchMedia('(min-width:768px)');
    if (type == 'small-mobile-only-slider') {
        breakpoint = window.matchMedia('(min-width:480px)');
    }
    var mySwiper = swiperInstance;
    var breakpointChecker = function() {
        if (breakpoint.matches) {
            if (mySwiper !== undefined) {
                try {
                    mySwiper.destroy(true, true);
                } catch (exception) {}
            }
            return;
        } else {
            return enableSwiper();
        }
    };
    var enableSwiper = function() {
        mySwiper = slider.swiper(current.getSwiperObj(type, numberOfColumns));
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
};

function handleTouchControlEnableDisable(swiper) {
    $(window).resize(function() {
        enableDisableTouch(swiper);
    });
    enableDisableTouch(swiper);

    function enableDisableTouch(swiper) {
        try {
            var ww = GT.wWidth;
            if (ww <= 959) {
                swiper.enableTouchControl();
            } else {
                swiper.disableTouchControl();
            }
        } catch (err) {

        }
    }
};


function handleLoop_REB(current, slider, swiperInstance, numberOfColumns, numberOfItems, sliderWrapper) {
    var resolutionThreshold = [{
            screenSize: 1440,
            rebSize: 372,
            items: 3
        },
        {
            screenSize: 1024,
            rebSize: 372,
            items: 2
        },
        {
            screenSize: 872,
            rebSize: 320,
            items: 2
        },
        {
            screenSize: 767,
            rebSize: 320,
            items: 1
        },
        {
            screenSize: 479,
            rebSize: 300,
            items: 1
        },
        {
            screenSize: 320,
            rebSize: 250,
            items: 1
        }
    ];

    function getRebWidth(screenWidth) {
        var rebSize = 372;
        for (var i = 0; i < resolutionThreshold.length; i++) {
            if (screenWidth <= resolutionThreshold[i].screenSize) {
                rebSize = resolutionThreshold[i].rebSize;
            }
        }
        return rebSize;
    }

    function getRebItemCount(screenWidth, numberOfItems) {
        var rebItemCount = numberOfItems;
        for (var i = 0; i < resolutionThreshold.length; i++) {
            if (screenWidth <= resolutionThreshold[i].screenSize) {
                rebItemCount = resolutionThreshold[i].items;
            }
        }
        if (rebItemCount === 0) rebItemCount = numberOfItems;
        return rebItemCount;
    }
    var desktopstarts = 1440;
    var tabletstarts = 768;
    var tabletMax = 800;
    var phoneStarts = 479;
    var isSwipeEnabled = false;


    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var windowWidth = $(window).width();

    window.addEventListener("resize", function() {
        if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Do stuff here
            handleResize();

        }
    }, false);

    if (!iOS) {
        window.addEventListener("resize",
            function() {
                handleResize();
            },
            false);
    }

    function handleResize() {
        swiperInstance.destroy(true, true);
        var $wrapper = slider.closest('.related-experts-wrapper');
        var ua = window.navigator.userAgent;
        var isIE = /MSIE|Trident/.test(ua);

        var isServiceIndustryNarrowRelatedExpertBlock = $wrapper.closest('.relatedexpertsblock.Narrow').length > 0;
        function isNarrowWidthPage($wrapper) {
            if ($wrapper.closest('.t2-content').length > 0) return true;
            var $closestT3 = $wrapper.closest('.t3-content');
            if ($closestT3.length > 0) return !$closestT3.hasClass('t3-content--wide');
            if ($wrapper.closest('.related-experts-on-page').length > 0) return true;
            if (isServiceIndustryNarrowRelatedExpertBlock) return true;
            return false;
        }
        var isNarrow = isNarrowWidthPage($wrapper);
        if (isIE && !isNarrow) {
            var $blockWrapper = $wrapper.closest('.related-experts-block');
            $blockWrapper.css('padding-left', '0px');
            $blockWrapper.css('padding-right', '0px');
        }
        if (isIE && isNarrow && numberOfItems === 2) {
            slider.css("margin", "0 -150px");
        }
        var screenWidth = GT.wWidth;
        var sliderWidth = $wrapper.width();
        var currentWidth = getRebWidth(screenWidth);
        var maximumItemInAWindow = (isNarrow ? sliderWidth : screenWidth) / currentWidth;
        isSwipeEnabled = numberOfItems > maximumItemInAWindow;
        var numberOfDisplayItem = getRebItemCount(screenWidth, numberOfItems);

        slider.find(".slider__prev-new").on('click', function (e) {
            e.preventDefault();
            swiperInstance.slidePrev();
        });
        slider.find(".slider__next-new").on('click', function (e) {
            e.preventDefault();
            swiperInstance.slideNext();
        });
        slider.find(".slider__prev-new").keyup(function (event) {
            if (event.keyCode === 13) {
                swiperInstance.slidePrev();
            }
        });
        slider.find(".slider__next-new").keyup(function (event) {
            if (event.keyCode === 13) {
                swiperInstance.slideNext();
            }
        });

        if (!isSwipeEnabled) {
            slider.find('.swiper-wrapper').addClass("disabled");
            slider.find('.slider__prev').css({ "display": "none" });
            slider.find('.slider__next').css({ "display": "none" });
            slider.find('.slider__prev-new').hide();
            slider.find('.slider__next-new').hide();
            slider.find('.swiper-pagination').css({ "display": "none" });
        } else {
            slider.find('.swiper-wrapper').removeClass("disabled");
            slider.find('.slider__prev').css({ "display": "inline-block" });
            slider.find('.slider__next').css({ "display": "inline-block" });
            slider.find('.slider__prev-new').removeAttr("style");
            slider.find('.slider__next-new').removeAttr("style");
            slider.find('.swiper-pagination').css({ "display": "block" });
        }
        var spaceBetween = isServiceIndustryNarrowRelatedExpertBlock ? 32 : 30;
        if (screenWidth >= desktopstarts && numberOfItems === 2) {
            spaceBetween = 170;
            swiperInstance = slider.swiper($.extend({},
                current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
            return;
        }
        if (screenWidth >= 768 && screenWidth <= 1119 && numberOfItems >= 3) {
            swiperInstance = slider.swiper($.extend({},
                current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
            return;
        }
        if (screenWidth >= 1119 && screenWidth <= 1200 && numberOfItems >= 3) {
            swiperInstance = slider.swiper($.extend({},
                current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
            return;
        }
        if (screenWidth >= 1861 && screenWidth <= 1877 && numberOfItems >= 3) {
            swiperInstance = slider.swiper($.extend({},
                current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
            return;
        }
        if (screenWidth > 1877 && numberOfItems >= 3) {
            swiperInstance = slider.swiper($.extend({},
                current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
            return;
        }
        if (isSwipeEnabled && !isServiceIndustryNarrowRelatedExpertBlock) {
            spaceBetween = (screenWidth - (currentWidth * numberOfDisplayItem)) / (numberOfDisplayItem);
            if (spaceBetween > 0) {
                swiperInstance = slider.swiper($.extend({},
                    current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled, spaceBetween: spaceBetween }));
                return;
            }
        }
        swiperInstance = slider.swiper($.extend({}, current.getSwiperObj('infinite_reb', numberOfColumns, numberOfItems, isSwipeEnabled), { loop: isSwipeEnabled }));
        return;
    }
    handleResize();
}

function getSwiperObj(type, numberOfColumns, numberOfItems, isSwipeEnabled) {
    var current = this;
    var defaultSettings = {
        a11y: true,
        keyboardControl: true,
        slidesPerView: numberOfColumns || 3,
        spaceBetween: current.settings.spaceBetween,
        nextButton: '.slider__next',
        prevButton: '.slider__prev',
        preventClicks: false
    };
    switch (type) {
        case "infinite_reb":
            var infinite_rebSettings = {
                a11y: true,
                keyboardControl: true,
                slidesPerView: numberOfColumns || 3,
                spaceBetween: current.settings.spaceBetween,
                preventClicks: false
            };
            if (numberOfItems < 3) {
                return $.extend({}, infinite_rebSettings, {
                    slidesPerView: 'auto',
                    loop: !(numberOfItems && numberOfItems <= 3),
                    centeredSlides: true,
                    resistance: true,
                    resistanceRation: 0,
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            initialSlide: 0
                        },
                        959: {
                            slidesPerView: 2,
                            initialSlide: 0
                        },
                        767: {
                            slidesPerView: 2,
                            centeredSlides: true,
                            resistanceRatio: 0.85,
                            initialSlide: 0
                        },
                        671: {
                            slidesPerView: 1,
                            centeredSlides: true,
                            resistanceRatio: 0.85,
                            initialSlide: 0
                        },
                    }
                });
            } else {
                return $.extend({}, infinite_rebSettings, {
                    slidesPerView: 'auto',
                    loop: (numberOfItems && numberOfItems > 3),
                    centeredSlides: true,
                    resistance: true,
                    resistanceRation: 0,
                    breakpoints: {
                        959: {
                            slidesPerView: 2,
                            initialSlide: 0
                        },
                        767: {
                            slidesPerView: 1,
                            centeredSlides: false,
                            resistanceRatio: 0.85,
                            initialSlide: 0
                        }
                    }
                });
            }
        case "infinite_fcb":
            var breakpoints = {
                479: {
                    slidesPerView: 1,
                    initialSlide: 0
                },
                959: {
                    slidesPerView: 2,
                    initialSlide: 0
                }
            };

            if (check3ThItems()){
                breakpoints = $.extend({}, breakpoints, {
                    1316: {
                        slidesPerView: 3,
                        initialSlide: 0
                    }
                });
                
            }else{
                breakpoints = $.extend({}, breakpoints, {
                    1299: {
                        slidesPerView: 3,
                        initialSlide: 0
                    }
                })
            }
            
            return $.extend({}, defaultSettings, {
                slidesPerView: 9,
                loop: true,
                watchSlidesVisibility: true,
                breakpoints: breakpoints
            });
            
        case "infinite_fcb_for3desktop":
            return $.extend({}, defaultSettings, {
                slidesPerView: 3,
                watchSlidesVisibility: true,
                loop: false
            });
        case "infinite":
            return $.extend({}, defaultSettings, {
                slidesPerView: numberOfColumns || 1,
                loop: true,
                loopAdditionalSlides: 1,
            });
        case "next_article_slide":
            return $.extend({}, defaultSettings, {
                slidesPerView: numberOfColumns || 1,
                loop: true,
                loopAdditionalSlides: 1,
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                paginationType: 'bullets',
                nextButton: false,
                prevButton: false,
                breakpoints: {
                    479: {
                        spaceBetween: 0,
                        paginationClickable: false
                    },
                    767: {
                        spaceBetween: 0,
                        paginationClickable: false
                    }
                }

            });
        case "wide_carousel_slider":
            return $.extend({}, defaultSettings, {
                slidesPerView: numberOfColumns || 1,
                loop: true,
                loopAdditionalSlides: 1,
                nextButton: '.slider__next',
                prevButton: '.slider__prev',
                breakpoints: {
                    479: {
                        spaceBetween: 0
                    },
                    767: {
                        spaceBetween: 0
                    }
                }
            });
        case "single_slide":
            return $.extend({}, defaultSettings, {
                slidesPerView: numberOfColumns || 1,
                loop: true,
                loopAdditionalSlides: 1,
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                paginationType: 'bullets',
                resistance: true,
                resistanceRation: 0,
                nextButton: null,
                prevButton: null,
                breakpoints: {
                    479: {
                        spaceBetween: 0,
                        paginationClickable: false
                    },
                    767: {
                        spaceBetween: 0,
                        paginationClickable: false
                    }
                }
            });
        case "large_promo_slider":
            return $.extend({}, defaultSettings, {
                slidesPerView: 1,
                loop: true,
                loopAdditionalSlides: 1,
                resistance: true,
                resistanceRation: 0,
                nextButton: null,
                prevButton: null,
                spaceBetween: 0,
                paginationType: 'bullets',
                pagination: current.settings.swiperPagination,
                paginationClickable: true
            });
        case "mobile-only-slider":
            return $.extend({}, defaultSettings, {
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                resistance: true,
                resistanceRatio: 0,
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        resistanceRatio: 0.85,
                        paginationClickable: false,
                    }
                }
            });
        case "small-mobile-only-slider":
            return $.extend({}, defaultSettings, {
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                resistance: true,
                resistanceRatio: 0,
                breakpoints: {
                    479: {
                        slidesPerView: 1,
                        resistanceRatio: 0.85,
                        paginationClickable: false,
                    }
                }
            });
        case "dotted-pagination":
            return $.extend({}, defaultSettings, {
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                resistance: true,
                resistanceRatio: 0,
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        resistanceRatio: 0.85,
                        paginationClickable: false,
                    },
                    961: {
                        slidesPerView: 2,
                        initialSlide: 0
                    }
                }
            });
        default:
            return $.extend({}, defaultSettings, {
                pagination: current.settings.swiperPagination,
                paginationClickable: true,
                resistance: true,
                resistanceRatio: 0,
                nextButton: null,
                prevButton: null,
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        resistanceRatio: 0.85,
                        paginationClickable: false
                    }
                }
            });
    }
};

// if(typeof isV1GT == "undefined")
// // set this function execute immediately
//     (function () {
//         [
//             {
//                 elm: $('.campaign-slider:not(.slideroff)'),
//                 setting: {type: 'dotted-pagination', el: '.swiper-pagination'}
//             },
//             {elm: $('.about-us-slider:not(.slideroff)')},
//             {elm: $('.news-slider:not(.slideroff)')},
//             {elm: $('.figureCarousel'), setting: {type: 'infinite_fcb'}},
//             {elm: $('.awardsCarousel'), setting: {type: 'infinite_fcb'}},
//             {elm: $('.linkListandAwardsCarousel'), setting: {type: 'infinite_fcb'}},
//             // {elm: $('.fcb__slider'), setting: {type: 'infinite_fcb'}},
//             {elm: $('.related-experts-slider'), setting: {type: 'infinite_reb'}},
//             {elm: $('.next-article-slider'), setting: {type: 'next_article_slide'}},
//             {elm: $('.industry-landing-slider'), setting: {type: 'single_slide'}},
//             {elm: $('.wide-carousel-slider'), setting: {type: 'wide_carousel_slider'}},
//             {elm: $('.large-promo-module-slider'), setting: {type: 'large_promo_slider'}},
//             {elm: $('.insightsHeroCarousel'), setting: {type: 'large_promo_slider'}},
//             {elm: $('.article-slider'), setting: {type: 'large_promo_slider'}},
//             {elm: $('.expert-container--slider'), setting: {type: 'mobile-only-slider'}},
//             {elm: $('.topic-block'), setting: {type: 'mobile-only-slider'}},
//             {elm: $('.simple-tiles--slider'), setting: {type: 'small-mobile-only-slider'}},
//         ].map(function (item) {
//             if (item.elm.length) {
//                 new GT.GTSwiper(item.elm, {settings: item.setting});
//             }
//         })
//     })();
if (typeof isV1GT == "undefined")
    [
        {
            elm: $('.campaign-slider:not(.slideroff)'),
            setting: {type: 'dotted-pagination', el: '.swiper-pagination'}
        }
    ].map(function (item) {
        if (item.elm.length) {
            new GT.Swiper(item.elm, {settings: item.setting});
        }
    })
/**
 * This file is an attempt to gradually refactor GT.Swiper to
 * a more modular approach in using Swiper:
 * 
 * Instead of keep adding functions and conditions to 1 file
 * This file will go with the following structure:
 * 
 * It will provide a skeleton with named hooks and variables;
 * The functions for these hooks or values of these variables are customizable by settings.
 * 
 * Presets of settings can be declared in the file GTSwiperNeoPreset.js
 * 
 * New presets, new hooks and new variables can be added on the condition that:
 * They must be reusable (no fixed value such as class names or breakpoint values).
 * In other words:
 * - For preset: They should be functions that returning a function or objects.
 * - For hooks: Their defition should be taken from the setting object.
 * - For variables: Their value should be taken from the setting object.
 * 
 * Default values for preset, hooks and variables can be set, but not fixed.
 * 
 * Also a reminder: No css selector should be global
 * For example:
 * - BAD: .swiper-slide { ... }
 * - GOOD: .your-swiper-container .swiper-slide { ... }
 */

 /**
  * Other settings need to be declared at GTConstruct
  * 
  * colNumber: data key to extract the number of column setting (not yet used in GTSwiperNeo, only in GTSwiper)
  * doSwipperAsync: function to control when to initialize the Swiper object
  * doSwipperTimeout: timeout duration for initializing Swiper object
  * extendedSettingFn: function to produce extended setting that are data dependent
  * beforeSwiperInit: function calling before swiper initialization
  * afterSwiperInit: function calling after swiper initialization
  * customInitFn: function to customize when and how to initialize swiper
  * swiperResizeFn: function to run on window resize event
  */

 GT.SwiperNeo = function($swiperContainer, type) {
    var current = this;
    var settings = typeof(type) == "object" && type.settings ? type.settings : (current.getSettingsByType(type) || {});

    // Some default settings
    current.settings = $.extend({}, {
        // Custom setting properties
        colNumber: 'number-of-columns',
        beforeSwiperInit: GT.SwiperNeoPreset.removePaginationOnOneSlide,

        // Swiper API (version 3.x.x)
        // https://github.com/nolimits4web/swiper/blob/Swiper3/API.md
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        pagination: '.swiper-pagination',
        paginationType: 'bullets',
        nextButton: '.slider__next',
        prevButton: '.slider__prev',
        spaceBetween: 32,
        a11y: true,
        keyboardControl: true,
        preventClicks: false
    }, settings);

    var doSwipperTimeout = settings.doSwipperTimeout || 100;
    $swiperContainer.each(function (index, element) {
        if (GT.isFunction(settings.doSwiperAsync)) {
            settings.doSwiperAsync(index, element, doSwiper);
            return;
        }
        doSwiper(element);
    })

    // Swiper object initialization
    function doSwiper(element) {
        setTimeout(function() {
            var DOT = '.';
            var $me = $(element);
            var $slidesContainer = $me.find(DOT + current.settings.wrapperClass);
            var $slides = $me.find(DOT + current.settings.slideClass);
            var numberOfColumns = $me.data(current.settings.colNumber);

            var swiperDOMInfo = {
                $me: $me,
                $slidesContainer: $slidesContainer,
                $slides: $slides,
                numberOfColumns: numberOfColumns
            };

            // Any customized settings should be declared in settings.extendedSettingFn
            var extendedSettings = GT.isFunction(current.settings.extendedSettingFn) ? current.settings.extendedSettingFn(swiperDOMInfo) : {};
            var swiperSettingObject = $.extend({}, current.settings, extendedSettings);

            // DOM manipulation before swiper initialization
            if (GT.isFunction(swiperSettingObject.beforeSwiperInit)) {
                current.settings.beforeSwiperInit(swiperDOMInfo, swiperSettingObject);
            }

            var swiperInstance = null;
            // Initialization of swiper (slider)
            if (!GT.isFunction(swiperSettingObject.customInitFn)) {
                swiperInstance = $me.swiper(swiperSettingObject);
            } else {
                swiperInstance = swiperSettingObject.customInitFn(
                    $me, // JQuery container element
                    swiperInstance, // current swiper instance
                    swiperDOMInfo, // swiper DOM info object
                    swiperSettingObject, // current customized settings
                    current.settings // customized settings that are data independent + default settings
                );
            }

            // DOM manipulation after swiper initialization
            if (GT.isFunction(swiperSettingObject.afterSwiperInit)) {
                swiperSettingObject.afterSwiperInit(swiperDOMInfo, swiperSettingObject);
            }

            // window resize
            if (GT.isFunction(swiperSettingObject.swiperResizeFn)) {
                var windowWidth = $(window).width();
                if ($(window).width() != windowWidth) {
                    swiperInstance = swiperSettingObject.swiperResizeFn(
                        $me,
                        swiperInstance,
                        swiperDOMInfo,
                        swiperSettingObject,
                        current.settings
                    );
                    windowWidth = $(window).width();
                }
            }
        }, doSwipperTimeout);
    }
};

GT.SwiperNeo.prototype.getSettingsByType = function (type) {
    'use strict';
    switch (type) {
        case 'tcpwsb_slider':
            return {
                loop: true,
                resistance: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                paginationClickable: false,
                slidesPerView: 1,
                extendedSettingFn: function () {
                    var settings = {
                        breakpoints: {},
                    };
                    settings.breakpoints[GT.SwiperNeoPreset.breakPoints.tabletMinWidth - 1] = {
                        resistanceRatio: 0.85,
                        spaceBetween: 32
                    };
                    return settings;
                },
                afterSwiperInit: function (swiperDOMInfo) {
                    new GT.LazyBackgrounds(swiperDOMInfo.$slidesContainer.find('.js-lazy-bg'), {settings: {safeDistance: 500}});
                }
            };
        case '.cswsb_slider':
            return {
                loop: true,
                resistance: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                paginationClickable: false,
                slidesPerView: 1,
                extendedSettingFn: function() {
                    var settings = {
                        breakpoints: {},
                    };
                    settings.breakpoints[GT.SwiperNeoPreset.breakPoints.tabletMinWidth - 1] = {
                        resistanceRatio: 0.85,
                        spaceBetween: 32
                    };
                    return settings;
                },
                afterSwiperInit: function (swiperDOMInfo) {
                    new GT.LazyBackgrounds(swiperDOMInfo.$slidesContainer.find('.js-lazy-bg'), { settings: { safeDistance: 500 } });
                }
            };
        case 'rcwib_slider':
            return GT.SwiperNeoPreset.limitedMediaSlider(
                GT.SwiperNeoPreset.breakPoints.tabletMinWidth,
                function () {
                    // Extra setting for limitedMediaSlider preset
                    return {
                        loop: true,
                        afterSwiperInit: function (swiperDOMInfo) {
                            new GT.LazyBackgrounds($('.js-lazy-bg'), { settings: { safeDistance: 500 } });
                            GT.SwiperNeoPreset.clampTextContent([
                                { selector: '.rcwib_item-content-category', lines: 1 },
                                { selector: '.rcwib_item-content-title', lines: 2 },
                            ])(swiperDOMInfo);
                        }
                    };
                }
            );
    }
};

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        [
            {elm: $('.tcpwsb_slider'), type: 'tcpwsb_slider'},
            {elm: $('.cswsb_slider'), type: '.cswsb_slider'},
            {elm: $('.rcwib_slider'), type: 'rcwib_slider'}
        ].map(function (item) {
            if (item.elm.length) {
                new GT.SwiperNeo(item.elm, item.type);
            }
        });
    })

GT.SwiperNeoPreset = {
    // SETTINGS OBJECTS
    /**
     * Properties of a setting object
     * 
     * colNumber: data key to extract the number of column setting (not yet used in GTSwiperNeo, only in GTSwiper)
     * doSwipperAsync: function to control when to initialize the Swiper object
     * doSwipperTimeout: timeout duration for initializing Swiper object
     * extendedSettingFn: function to produce extended setting that are data dependent
     * beforeSwiperInit: function calling before swiper initialization
     * afterSwiperInit: function calling after swiper initialization
     * customInitFn: function to customize when and how to initialize swiper
     * swiperResizeFn: function to run on window resize event
     * 
     * plus any properties from the following API
     * https://github.com/nolimits4web/swiper/blob/Swiper3/API.md
     */

    /**
     * This is a preset function to generate the setting object for a slider which
     * is only initialized from the target breakpoint and below
     * This can be considered to be a refactoring of both "mobile-only-slider" and "small-mobile-only-slider" in GTSwiper
     *
     * @param {Number} targetBreakPoint breakpoint (in pixel) only below which swiper will be initialized
     * @param {Function} extraSettingFn function that returns a setting object
     */
    limitedMediaSlider: function (targetBreakPoint, extraSettingFn) {
        var settings = {
            resistance: true,
            resistanceRatio: 0,
            customInitFn: GT.SwiperNeoPreset.restrictSwiperInitOnBreakpoint(targetBreakPoint),
            breakpoints: {},
            extendedSettingFn: extraSettingFn
        };
        settings.breakpoints[targetBreakPoint - 1] = {
            slidesPerView: 1,
            resistanceRatio: 0.85,
            paginationClickable: false
        };
        return settings;
    },


    // SHARED FUNCTIONS

    /**
     * An extended function of GTSwiper's hadleResize_ExpertBlock
     * Control at which break point the swiper shall be initialized
     *
     * @param {Number} targetBreakPoint breakpoint (in pixel) only below which swiper will be initialized
     */
    restrictSwiperInitOnBreakpoint: function (targetBreakPoint) {
        return function($me, swiperInstance, _swiperDOMInfo, swiperSettingObject, _baseSettings) {
            var breakpoint = window.matchMedia('(min-width:' + targetBreakPoint + 'px)');
            var mySwiper = swiperInstance;
            var enableSwiper = function() {
                mySwiper = $me.swiper(swiperSettingObject);
            };
            var breakpointChecker = function() {
                if (breakpoint.matches) {
                    if (mySwiper && mySwiper.destroy) {
                        try {
                            mySwiper.destroy(true, true);
                        } catch (exception) {}
                    }
                    return;
                } else {
                    return enableSwiper();
                }
            };
            breakpoint.addListener(breakpointChecker);
            breakpointChecker();
            return mySwiper; // This is important!
        };
    },

    /**
     * Default beforeInitFn function
     * Remove swiper pagination and navigation buttons when there is only one slide
     */
    removePaginationOnOneSlide: function (swiperDOMInfo, swiperSettingObject) {
        if (swiperDOMInfo.$slides.length === 1) {
            swiperDOMInfo.$slidesContainer.addClass('disabled');
            swiperDOMInfo.$me.find(swiperSettingObject.pagination).remove();
            swiperDOMInfo.$me.find(swiperSettingObject.nextButton).remove();
            swiperDOMInfo.$me.find(swiperSettingObject.prevButton).remove();
        }
    },

    /**
     * Truncate slide text content based on the clamp options
     * 
     * @param {Array} clampOptionArray each option is an object { selector: string, lines: interger | function returning integer }
     * selector: CSS selector to find the item containing the text to be truncated
     * lines: the number of lines the text is to be limited to
     * 
     * @param {String} clampDataKey data key to get the original text
     */
    clampTextContent: function (clampOptionArray, clampDataKey) {
        var dataKey = clampDataKey || 'clamp';
        return function (swiperDOMInfo, _swiperSettingObject) {
            // Function to execute clamping
            var clampSwiper = function () {
                swiperDOMInfo.$slides.each(function (_index, slide) {
                    clampOptionArray.map(function (option) {
                        // Get the number of lines
                        var lines = 3; // Default value
                        if (GT.isFunction(option.lines)) {
                            // option.lines is a function
                            lines = option.lines($targetTextContainer);
                        } else if (GT.isInteger(option.lines)) {
                            // option.lines is a number
                            lines = option.lines;
                        }

                        // Restore the original text
                        var $targetTextContainer = $(slide).find(option.selector);
                        var originalText = $targetTextContainer.data(dataKey);
                        if (originalText) {
                            $targetTextContainer.html(originalText);
                        }

                        // Execute clamping
                        GT.Clamp($targetTextContainer, { settings: { clamp: lines }});
                    });
                });
            };

            // Immediately run clamping
            clampSwiper();

            var windowWidth = $(window).width();
            // Handle window resize event
            $(window).resize(function () {
                if ($(window).width() != windowWidth) {
                    clampSwiper();
                }
            });
        }
    },

    // POPULAR BREAKPOINTS
    breakPoints: {
        tabletMinWidth: 768
    }
};

// GT SWITCH VIEW FOR T42 EVENT BLOCK

GT.SwitchView = function ($elem) {
    let GTSwitchView = this;
    try {
        $.each($elem, function() {
            let $container = $(this).closest('.events-block').find('.events-container');
            GTSwitchView.switchView($elem, $container);
        })
    } catch (e) {

    }

};
GT.SwitchView.prototype.changeView = function ($container, $currentElem) {
    let clampname = $container[0].dataset.clampname;
    $currentElem.closest('.change-view-cont').find('button').removeClass('enabled');
    $currentElem.addClass('enabled');
    if ($currentElem.hasClass('enable-grid-view')) {
        $container.removeClass('list-view');
        $container.addClass('grid-view');
        GT.clampRevertToOriginalText(clampname);
        GT.clampText(clampname, true);
    } else {
        $container.removeClass('grid-view');
        $container.addClass('list-view');
        GT.clampRevertToOriginalText(clampname);
        GT.clampText(clampname, true);
    }
    $(window).trigger('resize'); // to run GTEqualise
};

GT.SwitchView.prototype.switchView = function ($elem, $container) {
    var GTSwitchView = this;

    $elem.on('click', function (e) {
        e.preventDefault();
        var $currentElem = $(this);
        if ($currentElem.hasClass("enabled")) {
            return false;
        }
        GTSwitchView.changeView($container, $currentElem);
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.SwitchView($('.event-switch-view'));
        new GT.SwitchView($('.seminar-switch-view'));
    })
GT.Table = function () {
    let isRTL = document.querySelector(".RTL");
    document.querySelectorAll(".table-v2__fixed-layout").forEach(item => {
        item.addEventListener("scroll", e => {
            let currentTable = e.target;
            if (currentTable.scrollLeft * (isRTL ? -1 : 1) > 0)
                currentTable.classList.add("scrolling");
            else
                currentTable.classList.remove("scrolling");
        })
    })

    document.querySelectorAll(".table-v2__accordion-layout tr td:nth-child(1)").forEach(item => {
        item.addEventListener("click", e => {
            let currentTarget = e.target;
            let trElm = currentTarget.closest("tr");
            if (!["button", "a"].includes(currentTarget.nodeName.toLowerCase())) {
                if(trElm) {
                    trElm.classList.toggle("expand");
                    trElm.querySelectorAll("td").forEach(tdElm => {
                        tdElm.style.setProperty("--table-v2--td-height", (tdElm.querySelector(".table-v2__content")?.offsetHeight || 0) + "px");
                    })
                    setTimeout(e => {
                        trElm.classList.toggle("animate");
                    }, 300)
                }
            }

            if(currentTarget.classList.contains("table-v2__toggle-btn")) {
                currentTarget.closest("td").click();
            }

            trElm.querySelector(".table-v2__toggle-btn").setAttribute("aria-expanded", trElm.classList.contains("expand"));
        })
    })

    let lastExpandBtn;

    window.addEventListener("keydown", e => {
        if(e.key == "Escape") {
            let externalTable = document.querySelector(".external-table");
            if(externalTable) {
                externalTable.querySelector(".table-v2--close")?.click();
                setTimeout(e => {
                    externalTable.remove();
                    lastExpandBtn?.focus();
                }, 500)
            }
        }
    })

    document.querySelectorAll(".table-v2--expand").forEach(expandBtn => {
        expandBtn.addEventListener("click", e => {
            document.body.insertAdjacentHTML("beforeend", `<div class="external-table"></div>`);
            let currentTarget = e.target.closest("button"),
                currentTable = currentTarget.closest(".table-v2-container").outerHTML;
            lastExpandBtn = currentTarget;
            lastExpandBtn.classList.add("table-v2--hide-expand");
            let externalTable = document.querySelector(".external-table");
            GT.setInertWhileOpeningDialog(true);
            document.firstElementChild.classList.add("showing-overlay");

            externalTable.innerHTML = currentTable;
            externalTable.querySelector(".table-v2")?.classList.add("table-v2__fixed-layout");
            setTimeout(e => {
                externalTable.classList.add("show");
            }, 0)

            let closeBtn = externalTable.querySelector(".table-v2--close");
            closeBtn.focus();
            closeBtn.addEventListener("click", closeEvt => {
                externalTable.classList.remove("show");
                setTimeout(e => {
                    GT.setInertWhileOpeningDialog(false);
                    lastExpandBtn?.classList.remove("table-v2--hide-expand");
                    document.firstElementChild.classList.remove("showing-overlay");
                    externalTable.remove();
                    lastExpandBtn?.focus();
                }, 500)
            })
        })
    })
}

GT.domContentLoadedFncList.push(function () {
    GT.Table();
});

var GTTabs = function () {
    this.firmTabs = function ($elem) {
        // containers: .member-firms / .correspondent-firms
        // tab btns: .firm-tabs / #membFirm / #corrFirm
        if (!$('body').hasClass('epi-editmode')) {
            $('.correspondent-firms').hide();
        } // hide if it's not in edit mode

        // on click event
        $elem.find('a').on('click keydown', function (e) {
            if (!e.keyCode || e.keyCode === '13') {
                // hide all tabs
                // get href from anchor
                var currentTab = $(this).attr('id');
                // append "_container" to end of the href (this prevents
                // the page scrolling to the content of the hash value)

                if (currentTab === 'membFirm') {
                    $('#corrFirm').removeClass('active');
                    $('.correspondent-firms').hide();
                    $('.member-firms').fadeIn();
                } else if (currentTab === 'corrFirm') {
                    $('#membFirm').removeClass('active');
                    $('.member-firms').hide();
                    $('.correspondent-firms').fadeIn();
                }

                $(this).addClass('active');

                return false;
            }
        });
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.Tabs = new GTTabs();
    GT.Tabs.firmTabs($('.firm-tabs'));
});
GT.TombstoneTransactionEvents = {};
GT.TombstoneTransaction = function (forceReregisterEvt) {
    flipTransaction();
    function flipTransaction() {
        if(forceReregisterEvt) {
            Array.prototype.slice.call(document.querySelectorAll('.transaction-content')).forEach(function(el) {
                delete el.dataset.initedClickEvt;
                el.removeEventListener("click", GT.TombstoneTransactionEvents[el.dataset.eventClick]);
            })
            //wait for Remove Click Event completely
            Array.prototype.slice.call(document.querySelectorAll('.transaction-content')).forEach(function(el) {
                delete GT.TombstoneTransactionEvents[el.dataset.eventClick];
            })
        }
        Array.prototype.slice.call(document.querySelectorAll('.transaction-content')).forEach(function(el) {
            if(!el.dataset.initedClickEvt) {
                let eventClick = "tombstone_evt_" + Math.floor(Math.random() * 10000);
                el.dataset.eventClick = eventClick;

                function clickEvtHandler(e){
                    e.stopPropagation()
                    let triggerElms = el.parentElement.dataset.index != null ? Array.prototype.slice.call(document.querySelectorAll('.transaction-list__item[data-index="'+ el.parentElement.dataset.index +'"]')) : [el.parentElement];
                    triggerElms.forEach(function(elm){
                        elm.classList.toggle('active');
                    })
                }

                GT.TombstoneTransactionEvents[eventClick] = clickEvtHandler;
                el.addEventListener('click', clickEvtHandler);


                Array.prototype.slice.call(el.querySelectorAll('.expert-item__name')).forEach(function(child) {
                    child.addEventListener('click', function(e){
                        e.stopPropagation();
                    });
                });

                Array.prototype.slice.call(el.querySelectorAll('.transaction-readmore')).forEach(function(child) {
                    child.addEventListener('click', function(e){
                        e.stopPropagation();
                    });
                });
                el.dataset.initedClickEvt = true;
            }
        });
    }
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        new GT.TombstoneTransaction(document.querySelector('.transaction-content'));
    });
GT.TouchBlur = function ($element, obj) {
    this.current = $element;
    this.current.on('touchend', this.touchEndHandler);
};

GT.TouchBlur.prototype.touchEndHandler = function(e){
    var _this = $(this);
    _this.blur();
};



////////////////////////////
// GT TRACKING FUNCTIONS //
////////////////////////////
var GTTrack = function () {

    /**
     * Adds Episerver.Find tracking to SearchResults partial view
     */
    this.clickTracking = function ($elem) {
        $("#ResultListWrapper a")
            .click(function (e) {
                var $link = $(this);
                $.get("/ClickTracking/Track",
                    { query: $link.data("query"), hitId: $link.data("hitid"), trackId: $link.data("trackid") });
            });
    };

    /**
     * Track downloads of pdf or xls files attached on article pages
     */
    this.trackPDFs = function ($elem) {
        $('a').on("click.pdf",
            function (e) {
                // get url, filename & filetype
                let __ths = this;
                var href = $(this).attr("href");
                if (href) {
                    var fourCharFileType = href.substr(href.length - 4).toLowerCase();
                    var fileType = href.substr(href.length - 3).toLowerCase();

                    if (fourCharFileType === "xlsx" || fourCharFileType === "xlsm" || fileType === "xls") {
                        //e.preventDefault();
                        var fileName = href.substr(href.lastIndexOf("/") + 1);
                        dataLayer.push({ 'event': 'xls', 'eventAction': 'download', 'eventLabel': fileName });
                    }

                    if (fileType === "pdf") {
                        e.preventDefault();
                        var fileName = href.substr(href.lastIndexOf("/") + 1).slice(0, -4);
                        dataLayer.push({ 'event': fileType, 'eventAction': 'download', 'eventLabel': fileName });

                        // Women in Business - Outbrain Pixel Tag Implementation
                        if (fileName === 'ibr2015_wib_report_final') {
                            // add image with display none
                            $(new Image())
                                .attr('src', 'http://traffic.outbrain.com/network/trackpxl?advid=25202&action=view')
                                .appendTo($(this))
                                .css('display', 'none');
                            // when the image has loaded - redirect to the PDF url (if this isnt added it wont fire the above)
                            $('img')
                                .one('load',
                                    function () {
                                        if(__ths.target)
                                            window.open(href, __ths.target);
                                        else
                                            window.location.href = href;
                                    });
                        } else {
                            if(__ths.target)
                                window.open(href, __ths.target);
                            else
                                window.location.href = href;
                        }
                    }
                }
            });
    };
};

GT.domContentLoadedFncList.push(function(){
    GT.Track = new GTTrack();
    GT.Track.trackPDFs($('.download-pdf-link'));
    GT.Track.clickTracking($('#ResultListWrapper'));
});
var initTranslationDetect = function() {
	var allowTranslator = allowTranslateDetector();
	if(!allowTranslator) return;
    var originalLang = $('html').attr('lang');
	var observer = new MutationObserver(checkLang);
	function checkLang(){
		var currentLang = $('html').attr('lang');
        if (currentLang !== originalLang){
        	$('body').addClass('lang-changed');
			$(window).trigger('user-translate');
			originalLang = currentLang;
        }
	}
	var htmlDom = document.getElementsByTagName('html')[0];
	observer.observe(htmlDom,  { attributes: true, childList: false, subtree: false });

	function allowTranslateDetector(){
		var hasMutation = typeof MutationObserver !== undefined;
		var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		var notMobile = window.screen.width > 768;
		return hasMutation && isChrome && notMobile;
	}
}

initTranslationDetect();
//trimmming helper function
function trimSentence(s, l) {
    /* s: string to trim
       l: length to trim to
    */

    //trim whitespace from beginning and end of string that episerver adds
    s = s.trim();

    if (s.length <= l) {
        //do nothing, string is fine as is
    } else {
        l = l - 2; //absolute max length - ellipsis
        s = s.substring(0, l);

        //find last occurence of a word break; trim to it
        var lastSpace = s.lastIndexOf(" ");
        s = s.substring(0, lastSpace);
        s = s + "&hellip;";
    }
    return s;
};

GT.Trim = function ($element) {
    /* $element: element to act within
     */

    var textblocks = $($element).find('.text');
    for (var i = 0; i < textblocks.length; i++) {
        var s = trimSentence($(textblocks[i]).text(), 90);
        $(textblocks[i]).html(s);
    }

    var titleblocks = $($element).find('.title');
    for (var i = 0; i < titleblocks.length; i++) {
        var s = trimSentence($(titleblocks[i]).text(), 40);
        $(titleblocks[i]).html(s);
    }
};
/// <reference path="../plugins/phone-utils.js" />
GT.UpsaleEvents = function () {

    phoneFlagInit(document.getElementById('up-form'));
    matchClientsInput();
    addlableForInput();
    phoneFlagAccessibility();



    function addlableForInput() {
        var inputHint = $('.twitter-typeahead').find('.tt-input.tt-hint');
        if(inputHint.length > 0) {
            inputHint.attr('aria-hidden', 'true');
        }
    }

    function phoneFlagAccessibility() {
        var selectedFlag = $('.iti__selected-flag');
        if(selectedFlag) {
            selectedFlag.attr('aria-expanded', 'false');
            selectedFlag.click(function() {
                if(selectedFlag.find('.iti__arrow').hasClass('iti__arrow--up')) {
                    selectedFlag.attr('aria-expanded', 'true');
                } else {
                    selectedFlag.attr('aria-expanded', 'false');
                }
            });
        }
        
        
    }

    function matchClientsInput() {
        let nameField = document.querySelector("#up-client-name-input");
        if (nameField) {
            let spinner = document.querySelector("#up-client-spinner"),
                dunsField = document.querySelector("#up-client-dunsNo");
            
            spinner.style.display = "none";
            
            function orphanCharAsWord(word) {
                return word.length > 1 ? word : ' ' + word + ' ';
            }

            try {

                if(window.currentAutoComplete)
                    window.currentAutoComplete.destroy();

                window.currentAutoComplete = new autoComplete({
                    selector: `#up-client-name-input`,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    menuClass: 'upsale-eventform__autosuggestion',
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&');
                        
                        spinner.style.display = "inline";
                        
                        $.ajax({
                            url: "https://power.upsales.com/api/external/soliditet/clientSearch",
                            type: "get",
                            data:  { name: term },
                            success: function (res) {
                                suggest(res.data);  
                                spinner.style.display = "none";
                                if(!res.data || res.data.length <= 0) {
                                    let _autoCompleteItems = document.querySelectorAll('.autocomplete-suggestion');
                                    
                                    [].forEach.call(_autoCompleteItems, function(_autoCompleteItem){
                                        if(_autoCompleteItem) _autoCompleteItem.remove();
                                    });
                                }                  
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.name.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return "<div class='autocomplete-suggestion' data-val='" + item.name + "'  data-no='" + item.dunsNo + "'><div>" + decodedText.replace(re, "<b>$1</b>") + "</div><span class='city-name'>" + item.city + "</span></div>";
                    },
                    onSelect: function (e, term, item) {
                        dunsField.value = item.dataset.no;
                        nameField.value = item.dataset.val;
                    }
                });
            } catch (ex) {
                console.warn(ex);
            };
        }
    }
    function phoneFlagInit($elm) {
        var phoneFields = $elm.querySelectorAll('input[name*=phone], input[name*=Phone]');
        [].forEach.call(phoneFields, function (element) {
            window.hasPhoneFields = true;
            element.iti = window.intlTelInput(element, {
                preferredCountries: [],
                initialCountry: 'auto',
                utilsScript: '/dist/plugins/phone-utils.js',
                geoIpLookup: function (success) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', 'https://power.upsales.com/api/external/whereAmI');
                    xhr.onload = function () {
                        success(xhr.status === 200 ? JSON.parse(xhr.responseText).data : "");
                    };
                    xhr.send();
                }
            });
        });
    }

    function checkemail(str) {
        var filter = /^[a-zA-Z0-9.!#$%&�*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,}$/;

        if (filter.test(str))
            return true;
        else {
            return false;
        }
    }

    function checkBlockingPrivateEmail(str) {
        let blockEmailInputElm = document.querySelector("#formBlockPrivateEmail"),
            blockEmailStr = "";

        if(blockEmailInputElm)
            blockEmailStr = blockEmailInputElm.value.replaceAll(",", "|").replaceAll(" ", "");

        if (!blockEmailStr || new RegExp(blockEmailStr).test(str) == false)
            return true;
        else {
            return false;
        }
    }

    function validateForm(event) {    
        event.preventDefault();
        var formId = document.getElementsByName('formId')[0].value;
        var form = document.forms['form_' + formId];
        var inputs = form.querySelectorAll('input');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type === 'text') {
                inputs[i].value = inputs[i].value.trim();
            }
        }
        //if (!form.checkValidity()) {
        //    return false;
        //}
        let isSuccess = true,
            failFlag = [];

        var focusField = '';
        var contactName = $('input[name="Contact.name"]');
        if (!contactName.val().length) {
            contactName.parent().addClass('validate-failed');
            focusField = "Contact.name";
            failFlag.push(true);
        } else {
            contactName.parent().removeClass('validate-failed');
        }

        var contactEmail = $('input[name="Contact.email"]');
        if (!contactEmail.val().length) {
            contactEmail.parent().addClass('validate-failed');
            if (!focusField) focusField = "Contact.email";
            failFlag.push(true);
        } else {
            contactEmail.parent().removeClass('validate-failed');
        }

        if (!checkemail(contactEmail.val())) {
            contactEmail.parent().removeClass('validate-failed-private-email');
            contactEmail.parent().addClass('validate-failed');
            if (!focusField) focusField = "Contact.email";
            failFlag.push(true);
        } else {
            contactEmail.parent().removeClass('validate-failed');
        }

        if(checkemail(contactEmail.val())) {
            if (!checkBlockingPrivateEmail(contactEmail.val())) {
                contactEmail.parent().addClass('validate-failed');
                contactEmail.parent().addClass('validate-failed-private-email');
                if (!focusField) focusField = "Contact.email";
                failFlag.push(true);
            } else {
                contactEmail.parent().removeClass('validate-failed');
                contactEmail.parent().removeClass('validate-failed-private-email');
            }
        }


        var clientsName = $('input[name="Client.name"]');
        if (!clientsName.val().length) {
            clientsName.parents('.form-group').addClass('validate-failed');
            if (!focusField) focusField = "Client.name";
            failFlag.push(true);
        } else {
            clientsName.parents('.form-group').removeClass('validate-failed');
        }

        var title = $('input[name="Contact.title"]');
        if (!title.val().length) {
            title.parents('.form-group').addClass('validate-failed');
            if (!focusField) focusField = "Contact.title";
            failFlag.push(true);
        } else {
            title.parents('.form-group').removeClass('validate-failed');
        }

        var cellPhone = $('input[name="Contact.cellPhone"]');
        if (!cellPhone.val().length) {
            cellPhone.parents('.form-group').addClass('validate-failed');
            if (!focusField) focusField = "Contact.cellPhone";
            failFlag.push(true);
        } else {
            cellPhone.parents('.form-group').removeClass('validate-failed');
        }

        if ((recaptcha && !grecaptcha.getResponse().length)) {
            $('.g-recaptcha').parents('.form-group').find('.captcha-error').show();
            failFlag.push(true);
        } else {
            $('.g-recaptcha').parents('.form-group').find('.captcha-error').hide();
        }

        if(failFlag.length)
            isSuccess = false;
        else
            isSuccess = true;

        if (!isSuccess) {
            $('input[name="' + focusField + '"]').focus();
        }
        return isSuccess;
    }

    $("#upsaleSubmitBtn").click(function (event) {   
        event.preventDefault();
        var _this = $(this);
        if (!validateForm(event)) return false;
        var formId = document.getElementsByName('formId')[0].value;
        var form = document.forms['form_' + formId];
        
        var postFormURL = $(this).data('upsalepostajax');
        
        _this.attr("disabled", "disabled");
        var data = $(form).serialize();
        data += "&isAjax=true";
        var confirmLink = $('#event-confimation-page-link').val();
        $.ajax({
            type: "POST",
            url: postFormURL,
            data: data,
            success: function (qs) {
                $(this).removeAttr("disabled");
                if (confirmLink) {
                    setTimeout(function () {
                        window.top.location.href = confirmLink;
                    }, 333);
                } else {
                    $("#up-form").hide();
                    $("#up-form-thanks").show();
                }
            },
            error: function (res) {
                var errorHtml = '<div id="event-full-message"><span class="upsale-error__message">{{errormessage}}</span></div>';
                var mess = '';
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_FULL') {
                    mess = $('#hdf_event_full_mess').val();
                }
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_CANCELED') {
                    mess = $('#hdf_event_cancel_mess').val();
                }
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_CONTACT_DUPLICATE') {
                    mess = $('#hdf_cantact_duplicate_mess').val();
                }
                if (mess) {
                    errorHtml = errorHtml.replace(/\{\{errormessage\}\}/g, mess);
                    if ($('#event-full-message').length) {
                        $('#event-full-message').remove();
                    }
                    _this.before(errorHtml);
                }
                _this.removeAttr("disabled");
            }
        });
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.UpsaleEvents();
    });
GT.UpsaleOnDemandEvents = function () {

    matchClientsInput();
    addlableForInput();
    function addlableForInput() {
        var inputHint = $('.twitter-typeahead').find('.tt-input.tt-hint');
        if(inputHint.length > 0) {
            inputHint.attr('aria-hidden', 'true');
        }
    }
    function matchClientsInput() {
        let nameField = document.querySelector("#up-client-name-input");
        if (nameField) {
            let spinner = document.querySelector("#up-client-spinner"),
                dunsField = document.querySelector("#up-client-dunsNo");
            
            spinner.style.display = "none";
            
            function orphanCharAsWord(word) {
                return word.length > 1 ? word : ' ' + word + ' ';
            }

            try {

                if(window.currentAutoComplete)
                    window.currentAutoComplete.destroy();

                window.currentAutoComplete = new autoComplete({
                    selector: `#up-client-name-input`,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    menuClass: 'upsale-eventform__autosuggestion',
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&');
                        
                        spinner.style.display = "inline";
                        
                        $.ajax({
                            url: "https://power.upsales.com/api/external/soliditet/clientSearch",
                            type: "get",
                            data:  { name: term },
                            success: function (res) {
                                suggest(res.data);  
                                spinner.style.display = "none";                      
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.name.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return "<div class='autocomplete-suggestion' data-val='" + item.name + "'  data-no='" + item.dunsNo + "'><div>" + decodedText.replace(re, "<b>$1</b>") + "</div><span class='city-name'>" + item.city + "</span></div>";
                    },
                    onSelect: function (e, term, item) {
                        dunsField.value = item.dataset.no;
                        nameField.value = item.dataset.val;
                    }
                });
            } catch (ex) {
                console.warn(ex);
            };
        }
    }

    function checkemail(str) {
        var filter = /^[a-zA-Z0-9.!#$%&�*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,}$/;
        if (filter.test(str))
            return true;
        else {
            return false;
        }
    }
    
    function checkBlockingPrivateEmail(str) {
        let blockEmailInputElm = document.querySelector("#formBlockPrivateEmail"),
            blockEmailStr = "";

        if(blockEmailInputElm)
            blockEmailStr = blockEmailInputElm.value.replaceAll(",", "|").replaceAll(" ", "");

        if (!blockEmailStr || new RegExp(blockEmailStr).test(str) == false)
            return true;
        else {
            return false;
        }
    }

    function validateForm(event) {    
        event.preventDefault();
        var formId = document.getElementsByName('formId')[0].value;
        var form = document.forms['form_' + formId];
        var inputs = form.querySelectorAll('input');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type === 'text') {
                inputs[i].value = inputs[i].value.trim();
            }
        }

        let isSuccess = true,
            failFlag = [];
        var focusField = '';

        var contactFirstName = $('input[name="Contact.firstname"]');
        if (!contactFirstName.val().length) {
            contactFirstName.parent().addClass('validate-failed');
            focusField = "Contact.firstname";
            failFlag.push(true);
        } else {
            contactFirstName.parent().removeClass('validate-failed');
        }

        var contactLastName = $('input[name="Contact.lastname"]');
        if (!contactLastName.val().length) {
            contactLastName.parent().addClass('validate-failed');
            if (!focusField) focusField = "Contact.lastname";
            failFlag.push(true);
        } else {
            contactLastName.parent().removeClass('validate-failed');
        }
        var contactEmail = $('input[name="Contact.email"]');
        if (!contactEmail.val().length) {
            contactEmail.parent().addClass('validate-failed');
            if (!focusField) focusField = "Contact.email";
            failFlag.push(true);
        } else {
            contactEmail.parent().removeClass('validate-failed');
        }

        if (!checkemail(contactEmail.val())) {
            contactEmail.parent().removeClass('validate-failed-private-email');
            contactEmail.parent().addClass('validate-failed');
            if (!focusField) focusField = "Contact.email";
            failFlag.push(true);
        } else {
            contactEmail.parent().removeClass('validate-failed');
        }

        if(checkemail(contactEmail.val())) {
            if (!checkBlockingPrivateEmail(contactEmail.val())) {
                contactEmail.parent().addClass('validate-failed');
                contactEmail.parent().addClass('validate-failed-private-email');
                if (!focusField) focusField = "Contact.email";
                failFlag.push(true);
            } else {
                contactEmail.parent().removeClass('validate-failed');
                contactEmail.parent().removeClass('validate-failed-private-email');
            }
        }

        var clientsName = $('input[name="Client.name"]');
        if (!clientsName.val().length) {
            clientsName.parents('.form-group').addClass('validate-failed');
            if (!focusField) focusField = "Client.name";
            failFlag.push(true);
        } else {
            clientsName.parents('.form-group').removeClass('validate-failed');
        }

        if ((recaptcha && !grecaptcha.getResponse().length)) {
            $('.g-recaptcha').parents('.form-group').find('.captcha-error').show();
            failFlag.push(true);
        } else {
            $('.g-recaptcha').parents('.form-group').find('.captcha-error').hide();
        }

        if(failFlag.length)
            isSuccess = false;
        else
            isSuccess = true;

        if (!isSuccess) {
            $('input[name="' + focusField + '"]').focus();
        }
        return isSuccess;
    }

    $("#upsaleSubmitBtn").click(function (event) {   
        event.preventDefault();
        var _this = $(this);
        if (!validateForm(event)) return false;
        var formId = document.getElementsByName('formId')[0].value;
        var form = document.forms['form_' + formId];
        
        var postFormURL = $(this).data('upsalepostajax');
        
        _this.attr("disabled", "disabled");
        var data = $(form).serialize();
        data += "&isAjax=true";
        $.ajax({
            type: "POST",
            url: postFormURL,
            data: data,
            success: function (qs) {
                $(this).removeAttr("disabled");
                $("#up-form").hide();
                setCookie();
                window.location.reload();
            },
            error: function (res) {
                var errorHtml = '<div id="event-full-message"><span class="upsale-error__message">{{errormessage}}</span></div>';
                var mess = '';
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_FULL') {
                    mess = $('#hdf_event_full_mess').val();
                }
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_CANCELED') {
                    mess = $('#hdf_event_cancel_mess').val();
                }
                if (res && res.responseJSON && res.responseJSON.error === 'EVENT_CONTACT_DUPLICATE') {
                    mess = $('#hdf_cantact_duplicate_mess').val();
                }
                if (mess) {
                    errorHtml = errorHtml.replace(/\{\{errormessage\}\}/g, mess);
                    if ($('#event-full-message').length) {
                        $('#event-full-message').remove();
                    }
                    _this.before(errorHtml);
                }
                _this.removeAttr("disabled");
            }
        });
    });

    function setCookie() {
        var onDemandCookieValue = document.getElementsByName('onDemandCookieValue')[0].value;
        var onDemandUpsaleCookieName = document.getElementsByName('onDemandUpsaleCookieName')[0].value;
		var currentCookie = GT.Cookies.getCookie(onDemandUpsaleCookieName);
		if (currentCookie) {
			if (!currentCookie.includes(onDemandCookieValue))
				GT.Cookies.setCookieWithoutServerCheck(onDemandUpsaleCookieName, currentCookie + "," + onDemandCookieValue, 365, "/");
		} else {
			GT.Cookies.setCookieWithoutServerCheck(onDemandUpsaleCookieName, onDemandCookieValue, 365, "/");
		}
	}
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        GT.UpsaleOnDemandEvents();
    });
GT.UpsaleFormV2 = function () {

    function handleUpsalesIframeMessage() {
        const iframes = document.querySelectorAll('iframe[src*="pages.upsales.com"]');
        if (!iframes.length) return;

        const getFormTheme = (iframe) => {
            let formTheme = 'grey';
            const isWhitePage = document.querySelector('.page-bg-white, .t45-insights-page');
            if (isWhitePage) formTheme = 'white';
            if (iframe.closest('.bg-inverse__white')) formTheme = 'white';
            if (iframe.closest('.bg-inverse__grey') || iframe.closest('.t45-page--bottom')) formTheme = 'grey';
            if (iframe.closest('.bg-inverse__purple')) formTheme = 'purple';
            return formTheme;
        };

        iframes.forEach(iframe => {
            const formTheme = getFormTheme(iframe);
            
            iframe.addEventListener('load', () => {
                iframe.contentWindow.postMessage(
                    { formTheme },
                    'https://pages.upsales.com'
                );
            });
        });
    }
    function updateFieldWrapClass(fieldWrap, className, shouldAdd) {
        if (shouldAdd) {
            fieldWrap.classList.add(className);
        } else {
            fieldWrap.classList.remove(className);
        }
    }

    function filledClassHandle(item, fieldWrap) {
        const hasValue = item.value && item.value.length > 0;
        updateFieldWrapClass(fieldWrap, 'filled', hasValue);
    }

    function addLabelTitle(field, fieldWrap) {
        const label = fieldWrap.querySelector('label');
        const labelContent = label?.textContent.trim();

        if (!labelContent) return;

        label.setAttribute('title', labelContent);
        field.setAttribute('title', labelContent);
    }

    function addFieldEventListeners(element, fieldWrap) {
        element.addEventListener('focusin', () => updateFieldWrapClass(fieldWrap, 'focus', true));
        element.addEventListener('focusout', () => updateFieldWrapClass(fieldWrap, 'focus', false));
        element.addEventListener('change', (e) => filledClassHandle(e.target, fieldWrap));
    }

    function initFloatingLabelBehavior() {
        const upForm = document.querySelector('form#up-form');
        if (!upForm) return;

        const inputFields = upForm.querySelectorAll('.form-control, input[type="text"], input[type="email"]');

        inputFields.forEach(element => {
            const fieldWrap = element.closest('.form-group');
            if (!fieldWrap) return;

            fieldWrap.classList.add('floating-label');
            addLabelTitle(element, fieldWrap);

            // Check initial state
            setTimeout(() => filledClassHandle(element, fieldWrap), 1000);

            addFieldEventListeners(element, fieldWrap);
        });

        setTimeout(() => {
            const flagContainer = upForm.querySelector('.iti__flag-container');
            flagContainer && flagContainer.closest('.form-group')?.classList.add('form-group--flag-container');
        }, 500);
    }

    initFloatingLabelBehavior();
    handleUpsalesIframeMessage();
};
GT.domContentLoadedFncList.push(function () {
    GT.UpsaleFormV2();
});
GT.ViaTTSubscribe = function() {
    let endpoint = document.querySelector(".subscribePressEndpoint")?.dataset.endpoint;
    if(endpoint) {
        let viaTTSubscriptionDialog = document.querySelector(".viatt-press-subscription-dialog"),
            successMessageElm = viaTTSubscriptionDialog.querySelector(".success-message"),
            errorMessageElm = viaTTSubscriptionDialog.querySelector(".error-email"),
            errorMessageResponseElm = viaTTSubscriptionDialog.querySelector(".error-response"),
            emailInputElm = document.querySelector("#subscribeEmail");
            formGroup = emailInputElm?.closest(".form-group");
            httpService = new HttpService(),
            gtHelper = new GTHelper(),
            gtRecaptcha = null,
            submitBtn = viaTTSubscriptionDialog.querySelector(".submit-btn");

        if (formGroup && emailInputElm) {
            formGroup.classList.add("floating-label");

            emailInputElm.addEventListener("focus", () => {
                formGroup.classList.add("focus");
            });
    
            emailInputElm.addEventListener("blur", () => {
                formGroup.classList.remove("focus");
                if (emailInputElm.value) {
                    formGroup.classList.add("filled");
                } else {
                    formGroup.classList.remove("filled");
                }
            });
        }
        
        submitBtn?.addEventListener("click", e => {
            let captchaElm = document.querySelector(".g-recaptcha-response"),
                captchaErrElm = document.querySelector(".captcha-error"),
                emailStr = emailInputElm?.value;

            errorMessageResponseElm.classList.add("hide");
            errorMessageElm?.classList.add("hide");
            if(!emailStr || !gtHelper.validateEmail(emailStr)) {
                errorMessageElm?.classList.remove("hide");
                emailInputElm?.classList.add("error");
                emailInputElm?.focus();
                return;
            }

            captchaErrElm && (captchaErrElm.style.display = "none");
            if(!captchaElm?.value) {
                captchaErrElm && (captchaErrElm.style.display = "block");
                return;
            }

            submitBtn.setAttribute("disabled", true);
            httpService.get(endpoint+"&emailAddress="+emailStr).then(data => {
                if(data.success) {
                    successMessageElm?.classList.remove("hide");
                    viaTTSubscriptionDialog.querySelector(".form-area")?.classList.add("hide");
                } else {
                    errorMessageResponseElm.innerHTML = data.message;
                    errorMessageResponseElm.classList.remove("hide");
                    submitBtn.removeAttribute("disabled");
                }
            })
        })
    }
}


GT.domContentLoadedFncList.push(GT.ViaTTSubscribe);
GT.VideoBannerBlocks = function($element, obj) {
    $element.each(function(index, element) {
        new GT.VideoBannerBlock(element, obj);
        return false;
    });
};

GT.VideoBannerBlock = function(element, obj) {
    var _this = this;
    var _iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var _iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    var _isMobile = /Mobi/.test(navigator.userAgent) && !window.MSStream;

    _this.intervalId = null;
    _this.hideTimeout = obj.settings.hideTimeout || video.data("hide-timeout");
    _this.forceLoadOnMobile = obj.settings.forceLoadOnMobile || false;
    _this.videoArray = [];
    _this.isIOS = _iOS;
    _this.isMobile = _isMobile;
    _this.videoArray.push(element);

    if (_iOS && _iPhone && iOSversion() === 10) {
        $(element).addClass('ios10-video-fullscreen');
    }
    _this.loadVideo();

    function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return parseInt(v[1], 10);
        }
    }
    
};

GT.VideoBannerBlock.prototype.hideVideoAfterTimeout = function(video) {
    var _this = this;
    var currentVideo = video[0];
    currentVideo.pause();
    video.parent().removeClass("video-playing").removeClass("showing-video");
    if (_this.isIOS || _this.isMobile) {
        if (typeof(currentVideo.webkitExitFullscreen) !== "undefined") {
            currentVideo.webkitExitFullscreen();
        } else if (typeof(currentVideo.mozCancelFullscreen) !== "undefined") {
            currentVideo.mozCancelFullscreen();
        } else if (typeof(currentVideo.exitFullscreen) !== "undefined") {
            currentVideo.exitFullscreen();
        }
    }
};

GT.VideoBannerBlock.prototype.playWhenLoaded = function(video) {
    var _this = this;
    var currentVideo = video[0];
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');
    
    _this.checkAutoPlay(video);

    //only on IOS
    currentVideo.addEventListener('webkitendfullscreen', function(e) {
        video.parent().removeClass("video-playing");
        $playBtn.show();
    });

    //container
    $container[0].addEventListener('click', function(e) {
        if (e.target.classList.contains('js-play-video-button')){
            _this.playVideo(video);
        }
        else if ($container[0].classList.contains("banner-block--video") && (video.parent()[0].classList.contains('video-pause') || video.parent()[0].classList.contains('video-playing'))){
            if (!e.target.classList.contains('link') && !e.target.classList.contains('video-controls')){
                if (video.parent().hasClass("video-pause")){
                    _this.playVideo(video);
                }else{
                    _this.pauseVideo(video);
                }
            }
        }
    });
};

GT.VideoBannerBlock.prototype.playVideo = function(video) {
    var _this = this;
    var currentVideo = video[0],
        toggleVideoBtn = currentVideo.closest(".banner-block--video")?.querySelector(".b-toggle-video");

    currentVideo.play();
    video.parent().addClass("video-playing").removeClass("video-pause");
    _this.counterTimer(video);
    if(toggleVideoBtn)
        toggleVideoBtn.setAttribute("title", toggleVideoBtn.dataset.pausetitle);
}

GT.VideoBannerBlock.prototype.pauseVideo = function(video) {
    var _this = this;
    var currentVideo = video[0],
        toggleVideoBtn = currentVideo.closest(".banner-block--video")?.querySelector(".b-toggle-video");

    currentVideo.pause();
    video.parent().addClass("video-pause").removeClass("video-playing");
    if(toggleVideoBtn)
        toggleVideoBtn.setAttribute("title", toggleVideoBtn.dataset.playtitle);
    
    _this.hideTimeout = parseInt(video.attr("data-hide-timeout"));
    if (_this.intervalId)
        clearInterval(_this.intervalId);
}

GT.VideoBannerBlock.prototype.loadVideo = function() {
    var _this = this;
    _this.videoArray.map(function(video) {
        var _video = $(video);
        video.load();
        _this.playWhenLoaded(_video);
    });
};

GT.VideoBannerBlock.prototype.showPlayButton = function(video) {
    var _this = this;
    var currentVideo = video[0];
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');

    $playBtn.addClass('is-show');
    $playBtn[0].addEventListener('click', function() {
        if (_this.videoTimeOut) {
            clearTimeout(_this.videoTimeOut);
        }
        //_this.hideVideoAfterTimeout(video);
        video.parent().addClass("video-playing").addClass("showing-video");
        _this.counterTimer(video);
        $playBtn.hide();
        if (_this.isIOS || _this.isMobile) {
            //for android only
            if (!_this.isIOS) {
                var isPlaying = true;
                var showBtn = function() {
                    if (!isPlaying) {
                        screen.orientation.unlock();
                        isPlaying = true;
                        video.parent().removeClass("video-playing");
                        $playBtn.show();
                    } else if (isPlaying) {
                        isPlaying = false;
                    }
                };
                screen.orientation.lock("portrait-primary");
                currentVideo.removeEventListener('webkitfullscreenchange', showBtn);
                currentVideo.addEventListener('webkitfullscreenchange', showBtn);
            }
            currentVideo.play();
            if (typeof(currentVideo.webkitEnterFullscreen) !== "undefined") {
                currentVideo.webkitEnterFullscreen();
            } else if (typeof(currentVideo.webkitRequestFullscreen) !== "undefined") {
                currentVideo.webkitRequestFullscreen();
            } else if (typeof(currentVideo.mozRequestFullScreen) !== "undefined") {
                currentVideo.mozRequestFullScreen();
            }
            return;
        }
        currentVideo.play();
    });
};

GT.VideoBannerBlock.prototype.checkAutoPlay = function(video) {
    var _this = this;
    var $container = video.closest('.js-banner-block-video');
    var $playBtn = $container.find('.js-play-video-button');
    var s = window['Promise'] ? window['Promise'].toString() : '';
    if (s.indexOf('function Promise()') !== -1 || s.indexOf('function ZoneAwarePromise()') !== -1) {
        //Add a surrounding try catch for browser that could not evaluate promise
        try {
            video[0].play().then(function() {
                    if(!$container.hasClass("mobius") && !$container.hasClass("bg-gradient-animate"))
                        $container.find('.background-underlay').hide();
                    
                    $playBtn.hide();
                    video.parent().addClass("video-playing").addClass("showing-video");
                    _this.counterTimer(video);
                    //_this.hideVideoAfterTimeout(video);
                })
                .catch(function(error) {
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (error.name === "NotAllowedError" || (error.name === "AbortError" && isSafari)) {
                        _this.showPlayButton(video);
                    }
                });
        } catch (error) {
            _this.showPlayButton(video);
        }
    } else {
        _this.showPlayButton(video);
    }
};

GT.VideoBannerBlock.prototype.counterTimer = function(video) {
    var _this = this;
    if (video.attr("data-hide-timeout") >= 0){
        var counter = 0;
        _this.intervalId = setInterval(function() {
            counter++;
            // Display 'counter' wherever you want to display it.
            var timeplay = parseInt(_this.hideTimeout - counter);
            video.attr("data-hide-timeout", timeplay);

            if (counter == _this.hideTimeout) {
                // Display a login box
                clearInterval(_this.intervalId);
                _this.hideVideoAfterTimeout(video);
            }
        }, 1000);
    }
}

if(typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function () {
        [
            { elm: $('.banner-block--video .video-background'), settings: { hideTimeout: 60 } }
        ].map(function (item) {
            if (item.elm.length) {
                new GT.VideoBannerBlocks(item.elm, item);
            }
        })
    });

GT.VideoBlock = function() {
    const gtHelper = new GTHelper();
    let videoType = {
            local: "local",
            youtube: "youtube",
            vimeo: "vimeo",
        },
        videoManager = {
            state: "paused",
            position: "inline",
            type: videoType.local,
            id: null,
            videos: {}
        },
        videoPosition = {
            inline: "inline",
            modal: "modal",
            sticky: "sticky"
        },
        videoState = {
            paused: "paused",
            buffering: "buffering",
            playing: "playing"
        };

    videoManager.play = (videoBlockID, type) => {
        videoManager.id = videoBlockID;
        let videoBlock = videoManager.videos[videoBlockID];
        videoManager.pauseAll(videoBlockID);
        setTimeout(e => {
            switch(type) {
                case videoType.youtube:
                        videoBlock.player.playVideo();
                break;
                case videoType.local:
                case videoType.vimeo:
                        videoBlock.player.play();
                break;
            }
        })
    }

    videoManager.pauseAll = (playingID) => {
        document.exitPictureInPicture && document.exitPictureInPicture().catch(error => {});
        Object.keys(videoManager.videos).forEach(videoBlockID => {
            const videoBlock = videoManager.videos[videoBlockID];
            if(videoBlock.videoBlockElm && videoBlockID != playingID) {
                switch(videoBlock.type) {
                    case videoType.youtube:
                        videoBlock.player.pauseVideo();
                    break;
                    case videoType.vimeo:
                    case videoType.local:
                        videoBlock.player.pause();
                    break;
                }
                delete videoBlock.videoBlockElm.dataset.playingExternalPlayer;
            }
        })
    }

    Array.prototype.slice.call(document.querySelectorAll(".video-block-v2")).forEach(function(videoBlockElm){
        let playBtn = videoBlockElm.querySelector(".video-block-v2__play"),
            backgroundElm = videoBlockElm.querySelector(".video-block-v2__poster.from-iframe"),
            videoLink = playBtn.href,
            videoID = getVideoID(videoLink),
            hasIframe = videoBlockElm.classList.contains("has-iframe"),
            type = videoType.local;

        if(hasIframe) type = videoLink.indexOf("vimeo") >= 0 ? videoType.vimeo : videoType.youtube;
        if (hasIframe && backgroundElm && !backgroundElm.dataset.bgset) {
            if(videoLink.indexOf("vimeo") < 0) {
                backgroundElm.dataset.bgset = 'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg';
            } else {
                backgroundElm.dataset.bgset = 'https://vumbnail.com/' + videoID + '.jpg';
            }
            backgroundElm.classList.add("lazyload");
        }

        if(!playBtn.classList.contains("open-in-new-tab")) {
            videoManager.videos[videoBlockElm.id] = {
                "state": videoState.buffering,
                "position": videoPosition.inline,
                "type": type,
                "player": null
            }
            playBtn.addEventListener("click", e => {
                e.preventDefault();
                let currentPlayer = (e.currentTarget || e.target).closest(".video-block-v2"),
                    isPlaysinline = currentPlayer.dataset.playsinline == "true";

                if(!isPlaysinline) {
                    if(!document.querySelector("#external-video-player")) {
                        const externalPlayerTemplate = `        
                        <div class="video-block-v2__player" id="external-video-player" data-id="${videoBlockElm.id}">
                            <div class="video-block-v2__player-container">
                                <button class="btn-flat video-block-v2__toggle-stretch-btn" aria-pressed=false aria-label="${videoBlockElm.dataset.minimizeBtnText}">
                                    <svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#minimize"></use></svg>
                                    <svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#stretch"></use></svg>
                                </button>
                                <button class="btn-flat video-block-v2__close-btn" aria-label="${videoBlockElm.dataset.closeBtnText}">
                                    <svg aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-icon"></use></svg>
                                </button>
                                <div class="video-block-v2__player-area"></div>
                                <div class="error-message"></div>
                            </div>
                        </div>`;
        
                        document.body.insertAdjacentHTML("beforeend", externalPlayerTemplate);
                        document.querySelector("#external-video-player .video-block-v2__toggle-stretch-btn").addEventListener("click", e => {
                            let currentTarget = (e.currentTarget || e.target),
                                externalPlayer = currentTarget.closest("#external-video-player");
                            if(externalPlayer.dataset.position == videoPosition.sticky) {
                                externalPlayer.dataset.position = videoPosition.modal;
                                document.querySelector(".main")?.setAttribute("inert", true);
                                currentTarget.setAttribute("aria-pressed", false);
                                document.querySelector("#" + videoManager.id).dataset.position = videoPosition.modal;
                            } else {
                                externalPlayer.dataset.position = videoPosition.sticky;
                                document.querySelector(".main")?.removeAttribute("inert");
                                currentTarget.setAttribute("aria-pressed", true);
                                document.querySelector("#" + videoManager.id).dataset.position = videoPosition.sticky;
                            }
                        })
        
                        document.querySelector("#external-video-player .video-block-v2__close-btn").addEventListener("click", e => {
                            let currentTarget = (e.currentTarget || e.target).closest("#external-video-player");
                            currentTarget.classList.add("closing");
                            let playerContainer = document.querySelector('.video-block-v2__player-container');
                            setTimeout(e => {
                                document.querySelector(".main")?.removeAttribute("inert");
                                videoManager.pauseAll();
                                currentTarget.classList.remove("closing");
                                delete currentTarget.dataset.position;
                                let errorMessageElm = playerContainer?.querySelector('.error-message');
                                if(errorMessageElm) {
                                    errorMessageElm.style.display = "none";
                                    errorMessageElm.innerHTML = "";
                                }

                                videoManager.state = videoState.paused;
                                gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                                playBtn.focus();
                            }, 500)
                        })
                    }


                    let externalPlayer = document.querySelector("#external-video-player");
                    externalPlayer.dataset.allowsticky = currentPlayer.dataset.allowsticky ? true : false;
                    externalPlayer.dataset.hasiframe = type == videoType.local ? false : true;
                    currentPlayer.dataset.position = videoPosition.modal;
                } else if(!currentPlayer.querySelector(".video-block-v2__player-area")) {
                    const playerTemplate = `        
                    <div class="video-block-v2__player">
                        <div class="video-block-v2__player-container">
                            <div class="video-block-v2__player-area"></div>
                        </div>
                    </div>`;
    
                    currentPlayer.querySelector(".video-block-v2__container").insertAdjacentHTML("beforeend", playerTemplate);
                }

                let playerArea = isPlaysinline ? currentPlayer.querySelector(".video-block-v2__player-area") : document.querySelector("#external-video-player .video-block-v2__player-area");
                
                if(!isPlaysinline) {
                    setTimeout(e => {
                        document.querySelector("#external-video-player").dataset.position = videoPosition.modal;
                        document.querySelector(".main")?.setAttribute("inert", true);
                        currentPlayer.dataset.playingExternalPlayer = true;
                    })
                }
                if(isUnlistedVimeoURL(videoLink)) {
                    if(videoLink.indexOf("player.vimeo.com") < 0) {
                        let unlisted_hash = getUnlistedHashFromPath(videoLink);
                        videoLink = "https://player.vimeo.com/video/" + videoID + "?h=" + unlisted_hash;
                    } 
                    startVideo(currentPlayer, playerArea, videoLink, type, isPlaysinline);
                } else {
                    startVideo(currentPlayer, playerArea, hasIframe ? videoID : videoLink, type, isPlaysinline);
                }
            })

            videoBlockElm.addEventListener("onStateChange", e => {
                e.target.dataset.state = videoManager.state;
            })
        }
    })

    function getVideoID(link){
        let videoID;
        if(link.indexOf("vimeo") < 0) {
            videoID = link.match(/(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
            if (!videoID) {
                // check with other regex
                videoID = link.match(/^(https?:)?(\/\/)?((www\.|m\.)?youtube(-nocookie)?\.com\/((watch)?\?(feature=\w*&)?vi?=|embed\/|vi?\/|e\/)|youtu.be\/)([\w\-]{10,20})/i);
                videoID = videoID ? videoID[9] : "";
            } else {
                videoID = videoID[1];
            }
        } else {
            //videoID = link.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/);

            // Change regex above to new regex below to handle this url: https://vimeo.com/agencyseven/review/209433002/844533f04d
            videoID = link.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|[\w]+\/review\/|)(\d+)(?:\/(\w+))?(?:$|\/|\?)/);
            videoID = videoID ? videoID[3] : "";
        }
        return videoID;
    }

    function isUnlistedVimeoURL(url) {
        let pattern = /https:\/\/vimeo\.com\/(\d+)\/[0-9a-fA-F]+/;
        if(url.indexOf('player.vimeo.com') >= 0) {
            pattern = /https:\/\/player\.vimeo\.com\/video\/(\d+)\?h=[0-9a-zA-Z]+/;
        }
        
        return pattern.test(url);
    }

    function getUnlistedHashFromPath(url) {
        const pattern = /vimeo\.com\/\d+\/([0-9a-zA-Z]+)/;
        const match = url.match(pattern);
        return match ? match[1] : null;
    }

    function startVideo(videoBlockElm, playerArea, videoSource, type, isPlaysinline){
        const playerID = `Player_${videoSource}`;

        videoManager.type = type;
        videoManager.position = videoPosition.inline;

        function setFocus() {
            if(isPlaysinline)
                playerArea.focus();
            else {
                setTimeout(e => {
                    window.getComputedStyle(document.querySelector(".video-block-v2__toggle-stretch-btn")).display != "none" ? document.querySelector(".video-block-v2__toggle-stretch-btn").focus() : document.querySelector(".video-block-v2__close-btn").focus();
                }, 500)
            }
        }

        if(type == videoType.youtube) {
            function startYT(){
                if((videoBlockElm.id != videoManager.id && !isPlaysinline) || (!videoManager.videos[videoBlockElm.id].player && isPlaysinline)) {
                    playerArea.innerHTML = `<div id="${playerID}"></div>`;
                    let ytplayer = new YT.Player(playerID, {
                        videoId: videoSource,
                        playerVars: { 'autoplay': 1, 'playsinline': 1 },
                            events: {
                                'onReady': function(e){
                                    videoManager.play(videoBlockElm.id, type);
                                },
                                'onStateChange': function(playerStatus){
                                    switch(playerStatus.data) {
                                        case 1:
                                            videoManager.state = videoState.playing;
                                        break;
                                        case 3:
                                            videoManager.state = videoState.buffering;
                                        break;
                                        default:
                                            videoManager.state = videoState.paused;
                                        break;
                                    }
                                    gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                                },
                                'onError': function(e){
                                    videoManager.state = videoState.paused;
                                    gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                                }
                            }
                        }
                    );

                    videoManager.videos[videoBlockElm.id].videoBlockElm = videoBlockElm;
                    videoManager.videos[videoBlockElm.id].player = ytplayer;
                } else {
                    videoManager.play(videoBlockElm.id, type);
                }
                setFocus();
            }
            
            videoManager.state = videoState.buffering;
            gtHelper.dispatchEvt("onStateChange", videoBlockElm);
            if ((typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined')) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                window.onYouTubePlayerAPIReady = function () {
                    startYT();
                };
            } else
                startYT();
        } else if(type == videoType.vimeo) {
            function startVimeo(){
                if((videoBlockElm.id != videoManager.id && !isPlaysinline) || (!videoManager.videos[videoBlockElm.id].player && isPlaysinline)) {
                    playerArea.innerHTML = `<div id="${playerID}"></div>`;
                    let vimeoPlayer = new Vimeo.Player(playerID, {
                        id: videoSource,
                        autoplay: true,
                        pip: 0
                    });
                    // Check if un-listed video url
                    if(isUnlistedVimeoURL(videoSource)) {
                        vimeoPlayer = new Vimeo.Player(playerID, {
                            autoplay: true,
                            pip: 0,
                            url: videoSource,
                        });
                    }
                    vimeoPlayer.ready().catch(e => {
                        videoManager.state = videoState.paused;
                        videoManager.id = null;
                        gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                        let playerContainer = document.querySelector('.video-block-v2__player-container');
                        let errorMessageElm = playerContainer?.querySelector('.error-message');
                        if(errorMessageElm)  {
                            let errorMsg = e.toString();
                            if(errorMsg.indexOf("not found") >= 0 || errorMsg.indexOf("is not embeddable") >= 0) {
                                errorMessageElm.innerHTML = e.toString();
                                errorMessageElm.style.display = "flex";
                            }
                        }
                    })

                    vimeoPlayer.on("play", e => {
                        videoManager.state = videoState.playing;
                        gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                    })
                    vimeoPlayer.on("pause", e => {
                        videoManager.state = videoState.paused;
                        gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                    })
                    vimeoPlayer.on("bufferstart", e => {
                        videoManager.state = videoState.buffering;
                            gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                    })
                    vimeoPlayer.on("bufferend", e => {
                        videoManager.state = videoState.playing;
                        gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                    })

                    vimeoPlayer.on('enterpictureinpicture', () => {
                        videoBlockElm.dataset.playingExternalPlayer = true;
                        if(!isPlaysinline) {
                            delete playerArea.closest("#external-video-player").dataset.position;
                            document.querySelector(".main")?.removeAttribute("inert");
                            document.querySelector("#" + videoManager.id).dataset.position = videoPosition.sticky;
                        }
                    });
                    vimeoPlayer.on('leavepictureinpicture', () => {
                        if(!isPlaysinline) {
                            document.querySelector("#" + videoManager.id).dataset.position = videoPosition.modal;
                            playerArea.closest("#external-video-player").dataset.position = videoPosition.modal;
                            playerArea.closest("#external-video-player").querySelector(".video-block-v2__toggle-stretch-btn").focus();
                            document.querySelector(".main")?.setAttribute("inert", true);
                        }
                    });
                    
                    videoManager.play(videoBlockElm.id, type);
                    videoManager.videos[videoBlockElm.id].videoBlockElm = videoBlockElm;
                    videoManager.videos[videoBlockElm.id].player = vimeoPlayer;
                } else 
                    videoManager.play(videoBlockElm.id, type);

                setFocus();
            }
            
            videoManager.state = videoState.buffering;
            gtHelper.dispatchEvt("onStateChange", videoBlockElm);
            if (typeof (Vimeo) == 'undefined') {
                var tag = document.createElement('script');
                tag.src = "https://player.vimeo.com/api/player.js";
                tag.onload = function() {
                    startVimeo();
                }

                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            } else
                startVimeo();
        } else {
            if((videoBlockElm.id != videoManager.id && !isPlaysinline) || (!videoManager.videos[videoBlockElm.id].player && isPlaysinline)) {
                playerArea.innerHTML = `<video id="${playerID}" src="${videoSource}" controls playsinline></video>`;
                let nativePlayer = playerArea.querySelector("video");
                nativePlayer.addEventListener("playing", e => {
                    videoManager.state = videoState.playing;
                    gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                })
                nativePlayer.addEventListener("pause", e => {
                    videoManager.state = videoState.paused;
                    gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                })
                nativePlayer.addEventListener("waiting", e => {
                    videoManager.state = videoState.buffering;
                    gtHelper.dispatchEvt("onStateChange", videoBlockElm);
                })

                videoManager.play(videoBlockElm.id, type);
                videoManager.videos[videoBlockElm.id].videoBlockElm = videoBlockElm;
                videoManager.videos[videoBlockElm.id].player = nativePlayer;

                nativePlayer.addEventListener('enterpictureinpicture', () => {
                    videoBlockElm.dataset.playingExternalPlayer = true;
                    if(!isPlaysinline) {
                        delete playerArea.closest("#external-video-player").dataset.position;
                        document.querySelector(".main")?.removeAttribute("inert");
                        document.querySelector("#" + videoManager.id).dataset.position = videoPosition.sticky;
                    }
                });
                nativePlayer.addEventListener('leavepictureinpicture', () => {
                    if(!isPlaysinline) {
                        playerArea.closest("#external-video-player").dataset.position = videoPosition.modal;
                        playerArea.closest("#external-video-player").querySelector(".video-block-v2__close-btn").focus();
                        document.querySelector(".main")?.setAttribute("inert", true);
                        document.querySelector("#" + videoManager.id).dataset.position = videoPosition.modal;
                    }
                });
            } else 
                videoManager.play(videoBlockElm.id, type);

                
            setFocus();
        }


    }

    GT.listFunctionsTriggerInScrollEvent.videoBlock = function() {
        if(!GT.isScrollingUp && GT.wWidth >= GT.breakPoints.desktop_md) {
            let videoModal = document.querySelector("#external-video-player[data-position=modal][data-allowsticky=true]");
            if(videoModal) {
                if(videoModal.dataset.hasiframe == "true")
                    videoModal.dataset.position = videoPosition.sticky;
                else {
                    let videoArea = videoModal.querySelector("video");
                    if(videoArea) {
                        videoArea.requestPictureInPicture && videoArea.requestPictureInPicture().catch(e => {
                            console.log(e);
                        });
                    }
                }
                document.querySelector(".main")?.removeAttribute("inert");
                document.querySelector("#" + videoModal.dataset.id).dataset.position = videoPosition.sticky;
            }
        }
    }
}

GT.domContentLoadedFncList.push(function(){
    GT.VideoBlock();
});
function GTVideoSlider(){
    let player = document.querySelector(".main-video-slider--player");
    if(player) {
        let thumbInPlayer = player.querySelector("[data-link]"),
            playlist = document.querySelector(".main-video-slider--list-container"),
            scrollUpBtn = document.querySelector(".main-video-slider--scroll.up"),
            scrollDownBtn = document.querySelector(".main-video-slider--scroll.down"),
            frameInPlayer = player.querySelector(".main-video-slider--player-container"),
            videoSliderTitle = document.querySelector(".video-slider-title");
            deletedThumb = false;
            
        function startVideo(link, type){
            let videoLink = "about:blank";
            if(type == "youtube") {
                
                let videoID = link.match(/^(https?:)?(\/\/)?((www\.|m\.)?youtube(-nocookie)?\.com\/((watch)?\?(feature=\w*&)?vi?=|embed\/|vi?\/|e\/)|youtu.be\/)([\w\-]{10,20})/i);
                videoID = videoID ? videoID[9] : "";
                videoLink = "https://www.youtube.com/embed/" + videoID + "?autoplay=1&rel=0";
                frameInPlayer.innerHTML = '<div id="YTPlayer"></div>';
                
                function startYT(){
                    new YT.Player("YTPlayer", {
                        videoId: videoID,
                        playerVars: { 'autoplay': 1, 'playsinline': 1 },
                            events: {
                                'onReady': function(e){
                                    e.target.playVideo();
                                }
                            }
                        }
                    );
                }
                
                if ((typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined')) {
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    window.onYouTubePlayerAPIReady = function () {
                        startYT();
                    };
                } else
                    startYT();
            } else {
                let videoID = link.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|[\w]+\/review\/|)(\d+)(?:\/(\w+))?(?:$|\/|\?)/);
                videoID = videoID ? videoID[3] : "";
                videoLink = "https://player.vimeo.com/video/" + videoID + "?title=1&byline=0&portrait=0&autoplay=true";
                frameInPlayer.innerHTML = '<iframe src="'+ videoLink +'" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen tabindex="0" aria-label="player"></iframe>';
            }

            frameInPlayer.focus();
        }

        thumbInPlayer.addEventListener("click", function(e){
            let currentThumb = e.currentTarget;
            startVideo(currentThumb.dataset.link, currentThumb.dataset.type);
            thumbInPlayer.remove();
            deletedThumb = true;
        })

        if(playlist) {
            Array.prototype.slice.call(playlist.querySelectorAll("[data-link]")).forEach(function(playlistItemElm) {
                playlistItemElm.addEventListener('click', function(e){
                    playlist.querySelector(".selected").classList.remove("selected");
                    let currentThumb = e.currentTarget;
                    currentThumb.classList.add("selected");
                    if(!deletedThumb) {
                        thumbInPlayer.remove();
                        deletedThumb = true;
                    }
                    startVideo(currentThumb.dataset.link, currentThumb.dataset.type);
                })
            })

            scrollUpBtn.addEventListener("click", function(){
                playlist.scrollTop = 0;
                scrollDownBtn.classList.remove("hide");
                scrollUpBtn.classList.add("hide");
            })
            scrollDownBtn.addEventListener("click", function(){
                playlist.scrollTop = 1000;
                scrollUpBtn.classList.remove("hide");
                scrollDownBtn.classList.add("hide");
            })
        }
    }
}

GT.domContentLoadedFncList.push(function(){
    GTVideoSlider();
});

////////////////////////////
// GT VIEWPORT  FUNCTIONS //
////////////////////////////

GT.View = function ($elem) {
    try {
        this.currentElem = $elem;
        var container = $elem.closest('.change-view-cont').data('container');
        if (!container) {
            container = '.expert-container'; // just for legacy purposes
        }
        var $container = $(container);
        this.switchView($elem, $container);
    } catch(e) {

    }
};
GT.View.prototype.changeView = function ($container, $currentElem) {
    let clampname = $container[0].dataset.clampname;
    $('.change-view.enabled').removeClass('enabled').attr("aria-pressed", "false");
    $currentElem.addClass('enabled').attr("aria-pressed", "true");
    if ($currentElem.hasClass('change-grid-view')) {
        $container.removeClass('list-view');
        $container.addClass('grid-view');
        GT.clampRevertToOriginalText(clampname);
        GT.clampText(clampname, true);
    } else {
        $container.removeClass('grid-view');
        $container.addClass('list-view');
        GT.clampRevertToOriginalText(clampname);
        GT.clampText(clampname, true);
    }
};

GT.View.prototype.changeViewMobile = function ($container) {
    $(".change-view.change-list-view").removeClass('enabled');
    $(".change-view.change-grid-view").addClass('enabled');
    // add the class to container
    $container.removeClass("list-view");
    $container.addClass("grid-view");
};

GT.View.prototype.switchView = function ($elem, $container) {
    var me = this;

    $elem.on('click', function (e) {
        e.preventDefault();
        var $currentElem = $(this);
        if ($currentElem.hasClass("enabled")) {
            return false;
        }
        me.changeView($container, $currentElem);
    });
};

if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
        new GT.View($('.change-view'));
    });

GT.GTVisitorProfile = function ($element) {
	visitorProfileTabs();
	cloneArticleToOther();
	loadMoreData();

	function loadMoreData() {
		$("#bookmarks_list__loadmore").click(function () {
			var _this = $(this);
			_this.addClass('loading');
			var pageIndexAttr = _this.attr('page-index');
			var pageIndex = 1;
			if (pageIndexAttr)
				pageIndex = parseInt(pageIndexAttr) + 1;

			var url = "/Bookmark/GetMoreBookmarkedArticles";
			$.get(url,
				{
					pageIndex: pageIndex
				}).done(function (data) {
					if (data && data !== '') {
						$("#bookmarks_list .visitor-profile__details--container").append(data.data);
						_this.attr('page-index', pageIndex);
						if (data.showloadmore) {
							$("#bookmarks_list__loadmore").show();
						} else {
							$("#bookmarks_list__loadmore").hide();
						}
					}
					_this.removeClass('loading');
					$("#bookmarks_list .visitor-profile__details--container .visitor-profile__details--item.hidden").fadeIn(1000);
				});
			_this.blur();
		});

		$("#archives_list__loadmore").click(function () {
			var _this = $(this);
			_this.addClass('loading');
			var pageIndexAttr = _this.attr('page-index');
			var pageIndex = 1;
			if (pageIndexAttr)
				pageIndex = parseInt(pageIndexAttr) + 1;
			var url = "/Bookmark/GetMoreArchivedArticle";
			$.get(url,
				{
					pageIndex: pageIndex
				}).done(function (data) {
					if (data && data !== '') {
						$("#archives_list .visitor-profile__details--container").append(data.data);
						_this.attr('page-index', pageIndex);
						if (data.showloadmore) {
                            $("#archives_list__loadmore").show();
						} else {
                            $("#archives_list__loadmore").hide();
						}
					}
					_this.removeClass('loading');
					$("#archives_list .visitor-profile__details--container .visitor-profile__details--item.hidden").fadeIn(1000);
				});
			_this.blur();
		});
	}

	function RefreshBookmarksData() {
		var loadMoreButton = $("#bookmarks_list__loadmore");
		var pageIndexAttr = loadMoreButton.attr('page-index');
		var pageIndex = 1;
		if (pageIndexAttr)
			pageIndex = parseInt(pageIndexAttr);
		var url = "/Bookmark/RefreshBookmarksData";
		$.get(url,
			{
				pageIndex: pageIndex
			}).done(function (data) {
				if (data && data !== '') {
					$('#visitor_archives_tab').find('.total-count').text(data.totalarchived);
					$('#visitor_bookmarks_tab').find('.total-count').text(data.totalbookmark);
					$("#bookmarks_list .visitor-profile__details--container").html(data.data);
					if (data.showloadmore) {
						$("#bookmarks_list__loadmore").css('display', 'block');

					} else {
						$("#bookmarks_list__loadmore").hide();
					}
				}

				$("#bookmarks_list .visitor-profile__details--container .visitor-profile__details--item.hidden").fadeIn(1000);
			});
	}
	
	function RefreshArchivedsData(keepSwitchTab) {
		var _this = $("#archives_list__loadmore");
		var pageIndexAttr = _this.attr('page-index');
		var pageIndex = 1;
		if (pageIndexAttr && keepSwitchTab)
			pageIndex = parseInt(pageIndexAttr);
		var url = "/Bookmark/RefreshArchivedsData";
		$.get(url,
			{
				pageIndex: pageIndex
			}).done(function (data) {
				if (data && data !== '') {
					$('#visitor_archives_tab').find('.total-count').text(data.totalarchived);
					$('#visitor_archives_tab').attr('moved-item', 'false');
					$("#archives_list .visitor-profile__details--container").html(data.data);
					if (data.showloadmore) {
						$("#archives_list__loadmore").css('display', 'block');
						$("#archives_list__loadmore").attr('page-index', pageIndex);
					} else {
                        $("#archives_list__loadmore").hide();
					}
				}

				$("#archives_list .visitor-profile__details--container .visitor-profile__details--item.hidden").fadeIn(1000);
			});
	}

	function visitorProfileTabs() {
		$('.visitor-profile__tab').click(function () {
			var _this = $(this);
			_this.parent().siblings().removeClass('active');
			_this.parents('.visitor-profile__container').find('.visitor-profile__details').removeClass('active');
			_this.parent().addClass('active');
			var _showTarget = _this.attr('data-target');
			_this.parents('.visitor-profile__container').find(_showTarget).addClass('active');
			if (_this.attr('moved-item') == 'true') {
				RefreshArchivedsData();
			}

		});
	}

	function cloneArticleToOther() {
		$(document).on('click', '.remove-saved__article', function () {
			var _this = $(this);
			_this.addClass('loading');
			var url = "/Bookmark/Archived";
			var bookMarkId = _this.attr('articlebookmark-id');
			var dataObject = { "articleBookmarkId": bookMarkId };
			$.ajax({
				type: "POST",
				url: url,
				contentType: "application/json",
				dataType: "json",
				data: JSON.stringify(dataObject),
				success: function (data) {
					if (data.data) {
						$('#visitor_archives_tab').attr('moved-item', 'true');
						RefreshBookmarksData(true);
					}
				},
				error: function (xhr) {
					console.error(xhr);
				}
			});
		});

		$(document).on('click', '.remove-archived__article', function () {
			var _this = $(this);
			_this.addClass('loading');
			var url = "/Bookmark/RemoveArchived";
			var bookMarkId = _this.attr('articlebookmark-id');
			var dataObject = { "articleBookmarkId": bookMarkId };
			$.ajax({
				type: "POST",
				url: url,
				contentType: "application/json",
				dataType: "json",
				data: JSON.stringify(dataObject),
				success: function (data) {
					if (data.data) {
						_this.parents('.visitor-profile__details--item').remove();
						RefreshArchivedsData(true);
					}
				},
				error: function (xhr) {
					console.error(xhr);
				}
			});
		});
	}
};

GT.GTWraptextButton = function($elem, option) {
    var extra = option.settings.extra || 0;
    var padding = option.settings.padding || 0;
    var $rulerDiv = $('#rulerDiv');
    if ($rulerDiv.length === 0) {
        $('body').append('<span id="rulerDiv"></span>');
        $rulerDiv = $('#rulerDiv');
    }

    $.each($elem, function(index, element) {
        calculate(element);
        $(window).on('resize', calculate(element));
    });

    function calculate(element) {
        var text = $(element).text();
        var width = $(element).width();
        $rulerDiv.css('font-size', $(element).css('font-size'));
        $rulerDiv.text(text);
        var totalWidth = $rulerDiv.width() + extra;
        if (totalWidth >= width) {
            $(element).addClass('free-row-button');
        }else{
            $(element).removeClass('free-row-button');
        }
    }
};
var SNE = SNE || {};

SNE.mediaFiltersMobile = SNE.mediaFiltersMobile || (function () {

    function init() {

        var $toggle = $('.toggle-filters-slideout'),
            $pageContainer = $('.page'),
            $mobileFilters = $('.mobile-filters'),
            $nextButton = $('.mobile-filters li > a'),
            $checkBox = $('.mobile-filters li input'),
            $backButton = $('.filters-header .back-button'),
            $doneButton = $('.filters-header .done-button'),
            $toPage,
            toPageID,
            $currentPage = $pageContainer,
            pageNum = 0, // 0 = top level...
            pageHistory,
            shiftedClass = 'shifted',
            screenWidth = window.innerWidth,
            screenHeight = window.innerHeight,
            timer,
            cookieName = 'mobileFilterNavActive',
            resize = false,
            url;

        // Toggle mobile filters
        $toggle.on('click', function (e) {
            e.preventDefault();
            $mobileFilters.fadeIn(200);
            pageNum = 1;
            pageHistory = ['home'];
            // createCookie(cookieName, cookieValue, 1); // Set the cookie
            $pageContainer.toggleClass('off-screen');
            $('html').toggleClass('overflowHidden--mobile');
        });

        setState();

        // Go to children
        $nextButton.on('click', function (e) {
            var $this = $(this);

            if ($this.parent('li').hasClass('ctatag')) {
                return true;
            }
            e.preventDefault();
            //if the link is on the last level make the anchor control the sibling checkbox
            if (!$this.parent().hasClass('has-children')) {
                var nextCheckbox = $this.siblings('input[type=checkbox]')
                if ($this.attr('href').slice(1) == nextCheckbox.attr('id')) {
                    nextCheckbox.prop('checked', !nextCheckbox.prop('checked'));
                    url = nextCheckbox.attr('data-url');
                    toggleCheckbox();
                }
            } else {
                // open next children pane
                toPageID = $this.siblings('ul').attr('id');
                $toPage = $('#' + toPageID);
                $currentPage = $toPage;
                $toPage.addClass('shifted');

                // Store the ID so we can use it when clicking the back button
                pageHistory[pageNum] = toPageID;
                pageNum += 1;
            }
        });

        // Go back
        $backButton.on('click', function (e) {
            resize = false;

            if (pageNum === 1) {
                backToSite();
                // un-lock scroll position
                var html = $('html');
                //var scrollPosition = html.data('scroll-position');
                html.css('overflow', html.data('previous-overflow'));
            } else {
                pageNum -= 1;
                // Save current page ID
                toPageID = pageHistory[pageNum];
                $currentPage = $('#' + toPageID);
                $currentPage.removeClass(shiftedClass);
                pageHistory.pop(); // Remove last item in array
            }

            e.preventDefault();
        });

        // Put the filters back to the same position after a refresh
        function setState() {

            var cookieValue = readCookie(cookieName);
            // console.log(pageHistory);
            if (cookieValue) {
                var cookieValueArr = cookieValue.split('|'),
                    arrLen = cookieValueArr.length,
                    toPageID = cookieValueArr[arrLen - 1],
                    $toPage = $('#' + toPageID),
                    i = 0;

                pageHistory = cookieValueArr;
                pageNum = pageHistory.length;

                // Add shifted class to each corresponding item in array
                for (i; i < arrLen; i++) {
                    $('#' + cookieValueArr[i]).addClass(shiftedClass);
                }

                // If not on the first page
                if (arrLen > 1) {
                    $mobileFilters.fadeIn(200);
                    $pageContainer.addClass('off-screen');
                    $('html').addClass('overflowHidden--mobile');
                }
            }
        }

        // Toggle Checkbox
        $checkBox.change(function () {
            url = $(this).attr('data-url')
            toggleCheckbox();
        });

        function toggleCheckbox() {

            window.location.href = url;

            if ($(this).is(':checked')) {

                // To set the cookie trail
                var cookieArr = pageHistory.join('|');
                createCookie(cookieName, cookieArr, 1); // Set the cookie

                // Add selected styling
                $(this).parent('li').not('.disabled').addClass('selected');
            } else {
                // Remove selected styling
                $(this).parent('li').removeClass('selected');
            }
        }

        // Done
        $doneButton.on('click', function (e) {
            e.preventDefault();

            resize = false;
            backToSite();
        });

        // Delay the resize function till after resizing has stopped
        $(window).bind('resize', function () {
            resize = true;
            timer && clearTimeout(timer);
            timer = setTimeout(resetOnResize, 200);
        });

        function resetOnResize() {
            screenWidth = window.innerWidth;
            screenHeight = window.innerHeight;
            setDimensions();

            if ($pageContainer.hasClass('off-screen')) {
                if (pageNum !== 1) {
                    resize = false;
                }
            }

            if (screenWidth > 768) {
                backToSite();
            }
        }

        function setDimensions() { // And now a bit of layout
            $mobileFilters.css({
                height: screenHeight
            });
        }

        setDimensions();

        function backToSite() {
            $pageContainer.removeClass('off-screen');
            // Slide page back
            resize = true;

            $('html').removeClass('overflowHidden--mobile');
            $('.focus').removeClass('focus');
            $('.shifted').removeClass('shifted');
            // Fade out filter pages and put back into position
            $mobileFilters.fadeOut(200);
            // Reset page num to 0
            pageNum = 0;
            createCookie(cookieName, '', -1); //remove cookie
        }
    }

    return {
        init: init
    };

}());

GT.domContentLoadedFncList.push(function(){
    SNE.mediaFiltersMobile.init();
});
GT.chartPlugins.centerText = {
    id: 'centerText',
    beforeDraw: (chart) => {
        if (!chart.config.options.plugins.centerText) return; // Check visibility

        const width = chart.width;
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;

        ctx.restore();
        const fontSize = Math.min(chartArea.width, chartArea.height) / 8; // Adjust the divisor to control the font size
        ctx.font = `bolder ${fontSize}px ${GT.chartConfigs.CANVAS_SYSTEM_FONT_FAMILY}`;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = GT.chartConfigs.CANVAS_TEXT_CHART_COLOR;

        const text = GT.chartConfigs.formatText(chart.canvas.closest('.chart-container'), chart.total);
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = chartArea.top + (chartArea.height / 2); // Calculate center based on chart area
        ctx.fillText(text, textX, textY);
        ctx.save();
    }
}
function GTChartTooltip(context, formatText) {
    // Tooltip Element
    const chartContainer = context.chart.containerElm;
    let tooltipEl = document.getElementById('chartjs-tooltip');
    let dataPoint = context.tooltip?.dataPoints?.[0];
    let tooltipContent = "";
    let dataPointDescription;
    if(!dataPoint) return;

    let mergeData = {};
    context.tooltip.dataPoints.forEach(dataPoint => {
        let bgColor = (typeof dataPoint.dataset.backgroundColor === "string" ? dataPoint.dataset.backgroundColor : dataPoint.dataset.backgroundColor[dataPoint.dataIndex]);
        let keyData = GT.generateHexCode(dataPoint.dataset.label + bgColor);
        if(!mergeData[keyData]) {
            mergeData[keyData] = {
                label: dataPoint.dataset.label,
                datasetIndex: dataPoint.datasetIndex,
                bgColor: bgColor,
                data: []
            };
        }
        if(dataPoint.dataset.description?.length) {
            dataPointDescription = dataPoint.dataset.description;
        }

        mergeData[keyData].data.push(formatText(chartContainer, dataPoint.raw));
    });

    // Sort mergeData by datasetIndex
    const sortedKeys = Object.keys(mergeData).sort((a, b) => {
        return mergeData[a].datasetIndex - mergeData[b].datasetIndex;
    });
    
    // Create new sorted object
    const sortedMergeData = {};
    sortedKeys.forEach(key => {
        sortedMergeData[key] = mergeData[key];
    });
    
    // Replace original mergeData with sorted version
    mergeData = sortedMergeData;

    Object.keys(mergeData).forEach(key => {
        tooltipContent += "<span style='background-color: "+ mergeData[key].bgColor +"'></span> " + mergeData[key].label + ": " + mergeData[key].data.join("&nbsp; - &nbsp;") + "<br>";
    })
        
    if(dataPointDescription) {
        let tmpStr = [];
        dataPointDescription[dataPoint.dataIndex]?.forEach(descItem => {
            // Handle both numeric values and text values
            let displayValue = "";
            if (descItem.isNumeric && descItem.value !== null && descItem.value !== undefined) {
                displayValue = formatText(chartContainer, descItem.value);
            } else if (descItem.textValue) {
                displayValue = descItem.textValue;
            }
            tmpStr.push(descItem.label + ": " + displayValue);
        })
        tooltipContent += "<div>" + tmpStr.join("<br>") + "</div>";
    }

    // Create element on first render
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.innerHTML = '<div></div>';
        document.body.appendChild(tooltipEl);
    }
    
    // Hide if no tooltip
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0 || !tooltipContent) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.zIndex = -1;
        return;
    }

    const position = context.chart.canvas.getBoundingClientRect();
    // Display, position, and set styles for font
    // const leftPos = position.left + window.pageXOffset + tooltipModel.caretX;
    const leftPos = tooltipModel._eventPosition.x;
    tooltipEl.style.opacity = 1;
    tooltipEl.style.zIndex = 1;

    let title = context.tooltip.title[0] || "";

    if(chartContainer.dataset.isLineChartWithDates == "true") {
        if(title) {
            title = new Date(title);
            title = title.toLocaleDateString(document.firstElementChild.lang, { day: "numeric", month: "long", year: "numeric" });
        }
    } else {
        tooltipEl.innerHTML = (title ? `<strong>${title}</strong>` : "") + tooltipContent;
    }
        
    tooltipEl.innerHTML = (title ? `<strong>${title}</strong>` : "") + tooltipContent;
    if(leftPos + tooltipEl.offsetWidth > GT.wWidth - 32) {
        tooltipEl.style.left = "auto";
        tooltipEl.style.right = "16px";
        tooltipEl.style.top = position.top + window.scrollY +  (tooltipModel._eventPosition.y > tooltipModel.caretY ? tooltipModel._eventPosition.y : tooltipModel.caretY) + 32 + 'px';
    } else {
        tooltipEl.style.right = "auto";
        tooltipEl.style.left = (position.left + window.pageXOffset + tooltipModel._eventPosition.x) + 'px';
        tooltipEl.style.top = (position.top + window.scrollY + tooltipModel._eventPosition.y) + 'px';
    }
}
GT.chartPlugins.cutByDate = {
    id: 'cutByDate',
    beforeDraw: (chart) => {
        const container = chart.canvas.closest('.data-visualisation-block');
        const timeController = container?.querySelector(".chart__date-container");
        if(!timeController) return;

        const startDateElm = timeController.querySelector(".chart__date-input.start");
        const endDateElm = timeController.querySelector(".chart__date-input.end");
        const buttonElms = timeController.querySelectorAll("button");

        if(!startDateElm || !endDateElm || startDateElm.isInitialized || endDateElm.isInitialized) return;

        let chartData = {};
        GT.listCharts.forEach(currentChart => {
            if(currentChart.containerElm.id == chart.containerElm.id) {
                chartData = currentChart.chartData.data;
            }
        })

        if(!chartData.labels) return;

        function setStartDate(endDate, chartLength, startDateElm, diff) {
            let tmpStartDate;

            endDate.setMonth(endDate.getMonth() - diff)
            let tmpCompareDate = endDate.getTime();
            let flagValid = true;
            let labelPointer = chartLength - 1;

            do {
                const currentDateStr = chartData.labels[labelPointer];
                flagValid = tmpCompareDate <= new Date(currentDateStr).getTime();
                if(flagValid) {
                    tmpStartDate = currentDateStr;
                }
                labelPointer--;
            } while(labelPointer >= 0)

            if(tmpStartDate) {
                startDateElm.value = tmpStartDate;
            }
        }

        buttonElms.forEach(buttonElm => {
            if(!buttonElm.isInitialized) {
                buttonElm.isInitialized = true;

                buttonElm.addEventListener("click", (e) => {
                    const chartLength = chartData.labels.length;
                    const endDate = new Date(chartData.labels[chartLength - 1]);
                    endDateElm.value = chartData.labels[chartLength - 1];
                    const currentBtn = e.target;
                    
                    buttonElms.forEach(buttonElm => {
                        buttonElm.classList.remove("active");
                    })
                    currentBtn.classList.add("active");

                    switch(currentBtn.dataset.type) {
                        case "1m":
                            setStartDate(endDate, chartLength, startDateElm, 1);
                        break;
                        case "3m":
                            setStartDate(endDate, chartLength, startDateElm, 3);
                        break;
                        case "6m":
                            setStartDate(endDate, chartLength, startDateElm, 6);
                        break;
                        case "1y":
                            setStartDate(endDate, chartLength, startDateElm, 12);
                        break;
                        case "all":
                            startDateElm.value = chartData.labels[0];
                        break;
                    }

                    
                    updateChartData();
                })
            }
        })
        

        function updateChartData() {
            const startDate = new Date(startDateElm.value).getTime();
            const endDate = new Date(endDateElm.value).getTime();
            const chartLength = chartData.labels.length;

            const newChartData = {
                labels: [],
                datasets: []
            }

            if(startDate > endDate) {
                endDateElm.value = startDateElm.value;
            }

            chartData.datasets.forEach((dataset, idx) => {
                newChartData.datasets.push({
                    ...dataset,
                    data: [],
                    description: []
                });
            })

            let labelIdx = 0;
            let flagValid = true;
            let chartDataSetLength = chartData.datasets.length;

            do {
                const label = chartData.labels[labelIdx];
                const currentDate = new Date(label).getTime();
                flagValid = currentDate >= startDate && currentDate <= endDate;
                if(flagValid) {
                    newChartData.labels.push(label);
                    for(let i = 0; i < chartDataSetLength; i++) {
                        newChartData.datasets[i].data.push(chartData.datasets[i].data[labelIdx]);

                        const descData = chartData.datasets[i].description;
                        if(descData) {
                            newChartData.datasets[i].description.push(descData[labelIdx]);
                        }
                    }
                }
                labelIdx++;
            } while(labelIdx < chartLength)


            chart.data = newChartData;
            
            const lang = document.firstElementChild.lang;
            const diffMonth = Math.abs(new Date(newChartData.labels[newChartData.labels.length - 1]).getTime() - new Date(newChartData.labels[0]).getTime()) / (1000 * 60 * 60 * 24 * 30);
            chart.options.scales.x.ticks.callback = function(value) {
                if (diffMonth < 7) {
                    return new Date(value).toLocaleDateString(lang, {day: "numeric", month: "short", year: "numeric" });
                } else {
                    return new Date(value).toLocaleDateString(lang, {month: "short", year: "numeric" });
                }
            }

            chart.update();
        }

        startDateElm.addEventListener("change", () => {
            
            buttonElms.forEach(buttonElm => {
                buttonElm.classList.remove("active");
            })

            updateChartData();
        });
        endDateElm.addEventListener("change", () => {
            
            buttonElms.forEach(buttonElm => {
                buttonElm.classList.remove("active");
            })
            
            updateChartData();
        });
        startDateElm.isInitialized = true;
        endDateElm.isInitialized = true;
        // buttonElms[0].click();
    }
}
GT.chartPlugins.drawLines = {
    id: 'drawLines',
    afterDraw: (chart) => {
        if (!chart.config.options.plugins.drawLines) return; // Check visibility

        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        const meta = chart.getDatasetMeta(0);

        ctx.save();
        ctx.lineWidth = 1;
        ctx.font = '14px ' + GT.chartConfigs.CANVAS_SYSTEM_FONT_FAMILY;

        const labelItems = chart.options.plugins.legend.labels.generateLabels(chart);

        meta.data.forEach((element, index) => {
            const label = labelItems[index]?.text;
            if(!label) return;

            const center = element.getCenterPoint();
            const radius = element.outerRadius * 30 / 100; // minus the 40% of cutout size
            const midAngle = element.startAngle + (element.endAngle - element.startAngle) / 2;
            const isHide = element.startAngle == element.endAngle;
            
            const labelDistance = 25; // Adjust this value to control how far the labels are from the pie

            // Calculate start point at the edge of the pie
            let startX = center.x + Math.cos(midAngle) * (radius - labelDistance);
            let startY = center.y + Math.sin(midAngle) * (radius - labelDistance);

            // Define line end point and label position based on quadrant
            const isRightSide = startX > chartArea.left + chartArea.width / 2;
            const endX = center.x + Math.cos(midAngle) * (radius + labelDistance);
            const endY = center.y + Math.sin(midAngle) * (radius + labelDistance);
            
            // Draw connector line - no shadow for lines
            ctx.shadowColor = 'transparent';
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.strokeStyle = isHide ? 'transparent' : element.options.backgroundColor;
            ctx.beginPath();
            ctx.moveTo(startX, startY);
            ctx.lineTo(endX, endY);
            ctx.stroke();

            // Add text shadow for better label visibility and accessibility
            // Using a stronger white glow effect for better contrast on dark backgrounds
            ctx.shadowColor = 'rgba(255, 255, 255, 1)';
            ctx.shadowBlur = 1;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            // Set up label properties
            ctx.fillStyle = isHide ? 'transparent' : GT.chartConfigs.CANVAS_TEXT_CHART_LIGHT_COLOR;
            ctx.textAlign = isRightSide ? 'left' : 'right';

            // Calculate maximum width for text
            const maxLabelWidth = 90; // Adjust this value as needed
            
            // Word wrap function
            const words = label.split(' ');
            let line = '';
            let lines = [];
            let y = endY - 15;

            words.forEach(word => {
                const testLine = line + (line ? ' ' : '') + word;
                const metrics = ctx.measureText(testLine);
                if (metrics.width > maxLabelWidth && line !== '') {
                    lines.push(line);
                    line = word;
                } else {
                    line = testLine;
                }
            });
            lines.push(line);

            // Draw wrapped text
            lines.forEach((line, i) => {
                ctx.fillText(line, endX + (isRightSide ? 5 : -5), y + (i * 15));
            });
            
            // Draw value below the wrapped label
            ctx.fillStyle = isHide ? 'transparent' : element.options.backgroundColor;
            ctx.fillText(GT.chartConfigs.formatText(chart.containerElm, element.$context.parsed), 
                endX + (isRightSide ? 5 : -5), 
                y + (lines.length * 15) + 10);
        });

        ctx.restore();
    }
}
GT.chartPlugins.htmlLegend = {
    id: 'htmlLegend',
    afterUpdate(chart, args, options) {
        if (!chart.config.options.plugins.htmlLegend) return; // Check visibility

        const container = chart.canvas.closest('.data-visualisation-block');
        let legendContainer = container.querySelector('.chart-container ul');
        
        if(!legendContainer) {
            container.querySelector(".chart-container").insertAdjacentHTML("beforeend", "<ul class='chart-legend-list'></ul>");
            legendContainer = container.querySelector('ul');
        }

        if(chart.canvas.closest(".chart-container-overview")) return;

        // Remove old legend items
        while (legendContainer.firstChild) {
            legendContainer.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = [];
        const generatedItems = [];
        const { type } = chart.config;

        if (type === 'pie' || type === 'doughnut') {
            chart.options.plugins.legend.labels.generateLabels(chart).forEach((item, index) => {
                items.push({
                    bgcolor: item.fillStyle,
                    label: item.text,
                    type: item.type,
                    linestyle: item._dataset?.lineStyle,
                    hidden: item.hidden
                });
            });
        } else {
            chart._metasets.forEach((item, index) => {
                items.push({
                    bgcolor: item._dataset.backgroundColor,
                    label: item.label,
                    type: item.type,
                    linestyle: item._dataset?.isTrendline ? "solid" : item._dataset?.lineStyle,
                    hidden: item.hidden
                });
            });
        }

        items.forEach((item, index) => {
            const hexCode = GT.generateHexCode(item.label + item.bgcolor);
            if(!generatedItems.includes(hexCode)) {
                legendContainer.insertAdjacentHTML("beforeend", `
                    <li class='chart-legend-item' data-index="${generatedItems.length}" data-type="${item.type}" data-linestyle="${item.linestyle}">
                        <span class='chart-legend-box-item' style='--line-chart-legend-box-item-background: ${item.bgcolor}; --line-chart-legend-box-item-bordercolor: ${item.bgcolor+40};'></span>
                        <div class='chart-legend-text ${item.hidden ? 'chart-legend-text-hidden' : ''}'>${item.label}</div>
                    </li>
                `);

                generatedItems.push(hexCode);

                legendContainer.lastElementChild.onclick = (e) => {
                    const { type } = chart.config;
                    const currentIndex = e.target.closest('.chart-legend-item').dataset.index;
                    const currentHex = generatedItems[currentIndex];
                    items.forEach((item, index) => {
                        const hexCode = GT.generateHexCode(item.label + item.bgcolor);
                        if(hexCode == currentHex) {
                            if (type === 'pie' || type === 'doughnut') {
                                // Pie and doughnut charts only have a single dataset and visibility is per item
                                chart.toggleDataVisibility(index);
                            } else {
                                chart.setDatasetVisibility(index, !chart.isDatasetVisible(index));
                            }
                        }
                    })

                    chart.update();
                };
            }
        });
    }
};
function GTRebuildChartData(chartContainer, baseData, chartType) {
    const datasetType = chartContainer.dataset.type;
    const chartColors = baseData.colorSets;
    function getCommonProps(index) {
        let commonOptions = {
            borderColor: chartColors[index],
            backgroundColor: chartColors[index],
            order: index,
        };

        if([chartType.BAR, chartType.BAR_STACKED, chartType.BAR_STACKED_100, chartType.PARETO].includes(datasetType)) {
            Object.assign(commonOptions, {
                borderWidth: 0,
                borderRadius: 4,
                categoryPercentage: 0.7,
                barThickness: 'flex'
            });
        }

        if(chartContainer.dataset.orientation == "horizontal" && datasetType == chartType.BAR) {
            Object.assign(commonOptions, {
                borderWidth: 1,
            });
        }

        if([chartType.LINE, chartType.PARETO].includes(datasetType)) {
            Object.assign(commonOptions, {
                borderWidth: 2,
                pointBackgroundColor: chartColors[index],
                pointBorderColor: chartColors[index] + '40',
                pointBorderWidth: 12,
                pointRadius: 5,
                pointHoverRadius: 8,
                tension: chartContainer.dataset.tension === "true" ? 0.2 : 0
            });
        }

        if(chartContainer.dataset.isLineChartWithDates == "true") {
            Object.assign(commonOptions, {
                pointBorderWidth: 0,
                pointHoverBorderWidth: 12,
                pointRadius: 0,
                pointHoverRadius: 8,
            });
        }

        if([chartType.CIRCLE_PIE, chartType.CIRCLE_DONUT, chartType.CIRCLE_DONUT_MULTIPLE].includes(datasetType)) {
            Object.assign(commonOptions, {
                borderColor: "transparent"
            });
        }

        return commonOptions;
    }

    const data = {
        labels: baseData.labels,
        datasets: []
    };

    baseData.datasets.forEach((item, idx) => {
        let _commonOptions = getCommonProps(idx);
        // Apply line style for line charts
        if([chartType.LINE, chartType.PARETO].includes(datasetType) && item.lineStyle) {
            const lineStyle = item.lineStyle.toLowerCase();
            if(lineStyle === 'dashed') {
                _commonOptions.borderDash = [6, 6];
            } else if(lineStyle === 'dotted') {
                _commonOptions.borderDash = [2, 2];
            } else if(lineStyle === 'dot-dashed') {
                _commonOptions.borderDash = [10, 2, 2, 2];
            }
        }
        
        data.datasets.push({...item, ..._commonOptions});
    })
    
    if(baseData.trendLineDatasets.length > 0) {
        let orderLine = 1000;
        baseData.trendLineDatasets.forEach((item, idx) => {
            const commonObj = {
                ...getCommonProps(baseData.colorSets.length - 1),
                label: item.label,
                backgroundColor: item.backgroundColor,
                datalabels: {
                    display: false
                },
                type: "line",
                pointBorderWidth: 0,
                pointHoverRadius: 0,
                pointRadius: 0,
                isTrendline: true
            }

            const trendlineDatasLength = item.trendlineDatas.length;
            if(trendlineDatasLength > 1) {
                const tmpObj = {
                    ...commonObj,
                    data: item.data,
                    borderWidth: 0
                }

                item.trendlineDatas.forEach((childItem, childIdx) => {
                    orderLine++;
                    const currentObj = {
                        ...tmpObj,
                        order: orderLine,
                        data: childItem
                    }

                    if(childIdx == 0) {
                        currentObj.fill = "+" + (trendlineDatasLength - 1);
                    }

                    data.datasets.push(currentObj)
                })
            } else {
                orderLine++;
                let trendlineData = trendlineDatasLength == 1 ? item.trendlineDatas[0] : [];
                data.datasets.push({
                    data: trendlineData,
                    ...commonObj,
                    borderWidth: 2,
                    order: -1
                });
            }
        });
    }

    if(datasetType === chartType.PARETO) {
        let lastIndex = 0;
        data.datasets.forEach((item, idx) => {
            if(!item.isTrendline) lastIndex = idx;
        });
        data.datasets[lastIndex].type = 'bar';
        data.datasets[lastIndex].borderWidth = 0;
    }

    if([chartType.CIRCLE_PIE, chartType.CIRCLE_DONUT, chartType.CIRCLE_DONUT_MULTIPLE].includes(datasetType)) {
        data.datasets = [data.datasets[0]];
        data.datasets[0].backgroundColor = chartColors;
    }

    let total = data.datasets[0].data.reduce((a, b) => a + b, 0);
    total = chartContainer.dataset.decimalPlaces ? total.toFixed(chartContainer.dataset.decimalPlaces) : Math.round(total);

    return {
        total,
        data
    }
}
GT.Dynamic365FormEventRegistrationPage = function () {
    const asideSelector = ".event-inline__aside";

    function setCookie(cookieValue, cookieName) {
        var currentCookie = GT.Cookies.getCookie(cookieName);
        if (currentCookie) {
            if (!currentCookie.includes(cookieValue))
                GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
        } else {
            GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
        }
    }

    function afterFormSubmit(formPlaceholder) {
        const containerForm = formPlaceholder.closest(asideSelector);
        if(!containerForm) return;

        const redirectUrl = containerForm.querySelector("#event-confimation-page-link")?.value;
        const cookieName = containerForm.querySelector('[name="registrationCookieName"]')?.value;
        const cookieValue = containerForm.querySelector('[name="eventPageGuidValue"]')?.value;

        if(cookieName && cookieValue) {
            setCookie(cookieValue, cookieName);
        }

        if (redirectUrl) {
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 2000);
        }
    }

    // New D365Mkt form
    document.addEventListener("d365mkt-afterformsubmit", (event) => {
        if(event.detail.successful)
            afterFormSubmit(event.target);
    });
};


GT.domContentLoadedFncList.push(function(){
    GT.Dynamic365FormEventRegistrationPage();
});
GT.GTEPiServerFormEventRegistrationPage = function(elem) {
	if (typeof $$epiforms !== 'undefined') {

		function setCookie(cookieValue, cookieName) {
			var currentCookie = GT.Cookies.getCookie(cookieName);
			if (currentCookie) {
				if (!currentCookie.includes(cookieValue))
					GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
			} else {
				GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
			}
		}

		$$epiforms(".EPiServerForms").on(
			"formsSubmitted",
			function (event, param1, param2) {
				const containerElm = this.closest(elem);
				if(!containerElm) return;
				const redirectUrl = containerElm.querySelector("#event-confimation-page-link")?.value;
				const cookieName = containerElm.querySelector('[name="registrationCookieName"]')?.value;
				const cookieValue = containerElm.querySelector('[name="eventPageGuidValue"]')?.value;

				if(cookieName && cookieValue) {
					setCookie(cookieValue, cookieName);
				}

				if (redirectUrl) {
					setTimeout(() => {
						window.location.href = redirectUrl;
					}, 500);
				}
			});
	}
};
if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		new GT.GTEPiServerFormEventRegistrationPage(".event-inline__aside");
	});
GT.EventListing = function () {
    const reClampText = () => {
        let clampname = document.querySelector('.extended-search-v3__listing-results')?.dataset.clampname;
        if (!clampname) return;
        GT.clampRevertToOriginalText(clampname);
        GT.clampText(clampname, true);
    };

    let lastView;

    document.querySelectorAll(".change-view").forEach(item => {
        item.addEventListener("click", (e) => {
            lastView = e.target.closest(".change-view").textContent;
        });
    });

    if (GT.ExtendedSearchV3Callback) {
        GT.ExtendedSearchV3Callback.replace.eventListing = function (response) {
            new GT.View($('.change-view'));

            let currentView;

            document.querySelectorAll(".change-view").forEach(item => {
                item.addEventListener("click", (e) => {
                    lastView = e.target.closest(".change-view").textContent;
                });
                
                if(lastView == item.textContent) {
                    currentView = item;
                }
            });

            currentView?.click();

            reClampText();
        }
        if (GT.ExtendedSearchV3Callback.append) {
            GT.ExtendedSearchV3Callback.append.eventListing = function (response) {
                reClampText();
            }
        }
    }
}

GT.domContentLoadedFncList.push(() => {
    GT.EventListing();
});
GT.GTGateEventResourcesDynamic365Form = function () {

    const containerSelector = ".event-resources-with-gate-dynamic365-form";
    const asideSelector = ".event-inline__aside";
    const containerElm = document.querySelector(containerSelector);
    if(!containerElm) return;

    function afterFormSubmit(formPlaceholder, isSuccessful) {
        const formContainer = formPlaceholder.closest(asideSelector);
        if(!formContainer) return;

        const formId = formContainer.querySelector("#eventExternalFormGateBlockId")?.value;
        if(!formId) return;
        
        const objGatedForm = $(formContainer.querySelector("form")).find(":input:not(:hidden)").serialize();
        localStorage.setItem("GatedMS365Form" + formId, JSON.stringify(objGatedForm));

        if(isSuccessful) {
            const cookieName = formContainer.querySelector('[name="eventGatedCookieName"]')?.value;
            const cookieValue = formContainer.querySelector('[name="eventPageGuidValue"]')?.value;

            if(cookieName && cookieValue) {
                setGatedArticleDynamic365FormCookie(cookieValue, cookieName);
            }
            
            setTimeout(function () {
                location.reload();
            }, 2000);
        }
    }

    function afterFormLoad(formPlaceholder) {
        const formContainer = formPlaceholder.closest(asideSelector);
        if(!formContainer) return;

        const formId = formContainer.querySelector("#eventExternalFormGateBlockId")?.value;
        if(!formId) return;

        const storedGatedForm = JSON.parse(localStorage.getItem("GatedMS365Form" + formId));
        if (storedGatedForm)
            $(formContainer.querySelector("form")).deserialize(storedGatedForm);

        switchBgBasedOnHeight(containerElm);
    }

    // New D365Mkt form
    document.addEventListener("d365mkt-afterformsubmit", (event) => {
        afterFormSubmit(event.target, event.detail.successful);
    });
    
    document.addEventListener("d365mkt-afterformload", (event) => {
        afterFormLoad(event.target);
    });

    function setGatedArticleDynamic365FormCookie(cookieValue, cookieName) {
        var currentCookie = GT.Cookies.getCookie(cookieName);
        if (currentCookie) {
            if (!currentCookie.includes(cookieValue))
                GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
        } else {
            GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
        }
    }

    function switchBgBasedOnHeight(el) {
        var blockImage = el.querySelector('.block--image');
        if (blockImage) {
            var heightBreakpoint = 374;
            var formHeight = el.offsetHeight;
            var smallImageInput = el.querySelector('.smallImageUrl');
            var bigImageInput = el.querySelector('.bigImageUrl');
            if (!smallImageInput && !bigImageInput) return;
            var smallImageUrl = smallImageInput ? smallImageInput.value : undefined;
            var bigImageUrl = bigImageInput ? bigImageInput.value : undefined;
            var imageUrl = bigImageUrl ? bigImageUrl : smallImageUrl;
            var finalUrl = formHeight > heightBreakpoint ? bigImageUrl : smallImageUrl;
            if (!finalUrl) finalUrl = imageUrl;
            blockImage.style.backgroundImage = 'url(' + finalUrl + ')';
        }
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.GTGateEventResourcesDynamic365Form();
});


GT.GTGateEventResourcesEpiForm = function ($element) {
	$element.each(function (index, element) {
		const epiForm = $(element).find("form")[0];
		if (!epiForm)
			return;

		const containerElm = this.closest(".event-inline__aside");
		if(!containerElm) return;

		const formId = containerElm.querySelector("#eventEpiFormGateBlockId")?.value;

		if (!formId)
			return;

		const localStorageId = "GatedEventResourcesEpiForm" + formId;
		if (typeof $$epiforms !== 'undefined') {
			$$epiforms(document).ready(function myfunction() {
				let objGatedForm = '';
				$$epiforms(epiForm).on("formsStartSubmitting",
					function (event) {
						objGatedForm = $(epiForm).find(":input:not(:hidden)").serialize();
						delete objGatedForm["__RequestVerificationToken"];
					});
				$$epiforms(epiForm).on("formsSubmitted", function (data) {
					$(element).find(".Form__Description").css('display', 'none');
					localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));

					const cookieName = containerElm.querySelector("input[name=eventGatedCookieName]")?.value;
					const cookieValue = containerElm.querySelector("input[name=eventPageGuidValue]")?.value;
					if(cookieName && cookieValue) {
						setCookie(cookieValue, cookieName);
					}

					location.reload();
				});
			});
		}
		const storedGatedArticleForm = JSON.parse(localStorage.getItem(localStorageId));
		if (storedGatedArticleForm)
			$(epiForm).deserialize(storedGatedArticleForm);

	});

	function setCookie(cookieValue, cookieName) {
		const currentCookie = GT.Cookies.getCookie(cookieName);
		if (currentCookie) {
			if (!currentCookie.includes(cookieValue))
				GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
		} else {
			GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
		}
	}
};
if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		new GT.GTGateEventResourcesEpiForm($('.event-resources-with-gate-epi-form'));
    });

GT.GTGateEventResourcesMarketoForm = function ($element) {

    $element.each(function (index, element) {
		//support multiple forms in the same page
		let containerForm = null;
        let localStorageId = null;

        MktoForms2.whenReady(function (form) {
            var maketoForm = form.getFormElem();
            if (maketoForm && maketoForm.length) {
                containerForm = maketoForm[0]?.closest(".event-inline__aside");
                if (containerForm) {
                    localStorageId = "GatedEventResourceMarketoForm" + containerForm.querySelector("#eventExternalFormGateBlockId")?.value;
                }

                form.onSubmit(function (e) {
                    var maketoFormSubmit = e.getFormElem();
                    if(maketoFormSubmit && maketoFormSubmit.length) {
                        var objGatedForm = $(maketoFormSubmit).find(":input:not(:hidden)").serialize();
                        if (localStorageId) {
                            localStorage.setItem(localStorageId, JSON.stringify(objGatedForm));
                        }
                        let wrapperForm = maketoFormSubmit[0]?.closest(".event-inline__aside");
                        if(wrapperForm) {
                            const cookieName = wrapperForm.querySelector('[name="eventGatedCookieName"]')?.value;
                            const cookieValue = wrapperForm.querySelector('[name="eventPageGuidValue"]')?.value;
                            setGatedArticleMarketoFormCookie(cookieValue, cookieName);
                        }

                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                });

                var storedGatedForm = JSON.parse(localStorage.getItem(localStorageId));
                if (storedGatedForm)
                    $(maketoForm).deserialize(storedGatedForm);

                switchBgBasedOnHeight($(element));
            }
        });
    });

    function setGatedArticleMarketoFormCookie(cookieValue, cookieName) {
        if(!cookieName || !cookieValue) return;
        var currentCookie = GT.Cookies.getCookie(cookieName);
        if (currentCookie) {
            if (!currentCookie.includes(cookieValue))
                GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
        } else {
            GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
        }
    }

    function switchBgBasedOnHeight($el) {
        var $blockImage = $el.find('.block--image');
        if ($blockImage.length > 0) {
            var heightBreakpoint = 374;
            var formHeight = $el.height();
            var $smallImageInput = $el.find('.smallImageUrl');
            var $bigImageInput = $el.find('.bigImageUrl');
            if ($smallImageInput.length === 0 && $bigImageInput.length === 0) return;
            var smallImageUrl = $smallImageInput.length > 0 ? $smallImageInput.val() : undefined;
            var bigImageUrl = $bigImageInput.length > 0 ? $bigImageInput.val() : undefined;
            var imageUrl = bigImageUrl ? bigImageUrl : smallImageUrl;
            var finalUrl = formHeight > heightBreakpoint ? bigImageUrl : smallImageUrl;
            if (!finalUrl) finalUrl = imageUrl;
            $blockImage.css('background-image', 'url(' + finalUrl + ')');
        }
    }
};
if (typeof isV1GT == "undefined")
    GT.domContentLoadedFncList.push(function(){
		new GT.GTGateEventResourcesMarketoForm($('.event-resources-with-gate-marketo-form'));
    });
GT.GTMarketoEmbedFormEventRegistrationPage = function (elem) {
	if (typeof MktoForms2 !== 'undefined') {

		function setCookie(cookieValue, cookieName) {
			var currentCookie = GT.Cookies.getCookie(cookieName);
			if (currentCookie) {
				if (!currentCookie.includes(cookieValue))
					GT.Cookies.setCookieWithoutServerCheck(cookieName, currentCookie + "," + cookieValue, 365, "/");
			} else {
				GT.Cookies.setCookieWithoutServerCheck(cookieName, cookieValue, 365, "/");
			}
		}


		//support multiple forms in the same page
		MktoForms2.whenReady(function (form) {
			let containerForm = form.getFormElem()[0]?.closest(elem);
			form.onSuccess(function () {
				if(containerForm) {
					const redirectUrl = containerForm.querySelector("#event-confimation-page-link")?.value;
					const cookieName = containerForm.querySelector('[name="registrationCookieName"]')?.value;
					const cookieValue = containerForm.querySelector('[name="eventPageGuidValue"]')?.value;

					if(cookieName && cookieValue) {
						setCookie(cookieValue, cookieName);
					}

					if (redirectUrl) {
						setTimeout(() => {
							window.location.href = redirectUrl;
						}, 500);
					} else {
						setTimeout(() => {
							let targetOffsetTop = GT.getElementOffset(containerForm).top;
							let scrollOffset = targetOffsetTop - GT.headerElm.clientHeight - 72;
							window.scrollTo(0, scrollOffset);
						}, 250);
					}
				}
			});
		});
	}
};
if (typeof isV1GT == "undefined")
	GT.domContentLoadedFncList.push(function(){
		new GT.GTMarketoEmbedFormEventRegistrationPage(".event-inline__aside");
	});
GT.dropdown = function () {
    const SELECTORS = {
        dropdown: ".extended-search-v3__dropdown",
        dropdownButton: ".extended-search-v3__dropdown-button",
        searchInput: ".extended-search-v3__dropdown-search",
        openingDropdown: "opening-dropdown",
        selectedItem: ".extended-search-v3__dropdown-selected-item",
        dropdownWrapper: ".extended-search-v3__dropdown-list-wrapper",
        dropdownList: ".extended-search-v3__dropdown-list",
        dropdownItem: ".extended-search-v3__dropdown-item",
        singleSelection: ".single-selection"
    };

    let callback = GT.dropdown?.callback || {};
    let currentListFocusableElms = [];

    function showSelectedTagsOnDropdown(dropdownElm) {
        if(dropdownElm.closest("[data-show-selected-tags-on-dropdown]")) {
            const selectedItems = Array.from(dropdownElm.querySelectorAll(`input:checked`));
            const selectedElm = dropdownElm.querySelector(SELECTORS.selectedItem);
            if(!selectedElm.dataset.text) selectedElm.dataset.text = selectedElm.innerText;
            selectedElm.innerText = selectedItems.length ? selectedItems.map(tag => tag.getAttribute("data-label")).join(", ") : selectedElm.dataset.text;
        }

        currentListFocusableElms = [];
        Object.keys(callback).forEach(key => {
            callback[key](dropdownElm);
        });
    }

    function closeAllDropdowns(e) {
        document.querySelectorAll(SELECTORS.dropdown).forEach(dropdownElm => {
            if((dropdownElm != e.target.closest(SELECTORS.dropdown) || e.key == "Escape")
                && !e.target.querySelector(".fetching") 
                && !e.target.closest(".fetching") 
                && dropdownElm.classList.contains("open")
            ) {
                currentListFocusableElms = [];
                dropdownElm.classList.add("closing");
                dropdownElm.classList.remove("open");
                setTimeout(() => {
                    dropdownElm.classList.remove("closing");
                    showSelectedTagsOnDropdown(dropdownElm);
                }, 300);
                dropdownElm.closest(".flexible-banner__block")?.classList.remove(SELECTORS.openingDropdown);
                dropdownElm.querySelector(SELECTORS.dropdownButton).setAttribute("aria-expanded", "false");
                dropdownElm.removeAttribute("aria-modal");
                dropdownElm.querySelector(SELECTORS.dropdownWrapper)?.removeAttribute("style");
            }
        });
    }

    function registerLoopFocusForDropdown(dropdownElm) {
        if(!dropdownElm) return;
        const inputElm = dropdownElm.querySelector(SELECTORS.searchInput);
        currentListFocusableElms = [inputElm, ...dropdownElm.querySelectorAll(SELECTORS.dropdownItem + ":not(.hide):not(.disabled)")];

        if(!dropdownElm.isInitialized) {
            dropdownElm.isInitialized = true;
            dropdownElm.addEventListener("keydown", e => {
                let currentDropdown = e.target.closest(SELECTORS.dropdown);
                if(e.key == "Tab" && currentDropdown?.classList.contains("open") && !GT.isTouchDevice) {
                    e.preventDefault();
                    const dropdownBtn = currentDropdown?.querySelector(SELECTORS.dropdownButton);
                    dropdownBtn?.setAttribute("aria-expanded", "false");
                    setTimeout(() => {
                        dropdownBtn?.focus();
                        dropdownBtn?.click();
                    }, 100);
                    e.stopPropagation();
                }
            })
        }
        
        currentListFocusableElms.forEach((item, idx) => {
            item.idx = idx;
            if(!item.closest(SELECTORS.searchInput)) {
                item.removeAttribute("aria-checked");
                item.setAttribute("role", "option");
                item.setAttribute("aria-selected", item.querySelector("input")?.checked ? true : false);
            }

            if(item.addedEvent === undefined) {
                item.addedEvent = true;
                item.addEventListener("keydown", e => {
                    let currentItem = e.target;
                    if(e.key == "ArrowDown" || e.key == "ArrowUp") {
                        e.preventDefault();
                        let nextIndex = parseInt(currentItem.idx) + (e.key == "ArrowDown" ? 1 : -1);
                        if(nextIndex < 0) nextIndex = currentListFocusableElms.length - 1;
                        if(nextIndex >= currentListFocusableElms.length) nextIndex = 0;
                        (currentListFocusableElms[nextIndex].closest(SELECTORS.dropdownItem) || currentListFocusableElms[nextIndex])?.focus();
                    }

                    if(currentItem.classList.contains(SELECTORS.dropdownItem.replace(".", "")) && (e.key == "Enter" || e.key == " ")) {
                        e.preventDefault();
                        e.stopPropagation();
                        currentItem.click();
                        const isChecked = currentItem.querySelector("input")?.checked ? true : false;
                        if(GT.isTouchDevice) {
                            currentItem.setAttribute("aria-checked", isChecked);
                        } else {
                            currentItem.setAttribute("aria-selected", isChecked);
                        }
                    }
                })
            }
        })
    }

    function registerEventForDropdown(dropdownElm) {
        if(!dropdownElm) return;
        dropdownElm.querySelectorAll(SELECTORS.dropdownItem + ":not(.hide):not(.disabled)").forEach((item, idx) => {
            if(item.addedChangeEvent === undefined) {
                item.addedChangeEvent = true;
                item.addEventListener("click", e => {
                    let currentItem = e.target.closest(SELECTORS.dropdownItem);
                    let checkboxElm = currentItem?.querySelector("input");
                    if(!checkboxElm) return;

                    if(currentItem.closest(SELECTORS.singleSelection)) {
                        const parentDropdown = currentItem.closest(SELECTORS.dropdown);
                        parentDropdown.querySelectorAll(SELECTORS.dropdownItem + " input").forEach(item => {
                            item.checked = false;
                        });
                        
                        setTimeout(() => {
                            parentDropdown?.querySelector(SELECTORS.dropdownButton)?.click();
                        }, 100);
                    }

                    checkboxElm.checked ^= 1;
                    
                    const isChecked = checkboxElm.checked;
                    if(GT.isTouchDevice) {
                        currentItem.setAttribute("aria-checked", isChecked);
                    } else {
                        currentItem.setAttribute("aria-selected", isChecked);
                    }

                    const event = new Event("change");
                    checkboxElm.dispatchEvent(event);
                })
            }
        });
    }

    function init() {
        if(GT.ExtendedSearchV3Callback)
            GT.ExtendedSearchV3Callback.replace.reregisterEventForDropdown = () => {
                document.querySelectorAll(SELECTORS.dropdown).forEach(dropdownElm => {
                    registerEventForDropdown(dropdownElm);

                    // if not checking open state, the currentListFocusableElms will be wrong after filtering finished
                    if(dropdownElm.classList.contains("open")) {
                        registerLoopFocusForDropdown(dropdownElm);
                    }
                });
            }

        document.querySelectorAll(SELECTORS.dropdown).forEach(dropdownElm => {
            const inputElm = dropdownElm.querySelector(SELECTORS.searchInput);
            
            if(dropdownElm.dataset.initialized) return;

            dropdownElm.dataset.initialized = true;

            registerEventForDropdown(dropdownElm);

            function triggerFilter(value) {
                const currentValue = value?.trim().toLowerCase() || "";
                dropdownElm.querySelectorAll(SELECTORS.dropdownItem + " label").forEach(item => {
                    const itemText = item.textContent.trim().toLowerCase();
                    const words = itemText.split(' ');
                    const firstLetters = words.map(word => word.charAt(0)).join('');
                    
                    // Check if current value matches full text OR first letters of words
                    const matchesFullText = itemText.includes(currentValue);
                    const matchesFirstLetters = firstLetters.includes(currentValue);
                    
                    if(!matchesFullText && !matchesFirstLetters) {
                        item.closest(SELECTORS.dropdownItem).classList.add("hide");
                    } else {
                        item.closest(SELECTORS.dropdownItem).classList.remove("hide");
                    }
                });
                
                const dropdownList = dropdownElm.querySelector(SELECTORS.dropdownList);
                const hasVisibleItems = dropdownElm.querySelectorAll(SELECTORS.dropdownItem + ":not(.hide)").length > 0;
                if(hasVisibleItems) {
                    dropdownList?.classList.remove("no-items");
                } else {
                    dropdownList?.classList.add("no-items");
                }

                registerLoopFocusForDropdown(dropdownElm);
            }

            function toggleDropdown(e) {
                const toggleBtn = e.target.closest(SELECTORS.dropdownButton);
                let container = toggleBtn.closest(SELECTORS.dropdown);
                let isOpen = container.classList.contains("open");
                const dropdownWrapper = container.querySelector(SELECTORS.dropdownWrapper);
                if(!isOpen) {
                    const computed = dropdownWrapper.getBoundingClientRect();

                    if(computed.right >= GT.wWidth) {
                        dropdownWrapper.style.left = (GT.wWidth - computed.right - 16) + "px";
                    }

                    container.querySelector(SELECTORS.dropdownList).classList.remove("no-items");
                    inputElm.value = "";
                    triggerFilter("");
                    container.classList.add("opening");
                    container.classList.add("open");
                    setTimeout(() => {
                        container.setAttribute("aria-modal", "true");
                        container.classList.remove("opening");
                        setTimeout(() => {
                            inputElm.focus();
                        }, 200);

                        registerLoopFocusForDropdown(container);
                    }, 300);
                    container.closest(".flexible-banner__block")?.classList.add(SELECTORS.openingDropdown);
                    toggleBtn.setAttribute("aria-expanded", "true");
                } else {
                    dropdownWrapper.removeAttribute("style");
                    container.closest(".flexible-banner__block")?.classList.remove(SELECTORS.openingDropdown);
                    container.classList.add("closing");
                    container.classList.remove("open");
                    container.setAttribute("aria-modal", "false");
                    if(GT.isTouchDevice) {
                        container.insertAdjacentHTML("beforebegin", "<button id='temp-btn' style='position: absolute; height: 1px; width: 1px; overflow: hidden; opacity: 0;'>"+ toggleBtn.textContent +"</button>");
                        document.querySelector("#temp-btn").focus();
                    }

                    toggleBtn.setAttribute("aria-expanded", "false");
                    setTimeout(() => {
                        showSelectedTagsOnDropdown(dropdownElm);
                        container.classList.remove("closing");
                        toggleBtn.focus();
                        if(GT.isTouchDevice) {
                            document.querySelector("#temp-btn").remove();
                        }
                    }, 300);
                }
            }


            dropdownElm.querySelector(SELECTORS.dropdownButton).addEventListener("keydown", e => {
                if(e.key == "Enter" && e.target.nodeName != "INPUT") {
                    toggleDropdown(e);
                }
            });

            dropdownElm.querySelector(SELECTORS.dropdownButton).addEventListener("click", toggleDropdown);

            dropdownElm.addEventListener("focusout", e => {
                const currentElm = e.target.closest(SELECTORS.dropdown);
                if(currentElm.classList.contains(SELECTORS.dropdown)) {
                    closeAllDropdowns(e);
                }
            });

            inputElm.addEventListener("click", e => {
                e.stopPropagation();
            });

            inputElm.addEventListener("keypress", e => {
                if(e.key == "Enter") {
                    e.preventDefault();
                };
            });

            inputElm.addEventListener("keyup", e => {
                triggerFilter(e.target.value);
            });
        });
    }

    document.body.addEventListener("click", e => {
        closeAllDropdowns(e);
    });

    window.addEventListener("keydown", e => {
        if(e.key == "Escape") {
            closeAllDropdowns(e);
            const parentElm = e.target.closest(SELECTORS.dropdown);
            if(parentElm) {
                setTimeout(() => {
                    parentElm.querySelector(SELECTORS.dropdownButton).focus();
                }, 100);
            }
        }
    });

    //Auto close dropdown when focus out ?
    // document.addEventListener('focusin', (e) => {
    //     if(!e.target.closest(SELECTORS.dropdown))
    //         closeAllDropdowns(e);
    // });

    init();

    return {
        init,
        closeAllDropdowns,
        callback,
        registerLoopFocusForDropdown,
        showSelectedTagsOnDropdown
    }
}

GT.domContentLoadedFncList.push(() => {
    GT.dropdown = GT.dropdown();
});
GT.ExtendedSearchV3Callback = {
    replace: {},
    append: {}
};

GT.ExtendedSearchV3 = function (formElm) {
    
    const SELECTORS = {
        templateContainer: ".extended-search-v3__template-data",
        templateDataResults: ".template-data__results",
        templateFilter: ".template-data__filter",
        templateSubmitBtn: ".template-cta-button",
        dropdownList: ".extended-search-v3__dropdown-list",
        dropdownItem: ".extended-search-v3__dropdown-item",
        dropdownButton: ".extended-search-v3__dropdown-button",
        dropdown: ".extended-search-v3__dropdown",
        filterItem: ".filters__item",
        searchInputArea: ".extended-search-v3__search",
        searchBtn: ".extended-search-v3__search-btn",
        filterBtn: ".extended-search-v3__filter-btn",
        selectedTags: ".extended-search-v3__selected_tags button[data-id]",
        clearTags: ".extended-search-v3__selected_tags .clear-all-tags",
        inputElm: ".extended-search-v3__search-input",
        resultText: ".extended-search-v3__result-text",
        sortElm: "#select_sorting",
        listingContainer: ".extended-search-v3__listing-results",

        loadMoreContainer: ".load-more-container",
        loadMoreBtn: ".load-more-btn",
        loadMoreStats: ".load-more-stats",
        loadMoreStatsProgressbar: ".load-more-stats__progressbar-loaded",
        loadMoreStatsShowingItems: ".load-more-stats__showing-items",
    }

    const resultContainer = document.querySelector("#" + formElm.dataset.resultId);
    let lastClickedFilterItem = null;

    const extendedSearchV3Elms = {
        //filter form
        form: formElm,
        searchInputArea: formElm.querySelector(SELECTORS.searchInputArea),
        inputElm: formElm.querySelector(SELECTORS.inputElm),

        //result container
        resultContainer: resultContainer,
        templateContainer: document.querySelector(SELECTORS.templateContainer),
    }


    if(!extendedSearchV3Elms.form) return;

    const httpService = new HttpService();
    const filterURL = extendedSearchV3Elms.form.action;

    function toggleFilter(e) {
        const parentElm = e.target.closest(".extended-search-v3-wrap");
        if(parentElm) {
            parentElm.classList.toggle("opening-filter");
            if(parentElm.classList.contains("opening-filter")) {
                extendedSearchV3Elms.form.querySelectorAll(SELECTORS.filterBtn).forEach(btn => {
                    btn.setAttribute("aria-expanded", "true");
                });
                if(GT.isEventFromScreenReader(e)) {
                    setTimeout(() => {
                        parentElm.querySelector(SELECTORS.dropdownButton)?.focus();
                    }, 500);
                }
            } else {
                extendedSearchV3Elms.form.querySelectorAll(SELECTORS.filterBtn).forEach(btn => {
                    btn.setAttribute("aria-expanded", "false");
                });
            }
        }
    }

    extendedSearchV3Elms.form.querySelectorAll(SELECTORS.filterBtn).forEach(btn => {
        btn.addEventListener("click", toggleFilter);
        btn.addEventListener("keydown", e => {
            if(e.key === "Enter") {
                toggleFilter(e);
            }
        });
    });
    
    function fireAutocomplete() {

        if(!extendedSearchV3Elms.inputElm?.dataset?.endpoint) return;

        function orphanCharAsWord(word) {
            return word.length > 1 ? word : ' ' + word + ' ';
        }

        try {
            if(window.currentAutoComplete)
                window.currentAutoComplete.destroy();

            if (extendedSearchV3Elms.inputElm) {
                window.currentAutoComplete = new autoComplete({
                    selector: SELECTORS.inputElm,
                    minChars: 3,
                    delay: 250,
                    cache: 0,
                    source: function (term, suggest) {
                        term = term.toLowerCase()
                            .replace(/</gi, '%253C')
                            .replace(/>/gi, '%253E')
                            .replace(/([|\\\/{}[\]^*$+?."'])/gi, function (match, dec) {
                                return encodeURI(dec);
                            })
                            .replace(/[()]/gi, '\\$&');
                        
                        formElm.classList.add("fetching");

                        $.ajax({
                            url: extendedSearchV3Elms.inputElm.dataset.endpoint,
                            type: "get",
                            data: {
                                query: term
                            },
                            success: function (data) {
                                formElm.classList.remove("fetching");
                                suggest(data);
                                if(!data || data.length <= 0) {
                                    let _autoCompleteItems = document.querySelectorAll('.autocomplete-suggestion');
                                    
                                    [].forEach.call(_autoCompleteItems, function(_autoCompleteItem){
                                        if(_autoCompleteItem) _autoCompleteItem.remove();
                                    });
                                }
                            },
                            error: function (xhr) {
                                console.warn(xhr);
                            }
                        });
                    },
                    renderItem: function (item, search) {
                        var decodedText = item.Text.replace(/&#(\d+);/g, function (match, dec) {
                            return String.fromCharCode(dec);
                        }).replace(/[\"]/gi, "&#34;");
                        var re = new RegExp("(" + search.split(' ').map(orphanCharAsWord).join('|').replace(/[\(\)\?\.\*\+\^\{\}\-\[\]\$]/gi, '\\$&').replace(/[\"]/gi, "&#34;") + ")", "gi");
                        return '<div class="autocomplete-suggestion" data-link="' + item.Value + '" data-val="' + decodedText + '" >' + decodedText.replace(re, "<b>$1</b>") + '</div>';
                    },
                    onSelect: function (e, term, item) {
                        window.location.href = $(item).data('link');
                    }
                });
            }
        } catch (ex) {
            console.warn(ex);
        };
    };

    function assignParamsToURL(currentURL) {
        let apiFilterURL = new URL(currentURL);
        const sortValue = document.querySelector(SELECTORS.sortElm)?.value || "";

        if(extendedSearchV3Elms.inputElm?.value) {
            apiFilterURL.searchParams.set("query", extendedSearchV3Elms.inputElm.value);
        }

        const selectedTags = [];
        const dropdownLists = formElm.querySelectorAll(SELECTORS.dropdownList);
        dropdownLists.forEach(dropdownList => {
            const dropdownType = dropdownList.dataset.dropdownType;
            apiFilterURL.searchParams.delete(dropdownType);
        });

        
        dropdownLists.forEach(dropdownList => {
            const dropdownType = dropdownList.dataset.dropdownType;
            const selectedItems = Array.from(dropdownList.querySelectorAll(`input:checked`));
            const tags = selectedItems.map(tag => tag.value).join("+");
            if(tags) {
                apiFilterURL.searchParams.append(dropdownType, tags);
            }
            selectedTags.push({
                param: dropdownType,
                value: tags
            });
        });

        if(sortValue) {
            apiFilterURL.searchParams.set("sort", sortValue);
        }

        return {
            sortValue,
            url: apiFilterURL.toString(),
            selectedTags,
            dropdownLists
        };
    }


    function triggerFilter(e, hasChangedTags) {
        e.preventDefault();
        const currentElm = e.target;
        const previousScrollPosition = hasChangedTags ? currentElm.closest(SELECTORS.dropdownList).scrollTop : 0;
        const previousScrollHeight = hasChangedTags ? currentElm.closest(SELECTORS.dropdownList).scrollHeight : 0;

        formElm.classList.add("fetching");

        let paramsData = assignParamsToURL(filterURL);

        setTimeout(() => {
            GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
        }, 10);


        const targetReplaceAllStr = formElm.querySelector(`${SELECTORS.filterItem}[value="${lastClickedFilterItem}"]`)?.closest(SELECTORS.dropdownList)?.dataset.replaceAll;

        httpService.getHtmlContent(paramsData.url).then(response => {
            extendedSearchV3Elms.templateContainer.innerHTML = response;
            extendedSearchV3Elms.resultContainer?.replaceChildren(extendedSearchV3Elms.templateContainer.querySelector(SELECTORS.templateDataResults).content || "");

            const newSubmitBtn = extendedSearchV3Elms.templateContainer.querySelector(SELECTORS.templateSubmitBtn)?.content || "";
            if(newSubmitBtn) {
                const currentSubmitBtn = extendedSearchV3Elms.form.querySelector(SELECTORS.searchBtn);
                if(currentSubmitBtn) {
                    currentSubmitBtn.replaceWith(newSubmitBtn);
                } else {
                    extendedSearchV3Elms.form.appendChild(newSubmitBtn);
                }
            }

            if(targetReplaceAllStr) {
                extendedSearchV3Elms.form.querySelector(targetReplaceAllStr).replaceWith(extendedSearchV3Elms.templateContainer.querySelector(SELECTORS.templateFilter).content);
                extendedSearchV3Elms.form.querySelectorAll(".animation-item").forEach(item => {
                    item.classList.remove("animation-item");
                });
                
                extendedSearchV3Elms.form.querySelectorAll(SELECTORS.dropdown).forEach(dropdownItem => {
                    GT.dropdown.showSelectedTagsOnDropdown(dropdownItem);
                });

                formElm.querySelector(`${SELECTORS.filterItem}[value="${lastClickedFilterItem}"]`)?.closest(SELECTORS.dropdown)?.querySelector(SELECTORS.dropdownButton)?.focus();
            } else {
                const newDropdownList = extendedSearchV3Elms.templateContainer.querySelector(SELECTORS.templateFilter)?.content.querySelectorAll(SELECTORS.dropdownList) || [];
                paramsData.dropdownLists.forEach((dropdownList, idx) => {
                    if(newDropdownList[idx]) {
                        dropdownList.replaceWith(newDropdownList[idx]);
                        const dropdownContainer = dropdownList.closest(SELECTORS.dropdown);
                        if(dropdownContainer && !dropdownContainer.classList.contains("open")) {
                            GT.dropdown.showSelectedTagsOnDropdown(dropdownContainer);
                        }
                    }
                });
            }

            registerEventForFilterItems();
            Object.keys(GT.ExtendedSearchV3Callback.replace).forEach(key => {
                GT.ExtendedSearchV3Callback.replace[key](response);
            });

            if(hasChangedTags) {
                let previousSelectedElm = formElm.querySelector(`${SELECTORS.filterItem}[value="${lastClickedFilterItem}"]`)?.closest(SELECTORS.dropdownItem);
                if(previousSelectedElm) {
                    const isChangedItems = previousScrollHeight != previousSelectedElm.closest(SELECTORS.dropdownList).scrollHeight;
                    previousSelectedElm.focus({ preventScroll: !isChangedItems });
                    if(!isChangedItems) {
                        previousSelectedElm.closest(SELECTORS.dropdownList).scrollTop = previousScrollPosition;
                    }
                }
            }

            setTimeout(() => {
                formElm.classList.remove("fetching");
            }, 500);
            GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText + " " + (extendedSearchV3Elms.resultContainer?.querySelector(SELECTORS.resultText)?.textContent || "");


            GT.FormSelect && GT.FormSelect($('.form-select'));            
            // if(e.target.closest(SELECTORS.sortElm)) {
            //     (formElm.querySelector(SELECTORS.sortElm) || resultContainer.querySelector(SELECTORS.sortElm))?.focus();
            // }


            if(!formElm.dataset.noChangeUrl) {
                let browserURL = new URL(window.location.href);
                browserURL.searchParams.set("q", extendedSearchV3Elms.inputElm?.value || "");
                browserURL.searchParams.set("sort", paramsData.sortValue);
                browserURL.searchParams.delete("page");
                browserURL.searchParams.delete("pageId");
                paramsData.selectedTags.forEach(tag => {
                    browserURL.searchParams.delete(tag.param);
                });
                
                paramsData.selectedTags.forEach(tag => {
                    if(tag.value) {
                        browserURL.searchParams.append(tag.param, tag.value);
                    }
                });
                window.history.pushState({}, "", browserURL);
            }
        });
    }

    
    function updatePageIndex(pageIndex) {
        let browserURL = new URL(window.location.href);
        if(pageIndex > 1) {
            browserURL.searchParams.set("page", pageIndex);
        } else {
            browserURL.searchParams.delete("page");
        }
        window.history.pushState({}, "", browserURL);

        let canonicalElm = document.querySelector('link[rel="canonical"]');
        if(canonicalElm)
            canonicalElm.href = browserURL.toString(); 
    }

    function observerElm(elm) {
        if(!elm.dataset.observed) {
            elm.dataset.observed = true;
            GT.checkElmVisible(elm, {
                callback: (e) => {
                    updatePageIndex(elm.dataset.page);
                },
                recheck: true,
                threshold: 1
            })
        }
    }

    function showLoadMore(loadNewConfig) {
        const loadMoreContainer = extendedSearchV3Elms.resultContainer?.querySelector(SELECTORS.loadMoreContainer);
        const loadmoreConfigTemp = extendedSearchV3Elms.resultContainer?.querySelector('.extendeded-search-v3__loadmore-config')?.content?.textContent;

        if(!loadmoreConfigTemp) return;

        if(loadNewConfig) {
            loadmoreConfig = JSON.parse(loadmoreConfigTemp);
            loadmoreConfig.container = loadMoreContainer;
            loadmoreConfig.loadMoreBtn = loadMoreContainer?.querySelector(SELECTORS.loadMoreBtn);
            loadmoreConfig.loadMoreBtn?.addEventListener("click", e => {
                e.preventDefault();
                loadMore(false);
            });
            loadmoreConfig.previousPageIndex = loadmoreConfig.nextPageIndex = loadmoreConfig.currentPageIndex;
            loadmoreConfig.totalPages = Math.ceil(loadmoreConfig.totalItems / loadmoreConfig.pageSize);
        }

        const listingContainer = extendedSearchV3Elms.resultContainer?.querySelector(SELECTORS.listingContainer);
        if(!listingContainer) return;

        Array.from(listingContainer.children).forEach(elm => {
            if(!elm.dataset.page) {
                elm.dataset.page = loadmoreConfig.currentPageIndex;
                observerElm(elm);
            }
        });
    }

    function loadMore(isLoadPrevious) {
        const listingContainer = extendedSearchV3Elms.resultContainer?.querySelector(SELECTORS.listingContainer);
        if(!listingContainer || formElm.classList.contains("fetching")) return;

        let apiLoadMoreURL = new URL(assignParamsToURL(window.location.origin + loadmoreConfig.endPoint).url);
        let currentPageIndex = 1;
        if(isLoadPrevious) {
            loadmoreConfig.previousPageIndex -= 1;
            currentPageIndex = loadmoreConfig.previousPageIndex;
        } else {
            loadmoreConfig.nextPageIndex += 1;
            currentPageIndex = loadmoreConfig.nextPageIndex;
        }

        if(currentPageIndex <= 0 || currentPageIndex > loadmoreConfig.totalPages) return;

        loadmoreConfig.currentPageIndex = currentPageIndex;
        apiLoadMoreURL.searchParams.set("CurrentPageIndex", currentPageIndex);
        
        formElm.classList.add("fetching");
        setTimeout(() => {
            GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
        }, 10);


        httpService.getHtmlContent(apiLoadMoreURL.toString()).then(response => {
            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
            
            let lastItem = listingContainer.lastElementChild,
            old_DOM_height = document.querySelector(".gt-wrapper").offsetHeight,
            old_scroll = GT.lastScrollTop;
            
            listingContainer.insertAdjacentHTML(isLoadPrevious ? "afterbegin" : "beforeend", response);

            showLoadMore(false);
            
            if(!isLoadPrevious) {
                let focusableItem = lastItem?.nextElementSibling;
                if(focusableItem) {
                    let elmIsFocusable = GT.canFocus(focusableItem);
                    if(elmIsFocusable) elmIsFocusable.focus();
                    else {
                        let lstFocusableElms = GT.getListFocusableElms(focusableItem);
                        if(lstFocusableElms.length)
                            lstFocusableElms[0].focus();
                    }
                }

                

                if(loadmoreConfig.container) {
                    
                    loadmoreConfig.totalDisplayingItems += loadmoreConfig.pageSize;
                    if(loadmoreConfig.totalDisplayingItems > loadmoreConfig.totalItems) {
                        loadmoreConfig.totalDisplayingItems = loadmoreConfig.totalItems;
                    }
                    
                    if(loadmoreConfig.currentPageIndex >= loadmoreConfig.totalPages) {
                        loadmoreConfig.container.classList.add("hidden");
                    } else {
                        loadmoreConfig.container.classList.remove("hidden");
                    }
        
                    loadmoreConfig.container.querySelector(SELECTORS.loadMoreStatsShowingItems).innerText = loadmoreConfig.totalDisplayingItems;
                    
                    const loadMoreStatsProgressBar = loadmoreConfig.container.querySelector(SELECTORS.loadMoreStatsProgressbar);
                    if(loadMoreStatsProgressBar) {
                        loadMoreStatsProgressBar.style.width = (loadmoreConfig.totalDisplayingItems / loadmoreConfig.totalItems * 100) + "%";
                    }
                }
            } else {
                window.scrollTo({ top: (old_scroll + document.querySelector(".gt-wrapper").offsetHeight - old_DOM_height), left:0, behavior: "instant"});
            }
            setTimeout(() => {
                formElm.classList.remove("fetching");
            }, 500);

            GT.FakeHyperlink();

            GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText + " " + (extendedSearchV3Elms.resultContainer?.querySelector(SELECTORS.resultText)?.textContent || "");

            if(!formElm.dataset.noChangeUrl) {
                let browserURL = new URL(window.location.href);

                if(loadmoreConfig.loadMoreBtn) {
                    browserURL.searchParams.set("page", loadmoreConfig.currentPageIndex + 1);
                    loadmoreConfig.loadMoreBtn.href = browserURL.toString() + location.hash;
                }
            }
            
            Object.keys(GT.ExtendedSearchV3Callback.append).forEach(key => {
                GT.ExtendedSearchV3Callback.append[key](response);
            });
        });
    }

    function registerEventForFilterItems() {
        GT.dropdown.init();
        extendedSearchV3Elms.form.querySelector(SELECTORS.dropdown + ".open input")?.dispatchEvent(new KeyboardEvent("keyup", { key: "Enter" }));
        extendedSearchV3Elms.filterItems = formElm.querySelectorAll(SELECTORS.filterItem);
        extendedSearchV3Elms.filterItems.forEach(item => {
            if(!item.isInitial) {
                item.isInitial = true;
                item.addEventListener("change", e => {
                    const currentTarget = e.target;
                    lastClickedFilterItem = currentTarget.value;
                    
                    const childTypes = currentTarget.closest(SELECTORS.dropdownList).dataset.childTypes;
                    if(childTypes) {                    
                        childTypes.split(",").forEach(dropdownType => {
                            extendedSearchV3Elms.form.querySelectorAll("[data-dropdown-type='"+ dropdownType +"'] " + SELECTORS.filterItem).forEach(elm => {
                                elm.checked = false;
                            });
                        });
                    }

                    triggerFilter(e, true);
                });
            }
        });

        document.querySelector(SELECTORS.clearTags)?.addEventListener("click", e => {
            extendedSearchV3Elms.filterItems.forEach(item => {
                item.checked = false;
            });
            formElm.querySelector(SELECTORS.inputElm).value = "";
            triggerFilter(e);
            e.currentTarget.disabled = true;
        });

        document.querySelectorAll(SELECTORS.selectedTags)?.forEach(tag => {
            tag.addEventListener("click", e => {
                const currentTag = e.currentTarget;
                if(currentTag.dataset.id == "gt-keywords") {
                    formElm.querySelector(SELECTORS.inputElm).value = "";
                    triggerFilter(e);
                } else {
                    formElm.querySelector(`#${currentTag.dataset.id}`)?.closest(SELECTORS.dropdownItem)?.click();
                }
                currentTag.remove();
            });
        });

        document.querySelector(SELECTORS.sortElm)?.addEventListener("change", e => {
            triggerFilter(e);
        });
        showLoadMore(true);
    }

    extendedSearchV3Elms.form.addEventListener("submit", triggerFilter);
    registerEventForFilterItems();
    fireAutocomplete();

    
    let resultContainerOffsetTop = 0;
    GT.listFunctionsTriggerInScrollEvent['checkScrollPosExtendedSearch_0'] = (e) => {
        if(!resultContainerOffsetTop) {
            resultContainerOffsetTop = GT.getElementOffset(extendedSearchV3Elms.resultContainer).top;
        }

        const currentPageIndex = new URLSearchParams(window.location.search).get("page") || 1;
        if(currentPageIndex > 1 && GT.isScrollingUp && GT.lastScrollTop - resultContainerOffsetTop < 300 && !formElm.classList.contains("fetching")) {
            loadMore(true);
        }
    }
    
}


GT.domContentLoadedFncList.push(() => {
    document.querySelectorAll(".extended-search-v3").forEach(formElm => {
        GT.ExtendedSearchV3(formElm);
    });
});
GT.CareerFilter = function () {
    if(!document.querySelector(".extended-search-v3")) return;

    const SELECTORS = {
        listingPage: ".career-listing-page",
        careerContainer: ".career-listing__container",
        careerItem: ".career-item",
        careerListContainer: ".career-listing__jobs",
        detailElm: ".career-listing__job-detail",
        apiEndPointDetail: ".api-job-config",
        pagination: ".pagination",
        paginationItem: "a",
        dropdown: ".extended-search-v3__simple-dropdown"
    }

    const httpService = new HttpService();


    let careerElms = {};

    function loadSelectors(){
        const listingPageContainer = document.querySelector(SELECTORS.listingPage);
        const careerListContainer = document.querySelector(SELECTORS.careerListContainer);
        const paginationElm = careerListContainer?.querySelector(SELECTORS.pagination);
        careerElms = {
            listingPage: listingPageContainer,
            careerContainer: document.querySelector(SELECTORS.careerContainer),
            careerListContainer: careerListContainer,
            careerItemList: careerListContainer?.querySelectorAll(SELECTORS.careerItem) || [],
            detailElm: document.querySelector(SELECTORS.detailElm),
            apiEndPoint: JSON.parse(listingPageContainer?.querySelector(SELECTORS.apiEndPointDetail)?.textContent || "{}"),
            pagination: paginationElm,
            paginationItems: paginationElm?.querySelectorAll(SELECTORS.paginationItem) || [],
            paginationEndPoint: paginationElm?.dataset?.apiEndpoint
        }
    }

    function updateBrowserURL(value, isDetail) {
        const url = new URL(window.location.href);
        if(isDetail) {
            url.searchParams.set("pageId", value);
        } else {
            url.searchParams.delete("pageId");
            url.searchParams.set("page", value);
        }
        window.history.pushState({}, "", url);
    }

    function loadDetail() {
        careerElms.careerItemList.forEach(item => {
            item.addEventListener("click", e => {
                if(GT.isTabletView()) {
                    e.preventDefault();
                    careerElms.careerListContainer?.querySelector(".current")?.classList.remove("current");
                    e.currentTarget.classList.add("current");
                    careerElms.listingPage.classList.add("fetching");
                    GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
                    const pageId = e.target.closest(SELECTORS.careerItem).dataset.jobId;
                    httpService.getHtmlContent(careerElms.apiEndPoint.jobDetailEndPointUrl + pageId).then(detailResponse => {
                        careerElms.detailElm.innerHTML = detailResponse;
                        careerElms.listingPage.classList.remove("fetching");
                        GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText;
                        updateBrowserURL(pageId, true);

                        if(GT.isScreenReader) {
                            let firstFocusableElm = GT.getListFocusableElms(careerElms.detailElm)[0];
                            if(firstFocusableElm) {
                                firstFocusableElm.focus();
                                firstFocusableElm.addEventListener("keydown", e => {
                                    if(e.key == "Tab" && e.shiftKey) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        careerElms.listingPage.querySelector(SELECTORS.careerItem + ".current")?.focus();
                                    }
                                });
                            }
                        }

                        //scroll to detail element
                        const detailPos = careerElms.detailElm.getBoundingClientRect().y;
                        if(detailPos < GT.headerElmHeight) window.scrollTo({top: window.scrollY + (detailPos- GT.headerElmHeight - 50)})
                    });
                }
            });
        });
    }

    function loadListingByPagination() {
        careerElms.paginationItems.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                const pageIndex = e.target.closest(SELECTORS.paginationItem).dataset.pageIndex;
                if(!careerElms.careerContainer) return;
                careerElms.listingPage.classList.add("fetching");
                GT.announceArea.innerText = GT.announceArea.dataset.loadingText;
                httpService.getHtmlContent(careerElms.paginationEndPoint.replace("{0}", pageIndex)).then(listingResponse => {
                    careerElms.careerContainer.innerHTML = listingResponse;
                    loadSelectors();
                    loadDetail();
                    loadListingByPagination();
                    updateBrowserURL(pageIndex);
                    careerElms.listingPage.classList.remove("fetching");
                    GT.announceArea.innerText = GT.announceArea.dataset.loadingFinishedText;
                    //scroll to dropdown and detail element
                    window.scrollTo({ top: document.querySelector(SELECTORS.dropdown).offsetTop - 50, behavior: "smooth" });
                    careerElms.detailElm.scrollTo({ top: 0 });
                    careerElms.listingPage.querySelector(SELECTORS.careerItem)?.focus();
                });
            });
        });
    }

    GT.ExtendedSearchV3Callback.replace.career = function (response) {
        loadSelectors();
        loadDetail();
        loadListingByPagination();
    }

    loadSelectors();
    loadDetail();
    loadListingByPagination();
}

GT.domContentLoadedFncList.push(GT.CareerFilter);
GT.Initiator = function (__object) {
    // if test passed (selector present on site) - fire function form current object on obj context (passing as argument selector and arguments or empty)
    var __$tmp = $(__object.test);
    try {
        if (__$tmp.length && __object.constr)
            new __object.constr(__$tmp, __object);
    } catch (exp) {
        console.warn(exp);
    }
};

$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    GT.Cookies = new GTCookies();
    GT.Cookies.cookieNotify();
    SVGInjector(document.querySelectorAll('img[src*=".svg"]'));

    requestAnimationFrame(() => {
        GT.wHeight = window.innerHeight;
        GT.wWidth = window.innerWidth;
        GT.bodyWidth = document.body.clientWidth;
        GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    });

    requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
        document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');
    });

    GT.isTouchDevice = GT.isTouchDevice();
	GT.announceArea = document.querySelector(".announce-area");
    
    GT.domContentLoadedFncList.forEach(function(fnc){
        try {
            fnc();
        } catch (e) {
            console.log(e);
        }
    })
    initTabPanelActionHandler();

    GT.GTObjects = [
        // array of functions to check if they should be fired
        { constr: GT.StickyHeader, test: '.main-header', settings: { } },
        { constr: GT.TopBannerMessageForNoStickyHeader, test: '.main-header', settings: { } },
        { constr: GT.TopBannerMessageForNoStickyHeader, test: '.campaign-header', settings: { } },
        { constr: GT.GTInsightArticle, test: '.insights-banner__block', settings: {} },
        { constr: GT.Reveal, test: '.scroll-reveal__container', settings: { rvlItemClass: 'reveal-item' } },
        { constr: GT.Clamp, test: '.mega__level .article-tile__content-container .content .title', settings: { clamp: 2, isHidden: true } }, // megamenu promoted content heading
        { constr: GT.Clamp, test: '.mega__level .article-tile__content-container .content-bottom .text', settings: { clamp: 5, isHidden: true } }, // megamenu promoted content
        { constr: GT.Clamp, test: '.about-us-block .title', settings: { clamp: 5, charLimit: 150 } },
        { constr: GT.Clamp, test: '.about-us-block .page-name', settings: { clamp: 2, charLimit: 60 } },
        { constr: GT.Clamp, test: '.about-us-block .page-summary', settings: { clamp: 3, charLimit: 150 } },
        { constr: GT.Clamp, test: '.trending-content-block .description', settings: { clamp: 2, charLimit: 60 } },
        { constr: GT.Clamp, test: '.news-block .news-title', settings: { clamp: 3, charLimit: 60 } },
        { constr: GT.Clamp, test: '.news-block .news-text', settings: { clamp: 5, charLimit: 150 } },
        { constr: GT.Clamp, test: '.single-event-block .event-name-single span a, .single-event-block .event-name span a', settings: { clamp: 2, charLimit: 50 } },
        { constr: GT.Clamp, test: '.double-banner-block .title', settings: { clamp: 3, charLimit: 60 } },
        { constr: GT.Clamp, test: '.double-banner-block p', settings: { clamp: 6, charLimit: 200 } },
        { constr: GT.Clamp, test: '.tombstone-block-container .item-client', settings: { clamp: 4, charLimit: 120 } },
        { constr: GT.Clamp, test: '.tombstone-block-container .item-transaction', settings: { clamp: 3, charLimit: 60 } },
        { constr: GT.Clamp, test: '.tombstone-block-container .item-business', settings: { clamp: 4, charLimit: 120 } },
        { constr: GT.Clamp, test: '.career-landing-page-v2 .block-title-24', settings: { clamp: 3, charLimit: 60 } },
        { constr: GT.Clamp, test: '.career-landing-page-v2 .careers-block .btn-secondary', settings: { clamp: 4, charLimit: 200 } },
        { constr: GT.Swiper, test: '.campaign-slider:not(.slideroff)', settings: { type: "dotted-pagination", el: ".swiper-pagination" } },
        { constr: GT.Swiper, test: '.about-us-slider:not(.slideroff)' },
        { constr: GT.Swiper, test: '.news-slider:not(.slideroff)' },
        { constr: GT.Swiper, test: '.figureCarousel', settings: { type: "single_slide" } },
        { constr: GT.Swiper, test: '.fcb__slider', settings: { type: "infinite_fcb" } },
        // { constr: GT.Swiper, test: '.related-experts-slider', settings: { type: "infinite_reb" } },
        { constr: GT.Swiper, test: '.next-article-slider', settings: { type: "next_article_slide" } },
        { constr: GT.Swiper, test: '.industry-landing-slider', settings: { type: "single_slide" } },       
        { constr: GT.Expert, test: '.experts-search-block', settings: {} },
        { constr: GT.Select, test: '.custom-select', settings: {} },
        { constr: GT.Swiper, test: '.large-promo-module-slider', settings: { type: "large_promo_slider" } },
        { constr: GT.Swiper, test: '.insightsHeroCarousel', settings: { type: "large_promo_slider" } },
        { constr: GT.Swiper, test: '.article-slider', settings: { type: "large_promo_slider" } },
        { constr: GT.Swiper, test: '.expert-container--slider', settings: { type: "mobile-only-slider" } },
        { constr: GT.Swiper, test: '.topic-block', settings: { type: "mobile-only-slider" } },
        { constr: GT.Swiper, test: '.simple-tiles--slider', settings: { type: "small-mobile-only-slider" } },
        { 
            constr: GT.SwiperNeo,
            test: '.rcwib_slider',
            settings: GT.SwiperNeoPreset.limitedMediaSlider(
                GT.SwiperNeoPreset.breakPoints.tabletMinWidth,
                function () {
                    // Extra setting for limitedMediaSlider preset
                    return {
                        loop: true,
                        afterSwiperInit: function (swiperDOMInfo) {
                            GT.LazyBackgrounds($('.js-lazy-bg'), { settings: { safeDistance: 500 } });
                            GT.SwiperNeoPreset.clampTextContent([
                                { selector: '.rcwib_item-content-category', lines: 1 },
                                { selector: '.rcwib_item-content-title', lines: 2 },
                            ])(swiperDOMInfo);
                        }
                    };
                }
            )
        },
        {
            constr: GT.SwiperNeo,
            test: '.cswsb_slider',
            settings: {
                loop: true,
                resistance: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                paginationClickable: false,
                slidesPerView: 1,
                extendedSettingFn: function() {
                    var settings = {
                        breakpoints: {},
                    };
                    settings.breakpoints[GT.SwiperNeoPreset.breakPoints.tabletMinWidth - 1] = {
                        resistanceRatio: 0.85,
                        spaceBetween: 32
                    };
                    return settings;
                },
                afterSwiperInit: function (swiperDOMInfo) {
                    GT.LazyBackgrounds(swiperDOMInfo.$slidesContainer.find('.js-lazy-bg'), { settings: { safeDistance: 500 } });
                }
            }
        },
        { constr: GT.FormSelect, test: '.form-select', settings: {} },
        { constr: GT.SearchInput, test: '.name-search' },
        { constr: GT.SideNav, test: '.secondary-nav' },
        { constr: GT.Trim, test: '.mega__feature' },
        { constr: GT.Tabs.firmTabs, test: '.firm-tabs' },
        { constr: GT.MediaCarousel, test: '.article-carousel-block', settings: {} },
        { constr: GT.Overlays.launchVideoOverlay, test: '.video__with-overlay' },
        { constr: GT.Overlays.launchOverlay, test: '.youtube-video' },
        // GT.EPiServerFormsOverlay does not use jQuery anymore, so these two lines cannot be used here
        // { constr: GT.EPiServerFormsOverlay, test: '#launchContactFormSubscribe[data-epiforms-overlay]' },
        // { constr: GT.EPiServerFormsOverlay, test: '#launchServiceIndustryContactFormSubscribe[data-epiforms-overlay]' },        { constr: GT.Overlays.loadOverlayContact, test: '#launchContactFormSubscribe:not([data-epiforms-overlay])' },
        { constr: GT.Overlays.loadOverlaySeminar, test: '#launchSemminarsFormSubscribe' },
        { constr: GT.Reach, test: '.global-reach' },
        { constr: GT.Filters.defineSearch, test: '.js-define-search li a' },
        { constr: GT.Filters.moreFilters, test: '.more-btn' },
        { constr: GT.Filters.tabs, test: '.filters-container' },
        { constr: GT.LazyLoad, test: '.locations-list', settings: { run: "getLocation" } },
        { constr: GT.LazyLoad, test: '.locations-list', settings: { run: "scrollToLocation" } },
        { constr: GT.LazyLoad, test: '.js-related-articles', settings: { run: "loadArticles" } },
        { constr: GT.LazyLoad, test: '.js-more-experts', settings: { run: "LazyLoadingPeople" } },
        { constr: GT.LazyLoad, test: '.js-more-articles', settings: { run: "LazyLoadingArticles" } },
        { constr: GT.LazyLoad, test: '.js-mediacenter-more-articles', settings: { run: "LazyLoadingMediaItemsArticles" } },
        { constr: GT.LazyLoad, test: '.js-more-vacancies', settings: { run: "loadVacancies" } },
        { constr: GT.LazyLoad, test: '.js-more-events', settings: { run: "LazyLoadingEvents" } },
        { constr: GT.LazyLoad, test: '#show-location', settings: { run: "FilterEvents" } },
        {
            constr: GT.SwiperNeo,
            test: '.tcpwsb_slider',
            settings: {
                loop: true,
                resistance: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                paginationClickable: false,
                slidesPerView: 1,
                extendedSettingFn: function() {
                    var settings = {
                        breakpoints: {},
                    };
                    settings.breakpoints[GT.SwiperNeoPreset.breakPoints.tabletMinWidth - 1] = {
                        resistanceRatio: 0.85,
                        spaceBetween: 32
                    };
                    return settings;
                },
                afterSwiperInit: function (swiperDOMInfo) {
                    GT.LazyBackgrounds(swiperDOMInfo.$slidesContainer.find('.js-lazy-bg'), { settings: { safeDistance: 500 } });
                }
            }
        },
        { constr: GT.HeadSearch, test: '.h-search-container' },
        { constr: GT.MegaNavigation, test: '.mega' },
        { constr: GT.MobileNavigation, test: '.mobile' },
        { constr: GT.View, test: '.change-view' },
        { constr: GT.SwitchView, test: '.event-switch-view' }, 
        { constr: GT.SwitchView, test: '.seminar-switch-view' },

        { constr: GT.Contact.contactForm, test: '#EnquiryType' },
        { constr: GT.Contact.updateFileUploadVisibility, test: '#EnquiryType' },
        { constr: GT.Contact.methodOfContact, test: '.event-register-form' },
        { constr: GT.Contact.privacyPolicyAccepted, test: '.event-register-form' },
        { constr: GT.Contact.contactSelector, test: '.contact-selector' },
        { constr: GT.TouchBlur, test: '.btn-primary, .btn-primary-light, .btn-primary-alt, .btn-secondary, .btn-secondary-light, .slider__next, .slider__prev' },
        // { constr: GT.Equalise, test: '.single-event-block' },
        // { constr: GT.Equalise, test: '.events-container .switchable-single-event-block' },
        // { constr: GT.Equalise, test: '.seminars-container .switchable-single-event-block' },
        { constr: GT.InputLabel, test: '.h-search' },
        { constr: GT.RangeSlider, test: 'input[type="range"]' },
        { constr: GT.Track.trackPDFs, test: '.download-pdf-link' },
        { constr: GT.Track.clickTracking, test: '#ResultListWrapper' },
        { constr: GT.ClickDimensions, test: '[pageid]', settings: { parent: ".clickdform", selector: ".clickdform *", attr: "style" } },
        { constr: GT.SocialShareLine, test: '.line-it-button' },
        { constr: GT.VideoBannerBlocks, test: '.banner-block--video .video-background', settings: { hideTimeout: 60 } },
        // Dupliacate event when click to play/pause video in case study banner when open line below:
        //{ constr: GT.VideoBannerBlocks, test: '.case-study-video-banner video', settings: { hideTimeout: 60 } },
        { constr: GT.Accordion, test: '.accordion', settings: { containerSelector: '.accordion-item__content', triggerSelector: '.accordion-item__trigger' } },
        { constr: GT.FakeHyperlink, test: '[data-anchor]' },
        { constr: GT.EPiServerForms, test: '.EPiServerForms', settings: {} },
        { constr: GT.MarketoEmbedForms, test: '.marketo-embed-form', settings: {} },
        { constr: GT.CampaignBanners, test: '.campaign-banner', settings: {} },
        { constr: GT.DragNDrop, test: 'body', settings: {} },
        { constr: GT.FakeArrowTransitions, test: '.tombstone-block-container .deal-item .btn-secondary', settings: { width : 5 } },
        { constr: GT.expandBanner, test: '.content_hub.content_hub-container--wide', settings: {} },
        { constr: GT.Datatables, test: '.gt-dataTable', settings: { autoWidth: true,  scrollX: true } },
		{ constr: GT.GatedPdfForm, test: '.js-gated-form', settings: {} },
		{ constr: GT.GatedPdfMarketoForm, test: '.js-gated-marketo', settings: {} },
        { constr: GT.GatedArticleForm, test: '.js-article-gated-form', settings: {} },
        { constr: GT.GatedArticleMarketoForm, test: '.js-article-gated-marketo-form', settings: {} },
        { constr: GT.SecondaryNavbar, test: '.gt-secondary-nav', settings: {} },
        { constr: GT.HorizontalTable, test: '.gt-horizontal-table', settings: {} },
        { constr: GT.LazyBackgrounds, test: '.trending-content-block .background--focus-left-center', settings: {} },
        { constr: GT.LazyBackgrounds, test: '.home-page-container .extended-banner-block > .background', settings: {} },
        { constr: GT.LazyBackgrounds, test: '.home-page-container .banner-block > .background', settings: {} },
        { constr: GT.ImagesGallery, test: '.gt-gallery__block' },
        {
            constr: GT.ExtendedSearch, test: '.extended-search', settings: {
                'form': 'form',
                'submitBtn': '.extended-search-bar__search-btn',
                'loadBtn': '.extended-search__load-btn',
                'applyFilters': '.filters__apply-close-btn',
                'filterTags': '.filters__item',
                'clearFiltersBtn': '.article-grid__clear-btn',
                'sResults': '.extended-search__results',
                'toggleFilters': '.extended-search-bar__filter-btn',
                'searchInput': '.extended-search-bar__search-input',
                'filters': '.extended-search-bar__filters',
                'closeFiltersButton': '.filters__close-button a',
                'filterHeading': '.filters__heading',
                'isFilterField': '.isFilter',
                'totalResultsQty': '.totalResultsQty',
                'pageSize': '.pageSize',
                'joinChar': '+',
                'classes': {
                    'filtersClosed': 'filters--closed',
                    'overflowHidden': 'overflowHidden--mobile'
                }
            }
        },
        {
            constr: GT.ExtendedSearch, test: '.insights-article-block', settings: {
                'loadBtn': '.extended-search__load-btn',
                'sResults': '.extended-search__results',
                'isFilterField': '.isFilter',
                'totalResultsQty': '.totalResultsQty',
                'pageSize': '.pageSize',
                'joinChar': '+',
                'classes': {
                    'filtersClosed': 'filters--closed',
                    'overflowHidden': 'overflowHidden--mobile'
                }
            }
        },
        {
            constr: GT.Captcha, test: '.g-recaptcha:not(.FormRecaptcha .g-recaptcha)', settings: {
                error_origin: "selector",
                error_value: "",
                error_selector: "data-captcha-error"
            }
        },
        {
            constr: GT.Captcha, test: '.royalty-calculator', settings: {
                creator_container: ".submit.submit-element", creator_where: "before",
                error_origin: "variable", error_value: null, error_variable: ["customCalculator", "errorMsg"], error_containerSelector: ".g-recaptcha", error_where: "after",
                key_origin: "variable", key_value: null, key_variable: ["customCalculator", "captchaKey"]
            }
        },
		{
			constr: GT.EmailObfuscate,
			test: $([
				'[data-obfuscate="true"]',
				'.simple-contact-block'
			].join(','))
		},
        { constr: GT.OfficeBanner, test: '.office-banner', settings: {} },
        { constr: GT.GTWraptextButton, test: '#officeNearByRow .btn-large', settings: { extra : 12, padding : 16 } },
        { constr: GT.GTInsightHubOverlays, test: '.js-hub-overlay', settings: {} },
        { constr: GT.ArticleSummaries, test: '.t13-page .article-summary, .t45-insights-page .article-summary, .campaign-content-page .article-summary', settings: {} },
        { constr: GT.GTContactWidgetOverlay, test: '.js-contact-widget-overlay', settings: {} },
        { constr: GT.GTFindOfficesNearYou, test: '.select-offices', settings: {} },        
        { constr: GT.Footer, test: 'footer', settings: {} },
        { constr: GT.ServiceIndustrySubMenu, test: '.service-industry-sub-menu' },
        { constr: GT.ReadMore, test: '[data-readmore-enabled]' },
        { constr: GT.SelectPlaceholder, test: '.simplecontactblock' },
		{ constr: GT.ContactFormOverlay, test: '.contact-form-launcher' },
		{ constr: GT.CheckClosestOffice, test: '.closest-office-js' },
        { constr: GT.StickyContact, test: '.sticky-contact-block'},
        { constr: GT.Square, test: '.contact-actions_divider .divider-text' },
        { constr: GT.KeyQuestion, test: '.key-question' },
        { constr: GT.GTExternalLogin, test: '.externalLoginButton' },
        { constr: GT.GTVisitorProfile, test: '.visitor-profile__container' },
        { constr: GT.GTReaderView, test: '.t45-insights-page' },
        { constr: GT.GTPeopleLandingPage, test: '.people-landing-page' },
        { constr: GT.TombstoneTransaction, test: '.transaction-content' }
    ].map(GT.Initiator);

});
GT.freezeVp = function (e) {
    e.preventDefault();
};